import "core-js/modules/es.array.unscopables.flat-map.js";
import * as e from "react";
import t, { useState as r, useRef as n, useEffect as a, createContext as o, Component as i, Fragment as l, Children as s, version as c, memo as u, useLayoutEffect as h, useContext as m, useInsertionEffect as p, useCallback as f, useMemo as d, forwardRef as v, createElement as g, useId as b, cloneElement as w, isValidElement as y, useReducer as x, createRef as O } from "react";
import { createHmac as E } from "crypto";
import * as j from "http";
import { Agent as C } from "http";
import * as P from "https";
import { Agent as M } from "https";
import { parse as k, fileURLToPath as S } from "url";
import N from "path";
import B from "process";
import { createPortal as V } from "react-dom";
const R = {
  "bg-storybook-default-heading": "bg-storybook-default-heading",
  "text-storybook-default-heading": "text-storybook-default-heading",
  "bg-base-0": "bg-base-0",
  "text-base-0": "text-base-0",
  "bg-base-1000": "bg-base-1000",
  "text-base-1000": "text-base-1000",
  "bg-neutral-0": "bg-neutral-0",
  "text-neutral-0": "text-neutral-0",
  "bg-neutral-50": "bg-neutral-50",
  "text-neutral-50": "text-neutral-50",
  "bg-neutral-100": "bg-neutral-100",
  "text-neutral-100": "text-neutral-100",
  "bg-neutral-150": "bg-neutral-150",
  "text-neutral-150": "text-neutral-150",
  "bg-neutral-200": "bg-neutral-200",
  "text-neutral-200": "text-neutral-200",
  "bg-neutral-300": "bg-neutral-300",
  "text-neutral-300": "text-neutral-300",
  "bg-neutral-400": "bg-neutral-400",
  "text-neutral-400": "text-neutral-400",
  "bg-neutral-500": "bg-neutral-500",
  "text-neutral-500": "text-neutral-500",
  "bg-neutral-600": "bg-neutral-600",
  "text-neutral-600": "text-neutral-600",
  "bg-neutral-700": "bg-neutral-700",
  "text-neutral-700": "text-neutral-700",
  "bg-neutral-800": "bg-neutral-800",
  "text-neutral-800": "text-neutral-800",
  "bg-neutral-850": "bg-neutral-850",
  "text-neutral-850": "text-neutral-850",
  "bg-neutral-900": "bg-neutral-900",
  "text-neutral-900": "text-neutral-900",
  "bg-neutral-950": "bg-neutral-950",
  "text-neutral-950": "text-neutral-950",
  "bg-neutral-1000": "bg-neutral-1000",
  "text-neutral-1000": "text-neutral-1000",
  "bg-blue-100": "bg-blue-100",
  "text-blue-100": "text-blue-100",
  "bg-blue-200": "bg-blue-200",
  "text-blue-200": "text-blue-200",
  "bg-blue-300": "bg-blue-300",
  "text-blue-300": "text-blue-300",
  "bg-blue-400": "bg-blue-400",
  "text-blue-400": "text-blue-400",
  "bg-blue-500": "bg-blue-500",
  "text-blue-500": "text-blue-500",
  "bg-blue-600": "bg-blue-600",
  "text-blue-600": "text-blue-600",
  "bg-blue-700": "bg-blue-700",
  "text-blue-700": "text-blue-700",
  "bg-blue-800": "bg-blue-800",
  "text-blue-800": "text-blue-800",
  "bg-blue-900": "bg-blue-900",
  "text-blue-900": "text-blue-900",
  "bg-purple-100": "bg-purple-100",
  "text-purple-100": "text-purple-100",
  "bg-purple-200": "bg-purple-200",
  "text-purple-200": "text-purple-200",
  "bg-purple-300": "bg-purple-300",
  "text-purple-300": "text-purple-300",
  "bg-purple-400": "bg-purple-400",
  "text-purple-400": "text-purple-400",
  "bg-purple-500": "bg-purple-500",
  "text-purple-500": "text-purple-500",
  "bg-purple-600": "bg-purple-600",
  "text-purple-600": "text-purple-600",
  "bg-purple-700": "bg-purple-700",
  "text-purple-700": "text-purple-700",
  "bg-purple-800": "bg-purple-800",
  "text-purple-800": "text-purple-800",
  "bg-purple-900": "bg-purple-900",
  "text-purple-900": "text-purple-900",
  "bg-cyan-100": "bg-cyan-100",
  "text-cyan-100": "text-cyan-100",
  "bg-cyan-200": "bg-cyan-200",
  "text-cyan-200": "text-cyan-200",
  "bg-cyan-300": "bg-cyan-300",
  "text-cyan-300": "text-cyan-300",
  "bg-cyan-400": "bg-cyan-400",
  "text-cyan-400": "text-cyan-400",
  "bg-cyan-500": "bg-cyan-500",
  "text-cyan-500": "text-cyan-500",
  "bg-cyan-600": "bg-cyan-600",
  "text-cyan-600": "text-cyan-600",
  "bg-cyan-700": "bg-cyan-700",
  "text-cyan-700": "text-cyan-700",
  "bg-cyan-800": "bg-cyan-800",
  "text-cyan-800": "text-cyan-800",
  "bg-cyan-900": "bg-cyan-900",
  "text-cyan-900": "text-cyan-900",
  "bg-green-100": "bg-green-100",
  "text-green-100": "text-green-100",
  "bg-green-200": "bg-green-200",
  "text-green-200": "text-green-200",
  "bg-green-300": "bg-green-300",
  "text-green-300": "text-green-300",
  "bg-green-400": "bg-green-400",
  "text-green-400": "text-green-400",
  "bg-green-500": "bg-green-500",
  "text-green-500": "text-green-500",
  "bg-green-600": "bg-green-600",
  "text-green-600": "text-green-600",
  "bg-green-700": "bg-green-700",
  "text-green-700": "text-green-700",
  "bg-green-800": "bg-green-800",
  "text-green-800": "text-green-800",
  "bg-green-900": "bg-green-900",
  "text-green-900": "text-green-900",
  "bg-pink-100": "bg-pink-100",
  "text-pink-100": "text-pink-100",
  "bg-pink-200": "bg-pink-200",
  "text-pink-200": "text-pink-200",
  "bg-pink-300": "bg-pink-300",
  "text-pink-300": "text-pink-300",
  "bg-pink-400": "bg-pink-400",
  "text-pink-400": "text-pink-400",
  "bg-pink-500": "bg-pink-500",
  "text-pink-500": "text-pink-500",
  "bg-pink-600": "bg-pink-600",
  "text-pink-600": "text-pink-600",
  "bg-pink-700": "bg-pink-700",
  "text-pink-700": "text-pink-700",
  "bg-pink-800": "bg-pink-800",
  "text-pink-800": "text-pink-800",
  "bg-pink-900": "bg-pink-900",
  "text-pink-900": "text-pink-900",
  "bg-amber-100": "bg-amber-100",
  "text-amber-100": "text-amber-100",
  "bg-amber-200": "bg-amber-200",
  "text-amber-200": "text-amber-200",
  "bg-amber-300": "bg-amber-300",
  "text-amber-300": "text-amber-300",
  "bg-amber-400": "bg-amber-400",
  "text-amber-400": "text-amber-400",
  "bg-amber-500": "bg-amber-500",
  "text-amber-500": "text-amber-500",
  "bg-amber-600": "bg-amber-600",
  "text-amber-600": "text-amber-600",
  "bg-amber-700": "bg-amber-700",
  "text-amber-700": "text-amber-700",
  "bg-amber-800": "bg-amber-800",
  "text-amber-800": "text-amber-800",
  "bg-amber-900": "bg-amber-900",
  "text-amber-900": "text-amber-900",
  "bg-yellow-100": "bg-yellow-100",
  "text-yellow-100": "text-yellow-100",
  "bg-yellow-200": "bg-yellow-200",
  "text-yellow-200": "text-yellow-200",
  "bg-yellow-300": "bg-yellow-300",
  "text-yellow-300": "text-yellow-300",
  "bg-yellow-400": "bg-yellow-400",
  "text-yellow-400": "text-yellow-400",
  "bg-yellow-500": "bg-yellow-500",
  "text-yellow-500": "text-yellow-500",
  "bg-yellow-600": "bg-yellow-600",
  "text-yellow-600": "text-yellow-600",
  "bg-yellow-700": "bg-yellow-700",
  "text-yellow-700": "text-yellow-700",
  "bg-yellow-800": "bg-yellow-800",
  "text-yellow-800": "text-yellow-800",
  "bg-orange-100": "bg-orange-100",
  "text-orange-100": "text-orange-100",
  "bg-orange-200": "bg-orange-200",
  "text-orange-200": "text-orange-200",
  "bg-orange-300": "bg-orange-300",
  "text-orange-300": "text-orange-300",
  "bg-orange-400": "bg-orange-400",
  "text-orange-400": "text-orange-400",
  "bg-orange-500": "bg-orange-500",
  "text-orange-500": "text-orange-500",
  "bg-orange-600": "bg-orange-600",
  "text-orange-600": "text-orange-600",
  "bg-orange-700": "bg-orange-700",
  "text-orange-700": "text-orange-700",
  "bg-orange-800": "bg-orange-800",
  "text-orange-800": "text-orange-800",
  "bg-red-100": "bg-red-100",
  "text-red-100": "text-red-100",
  "bg-red-200": "bg-red-200",
  "text-red-200": "text-red-200",
  "bg-red-300": "bg-red-300",
  "text-red-300": "text-red-300",
  "bg-red-400": "bg-red-400",
  "text-red-400": "text-red-400",
  "bg-red-500": "bg-red-500",
  "text-red-500": "text-red-500",
  "bg-red-600": "bg-red-600",
  "text-red-600": "text-red-600",
  "bg-red-700": "bg-red-700",
  "text-red-700": "text-red-700",
  "bg-red-800": "bg-red-800",
  "text-red-800": "text-red-800",
  "from-storybook-default-heading": "from-storybook-default-heading",
  "from-base-0": "from-base-0",
  "from-base-1000": "from-base-1000",
  "from-neutral-0": "from-neutral-0",
  "from-neutral-50": "from-neutral-50",
  "from-neutral-100": "from-neutral-100",
  "from-neutral-150": "from-neutral-150",
  "from-neutral-200": "from-neutral-200",
  "from-neutral-300": "from-neutral-300",
  "from-neutral-400": "from-neutral-400",
  "from-neutral-500": "from-neutral-500",
  "from-neutral-600": "from-neutral-600",
  "from-neutral-700": "from-neutral-700",
  "from-neutral-800": "from-neutral-800",
  "from-neutral-850": "from-neutral-850",
  "from-neutral-900": "from-neutral-900",
  "from-neutral-950": "from-neutral-950",
  "from-neutral-1000": "from-neutral-1000",
  "from-blue-100": "from-blue-100",
  "from-blue-200": "from-blue-200",
  "from-blue-300": "from-blue-300",
  "from-blue-400": "from-blue-400",
  "from-blue-500": "from-blue-500",
  "from-blue-600": "from-blue-600",
  "from-blue-700": "from-blue-700",
  "from-blue-800": "from-blue-800",
  "from-blue-900": "from-blue-900",
  "from-purple-100": "from-purple-100",
  "from-purple-200": "from-purple-200",
  "from-purple-300": "from-purple-300",
  "from-purple-400": "from-purple-400",
  "from-purple-500": "from-purple-500",
  "from-purple-600": "from-purple-600",
  "from-purple-700": "from-purple-700",
  "from-purple-800": "from-purple-800",
  "from-purple-900": "from-purple-900",
  "from-cyan-100": "from-cyan-100",
  "from-cyan-200": "from-cyan-200",
  "from-cyan-300": "from-cyan-300",
  "from-cyan-400": "from-cyan-400",
  "from-cyan-500": "from-cyan-500",
  "from-cyan-600": "from-cyan-600",
  "from-cyan-700": "from-cyan-700",
  "from-cyan-800": "from-cyan-800",
  "from-cyan-900": "from-cyan-900",
  "from-green-100": "from-green-100",
  "from-green-200": "from-green-200",
  "from-green-300": "from-green-300",
  "from-green-400": "from-green-400",
  "from-green-500": "from-green-500",
  "from-green-600": "from-green-600",
  "from-green-700": "from-green-700",
  "from-green-800": "from-green-800",
  "from-green-900": "from-green-900",
  "from-pink-100": "from-pink-100",
  "from-pink-200": "from-pink-200",
  "from-pink-300": "from-pink-300",
  "from-pink-400": "from-pink-400",
  "from-pink-500": "from-pink-500",
  "from-pink-600": "from-pink-600",
  "from-pink-700": "from-pink-700",
  "from-pink-800": "from-pink-800",
  "from-pink-900": "from-pink-900",
  "from-amber-100": "from-amber-100",
  "from-amber-200": "from-amber-200",
  "from-amber-300": "from-amber-300",
  "from-amber-400": "from-amber-400",
  "from-amber-500": "from-amber-500",
  "from-amber-600": "from-amber-600",
  "from-amber-700": "from-amber-700",
  "from-amber-800": "from-amber-800",
  "from-amber-900": "from-amber-900",
  "from-yellow-100": "from-yellow-100",
  "from-yellow-200": "from-yellow-200",
  "from-yellow-300": "from-yellow-300",
  "from-yellow-400": "from-yellow-400",
  "from-yellow-500": "from-yellow-500",
  "from-yellow-600": "from-yellow-600",
  "from-yellow-700": "from-yellow-700",
  "from-yellow-800": "from-yellow-800",
  "from-orange-100": "from-orange-100",
  "from-orange-200": "from-orange-200",
  "from-orange-300": "from-orange-300",
  "from-orange-400": "from-orange-400",
  "from-orange-500": "from-orange-500",
  "from-orange-600": "from-orange-600",
  "from-orange-700": "from-orange-700",
  "from-orange-800": "from-orange-800",
  "from-red-100": "from-red-100",
  "from-red-200": "from-red-200",
  "from-red-300": "from-red-300",
  "from-red-400": "from-red-400",
  "from-red-500": "from-red-500",
  "from-red-600": "from-red-600",
  "from-red-700": "from-red-700",
  "from-red-800": "from-red-800",
  "via-storybook-default-heading": "via-storybook-default-heading",
  "via-base-0": "via-base-0",
  "via-base-1000": "via-base-1000",
  "via-neutral-0": "via-neutral-0",
  "via-neutral-50": "via-neutral-50",
  "via-neutral-100": "via-neutral-100",
  "via-neutral-150": "via-neutral-150",
  "via-neutral-200": "via-neutral-200",
  "via-neutral-300": "via-neutral-300",
  "via-neutral-400": "via-neutral-400",
  "via-neutral-500": "via-neutral-500",
  "via-neutral-600": "via-neutral-600",
  "via-neutral-700": "via-neutral-700",
  "via-neutral-800": "via-neutral-800",
  "via-neutral-850": "via-neutral-850",
  "via-neutral-900": "via-neutral-900",
  "via-neutral-950": "via-neutral-950",
  "via-neutral-1000": "via-neutral-1000",
  "via-blue-100": "via-blue-100",
  "via-blue-200": "via-blue-200",
  "via-blue-300": "via-blue-300",
  "via-blue-400": "via-blue-400",
  "via-blue-500": "via-blue-500",
  "via-blue-600": "via-blue-600",
  "via-blue-700": "via-blue-700",
  "via-blue-800": "via-blue-800",
  "via-blue-900": "via-blue-900",
  "via-purple-100": "via-purple-100",
  "via-purple-200": "via-purple-200",
  "via-purple-300": "via-purple-300",
  "via-purple-400": "via-purple-400",
  "via-purple-500": "via-purple-500",
  "via-purple-600": "via-purple-600",
  "via-purple-700": "via-purple-700",
  "via-purple-800": "via-purple-800",
  "via-purple-900": "via-purple-900",
  "via-cyan-100": "via-cyan-100",
  "via-cyan-200": "via-cyan-200",
  "via-cyan-300": "via-cyan-300",
  "via-cyan-400": "via-cyan-400",
  "via-cyan-500": "via-cyan-500",
  "via-cyan-600": "via-cyan-600",
  "via-cyan-700": "via-cyan-700",
  "via-cyan-800": "via-cyan-800",
  "via-cyan-900": "via-cyan-900",
  "via-green-100": "via-green-100",
  "via-green-200": "via-green-200",
  "via-green-300": "via-green-300",
  "via-green-400": "via-green-400",
  "via-green-500": "via-green-500",
  "via-green-600": "via-green-600",
  "via-green-700": "via-green-700",
  "via-green-800": "via-green-800",
  "via-green-900": "via-green-900",
  "via-pink-100": "via-pink-100",
  "via-pink-200": "via-pink-200",
  "via-pink-300": "via-pink-300",
  "via-pink-400": "via-pink-400",
  "via-pink-500": "via-pink-500",
  "via-pink-600": "via-pink-600",
  "via-pink-700": "via-pink-700",
  "via-pink-800": "via-pink-800",
  "via-pink-900": "via-pink-900",
  "via-amber-100": "via-amber-100",
  "via-amber-200": "via-amber-200",
  "via-amber-300": "via-amber-300",
  "via-amber-400": "via-amber-400",
  "via-amber-500": "via-amber-500",
  "via-amber-600": "via-amber-600",
  "via-amber-700": "via-amber-700",
  "via-amber-800": "via-amber-800",
  "via-amber-900": "via-amber-900",
  "via-yellow-100": "via-yellow-100",
  "via-yellow-200": "via-yellow-200",
  "via-yellow-300": "via-yellow-300",
  "via-yellow-400": "via-yellow-400",
  "via-yellow-500": "via-yellow-500",
  "via-yellow-600": "via-yellow-600",
  "via-yellow-700": "via-yellow-700",
  "via-yellow-800": "via-yellow-800",
  "via-orange-100": "via-orange-100",
  "via-orange-200": "via-orange-200",
  "via-orange-300": "via-orange-300",
  "via-orange-400": "via-orange-400",
  "via-orange-500": "via-orange-500",
  "via-orange-600": "via-orange-600",
  "via-orange-700": "via-orange-700",
  "via-orange-800": "via-orange-800",
  "via-red-100": "via-red-100",
  "via-red-200": "via-red-200",
  "via-red-300": "via-red-300",
  "via-red-400": "via-red-400",
  "via-red-500": "via-red-500",
  "via-red-600": "via-red-600",
  "via-red-700": "via-red-700",
  "via-red-800": "via-red-800",
  "to-storybook-default-heading": "to-storybook-default-heading",
  "to-base-0": "to-base-0",
  "to-base-1000": "to-base-1000",
  "to-neutral-0": "to-neutral-0",
  "to-neutral-50": "to-neutral-50",
  "to-neutral-100": "to-neutral-100",
  "to-neutral-150": "to-neutral-150",
  "to-neutral-200": "to-neutral-200",
  "to-neutral-300": "to-neutral-300",
  "to-neutral-400": "to-neutral-400",
  "to-neutral-500": "to-neutral-500",
  "to-neutral-600": "to-neutral-600",
  "to-neutral-700": "to-neutral-700",
  "to-neutral-800": "to-neutral-800",
  "to-neutral-850": "to-neutral-850",
  "to-neutral-900": "to-neutral-900",
  "to-neutral-950": "to-neutral-950",
  "to-neutral-1000": "to-neutral-1000",
  "to-blue-100": "to-blue-100",
  "to-blue-200": "to-blue-200",
  "to-blue-300": "to-blue-300",
  "to-blue-400": "to-blue-400",
  "to-blue-500": "to-blue-500",
  "to-blue-600": "to-blue-600",
  "to-blue-700": "to-blue-700",
  "to-blue-800": "to-blue-800",
  "to-blue-900": "to-blue-900",
  "to-purple-100": "to-purple-100",
  "to-purple-200": "to-purple-200",
  "to-purple-300": "to-purple-300",
  "to-purple-400": "to-purple-400",
  "to-purple-500": "to-purple-500",
  "to-purple-600": "to-purple-600",
  "to-purple-700": "to-purple-700",
  "to-purple-800": "to-purple-800",
  "to-purple-900": "to-purple-900",
  "to-cyan-100": "to-cyan-100",
  "to-cyan-200": "to-cyan-200",
  "to-cyan-300": "to-cyan-300",
  "to-cyan-400": "to-cyan-400",
  "to-cyan-500": "to-cyan-500",
  "to-cyan-600": "to-cyan-600",
  "to-cyan-700": "to-cyan-700",
  "to-cyan-800": "to-cyan-800",
  "to-cyan-900": "to-cyan-900",
  "to-green-100": "to-green-100",
  "to-green-200": "to-green-200",
  "to-green-300": "to-green-300",
  "to-green-400": "to-green-400",
  "to-green-500": "to-green-500",
  "to-green-600": "to-green-600",
  "to-green-700": "to-green-700",
  "to-green-800": "to-green-800",
  "to-green-900": "to-green-900",
  "to-pink-100": "to-pink-100",
  "to-pink-200": "to-pink-200",
  "to-pink-300": "to-pink-300",
  "to-pink-400": "to-pink-400",
  "to-pink-500": "to-pink-500",
  "to-pink-600": "to-pink-600",
  "to-pink-700": "to-pink-700",
  "to-pink-800": "to-pink-800",
  "to-pink-900": "to-pink-900",
  "to-amber-100": "to-amber-100",
  "to-amber-200": "to-amber-200",
  "to-amber-300": "to-amber-300",
  "to-amber-400": "to-amber-400",
  "to-amber-500": "to-amber-500",
  "to-amber-600": "to-amber-600",
  "to-amber-700": "to-amber-700",
  "to-amber-800": "to-amber-800",
  "to-amber-900": "to-amber-900",
  "to-yellow-100": "to-yellow-100",
  "to-yellow-200": "to-yellow-200",
  "to-yellow-300": "to-yellow-300",
  "to-yellow-400": "to-yellow-400",
  "to-yellow-500": "to-yellow-500",
  "to-yellow-600": "to-yellow-600",
  "to-yellow-700": "to-yellow-700",
  "to-yellow-800": "to-yellow-800",
  "to-orange-100": "to-orange-100",
  "to-orange-200": "to-orange-200",
  "to-orange-300": "to-orange-300",
  "to-orange-400": "to-orange-400",
  "to-orange-500": "to-orange-500",
  "to-orange-600": "to-orange-600",
  "to-orange-700": "to-orange-700",
  "to-orange-800": "to-orange-800",
  "to-red-100": "to-red-100",
  "to-red-200": "to-red-200",
  "to-red-300": "to-red-300",
  "to-red-400": "to-red-400",
  "to-red-500": "to-red-500",
  "to-red-600": "to-red-600",
  "to-red-700": "to-red-700",
  "to-red-800": "to-red-800",
  "stroke-base-0": "stroke-base-0",
  "stroke-base-1000": "stroke-base-1000",
  "stroke-neutral-0": "stroke-neutral-0",
  "stroke-neutral-50": "stroke-neutral-50",
  "stroke-neutral-100": "stroke-neutral-100",
  "stroke-neutral-150": "stroke-neutral-150",
  "stroke-neutral-200": "stroke-neutral-200",
  "stroke-neutral-300": "stroke-neutral-300",
  "stroke-neutral-400": "stroke-neutral-400",
  "stroke-neutral-500": "stroke-neutral-500",
  "stroke-neutral-600": "stroke-neutral-600",
  "stroke-neutral-700": "stroke-neutral-700",
  "stroke-neutral-800": "stroke-neutral-800",
  "stroke-neutral-850": "stroke-neutral-850",
  "stroke-neutral-900": "stroke-neutral-900",
  "stroke-neutral-950": "stroke-neutral-950",
  "stroke-neutral-1000": "stroke-neutral-1000",
  "stroke-blue-100": "stroke-blue-100",
  "stroke-blue-200": "stroke-blue-200",
  "stroke-blue-300": "stroke-blue-300",
  "stroke-blue-400": "stroke-blue-400",
  "stroke-blue-500": "stroke-blue-500",
  "stroke-blue-600": "stroke-blue-600",
  "stroke-blue-700": "stroke-blue-700",
  "stroke-blue-800": "stroke-blue-800",
  "stroke-blue-900": "stroke-blue-900",
  "stroke-purple-100": "stroke-purple-100",
  "stroke-purple-200": "stroke-purple-200",
  "stroke-purple-300": "stroke-purple-300",
  "stroke-purple-400": "stroke-purple-400",
  "stroke-purple-500": "stroke-purple-500",
  "stroke-purple-600": "stroke-purple-600",
  "stroke-purple-700": "stroke-purple-700",
  "stroke-purple-800": "stroke-purple-800",
  "stroke-purple-900": "stroke-purple-900",
  "stroke-cyan-100": "stroke-cyan-100",
  "stroke-cyan-200": "stroke-cyan-200",
  "stroke-cyan-300": "stroke-cyan-300",
  "stroke-cyan-400": "stroke-cyan-400",
  "stroke-cyan-500": "stroke-cyan-500",
  "stroke-cyan-600": "stroke-cyan-600",
  "stroke-cyan-700": "stroke-cyan-700",
  "stroke-cyan-800": "stroke-cyan-800",
  "stroke-cyan-900": "stroke-cyan-900",
  "stroke-green-100": "stroke-green-100",
  "stroke-green-200": "stroke-green-200",
  "stroke-green-300": "stroke-green-300",
  "stroke-green-400": "stroke-green-400",
  "stroke-green-500": "stroke-green-500",
  "stroke-green-600": "stroke-green-600",
  "stroke-green-700": "stroke-green-700",
  "stroke-green-800": "stroke-green-800",
  "stroke-green-900": "stroke-green-900",
  "stroke-pink-100": "stroke-pink-100",
  "stroke-pink-200": "stroke-pink-200",
  "stroke-pink-300": "stroke-pink-300",
  "stroke-pink-400": "stroke-pink-400",
  "stroke-pink-500": "stroke-pink-500",
  "stroke-pink-600": "stroke-pink-600",
  "stroke-pink-700": "stroke-pink-700",
  "stroke-pink-800": "stroke-pink-800",
  "stroke-pink-900": "stroke-pink-900",
  "stroke-amber-100": "stroke-amber-100",
  "stroke-amber-200": "stroke-amber-200",
  "stroke-amber-300": "stroke-amber-300",
  "stroke-amber-400": "stroke-amber-400",
  "stroke-amber-500": "stroke-amber-500",
  "stroke-amber-600": "stroke-amber-600",
  "stroke-amber-700": "stroke-amber-700",
  "stroke-amber-800": "stroke-amber-800",
  "stroke-amber-900": "stroke-amber-900",
  "stroke-yellow-100": "stroke-yellow-100",
  "stroke-yellow-200": "stroke-yellow-200",
  "stroke-yellow-300": "stroke-yellow-300",
  "stroke-yellow-400": "stroke-yellow-400",
  "stroke-yellow-500": "stroke-yellow-500",
  "stroke-yellow-600": "stroke-yellow-600",
  "stroke-yellow-700": "stroke-yellow-700",
  "stroke-yellow-800": "stroke-yellow-800",
  "stroke-orange-100": "stroke-orange-100",
  "stroke-orange-200": "stroke-orange-200",
  "stroke-orange-300": "stroke-orange-300",
  "stroke-orange-400": "stroke-orange-400",
  "stroke-orange-500": "stroke-orange-500",
  "stroke-orange-600": "stroke-orange-600",
  "stroke-orange-700": "stroke-orange-700",
  "stroke-orange-800": "stroke-orange-800",
  "stroke-red-100": "stroke-red-100",
  "stroke-red-200": "stroke-red-200",
  "stroke-red-300": "stroke-red-300",
  "stroke-red-400": "stroke-red-400",
  "stroke-red-500": "stroke-red-500",
  "stroke-red-600": "stroke-red-600",
  "stroke-red-700": "stroke-red-700",
  "stroke-red-800": "stroke-red-800",
  "hover:bg-storybook-default-heading": "hover:bg-storybook-default-heading",
  "hover:bg-base-0": "hover:bg-base-0",
  "hover:bg-base-1000": "hover:bg-base-1000",
  "hover:bg-neutral-0": "hover:bg-neutral-0",
  "hover:bg-neutral-50": "hover:bg-neutral-50",
  "hover:bg-neutral-100": "hover:bg-neutral-100",
  "hover:bg-neutral-150": "hover:bg-neutral-150",
  "hover:bg-neutral-200": "hover:bg-neutral-200",
  "hover:bg-neutral-300": "hover:bg-neutral-300",
  "hover:bg-neutral-400": "hover:bg-neutral-400",
  "hover:bg-neutral-500": "hover:bg-neutral-500",
  "hover:bg-neutral-600": "hover:bg-neutral-600",
  "hover:bg-neutral-700": "hover:bg-neutral-700",
  "hover:bg-neutral-800": "hover:bg-neutral-800",
  "hover:bg-neutral-850": "hover:bg-neutral-850",
  "hover:bg-neutral-900": "hover:bg-neutral-900",
  "hover:bg-neutral-950": "hover:bg-neutral-950",
  "hover:bg-neutral-1000": "hover:bg-neutral-1000",
  "hover:bg-blue-100": "hover:bg-blue-100",
  "hover:bg-blue-200": "hover:bg-blue-200",
  "hover:bg-blue-300": "hover:bg-blue-300",
  "hover:bg-blue-400": "hover:bg-blue-400",
  "hover:bg-blue-500": "hover:bg-blue-500",
  "hover:bg-blue-600": "hover:bg-blue-600",
  "hover:bg-blue-700": "hover:bg-blue-700",
  "hover:bg-blue-800": "hover:bg-blue-800",
  "hover:bg-blue-900": "hover:bg-blue-900",
  "hover:bg-purple-100": "hover:bg-purple-100",
  "hover:bg-purple-200": "hover:bg-purple-200",
  "hover:bg-purple-300": "hover:bg-purple-300",
  "hover:bg-purple-400": "hover:bg-purple-400",
  "hover:bg-purple-500": "hover:bg-purple-500",
  "hover:bg-purple-600": "hover:bg-purple-600",
  "hover:bg-purple-700": "hover:bg-purple-700",
  "hover:bg-purple-800": "hover:bg-purple-800",
  "hover:bg-purple-900": "hover:bg-purple-900",
  "hover:bg-cyan-100": "hover:bg-cyan-100",
  "hover:bg-cyan-200": "hover:bg-cyan-200",
  "hover:bg-cyan-300": "hover:bg-cyan-300",
  "hover:bg-cyan-400": "hover:bg-cyan-400",
  "hover:bg-cyan-500": "hover:bg-cyan-500",
  "hover:bg-cyan-600": "hover:bg-cyan-600",
  "hover:bg-cyan-700": "hover:bg-cyan-700",
  "hover:bg-cyan-800": "hover:bg-cyan-800",
  "hover:bg-cyan-900": "hover:bg-cyan-900",
  "hover:bg-green-100": "hover:bg-green-100",
  "hover:bg-green-200": "hover:bg-green-200",
  "hover:bg-green-300": "hover:bg-green-300",
  "hover:bg-green-400": "hover:bg-green-400",
  "hover:bg-green-500": "hover:bg-green-500",
  "hover:bg-green-600": "hover:bg-green-600",
  "hover:bg-green-700": "hover:bg-green-700",
  "hover:bg-green-800": "hover:bg-green-800",
  "hover:bg-green-900": "hover:bg-green-900",
  "hover:bg-pink-100": "hover:bg-pink-100",
  "hover:bg-pink-200": "hover:bg-pink-200",
  "hover:bg-pink-300": "hover:bg-pink-300",
  "hover:bg-pink-400": "hover:bg-pink-400",
  "hover:bg-pink-500": "hover:bg-pink-500",
  "hover:bg-pink-600": "hover:bg-pink-600",
  "hover:bg-pink-700": "hover:bg-pink-700",
  "hover:bg-pink-800": "hover:bg-pink-800",
  "hover:bg-pink-900": "hover:bg-pink-900",
  "hover:bg-amber-100": "hover:bg-amber-100",
  "hover:bg-amber-200": "hover:bg-amber-200",
  "hover:bg-amber-300": "hover:bg-amber-300",
  "hover:bg-amber-400": "hover:bg-amber-400",
  "hover:bg-amber-500": "hover:bg-amber-500",
  "hover:bg-amber-600": "hover:bg-amber-600",
  "hover:bg-amber-700": "hover:bg-amber-700",
  "hover:bg-amber-800": "hover:bg-amber-800",
  "hover:bg-amber-900": "hover:bg-amber-900",
  "hover:bg-yellow-100": "hover:bg-yellow-100",
  "hover:bg-yellow-200": "hover:bg-yellow-200",
  "hover:bg-yellow-300": "hover:bg-yellow-300",
  "hover:bg-yellow-400": "hover:bg-yellow-400",
  "hover:bg-yellow-500": "hover:bg-yellow-500",
  "hover:bg-yellow-600": "hover:bg-yellow-600",
  "hover:bg-yellow-700": "hover:bg-yellow-700",
  "hover:bg-yellow-800": "hover:bg-yellow-800",
  "hover:bg-orange-100": "hover:bg-orange-100",
  "hover:bg-orange-200": "hover:bg-orange-200",
  "hover:bg-orange-300": "hover:bg-orange-300",
  "hover:bg-orange-400": "hover:bg-orange-400",
  "hover:bg-orange-500": "hover:bg-orange-500",
  "hover:bg-orange-600": "hover:bg-orange-600",
  "hover:bg-orange-700": "hover:bg-orange-700",
  "hover:bg-orange-800": "hover:bg-orange-800",
  "hover:bg-red-100": "hover:bg-red-100",
  "hover:bg-red-200": "hover:bg-red-200",
  "hover:bg-red-300": "hover:bg-red-300",
  "hover:bg-red-400": "hover:bg-red-400",
  "hover:bg-red-500": "hover:bg-red-500",
  "hover:bg-red-600": "hover:bg-red-600",
  "hover:bg-red-700": "hover:bg-red-700",
  "hover:bg-red-800": "hover:bg-red-800",
  "border-storybook-default-heading": "border-storybook-default-heading",
  "border-base-0": "border-base-0",
  "border-base-1000": "border-base-1000",
  "border-neutral-0": "border-neutral-0",
  "border-neutral-50": "border-neutral-50",
  "border-neutral-100": "border-neutral-100",
  "border-neutral-150": "border-neutral-150",
  "border-neutral-200": "border-neutral-200",
  "border-neutral-300": "border-neutral-300",
  "border-neutral-400": "border-neutral-400",
  "border-neutral-500": "border-neutral-500",
  "border-neutral-600": "border-neutral-600",
  "border-neutral-700": "border-neutral-700",
  "border-neutral-800": "border-neutral-800",
  "border-neutral-850": "border-neutral-850",
  "border-neutral-900": "border-neutral-900",
  "border-neutral-950": "border-neutral-950",
  "border-neutral-1000": "border-neutral-1000",
  "border-blue-100": "border-blue-100",
  "border-blue-200": "border-blue-200",
  "border-blue-300": "border-blue-300",
  "border-blue-400": "border-blue-400",
  "border-blue-500": "border-blue-500",
  "border-blue-600": "border-blue-600",
  "border-blue-700": "border-blue-700",
  "border-blue-800": "border-blue-800",
  "border-blue-900": "border-blue-900",
  "border-purple-100": "border-purple-100",
  "border-purple-200": "border-purple-200",
  "border-purple-300": "border-purple-300",
  "border-purple-400": "border-purple-400",
  "border-purple-500": "border-purple-500",
  "border-purple-600": "border-purple-600",
  "border-purple-700": "border-purple-700",
  "border-purple-800": "border-purple-800",
  "border-purple-900": "border-purple-900",
  "border-cyan-100": "border-cyan-100",
  "border-cyan-200": "border-cyan-200",
  "border-cyan-300": "border-cyan-300",
  "border-cyan-400": "border-cyan-400",
  "border-cyan-500": "border-cyan-500",
  "border-cyan-600": "border-cyan-600",
  "border-cyan-700": "border-cyan-700",
  "border-cyan-800": "border-cyan-800",
  "border-cyan-900": "border-cyan-900",
  "border-green-100": "border-green-100",
  "border-green-200": "border-green-200",
  "border-green-300": "border-green-300",
  "border-green-400": "border-green-400",
  "border-green-500": "border-green-500",
  "border-green-600": "border-green-600",
  "border-green-700": "border-green-700",
  "border-green-800": "border-green-800",
  "border-green-900": "border-green-900",
  "border-pink-100": "border-pink-100",
  "border-pink-200": "border-pink-200",
  "border-pink-300": "border-pink-300",
  "border-pink-400": "border-pink-400",
  "border-pink-500": "border-pink-500",
  "border-pink-600": "border-pink-600",
  "border-pink-700": "border-pink-700",
  "border-pink-800": "border-pink-800",
  "border-pink-900": "border-pink-900",
  "border-amber-100": "border-amber-100",
  "border-amber-200": "border-amber-200",
  "border-amber-300": "border-amber-300",
  "border-amber-400": "border-amber-400",
  "border-amber-500": "border-amber-500",
  "border-amber-600": "border-amber-600",
  "border-amber-700": "border-amber-700",
  "border-amber-800": "border-amber-800",
  "border-amber-900": "border-amber-900",
  "border-yellow-100": "border-yellow-100",
  "border-yellow-200": "border-yellow-200",
  "border-yellow-300": "border-yellow-300",
  "border-yellow-400": "border-yellow-400",
  "border-yellow-500": "border-yellow-500",
  "border-yellow-600": "border-yellow-600",
  "border-yellow-700": "border-yellow-700",
  "border-yellow-800": "border-yellow-800",
  "border-orange-100": "border-orange-100",
  "border-orange-200": "border-orange-200",
  "border-orange-300": "border-orange-300",
  "border-orange-400": "border-orange-400",
  "border-orange-500": "border-orange-500",
  "border-orange-600": "border-orange-600",
  "border-orange-700": "border-orange-700",
  "border-orange-800": "border-orange-800",
  "border-red-100": "border-red-100",
  "border-red-200": "border-red-200",
  "border-red-300": "border-red-300",
  "border-red-400": "border-red-400",
  "border-red-500": "border-red-500",
  "border-red-600": "border-red-600",
  "border-red-700": "border-red-700",
  "border-red-800": "border-red-800"
};
function A() {
  let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return R[e] || (R[e] = e), R[e];
}
function T(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function H(e) {
  if (e.__esModule) return e;
  var t = e.default;
  if ("function" == typeof t) {
    var r = function e() {
      if (this instanceof e) {
        var r = [null];
        return r.push.apply(r, arguments), new (Function.bind.apply(t, r))();
      }
      return t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", {
    value: !0
  }), Object.keys(e).forEach(function (t) {
    var n = Object.getOwnPropertyDescriptor(e, t);
    Object.defineProperty(r, t, n.get ? n : {
      enumerable: !0,
      get: function () {
        return e[t];
      }
    });
  }), r;
}
var L,
  I = {
    exports: {}
  },
  F = {
    exports: {}
  },
  _ = {};
var Z,
  D,
  q,
  U,
  $,
  z,
  W,
  Q,
  G,
  Y,
  K,
  X,
  J,
  ee,
  te = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function re() {
  return D || (D = 1, "production" === process.env.NODE_ENV ? F.exports = function () {
    if (L) return _;
    L = 1;
    var e = "function" == typeof Symbol && Symbol.for,
      t = e ? Symbol.for("react.element") : 60103,
      r = e ? Symbol.for("react.portal") : 60106,
      n = e ? Symbol.for("react.fragment") : 60107,
      a = e ? Symbol.for("react.strict_mode") : 60108,
      o = e ? Symbol.for("react.profiler") : 60114,
      i = e ? Symbol.for("react.provider") : 60109,
      l = e ? Symbol.for("react.context") : 60110,
      s = e ? Symbol.for("react.async_mode") : 60111,
      c = e ? Symbol.for("react.concurrent_mode") : 60111,
      u = e ? Symbol.for("react.forward_ref") : 60112,
      h = e ? Symbol.for("react.suspense") : 60113,
      m = e ? Symbol.for("react.suspense_list") : 60120,
      p = e ? Symbol.for("react.memo") : 60115,
      f = e ? Symbol.for("react.lazy") : 60116,
      d = e ? Symbol.for("react.block") : 60121,
      v = e ? Symbol.for("react.fundamental") : 60117,
      g = e ? Symbol.for("react.responder") : 60118,
      b = e ? Symbol.for("react.scope") : 60119;
    function w(e) {
      if ("object" == typeof e && null !== e) {
        var m = e.$$typeof;
        switch (m) {
          case t:
            switch (e = e.type) {
              case s:
              case c:
              case n:
              case o:
              case a:
              case h:
                return e;
              default:
                switch (e = e && e.$$typeof) {
                  case l:
                  case u:
                  case f:
                  case p:
                  case i:
                    return e;
                  default:
                    return m;
                }
            }
          case r:
            return m;
        }
      }
    }
    function y(e) {
      return w(e) === c;
    }
    return _.AsyncMode = s, _.ConcurrentMode = c, _.ContextConsumer = l, _.ContextProvider = i, _.Element = t, _.ForwardRef = u, _.Fragment = n, _.Lazy = f, _.Memo = p, _.Portal = r, _.Profiler = o, _.StrictMode = a, _.Suspense = h, _.isAsyncMode = function (e) {
      return y(e) || w(e) === s;
    }, _.isConcurrentMode = y, _.isContextConsumer = function (e) {
      return w(e) === l;
    }, _.isContextProvider = function (e) {
      return w(e) === i;
    }, _.isElement = function (e) {
      return "object" == typeof e && null !== e && e.$$typeof === t;
    }, _.isForwardRef = function (e) {
      return w(e) === u;
    }, _.isFragment = function (e) {
      return w(e) === n;
    }, _.isLazy = function (e) {
      return w(e) === f;
    }, _.isMemo = function (e) {
      return w(e) === p;
    }, _.isPortal = function (e) {
      return w(e) === r;
    }, _.isProfiler = function (e) {
      return w(e) === o;
    }, _.isStrictMode = function (e) {
      return w(e) === a;
    }, _.isSuspense = function (e) {
      return w(e) === h;
    }, _.isValidElementType = function (e) {
      return "string" == typeof e || "function" == typeof e || e === n || e === c || e === o || e === a || e === h || e === m || "object" == typeof e && null !== e && (e.$$typeof === f || e.$$typeof === p || e.$$typeof === i || e.$$typeof === l || e.$$typeof === u || e.$$typeof === v || e.$$typeof === g || e.$$typeof === b || e.$$typeof === d);
    }, _.typeOf = w, _;
  }() : F.exports = (Z || (Z = 1, "production" !== process.env.NODE_ENV && function () {
    var e = "function" == typeof Symbol && Symbol.for,
      t = e ? Symbol.for("react.element") : 60103,
      r = e ? Symbol.for("react.portal") : 60106,
      n = e ? Symbol.for("react.fragment") : 60107,
      a = e ? Symbol.for("react.strict_mode") : 60108,
      o = e ? Symbol.for("react.profiler") : 60114,
      i = e ? Symbol.for("react.provider") : 60109,
      l = e ? Symbol.for("react.context") : 60110,
      s = e ? Symbol.for("react.async_mode") : 60111,
      c = e ? Symbol.for("react.concurrent_mode") : 60111,
      u = e ? Symbol.for("react.forward_ref") : 60112,
      h = e ? Symbol.for("react.suspense") : 60113,
      m = e ? Symbol.for("react.suspense_list") : 60120,
      p = e ? Symbol.for("react.memo") : 60115,
      f = e ? Symbol.for("react.lazy") : 60116,
      d = e ? Symbol.for("react.block") : 60121,
      v = e ? Symbol.for("react.fundamental") : 60117,
      g = e ? Symbol.for("react.responder") : 60118,
      b = e ? Symbol.for("react.scope") : 60119;
    function w(e) {
      if ("object" == typeof e && null !== e) {
        var m = e.$$typeof;
        switch (m) {
          case t:
            var d = e.type;
            switch (d) {
              case s:
              case c:
              case n:
              case o:
              case a:
              case h:
                return d;
              default:
                var v = d && d.$$typeof;
                switch (v) {
                  case l:
                  case u:
                  case f:
                  case p:
                  case i:
                    return v;
                  default:
                    return m;
                }
            }
          case r:
            return m;
        }
      }
    }
    var y = s,
      x = c,
      O = l,
      E = i,
      j = t,
      C = u,
      P = n,
      M = f,
      k = p,
      S = r,
      N = o,
      B = a,
      V = h,
      R = !1;
    function A(e) {
      return w(e) === c;
    }
    te.AsyncMode = y, te.ConcurrentMode = x, te.ContextConsumer = O, te.ContextProvider = E, te.Element = j, te.ForwardRef = C, te.Fragment = P, te.Lazy = M, te.Memo = k, te.Portal = S, te.Profiler = N, te.StrictMode = B, te.Suspense = V, te.isAsyncMode = function (e) {
      return R || (R = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), A(e) || w(e) === s;
    }, te.isConcurrentMode = A, te.isContextConsumer = function (e) {
      return w(e) === l;
    }, te.isContextProvider = function (e) {
      return w(e) === i;
    }, te.isElement = function (e) {
      return "object" == typeof e && null !== e && e.$$typeof === t;
    }, te.isForwardRef = function (e) {
      return w(e) === u;
    }, te.isFragment = function (e) {
      return w(e) === n;
    }, te.isLazy = function (e) {
      return w(e) === f;
    }, te.isMemo = function (e) {
      return w(e) === p;
    }, te.isPortal = function (e) {
      return w(e) === r;
    }, te.isProfiler = function (e) {
      return w(e) === o;
    }, te.isStrictMode = function (e) {
      return w(e) === a;
    }, te.isSuspense = function (e) {
      return w(e) === h;
    }, te.isValidElementType = function (e) {
      return "string" == typeof e || "function" == typeof e || e === n || e === c || e === o || e === a || e === h || e === m || "object" == typeof e && null !== e && (e.$$typeof === f || e.$$typeof === p || e.$$typeof === i || e.$$typeof === l || e.$$typeof === u || e.$$typeof === v || e.$$typeof === g || e.$$typeof === b || e.$$typeof === d);
    }, te.typeOf = w;
  }()), te)), F.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
function ne() {
  if (U) return q;
  U = 1;
  var e = Object.getOwnPropertySymbols,
    t = Object.prototype.hasOwnProperty,
    r = Object.prototype.propertyIsEnumerable;
  return q = function () {
    try {
      if (!Object.assign) return !1;
      var e = new String("abc");
      if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;
      for (var t = {}, r = 0; r < 10; r++) t["_" + String.fromCharCode(r)] = r;
      var n = Object.getOwnPropertyNames(t).map(function (e) {
        return t[e];
      });
      if ("0123456789" !== n.join("")) return !1;
      var a = {};
      return "abcdefghijklmnopqrst".split("").forEach(function (e) {
        a[e] = e;
      }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, a)).join("");
    } catch (e) {
      return !1;
    }
  }() ? Object.assign : function (n, a) {
    for (var o, i, l = function (e) {
        if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
        return Object(e);
      }(n), s = 1; s < arguments.length; s++) {
      for (var c in o = Object(arguments[s])) t.call(o, c) && (l[c] = o[c]);
      if (e) {
        i = e(o);
        for (var u = 0; u < i.length; u++) r.call(o, i[u]) && (l[i[u]] = o[i[u]]);
      }
    }
    return l;
  }, q;
}
function ae() {
  if (z) return $;
  z = 1;
  return $ = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}
function oe() {
  return Q ? W : (Q = 1, W = Function.call.bind(Object.prototype.hasOwnProperty));
}
if ("production" !== process.env.NODE_ENV) {
  var ie = re();
  I.exports = function () {
    if (X) return K;
    X = 1;
    var e = re(),
      t = ne(),
      r = ae(),
      n = oe(),
      a = function () {
        if (Y) return G;
        Y = 1;
        var e = function () {};
        if ("production" !== process.env.NODE_ENV) {
          var t = ae(),
            r = {},
            n = oe();
          e = function (e) {
            var t = "Warning: " + e;
            "undefined" != typeof console && console.error(t);
            try {
              throw new Error(t);
            } catch (e) {}
          };
        }
        function a(a, o, i, l, s) {
          if ("production" !== process.env.NODE_ENV) for (var c in a) if (n(a, c)) {
            var u;
            try {
              if ("function" != typeof a[c]) {
                var h = Error((l || "React class") + ": " + i + " type `" + c + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[c] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw h.name = "Invariant Violation", h;
              }
              u = a[c](o, c, l, i, null, t);
            } catch (e) {
              u = e;
            }
            if (!u || u instanceof Error || e((l || "React class") + ": type specification of " + i + " `" + c + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof u + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), u instanceof Error && !(u.message in r)) {
              r[u.message] = !0;
              var m = s ? s() : "";
              e("Failed " + i + " type: " + u.message + (null != m ? m : ""));
            }
          }
        }
        return a.resetWarningCache = function () {
          "production" !== process.env.NODE_ENV && (r = {});
        }, G = a;
      }(),
      o = function () {};
    function i() {
      return null;
    }
    return "production" !== process.env.NODE_ENV && (o = function (e) {
      var t = "Warning: " + e;
      "undefined" != typeof console && console.error(t);
      try {
        throw new Error(t);
      } catch (e) {}
    }), K = function (l, s) {
      var c = "function" == typeof Symbol && Symbol.iterator,
        u = "@@iterator",
        h = "<<anonymous>>",
        m = {
          array: v("array"),
          bigint: v("bigint"),
          bool: v("boolean"),
          func: v("function"),
          number: v("number"),
          object: v("object"),
          string: v("string"),
          symbol: v("symbol"),
          any: d(i),
          arrayOf: function (e) {
            return d(function (t, n, a, o, i) {
              if ("function" != typeof e) return new f("Property `" + i + "` of component `" + a + "` has invalid PropType notation inside arrayOf.");
              var l = t[n];
              if (!Array.isArray(l)) return new f("Invalid " + o + " `" + i + "` of type `" + w(l) + "` supplied to `" + a + "`, expected an array.");
              for (var s = 0; s < l.length; s++) {
                var c = e(l, s, a, o, i + "[" + s + "]", r);
                if (c instanceof Error) return c;
              }
              return null;
            });
          },
          element: d(function (e, t, r, n, a) {
            var o = e[t];
            return l(o) ? null : new f("Invalid " + n + " `" + a + "` of type `" + w(o) + "` supplied to `" + r + "`, expected a single ReactElement.");
          }),
          elementType: d(function (t, r, n, a, o) {
            var i = t[r];
            return e.isValidElementType(i) ? null : new f("Invalid " + a + " `" + o + "` of type `" + w(i) + "` supplied to `" + n + "`, expected a single ReactElement type.");
          }),
          instanceOf: function (e) {
            return d(function (t, r, n, a, o) {
              if (!(t[r] instanceof e)) {
                var i = e.name || h;
                return new f("Invalid " + a + " `" + o + "` of type `" + ((l = t[r]).constructor && l.constructor.name ? l.constructor.name : h) + "` supplied to `" + n + "`, expected instance of `" + i + "`.");
              }
              var l;
              return null;
            });
          },
          node: d(function (e, t, r, n, a) {
            return b(e[t]) ? null : new f("Invalid " + n + " `" + a + "` supplied to `" + r + "`, expected a ReactNode.");
          }),
          objectOf: function (e) {
            return d(function (t, a, o, i, l) {
              if ("function" != typeof e) return new f("Property `" + l + "` of component `" + o + "` has invalid PropType notation inside objectOf.");
              var s = t[a],
                c = w(s);
              if ("object" !== c) return new f("Invalid " + i + " `" + l + "` of type `" + c + "` supplied to `" + o + "`, expected an object.");
              for (var u in s) if (n(s, u)) {
                var h = e(s, u, o, i, l + "." + u, r);
                if (h instanceof Error) return h;
              }
              return null;
            });
          },
          oneOf: function (e) {
            return Array.isArray(e) ? d(function (t, r, n, a, o) {
              for (var i = t[r], l = 0; l < e.length; l++) if (p(i, e[l])) return null;
              var s = JSON.stringify(e, function (e, t) {
                return "symbol" === y(t) ? String(t) : t;
              });
              return new f("Invalid " + a + " `" + o + "` of value `" + String(i) + "` supplied to `" + n + "`, expected one of " + s + ".");
            }) : ("production" !== process.env.NODE_ENV && o(arguments.length > 1 ? "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])." : "Invalid argument supplied to oneOf, expected an array."), i);
          },
          oneOfType: function (e) {
            if (!Array.isArray(e)) return "production" !== process.env.NODE_ENV && o("Invalid argument supplied to oneOfType, expected an instance of array."), i;
            for (var t = 0; t < e.length; t++) {
              var a = e[t];
              if ("function" != typeof a) return o("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + x(a) + " at index " + t + "."), i;
            }
            return d(function (t, a, o, i, l) {
              for (var s = [], c = 0; c < e.length; c++) {
                var u = (0, e[c])(t, a, o, i, l, r);
                if (null == u) return null;
                u.data && n(u.data, "expectedType") && s.push(u.data.expectedType);
              }
              return new f("Invalid " + i + " `" + l + "` supplied to `" + o + "`" + (s.length > 0 ? ", expected one of type [" + s.join(", ") + "]" : "") + ".");
            });
          },
          shape: function (e) {
            return d(function (t, n, a, o, i) {
              var l = t[n],
                s = w(l);
              if ("object" !== s) return new f("Invalid " + o + " `" + i + "` of type `" + s + "` supplied to `" + a + "`, expected `object`.");
              for (var c in e) {
                var u = e[c];
                if ("function" != typeof u) return g(a, o, i, c, y(u));
                var h = u(l, c, a, o, i + "." + c, r);
                if (h) return h;
              }
              return null;
            });
          },
          exact: function (e) {
            return d(function (a, o, i, l, s) {
              var c = a[o],
                u = w(c);
              if ("object" !== u) return new f("Invalid " + l + " `" + s + "` of type `" + u + "` supplied to `" + i + "`, expected `object`.");
              var h = t({}, a[o], e);
              for (var m in h) {
                var p = e[m];
                if (n(e, m) && "function" != typeof p) return g(i, l, s, m, y(p));
                if (!p) return new f("Invalid " + l + " `" + s + "` key `" + m + "` supplied to `" + i + "`.\nBad object: " + JSON.stringify(a[o], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(e), null, "  "));
                var d = p(c, m, i, l, s + "." + m, r);
                if (d) return d;
              }
              return null;
            });
          }
        };
      function p(e, t) {
        return e === t ? 0 !== e || 1 / e == 1 / t : e != e && t != t;
      }
      function f(e, t) {
        this.message = e, this.data = t && "object" == typeof t ? t : {}, this.stack = "";
      }
      function d(e) {
        if ("production" !== process.env.NODE_ENV) var t = {},
          n = 0;
        function a(a, i, l, c, u, m, p) {
          if (c = c || h, m = m || l, p !== r) {
            if (s) {
              var d = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
              throw d.name = "Invariant Violation", d;
            }
            if ("production" !== process.env.NODE_ENV && "undefined" != typeof console) {
              var v = c + ":" + l;
              !t[v] && n < 3 && (o("You are manually calling a React.PropTypes validation function for the `" + m + "` prop on `" + c + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), t[v] = !0, n++);
            }
          }
          return null == i[l] ? a ? null === i[l] ? new f("The " + u + " `" + m + "` is marked as required in `" + c + "`, but its value is `null`.") : new f("The " + u + " `" + m + "` is marked as required in `" + c + "`, but its value is `undefined`.") : null : e(i, l, c, u, m);
        }
        var i = a.bind(null, !1);
        return i.isRequired = a.bind(null, !0), i;
      }
      function v(e) {
        return d(function (t, r, n, a, o, i) {
          var l = t[r];
          return w(l) !== e ? new f("Invalid " + a + " `" + o + "` of type `" + y(l) + "` supplied to `" + n + "`, expected `" + e + "`.", {
            expectedType: e
          }) : null;
        });
      }
      function g(e, t, r, n, a) {
        return new f((e || "React class") + ": " + t + " type `" + r + "." + n + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + a + "`.");
      }
      function b(e) {
        switch (typeof e) {
          case "number":
          case "string":
          case "undefined":
            return !0;
          case "boolean":
            return !e;
          case "object":
            if (Array.isArray(e)) return e.every(b);
            if (null === e || l(e)) return !0;
            var t = function (e) {
              var t = e && (c && e[c] || e[u]);
              if ("function" == typeof t) return t;
            }(e);
            if (!t) return !1;
            var r,
              n = t.call(e);
            if (t !== e.entries) {
              for (; !(r = n.next()).done;) if (!b(r.value)) return !1;
            } else for (; !(r = n.next()).done;) {
              var a = r.value;
              if (a && !b(a[1])) return !1;
            }
            return !0;
          default:
            return !1;
        }
      }
      function w(e) {
        var t = typeof e;
        return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : function (e, t) {
          return "symbol" === e || !!t && ("Symbol" === t["@@toStringTag"] || "function" == typeof Symbol && t instanceof Symbol);
        }(t, e) ? "symbol" : t;
      }
      function y(e) {
        if (null == e) return "" + e;
        var t = w(e);
        if ("object" === t) {
          if (e instanceof Date) return "date";
          if (e instanceof RegExp) return "regexp";
        }
        return t;
      }
      function x(e) {
        var t = y(e);
        switch (t) {
          case "array":
          case "object":
            return "an " + t;
          case "boolean":
          case "date":
          case "regexp":
            return "a " + t;
          default:
            return t;
        }
      }
      return f.prototype = Error.prototype, m.checkPropTypes = a, m.resetWarningCache = a.resetWarningCache, m.PropTypes = m, m;
    }, K;
  }()(ie.isElement, !0);
} else I.exports = function () {
  if (ee) return J;
  ee = 1;
  var e = ae();
  function t() {}
  function r() {}
  return r.resetWarningCache = t, J = function () {
    function n(t, r, n, a, o, i) {
      if (i !== e) {
        var l = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw l.name = "Invariant Violation", l;
      }
    }
    function a() {
      return n;
    }
    n.isRequired = n;
    var o = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: a,
      element: n,
      elementType: n,
      instanceOf: a,
      node: n,
      objectOf: a,
      oneOf: a,
      oneOfType: a,
      shape: a,
      exact: a,
      checkPropTypes: r,
      resetWarningCache: t
    };
    return o.PropTypes = o, o;
  };
}()();
var le = I.exports,
  se = T(le);
function ce(e) {
  const {
      children: r,
      textStyle: n = "h1",
      className: a = "",
      as: o = "div"
    } = e,
    i = o;
  return t.createElement(i, {
    className: "".concat({
      h1: "text-hds-m-h1 tb:text-hds-t-h1 db:text-hds-d-h1",
      h2: "text-hds-m-h2 tb:text-hds-t-h2 db:text-hds-d-h2",
      h3: "text-hds-m-h3 tb:text-hds-t-h3 db:text-hds-d-h3",
      h4: "text-hds-m-h4 tb:text-hds-t-h4 db:text-hds-d-h4",
      h5: "text-hds-m-h5 tb:text-hds-t-h5 db:text-hds-d-h5",
      h6: "text-hds-m-h6 tb:text-hds-t-h6 db:text-hds-d-h6",
      h7: "text-hds-m-h7 tb:text-hds-t-h7 db:text-hds-d-h7",
      sub1: "text-hds-m-sub1 tb:text-hds-t-sub1 db:text-hds-d-sub1",
      sub2: "text-hds-m-sub2 tb:text-hds-t-sub2 db:text-hds-d-sub2",
      body1: "text-hds-m-body1 tb:text-hds-t-body1 db:text-hds-d-body1",
      "body1-medium": "text-hds-m-body1-medium tb:text-hds-t-body1-medium db:text-hds-d-body1-medium",
      "body1-semi-bold": "text-hds-m-body1-semi-bold tb:text-hds-t-body1-semi-bold db:text-hds-d-body1-semi-bold",
      "body1-bold": "text-hds-m-body1-bold tb:text-hds-t-body1-bold db:text-hds-d-body1-bold",
      body1c: "text-hds-m-body1c tb:text-hds-t-body1c db:text-hds-d-body1c",
      "body1c-medium": "text-hds-m-body1c-medium tb:text-hds-t-body1c-medium db:text-hds-d-body1c-medium",
      "body1c-semi-bold": "text-hds-m-body1c-semi-bold tb:text-hds-t-body1c-semi-bold db:text-hds-d-body1c-semi-bold",
      "body1c-bold": "text-hds-m-body1c-bold tb:text-hds-t-body1c-bold db:text-hds-d-body1c-bold",
      body2: "text-hds-m-body2 tb:text-hds-t-body2 db:text-hds-d-body2",
      "body2-medium": "text-hds-m-body2-medium tb:text-hds-t-body2-medium db:text-hds-d-body2-medium",
      "body2-semi-bold": "text-hds-m-body2-semi-bold tb:text-hds-t-body2-semi-bold db:text-hds-d-body2-semi-bold",
      "body2-bold": "text-hds-m-body2-bold tb:text-hds-t-body2-bold db:text-hds-d-body2-bold",
      body2c: "text-hds-m-body2c tb:text-hds-t-body2c db:text-hds-d-body2c",
      "body2c-medium": "text-hds-m-body2c-medium tb:text-hds-t-body2c-medium db:text-hds-d-body2c-medium",
      "body2c-semi-bold": "text-hds-m-body2c-semi-bold tb:text-hds-t-body2c-semi-bold db:text-hds-d-body2c-semi-bold",
      "body2c-bold": "text-hds-m-body2c-bold tb:text-hds-t-body2c-bold db:text-hds-d-body2c-bold",
      body3: "text-hds-m-body3 tb:text-hds-t-body3 db:text-hds-d-body3",
      "body3-medium": "text-hds-m-body3-medium tb:text-hds-t-body3-medium db:text-hds-d-body3-medium",
      "body3-semi-bold": "text-hds-m-body3-semi-bold tb:text-hds-t-body3-semi-bold db:text-hds-d-body3-semi-bold",
      "body3-bold": "text-hds-m-body3-bold tb:text-hds-t-body3-bold db:text-hds-d-body3-bold",
      body3c: "text-hds-m-body3c tb:text-hds-t-body3c db:text-hds-d-body3c",
      "body3c-medium": "text-hds-m-body3c-medium tb:text-hds-t-body3c-medium db:text-hds-d-body3c-medium",
      "body3c-semi-bold": "text-hds-m-body3c-semi-bold tb:text-hds-t-body3c-semi-bold db:text-hds-d-body3c-semi-bold",
      "body3c-bold": "text-hds-m-body3c-bold tb:text-hds-t-body3c-bold db:text-hds-d-body3c-bold",
      quote: "font-petrona font-normal italic text-hds-m-quote tb:text-hds-t-quote db:text-hds-d-quote",
      code1: "font-firaCode text-hds-m-code1 tb:text-hds-t-code1 db:text-hds-d-code1",
      code2: "text-hds-m-code2 tb:text-hds-t-code2 db:text-hds-d-code2"
    }[n], " ").concat(a)
  }, r);
}
ce.propTypes = {
  textStyle: le.PropTypes.string,
  className: le.PropTypes.string
}, ce.defaultProps = {
  children: "default Text",
  textStyle: "h1"
};
const ue = _ref => {
    let {
      applyclass: e,
      text: r
    } = _ref;
    return t.createElement("div", {
      className: " "
    }, t.createElement("div", {
      className: "grid grid-cols-4 gap-10"
    }, t.createElement("div", null, "ClassName"), t.createElement("div", null, "Tab"), t.createElement("div", null, "Mobile"), t.createElement("div", null, "Desktop")), t.createElement("div", {
      className: "grid grid-cols-4 gap-10 border"
    }, t.createElement("div", null, e.map(e => t.createElement("div", {
      className: ""
    }, t.createElement("div", {
      className: "text-lg-regular not-italic flex items-center ml-2 col-span-1 my-10"
    }, e)))), t.createElement("div", {
      className: "grid grid-cols-3 gap-[14rem] "
    }, e.map(e => t.createElement("div", {
      className: ""
    }, t.createElement("div", {
      className: "".concat(e, " mr-2 ")
    }, "Aa"))))));
  },
  he = {
    en: {
      GREETING: "Hello!",
      GOODBYE: "Goodbye!"
    },
    fr: {
      GREETING: "Bonjour!",
      GOODBYE: "Au revoir!"
    },
    es: {
      GREETING: "¡Hola!",
      GOODBYE: "¡Adiós!"
    }
  };
var me;
function pe() {
  return pe = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, pe.apply(this, arguments);
}
var fe;
function de() {
  return de = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, de.apply(this, arguments);
}
var ve;
function ge() {
  return ge = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ge.apply(this, arguments);
}
var be;
function we() {
  return we = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, we.apply(this, arguments);
}
var ye;
function xe() {
  return xe = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, xe.apply(this, arguments);
}
var Oe, Ee, je;
function Ce() {
  return Ce = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ce.apply(this, arguments);
}
var Pe;
function Me() {
  return Me = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Me.apply(this, arguments);
}
var ke;
function Se() {
  return Se = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Se.apply(this, arguments);
}
var Ne;
function Be() {
  return Be = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Be.apply(this, arguments);
}
var Ve;
function Re() {
  return Re = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Re.apply(this, arguments);
}
var Ae, Te;
function He() {
  return He = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, He.apply(this, arguments);
}
var Le;
function Ie() {
  return Ie = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ie.apply(this, arguments);
}
var Fe;
function _e() {
  return _e = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, _e.apply(this, arguments);
}
var Ze;
function De() {
  return De = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, De.apply(this, arguments);
}
var qe;
function Ue() {
  return Ue = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ue.apply(this, arguments);
}
var $e;
function ze() {
  return ze = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ze.apply(this, arguments);
}
var We;
function Qe() {
  return Qe = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Qe.apply(this, arguments);
}
var Ge;
function Ye() {
  return Ye = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ye.apply(this, arguments);
}
var Ke;
function Xe() {
  return Xe = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Xe.apply(this, arguments);
}
var Je;
function et() {
  return et = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, et.apply(this, arguments);
}
var tt;
function rt() {
  return rt = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, rt.apply(this, arguments);
}
var nt;
function at() {
  return at = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, at.apply(this, arguments);
}
var ot;
function it() {
  return it = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, it.apply(this, arguments);
}
var lt;
function st() {
  return st = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, st.apply(this, arguments);
}
var ct;
function ut() {
  return ut = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ut.apply(this, arguments);
}
var ht;
function mt() {
  return mt = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, mt.apply(this, arguments);
}
var pt;
function ft() {
  return ft = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ft.apply(this, arguments);
}
var dt;
function vt() {
  return vt = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, vt.apply(this, arguments);
}
var gt;
function bt() {
  return bt = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, bt.apply(this, arguments);
}
var wt;
function yt() {
  return yt = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, yt.apply(this, arguments);
}
var xt;
function Ot() {
  return Ot = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ot.apply(this, arguments);
}
var Et;
function jt() {
  return jt = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, jt.apply(this, arguments);
}
var Ct;
function Pt() {
  return Pt = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Pt.apply(this, arguments);
}
var Mt;
function kt() {
  return kt = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, kt.apply(this, arguments);
}
var St;
function Nt() {
  return Nt = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Nt.apply(this, arguments);
}
var Bt;
function Vt() {
  return Vt = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Vt.apply(this, arguments);
}
var Rt;
function At() {
  return At = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, At.apply(this, arguments);
}
var Tt;
function Ht() {
  return Ht = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ht.apply(this, arguments);
}
var Lt;
function It() {
  return It = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, It.apply(this, arguments);
}
var Ft;
function _t() {
  return _t = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, _t.apply(this, arguments);
}
var Zt;
function Dt() {
  return Dt = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Dt.apply(this, arguments);
}
var qt;
function Ut() {
  return Ut = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ut.apply(this, arguments);
}
var $t;
function zt() {
  return zt = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, zt.apply(this, arguments);
}
var Wt;
function Qt() {
  return Qt = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Qt.apply(this, arguments);
}
var Gt;
function Yt() {
  return Yt = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Yt.apply(this, arguments);
}
var Kt;
function Xt() {
  return Xt = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Xt.apply(this, arguments);
}
var Jt;
function er() {
  return er = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, er.apply(this, arguments);
}
var tr;
function rr() {
  return rr = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, rr.apply(this, arguments);
}
var nr;
function ar() {
  return ar = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ar.apply(this, arguments);
}
var or;
function ir() {
  return ir = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ir.apply(this, arguments);
}
var lr;
function sr() {
  return sr = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, sr.apply(this, arguments);
}
var cr;
function ur() {
  return ur = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ur.apply(this, arguments);
}
var hr;
function mr() {
  return mr = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, mr.apply(this, arguments);
}
var pr;
function fr() {
  return fr = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, fr.apply(this, arguments);
}
var dr;
function vr() {
  return vr = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, vr.apply(this, arguments);
}
var gr;
function br() {
  return br = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, br.apply(this, arguments);
}
var wr;
function yr() {
  return yr = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, yr.apply(this, arguments);
}
var xr;
function Or() {
  return Or = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Or.apply(this, arguments);
}
var Er;
function jr() {
  return jr = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, jr.apply(this, arguments);
}
var Cr;
function Pr() {
  return Pr = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Pr.apply(this, arguments);
}
var Mr;
function kr() {
  return kr = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, kr.apply(this, arguments);
}
var Sr;
function Nr() {
  return Nr = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Nr.apply(this, arguments);
}
var Br;
function Vr() {
  return Vr = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Vr.apply(this, arguments);
}
var Rr;
function Ar() {
  return Ar = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ar.apply(this, arguments);
}
var Tr;
function Hr() {
  return Hr = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Hr.apply(this, arguments);
}
var Lr;
function Ir() {
  return Ir = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ir.apply(this, arguments);
}
var Fr;
function _r() {
  return _r = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, _r.apply(this, arguments);
}
var Zr;
function Dr() {
  return Dr = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Dr.apply(this, arguments);
}
var qr;
function Ur() {
  return Ur = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ur.apply(this, arguments);
}
var $r;
function zr() {
  return zr = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, zr.apply(this, arguments);
}
var Wr;
function Qr() {
  return Qr = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Qr.apply(this, arguments);
}
var Gr;
function Yr() {
  return Yr = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Yr.apply(this, arguments);
}
var Kr;
function Xr() {
  return Xr = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Xr.apply(this, arguments);
}
var Jr;
function en() {
  return en = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, en.apply(this, arguments);
}
var tn;
function rn() {
  return rn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, rn.apply(this, arguments);
}
var nn;
function an() {
  return an = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, an.apply(this, arguments);
}
var on;
function ln() {
  return ln = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ln.apply(this, arguments);
}
var sn, cn;
function un() {
  return un = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, un.apply(this, arguments);
}
var hn;
function mn() {
  return mn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, mn.apply(this, arguments);
}
var pn;
function fn() {
  return fn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, fn.apply(this, arguments);
}
var dn;
function vn() {
  return vn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, vn.apply(this, arguments);
}
var gn;
function bn() {
  return bn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, bn.apply(this, arguments);
}
var wn;
function yn() {
  return yn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, yn.apply(this, arguments);
}
var xn;
function On() {
  return On = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, On.apply(this, arguments);
}
var En;
function jn() {
  return jn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, jn.apply(this, arguments);
}
var Cn;
function Pn() {
  return Pn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Pn.apply(this, arguments);
}
var Mn, kn;
function Sn() {
  return Sn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Sn.apply(this, arguments);
}
var Nn;
function Bn() {
  return Bn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Bn.apply(this, arguments);
}
var Vn;
function Rn() {
  return Rn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Rn.apply(this, arguments);
}
var An;
function Tn() {
  return Tn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Tn.apply(this, arguments);
}
var Hn;
function Ln() {
  return Ln = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ln.apply(this, arguments);
}
var In;
function Fn() {
  return Fn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Fn.apply(this, arguments);
}
var _n;
function Zn() {
  return Zn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Zn.apply(this, arguments);
}
var Dn;
function qn() {
  return qn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, qn.apply(this, arguments);
}
var Un;
function $n() {
  return $n = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, $n.apply(this, arguments);
}
var zn;
function Wn() {
  return Wn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Wn.apply(this, arguments);
}
var Qn;
function Gn() {
  return Gn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Gn.apply(this, arguments);
}
var Yn;
function Kn() {
  return Kn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Kn.apply(this, arguments);
}
var Xn;
function Jn() {
  return Jn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Jn.apply(this, arguments);
}
var ea;
function ta() {
  return ta = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ta.apply(this, arguments);
}
var ra;
function na() {
  return na = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, na.apply(this, arguments);
}
var aa;
function oa() {
  return oa = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, oa.apply(this, arguments);
}
var ia;
function la() {
  return la = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, la.apply(this, arguments);
}
var sa;
function ca() {
  return ca = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ca.apply(this, arguments);
}
var ua;
function ha() {
  return ha = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ha.apply(this, arguments);
}
var ma;
function pa() {
  return pa = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, pa.apply(this, arguments);
}
var fa;
function da() {
  return da = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, da.apply(this, arguments);
}
var va;
function ga() {
  return ga = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ga.apply(this, arguments);
}
var ba;
function wa() {
  return wa = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, wa.apply(this, arguments);
}
var ya;
function xa() {
  return xa = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, xa.apply(this, arguments);
}
var Oa;
function Ea() {
  return Ea = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ea.apply(this, arguments);
}
var ja;
function Ca() {
  return Ca = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ca.apply(this, arguments);
}
var Pa;
function Ma() {
  return Ma = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ma.apply(this, arguments);
}
var ka;
function Sa() {
  return Sa = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Sa.apply(this, arguments);
}
var Na;
function Ba() {
  return Ba = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ba.apply(this, arguments);
}
var Va;
function Ra() {
  return Ra = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ra.apply(this, arguments);
}
var Aa;
function Ta() {
  return Ta = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ta.apply(this, arguments);
}
var Ha;
function La() {
  return La = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, La.apply(this, arguments);
}
var Ia;
function Fa() {
  return Fa = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Fa.apply(this, arguments);
}
var _a;
function Za() {
  return Za = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Za.apply(this, arguments);
}
var Da;
function qa() {
  return qa = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, qa.apply(this, arguments);
}
var Ua;
function $a() {
  return $a = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, $a.apply(this, arguments);
}
var za;
function Wa() {
  return Wa = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Wa.apply(this, arguments);
}
var Qa;
function Ga() {
  return Ga = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ga.apply(this, arguments);
}
var Ya;
function Ka() {
  return Ka = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ka.apply(this, arguments);
}
var Xa;
function Ja() {
  return Ja = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ja.apply(this, arguments);
}
var eo;
function to() {
  return to = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, to.apply(this, arguments);
}
var ro;
function no() {
  return no = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, no.apply(this, arguments);
}
var ao;
function oo() {
  return oo = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, oo.apply(this, arguments);
}
var io;
function lo() {
  return lo = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, lo.apply(this, arguments);
}
var so;
function co() {
  return co = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, co.apply(this, arguments);
}
var uo;
function ho() {
  return ho = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ho.apply(this, arguments);
}
var mo;
function po() {
  return po = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, po.apply(this, arguments);
}
var fo;
function vo() {
  return vo = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, vo.apply(this, arguments);
}
var go;
function bo() {
  return bo = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, bo.apply(this, arguments);
}
var wo;
function yo() {
  return yo = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, yo.apply(this, arguments);
}
var xo;
function Oo() {
  return Oo = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Oo.apply(this, arguments);
}
var Eo;
function jo() {
  return jo = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, jo.apply(this, arguments);
}
var Co;
function Po() {
  return Po = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Po.apply(this, arguments);
}
var Mo;
function ko() {
  return ko = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ko.apply(this, arguments);
}
var So;
function No() {
  return No = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, No.apply(this, arguments);
}
var Bo;
function Vo() {
  return Vo = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Vo.apply(this, arguments);
}
var Ro;
function Ao() {
  return Ao = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ao.apply(this, arguments);
}
var To;
function Ho() {
  return Ho = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ho.apply(this, arguments);
}
var Lo;
function Io() {
  return Io = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Io.apply(this, arguments);
}
var Fo;
function _o() {
  return _o = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, _o.apply(this, arguments);
}
var Zo;
function Do() {
  return Do = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Do.apply(this, arguments);
}
var qo;
function Uo() {
  return Uo = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Uo.apply(this, arguments);
}
var $o;
function zo() {
  return zo = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, zo.apply(this, arguments);
}
var Wo;
function Qo() {
  return Qo = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Qo.apply(this, arguments);
}
var Go;
function Yo() {
  return Yo = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Yo.apply(this, arguments);
}
var Ko;
function Xo() {
  return Xo = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Xo.apply(this, arguments);
}
var Jo;
function ei() {
  return ei = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ei.apply(this, arguments);
}
var ti;
function ri() {
  return ri = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ri.apply(this, arguments);
}
var ni;
function ai() {
  return ai = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ai.apply(this, arguments);
}
var oi;
function ii() {
  return ii = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ii.apply(this, arguments);
}
var li;
function si() {
  return si = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, si.apply(this, arguments);
}
var ci;
function ui() {
  return ui = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ui.apply(this, arguments);
}
var hi;
function mi() {
  return mi = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, mi.apply(this, arguments);
}
var pi;
function fi() {
  return fi = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, fi.apply(this, arguments);
}
var di;
function vi() {
  return vi = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, vi.apply(this, arguments);
}
var gi;
function bi() {
  return bi = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, bi.apply(this, arguments);
}
var wi;
function yi() {
  return yi = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, yi.apply(this, arguments);
}
var xi, Oi;
function Ei() {
  return Ei = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ei.apply(this, arguments);
}
var ji;
function Ci() {
  return Ci = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ci.apply(this, arguments);
}
var Pi;
function Mi() {
  return Mi = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Mi.apply(this, arguments);
}
var ki;
function Si() {
  return Si = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Si.apply(this, arguments);
}
var Ni;
function Bi() {
  return Bi = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Bi.apply(this, arguments);
}
var Vi;
function Ri() {
  return Ri = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ri.apply(this, arguments);
}
var Ai;
function Ti() {
  return Ti = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ti.apply(this, arguments);
}
var Hi;
function Li() {
  return Li = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Li.apply(this, arguments);
}
var Ii;
function Fi() {
  return Fi = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Fi.apply(this, arguments);
}
var _i;
function Zi() {
  return Zi = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Zi.apply(this, arguments);
}
var Di;
function qi() {
  return qi = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, qi.apply(this, arguments);
}
var Ui;
function $i() {
  return $i = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, $i.apply(this, arguments);
}
var zi;
function Wi() {
  return Wi = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Wi.apply(this, arguments);
}
var Qi;
function Gi() {
  return Gi = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Gi.apply(this, arguments);
}
var Yi;
function Ki() {
  return Ki = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ki.apply(this, arguments);
}
var Xi;
function Ji() {
  return Ji = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ji.apply(this, arguments);
}
var el;
function tl() {
  return tl = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, tl.apply(this, arguments);
}
var rl, nl;
function al() {
  return al = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, al.apply(this, arguments);
}
var ol;
function il() {
  return il = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, il.apply(this, arguments);
}
var ll;
function sl() {
  return sl = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, sl.apply(this, arguments);
}
var cl;
function ul() {
  return ul = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ul.apply(this, arguments);
}
var hl;
function ml() {
  return ml = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ml.apply(this, arguments);
}
var pl;
function fl() {
  return fl = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, fl.apply(this, arguments);
}
var dl;
function vl() {
  return vl = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, vl.apply(this, arguments);
}
var gl;
function bl() {
  return bl = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, bl.apply(this, arguments);
}
var wl;
function yl() {
  return yl = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, yl.apply(this, arguments);
}
var xl;
function Ol() {
  return Ol = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ol.apply(this, arguments);
}
var El;
function jl() {
  return jl = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, jl.apply(this, arguments);
}
var Cl;
function Pl() {
  return Pl = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Pl.apply(this, arguments);
}
var Ml;
function kl() {
  return kl = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, kl.apply(this, arguments);
}
var Sl;
function Nl() {
  return Nl = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Nl.apply(this, arguments);
}
var Bl;
function Vl() {
  return Vl = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Vl.apply(this, arguments);
}
var Rl;
function Al() {
  return Al = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Al.apply(this, arguments);
}
var Tl;
function Hl() {
  return Hl = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Hl.apply(this, arguments);
}
var Ll;
function Il() {
  return Il = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Il.apply(this, arguments);
}
var Fl;
function _l() {
  return _l = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, _l.apply(this, arguments);
}
var Zl;
function Dl() {
  return Dl = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Dl.apply(this, arguments);
}
var ql;
function Ul() {
  return Ul = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ul.apply(this, arguments);
}
var $l;
function zl() {
  return zl = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, zl.apply(this, arguments);
}
var Wl;
function Ql() {
  return Ql = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ql.apply(this, arguments);
}
var Gl;
function Yl() {
  return Yl = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Yl.apply(this, arguments);
}
var Kl;
function Xl() {
  return Xl = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Xl.apply(this, arguments);
}
var Jl;
function es() {
  return es = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, es.apply(this, arguments);
}
var ts;
function rs() {
  return rs = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, rs.apply(this, arguments);
}
var ns;
function as() {
  return as = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, as.apply(this, arguments);
}
var os;
function is() {
  return is = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, is.apply(this, arguments);
}
var ls;
function ss() {
  return ss = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ss.apply(this, arguments);
}
var cs;
function us() {
  return us = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, us.apply(this, arguments);
}
var hs;
function ms() {
  return ms = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ms.apply(this, arguments);
}
var ps;
function fs() {
  return fs = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, fs.apply(this, arguments);
}
var ds;
function vs() {
  return vs = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, vs.apply(this, arguments);
}
var gs;
function bs() {
  return bs = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, bs.apply(this, arguments);
}
var ws;
function ys() {
  return ys = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ys.apply(this, arguments);
}
var xs;
function Os() {
  return Os = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Os.apply(this, arguments);
}
var Es;
function js() {
  return js = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, js.apply(this, arguments);
}
var Cs;
function Ps() {
  return Ps = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ps.apply(this, arguments);
}
var Ms;
function ks() {
  return ks = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ks.apply(this, arguments);
}
var Ss;
function Ns() {
  return Ns = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ns.apply(this, arguments);
}
var Bs;
function Vs() {
  return Vs = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Vs.apply(this, arguments);
}
var Rs;
function As() {
  return As = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, As.apply(this, arguments);
}
var Ts;
function Hs() {
  return Hs = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Hs.apply(this, arguments);
}
var Ls;
function Is() {
  return Is = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Is.apply(this, arguments);
}
var Fs;
function _s() {
  return _s = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, _s.apply(this, arguments);
}
var Zs;
function Ds() {
  return Ds = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ds.apply(this, arguments);
}
var qs;
function Us() {
  return Us = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Us.apply(this, arguments);
}
var $s;
function zs() {
  return zs = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, zs.apply(this, arguments);
}
var Ws, Qs;
function Gs() {
  return Gs = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Gs.apply(this, arguments);
}
var Ys;
function Ks() {
  return Ks = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ks.apply(this, arguments);
}
var Xs;
function Js() {
  return Js = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Js.apply(this, arguments);
}
var ec;
function tc() {
  return tc = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, tc.apply(this, arguments);
}
var rc;
function nc() {
  return nc = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, nc.apply(this, arguments);
}
var ac;
function oc() {
  return oc = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, oc.apply(this, arguments);
}
var ic;
function lc() {
  return lc = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, lc.apply(this, arguments);
}
var sc;
function cc() {
  return cc = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, cc.apply(this, arguments);
}
var uc;
function hc() {
  return hc = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, hc.apply(this, arguments);
}
var mc;
function pc() {
  return pc = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, pc.apply(this, arguments);
}
var fc;
function dc() {
  return dc = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, dc.apply(this, arguments);
}
var vc;
function gc() {
  return gc = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, gc.apply(this, arguments);
}
var bc;
function wc() {
  return wc = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, wc.apply(this, arguments);
}
var yc;
function xc() {
  return xc = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, xc.apply(this, arguments);
}
var Oc;
function Ec() {
  return Ec = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ec.apply(this, arguments);
}
var jc;
function Cc() {
  return Cc = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Cc.apply(this, arguments);
}
var Pc;
function Mc() {
  return Mc = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Mc.apply(this, arguments);
}
var kc;
function Sc() {
  return Sc = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Sc.apply(this, arguments);
}
var Nc;
function Bc() {
  return Bc = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Bc.apply(this, arguments);
}
var Vc;
function Rc() {
  return Rc = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Rc.apply(this, arguments);
}
var Ac;
function Tc() {
  return Tc = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Tc.apply(this, arguments);
}
var Hc;
function Lc() {
  return Lc = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Lc.apply(this, arguments);
}
var Ic;
function Fc() {
  return Fc = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Fc.apply(this, arguments);
}
var _c;
function Zc() {
  return Zc = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Zc.apply(this, arguments);
}
var Dc;
function qc() {
  return qc = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, qc.apply(this, arguments);
}
var Uc;
function $c() {
  return $c = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, $c.apply(this, arguments);
}
var zc;
function Wc() {
  return Wc = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Wc.apply(this, arguments);
}
var Qc;
function Gc() {
  return Gc = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Gc.apply(this, arguments);
}
var Yc;
function Kc() {
  return Kc = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Kc.apply(this, arguments);
}
var Xc;
function Jc() {
  return Jc = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Jc.apply(this, arguments);
}
var eu;
function tu() {
  return tu = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, tu.apply(this, arguments);
}
var ru;
function nu() {
  return nu = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, nu.apply(this, arguments);
}
var au;
function ou() {
  return ou = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ou.apply(this, arguments);
}
var iu;
function lu() {
  return lu = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, lu.apply(this, arguments);
}
var su;
function cu() {
  return cu = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, cu.apply(this, arguments);
}
var uu;
function hu() {
  return hu = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, hu.apply(this, arguments);
}
var mu;
function pu() {
  return pu = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, pu.apply(this, arguments);
}
var fu;
function du() {
  return du = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, du.apply(this, arguments);
}
var vu;
function gu() {
  return gu = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, gu.apply(this, arguments);
}
var bu;
function wu() {
  return wu = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, wu.apply(this, arguments);
}
var yu;
function xu() {
  return xu = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, xu.apply(this, arguments);
}
var Ou;
function Eu() {
  return Eu = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Eu.apply(this, arguments);
}
var ju;
function Cu() {
  return Cu = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Cu.apply(this, arguments);
}
var Pu;
function Mu() {
  return Mu = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Mu.apply(this, arguments);
}
var ku;
function Su() {
  return Su = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Su.apply(this, arguments);
}
var Nu;
function Bu() {
  return Bu = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Bu.apply(this, arguments);
}
var Vu;
function Ru() {
  return Ru = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ru.apply(this, arguments);
}
var Au;
function Tu() {
  return Tu = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Tu.apply(this, arguments);
}
var Hu;
function Lu() {
  return Lu = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Lu.apply(this, arguments);
}
var Iu;
function Fu() {
  return Fu = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Fu.apply(this, arguments);
}
var _u;
function Zu() {
  return Zu = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Zu.apply(this, arguments);
}
var Du;
function qu() {
  return qu = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, qu.apply(this, arguments);
}
var Uu;
function $u() {
  return $u = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, $u.apply(this, arguments);
}
var zu;
function Wu() {
  return Wu = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Wu.apply(this, arguments);
}
var Qu;
function Gu() {
  return Gu = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Gu.apply(this, arguments);
}
var Yu;
function Ku() {
  return Ku = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ku.apply(this, arguments);
}
var Xu;
function Ju() {
  return Ju = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ju.apply(this, arguments);
}
var eh;
function th() {
  return th = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, th.apply(this, arguments);
}
var rh;
function nh() {
  return nh = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, nh.apply(this, arguments);
}
var ah;
function oh() {
  return oh = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, oh.apply(this, arguments);
}
var ih;
function lh() {
  return lh = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, lh.apply(this, arguments);
}
var sh;
function ch() {
  return ch = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ch.apply(this, arguments);
}
var uh;
function hh() {
  return hh = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, hh.apply(this, arguments);
}
var mh;
function ph() {
  return ph = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ph.apply(this, arguments);
}
var fh;
function dh() {
  return dh = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, dh.apply(this, arguments);
}
var vh;
function gh() {
  return gh = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, gh.apply(this, arguments);
}
var bh;
function wh() {
  return wh = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, wh.apply(this, arguments);
}
var yh;
function xh() {
  return xh = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, xh.apply(this, arguments);
}
var Oh;
function Eh() {
  return Eh = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Eh.apply(this, arguments);
}
var jh;
function Ch() {
  return Ch = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ch.apply(this, arguments);
}
var Ph;
function Mh() {
  return Mh = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Mh.apply(this, arguments);
}
var kh;
function Sh() {
  return Sh = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Sh.apply(this, arguments);
}
var Nh;
function Bh() {
  return Bh = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Bh.apply(this, arguments);
}
var Vh;
function Rh() {
  return Rh = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Rh.apply(this, arguments);
}
var Ah;
function Th() {
  return Th = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Th.apply(this, arguments);
}
var Hh;
function Lh() {
  return Lh = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Lh.apply(this, arguments);
}
var Ih;
function Fh() {
  return Fh = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Fh.apply(this, arguments);
}
var _h;
function Zh() {
  return Zh = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Zh.apply(this, arguments);
}
var Dh;
function qh() {
  return qh = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, qh.apply(this, arguments);
}
var Uh;
function $h() {
  return $h = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, $h.apply(this, arguments);
}
var zh;
function Wh() {
  return Wh = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Wh.apply(this, arguments);
}
var Qh;
function Gh() {
  return Gh = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Gh.apply(this, arguments);
}
var Yh;
function Kh() {
  return Kh = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Kh.apply(this, arguments);
}
var Xh;
function Jh() {
  return Jh = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Jh.apply(this, arguments);
}
var em;
function tm() {
  return tm = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, tm.apply(this, arguments);
}
var rm;
function nm() {
  return nm = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, nm.apply(this, arguments);
}
var am;
function om() {
  return om = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, om.apply(this, arguments);
}
var im;
function lm() {
  return lm = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, lm.apply(this, arguments);
}
var sm;
function cm() {
  return cm = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, cm.apply(this, arguments);
}
var um;
function hm() {
  return hm = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, hm.apply(this, arguments);
}
var mm;
function pm() {
  return pm = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, pm.apply(this, arguments);
}
var fm;
function dm() {
  return dm = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, dm.apply(this, arguments);
}
var vm;
function gm() {
  return gm = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, gm.apply(this, arguments);
}
var bm;
function wm() {
  return wm = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, wm.apply(this, arguments);
}
var ym;
function xm() {
  return xm = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, xm.apply(this, arguments);
}
var Om;
function Em() {
  return Em = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Em.apply(this, arguments);
}
var jm;
function Cm() {
  return Cm = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Cm.apply(this, arguments);
}
var Pm;
function Mm() {
  return Mm = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Mm.apply(this, arguments);
}
var km;
function Sm() {
  return Sm = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Sm.apply(this, arguments);
}
var Nm;
function Bm() {
  return Bm = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Bm.apply(this, arguments);
}
var Vm;
function Rm() {
  return Rm = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Rm.apply(this, arguments);
}
var Am;
function Tm() {
  return Tm = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Tm.apply(this, arguments);
}
var Hm;
function Lm() {
  return Lm = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Lm.apply(this, arguments);
}
var Im, Fm;
function _m() {
  return _m = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, _m.apply(this, arguments);
}
var Zm;
function Dm() {
  return Dm = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Dm.apply(this, arguments);
}
var qm;
function Um() {
  return Um = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Um.apply(this, arguments);
}
var $m;
function zm() {
  return zm = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, zm.apply(this, arguments);
}
var Wm;
function Qm() {
  return Qm = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Qm.apply(this, arguments);
}
var Gm;
function Ym() {
  return Ym = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ym.apply(this, arguments);
}
var Km;
function Xm() {
  return Xm = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Xm.apply(this, arguments);
}
var Jm;
function ep() {
  return ep = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ep.apply(this, arguments);
}
var tp;
function rp() {
  return rp = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, rp.apply(this, arguments);
}
var np;
function ap() {
  return ap = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ap.apply(this, arguments);
}
var op;
function ip() {
  return ip = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ip.apply(this, arguments);
}
var lp;
function sp() {
  return sp = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, sp.apply(this, arguments);
}
var cp;
function up() {
  return up = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, up.apply(this, arguments);
}
var hp;
function mp() {
  return mp = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, mp.apply(this, arguments);
}
var pp, fp;
function dp() {
  return dp = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, dp.apply(this, arguments);
}
var vp;
function gp() {
  return gp = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, gp.apply(this, arguments);
}
var bp;
function wp() {
  return wp = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, wp.apply(this, arguments);
}
var yp;
function xp() {
  return xp = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, xp.apply(this, arguments);
}
var Op;
function Ep() {
  return Ep = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ep.apply(this, arguments);
}
var jp;
function Cp() {
  return Cp = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Cp.apply(this, arguments);
}
var Pp;
function Mp() {
  return Mp = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Mp.apply(this, arguments);
}
var kp;
function Sp() {
  return Sp = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Sp.apply(this, arguments);
}
var Np;
function Bp() {
  return Bp = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Bp.apply(this, arguments);
}
var Vp;
function Rp() {
  return Rp = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Rp.apply(this, arguments);
}
var Ap;
function Tp() {
  return Tp = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Tp.apply(this, arguments);
}
var Hp;
function Lp() {
  return Lp = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Lp.apply(this, arguments);
}
var Ip;
function Fp() {
  return Fp = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Fp.apply(this, arguments);
}
var _p;
function Zp() {
  return Zp = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Zp.apply(this, arguments);
}
var Dp;
function qp() {
  return qp = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, qp.apply(this, arguments);
}
var Up;
function $p() {
  return $p = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, $p.apply(this, arguments);
}
var zp;
function Wp() {
  return Wp = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Wp.apply(this, arguments);
}
var Qp;
function Gp() {
  return Gp = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Gp.apply(this, arguments);
}
var Yp;
function Kp() {
  return Kp = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Kp.apply(this, arguments);
}
var Xp;
function Jp() {
  return Jp = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Jp.apply(this, arguments);
}
var ef;
function tf() {
  return tf = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, tf.apply(this, arguments);
}
var rf;
function nf() {
  return nf = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, nf.apply(this, arguments);
}
var af;
function of() {
  return of = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, of.apply(this, arguments);
}
var lf;
function sf() {
  return sf = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, sf.apply(this, arguments);
}
var cf;
function uf() {
  return uf = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, uf.apply(this, arguments);
}
var hf;
function mf() {
  return mf = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, mf.apply(this, arguments);
}
var pf;
function ff() {
  return ff = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ff.apply(this, arguments);
}
var df;
function vf() {
  return vf = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, vf.apply(this, arguments);
}
var gf;
function bf() {
  return bf = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, bf.apply(this, arguments);
}
var wf;
function yf() {
  return yf = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, yf.apply(this, arguments);
}
var xf;
function Of() {
  return Of = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Of.apply(this, arguments);
}
var Ef;
function jf() {
  return jf = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, jf.apply(this, arguments);
}
var Cf;
function Pf() {
  return Pf = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Pf.apply(this, arguments);
}
var Mf;
function kf() {
  return kf = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, kf.apply(this, arguments);
}
var Sf;
function Nf() {
  return Nf = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Nf.apply(this, arguments);
}
var Bf;
function Vf() {
  return Vf = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Vf.apply(this, arguments);
}
var Rf;
function Af() {
  return Af = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Af.apply(this, arguments);
}
var Tf;
function Hf() {
  return Hf = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Hf.apply(this, arguments);
}
var Lf;
function If() {
  return If = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, If.apply(this, arguments);
}
var Ff;
function _f() {
  return _f = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, _f.apply(this, arguments);
}
var Zf;
function Df() {
  return Df = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Df.apply(this, arguments);
}
var qf;
function Uf() {
  return Uf = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Uf.apply(this, arguments);
}
var $f;
function zf() {
  return zf = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, zf.apply(this, arguments);
}
var Wf;
function Qf() {
  return Qf = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Qf.apply(this, arguments);
}
var Gf;
function Yf() {
  return Yf = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Yf.apply(this, arguments);
}
var Kf;
function Xf() {
  return Xf = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Xf.apply(this, arguments);
}
var Jf;
function ed() {
  return ed = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ed.apply(this, arguments);
}
var td;
function rd() {
  return rd = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, rd.apply(this, arguments);
}
var nd;
function ad() {
  return ad = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ad.apply(this, arguments);
}
var od;
function id() {
  return id = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, id.apply(this, arguments);
}
var ld, sd;
function cd() {
  return cd = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, cd.apply(this, arguments);
}
var ud;
function hd() {
  return hd = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, hd.apply(this, arguments);
}
var md;
function pd() {
  return pd = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, pd.apply(this, arguments);
}
var fd;
function dd() {
  return dd = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, dd.apply(this, arguments);
}
var vd;
function gd() {
  return gd = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, gd.apply(this, arguments);
}
var bd;
function wd() {
  return wd = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, wd.apply(this, arguments);
}
var yd;
function xd() {
  return xd = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, xd.apply(this, arguments);
}
var Od;
function Ed() {
  return Ed = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ed.apply(this, arguments);
}
var jd;
function Cd() {
  return Cd = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Cd.apply(this, arguments);
}
var Pd;
function Md() {
  return Md = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Md.apply(this, arguments);
}
var kd;
function Sd() {
  return Sd = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Sd.apply(this, arguments);
}
var Nd;
function Bd() {
  return Bd = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Bd.apply(this, arguments);
}
var Vd;
function Rd() {
  return Rd = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Rd.apply(this, arguments);
}
var Ad, Td;
function Hd() {
  return Hd = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Hd.apply(this, arguments);
}
var Ld;
function Id() {
  return Id = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Id.apply(this, arguments);
}
var Fd;
function _d() {
  return _d = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, _d.apply(this, arguments);
}
var Zd;
function Dd() {
  return Dd = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Dd.apply(this, arguments);
}
var qd;
function Ud() {
  return Ud = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ud.apply(this, arguments);
}
var $d;
function zd() {
  return zd = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, zd.apply(this, arguments);
}
var Wd;
function Qd() {
  return Qd = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Qd.apply(this, arguments);
}
var Gd;
function Yd() {
  return Yd = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Yd.apply(this, arguments);
}
var Kd;
function Xd() {
  return Xd = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Xd.apply(this, arguments);
}
var Jd;
function ev() {
  return ev = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ev.apply(this, arguments);
}
var tv;
function rv() {
  return rv = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, rv.apply(this, arguments);
}
var nv, av;
function ov() {
  return ov = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ov.apply(this, arguments);
}
var iv;
function lv() {
  return lv = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, lv.apply(this, arguments);
}
var sv;
function cv() {
  return cv = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, cv.apply(this, arguments);
}
var uv, hv;
function mv() {
  return mv = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, mv.apply(this, arguments);
}
var pv;
function fv() {
  return fv = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, fv.apply(this, arguments);
}
var dv;
function vv() {
  return vv = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, vv.apply(this, arguments);
}
var gv;
function bv() {
  return bv = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, bv.apply(this, arguments);
}
var wv;
function yv() {
  return yv = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, yv.apply(this, arguments);
}
var xv;
function Ov() {
  return Ov = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ov.apply(this, arguments);
}
var Ev;
function jv() {
  return jv = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, jv.apply(this, arguments);
}
var Cv;
function Pv() {
  return Pv = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Pv.apply(this, arguments);
}
var Mv;
function kv() {
  return kv = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, kv.apply(this, arguments);
}
var Sv;
function Nv() {
  return Nv = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Nv.apply(this, arguments);
}
var Bv;
function Vv() {
  return Vv = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Vv.apply(this, arguments);
}
var Rv;
function Av() {
  return Av = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Av.apply(this, arguments);
}
var Tv, Hv;
function Lv() {
  return Lv = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Lv.apply(this, arguments);
}
var Iv;
function Fv() {
  return Fv = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Fv.apply(this, arguments);
}
var _v;
function Zv() {
  return Zv = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Zv.apply(this, arguments);
}
var Dv;
function qv() {
  return qv = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, qv.apply(this, arguments);
}
var Uv;
function $v() {
  return $v = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, $v.apply(this, arguments);
}
var zv, Wv;
function Qv() {
  return Qv = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Qv.apply(this, arguments);
}
var Gv;
function Yv() {
  return Yv = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Yv.apply(this, arguments);
}
var Kv;
function Xv() {
  return Xv = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Xv.apply(this, arguments);
}
var Jv;
function eg() {
  return eg = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, eg.apply(this, arguments);
}
var tg;
function rg() {
  return rg = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, rg.apply(this, arguments);
}
var ng;
function ag() {
  return ag = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ag.apply(this, arguments);
}
var og;
function ig() {
  return ig = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ig.apply(this, arguments);
}
var lg;
function sg() {
  return sg = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, sg.apply(this, arguments);
}
var cg;
function ug() {
  return ug = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ug.apply(this, arguments);
}
var hg;
function mg() {
  return mg = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, mg.apply(this, arguments);
}
var pg;
function fg() {
  return fg = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, fg.apply(this, arguments);
}
var dg;
function vg() {
  return vg = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, vg.apply(this, arguments);
}
var gg;
function bg() {
  return bg = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, bg.apply(this, arguments);
}
var wg;
function yg() {
  return yg = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, yg.apply(this, arguments);
}
var xg;
function Og() {
  return Og = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Og.apply(this, arguments);
}
var Eg;
function jg() {
  return jg = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, jg.apply(this, arguments);
}
var Cg;
function Pg() {
  return Pg = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Pg.apply(this, arguments);
}
var Mg;
function kg() {
  return kg = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, kg.apply(this, arguments);
}
var Sg;
function Ng() {
  return Ng = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ng.apply(this, arguments);
}
var Bg;
function Vg() {
  return Vg = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Vg.apply(this, arguments);
}
var Rg;
function Ag() {
  return Ag = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ag.apply(this, arguments);
}
var Tg;
function Hg() {
  return Hg = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Hg.apply(this, arguments);
}
var Lg;
function Ig() {
  return Ig = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ig.apply(this, arguments);
}
var Fg;
function _g() {
  return _g = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, _g.apply(this, arguments);
}
var Zg;
function Dg() {
  return Dg = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Dg.apply(this, arguments);
}
var qg;
function Ug() {
  return Ug = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ug.apply(this, arguments);
}
var $g;
function zg() {
  return zg = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, zg.apply(this, arguments);
}
var Wg;
function Qg() {
  return Qg = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Qg.apply(this, arguments);
}
var Gg;
function Yg() {
  return Yg = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Yg.apply(this, arguments);
}
var Kg;
function Xg() {
  return Xg = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Xg.apply(this, arguments);
}
var Jg;
function eb() {
  return eb = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, eb.apply(this, arguments);
}
var tb;
function rb() {
  return rb = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, rb.apply(this, arguments);
}
var nb;
function ab() {
  return ab = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ab.apply(this, arguments);
}
var ob;
function ib() {
  return ib = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ib.apply(this, arguments);
}
var lb;
function sb() {
  return sb = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, sb.apply(this, arguments);
}
var cb;
function ub() {
  return ub = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ub.apply(this, arguments);
}
var hb;
function mb() {
  return mb = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, mb.apply(this, arguments);
}
var pb;
function fb() {
  return fb = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, fb.apply(this, arguments);
}
var db;
function vb() {
  return vb = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, vb.apply(this, arguments);
}
var gb;
function bb() {
  return bb = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, bb.apply(this, arguments);
}
var wb;
function yb() {
  return yb = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, yb.apply(this, arguments);
}
var xb;
function Ob() {
  return Ob = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ob.apply(this, arguments);
}
var Eb;
function jb() {
  return jb = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, jb.apply(this, arguments);
}
var Cb;
function Pb() {
  return Pb = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Pb.apply(this, arguments);
}
var Mb;
function kb() {
  return kb = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, kb.apply(this, arguments);
}
var Sb;
function Nb() {
  return Nb = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Nb.apply(this, arguments);
}
var Bb;
function Vb() {
  return Vb = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Vb.apply(this, arguments);
}
var Rb;
function Ab() {
  return Ab = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ab.apply(this, arguments);
}
var Tb;
function Hb() {
  return Hb = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Hb.apply(this, arguments);
}
var Lb;
function Ib() {
  return Ib = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ib.apply(this, arguments);
}
var Fb;
function _b() {
  return _b = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, _b.apply(this, arguments);
}
var Zb;
function Db() {
  return Db = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Db.apply(this, arguments);
}
var qb;
function Ub() {
  return Ub = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ub.apply(this, arguments);
}
var $b;
function zb() {
  return zb = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, zb.apply(this, arguments);
}
var Wb;
function Qb() {
  return Qb = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Qb.apply(this, arguments);
}
var Gb;
function Yb() {
  return Yb = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Yb.apply(this, arguments);
}
var Kb;
function Xb() {
  return Xb = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Xb.apply(this, arguments);
}
var Jb;
function ew() {
  return ew = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ew.apply(this, arguments);
}
var tw;
function rw() {
  return rw = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, rw.apply(this, arguments);
}
var nw;
function aw() {
  return aw = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, aw.apply(this, arguments);
}
var ow;
function iw() {
  return iw = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, iw.apply(this, arguments);
}
var lw;
function sw() {
  return sw = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, sw.apply(this, arguments);
}
var cw;
function uw() {
  return uw = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, uw.apply(this, arguments);
}
var hw;
function mw() {
  return mw = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, mw.apply(this, arguments);
}
var pw;
function fw() {
  return fw = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, fw.apply(this, arguments);
}
var dw;
function vw() {
  return vw = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, vw.apply(this, arguments);
}
var gw;
function bw() {
  return bw = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, bw.apply(this, arguments);
}
var ww;
function yw() {
  return yw = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, yw.apply(this, arguments);
}
var xw;
function Ow() {
  return Ow = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ow.apply(this, arguments);
}
var Ew, jw;
function Cw() {
  return Cw = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Cw.apply(this, arguments);
}
var Pw;
function Mw() {
  return Mw = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Mw.apply(this, arguments);
}
var kw;
function Sw() {
  return Sw = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Sw.apply(this, arguments);
}
var Nw;
function Bw() {
  return Bw = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Bw.apply(this, arguments);
}
var Vw;
function Rw() {
  return Rw = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Rw.apply(this, arguments);
}
var Aw;
function Tw() {
  return Tw = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Tw.apply(this, arguments);
}
var Hw;
function Lw() {
  return Lw = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Lw.apply(this, arguments);
}
var Iw;
function Fw() {
  return Fw = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Fw.apply(this, arguments);
}
var _w;
function Zw() {
  return Zw = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Zw.apply(this, arguments);
}
var Dw;
function qw() {
  return qw = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, qw.apply(this, arguments);
}
var Uw;
function $w() {
  return $w = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, $w.apply(this, arguments);
}
var zw;
function Ww() {
  return Ww = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ww.apply(this, arguments);
}
var Qw;
function Gw() {
  return Gw = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Gw.apply(this, arguments);
}
var Yw;
function Kw() {
  return Kw = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Kw.apply(this, arguments);
}
var Xw;
function Jw() {
  return Jw = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Jw.apply(this, arguments);
}
var ey;
function ty() {
  return ty = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ty.apply(this, arguments);
}
var ry;
function ny() {
  return ny = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ny.apply(this, arguments);
}
var ay;
function oy() {
  return oy = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, oy.apply(this, arguments);
}
var iy;
function ly() {
  return ly = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ly.apply(this, arguments);
}
var sy;
function cy() {
  return cy = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, cy.apply(this, arguments);
}
var uy;
function hy() {
  return hy = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, hy.apply(this, arguments);
}
var my;
function py() {
  return py = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, py.apply(this, arguments);
}
var fy, dy, vy;
function gy() {
  return gy = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, gy.apply(this, arguments);
}
var by;
function wy() {
  return wy = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, wy.apply(this, arguments);
}
var yy;
function xy() {
  return xy = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, xy.apply(this, arguments);
}
var Oy;
function Ey() {
  return Ey = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ey.apply(this, arguments);
}
var jy;
function Cy() {
  return Cy = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Cy.apply(this, arguments);
}
var Py;
function My() {
  return My = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, My.apply(this, arguments);
}
var ky;
function Sy() {
  return Sy = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Sy.apply(this, arguments);
}
var Ny;
function By() {
  return By = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, By.apply(this, arguments);
}
var Vy;
function Ry() {
  return Ry = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ry.apply(this, arguments);
}
var Ay;
function Ty() {
  return Ty = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ty.apply(this, arguments);
}
var Hy;
function Ly() {
  return Ly = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ly.apply(this, arguments);
}
var Iy;
function Fy() {
  return Fy = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Fy.apply(this, arguments);
}
var _y;
function Zy() {
  return Zy = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Zy.apply(this, arguments);
}
var Dy;
function qy() {
  return qy = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, qy.apply(this, arguments);
}
var Uy;
function $y() {
  return $y = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, $y.apply(this, arguments);
}
var zy;
function Wy() {
  return Wy = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Wy.apply(this, arguments);
}
var Qy;
function Gy() {
  return Gy = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Gy.apply(this, arguments);
}
var Yy;
function Ky() {
  return Ky = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ky.apply(this, arguments);
}
var Xy;
function Jy() {
  return Jy = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Jy.apply(this, arguments);
}
var ex;
function tx() {
  return tx = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, tx.apply(this, arguments);
}
var rx;
function nx() {
  return nx = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, nx.apply(this, arguments);
}
var ax;
function ox() {
  return ox = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ox.apply(this, arguments);
}
var ix, lx;
function sx() {
  return sx = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, sx.apply(this, arguments);
}
var cx, ux;
function hx() {
  return hx = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, hx.apply(this, arguments);
}
var mx;
function px() {
  return px = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, px.apply(this, arguments);
}
var fx;
function dx() {
  return dx = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, dx.apply(this, arguments);
}
var vx;
function gx() {
  return gx = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, gx.apply(this, arguments);
}
var bx;
function wx() {
  return wx = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, wx.apply(this, arguments);
}
var yx;
function xx() {
  return xx = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, xx.apply(this, arguments);
}
var Ox;
function Ex() {
  return Ex = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ex.apply(this, arguments);
}
var jx;
function Cx() {
  return Cx = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Cx.apply(this, arguments);
}
var Px;
function Mx() {
  return Mx = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Mx.apply(this, arguments);
}
var kx;
function Sx() {
  return Sx = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Sx.apply(this, arguments);
}
var Nx;
function Bx() {
  return Bx = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Bx.apply(this, arguments);
}
var Vx;
function Rx() {
  return Rx = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Rx.apply(this, arguments);
}
var Ax;
function Tx() {
  return Tx = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Tx.apply(this, arguments);
}
var Hx;
function Lx() {
  return Lx = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Lx.apply(this, arguments);
}
var Ix;
function Fx() {
  return Fx = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Fx.apply(this, arguments);
}
var _x;
function Zx() {
  return Zx = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Zx.apply(this, arguments);
}
var Dx;
function qx() {
  return qx = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, qx.apply(this, arguments);
}
var Ux;
function $x() {
  return $x = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, $x.apply(this, arguments);
}
var zx;
function Wx() {
  return Wx = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Wx.apply(this, arguments);
}
var Qx;
function Gx() {
  return Gx = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Gx.apply(this, arguments);
}
var Yx;
function Kx() {
  return Kx = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Kx.apply(this, arguments);
}
var Xx;
function Jx() {
  return Jx = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Jx.apply(this, arguments);
}
var eO;
function tO() {
  return tO = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, tO.apply(this, arguments);
}
var rO;
function nO() {
  return nO = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, nO.apply(this, arguments);
}
var aO;
function oO() {
  return oO = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, oO.apply(this, arguments);
}
var iO;
function lO() {
  return lO = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, lO.apply(this, arguments);
}
var sO;
function cO() {
  return cO = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, cO.apply(this, arguments);
}
var uO;
function hO() {
  return hO = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, hO.apply(this, arguments);
}
var mO, pO;
function fO() {
  return fO = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, fO.apply(this, arguments);
}
var dO;
function vO() {
  return vO = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, vO.apply(this, arguments);
}
var gO;
function bO() {
  return bO = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, bO.apply(this, arguments);
}
var wO;
function yO() {
  return yO = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, yO.apply(this, arguments);
}
var xO;
function OO() {
  return OO = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, OO.apply(this, arguments);
}
var EO;
function jO() {
  return jO = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, jO.apply(this, arguments);
}
var CO;
function PO() {
  return PO = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, PO.apply(this, arguments);
}
var MO;
function kO() {
  return kO = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, kO.apply(this, arguments);
}
var SO;
function NO() {
  return NO = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, NO.apply(this, arguments);
}
var BO;
function VO() {
  return VO = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, VO.apply(this, arguments);
}
var RO;
function AO() {
  return AO = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, AO.apply(this, arguments);
}
var TO;
function HO() {
  return HO = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, HO.apply(this, arguments);
}
var LO;
function IO() {
  return IO = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, IO.apply(this, arguments);
}
var FO;
function _O() {
  return _O = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, _O.apply(this, arguments);
}
var ZO;
function DO() {
  return DO = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, DO.apply(this, arguments);
}
var qO;
function UO() {
  return UO = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, UO.apply(this, arguments);
}
var $O;
function zO() {
  return zO = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, zO.apply(this, arguments);
}
var WO;
function QO() {
  return QO = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, QO.apply(this, arguments);
}
var GO;
function YO() {
  return YO = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, YO.apply(this, arguments);
}
var KO;
function XO() {
  return XO = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, XO.apply(this, arguments);
}
var JO;
function eE() {
  return eE = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, eE.apply(this, arguments);
}
var tE;
function rE() {
  return rE = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, rE.apply(this, arguments);
}
var nE;
function aE() {
  return aE = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, aE.apply(this, arguments);
}
var oE, iE;
function lE() {
  return lE = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, lE.apply(this, arguments);
}
var sE;
function cE() {
  return cE = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, cE.apply(this, arguments);
}
var uE;
function hE() {
  return hE = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, hE.apply(this, arguments);
}
var mE;
function pE() {
  return pE = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, pE.apply(this, arguments);
}
var fE;
function dE() {
  return dE = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, dE.apply(this, arguments);
}
var vE;
function gE() {
  return gE = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, gE.apply(this, arguments);
}
var bE;
function wE() {
  return wE = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, wE.apply(this, arguments);
}
var yE;
function xE() {
  return xE = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, xE.apply(this, arguments);
}
var OE;
function EE() {
  return EE = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, EE.apply(this, arguments);
}
var jE;
function CE() {
  return CE = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, CE.apply(this, arguments);
}
var PE;
function ME() {
  return ME = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ME.apply(this, arguments);
}
var kE;
function SE() {
  return SE = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, SE.apply(this, arguments);
}
var NE;
function BE() {
  return BE = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, BE.apply(this, arguments);
}
var VE;
function RE() {
  return RE = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, RE.apply(this, arguments);
}
var AE;
function TE() {
  return TE = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, TE.apply(this, arguments);
}
var HE;
function LE() {
  return LE = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, LE.apply(this, arguments);
}
var IE;
function FE() {
  return FE = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, FE.apply(this, arguments);
}
var _E;
function ZE() {
  return ZE = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ZE.apply(this, arguments);
}
var DE;
function qE() {
  return qE = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, qE.apply(this, arguments);
}
var UE;
function $E() {
  return $E = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, $E.apply(this, arguments);
}
var zE;
function WE() {
  return WE = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, WE.apply(this, arguments);
}
var QE;
function GE() {
  return GE = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, GE.apply(this, arguments);
}
var YE;
function KE() {
  return KE = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, KE.apply(this, arguments);
}
var XE;
function JE() {
  return JE = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, JE.apply(this, arguments);
}
var ej;
function tj() {
  return tj = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, tj.apply(this, arguments);
}
var rj;
function nj() {
  return nj = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, nj.apply(this, arguments);
}
var aj;
function oj() {
  return oj = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, oj.apply(this, arguments);
}
var ij;
function lj() {
  return lj = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, lj.apply(this, arguments);
}
var sj;
function cj() {
  return cj = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, cj.apply(this, arguments);
}
var uj;
function hj() {
  return hj = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, hj.apply(this, arguments);
}
var mj;
function pj() {
  return pj = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, pj.apply(this, arguments);
}
var fj;
function dj() {
  return dj = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, dj.apply(this, arguments);
}
var vj, gj;
function bj() {
  return bj = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, bj.apply(this, arguments);
}
var wj;
function yj() {
  return yj = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, yj.apply(this, arguments);
}
var xj;
function Oj() {
  return Oj = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Oj.apply(this, arguments);
}
var Ej;
function jj() {
  return jj = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, jj.apply(this, arguments);
}
var Cj;
function Pj() {
  return Pj = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Pj.apply(this, arguments);
}
var Mj;
function kj() {
  return kj = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, kj.apply(this, arguments);
}
var Sj;
function Nj() {
  return Nj = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Nj.apply(this, arguments);
}
var Bj;
function Vj() {
  return Vj = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Vj.apply(this, arguments);
}
var Rj;
function Aj() {
  return Aj = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Aj.apply(this, arguments);
}
var Tj;
function Hj() {
  return Hj = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Hj.apply(this, arguments);
}
var Lj;
function Ij() {
  return Ij = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ij.apply(this, arguments);
}
var Fj;
function _j() {
  return _j = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, _j.apply(this, arguments);
}
var Zj;
function Dj() {
  return Dj = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Dj.apply(this, arguments);
}
var qj;
function Uj() {
  return Uj = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Uj.apply(this, arguments);
}
var $j;
function zj() {
  return zj = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, zj.apply(this, arguments);
}
var Wj;
function Qj() {
  return Qj = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Qj.apply(this, arguments);
}
var Gj;
function Yj() {
  return Yj = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Yj.apply(this, arguments);
}
var Kj;
function Xj() {
  return Xj = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Xj.apply(this, arguments);
}
var Jj;
function eC() {
  return eC = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, eC.apply(this, arguments);
}
var tC;
function rC() {
  return rC = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, rC.apply(this, arguments);
}
var nC;
function aC() {
  return aC = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, aC.apply(this, arguments);
}
var oC;
function iC() {
  return iC = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, iC.apply(this, arguments);
}
var lC;
function sC() {
  return sC = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, sC.apply(this, arguments);
}
var cC;
function uC() {
  return uC = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, uC.apply(this, arguments);
}
var hC;
function mC() {
  return mC = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, mC.apply(this, arguments);
}
var pC;
function fC() {
  return fC = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, fC.apply(this, arguments);
}
var dC;
function vC() {
  return vC = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, vC.apply(this, arguments);
}
var gC;
function bC() {
  return bC = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, bC.apply(this, arguments);
}
var wC;
function yC() {
  return yC = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, yC.apply(this, arguments);
}
var xC;
function OC() {
  return OC = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, OC.apply(this, arguments);
}
var EC;
function jC() {
  return jC = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, jC.apply(this, arguments);
}
var CC;
function PC() {
  return PC = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, PC.apply(this, arguments);
}
var MC;
function kC() {
  return kC = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, kC.apply(this, arguments);
}
var SC;
function NC() {
  return NC = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, NC.apply(this, arguments);
}
var BC;
function VC() {
  return VC = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, VC.apply(this, arguments);
}
var RC, AC;
function TC() {
  return TC = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, TC.apply(this, arguments);
}
var HC;
function LC() {
  return LC = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, LC.apply(this, arguments);
}
var IC;
function FC() {
  return FC = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, FC.apply(this, arguments);
}
var _C;
function ZC() {
  return ZC = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ZC.apply(this, arguments);
}
var DC;
function qC() {
  return qC = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, qC.apply(this, arguments);
}
var UC;
function $C() {
  return $C = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, $C.apply(this, arguments);
}
var zC;
function WC() {
  return WC = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, WC.apply(this, arguments);
}
var QC;
function GC() {
  return GC = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, GC.apply(this, arguments);
}
var YC;
function KC() {
  return KC = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, KC.apply(this, arguments);
}
var XC;
function JC() {
  return JC = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, JC.apply(this, arguments);
}
var eP;
function tP() {
  return tP = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, tP.apply(this, arguments);
}
var rP;
function nP() {
  return nP = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, nP.apply(this, arguments);
}
var aP;
function oP() {
  return oP = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, oP.apply(this, arguments);
}
var iP;
function lP() {
  return lP = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, lP.apply(this, arguments);
}
var sP;
function cP() {
  return cP = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, cP.apply(this, arguments);
}
var uP;
function hP() {
  return hP = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, hP.apply(this, arguments);
}
var mP;
function pP() {
  return pP = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, pP.apply(this, arguments);
}
var fP;
function dP() {
  return dP = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, dP.apply(this, arguments);
}
var vP;
function gP() {
  return gP = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, gP.apply(this, arguments);
}
var bP;
function wP() {
  return wP = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, wP.apply(this, arguments);
}
var yP;
function xP() {
  return xP = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, xP.apply(this, arguments);
}
var OP;
function EP() {
  return EP = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, EP.apply(this, arguments);
}
var jP;
function CP() {
  return CP = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, CP.apply(this, arguments);
}
var PP;
function MP() {
  return MP = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, MP.apply(this, arguments);
}
var kP;
function SP() {
  return SP = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, SP.apply(this, arguments);
}
var NP;
function BP() {
  return BP = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, BP.apply(this, arguments);
}
var VP;
function RP() {
  return RP = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, RP.apply(this, arguments);
}
var AP;
function TP() {
  return TP = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, TP.apply(this, arguments);
}
var HP;
function LP() {
  return LP = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, LP.apply(this, arguments);
}
var IP;
function FP() {
  return FP = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, FP.apply(this, arguments);
}
var _P;
function ZP() {
  return ZP = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ZP.apply(this, arguments);
}
var DP;
function qP() {
  return qP = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, qP.apply(this, arguments);
}
var UP;
function $P() {
  return $P = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, $P.apply(this, arguments);
}
var zP;
function WP() {
  return WP = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, WP.apply(this, arguments);
}
var QP;
function GP() {
  return GP = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, GP.apply(this, arguments);
}
var YP, KP;
function XP() {
  return XP = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, XP.apply(this, arguments);
}
var JP;
function eM() {
  return eM = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, eM.apply(this, arguments);
}
var tM;
function rM() {
  return rM = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, rM.apply(this, arguments);
}
var nM;
function aM() {
  return aM = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, aM.apply(this, arguments);
}
var oM;
function iM() {
  return iM = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, iM.apply(this, arguments);
}
var lM;
function sM() {
  return sM = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, sM.apply(this, arguments);
}
var cM;
function uM() {
  return uM = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, uM.apply(this, arguments);
}
var hM;
function mM() {
  return mM = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, mM.apply(this, arguments);
}
var pM;
function fM() {
  return fM = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, fM.apply(this, arguments);
}
var dM;
function vM() {
  return vM = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, vM.apply(this, arguments);
}
var gM;
function bM() {
  return bM = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, bM.apply(this, arguments);
}
var wM;
function yM() {
  return yM = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, yM.apply(this, arguments);
}
var xM;
function OM() {
  return OM = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, OM.apply(this, arguments);
}
var EM;
function jM() {
  return jM = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, jM.apply(this, arguments);
}
var CM;
function PM() {
  return PM = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, PM.apply(this, arguments);
}
var MM;
function kM() {
  return kM = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, kM.apply(this, arguments);
}
var SM;
function NM() {
  return NM = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, NM.apply(this, arguments);
}
var BM;
function VM() {
  return VM = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, VM.apply(this, arguments);
}
var RM;
function AM() {
  return AM = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, AM.apply(this, arguments);
}
var TM;
function HM() {
  return HM = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, HM.apply(this, arguments);
}
var LM;
function IM() {
  return IM = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, IM.apply(this, arguments);
}
var FM;
function _M() {
  return _M = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, _M.apply(this, arguments);
}
var ZM;
function DM() {
  return DM = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, DM.apply(this, arguments);
}
var qM;
function UM() {
  return UM = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, UM.apply(this, arguments);
}
var $M;
function zM() {
  return zM = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, zM.apply(this, arguments);
}
var WM;
function QM() {
  return QM = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, QM.apply(this, arguments);
}
var GM;
function YM() {
  return YM = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, YM.apply(this, arguments);
}
var KM;
function XM() {
  return XM = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, XM.apply(this, arguments);
}
var JM;
function ek() {
  return ek = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ek.apply(this, arguments);
}
var tk;
function rk() {
  return rk = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, rk.apply(this, arguments);
}
var nk;
function ak() {
  return ak = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ak.apply(this, arguments);
}
var ok;
function ik() {
  return ik = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ik.apply(this, arguments);
}
var lk;
function sk() {
  return sk = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, sk.apply(this, arguments);
}
var ck;
function uk() {
  return uk = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, uk.apply(this, arguments);
}
var hk;
function mk() {
  return mk = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, mk.apply(this, arguments);
}
var pk;
function fk() {
  return fk = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, fk.apply(this, arguments);
}
var dk;
function vk() {
  return vk = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, vk.apply(this, arguments);
}
var gk;
function bk() {
  return bk = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, bk.apply(this, arguments);
}
var wk;
function yk() {
  return yk = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, yk.apply(this, arguments);
}
var xk;
function Ok() {
  return Ok = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ok.apply(this, arguments);
}
var Ek;
function jk() {
  return jk = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, jk.apply(this, arguments);
}
var Ck;
function Pk() {
  return Pk = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Pk.apply(this, arguments);
}
var Mk;
function kk() {
  return kk = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, kk.apply(this, arguments);
}
var Sk;
function Nk() {
  return Nk = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Nk.apply(this, arguments);
}
var Bk;
function Vk() {
  return Vk = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Vk.apply(this, arguments);
}
var Rk;
function Ak() {
  return Ak = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ak.apply(this, arguments);
}
var Tk;
function Hk() {
  return Hk = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Hk.apply(this, arguments);
}
var Lk;
function Ik() {
  return Ik = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ik.apply(this, arguments);
}
var Fk;
function _k() {
  return _k = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, _k.apply(this, arguments);
}
var Zk;
function Dk() {
  return Dk = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Dk.apply(this, arguments);
}
var qk;
function Uk() {
  return Uk = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Uk.apply(this, arguments);
}
var $k;
function zk() {
  return zk = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, zk.apply(this, arguments);
}
var Wk;
function Qk() {
  return Qk = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Qk.apply(this, arguments);
}
var Gk;
function Yk() {
  return Yk = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Yk.apply(this, arguments);
}
var Kk;
function Xk() {
  return Xk = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Xk.apply(this, arguments);
}
var Jk;
function eS() {
  return eS = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, eS.apply(this, arguments);
}
var tS;
function rS() {
  return rS = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, rS.apply(this, arguments);
}
var nS;
function aS() {
  return aS = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, aS.apply(this, arguments);
}
var oS;
function iS() {
  return iS = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, iS.apply(this, arguments);
}
var lS;
function sS() {
  return sS = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, sS.apply(this, arguments);
}
var cS;
function uS() {
  return uS = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, uS.apply(this, arguments);
}
var hS;
function mS() {
  return mS = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, mS.apply(this, arguments);
}
var pS;
function fS() {
  return fS = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, fS.apply(this, arguments);
}
var dS;
function vS() {
  return vS = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, vS.apply(this, arguments);
}
var gS;
function bS() {
  return bS = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, bS.apply(this, arguments);
}
var wS;
function yS() {
  return yS = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, yS.apply(this, arguments);
}
var xS;
function OS() {
  return OS = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, OS.apply(this, arguments);
}
var ES;
function jS() {
  return jS = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, jS.apply(this, arguments);
}
var CS;
function PS() {
  return PS = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, PS.apply(this, arguments);
}
var MS;
function kS() {
  return kS = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, kS.apply(this, arguments);
}
var SS;
function NS() {
  return NS = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, NS.apply(this, arguments);
}
var BS;
function VS() {
  return VS = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, VS.apply(this, arguments);
}
var RS;
function AS() {
  return AS = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, AS.apply(this, arguments);
}
var TS;
function HS() {
  return HS = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, HS.apply(this, arguments);
}
var LS;
function IS() {
  return IS = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, IS.apply(this, arguments);
}
var FS;
function _S() {
  return _S = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, _S.apply(this, arguments);
}
var ZS;
function DS() {
  return DS = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, DS.apply(this, arguments);
}
var qS;
function US() {
  return US = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, US.apply(this, arguments);
}
var $S;
function zS() {
  return zS = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, zS.apply(this, arguments);
}
var WS;
function QS() {
  return QS = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, QS.apply(this, arguments);
}
var GS;
function YS() {
  return YS = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, YS.apply(this, arguments);
}
var KS;
function XS() {
  return XS = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, XS.apply(this, arguments);
}
var JS;
function eN() {
  return eN = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, eN.apply(this, arguments);
}
var tN;
function rN() {
  return rN = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, rN.apply(this, arguments);
}
var nN;
function aN() {
  return aN = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, aN.apply(this, arguments);
}
var oN;
function iN() {
  return iN = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, iN.apply(this, arguments);
}
var lN;
function sN() {
  return sN = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, sN.apply(this, arguments);
}
var cN;
function uN() {
  return uN = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, uN.apply(this, arguments);
}
var hN;
function mN() {
  return mN = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, mN.apply(this, arguments);
}
var pN;
function fN() {
  return fN = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, fN.apply(this, arguments);
}
var dN;
function vN() {
  return vN = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, vN.apply(this, arguments);
}
var gN;
function bN() {
  return bN = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, bN.apply(this, arguments);
}
var wN;
function yN() {
  return yN = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, yN.apply(this, arguments);
}
var xN;
function ON() {
  return ON = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ON.apply(this, arguments);
}
var EN;
function jN() {
  return jN = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, jN.apply(this, arguments);
}
var CN;
function PN() {
  return PN = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, PN.apply(this, arguments);
}
var MN;
function kN() {
  return kN = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, kN.apply(this, arguments);
}
var SN;
function NN() {
  return NN = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, NN.apply(this, arguments);
}
var BN;
function VN() {
  return VN = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, VN.apply(this, arguments);
}
var RN;
function AN() {
  return AN = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, AN.apply(this, arguments);
}
var TN, HN;
function LN() {
  return LN = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, LN.apply(this, arguments);
}
var IN;
function FN() {
  return FN = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, FN.apply(this, arguments);
}
var _N;
function ZN() {
  return ZN = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ZN.apply(this, arguments);
}
var DN;
function qN() {
  return qN = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, qN.apply(this, arguments);
}
var UN;
function $N() {
  return $N = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, $N.apply(this, arguments);
}
var zN;
function WN() {
  return WN = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, WN.apply(this, arguments);
}
var QN;
function GN() {
  return GN = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, GN.apply(this, arguments);
}
var YN;
function KN() {
  return KN = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, KN.apply(this, arguments);
}
var XN;
function JN() {
  return JN = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, JN.apply(this, arguments);
}
var eB;
function tB() {
  return tB = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, tB.apply(this, arguments);
}
var rB;
function nB() {
  return nB = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, nB.apply(this, arguments);
}
var aB;
function oB() {
  return oB = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, oB.apply(this, arguments);
}
var iB;
function lB() {
  return lB = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, lB.apply(this, arguments);
}
var sB;
function cB() {
  return cB = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, cB.apply(this, arguments);
}
var uB;
function hB() {
  return hB = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, hB.apply(this, arguments);
}
var mB;
function pB() {
  return pB = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, pB.apply(this, arguments);
}
var fB;
function dB() {
  return dB = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, dB.apply(this, arguments);
}
var vB;
function gB() {
  return gB = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, gB.apply(this, arguments);
}
var bB;
function wB() {
  return wB = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, wB.apply(this, arguments);
}
var yB;
function xB() {
  return xB = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, xB.apply(this, arguments);
}
var OB;
function EB() {
  return EB = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, EB.apply(this, arguments);
}
var jB;
function CB() {
  return CB = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, CB.apply(this, arguments);
}
var PB;
function MB() {
  return MB = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, MB.apply(this, arguments);
}
var kB;
function SB() {
  return SB = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, SB.apply(this, arguments);
}
var NB;
function BB() {
  return BB = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, BB.apply(this, arguments);
}
var VB;
function RB() {
  return RB = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, RB.apply(this, arguments);
}
var AB;
function TB() {
  return TB = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, TB.apply(this, arguments);
}
var HB;
function LB() {
  return LB = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, LB.apply(this, arguments);
}
var IB;
function FB() {
  return FB = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, FB.apply(this, arguments);
}
var _B;
function ZB() {
  return ZB = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ZB.apply(this, arguments);
}
var DB;
function qB() {
  return qB = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, qB.apply(this, arguments);
}
var UB;
function $B() {
  return $B = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, $B.apply(this, arguments);
}
var zB;
function WB() {
  return WB = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, WB.apply(this, arguments);
}
var QB;
function GB() {
  return GB = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, GB.apply(this, arguments);
}
var YB;
function KB() {
  return KB = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, KB.apply(this, arguments);
}
var XB;
function JB() {
  return JB = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, JB.apply(this, arguments);
}
var eV;
function tV() {
  return tV = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, tV.apply(this, arguments);
}
var rV;
function nV() {
  return nV = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, nV.apply(this, arguments);
}
var aV;
function oV() {
  return oV = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, oV.apply(this, arguments);
}
var iV;
function lV() {
  return lV = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, lV.apply(this, arguments);
}
var sV;
function cV() {
  return cV = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, cV.apply(this, arguments);
}
var uV, hV;
function mV() {
  return mV = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, mV.apply(this, arguments);
}
var pV;
function fV() {
  return fV = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, fV.apply(this, arguments);
}
var dV;
function vV() {
  return vV = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, vV.apply(this, arguments);
}
var gV;
function bV() {
  return bV = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, bV.apply(this, arguments);
}
var wV;
function yV() {
  return yV = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, yV.apply(this, arguments);
}
var xV;
function OV() {
  return OV = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, OV.apply(this, arguments);
}
var EV;
function jV() {
  return jV = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, jV.apply(this, arguments);
}
var CV, PV;
function MV() {
  return MV = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, MV.apply(this, arguments);
}
var kV;
function SV() {
  return SV = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, SV.apply(this, arguments);
}
var NV;
function BV() {
  return BV = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, BV.apply(this, arguments);
}
var VV;
function RV() {
  return RV = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, RV.apply(this, arguments);
}
var AV;
function TV() {
  return TV = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, TV.apply(this, arguments);
}
var HV;
function LV() {
  return LV = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, LV.apply(this, arguments);
}
var IV;
function FV() {
  return FV = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, FV.apply(this, arguments);
}
var _V;
function ZV() {
  return ZV = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ZV.apply(this, arguments);
}
var DV;
function qV() {
  return qV = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, qV.apply(this, arguments);
}
var UV;
function $V() {
  return $V = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, $V.apply(this, arguments);
}
var zV;
function WV() {
  return WV = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, WV.apply(this, arguments);
}
var QV;
function GV() {
  return GV = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, GV.apply(this, arguments);
}
var YV;
function KV() {
  return KV = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, KV.apply(this, arguments);
}
var XV;
function JV() {
  return JV = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, JV.apply(this, arguments);
}
var eR;
function tR() {
  return tR = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, tR.apply(this, arguments);
}
var rR;
function nR() {
  return nR = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, nR.apply(this, arguments);
}
var aR;
function oR() {
  return oR = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, oR.apply(this, arguments);
}
var iR;
function lR() {
  return lR = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, lR.apply(this, arguments);
}
var sR;
function cR() {
  return cR = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, cR.apply(this, arguments);
}
var uR;
function hR() {
  return hR = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, hR.apply(this, arguments);
}
var mR, pR;
function fR() {
  return fR = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, fR.apply(this, arguments);
}
var dR;
function vR() {
  return vR = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, vR.apply(this, arguments);
}
var gR;
function bR() {
  return bR = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, bR.apply(this, arguments);
}
var wR;
function yR() {
  return yR = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, yR.apply(this, arguments);
}
var xR;
function OR() {
  return OR = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, OR.apply(this, arguments);
}
var ER;
function jR() {
  return jR = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, jR.apply(this, arguments);
}
var CR;
function PR() {
  return PR = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, PR.apply(this, arguments);
}
var MR;
function kR() {
  return kR = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, kR.apply(this, arguments);
}
var SR;
function NR() {
  return NR = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, NR.apply(this, arguments);
}
var BR;
function VR() {
  return VR = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, VR.apply(this, arguments);
}
var RR;
function AR() {
  return AR = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, AR.apply(this, arguments);
}
var TR;
function HR() {
  return HR = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, HR.apply(this, arguments);
}
var LR;
function IR() {
  return IR = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, IR.apply(this, arguments);
}
var FR;
function _R() {
  return _R = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, _R.apply(this, arguments);
}
var ZR, DR;
function qR() {
  return qR = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, qR.apply(this, arguments);
}
var UR;
function $R() {
  return $R = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, $R.apply(this, arguments);
}
var zR, WR;
function QR() {
  return QR = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, QR.apply(this, arguments);
}
var GR;
function YR() {
  return YR = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, YR.apply(this, arguments);
}
var KR;
function XR() {
  return XR = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, XR.apply(this, arguments);
}
var JR;
function eA() {
  return eA = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, eA.apply(this, arguments);
}
var tA;
function rA() {
  return rA = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, rA.apply(this, arguments);
}
var nA;
function aA() {
  return aA = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, aA.apply(this, arguments);
}
var oA;
function iA() {
  return iA = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, iA.apply(this, arguments);
}
var lA;
function sA() {
  return sA = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, sA.apply(this, arguments);
}
var cA;
function uA() {
  return uA = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, uA.apply(this, arguments);
}
var hA;
function mA() {
  return mA = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, mA.apply(this, arguments);
}
var pA;
function fA() {
  return fA = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, fA.apply(this, arguments);
}
var dA;
function vA() {
  return vA = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, vA.apply(this, arguments);
}
var gA;
function bA() {
  return bA = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, bA.apply(this, arguments);
}
var wA;
function yA() {
  return yA = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, yA.apply(this, arguments);
}
var xA;
function OA() {
  return OA = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, OA.apply(this, arguments);
}
var EA;
function jA() {
  return jA = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, jA.apply(this, arguments);
}
var CA;
function PA() {
  return PA = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, PA.apply(this, arguments);
}
var MA;
function kA() {
  return kA = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, kA.apply(this, arguments);
}
var SA;
function NA() {
  return NA = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, NA.apply(this, arguments);
}
var BA;
function VA() {
  return VA = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, VA.apply(this, arguments);
}
var RA;
function AA() {
  return AA = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, AA.apply(this, arguments);
}
var TA;
function HA() {
  return HA = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, HA.apply(this, arguments);
}
var LA;
function IA() {
  return IA = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, IA.apply(this, arguments);
}
var FA;
function _A() {
  return _A = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, _A.apply(this, arguments);
}
var ZA;
function DA() {
  return DA = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, DA.apply(this, arguments);
}
var qA;
function UA() {
  return UA = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, UA.apply(this, arguments);
}
var $A;
function zA() {
  return zA = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, zA.apply(this, arguments);
}
var WA;
function QA() {
  return QA = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, QA.apply(this, arguments);
}
var GA;
function YA() {
  return YA = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, YA.apply(this, arguments);
}
var KA;
function XA() {
  return XA = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, XA.apply(this, arguments);
}
var JA;
function eT() {
  return eT = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, eT.apply(this, arguments);
}
var tT;
function rT() {
  return rT = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, rT.apply(this, arguments);
}
var nT;
function aT() {
  return aT = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, aT.apply(this, arguments);
}
var oT;
function iT() {
  return iT = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, iT.apply(this, arguments);
}
var lT;
function sT() {
  return sT = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, sT.apply(this, arguments);
}
var cT;
function uT() {
  return uT = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, uT.apply(this, arguments);
}
var hT;
function mT() {
  return mT = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, mT.apply(this, arguments);
}
var pT;
function fT() {
  return fT = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, fT.apply(this, arguments);
}
var dT, vT;
function gT() {
  return gT = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, gT.apply(this, arguments);
}
var bT;
function wT() {
  return wT = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, wT.apply(this, arguments);
}
var yT;
function xT() {
  return xT = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, xT.apply(this, arguments);
}
var OT;
function ET() {
  return ET = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ET.apply(this, arguments);
}
var jT, CT;
function PT() {
  return PT = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, PT.apply(this, arguments);
}
var MT;
function kT() {
  return kT = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, kT.apply(this, arguments);
}
var ST;
function NT() {
  return NT = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, NT.apply(this, arguments);
}
var BT;
function VT() {
  return VT = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, VT.apply(this, arguments);
}
var RT;
function AT() {
  return AT = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, AT.apply(this, arguments);
}
var TT;
function HT() {
  return HT = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, HT.apply(this, arguments);
}
var LT;
function IT() {
  return IT = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, IT.apply(this, arguments);
}
var FT;
function _T() {
  return _T = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, _T.apply(this, arguments);
}
var ZT;
function DT() {
  return DT = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, DT.apply(this, arguments);
}
var qT;
function UT() {
  return UT = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, UT.apply(this, arguments);
}
var $T;
function zT() {
  return zT = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, zT.apply(this, arguments);
}
var WT;
function QT() {
  return QT = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, QT.apply(this, arguments);
}
var GT, YT;
function KT() {
  return KT = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, KT.apply(this, arguments);
}
var XT;
function JT() {
  return JT = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, JT.apply(this, arguments);
}
var eH;
function tH() {
  return tH = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, tH.apply(this, arguments);
}
var rH;
function nH() {
  return nH = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, nH.apply(this, arguments);
}
var aH;
function oH() {
  return oH = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, oH.apply(this, arguments);
}
var iH;
function lH() {
  return lH = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, lH.apply(this, arguments);
}
var sH;
function cH() {
  return cH = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, cH.apply(this, arguments);
}
var uH;
function hH() {
  return hH = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, hH.apply(this, arguments);
}
var mH;
function pH() {
  return pH = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, pH.apply(this, arguments);
}
var fH;
function dH() {
  return dH = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, dH.apply(this, arguments);
}
var vH;
function gH() {
  return gH = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, gH.apply(this, arguments);
}
var bH;
function wH() {
  return wH = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, wH.apply(this, arguments);
}
var yH;
function xH() {
  return xH = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, xH.apply(this, arguments);
}
var OH, EH;
function jH() {
  return jH = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, jH.apply(this, arguments);
}
var CH, PH;
function MH() {
  return MH = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, MH.apply(this, arguments);
}
var kH;
function SH() {
  return SH = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, SH.apply(this, arguments);
}
var NH;
function BH() {
  return BH = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, BH.apply(this, arguments);
}
var VH;
function RH() {
  return RH = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, RH.apply(this, arguments);
}
var AH;
function TH() {
  return TH = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, TH.apply(this, arguments);
}
var HH;
function LH() {
  return LH = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, LH.apply(this, arguments);
}
var IH;
function FH() {
  return FH = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, FH.apply(this, arguments);
}
var _H;
function ZH() {
  return ZH = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ZH.apply(this, arguments);
}
var DH;
function qH() {
  return qH = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, qH.apply(this, arguments);
}
var UH;
function $H() {
  return $H = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, $H.apply(this, arguments);
}
var zH;
function WH() {
  return WH = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, WH.apply(this, arguments);
}
var QH;
function GH() {
  return GH = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, GH.apply(this, arguments);
}
var YH;
function KH() {
  return KH = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, KH.apply(this, arguments);
}
var XH;
function JH() {
  return JH = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, JH.apply(this, arguments);
}
var eL;
function tL() {
  return tL = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, tL.apply(this, arguments);
}
var rL;
function nL() {
  return nL = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, nL.apply(this, arguments);
}
var aL;
function oL() {
  return oL = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, oL.apply(this, arguments);
}
var iL;
function lL() {
  return lL = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, lL.apply(this, arguments);
}
var sL, cL;
function uL() {
  return uL = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, uL.apply(this, arguments);
}
var hL;
function mL() {
  return mL = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, mL.apply(this, arguments);
}
var pL;
function fL() {
  return fL = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, fL.apply(this, arguments);
}
var dL;
function vL() {
  return vL = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, vL.apply(this, arguments);
}
var gL;
function bL() {
  return bL = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, bL.apply(this, arguments);
}
var wL;
function yL() {
  return yL = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, yL.apply(this, arguments);
}
var xL;
function OL() {
  return OL = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, OL.apply(this, arguments);
}
var EL;
function jL() {
  return jL = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, jL.apply(this, arguments);
}
var CL;
function PL() {
  return PL = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, PL.apply(this, arguments);
}
var ML;
function kL() {
  return kL = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, kL.apply(this, arguments);
}
var SL;
function NL() {
  return NL = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, NL.apply(this, arguments);
}
var BL;
function VL() {
  return VL = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, VL.apply(this, arguments);
}
var RL;
function AL() {
  return AL = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, AL.apply(this, arguments);
}
var TL;
function HL() {
  return HL = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, HL.apply(this, arguments);
}
var LL;
function IL() {
  return IL = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, IL.apply(this, arguments);
}
var FL;
function _L() {
  return _L = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, _L.apply(this, arguments);
}
var ZL;
function DL() {
  return DL = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, DL.apply(this, arguments);
}
var qL;
function UL() {
  return UL = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, UL.apply(this, arguments);
}
var $L;
function zL() {
  return zL = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, zL.apply(this, arguments);
}
var WL;
function QL() {
  return QL = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, QL.apply(this, arguments);
}
var GL;
function YL() {
  return YL = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, YL.apply(this, arguments);
}
var KL;
function XL() {
  return XL = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, XL.apply(this, arguments);
}
var JL;
function eI() {
  return eI = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, eI.apply(this, arguments);
}
var tI;
function rI() {
  return rI = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, rI.apply(this, arguments);
}
var nI;
function aI() {
  return aI = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, aI.apply(this, arguments);
}
var oI;
function iI() {
  return iI = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, iI.apply(this, arguments);
}
var lI;
function sI() {
  return sI = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, sI.apply(this, arguments);
}
var cI;
function uI() {
  return uI = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, uI.apply(this, arguments);
}
var hI;
function mI() {
  return mI = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, mI.apply(this, arguments);
}
var pI;
function fI() {
  return fI = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, fI.apply(this, arguments);
}
var dI;
function vI() {
  return vI = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, vI.apply(this, arguments);
}
var gI;
function bI() {
  return bI = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, bI.apply(this, arguments);
}
var wI;
function yI() {
  return yI = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, yI.apply(this, arguments);
}
var xI;
function OI() {
  return OI = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, OI.apply(this, arguments);
}
var EI;
function jI() {
  return jI = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, jI.apply(this, arguments);
}
var CI;
function PI() {
  return PI = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, PI.apply(this, arguments);
}
var MI;
function kI() {
  return kI = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, kI.apply(this, arguments);
}
var SI;
function NI() {
  return NI = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, NI.apply(this, arguments);
}
var BI;
function VI() {
  return VI = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, VI.apply(this, arguments);
}
var RI;
function AI() {
  return AI = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, AI.apply(this, arguments);
}
var TI;
function HI() {
  return HI = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, HI.apply(this, arguments);
}
var LI;
function II() {
  return II = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, II.apply(this, arguments);
}
var FI;
function _I() {
  return _I = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, _I.apply(this, arguments);
}
var ZI;
function DI() {
  return DI = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, DI.apply(this, arguments);
}
var qI;
function UI() {
  return UI = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, UI.apply(this, arguments);
}
var $I;
function zI() {
  return zI = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, zI.apply(this, arguments);
}
var WI;
function QI() {
  return QI = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, QI.apply(this, arguments);
}
var GI;
function YI() {
  return YI = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, YI.apply(this, arguments);
}
var KI;
function XI() {
  return XI = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, XI.apply(this, arguments);
}
var JI;
function eF() {
  return eF = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, eF.apply(this, arguments);
}
var tF;
function rF() {
  return rF = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, rF.apply(this, arguments);
}
var nF;
function aF() {
  return aF = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, aF.apply(this, arguments);
}
var oF;
function iF() {
  return iF = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, iF.apply(this, arguments);
}
var lF;
function sF() {
  return sF = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, sF.apply(this, arguments);
}
var cF;
function uF() {
  return uF = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, uF.apply(this, arguments);
}
var hF;
function mF() {
  return mF = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, mF.apply(this, arguments);
}
var pF;
function fF() {
  return fF = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, fF.apply(this, arguments);
}
var dF;
function vF() {
  return vF = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, vF.apply(this, arguments);
}
var gF;
function bF() {
  return bF = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, bF.apply(this, arguments);
}
var wF;
function yF() {
  return yF = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, yF.apply(this, arguments);
}
var xF;
function OF() {
  return OF = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, OF.apply(this, arguments);
}
var EF;
function jF() {
  return jF = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, jF.apply(this, arguments);
}
var CF;
function PF() {
  return PF = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, PF.apply(this, arguments);
}
var MF;
function kF() {
  return kF = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, kF.apply(this, arguments);
}
var SF;
function NF() {
  return NF = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, NF.apply(this, arguments);
}
var BF;
function VF() {
  return VF = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, VF.apply(this, arguments);
}
var RF;
function AF() {
  return AF = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, AF.apply(this, arguments);
}
var TF;
function HF() {
  return HF = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, HF.apply(this, arguments);
}
var LF, IF;
function FF() {
  return FF = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, FF.apply(this, arguments);
}
var _F;
function ZF() {
  return ZF = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ZF.apply(this, arguments);
}
var DF;
function qF() {
  return qF = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, qF.apply(this, arguments);
}
var UF;
function $F() {
  return $F = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, $F.apply(this, arguments);
}
var zF;
function WF() {
  return WF = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, WF.apply(this, arguments);
}
var QF;
function GF() {
  return GF = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, GF.apply(this, arguments);
}
var YF;
function KF() {
  return KF = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, KF.apply(this, arguments);
}
var XF;
function JF() {
  return JF = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, JF.apply(this, arguments);
}
var e_;
function t_() {
  return t_ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, t_.apply(this, arguments);
}
var r_;
function n_() {
  return n_ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, n_.apply(this, arguments);
}
var a_;
function o_() {
  return o_ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, o_.apply(this, arguments);
}
var i_;
function l_() {
  return l_ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, l_.apply(this, arguments);
}
var s_;
function c_() {
  return c_ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, c_.apply(this, arguments);
}
var u_, h_;
function m_() {
  return m_ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, m_.apply(this, arguments);
}
var p_;
function f_() {
  return f_ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, f_.apply(this, arguments);
}
var d_;
function v_() {
  return v_ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, v_.apply(this, arguments);
}
var g_;
function b_() {
  return b_ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, b_.apply(this, arguments);
}
var w_;
function y_() {
  return y_ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, y_.apply(this, arguments);
}
var x_;
function O_() {
  return O_ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, O_.apply(this, arguments);
}
var E_;
function j_() {
  return j_ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, j_.apply(this, arguments);
}
var C_;
function P_() {
  return P_ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, P_.apply(this, arguments);
}
var M_;
function k_() {
  return k_ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, k_.apply(this, arguments);
}
var S_, N_;
function B_() {
  return B_ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, B_.apply(this, arguments);
}
var V_;
function R_() {
  return R_ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, R_.apply(this, arguments);
}
var A_;
function T_() {
  return T_ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, T_.apply(this, arguments);
}
var H_;
function L_() {
  return L_ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, L_.apply(this, arguments);
}
var I_;
function F_() {
  return F_ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, F_.apply(this, arguments);
}
var __;
function Z_() {
  return Z_ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Z_.apply(this, arguments);
}
var D_;
function q_() {
  return q_ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, q_.apply(this, arguments);
}
var U_;
function $_() {
  return $_ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, $_.apply(this, arguments);
}
var z_;
function W_() {
  return W_ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, W_.apply(this, arguments);
}
var Q_;
function G_() {
  return G_ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, G_.apply(this, arguments);
}
var Y_;
function K_() {
  return K_ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, K_.apply(this, arguments);
}
var X_;
function J_() {
  return J_ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, J_.apply(this, arguments);
}
var eZ;
function tZ() {
  return tZ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, tZ.apply(this, arguments);
}
var rZ;
function nZ() {
  return nZ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, nZ.apply(this, arguments);
}
var aZ;
function oZ() {
  return oZ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, oZ.apply(this, arguments);
}
var iZ;
function lZ() {
  return lZ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, lZ.apply(this, arguments);
}
var sZ;
function cZ() {
  return cZ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, cZ.apply(this, arguments);
}
var uZ;
function hZ() {
  return hZ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, hZ.apply(this, arguments);
}
var mZ;
function pZ() {
  return pZ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, pZ.apply(this, arguments);
}
var fZ;
function dZ() {
  return dZ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, dZ.apply(this, arguments);
}
var vZ;
function gZ() {
  return gZ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, gZ.apply(this, arguments);
}
var bZ;
function wZ() {
  return wZ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, wZ.apply(this, arguments);
}
var yZ;
function xZ() {
  return xZ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, xZ.apply(this, arguments);
}
var OZ;
function EZ() {
  return EZ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, EZ.apply(this, arguments);
}
var jZ;
function CZ() {
  return CZ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, CZ.apply(this, arguments);
}
var PZ;
function MZ() {
  return MZ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, MZ.apply(this, arguments);
}
var kZ;
function SZ() {
  return SZ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, SZ.apply(this, arguments);
}
var NZ;
function BZ() {
  return BZ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, BZ.apply(this, arguments);
}
var VZ;
function RZ() {
  return RZ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, RZ.apply(this, arguments);
}
var AZ;
function TZ() {
  return TZ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, TZ.apply(this, arguments);
}
var HZ;
function LZ() {
  return LZ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, LZ.apply(this, arguments);
}
var IZ;
function FZ() {
  return FZ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, FZ.apply(this, arguments);
}
var _Z;
function ZZ() {
  return ZZ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ZZ.apply(this, arguments);
}
var DZ;
function qZ() {
  return qZ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, qZ.apply(this, arguments);
}
var UZ;
function $Z() {
  return $Z = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, $Z.apply(this, arguments);
}
var zZ;
function WZ() {
  return WZ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, WZ.apply(this, arguments);
}
var QZ;
function GZ() {
  return GZ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, GZ.apply(this, arguments);
}
var YZ;
function KZ() {
  return KZ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, KZ.apply(this, arguments);
}
var XZ;
function JZ() {
  return JZ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, JZ.apply(this, arguments);
}
var eD;
function tD() {
  return tD = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, tD.apply(this, arguments);
}
var rD;
function nD() {
  return nD = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, nD.apply(this, arguments);
}
var aD;
function oD() {
  return oD = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, oD.apply(this, arguments);
}
var iD;
function lD() {
  return lD = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, lD.apply(this, arguments);
}
var sD;
function cD() {
  return cD = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, cD.apply(this, arguments);
}
var uD;
function hD() {
  return hD = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, hD.apply(this, arguments);
}
var mD;
function pD() {
  return pD = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, pD.apply(this, arguments);
}
var fD;
function dD() {
  return dD = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, dD.apply(this, arguments);
}
var vD;
function gD() {
  return gD = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, gD.apply(this, arguments);
}
var bD;
function wD() {
  return wD = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, wD.apply(this, arguments);
}
var yD;
function xD() {
  return xD = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, xD.apply(this, arguments);
}
var OD;
function ED() {
  return ED = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ED.apply(this, arguments);
}
var jD;
function CD() {
  return CD = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, CD.apply(this, arguments);
}
var PD;
function MD() {
  return MD = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, MD.apply(this, arguments);
}
var kD;
function SD() {
  return SD = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, SD.apply(this, arguments);
}
var ND;
function BD() {
  return BD = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, BD.apply(this, arguments);
}
var VD;
function RD() {
  return RD = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, RD.apply(this, arguments);
}
var AD;
function TD() {
  return TD = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, TD.apply(this, arguments);
}
var HD;
function LD() {
  return LD = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, LD.apply(this, arguments);
}
var ID;
function FD() {
  return FD = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, FD.apply(this, arguments);
}
var _D, ZD;
function DD() {
  return DD = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, DD.apply(this, arguments);
}
var qD;
function UD() {
  return UD = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, UD.apply(this, arguments);
}
var $D;
function zD() {
  return zD = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, zD.apply(this, arguments);
}
var WD;
function QD() {
  return QD = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, QD.apply(this, arguments);
}
var GD;
function YD() {
  return YD = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, YD.apply(this, arguments);
}
var KD;
function XD() {
  return XD = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, XD.apply(this, arguments);
}
var JD;
function eq() {
  return eq = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, eq.apply(this, arguments);
}
var tq;
function rq() {
  return rq = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, rq.apply(this, arguments);
}
var nq;
function aq() {
  return aq = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, aq.apply(this, arguments);
}
var oq;
function iq() {
  return iq = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, iq.apply(this, arguments);
}
var lq;
function sq() {
  return sq = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, sq.apply(this, arguments);
}
var cq, uq;
function hq() {
  return hq = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, hq.apply(this, arguments);
}
var mq;
function pq() {
  return pq = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, pq.apply(this, arguments);
}
var fq;
function dq() {
  return dq = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, dq.apply(this, arguments);
}
var vq;
function gq() {
  return gq = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, gq.apply(this, arguments);
}
var bq;
function wq() {
  return wq = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, wq.apply(this, arguments);
}
var yq;
function xq() {
  return xq = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, xq.apply(this, arguments);
}
var Oq;
function Eq() {
  return Eq = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Eq.apply(this, arguments);
}
var jq;
function Cq() {
  return Cq = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Cq.apply(this, arguments);
}
var Pq;
function Mq() {
  return Mq = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Mq.apply(this, arguments);
}
var kq;
function Sq() {
  return Sq = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Sq.apply(this, arguments);
}
var Nq;
function Bq() {
  return Bq = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Bq.apply(this, arguments);
}
var Vq;
function Rq() {
  return Rq = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Rq.apply(this, arguments);
}
var Aq;
function Tq() {
  return Tq = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Tq.apply(this, arguments);
}
var Hq;
function Lq() {
  return Lq = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Lq.apply(this, arguments);
}
var Iq;
function Fq() {
  return Fq = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Fq.apply(this, arguments);
}
var _q;
function Zq() {
  return Zq = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Zq.apply(this, arguments);
}
var Dq;
function qq() {
  return qq = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, qq.apply(this, arguments);
}
var Uq;
function $q() {
  return $q = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, $q.apply(this, arguments);
}
var zq;
function Wq() {
  return Wq = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Wq.apply(this, arguments);
}
var Qq;
function Gq() {
  return Gq = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Gq.apply(this, arguments);
}
var Yq;
function Kq() {
  return Kq = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Kq.apply(this, arguments);
}
var Xq;
function Jq() {
  return Jq = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Jq.apply(this, arguments);
}
var eU;
function tU() {
  return tU = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, tU.apply(this, arguments);
}
var rU;
function nU() {
  return nU = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, nU.apply(this, arguments);
}
var aU;
function oU() {
  return oU = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, oU.apply(this, arguments);
}
var iU;
function lU() {
  return lU = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, lU.apply(this, arguments);
}
var sU;
function cU() {
  return cU = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, cU.apply(this, arguments);
}
var uU;
function hU() {
  return hU = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, hU.apply(this, arguments);
}
var mU;
function pU() {
  return pU = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, pU.apply(this, arguments);
}
var fU;
function dU() {
  return dU = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, dU.apply(this, arguments);
}
var vU;
function gU() {
  return gU = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, gU.apply(this, arguments);
}
var bU;
function wU() {
  return wU = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, wU.apply(this, arguments);
}
var yU;
function xU() {
  return xU = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, xU.apply(this, arguments);
}
var OU;
function EU() {
  return EU = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, EU.apply(this, arguments);
}
var jU, CU;
function PU() {
  return PU = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, PU.apply(this, arguments);
}
var MU, kU;
function SU() {
  return SU = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, SU.apply(this, arguments);
}
var NU;
function BU() {
  return BU = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, BU.apply(this, arguments);
}
var VU;
function RU() {
  return RU = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, RU.apply(this, arguments);
}
var AU;
function TU() {
  return TU = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, TU.apply(this, arguments);
}
var HU;
function LU() {
  return LU = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, LU.apply(this, arguments);
}
var IU, FU;
function _U() {
  return _U = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, _U.apply(this, arguments);
}
var ZU;
function DU() {
  return DU = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, DU.apply(this, arguments);
}
var qU, UU;
function $U() {
  return $U = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, $U.apply(this, arguments);
}
var zU;
function WU() {
  return WU = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, WU.apply(this, arguments);
}
var QU;
function GU() {
  return GU = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, GU.apply(this, arguments);
}
var YU;
function KU() {
  return KU = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, KU.apply(this, arguments);
}
var XU, JU;
function e$() {
  return e$ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, e$.apply(this, arguments);
}
var t$, r$;
function n$() {
  return n$ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, n$.apply(this, arguments);
}
var a$;
function o$() {
  return o$ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, o$.apply(this, arguments);
}
var i$;
function l$() {
  return l$ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, l$.apply(this, arguments);
}
var s$, c$, u$;
function h$() {
  return h$ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, h$.apply(this, arguments);
}
var m$;
function p$() {
  return p$ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, p$.apply(this, arguments);
}
var f$, d$;
function v$() {
  return v$ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, v$.apply(this, arguments);
}
var g$, b$;
function w$() {
  return w$ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, w$.apply(this, arguments);
}
var y$;
function x$() {
  return x$ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, x$.apply(this, arguments);
}
var O$;
function E$() {
  return E$ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, E$.apply(this, arguments);
}
var j$, C$;
function P$() {
  return P$ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, P$.apply(this, arguments);
}
var M$;
function k$() {
  return k$ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, k$.apply(this, arguments);
}
var S$;
function N$() {
  return N$ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, N$.apply(this, arguments);
}
var B$;
function V$() {
  return V$ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, V$.apply(this, arguments);
}
var R$, A$;
function T$() {
  return T$ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, T$.apply(this, arguments);
}
var H$;
function L$() {
  return L$ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, L$.apply(this, arguments);
}
var I$;
function F$() {
  return F$ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, F$.apply(this, arguments);
}
var _$, Z$, D$, q$;
function U$() {
  return U$ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, U$.apply(this, arguments);
}
var $$;
function z$() {
  return z$ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, z$.apply(this, arguments);
}
var W$, Q$;
function G$() {
  return G$ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, G$.apply(this, arguments);
}
var Y$;
function K$() {
  return K$ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, K$.apply(this, arguments);
}
var X$, J$;
function ez() {
  return ez = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ez.apply(this, arguments);
}
var tz;
function rz() {
  return rz = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, rz.apply(this, arguments);
}
var nz;
function az() {
  return az = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, az.apply(this, arguments);
}
var oz, iz;
function lz() {
  return lz = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, lz.apply(this, arguments);
}
var sz, cz;
function uz() {
  return uz = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, uz.apply(this, arguments);
}
const hz = {
  group1: t => e.createElement("svg", pe({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none"
  }, t), me || (me = e.createElement("path", {
    d: "M9.389 5.771a3.329 3.329 0 1 0 0-4.885c-.333.313-.599.69-.782 1.108a3.323 3.323 0 0 0 0 2.672c.183.418.45.794.782 1.105Zm.72-4.15a2.56 2.56 0 0 1 3.63-.196c.26.242.47.535.616.86a2.575 2.575 0 0 1 0 2.09 2.665 2.665 0 0 1-.617.86 2.569 2.569 0 0 1-3.628-3.614ZM4.56 8.564a2.62 2.62 0 1 0-1.04-5.088 2.597 2.597 0 0 0-1.53 1.417 2.63 2.63 0 0 0 .63 2.998 2.608 2.608 0 0 0 1.941.673Zm-1.217-3.83a1.842 1.842 0 0 1 3.086.448 1.87 1.87 0 0 1-.467 2.17 1.834 1.834 0 0 1-1.402.45 1.862 1.862 0 0 1-1.683-1.854c.003-.448.169-.88.466-1.214Zm15.76 3.83a2.619 2.619 0 1 0-1.041-5.088 2.597 2.597 0 0 0-1.533 1.417 2.632 2.632 0 0 0 .63 2.998 2.608 2.608 0 0 0 1.944.673Zm-1.217-3.83a1.842 1.842 0 0 1 2.62-.185 1.87 1.87 0 0 1-.655 3.175 1.834 1.834 0 0 1-.748.078 1.862 1.862 0 0 1-1.683-1.854c.003-.448.169-.88.466-1.214Zm5.306 6.548a4.961 4.961 0 0 0-.404-.527 5.656 5.656 0 0 0-.477-.46 4.486 4.486 0 0 0-1.122-.704 4.72 4.72 0 0 0-2.523-.384 4.546 4.546 0 0 0-1.921.712 6.049 6.049 0 0 0-5.101-2.32A6.043 6.043 0 0 0 7.4 9.642c-.037.042-.068.087-.101.13a.56.56 0 0 0-.14-.119 4.835 4.835 0 0 0-2.544-.647 4.705 4.705 0 0 0-4.153 2.639 4.787 4.787 0 0 0-.449 2.422.185.185 0 0 0 .188.177.188.188 0 0 0 .19-.19 4.159 4.159 0 0 1 .562-2.16 4.061 4.061 0 0 1 1.562-1.511 3.909 3.909 0 0 1 2.07-.463 3.814 3.814 0 0 1 1.962.662l.037.025.084.036a5.756 5.756 0 0 0-.446 1.074 5.922 5.922 0 0 0-.28 1.147 4.17 4.17 0 0 0-.043.592v.58a.19.19 0 0 0 .188.186.194.194 0 0 0 .194-.188c0-.191 0-.384.022-.561a3.97 3.97 0 0 1 .062-.561c.032-.179.078-.355.137-.527.042-.178.099-.353.169-.522A5.443 5.443 0 0 1 9.575 8.8a5.328 5.328 0 0 1 5.919 1.125A5.186 5.186 0 0 1 17 13.695v.028a.56.56 0 1 0 1.122-.022 6.3 6.3 0 0 0-.539-2.431 6.001 6.001 0 0 0-.575-1.013 4.027 4.027 0 0 1 3.862 0c.32.175.614.395.872.654.129.128.25.263.362.406.102.145.195.296.28.452a3.86 3.86 0 0 1 .494 2.041v.05a.561.561 0 0 0 1.121-.05 4.899 4.899 0 0 0-.807-2.53Z"
  }))),
  group2: t => e.createElement("svg", de({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none"
  }, t), fe || (fe = e.createElement("path", {
    fill: "#000",
    d: "M9.389 5.771a3.329 3.329 0 1 0 0-4.885c-.333.313-.599.69-.782 1.108a3.323 3.323 0 0 0 0 2.672c.183.418.45.794.782 1.105Zm.72-4.15a2.56 2.56 0 0 1 3.63-.196c.26.242.47.535.616.86a2.575 2.575 0 0 1 0 2.09 2.665 2.665 0 0 1-.617.86 2.569 2.569 0 0 1-3.628-3.614ZM4.56 8.564a2.62 2.62 0 1 0-1.04-5.088 2.597 2.597 0 0 0-1.53 1.417 2.63 2.63 0 0 0 .63 2.998 2.608 2.608 0 0 0 1.941.673Zm-1.217-3.83a1.842 1.842 0 0 1 3.086.448 1.87 1.87 0 0 1-.467 2.17 1.834 1.834 0 0 1-1.402.45 1.862 1.862 0 0 1-1.683-1.854c.003-.448.169-.88.466-1.214Zm15.76 3.83a2.619 2.619 0 1 0-1.041-5.088 2.597 2.597 0 0 0-1.533 1.417 2.632 2.632 0 0 0 .63 2.998 2.608 2.608 0 0 0 1.944.673Zm-1.217-3.83a1.842 1.842 0 0 1 2.62-.185 1.87 1.87 0 0 1-.655 3.175 1.834 1.834 0 0 1-.748.078 1.862 1.862 0 0 1-1.683-1.854c.003-.448.169-.88.466-1.214Zm5.306 6.548a4.961 4.961 0 0 0-.404-.527 5.656 5.656 0 0 0-.477-.46 4.486 4.486 0 0 0-1.122-.704 4.72 4.72 0 0 0-2.523-.384 4.546 4.546 0 0 0-1.921.712 6.049 6.049 0 0 0-5.101-2.32A6.043 6.043 0 0 0 7.4 9.642c-.037.042-.068.087-.101.13a.56.56 0 0 0-.14-.119 4.835 4.835 0 0 0-2.544-.647 4.705 4.705 0 0 0-4.153 2.639 4.787 4.787 0 0 0-.449 2.422.185.185 0 0 0 .188.177.188.188 0 0 0 .19-.19 4.159 4.159 0 0 1 .562-2.16 4.061 4.061 0 0 1 1.562-1.511 3.909 3.909 0 0 1 2.07-.463 3.814 3.814 0 0 1 1.962.662l.037.025.084.036a5.756 5.756 0 0 0-.446 1.074 5.922 5.922 0 0 0-.28 1.147 4.17 4.17 0 0 0-.043.592v.58a.19.19 0 0 0 .188.186.194.194 0 0 0 .194-.188c0-.191 0-.384.022-.561a3.97 3.97 0 0 1 .062-.561c.032-.179.078-.355.137-.527.042-.178.099-.353.169-.522A5.443 5.443 0 0 1 9.575 8.8a5.328 5.328 0 0 1 5.919 1.125A5.186 5.186 0 0 1 17 13.695v.028a.56.56 0 1 0 1.122-.022 6.3 6.3 0 0 0-.539-2.431 6.001 6.001 0 0 0-.575-1.013 4.027 4.027 0 0 1 3.862 0c.32.175.614.395.872.654.129.128.25.263.362.406.102.145.195.296.28.452a3.86 3.86 0 0 1 .494 2.041v.05a.561.561 0 0 0 1.121-.05 4.899 4.899 0 0 0-.807-2.53Z"
  }))),
  verifiedBlue: t => e.createElement("svg", uz({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 23 22"
  }, t), sz || (sz = e.createElement("path", {
    fill: "#1E56E3",
    d: "M9.014 1.915a3.832 3.832 0 0 1-2.18.904 3.832 3.832 0 0 0-3.515 3.515 3.832 3.832 0 0 1-.904 2.18 3.832 3.832 0 0 0 0 4.972c.523.613.84 1.376.904 2.18a3.832 3.832 0 0 0 3.515 3.515c.804.064 1.567.38 2.18.904a3.832 3.832 0 0 0 4.972 0 3.832 3.832 0 0 1 2.18-.904 3.832 3.832 0 0 0 3.515-3.515c.064-.804.38-1.567.904-2.18a3.832 3.832 0 0 0 0-4.972 3.832 3.832 0 0 1-.904-2.18 3.832 3.832 0 0 0-3.515-3.515 3.832 3.832 0 0 1-2.18-.904 3.832 3.832 0 0 0-4.972 0Z"
  })), cz || (cz = e.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m8.5 11 2 2L15 8.5M6.834 2.819a3.832 3.832 0 0 0 2.18-.904 3.832 3.832 0 0 1 4.972 0c.613.523 1.376.84 2.18.904a3.832 3.832 0 0 1 3.515 3.515c.064.804.38 1.567.904 2.18a3.832 3.832 0 0 1 0 4.972 3.832 3.832 0 0 0-.904 2.18 3.832 3.832 0 0 1-3.515 3.515 3.832 3.832 0 0 0-2.18.904 3.832 3.832 0 0 1-4.972 0 3.832 3.832 0 0 0-2.18-.904 3.832 3.832 0 0 1-3.515-3.515 3.832 3.832 0 0 0-.904-2.18 3.832 3.832 0 0 1 0-4.972c.523-.613.84-1.376.904-2.18a3.832 3.832 0 0 1 3.515-3.515Z"
  }))),
  aibot: t => e.createElement("svg", lz({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20",
    width: "1em",
    height: "1em"
  }, t), oz || (oz = e.createElement("path", {
    d: "M.75 5A4.25 4.25 0 0 1 5 .75h10A4.25 4.25 0 0 1 19.25 5v10A4.25 4.25 0 0 1 15 19.25H5A4.25 4.25 0 0 1 .75 15V5Z"
  })), iz || (iz = e.createElement("path", {
    d: "M7 12a3 3 0 1 0 6 0M4.447 6.106A2 2 0 0 1 6.237 5h7.527a2 2 0 1 1 0 4H6.236a2 2 0 0 1-1.789-2.894ZM8 5v4M12 5v4"
  }))),
  facebookBlue: t => e.createElement("svg", rz({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, t), tz || (tz = e.createElement("path", {
    fill: "#1877F2",
    d: "M9.755 9.006H7.51V12h2.245v8.981h3.742V12h2.694l.3-2.994h-2.994V7.734c0-.674.15-.973.823-.973h2.17V3.02h-2.843c-2.695 0-3.892 1.197-3.892 3.443v2.544Z"
  }))),
  linkedinBlue: t => e.createElement("svg", az({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, t), nz || (nz = e.createElement("path", {
    fill: "#0A66C2",
    d: "M6.656 5.13a1.89 1.89 0 0 1-1.908 1.908A1.89 1.89 0 0 1 2.839 5.13 1.89 1.89 0 0 1 4.748 3.22 1.89 1.89 0 0 1 6.656 5.13Zm0 3.435H2.84v12.214h3.817V8.565Zm6.107 0H8.946v12.214h3.817v-6.412c0-3.588 4.58-3.894 4.58 0v6.412h3.817v-7.71c0-6.03-6.794-5.802-8.397-2.825v-1.68Z"
  }))),
  reddit: t => e.createElement("svg", T$({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, t), R$ || (R$ = e.createElement("path", {
    fill: "#FF4500",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z"
  })), A$ || (A$ = e.createElement("path", {
    fill: "#fff",
    d: "M18.667 12c0-.807-.655-1.462-1.462-1.462-.398 0-.749.152-1.006.41-.994-.714-2.374-1.182-3.895-1.24l.667-3.123 2.163.456a1.042 1.042 0 0 0 2.082-.047c0-.573-.468-1.04-1.04-1.04-.41 0-.76.233-.924.584l-2.422-.515a.291.291 0 0 0-.198.036.285.285 0 0 0-.117.163l-.737 3.486c-1.556.046-2.948.503-3.953 1.24a1.476 1.476 0 0 0-1.006-.41 1.463 1.463 0 0 0-.597 2.795c-.023.14-.035.293-.035.445 0 2.245 2.608 4.058 5.836 4.058 3.229 0 5.837-1.813 5.837-4.058 0-.152-.012-.293-.035-.433.48-.234.842-.748.842-1.345Zm-10 1.041c0-.573.468-1.041 1.04-1.041.574 0 1.041.468 1.041 1.041s-.467 1.04-1.04 1.04-1.041-.467-1.041-1.04Zm5.813 2.748c-.714.714-2.07.76-2.468.76-.398 0-1.766-.058-2.468-.76a.275.275 0 0 1 0-.386.275.275 0 0 1 .386 0c.444.445 1.403.609 2.093.609s1.638-.164 2.094-.609a.275.275 0 0 1 .386 0 .3.3 0 0 1-.024.386Zm-.188-1.707c-.573 0-1.04-.468-1.04-1.041S13.719 12 14.291 12c.574 0 1.041.468 1.041 1.041s-.467 1.04-1.04 1.04Z"
  }))),
  github: t => e.createElement("svg", L$({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, t), H$ || (H$ = e.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12 1C5.925 1 1 5.932 1 12.019c0 4.867 3.152 8.998 7.523 10.454.55.101.75-.239.75-.531 0-.26-.009-.955-.014-1.873-3.06.665-3.706-1.478-3.706-1.478-.5-1.274-1.221-1.612-1.221-1.612-.999-.682.076-.67.076-.67 1.103.078 1.684 1.136 1.684 1.136.981 1.683 2.575 1.197 3.2.915.102-.712.386-1.197.7-1.472-2.442-.278-5.01-1.224-5.01-5.446 0-1.202.429-2.187 1.132-2.957-.113-.278-.49-1.399.108-2.914 0 0 .924-.297 3.025 1.128A10.52 10.52 0 0 1 12 6.33c.935.004 1.876.126 2.754.37 2.1-1.425 3.022-1.13 3.022-1.13.6 1.517.222 2.638.11 2.917.704.77 1.13 1.754 1.13 2.956 0 4.233-2.572 5.165-5.022 5.438.395.34.746 1.012.746 2.04 0 1.472-.013 2.661-.013 3.022 0 .295.198.638.757.53A11.021 11.021 0 0 0 23 12.019C23 5.932 18.074 1 12 1Z",
    clipRule: "evenodd"
  }))),
  apple: t => e.createElement("svg", F$({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, t), I$ || (I$ = e.createElement("path", {
    fill: "#000",
    d: "M20.843 17.145a11.957 11.957 0 0 1-1.183 2.127c-.622.886-1.131 1.5-1.524 1.841-.608.56-1.26.846-1.958.862-.501 0-1.106-.142-1.809-.432-.706-.287-1.354-.43-1.947-.43-.622 0-1.29.143-2.003.43-.714.29-1.29.44-1.73.455-.67.029-1.337-.266-2.003-.885-.425-.37-.956-1.006-1.593-1.907-.683-.961-1.245-2.076-1.685-3.347-.472-1.373-.708-2.703-.708-3.99 0-1.474.319-2.746.957-3.811A5.612 5.612 0 0 1 5.66 6.03a5.39 5.39 0 0 1 2.71-.764c.53 0 1.228.164 2.095.487.863.325 1.418.489 1.661.489.182 0 .799-.192 1.843-.576.988-.355 1.822-.502 2.505-.444 1.85.149 3.241.879 4.166 2.193-1.655 1.003-2.474 2.408-2.458 4.21.015 1.404.524 2.572 1.525 3.5.454.43.96.763 1.524 1-.122.354-.251.693-.388 1.019ZM16.598.44c0 1.1-.402 2.128-1.204 3.079-.966 1.13-2.136 1.783-3.404 1.68a3.417 3.417 0 0 1-.026-.417c0-1.056.46-2.186 1.277-3.11A4.914 4.914 0 0 1 14.796.504C15.423.198 16.015.03 16.573 0c.017.147.023.294.023.44Z"
  }))),
  google: t => e.createElement("svg", U$({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, t), _$ || (_$ = e.createElement("path", {
    fill: "#4285F4",
    d: "M22.76 11.833c0-.72-.058-1.443-.183-2.152H12.59v4.078h5.72a4.9 4.9 0 0 1-2.117 3.218v2.646h3.413c2.003-1.845 3.155-4.568 3.155-7.79Z"
  })), Z$ || (Z$ = e.createElement("path", {
    fill: "#34A853",
    d: "M12.59 22.179c2.855 0 5.264-.938 7.018-2.556l-3.412-2.646c-.95.646-2.175 1.011-3.603 1.011-2.763 0-5.105-1.863-5.945-4.369H3.126v2.727a10.59 10.59 0 0 0 9.463 5.833Z"
  })), D$ || (D$ = e.createElement("path", {
    fill: "#FBBC04",
    d: "M6.644 13.619a6.343 6.343 0 0 1 0-4.054V6.837H3.126a10.598 10.598 0 0 0 0 9.51l3.518-2.728Z"
  })), q$ || (q$ = e.createElement("path", {
    fill: "#EA4335",
    d: "M12.59 5.191A5.754 5.754 0 0 1 16.65 6.78l3.023-3.024a10.177 10.177 0 0 0-7.085-2.754 10.587 10.587 0 0 0-9.463 5.836l3.518 2.728c.836-2.51 3.183-4.374 5.945-4.374Z"
  }))),
  linkedin: t => e.createElement("svg", z$({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, t), $$ || ($$ = e.createElement("path", {
    fill: "#0A66C2",
    d: "M20.524 2H3.476A1.476 1.476 0 0 0 2 3.476v17.048A1.476 1.476 0 0 0 3.476 22h17.048A1.476 1.476 0 0 0 22 20.524V3.476A1.476 1.476 0 0 0 20.524 2ZM7.96 19.038H4.954V9.486h3.007v9.552ZM6.456 8.162a1.726 1.726 0 1 1 1.736-1.725 1.702 1.702 0 0 1-1.736 1.725Zm12.588 10.884H16.04v-5.218c0-1.54-.654-2.014-1.499-2.014-.891 0-1.766.672-1.766 2.053v5.179H9.767V9.493h2.891v1.324h.04c.29-.588 1.306-1.592 2.858-1.592 1.677 0 3.49.996 3.49 3.912l-.002 5.909Z"
  }))),
  instagram: t => e.createElement("svg", G$({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, t), W$ || (W$ = e.createElement("path", {
    fill: "#000100",
    d: "M11.999 3.797c2.673 0 2.99.012 4.04.058.978.043 1.505.208 1.857.344.465.18.801.399 1.149.747.351.352.566.684.746 1.149.137.351.301.883.344 1.856.047 1.055.059 1.372.059 4.04 0 2.674-.012 2.99-.059 4.042-.043.977-.207 1.504-.344 1.856-.18.465-.398.801-.746 1.149a3.078 3.078 0 0 1-1.15.746c-.35.137-.882.301-1.855.344-1.055.047-1.372.059-4.041.059-2.673 0-2.99-.012-4.041-.059-.977-.043-1.505-.207-1.856-.344a3.094 3.094 0 0 1-1.15-.746 3.077 3.077 0 0 1-.746-1.15c-.136-.35-.3-.882-.343-1.855-.047-1.056-.06-1.372-.06-4.041 0-2.673.013-2.99.06-4.041.043-.977.207-1.505.343-1.856.18-.465.399-.801.747-1.15A3.077 3.077 0 0 1 6.102 4.2c.351-.136.883-.3 1.856-.344 1.051-.046 1.368-.058 4.04-.058Zm0-1.802c-2.716 0-3.056.012-4.123.059-1.063.047-1.794.219-2.427.465-.66.258-1.22.598-1.774 1.157a4.902 4.902 0 0 0-1.157 1.77c-.246.637-.418 1.364-.465 2.427-.047 1.07-.058 1.41-.058 4.127 0 2.716.011 3.056.058 4.122.047 1.063.219 1.794.465 2.427.258.66.598 1.22 1.157 1.774a4.89 4.89 0 0 0 1.77 1.153c.637.247 1.364.419 2.427.465 1.067.047 1.407.059 4.123.059s3.056-.012 4.123-.059c1.063-.046 1.794-.218 2.427-.465a4.89 4.89 0 0 0 1.77-1.152 4.89 4.89 0 0 0 1.153-1.77c.246-.638.418-1.365.465-2.428.047-1.067.058-1.407.058-4.123s-.011-3.055-.058-4.122c-.047-1.063-.22-1.794-.465-2.427a4.685 4.685 0 0 0-1.145-1.778 4.89 4.89 0 0 0-1.77-1.153c-.638-.246-1.364-.418-2.427-.465-1.071-.051-1.411-.063-4.127-.063Z"
  })), Q$ || (Q$ = e.createElement("path", {
    fill: "#000100",
    d: "M11.999 6.86A5.14 5.14 0 0 0 6.859 12 5.14 5.14 0 0 0 12 17.139a5.14 5.14 0 0 0 0-10.278Zm0 8.473a3.334 3.334 0 1 1 0-6.668 3.334 3.334 0 0 1 0 6.668ZM18.54 6.657a1.2 1.2 0 1 1-2.4 0 1.2 1.2 0 0 1 2.4 0Z"
  }))),
  twitter: t => e.createElement("svg", K$({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, t), Y$ || (Y$ = e.createElement("path", {
    fill: "#1DA1F2",
    d: "M7.919 20.876c8.302 0 12.842-6.878 12.842-12.843 0-.195 0-.39-.013-.583A9.183 9.183 0 0 0 23 5.114a8.996 8.996 0 0 1-2.593.71 4.528 4.528 0 0 0 1.985-2.497 9.043 9.043 0 0 1-2.866 1.096 4.518 4.518 0 0 0-7.692 4.116A12.816 12.816 0 0 1 2.53 3.823 4.517 4.517 0 0 0 3.93 9.85a4.474 4.474 0 0 1-2.049-.565v.057a4.515 4.515 0 0 0 3.621 4.425 4.507 4.507 0 0 1-2.038.077 4.52 4.52 0 0 0 4.217 3.135A9.055 9.055 0 0 1 1 18.848a12.78 12.78 0 0 0 6.919 2.025"
  }))),
  youtubecolored: t => e.createElement("svg", ez({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, t), X$ || (X$ = e.createElement("path", {
    fill: "#FF0302",
    d: "M22.54 6.42a2.765 2.765 0 0 0-1.945-1.957C18.875 4 12 4 12 4s-6.875 0-8.595.463A2.765 2.765 0 0 0 1.46 6.42C1 8.148 1 11.75 1 11.75s0 3.602.46 5.33a2.765 2.765 0 0 0 1.945 1.958C5.125 19.5 12 19.5 12 19.5s6.875 0 8.595-.462a2.765 2.765 0 0 0 1.945-1.958c.46-1.727.46-5.33.46-5.33s0-3.602-.46-5.33Z"
  })), J$ || (J$ = e.createElement("path", {
    fill: "#FEFEFE",
    d: "M9.75 15.021V8.48l5.75 3.271-5.75 3.271Z"
  }))),
  facebookGray: t => e.createElement("svg", k$({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 9 19"
  }, t), M$ || (M$ = e.createElement("path", {
    fill: "#9DA4AE",
    d: "M2.255 6.506H.01V9.5h2.245v8.981h3.742V9.5H8.69l.3-2.994H5.996V5.234c0-.674.15-.973.823-.973h2.17V.52H6.147c-2.695 0-3.892 1.197-3.892 3.443v2.544Z"
  }))),
  twitterGray: t => e.createElement("svg", N$({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 23 19"
  }, t), S$ || (S$ = e.createElement("path", {
    fill: "#9DA4AE",
    d: "M7.506 18.248c8.125 0 12.568-6.73 12.568-12.567 0-.192-.004-.382-.013-.571a8.99 8.99 0 0 0 2.204-2.287 8.811 8.811 0 0 1-2.537.695 4.433 4.433 0 0 0 1.942-2.444 8.854 8.854 0 0 1-2.804 1.072 4.418 4.418 0 0 0-7.528 4.028A12.54 12.54 0 0 1 2.234 1.56 4.414 4.414 0 0 0 3.6 7.457a4.385 4.385 0 0 1-2-.553c-.002.019-.002.037-.002.056a4.419 4.419 0 0 0 3.544 4.33 4.422 4.422 0 0 1-1.995.077 4.422 4.422 0 0 0 4.127 3.067 8.863 8.863 0 0 1-5.486 1.891c-.356 0-.708-.02-1.054-.06a12.505 12.505 0 0 0 6.771 1.983Z"
  }))),
  linkedinGray: t => e.createElement("svg", V$({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 19 19"
  }, t), B$ || (B$ = e.createElement("path", {
    fill: "#9DA4AE",
    d: "M4.156 2.63a1.89 1.89 0 0 1-1.908 1.908A1.89 1.89 0 0 1 .339 2.63 1.89 1.89 0 0 1 2.248.72 1.89 1.89 0 0 1 4.156 2.63Zm0 3.435H.34v12.214h3.817V6.065Zm6.107 0H6.446v12.214h3.817v-6.412c0-3.588 4.58-3.894 4.58 0v6.412h3.817v-7.71c0-6.03-6.794-5.802-8.397-2.825v-1.68Z"
  }))),
  discord: t => e.createElement("svg", x$({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    width: "1em",
    height: "1em"
  }, t), y$ || (y$ = e.createElement("path", {
    d: "M15.785 4.38a13.89 13.89 0 0 0-3.438-1.047 9.32 9.32 0 0 0-.44.886 12.938 12.938 0 0 0-3.817 0 9.35 9.35 0 0 0-.44-.886c-1.189.2-2.345.554-3.441 1.05-2.177 3.186-2.766 6.292-2.471 9.355 1.274.932 2.7 1.64 4.217 2.095.341-.454.643-.936.903-1.441a9.011 9.011 0 0 1-1.422-.672c.119-.086.236-.174.348-.26a9.993 9.993 0 0 0 8.432 0c.114.093.23.181.349.26-.455.265-.931.49-1.425.673.259.505.561.986.903 1.44a13.856 13.856 0 0 0 4.22-2.094c.346-3.551-.592-6.63-2.478-9.359Zm-8.554 7.475c-.821 0-1.5-.738-1.5-1.646 0-.909.655-1.653 1.498-1.653s1.517.744 1.502 1.653c-.014.908-.662 1.646-1.5 1.646Zm5.538 0c-.824 0-1.5-.738-1.5-1.646 0-.909.655-1.653 1.5-1.653.844 0 1.512.744 1.498 1.653-.014.908-.66 1.646-1.498 1.646Z"
  }))),
  meetup: t => e.createElement("svg", P$({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    width: "1em",
    height: "1em"
  }, t), j$ || (j$ = e.createElement("path", {
    d: "M13.808 16.383a.791.791 0 1 0 .899 1.303.791.791 0 0 0-.899-1.303Zm-4.624 1.383a.488.488 0 1 0 .555.804.488.488 0 0 0-.555-.804Zm-5.617-2.27a.351.351 0 1 0 .687-.148.351.351 0 0 0-.688.148m-1.353-5.438a.756.756 0 1 0-1.245-.856.756.756 0 0 0 1.245.856m2.585-4.876a.574.574 0 1 0-.653-.945.574.574 0 0 0 .653.945ZM6.51 1.66a.402.402 0 1 0-.785.17.402.402 0 0 0 .785-.17Zm5.125.531a.75.75 0 1 0-1.286.772.75.75 0 0 0 1.286-.772Zm3.683 5.362a3.355 3.355 0 0 0-.587-2.172 3.378 3.378 0 0 0-3.929-1.253 3.813 3.813 0 0 0-4.23.062 3.804 3.804 0 0 0-1.398 1.784c-.385.052-.764.18-1.106.417a2.552 2.552 0 0 0-.71 3.45 2.747 2.747 0 0 0-.457 3.516 2.726 2.726 0 0 0 1.864 1.209c.014.553.18 1.11.518 1.599a2.95 2.95 0 0 0 4.102.75c.052-.036.091-.081.14-.119a2.206 2.206 0 0 0 2.727.182c.459-.317.752-.778.88-1.279a3.203 3.203 0 0 0 1.954-.558 3.233 3.233 0 0 0 .9-4.379c.734-.619.892-1.702.328-2.502a1.853 1.853 0 0 0-.996-.707m1.616-.46a.639.639 0 1 0-.725-1.05.639.639 0 0 0 .725 1.05Zm1.238 3.739a.476.476 0 1 0-.93.2.476.476 0 0 0 .93-.2Zm.805-2.292a.353.353 0 1 0-.691.15.353.353 0 0 0 .692-.15"
  })), C$ || (C$ = e.createElement("path", {
    fill: "#fff",
    d: "M13.604 13.26c-.11-.697-1.401-.159-1.48-.923-.114-1.085 1.499-3.421 1.372-4.328-.114-.817-.665-.988-1.144-.996-.465-.009-.588.065-.745.157-.091.052-.221.157-.402-.015-.12-.115-.2-.195-.327-.296a.68.68 0 0 0-.341-.143c-.174-.025-.397 0-.54.061-.143.061-.254.168-.372.27-.117.101-.413.434-.69.311-.12-.053-.527-.256-.82-.383-.566-.245-1.383.152-1.677.675-.438.777-1.302 3.832-1.433 4.236-.293.904.372 1.642 1.269 1.6.38-.019.632-.157.871-.593.139-.252 1.44-3.648 1.536-3.811.07-.118.304-.274.503-.172.198.101.238.314.209.514-.048.323-.965 2.395-1 2.63-.06.398.13.62.543.641.284.015.566-.087.79-.51.126-.236 1.573-3.133 1.701-3.326.14-.212.254-.282.397-.275.111.006.29.034.245.368-.044.326-1.207 2.451-1.329 2.972-.163.696.219 1.4.848 1.709.401.196 2.157.533 2.016-.372"
  }))),
  octoface: t => e.createElement("svg", E$({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    width: "1em",
    height: "1em"
  }, t), O$ || (O$ = e.createElement("path", {
    fillRule: "evenodd",
    d: "M17.328 7.09c.142-.35.602-1.738-.142-3.62 0 0-1.148-.36-3.763 1.422-1.093-.306-2.264-.35-3.423-.35-1.16 0-2.33.044-3.423.35C3.962 3.1 2.814 3.47 2.814 3.47c-.744 1.882-.284 3.27-.142 3.62-.886.952-1.422 2.177-1.422 3.665 0 5.633 3.642 6.901 8.728 6.901s8.772-1.268 8.772-6.901c0-1.488-.536-2.713-1.422-3.664ZM10 16.585c-3.61 0-6.54-.164-6.54-3.664 0-.83.415-1.618 1.115-2.264 1.17-1.072 3.172-.503 5.425-.503 2.264 0 4.244-.569 5.425.503.71.646 1.116 1.422 1.116 2.264 0 3.49-2.932 3.664-6.541 3.664Zm-2.745-5.48c-.722 0-1.313.876-1.313 1.948s.59 1.957 1.313 1.957c.722 0 1.312-.875 1.312-1.957 0-1.083-.59-1.947-1.312-1.947Zm5.49 0c-.722 0-1.312.865-1.312 1.948 0 1.082.59 1.957 1.312 1.957.722 0 1.313-.875 1.313-1.957 0-1.083-.58-1.947-1.313-1.947Z",
    clipRule: "evenodd"
  }))),
  graphQL: t => e.createElement("svg", w$({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), g$ || (g$ = e.createElement("path", {
    fill: "#1F2A37",
    fillRule: "evenodd",
    d: "m12 1.657 8.957 5.172v10.343l-8.958 5.172-8.957-5.172V6.83l8.957-5.172ZM4.046 7.41v7.598l6.58-11.397-6.58 3.8Zm7.952-4.166L4.415 16.379h15.17L11.998 3.244Zm6.58 14.141H5.42l6.58 3.8 6.58-3.8Zm1.373-2.377L13.372 3.61l6.58 3.8v7.597Z",
    clipRule: "evenodd"
  })), b$ || (b$ = e.createElement("path", {
    fill: "#1F2A37",
    d: "M12 4.354A2.117 2.117 0 1 0 12 .12a2.117 2.117 0 0 0 0 4.234ZM20.455 9.236a2.117 2.117 0 1 0 0-4.234 2.117 2.117 0 0 0 0 4.234ZM20.455 18.998a2.117 2.117 0 1 0 0-4.233 2.117 2.117 0 0 0 0 4.233ZM12 23.88a2.117 2.117 0 1 0 0-4.233 2.117 2.117 0 0 0 0 4.233ZM3.544 18.998a2.117 2.117 0 1 0 0-4.233 2.117 2.117 0 0 0 0 4.233ZM3.544 9.236a2.117 2.117 0 1 0 0-4.234 2.117 2.117 0 0 0 0 4.234Z"
  }))),
  caching: t => e.createElement("svg", WU({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), zU || (zU = e.createElement("path", {
    d: "M20 10.5V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 2 16.88 2 15.2 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22H12m2-11H8m2 4H8m8-8H8M17.889 14l-2.39 3.088c-.16.207-.24.311-.24.398a.25.25 0 0 0 .095.194c.069.053.2.053.461.053h3.348c.268 0 .402 0 .47.055a.25.25 0 0 1 .094.196c0 .088-.085.192-.253.4L16.556 22"
  }))),
  doubleArrow: t => e.createElement("svg", GU({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 18",
    width: "1em",
    height: "1em"
  }, t), QU || (QU = e.createElement("path", {
    d: "M15 1v16m0 0-4-4m4 4 4-4M5 17V1m0 0L1 5m4-4 4 4"
  }))),
  endpoint: t => e.createElement("svg", KU({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), YU || (YU = e.createElement("path", {
    d: "M9.75 2.25h-.053c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311c-.327.642-.327 1.482-.327 3.162v.6c0 .97 0 1.454-.137 1.892a3 3 0 0 1-.583 1.054c-.298.348-.709.606-1.53 1.12l-.397.25.397.248c.821.515 1.232.773 1.53 1.121a3 3 0 0 1 .583 1.054c.137.438.137.922.137 1.892v.669c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311c.642.327 1.482.327 3.162.327h.053M15 2.25c1.274 0 1.91 0 2.419.19A3 3 0 0 1 19.177 4.2c.19.508.19 1.145.19 2.419V7.8c0 .917 0 1.376.125 1.794a3 3 0 0 0 .531 1.017c.272.34.648.603 1.401 1.127l.326.227-.326.228c-.753.524-1.129.786-1.401 1.127-.24.302-.421.647-.531 1.017-.124.418-.124.877-.124 1.794v1.251c0 1.274 0 1.91-.19 2.42a3 3 0 0 1-1.759 1.758c-.509.19-1.145.19-2.419.19"
  }))),
  mutation: t => e.createElement("svg", e$({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), XU || (XU = e.createElement("path", {
    d: "M9 13.447c0-.49 0-.734.055-.964.05-.204.13-.4.24-.578.123-.202.296-.375.642-.72L19.5 1.62a2.121 2.121 0 0 1 3 3l-9.563 9.563c-.346.346-.519.519-.72.643-.18.11-.374.19-.579.24-.23.054-.474.054-.963.054H9v-1.674Z"
  })), JU || (JU = e.createElement("path", {
    d: "M20.574 12.072a9.192 9.192 0 1 1-9.289-8.273"
  }))),
  networking: t => e.createElement("svg", n$({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), t$ || (t$ = e.createElement("path", {
    d: "M15 16.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C15.76 15 16.04 15 16.6 15h2.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C21 15.76 21 16.04 21 16.6v2.8c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437C20.24 21 19.96 21 19.4 21h-2.8c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C15 20.24 15 19.96 15 19.4v-2.8ZM3 16.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C3.76 15 4.04 15 4.6 15h2.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C9 15.76 9 16.04 9 16.6v2.8c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437C8.24 21 7.96 21 7.4 21H4.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C3 20.24 3 19.96 3 19.4v-2.8ZM6 15l5.823-6M18 15l-5.823-6"
  })), r$ || (r$ = e.createElement("rect", {
    width: 6,
    height: 6,
    x: 9,
    y: 3,
    rx: 1
  }))),
  queries: t => e.createElement("svg", o$({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), a$ || (a$ = e.createElement("path", {
    stroke: "#1F2A37",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3m.08 4h.01M3 7.942v8.117c0 .342 0 .514.05.666a1 1 0 0 0 .215.364c.109.119.258.202.558.368l7.4 4.111c.284.158.425.237.575.268.133.027.27.027.403 0 .15-.031.292-.11.576-.268l7.4-4.11c.3-.167.45-.25.558-.369a.999.999 0 0 0 .215-.364c.05-.152.05-.324.05-.666V7.942c0-.343 0-.514-.05-.667a1 1 0 0 0-.215-.364c-.109-.119-.258-.202-.558-.368l-7.4-4.111c-.284-.158-.425-.237-.575-.267a1 1 0 0 0-.403 0c-.15.03-.292.11-.576.267l-7.4 4.11c-.3.167-.45.25-.558.369a1 1 0 0 0-.215.364C3 7.428 3 7.599 3 7.942Z"
  }))),
  remote: t => e.createElement("svg", l$({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), i$ || (i$ = e.createElement("path", {
    d: "M5 9v5.6c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C8.04 21 9.16 21 11.4 21h1.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C19 17.96 19 16.84 19 14.6V9M3 8h18M8 3v5M16 3v5"
  }))),
  trigger: t => e.createElement("svg", h$({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), s$ || (s$ = e.createElement("path", {
    d: "M8 19h3a1 1 0 0 0 1-1V6a1 1 0 0 1 1-1h3"
  })), c$ || (c$ = e.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    transform: "matrix(1 0 0 -1 2 22)"
  })), u$ || (u$ = e.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    transform: "matrix(1 0 0 -1 16 8)"
  }))),
  watchTrigger: t => e.createElement("svg", p$({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), m$ || (m$ = e.createElement("path", {
    d: "m14.5 19 2 2 4.5-4.5m.985-3.95c.01-.182.015-.366.015-.55 0-5.523-4.477-10-10-10S2 6.477 2 12c0 5.435 4.337 9.858 9.739 9.997M12 6v6l3.738 1.87"
  }))),
  hasura1: t => e.createElement("svg", ge({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 21 21",
    width: "1em",
    height: "1em"
  }, t), ve || (ve = e.createElement("path", {
    fill: "#80A3FF",
    fillRule: "evenodd",
    d: "M5.043 3.012a9.22 9.22 0 0 1 4.994-1.468h.21a9.14 9.14 0 0 1 4.995 1.468c.448.286 1.039.19 1.363-.22L17.787.954a.54.54 0 0 1 .4-.238.478.478 0 0 1 .42.19c.953 1.392 1.22 4.547.696 6.168a3.547 3.547 0 0 0-.134 1.754c.115.581.22 1.277.22 1.763 0 5.004-4.09 9.055-9.142 9.055h-.21c-5.051 0-9.14-4.05-9.14-9.055 0-.486.114-1.182.219-1.763a3.661 3.661 0 0 0-.134-1.754C.458 5.453.734 2.297 1.678.906c.086-.143.257-.2.42-.191.161.019.314.105.4.238l1.182 1.84c.333.41.915.505 1.363.22Zm6.065 11.26V7H9.29L7.5 8.094V9.77l1.59-.952h.044v5.455h1.974Z",
    clipRule: "evenodd"
  }))),
  hasura2: t => e.createElement("svg", we({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 21 21",
    width: "1em",
    height: "1em"
  }, t), be || (be = e.createElement("path", {
    fill: "#80A3FF",
    fillRule: "evenodd",
    d: "M5.043 3.012a9.22 9.22 0 0 1 4.994-1.468h.21a9.14 9.14 0 0 1 4.995 1.468c.448.286 1.039.19 1.363-.22L17.787.954a.54.54 0 0 1 .4-.238.478.478 0 0 1 .42.19c.953 1.392 1.22 4.547.696 6.168a3.547 3.547 0 0 0-.134 1.754c.115.581.22 1.277.22 1.763 0 5.004-4.09 9.055-9.142 9.055h-.21c-5.051 0-9.14-4.05-9.14-9.055 0-.486.114-1.182.219-1.763a3.661 3.661 0 0 0-.134-1.754C.458 5.453.734 2.297 1.678.906c.086-.143.257-.2.42-.191.161.019.314.105.4.238l1.182 1.84c.333.41.915.505 1.363.22Zm2.099 9.94v1.42h5.582v-1.576h-2.84v-.043l.681-.568c.554-.462.982-.86 1.282-1.194.301-.333.51-.637.625-.912.116-.277.174-.555.174-.835 0-.452-.117-.846-.351-1.182-.232-.336-.563-.597-.991-.781-.426-.187-.93-.281-1.513-.281-.563 0-1.054.1-1.474.298a2.251 2.251 0 0 0-.973.853C7.114 8.52 7 8.96 7 9.47h1.875c0-.203.038-.376.114-.518a.765.765 0 0 1 .32-.323c.139-.073.3-.11.482-.11s.343.037.483.11c.14.071.249.173.327.305.08.133.12.293.12.48 0 .17-.035.325-.106.465-.069.14-.168.276-.298.408-.128.13-.282.27-.462.42l-2.713 2.244Z",
    clipRule: "evenodd"
  }))),
  hasura3: t => e.createElement("svg", xe({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 21 21",
    width: "1em",
    height: "1em"
  }, t), ye || (ye = e.createElement("path", {
    fill: "#80A3FF",
    fillRule: "evenodd",
    d: "M5.043 3.012a9.22 9.22 0 0 1 4.994-1.468h.21a9.14 9.14 0 0 1 4.995 1.468c.448.286 1.039.19 1.363-.22L17.787.954a.54.54 0 0 1 .4-.238.478.478 0 0 1 .42.19c.953 1.392 1.22 4.547.696 6.168a3.547 3.547 0 0 0-.134 1.754c.115.581.22 1.277.22 1.763 0 5.004-4.09 9.055-9.142 9.055h-.21c-5.051 0-9.14-4.05-9.14-9.055 0-.486.114-1.182.219-1.763a3.661 3.661 0 0 0-.134-1.754C.458 5.453.734 2.297 1.678.906c.086-.143.257-.2.42-.191.161.019.314.105.4.238l1.182 1.84c.333.41.915.505 1.363.22Zm3.385 11.165c.445.196.954.295 1.527.295.594 0 1.118-.094 1.573-.28.457-.188.813-.446 1.069-.775.258-.33.386-.707.383-1.133.005-.445-.14-.814-.437-1.108-.296-.296-.737-.476-1.324-.54v-.056c.433-.048.79-.202 1.072-.462.284-.26.424-.594.42-1.002a1.768 1.768 0 0 0-.349-1.09c-.232-.32-.555-.57-.97-.753C10.982 7.091 10.507 7 9.97 7c-.55 0-1.036.097-1.46.291a2.459 2.459 0 0 0-1.001.803c-.242.34-.364.734-.366 1.179h1.89a.679.679 0 0 1 .124-.39.805.805 0 0 1 .33-.267c.142-.064.303-.096.483-.096a.98.98 0 0 1 .437.092.718.718 0 0 1 .298.256.652.652 0 0 1 .103.376.616.616 0 0 1-.125.39.813.813 0 0 1-.351.267c-.15.064-.322.096-.518.096h-.74v1.364h.74c.213 0 .4.032.564.096a.88.88 0 0 1 .38.266.586.586 0 0 1 .135.39.675.675 0 0 1-.114.398.793.793 0 0 1-.326.274c-.14.064-.301.096-.483.096-.19 0-.358-.031-.505-.093a.847.847 0 0 1-.348-.255.633.633 0 0 1-.127-.377H7c.002.452.13.852.384 1.2a2.55 2.55 0 0 0 1.044.82Z",
    clipRule: "evenodd"
  }))),
  hasuraPrimary: t => e.createElement("svg", Ce({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 105 33"
  }, t), Oe || (Oe = e.createElement("path", {
    fill: "#3970FD",
    d: "M30.232 11.397c.912-2.87.363-8.597-1.405-10.71a.53.53 0 0 0-.856.068l-2.178 3.453a1.665 1.665 0 0 1-2.239.368 14.85 14.85 0 0 0-8.22-2.47 14.85 14.85 0 0 0-8.222 2.47 1.67 1.67 0 0 1-2.238-.368L2.695.755A.532.532 0 0 0 1.84.686C.07 2.804-.478 8.53.435 11.396c.303.955.385 1.963.207 2.943-.178.972-.357 2.146-.357 2.964C.285 25.697 7.023 32.5 15.33 32.5c8.31 0 15.044-6.806 15.044-15.197 0-.818-.178-1.992-.356-2.964a6.155 6.155 0 0 1 .214-2.942ZM15.33 29.107c-6.424 0-11.647-5.279-11.647-11.768a11.774 11.774 0 0 1 6.67-10.63 11.43 11.43 0 0 1 4.98-1.132c1.783 0 3.47.403 4.98 1.134a11.779 11.779 0 0 1 6.671 10.631c-.004 6.486-5.23 11.766-11.654 11.766Z"
  })), Ee || (Ee = e.createElement("path", {
    fill: "#3970FD",
    d: "M20.377 21.87 17.4 16.653l-2.552-4.346a.333.333 0 0 0-.29-.166H12.12a.338.338 0 0 0-.289.511l2.443 4.146-3.277 5.049a.343.343 0 0 0-.014.345.334.334 0 0 0 .296.177h2.456a.331.331 0 0 0 .282-.155l1.772-2.795 1.59 2.784c.06.104.17.17.288.17h2.421a.327.327 0 0 0 .289-.17c.06-.1.06-.23 0-.335Z"
  })), je || (je = e.createElement("path", {
    fill: "#000",
    d: "M43.293 8.5h3.111v17.063h-3.111v-7.27h-3.515v7.274h-3.111V8.5h3.111v7.41h3.515V8.5ZM56.002 25.567l-.65-3.544h-3.733l-.596 3.544H47.91l3.433-17.064h4.19l3.597 17.064H56Zm-3.976-5.899h2.893l-1.485-8.167-1.408 8.167ZM66.06 22.455v-3.651c0-.29-.053-.483-.16-.583-.107-.1-.307-.15-.597-.15h-2.19c-1.857 0-2.785-.9-2.785-2.705V11.18c0-1.786.971-2.676 2.918-2.676h2.975c1.947 0 2.919.894 2.919 2.676v2.38h-3.136v-1.947c0-.29-.054-.483-.161-.583-.107-.1-.308-.15-.597-.15h-1.028c-.308 0-.515.05-.622.15-.107.1-.16.293-.16.583v3.433c0 .29.053.482.16.582.107.1.314.15.622.15h2.135c1.894 0 2.84.883 2.84 2.651v4.463c0 1.786-.982 2.676-2.947 2.676h-2.921c-1.965 0-2.947-.894-2.947-2.676v-2.355h3.107v1.919c0 .29.054.482.161.582.107.1.314.15.621.15h1.03c.288 0 .485-.05.596-.15.11-.1.168-.293.168-.582ZM77.494 8.5h3.108v14.387c0 1.787-.982 2.676-2.947 2.676h-3.297c-1.964 0-2.947-.893-2.947-2.676V8.5h3.111v13.955c0 .29.054.482.161.582.107.1.307.15.597.15h1.432c.307 0 .514-.05.622-.15.107-.1.16-.293.16-.582V8.5ZM86.282 18.914v6.653h-3.108V8.5h6.272c1.965 0 2.947.893 2.947 2.676v5.059c0 1.479-.657 2.343-1.975 2.597l2.84 6.735h-3.354l-2.597-6.653h-1.025Zm0-8.035v5.735h2.243c.29 0 .486-.05.596-.15.108-.1.161-.293.161-.583v-4.27c0-.289-.053-.482-.16-.582-.108-.1-.308-.15-.597-.15h-2.243ZM101.801 25.567l-.65-3.544h-3.732l-.597 3.544h-3.107l3.432-17.064h4.19l3.597 17.064h-3.133Zm-3.972-5.899h2.894l-1.486-8.167-1.407 8.167Z"
  }))),
  hasura: t => e.createElement("svg", $U({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, t), qU || (qU = e.createElement("g", {
    clipPath: "url(#hasura_svg__a)"
  }, e.createElement("path", {
    d: "M12.033 3.544a9.22 9.22 0 0 0-4.995 1.468c-.448.286-1.03.19-1.363-.22L4.493 2.954a.553.553 0 0 0-.4-.238c-.162-.01-.334.048-.42.19-.943 1.392-1.22 4.547-.695 6.168.18.572.238 1.172.133 1.754-.105.581-.22 1.277-.22 1.763 0 5.004 4.09 9.055 9.142 9.055h.21c5.052 0 9.141-4.05 9.141-9.055 0-.486-.105-1.182-.22-1.763a3.547 3.547 0 0 1 .134-1.754c.525-1.62.258-4.776-.696-6.167a.478.478 0 0 0-.419-.191.54.54 0 0 0-.4.238L18.6 4.793c-.324.41-.915.505-1.363.22a9.14 9.14 0 0 0-4.995-1.469h-.22.01Z"
  }), e.createElement("path", {
    d: "m14.044 15.03-3.05-4.766 1.525 2.383-2.287 2.383"
  }))), UU || (UU = e.createElement("defs", null, e.createElement("clipPath", {
    id: "hasura_svg__a"
  }, e.createElement("path", {
    fill: "#fff",
    d: "M1.996 2H22.28v20.37H1.996z"
  }))))),
  minus01: t => e.createElement("svg", DU({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ZU || (ZU = e.createElement("path", {
    d: "M7 12h10"
  }))),
  clockrewind: t => e.createElement("svg", Me({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Pe || (Pe = e.createElement("path", {
    d: "m22.7 13.5-2-2-2 2M21 12a9 9 0 1 1-1.245-4.57M12 7v5l3 2"
  }))),
  passport: t => e.createElement("svg", Se({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ke || (ke = e.createElement("path", {
    d: "M10 16h4m-5.2 6h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 19.72 20 18.88 20 17.2V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 2 16.88 2 15.2 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22ZM15 9a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
  }))),
  compass02: t => e.createElement("svg", Be({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Ne || (Ne = e.createElement("path", {
    d: "M22 12h-2m2 0c0 5.523-4.477 10-10 10m10-10c0-5.523-4.477-10-10-10m7.071 17.071-1.414-1.414M4 12H2m0 0c0 5.523 4.477 10 10 10M2 12C2 6.477 6.477 2 12 2M6.343 6.343 4.93 4.93M12 4V2m5.657 4.343L19.07 4.93M12 22v-2m-7.071-.929 1.414-1.414M12 8l4 4-4 4-4-4 4-4Z"
  }))),
  arrowsquareup: t => e.createElement("svg", Re({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Ve || (Ve = e.createElement("path", {
    d: "m16 12-4-4m0 0-4 4m4-4v8m-4.2 5h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Z"
  }))),
  heartcircle: t => e.createElement("svg", He({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Ae || (Ae = e.createElement("path", {
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z"
  })), Te || (Te = e.createElement("path", {
    d: "M11.997 9.068c-1-1.169-2.667-1.483-3.92-.413-1.252 1.07-1.429 2.86-.445 4.125.63.81 2.244 2.314 3.322 3.29.359.325.538.487.753.552.184.056.395.056.58 0 .214-.065.393-.227.752-.552 1.079-.976 2.692-2.48 3.322-3.29.984-1.265.829-3.066-.445-4.125-1.274-1.059-2.92-.756-3.92.413Z",
    clipRule: "evenodd"
  }))),
  refreshcw05: t => e.createElement("svg", Ie({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Le || (Le = e.createElement("path", {
    d: "M20.453 12.893A8.5 8.5 0 0 1 4.638 16.25l-.25-.433m-.842-4.71A8.5 8.5 0 0 1 19.361 7.75l.25.433M3.493 18.066l.732-2.732 2.732.732m10.085-8.132 2.732.732.732-2.732"
  }))),
  shoppingbag01: t => e.createElement("svg", _e({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Fe || (Fe = e.createElement("path", {
    d: "M5.52 2.64 3.96 4.72c-.309.412-.463.618-.46.79a.5.5 0 0 0 .192.384C3.828 6 4.085 6 4.6 6h14.8c.515 0 .773 0 .908-.106a.5.5 0 0 0 .192-.384c.003-.172-.151-.378-.46-.79l-1.56-2.08m-12.96 0c.176-.235.264-.352.376-.437a1 1 0 0 1 .33-.165C6.36 2 6.505 2 6.8 2h10.4c.293 0 .44 0 .575.038a1 1 0 0 1 .33.165c.111.085.199.202.375.437m-12.96 0L3.64 5.147c-.237.316-.356.475-.44.649a2 2 0 0 0-.163.487C3 6.473 3 6.671 3 7.067V18.8c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C4.52 22 5.08 22 6.2 22h11.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C21 20.48 21 19.92 21 18.8V7.067c0-.396 0-.594-.037-.784a1.998 1.998 0 0 0-.163-.487c-.084-.174-.203-.333-.44-.65L18.48 2.64M16 10a4 4 0 1 1-8 0"
  }))),
  messagequestioncircle: t => e.createElement("svg", De({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Ze || (Ze = e.createElement("path", {
    d: "M10.5 9.002a2.248 2.248 0 0 1 4.369.75C14.869 11.25 12.62 12 12.62 12m.028 3h.01m-.16 5a8.5 8.5 0 1 0-8.056-5.783c.108.32.162.481.172.604a.899.899 0 0 1-.028.326c-.03.12-.098.245-.232.494l-1.636 3.027c-.233.432-.35.648-.324.815a.5.5 0 0 0 .234.35c.144.087.388.062.876.011l5.121-.529c.155-.016.233-.024.303-.021.07.002.12.009.187.024.069.016.155.05.329.116A8.478 8.478 0 0 0 12.5 20Z"
  }))),
  qrcode01: t => e.createElement("svg", Ue({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), qe || (qe = e.createElement("path", {
    d: "M7 12h5v5m-8.99-5H3m5.01 5H8m4.01 4H12m9.01-9H21M3 17h1.5m11-5h2M3 21h5m4-19v6m5.6 13h1.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C21 20.24 21 19.96 21 19.4v-1.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C20.24 16 19.96 16 19.4 16h-1.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C16 16.76 16 17.04 16 17.6v1.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C16.76 21 17.04 21 17.6 21Zm0-13h1.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C21 7.24 21 6.96 21 6.4V4.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C20.24 3 19.96 3 19.4 3h-1.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C16 3.76 16 4.04 16 4.6v1.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C16.76 8 17.04 8 17.6 8Zm-13 0h1.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C8 7.24 8 6.96 8 6.4V4.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C7.24 3 6.96 3 6.4 3H4.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 3.76 3 4.04 3 4.6v1.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C3.76 8 4.04 8 4.6 8Z"
  }))),
  triangle: t => e.createElement("svg", ze({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), $e || ($e = e.createElement("path", {
    d: "m2.39 18.098 8.225-14.206c.455-.785.682-1.178.979-1.31a1 1 0 0 1 .812 0c.297.132.524.525.978 1.31l8.225 14.206c.456.788.685 1.182.65 1.506a1 1 0 0 1-.406.705c-.263.191-.718.191-1.628.191H3.775c-.91 0-1.366 0-1.629-.191a1 1 0 0 1-.406-.705c-.034-.324.194-.718.65-1.506Z"
  }))),
  creditcarddown: t => e.createElement("svg", Qe({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), We || (We = e.createElement("path", {
    d: "m16 18 3 3m0 0 3-3m-3 3v-6m3-5H2m20 2V8.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 5 19.92 5 18.8 5H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 6.52 2 7.08 2 8.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 19 4.08 19 5.2 19H12"
  }))),
  wallet03: t => e.createElement("svg", Ye({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Ge || (Ge = e.createElement("path", {
    d: "M16.5 14h.01M3 5v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2H5a2 2 0 0 1-2-2Zm0 0a2 2 0 0 1 2-2h12m0 11a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
  }))),
  hand: t => e.createElement("svg", Xe({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Ke || (Ke = e.createElement("path", {
    d: "M6.9 11.444v2.778m0-2.778V4.778c0-.92.761-1.667 1.7-1.667s1.7.746 1.7 1.667m-3.4 6.666c0-.92-.761-1.666-1.7-1.666s-1.7.746-1.7 1.666v2.223C3.5 18.269 7.306 22 12 22s8.5-3.731 8.5-8.333V8.11c0-.92-.761-1.667-1.7-1.667s-1.7.747-1.7 1.667m-6.8-3.333v6.11m0-6.11V3.667C10.3 2.747 11.061 2 12 2s1.7.746 1.7 1.667v1.11m0 0v6.112m0-6.111c0-.92.761-1.667 1.7-1.667s1.7.746 1.7 1.667V8.11m0 0v2.778"
  }))),
  clockfastforward: t => e.createElement("svg", et({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Je || (Je = e.createElement("path", {
    d: "m22.7 11.5-2 2-2-2m2.245 1.5A9 9 0 1 0 19 17.657M12 7v5l3 2"
  }))),
  facecontent: t => e.createElement("svg", rt({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), tt || (tt = e.createElement("path", {
    d: "M8 14s1.5 2 4 2 4-2 4-2m1-4.76c-.395.485-.935.76-1.5.76s-1.09-.275-1.5-.76m-4 0c-.395.485-.935.76-1.5.76S7.41 9.725 7 9.24M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }))),
  refreshccw02: t => e.createElement("svg", at({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), nt || (nt = e.createElement("path", {
    d: "M2 10s.121-.85 3.636-4.364A9 9 0 0 1 20.776 10M2 10V4m0 6h6m14 4s-.121.85-3.636 4.364A9 9 0 0 1 3.224 14M22 14v6m0-6h-6"
  }))),
  imageuser: t => e.createElement("svg", it({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ot || (ot = e.createElement("path", {
    d: "M4 21.817C4.603 22 5.416 22 6.8 22h10.4c1.384 0 2.197 0 2.8-.183m-16 0a2.18 2.18 0 0 1-.362-.144 3 3 0 0 1-1.311-1.311C2 19.72 2 18.88 2 17.2V6.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C4.28 2 5.12 2 6.8 2h10.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C22 4.28 22 5.12 22 6.8v10.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311 2.18 2.18 0 0 1-.362.144m-16 0c0-.809.005-1.237.077-1.597a4 4 0 0 1 3.143-3.143C7.606 17 8.07 17 9 17h6c.93 0 1.394 0 1.78.077a4 4 0 0 1 3.143 3.143c.072.36.077.788.077 1.597M16 9.5a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
  }))),
  currencybitcoin: t => e.createElement("svg", st({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), lt || (lt = e.createElement("path", {
    d: "M9.5 2v2m0 16v2m4-20v2m0 16v2m-6-18H14a4 4 0 0 1 0 8H7.5 15a4 4 0 0 1 0 8H7.5m0-16h-2m2 0v16m0 0h-2"
  }))),
  linechartup04: t => e.createElement("svg", ut({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ct || (ct = e.createElement("path", {
    d: "m21 9-6.448 4.606c-.197.14-.294.21-.4.231a.5.5 0 0 1-.276-.023c-.1-.038-.185-.123-.355-.293l-3.042-3.042c-.17-.17-.255-.255-.355-.293a.5.5 0 0 0-.277-.023c-.105.021-.203.091-.398.23L3 15m4.8 6h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Z"
  }))),
  cameraplus: t => e.createElement("svg", mt({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ht || (ht = e.createElement("path", {
    d: "M22 11.5v3.1c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C18.96 21 17.84 21 15.6 21H8.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C2 17.96 2 16.84 2 14.6V9.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C5.04 3 6.16 3 8.4 3h4.1M19 8V2m-3 3h6m-6 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
  }))),
  usersplus: t => e.createElement("svg", ft({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), pt || (pt = e.createElement("path", {
    d: "M19 21v-6m-3 3h6m-10-3H8c-1.864 0-2.796 0-3.53.305a4 4 0 0 0-2.166 2.164C2 18.204 2 19.136 2 21M15.5 3.29a4.001 4.001 0 0 1 0 7.42M13.5 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
  }))),
  clipboardattachment: t => e.createElement("svg", vt({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), dt || (dt = e.createElement("path", {
    d: "M16 4c.93 0 1.395 0 1.776.102a3 3 0 0 1 2.122 2.122C20 6.605 20 7.07 20 8v9.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C17.72 22 16.88 22 15.2 22H8.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.72 4 18.88 4 17.2V8c0-.93 0-1.395.102-1.776a3 3 0 0 1 2.122-2.122C6.605 4 7.07 4 8 4m4 11.5V11a1.5 1.5 0 0 1 3 0v4.5a3 3 0 1 1-6 0v-4M9.6 6h4.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C16 5.24 16 4.96 16 4.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C15.24 2 14.96 2 14.4 2H9.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C8 2.76 8 3.04 8 3.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C8.76 6 9.04 6 9.6 6Z"
  }))),
  clipboardplus: t => e.createElement("svg", bt({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), gt || (gt = e.createElement("path", {
    d: "M16 4c.93 0 1.395 0 1.776.102a3 3 0 0 1 2.122 2.122C20 6.605 20 7.07 20 8v9.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C17.72 22 16.88 22 15.2 22H8.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.72 4 18.88 4 17.2V8c0-.93 0-1.395.102-1.776a3 3 0 0 1 2.122-2.122C6.605 4 7.07 4 8 4m4 13v-6m-3 3h6M9.6 6h4.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C16 5.24 16 4.96 16 4.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C15.24 2 14.96 2 14.4 2H9.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C8 2.76 8 3.04 8 3.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C8.76 6 9.04 6 9.6 6Z"
  }))),
  user02: t => e.createElement("svg", yt({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), wt || (wt = e.createElement("path", {
    d: "M12 15c-3.17 0-5.99 1.53-7.784 3.906-.386.511-.58.767-.573 1.112.005.267.172.604.382.769.272.213.649.213 1.402.213h13.146c.753 0 1.13 0 1.401-.213.21-.165.378-.502.383-.769.006-.345-.187-.6-.573-1.112C17.989 16.531 15.17 15 12 15ZM12 12a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Z"
  }))),
  eraser: t => e.createElement("svg", Ot({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), xt || (xt = e.createElement("path", {
    d: "m18 13-7-7m10 15H8m2.937-.937 8.668-8.669c1.189-1.188 1.782-1.782 2.005-2.467a3.001 3.001 0 0 0 0-1.854c-.223-.685-.816-1.279-2.005-2.467l-.211-.212c-1.188-1.188-1.782-1.782-2.467-2.004a3 3 0 0 0-1.854 0c-.686.222-1.28.816-2.468 2.004l-8.211 8.212c-1.188 1.188-1.782 1.782-2.005 2.467a3 3 0 0 0 0 1.854c.223.685.817 1.28 2.005 2.467l.668.669c.346.346.52.519.721.642.179.11.374.19.578.24.23.055.475.055.964.055h1.35c.488 0 .733 0 .963-.055.204-.05.4-.13.578-.24.202-.123.375-.296.72-.642Z"
  }))),
  logout01: t => e.createElement("svg", jt({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Et || (Et = e.createElement("path", {
    d: "m16 17 5-5m0 0-5-5m5 5H9m0-9H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21H9"
  }))),
  receipt: t => e.createElement("svg", Pt({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Ct || (Ct = e.createElement("path", {
    d: "M4 7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C6.28 3 7.12 3 8.8 3h6.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C20 5.28 20 6.12 20 7.8V21l-2.75-2-2.5 2L12 19l-2.75 2-2.5-2L4 21V7.8Z"
  }))),
  pausecircle: t => e.createElement("svg", kt({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Mt || (Mt = e.createElement("path", {
    d: "M9.5 15V9m5 6V9m7.5 3c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }))),
  checksquare: t => e.createElement("svg", Nt({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), St || (St = e.createElement("path", {
    d: "m7.5 12 3 3 6-6M7.8 21h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Z"
  }))),
  arrowdown: t => e.createElement("svg", Vt({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Bt || (Bt = e.createElement("path", {
    d: "M12 5v14m0 0 7-7m-7 7-7-7"
  }))),
  linkexternal02: t => e.createElement("svg", At({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Rt || (Rt = e.createElement("path", {
    d: "M21 9V3m0 0h-6m6 0-9 9m-2-9H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V14"
  }))),
  figma: t => e.createElement("svg", Ht({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Tt || (Tt = e.createElement("path", {
    d: "M12 1.5H8.5a3.5 3.5 0 1 0 0 7m3.5-7v7m0-7h3.5a3.5 3.5 0 1 1 0 7m-3.5 0H8.5m3.5 0v7m0-7h3.5m-7 0a3.5 3.5 0 1 0 0 7m3.5 0H8.5m3.5 0V19a3.5 3.5 0 1 1-3.5-3.5m7-7a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7Z"
  }))),
  cornerrightup: t => e.createElement("svg", It({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Lt || (Lt = e.createElement("path", {
    d: "M3 20h3.4c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C16 15.44 16 13.76 16 10.4V4m0 0-5 5m5-5 5 5"
  }))),
  columns01: t => e.createElement("svg", _t({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Ft || (Ft = e.createElement("path", {
    d: "M6.8 3h-.6c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C3 4.52 3 5.08 3 6.2v11.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C4.52 21 5.08 21 6.2 21h.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C10 19.48 10 18.92 10 17.8V6.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C8.48 3 7.92 3 6.8 3ZM17.8 3h-.6c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C14 4.52 14 5.08 14 6.2v11.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C15.52 21 16.08 21 17.2 21h.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C21 19.48 21 18.92 21 17.8V6.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C19.48 3 18.92 3 17.8 3Z"
  }))),
  helpoctagon: t => e.createElement("svg", Dt({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Zt || (Zt = e.createElement("path", {
    d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3m.08 4h.01M3 7.941v8.117c0 .343 0 .515.05.667a1 1 0 0 0 .215.364c.109.119.258.202.558.368l7.4 4.111c.284.158.425.237.575.267.133.028.27.028.403 0 .15-.03.292-.11.576-.267l7.4-4.11c.3-.167.45-.25.558-.369a1 1 0 0 0 .215-.364c.05-.152.05-.324.05-.667V7.941c0-.342 0-.514-.05-.666a1 1 0 0 0-.215-.364c-.109-.119-.258-.202-.558-.368l-7.4-4.111c-.284-.158-.425-.237-.575-.268a1 1 0 0 0-.403 0c-.15.031-.292.11-.576.268l-7.4 4.11c-.3.167-.45.25-.558.369a1 1 0 0 0-.215.364C3 7.427 3 7.599 3 7.94Z"
  }))),
  speedometer04: t => e.createElement("svg", Ut({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), qt || (qt = e.createElement("path", {
    d: "M17.745 16a7.026 7.026 0 0 0 1.094-5.5M6.255 16a7 7 0 0 1 6.982-10.891M16.5 7.5 12 12m10 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-9 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
  }))),
  leftindent01: t => e.createElement("svg", zt({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), $t || ($t = e.createElement("path", {
    d: "M21 9.25h-9M21 4H3m18 10.75h-9M21 20H3M4.28 8.56l3.867 2.9c.29.217.434.326.486.459a.5.5 0 0 1 0 .362c-.052.133-.197.242-.486.459l-3.867 2.9c-.412.309-.618.463-.79.46a.5.5 0 0 1-.384-.192C3 15.773 3 15.515 3 15V9.2c0-.515 0-.772.106-.908A.5.5 0 0 1 3.49 8.1c.172-.003.378.151.79.46Z"
  }))),
  chevronselectorhorizontal: t => e.createElement("svg", Qt({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Wt || (Wt = e.createElement("path", {
    d: "m9 7-5 5 5 5m6-10 5 5-5 5"
  }))),
  list: t => e.createElement("svg", Yt({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Gt || (Gt = e.createElement("path", {
    d: "M21 12H9m12-6H9m12 12H9m-4-6a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm0-6a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm0 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
  }))),
  database03: t => e.createElement("svg", Xt({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Kt || (Kt = e.createElement("path", {
    d: "M14 20a2 2 0 1 1-4 0m4 0a2 2 0 0 0-2-2m2 2h7m-11 0a2 2 0 0 1 2-2m-2 2H3m9-2v-4m9-9c0 1.657-4.03 3-9 3S3 6.657 3 5m18 0c0-1.657-4.03-3-9-3S3 3.343 3 5m18 0v6c0 1.66-4 3-9 3M3 5v6c0 1.66 4 3 9 3"
  }))),
  film01: t => e.createElement("svg", er({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Jt || (Jt = e.createElement("path", {
    d: "M2 12h20M2 7h5m10 0h5M2 17h5m10 0h5M7 22V2m10 20V2M6.8 22h10.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 19.72 22 18.88 22 17.2V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C19.72 2 18.88 2 17.2 2H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 4.28 2 5.12 2 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 22 5.12 22 6.8 22Z"
  }))),
  messagexcircle: t => e.createElement("svg", rr({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), tr || (tr = e.createElement("path", {
    d: "m10 9 5 5m0-5-5 5m2.5 6a8.5 8.5 0 1 0-8.057-5.783c.108.32.162.481.172.604a.899.899 0 0 1-.028.326c-.03.12-.098.245-.232.494l-1.636 3.027c-.233.432-.35.648-.324.815a.5.5 0 0 0 .234.35c.144.087.388.062.876.011l5.121-.529c.155-.016.233-.024.303-.021.07.002.12.009.187.024.069.016.155.05.329.116A8.478 8.478 0 0 0 12.5 20Z"
  }))),
  calendarcheck01: t => e.createElement("svg", ar({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), nr || (nr = e.createElement("path", {
    d: "M21 10H3m13-8v4M8 2v4m1 10 2 2 4.5-4.5M7.8 22h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 19.72 21 18.88 21 17.2V8.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 4 17.88 4 16.2 4H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 6.28 3 7.12 3 8.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 22 6.12 22 7.8 22Z"
  }))),
  hurricane02: t => e.createElement("svg", ir({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), or || (or = e.createElement("path", {
    d: "M18 12a6 6 0 0 1-12 0m12 0a6 6 0 0 0-12 0m12 0a8 8 0 1 1-16 0m4 0a8 8 0 1 1 16 0m-9 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
  }))),
  toggle02right: t => e.createElement("svg", sr({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), lr || (lr = e.createElement("path", {
    d: "M14 16H6a4 4 0 0 1 0-8h8m8 4a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z"
  }))),
  infosquare: t => e.createElement("svg", ur({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), cr || (cr = e.createElement("path", {
    d: "M12 16v-4m0-4h.01M7.8 21h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Z"
  }))),
  hurricane03: t => e.createElement("svg", mr({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), hr || (hr = e.createElement("path", {
    d: "M21 4H3m17 4H6m12 4H9m6 4H8m9 4h-5"
  }))),
  thermometercold: t => e.createElement("svg", fr({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), pr || (pr = e.createElement("path", {
    d: "M2 12h10M9 4v16M3 9l3 3-3 3m9-9L9 9 6 6m0 12 3-3 1.5 1.5m9.5-1.965V4a2 2 0 1 0-4 0v10.535a4 4 0 1 0 4 0Z"
  }))),
  building08: t => e.createElement("svg", vr({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), dr || (dr = e.createElement("path", {
    d: "M3 21h18M6 18v-8m4 8v-8m4 8v-8m4 8v-8m2-3-7.576-4.735c-.154-.096-.23-.144-.313-.163a.5.5 0 0 0-.222 0c-.082.019-.16.067-.313.163L4 7h16Z"
  }))),
  database02: t => e.createElement("svg", br({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), gr || (gr = e.createElement("path", {
    d: "M21 5c0 1.657-4.03 3-9 3S3 6.657 3 5m18 0c0-1.657-4.03-3-9-3S3 3.343 3 5m18 0v14c0 1.66-4 3-9 3s-9-1.34-9-3V5m18 4.72c0 1.66-4 3-9 3s-9-1.34-9-3m18 4.72c0 1.66-4 3-9 3s-9-1.34-9-3"
  }))),
  gitbranch02: t => e.createElement("svg", yr({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), wr || (wr = e.createElement("path", {
    d: "M6 3v12m0 0a3 3 0 1 0 3 3m-3-3a3 3 0 0 1 3 3m9-9a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0 0a9 9 0 0 1-9 9"
  }))),
  usersx: t => e.createElement("svg", Or({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), xr || (xr = e.createElement("path", {
    d: "m16.5 16 5 5m0-5-5 5m-1-17.71a4.001 4.001 0 0 1 0 7.42M12 15H8c-1.864 0-2.796 0-3.53.305a4 4 0 0 0-2.166 2.164C2 18.204 2 19.136 2 21M13.5 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
  }))),
  calendarheart01: t => e.createElement("svg", jr({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Er || (Er = e.createElement("path", {
    d: "M21 8H3m13-6v3M8 2v3m-.2 17h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 19.72 21 18.88 21 17.2V8.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 4 17.88 4 16.2 4H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 6.28 3 7.12 3 8.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 22 6.12 22 7.8 22Zm4.197-9.67c-.8-.908-2.133-1.153-3.135-.32-1.002.832-1.143 2.223-.356 3.208.571.715 2.153 2.122 2.977 2.839.179.155.268.233.373.264.09.027.192.027.283 0 .104-.03.194-.109.372-.264.824-.717 2.407-2.124 2.978-2.84a2.256 2.256 0 0 0-.356-3.208c-1.02-.823-2.336-.587-3.136.322Z"
  }))),
  googlechrome: t => e.createElement("svg", Pr({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Cr || (Cr = e.createElement("path", {
    d: "M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm0 0h9.17M3.95 6.06 8.54 14m2.34 7.94L15.46 14M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }))),
  dotshorizontal: t => e.createElement("svg", kr({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Mr || (Mr = e.createElement("path", {
    d: "M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM19 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM5 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
  }))),
  virus: t => e.createElement("svg", Nr({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Sr || (Sr = e.createElement("path", {
    d: "M12 2v5m0-5c-.713 0-1.41.075-2.08.217M12 2c.713 0 1.41.075 2.08.217M12 7a5 5 0 0 0-5 5m5-5a5 5 0 0 1 5 5m-5 5v5m0-5a5 5 0 0 0 5-5m-5 5a5 5 0 0 1-5-5m5 10c.712 0 1.407-.075 2.077-.216M12 22c-.715 0-1.412-.075-2.085-.218M4.93 4.93l3.535 3.535m7.072 7.072 3.535 3.535M2 12h5m-5 0c0 .713.075 1.41.217 2.08M2 12c0-.714.075-1.411.217-2.083M17 12h5m0 0c0-.713-.075-1.41-.217-2.08M22 12c0 .713-.075 1.409-.216 2.08M4.928 19.07l3.535-3.536m7.072-7.07 3.535-3.536m-1.624-1.317a10.053 10.053 0 0 1 2.942 2.943m-.003 10.895a10.053 10.053 0 0 1-2.941 2.94m-10.891-.002a10.055 10.055 0 0 1-2.94-2.937M3.613 6.554a10.054 10.054 0 0 1 2.94-2.942"
  }))),
  chartbreakoutcircle: t => e.createElement("svg", Vr({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Br || (Br = e.createElement("path", {
    d: "M15.5 3.5V2m3.94 2.56L20.5 3.5m.01 5h1.5m-.06 4.5c-.501 5.053-4.765 9-9.95 9-5.523 0-10-4.477-10-10 0-5.185 3.947-9.449 9-9.95M12 8h4v4m-.38-4A12.984 12.984 0 0 1 5 13.5c-1.003 0-1.98-.114-2.917-.329"
  }))),
  alerthexagon: t => e.createElement("svg", Ar({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Rr || (Rr = e.createElement("path", {
    d: "M12 8v4m0 4h.01M3 7.942v8.117c0 .342 0 .514.05.666a1 1 0 0 0 .215.364c.109.119.258.202.558.368l7.4 4.111c.284.158.425.237.575.268.133.027.27.027.403 0 .15-.031.292-.11.576-.268l7.4-4.11c.3-.167.45-.25.558-.369a.999.999 0 0 0 .215-.364c.05-.152.05-.324.05-.666V7.942c0-.343 0-.514-.05-.667a1 1 0 0 0-.215-.364c-.109-.119-.258-.202-.558-.368l-7.4-4.111c-.284-.158-.425-.237-.575-.267a1 1 0 0 0-.403 0c-.15.03-.292.11-.576.267l-7.4 4.11c-.3.167-.45.25-.558.369a1 1 0 0 0-.215.364C3 7.428 3 7.599 3 7.942Z"
  }))),
  bluetoothoff: t => e.createElement("svg", Hr({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Tr || (Tr = e.createElement("path", {
    d: "m6 17 6-5v10l5.44-4.533M12 7V2l6 5-2.918 2.432M21 21 3 3"
  }))),
  colors1: t => e.createElement("svg", Ir({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Lr || (Lr = e.createElement("path", {
    d: "M12 20.472a6 6 0 1 0 5.58-10.262m-11.16 0a6 6 0 1 0 7.16 3.58M18 8A6 6 0 1 1 6 8a6 6 0 0 1 12 0Z"
  }))),
  usersminus: t => e.createElement("svg", _r({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Fr || (Fr = e.createElement("path", {
    d: "M16 18h6M15.5 3.29a4.001 4.001 0 0 1 0 7.42M12 15H8c-1.864 0-2.796 0-3.53.305a4 4 0 0 0-2.166 2.164C2 18.204 2 19.136 2 21M13.5 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
  }))),
  modem01: t => e.createElement("svg", Dr({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Zr || (Zr = e.createElement("path", {
    d: "M16.243 4.757a6 6 0 0 1 0 8.486m-8.485 0a6 6 0 0 1 0-8.486M4.858 16c-3.834-3.91-3.81-10.19.07-14.071m14.143 0c3.882 3.882 3.906 10.16.07 14.071m-7.14 0V9M5 22h14c.931 0 1.397 0 1.765-.152a2 2 0 0 0 1.082-1.083C22 20.398 22 19.932 22 19c0-.932 0-1.398-.152-1.765a2 2 0 0 0-1.082-1.083C20.398 16 19.932 16 19 16H5c-.932 0-1.398 0-1.765.152a2 2 0 0 0-1.083 1.083C2 17.602 2 18.068 2 19c0 .932 0 1.398.152 1.765a2 2 0 0 0 1.083 1.083C3.602 22 4.068 22 5 22Z"
  }))),
  alignleft01: t => e.createElement("svg", Ur({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), qr || (qr = e.createElement("path", {
    d: "M3 3v18m18-9H7m0 0 7 7m-7-7 7-7"
  }))),
  scales01: t => e.createElement("svg", zr({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), $r || ($r = e.createElement("path", {
    d: "M2 17v-.15c0-.317 0-.475.024-.63a2 2 0 0 1 .107-.4c.055-.146.134-.283.29-.558L6 9m-4 8a4 4 0 0 0 8 0m-8 0v-.2c0-.28 0-.42.054-.527a.5.5 0 0 1 .219-.218C2.38 16 2.52 16 2.8 16h6.4c.28 0 .42 0 .527.055a.5.5 0 0 1 .218.218c.055.107.055.247.055.527v.2M6 9l3.578 6.262c.157.275.236.412.291.558a2 2 0 0 1 .107.4c.024.155.024.313.024.63V17M6 9l12-2m-4 8v-.15c0-.317 0-.475.024-.63.022-.136.057-.27.107-.4.055-.146.134-.283.29-.558L18 7m-4 8a4 4 0 0 0 8 0m-8 0v-.2c0-.28 0-.42.055-.527a.5.5 0 0 1 .218-.218C14.38 14 14.52 14 14.8 14h6.4c.28 0 .42 0 .527.055a.5.5 0 0 1 .218.218c.055.107.055.247.055.527v.2m-4-8 3.578 6.262c.157.275.236.412.291.558.05.13.085.264.107.4.024.155.024.313.024.63V15M12 3v5"
  }))),
  user03: t => e.createElement("svg", Qr({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Wr || (Wr = e.createElement("path", {
    d: "M3 20c2.336-2.477 5.507-4 9-4 3.493 0 6.664 1.523 9 4M16.5 7.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Z"
  }))),
  cornerupright: t => e.createElement("svg", Yr({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Gr || (Gr = e.createElement("path", {
    d: "M4 20v-1.4c0-3.36 0-5.04.654-6.324a6 6 0 0 1 2.622-2.622C8.56 9 10.24 9 13.6 9H20m0 0-5 5m5-5-5-5"
  }))),
  clapperboard: t => e.createElement("svg", Xr({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Kr || (Kr = e.createElement("path", {
    d: "M9 3 8 8m8-5-1 5m7 0H2m4.8 13h10.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 18.72 22 17.88 22 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C19.72 3 18.88 3 17.2 3H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 5.28 2 6.12 2 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 21 5.12 21 6.8 21Z"
  }))),
  subscript: t => e.createElement("svg", en({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Jr || (Jr = e.createElement("path", {
    d: "m3 5 10 10m0-10L3 15m18 4h-4c0-1.5.44-2 1.5-2.5S21 15.33 21 14c0-.47-.17-.93-.48-1.29a2.11 2.11 0 0 0-2.62-.44c-.42.24-.74.62-.9 1.07"
  }))),
  expand06: t => e.createElement("svg", rn({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), tn || (tn = e.createElement("path", {
    d: "m16 8 5-5m0 0h-5m5 0v5M8 8 3 3m0 0v5m0-5h5m0 13-5 5m0 0h5m-5 0v-5m13 0 5 5m0 0v-5m0 5h-5"
  }))),
  userminus01: t => e.createElement("svg", an({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), nn || (nn = e.createElement("path", {
    d: "M16 18h6m-10-2.5H7.5c-1.396 0-2.093 0-2.661.172a4 4 0 0 0-2.667 2.667C2 18.907 2 19.604 2 21M14.5 7.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Z"
  }))),
  linechartup05: t => e.createElement("svg", ln({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), on || (on = e.createElement("path", {
    d: "m18 10-3.434 3.434c-.198.198-.297.297-.412.334a.499.499 0 0 1-.309 0c-.114-.037-.213-.136-.41-.334l-2.87-2.868c-.197-.198-.296-.297-.41-.334a.499.499 0 0 0-.31 0c-.114.037-.213.136-.41.334L6 14m16-2c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }))),
  playcircle: t => e.createElement("svg", un({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), sn || (sn = e.createElement("path", {
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z"
  })), cn || (cn = e.createElement("path", {
    d: "M9.5 8.965c0-.477 0-.716.1-.849a.5.5 0 0 1 .364-.199c.166-.012.367.117.769.375l4.72 3.035c.349.224.523.336.583.478a.5.5 0 0 1 0 .39c-.06.142-.234.254-.583.478l-4.72 3.035c-.402.258-.603.387-.769.375a.5.5 0 0 1-.364-.2c-.1-.132-.1-.371-.1-.848v-6.07Z"
  }))),
  checkcirclebroken: t => e.createElement("svg", mn({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), hn || (hn = e.createElement("path", {
    d: "M22 11.086v.92a10 10 0 1 1-5.93-9.14M22 4 12 14.01l-3-3"
  }))),
  arrowsquareleft: t => e.createElement("svg", fn({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), pn || (pn = e.createElement("path", {
    d: "m12 8-4 4m0 0 4 4m-4-4h8m-8.2 9h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Z"
  }))),
  refreshccw03: t => e.createElement("svg", vn({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), dn || (dn = e.createElement("path", {
    d: "M14 2s.85.121 4.364 3.636A9 9 0 0 1 14 20.776M14 2h6m-6 0v6m-4 14s-.85-.122-4.364-3.636A9 9 0 0 1 10 3.224M10 22H4m6 0v-6"
  }))),
  arrowsdown: t => e.createElement("svg", bn({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), gn || (gn = e.createElement("path", {
    d: "M17 4v11m0 0-4-4m4 4 4-4M7 4v16m0 0-4-4m4 4 4-4"
  }))),
  wallet02: t => e.createElement("svg", yn({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), wn || (wn = e.createElement("path", {
    d: "M16 8V4.5c0-.831 0-1.247-.175-1.503a1 1 0 0 0-.657-.42c-.306-.052-.683.122-1.438.47L4.858 7.143c-.673.31-1.01.466-1.257.707a2 2 0 0 0-.486.76C3 8.936 3 9.307 3 10.048V15m13.5-.5h.01M3 11.2v6.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C4.52 21 5.08 21 6.2 21h11.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C21 19.48 21 18.92 21 17.8v-6.6c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C19.48 8 18.92 8 17.8 8H6.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C3 9.52 3 10.08 3 11.2Zm14 3.3a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
  }))),
  airplay: t => e.createElement("svg", On({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), xn || (xn = e.createElement("path", {
    d: "M5 18a3 3 0 0 1-3-3V7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C4.28 3 5.12 3 6.8 3h10.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C22 5.28 22 6.12 22 7.8V15a3 3 0 0 1-3 3M8.708 21h6.584c.545 0 .817 0 .955-.111a.5.5 0 0 0 .185-.396c-.002-.177-.177-.387-.525-.805l-3.292-3.95c-.212-.254-.317-.38-.443-.427a.5.5 0 0 0-.344 0c-.126.047-.231.173-.443.427l-3.292 3.95c-.348.418-.523.628-.525.805a.5.5 0 0 0 .185.396c.138.111.41.111.955.111Z"
  }))),
  refreshcw04: t => e.createElement("svg", jn({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), En || (En = e.createElement("path", {
    d: "M17 5.125A8.5 8.5 0 0 1 12 20.5h-.5M7 18.875A8.5 8.5 0 0 1 12 3.5h.5m.5 18.9-2-2 2-2M11 5.6l2-2-2-2"
  }))),
  announcement01: t => e.createElement("svg", Pn({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Cn || (Cn = e.createElement("path", {
    d: "M22 8v4M10.25 5.5H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.31C2 7.78 2 8.62 2 10.3v1.2c0 .932 0 1.398.152 1.765a2 2 0 0 0 1.083 1.083c.367.152.833.152 1.765.152v4.25c0 .232 0 .348.01.446a2 2 0 0 0 1.794 1.794c.098.01.214.01.446.01s.348 0 .446-.01a2 2 0 0 0 1.794-1.794c.01-.098.01-.214.01-.446V14.5h.75c1.766 0 3.927.947 5.594 1.856.973.53 1.46.795 1.778.756a.946.946 0 0 0 .691-.411c.187-.26.187-.783.187-1.827V5.126c0-1.044 0-1.566-.187-1.827a.946.946 0 0 0-.691-.411c-.319-.039-.805.226-1.778.756-1.667.909-3.828 1.856-5.594 1.856Z"
  }))),
  compass03: t => e.createElement("svg", Sn({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Mn || (Mn = e.createElement("path", {
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z"
  })), kn || (kn = e.createElement("path", {
    d: "M14.722 8.266c.489-.163.733-.244.895-.186a.5.5 0 0 1 .303.303c.058.162-.023.406-.186.895l-1.488 4.463c-.046.139-.07.208-.109.266a.5.5 0 0 1-.13.13c-.058.04-.127.063-.266.11l-4.463 1.487c-.489.163-.733.244-.895.186a.5.5 0 0 1-.303-.303c-.058-.162.023-.406.186-.895l1.488-4.463c.046-.139.07-.208.109-.266a.5.5 0 0 1 .13-.13c.058-.04.127-.063.266-.11l4.463-1.487Z"
  }))),
  compass01: t => e.createElement("svg", Bn({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Nn || (Nn = e.createElement("path", {
    d: "M22 12c0 5.523-4.477 10-10 10m10-10c0-5.523-4.477-10-10-10m10 10h-2m-8 10C6.477 22 2 17.523 2 12m10 10v-2M2 12C2 6.477 6.477 2 12 2M2 12h2m8-10v2m7.071 15.071-1.414-1.414M6.343 6.343 4.93 4.93m12.728 1.414L19.07 4.93M4.93 19.07l1.414-1.414M8 12l2.5-1.5L12 8l1.5 2.5L16 12l-2.5 1.5L12 16l-1.5-2.5L8 12Z"
  }))),
  cryptocurrency04: t => e.createElement("svg", Rn({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Vn || (Vn = e.createElement("path", {
    d: "m2 2 2 2m18-2-2 2m2 18-2-2M2 22l2-2m-2-4h1.5M8 2v1.5M22 8h-1.5M16 22v-1.5m2-4.5h3.5M16 2v4M2 8h4m2 14v-4m3.434-10.434-3.868 3.868c-.198.198-.297.297-.334.412a.5.5 0 0 0 0 .309c.037.114.136.213.334.41l3.868 3.87c.198.197.297.296.412.333.1.033.208.033.309 0 .114-.037.213-.136.41-.334l3.87-3.868c.197-.198.296-.297.333-.412a.499.499 0 0 0 0-.309c-.037-.114-.136-.213-.334-.41l-3.868-3.87c-.198-.197-.297-.296-.412-.333a.5.5 0 0 0-.309 0c-.114.037-.213.136-.41.334Z"
  }))),
  announcement03: t => e.createElement("svg", Tn({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), An || (An = e.createElement("path", {
    d: "M18.5 16c1.933 0 3.5-2.91 3.5-6.5S20.433 3 18.5 3m0 13c-1.933 0-3.5-2.91-3.5-6.5S16.567 3 18.5 3m0 13L5.444 13.626c-.928-.168-1.392-.253-1.767-.437a3 3 0 0 1-1.563-1.873C2 10.914 2 10.443 2 9.5c0-.943 0-1.414.114-1.816a3 3 0 0 1 1.563-1.873c.375-.184.839-.268 1.767-.437L18.5 3M5 14l.394 5.514c.037.524.056.785.17.984a1 1 0 0 0 .432.402c.206.1.469.1.994.1h1.782c.6 0 .9 0 1.123-.12a1 1 0 0 0 .44-.474c.101-.231.079-.53.032-1.129L10 14.5"
  }))),
  shoppingbag02: t => e.createElement("svg", Ln({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Hn || (Hn = e.createElement("path", {
    d: "M16 9V6a4 4 0 0 0-8 0v3m-4.408 1.352-.6 6.4c-.17 1.82-.256 2.73.046 3.432a3 3 0 0 0 1.32 1.45C5.03 22 5.944 22 7.771 22h8.458c1.828 0 2.742 0 3.413-.366a3 3 0 0 0 1.32-1.45c.302-.703.217-1.612.046-3.432l-.6-6.4c-.144-1.537-.216-2.305-.561-2.886a3 3 0 0 0-1.292-1.176C17.945 6 17.173 6 15.629 6H8.371c-1.543 0-2.315 0-2.925.29a3 3 0 0 0-1.292 1.176c-.346.581-.418 1.35-.562 2.886Z"
  }))),
  menu04: t => e.createElement("svg", Fn({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), In || (In = e.createElement("path", {
    d: "M3 12h18M3 6h18M9 18h12"
  }))),
  qrcode02: t => e.createElement("svg", Zn({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), _n || (_n = e.createElement("path", {
    d: "M6.5 6.5h.01m10.99 0h.01M6.5 17.5h.01M13 13h.01m4.49 4.5h.01M17 21h4v-4m-7-.5V21m7-7h-4.5m-.9-4h3.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C21 9.24 21 8.96 21 8.4V4.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C20.24 3 19.96 3 19.4 3h-3.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C14 3.76 14 4.04 14 4.6v3.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C14.76 10 15.04 10 15.6 10Zm-11 0h3.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C10 9.24 10 8.96 10 8.4V4.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C9.24 3 8.96 3 8.4 3H4.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 3.76 3 4.04 3 4.6v3.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C3.76 10 4.04 10 4.6 10Zm0 11h3.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C10 20.24 10 19.96 10 19.4v-3.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C9.24 14 8.96 14 8.4 14H4.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 14.76 3 15.04 3 15.6v3.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C3.76 21 4.04 21 4.6 21Z"
  }))),
  currencypound: t => e.createElement("svg", qn({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Dn || (Dn = e.createElement("path", {
    d: "M17.5 20.5h-11s3.5-2.759 3.5-7c0-2.828-2.086-3.839-2.116-6.195.002-4.664 5.617-4.416 7.568-2.562M6.5 13.5H15"
  }))),
  refreshccw01: t => e.createElement("svg", $n({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Un || (Un = e.createElement("path", {
    d: "M2 10s2.005-2.732 3.634-4.362A9 9 0 1 1 12 21a9.004 9.004 0 0 1-8.648-6.5M2 10V4m0 6h6"
  }))),
  barchart09: t => e.createElement("svg", Wn({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), zn || (zn = e.createElement("path", {
    d: "M21 21H6.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C3 19.48 3 18.92 3 17.8V3m4 2.5v12m4.5-9v9m4.5-6v6m4.5-3v3"
  }))),
  creditcardrefresh: t => e.createElement("svg", Gn({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Qn || (Qn = e.createElement("path", {
    d: "M22 10H2m9 9h7.8c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C22 17.48 22 16.92 22 15.8V8.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 5 19.92 5 18.8 5H17m-6 14 2 2m-2-2 2-2m-6 2H5.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C2 17.48 2 16.92 2 15.8V8.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C3.52 5 4.08 5 5.2 5H13m0 0-2 2m2-2-2-2"
  }))),
  dropper: t => e.createElement("svg", Kn({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Yn || (Yn = e.createElement("path", {
    d: "m10.5 6.5 7 7M2 22s4.5-.5 7-3L21 7a2.828 2.828 0 1 0-4-4L5 15c-2.5 2.5-3 7-3 7Z"
  }))),
  expand04: t => e.createElement("svg", Jn({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Xn || (Xn = e.createElement("path", {
    d: "M20 14v2.8c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C18.48 20 17.92 20 16.8 20H14M10 4H7.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C4 5.52 4 6.08 4 7.2V10m11-1 6-6m0 0h-6m6 0v6M9 15l-6 6m0 0h6m-6 0v-6"
  }))),
  logout02: t => e.createElement("svg", ta({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ea || (ea = e.createElement("path", {
    d: "m16 17 5-5m0 0-5-5m5 5H9m3 5c0 .93 0 1.395-.102 1.776a3 3 0 0 1-2.122 2.122C9.395 21 8.93 21 8 21h-.5c-1.398 0-2.097 0-2.648-.228a3 3 0 0 1-1.624-1.624C3 18.597 3 17.898 3 16.5v-9c0-1.398 0-2.097.228-2.648a3 3 0 0 1 1.624-1.624C5.403 3 6.102 3 7.5 3H8c.93 0 1.395 0 1.776.102a3 3 0 0 1 2.122 2.122C12 5.605 12 6.07 12 7"
  }))),
  user01: t => e.createElement("svg", na({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ra || (ra = e.createElement("path", {
    d: "M20 21c0-1.396 0-2.093-.172-2.661a4 4 0 0 0-2.667-2.667c-.568-.172-1.265-.172-2.661-.172h-5c-1.396 0-2.093 0-2.661.172a4 4 0 0 0-2.667 2.667C4 18.907 4 19.604 4 21M16.5 7.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Z"
  }))),
  settings04: t => e.createElement("svg", oa({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), aa || (aa = e.createElement("path", {
    d: "M3 8h12m0 0a3 3 0 1 0 6 0 3 3 0 0 0-6 0Zm-6 8h12M9 16a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
  }))),
  sunrise: t => e.createElement("svg", la({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ia || (ia = e.createElement("path", {
    d: "M4 18H2m4.314-5.686L4.9 10.9m12.786 1.414L19.1 10.9M22 18h-2M7 18a5 5 0 0 1 10 0m5 4H2M16 6l-4-4m0 0L8 6m4-4v7"
  }))),
  columns02: t => e.createElement("svg", ca({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), sa || (sa = e.createElement("path", {
    d: "M12 3v18M7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3Z"
  }))),
  linkexternal01: t => e.createElement("svg", ha({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ua || (ua = e.createElement("path", {
    d: "M21 9V3m0 0h-6m6 0-8 8m-3-6H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 7.28 3 8.12 3 9.8v6.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C19 18.72 19 17.88 19 16.2V14"
  }))),
  leftindent02: t => e.createElement("svg", pa({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ma || (ma = e.createElement("path", {
    d: "M21 9.25h-9M21 4h-9m9 10.75H3M21 20H3M4.28 2.96l3.867 2.9c.29.217.434.326.486.459a.5.5 0 0 1 0 .362c-.052.133-.197.242-.486.459l-3.867 2.9c-.412.309-.618.463-.79.46a.5.5 0 0 1-.384-.192C3 10.172 3 9.915 3 9.4V3.6c0-.515 0-.773.106-.908A.5.5 0 0 1 3.49 2.5c.172-.004.378.151.79.46Z"
  }))),
  searchsm: t => e.createElement("svg", da({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), fa || (fa = e.createElement("path", {
    d: "m21 21-6-6m2-5a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
  }))),
  griddotsblank: t => e.createElement("svg", ga({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), va || (va = e.createElement("path", {
    d: "M3 3h.01M3 12h.01M3 21h.01M3 16.5h.01M3 7.5h.01M7.5 3h.01m-.01 9h.01m-.01 9h.01M16.5 3h.01m-.01 9h.01m-.01 9h.01M12 3h.01M12 12h.01M12 21h.01M12 16.5h.01m-.01-9h.01M21 3h.01M21 12h.01M21 21h.01M21 16.5h.01m-.01-9h.01"
  }))),
  film02: t => e.createElement("svg", wa({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ba || (ba = e.createElement("path", {
    d: "M12 22V2M7 22v-5M7 7V2m10 20v-5m0-10V2M2 7h20M2 17h20m0 .2V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C19.72 2 18.88 2 17.2 2H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 4.28 2 5.12 2 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 22 5.12 22 6.8 22h10.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 19.72 22 18.88 22 17.2Z"
  }))),
  shielddollar: t => e.createElement("svg", xa({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ya || (ya = e.createElement("path", {
    d: "M9.213 14.5c.312.594.936 1 1.654 1H13a2 2 0 0 0 0-4h-2a2 2 0 0 1 0-4h2.133c.718 0 1.342.405 1.654 1M12 6v1.5m0 8V17m8-5c0 4.908-5.354 8.478-7.302 9.615-.221.129-.332.194-.488.227a1.137 1.137 0 0 1-.42 0c-.156-.034-.267-.098-.488-.227C9.354 20.478 4 16.908 4 12V7.217c0-.799 0-1.199.13-1.542a2 2 0 0 1 .548-.79c.276-.243.65-.383 1.398-.664l5.362-2.01c.208-.078.312-.117.419-.133a1 1 0 0 1 .286 0c.107.016.21.055.419.133l5.362 2.01c.748.28 1.123.421 1.398.664a2 2 0 0 1 .547.79c.131.343.131.743.131 1.542V12Z"
  }))),
  boldsquare: t => e.createElement("svg", Ea({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Oa || (Oa = e.createElement("path", {
    d: "M8.5 12H13a2.5 2.5 0 0 0 0-5H8.5v5Zm0 0H14a2.5 2.5 0 0 1 0 5H8.5v-5Zm-.7 9h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Z"
  }))),
  creditcardx: t => e.createElement("svg", Ca({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ja || (ja = e.createElement("path", {
    d: "m16.5 16 5 5m0-5-5 5M22 10H2m20 2V8.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 5 19.92 5 18.8 5H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 6.52 2 7.08 2 8.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 19 4.08 19 5.2 19H12"
  }))),
  hurricane01: t => e.createElement("svg", Ma({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Pa || (Pa = e.createElement("path", {
    d: "M16.5 20.5c-1.254.314-2.812.5-4.5.5-1.688 0-3.247-.186-4.5-.5M18 16.43c-1.466.554-3.61.903-6 .903s-4.534-.349-6-.902m-1.5-4.763c1.431.892 4.253 1.499 7.5 1.499s6.069-.607 7.5-1.5M21 6c0 1.657-4.03 3-9 3S3 7.657 3 6s4.03-3 9-3 9 1.343 9 3Z"
  }))),
  passcode: t => e.createElement("svg", Sa({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ka || (ka = e.createElement("path", {
    d: "M12 12h.005M17 12h.005M7 12h.005M5.2 7h13.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C22 8.52 22 9.08 22 10.2v3.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C20.48 17 19.92 17 18.8 17H5.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C2 15.48 2 14.92 2 13.8v-3.6c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C3.52 7 4.08 7 5.2 7Zm7.05 5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Zm5 0a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Zm-10 0a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Z"
  }))),
  videorecorderoff: t => e.createElement("svg", Ba({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Na || (Na = e.createElement("path", {
    d: "M5 5a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h9a3.001 3.001 0 0 0 2.87-2.125M17 12l3.634-3.634c.429-.429.643-.643.827-.657a.5.5 0 0 1 .42.173c.119.14.119.444.119 1.05v6.137c0 .605 0 .908-.12 1.049a.5.5 0 0 1-.42.173c-.183-.014-.397-.228-.826-.657L17 12Zm0 0V9.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C14.72 5 13.88 5 12.2 5H9.5M2 2l20 20"
  }))),
  calendarcheck02: t => e.createElement("svg", Ra({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Va || (Va = e.createElement("path", {
    d: "M21 10H3m18 2.5V8.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 4 17.88 4 16.2 4H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 6.28 3 7.12 3 8.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 22 6.12 22 7.8 22H12m4-20v4M8 2v4m6.5 13 2 2 4.5-4.5"
  }))),
  piechart04: t => e.createElement("svg", Ta({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Aa || (Aa = e.createElement("path", {
    d: "M12 12 2.332 9.446a10 10 0 0 0 5.922 11.826L12 12Zm0 0 .105-10A10 10 0 0 0 2.34 9.413L12 12Zm10 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }))),
  database01: t => e.createElement("svg", La({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Ha || (Ha = e.createElement("path", {
    d: "M21 5c0 1.657-4.03 3-9 3S3 6.657 3 5m18 0c0-1.657-4.03-3-9-3S3 3.343 3 5m18 0v14c0 1.66-4 3-9 3s-9-1.34-9-3V5m18 7c0 1.66-4 3-9 3s-9-1.34-9-3"
  }))),
  film03: t => e.createElement("svg", Fa({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Ia || (Ia = e.createElement("path", {
    d: "M7 2v4m0 10v4M17 4v4m0 10v4M2 6h10M2 16h10m0-8h10M12 18h10m-10 2V3.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C11.24 2 10.96 2 10.4 2H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 4.28 2 5.12 2 6.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 20 5.12 20 6.8 20H12Zm0-16h5.2c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C22 6.28 22 7.12 22 8.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C19.72 22 18.88 22 17.2 22h-3.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C12 21.24 12 20.96 12 20.4V4Z"
  }))),
  chevronleftdouble: t => e.createElement("svg", Za({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), _a || (_a = e.createElement("path", {
    d: "m18 17-5-5 5-5m-7 10-5-5 5-5"
  }))),
  calendarheart02: t => e.createElement("svg", qa({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Da || (Da = e.createElement("path", {
    d: "M21 10H3m18 1.5V8.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 4 17.88 4 16.2 4H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 6.28 3 7.12 3 8.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 22 6.12 22 7.8 22h4.7M16 2v4M8 2v4m9.498 9.712c-.7-.78-1.867-.989-2.744-.275-.877.713-1 1.906-.311 2.75.688.844 3.055 2.813 3.055 2.813s2.366-1.97 3.055-2.813c.688-.844.58-2.044-.312-2.75-.892-.706-2.044-.504-2.743.275Z"
  }))),
  gitbranch01: t => e.createElement("svg", $a({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Ua || (Ua = e.createElement("path", {
    d: "M3 3v10.2c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 18 6.12 18 7.8 18H15m0 0a3 3 0 1 0 6 0 3 3 0 0 0-6 0ZM3 8h12m0 0a3 3 0 1 0 6 0 3 3 0 0 0-6 0Z"
  }))),
  currencyyencircle: t => e.createElement("svg", Wa({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), za || (za = e.createElement("path", {
    d: "M12 18v-6m0 0 4-5m-4 5L8 7m8 5H8m7.5 3h-7M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }))),
  alignleft02: t => e.createElement("svg", Ga({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Qa || (Qa = e.createElement("path", {
    d: "M14 10c.932 0 1.398 0 1.765-.152a2 2 0 0 0 1.083-1.083C17 8.398 17 7.932 17 7c0-.932 0-1.398-.152-1.765a2 2 0 0 0-1.083-1.083C15.398 4 14.932 4 14 4H6c-.932 0-1.398 0-1.765.152a2 2 0 0 0-1.083 1.083C3 5.602 3 6.068 3 7c0 .932 0 1.398.152 1.765a2 2 0 0 0 1.083 1.083C4.602 10 5.068 10 6 10h8ZM18 20c.932 0 1.398 0 1.765-.152a2 2 0 0 0 1.083-1.083C21 18.398 21 17.932 21 17c0-.932 0-1.398-.152-1.765a2 2 0 0 0-1.083-1.083C19.398 14 18.932 14 18 14H6c-.932 0-1.398 0-1.765.152a2 2 0 0 0-1.083 1.083C3 15.602 3 16.068 3 17c0 .932 0 1.398.152 1.765a2 2 0 0 0 1.083 1.083C4.602 20 5.068 20 6 20h12Z"
  }))),
  annotationcheck: t => e.createElement("svg", Ka({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Ya || (Ya = e.createElement("path", {
    d: "m9 11 2 2 4.5-4.5M9.9 19.2l1.46 1.947c.217.29.326.434.459.486a.5.5 0 0 0 .362 0c.133-.052.242-.197.459-.486L14.1 19.2c.293-.39.44-.586.619-.735a2 2 0 0 1 .822-.412c.226-.053.47-.053.959-.053 1.398 0 2.097 0 2.648-.228a3 3 0 0 0 1.624-1.624C21 15.597 21 14.898 21 13.5V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v5.7c0 1.398 0 2.097.228 2.648a3 3 0 0 0 1.624 1.624C5.403 18 6.102 18 7.5 18c.489 0 .733 0 .96.053a2 2 0 0 1 .821.412c.18.149.326.344.619.735Z"
  }))),
  columns03: t => e.createElement("svg", Ja({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Xa || (Xa = e.createElement("path", {
    d: "M9 3v18m6-18v18M7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3Z"
  }))),
  modem02: t => e.createElement("svg", to({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), eo || (eo = e.createElement("path", {
    d: "M6.205 10.558a6.002 6.002 0 0 1 1.084-5.274m10.507 5.274a6.002 6.002 0 0 0-1.084-5.274M2.342 11.6a10 10 0 0 1 2.105-9.154M21.655 11.6a10 10 0 0 0-2.105-9.154M12 15V9m-6.5 9.5h4M5.2 22h13.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C22 20.48 22 19.92 22 18.8v-.6c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 15 19.92 15 18.8 15H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 16.52 2 17.08 2 18.2v.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 22 4.08 22 5.2 22Z"
  }))),
  scales02: t => e.createElement("svg", no({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ro || (ro = e.createElement("path", {
    d: "M2.5 13h6m7 0h6M12 7v14m0-14a2.5 2.5 0 0 0 2.5-2.5M12 7a2.5 2.5 0 0 1-2.5-2.5M4 21h16M4 4.5h5.5m0 0a2.5 2.5 0 0 1 5 0m0 0H20M8.88 14.336C8.48 15.871 7.12 17 5.5 17c-1.618 0-2.98-1.13-3.38-2.664a1.383 1.383 0 0 1-.05-.438 2.882 2.882 0 0 1 .105-.653c.08-.237.167-.371.34-.64L5.5 8l2.986 4.606c.173.268.26.402.34.639.05.145.107.5.106.653-.002.25-.018.313-.051.438Zm13 0C21.48 15.871 20.12 17 18.5 17c-1.618 0-2.98-1.13-3.38-2.664-.033-.125-.05-.188-.05-.438-.002-.154.055-.508.105-.653.08-.237.167-.371.34-.64L18.5 8l2.986 4.606c.173.268.26.402.34.639.05.145.107.5.106.653-.002.25-.018.313-.051.438Z"
  }))),
  distributespacinghorizontal: t => e.createElement("svg", oo({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ao || (ao = e.createElement("path", {
    d: "M21 21V3M3 21V3m6 5v8c0 .932 0 1.398.152 1.765a2 2 0 0 0 1.083 1.083C10.602 19 11.068 19 12 19c.932 0 1.398 0 1.765-.152a2 2 0 0 0 1.083-1.083C15 17.398 15 16.932 15 16V8c0-.932 0-1.398-.152-1.765a2 2 0 0 0-1.083-1.083C13.398 5 12.932 5 12 5c-.932 0-1.398 0-1.765.152a2 2 0 0 0-1.083 1.083C9 6.602 9 7.068 9 8Z"
  }))),
  logout03: t => e.createElement("svg", lo({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), io || (io = e.createElement("path", {
    d: "m16 17 5-5m0 0-5-5m5 5H9m3 5c0 .296 0 .443-.011.571a3 3 0 0 1-2.404 2.686c-.126.025-.273.042-.567.074l-1.021.114c-1.535.17-2.302.256-2.911.06a3 3 0 0 1-1.825-1.633C3 18.288 3 17.516 3 15.972V8.028c0-1.544 0-2.316.261-2.9a3 3 0 0 1 1.825-1.634c.61-.195 1.376-.11 2.91.061l1.022.114c.294.032.441.049.567.074a3 3 0 0 1 2.404 2.686c.011.128.011.275.011.57"
  }))),
  xcircle: t => e.createElement("svg", co({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), so || (so = e.createElement("path", {
    d: "m15 9-6 6m0-6 6 6m7-3c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }))),
  expand05: t => e.createElement("svg", ho({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), uo || (uo = e.createElement("path", {
    d: "m15 9 6-6m0 0h-6m6 0v6M9 9 3 3m0 0v6m0-6h6m0 12-6 6m0 0h6m-6 0v-6m12 0 6 6m0 0v-6m0 6h-6"
  }))),
  userminus02: t => e.createElement("svg", po({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), mo || (mo = e.createElement("path", {
    d: "M16 7h6m-6 14v-1.2c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C13.72 15 12.88 15 11.2 15H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 17.28 2 18.12 2 19.8V21M12.5 7.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
  }))),
  foldercheck: t => e.createElement("svg", vo({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), fo || (fo = e.createElement("path", {
    d: "m13 7-1.116-2.231c-.32-.642-.481-.963-.72-1.198a2 2 0 0 0-.748-.462C10.1 3 9.74 3 9.022 3H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 4.52 2 5.08 2 6.2V7m0 0h15.2c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C22 9.28 22 10.12 22 11.8v4.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C19.72 21 18.88 21 17.2 21H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.72 2 17.88 2 16.2V7Zm7 7 2 2 4.5-4.5"
  }))),
  barchart08: t => e.createElement("svg", bo({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), go || (go = e.createElement("path", {
    d: "M21 21H6.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C3 19.48 3 18.92 3 17.8V3m4 11.5v3m4.5-6v6m4.5-9v9m4.5-12v12"
  }))),
  stand: t => e.createElement("svg", yo({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), wo || (wo = e.createElement("path", {
    d: "m9 17-5 5m11-5 5 5M12 2v2m0 18v-5m-6.8 0h13.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C22 15.48 22 14.92 22 13.8V7.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 4 19.92 4 18.8 4H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 5.52 2 6.08 2 7.2v6.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 17 4.08 17 5.2 17Z"
  }))),
  menu05: t => e.createElement("svg", Oo({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), xo || (xo = e.createElement("path", {
    d: "M3 8.5h18m-18 7h18"
  }))),
  wallet01: t => e.createElement("svg", jo({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Eo || (Eo = e.createElement("path", {
    d: "M22 8.5H2m0 4h3.547c.54 0 .81 0 1.071.047.232.04.458.11.674.204.243.106.468.256.917.555l.582.388c.45.3.674.45.917.555.216.095.442.163.674.204.261.047.531.047 1.071.047h1.094c.54 0 .81 0 1.071-.047.232-.04.458-.11.674-.204.243-.106.468-.256.917-.555l.582-.388c.45-.3.674-.45.917-.555.216-.095.442-.163.674-.204.261-.047.531-.047 1.071-.047H22M2 7.2v9.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 20 4.08 20 5.2 20h13.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C22 18.48 22 17.92 22 16.8V7.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 4 19.92 4 18.8 4H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 5.52 2 6.08 2 7.2Z"
  }))),
  circle: t => e.createElement("svg", Po({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Co || (Co = e.createElement("path", {
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z"
  }))),
  imageuserdown: t => e.createElement("svg", ko({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Mo || (Mo = e.createElement("path", {
    d: "m16 5 3 3m0 0 3-3m-3 3V2m3 10v5.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C19.72 22 18.88 22 17.2 22H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 19.72 2 18.88 2 17.2V6.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C4.28 2 5.12 2 6.8 2H12M2.146 19.926A4.002 4.002 0 0 1 6 17h7c.93 0 1.394 0 1.78.077a4 4 0 0 1 3.143 3.143c.077.386.077.85.077 1.78M14 9.5a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
  }))),
  shoppingbag03: t => e.createElement("svg", No({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), So || (So = e.createElement("path", {
    d: "M16 8a4 4 0 1 1-8 0m-4.367-.599-.7 8.4c-.15 1.805-.226 2.707.08 3.403a3 3 0 0 0 1.319 1.434C5 21 5.905 21 7.716 21h8.567c1.81 0 2.716 0 3.384-.362a3 3 0 0 0 1.32-1.434c.305-.696.23-1.598.08-3.403l-.7-8.4c-.13-1.552-.195-2.329-.539-2.916a3 3 0 0 0-1.294-1.191C17.92 3 17.141 3 15.583 3H8.416c-1.558 0-2.337 0-2.95.294a3 3 0 0 0-1.295 1.19c-.344.588-.409 1.365-.538 2.917Z"
  }))),
  announcement02: t => e.createElement("svg", Vo({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Bo || (Bo = e.createElement("path", {
    d: "m4 14 1.575 6.299c.044.177.066.265.092.343A2 2 0 0 0 7.4 21.992c.08.007.172.007.355.007.228 0 .343 0 .44-.01a2 2 0 0 0 1.797-1.797c.009-.096.009-.21.009-.44V5.5m8.5 8a3.5 3.5 0 1 0 0-7m-8.25-1H6.5a4.5 4.5 0 0 0 0 9h3.75c1.766 0 3.927.947 5.594 1.856.973.53 1.46.795 1.778.756a.946.946 0 0 0 .691-.411c.187-.26.187-.783.187-1.827V5.126c0-1.044 0-1.566-.187-1.827a.946.946 0 0 0-.691-.411c-.319-.039-.805.226-1.778.756-1.667.909-3.828 1.856-5.594 1.856Z"
  }))),
  headingsquare: t => e.createElement("svg", Ao({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Ro || (Ro = e.createElement("path", {
    d: "M8 7v10m8-10v10m0-5H8m-.2 9h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Z"
  }))),
  cornerleftup: t => e.createElement("svg", Ho({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), To || (To = e.createElement("path", {
    d: "M21 20h-3.4c-3.36 0-5.04 0-6.324-.654a6 6 0 0 1-2.622-2.622C8 15.44 8 13.76 8 10.4V4m0 0 5 5M8 4 3 9"
  }))),
  annotationquestion: t => e.createElement("svg", Io({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Lo || (Lo = e.createElement("path", {
    d: "M10 8.502a2.248 2.248 0 0 1 4.37.75c0 1.499-2.25 2.248-2.25 2.248m.03 3h.01M9.9 19.2l1.46 1.947c.217.29.326.434.459.486a.5.5 0 0 0 .362 0c.133-.052.242-.197.459-.486L14.1 19.2c.293-.39.44-.586.619-.735a2 2 0 0 1 .822-.412c.226-.053.47-.053.959-.053 1.398 0 2.097 0 2.648-.228a3 3 0 0 0 1.624-1.624C21 15.597 21 14.898 21 13.5V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v5.7c0 1.398 0 2.097.228 2.648a3 3 0 0 0 1.624 1.624C5.403 18 6.102 18 7.5 18c.489 0 .733 0 .96.053a2 2 0 0 1 .821.412c.18.149.326.344.619.735Z"
  }))),
  cryptocurrency01: t => e.createElement("svg", _o({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Fo || (Fo = e.createElement("path", {
    d: "M17.878 20.09a10 10 0 0 1-11.756 0M16.384 3.012a10 10 0 0 1 5.519 10.38m-19.806 0a10 10 0 0 1 5.52-10.38M17.5 12a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Z"
  }))),
  spacingheight02: t => e.createElement("svg", Do({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Zo || (Zo = e.createElement("path", {
    d: "M21 3H3m18 18H3m9-3.5v-11m3 0H9m6 11H9"
  }))),
  safe: t => e.createElement("svg", Uo({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), qo || (qo = e.createElement("path", {
    d: "M6 21h3m6 0h3m-.5-14.5v8M3 6.2v8.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C4.52 18 5.08 18 6.2 18h11.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C21 16.48 21 15.92 21 14.8V6.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C19.48 3 18.92 3 17.8 3H6.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C3 4.52 3 5.08 3 6.2Zm8.5 4.3a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"
  }))),
  slashcircle01: t => e.createElement("svg", zo({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), $o || ($o = e.createElement("path", {
    d: "m4.93 4.93 14.14 14.14M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }))),
  wallet05: t => e.createElement("svg", Qo({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Wo || (Wo = e.createElement("path", {
    d: "M19 10H5m14 0 1.864 3.107c.418.696.627 1.044.735 1.42a3 3 0 0 1 .113 1.023c-.025.389-.154.774-.41 1.544l-.208.624c-.393 1.18-.59 1.77-.955 2.206a3 3 0 0 1-1.203.868c-.53.208-1.152.208-2.396.208H7.46c-1.245 0-1.867 0-2.396-.208a3 3 0 0 1-1.203-.868c-.365-.436-.562-1.026-.955-2.206l-.208-.624c-.257-.77-.385-1.155-.41-1.545a3 3 0 0 1 .113-1.023c.108-.375.317-.723.735-1.42L5 10m14 0 .417-1.46c.198-.693.297-1.039.22-1.313a1 1 0 0 0-.436-.577c-.242-.15-.602-.15-1.322-.15H6.12c-.72 0-1.08 0-1.322.15a1 1 0 0 0-.435.577c-.078.274.02.62.219 1.313L5 10m7-3.5H8.464c-.52 0-1.02-.21-1.389-.586A2.019 2.019 0 0 1 6.5 4.5c0-.53.207-1.04.575-1.414a1.947 1.947 0 0 1 1.39-.586c2.75 0 3.535 4 3.535 4Zm0 0h3.536c.52 0 1.02-.21 1.388-.586.369-.375.576-.884.576-1.414 0-.53-.207-1.04-.576-1.414a1.947 1.947 0 0 0-1.388-.586c-2.75 0-3.536 4-3.536 4Z"
  }))),
  microphoneoff01: t => e.createElement("svg", Yo({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Go || (Go = e.createElement("path", {
    d: "M15 9.4V5a3 3 0 0 0-5.688-1.334M12 19v3m0-3a7 7 0 0 1-7-7v-2m7 9a7 7 0 0 0 7-7v-2M8 22h8M2 2l20 20m-10-7a3 3 0 0 1-3-3V9l5.123 5.12A2.99 2.99 0 0 1 12 15Z"
  }))),
  menu01: t => e.createElement("svg", Xo({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Ko || (Ko = e.createElement("path", {
    d: "M3 12h18M3 6h18M3 18h18"
  }))),
  alarmclockcheck: t => e.createElement("svg", ei({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Jo || (Jo = e.createElement("path", {
    d: "M5 3 2 6m20 0-3-3M6 19l-2 2m14-2 2 2M9 13.5l2 2 4.5-4.5M12 21a8 8 0 1 0 0-16.001A8 8 0 0 0 12 21Z"
  }))),
  refreshcw03: t => e.createElement("svg", ri({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ti || (ti = e.createElement("path", {
    d: "M14 22s.85-.121 4.364-3.636A9 9 0 0 0 14 3.224M14 22h6m-6 0v-6M10 2s-.85.122-4.364 3.636A9 9 0 0 0 10 20.776M10 2H4m6 0v6"
  }))),
  cameralens: t => e.createElement("svg", ai({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ni || (ni = e.createElement("path", {
    d: "M21.416 15.341a9.17 9.17 0 0 1-9.539.659M2.584 8.659a9.17 9.17 0 0 1 9.56-.648m3.23 6.113A9.17 9.17 0 0 0 19.6 5.512M8.581 9.904A9.17 9.17 0 0 0 4.4 18.488m11.128-8.351a9.172 9.172 0 0 0-5.345-7.965M8.476 13.926a9.172 9.172 0 0 0 5.342 7.902m5.253-16.9c3.905 3.906 3.905 10.238 0 14.143-3.905 3.905-10.237 3.905-14.142 0-3.905-3.905-3.905-10.237 0-14.142 3.905-3.905 10.237-3.905 14.142 0Zm-4.243 4.244a4 4 0 1 1-5.656 5.656 4 4 0 0 1 5.656-5.656Z"
  }))),
  sunsetting02: t => e.createElement("svg", ii({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), oi || (oi = e.createElement("path", {
    d: "M22 16.5H2M20 20H4m8-17v2m-8 8H2m4.314-5.686L4.9 5.9m12.786 1.414L19.1 5.9M22 13h-2M7 13a5 5 0 0 1 10 0"
  }))),
  linechartup02: t => e.createElement("svg", si({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), li || (li = e.createElement("path", {
    d: "M21 21H4.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C3 20.24 3 19.96 3 19.4V3m18 4-5.434 5.434c-.198.198-.297.297-.412.334a.499.499 0 0 1-.309 0c-.114-.037-.213-.136-.41-.334l-1.87-1.868c-.197-.198-.296-.297-.41-.334a.499.499 0 0 0-.31 0c-.114.037-.213.136-.41.334L7 15m14-8h-4m4 0v4"
  }))),
  usersup: t => e.createElement("svg", ui({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ci || (ci = e.createElement("path", {
    d: "m16 18 3-3m0 0 3 3m-3-3v6M15.5 3.29a4.001 4.001 0 0 1 0 7.42M12 15H8c-1.864 0-2.796 0-3.53.305a4 4 0 0 0-2.166 2.164C2 18.204 2 19.136 2 21M13.5 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
  }))),
  alignbottom01: t => e.createElement("svg", mi({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), hi || (hi = e.createElement("path", {
    d: "M3 21h18M12 3v14m0 0 7-7m-7 7-7-7"
  }))),
  refreshccw04: t => e.createElement("svg", fi({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), pi || (pi = e.createElement("path", {
    d: "M17 18.875A8.5 8.5 0 0 0 12 3.5h-.5m.5 17A8.5 8.5 0 0 1 7 5.125M11 22.4l2-2-2-2m2-12.8-2-2 2-2"
  }))),
  equal: t => e.createElement("svg", vi({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), di || (di = e.createElement("path", {
    d: "M5 9h14M5 15h14"
  }))),
  expand01: t => e.createElement("svg", bi({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), gi || (gi = e.createElement("path", {
    d: "m14 10 7-7m0 0h-6m6 0v6m-11 5-7 7m0 0h6m-6 0v-6"
  }))),
  arrowupleft: t => e.createElement("svg", yi({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), wi || (wi = e.createElement("path", {
    d: "M17 17 7 7m0 0v10M7 7h10"
  }))),
  settings01: t => e.createElement("svg", Ei({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), xi || (xi = e.createElement("path", {
    d: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
  })), Oi || (Oi = e.createElement("path", {
    d: "M18.727 14.727a1.5 1.5 0 0 0 .3 1.655l.055.054a1.816 1.816 0 0 1 0 2.573 1.818 1.818 0 0 1-2.573 0l-.055-.055a1.5 1.5 0 0 0-1.654-.3 1.5 1.5 0 0 0-.91 1.373v.155a1.818 1.818 0 1 1-3.636 0V20.1a1.5 1.5 0 0 0-.981-1.373 1.5 1.5 0 0 0-1.655.3l-.054.055a1.818 1.818 0 0 1-3.106-1.287 1.818 1.818 0 0 1 .533-1.286l.054-.055a1.5 1.5 0 0 0 .3-1.654 1.5 1.5 0 0 0-1.372-.91h-.155a1.818 1.818 0 1 1 0-3.636H3.9a1.5 1.5 0 0 0 1.373-.981 1.5 1.5 0 0 0-.3-1.655l-.055-.054A1.818 1.818 0 1 1 7.491 4.99l.054.054a1.5 1.5 0 0 0 1.655.3h.073a1.5 1.5 0 0 0 .909-1.372v-.155a1.818 1.818 0 0 1 3.636 0V3.9a1.499 1.499 0 0 0 .91 1.373 1.5 1.5 0 0 0 1.654-.3l.054-.055a1.817 1.817 0 0 1 2.573 0 1.819 1.819 0 0 1 0 2.573l-.055.054a1.5 1.5 0 0 0-.3 1.655v.073a1.5 1.5 0 0 0 1.373.909h.155a1.818 1.818 0 0 1 0 3.636H20.1a1.499 1.499 0 0 0-1.373.91Z"
  }))),
  chevrondown: t => e.createElement("svg", Ci({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ji || (ji = e.createElement("path", {
    d: "m6 9 6 6 6-6"
  }))),
  backpack: t => e.createElement("svg", Mi({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Pi || (Pi = e.createElement("path", {
    d: "M20 13v4.8c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C18.48 21 17.92 21 16.8 21H7.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C4 19.48 4 18.92 4 17.8V13m5-3h6m-5.714 4h5.428c2.133 0 3.199 0 4.021-.396a4 4 0 0 0 1.869-1.868C21 10.912 21 9.845 21 7.713c0-1.6 0-2.399-.297-3.016a3 3 0 0 0-1.401-1.4C18.685 3 17.885 3 16.286 3H7.714c-1.6 0-2.399 0-3.016.297a3 3 0 0 0-1.4 1.401C3 5.315 3 6.115 3 7.714c0 2.133 0 3.199.396 4.021a4 4 0 0 0 1.868 1.869C6.087 14 7.154 14 9.286 14Z"
  }))),
  wind03: t => e.createElement("svg", Si({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ki || (ki = e.createElement("path", {
    d: "M16.764 6.5a3 3 0 1 1 2.236 5h-6M6.764 4A3 3 0 1 1 9 9H2m8.764 11A3 3 0 1 0 13 15H2"
  }))),
  stars02: t => e.createElement("svg", Bi({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Ni || (Ni = e.createElement("path", {
    d: "M4.5 22v-5m0-10V2M2 4.5h5m-5 15h5M13 3l-1.734 4.509c-.282.733-.423 1.1-.643 1.408a3 3 0 0 1-.706.707c-.308.219-.675.36-1.408.642L4 12l4.509 1.734c.733.282 1.1.423 1.408.643.273.194.512.433.707.706.219.308.36.675.642 1.408L13 21l1.734-4.509c.282-.733.423-1.1.643-1.408.194-.273.433-.512.706-.707.308-.219.675-.36 1.408-.642L22 12l-4.509-1.734c-.733-.282-1.1-.423-1.408-.642a3 3 0 0 1-.706-.707c-.22-.308-.36-.675-.643-1.408L13 3Z"
  }))),
  italic02: t => e.createElement("svg", Ri({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Vi || (Vi = e.createElement("path", {
    d: "m13.25 4-6 16m9.5-16-6 16M19.5 4h-10m5 16h-10"
  }))),
  layersthree01: t => e.createElement("svg", Ti({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Ai || (Ai = e.createElement("path", {
    d: "m2 12 9.642 4.821c.131.066.197.099.266.111.06.012.123.012.184 0 .069-.012.135-.045.266-.11L22 12M2 17l9.642 4.821c.131.066.197.099.266.111.06.012.123.012.184 0 .069-.012.135-.045.266-.11L22 17M2 7l9.642-4.821c.131-.066.197-.098.266-.111a.5.5 0 0 1 .184 0c.069.013.135.045.266.11L22 7l-9.642 4.821c-.131.066-.197.099-.266.111a.501.501 0 0 1-.184 0c-.069-.012-.135-.045-.266-.11L2 7Z"
  }))),
  currencyethereumcircle: t => e.createElement("svg", Li({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Hi || (Hi = e.createElement("path", {
    d: "M6.5 15.5 12 18l5.5-2.5M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-15.5-.5L12 14l5.5-2.5L12 5l-5.5 6.5Z"
  }))),
  droplets01: t => e.createElement("svg", Fi({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Ii || (Ii = e.createElement("path", {
    d: "M22 16a6 6 0 0 1-12 0c0-4.314 6-14 6-14s6 9.686 6 14ZM8 9a3 3 0 1 1-6 0c0-2.157 3-7 3-7s3 4.843 3 7Z"
  }))),
  creditcardshield: t => e.createElement("svg", Zi({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), _i || (_i = e.createElement("path", {
    d: "M22 10H2m20 1V8.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 5 19.92 5 18.8 5H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 6.52 2 7.08 2 8.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 19 4.08 19 5.2 19h6.3m6.5 2s3-1.43 3-3.575v-2.502l-2.188-.782a2.41 2.41 0 0 0-1.626 0L15 14.923v2.502C15 19.57 18 21 18 21Z"
  }))),
  shield01: t => e.createElement("svg", qi({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Di || (Di = e.createElement("path", {
    d: "M11.302 21.615c.221.129.332.194.488.227.122.026.298.026.42 0 .156-.034.267-.098.488-.227C14.646 20.478 20 16.908 20 12V7.217c0-.799 0-1.199-.13-1.542a2 2 0 0 0-.548-.79c-.275-.243-.65-.383-1.398-.664l-5.362-2.01c-.208-.078-.312-.117-.419-.133a1 1 0 0 0-.286 0c-.107.016-.21.055-.419.133L6.076 4.22c-.748.28-1.122.421-1.398.664a2 2 0 0 0-.547.79C4 6.018 4 6.418 4 7.217V12c0 4.908 5.354 8.478 7.302 9.615Z"
  }))),
  bold02: t => e.createElement("svg", $i({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Ui || (Ui = e.createElement("path", {
    d: "M6 4v16M9.5 4h6a4 4 0 0 1 0 8h-6 7a4 4 0 0 1 0 8h-7m0-16v16m0-16H4m5.5 16H4"
  }))),
  speedometer02: t => e.createElement("svg", Wi({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), zi || (zi = e.createElement("path", {
    d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12m20 0c0-5.523-4.477-10-10-10m10 10h-2.5M2 12C2 6.477 6.477 2 12 2M2 12h2.5M12 2v2.5m7.078.5L13.5 10.5m5.578 8.578-.203-.203c-.692-.692-1.038-1.038-1.442-1.286a3.999 3.999 0 0 0-1.156-.479c-.46-.11-.95-.11-1.928-.11H9.651c-.978 0-1.468 0-1.928.11a4 4 0 0 0-1.156.48c-.404.247-.75.593-1.442 1.285l-.203.203M4.922 5l1.736 1.736M14 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
  }))),
  bluetoothconnect: t => e.createElement("svg", Gi({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Qi || (Qi = e.createElement("path", {
    d: "m3 7 12 10-6 5V2l6 5L3 17m15-5h.01M15 12h.01M21 12h.01"
  }))),
  cloud01: t => e.createElement("svg", Ki({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Yi || (Yi = e.createElement("path", {
    d: "M6.5 19a4.5 4.5 0 0 1-.42-8.98 6.002 6.002 0 0 1 11.84 0A4.5 4.5 0 0 1 17.5 19h-11Z"
  }))),
  shieldplus: t => e.createElement("svg", Ji({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Xi || (Xi = e.createElement("path", {
    d: "M12 14.5v-6m-3 3h6m5 .5c0 4.908-5.354 8.478-7.302 9.615-.221.129-.332.194-.488.227a1.137 1.137 0 0 1-.42 0c-.156-.034-.267-.098-.488-.227C9.354 20.478 4 16.908 4 12V7.217c0-.799 0-1.199.13-1.542a2 2 0 0 1 .548-.79c.276-.243.65-.383 1.398-.664l5.362-2.01c.208-.078.312-.117.419-.133a1 1 0 0 1 .286 0c.107.016.21.055.419.133l5.362 2.01c.748.28 1.123.421 1.398.664a2 2 0 0 1 .547.79c.131.343.131.743.131 1.542V12Z"
  }))),
  piechart01: t => e.createElement("svg", tl({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), el || (el = e.createElement("path", {
    d: "M21.21 15.89A10 10 0 1 1 8 2.83m13.24 5.343a10 10 0 0 1 .728 3.028c.021.257.031.385-.02.5a.525.525 0 0 1-.22.239c-.11.06-.25.06-.528.06h-8.4c-.28 0-.42 0-.527-.055a.5.5 0 0 1-.218-.218C12 11.62 12 11.48 12 11.2V2.8c0-.278 0-.417.06-.528a.525.525 0 0 1 .239-.22c.115-.05.244-.04.5-.02a10 10 0 0 1 8.44 6.141Z"
  }))),
  medicalcircle: t => e.createElement("svg", al({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), rl || (rl = e.createElement("path", {
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z"
  })), nl || (nl = e.createElement("path", {
    d: "M13.833 7.3c0-.28 0-.42-.054-.527a.5.5 0 0 0-.219-.218c-.107-.055-.247-.055-.527-.055h-2.066c-.28 0-.42 0-.527.054a.5.5 0 0 0-.219.219c-.054.107-.054.247-.054.527v2.067c0 .28 0 .42-.055.527a.5.5 0 0 1-.218.218c-.107.055-.247.055-.527.055H7.3c-.28 0-.42 0-.527.054a.5.5 0 0 0-.218.219c-.055.107-.055.247-.055.527v2.066c0 .28 0 .42.054.527a.5.5 0 0 0 .219.219c.107.054.247.054.527.054h2.067c.28 0 .42 0 .527.055.094.048.17.124.218.218.055.107.055.247.055.527V16.7c0 .28 0 .42.054.527a.5.5 0 0 0 .219.218c.107.055.247.055.527.055h2.066c.28 0 .42 0 .527-.055a.5.5 0 0 0 .219-.218c.054-.107.054-.247.054-.527v-2.067c0-.28 0-.42.055-.527a.501.501 0 0 1 .218-.218c.107-.055.247-.055.527-.055H16.7c.28 0 .42 0 .527-.054a.5.5 0 0 0 .218-.219c.055-.107.055-.247.055-.527v-2.066c0-.28 0-.42-.055-.527a.5.5 0 0 0-.218-.219c-.107-.054-.247-.054-.527-.054h-2.067c-.28 0-.42 0-.527-.055a.501.501 0 0 1-.218-.218c-.055-.107-.055-.247-.055-.527V7.3Z"
  }))),
  scissors01: t => e.createElement("svg", il({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ol || (ol = e.createElement("path", {
    d: "M20 4 8.5 15.5m0-7L20 20M6 3a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 12a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z"
  }))),
  rocket01: t => e.createElement("svg", sl({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ll || (ll = e.createElement("path", {
    d: "m13 11-9.5 9.5M14.018 3.538a22.613 22.613 0 0 1 3.483 2.855 22.61 22.61 0 0 1 2.876 3.515M9.255 7.896 6.38 6.938a1 1 0 0 0-.962.185L2.56 9.541a1 1 0 0 0 .3 1.701l2.708.998m6.113 6.112.997 2.708a1 1 0 0 0 1.702.3l2.417-2.857a1 1 0 0 0 .186-.962l-.959-2.875M19.348 2.27l-4.906.817a2.443 2.443 0 0 0-1.383.741L6.446 10.9a4.653 4.653 0 0 0 6.576 6.575l7.07-6.613c.391-.367.652-.853.74-1.382l.818-4.907a2 2 0 0 0-2.302-2.301Z"
  }))),
  speedometer03: t => e.createElement("svg", ul({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), cl || (cl = e.createElement("path", {
    d: "M5 12a7 7 0 0 1 7-7m4.5 2.5L12 12m10 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-9 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
  }))),
  arrowsquaredownright: t => e.createElement("svg", ml({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), hl || (hl = e.createElement("path", {
    d: "M15 9v6m0 0H9m6 0L9 9M7.8 21h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Z"
  }))),
  cloudsnowing02: t => e.createElement("svg", fl({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), pl || (pl = e.createElement("path", {
    d: "M8 18h.01M8 21h.01M12 18.5h.01m-.01 3h.01M16 18h.01M16 21h.01M7 15a5 5 0 1 1 .1-9.999 5.502 5.502 0 0 1 10.195 1.004A4.5 4.5 0 1 1 17.5 15H6.999Z"
  }))),
  stars03: t => e.createElement("svg", vl({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), dl || (dl = e.createElement("path", {
    d: "M18.5 8V3m-13 18v-5M16 5.5h5m-18 13h5M6.5 2l-.784 1.569c-.266.53-.399.796-.576 1.026a3 3 0 0 1-.545.545c-.23.177-.495.31-1.026.576L2 6.5l1.569.784c.53.266.796.399 1.026.576a3 3 0 0 1 .545.545c.177.23.31.495.576 1.026L6.5 11l.784-1.569c.266-.53.399-.796.576-1.026a3 3 0 0 1 .545-.545c.23-.177.495-.31 1.026-.576L11 6.5l-1.569-.784c-.53-.266-.796-.399-1.026-.576a3 3 0 0 1-.545-.545c-.177-.23-.31-.495-.576-1.026L6.5 2ZM17 12l-.951 1.902c-.266.531-.398.797-.576 1.027-.157.204-.34.387-.544.544-.23.178-.496.31-1.027.576L12 17l1.902.951c.531.266.797.398 1.027.576.204.157.387.34.544.544.178.23.31.496.576 1.027L17 22l.951-1.902c.266-.531.398-.797.576-1.027.157-.204.34-.387.544-.544.23-.178.496-.31 1.027-.576L22 17l-1.902-.951c-.531-.266-.797-.398-1.027-.576a3.005 3.005 0 0 1-.544-.544c-.178-.23-.31-.496-.576-1.027L17 12Z"
  }))),
  wind02: t => e.createElement("svg", bl({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), gl || (gl = e.createElement("path", {
    d: "M9.51 4.667A2 2 0 1 1 11 8H2m10.51 11.333A2 2 0 1 0 14 16H2m14.764-9A3 3 0 1 1 19 12H2"
  }))),
  lightning01: t => e.createElement("svg", yl({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), wl || (wl = e.createElement("path", {
    d: "M13 2 4.093 12.688c-.348.418-.523.628-.526.804a.5.5 0 0 0 .186.397c.138.111.41.111.955.111H12l-1 8 8.906-10.688c.35-.418.524-.628.526-.804a.5.5 0 0 0-.185-.397c-.138-.111-.41-.111-.955-.111H12l1-8Z"
  }))),
  layoutgrid01: t => e.createElement("svg", Ol({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), xl || (xl = e.createElement("path", {
    d: "M3 12h18m-9-9v18M7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3Z"
  }))),
  brackets: t => e.createElement("svg", jl({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), El || (El = e.createElement("path", {
    d: "M18.57 20a2.286 2.286 0 0 0 2.287-2.286v-4.571L22 12l-1.143-1.143V6.286A2.285 2.285 0 0 0 18.57 4M5.429 4a2.285 2.285 0 0 0-2.286 2.286v4.571L2 12l1.143 1.143v4.571A2.285 2.285 0 0 0 5.429 20"
  }))),
  italicsquare: t => e.createElement("svg", Pl({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Cl || (Cl = e.createElement("path", {
    d: "m14 7-4 10m-2.2 4h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Z"
  }))),
  griddotsouter: t => e.createElement("svg", kl({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Ml || (Ml = e.createElement("path", {
    d: "M7.5 12h.01m8.99 0h.01M12 12h.01M12 16.5h.01m-.01-9h.01M3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8Z"
  }))),
  navigationpointeroff01: t => e.createElement("svg", Nl({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Sl || (Sl = e.createElement("path", {
    d: "M11.337 6.161 20.3 2.663c.537-.21.806-.314.978-.257a.5.5 0 0 1 .316.316c.057.172-.048.44-.258.977l-3.509 8.992m-1.441 3.695-1.64 4.201c-.232.595-.348.893-.515.98a.5.5 0 0 1-.462 0c-.167-.088-.282-.385-.514-.98l-2.628-6.759a1.075 1.075 0 0 0-.107-.232.5.5 0 0 0-.116-.117c-.051-.036-.112-.06-.232-.106l-6.759-2.628c-.595-.232-.893-.348-.98-.515a.5.5 0 0 1 0-.461c.087-.167.385-.283.98-.515l4.204-1.641M21 21 3 3"
  }))),
  dotsgrid: t => e.createElement("svg", Vl({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Bl || (Bl = e.createElement("path", {
    d: "M12 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM12 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM19 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM19 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM19 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM5 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM5 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM5 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
  }))),
  key02: t => e.createElement("svg", Al({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Rl || (Rl = e.createElement("path", {
    d: "M15 9h.01M15 15a6 6 0 1 0-5.946-5.193c.058.434.087.651.068.789a.853.853 0 0 1-.117.346c-.068.121-.187.24-.426.479l-5.11 5.11c-.173.173-.26.26-.322.36a1 1 0 0 0-.12.29C3 17.296 3 17.418 3 17.663V19.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C3.76 21 4.04 21 4.6 21h1.737c.245 0 .367 0 .482-.028a.998.998 0 0 0 .29-.12c.1-.061.187-.148.36-.32l5.11-5.111c.239-.239.358-.358.48-.426a.852.852 0 0 1 .345-.117c.138-.02.355.01.789.068.264.036.533.054.807.054Z"
  }))),
  refreshccw05: t => e.createElement("svg", Hl({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Tl || (Tl = e.createElement("path", {
    d: "M8.546 19.767A8.5 8.5 0 0 0 19.361 7.75l-.25-.433M4.638 16.25A8.5 8.5 0 0 1 15.453 4.233m-12.96 12.1 2.732.733.732-2.732m12.085-4.668.732-2.732 2.732.732"
  }))),
  linechartup03: t => e.createElement("svg", Il({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Ll || (Ll = e.createElement("path", {
    d: "m17 9-5.434 5.434c-.198.198-.297.297-.412.334a.499.499 0 0 1-.309 0c-.114-.037-.213-.136-.41-.334l-1.87-1.868c-.197-.198-.296-.297-.41-.334a.499.499 0 0 0-.31 0c-.114.037-.213.136-.41.334L3 17m14-8h-4m4 0v4m-9.2 8h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Z"
  }))),
  certificate02: t => e.createElement("svg", _l({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Fl || (Fl = e.createElement("path", {
    d: "M9 18.5h6M7 15h10M5 2h14c1.105 0 2 .995 2 2.222v15.556C21 21.005 20.105 22 19 22H5c-1.105 0-2-.995-2-2.222V4.222C3 2.995 3.895 2 5 2Zm6.998 4.212c-.7-.78-1.867-.989-2.744-.275-.877.713-1 1.906-.312 2.75.689.844 3.056 2.813 3.056 2.813s2.366-1.97 3.055-2.813c.688-.844.58-2.044-.312-2.75-.892-.706-2.044-.504-2.743.275Z"
  }))),
  alignright01: t => e.createElement("svg", Dl({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Zl || (Zl = e.createElement("path", {
    d: "M21 21V3M3 12h14m0 0-7-7m7 7-7 7"
  }))),
  sunsetting03: t => e.createElement("svg", Ul({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ql || (ql = e.createElement("path", {
    d: "M6.06 20.913c1.21.55 2.75.55 3.96 0s2.75-.55 3.96 0 2.75.55 3.96 0M12 3v2m-8 8H2m4.314-5.686L4.9 5.9m12.786 1.414L19.1 5.9M22 13h-2M7 13a5 5 0 0 1 10 0M2.1 17.413c1.21-.55 2.75-.55 3.96 0s2.75.55 3.96 0 2.75-.55 3.96 0 2.75.55 3.96 0 2.75-.55 3.96 0"
  }))),
  refreshcw02: t => e.createElement("svg", zl({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), $l || ($l = e.createElement("path", {
    d: "M2 14s.121.85 3.636 4.364A9 9 0 0 0 20.776 14M2 14v6m0-6h6m14-4s-.121-.85-3.636-4.364A9 9 0 0 0 3.224 10M22 10V4m0 6h-6"
  }))),
  bracketscheck: t => e.createElement("svg", Ql({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Wl || (Wl = e.createElement("path", {
    d: "M18.57 20a2.286 2.286 0 0 0 2.287-2.286v-4.571L22 12l-1.143-1.143V6.286A2.285 2.285 0 0 0 18.57 4M5.429 4a2.285 2.285 0 0 0-2.286 2.286v4.571L2 12l1.143 1.143v4.571A2.285 2.285 0 0 0 5.429 20M7.5 12l2.434 2.434c.198.198.297.297.412.334.1.033.208.033.309 0 .114-.037.213-.136.41-.334L16.5 9"
  }))),
  wallet04: t => e.createElement("svg", Yl({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Gl || (Gl = e.createElement("path", {
    d: "M20 9.5V7.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C18.48 4 17.92 4 16.8 4H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 5.52 2 6.08 2 7.2v9.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 20 4.08 20 5.2 20h11.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C20 18.48 20 17.92 20 16.8v-2.3M15 12c0-.465 0-.697.038-.89a2 2 0 0 1 1.572-1.572c.193-.038.425-.038.89-.038h2c.465 0 .697 0 .89.038a2 2 0 0 1 1.572 1.572c.038.193.038.425.038.89s0 .697-.038.89a2 2 0 0 1-1.572 1.572c-.193.038-.425.038-.89.038h-2c-.465 0-.697 0-.89-.038a2 2 0 0 1-1.572-1.572C15 12.697 15 12.465 15 12Z"
  }))),
  userx02: t => e.createElement("svg", Xl({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Kl || (Kl = e.createElement("path", {
    d: "m16.5 4 5 5m0-5-5 5M16 21v-1.2c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C13.72 15 12.88 15 11.2 15H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 17.28 2 18.12 2 19.8V21M12.5 7.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
  }))),
  phoneplus: t => e.createElement("svg", es({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Jl || (Jl = e.createElement("path", {
    d: "M17 11V3m-4 4h8m-10.773 6.863a14.604 14.604 0 0 1-2.847-4.01 1.698 1.698 0 0 1-.113-.266 1.046 1.046 0 0 1 .147-.862c.048-.067.105-.124.22-.238.35-.35.524-.524.638-.7a2 2 0 0 0 0-2.18c-.114-.176-.289-.351-.638-.7l-.195-.196c-.532-.531-.797-.797-1.083-.941a2 2 0 0 0-1.805 0c-.285.144-.551.41-1.083.941l-.157.158c-.53.53-.795.794-.997 1.154-.224.4-.386 1.02-.384 1.479 0 .413.081.695.241 1.26a19.038 19.038 0 0 0 4.874 8.283 19.039 19.039 0 0 0 8.283 4.873c.565.16.847.24 1.26.242a3.377 3.377 0 0 0 1.478-.384c.36-.203.625-.468 1.155-.997l.157-.158c.532-.531.797-.797.942-1.082a2 2 0 0 0 0-1.806c-.145-.285-.41-.55-.942-1.082l-.195-.195c-.35-.35-.524-.524-.7-.639a2 2 0 0 0-2.18 0c-.176.114-.35.29-.7.639-.115.114-.172.171-.239.22-.237.17-.581.228-.862.146a1.695 1.695 0 0 1-.266-.113 14.605 14.605 0 0 1-4.01-2.846Z"
  }))),
  coinsswap02: t => e.createElement("svg", rs({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ts || (ts = e.createElement("path", {
    d: "m6 6 2-2m0 0L6 2m2 2H6a4 4 0 0 0-4 4m16 10-2 2m0 0 2 2m-2-2h2a4 4 0 0 0 4-4M10.189 6.5a6 6 0 1 1 7.311 7.311M14 16a6 6 0 1 1-12 0 6 6 0 0 1 12 0Z"
  }))),
  arrowcircleup: t => e.createElement("svg", as({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ns || (ns = e.createElement("path", {
    d: "m16 12-4-4m0 0-4 4m4-4v8m10-4c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }))),
  userup02: t => e.createElement("svg", is({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), os || (os = e.createElement("path", {
    d: "m16 6 3-3m0 0 3 3m-3-3v6m-3 12v-1.2c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C13.72 15 12.88 15 11.2 15H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 17.28 2 18.12 2 19.8V21M12.5 7.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
  }))),
  imagedown: t => e.createElement("svg", ss({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ls || (ls = e.createElement("path", {
    d: "m16 5 3 3m0 0 3-3m-3 3V2m-6.5 1H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21H17c.93 0 1.395 0 1.776-.102a3 3 0 0 0 2.122-2.122C21 18.395 21 17.93 21 17M10.5 8.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4.49 3.418-8.459 7.69c-.476.433-.714.649-.735.836a.5.5 0 0 0 .167.431C6.105 21 6.426 21 7.07 21h9.387c1.44 0 2.159 0 2.724-.242a3 3 0 0 0 1.578-1.578c.242-.565.242-1.285.242-2.724 0-.484 0-.726-.053-.952a2.001 2.001 0 0 0-.374-.778c-.143-.182-.332-.333-.71-.636l-2.797-2.237c-.379-.303-.568-.454-.776-.508a1 1 0 0 0-.557.018c-.205.066-.384.23-.743.555Z"
  }))),
  barchartsquareminus: t => e.createElement("svg", us({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), cs || (cs = e.createElement("path", {
    d: "M12 3h4.2c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V12m5 1v4m8-6v6M12 7v10M2 5h6"
  }))),
  spacingheight01: t => e.createElement("svg", ms({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), hs || (hs = e.createElement("path", {
    d: "M12 18V6m0 12-3-2m3 2 3-2M12 6 9 8m3-2 3 2m6-5H3m18 18H3"
  }))),
  cryptocurrency02: t => e.createElement("svg", fs({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ps || (ps = e.createElement("path", {
    d: "M17.878 20.09a10 10 0 0 1-11.756 0M16.384 3.012a10 10 0 0 1 5.519 10.38m-19.806 0a10 10 0 0 1 5.52-10.38m3.817 3.553-4.868 4.87c-.198.197-.297.296-.335.41a.5.5 0 0 0 0 .31c.038.113.137.212.335.41l4.868 4.87c.198.197.297.296.411.333a.5.5 0 0 0 .31 0c.114-.037.213-.136.41-.334l4.87-4.869c.197-.198.296-.297.333-.41a.5.5 0 0 0 0-.31c-.037-.114-.136-.213-.334-.41l-4.868-4.87c-.198-.198-.297-.297-.412-.334a.5.5 0 0 0-.309 0c-.114.037-.213.136-.41.334Z"
  }))),
  facesad: t => e.createElement("svg", vs({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ds || (ds = e.createElement("path", {
    d: "M16 16s-1.5-2-4-2-4 2-4 2m9-6.76c-.395.485-.935.76-1.5.76s-1.09-.275-1.5-.76m-4 0c-.395.485-.935.76-1.5.76S7.41 9.725 7 9.24M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }))),
  slashcircle02: t => e.createElement("svg", bs({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), gs || (gs = e.createElement("path", {
    d: "m4.93 4.93 14.14 14.14m0-14.14L4.93 19.07M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }))),
  microphoneoff02: t => e.createElement("svg", ys({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ws || (ws = e.createElement("path", {
    d: "M4 12v1a8 8 0 0 0 14.138 5.132M2 2l20 20m-6-11.6V7a4 4 0 0 0-6.53-3.1M12 17a4 4 0 0 1-4-4V8l7.281 7.288A3.995 3.995 0 0 1 12 17Z"
  }))),
  menu02: t => e.createElement("svg", Os({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), xs || (xs = e.createElement("path", {
    d: "M3 12h12M3 6h18M3 18h18"
  }))),
  sunsetting01: t => e.createElement("svg", js({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Es || (Es = e.createElement("path", {
    d: "M12 3v2M5.314 7.314 3.9 5.9m14.786 1.414L20.1 5.9M6 15a6 6 0 0 1 12 0m4 0H2m17 4H5"
  }))),
  annotationplus: t => e.createElement("svg", Ps({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Cs || (Cs = e.createElement("path", {
    d: "M12 13.5v-6m-3 3h6m-5.1 8.7 1.46 1.947c.217.29.326.434.459.486a.5.5 0 0 0 .362 0c.133-.052.242-.197.459-.486L14.1 19.2c.293-.39.44-.586.619-.735a2 2 0 0 1 .822-.412c.226-.053.47-.053.959-.053 1.398 0 2.097 0 2.648-.228a3 3 0 0 0 1.624-1.624C21 15.597 21 14.898 21 13.5V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v5.7c0 1.398 0 2.097.228 2.648a3 3 0 0 0 1.624 1.624C5.403 18 6.102 18 7.5 18c.489 0 .733 0 .96.053a2 2 0 0 1 .821.412c.18.149.326.344.619.735Z"
  }))),
  alignbottom02: t => e.createElement("svg", ks({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Ms || (Ms = e.createElement("path", {
    d: "M10 18V6c0-.932 0-1.398-.152-1.765a2 2 0 0 0-1.083-1.083C8.398 3 7.932 3 7 3c-.932 0-1.398 0-1.765.152a2 2 0 0 0-1.083 1.083C4 4.602 4 5.068 4 6v12c0 .932 0 1.398.152 1.765a2 2 0 0 0 1.083 1.083C5.602 21 6.068 21 7 21c.932 0 1.398 0 1.765-.152a2 2 0 0 0 1.083-1.083C10 19.398 10 18.932 10 18ZM20 18v-8c0-.932 0-1.398-.152-1.765a2 2 0 0 0-1.083-1.083C18.398 7 17.932 7 17 7c-.932 0-1.398 0-1.765.152a2 2 0 0 0-1.083 1.083C14 8.602 14 9.068 14 10v8c0 .932 0 1.398.152 1.765a2 2 0 0 0 1.083 1.083C15.602 21 16.068 21 17 21c.932 0 1.398 0 1.765-.152a2 2 0 0 0 1.083-1.083C20 19.398 20 18.932 20 18Z"
  }))),
  clockplus: t => e.createElement("svg", Ns({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Ss || (Ss = e.createElement("path", {
    d: "M21.92 13.265c.053-.414.08-.837.08-1.265 0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10c.435 0 .864-.028 1.285-.082M12 6v6l3.738 1.87M19 22v-6m-3 3h6"
  }))),
  alignjustify: t => e.createElement("svg", Vs({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Bs || (Bs = e.createElement("path", {
    d: "M21 10H3m18 8H3M21 6H3m18 8H3"
  }))),
  linechartup01: t => e.createElement("svg", As({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Rs || (Rs = e.createElement("path", {
    d: "M21 21H4.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C3 20.24 3 19.96 3 19.4V3m17 5-3.919 4.183c-.148.158-.223.237-.312.278a.5.5 0 0 1-.253.044c-.098-.01-.194-.06-.387-.16l-3.258-1.69c-.193-.1-.289-.15-.387-.16a.5.5 0 0 0-.253.044c-.09.04-.164.12-.312.278L7 15"
  }))),
  plussquare: t => e.createElement("svg", Hs({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Ts || (Ts = e.createElement("path", {
    d: "M12 8v8m-4-4h8m-8.2 9h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Z"
  }))),
  paint: t => e.createElement("svg", Is({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Ls || (Ls = e.createElement("path", {
    d: "M3 13h17m-8-9.5L10.5 2m1 1 8.868 8.869c.396.396.594.594.668.822a1 1 0 0 1 0 .618c-.074.228-.272.426-.668.822l-5.474 5.475c-1.188 1.188-1.782 1.782-2.467 2.004a3 3 0 0 1-1.854 0c-.685-.222-1.28-.816-2.468-2.004l-3.211-3.212c-1.188-1.188-1.782-1.782-2.005-2.467a3 3 0 0 1 0-1.854c.223-.685.817-1.28 2.005-2.467L11.499 3Z"
  }))),
  divider: t => e.createElement("svg", _s({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Fs || (Fs = e.createElement("path", {
    d: "M3 12h.01m4.49 0h.01m8.99 0h.01M12 12h.01M21 12h.01M21 21v-.8c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C19.48 17 18.92 17 17.8 17H6.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C3 18.52 3 19.08 3 20.2v.8M21 3v.8c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C19.48 7 18.92 7 17.8 7H6.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C3 5.48 3 4.92 3 3.8V3"
  }))),
  expand02: t => e.createElement("svg", Ds({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Zs || (Zs = e.createElement("path", {
    d: "M3 21 21 3M3 21h6m-6 0v-6M21 3h-6m6 0v6"
  }))),
  imageindentright: t => e.createElement("svg", Us({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), qs || (qs = e.createElement("path", {
    d: "M21 4H3m18 16H3M9 9.25H3m6 5.5H3M14.6 16h4.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C21 15.24 21 14.96 21 14.4V9.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C20.24 8 19.96 8 19.4 8h-4.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C13 8.76 13 9.04 13 9.6v4.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C13.76 16 14.04 16 14.6 16Z"
  }))),
  cameraoff: t => e.createElement("svg", zs({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), $s || ($s = e.createElement("path", {
    d: "M5 5h.419c.133 0 .2 0 .26-.004a2 2 0 0 0 1.735-1.25c.023-.056.044-.12.086-.246.042-.127.063-.19.086-.246a2 2 0 0 1 1.735-1.25C9.38 2 9.448 2 9.58 2h4.838c.133 0 .2 0 .26.004a2 2 0 0 1 1.735 1.25c.023.056.044.12.086.246.042.127.063.19.086.246a2 2 0 0 0 1.735 1.25c.06.004.131.004.273.004.37 0 .554 0 .702.015a3 3 0 0 1 2.69 2.69c.014.147.014.322.014.672V18a2.998 2.998 0 0 1-1.439 2.562m-5.497-5.49A4 4 0 0 0 9.43 9.434M22 22 2 2m0 5.5v8.7c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 21 5.12 21 6.8 21h8.7M12 16.5a4 4 0 0 1-4-4"
  }))),
  settings02: t => e.createElement("svg", Gs({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Ws || (Ws = e.createElement("path", {
    d: "m9.395 19.371.584 1.315a2.213 2.213 0 0 0 4.045 0l.584-1.315a2.426 2.426 0 0 1 2.47-1.423l1.43.152a2.212 2.212 0 0 0 2.023-3.502l-.847-1.164a2.43 2.43 0 0 1-.46-1.434c0-.513.162-1.014.464-1.429l.847-1.163a2.21 2.21 0 0 0-.785-3.274 2.212 2.212 0 0 0-1.237-.228l-1.43.152a2.434 2.434 0 0 1-1.47-.312 2.426 2.426 0 0 1-1-1.117l-.59-1.315a2.212 2.212 0 0 0-4.044 0L9.395 4.63c-.207.468-.557.86-1 1.117-.445.256-.96.365-1.47.312l-1.434-.152a2.212 2.212 0 0 0-2.023 3.502l.847 1.163a2.43 2.43 0 0 1 0 2.858l-.847 1.163a2.21 2.21 0 0 0 .786 3.273c.381.195.811.274 1.237.23l1.43-.153a2.434 2.434 0 0 1 2.474 1.43Z"
  })), Qs || (Qs = e.createElement("path", {
    d: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
  }))),
  transform: t => e.createElement("svg", Ks({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Ys || (Ys = e.createElement("path", {
    d: "M19 7v10M5 7v10M17 5H7m10 14H7M4.6 7h.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C7 6.24 7 5.96 7 5.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C6.24 3 5.96 3 5.4 3h-.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 3.76 3 4.04 3 4.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C3.76 7 4.04 7 4.6 7Zm0 14h.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C7 20.24 7 19.96 7 19.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C6.24 17 5.96 17 5.4 17h-.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 17.76 3 18.04 3 18.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C3.76 21 4.04 21 4.6 21Zm14-14h.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C21 6.24 21 5.96 21 5.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C20.24 3 19.96 3 19.4 3h-.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C17 3.76 17 4.04 17 4.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C17.76 7 18.04 7 18.6 7Zm0 14h.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C21 20.24 21 19.96 21 19.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C20.24 17 19.96 17 19.4 17h-.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C17 17.76 17 18.04 17 18.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C17.76 21 18.04 21 18.6 21Z"
  }))),
  volumemin: t => e.createElement("svg", Js({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Xs || (Xs = e.createElement("path", {
    d: "M18.245 8a6.968 6.968 0 0 1 1.255 4 6.967 6.967 0 0 1-1.255 4m-6.11-10.634L8.968 8.53c-.173.173-.26.26-.36.322a1 1 0 0 1-.29.12C8.204 9 8.082 9 7.837 9H6.1c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C4.5 9.76 4.5 10.04 4.5 10.6v2.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C5.26 15 5.54 15 6.1 15h1.737c.245 0 .367 0 .482.028a1 1 0 0 1 .29.12c.1.061.187.148.36.32l3.165 3.166c.429.429.643.643.827.657a.5.5 0 0 0 .42-.174c.119-.14.119-.443.119-1.048V5.93c0-.606 0-.908-.12-1.049a.5.5 0 0 0-.42-.173c-.183.014-.397.228-.826.657Z"
  }))),
  logout04: t => e.createElement("svg", tc({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ec || (ec = e.createElement("path", {
    d: "m18 8 4 4m0 0-4 4m4-4H9m6-7.796A8.383 8.383 0 0 0 10.667 3C5.88 3 2 7.03 2 12s3.88 9 8.667 9A8.384 8.384 0 0 0 15 19.796"
  }))),
  stars01: t => e.createElement("svg", nc({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), rc || (rc = e.createElement("path", {
    d: "m6.5 13 .784 1.569c.266.53.399.796.576 1.026a3 3 0 0 0 .545.545c.23.177.495.31 1.026.575L11 17.5l-1.569.785c-.53.265-.796.398-1.026.575a3 3 0 0 0-.545.545c-.177.23-.31.495-.576 1.026L6.5 22l-.784-1.569c-.266-.53-.399-.796-.576-1.026a3 3 0 0 0-.545-.545c-.23-.177-.495-.31-1.026-.575L2 17.5l1.569-.785c.53-.265.796-.398 1.026-.575a3 3 0 0 0 .545-.545c.177-.23.31-.495.576-1.026L6.5 13ZM15 2l1.179 3.064c.282.734.423 1.1.642 1.409a3 3 0 0 0 .706.706c.309.22.675.36 1.409.642L22 9l-3.064 1.179c-.734.282-1.1.423-1.409.642a3 3 0 0 0-.706.706c-.22.309-.36.675-.642 1.409L15 16l-1.179-3.064c-.282-.734-.423-1.1-.642-1.409a3 3 0 0 0-.706-.706c-.309-.22-.675-.36-1.409-.642L8 9l3.064-1.179c.734-.282 1.1-.423 1.409-.642a3 3 0 0 0 .706-.706c.22-.309.36-.675.642-1.409L15 2Z"
  }))),
  airpods: t => e.createElement("svg", oc({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ac || (ac = e.createElement("path", {
    d: "M2 7.625a4.125 4.125 0 0 0 4.125 4.125c.306 0 .459 0 .538.027a.445.445 0 0 1 .31.31c.027.08.027.203.027.452v6.336a1.625 1.625 0 1 0 3.25 0V7.625a4.125 4.125 0 0 0-8.25 0ZM22 7.625a4.125 4.125 0 0 1-4.125 4.125c-.306 0-.459 0-.538.027a.445.445 0 0 0-.31.31c-.027.08-.027.203-.027.452v6.336a1.625 1.625 0 1 1-3.25 0V7.625a4.125 4.125 0 1 1 8.25 0Z"
  }))),
  usersquare: t => e.createElement("svg", lc({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ic || (ic = e.createElement("path", {
    d: "M4 21.817C4.603 22 5.416 22 6.8 22h10.4c1.384 0 2.197 0 2.8-.183m-16 0a2.18 2.18 0 0 1-.362-.144 3 3 0 0 1-1.311-1.311C2 19.72 2 18.88 2 17.2V6.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C4.28 2 5.12 2 6.8 2h10.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C22 4.28 22 5.12 22 6.8v10.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311 2.18 2.18 0 0 1-.362.144m-16 0c0-.809.005-1.237.077-1.597a4 4 0 0 1 3.143-3.143C7.606 17 8.07 17 9 17h6c.93 0 1.394 0 1.78.077a4 4 0 0 1 3.143 3.143c.072.36.077.788.077 1.597M16 9.5a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
  }))),
  droplets02: t => e.createElement("svg", cc({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), sc || (sc = e.createElement("path", {
    d: "M12 21.5a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5C11.5 5 10 7.4 8 9c-2 1.6-3 3.5-3 5.5a7 7 0 0 0 7 7Z"
  }))),
  italic01: t => e.createElement("svg", hc({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), uc || (uc = e.createElement("path", {
    d: "M19 4h-9m4 16H5M15 4 9 20"
  }))),
  layersthree02: t => e.createElement("svg", pc({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), mc || (mc = e.createElement("path", {
    d: "M7 9.5 2 12l9.642 4.821c.131.066.197.099.266.111.06.012.123.012.184 0 .069-.012.135-.045.266-.11L22 12l-5-2.5m-10 5L2 17l9.642 4.821c.131.066.197.099.266.111.06.012.123.012.184 0 .069-.012.135-.045.266-.11L22 17l-5-2.5M2 7l9.642-4.821c.131-.066.197-.098.266-.111a.5.5 0 0 1 .184 0c.069.013.135.045.266.11L22 7l-9.642 4.821c-.131.066-.197.099-.266.111a.501.501 0 0 1-.184 0c-.069-.012-.135-.045-.266-.11L2 7Z"
  }))),
  shield02: t => e.createElement("svg", dc({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), fc || (fc = e.createElement("path", {
    d: "M11.302 21.615c.221.13.332.194.488.227.122.026.298.026.42 0 .156-.033.267-.098.488-.227C14.646 20.479 20 16.909 20 12V8.2c0-1.074 0-1.61-.166-1.992a1.746 1.746 0 0 0-.68-.837c-.34-.24-1.005-.378-2.336-.655-1.467-.305-2.594-.856-3.624-1.653-.494-.382-.74-.573-.934-.625a.842.842 0 0 0-.52 0c-.194.052-.44.243-.934.625-1.03.797-2.157 1.348-3.624 1.653-1.33.277-1.996.415-2.336.655-.345.244-.512.45-.68.837C4 6.59 4 7.126 4 8.2V12c0 4.909 5.354 8.479 7.302 9.615Z"
  }))),
  bold01: t => e.createElement("svg", gc({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), vc || (vc = e.createElement("path", {
    d: "M6 12h8a4 4 0 0 0 0-8H6v8Zm0 0h9a4 4 0 0 1 0 8H6v-8Z"
  }))),
  cloud02: t => e.createElement("svg", wc({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), bc || (bc = e.createElement("path", {
    d: "M6 19a4 4 0 0 1-.999-7.874L5 11a7 7 0 0 1 13.96-.758A4.502 4.502 0 0 1 17.5 19H6Z"
  }))),
  speedometer01: t => e.createElement("svg", xc({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), yc || (yc = e.createElement("path", {
    d: "M12 2v2.5M12 2C6.477 2 2 6.477 2 12M12 2c5.523 0 10 4.477 10 10m-10 7.5V22m0 0c5.523 0 10-4.477 10-10M12 22C6.477 22 2 17.523 2 12m2.5 0H2m20 0h-2.5m-.422 7.078-1.773-1.773M4.922 19.078l1.775-1.775M4.922 5l1.736 1.736M19.078 5 13.5 10.5M14 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
  }))),
  piechart03: t => e.createElement("svg", Ec({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Oc || (Oc = e.createElement("path", {
    d: "M12 2a10 10 0 0 1 10 10M12 2v10m0-10C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10M12 2c5.523 0 10 4.477 10 10m0 0H12m10 0a10 10 0 0 1-4.122 8.09L12 12"
  }))),
  mooneclipse: t => e.createElement("svg", Cc({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), jc || (jc = e.createElement("path", {
    d: "M20.002 6A10.006 10.006 0 0 1 20 18.002M12 22a9.96 9.96 0 0 0 4.38-1.008 9 9 0 1 1 0-17.984A9.96 9.96 0 0 0 12 2C6.477 2 2 6.477 2 12s4.477 10 10 10Z"
  }))),
  terminalcircle: t => e.createElement("svg", Mc({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Pc || (Pc = e.createElement("path", {
    d: "m7 15 3-3-3-3m6 6h4m5-3c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }))),
  bracketsslash: t => e.createElement("svg", Sc({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), kc || (kc = e.createElement("path", {
    d: "M18.57 20a2.286 2.286 0 0 0 2.287-2.286v-4.571L22 12l-1.143-1.143V6.286A2.285 2.285 0 0 0 18.57 4M5.429 4a2.285 2.285 0 0 0-2.286 2.286v4.571L2 12l1.143 1.143v4.571A2.285 2.285 0 0 0 5.429 20M9 17l6-10"
  }))),
  infohexagon: t => e.createElement("svg", Bc({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Nc || (Nc = e.createElement("path", {
    d: "M12 16v-4m0-4h.01M3 7.942v8.117c0 .342 0 .514.05.666a1 1 0 0 0 .215.364c.109.119.258.202.558.368l7.4 4.111c.284.158.425.237.575.268.133.027.27.027.403 0 .15-.031.292-.11.576-.268l7.4-4.11c.3-.167.45-.25.558-.369a.999.999 0 0 0 .215-.364c.05-.152.05-.324.05-.666V7.942c0-.343 0-.514-.05-.667a1 1 0 0 0-.215-.364c-.109-.119-.258-.202-.558-.368l-7.4-4.111c-.284-.158-.425-.237-.575-.267a1 1 0 0 0-.403 0c-.15.03-.292.11-.576.267l-7.4 4.11c-.3.167-.45.25-.558.369a1 1 0 0 0-.215.364C3 7.428 3 7.599 3 7.942Z"
  }))),
  scissors02: t => e.createElement("svg", Rc({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Vc || (Vc = e.createElement("path", {
    d: "M4.5 8.6 21 17m0-10L4.5 15.4M6 3a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 12a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z"
  }))),
  creditcardminus: t => e.createElement("svg", Tc({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Ac || (Ac = e.createElement("path", {
    d: "M16 18h6m0-8H2m20 3.5V8.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 5 19.92 5 18.8 5H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 6.52 2 7.08 2 8.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 19 4.08 19 5.2 19H12"
  }))),
  piechart02: t => e.createElement("svg", Lc({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Hc || (Hc = e.createElement("path", {
    d: "M17.2 14c.277 0 .416 0 .528.062a.53.53 0 0 1 .22.243c.05.117.037.243.012.494A8 8 0 1 1 9.201 6.04c.251-.025.376-.038.494.012a.53.53 0 0 1 .243.22c.062.112.062.251.062.528v6.4c0 .28 0 .42.055.527a.5.5 0 0 0 .218.218c.107.055.247.055.527.055h6.4ZM14 2.8c0-.277 0-.416.062-.528a.53.53 0 0 1 .243-.22c.117-.05.243-.037.494-.012A8 8 0 0 1 21.96 9.2c.025.251.038.376-.012.494a.53.53 0 0 1-.22.243c-.113.062-.251.062-.528.062h-6.4c-.28 0-.42 0-.527-.055a.5.5 0 0 1-.218-.218C14 9.62 14 9.48 14 9.2V2.8Z"
  }))),
  voicemail: t => e.createElement("svg", Fc({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Ic || (Ic = e.createElement("path", {
    d: "M6 16h12M6 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm12 0a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
  }))),
  rocket02: t => e.createElement("svg", Zc({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), _c || (_c = e.createElement("path", {
    d: "m12 15-3-3m3 3a22.355 22.355 0 0 0 4-2m-4 2v5s3.03-.55 4-2c1.08-1.62 0-5 0-5m-7-1a21.999 21.999 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11m-7-1H4s.55-3.03 2-4c1.62-1.08 5 0 5 0m-6.5 8.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09Z"
  }))),
  cloud03: t => e.createElement("svg", qc({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Dc || (Dc = e.createElement("path", {
    d: "M9.5 19a7.5 7.5 0 1 1 6.641-10.988A5.5 5.5 0 1 1 16.5 19h-7Z"
  }))),
  annotationinfo: t => e.createElement("svg", $c({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Uc || (Uc = e.createElement("path", {
    d: "M12 14v-3.5M12 7h.01M9.9 19.2l1.46 1.947c.217.29.326.434.459.486a.5.5 0 0 0 .362 0c.133-.052.242-.197.459-.486L14.1 19.2c.293-.39.44-.586.619-.735a2 2 0 0 1 .822-.412c.226-.053.47-.053.959-.053 1.398 0 2.097 0 2.648-.228a3 3 0 0 0 1.624-1.624C21 15.597 21 14.898 21 13.5V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v5.7c0 1.398 0 2.097.228 2.648a3 3 0 0 0 1.624 1.624C5.403 18 6.102 18 7.5 18c.489 0 .733 0 .96.053a2 2 0 0 1 .821.412c.18.149.326.344.619.735Z"
  }))),
  checksquarebroken: t => e.createElement("svg", Wc({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), zc || (zc = e.createElement("path", {
    d: "m9 11 3 3L22 4m-6-1H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V12"
  }))),
  shield03: t => e.createElement("svg", Gc({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Qc || (Qc = e.createElement("path", {
    d: "M12 2.5v19m8-9.5c0 4.909-5.354 8.479-7.302 9.615-.221.13-.332.194-.488.227a1.137 1.137 0 0 1-.42 0c-.156-.033-.267-.098-.488-.227C9.354 20.479 4 16.909 4 12V7.218c0-.8 0-1.2.13-1.543a2 2 0 0 1 .548-.79c.276-.242.65-.383 1.398-.664l5.362-2.01c.208-.078.312-.117.419-.133a1 1 0 0 1 .286 0c.107.016.21.055.419.133l5.362 2.01c.748.281 1.123.422 1.398.665a2 2 0 0 1 .547.789c.131.343.131.743.131 1.543V12Z"
  }))),
  droplets03: t => e.createElement("svg", Kc({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Yc || (Yc = e.createElement("path", {
    d: "M12.56 6.08A10.97 10.97 0 0 0 14 2.5c.5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a6.98 6.98 0 0 1-11.91 4.97M7 15.78c2.2 0 4-1.83 4-4.05 0-1.16-.57-2.26-1.71-3.19-1.14-.93-2-2.31-2.29-3.76a6.585 6.585 0 0 1-2.29 3.76C3.56 9.46 3 10.58 3 11.73c0 2.22 1.8 4.05 4 4.05Z"
  }))),
  skew: t => e.createElement("svg", Jc({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Xc || (Xc = e.createElement("path", {
    d: "m19.714 7-1.428 10M6.143 7 4.357 17M18 5H8m8 14H6M5.6 7h.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C8 6.24 8 5.96 8 5.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C7.24 3 6.96 3 6.4 3h-.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C4 3.76 4 4.04 4 4.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C4.76 7 5.04 7 5.6 7Zm-2 14h.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C6 20.24 6 19.96 6 19.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C5.24 17 4.96 17 4.4 17h-.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C2 17.76 2 18.04 2 18.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C2.76 21 3.04 21 3.6 21Zm16-14h.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C22 6.24 22 5.96 22 5.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C21.24 3 20.96 3 20.4 3h-.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C18 3.76 18 4.04 18 4.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C18.76 7 19.04 7 19.6 7Zm-2 14h.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C20 20.24 20 19.96 20 19.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C19.24 17 18.96 17 18.4 17h-.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C16 17.76 16 18.04 16 18.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C16.76 21 17.04 21 17.6 21Z"
  }))),
  alarmclockplus: t => e.createElement("svg", tu({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), eu || (eu = e.createElement("path", {
    d: "M5 3 2 6m20 0-3-3M6 19l-2 2m14-2 2 2m-8-5v-6m-3 3h6m-3 8a8 8 0 1 0 0-16.001A8 8 0 0 0 12 21Z"
  }))),
  cloudsnowing01: t => e.createElement("svg", nu({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ru || (ru = e.createElement("path", {
    d: "M20 15.242a4.5 4.5 0 0 0-2.08-8.223 6.002 6.002 0 0 0-11.84 0A4.5 4.5 0 0 0 4 15.242M8 15h.01M8 19h.01M12 17h.01M12 21h.01M16 15h.01M16 19h.01"
  }))),
  arrownarrowupright: t => e.createElement("svg", ou({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), au || (au = e.createElement("path", {
    d: "M6 18 18 6m0 0h-8m8 0v8"
  }))),
  terminal: t => e.createElement("svg", lu({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), iu || (iu = e.createElement("path", {
    d: "m4 17 6-6-6-6m8 14h8"
  }))),
  layoutgrid02: t => e.createElement("svg", cu({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), su || (su = e.createElement("path", {
    d: "M3 9h18M3 15h18M12 3v18M7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3Z"
  }))),
  bracketsplus: t => e.createElement("svg", hu({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), uu || (uu = e.createElement("path", {
    d: "M18.57 20a2.286 2.286 0 0 0 2.287-2.286v-4.571L22 12l-1.143-1.143V6.286A2.285 2.285 0 0 0 18.57 4M5.429 4a2.285 2.285 0 0 0-2.286 2.286v4.571L2 12l1.143 1.143v4.571A2.285 2.285 0 0 0 5.429 20M12 8v8m-4-4h8"
  }))),
  lightning02: t => e.createElement("svg", pu({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), mu || (mu = e.createElement("path", {
    d: "M14.25 2H8.493c-.18 0-.27 0-.348.027a.5.5 0 0 0-.187.116c-.06.058-.1.139-.18.3l-4.2 8.4c-.192.383-.288.574-.265.73a.5.5 0 0 0 .208.337c.129.09.343.09.772.09h6.205l-3 10L19.694 9.355c.411-.426.617-.64.629-.822a.5.5 0 0 0-.177-.415C20.005 8 19.71 8 19.117 8h-7.118l2.25-6Z"
  }))),
  wind01: t => e.createElement("svg", du({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), fu || (fu = e.createElement("path", {
    d: "M21 18s-1.19-.47-2-.698c-5.12-1.445-8.88 2.84-14 1.396C4.19 18.469 3 18 3 18m18-6s-1.19-.47-2-.698c-5.12-1.445-8.88 2.84-14 1.396C4.19 12.469 3 12 3 12m18-6s-1.19-.47-2-.698c-5.12-1.445-8.88 2.84-14 1.396C4.19 6.47 3 6 3 6"
  }))),
  shieldtick: t => e.createElement("svg", gu({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), vu || (vu = e.createElement("path", {
    d: "m9 11.5 2 2L15.5 9m4.5 3c0 4.908-5.354 8.478-7.302 9.615-.221.129-.332.194-.488.227a1.137 1.137 0 0 1-.42 0c-.156-.034-.267-.098-.488-.227C9.354 20.478 4 16.908 4 12V7.217c0-.799 0-1.199.13-1.542a2 2 0 0 1 .548-.79c.276-.243.65-.383 1.398-.664l5.362-2.01c.208-.078.312-.117.419-.133a1 1 0 0 1 .286 0c.107.016.21.055.419.133l5.362 2.01c.748.28 1.123.421 1.398.664a2 2 0 0 1 .547.79c.131.343.131.743.131 1.542V12Z"
  }))),
  settings03: t => e.createElement("svg", wu({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), bu || (bu = e.createElement("path", {
    d: "M15.05 9H5.5a2.5 2.5 0 0 1 0-5h9.55m-6.1 16h9.55a2.5 2.5 0 0 0 0-5H8.95M3 17.5a3.5 3.5 0 1 0 7 0 3.5 3.5 0 0 0-7 0Zm18-11a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
  }))),
  move: t => e.createElement("svg", xu({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), yu || (yu = e.createElement("path", {
    d: "m5 9-3 3m0 0 3 3m-3-3h20M9 5l3-3m0 0 3 3m-3-3v20m3-3-3 3m0 0-3-3M19 9l3 3m0 0-3 3"
  }))),
  homesmile: t => e.createElement("svg", Eu({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Ou || (Ou = e.createElement("path", {
    d: "M8.126 14a4.002 4.002 0 0 0 7.748 0M11.018 2.764 4.235 8.039c-.453.353-.68.53-.843.75a2 2 0 0 0-.318.65C3 9.704 3 9.991 3 10.565V17.8c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C4.52 21 5.08 21 6.2 21h11.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C21 19.48 21 18.92 21 17.8v-7.235c0-.574 0-.861-.074-1.126a2.002 2.002 0 0 0-.318-.65c-.163-.22-.39-.397-.843-.75l-6.783-5.275c-.351-.273-.527-.41-.72-.462a1 1 0 0 0-.523 0c-.194.052-.37.189-.721.462Z"
  }))),
  alertsquare: t => e.createElement("svg", Cu({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ju || (ju = e.createElement("path", {
    d: "M12 8v4m0 4h.01M7.8 21h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Z"
  }))),
  navigationpointeroff02: t => e.createElement("svg", Mu({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Pu || (Pu = e.createElement("path", {
    d: "m10.471 5.476.792-1.806c.232-.528.348-.792.51-.872a.5.5 0 0 1 .446 0c.162.08.278.344.51.872l3.172 7.233M8.947 8.952l-4.965 11.32c-.257.585-.385.878-.329 1.057a.5.5 0 0 0 .327.326c.18.056.472-.072 1.056-.33l6.637-2.92c.12-.052.178-.078.24-.088.055-.01.11-.01.165 0 .062.01.121.036.24.088l6.637 2.92c.584.258.877.386 1.056.33a.5.5 0 0 0 .327-.326c.056-.18-.072-.472-.328-1.057l-.205-.465M22 22 2 2"
  }))),
  expand03: t => e.createElement("svg", Su({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ku || (ku = e.createElement("path", {
    d: "M21 14v2.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H14M10 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8V10m12-1 6-6m0 0h-6m6 0v6M9 15l-6 6m0 0h6m-6 0v-6"
  }))),
  griddotsleft: t => e.createElement("svg", Bu({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Nu || (Nu = e.createElement("path", {
    d: "M7.5 3h.01m-.01 9h.01m-.01 9h.01M16.5 3h.01m-.01 9h.01m-.01 9h.01M12 3h.01M12 12h.01M12 21h.01M12 16.5h.01m-.01-9h.01M21 3h.01M21 12h.01M21 21h.01M21 16.5h.01m-.01-9h.01M3 21V3"
  }))),
  chevronup: t => e.createElement("svg", Ru({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Vu || (Vu = e.createElement("path", {
    d: "m18 15-6-6-6 6"
  }))),
  key01: t => e.createElement("svg", Tu({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Au || (Au = e.createElement("path", {
    d: "M17 9c0-.512-.195-1.024-.586-1.414A1.994 1.994 0 0 0 15 7m0 8a6 6 0 1 0-5.946-5.193c.058.434.087.651.068.789a.853.853 0 0 1-.117.346c-.068.121-.187.24-.426.479l-5.11 5.11c-.173.173-.26.26-.322.36a1 1 0 0 0-.12.29C3 17.296 3 17.418 3 17.663V19.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C3.76 21 4.04 21 4.6 21H7v-2h2v-2h2l1.58-1.58c.238-.238.357-.357.478-.425a.852.852 0 0 1 .346-.117c.138-.02.355.01.789.068.264.036.533.054.807.054Z"
  }))),
  refreshcw01: t => e.createElement("svg", Lu({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Hu || (Hu = e.createElement("path", {
    d: "M21 10s-2.005-2.732-3.634-4.362a9 9 0 1 0 2.282 8.862M21 10V4m0 6h-6"
  }))),
  certificate01: t => e.createElement("svg", Fu({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Iu || (Iu = e.createElement("path", {
    d: "M6.5 20H5a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-1.5M12 19a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0 0h.021L8.83 22.193 6 19.364l3.02-3.02M12 19l3.193 3.193 2.828-2.829-3.02-3.02M9 6h6M7 9.5h10"
  }))),
  alignright02: t => e.createElement("svg", Zu({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), _u || (_u = e.createElement("path", {
    d: "M18 10c.932 0 1.398 0 1.765-.152a2 2 0 0 0 1.083-1.083C21 8.398 21 7.932 21 7c0-.932 0-1.398-.152-1.765a2 2 0 0 0-1.083-1.083C19.398 4 18.932 4 18 4h-8c-.932 0-1.398 0-1.765.152a2 2 0 0 0-1.083 1.083C7 5.602 7 6.068 7 7c0 .932 0 1.398.152 1.765a2 2 0 0 0 1.083 1.083C8.602 10 9.068 10 10 10h8ZM18 20c.932 0 1.398 0 1.765-.152a2 2 0 0 0 1.083-1.083C21 18.398 21 17.932 21 17c0-.932 0-1.398-.152-1.765a2 2 0 0 0-1.083-1.083C19.398 14 18.932 14 18 14H6c-.932 0-1.398 0-1.765.152a2 2 0 0 0-1.083 1.083C3 15.602 3 16.068 3 17c0 .932 0 1.398.152 1.765a2 2 0 0 0 1.083 1.083C4.602 20 5.068 20 6 20h12Z"
  }))),
  menu03: t => e.createElement("svg", qu({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Du || (Du = e.createElement("path", {
    d: "M3 12h18M3 6h18M3 18h12"
  }))),
  coinsswap01: t => e.createElement("svg", $u({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Uu || (Uu = e.createElement("path", {
    d: "m6 6 2-2m0 0L6 2m2 2H6a4 4 0 0 0-4 4m16 10-2 2m0 0 2 2m-2-2h2a4 4 0 0 0 4-4m-8.583-2.583a6 6 0 1 0-2.834-2.834M14 16a6 6 0 1 1-12 0 6 6 0 0 1 12 0Z"
  }))),
  arrowcirclebrokenleft: t => e.createElement("svg", Wu({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), zu || (zu = e.createElement("path", {
    d: "M20.662 17A9.996 9.996 0 0 1 12 22C6.477 22 2 17.523 2 12S6.477 2 12 2a9.996 9.996 0 0 1 8.662 5M12 8l-4 4m0 0 4 4m-4-4h14"
  }))),
  userup01: t => e.createElement("svg", Gu({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Qu || (Qu = e.createElement("path", {
    d: "m16 18 3-3m0 0 3 3m-3-3v6m-7-5.5H7.5c-1.396 0-2.093 0-2.661.172a4 4 0 0 0-2.667 2.667C2 18.907 2 19.604 2 21M14.5 7.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Z"
  }))),
  arrowcirclebrokenupright: t => e.createElement("svg", Ku({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Yu || (Yu = e.createElement("path", {
    d: "M2.34 14.59a9.996 9.996 0 0 1 2.589-9.661c3.905-3.905 10.237-3.905 14.142 0 3.905 3.905 3.905 10.237 0 14.142a9.996 9.996 0 0 1-9.66 2.59M15 15V9m0 0H9m6 0L5 19"
  }))),
  currencydollarcircle: t => e.createElement("svg", Ju({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Xu || (Xu = e.createElement("path", {
    d: "M8.5 14.667A2.333 2.333 0 0 0 10.833 17H13a2.5 2.5 0 0 0 0-5h-2a2.5 2.5 0 0 1 0-5h2.167A2.333 2.333 0 0 1 15.5 9.333M12 5.5V7m0 10v1.5M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }))),
  userx01: t => e.createElement("svg", th({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), eh || (eh = e.createElement("path", {
    d: "m16.5 16 5 5m0-5-5 5M12 15.5H7.5c-1.396 0-2.093 0-2.661.172a4 4 0 0 0-2.667 2.667C2 18.907 2 19.604 2 21M14.5 7.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Z"
  }))),
  arrowdownleft: t => e.createElement("svg", nh({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), rh || (rh = e.createElement("path", {
    d: "M17 7 7 17m0 0h10M7 17V7"
  }))),
  cryptocurrency03: t => e.createElement("svg", oh({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ah || (ah = e.createElement("path", {
    d: "m2 2 2 2m18-2-2 2m2 18-2-2M2 22l2-2m-2-4h1.5M8 2v1.5M22 8h-1.5M16 22v-1.5m2-4.5h3.5M16 2v4M2 8h4m2 14v-4m8-6a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
  }))),
  griddotstop: t => e.createElement("svg", lh({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ih || (ih = e.createElement("path", {
    d: "M3 21h.01M3 12h.01M3 16.5h.01M3 7.5h.01M7.5 21h.01m-.01-9h.01m8.99 9h.01m-.01-9h.01M12 21h.01M12 12h.01M12 16.5h.01m-.01-9h.01M21 21h.01M21 12h.01M21 16.5h.01m-.01-9h.01M21 3H3"
  }))),
  packageminus: t => e.createElement("svg", ch({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), sh || (sh = e.createElement("path", {
    d: "M20.5 7.278 12 12m0 0L3.5 7.278M12 12v9.5m2-.611-1.223.68c-.284.157-.425.236-.575.267a.998.998 0 0 1-.403 0c-.15-.031-.292-.11-.576-.268l-7.4-4.11c-.3-.167-.45-.25-.558-.369a1 1 0 0 1-.215-.364C3 16.573 3 16.401 3 16.06V7.942c0-.343 0-.514.05-.667a1 1 0 0 1 .215-.364c.109-.119.258-.202.558-.368l7.4-4.111c.284-.158.425-.237.576-.267a1 1 0 0 1 .402 0c.15.03.292.11.576.267l7.4 4.11c.3.167.45.25.558.369a1 1 0 0 1 .215.364c.05.153.05.324.05.667V13M7.5 4.5l9 5M16 18h6"
  }))),
  zapoff: t => e.createElement("svg", hh({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), uh || (uh = e.createElement("path", {
    d: "m8 8-3.907 4.688c-.348.418-.523.628-.525.804a.5.5 0 0 0 .185.397c.138.111.41.111.955.111H12l-1 8 5-6m-.35-6h3.642c.545 0 .817 0 .955.111a.5.5 0 0 1 .185.396c-.002.177-.177.387-.525.805L18.55 12.94m-7.977-8.027L13 2l-.6 4.798M21 21 3 3"
  }))),
  users02: t => e.createElement("svg", ph({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), mh || (mh = e.createElement("path", {
    d: "M16 3.468a4.5 4.5 0 0 1 0 8.064m2 5.234c1.512.684 2.872 1.799 4 3.234M2 20c1.946-2.477 4.59-4 7.5-4s5.553 1.523 7.5 4M14 7.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Z"
  }))),
  bellringing03: t => e.createElement("svg", dh({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), fh || (fh = e.createElement("path", {
    d: "M15 19a3 3 0 1 1-6 0m4.797-12.761a2.5 2.5 0 1 0-3.593 0M2.547 8.323a4.007 4.007 0 0 1 2.032-3.52m16.874 3.52a4.007 4.007 0 0 0-2.032-3.52m-1.42 6.397c0-1.38-.633-2.702-1.758-3.677C15.118 6.548 13.592 6 12 6c-1.591 0-3.117.548-4.242 1.523C6.632 8.498 6 9.821 6 11.2c0 2.282-.566 3.95-1.272 5.145-.804 1.36-1.207 2.041-1.19 2.204.017.186.05.244.202.355.131.096.794.096 2.118.096h12.284c1.325 0 1.987 0 2.119-.096.15-.11.184-.17.202-.355.016-.163-.386-.843-1.19-2.204C18.565 15.15 18 13.482 18 11.2Z"
  }))),
  x: t => e.createElement("svg", gh({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), vh || (vh = e.createElement("path", {
    d: "M17 7 7 17M7 7l10 10"
  }))),
  imageuserplus: t => e.createElement("svg", wh({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), bh || (bh = e.createElement("path", {
    d: "M19 8V2m-3 3h6m0 7v5.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C19.72 22 18.88 22 17.2 22H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 19.72 2 18.88 2 17.2V6.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C4.28 2 5.12 2 6.8 2H12M2.146 19.926A4.002 4.002 0 0 1 6 17h7c.93 0 1.394 0 1.78.077a4 4 0 0 1 3.143 3.143c.077.386.077.85.077 1.78M14 9.5a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
  }))),
  trendup02: t => e.createElement("svg", xh({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), yh || (yh = e.createElement("path", {
    d: "M7 17 17 7m0 0H7m10 0v10"
  }))),
  luggage02: t => e.createElement("svg", Eh({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Oh || (Oh = e.createElement("path", {
    d: "M16 7c0-.93 0-1.395-.102-1.776a3 3 0 0 0-2.121-2.122C13.395 3 12.93 3 12 3c-.93 0-1.395 0-1.777.102a3 3 0 0 0-2.12 2.122C8 5.605 8 6.07 8 7m4.8 10.5h4.9c.28 0 .42 0 .527-.055a.5.5 0 0 0 .218-.218c.055-.107.055-.247.055-.527v-2.4c0-.28 0-.42-.055-.527a.5.5 0 0 0-.218-.218c-.107-.055-.247-.055-.527-.055h-4.9c-.28 0-.42 0-.527.055a.5.5 0 0 0-.218.218C12 13.88 12 14.02 12 14.3v2.4c0 .28 0 .42.055.527a.5.5 0 0 0 .218.218c.107.055.247.055.527.055Zm-6 3.5h10.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 18.72 22 17.88 22 16.2v-4.4c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C19.72 7 18.88 7 17.2 7H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 9.28 2 10.12 2 11.8v4.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 21 5.12 21 6.8 21Z"
  }))),
  bellminus: t => e.createElement("svg", Ch({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), jh || (jh = e.createElement("path", {
    d: "M9.354 21c.705.622 1.631 1 2.646 1 1.014 0 1.94-.378 2.646-1M15 5h6m-8-2.916A6 6 0 0 0 6 8c0 3.09-.78 5.206-1.65 6.605-.735 1.18-1.102 1.771-1.089 1.936.015.182.054.252.2.36.133.099.731.099 1.928.099H18.61c1.196 0 1.794 0 1.927-.098.147-.11.186-.179.2-.361.014-.165-.353-.755-1.088-1.935-.773-1.243-1.475-3.052-1.622-5.606"
  }))),
  clipboarddownload: t => e.createElement("svg", Mh({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Ph || (Ph = e.createElement("path", {
    d: "M12 11v6m0 0-3-3m3 3 3-3m1-10c.93 0 1.395 0 1.776.102a3 3 0 0 1 2.122 2.122C20 6.605 20 7.07 20 8v9.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C17.72 22 16.88 22 15.2 22H8.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.72 4 18.88 4 17.2V8c0-.93 0-1.395.102-1.776a3 3 0 0 1 2.122-2.122C6.605 4 7.07 4 8 4m1.6 2h4.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C16 5.24 16 4.96 16 4.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C15.24 2 14.96 2 14.4 2H9.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C8 2.76 8 3.04 8 3.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C8.76 6 9.04 6 9.6 6Z"
  }))),
  briefcase02: t => e.createElement("svg", Sh({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), kh || (kh = e.createElement("path", {
    d: "M8 21V7c0-.93 0-1.395.102-1.776a3 3 0 0 1 2.121-2.122C10.605 3 11.07 3 12 3c.93 0 1.395 0 1.777.102a3 3 0 0 1 2.12 2.122C16 5.605 16 6.07 16 7v14M5.2 21h13.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C22 19.48 22 18.92 22 17.8v-7.6c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 7 19.92 7 18.8 7H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 8.52 2 9.08 2 10.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 21 4.08 21 5.2 21Z"
  }))),
  file06: t => e.createElement("svg", Bh({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Nh || (Nh = e.createElement("path", {
    d: "M14 2.27V6.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437c.214.11.494.11 1.054.11h4.13M16 13H8m8 4H8m2-8H8m6-7H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 19.72 20 18.88 20 17.2V8l-6-6Z"
  }))),
  dice2: t => e.createElement("svg", Rh({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Vh || (Vh = e.createElement("path", {
    d: "M15.25 8.75h.005m-6.505 6.5h.005M7.8 21h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Zm7.7-12.25a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM9 15.25a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Z"
  }))),
  messagealertcircle: t => e.createElement("svg", Th({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Ah || (Ah = e.createElement("path", {
    d: "M12.5 11V7.5m0 7h.01M12.5 20a8.5 8.5 0 1 0-8.057-5.783c.108.32.162.481.172.604a.899.899 0 0 1-.028.326c-.03.12-.098.245-.232.494l-1.636 3.027c-.233.432-.35.648-.324.815a.5.5 0 0 0 .234.35c.144.087.388.062.876.011l5.121-.529c.155-.016.233-.024.303-.021.07.002.12.009.187.024.069.016.155.05.329.116A8.478 8.478 0 0 0 12.5 20Z"
  }))),
  volumeplus: t => e.createElement("svg", Lh({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Hh || (Hh = e.createElement("path", {
    d: "M18.5 15.5v-7M15 12h7M9.634 5.366 6.47 8.53c-.173.173-.26.26-.36.322a1 1 0 0 1-.29.12C5.704 9 5.582 9 5.337 9H3.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C2 9.76 2 10.04 2 10.6v2.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C2.76 15 3.04 15 3.6 15h1.737c.245 0 .367 0 .482.028a1 1 0 0 1 .29.12c.1.061.187.148.36.32l3.165 3.166c.429.429.643.643.827.657a.5.5 0 0 0 .42-.174c.119-.14.119-.443.119-1.048V5.93c0-.606 0-.908-.12-1.049a.5.5 0 0 0-.42-.173c-.183.014-.397.228-.826.657Z"
  }))),
  target01: t => e.createElement("svg", Fh({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Ih || (Ih = e.createElement("path", {
    d: "M22 12c0 5.523-4.477 10-10 10m10-10c0-5.523-4.477-10-10-10m10 10h-4m-6 10C6.477 22 2 17.523 2 12m10 10v-4M2 12C2 6.477 6.477 2 12 2M2 12h4m6-10v4"
  }))),
  reflect01: t => e.createElement("svg", Zh({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), _h || (_h = e.createElement("path", {
    d: "M12 3v3m0 4.5v3m0 4.5v3M3.288 7.99l4.388 3.376c.28.216.42.324.47.455a.5.5 0 0 1 0 .358c-.05.131-.19.24-.47.455L3.288 16.01c-.414.319-.62.478-.794.476a.5.5 0 0 1-.387-.19C2 16.157 2 15.896 2 15.374v-6.75c0-.522 0-.783.107-.92a.5.5 0 0 1 .387-.19c.173-.002.38.157.794.476Zm17.424 0-4.388 3.376c-.28.216-.42.324-.47.455a.5.5 0 0 0 0 .358c.05.131.19.24.47.455l4.388 3.375c.414.319.62.478.794.476a.5.5 0 0 0 .386-.19c.108-.137.108-.398.108-.92v-6.75c0-.522 0-.783-.108-.92a.5.5 0 0 0-.386-.19c-.173-.002-.38.157-.794.476Z"
  }))),
  laptop02: t => e.createElement("svg", qh({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Dh || (Dh = e.createElement("path", {
    d: "M21 16V7.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C19.48 4 18.92 4 17.8 4H6.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C3 5.52 3 6.08 3 7.2V16m1.667 4h14.666c.62 0 .93 0 1.185-.068a2 2 0 0 0 1.414-1.414c.068-.255.068-.565.068-1.185 0-.31 0-.465-.034-.592a1 1 0 0 0-.707-.707C21.132 16 20.977 16 20.667 16H3.333c-.31 0-.465 0-.592.034a1 1 0 0 0-.707.707C2 16.868 2 17.023 2 17.333c0 .62 0 .93.068 1.185a2 2 0 0 0 1.414 1.414c.255.068.565.068 1.185.068Z"
  }))),
  flag02: t => e.createElement("svg", $h({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Uh || (Uh = e.createElement("path", {
    d: "M4 15s1-1 4-1 5 2 8 2 4-1 4-1V4s-1 1-4 1-5-2-8-2-4 1-4 1m0 18V2"
  }))),
  link01: t => e.createElement("svg", Wh({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), zh || (zh = e.createElement("path", {
    d: "m12.708 18.364-1.415 1.414a5 5 0 1 1-7.07-7.07l1.413-1.415m12.728 1.414 1.415-1.414a5 5 0 0 0-7.071-7.071l-1.415 1.414M8.5 15.5l7-7"
  }))),
  pentool01: t => e.createElement("svg", Gh({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Qh || (Qh = e.createElement("path", {
    d: "m18 13-1.3-6.498c-.072-.363-.108-.545-.197-.692a1 1 0 0 0-.312-.325c-.144-.094-.324-.138-.684-.225L2 2m0 0 3.26 13.507c.087.36.13.54.225.684a1 1 0 0 0 .325.312c.147.088.329.125.692.197L13 18M2 2l7.586 7.586m6.545 11.283 4.738-4.738c.396-.396.594-.594.668-.822a1 1 0 0 0 0-.618c-.074-.228-.272-.426-.668-.822l-.738-.738c-.396-.396-.594-.594-.822-.668a1 1 0 0 0-.618 0c-.228.074-.426.272-.822.668L13.13 17.87c-.396.396-.594.594-.668.822a1 1 0 0 0 0 .618c.074.228.272.426.668.822l.738.738c.396.396.594.594.822.668a1 1 0 0 0 .618 0c.228-.074.426-.272.822-.668ZM13 11a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
  }))),
  diamond02: t => e.createElement("svg", Kh({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Yh || (Yh = e.createElement("path", {
    d: "M5 22h14M2.5 8h19M10 2 8 8l4 10.5L16 8l-2-6m-1.408 16.349 8.94-9.834c.166-.182.249-.274.282-.378a.5.5 0 0 0 .006-.282c-.028-.106-.108-.2-.265-.39L17.24 2.288c-.088-.106-.132-.159-.186-.197a.5.5 0 0 0-.158-.074C16.832 2 16.763 2 16.626 2H7.375c-.138 0-.207 0-.27.017a.5.5 0 0 0-.158.074 1.08 1.08 0 0 0-.187.197L2.446 7.465c-.158.19-.237.284-.265.39a.5.5 0 0 0 .006.282c.033.104.116.196.282.378l8.94 9.834c.205.226.307.338.428.38a.5.5 0 0 0 .327 0c.12-.041.223-.154.428-.38Z"
  }))),
  arrowsquareright: t => e.createElement("svg", Jh({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Xh || (Xh = e.createElement("path", {
    d: "m12 16 4-4m0 0-4-4m4 4H8m-.2 9h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Z"
  }))),
  checkverified01: t => e.createElement("svg", tm({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), em || (em = e.createElement("path", {
    d: "m9 12 2 2 4.5-4.5M7.334 3.819a3.832 3.832 0 0 0 2.18-.904 3.832 3.832 0 0 1 4.972 0c.613.523 1.376.84 2.18.904a3.832 3.832 0 0 1 3.515 3.515c.064.804.38 1.567.904 2.18a3.832 3.832 0 0 1 0 4.972 3.832 3.832 0 0 0-.904 2.18 3.832 3.832 0 0 1-3.515 3.515 3.832 3.832 0 0 0-2.18.904 3.832 3.832 0 0 1-4.972 0 3.832 3.832 0 0 0-2.18-.904 3.832 3.832 0 0 1-3.515-3.515 3.832 3.832 0 0 0-.904-2.18 3.832 3.832 0 0 1 0-4.972c.523-.613.84-1.376.904-2.18a3.832 3.832 0 0 1 3.515-3.515Z"
  }))),
  plane: t => e.createElement("svg", nm({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), rm || (rm = e.createElement("path", {
    d: "M17.745 2.813a2.483 2.483 0 0 1 3.58 3.442l-2.78 2.91c-.217.228-.326.342-.393.475a1 1 0 0 0-.104.38c-.01.148.025.302.096.61l1.728 7.487c.072.315.109.473.097.626a1 1 0 0 1-.11.386c-.072.136-.186.25-.415.479l-.37.37c-.607.607-.91.91-1.22.965a1 1 0 0 1-.77-.182c-.253-.188-.389-.594-.66-1.408l-2.01-6.029-3.345 3.345c-.2.2-.3.3-.367.418a1 1 0 0 0-.117.336c-.022.134-.006.274.025.555l.184 1.653c.03.28.046.42.025.554a1.003 1.003 0 0 1-.118.337c-.067.117-.167.217-.366.417l-.198.198c-.473.473-.71.71-.972.778a1 1 0 0 1-.69-.069c-.244-.118-.43-.397-.8-.953L6.106 18.54c-.066-.1-.1-.149-.138-.194a.999.999 0 0 0-.111-.112c-.045-.038-.095-.071-.194-.138L3.31 16.528c-.557-.371-.835-.557-.954-.8a1 1 0 0 1-.068-.69c.069-.263.305-.5.778-.973l.198-.197c.2-.2.3-.3.417-.366.104-.06.218-.1.336-.118.134-.022.274-.006.555.025l1.653.184c.28.03.421.046.555.025a.998.998 0 0 0 .336-.118c.118-.067.218-.166.417-.366l3.346-3.345-6.03-2.01c-.813-.271-1.22-.407-1.407-.66a1 1 0 0 1-.182-.77c.055-.31.358-.613.964-1.22l.37-.37c.23-.23.344-.344.48-.414a1 1 0 0 1 .386-.111c.153-.012.31.024.626.097l7.459 1.721c.31.072.465.108.614.097a1 1 0 0 0 .412-.122c.132-.072.242-.186.464-.415l2.71-2.799Z"
  }))),
  flag03: t => e.createElement("svg", om({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), am || (am = e.createElement("path", {
    d: "M4 13h15.587c.462 0 .694 0 .826-.097a.5.5 0 0 0 .202-.357c.015-.163-.104-.361-.342-.758l-2.026-3.376c-.09-.15-.135-.225-.152-.305a.5.5 0 0 1 0-.214c.017-.08.062-.155.152-.305l2.026-3.376c.238-.397.357-.595.342-.758a.5.5 0 0 0-.202-.357C20.28 3 20.049 3 19.587 3H4v18"
  }))),
  chevronright: t => e.createElement("svg", lm({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), im || (im = e.createElement("path", {
    d: "m9 18 6-6-6-6"
  }))),
  messagenotificationsquare: t => e.createElement("svg", cm({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), sm || (sm = e.createElement("path", {
    d: "M11 4H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 6.28 3 7.12 3 8.8V14c0 .93 0 1.395.102 1.777a3 3 0 0 0 2.122 2.12C5.605 18 6.07 18 7 18v2.335c0 .533 0 .8.11.937a.5.5 0 0 0 .39.188c.176 0 .384-.167.8-.5l2.385-1.908c.487-.39.731-.585 1.002-.724.241-.122.497-.212.762-.267.299-.061.61-.061 1.235-.061H15.2c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 15.72 20 14.88 20 13.2V13m.121-9.121A3 3 0 1 1 15.88 8.12 3 3 0 0 1 20.12 3.88Z"
  }))),
  clipboard: t => e.createElement("svg", hm({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), um || (um = e.createElement("path", {
    d: "M16 4c.93 0 1.395 0 1.776.102a3 3 0 0 1 2.122 2.122C20 6.605 20 7.07 20 8v9.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C17.72 22 16.88 22 15.2 22H8.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.72 4 18.88 4 17.2V8c0-.93 0-1.395.102-1.776a3 3 0 0 1 2.122-2.122C6.605 4 7.07 4 8 4m1.6 2h4.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C16 5.24 16 4.96 16 4.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C15.24 2 14.96 2 14.4 2H9.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C8 2.76 8 3.04 8 3.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C8.76 6 9.04 6 9.6 6Z"
  }))),
  equalnot: t => e.createElement("svg", pm({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), mm || (mm = e.createElement("path", {
    d: "M5 9h14M5 15h14m0-10L5 19"
  }))),
  messagesmilesquare: t => e.createElement("svg", dm({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), fm || (fm = e.createElement("path", {
    d: "M8.5 12.5S9.813 14 12 14c2.188 0 3.5-1.5 3.5-1.5m-.75-5h.01m-5.51 0h.01M7 18v2.335c0 .533 0 .8.11.937a.5.5 0 0 0 .39.188c.176 0 .384-.167.8-.5l2.385-1.908c.487-.39.731-.585 1.002-.724.241-.122.497-.212.762-.267.299-.061.61-.061 1.235-.061H16.2c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 15.72 21 14.88 21 13.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8V14c0 .93 0 1.395.102 1.777a3 3 0 0 0 2.122 2.12C5.605 18 6.07 18 7 18Zm8.25-10.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm-5.5 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
  }))),
  package: t => e.createElement("svg", gm({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), vm || (vm = e.createElement("path", {
    d: "M20.5 7.278 12 12m0 0L3.5 7.278M12 12v9.5m9-5.441V7.942c0-.343 0-.514-.05-.667a1 1 0 0 0-.215-.364c-.109-.119-.258-.202-.558-.368l-7.4-4.111c-.284-.158-.425-.237-.575-.267a1 1 0 0 0-.403 0c-.15.03-.292.11-.576.267l-7.4 4.11c-.3.167-.45.25-.558.369a1 1 0 0 0-.215.364C3 7.428 3 7.599 3 7.942v8.117c0 .342 0 .514.05.666a1 1 0 0 0 .215.364c.109.119.258.202.558.368l7.4 4.111c.284.158.425.237.576.268.133.027.27.027.402 0 .15-.031.292-.11.576-.268l7.4-4.11c.3-.167.45-.25.558-.369a.999.999 0 0 0 .215-.364c.05-.152.05-.324.05-.666ZM16.5 9.5l-9-5"
  }))),
  reverseright: t => e.createElement("svg", wm({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), bm || (bm = e.createElement("path", {
    d: "M20 7H10a6 6 0 1 0 0 12h10m0-12-4-4m4 4-4 4"
  }))),
  flexalignright: t => e.createElement("svg", xm({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ym || (ym = e.createElement("path", {
    d: "M17.5 17.5v-11M7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3Z"
  }))),
  bell01: t => e.createElement("svg", Em({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Om || (Om = e.createElement("path", {
    d: "M9.354 21c.705.622 1.631 1 2.646 1 1.014 0 1.94-.378 2.646-1M18 8A6 6 0 0 0 6 8c0 3.09-.78 5.206-1.65 6.605-.735 1.18-1.102 1.771-1.089 1.936.015.182.054.252.2.36.133.099.731.099 1.928.099H18.61c1.196 0 1.794 0 1.927-.098.147-.11.186-.179.2-.361.014-.165-.353-.755-1.088-1.936C18.78 13.206 18 11.09 18 8Z"
  }))),
  dice3: t => e.createElement("svg", Cm({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), jm || (jm = e.createElement("path", {
    d: "M16.25 7.75h.005m-4.255 4h.005m-4.255 4.5h.005M7.8 21h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Zm8.7-13.25a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Zm-4.25 4a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM8 16.25a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Z"
  }))),
  translate02: t => e.createElement("svg", Mm({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Pm || (Pm = e.createElement("path", {
    d: "m5 8 5 5m-6 1 6-6 2-3M2 5h12M7 2h1m4.913 15h7.174m-7.174 0L11 21m1.913-4 2.865-5.991c.231-.483.347-.724.505-.8a.5.5 0 0 1 .434 0c.158.076.274.317.505.8L20.087 17m0 0L22 21"
  }))),
  typesquare: t => e.createElement("svg", Sm({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), km || (km = e.createElement("path", {
    d: "M8 7h8m-4 0v10m-4.2 4h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Z"
  }))),
  layoutalt01: t => e.createElement("svg", Bm({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Nm || (Nm = e.createElement("path", {
    d: "M3 9h18M9 9v12M7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3Z"
  }))),
  globe01: t => e.createElement("svg", Rm({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Vm || (Vm = e.createElement("path", {
    d: "M2 12h20M2 12c0 5.523 4.477 10 10 10M2 12C2 6.477 6.477 2 12 2m10 10c0 5.523-4.477 10-10 10m10-10c0-5.523-4.477-10-10-10m0 0a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10m0-20a15.3 15.3 0 0 0-4 10 15.3 15.3 0 0 0 4 10"
  }))),
  file07: t => e.createElement("svg", Tm({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Am || (Am = e.createElement("path", {
    d: "M14 2.27V6.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437c.214.11.494.11 1.054.11h4.13M8 15v3m8-5v5m-4-7.5V18m8-8.012V17.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C17.72 22 16.88 22 15.2 22H8.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.72 4 18.88 4 17.2V6.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C6.28 2 7.12 2 8.8 2h3.212c.733 0 1.1 0 1.446.083.306.073.598.195.867.36.303.185.562.444 1.08.963l3.19 3.188c.518.519.777.778.963 1.081a3 3 0 0 1 .36.867c.082.346.082.712.082 1.446Z"
  }))),
  alignverticalcenter02: t => e.createElement("svg", Lm({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Hm || (Hm = e.createElement("path", {
    d: "M10 18V6c0-.932 0-1.398-.152-1.765a2 2 0 0 0-1.083-1.083C8.398 3 7.932 3 7 3c-.932 0-1.398 0-1.765.152a2 2 0 0 0-1.083 1.083C4 4.602 4 5.068 4 6v12c0 .932 0 1.398.152 1.765a2 2 0 0 0 1.083 1.083C5.602 21 6.068 21 7 21c.932 0 1.398 0 1.765-.152a2 2 0 0 0 1.083-1.083C10 19.398 10 18.932 10 18ZM20 16V8c0-.932 0-1.398-.152-1.765a2 2 0 0 0-1.083-1.083C18.398 5 17.932 5 17 5c-.932 0-1.398 0-1.765.152a2 2 0 0 0-1.083 1.083C14 6.602 14 7.068 14 8v8c0 .932 0 1.398.152 1.765a2 2 0 0 0 1.083 1.083C15.602 19 16.068 19 17 19c.932 0 1.398 0 1.765-.152a2 2 0 0 0 1.083-1.083C20 17.398 20 16.932 20 16Z"
  }))),
  toggle03right: t => e.createElement("svg", _m({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Im || (Im = e.createElement("path", {
    d: "M2 12a6 6 0 0 1 6-6h8a6 6 0 0 1 0 12H8a6 6 0 0 1-6-6Z"
  })), Fm || (Fm = e.createElement("path", {
    d: "M16 14.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
  }))),
  terminalbrowser: t => e.createElement("svg", Dm({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Zm || (Zm = e.createElement("path", {
    d: "M22 9H2m4 8.5L8.5 15 6 12.5m5 5h4M2 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 21 5.12 21 6.8 21h10.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 18.72 22 17.88 22 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C19.72 3 18.88 3 17.2 3H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 5.28 2 6.12 2 7.8Z"
  }))),
  heading02: t => e.createElement("svg", Um({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), qm || (qm = e.createElement("path", {
    d: "M6 4v16M18 4v16M9.5 4v16m2-16H4m14 8H9.5m2 8H4m16 0h-4m4-16h-4"
  }))),
  luggage03: t => e.createElement("svg", zm({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), $m || ($m = e.createElement("path", {
    d: "M8 21V7c0-.93 0-1.395.102-1.776a3 3 0 0 1 2.121-2.122C10.605 3 11.07 3 12 3c.93 0 1.395 0 1.777.102a3 3 0 0 1 2.12 2.122C16 5.605 16 6.07 16 7v6.5m0 4V21m-9.2 0h10.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 18.72 22 17.88 22 16.2v-4.4c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C19.72 7 18.88 7 17.2 7H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 9.28 2 10.12 2 11.8v4.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 21 5.12 21 6.8 21Zm6-3.5h4.9c.28 0 .42 0 .527-.055a.5.5 0 0 0 .218-.218c.055-.107.055-.247.055-.527v-2.4c0-.28 0-.42-.055-.527a.5.5 0 0 0-.218-.218c-.107-.055-.247-.055-.527-.055h-4.9c-.28 0-.42 0-.527.055a.5.5 0 0 0-.218.218C12 13.88 12 14.02 12 14.3v2.4c0 .28 0 .42.055.527a.5.5 0 0 0 .218.218c.107.055.247.055.527.055Z"
  }))),
  fileminus01: t => e.createElement("svg", Qm({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Wm || (Wm = e.createElement("path", {
    d: "M20 11.941V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 2 16.88 2 15.2 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22H14m1-5h6"
  }))),
  cornerdownright: t => e.createElement("svg", Ym({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Gm || (Gm = e.createElement("path", {
    d: "M4 4v1.4c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C8.56 15 10.24 15 13.6 15H20m0 0-5-5m5 5-5 5"
  }))),
  arrowright: t => e.createElement("svg", Xm({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Km || (Km = e.createElement("path", {
    d: "M5 12h14m0 0-7-7m7 7-7 7"
  }))),
  annotationdots: t => e.createElement("svg", ep({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Jm || (Jm = e.createElement("path", {
    d: "M7.5 10.5h.01m4.49 0h.01m4.49 0h.01M9.9 19.2l1.46 1.947c.217.29.326.434.459.486a.5.5 0 0 0 .362 0c.133-.052.242-.197.459-.486L14.1 19.2c.293-.39.44-.586.619-.735a2 2 0 0 1 .822-.412c.226-.053.47-.053.959-.053 1.398 0 2.097 0 2.648-.228a3 3 0 0 0 1.624-1.624C21 15.597 21 14.898 21 13.5V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v5.7c0 1.398 0 2.097.228 2.648a3 3 0 0 0 1.624 1.624C5.403 18 6.102 18 7.5 18c.489 0 .733 0 .96.053a2 2 0 0 1 .821.412c.18.149.326.344.619.735ZM8 10.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm4.5 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm4.5 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
  }))),
  fingerprint04: t => e.createElement("svg", rp({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), tp || (tp = e.createElement("path", {
    d: "m5.807 18.53.054-.089A13.916 13.916 0 0 0 8 11a4 4 0 1 1 8 0c0 1.017-.07 2.019-.203 3m-2.118 6.844A21.88 21.88 0 0 0 15.171 17m3.839 1.132c.645-2.266.99-4.659.99-7.132A8 8 0 0 0 8 4.07M3 15.364c.64-1.319 1-2.8 1-4.364 0-1.457.39-2.823 1.07-4M12 11c0 3.517-1.009 6.799-2.753 9.571"
  }))),
  shoppingcart01: t => e.createElement("svg", ap({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), np || (np = e.createElement("path", {
    d: "M2 2h1.306c.246 0 .37 0 .468.045a.5.5 0 0 1 .213.185c.059.092.076.213.111.457L4.571 6m0 0 1.052 7.731c.134.982.2 1.472.435 1.841a2 2 0 0 0 .853.745c.398.183.893.183 1.883.183h8.558c.942 0 1.414 0 1.799-.17a2 2 0 0 0 .841-.696c.239-.346.327-.81.503-1.735l1.324-6.95c.062-.325.093-.488.048-.615a.5.5 0 0 0-.22-.266C21.532 6 21.366 6 21.034 6H4.571ZM10 21a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm8 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
  }))),
  annotationalert: t => e.createElement("svg", ip({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), op || (op = e.createElement("path", {
    d: "M12 10.5V7m0 7h.01M9.9 19.2l1.46 1.947c.217.29.326.434.459.486a.5.5 0 0 0 .362 0c.133-.052.242-.197.459-.486L14.1 19.2c.293-.39.44-.586.619-.735a2 2 0 0 1 .822-.412c.226-.053.47-.053.959-.053 1.398 0 2.097 0 2.648-.228a3 3 0 0 0 1.624-1.624C21 15.597 21 14.898 21 13.5V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v5.7c0 1.398 0 2.097.228 2.648a3 3 0 0 0 1.624 1.624C5.403 18 6.102 18 7.5 18c.489 0 .733 0 .96.053a2 2 0 0 1 .821.412c.18.149.326.344.619.735Z"
  }))),
  users03: t => e.createElement("svg", sp({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), lp || (lp = e.createElement("path", {
    d: "M18 15.837c1.456.731 2.704 1.905 3.615 3.373.18.29.27.436.302.637.063.409-.216.912-.597 1.073-.188.08-.398.08-.82.08M16 11.532a4.5 4.5 0 0 0 0-8.064M14 7.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM2.56 18.938C4.152 16.545 6.67 15 9.5 15s5.346 1.545 6.94 3.938c.35.525.524.787.504 1.122-.015.26-.186.58-.395.738-.267.202-.635.202-1.371.202H3.822c-.736 0-1.104 0-1.372-.202a1.109 1.109 0 0 1-.395-.738c-.02-.335.155-.597.504-1.122Z"
  }))),
  bellringing02: t => e.createElement("svg", up({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), cp || (cp = e.createElement("path", {
    d: "M14 21h-4M2.294 5.82A4.007 4.007 0 0 1 4.326 2.3m17.377 3.52A4.007 4.007 0 0 0 19.67 2.3M18 8A6 6 0 1 0 6 8c0 3.09-.78 5.206-1.65 6.605-.735 1.18-1.102 1.771-1.088 1.936.015.182.053.252.2.36.133.099.73.099 1.927.099h13.222c1.197 0 1.795 0 1.927-.098.147-.11.186-.179.201-.361.013-.165-.354-.755-1.088-1.936C18.78 13.206 18 11.09 18 8Z"
  }))),
  toggle01left: t => e.createElement("svg", mp({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), hp || (hp = e.createElement("path", {
    d: "M7 17h10a5 5 0 0 0 0-10H7m0 10A5 5 0 0 1 7 7m0 10A5 5 0 0 0 7 7"
  }))),
  stopcircle: t => e.createElement("svg", dp({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), pp || (pp = e.createElement("path", {
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z"
  })), fp || (fp = e.createElement("path", {
    d: "M8 9.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C8.76 8 9.04 8 9.6 8h4.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C16 8.76 16 9.04 16 9.6v4.8c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437C15.24 16 14.96 16 14.4 16H9.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C8 15.24 8 14.96 8 14.4V9.6Z"
  }))),
  cpuchip01: t => e.createElement("svg", gp({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), vp || (vp = e.createElement("path", {
    d: "M9 2v2m6-2v2M9 20v2m6-2v2m5-13h2m-2 5h2M2 9h2m-2 5h2m4.8 6h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 17.72 20 16.88 20 15.2V8.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 4 16.88 4 15.2 4H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 6.28 4 7.12 4 8.8v6.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 20 7.12 20 8.8 20Zm1.8-5h2.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C15 14.24 15 13.96 15 13.4v-2.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C14.24 9 13.96 9 13.4 9h-2.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C9 9.76 9 10.04 9 10.6v2.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C9.76 15 10.04 15 10.6 15Z"
  }))),
  lifebuoy02: t => e.createElement("svg", wp({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), bp || (bp = e.createElement("path", {
    d: "M8.464 8.464 4.93 4.93m0 14.142 3.535-3.536m7.072 0 3.535 3.536m0-14.142-3.536 3.535M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-5 0a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z"
  }))),
  telescope: t => e.createElement("svg", xp({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), yp || (yp = e.createElement("path", {
    d: "M13.122 14.845 18 22m-7.121-7.155L6 22m8-8.8a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm3.149-8.668L5.365 7.69c-.27.072-.406.109-.495.189a.5.5 0 0 0-.155.267c-.025.118.011.253.084.524l.88 3.284c.072.27.109.405.189.495a.5.5 0 0 0 .268.154c.117.025.252-.011.523-.083l11.784-3.158-1.294-4.83ZM21.793 9.5c-1.082.29-1.623.434-2.093.335a2 2 0 0 1-1.07-.618c-.322-.357-.466-.898-.756-1.98l-.156-.58c-.29-1.082-.434-1.623-.335-2.092a2 2 0 0 1 .618-1.07c.357-.322.898-.467 1.98-.757.27-.072.406-.109.523-.084a.5.5 0 0 1 .268.155c.08.09.116.224.189.495l1.398 5.216c.072.27.108.406.083.523a.5.5 0 0 1-.154.268c-.09.08-.225.116-.495.189Zm-18.29 2.83 1.351-.362c.27-.073.406-.11.495-.19a.5.5 0 0 0 .155-.267c.025-.117-.011-.253-.084-.523l-.362-1.352c-.073-.27-.109-.406-.19-.495a.5.5 0 0 0-.267-.155c-.117-.025-.253.011-.523.084l-1.352.362c-.27.073-.406.109-.495.19a.5.5 0 0 0-.155.267c-.025.117.011.253.084.523l.362 1.352c.073.27.109.406.19.495a.5.5 0 0 0 .267.155c.117.025.253-.011.523-.084Z"
  }))),
  thermometerwarm: t => e.createElement("svg", Ep({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Op || (Op = e.createElement("path", {
    d: "M12 9a4 4 0 0 0-2 7.5M12 3v2M6.6 18.4l-1.4 1.4M4 13H2m4.6-5.4L5.2 6.2M20 14.535V4a2 2 0 1 0-4 0v10.535a4 4 0 1 0 4 0Z"
  }))),
  shoppingcart03: t => e.createElement("svg", Cp({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), jp || (jp = e.createElement("path", {
    d: "M5 14h13.136c1.013 0 1.52 0 1.922-.189a2 2 0 0 0 .858-.768c.232-.38.288-.883.4-1.89l.585-5.265c.035-.307.052-.46.002-.58a.5.5 0 0 0-.22-.246C21.57 5 21.416 5 21.106 5H4.5M2 2h1.248c.265 0 .397 0 .5.05a.5.5 0 0 1 .217.204c.057.1.065.232.082.496l.906 14.5c.017.264.025.396.082.496a.5.5 0 0 0 .216.204c.104.05.236.05.5.05H19M7.5 21.5h.01m8.99 0h.01M8 21.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm9 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
  }))),
  users01: t => e.createElement("svg", Mp({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Pp || (Pp = e.createElement("path", {
    d: "M22 21v-2a4.002 4.002 0 0 0-3-3.874M15.5 3.291a4.001 4.001 0 0 1 0 7.418M17 21c0-1.864 0-2.796-.305-3.53a4 4 0 0 0-2.164-2.165C13.796 15 12.864 15 11 15H8c-1.864 0-2.796 0-3.53.305a4 4 0 0 0-2.166 2.164C2 18.204 2 19.136 2 21M13.5 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
  }))),
  arrowblockdown: t => e.createElement("svg", Sp({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), kp || (kp = e.createElement("path", {
    d: "M9 3.8c0-.28 0-.42.055-.527a.5.5 0 0 1 .218-.219C9.38 3 9.52 3 9.8 3h4.4c.28 0 .42 0 .527.054a.5.5 0 0 1 .218.219C15 3.38 15 3.52 15 3.8V14h4l-7 7-7-7h4V3.8Z"
  }))),
  gitpullrequest: t => e.createElement("svg", Bp({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Np || (Np = e.createElement("path", {
    d: "M18 15a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm0 0V8a2 2 0 0 0-2-2h-3M6 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0 0v12"
  }))),
  fileminus03: t => e.createElement("svg", Rp({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Vp || (Vp = e.createElement("path", {
    d: "M14 2.27V6.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437c.214.11.494.11 1.054.11h4.13M9 15h6M14 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 19.72 20 18.88 20 17.2V8l-6-6Z"
  }))),
  luggage01: t => e.createElement("svg", Tp({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Ap || (Ap = e.createElement("path", {
    d: "M8 22v-2m1.5-5V7M16 22v-2m-1.5-5V7M8.8 20h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 17.72 20 16.88 20 15.2V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 2 16.88 2 15.2 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 20 7.12 20 8.8 20Z"
  }))),
  trendup01: t => e.createElement("svg", Lp({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Hp || (Hp = e.createElement("path", {
    d: "m22 7-7.869 7.869c-.396.396-.594.594-.822.668a1 1 0 0 1-.618 0c-.228-.074-.426-.272-.822-.668L9.13 12.13c-.396-.396-.594-.594-.822-.668a1 1 0 0 0-.618 0c-.228.074-.426.272-.822.668L2 17M22 7h-7m7 0v7"
  }))),
  minussquare: t => e.createElement("svg", Fp({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Ip || (Ip = e.createElement("path", {
    d: "M8 12h8m-8.2 9h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Z"
  }))),
  briefcase01: t => e.createElement("svg", Zp({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), _p || (_p = e.createElement("path", {
    d: "M16 7c0-.93 0-1.395-.102-1.776a3 3 0 0 0-2.121-2.122C13.395 3 12.93 3 12 3c-.93 0-1.395 0-1.777.102a3 3 0 0 0-2.12 2.122C8 5.605 8 6.07 8 7M5.2 21h13.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C22 19.48 22 18.92 22 17.8v-7.6c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 7 19.92 7 18.8 7H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 8.52 2 9.08 2 10.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 21 4.08 21 5.2 21Z"
  }))),
  file05: t => e.createElement("svg", qp({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Dp || (Dp = e.createElement("path", {
    d: "M14 2.27V6.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437c.214.11.494.11 1.054.11h4.13M14 17H8m8-4H8m12-3.012V17.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C17.72 22 16.88 22 15.2 22H8.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.72 4 18.88 4 17.2V6.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C6.28 2 7.12 2 8.8 2h3.212c.733 0 1.1 0 1.446.083.306.073.598.195.867.36.303.185.562.444 1.08.963l3.19 3.188c.518.519.777.778.963 1.081a3 3 0 0 1 .36.867c.082.346.082.712.082 1.446Z"
  }))),
  globe03: t => e.createElement("svg", $p({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Up || (Up = e.createElement("path", {
    d: "M12 2c3 2 3.923 6.292 4 10-.077 3.708-1 8-4 10m0-20C9 4 8.077 8.292 8 12c.077 3.708 1 8 4 10m0-20C6.477 2 2 6.477 2 12M12 2c5.523 0 10 4.477 10 10M12 22c5.523 0 10-4.477 10-10M12 22C6.477 22 2 17.523 2 12m20 0c-2 3-6.292 3.923-10 4-3.708-.077-8-1-10-4m20 0c-2-3-6.292-3.923-10-4-3.708.077-8 1-10 4"
  }))),
  currencyrupee: t => e.createElement("svg", Wp({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), zp || (zp = e.createElement("path", {
    d: "M6 3h12M6 8h12m-3.5 13L6 13h3c6.667 0 6.667-10 0-10"
  }))),
  layoutalt03: t => e.createElement("svg", Gp({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Qp || (Qp = e.createElement("path", {
    d: "M17.5 17h-11m11-4h-11M3 9h18M7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3Z"
  }))),
  thumbsdown: t => e.createElement("svg", Kp({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Yp || (Yp = e.createElement("path", {
    d: "M17 2v11m5-3.2V5.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 2 19.92 2 18.8 2H8.118c-1.461 0-2.192 0-2.782.267A3 3 0 0 0 4.06 3.361c-.354.542-.465 1.265-.687 2.71l-.523 3.4c-.293 1.904-.44 2.857-.157 3.598a3 3 0 0 0 1.32 1.539C4.704 15 5.667 15 7.595 15H8.4c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437c.11.214.11.494.11 1.054v2.934A2.466 2.466 0 0 0 12.465 22c.325 0 .62-.191.751-.488l3.36-7.562c.154-.344.23-.516.35-.642a1 1 0 0 1 .384-.249c.164-.059.352-.059.729-.059h.76c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C22 11.48 22 10.92 22 9.8Z"
  }))),
  dice1: t => e.createElement("svg", Jp({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Xp || (Xp = e.createElement("path", {
    d: "M12 11.75h.005M7.8 21h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Zm4.45-9.25a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Z"
  }))),
  lightbulb04: t => e.createElement("svg", tf({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ef || (ef = e.createElement("path", {
    d: "M9.5 22h5M10 10h4m-2 0v6m3-.674a7 7 0 1 0-6 0V16c0 .932 0 1.398.152 1.765a2 2 0 0 0 1.083 1.083C10.602 19 11.068 19 12 19c.932 0 1.398 0 1.765-.152a2 2 0 0 0 1.083-1.083C15 17.398 15 16.932 15 16v-.674Z"
  }))),
  messageplussquare: t => e.createElement("svg", nf({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), rf || (rf = e.createElement("path", {
    d: "M12 13.5v-6m-3 3h6M7 18v2.335c0 .533 0 .8.11.937a.5.5 0 0 0 .39.188c.176 0 .384-.167.8-.5l2.385-1.908c.487-.39.731-.585 1.002-.724.241-.122.497-.212.762-.267.299-.061.61-.061 1.235-.061H16.2c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 15.72 21 14.88 21 13.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8V14c0 .93 0 1.395.102 1.777a3 3 0 0 0 2.122 2.12C5.605 18 6.07 18 7 18Z"
  }))),
  bell03: t => e.createElement("svg", of({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), af || (af = e.createElement("path", {
    d: "M15 19a3 3 0 1 1-6 0m4.796-12.761a2.5 2.5 0 1 0-3.593 0M18 11.2c0-1.38-.632-2.702-1.758-3.677C15.117 6.548 13.591 6 12 6c-1.592 0-3.118.548-4.243 1.523C6.632 8.498 6 9.821 6 11.2c0 2.282-.566 3.95-1.272 5.145-.805 1.36-1.207 2.041-1.191 2.204.018.186.051.244.202.355.132.096.794.096 2.119.096h12.284c1.324 0 1.987 0 2.118-.096.151-.11.185-.17.203-.355.016-.163-.387-.843-1.191-2.204C18.566 15.15 18 13.482 18 11.2Z"
  }))),
  target02: t => e.createElement("svg", sf({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), lf || (lf = e.createElement("path", {
    d: "M22 12h-4M6 12H2m10-6V2m0 20v-4m8-6a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z"
  }))),
  faceidsquare: t => e.createElement("svg", uf({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), cf || (cf = e.createElement("path", {
    d: "M7.5 8v1.5m9-1.5v1.5M11 12.6c.8 0 1.5-.7 1.5-1.5V8m2.7 7.2c-1.8 1.8-4.7 1.8-6.5 0M3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8Z"
  }))),
  reflect02: t => e.createElement("svg", mf({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), hf || (hf = e.createElement("path", {
    d: "M12 3v3m0 4.5v3m0 4.5v3m10-9h-6.5m0 0 4 4m-4-4 4-4M2 12h6.5m0 0-4 4m4-4-4-4"
  }))),
  laptop01: t => e.createElement("svg", ff({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), pf || (pf = e.createElement("path", {
    d: "M3 16V7.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C4.52 4 5.08 4 6.2 4h11.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C21 5.52 21 6.08 21 7.2V16h-5.337c-.245 0-.367 0-.482.028a.998.998 0 0 0-.29.12c-.1.061-.187.148-.36.32l-.062.063c-.173.173-.26.26-.36.322a.998.998 0 0 1-.29.12c-.115.027-.237.027-.482.027h-2.674c-.245 0-.367 0-.482-.028a.998.998 0 0 1-.29-.12c-.1-.061-.187-.148-.36-.32l-.062-.063c-.173-.173-.26-.26-.36-.322a.998.998 0 0 0-.29-.12C8.704 16 8.582 16 8.337 16H3Zm0 0a1 1 0 0 0-1 1v.333c0 .62 0 .93.068 1.185a2 2 0 0 0 1.414 1.414c.255.068.565.068 1.185.068h14.666c.62 0 .93 0 1.185-.068a2 2 0 0 0 1.414-1.414c.068-.255.068-.565.068-1.185 0-.31 0-.465-.034-.592a1 1 0 0 0-.707-.707C21.132 16 20.977 16 20.667 16H20"
  }))),
  archive: t => e.createElement("svg", vf({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), df || (df = e.createElement("path", {
    d: "M4 7.997a2.295 2.295 0 0 1-.39-.035A2 2 0 0 1 2.038 6.39C2 6.197 2 5.965 2 5.5s0-.697.038-.89A2 2 0 0 1 3.61 3.038C3.803 3 4.035 3 4.5 3h15c.465 0 .697 0 .89.038a2 2 0 0 1 1.572 1.572c.038.193.038.425.038.89s0 .697-.038.89a2 2 0 0 1-1.572 1.572c-.107.02-.226.03-.39.035M10 13h4M4 8h16v8.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C17.72 21 16.88 21 15.2 21H8.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 18.72 4 17.88 4 16.2V8Z"
  }))),
  link02: t => e.createElement("svg", bf({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), gf || (gf = e.createElement("path", {
    d: "M9 17H7A5 5 0 0 1 7 7h2m6 10h2a5 5 0 0 0 0-10h-2m-8 5h10"
  }))),
  flag01: t => e.createElement("svg", yf({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), wf || (wf = e.createElement("path", {
    d: "M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1v19"
  }))),
  diamond01: t => e.createElement("svg", Of({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), xf || (xf = e.createElement("path", {
    d: "M2.5 9h19M10 3 8 9l4 11.5L16 9l-2-6m-1.386 17.262 8.959-10.75c.152-.182.227-.273.256-.375a.5.5 0 0 0 0-.274c-.029-.102-.104-.193-.256-.375l-4.334-5.2c-.088-.106-.132-.159-.186-.197a.5.5 0 0 0-.158-.074C16.831 3 16.763 3 16.625 3h-9.25c-.138 0-.207 0-.271.017a.5.5 0 0 0-.158.074 1.08 1.08 0 0 0-.186.197l-4.334 5.2c-.151.182-.227.273-.256.375a.5.5 0 0 0 0 .274c.029.102.105.193.256.375l8.959 10.75c.211.254.316.38.443.427a.5.5 0 0 0 .343 0c.127-.047.232-.173.443-.427Z"
  }))),
  pentool02: t => e.createElement("svg", jf({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Ef || (Ef = e.createElement("path", {
    d: "M13 6 6.502 7.3c-.363.072-.545.108-.692.197a1 1 0 0 0-.325.312c-.094.144-.138.324-.225.684L2 22m0 0 13.507-3.26c.36-.087.54-.13.684-.225a1 1 0 0 0 .312-.325c.088-.148.125-.329.197-.692L18 11M2 22l7.586-7.586m11.283-6.546L16.13 3.131c-.396-.396-.594-.594-.822-.668a1 1 0 0 0-.618 0c-.228.074-.426.272-.822.668l-.738.737c-.396.397-.594.595-.668.823a1 1 0 0 0 0 .618c.074.228.272.426.668.822l4.738 4.737c.396.396.594.595.822.669a1 1 0 0 0 .618 0c.228-.075.426-.273.822-.669l.738-.737c.396-.396.594-.594.668-.822a1 1 0 0 0 0-.618c-.074-.229-.272-.427-.668-.823ZM11 11a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z"
  }))),
  checkverified03: t => e.createElement("svg", Pf({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Cf || (Cf = e.createElement("path", {
    d: "m9 12 2 2 4.5-4.5M9.202 20.6a1.24 1.24 0 0 1 .92.247l1.203.924c.398.305.951.305 1.348 0l1.248-.959c.234-.179.528-.258.82-.219l1.561.206c.497.065.976-.212 1.168-.675l.601-1.453c.112-.272.328-.488.6-.6l1.453-.601c.464-.191.74-.671.675-1.168l-.198-1.505a1.24 1.24 0 0 1 .247-.92l.923-1.204a1.105 1.105 0 0 0 0-1.347l-.959-1.25a1.105 1.105 0 0 1-.219-.818l.206-1.562a1.108 1.108 0 0 0-.675-1.168l-1.453-.601a1.103 1.103 0 0 1-.6-.6l-.6-1.453a1.107 1.107 0 0 0-1.169-.675l-1.562.206a1.1 1.1 0 0 1-.817-.217l-1.25-.959a1.105 1.105 0 0 0-1.347 0l-1.249.959a1.115 1.115 0 0 1-.818.219L7.696 3.2a1.108 1.108 0 0 0-1.167.675l-.6 1.453a1.117 1.117 0 0 1-.6.6l-1.453.6c-.464.192-.74.671-.675 1.168l.206 1.562c.038.291-.041.585-.219.818l-.959 1.249a1.105 1.105 0 0 0 0 1.347l.959 1.25c.179.232.258.527.219.818L3.2 16.303c-.065.497.211.976.675 1.168l1.453.601c.272.112.488.328.6.6l.6 1.453c.192.464.672.74 1.169.675l1.504-.2Z"
  }))),
  checkverified02: t => e.createElement("svg", kf({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Mf || (Mf = e.createElement("path", {
    d: "m9 12 2 2 4.5-4.5m2.401-4.501c.206.498.601.893 1.1 1.1l1.744.723a2.033 2.033 0 0 1 1.1 2.656l-.722 1.744a2.03 2.03 0 0 0 0 1.556l.722 1.744a2.033 2.033 0 0 1-1.1 2.656L19 17.901A2.033 2.033 0 0 0 17.9 19l-.723 1.745a2.032 2.032 0 0 1-2.656 1.1l-1.744-.722a2.032 2.032 0 0 0-1.555 0l-1.745.723a2.033 2.033 0 0 1-2.654-1.1L6.1 19.001A2.033 2.033 0 0 0 5 17.9l-1.744-.723a2.033 2.033 0 0 1-1.1-2.654l.721-1.744a2.033 2.033 0 0 0 0-1.556l-.722-1.746a2.033 2.033 0 0 1 1.1-2.657L5 6.098c.498-.206.893-.6 1.1-1.098l.723-1.745a2.033 2.033 0 0 1 2.656-1.1l1.744.722a2.033 2.033 0 0 0 1.555-.001l1.746-.72a2.032 2.032 0 0 1 2.655 1.1l.723 1.746v-.003Z"
  }))),
  link03: t => e.createElement("svg", Nf({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Sf || (Sf = e.createElement("path", {
    d: "M10 13a5.002 5.002 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"
  }))),
  target03: t => e.createElement("svg", Vf({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Bf || (Bf = e.createElement("path", {
    d: "M22 12h-4M6 12H2m10-6V2m0 20v-4m8-6a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-5 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
  }))),
  bell02: t => e.createElement("svg", Af({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Rf || (Rf = e.createElement("path", {
    d: "M14 21h-4m8-13A6 6 0 0 0 6 8c0 3.09-.78 5.206-1.65 6.605-.735 1.18-1.102 1.771-1.089 1.936.015.182.054.252.2.36.133.099.731.099 1.928.099H18.61c1.196 0 1.794 0 1.927-.098.147-.11.186-.179.2-.361.014-.165-.353-.755-1.088-1.936C18.78 13.206 18 11.09 18 8Z"
  }))),
  lightbulb05: t => e.createElement("svg", Hf({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Tf || (Tf = e.createElement("path", {
    d: "M12 2v1m-9 9H2m3.5-6.5-.6-.6m13.6.6.6-.6M22 12h-1m-11 1.5h4m-2 0v5m3.5-1.626a6 6 0 1 0-7 0V18.8c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C10.02 22 10.58 22 11.7 22h.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874c.218-.428.218-.988.218-2.108v-1.926Z"
  }))),
  bellplus: t => e.createElement("svg", If({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Lf || (Lf = e.createElement("path", {
    d: "M9.354 21c.705.622 1.631 1 2.646 1 1.014 0 1.94-.378 2.646-1M18 8V2m-3 3h6m-8-2.916A6 6 0 0 0 6 8c0 3.09-.78 5.206-1.65 6.605-.735 1.18-1.102 1.771-1.089 1.936.015.182.054.252.2.36.133.099.731.099 1.928.099H18.61c1.196 0 1.794 0 1.927-.098.147-.11.186-.179.2-.361.014-.165-.354-.755-1.088-1.936-.492-.79-.955-1.81-1.264-3.105"
  }))),
  arrowsright: t => e.createElement("svg", _f({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Ff || (Ff = e.createElement("path", {
    d: "M4 7h11m0 0-4 4m4-4-4-4M4 17h16m0 0-4 4m4-4-4-4"
  }))),
  arrowcirclebrokendownleft: t => e.createElement("svg", Df({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Zf || (Zf = e.createElement("path", {
    d: "M9 9v6m0 0h6m-6 0L19 5m2.66 4.41a9.996 9.996 0 0 1-2.589 9.661c-3.905 3.905-10.237 3.905-14.142 0-3.905-3.905-3.905-10.237 0-14.142a9.996 9.996 0 0 1 9.66-2.59"
  }))),
  translate01: t => e.createElement("svg", Uf({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), qf || (qf = e.createElement("path", {
    d: "M12.913 17h7.174m-7.174 0L11 21m1.913-4 2.865-5.991c.231-.483.347-.724.505-.8a.5.5 0 0 1 .434 0c.158.076.274.317.505.8L20.087 17m0 0L22 21M2 5h6m0 0h3.5M8 5V3m3.5 2H14m-2.5 0c-.496 2.957-1.647 5.636-3.334 7.884M10 14a9.396 9.396 0 0 1-1.834-1.116m0 0C6.813 11.848 5.603 10.427 5 9m3.166 3.884A17.295 17.295 0 0 1 2 18"
  }))),
  cornerrightdown: t => e.createElement("svg", zf({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), $f || ($f = e.createElement("path", {
    d: "M3 4h3.4c3.36 0 5.04 0 6.324.654a6 6 0 0 1 2.622 2.622C16 8.56 16 10.24 16 13.6V20m0 0-5-5m5 5 5-5"
  }))),
  file04: t => e.createElement("svg", Qf({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Wf || (Wf = e.createElement("path", {
    d: "M14 2.27V6.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C14.76 8 15.04 8 15.6 8h4.13M20 9.988V17.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C17.72 22 16.88 22 15.2 22H8.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.72 4 18.88 4 17.2V6.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C6.28 2 7.12 2 8.8 2h3.212c.733 0 1.1 0 1.446.083.306.073.598.195.867.36.303.185.562.444 1.08.963l3.19 3.188c.518.519.777.778.963 1.081a3 3 0 0 1 .36.867c.082.346.082.712.082 1.446Z"
  }))),
  layoutalt02: t => e.createElement("svg", Yf({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Gf || (Gf = e.createElement("path", {
    d: "M17.5 11h-5m5 4h-5m5-8h-5M9 3v18M7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3Z"
  }))),
  globe02: t => e.createElement("svg", Xf({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Kf || (Kf = e.createElement("path", {
    d: "M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10m0-20a15.3 15.3 0 0 0-4 10 15.3 15.3 0 0 0 4 10m0-20C6.477 2 2 6.477 2 12s4.477 10 10 10m0-20c5.523 0 10 4.477 10 10s-4.477 10-10 10M2.5 9h19m-19 6h19"
  }))),
  usersdown: t => e.createElement("svg", ed({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Jf || (Jf = e.createElement("path", {
    d: "m16 18 3 3m0 0 3-3m-3 3v-6M15.5 3.29a4.001 4.001 0 0 1 0 7.42M12 15H8c-1.864 0-2.796 0-3.53.305a4 4 0 0 0-2.166 2.164C2 18.204 2 19.136 2 21M13.5 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
  }))),
  heading01: t => e.createElement("svg", rd({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), td || (td = e.createElement("path", {
    d: "M6 4v16M18 4v16M8 4H4m14 8H6m2 8H4m16 0h-4m4-16h-4"
  }))),
  alignverticalcenter01: t => e.createElement("svg", ad({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), nd || (nd = e.createElement("path", {
    d: "M3 12h18M12 2v6.5m0 0 4-4m-4 4-4-4M12 22v-6.5m0 0 4 4m-4-4-4 4"
  }))),
  paintpour: t => e.createElement("svg", id({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), od || (od = e.createElement("path", {
    d: "M16 11H2m8-7L8 2m6 20H2m20-6a2 2 0 1 1-4 0c0-1.105 2-3 2-3s2 1.895 2 3ZM9 3l6.868 6.869c.396.396.594.594.668.822a1 1 0 0 1 0 .618c-.074.228-.272.426-.668.822l-4.606 4.606c-.792.792-1.188 1.188-1.644 1.337a2 2 0 0 1-1.236 0c-.457-.149-.853-.545-1.645-1.337l-3.475-3.474c-.792-.792-1.188-1.188-1.336-1.645a2 2 0 0 1 0-1.236c.148-.457.544-.853 1.336-1.645L9 3Z"
  }))),
  zapcircle: t => e.createElement("svg", cd({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ld || (ld = e.createElement("path", {
    d: "m12 5.5-4.638 6.747c-.28.406-.42.609-.41.778a.5.5 0 0 0 .195.373c.135.102.38.102.874.102H12v5l4.638-6.747c.28-.406.42-.609.41-.778a.5.5 0 0 0-.195-.373c-.135-.102-.38-.102-.874-.102H12v-5Z"
  })), sd || (sd = e.createElement("path", {
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z"
  }))),
  repeat04: t => e.createElement("svg", hd({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ud || (ud = e.createElement("path", {
    d: "M12 20.5a8.5 8.5 0 0 0 5-15.375M13 22.4l-2-2 2-2M12 3.5a8.5 8.5 0 0 0-5 15.375M11 5.6l2-2-2-2"
  }))),
  bluetoothsignal: t => e.createElement("svg", pd({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), md || (md = e.createElement("path", {
    d: "m2 7 12 10-6 5V2l6 5L2 17M20.145 6.5a9.386 9.386 0 0 1 1.769 5.5 9.386 9.386 0 0 1-1.77 5.5M17 8.857c.621.891.986 1.975.986 3.143A5.475 5.475 0 0 1 17 15.143"
  }))),
  fileminus02: t => e.createElement("svg", dd({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), fd || (fd = e.createElement("path", {
    d: "M20 11.941V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 2 16.88 2 15.2 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22H14m0-11H8m2 4H8m8-8H8m7 10h6"
  }))),
  heartrounded: t => e.createElement("svg", gd({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), vd || (vd = e.createElement("path", {
    d: "M16.111 3C19.633 3 22 6.353 22 9.48 22 15.814 12.178 21 12 21c-.178 0-10-5.186-10-11.52C2 6.352 4.367 3 7.889 3 9.91 3 11.233 4.024 12 4.924 12.767 4.024 14.089 3 16.111 3Z"
  }))),
  messagedotscircle: t => e.createElement("svg", wd({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), bd || (bd = e.createElement("path", {
    d: "M7.5 12h.01M12 12h.01m4.49 0h.01M12 21a9 9 0 1 0-8.342-5.616c.081.2.122.3.14.381a.907.907 0 0 1 .024.219c0 .083-.015.173-.045.353l-.593 3.558c-.062.373-.093.56-.035.694a.5.5 0 0 0 .262.262c.135.058.321.027.694-.035l3.558-.593c.18-.03.27-.045.353-.045.081 0 .14.006.219.024.08.018.18.059.38.14A8.973 8.973 0 0 0 12 21Zm-4-9a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm4.5 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm4.5 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
  }))),
  skipforward: t => e.createElement("svg", xd({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), yd || (yd = e.createElement("path", {
    d: "M19 5v14M7.6 17.92l5.838-4.67c.534-.428.801-.641.898-.9a1 1 0 0 0 0-.7c-.097-.259-.364-.472-.898-.9L7.6 6.08C6.767 5.414 6.35 5.08 6 5.08a1 1 0 0 0-.783.377C5 5.73 5 6.263 5 7.329v9.342c0 1.066 0 1.599.218 1.872a1 1 0 0 0 .783.376c.35 0 .766-.333 1.599-.999Z"
  }))),
  bellringing01: t => e.createElement("svg", Ed({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Od || (Od = e.createElement("path", {
    d: "M9.354 21c.706.622 1.632 1 2.646 1 1.015 0 1.94-.378 2.646-1M2.294 5.82A4.007 4.007 0 0 1 4.326 2.3m17.376 3.52A4.007 4.007 0 0 0 19.67 2.3M18 8A6 6 0 1 0 6 8c0 3.09-.78 5.206-1.65 6.605-.735 1.18-1.102 1.771-1.088 1.936.014.182.053.252.2.36.133.099.73.099 1.927.099h13.222c1.197 0 1.795 0 1.927-.098.147-.11.186-.179.2-.361.014-.165-.353-.755-1.087-1.936C18.78 13.206 18 11.09 18 8Z"
  }))),
  shoppingcart02: t => e.createElement("svg", Cd({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), jd || (jd = e.createElement("path", {
    d: "M6.5 17h10.83c.95 0 1.424 0 1.811-.172a2 2 0 0 0 .844-.703c.238-.35.323-.818.493-1.753l1.35-7.429c.06-.324.089-.486.043-.612a.5.5 0 0 0-.22-.264C21.536 6 21.372 6 21.042 6H5.001M2 2h1.316c.243 0 .364 0 .463.044a.5.5 0 0 1 .212.182c.059.09.078.21.116.45l2.786 17.649c.038.24.057.36.116.45a.5.5 0 0 0 .212.18c.099.045.22.045.463.045H19"
  }))),
  creditcardplus: t => e.createElement("svg", Md({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Pd || (Pd = e.createElement("path", {
    d: "M19 21v-6m-3 3h6m0-8H2m20 2V8.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 5 19.92 5 18.8 5H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 6.52 2 7.08 2 8.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 19 4.08 19 5.2 19H12"
  }))),
  cpuchip02: t => e.createElement("svg", Sd({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), kd || (kd = e.createElement("path", {
    d: "M9 2v3m6-3v3M9 19v3m6-3v3m4-13h3m-3 5h3M2 9h3m-3 5h3m4.8 5h4.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C19 16.72 19 15.88 19 14.2V9.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C16.72 5 15.88 5 14.2 5H9.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C5 7.28 5 8.12 5 9.8v4.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C7.28 19 8.12 19 9.8 19Z"
  }))),
  lifebuoy01: t => e.createElement("svg", Bd({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Nd || (Nd = e.createElement("path", {
    d: "M9.136 9.136 4.93 4.93m0 14.142 4.239-4.239m5.693.032 4.207 4.207m0-14.142-4.24 4.24M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-6 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
  }))),
  save03: t => e.createElement("svg", Rd({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Vd || (Vd = e.createElement("path", {
    d: "M7 3h7.675c.489 0 .733 0 .963.055.204.05.4.13.579.24.201.123.374.296.72.642l3.126 3.126c.346.346.519.519.642.72.11.18.19.374.24.579.055.23.055.474.055.963V17m-8.5-7H8.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C7 9.24 7 8.96 7 8.4V6.5M13.5 21v-4.4c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C12.74 15 12.46 15 11.9 15H8.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C7 15.76 7 16.04 7 16.6V21m10.5-10.837V17.8c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C15.98 21 15.42 21 14.3 21H6.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C3 19.48 3 18.92 3 17.8V9.7c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C4.52 6.5 5.08 6.5 6.2 6.5h7.637c.245 0 .367 0 .482.028a1 1 0 0 1 .29.12c.1.061.187.148.36.32l2.062 2.063c.173.173.26.26.322.36.054.09.095.188.12.29.027.115.027.237.027.482Z"
  }))),
  thermometer02: t => e.createElement("svg", Hd({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Ad || (Ad = e.createElement("path", {
    d: "M14.5 4.5a2.5 2.5 0 0 0-5 0v9.258a4.5 4.5 0 1 0 5 0V4.5Z"
  })), Td || (Td = e.createElement("path", {
    d: "M12 18.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
  }))),
  arrownarrowleft: t => e.createElement("svg", Id({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Ld || (Ld = e.createElement("path", {
    d: "M20 12H4m0 0 6 6m-6-6 6-6"
  }))),
  facehappy: t => e.createElement("svg", _d({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Fd || (Fd = e.createElement("path", {
    d: "M15 9h.01M9 9h.01M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-6.5-3a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm-6 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm2.5 8.5c2.5 0 4.5-1.833 4.5-3.5h-9c0 1.667 2 3.5 4.5 3.5Z"
  }))),
  musicnote02: t => e.createElement("svg", Dd({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Zd || (Zd = e.createElement("path", {
    d: "M12 18V5.589c0-.857 0-1.286.18-1.544a1 1 0 0 1 .674-.416c.312-.046.695.145 1.462.529L18 6m-6 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
  }))),
  cursorclick01: t => e.createElement("svg", Ud({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), qd || (qd = e.createElement("path", {
    d: "M9 3.5V2M5.06 5.06 4 4m1.06 9L4 14.06m9-9L14.06 4M3.5 9H2m13.864 7.19-2.491 4.627c-.285.529-.427.793-.598.86a.5.5 0 0 1-.451-.044c-.155-.099-.243-.386-.42-.96L8.445 9.445c-.144-.468-.216-.703-.158-.861a.5.5 0 0 1 .297-.297c.158-.058.393.014.861.158l11.228 3.459c.574.177.86.265.96.42a.5.5 0 0 1 .044.45c-.067.172-.331.314-.86.599l-4.627 2.492c-.079.042-.118.063-.153.09a.493.493 0 0 0-.082.082c-.027.035-.048.074-.09.153Z"
  }))),
  bookmarkminus: t => e.createElement("svg", zd({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), $d || ($d = e.createElement("path", {
    d: "M9 10h6m4 11V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C16.72 3 15.88 3 14.2 3H9.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C5 5.28 5 6.12 5 7.8V21l7-4 7 4Z"
  }))),
  shuffle01: t => e.createElement("svg", Qd({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Wd || (Wd = e.createElement("path", {
    d: "m18 15 3 3m0 0-3 3m3-3h-2.431c-.94 0-1.409 0-1.835-.13a2.998 2.998 0 0 1-1.033-.552c-.345-.283-.605-.674-1.126-1.455l-.242-.363M18 3l3 3m0 0-3 3m3-3h-2.431c-.94 0-1.409 0-1.835.13a3 3 0 0 0-1.033.552c-.345.283-.605.674-1.126 1.455l-5.15 7.726c-.521.781-.782 1.172-1.126 1.455-.304.25-.655.438-1.033.552-.426.13-.896.13-1.835.13H3M3 6h2.431c.94 0 1.409 0 1.835.13a3 3 0 0 1 1.033.552c.344.283.605.674 1.126 1.455l.242.363"
  }))),
  strikethrough01: t => e.createElement("svg", Yd({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Gd || (Gd = e.createElement("path", {
    d: "M6 16a4 4 0 0 0 4 4h4a4 4 0 0 0 0-8m4-4a4 4 0 0 0-4-4h-4a4 4 0 0 0-4 4m-3 4h18"
  }))),
  alarmclock: t => e.createElement("svg", Xd({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Kd || (Kd = e.createElement("path", {
    d: "M5 3 2 6m20 0-3-3M6 19l-2 2m14-2 2 2M12 9v4l2 2m-2 6a8 8 0 1 0 0-16.001A8 8 0 0 0 12 21Z"
  }))),
  alarmclockoff: t => e.createElement("svg", ev({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Jd || (Jd = e.createElement("path", {
    d: "M10.5 5.142a7.999 7.999 0 0 1 9.358 9.358m-1.722 3.634A8 8 0 1 1 6.862 6.869M4 4 2 6m20 0-3-3M6 19l-2 2m17 0L3 3"
  }))),
  downloadcloud01: t => e.createElement("svg", rv({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), tv || (tv = e.createElement("path", {
    d: "M4 16.242A4.5 4.5 0 0 1 6.08 8.02a6.002 6.002 0 0 1 11.84 0A4.5 4.5 0 0 1 20 16.242M8 17l4 4m0 0 4-4m-4 4v-9"
  }))),
  lockkeyholesquare: t => e.createElement("svg", ov({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), nv || (nv = e.createElement("path", {
    d: "M16.2 21c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21h8.4Z"
  })), av || (av = e.createElement("path", {
    d: "M13.732 13.195c-.071-.212-.106-.318-.104-.404a.422.422 0 0 1 .056-.22c.04-.077.146-.176.36-.374a3 3 0 1 0-4.086 0c.212.198.319.297.358.374.042.08.054.129.056.22.002.086-.033.192-.104.404l-.917 2.752c-.119.355-.178.533-.142.675a.5.5 0 0 0 .216.3c.123.078.31.078.685.078h3.78c.375 0 .562 0 .685-.078a.5.5 0 0 0 .216-.3c.036-.142-.024-.32-.142-.675l-.917-2.752Z"
  }))),
  globe06: t => e.createElement("svg", lv({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), iv || (iv = e.createElement("path", {
    d: "m2.687 15.645 1.908-1.101a.5.5 0 0 1 .342-.059l3.754.703a.5.5 0 0 0 .592-.494l-.014-3.29a.5.5 0 0 1 .068-.254l1.895-3.244a.5.5 0 0 0-.023-.54l-3.19-4.54M19 4.859C13.5 7.5 16.5 11 17.5 11.5c1.877.938 4.488 1 4.488 1 .008-.166.012-.332.012-.5 0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10c.168 0 .334-.004.5-.012m4.258-.048L13.59 13.59l8.349 3.167-3.702 1.48-1.48 3.702Z"
  }))),
  searchrefraction: t => e.createElement("svg", cv({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), sv || (sv = e.createElement("path", {
    d: "m21 21-4.35-4.35M11 6a5 5 0 0 1 5 5m3 0a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z"
  }))),
  intersectsquare: t => e.createElement("svg", mv({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), uv || (uv = e.createElement("path", {
    d: "M2 5.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C3.52 2 4.08 2 5.2 2h7.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C16 3.52 16 4.08 16 5.2v7.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C14.48 16 13.92 16 12.8 16H5.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C2 14.48 2 13.92 2 12.8V5.2Z"
  })), hv || (hv = e.createElement("path", {
    d: "M8 11.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C9.52 8 10.08 8 11.2 8h7.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C22 9.52 22 10.08 22 11.2v7.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C20.48 22 19.92 22 18.8 22h-7.6c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C8 20.48 8 19.92 8 18.8v-7.6Z"
  }))),
  variable: t => e.createElement("svg", fv({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), pv || (pv = e.createElement("path", {
    d: "M19.906 21A20.253 20.253 0 0 0 22 12c0-3.233-.754-6.289-2.094-9M4.094 3A20.253 20.253 0 0 0 2 12c0 3.233.754 6.289 2.094 9M16.549 8.625h-.09c-.653 0-1.274.287-1.7.786l-5.374 6.303a2.233 2.233 0 0 1-1.7.786h-.09m1.12-7.875h1.394c.5 0 .939.333 1.076.816l1.774 6.243a1.12 1.12 0 0 0 1.077.816h1.394"
  }))),
  map01: t => e.createElement("svg", vv({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), dv || (dv = e.createElement("path", {
    d: "m9 18-7 4V6l7-4m0 16 7 4m-7-4V2m7 20 6-4V2l-6 4m0 16V6m0 0L9 2"
  }))),
  dice4: t => e.createElement("svg", bv({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), gv || (gv = e.createElement("path", {
    d: "M16.25 7.75h.005m-.005 8.5h.005M7.75 7.75h.005m-.005 8.5h.005M7.8 21h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Zm8.7-13.25a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Zm0 8.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM8 7.75a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Zm0 8.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Z"
  }))),
  train: t => e.createElement("svg", yv({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), wv || (wv = e.createElement("path", {
    d: "M9.5 22h5M8 2h8m-4 3V2M4 12h16m-3 7 1.5 3M7 19l-1.5 3m3-6.5h.01m6.99 0h.01M8.8 19h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 16.72 20 15.88 20 14.2V9.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 5 16.88 5 15.2 5H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 7.28 4 8.12 4 9.8v4.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 19 7.12 19 8.8 19Zm.2-3.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm7 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
  }))),
  arrowsquareupright: t => e.createElement("svg", Ov({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), xv || (xv = e.createElement("path", {
    d: "M15 15V9m0 0H9m6 0-6 6m-1.2 6h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Z"
  }))),
  lightbulb01: t => e.createElement("svg", jv({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Ev || (Ev = e.createElement("path", {
    d: "M15 16.5V19c0 .932 0 1.398-.152 1.765a2 2 0 0 1-1.083 1.083C13.398 22 12.932 22 12 22c-.932 0-1.398 0-1.765-.152a2 2 0 0 1-1.083-1.083C9 20.398 9 19.932 9 19v-2.5m6 0c2.649-1.157 4.5-3.925 4.5-7a7.5 7.5 0 0 0-15 0c0 3.075 1.851 5.843 4.5 7m6 0H9"
  }))),
  fileshield02: t => e.createElement("svg", Pv({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Cv || (Cv = e.createElement("path", {
    d: "M14 11H8m2 4H8m8-8H8m12 3V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 2 16.88 2 15.2 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22h3.7m5.5-1s3-1.43 3-3.575v-2.502l-2.188-.782a2.41 2.41 0 0 0-1.626 0L15 14.923v2.502C15 19.57 18 21 18 21Z"
  }))),
  flag04: t => e.createElement("svg", kv({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Mv || (Mv = e.createElement("path", {
    d: "M14 7h5.64c.448 0 .671 0 .802.094a.5.5 0 0 1 .205.348c.019.16-.09.356-.307.747l-1.346 2.422c-.08.142-.119.213-.134.288a.499.499 0 0 0 0 .202c.015.075.055.146.134.287l1.346 2.424c.217.39.326.586.307.746a.5.5 0 0 1-.205.348c-.13.094-.354.094-.802.094H12.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C11 14.24 11 13.96 11 13.4V11M4 21V4m0 7h8.4c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C14 10.24 14 9.96 14 9.4V4.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C13.24 3 12.96 3 12.4 3H5.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C4 3.76 4 4.04 4 4.6V11Z"
  }))),
  clocksnooze: t => e.createElement("svg", Nv({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Sv || (Sv = e.createElement("path", {
    d: "M16.5 17h5l-5 5h5m.45-9c.033-.329.05-.662.05-1 0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10a10.11 10.11 0 0 0 1-.05M12 6v6l3.738 1.87"
  }))),
  beziercurve02: t => e.createElement("svg", Vv({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Bv || (Bv = e.createElement("path", {
    d: "M10 20.263A8.513 8.513 0 0 1 3.737 14m16.527 0A8.514 8.514 0 0 1 14 20.263m0-16.526A8.513 8.513 0 0 1 20.264 10M3.737 10A8.513 8.513 0 0 1 10 3.737M3.6 14h.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C6 13.24 6 12.96 6 12.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C5.24 10 4.96 10 4.4 10h-.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C2 10.76 2 11.04 2 11.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C2.76 14 3.04 14 3.6 14Zm16 0h.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C22 13.24 22 12.96 22 12.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C21.24 10 20.96 10 20.4 10h-.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C18 10.76 18 11.04 18 11.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C18.76 14 19.04 14 19.6 14Zm-8-8h.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C14 5.24 14 4.96 14 4.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C13.24 2 12.96 2 12.4 2h-.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C10 2.76 10 3.04 10 3.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C10.76 6 11.04 6 11.6 6Zm0 16h.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C14 21.24 14 20.96 14 20.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C13.24 18 12.96 18 12.4 18h-.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C10 18.76 10 19.04 10 19.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C10.76 22 11.04 22 11.6 22Z"
  }))),
  colors: t => e.createElement("svg", Av({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Rv || (Rv = e.createElement("path", {
    d: "M12 20.472a6 6 0 1 0 5.58-10.262m-11.16 0a6 6 0 1 0 7.16 3.58M18 8A6 6 0 1 1 6 8a6 6 0 0 1 12 0Z"
  }))),
  contrast03: t => e.createElement("svg", Lv({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Tv || (Tv = e.createElement("path", {
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z"
  })), Hv || (Hv = e.createElement("path", {
    d: "M16 8.5a7.5 7.5 0 0 1-9.284 7.287 6.5 6.5 0 1 0 9.07-9.07c.14.571.214 1.168.214 1.783Z"
  }))),
  flash: t => e.createElement("svg", Fv({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Iv || (Iv = e.createElement("path", {
    d: "M13 2 4.093 12.688c-.348.418-.523.628-.526.804a.5.5 0 0 0 .186.397c.138.111.41.111.955.111H12l-1 8 8.906-10.688c.35-.418.524-.628.526-.804a.5.5 0 0 0-.185-.397c-.138-.111-.41-.111-.955-.111H12l1-8Z"
  }))),
  spacingwidth02: t => e.createElement("svg", Zv({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), _v || (_v = e.createElement("path", {
    d: "M21 21V3M3 21V3m3.5 9h11m0 3V9m-11 6V9"
  }))),
  phonecall02: t => e.createElement("svg", qv({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Dv || (Dv = e.createElement("path", {
    d: "M4.859 6A9.97 9.97 0 0 1 12 3a9.97 9.97 0 0 1 7.142 3m-2.67 3A5.985 5.985 0 0 0 12 7a5.985 5.985 0 0 0-4.472 2M12 17c1.51 0 2.96.258 4.31.731.044.016.067.024.102.04a1.045 1.045 0 0 1 .597.978c0 .233 0 .35.01.448a2 2 0 0 0 1.793 1.793c.098.01.215.01.447.01h.245c.461 0 .691 0 .883-.038a2 2 0 0 0 1.575-1.575c.038-.192.038-.422.038-.883v-.198c0-.475 0-.713-.05-.985-.114-.61-.557-1.363-1.033-1.759-.214-.177-.358-.257-.647-.418A16.924 16.924 0 0 0 12 13c-3.002 0-5.822.778-8.27 2.143-.289.162-.433.242-.647.42-.476.395-.919 1.149-1.032 1.758-.051.272-.051.51-.051.985v.198c0 .461 0 .691.038.883a2 2 0 0 0 1.575 1.575c.192.038.422.038.883.038h.245c.232 0 .349 0 .447-.01a2 2 0 0 0 1.794-1.793c.01-.098.01-.215.01-.448 0-.068 0-.102.002-.14.027-.35.273-.697.594-.839a1.22 1.22 0 0 1 .103-.039A12.98 12.98 0 0 1 12 17Z"
  }))),
  asterisk02: t => e.createElement("svg", $v({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Uv || (Uv = e.createElement("path", {
    d: "M12 4v16m6-14L6 18m14-6H4m14 6L6 6"
  }))),
  contrast02: t => e.createElement("svg", Qv({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), zv || (zv = e.createElement("path", {
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z"
  })), Wv || (Wv = e.createElement("path", {
    d: "M12 18.5a6.5 6.5 0 1 0 0-13v13Z"
  }))),
  umbrella01: t => e.createElement("svg", Yv({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Gv || (Gv = e.createElement("path", {
    d: "M17 19.4c0 1.436-1.12 2.6-2.5 2.6S12 20.836 12 19.4V12m-9.873-1.594C2.89 5.641 7.02 2 12 2c4.98 0 9.11 3.64 9.874 8.406.074.465.112.698.018.946a1.098 1.098 0 0 1-.44.516c-.23.132-.504.132-1.052.132H3.6c-.547 0-.821 0-1.052-.132a1.097 1.097 0 0 1-.44-.516c-.093-.248-.056-.48.019-.946Z"
  }))),
  medicalcross: t => e.createElement("svg", Xv({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Kv || (Kv = e.createElement("path", {
    d: "M15 4.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C14.24 3 13.96 3 13.4 3h-2.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C9 3.76 9 4.04 9 4.6v2.8c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437C8.24 9 7.96 9 7.4 9H4.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 9.76 3 10.04 3 10.6v2.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C3.76 15 4.04 15 4.6 15h2.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C9 15.76 9 16.04 9 16.6v2.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C9.76 21 10.04 21 10.6 21h2.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C15 20.24 15 19.96 15 19.4v-2.8c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C15.76 15 16.04 15 16.6 15h2.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C21 14.24 21 13.96 21 13.4v-2.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C20.24 9 19.96 9 19.4 9h-2.8c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C15 8.24 15 7.96 15 7.4V4.6Z"
  }))),
  creditcardlock: t => e.createElement("svg", eg({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Jv || (Jv = e.createElement("path", {
    d: "M20.25 17.5v-1.75a1.75 1.75 0 1 0-3.5 0v1.75M22 10H2m20 1V8.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 5 19.92 5 18.8 5H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 6.52 2 7.08 2 8.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 19 4.08 19 5.2 19H11m5.6 2.5h3.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C22 20.74 22 20.46 22 19.9v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437c-.214-.109-.494-.109-1.054-.109h-3.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C15 18.26 15 18.54 15 19.1v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437c.214.109.494.109 1.054.109Z"
  }))),
  arrownarrowup: t => e.createElement("svg", rg({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), tg || (tg = e.createElement("path", {
    d: "M12 20V4m0 0-6 6m6-6 6 6"
  }))),
  beziercurve03: t => e.createElement("svg", ag({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ng || (ng = e.createElement("path", {
    d: "M10.857 7 5.143 17M6 19h12m.857-2L13.143 7M3.6 21h.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C6 20.24 6 19.96 6 19.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C5.24 17 4.96 17 4.4 17h-.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C2 17.76 2 18.04 2 18.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C2.76 21 3.04 21 3.6 21Zm16 0h.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C22 20.24 22 19.96 22 19.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C21.24 17 20.96 17 20.4 17h-.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C18 17.76 18 18.04 18 18.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C18.76 21 19.04 21 19.6 21Zm-8-14h.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C14 6.24 14 5.96 14 5.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C13.24 3 12.96 3 12.4 3h-.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C10 3.76 10 4.04 10 4.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C10.76 7 11.04 7 11.6 7Z"
  }))),
  rss01: t => e.createElement("svg", ig({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), og || (og = e.createElement("path", {
    d: "M4 11a9 9 0 0 1 9 9M4 4a16 16 0 0 1 16 16M6 19a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
  }))),
  flag05: t => e.createElement("svg", sg({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), lg || (lg = e.createElement("path", {
    d: "M14.091 6.722h5.954c.472 0 .708 0 .846.1.12.086.2.22.217.367.02.169-.095.375-.325.788l-1.42 2.557c-.084.15-.125.225-.142.304a.529.529 0 0 0 0 .213c.017.079.058.154.141.303l1.421 2.558c.23.413.344.62.325.788a.528.528 0 0 1-.217.367c-.138.1-.374.1-.846.1h-7.431c-.592 0-.887 0-1.113-.115a1.055 1.055 0 0 1-.461-.462c-.115-.226-.115-.521-.115-1.112v-2.534M7.23 21.5 3.008 4.611m1.583 6.333h7.811c.592 0 .887 0 1.113-.115.199-.1.36-.262.461-.46.115-.227.115-.522.115-1.113V4.189c0-.591 0-.887-.115-1.113a1.055 1.055 0 0 0-.461-.46c-.226-.116-.521-.116-1.113-.116H4.643c-.737 0-1.106 0-1.358.153a1.056 1.056 0 0 0-.461.59c-.087.283.002.64.18 1.356l1.587 6.345Z"
  }))),
  fileshield03: t => e.createElement("svg", ug({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), cg || (cg = e.createElement("path", {
    d: "M14 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 19.72 20 18.88 20 17.2V8m-6-6 6 6m-6-6v6h6m-8 10s3-1.43 3-3.575v-2.502l-2.188-.782a2.41 2.41 0 0 0-1.626 0L9 11.923v2.502C9 16.57 12 18 12 18Z"
  }))),
  receiptcheck: t => e.createElement("svg", mg({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), hg || (hg = e.createElement("path", {
    d: "m9 10.5 2 2L15.5 8M20 21V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 3 16.88 3 15.2 3H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 5.28 4 6.12 4 7.8V21l2.75-2 2.5 2L12 19l2.75 2 2.5-2L20 21Z"
  }))),
  podcast: t => e.createElement("svg", fg({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), pg || (pg = e.createElement("path", {
    d: "M17.119 18C19.462 16.415 21 13.778 21 10.785 21 5.933 16.97 2 12 2s-9 3.933-9 8.785c0 2.993 1.538 5.63 3.881 7.215m1.479-4C7.519 13.15 7 12.009 7 10.75 7 8.128 9.239 6 12 6s5 2.127 5 4.75c0 1.26-.519 2.4-1.36 3.25M12 22a2 2 0 0 1-2-2v-2a2 2 0 1 1 4 0v2a2 2 0 0 1-2 2Zm1-11a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
  }))),
  snowflake01: t => e.createElement("svg", vg({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), dg || (dg = e.createElement("path", {
    d: "m18.062 8.5-12.124 7m12.124-7 1.098-4.098M18.062 8.5l4.098 1.098M5.938 15.5 1.84 14.402M5.938 15.5 4.84 19.598M18.062 15.5l-12.124-7m12.124 7 4.098-1.098M18.062 15.5l1.098 4.098M5.938 8.5 4.84 4.402M5.938 8.5 1.84 9.598M12 5v14m0-14L9 2m3 3 3-3m-3 17-3 3m3-3 3 3"
  }))),
  eyeoff: t => e.createElement("svg", bg({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), gg || (gg = e.createElement("path", {
    d: "M10.743 5.092C11.149 5.032 11.569 5 12 5c5.105 0 8.455 4.505 9.58 6.287.137.215.205.323.243.49.029.125.029.322 0 .447-.038.166-.107.274-.244.492-.3.474-.757 1.141-1.363 1.865M6.724 6.715c-2.162 1.467-3.63 3.504-4.303 4.57-.137.217-.205.325-.243.492a1.173 1.173 0 0 0 0 .446c.038.167.106.274.242.49C3.546 14.495 6.895 19 12 19c2.059 0 3.832-.732 5.289-1.723M3 3l18 18M9.88 9.879a3 3 0 1 0 4.243 4.243"
  }))),
  dice5: t => e.createElement("svg", yg({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), wg || (wg = e.createElement("path", {
    d: "M16.25 7.75h.005m-.005 8.5h.005M7.75 7.75h.005m4.245 4h.005m-4.255 4.5h.005M7.8 21h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Zm8.7-13.25a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Zm0 8.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM8 7.75a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Zm4.25 4a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM8 16.25a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Z"
  }))),
  power01: t => e.createElement("svg", Og({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), xg || (xg = e.createElement("path", {
    d: "M12 2v10m6.36-5.36a9 9 0 1 1-12.73 0"
  }))),
  graduationhat02: t => e.createElement("svg", jg({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Eg || (Eg = e.createElement("path", {
    d: "M17 14.5v-3.005c0-.18 0-.27-.027-.349a.5.5 0 0 0-.116-.187c-.058-.06-.139-.1-.3-.18L12 8.5m-8 1v6.807c0 .372 0 .558.058.72a1 1 0 0 0 .244.381c.124.12.293.198.631.353l6.4 2.934c.246.112.368.168.496.19.113.02.229.02.342 0 .128-.022.25-.078.496-.19l6.4-2.934c.338-.155.507-.232.63-.353a1 1 0 0 0 .245-.38c.058-.163.058-.35.058-.721V9.5m-18-1 9.642-4.821c.131-.066.197-.098.266-.111a.5.5 0 0 1 .184 0c.069.013.135.045.266.11L22 8.5l-9.642 4.821c-.131.066-.197.099-.266.111a.501.501 0 0 1-.184 0c-.069-.012-.135-.045-.266-.11L2 8.5Z"
  }))),
  cubeoutline: t => e.createElement("svg", Pg({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Cg || (Cg = e.createElement("path", {
    d: "m9.75 20.75 1.473.818c.284.158.425.237.576.268.133.027.27.027.402 0 .15-.031.292-.11.576-.268l1.473-.818m-9-2.5-1.427-.793c-.3-.166-.45-.25-.558-.368a1 1 0 0 1-.215-.364C3 16.573 3 16.401 3 16.06V14.5m0-5V7.942c0-.343 0-.514.05-.667a1 1 0 0 1 .215-.364c.109-.119.258-.202.558-.368L5.25 5.75m4.5-2.5 1.473-.818c.284-.158.425-.237.576-.267a1 1 0 0 1 .402 0c.15.03.292.11.576.267l1.473.818m4.5 2.5 1.427.793c.3.166.45.25.558.368a1 1 0 0 1 .215.364c.05.153.05.324.05.667V9.5m0 5v1.559c0 .342 0 .514-.05.666a.999.999 0 0 1-.215.364c-.109.119-.258.202-.558.368l-1.427.793m-9-7.5L12 12m0 0 2.25-1.25M12 12v2.5M3 7l2.25 1.25m13.5 0L21 7m-9 12.5V22"
  }))),
  file01: t => e.createElement("svg", kg({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Mg || (Mg = e.createElement("path", {
    d: "M4 6.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C6.28 2 7.12 2 8.8 2h6.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C20 4.28 20 5.12 20 6.8v10.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C17.72 22 16.88 22 15.2 22H8.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.72 4 18.88 4 17.2V6.8Z"
  }))),
  stop: t => e.createElement("svg", Ng({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Sg || (Sg = e.createElement("path", {
    d: "M3 7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8Z"
  }))),
  maximize02: t => e.createElement("svg", Vg({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Bg || (Bg = e.createElement("path", {
    d: "M8 3h-.2c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8V8m5 13h-.2c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V16m18-8v-.2c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H16m5 13v.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H16"
  }))),
  griddotsverticalcenter: t => e.createElement("svg", Ag({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Rg || (Rg = e.createElement("path", {
    d: "M3 3h.01M3 21h.01M3 16.5h.01M3 7.5h.01M7.5 3h.01M7.5 21h.01M16.5 3h.01m-.01 18h.01M12 3h.01M12 21h.01M12 16.5h.01m-.01-9h.01M21 3h.01M21 21h.01M21 16.5h.01m-.01-9h.01M21 12H3"
  }))),
  arrowcircleleft: t => e.createElement("svg", Hg({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Tg || (Tg = e.createElement("path", {
    d: "m12 8-4 4m0 0 4 4m-4-4h8m6 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }))),
  paragraphspacing: t => e.createElement("svg", Ig({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Lg || (Lg = e.createElement("path", {
    d: "M21 10h-8m8-4h-8m8 8h-8m8 4h-8m-7 2V4m0 16-3-3m3 3 3-3M6 4 3 7m3-3 3 3"
  }))),
  alignhorizontalcentre01: t => e.createElement("svg", _g({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Fg || (Fg = e.createElement("path", {
    d: "M12 3v18m10-9h-6.5m0 0 4 4m-4-4 4-4M2 12h6.5m0 0-4 4m4-4-4-4"
  }))),
  repeat01: t => e.createElement("svg", Dg({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Zg || (Zg = e.createElement("path", {
    d: "m17 2 4 4m0 0-4 4m4-4H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 8.28 3 9.12 3 10.8v.2m0 7h13.2c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 15.72 21 14.88 21 13.2V13M3 18l4 4m-4-4 4-4"
  }))),
  homeline: t => e.createElement("svg", Ug({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), qg || (qg = e.createElement("path", {
    d: "M8 17h8M11.018 2.764 4.235 8.039c-.453.353-.68.53-.843.75a2 2 0 0 0-.318.65C3 9.704 3 9.991 3 10.565V17.8c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C4.52 21 5.08 21 6.2 21h11.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C21 19.48 21 18.92 21 17.8v-7.235c0-.574 0-.861-.074-1.126a2.002 2.002 0 0 0-.318-.65c-.163-.22-.39-.397-.843-.75l-6.783-5.275c-.351-.273-.527-.41-.72-.462a1 1 0 0 0-.523 0c-.194.052-.37.189-.721.462Z"
  }))),
  imagecheck: t => e.createElement("svg", zg({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), $g || ($g = e.createElement("path", {
    d: "m16 5 2 2 4-4m-9.5 0H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21H17c.93 0 1.395 0 1.776-.102a3 3 0 0 0 2.122-2.122C21 18.395 21 17.93 21 17M10.5 8.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4.49 3.418-8.459 7.69c-.476.433-.714.649-.735.836a.5.5 0 0 0 .167.431C6.105 21 6.426 21 7.07 21h9.387c1.44 0 2.159 0 2.724-.242a3 3 0 0 0 1.578-1.578c.242-.565.242-1.285.242-2.724 0-.484 0-.726-.053-.952a2.001 2.001 0 0 0-.374-.778c-.143-.182-.332-.333-.71-.636l-2.797-2.237c-.379-.303-.568-.454-.776-.508a1 1 0 0 0-.557.018c-.205.066-.384.23-.743.555Z"
  }))),
  hearthand: t => e.createElement("svg", Qg({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Wg || (Wg = e.createElement("path", {
    d: "M6 20.087h2.61c.34 0 .679.04 1.009.122l2.758.67c.598.146 1.222.16 1.826.042l3.05-.593a4.204 4.204 0 0 0 2.127-1.107l2.158-2.1a1.503 1.503 0 0 0 0-2.168 1.61 1.61 0 0 0-2.06-.143l-2.515 1.835c-.36.263-.799.405-1.25.405h-2.427 1.545c.871 0 1.577-.687 1.577-1.534v-.307c0-.704-.492-1.317-1.194-1.487l-2.385-.58A5.025 5.025 0 0 0 11.643 13c-.965 0-2.711.799-2.711.799L6 15.025M2 14.6v5.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C2.76 22 3.04 22 3.6 22h.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C6 21.24 6 20.96 6 20.4v-5.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C5.24 13 4.96 13 4.4 13h-.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C2 13.76 2 14.04 2 14.6ZM17.191 3.592c-.596-1.249-1.972-1.91-3.31-1.272-1.339.639-1.909 2.153-1.348 3.483.346.821 1.338 2.417 2.045 3.516.261.406.392.61.583.728.164.102.369.157.561.15.225-.007.44-.118.87-.339 1.161-.598 2.818-1.483 3.529-2.022a2.66 2.66 0 0 0 .574-3.69c-.861-1.217-2.362-1.337-3.504-.554Z"
  }))),
  bellringing04: t => e.createElement("svg", Yg({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Gg || (Gg = e.createElement("path", {
    d: "M15.646 18.015a3 3 0 1 1-5.796 1.553m-7.793-7.955a4.007 4.007 0 0 1 1.052-3.926m9.037-1.946a2.5 2.5 0 1 0-3.47.93m11.643.049a4.007 4.007 0 0 0-2.874-2.874m.046 5.6c-.357-1.333-1.31-2.447-2.65-3.098-1.339-.65-2.955-.784-4.492-.373-1.537.412-2.87 1.336-3.704 2.57-.834 1.233-1.102 2.674-.745 4.006.59 2.204.475 3.963.102 5.299-.425 1.522-.637 2.284-.58 2.437.066.175.113.223.288.29.152.06.792-.112 2.071-.455l11.865-3.18c1.28-.342 1.92-.514 2.022-.64.117-.146.134-.212.104-.396-.027-.161-.592-.714-1.721-1.82-.991-.971-1.97-2.437-2.56-4.64Z"
  }))),
  trophy02: t => e.createElement("svg", Xg({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Kg || (Kg = e.createElement("path", {
    d: "M12 17a6.5 6.5 0 0 1-6.5-6.5V4.556c0-.519 0-.778.094-.979a1 1 0 0 1 .483-.483C6.278 3 6.537 3 7.056 3h9.888c.519 0 .778 0 .979.094a1 1 0 0 1 .483.483c.094.201.094.46.094.979V10.5A6.5 6.5 0 0 1 12 17Zm0 0v4m5 0H7M22 5v5M2 5v5"
  }))),
  fingerprint02: t => e.createElement("svg", eb({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Jg || (Jg = e.createElement("path", {
    d: "M12 10v4M7.447 3.421A8 8 0 0 1 20 10v1.237M4.416 7.447A7.99 7.99 0 0 0 4 10v4a8.004 8.004 0 0 0 5.744 7.677m9.915-5.358a8.02 8.02 0 0 1-4.922 5.2m-.412-15.373A4.5 4.5 0 0 0 7.5 10v2.95m9-1.91V14a4.5 4.5 0 0 1-6.82 3.857"
  }))),
  thermometer03: t => e.createElement("svg", rb({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), tb || (tb = e.createElement("path", {
    d: "M21 3h-6m6 4h-6m6 4h-6m-9.5 2.758V4.5a2.5 2.5 0 0 1 5 0v9.258a4.5 4.5 0 1 1-5 0ZM9 17.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
  }))),
  inbox01: t => e.createElement("svg", ab({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), nb || (nb = e.createElement("path", {
    d: "M2.5 12h3.382c.685 0 1.312.387 1.618 1 .306.613.933 1 1.618 1h5.764c.685 0 1.312-.387 1.618-1 .306-.613.933-1 1.618-1H21.5M8.967 4h6.066c1.077 0 1.616 0 2.091.164a3 3 0 0 1 1.121.693c.36.352.6.833 1.082 1.796l2.166 4.333c.19.378.284.567.35.765.06.177.102.357.128.541.029.207.029.418.029.841V15.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C19.72 20 18.88 20 17.2 20H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 17.72 2 16.88 2 15.2v-2.067c0-.422 0-.634.029-.84.026-.184.068-.365.128-.541.066-.199.16-.388.35-.766l2.166-4.333c.482-.963.723-1.444 1.082-1.796a3 3 0 0 1 1.12-.693C7.352 4 7.89 4 8.968 4Z"
  }))),
  helpoctagon1: t => e.createElement("svg", ib({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ob || (ob = e.createElement("path", {
    d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3m.08 4h.01M2 8.523v6.954c0 .245 0 .367.028.482a1 1 0 0 0 .12.29c.061.1.148.187.32.36l4.923 4.922c.173.173.26.26.36.322.09.054.188.095.29.12.115.027.237.027.482.027h6.954c.245 0 .367 0 .482-.028a.998.998 0 0 0 .29-.12c.1-.061.187-.148.36-.32l4.922-4.923c.173-.173.26-.26.322-.36a.998.998 0 0 0 .12-.29c.027-.115.027-.237.027-.482V8.523c0-.245 0-.367-.028-.482a.998.998 0 0 0-.12-.29c-.061-.1-.148-.187-.32-.36L16.608 2.47c-.173-.173-.26-.26-.36-.322a1 1 0 0 0-.29-.12C15.844 2 15.722 2 15.477 2H8.523c-.245 0-.367 0-.482.028a1 1 0 0 0-.29.12c-.1.061-.187.148-.36.32L2.47 7.392c-.173.173-.26.26-.322.36a1 1 0 0 0-.12.29C2 8.156 2 8.278 2 8.523Z"
  }))),
  imageplus: t => e.createElement("svg", sb({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), lb || (lb = e.createElement("path", {
    d: "M12.5 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21H17c.93 0 1.395 0 1.776-.102a3 3 0 0 0 2.122-2.122C21 18.395 21 17.93 21 17m-2-9V2m-3 3h6M10.5 8.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4.49 3.418-8.459 7.69c-.476.433-.714.649-.735.836a.5.5 0 0 0 .167.431C6.105 21 6.426 21 7.07 21h9.387c1.44 0 2.159 0 2.724-.242a3 3 0 0 0 1.578-1.578c.242-.565.242-1.285.242-2.724 0-.484 0-.726-.053-.952a2.001 2.001 0 0 0-.374-.778c-.143-.182-.332-.333-.71-.636l-2.797-2.237c-.379-.303-.568-.454-.776-.508a1 1 0 0 0-.557.018c-.205.066-.384.23-.743.555Z"
  }))),
  layouttop: t => e.createElement("svg", ub({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), cb || (cb = e.createElement("path", {
    d: "M3 9h18M7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3Z"
  }))),
  chromecast: t => e.createElement("svg", mb({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), hb || (hb = e.createElement("path", {
    d: "M2 12.05A9 9 0 0 1 9.95 20M2 16.1A5 5 0 0 1 5.9 20M2 20h.01M14 21h3.2c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 18.72 22 17.88 22 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C19.72 3 18.88 3 17.2 3H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 5.28 2 6.12 2 7.8V8"
  }))),
  stickersquare: t => e.createElement("svg", fb({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), pb || (pb = e.createElement("path", {
    d: "M13 3.5v2.7c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C15.28 11 16.12 11 17.8 11h2.7m.5 1.988V16.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3h3.212c.733 0 1.1 0 1.446.083.306.073.598.195.867.36.303.185.562.444 1.08.963l5.19 5.188c.518.519.777.778.963 1.081.164.269.286.561.36.867.082.346.082.713.082 1.446Z"
  }))),
  container: t => e.createElement("svg", vb({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), db || (db = e.createElement("path", {
    d: "M20.5 7.278 12 12m0 0L3.5 7.278M12 12v9.5m9-5.441V7.942c0-.343 0-.514-.05-.667a1 1 0 0 0-.215-.364c-.109-.119-.258-.202-.558-.368l-7.4-4.111c-.284-.158-.425-.237-.575-.267a1 1 0 0 0-.403 0c-.15.03-.292.11-.576.267l-7.4 4.11c-.3.167-.45.25-.558.369a1 1 0 0 0-.215.364C3 7.428 3 7.599 3 7.942v8.117c0 .342 0 .514.05.666a1 1 0 0 0 .215.364c.109.119.258.202.558.368l7.4 4.111c.284.158.425.237.576.268.133.027.27.027.402 0 .15-.031.292-.11.576-.268l7.4-4.11c.3-.167.45-.25.558-.369a.999.999 0 0 0 .215-.364c.05-.152.05-.324.05-.666Z"
  }))),
  save02: t => e.createElement("svg", bb({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), gb || (gb = e.createElement("path", {
    d: "M15 8H8.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C7 7.24 7 6.96 7 6.4V3m10 18v-6.4c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C16.24 13 15.96 13 15.4 13H8.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C7 13.76 7 14.04 7 14.6V21M21 9.325V16.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3h6.875c.489 0 .733 0 .963.055.204.05.4.13.579.24.201.123.374.296.72.642l3.126 3.126c.346.346.519.519.642.72.11.18.19.374.24.579.055.23.055.474.055.963Z"
  }))),
  ruler: t => e.createElement("svg", yb({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), wb || (wb = e.createElement("path", {
    d: "M14.5 5.5 16 7m-4.5 1.5L13 10m-4.5 1.5L10 13m-4.5 1.5L7 16m-4.434 1.566 3.868 3.868c.198.198.297.297.411.334.1.033.209.033.31 0 .114-.037.213-.136.41-.334l13.87-13.868c.197-.198.296-.297.333-.412a.499.499 0 0 0 0-.309c-.037-.114-.136-.213-.334-.41l-3.868-3.87c-.198-.197-.297-.296-.412-.333a.5.5 0 0 0-.309 0c-.114.037-.213.136-.41.334L2.564 16.434c-.197.198-.296.297-.333.411a.5.5 0 0 0 0 .31c.037.114.136.213.334.41Z"
  }))),
  helpsquare: t => e.createElement("svg", Ob({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), xb || (xb = e.createElement("path", {
    d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3m.08 4h.01M7.8 21h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Z"
  }))),
  currencyruble: t => e.createElement("svg", jb({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Eb || (Eb = e.createElement("path", {
    d: "M8.5 11.5h6a4 4 0 0 0 0-8h-6v8Zm0 0h-2m7 4h-7M8.5 4v16.5"
  }))),
  usersright: t => e.createElement("svg", Pb({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Cb || (Cb = e.createElement("path", {
    d: "m19 21 3-3m0 0-3-3m3 3h-6m-.5-14.71a4.001 4.001 0 0 1 0 7.42M12 15H8c-1.864 0-2.796 0-3.53.305a4 4 0 0 0-2.166 2.164C2 18.204 2 19.136 2 21M13.5 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
  }))),
  thermometer01: t => e.createElement("svg", kb({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Mb || (Mb = e.createElement("path", {
    d: "M14.5 4.5a2.5 2.5 0 0 0-5 0v9.258a4.5 4.5 0 1 0 5 0V4.5Z"
  }))),
  cursorclick02: t => e.createElement("svg", Nb({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Sb || (Sb = e.createElement("path", {
    d: "M9 3.5V2M5.06 5.06 4 4m1.06 9L4 14.06m9-9L14.06 4M3.5 9H2m6.5-.5 4.111 12.778 2.889-2.89L19.111 22 22 19.111 18.389 15.5l2.889-2.889L8.5 8.5Z"
  }))),
  musicnote01: t => e.createElement("svg", Vb({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Bb || (Bb = e.createElement("path", {
    d: "M9 18V6.355c0-.481 0-.722.088-.917a1 1 0 0 1 .358-.424c.178-.118.416-.158.891-.237l8.8-1.467c.64-.106.961-.16 1.211-.067a1 1 0 0 1 .52.44c.132.231.132.556.132 1.206V16M9 18a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm12-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
  }))),
  folderx: t => e.createElement("svg", Ab({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Rb || (Rb = e.createElement("path", {
    d: "m13 7-1.116-2.231c-.32-.642-.481-.963-.72-1.198a2 2 0 0 0-.748-.462C10.1 3 9.74 3 9.022 3H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 4.52 2 5.08 2 6.2V7m0 0h15.2c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C22 9.28 22 10.12 22 11.8v4.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C19.72 21 18.88 21 17.2 21H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.72 2 17.88 2 16.2V7Zm7.5 4.5 5 5m0-5-5 5"
  }))),
  strikethrough02: t => e.createElement("svg", Hb({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Tb || (Tb = e.createElement("path", {
    d: "M6 16a4 4 0 0 0 4 4h4a4 4 0 0 0 0-8m-3.5 8a4 4 0 0 0 0-8M18 8a4 4 0 0 0-4-4h-4a4 4 0 0 0-4 4m7.5-4a4 4 0 0 0-4 4M3 12h18"
  }))),
  repeat03: t => e.createElement("svg", Ib({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Lb || (Lb = e.createElement("path", {
    d: "m13 22-3-3m0 0 3-3m-3 3h5a7 7 0 0 0 3-13.326M6 18.326A7 7 0 0 1 9 5h5m0 0-3-3m3 3-3 3"
  }))),
  shuffle02: t => e.createElement("svg", _b({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Fb || (Fb = e.createElement("path", {
    d: "M21 16v5m0 0h-5m5 0-6-6M3 3l6 6m7-6h5m0 0v5m0-5L3 21"
  }))),
  downloadcloud02: t => e.createElement("svg", Db({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Zb || (Zb = e.createElement("path", {
    d: "m8 17 4 4m0 0 4-4m-4 4v-9m8 4.743A5.5 5.5 0 0 0 16.5 7a.62.62 0 0 1-.534-.302 7.5 7.5 0 1 0-11.78 9.096"
  }))),
  strikethroughsquare: t => e.createElement("svg", Ub({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), qb || (qb = e.createElement("path", {
    d: "M6 12h12m-7 0h2a2.5 2.5 0 0 1 0 5h-2.167a2.334 2.334 0 0 1-2.18-1.5m6.694-7a2.334 2.334 0 0 0-2.18-1.5H11a2.5 2.5 0 0 0-2.292 1.5M7.8 21h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Z"
  }))),
  file03: t => e.createElement("svg", zb({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), $b || ($b = e.createElement("path", {
    d: "M8 14v4m8-6v6M12 8v10m8-11.2v10.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C17.72 22 16.88 22 15.2 22H8.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.72 4 18.88 4 17.2V6.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C6.28 2 7.12 2 8.8 2h6.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C20 4.28 20 5.12 20 6.8Z"
  }))),
  globe05: t => e.createElement("svg", Qb({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Wb || (Wb = e.createElement("path", {
    d: "M15 2.458A9.996 9.996 0 0 0 12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10c0-1.715-.432-3.33-1.193-4.74M17 5.75h.005M10.5 21.888v-2.203a.5.5 0 0 1 .12-.325l2.486-2.9a.5.5 0 0 0-.131-.76l-2.857-1.632a.499.499 0 0 1-.186-.187L8.07 10.62a.5.5 0 0 0-.478-.25l-5.528.492M21 6c0 2.21-2 4-4 6-2-2-4-3.79-4-6a4 4 0 0 1 8 0Zm-3.75-.25a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Z"
  }))),
  notificationmessage: t => e.createElement("svg", Yb({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Gb || (Gb = e.createElement("path", {
    d: "M11 4H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 6.28 3 7.12 3 8.8V14c0 .93 0 1.395.102 1.777a3 3 0 0 0 2.122 2.12C5.605 18 6.07 18 7 18v2.335c0 .533 0 .8.11.937a.5.5 0 0 0 .39.188c.176 0 .384-.167.8-.5l2.385-1.908c.487-.39.731-.585 1.002-.724.241-.122.497-.212.762-.267.299-.061.61-.061 1.235-.061H15.2c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 15.72 20 14.88 20 13.2V13m.121-9.121A3 3 0 1 1 15.88 8.12 3 3 0 0 1 20.12 3.88Z"
  }))),
  batteryfull: t => e.createElement("svg", Xb({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Kb || (Kb = e.createElement("path", {
    d: "M6.5 10v4m4-4v4m4-4v4m7.5-1v-2M6.8 18h7.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C19 15.72 19 14.88 19 13.2v-2.4c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C16.72 6 15.88 6 14.2 6H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 8.28 2 9.12 2 10.8v2.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 18 5.12 18 6.8 18Z"
  }))),
  plus: t => e.createElement("svg", ew({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Jb || (Jb = e.createElement("path", {
    d: "M12 5v14m-7-7h14"
  }))),
  map02: t => e.createElement("svg", rw({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), tw || (tw = e.createElement("path", {
    d: "m8 3 8 18M3 17l9-5m-4.2 9h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Z"
  }))),
  clipboardminus: t => e.createElement("svg", aw({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), nw || (nw = e.createElement("path", {
    d: "M16 4c.93 0 1.395 0 1.776.102a3 3 0 0 1 2.122 2.122C20 6.605 20 7.07 20 8v9.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C17.72 22 16.88 22 15.2 22H8.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.72 4 18.88 4 17.2V8c0-.93 0-1.395.102-1.776a3 3 0 0 1 2.122-2.122C6.605 4 7.07 4 8 4m1 10h6M9.6 6h4.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C16 5.24 16 4.96 16 4.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C15.24 2 14.96 2 14.4 2H9.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C8 2.76 8 3.04 8 3.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C8.76 6 9.04 6 9.6 6Z"
  }))),
  power03: t => e.createElement("svg", iw({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ow || (ow = e.createElement("path", {
    d: "M12 7v10m10-5c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }))),
  check: t => e.createElement("svg", sw({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), lw || (lw = e.createElement("path", {
    d: "M20 6 9 17l-5-5"
  }))),
  facefrown: t => e.createElement("svg", uw({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), cw || (cw = e.createElement("path", {
    d: "M16 16s-1.5-2-4-2-4 2-4 2m7-7h.01M9 9h.01M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-6.5-3a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm-6 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
  }))),
  target04: t => e.createElement("svg", mw({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), hw || (hw = e.createElement("path", {
    d: "M16 8V5l3-3 1 2 2 1-3 3h-3Zm0 0-4 4m10 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2m5 10a5 5 0 1 1-5-5"
  }))),
  fileshield01: t => e.createElement("svg", fw({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), pw || (pw = e.createElement("path", {
    d: "M20 10V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 2 16.88 2 15.2 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22h3.7m5.5-1s3-1.43 3-3.575v-2.502l-2.188-.782a2.41 2.41 0 0 0-1.626 0L15 14.923v2.502C15 19.57 18 21 18 21Z"
  }))),
  bluetoothon: t => e.createElement("svg", vw({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), dw || (dw = e.createElement("path", {
    d: "m6 7 12 10-6 5V2l6 5L6 17"
  }))),
  harddrive: t => e.createElement("svg", bw({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), gw || (gw = e.createElement("path", {
    d: "M2.5 12h19M6 16h4M8.967 4h6.066c1.077 0 1.616 0 2.091.164a3 3 0 0 1 1.121.693c.36.352.6.833 1.082 1.796l2.166 4.333c.19.378.284.567.35.765.06.177.102.357.128.541.029.207.029.418.029.841V15.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C19.72 20 18.88 20 17.2 20H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 17.72 2 16.88 2 15.2v-2.067c0-.422 0-.634.029-.84.026-.184.068-.365.128-.541.066-.199.16-.388.35-.766l2.166-4.333c.482-.963.723-1.444 1.082-1.796a3 3 0 0 1 1.12-.693C7.352 4 7.89 4 8.968 4Z"
  }))),
  notificationbox: t => e.createElement("svg", yw({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ww || (ww = e.createElement("path", {
    d: "M11 4H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 6.28 3 7.12 3 8.8v7.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21h7.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 18.72 20 17.88 20 16.2V13m.121-9.121A3 3 0 1 1 15.88 8.12 3 3 0 0 1 20.12 3.88Z"
  }))),
  lightbulb02: t => e.createElement("svg", Ow({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), xw || (xw = e.createElement("path", {
    d: "M10 17.659V20a2 2 0 1 0 4 0v-2.341M12 2v1m-9 9H2m3.5-6.5-.6-.6m13.6.6.6-.6M22 12h-1m-3 0a6 6 0 1 1-12 0 6 6 0 0 1 12 0Z"
  }))),
  hearthexagon: t => e.createElement("svg", Cw({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Ew || (Ew = e.createElement("path", {
    d: "M11.223 2.432c.284-.158.425-.237.575-.268a1 1 0 0 1 .403 0c.15.031.292.11.576.268l7.4 4.11c.3.167.45.25.558.369a1 1 0 0 1 .215.364c.05.152.05.324.05.666v8.117c0 .343 0 .515-.05.667a1 1 0 0 1-.215.364c-.109.119-.258.202-.558.368l-7.4 4.111c-.284.158-.425.237-.575.267-.133.028-.27.028-.403 0-.15-.03-.292-.11-.576-.267l-7.4-4.11c-.3-.167-.45-.25-.558-.369a1 1 0 0 1-.215-.364C3 16.573 3 16.401 3 16.058V7.941c0-.342 0-.514.05-.666a1 1 0 0 1 .215-.364c.109-.119.258-.202.558-.368l7.4-4.111Z"
  })), jw || (jw = e.createElement("path", {
    d: "M11.997 9.068c-1-1.169-2.667-1.483-3.92-.413-1.252 1.07-1.429 2.86-.445 4.125.63.81 2.244 2.314 3.322 3.29.359.325.538.487.753.552.184.056.395.056.58 0 .214-.065.393-.227.752-.552 1.079-.976 2.692-2.48 3.322-3.29.984-1.265.829-3.066-.445-4.125-1.274-1.059-2.92-.756-3.92.413Z",
    clipRule: "evenodd"
  }))),
  link04: t => e.createElement("svg", Mw({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Pw || (Pw = e.createElement("path", {
    d: "M7.5 7H7a5 5 0 0 0 0 10h2a5 5 0 0 0 5-5m2.5 5h.5a5 5 0 0 0 0-10h-2a5 5 0 0 0-5 5"
  }))),
  beziercurve01: t => e.createElement("svg", Sw({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), kw || (kw = e.createElement("path", {
    d: "M10 7H3m18 0h-7m0 .252c3.45.888 6 4.02 6 7.748M4 15c0-3.728 2.55-6.86 6-7.748M3.6 19h.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C6 18.24 6 17.96 6 17.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C5.24 15 4.96 15 4.4 15h-.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C2 15.76 2 16.04 2 16.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C2.76 19 3.04 19 3.6 19Zm8-10h.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C14 8.24 14 7.96 14 7.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C13.24 5 12.96 5 12.4 5h-.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C10 5.76 10 6.04 10 6.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C10.76 9 11.04 9 11.6 9Zm8 10h.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C22 18.24 22 17.96 22 17.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C21.24 15 20.96 15 20.4 15h-.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C18 15.76 18 16.04 18 16.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C18.76 19 19.04 19 19.6 19ZM22 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM4 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
  }))),
  umbrella03: t => e.createElement("svg", Bw({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Nw || (Nw = e.createElement("path", {
    d: "M6.25 21.96 12 12m5-8.66C12.687.85 7.29 1.938 4.246 5.683c-.297.366-.446.548-.489.81-.034.209.017.485.123.667.134.23.371.366.845.64l14.55 8.4c.474.274.711.41.976.412.212.001.476-.093.64-.227.205-.168.289-.388.457-.828C23.07 11.048 21.313 5.83 17 3.34Zm0 0C15.087 2.235 11.297 5.217 8.536 10M17 3.34c1.913 1.105 1.226 5.877-1.536 10.66M22 22H2"
  }))),
  faceneutral: t => e.createElement("svg", Rw({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Vw || (Vw = e.createElement("path", {
    d: "M8 15h8m-1-6h.01M9 9h.01M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-6.5-3a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm-6 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
  }))),
  phonecall01: t => e.createElement("svg", Tw({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Aw || (Aw = e.createElement("path", {
    d: "M14.05 6A5 5 0 0 1 18 9.95M14.05 2A9 9 0 0 1 22 9.94m-11.773 3.923a14.604 14.604 0 0 1-2.847-4.01 1.698 1.698 0 0 1-.113-.266 1.046 1.046 0 0 1 .147-.862c.048-.067.105-.124.22-.238.35-.35.524-.524.638-.7a2 2 0 0 0 0-2.18c-.114-.176-.289-.351-.638-.7l-.195-.196c-.532-.531-.797-.797-1.083-.941a2 2 0 0 0-1.805 0c-.285.144-.551.41-1.083.941l-.157.158c-.53.53-.795.794-.997 1.154-.224.4-.386 1.02-.384 1.479 0 .413.081.695.241 1.26a19.038 19.038 0 0 0 4.874 8.283 19.039 19.039 0 0 0 8.283 4.873c.565.16.847.24 1.26.242a3.377 3.377 0 0 0 1.478-.384c.36-.203.625-.468 1.155-.997l.157-.158c.532-.531.797-.797.942-1.082a2 2 0 0 0 0-1.806c-.145-.285-.41-.55-.942-1.082l-.195-.195c-.35-.35-.524-.524-.7-.639a2 2 0 0 0-2.18 0c-.176.114-.35.29-.7.639-.115.114-.172.171-.239.22-.237.17-.581.228-.862.146a1.695 1.695 0 0 1-.266-.113 14.605 14.605 0 0 1-4.01-2.846Z"
  }))),
  currencybitcoincircle: t => e.createElement("svg", Lw({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Hw || (Hw = e.createElement("path", {
    d: "M9.5 7.5h4.25a2.25 2.25 0 0 1 0 4.5H9.5h4.75a2.25 2.25 0 0 1 0 4.5H9.5m0-9H8m1.5 0v9m0 0H8M10 6v1.5m0 9V18m3-12v1.5m0 9V18m9-6c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }))),
  spacingwidth01: t => e.createElement("svg", Fw({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Iw || (Iw = e.createElement("path", {
    d: "M6 12h12M6 12l2-3m-2 3 2 3m10-3-2-3m2 3-2 3m5 6V3M3 21V3"
  }))),
  umbrella02: t => e.createElement("svg", Zw({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), _w || (_w = e.createElement("path", {
    d: "M7 19.4C7 20.836 8.12 22 9.5 22s2.5-1.164 2.5-2.6V11m0 0c-1.61 0-4 1-4 1s-1.39-1-3-1-3 1-3 1C2 6.477 6.477 2 12 2s10 4.477 10 10c0 0-1.39-1-3-1s-3 1-3 1-2.39-1-4-1Z"
  }))),
  cursorbox: t => e.createElement("svg", qw({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Dw || (Dw = e.createElement("path", {
    d: "M21 9.5V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21h1.7m7.886-3.289-1.698 3.154c-.278.516-.417.774-.586.84a.5.5 0 0 1-.447-.038c-.155-.096-.247-.374-.43-.93L11.5 12.511c-.16-.486-.241-.73-.183-.892a.5.5 0 0 1 .302-.302c.162-.058.405.022.892.183l8.226 2.724c.556.184.834.276.93.431a.5.5 0 0 1 .039.447c-.067.17-.325.308-.84.586l-3.155 1.698a1.062 1.062 0 0 0-.152.09.508.508 0 0 0-.082.083 1.062 1.062 0 0 0-.09.152Z"
  }))),
  contrast01: t => e.createElement("svg", $w({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Uw || (Uw = e.createElement("path", {
    d: "M12 2c.592 0 1.171.051 1.735.15M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10m0-20v20m5.738-18.191c.954.67 1.786 1.502 2.455 2.456m1.657 4a10.064 10.064 0 0 1 0 3.47m-1.66 4.006c-.67.952-1.5 1.782-2.453 2.45m-4.004 1.66C13.17 21.948 12.59 22 12 22"
  }))),
  asterisk01: t => e.createElement("svg", Ww({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), zw || (zw = e.createElement("path", {
    d: "M12 2v20m7.071-17.071L4.93 19.07M22 12H2m17.071 7.071L4.93 4.93"
  }))),
  link05: t => e.createElement("svg", Gw({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Qw || (Qw = e.createElement("path", {
    d: "M9 17H7A5 5 0 0 1 7 7h2m-1 5h10m-2.222 5H17a5 5 0 0 0 0-10h-1.222a.778.778 0 0 0-.778.778v8.444c0 .43.348.778.778.778Z"
  }))),
  rss02: t => e.createElement("svg", Kw({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Yw || (Yw = e.createElement("path", {
    d: "M3 13.023c5.185-.78 8.756 2.792 7.977 7.977M3 8.038c7.938-.78 13.742 5.024 12.962 12.962M3 3.052C13.692 2.274 21.726 10.308 20.948 21M5 21a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z"
  }))),
  flag06: t => e.createElement("svg", Jw({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Xw || (Xw = e.createElement("path", {
    d: "M4 21V4m0 9h7.4c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C13 12.24 13 11.96 13 11.4V4.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C12.24 3 11.96 3 11.4 3H5.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C4 3.76 4 4.04 4 4.6V13Zm9-8h6.4c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C21 5.76 21 6.04 21 6.6v6.8c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437C20.24 15 19.96 15 19.4 15h-4.8c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C13 14.24 13 13.96 13 13.4V5Z"
  }))),
  watchcircle: t => e.createElement("svg", ty({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ey || (ey = e.createElement("path", {
    d: "m7 17 .486 2.428c.183.916.274 1.374.514 1.717a2 2 0 0 0 .839.688c.383.167.85.167 1.784.167h2.754c.934 0 1.401 0 1.784-.167a2 2 0 0 0 .84-.688c.239-.343.33-.801.514-1.717L17 17M7 7l.486-2.428c.183-.916.274-1.374.514-1.717a2 2 0 0 1 .839-.688C9.222 2 9.689 2 10.623 2h2.754c.934 0 1.401 0 1.784.167a2 2 0 0 1 .84.688c.239.343.33.801.514 1.717L17 7m-5 2v3l1.5 1.5M19 12a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
  }))),
  wifi: t => e.createElement("svg", ny({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ry || (ry = e.createElement("path", {
    d: "M12 19.5h.01M22.806 8.7A15.942 15.942 0 0 0 12 4.5c-4.166 0-7.96 1.592-10.807 4.2m3.539 3.543A10.958 10.958 0 0 1 12 9.5c2.786 0 5.33 1.036 7.268 2.743m-3.57 3.532A5.974 5.974 0 0 0 12 14.5c-1.416 0-2.718.49-3.745 1.312"
  }))),
  lightbulb03: t => e.createElement("svg", oy({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ay || (ay = e.createElement("path", {
    d: "M9.5 22h5m.5-6.674a7 7 0 1 0-6 0V16c0 .932 0 1.398.152 1.765a2 2 0 0 0 1.083 1.083C10.602 19 11.068 19 12 19c.932 0 1.398 0 1.765-.152a2 2 0 0 0 1.083-1.083C15 17.398 15 16.932 15 16v-.674Z"
  }))),
  slashdivider: t => e.createElement("svg", ly({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), iy || (iy = e.createElement("path", {
    d: "M7 22 17 2"
  }))),
  imagex: t => e.createElement("svg", cy({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), sy || (sy = e.createElement("path", {
    d: "m16.5 2.5 5 5m0-5-5 5m-4-4.5H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21H17c.93 0 1.395 0 1.776-.102a3 3 0 0 0 2.122-2.122C21 18.395 21 17.93 21 17M10.5 8.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4.49 3.418-8.459 7.69c-.476.433-.714.649-.735.836a.5.5 0 0 0 .167.431C6.105 21 6.426 21 7.07 21h9.387c1.44 0 2.159 0 2.724-.242a3 3 0 0 0 1.578-1.578c.242-.565.242-1.285.242-2.724 0-.484 0-.726-.053-.952a2.001 2.001 0 0 0-.374-.778c-.143-.182-.332-.333-.71-.636l-2.797-2.237c-.379-.303-.568-.454-.776-.508a1 1 0 0 0-.557.018c-.205.066-.384.23-.743.555Z"
  }))),
  cornerupleft: t => e.createElement("svg", hy({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), uy || (uy = e.createElement("path", {
    d: "M9 14 4 9m0 0 5-5M4 9h6.4c3.36 0 5.04 0 6.324.654a6 6 0 0 1 2.622 2.622C20 13.56 20 15.24 20 18.6V20"
  }))),
  lineheight: t => e.createElement("svg", py({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), my || (my = e.createElement("path", {
    d: "M9 13h6m-8 4 4.272-9.398c.231-.509.347-.763.507-.842a.5.5 0 0 1 .442 0c.16.079.276.333.507.842L17 17m4 4H3M21 3H3"
  }))),
  target05: t => e.createElement("svg", gy({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), fy || (fy = e.createElement("path", {
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z"
  })), dy || (dy = e.createElement("path", {
    d: "M12 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z"
  })), vy || (vy = e.createElement("path", {
    d: "M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
  }))),
  bell04: t => e.createElement("svg", wy({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), by || (by = e.createElement("path", {
    d: "M14.39 18.015a3 3 0 0 1-5.795 1.553M10.891 5.74a2.5 2.5 0 1 0-3.47.93m8.815 2.775c-.357-1.333-1.31-2.447-2.65-3.097-1.339-.651-2.955-.785-4.492-.373-1.537.411-2.869 1.336-3.704 2.569-.834 1.233-1.102 2.674-.745 4.006.59 2.204.476 3.963.103 5.299-.425 1.523-.638 2.284-.58 2.437.065.175.113.223.287.29.152.06.792-.112 2.071-.455l11.866-3.179c1.28-.343 1.919-.514 2.021-.642.117-.145.134-.21.104-.395-.027-.16-.591-.714-1.721-1.82-.991-.971-1.97-2.436-2.56-4.64Z"
  }))),
  snowflake02: t => e.createElement("svg", xy({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), yy || (yy = e.createElement("path", {
    d: "M12 8v8m0-8V2m0 6L7 3m5 5 5-5m-5 13v6m0-6-5 5m5-5 5 5m-1-9H8m8 0h6m-6 0 5-5m-5 5 5 5M8 12H2m6 0L3 7m5 5-5 5"
  }))),
  volumeminus: t => e.createElement("svg", Ey({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Oy || (Oy = e.createElement("path", {
    d: "M15 12h7M9.634 5.366 6.47 8.53c-.173.173-.26.26-.36.322a1 1 0 0 1-.29.12C5.704 9 5.582 9 5.337 9H3.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C2 9.76 2 10.04 2 10.6v2.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C2.76 15 3.04 15 3.6 15h1.737c.245 0 .367 0 .482.028a1 1 0 0 1 .29.12c.1.061.187.148.36.32l3.165 3.166c.429.429.643.643.827.657a.5.5 0 0 0 .42-.174c.119-.14.119-.443.119-1.048V5.93c0-.606 0-.908-.12-1.049a.5.5 0 0 0-.42-.173c-.183.014-.397.228-.826.657Z"
  }))),
  power02: t => e.createElement("svg", Cy({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), jy || (jy = e.createElement("path", {
    d: "M12 7v5M8 9a5 5 0 1 0 8 0m6 3c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }))),
  graduationhat01: t => e.createElement("svg", My({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Py || (Py = e.createElement("path", {
    d: "M5 10v6.011c0 .36 0 .539.055.697a1 1 0 0 0 .23.374c.118.12.278.2.6.36l5.4 2.7c.262.131.393.197.53.223.123.023.248.023.37 0 .137-.026.268-.091.53-.223l5.4-2.7c.322-.16.482-.24.6-.36a.999.999 0 0 0 .23-.374c.055-.158.055-.338.055-.697v-6.01M2 8.5l9.642-4.822c.131-.066.197-.098.266-.111a.5.5 0 0 1 .184 0c.069.013.135.045.266.11L22 8.5l-9.642 4.821c-.131.066-.197.099-.266.111a.501.501 0 0 1-.184 0c-.069-.012-.135-.045-.266-.11L2 8.5Z"
  }))),
  dice6: t => e.createElement("svg", Sy({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ky || (ky = e.createElement("path", {
    d: "M16.25 7.75h.005m-.005 4h.005m-.005 4.5h.005M7.75 7.75h.005m-.005 4h.005m-.005 4.5h.005M7.8 21h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Zm8.7-13.25a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Zm0 4a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Zm0 4.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM8 7.75a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Zm0 4a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Zm0 4.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Z"
  }))),
  imageuserright: t => e.createElement("svg", By({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Ny || (Ny = e.createElement("path", {
    d: "m19 8 3-3m0 0-3-3m3 3h-6m6 7v5.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C19.72 22 18.88 22 17.2 22H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 19.72 2 18.88 2 17.2V6.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C4.28 2 5.12 2 6.8 2H12M2.146 19.926A4.002 4.002 0 0 1 6 17h7c.93 0 1.394 0 1.78.077a4 4 0 0 1 3.143 3.143c.077.386.077.85.077 1.78M14 9.5a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
  }))),
  shieldzap: t => e.createElement("svg", Ry({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Vy || (Vy = e.createElement("path", {
    d: "m13 7.5-3 3 4 2-3 3m9-3.5c0 4.908-5.354 8.478-7.302 9.615-.221.129-.332.194-.488.227a1.137 1.137 0 0 1-.42 0c-.156-.034-.267-.098-.488-.227C9.354 20.478 4 16.908 4 12V7.217c0-.799 0-1.199.13-1.542a2 2 0 0 1 .548-.79c.276-.243.65-.383 1.398-.664l5.362-2.01c.208-.078.312-.117.419-.133a1 1 0 0 1 .286 0c.107.016.21.055.419.133l5.362 2.01c.748.28 1.123.421 1.398.664a2 2 0 0 1 .547.79c.131.343.131.743.131 1.542V12Z"
  }))),
  messagecheckcircle: t => e.createElement("svg", Ty({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Ay || (Ay = e.createElement("path", {
    d: "m9.5 11.5 2 2L16 9m-3.5 11a8.5 8.5 0 1 0-8.057-5.783c.108.32.162.481.172.604a.899.899 0 0 1-.028.326c-.03.12-.098.245-.232.494l-1.636 3.027c-.233.432-.35.648-.324.815a.5.5 0 0 0 .234.35c.144.087.388.062.876.011l5.121-.529c.155-.016.233-.024.303-.021.07.002.12.009.187.024.069.016.155.05.329.116A8.478 8.478 0 0 0 12.5 20Z"
  }))),
  circlecut: t => e.createElement("svg", Ly({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Hy || (Hy = e.createElement("path", {
    d: "M7 20.662c2.989-1.729 5-4.96 5-8.662a9.996 9.996 0 0 0-5-8.662M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }))),
  arrowcircleright: t => e.createElement("svg", Fy({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Iy || (Iy = e.createElement("path", {
    d: "m12 16 4-4m0 0-4-4m4 4H8m14 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }))),
  creditcardsearch: t => e.createElement("svg", Zy({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), _y || (_y = e.createElement("path", {
    d: "m22 22-1.5-1.5M22 10H2m20 2V8.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 5 19.92 5 18.8 5H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 6.52 2 7.08 2 8.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 19 4.08 19 5.2 19h5.3m11-1a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
  }))),
  file02: t => e.createElement("svg", qy({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Dy || (Dy = e.createElement("path", {
    d: "M14 11H8m2 4H8m8-8H8m12-.2v10.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C17.72 22 16.88 22 15.2 22H8.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.72 4 18.88 4 17.2V6.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C6.28 2 7.12 2 8.8 2h6.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C20 4.28 20 5.12 20 6.8Z"
  }))),
  layoutalt04: t => e.createElement("svg", $y({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Uy || (Uy = e.createElement("path", {
    d: "M12 12h9m-9-9v18M7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3Z"
  }))),
  globe04: t => e.createElement("svg", Wy({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), zy || (zy = e.createElement("path", {
    d: "m3.076 7.483 4.288 3.063c.223.159.335.239.451.257a.5.5 0 0 0 .301-.046c.106-.053.188-.163.353-.382l.906-1.208c.047-.063.07-.094.097-.12a.5.5 0 0 1 .08-.064c.032-.02.067-.036.138-.068l3.869-1.719c.16-.071.24-.107.3-.162a.5.5 0 0 0 .124-.177c.032-.076.037-.164.05-.339l.282-4.249M13.5 13.5l2.616 1.121c.303.13.455.195.536.303a.5.5 0 0 1 .098.33c-.009.134-.1.271-.284.546l-1.229 1.844c-.086.13-.13.195-.187.242a.5.5 0 0 1-.172.092c-.071.022-.15.022-.306.022h-1.995c-.208 0-.311 0-.4-.035a.5.5 0 0 1-.2-.144c-.061-.073-.094-.171-.16-.368l-.712-2.139a1.07 1.07 0 0 1-.063-.233.5.5 0 0 1 .01-.156c.014-.057.042-.112.096-.221l.542-1.083c.11-.22.165-.33.25-.399a.5.5 0 0 1 .26-.108c.108-.011.225.028.458.105l.842.281ZM22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }))),
  alignhorizontalcentre02: t => e.createElement("svg", Gy({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Qy || (Qy = e.createElement("path", {
    d: "M16 10c.932 0 1.398 0 1.765-.152a2 2 0 0 0 1.083-1.083C19 8.398 19 7.932 19 7c0-.932 0-1.398-.152-1.765a2 2 0 0 0-1.083-1.083C17.398 4 16.932 4 16 4H8c-.932 0-1.398 0-1.765.152a2 2 0 0 0-1.083 1.083C5 5.602 5 6.068 5 7c0 .932 0 1.398.152 1.765a2 2 0 0 0 1.083 1.083C6.602 10 7.068 10 8 10h8ZM18 20c.932 0 1.398 0 1.765-.152a2 2 0 0 0 1.083-1.083C21 18.398 21 17.932 21 17c0-.932 0-1.398-.152-1.765a2 2 0 0 0-1.083-1.083C19.398 14 18.932 14 18 14H6c-.932 0-1.398 0-1.765.152a2 2 0 0 0-1.083 1.083C3 15.602 3 16.068 3 17c0 .932 0 1.398.152 1.765a2 2 0 0 0 1.083 1.083C4.602 20 5.068 20 6 20h12Z"
  }))),
  arrownarrowupleft: t => e.createElement("svg", Ky({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Yy || (Yy = e.createElement("path", {
    d: "M18 18 6 6m0 0v8m0-8h8"
  }))),
  maximize01: t => e.createElement("svg", Jy({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Xy || (Xy = e.createElement("path", {
    d: "m14 10 7-7m0 0h-6m6 0v6m-11 5-7 7m0 0h6m-6 0v-6"
  }))),
  messagechatcircle: t => e.createElement("svg", tx({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ex || (ex = e.createElement("path", {
    d: "M6.094 11.229A8.01 8.01 0 0 1 6 10c0-4.418 3.605-8 8.053-8 4.447 0 8.052 3.582 8.052 8 0 .998-.184 1.954-.52 2.835-.07.182-.105.274-.12.345a.897.897 0 0 0-.024.194c-.002.073.008.153.028.314l.403 3.27c.043.355.065.532.006.66a.5.5 0 0 1-.257.252c-.13.055-.306.03-.66-.022l-3.184-.467c-.167-.024-.25-.037-.326-.036a.898.898 0 0 0-.2.021c-.074.016-.169.051-.358.122a8.174 8.174 0 0 1-4.07.42M7.632 22C10.597 22 13 19.538 13 16.5S10.597 11 7.632 11c-2.965 0-5.369 2.462-5.369 5.5 0 .61.097 1.198.277 1.747.075.232.113.348.126.427.013.083.015.13.01.213-.005.08-.025.17-.065.351L2 22l2.995-.409c.163-.022.245-.034.316-.033.076 0 .115.005.19.02.07.013.173.05.381.123a5.246 5.246 0 0 0 1.75.299Z"
  }))),
  repeat02: t => e.createElement("svg", nx({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), rx || (rx = e.createElement("path", {
    d: "m11 2 3 3m0 0-3 3m3-3H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 7.28 2 8.12 2 9.8v5.7c0 .464 0 .697.026.892a3 3 0 0 0 2.582 2.582c.195.026.428.026.892.026m4.5 0h7.2c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 16.72 22 15.88 22 14.2V8.5c0-.464 0-.697-.026-.892a3 3 0 0 0-2.582-2.582C19.197 5 18.964 5 18.5 5M10 19l3 3m-3-3 3-3"
  }))),
  fingerprint01: t => e.createElement("svg", ox({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ax || (ax = e.createElement("path", {
    d: "M6.918 3.386A9.954 9.954 0 0 1 12 2c5.523 0 10 4.477 10 10v.1M3.38 6.925A9.954 9.954 0 0 0 2 12c0 4.66 3.187 8.575 7.5 9.685m11.208-4.764a10.02 10.02 0 0 1-6.208 4.764m-.41-15.311A6 6 0 0 0 6.377 14.1m11.247-4.192a6 6 0 0 1-7.701 7.723M12 10v4"
  }))),
  palette: t => e.createElement("svg", sx({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ix || (ix = e.createElement("path", {
    d: "M2 12c0 5.523 4.477 10 10 10a3 3 0 0 0 3-3v-.5c0-.464 0-.697.026-.892a3 3 0 0 1 2.582-2.582c.195-.026.428-.026.892-.026h.5a3 3 0 0 0 3-3c0-5.523-4.477-10-10-10S2 6.477 2 12Z"
  })), lx || (lx = e.createElement("path", {
    d: "M7 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM16 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM10 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
  }))),
  messageheartsquare: t => e.createElement("svg", hx({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), cx || (cx = e.createElement("path", {
    d: "M3 7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v5.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 18 17.88 18 16.2 18h-2.516c-.624 0-.936 0-1.235.061a2.997 2.997 0 0 0-.761.267c-.272.14-.516.334-1.003.724L8.3 20.96c-.416.333-.624.5-.8.5a.5.5 0 0 1-.39-.188C7 21.135 7 20.868 7 20.336V18c-.93 0-1.395 0-1.776-.102a3 3 0 0 1-2.122-2.121C3 15.395 3 14.93 3 14V7.8Z"
  })), ux || (ux = e.createElement("path", {
    d: "M11.997 7.7c-.9-1.04-2.4-1.319-3.527-.368-1.128.952-1.286 2.542-.401 3.667.548.697 1.925 1.97 2.893 2.838.356.319.533.478.747.542.183.055.393.055.576 0 .213-.064.391-.223.747-.542.968-.868 2.345-2.14 2.893-2.838a2.606 2.606 0 0 0-.4-3.667c-1.147-.941-2.628-.672-3.528.367Z",
    clipRule: "evenodd"
  }))),
  trophy01: t => e.createElement("svg", px({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), mx || (mx = e.createElement("path", {
    d: "M12 15a6 6 0 0 1-6-6V3.444c0-.413 0-.62.06-.786a1 1 0 0 1 .598-.598C6.824 2 7.031 2 7.444 2h9.112c.413 0 .62 0 .786.06a1 1 0 0 1 .598.598c.06.166.06.373.06.786V9a6 6 0 0 1-6 6Zm0 0v3m6-14h2.5c.466 0 .699 0 .883.076a1 1 0 0 1 .54.541c.077.184.077.417.077.883V6c0 .93 0 1.395-.102 1.776a3 3 0 0 1-2.122 2.122C19.395 10 18.93 10 18 10M6 4H3.5c-.466 0-.699 0-.883.076a1 1 0 0 0-.54.541C2 4.801 2 5.034 2 5.5V6c0 .93 0 1.395.102 1.776a3 3 0 0 0 2.122 2.122C4.605 10 5.07 10 6 10m1.444 12h9.112a.444.444 0 0 0 .444-.444A3.556 3.556 0 0 0 13.444 18h-2.888A3.556 3.556 0 0 0 7 21.556c0 .245.199.444.444.444Z"
  }))),
  inbox02: t => e.createElement("svg", dx({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), fx || (fx = e.createElement("path", {
    d: "M2 12h3.882c.685 0 1.312.387 1.618 1 .306.613.933 1 1.618 1h5.764c.685 0 1.312-.387 1.618-1 .306-.613.933-1 1.618-1H22M2 12V8.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C4.28 4 5.12 4 6.8 4h10.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C22 6.28 22 7.12 22 8.8V12M2 12v3.2c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 20 5.12 20 6.8 20h10.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 17.72 22 16.88 22 15.2V12"
  }))),
  rollerbrush: t => e.createElement("svg", gx({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), vx || (vx = e.createElement("path", {
    d: "M19 4.5c0 .465 0 .697-.038.89a2 2 0 0 1-1.572 1.572C17.197 7 16.965 7 16.5 7h-11c-.465 0-.697 0-.89-.038A2 2 0 0 1 3.038 5.39C3 5.197 3 4.965 3 4.5s0-.697.038-.89A2 2 0 0 1 4.61 2.038C4.803 2 5.035 2 5.5 2h11c.465 0 .697 0 .89.038a2 2 0 0 1 1.572 1.572c.038.193.038.425.038.89Zm0 0c.932 0 1.398 0 1.765.152a2 2 0 0 1 1.083 1.083C22 6.102 22 6.568 22 7.5v.3c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C20.48 11 19.92 11 18.8 11h-3.6c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C12 12.52 12 13.08 12 14.2v.8m-.4 7h.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C14 21.24 14 20.96 14 20.4v-3.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C13.24 15 12.96 15 12.4 15h-.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C10 15.76 10 16.04 10 16.6v3.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C10.76 22 11.04 22 11.6 22Z"
  }))),
  save01: t => e.createElement("svg", wx({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), bx || (bx = e.createElement("path", {
    d: "M7 3v3.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C7.76 8 8.04 8 8.6 8h6.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C17 7.24 17 6.96 17 6.4V4m0 17v-6.4c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C16.24 13 15.96 13 15.4 13H8.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C7 13.76 7 14.04 7 14.6V21M21 9.325V16.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3h6.875c.489 0 .733 0 .963.055.204.05.4.13.579.24.201.123.374.296.72.642l3.126 3.126c.346.346.519.519.642.72.11.18.19.374.24.579.055.23.055.474.055.963Z"
  }))),
  share04: t => e.createElement("svg", xx({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), yx || (yx = e.createElement("path", {
    d: "M21 9V3m0 0h-6m6 0-8 8m-3-6H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 7.28 3 8.12 3 9.8v6.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C19 18.72 19 17.88 19 16.2V14"
  }))),
  infocircle: t => e.createElement("svg", Ex({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Ox || (Ox = e.createElement("path", {
    d: "M12 16v-4m0-4h.01M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }))),
  chartbreakoutsquare: t => e.createElement("svg", Cx({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), jx || (jx = e.createElement("path", {
    d: "M11 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V13m-9-5h4v4m-.5-8.5V2m3.94 2.56L20.5 3.5m.01 5h1.5M3 13.347c.652.1 1.32.153 2 .153 4.386 0 8.265-2.172 10.62-5.5"
  }))),
  divide03: t => e.createElement("svg", Mx({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Px || (Px = e.createElement("path", {
    d: "M12 8h.01M12 16h.01M7 12h10m-4.5-4a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm0 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm9.5-4c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }))),
  fileplus01: t => e.createElement("svg", Sx({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), kx || (kx = e.createElement("path", {
    d: "M20 10.5V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 2 16.88 2 15.2 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22H12m6-1v-6m-3 3h6"
  }))),
  usersleft: t => e.createElement("svg", Bx({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Nx || (Nx = e.createElement("path", {
    d: "m19 21-3-3m0 0 3-3m-3 3h6M15.5 3.29a4.001 4.001 0 0 1 0 7.42M12 15H8c-1.864 0-2.796 0-3.53.305a4 4 0 0 0-2.166 2.164C2 18.204 2 19.136 2 21M13.5 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
  }))),
  folderplus: t => e.createElement("svg", Rx({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Vx || (Vx = e.createElement("path", {
    d: "m13 7-1.116-2.231c-.32-.642-.481-.963-.72-1.198a2 2 0 0 0-.748-.462C10.1 3 9.74 3 9.022 3H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 4.52 2 5.08 2 6.2V7m0 0h15.2c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C22 9.28 22 10.12 22 11.8v4.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C19.72 21 18.88 21 17.2 21H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.72 2 17.88 2 16.2V7Zm10 10v-6m-3 3h6"
  }))),
  gitmerge: t => e.createElement("svg", Tx({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Ax || (Ax = e.createElement("path", {
    d: "M15 18a3 3 0 1 0 6 0 3 3 0 0 0-6 0Zm0 0a9 9 0 0 1-9-9m0 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0 0v12"
  }))),
  imageusercheck: t => e.createElement("svg", Lx({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Hx || (Hx = e.createElement("path", {
    d: "m16 5 2 2 4-4m0 9v5.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C19.72 22 18.88 22 17.2 22H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 19.72 2 18.88 2 17.2V6.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C4.28 2 5.12 2 6.8 2H12M2.146 19.926A4.002 4.002 0 0 1 6 17h7c.93 0 1.394 0 1.78.077a4 4 0 0 1 3.143 3.143c.077.386.077.85.077 1.78M14 9.5a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
  }))),
  perspective01: t => e.createElement("svg", Fx({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Ix || (Ix = e.createElement("path", {
    d: "M19 9v6M5 7v10M17 6.714 7 5.286m10 12L7 18.714M4.6 7h.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C7 6.24 7 5.96 7 5.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C6.24 3 5.96 3 5.4 3h-.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 3.76 3 4.04 3 4.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C3.76 7 4.04 7 4.6 7Zm0 14h.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C7 20.24 7 19.96 7 19.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C6.24 17 5.96 17 5.4 17h-.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 17.76 3 18.04 3 18.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C3.76 21 4.04 21 4.6 21Zm14-12h.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C21 8.24 21 7.96 21 7.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C20.24 5 19.96 5 19.4 5h-.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C17 5.76 17 6.04 17 6.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C17.76 9 18.04 9 18.6 9Zm0 10h.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C21 18.24 21 17.96 21 17.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C20.24 15 19.96 15 19.4 15h-.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C17 15.76 17 16.04 17 16.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C17.76 19 18.04 19 18.6 19Z"
  }))),
  creditcard01: t => e.createElement("svg", Zx({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), _x || (_x = e.createElement("path", {
    d: "M22 10H2m0-1.8v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 19 4.08 19 5.2 19h13.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C22 17.48 22 16.92 22 15.8V8.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 5 19.92 5 18.8 5H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 6.52 2 7.08 2 8.2Z"
  }))),
  switchhorizontal01: t => e.createElement("svg", qx({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Dx || (Dx = e.createElement("path", {
    d: "M20 17H4m0 0 4-4m-4 4 4 4M4 7h16m0 0-4-4m4 4-4 4"
  }))),
  monitor04: t => e.createElement("svg", $x({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Ux || (Ux = e.createElement("path", {
    d: "M15 17v4H9v-4m-3.8 0h13.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C22 15.48 22 14.92 22 13.8V6.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 3 19.92 3 18.8 3H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 4.52 2 5.08 2 6.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 17 4.08 17 5.2 17Z"
  }))),
  percent01: t => e.createElement("svg", Wx({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), zx || (zx = e.createElement("path", {
    d: "M19 5 5 19M7.5 6.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm11 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
  }))),
  fileattachment04: t => e.createElement("svg", Gx({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Qx || (Qx = e.createElement("path", {
    d: "M20 7v-.2c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 2 16.88 2 15.2 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22h3.7m0-11H8m3.5 4H8m8-8H8m10 11v-5.5a1.5 1.5 0 0 1 3 0V18a3 3 0 1 1-6 0v-4"
  }))),
  server01: t => e.createElement("svg", Kx({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Yx || (Yx = e.createElement("path", {
    d: "M6 6h.01M6 18h.01m-.81-8h13.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C22 8.48 22 7.92 22 6.8V5.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 2 19.92 2 18.8 2H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 3.52 2 4.08 2 5.2v1.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 10 4.08 10 5.2 10Zm0 12h13.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C22 20.48 22 19.92 22 18.8v-1.6c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 14 19.92 14 18.8 14H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 15.52 2 16.08 2 17.2v1.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 22 4.08 22 5.2 22Z"
  }))),
  userdown02: t => e.createElement("svg", Jx({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Xx || (Xx = e.createElement("path", {
    d: "m16 7 3 3m0 0 3-3m-3 3V4m-3 17v-1.2c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C13.72 15 12.88 15 11.2 15H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 17.28 2 18.12 2 19.8V21M12.5 7.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
  }))),
  keyboard01: t => e.createElement("svg", tO({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), eO || (eO = e.createElement("path", {
    d: "M6 10h.01M8 14h.01M10 10h.01M12 14h.01M14 10h.01M16 14h.01M18 10h.01M5.2 18h13.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C22 16.48 22 15.92 22 14.8V9.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 6 19.92 6 18.8 6H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 7.52 2 8.08 2 9.2v5.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 18 4.08 18 5.2 18Z"
  }))),
  keyboard03: t => e.createElement("svg", nO({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32",
    width: "1em",
    height: "1em"
  }, t), rO || (rO = e.createElement("path", {
    d: "M9.333 19.333h13.333M6.933 24h18.134c1.493 0 2.24 0 2.81-.29.502-.256.91-.664 1.166-1.166.29-.57.29-1.317.29-2.81v-7.467c0-1.494 0-2.24-.29-2.811a2.666 2.666 0 0 0-1.166-1.165C27.307 8 26.56 8 25.067 8H6.933c-1.493 0-2.24 0-2.81.29-.502.256-.91.664-1.166 1.166-.29.57-.29 1.317-.29 2.81v7.467c0 1.494 0 2.24.29 2.811.256.502.664.91 1.166 1.165.57.291 1.317.291 2.81.291ZM7 13h3M14 13h4M22 13h3"
  }))),
  tram: t => e.createElement("svg", oO({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), aO || (aO = e.createElement("path", {
    d: "m18.5 3-.986-.493c-.378-.19-.567-.284-.765-.35a3.004 3.004 0 0 0-.541-.128C16 2 15.79 2 15.367 2H8.633c-.422 0-.634 0-.84.029a3 3 0 0 0-.541.128c-.199.066-.388.16-.765.35L5.5 3M11 6 9 2m4 4 2-4M4 13h16m-3 7 1 2M7 20l-1 2m2.5-5.5h.01m6.99 0h.01M8.8 20h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 17.72 20 16.88 20 15.2v-4.4c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 6 16.88 6 15.2 6H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 8.28 4 9.12 4 10.8v4.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 20 7.12 20 8.8 20Zm.2-3.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm7 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
  }))),
  download02: t => e.createElement("svg", lO({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), iO || (iO = e.createElement("path", {
    d: "M21 21H3m15-10-6 6m0 0-6-6m6 6V3"
  }))),
  zoomin: t => e.createElement("svg", cO({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), sO || (sO = e.createElement("path", {
    d: "m21 21-4.35-4.35M11 8v6m-3-3h6m5 0a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z"
  }))),
  cursor04: t => e.createElement("svg", hO({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), uO || (uO = e.createElement("path", {
    d: "M4.407 3.414c-.458-.135-.687-.202-.843-.144a.5.5 0 0 0-.294.294c-.058.156.01.385.144.843l4.206 14.3c.125.426.188.64.314.738a.5.5 0 0 0 .39.1c.158-.027.315-.184.63-.498L12 16l4.434 4.434c.198.198.297.297.412.335a.5.5 0 0 0 .309 0c.114-.037.213-.136.41-.334l2.87-2.87c.198-.197.297-.296.334-.41a.5.5 0 0 0 0-.31c-.037-.113-.136-.212-.334-.41L16 12l3.047-3.047c.314-.314.471-.47.497-.629a.5.5 0 0 0-.1-.39c-.098-.126-.31-.189-.737-.314l-14.3-4.206Z"
  }))),
  playsquare: t => e.createElement("svg", fO({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), mO || (mO = e.createElement("path", {
    d: "M9.5 8.965c0-.477 0-.716.1-.849a.5.5 0 0 1 .364-.199c.166-.012.367.117.769.375l4.72 3.035c.349.224.523.336.583.478a.5.5 0 0 1 0 .39c-.06.142-.234.254-.583.478l-4.72 3.035c-.402.258-.603.387-.769.375a.5.5 0 0 1-.364-.2c-.1-.132-.1-.371-.1-.848v-6.07Z"
  })), pO || (pO = e.createElement("path", {
    d: "M3 7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8Z"
  }))),
  cloudsun03: t => e.createElement("svg", vO({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), dO || (dO = e.createElement("path", {
    d: "M3.15 11a7.5 7.5 0 1 1 14.784-2.5M6 22a4 4 0 1 1 .337-7.986 6.003 6.003 0 0 1 10.866-1.004A4.5 4.5 0 1 1 17.5 22H6Z"
  }))),
  tag03: t => e.createElement("svg", bO({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), gO || (gO = e.createElement("path", {
    d: "m21 11-7.594-7.594c-.519-.519-.778-.778-1.081-.964a3.001 3.001 0 0 0-.867-.36C11.112 2 10.745 2 10.012 2H6M3 8.7v1.975c0 .489 0 .733.055.963.05.204.13.4.24.579.123.201.296.374.642.72l7.8 7.8c.792.792 1.188 1.188 1.645 1.337a2 2 0 0 0 1.236 0c.457-.149.853-.545 1.645-1.337l2.474-2.474c.792-.792 1.188-1.188 1.337-1.645a2 2 0 0 0 0-1.236c-.149-.457-.545-.853-1.337-1.645l-7.3-7.3c-.346-.346-.519-.519-.72-.642a2.001 2.001 0 0 0-.579-.24c-.23-.055-.474-.055-.963-.055H6.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C3 7.02 3 7.58 3 8.7Z"
  }))),
  gift02: t => e.createElement("svg", yO({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), wO || (wO = e.createElement("path", {
    d: "M12 7H7.5a2.5 2.5 0 1 1 0-5C11 2 12 7 12 7Zm0 0h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7Zm0 0v15M2 14h20M2 10.2v8.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 22 4.08 22 5.2 22h13.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C22 20.48 22 19.92 22 18.8v-8.6c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 7 19.92 7 18.8 7H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 8.52 2 9.08 2 10.2Z"
  }))),
  upload02: t => e.createElement("svg", OO({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), xO || (xO = e.createElement("path", {
    d: "M21 3H3m15 10-6-6m0 0-6 6m6-6v14"
  }))),
  arrownarrowdownright: t => e.createElement("svg", jO({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), EO || (EO = e.createElement("path", {
    d: "m6 6 12 12m0 0v-8m0 8h-8"
  }))),
  globe021: t => e.createElement("svg", PO({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), CO || (CO = e.createElement("path", {
    d: "m2.661 18.34 4.594-4.595M18.218 2.783A9.5 9.5 0 1 1 4.783 16.218M17 22H7m5 0v-3m5.5-9.5a6 6 0 1 1-12 0 6 6 0 0 1 12 0Z"
  }))),
  recording02: t => e.createElement("svg", kO({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), MO || (MO = e.createElement("path", {
    d: "M3 10v4m4.5-3v2M12 6v12m4.5-15v18M21 10v4"
  }))),
  bookmarkx: t => e.createElement("svg", NO({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), SO || (SO = e.createElement("path", {
    d: "m9.5 7.5 5 5m0-5-5 5M19 21V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C16.72 3 15.88 3 14.2 3H9.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C5 5.28 5 6.12 5 7.8V21l7-4 7 4Z"
  }))),
  userleft01: t => e.createElement("svg", VO({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), BO || (BO = e.createElement("path", {
    d: "m19 21-3-3m0 0 3-3m-3 3h6m-10-2.5H7.5c-1.396 0-2.093 0-2.661.172a4 4 0 0 0-2.667 2.667C2 18.907 2 19.604 2 21M14.5 7.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Z"
  }))),
  star02: t => e.createElement("svg", AO({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), RO || (RO = e.createElement("path", {
    d: "M11.306 3.207c.228-.396.342-.594.49-.66a.5.5 0 0 1 .408 0c.148.066.262.264.49.66l1.955 3.402c.084.147.126.22.185.273a.5.5 0 0 0 .181.105c.076.024.16.024.33.024l3.923-.008c.457-.001.685-.002.817.094a.5.5 0 0 1 .204.353c.016.162-.098.36-.327.754l-1.97 3.394c-.084.147-.126.22-.143.297a.5.5 0 0 0 0 .21c.017.077.06.15.144.296l1.969 3.395c.229.395.343.592.327.754a.5.5 0 0 1-.204.353c-.132.096-.36.095-.817.094l-3.924-.008c-.169 0-.253 0-.329.024a.5.5 0 0 0-.18.104c-.06.054-.102.127-.186.273l-1.955 3.403c-.228.396-.342.594-.49.66a.5.5 0 0 1-.408 0c-.148-.066-.262-.264-.49-.66L9.351 17.39c-.084-.147-.126-.22-.185-.273a.5.5 0 0 0-.18-.105c-.076-.024-.161-.024-.33-.024l-3.924.008c-.457.001-.685.002-.817-.094a.5.5 0 0 1-.203-.353c-.017-.162.097-.36.326-.754l1.97-3.395c.084-.146.126-.219.143-.297a.5.5 0 0 0 0-.208c-.017-.078-.059-.151-.144-.298L4.038 8.204c-.229-.395-.343-.592-.326-.754a.5.5 0 0 1 .203-.353c.132-.096.36-.095.817-.094l3.924.008c.169 0 .254 0 .33-.024a.5.5 0 0 0 .18-.105c.059-.053.101-.126.185-.273l1.955-3.402Z"
  }))),
  copy03: t => e.createElement("svg", HO({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), TO || (TO = e.createElement("path", {
    d: "M8 8V5.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C9.52 2 10.08 2 11.2 2h7.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C22 3.52 22 4.08 22 5.2v7.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C20.48 16 19.92 16 18.8 16H16M5.2 22h7.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C16 20.48 16 19.92 16 18.8v-7.6c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C14.48 8 13.92 8 12.8 8H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 9.52 2 10.08 2 11.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 22 4.08 22 5.2 22Z"
  }))),
  filterlines: t => e.createElement("svg", IO({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), LO || (LO = e.createElement("path", {
    d: "M6 12h12M3 6h18M9 18h6"
  }))),
  copy02: t => e.createElement("svg", _O({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), FO || (FO = e.createElement("path", {
    d: "M16 8V5.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C14.48 2 13.92 2 12.8 2H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 3.52 2 4.08 2 5.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 16 4.08 16 5.2 16H8m3.2 6h7.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C22 20.48 22 19.92 22 18.8v-7.6c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 8 19.92 8 18.8 8h-7.6c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C8 9.52 8 10.08 8 11.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C9.52 22 10.08 22 11.2 22Z"
  }))),
  star03: t => e.createElement("svg", DO({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ZO || (ZO = e.createElement("path", {
    d: "M11.29 3.366c.23-.442.344-.663.498-.735a.5.5 0 0 1 .423 0c.154.072.269.293.498.735l1.514 2.913c.099.19.148.286.222.349a.5.5 0 0 0 .23.11c.095.019.2-.002.412-.043l3.22-.633c.489-.096.733-.144.885-.069a.5.5 0 0 1 .264.331c.04.165-.061.393-.264.848l-1.333 2.999c-.088.196-.131.294-.135.392a.5.5 0 0 0 .057.248c.045.086.127.156.291.295l2.503 2.123c.38.322.57.483.605.65a.5.5 0 0 1-.094.412c-.104.134-.345.197-.827.322l-3.176.827c-.208.054-.312.082-.39.14a.5.5 0 0 0-.159.199c-.04.089-.043.196-.05.411l-.099 3.28c-.015.498-.023.748-.13.879a.5.5 0 0 1-.381.183c-.17.003-.37-.147-.768-.445l-2.627-1.968c-.172-.129-.258-.193-.352-.218a.498.498 0 0 0-.255 0c-.094.025-.18.09-.352.218l-2.627 1.968c-.399.298-.598.448-.768.445a.5.5 0 0 1-.38-.183c-.108-.131-.116-.38-.131-.878l-.1-3.28c-.006-.216-.01-.323-.049-.412a.5.5 0 0 0-.158-.2c-.079-.058-.183-.085-.39-.139l-3.177-.827c-.482-.125-.723-.188-.827-.322a.5.5 0 0 1-.094-.412c.036-.167.226-.328.605-.65l2.503-2.123c.164-.14.246-.209.291-.295a.5.5 0 0 0 .057-.248c-.004-.098-.047-.196-.135-.392L4.808 7.172c-.203-.455-.304-.683-.264-.848a.5.5 0 0 1 .264-.33c.152-.076.396-.028.885.068l3.22.633c.211.041.317.062.413.043a.5.5 0 0 0 .229-.11c.074-.063.124-.159.223-.35l1.513-2.912Z"
  }))),
  messagetextcircle02: t => e.createElement("svg", UO({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), qO || (qO = e.createElement("path", {
    d: "M8 9.5h4M8 13h7m-3 8a9 9 0 1 0-8.342-5.616c.081.2.122.3.14.381a.907.907 0 0 1 .024.219c0 .083-.015.173-.045.353l-.593 3.558c-.062.373-.093.56-.035.694a.5.5 0 0 0 .262.262c.135.058.321.027.694-.035l3.558-.593c.18-.03.27-.045.353-.045.081 0 .14.006.219.024.08.018.18.059.38.14A8.973 8.973 0 0 0 12 21Z"
  }))),
  phone01: t => e.createElement("svg", zO({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), $O || ($O = e.createElement("path", {
    d: "M12 17.5h.01M8.2 22h7.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C19 20.48 19 19.92 19 18.8V5.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C17.48 2 16.92 2 15.8 2H8.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C5 3.52 5 4.08 5 5.2v13.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C6.52 22 7.08 22 8.2 22Zm4.3-4.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
  }))),
  recording03: t => e.createElement("svg", QO({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), WO || (WO = e.createElement("path", {
    d: "M6 11v2m4-4v6m4-8v10m4-6v2m4-1c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }))),
  fastbackward: t => e.createElement("svg", YO({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), GO || (GO = e.createElement("path", {
    d: "M22 16.437c0 1.13 0 1.695-.229 1.972a1 1 0 0 1-.809.363c-.358-.013-.78-.388-1.625-1.14l-4.992-4.436c-.465-.414-.698-.62-.784-.865a1 1 0 0 1 0-.662c.086-.245.319-.451.784-.865l4.992-4.437c.844-.75 1.267-1.126 1.625-1.14a1 1 0 0 1 .81.364c.228.277.228.842.228 1.972v8.874ZM11 16.437c0 1.13 0 1.695-.229 1.972a1 1 0 0 1-.809.363c-.358-.013-.78-.388-1.625-1.14l-4.992-4.436c-.465-.414-.698-.62-.784-.865a1 1 0 0 1 0-.662c.086-.245.319-.451.784-.865l4.992-4.437c.844-.75 1.267-1.126 1.625-1.14a1 1 0 0 1 .81.364c.228.277.228.842.228 1.972v8.874Z"
  }))),
  messagequestionsquare: t => e.createElement("svg", XO({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), KO || (KO = e.createElement("path", {
    d: "M10 8.002a2.249 2.249 0 0 1 4.37.75c0 1.499-2.25 2.248-2.25 2.248m.03 3h.01M7 18v2.335c0 .533 0 .8.11.937a.5.5 0 0 0 .39.188c.176 0 .384-.167.8-.5l2.385-1.908c.487-.39.731-.585 1.002-.724.241-.122.497-.212.762-.267.299-.061.61-.061 1.235-.061H16.2c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 15.72 21 14.88 21 13.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8V14c0 .93 0 1.395.102 1.777a3 3 0 0 0 2.122 2.12C5.605 18 6.07 18 7 18Z"
  }))),
  userscheck: t => e.createElement("svg", eE({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), JO || (JO = e.createElement("path", {
    d: "m16 18 2 2 4-4m-10-1H8c-1.864 0-2.796 0-3.53.305a4 4 0 0 0-2.166 2.164C2 18.204 2 19.136 2 21M15.5 3.29a4.001 4.001 0 0 1 0 7.42M13.5 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
  }))),
  layoutright: t => e.createElement("svg", rE({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), tE || (tE = e.createElement("path", {
    d: "M15 3v18M7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3Z"
  }))),
  upload03: t => e.createElement("svg", aE({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), nE || (nE = e.createElement("path", {
    d: "m16 12-4-4m0 0-4 4m4-4v8m10-4c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }))),
  heartsquare: t => e.createElement("svg", lE({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), oE || (oE = e.createElement("path", {
    d: "M3 7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8Z"
  })), iE || (iE = e.createElement("path", {
    d: "M11.997 9.068c-1-1.169-2.667-1.483-3.92-.413-1.252 1.07-1.429 2.86-.445 4.125.63.81 2.244 2.314 3.322 3.29.359.325.538.487.753.552.184.056.395.056.58 0 .214-.065.393-.227.752-.552 1.079-.976 2.692-2.48 3.322-3.29.984-1.265.829-3.066-.445-4.125-1.274-1.059-2.92-.756-3.92.413Z",
    clipRule: "evenodd"
  }))),
  tag02: t => e.createElement("svg", cE({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), sE || (sE = e.createElement("path", {
    d: "M8 8h.01M4.563 2.937 2.937 4.563c-.346.346-.519.519-.642.72a2 2 0 0 0-.24.579C2 6.092 2 6.336 2 6.825v2.85c0 .489 0 .733.055.963.05.204.13.4.24.579.123.201.296.374.642.72l7.669 7.669c1.188 1.188 1.782 1.782 2.467 2.004a3 3 0 0 0 1.854 0c.685-.222 1.28-.816 2.467-2.004l2.212-2.212c1.188-1.188 1.782-1.782 2.004-2.467a3 3 0 0 0 0-1.854c-.222-.685-.816-1.28-2.004-2.467l-7.669-7.669c-.346-.346-.519-.519-.72-.642a2.001 2.001 0 0 0-.579-.24C10.409 2 10.165 2 9.676 2h-2.85c-.489 0-.733 0-.963.055a2 2 0 0 0-.579.24c-.201.123-.374.296-.72.642ZM8.5 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
  }))),
  switchvertical01: t => e.createElement("svg", hE({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), uE || (uE = e.createElement("path", {
    d: "M17 4v16m0 0-4-4m4 4 4-4M7 20V4m0 0L3 8m4-4 4 4"
  }))),
  alignright: t => e.createElement("svg", pE({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), mE || (mE = e.createElement("path", {
    d: "M21 10H8m13-4H4m17 8H4m17 4H8"
  }))),
  cloudsun02: t => e.createElement("svg", dE({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), fE || (fE = e.createElement("path", {
    d: "M10.5 1.5v1.6M3.6 10H2m3.451-5.049L4.32 3.82m11.23 1.131L16.68 3.82M19 10h-1.6M6.5 10A4 4 0 0 1 14 8.062M6 22a4 4 0 1 1 1.324-7.775 5.002 5.002 0 0 1 9.352 0A4 4 0 1 1 18 22H6Z"
  }))),
  cube01: t => e.createElement("svg", gE({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), vE || (vE = e.createElement("path", {
    d: "M20.5 7.278 12 12m0 0L3.5 7.278M12 12v9.5m9-5.441V7.942c0-.343 0-.514-.05-.667a1 1 0 0 0-.215-.364c-.109-.119-.258-.202-.558-.368l-7.4-4.111c-.284-.158-.425-.237-.575-.267a1 1 0 0 0-.403 0c-.15.03-.292.11-.576.267l-7.4 4.11c-.3.167-.45.25-.558.369a1 1 0 0 0-.215.364C3 7.428 3 7.599 3 7.942v8.117c0 .342 0 .514.05.666a1 1 0 0 0 .215.364c.109.119.258.202.558.368l7.4 4.111c.284.158.425.237.576.268.133.027.27.027.402 0 .15-.031.292-.11.576-.268l7.4-4.11c.3-.167.45-.25.558-.369a.999.999 0 0 0 .215-.364c.05-.152.05-.324.05-.666Z"
  }))),
  searchlg: t => e.createElement("svg", wE({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), bE || (bE = e.createElement("path", {
    d: "m21 21-3.5-3.5m2.5-6a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0Z"
  }))),
  download03: t => e.createElement("svg", xE({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), yE || (yE = e.createElement("path", {
    d: "m8 12 4 4m0 0 4-4m-4 4V8m10 4c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }))),
  checkcircle: t => e.createElement("svg", EE({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), OE || (OE = e.createElement("path", {
    d: "m7.5 12 3 3 6-6m5.5 3c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }))),
  pausesquare: t => e.createElement("svg", CE({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), jE || (jE = e.createElement("path", {
    d: "M9.5 15V9m5 6V9M7.8 21h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Z"
  }))),
  sunset: t => e.createElement("svg", ME({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), PE || (PE = e.createElement("path", {
    d: "M4 18H2m4.314-5.686L4.9 10.9m12.786 1.414L19.1 10.9M22 18h-2M7 18a5 5 0 0 1 10 0m5 4H2M16 5l-4 4m0 0L8 5m4 4V2"
  }))),
  horizontalbarchart01: t => e.createElement("svg", SE({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), kE || (kE = e.createElement("path", {
    d: "M17 9.5V6.1c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C16.24 4.5 15.96 4.5 15.4 4.5H3m10 10v3.4c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437c-.214.109-.494.109-1.054.109H3M3 2v20m0-7.5h16.4c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C21 13.74 21 13.46 21 12.9v-1.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C20.24 9.5 19.96 9.5 19.4 9.5H3v5Z"
  }))),
  pin02: t => e.createElement("svg", BE({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), NE || (NE = e.createElement("path", {
    d: "M8.377 15.616 2.72 21.273m8.974-14.631-1.56 1.56a2.099 2.099 0 0 1-.264.242 1 1 0 0 1-.207.111c-.082.032-.17.05-.347.085l-3.665.733c-.952.19-1.428.286-1.65.537a1 1 0 0 0-.243.8c.046.333.389.677 1.076 1.363l7.085 7.086c.687.687 1.03 1.03 1.363 1.076a1 1 0 0 0 .801-.242c.251-.223.346-.7.537-1.651l.733-3.665c.035-.176.053-.265.085-.347.029-.073.066-.143.11-.207.051-.072.115-.136.242-.263l1.561-1.561c.082-.082.122-.122.167-.158.04-.031.082-.06.126-.085.05-.029.102-.051.208-.097l2.495-1.069c.727-.312 1.091-.467 1.256-.72a1 1 0 0 0 .144-.747c-.06-.295-.34-.575-.9-1.135l-5.143-5.143c-.56-.56-.84-.84-1.135-.9a1 1 0 0 0-.747.145c-.252.165-.408.529-.72 1.256l-1.069 2.495a2.078 2.078 0 0 1-.096.208.998.998 0 0 1-.085.126 2.065 2.065 0 0 1-.158.167Z"
  }))),
  slashoctagon: t => e.createElement("svg", RE({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), VE || (VE = e.createElement("path", {
    d: "m4.93 4.93 14.14 14.14M2 8.523v6.954c0 .245 0 .367.028.482a1 1 0 0 0 .12.29c.061.1.148.187.32.36l4.923 4.922c.173.173.26.26.36.322.09.054.188.095.29.12.115.027.237.027.482.027h6.954c.245 0 .367 0 .482-.028a.998.998 0 0 0 .29-.12c.1-.061.187-.148.36-.32l4.922-4.923c.173-.173.26-.26.322-.36a.998.998 0 0 0 .12-.29c.027-.115.027-.237.027-.482V8.523c0-.245 0-.367-.028-.482a.998.998 0 0 0-.12-.29c-.061-.1-.148-.187-.32-.36L16.608 2.47c-.173-.173-.26-.26-.36-.322a1 1 0 0 0-.29-.12C15.844 2 15.722 2 15.477 2H8.523c-.245 0-.367 0-.482.028a1 1 0 0 0-.29.12c-.1.061-.187.148-.36.32L2.47 7.392c-.173.173-.26.26-.322.36a1 1 0 0 0-.12.29C2 8.156 2 8.278 2 8.523Z"
  }))),
  scan: t => e.createElement("svg", TE({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), AE || (AE = e.createElement("path", {
    d: "M8 3h-.2c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8V8m5 13h-.2c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V16m18-8v-.2c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H16m5 13v.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H16M3 12h.01m4.49 0h.01m8.99 0h.01M12 12h.01M21 12h.01"
  }))),
  fileattachment05: t => e.createElement("svg", LE({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), HE || (HE = e.createElement("path", {
    d: "M12 14V8.5a1.5 1.5 0 0 1 3 0V14a3 3 0 1 1-6 0v-4m-.2 12h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 19.72 20 18.88 20 17.2V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 2 16.88 2 15.2 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22Z"
  }))),
  monitor05: t => e.createElement("svg", FE({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), IE || (IE = e.createElement("path", {
    d: "M5.5 20H8m9-11h.01M8 6H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 7.52 2 8.08 2 9.2v3.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 16 4.08 16 5.2 16H8m7.2 4h3.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C22 18.48 22 17.92 22 16.8V7.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 4 19.92 4 18.8 4h-3.6c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C12 5.52 12 6.08 12 7.2v9.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C13.52 20 14.08 20 15.2 20Zm2.8-5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
  }))),
  cloudlightning: t => e.createElement("svg", ZE({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), _E || (_E = e.createElement("path", {
    d: "M19 15.744a4.502 4.502 0 0 0-1.08-8.725 6.002 6.002 0 0 0-11.84 0A4.5 4.5 0 0 0 5 15.744M13 10l-4 6h6l-4 6"
  }))),
  imageindentleft: t => e.createElement("svg", qE({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), DE || (DE = e.createElement("path", {
    d: "M21 9.25h-6M21 4H3m18 10.75h-6M21 20H3m1.6-4h4.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C11 15.24 11 14.96 11 14.4V9.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C10.24 8 9.96 8 9.4 8H4.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 8.76 3 9.04 3 9.6v4.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C3.76 16 4.04 16 4.6 16Z"
  }))),
  phonex: t => e.createElement("svg", $E({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), UE || (UE = e.createElement("path", {
    d: "m21 3-6 6m0-6 6 6m-10.773 4.863a14.604 14.604 0 0 1-2.847-4.01 1.698 1.698 0 0 1-.113-.266 1.046 1.046 0 0 1 .147-.862c.048-.067.105-.124.22-.238.35-.35.524-.524.638-.7a2 2 0 0 0 0-2.18c-.114-.176-.289-.351-.638-.7l-.195-.196c-.532-.531-.797-.797-1.083-.941a2 2 0 0 0-1.805 0c-.285.144-.551.41-1.083.941l-.157.158c-.53.53-.795.794-.997 1.154-.224.4-.386 1.02-.384 1.479 0 .413.081.695.241 1.26a19.038 19.038 0 0 0 4.874 8.283 19.039 19.039 0 0 0 8.283 4.873c.565.16.847.24 1.26.242a3.377 3.377 0 0 0 1.478-.384c.36-.203.625-.468 1.155-.997l.157-.158c.532-.531.797-.797.942-1.082a2 2 0 0 0 0-1.806c-.145-.285-.41-.55-.942-1.082l-.195-.195c-.35-.35-.524-.524-.7-.639a2 2 0 0 0-2.18 0c-.176.114-.35.29-.7.639-.115.114-.172.171-.239.22-.237.17-.581.228-.862.146a1.695 1.695 0 0 1-.266-.113 14.605 14.605 0 0 1-4.01-2.846Z"
  }))),
  divide02: t => e.createElement("svg", WE({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), zE || (zE = e.createElement("path", {
    d: "M4 12h16m-6-6a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm0 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
  }))),
  arrowcirclebrokenup: t => e.createElement("svg", GE({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), QE || (QE = e.createElement("path", {
    d: "M7 20.662A9.996 9.996 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10a9.996 9.996 0 0 1-5 8.662M16 12l-4-4m0 0-4 4m4-4v14"
  }))),
  codecircle01: t => e.createElement("svg", KE({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), YE || (YE = e.createElement("path", {
    d: "m14.5 15 3-3-3-3m-5 0-3 3 3 3M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }))),
  share05: t => e.createElement("svg", JE({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), XE || (XE = e.createElement("path", {
    d: "M21 6h-3.2c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C13 8.28 13 9.12 13 10.8V12m8-6-3-3m3 3-3 3m-8-6H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V14"
  }))),
  dataflow01: t => e.createElement("svg", tj({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ej || (ej = e.createElement("path", {
    d: "M17 20h-.2c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C12 17.72 12 16.88 12 15.2V8.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C14.28 4 15.12 4 16.8 4h.2m0 16a2 2 0 1 0 4 0 2 2 0 0 0-4 0Zm0-16a2 2 0 1 0 4 0 2 2 0 0 0-4 0ZM7 12h10M7 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm10 0a2 2 0 1 0 4 0 2 2 0 0 0-4 0Z"
  }))),
  truck01: t => e.createElement("svg", nj({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), rj || (rj = e.createElement("path", {
    d: "M14 7h2.337c.245 0 .367 0 .482.028a1 1 0 0 1 .29.12c.1.061.187.148.36.32l4.062 4.063c.173.173.26.26.322.36.054.09.095.188.12.29.027.115.027.237.027.482V15.5c0 .466 0 .699-.076.883a1 1 0 0 1-.541.54c-.184.077-.417.077-.883.077m-5 0H14m0 0V7.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C12.48 4 11.92 4 10.8 4H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 5.52 2 6.08 2 7.2V15a2 2 0 0 0 2 2m10 0h-4m0 0a3 3 0 1 1-6 0m6 0a3 3 0 1 0-6 0m16.5.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"
  }))),
  messagexsquare: t => e.createElement("svg", oj({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), aj || (aj = e.createElement("path", {
    d: "m9.5 8 5 5m0-5-5 5M7 18v2.335c0 .533 0 .8.11.937a.5.5 0 0 0 .39.188c.176 0 .384-.167.8-.5l2.385-1.908c.487-.39.731-.585 1.002-.724.241-.122.497-.212.762-.267.299-.061.61-.061 1.235-.061H16.2c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 15.72 21 14.88 21 13.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8V14c0 .93 0 1.395.102 1.777a3 3 0 0 0 2.122 2.12C5.605 18 6.07 18 7 18Z"
  }))),
  bookclosed: t => e.createElement("svg", lj({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ij || (ij = e.createElement("path", {
    d: "M20 19v-3H7a3 3 0 0 0-3 3m4.8 3h8c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C20 20.48 20 19.92 20 18.8V5.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C18.48 2 17.92 2 16.8 2h-8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22Z"
  }))),
  arrowblockleft: t => e.createElement("svg", cj({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), sj || (sj = e.createElement("path", {
    d: "m3 12 7-7v4h10.2c.28 0 .42 0 .527.055a.5.5 0 0 1 .218.218C21 9.38 21 9.52 21 9.8v4.4c0 .28 0 .42-.055.527a.5.5 0 0 1-.218.218C20.62 15 20.48 15 20.2 15H10v4l-7-7Z"
  }))),
  codecircle03: t => e.createElement("svg", hj({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), uj || (uj = e.createElement("path", {
    d: "m15.5 15 3-3-3-3m-7 0-3 3 3 3M13 7l-2 10m11-5c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }))),
  dataflow03: t => e.createElement("svg", pj({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), mj || (mj = e.createElement("path", {
    d: "M11 4.5h7.3c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874c.218.428.218.988.218 2.108V9c0 .932 0 1.398-.152 1.765a2 2 0 0 1-1.083 1.083C19.898 12 19.432 12 18.5 12M13 19.5H5.7c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C2.5 17.98 2.5 17.42 2.5 16.3V15c0-.932 0-1.398.152-1.765a2 2 0 0 1 1.083-1.083C4.102 12 4.568 12 5.5 12m4.8 2.5h3.4c.28 0 .42 0 .527-.055a.5.5 0 0 0 .218-.218c.055-.107.055-.247.055-.527v-3.4c0-.28 0-.42-.055-.527a.5.5 0 0 0-.218-.218C14.12 9.5 13.98 9.5 13.7 9.5h-3.4c-.28 0-.42 0-.527.055a.5.5 0 0 0-.218.218c-.055.107-.055.247-.055.527v3.4c0 .28 0 .42.055.527a.5.5 0 0 0 .218.218c.107.055.247.055.527.055Zm7.5 7.5h3.4c.28 0 .42 0 .527-.055a.5.5 0 0 0 .218-.218C22 21.62 22 21.48 22 21.2v-3.4c0-.28 0-.42-.055-.527a.5.5 0 0 0-.218-.218C21.62 17 21.48 17 21.2 17h-3.4c-.28 0-.42 0-.527.055a.5.5 0 0 0-.218.218C17 17.38 17 17.52 17 17.8v3.4c0 .28 0 .42.055.527a.5.5 0 0 0 .218.218c.107.055.247.055.527.055ZM2.8 7h3.4c.28 0 .42 0 .527-.054a.5.5 0 0 0 .218-.219C7 6.62 7 6.48 7 6.2V2.8c0-.28 0-.42-.054-.527a.5.5 0 0 0-.219-.219C6.62 2 6.48 2 6.2 2H2.8c-.28 0-.42 0-.527.054a.5.5 0 0 0-.219.219C2 2.38 2 2.52 2 2.8v3.4c0 .28 0 .42.054.527a.5.5 0 0 0 .219.218C2.38 7 2.52 7 2.8 7Z"
  }))),
  share07: t => e.createElement("svg", dj({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), fj || (fj = e.createElement("path", {
    d: "m8.59 13.51 6.83 3.98m-.01-10.98-6.82 3.98M21 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM9 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm12 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
  }))),
  annotationheart: t => e.createElement("svg", bj({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), vj || (vj = e.createElement("path", {
    d: "M3 7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v5.7c0 1.398 0 2.097-.228 2.648a3 3 0 0 1-1.624 1.624C18.597 18 17.898 18 16.5 18c-.489 0-.733 0-.96.053a2 2 0 0 0-.821.412c-.18.149-.326.344-.619.735l-1.46 1.947c-.217.29-.326.434-.459.486a.5.5 0 0 1-.362 0c-.133-.052-.242-.197-.459-.486L9.9 19.2c-.293-.39-.44-.586-.619-.735a2 2 0 0 0-.821-.412C8.233 18 7.989 18 7.5 18c-1.398 0-2.097 0-2.648-.228a3 3 0 0 1-1.624-1.624C3 15.597 3 14.898 3 13.5V7.8Z"
  })), gj || (gj = e.createElement("path", {
    d: "M11.997 8.33c-.8-.908-2.133-1.153-3.135-.32-1.002.832-1.143 2.223-.356 3.208.468.585 1.614 1.635 2.466 2.39.352.311.528.467.74.53.18.055.39.055.571 0 .212-.063.388-.219.74-.53.852-.755 1.998-1.805 2.466-2.39a2.256 2.256 0 0 0-.356-3.209c-1.02-.823-2.336-.587-3.136.322Z",
    clipRule: "evenodd"
  }))),
  paperclip: t => e.createElement("svg", yj({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), wj || (wj = e.createElement("path", {
    d: "m21.153 10.9-9.016 9.015a5.25 5.25 0 0 1-7.425-7.425l9.016-9.015a3.5 3.5 0 0 1 4.95 4.95l-8.662 8.662a1.75 1.75 0 1 1-2.475-2.475l7.601-7.602"
  }))),
  fileplus02: t => e.createElement("svg", Oj({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), xj || (xj = e.createElement("path", {
    d: "M20 10.5V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 2 16.88 2 15.2 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22H12m2-11H8m2 4H8m8-8H8m10 14v-6m-3 3h6"
  }))),
  coins04: t => e.createElement("svg", jj({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Ej || (Ej = e.createElement("path", {
    d: "M10.101 4A7 7 0 0 1 20 13.899M7.5 13 9 12v5.5m-1.5 0h3M16 15a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
  }))),
  clockcheck: t => e.createElement("svg", Pj({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Cj || (Cj = e.createElement("path", {
    d: "m14.5 19 2 2 4.5-4.5m.985-3.95c.01-.182.015-.366.015-.55 0-5.523-4.477-10-10-10S2 6.477 2 12c0 5.435 4.337 9.858 9.739 9.997M12 6v6l3.738 1.87"
  }))),
  percent02: t => e.createElement("svg", kj({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Mj || (Mj = e.createElement("path", {
    d: "M19 5 5 19M9 7a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm10 10a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
  }))),
  switchhorizontal02: t => e.createElement("svg", Nj({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Sj || (Sj = e.createElement("path", {
    d: "M4 17h16m0 0-4-4m4 4-4 4m4-14H4m0 0 4-4M4 7l4 4"
  }))),
  perspective02: t => e.createElement("svg", Vj({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Bj || (Bj = e.createElement("path", {
    d: "M16 5v14M10 4v16m-7-8h18M3 5.99v12.02c0 1.365 0 2.047.281 2.52a2 2 0 0 0 1.093.877c.523.171 1.189.024 2.52-.272l11.6-2.578c.894-.199 1.341-.298 1.675-.538a2 2 0 0 0 .669-.834c.162-.378.162-.836.162-1.752V8.567c0-.916 0-1.374-.162-1.752a2 2 0 0 0-.669-.833c-.334-.24-.78-.34-1.675-.539l-11.6-2.578c-1.331-.295-1.997-.443-2.52-.271a2 2 0 0 0-1.093.876C3 3.943 3 4.625 3 5.99Z"
  }))),
  creditcard02: t => e.createElement("svg", Aj({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Rj || (Rj = e.createElement("path", {
    d: "M22 10H2m9 4H6M2 8.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 19 4.08 19 5.2 19h13.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C22 17.48 22 16.92 22 15.8V8.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 5 19.92 5 18.8 5H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 6.52 2 7.08 2 8.2Z"
  }))),
  horizontalbarchart03: t => e.createElement("svg", Hj({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Tj || (Tj = e.createElement("path", {
    d: "M13 9.5V6.1c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C12.24 4.5 11.96 4.5 11.4 4.5H3m14 10v-3.4c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C16.24 9.5 15.96 9.5 15.4 9.5H3M3 2v20m0-2.5h16.4c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C21 18.74 21 18.46 21 17.9v-1.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437c-.214-.109-.494-.109-1.054-.109H3v5Z"
  }))),
  fastforward: t => e.createElement("svg", Ij({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Lj || (Lj = e.createElement("path", {
    d: "M13 16.437c0 1.13 0 1.695.228 1.972a1 1 0 0 0 .81.363c.358-.013.78-.388 1.625-1.14l4.992-4.436c.465-.414.698-.62.783-.865a1 1 0 0 0 0-.662c-.085-.245-.318-.451-.783-.865l-4.992-4.437c-.845-.75-1.267-1.126-1.626-1.14a1 1 0 0 0-.809.364C13 5.868 13 6.433 13 7.563v8.874ZM2 16.437c0 1.13 0 1.695.228 1.972a1 1 0 0 0 .81.363c.358-.013.78-.388 1.625-1.14l4.992-4.436c.465-.414.698-.62.783-.865a1 1 0 0 0 0-.662c-.085-.245-.318-.451-.783-.865L4.663 6.367c-.845-.75-1.267-1.126-1.626-1.14a1 1 0 0 0-.809.364C2 5.868 2 6.433 2 7.563v8.874Z"
  }))),
  server02: t => e.createElement("svg", _j({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Fj || (Fj = e.createElement("path", {
    d: "M6 8h.01M6 16h.01M6 12h12M6 12a4 4 0 0 1 0-8h12a4 4 0 0 1 0 8M6 12a4 4 0 0 0 0 8h12a4 4 0 0 0 0-8"
  }))),
  xsquare: t => e.createElement("svg", Dj({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Zj || (Zj = e.createElement("path", {
    d: "m9 9 6 6m0-6-6 6m-1.2 6h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Z"
  }))),
  keyboard02: t => e.createElement("svg", Uj({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), qj || (qj = e.createElement("path", {
    d: "M7 14.5h10M6 10h.01M10 10h.01M14 10h.01M18 10h.01M5.2 18h13.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C22 16.48 22 15.92 22 14.8V9.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 6 19.92 6 18.8 6H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 7.52 2 8.08 2 9.2v5.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 18 4.08 18 5.2 18Z"
  }))),
  bracketsellipses: t => e.createElement("svg", zj({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), $j || ($j = e.createElement("path", {
    d: "M18.57 20a2.286 2.286 0 0 0 2.287-2.286v-4.571L22 12l-1.143-1.143V6.286A2.285 2.285 0 0 0 18.57 4M5.429 4a2.285 2.285 0 0 0-2.286 2.286v4.571L2 12l1.143 1.143v4.571A2.285 2.285 0 0 0 5.429 20M7.5 12h.01M12 12h.01m4.49 0h.01M8 12a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm4.5 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm4.5 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
  }))),
  userdown01: t => e.createElement("svg", Qj({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Wj || (Wj = e.createElement("path", {
    d: "M12 15.5H7.5c-1.396 0-2.093 0-2.661.172a4 4 0 0 0-2.667 2.667C2 18.907 2 19.604 2 21m14-3 3 3m0 0 3-3m-3 3v-6m-4.5-7.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Z"
  }))),
  phonehangup: t => e.createElement("svg", Yj({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Gj || (Gj = e.createElement("path", {
    d: "M5.475 12.863a18.998 18.998 0 0 1-2.304-5.102c-.16-.564-.24-.846-.241-1.26a3.377 3.377 0 0 1 .384-1.478c.202-.36.467-.624.997-1.154l.157-.158c.532-.531.798-.797 1.083-.941a2 2 0 0 1 1.805 0c.286.144.551.41 1.083.941l.195.195c.35.35.524.525.638.7a2 2 0 0 1 0 2.18c-.114.177-.289.351-.638.701a2.02 2.02 0 0 0-.22.238c-.17.238-.228.582-.147.862.023.08.053.142.113.266.121.252.25.5.386.747m2.416 3.218.045.045a14.605 14.605 0 0 0 4.01 2.846c.124.06.187.09.265.113.28.082.625.023.862-.147.067-.048.124-.105.239-.22.35-.349.524-.524.7-.638a2 2 0 0 1 2.18 0c.176.114.35.29.7.639l.195.195c.532.531.797.797.942 1.082a2 2 0 0 1 0 1.806c-.145.285-.41.55-.942 1.082l-.157.158c-.53.53-.795.794-1.155.997-.4.224-1.02.385-1.478.384-.413-.001-.695-.081-1.26-.241a19.038 19.038 0 0 1-8.283-4.874L8 16M21 3 3 21"
  }))),
  currencyyen: t => e.createElement("svg", Xj({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Kj || (Kj = e.createElement("path", {
    d: "M12 20.5v-9m0 0 6.5-8m-6.5 8-6.5-8m12.5 8H6m11 4H7"
  }))),
  download01: t => e.createElement("svg", eC({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Jj || (Jj = e.createElement("path", {
    d: "M21 15v1.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V15m14-5-5 5m0 0-5-5m5 5V3"
  }))),
  imageright: t => e.createElement("svg", rC({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), tC || (tC = e.createElement("path", {
    d: "m19 8 3-3m0 0-3-3m3 3h-6m-3.5-2H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21H17c.93 0 1.395 0 1.776-.102a3 3 0 0 0 2.122-2.122C21 18.395 21 17.93 21 17M10.5 8.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4.49 3.418-8.459 7.69c-.476.433-.714.649-.735.836a.5.5 0 0 0 .167.431C6.105 21 6.426 21 7.07 21h9.387c1.44 0 2.159 0 2.724-.242a3 3 0 0 0 1.578-1.578c.242-.565.242-1.285.242-2.724 0-.484 0-.726-.053-.952a2.001 2.001 0 0 0-.374-.778c-.143-.182-.332-.333-.71-.636l-2.797-2.237c-.379-.303-.568-.454-.776-.508a1 1 0 0 0-.557.018c-.205.066-.384.23-.743.555Z"
  }))),
  zoomout: t => e.createElement("svg", aC({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), nC || (nC = e.createElement("path", {
    d: "m21 21-4.35-4.35M8 11h6m5 0a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z"
  }))),
  cube03: t => e.createElement("svg", iC({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), oC || (oC = e.createElement("path", {
    d: "M3.5 8H16m0 0v12.5M16 8l4.5-4.5m.5 11.837V3.8c0-.28 0-.42-.055-.527a.5.5 0 0 0-.218-.219C20.62 3 20.48 3 20.2 3H8.663c-.245 0-.367 0-.482.028a1 1 0 0 0-.29.12c-.1.061-.187.148-.36.32L3.47 7.532c-.173.173-.26.26-.322.36a1 1 0 0 0-.12.29C3 8.296 3 8.418 3 8.663V20.2c0 .28 0 .42.054.527a.5.5 0 0 0 .219.218C3.38 21 3.52 21 3.8 21h11.537c.245 0 .367 0 .482-.028a.998.998 0 0 0 .29-.12c.1-.061.187-.148.36-.32l4.062-4.063c.173-.173.26-.26.322-.36a.998.998 0 0 0 .12-.29c.027-.115.027-.237.027-.482Z"
  }))),
  box: t => e.createElement("svg", sC({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), lC || (lC = e.createElement("path", {
    d: "M20.5 8v8.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.22 21 17.38 21 15.7 21H8.3c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3.5 18.72 3.5 17.88 3.5 16.2V8m.1-5h16.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C22 3.76 22 4.04 22 4.6v1.8c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437C21.24 8 20.96 8 20.4 8H3.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C2 7.24 2 6.96 2 6.4V4.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C2.76 3 3.04 3 3.6 3Zm6 8.5h4.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C16 12.26 16 12.54 16 13.1v.8c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437c-.214.109-.494.109-1.054.109H9.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C8 14.74 8 14.46 8 13.9v-.8c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C8.76 11.5 9.04 11.5 9.6 11.5Z"
  }))),
  thumbsup: t => e.createElement("svg", uC({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), cC || (cC = e.createElement("path", {
    d: "M7 22V11m-5 2v7a2 2 0 0 0 2 2h13.426a3 3 0 0 0 2.965-2.544l1.077-7A3 3 0 0 0 18.503 9H15a1 1 0 0 1-1-1V4.466A2.466 2.466 0 0 0 11.534 2a.822.822 0 0 0-.75.488l-3.52 7.918A1 1 0 0 1 6.35 11H4a2 2 0 0 0-2 2Z"
  }))),
  batterylow: t => e.createElement("svg", mC({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), hC || (hC = e.createElement("path", {
    d: "M6.5 10v4M22 13v-2M6.8 18h7.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C19 15.72 19 14.88 19 13.2v-2.4c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C16.72 6 15.88 6 14.2 6H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 8.28 2 9.12 2 10.8v2.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 18 5.12 18 6.8 18Z"
  }))),
  arrowcircledownleft: t => e.createElement("svg", fC({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), pC || (pC = e.createElement("path", {
    d: "M9 9v6m0 0h6m-6 0 6-6m7 3c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }))),
  upload01: t => e.createElement("svg", vC({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), dC || (dC = e.createElement("path", {
    d: "M21 15v1.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V15m14-7-5-5m0 0L7 8m5-5v12"
  }))),
  pilcrowsquare: t => e.createElement("svg", bC({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), gC || (gC = e.createElement("path", {
    d: "M15 17V7h-4a3 3 0 0 0 0 6h4m-7.2 8h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Z"
  }))),
  gift01: t => e.createElement("svg", yC({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), wC || (wC = e.createElement("path", {
    d: "M12 6v16m0-16H8.464c-.52 0-1.02-.21-1.389-.586A2.019 2.019 0 0 1 6.5 4c0-.53.207-1.04.575-1.414A1.947 1.947 0 0 1 8.465 2C11.214 2 12 6 12 6Zm0 0h3.536c.52 0 1.02-.21 1.389-.586.368-.375.575-.884.575-1.414 0-.53-.207-1.04-.575-1.414A1.947 1.947 0 0 0 15.535 2C12.786 2 12 6 12 6Zm8 5v7.8c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C18.48 22 17.92 22 16.8 22H7.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C4 20.48 4 19.92 4 18.8V11M2 7.6v1.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C2.76 11 3.04 11 3.6 11h16.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C22 10.24 22 9.96 22 9.4V7.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C21.24 6 20.96 6 20.4 6H3.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C2 6.76 2 7.04 2 7.6Z"
  }))),
  facesmile: t => e.createElement("svg", OC({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), xC || (xC = e.createElement("path", {
    d: "M8 14s1.5 2 4 2 4-2 4-2m-1-5h.01M9 9h.01M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-6.5-3a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm-6 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
  }))),
  barchartsquaredown: t => e.createElement("svg", jC({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), EC || (EC = e.createElement("path", {
    d: "M12 3h4.2c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V12m5 1v4m8-6v6M12 7v10M2 5l3 3m0 0 3-3M5 8V2"
  }))),
  recording01: t => e.createElement("svg", PC({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), CC || (CC = e.createElement("path", {
    d: "M3 10v4m4.5-8v12M12 3v18m4.5-15v12m4.5-8v4"
  }))),
  square: t => e.createElement("svg", kC({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), MC || (MC = e.createElement("path", {
    d: "M3 7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8Z"
  }))),
  star01: t => e.createElement("svg", NC({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), SC || (SC = e.createElement("path", {
    d: "M11.283 3.453c.23-.467.345-.7.502-.775a.5.5 0 0 1 .43 0c.157.075.272.308.502.775l2.187 4.43c.068.138.102.207.152.26a.502.502 0 0 0 .155.114c.067.03.143.042.295.064l4.891.715c.515.075.773.113.892.238a.5.5 0 0 1 .133.41c-.023.172-.21.353-.582.716L17.3 13.846c-.11.108-.165.162-.2.226a.5.5 0 0 0-.06.183c-.009.072.004.148.03.3l.835 4.867c.088.514.132.77.05.922a.5.5 0 0 1-.349.253c-.17.032-.4-.09-.862-.332l-4.373-2.3c-.136-.07-.204-.107-.276-.12a.498.498 0 0 0-.192 0c-.072.013-.14.05-.276.12l-4.373 2.3c-.461.243-.692.364-.862.332a.5.5 0 0 1-.348-.253c-.083-.152-.039-.409.05-.922l.834-4.867c.026-.152.039-.228.03-.3a.5.5 0 0 0-.06-.184c-.035-.063-.09-.117-.2-.225L3.16 10.4c-.373-.363-.56-.544-.582-.716a.5.5 0 0 1 .132-.41c.12-.125.377-.163.892-.238l4.891-.715c.152-.022.228-.034.295-.064a.5.5 0 0 0 .155-.113c.05-.054.084-.123.152-.26l2.187-4.43Z"
  }))),
  play: t => e.createElement("svg", VC({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), BC || (BC = e.createElement("path", {
    d: "M5 4.99c0-.972 0-1.457.202-1.725a1 1 0 0 1 .738-.395c.335-.02.74.25 1.548.788l10.515 7.01c.668.446 1.002.668 1.118.949a1 1 0 0 1 0 .766c-.116.28-.45.503-1.118.948l-10.515 7.01c-.809.54-1.213.809-1.548.789a1 1 0 0 1-.738-.395C5 20.467 5 19.98 5 19.01V4.99Z"
  }))),
  heartoctagon: t => e.createElement("svg", TC({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), RC || (RC = e.createElement("path", {
    d: "M7.391 2.469c.173-.173.26-.26.36-.322a1 1 0 0 1 .29-.12C8.156 2 8.278 2 8.523 2h6.954c.245 0 .367 0 .482.028a1 1 0 0 1 .29.12c.1.061.187.148.36.32l4.922 4.923c.173.173.26.26.322.36.054.09.095.188.12.29.027.115.027.237.027.482v6.954c0 .245 0 .367-.028.482a.998.998 0 0 1-.12.29c-.061.1-.148.187-.32.36l-4.923 4.922c-.173.173-.26.26-.36.322a.998.998 0 0 1-.29.12c-.115.027-.237.027-.482.027H8.523c-.245 0-.367 0-.482-.028a.998.998 0 0 1-.29-.12c-.1-.061-.187-.148-.36-.32L2.47 16.608c-.173-.173-.26-.26-.322-.36a1 1 0 0 1-.12-.29C2 15.844 2 15.722 2 15.477V8.523c0-.245 0-.367.028-.482a1 1 0 0 1 .12-.29c.061-.1.148-.187.32-.36L7.392 2.47Z"
  })), AC || (AC = e.createElement("path", {
    d: "M11.997 9.068c-1-1.169-2.667-1.483-3.92-.413-1.252 1.07-1.429 2.86-.445 4.125.63.81 2.244 2.314 3.322 3.29.359.325.538.487.753.552.184.056.395.056.58 0 .214-.065.393-.227.752-.552 1.079-.976 2.692-2.48 3.322-3.29.984-1.265.829-3.066-.445-4.125-1.274-1.059-2.92-.756-3.92.413Z",
    clipRule: "evenodd"
  }))),
  userleft02: t => e.createElement("svg", LC({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), HC || (HC = e.createElement("path", {
    d: "m19 9-3-3m0 0 3-3m-3 3h6m-6 15v-1.2c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C13.72 15 12.88 15 11.2 15H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 17.28 2 18.12 2 19.8V21M12.5 7.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
  }))),
  gitcommit: t => e.createElement("svg", FC({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), IC || (IC = e.createElement("path", {
    d: "M16 12a4 4 0 0 1-8 0m8 0a4 4 0 0 0-8 0m8 0h6M8 12H2"
  }))),
  messagetextcircle01: t => e.createElement("svg", ZC({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), _C || (_C = e.createElement("path", {
    d: "M8 9.5h4M8 13h7m-2.5 7a8.5 8.5 0 1 0-8.057-5.783c.108.32.162.481.172.604a.899.899 0 0 1-.028.326c-.03.12-.098.245-.232.494l-1.636 3.027c-.233.432-.35.648-.324.815a.5.5 0 0 0 .234.35c.144.087.388.062.876.011l5.121-.529c.155-.016.233-.024.303-.021.07.002.12.009.187.024.069.016.155.05.329.116A8.478 8.478 0 0 0 12.5 20Z"
  }))),
  copy01: t => e.createElement("svg", qC({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), DC || (DC = e.createElement("path", {
    d: "M5 15c-.932 0-1.398 0-1.765-.152a2 2 0 0 1-1.083-1.083C2 13.398 2 12.932 2 12V5.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C3.52 2 4.08 2 5.2 2H12c.932 0 1.398 0 1.765.152a2 2 0 0 1 1.083 1.083C15 3.602 15 4.068 15 5m-2.8 17h6.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C22 20.48 22 19.92 22 18.8v-6.6c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 9 19.92 9 18.8 9h-6.6c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C9 10.52 9 11.08 9 12.2v6.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C10.52 22 11.08 22 12.2 22Z"
  }))),
  paragraphwrap: t => e.createElement("svg", $C({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), UC || (UC = e.createElement("path", {
    d: "M3 6h18M3 12h15a3 3 0 0 1 0 6h-4m0 0 2-2m-2 2 2 2M3 18h7"
  }))),
  griddotsbottom: t => e.createElement("svg", WC({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), zC || (zC = e.createElement("path", {
    d: "M3 3h.01M3 12h.01M3 16.5h.01M3 7.5h.01M7.5 3h.01m-.01 9h.01m8.99-9h.01m-.01 9h.01M12 3h.01M12 12h.01M12 16.5h.01m-.01-9h.01M21 3h.01M21 12h.01M21 16.5h.01m-.01-9h.01M21 21H3"
  }))),
  phone02: t => e.createElement("svg", GC({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), QC || (QC = e.createElement("path", {
    d: "M15 2v1.4c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437C14.24 5 13.96 5 13.4 5h-2.8c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C9 4.24 9 3.96 9 3.4V2m-.8 20h7.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C19 20.48 19 19.92 19 18.8V5.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C17.48 2 16.92 2 15.8 2H8.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C5 3.52 5 4.08 5 5.2v13.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C6.52 22 7.08 22 8.2 22Z"
  }))),
  tag01: t => e.createElement("svg", KC({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), YC || (YC = e.createElement("path", {
    d: "M8 8h.01M2 5.2v4.475c0 .489 0 .733.055.963.05.204.13.4.24.579.123.201.296.374.642.72l7.669 7.669c1.188 1.188 1.782 1.782 2.467 2.004a3 3 0 0 0 1.854 0c.685-.222 1.28-.816 2.467-2.004l2.212-2.212c1.188-1.188 1.782-1.782 2.004-2.467a3 3 0 0 0 0-1.854c-.222-.685-.816-1.28-2.004-2.467l-7.669-7.669c-.346-.346-.519-.519-.72-.642a2.001 2.001 0 0 0-.579-.24C10.409 2 10.165 2 9.676 2H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 3.52 2 4.08 2 5.2ZM8.5 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
  }))),
  cloudsun01: t => e.createElement("svg", JC({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), XC || (XC = e.createElement("path", {
    d: "M19.368 12.405A5 5 0 1 0 12 8m0 0a5.5 5.5 0 0 0-4.9 3.001L7 11a5 5 0 0 0 0 10h10.5a4.5 4.5 0 1 0-.206-8.995A5.502 5.502 0 0 0 12 8Z"
  }))),
  creditcarddownload: t => e.createElement("svg", tP({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), eP || (eP = e.createElement("path", {
    d: "m9 17 3 3m0 0 3-3m-3 3v-7m10-4H2m3.5 9h-.3c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C2 16.48 2 15.92 2 14.8V7.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C3.52 4 4.08 4 5.2 4h13.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C22 5.52 22 6.08 22 7.2v7.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C20.48 18 19.92 18 18.8 18h-.3"
  }))),
  switchvertical02: t => e.createElement("svg", nP({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), rP || (rP = e.createElement("path", {
    d: "M7 4v16m0 0-4-4m4 4 4-4m6 4V4m0 0-4 4m4-4 4 4"
  }))),
  login04: t => e.createElement("svg", oP({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), aP || (aP = e.createElement("path", {
    d: "m12 8 4 4m0 0-4 4m4-4H3m.338-5A9.996 9.996 0 0 1 12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10a9.996 9.996 0 0 1-8.662-5"
  }))),
  useredit: t => e.createElement("svg", lP({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), iP || (iP = e.createElement("path", {
    d: "M9 15.5H7.5c-1.396 0-2.093 0-2.661.172a4 4 0 0 0-2.667 2.667C2 18.907 2 19.604 2 21M14.5 7.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM11 21l3.101-.886c.149-.043.223-.064.292-.096a.998.998 0 0 0 .175-.102c.061-.045.116-.1.225-.21l6.457-6.456a1.768 1.768 0 1 0-2.5-2.5l-6.457 6.457c-.11.11-.164.164-.209.225a.998.998 0 0 0-.102.175 2.07 2.07 0 0 0-.096.292L11 21Z"
  }))),
  table: t => e.createElement("svg", cP({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), sP || (sP = e.createElement("path", {
    d: "M3 9h18M9 3v18M7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3Z"
  }))),
  creditcardedit: t => e.createElement("svg", hP({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), uP || (uP = e.createElement("path", {
    d: "M2 10h20V8.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 5 19.92 5 18.8 5H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 6.52 2 7.08 2 8.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 19 4.08 19 5.2 19H11m3.5 2 2.025-.405c.177-.035.265-.053.347-.085a.994.994 0 0 0 .207-.111c.073-.05.136-.114.264-.242L21.5 16a1.414 1.414 0 1 0-2-2l-4.157 4.157a2.098 2.098 0 0 0-.242.264.994.994 0 0 0-.11.207c-.033.082-.05.17-.086.347L14.5 21Z"
  }))),
  cube02: t => e.createElement("svg", pP({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), mP || (mP = e.createElement("path", {
    d: "M12 2.5V12m0 0 8.5-4.722M12 12 3.5 7.278M12 12v9.5m8.5-4.778-7.723-4.29c-.284-.158-.425-.237-.575-.268a1.001 1.001 0 0 0-.403 0c-.15.031-.292.11-.576.268L3.5 16.722M21 16.06V7.942c0-.343 0-.514-.05-.667a1 1 0 0 0-.215-.364c-.109-.119-.258-.202-.558-.368l-7.4-4.111c-.284-.158-.425-.237-.575-.267a1 1 0 0 0-.403 0c-.15.03-.292.11-.576.267l-7.4 4.11c-.3.167-.45.25-.558.369a1 1 0 0 0-.215.364C3 7.428 3 7.599 3 7.942v8.117c0 .342 0 .514.05.666a1 1 0 0 0 .215.364c.109.119.258.202.558.368l7.4 4.111c.284.158.425.237.576.268.133.027.27.027.402 0 .15-.031.292-.11.576-.268l7.4-4.11c.3-.167.45-.25.558-.369a.999.999 0 0 0 .215-.364c.05-.152.05-.324.05-.666Z"
  }))),
  notificationtext: t => e.createElement("svg", dP({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), fP || (fP = e.createElement("path", {
    d: "M11 4H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 6.28 3 7.12 3 8.8v7.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21h7.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 18.72 20 17.88 20 16.2V13m-7 4H7m8-4H7m13.121-9.121A3 3 0 1 1 15.88 8.12 3 3 0 0 1 20.12 3.88Z"
  }))),
  creditcardupload: t => e.createElement("svg", gP({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), vP || (vP = e.createElement("path", {
    d: "m9 16 3-3m0 0 3 3m-3-3v7M22 9H2m3.5 9h-.3c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C2 16.48 2 15.92 2 14.8V7.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C3.52 4 4.08 4 5.2 4h13.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C22 5.52 22 6.08 22 7.2v7.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C20.48 18 19.92 18 18.8 18h-.3"
  }))),
  pin01: t => e.createElement("svg", wP({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), bP || (bP = e.createElement("path", {
    d: "M12 15v7M8 7.308v2.13c0 .209 0 .313-.02.412a1.001 1.001 0 0 1-.09.254c-.045.09-.11.172-.24.334L6.08 12.4c-.666.833-.999 1.249-.999 1.599a1 1 0 0 0 .376.782C5.731 15 6.264 15 7.33 15h9.342c1.066 0 1.599 0 1.873-.219A1 1 0 0 0 18.92 14c0-.35-.333-.766-1-1.599l-1.569-1.962c-.13-.162-.195-.243-.241-.334a1.004 1.004 0 0 1-.09-.254C16 9.75 16 9.647 16 9.44v-2.13c0-.116 0-.174.007-.23.006-.05.015-.1.029-.15.015-.055.036-.108.079-.215l1.008-2.52c.294-.735.44-1.102.38-1.397a1 1 0 0 0-.427-.63C16.825 2 16.429 2 15.637 2H8.364c-.792 0-1.188 0-1.44.167a1 1 0 0 0-.426.63c-.06.295.086.662.38 1.397l1.008 2.52c.043.107.064.16.08.215a1 1 0 0 1 .028.15c.006.056.006.114.006.23Z"
  }))),
  horizontalbarchart02: t => e.createElement("svg", xP({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), yP || (yP = e.createElement("path", {
    d: "M17 9.5v3.4c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437c-.214.109-.494.109-1.054.109H3m10 0v3.4c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437c-.214.109-.494.109-1.054.109H3M3 2v20M3 9.5h16.4c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C21 8.74 21 8.46 21 7.9V6.1c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C20.24 4.5 19.96 4.5 19.4 4.5H3v5Z"
  }))),
  server03: t => e.createElement("svg", EP({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), OP || (OP = e.createElement("path", {
    d: "m22 17.5-.692-10.03c-.108-1.575-.163-2.362-.504-2.96a3 3 0 0 0-1.298-1.21C18.887 3 18.098 3 16.52 3H7.48c-1.578 0-2.367 0-2.986.3a3 3 0 0 0-1.298 1.21c-.341.598-.396 1.385-.504 2.96L2 17.5m20 0a3.5 3.5 0 0 1-3.5 3.5h-13A3.5 3.5 0 0 1 2 17.5m20 0a3.5 3.5 0 0 0-3.5-3.5h-13A3.5 3.5 0 0 0 2 17.5m4 0h.01m5.99 0h6"
  }))),
  percent03: t => e.createElement("svg", CP({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), jP || (jP = e.createElement("path", {
    d: "M9 9h.01M15 15h.01M16 8l-8 8m1.5-7a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm6 6a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm6.5-3c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }))),
  chevronselectorvertical: t => e.createElement("svg", MP({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), PP || (PP = e.createElement("path", {
    d: "m7 15 5 5 5-5M7 9l5-5 5 5"
  }))),
  fileplus03: t => e.createElement("svg", SP({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), kP || (kP = e.createElement("path", {
    d: "M14 2.27V6.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437c.214.11.494.11 1.054.11h4.13M12 18v-6m-3 3h6M14 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 19.72 20 18.88 20 17.2V8l-6-6Z"
  }))),
  foldercode: t => e.createElement("svg", BP({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), NP || (NP = e.createElement("path", {
    d: "m13 7-1.116-2.231c-.32-.642-.481-.963-.72-1.198a2 2 0 0 0-.748-.462C10.1 3 9.74 3 9.022 3H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 4.52 2 5.08 2 6.2V7m0 0h15.2c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C22 9.28 22 10.12 22 11.8v4.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C19.72 21 18.88 21 17.2 21H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.72 2 17.88 2 16.2V7Zm12 9.5 2.5-2.5-2.5-2.5m-4 0L7.5 14l2.5 2.5"
  }))),
  divide01: t => e.createElement("svg", RP({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), VP || (VP = e.createElement("path", {
    d: "M4 12h16m-7-6a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm0 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
  }))),
  batteryempty: t => e.createElement("svg", TP({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), AP || (AP = e.createElement("path", {
    d: "M22 13v-2M6.8 18h7.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C19 15.72 19 14.88 19 13.2v-2.4c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C16.72 6 15.88 6 14.2 6H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 8.28 2 9.12 2 10.8v2.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 18 5.12 18 6.8 18Z"
  }))),
  printer: t => e.createElement("svg", LP({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), HP || (HP = e.createElement("path", {
    d: "M18 7V5.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C16.48 2 15.92 2 14.8 2H9.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C6 3.52 6 4.08 6 5.2V7m0 11c-.93 0-1.395 0-1.776-.102a3 3 0 0 1-2.122-2.121C2 15.395 2 14.93 2 14v-2.2c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C4.28 7 5.12 7 6.8 7h10.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C22 9.28 22 10.12 22 11.8V14c0 .93 0 1.395-.102 1.777a3 3 0 0 1-2.122 2.12C19.395 18 18.93 18 18 18m-3-7.5h3M9.2 22h5.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C18 20.48 18 19.92 18 18.8v-1.6c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C16.48 14 15.92 14 14.8 14H9.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C6 15.52 6 16.08 6 17.2v1.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C7.52 22 8.08 22 9.2 22Z"
  }))),
  share06: t => e.createElement("svg", FP({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), IP || (IP = e.createElement("path", {
    d: "M20.791 12.607c.244-.209.366-.313.411-.438a.5.5 0 0 0 0-.338c-.045-.124-.167-.23-.41-.438L12.32 4.132c-.42-.36-.63-.54-.809-.545a.5.5 0 0 0-.4.184C11 3.91 11 4.186 11 4.74v4.296a9.666 9.666 0 0 0-8 9.516v.612a11.401 11.401 0 0 1 8-4.093v4.19c0 .554 0 .83.112.969a.5.5 0 0 0 .4.184c.178-.005.388-.185.809-.545l8.47-7.26Z"
  }))),
  dataflow02: t => e.createElement("svg", ZP({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), _P || (_P = e.createElement("path", {
    d: "M12 4v11.2c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C14.28 20 15.12 20 16.8 20h.2m0 0a2 2 0 1 0 4 0 2 2 0 0 0-4 0ZM7 4h10M7 4a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm10 0a2 2 0 1 0 4 0 2 2 0 0 0-4 0Zm-5 8h5m0 0a2 2 0 1 0 4 0 2 2 0 0 0-4 0Z"
  }))),
  truck02: t => e.createElement("svg", qP({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), DP || (DP = e.createElement("path", {
    d: "M16 16V6.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C14.48 3 13.92 3 12.8 3H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 4.52 2 5.08 2 6.2v6.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 16 4.08 16 5.2 16H16Zm0 0h4.4c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C22 15.24 22 14.96 22 14.4v-2.737c0-.245 0-.367-.028-.482a.998.998 0 0 0-.12-.29c-.061-.1-.148-.187-.32-.36L19.468 8.47c-.173-.173-.26-.26-.36-.322a1 1 0 0 0-.29-.12C18.704 8 18.582 8 18.337 8H16M9 18.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm11 0a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"
  }))),
  codecircle02: t => e.createElement("svg", $P({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), UP || (UP = e.createElement("path", {
    d: "m14 17 3-3-3-3m-4-4-3 3 3 3m12-1c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }))),
  layersingle: t => e.createElement("svg", WP({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), zP || (zP = e.createElement("path", {
    d: "M12.358 7.179c-.131-.066-.197-.098-.266-.111a.5.5 0 0 0-.184 0c-.069.013-.135.045-.266.111L2 12l9.642 4.821c.131.066.197.099.266.111.06.012.123.012.184 0 .069-.012.135-.045.266-.11L22 12 12.358 7.18Z"
  }))),
  folderminus: t => e.createElement("svg", GP({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), QP || (QP = e.createElement("path", {
    d: "m13 7-1.116-2.231c-.32-.642-.481-.963-.72-1.198a2 2 0 0 0-.748-.462C10.1 3 9.74 3 9.022 3H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 4.52 2 5.08 2 6.2V7m0 0h15.2c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C22 9.28 22 10.12 22 11.8v4.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C19.72 21 18.88 21 17.2 21H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.72 2 17.88 2 16.2V7Zm7 7h6"
  }))),
  medicalsquare: t => e.createElement("svg", XP({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), YP || (YP = e.createElement("path", {
    d: "M3 7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8Z"
  })), KP || (KP = e.createElement("path", {
    d: "M13.833 7.3c0-.28 0-.42-.054-.527a.5.5 0 0 0-.219-.218c-.107-.055-.247-.055-.527-.055h-2.066c-.28 0-.42 0-.527.054a.5.5 0 0 0-.219.219c-.054.107-.054.247-.054.527v2.067c0 .28 0 .42-.055.527a.5.5 0 0 1-.218.218c-.107.055-.247.055-.527.055H7.3c-.28 0-.42 0-.527.054a.5.5 0 0 0-.218.219c-.055.107-.055.247-.055.527v2.066c0 .28 0 .42.054.527a.5.5 0 0 0 .219.219c.107.054.247.054.527.054h2.067c.28 0 .42 0 .527.055.094.048.17.124.218.218.055.107.055.247.055.527V16.7c0 .28 0 .42.054.527a.5.5 0 0 0 .219.218c.107.055.247.055.527.055h2.066c.28 0 .42 0 .527-.055a.5.5 0 0 0 .219-.218c.054-.107.054-.247.054-.527v-2.067c0-.28 0-.42.055-.527a.501.501 0 0 1 .218-.218c.107-.055.247-.055.527-.055H16.7c.28 0 .42 0 .527-.054a.5.5 0 0 0 .218-.219c.055-.107.055-.247.055-.527v-2.066c0-.28 0-.42-.055-.527a.5.5 0 0 0-.218-.219c-.107-.054-.247-.054-.527-.054h-2.067c-.28 0-.42 0-.527-.055a.501.501 0 0 1-.218-.218c-.055-.107-.055-.247-.055-.527V7.3Z"
  }))),
  arrowupright: t => e.createElement("svg", eM({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), JP || (JP = e.createElement("path", {
    d: "M7 17 17 7m0 0H7m10 0v10"
  }))),
  share02: t => e.createElement("svg", rM({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), tM || (tM = e.createElement("path", {
    d: "M7 11c-.93 0-1.395 0-1.776.102a3 3 0 0 0-2.122 2.121C3 13.605 3 14.07 3 15v1.2c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V15c0-.93 0-1.395-.102-1.777a3 3 0 0 0-2.122-2.12C18.395 11 17.93 11 17 11m-1-4-4-4m0 0L8 7m4-4v12"
  }))),
  grid01: t => e.createElement("svg", aM({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), nM || (nM = e.createElement("path", {
    d: "M8.4 3H4.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 3.76 3 4.04 3 4.6v3.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C3.76 10 4.04 10 4.6 10h3.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C10 9.24 10 8.96 10 8.4V4.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C9.24 3 8.96 3 8.4 3ZM19.4 3h-3.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C14 3.76 14 4.04 14 4.6v3.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C14.76 10 15.04 10 15.6 10h3.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C21 9.24 21 8.96 21 8.4V4.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C20.24 3 19.96 3 19.4 3ZM19.4 14h-3.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C14 14.76 14 15.04 14 15.6v3.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C14.76 21 15.04 21 15.6 21h3.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C21 20.24 21 19.96 21 19.4v-3.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C20.24 14 19.96 14 19.4 14ZM8.4 14H4.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 14.76 3 15.04 3 15.6v3.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C3.76 21 4.04 21 4.6 21h3.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C10 20.24 10 19.96 10 19.4v-3.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C9.24 14 8.96 14 8.4 14Z"
  }))),
  codesquare01: t => e.createElement("svg", iM({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), oM || (oM = e.createElement("path", {
    d: "m14.5 15 3-3-3-3m-5 0-3 3 3 3m-1.7 6h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Z"
  }))),
  packagex: t => e.createElement("svg", sM({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), lM || (lM = e.createElement("path", {
    d: "M20.5 7.278 12 12m0 0L3.5 7.278M12 12v9.5m9-9V7.942c0-.343 0-.514-.05-.667a1 1 0 0 0-.215-.364c-.109-.119-.258-.202-.558-.368l-7.4-4.111c-.284-.158-.425-.237-.575-.267a1 1 0 0 0-.403 0c-.15.03-.292.11-.576.267l-7.4 4.11c-.3.167-.45.25-.558.369a1 1 0 0 0-.215.364C3 7.428 3 7.599 3 7.942v8.117c0 .342 0 .514.05.666a1 1 0 0 0 .215.364c.109.119.258.202.558.368l7.4 4.111c.284.158.425.237.576.268.133.027.27.027.402 0 .15-.031.292-.11.576-.268l.223-.123M7.5 4.5l9 5m0 6.5 5 5m0-5-5 5"
  }))),
  filex01: t => e.createElement("svg", uM({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), cM || (cM = e.createElement("path", {
    d: "M20 12V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 2 16.88 2 15.2 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22H12m4-6 5 5m0-5-5 5"
  }))),
  fileattachment02: t => e.createElement("svg", mM({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), hM || (hM = e.createElement("path", {
    d: "M12.5 2h2.7c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C20 4.28 20 5.12 20 6.8v10.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C17.72 22 16.88 22 15.2 22H8.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.72 4 18.88 4 17.2v-.7M16 13h-4.5M16 9h-3.5m3.5 8H8m-2-7V4.5a1.5 1.5 0 1 1 3 0V10a3 3 0 1 1-6 0V6"
  }))),
  alarmclockminus: t => e.createElement("svg", fM({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), pM || (pM = e.createElement("path", {
    d: "M5 3 2 6m20 0-3-3M6 19l-2 2m14-2 2 2M9 13h6m-3 8a8 8 0 1 0 0-16.001A8 8 0 0 0 12 21Z"
  }))),
  monitor02: t => e.createElement("svg", vM({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), dM || (dM = e.createElement("path", {
    d: "M7.572 21c1.335-.64 2.838-1 4.428-1 1.59 0 3.093.36 4.428 1M6.8 17h10.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 14.72 22 13.88 22 12.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C19.72 3 18.88 3 17.2 3H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 5.28 2 6.12 2 7.8v4.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 17 5.12 17 6.8 17Z"
  }))),
  coins01: t => e.createElement("svg", bM({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), gM || (gM = e.createElement("path", {
    d: "M15.938 15.938A7.001 7.001 0 0 0 15 2a7.001 7.001 0 0 0-6.938 6.062M16 15a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
  }))),
  atsign: t => e.createElement("svg", yM({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), wM || (wM = e.createElement("path", {
    d: "M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
  }))),
  currencypoundcircle: t => e.createElement("svg", OM({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), xM || (xM = e.createElement("path", {
    d: "M15 17.5H9s2-2.256 2-5c0-1.5-1.085-2.013-1.105-3.538.002-3.018 3.635-2.857 4.898-1.658M9 12.5h5m8-.5c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }))),
  barchartsquareup: t => e.createElement("svg", jM({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), EM || (EM = e.createElement("path", {
    d: "M12 3h4.2c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V12m5 1v4m8-6v6M12 7v10M2 5l3-3m0 0 3 3M5 2v6"
  }))),
  arrowcircleupleft: t => e.createElement("svg", PM({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), CM || (CM = e.createElement("path", {
    d: "M9 15V9m0 0h6M9 9l6 6m7-3c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }))),
  searchmd: t => e.createElement("svg", kM({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), MM || (MM = e.createElement("path", {
    d: "m21 21-4.35-4.35M19 11a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z"
  }))),
  filecheck03: t => e.createElement("svg", NM({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), SM || (SM = e.createElement("path", {
    d: "M14 2.27V6.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437c.214.11.494.11 1.054.11h4.13M9 16l2 2 4.5-4.5M14 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 19.72 20 18.88 20 17.2V8l-6-6Z"
  }))),
  moon01: t => e.createElement("svg", VM({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), BM || (BM = e.createElement("path", {
    d: "M22 15.844a10.424 10.424 0 0 1-4.306.925c-5.779 0-10.463-4.684-10.463-10.462 0-1.536.33-2.994.925-4.307A10.464 10.464 0 0 0 2 11.538C2 17.316 6.684 22 12.462 22c4.243 0 7.896-2.526 9.538-6.156Z"
  }))),
  download04: t => e.createElement("svg", AM({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), RM || (RM = e.createElement("path", {
    d: "m8 12 4 4m0 0 4-4m-4 4V6.8c0-1.39 0-2.086-.55-2.865-.366-.517-1.42-1.155-2.047-1.24-.945-.128-1.304.059-2.022.433A9.999 9.999 0 0 0 2 12c0 5.523 4.477 10 10 10s10-4.477 10-10a9.996 9.996 0 0 0-5-8.662"
  }))),
  griddotsright: t => e.createElement("svg", HM({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), TM || (TM = e.createElement("path", {
    d: "M7.5 3h.01m-.01 9h.01m-.01 9h.01M16.5 3h.01m-.01 9h.01m-.01 9h.01M12 3h.01M12 12h.01M12 21h.01M12 16.5h.01m-.01-9h.01M3 3h.01M3 12h.01M3 21h.01M3 16.5h.01M3 7.5h.01M21 21V3"
  }))),
  fileheart02: t => e.createElement("svg", IM({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), LM || (LM = e.createElement("path", {
    d: "M20 10V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 2 16.88 2 15.2 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22H12m.5-11H8m1 4H8m8-8H8m8.997 7.83c-.8-.908-2.133-1.153-3.135-.32-1.002.832-1.143 2.223-.356 3.208.787.984 3.491 3.282 3.491 3.282s2.705-2.298 3.492-3.282a2.256 2.256 0 0 0-.356-3.209c-1.02-.823-2.336-.587-3.136.322Z"
  }))),
  arrowblockup: t => e.createElement("svg", _M({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), FM || (FM = e.createElement("path", {
    d: "M9.8 21c-.28 0-.42 0-.527-.055a.5.5 0 0 1-.218-.218C9 20.62 9 20.48 9 20.2V10H5l7-7 7 7h-4v10.2c0 .28 0 .42-.055.527a.5.5 0 0 1-.218.218C14.62 21 14.48 21 14.2 21H9.8Z"
  }))),
  cursor02: t => e.createElement("svg", DM({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ZM || (ZM = e.createElement("path", {
    d: "M20.505 10.775c.617-.24.926-.36 1.012-.53a.5.5 0 0 0-.006-.465c-.09-.168-.402-.28-1.025-.503L4.596 3.573c-.51-.183-.764-.275-.931-.217a.5.5 0 0 0-.309.309c-.058.167.034.421.217.931l5.704 15.89c.223.623.335.934.502 1.025a.5.5 0 0 0 .467.006c.17-.086.29-.395.53-1.012l2.596-6.677c.047-.121.07-.181.107-.232a.501.501 0 0 1 .117-.117c.05-.036.11-.06.232-.107l6.677-2.597Z"
  }))),
  atom02: t => e.createElement("svg", UM({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), qM || (qM = e.createElement("path", {
    d: "M17.115 15.358c-.27.306-.554.608-.851.905-4.296 4.296-9.678 5.88-12.021 3.536-1.607-1.606-1.368-4.641.325-7.775M6.89 8.725c.281-.32.578-.636.888-.947C12.074 3.482 17.456 1.9 19.8 4.243c1.608 1.607 1.367 4.645-.33 7.781m-3.206-4.246c4.296 4.296 5.88 9.678 3.536 12.021-2.343 2.343-7.725.76-12.02-3.535-4.297-4.296-5.88-9.678-3.536-12.021 2.343-2.343 7.725-.76 12.02 3.535ZM13 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
  }))),
  bus: t => e.createElement("svg", zM({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), $M || ($M = e.createElement("path", {
    d: "M8.5 19v2.2c0 .28 0 .42-.055.527a.5.5 0 0 1-.218.218C8.12 22 7.98 22 7.7 22H5.8c-.28 0-.42 0-.527-.055a.5.5 0 0 1-.218-.218C5 21.62 5 21.48 5 21.2V19m14 0v2.2c0 .28 0 .42-.055.527a.5.5 0 0 1-.218.218C18.62 22 18.48 22 18.2 22h-1.9c-.28 0-.42 0-.527-.055a.5.5 0 0 1-.218-.218c-.055-.107-.055-.247-.055-.527V19M3 12h18M3 5.5h18m-14.5 10H8m8 0h1.5M7.8 19h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 16.72 21 15.88 21 14.2V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 2 17.88 2 16.2 2H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 4.28 3 5.12 3 6.8v7.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 19 6.12 19 7.8 19Z"
  }))),
  upload04: t => e.createElement("svg", QM({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), WM || (WM = e.createElement("path", {
    d: "m16 12-4-4m0 0-4 4m4-4v9.2c0 1.39 0 2.086.55 2.865.366.517 1.42 1.155 2.047 1.24.945.128 1.304-.059 2.022-.433A9.999 9.999 0 0 0 22 12c0-5.523-4.477-10-10-10S2 6.477 2 12a9.996 9.996 0 0 0 5 8.662"
  }))),
  filesearch02: t => e.createElement("svg", YM({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), GM || (GM = e.createElement("path", {
    d: "M14 11H8m2 4H8m8-8H8m12 3.5V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 2 16.88 2 15.2 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22h2.7M22 22l-1.5-1.5m1-2.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
  }))),
  messagetextsquare02: t => e.createElement("svg", XM({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), KM || (KM = e.createElement("path", {
    d: "M7 8.5h5M7 12h8m-8 6v2.335c0 .533 0 .8.11.937a.5.5 0 0 0 .39.188c.176 0 .384-.167.8-.5l2.385-1.908c.487-.39.731-.585 1.002-.724.241-.122.497-.212.762-.267.299-.061.61-.061 1.235-.061H16.2c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 15.72 21 14.88 21 13.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8V14c0 .93 0 1.395.102 1.777a3 3 0 0 0 2.122 2.12C5.605 18 6.07 18 7 18Z"
  }))),
  crop01: t => e.createElement("svg", ek({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), JM || (JM = e.createElement("path", {
    d: "M2 6h12.8c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C18 7.52 18 8.08 18 9.2V22m4-4H9.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C6 16.48 6 15.92 6 14.8V2"
  }))),
  infinity: t => e.createElement("svg", rk({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), tk || (tk = e.createElement("path", {
    d: "M18.178 8c5.096 0 5.096 8 0 8-5.095 0-7.133-8-12.74-8-4.584 0-4.584 8 0 8 5.607 0 7.645-8 12.74-8Z"
  }))),
  currencyeuro: t => e.createElement("svg", ak({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), nk || (nk = e.createElement("path", {
    d: "M19 5.519a8.5 8.5 0 1 0 0 12.962M3 14h10M3 10h10"
  }))),
  star04: t => e.createElement("svg", ik({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ok || (ok = e.createElement("path", {
    d: "m12 2 2.012 5.231c.282.733.423 1.1.642 1.408.195.274.433.512.707.707.308.219.675.36 1.408.642L22 12l-5.231 2.012c-.733.282-1.1.423-1.408.642a3.003 3.003 0 0 0-.707.707c-.219.308-.36.675-.642 1.408L12 22l-2.012-5.231c-.282-.733-.423-1.1-.642-1.408a3.002 3.002 0 0 0-.707-.707c-.308-.219-.675-.36-1.408-.642L2 12l5.231-2.012c.733-.282 1.1-.423 1.408-.642a3 3 0 0 0 .707-.707c.219-.308.36-.675.642-1.408L12 2Z"
  }))),
  copy05: t => e.createElement("svg", sk({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), lk || (lk = e.createElement("path", {
    d: "M8 16v2.8c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C9.52 22 10.08 22 11.2 22h7.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C22 20.48 22 19.92 22 18.8v-7.6c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 8 19.92 8 18.8 8H16M5.2 16h7.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C16 14.48 16 13.92 16 12.8V5.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C14.48 2 13.92 2 12.8 2H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 3.52 2 4.08 2 5.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 16 4.08 16 5.2 16Z"
  }))),
  copy04: t => e.createElement("svg", uk({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ck || (ck = e.createElement("path", {
    d: "M16 16v2.8c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C14.48 22 13.92 22 12.8 22H5.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C2 20.48 2 19.92 2 18.8v-7.6c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C3.52 8 4.08 8 5.2 8H8m3.2 8h7.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C22 14.48 22 13.92 22 12.8V5.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 2 19.92 2 18.8 2h-7.6c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C8 3.52 8 4.08 8 5.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C9.52 16 10.08 16 11.2 16Z"
  }))),
  star05: t => e.createElement("svg", mk({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), hk || (hk = e.createElement("path", {
    d: "m12 2-1.302 5.206c-.254 1.016-.38 1.524-.645 1.937a3 3 0 0 1-.91.91c-.413.265-.921.391-1.937.645L2 12l5.206 1.302c1.016.254 1.524.38 1.937.645a3 3 0 0 1 .91.91c.265.413.391.921.645 1.937L12 22l1.302-5.206c.254-1.016.38-1.524.645-1.937.234-.366.544-.676.91-.91.413-.265.921-.391 1.937-.645L22 12l-5.206-1.302c-1.016-.254-1.524-.38-1.937-.645a3 3 0 0 1-.91-.91c-.265-.413-.391-.921-.645-1.937L12 2Z"
  }))),
  feather: t => e.createElement("svg", fk({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), pk || (pk = e.createElement("path", {
    d: "M16 8 2 22m16-7H9m-2.4 4h6.737c.245 0 .367 0 .482-.028a1 1 0 0 0 .29-.12c.1-.061.187-.148.36-.32L19.5 13.5c.239-.239.358-.358.455-.464a6 6 0 0 0 0-8.072A15.09 15.09 0 0 0 19.5 4.5c-.239-.239-.358-.358-.464-.455a6 6 0 0 0-8.072 0c-.106.097-.225.216-.464.455L5.469 9.531c-.173.173-.26.26-.322.36a1 1 0 0 0-.12.29C5 10.296 5 10.418 5 10.663V17.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437c.214.11.494.11 1.054.11Z"
  }))),
  layerstwo02: t => e.createElement("svg", vk({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), dk || (dk = e.createElement("path", {
    d: "m7 12-5 2.5 9.642 4.821c.131.066.197.099.266.111.06.012.123.012.184 0 .069-.012.135-.045.266-.11L22 14.5 17 12M2 9.5l9.642-4.821c.131-.066.197-.098.266-.111a.5.5 0 0 1 .184 0c.069.013.135.045.266.111L22 9.5l-9.642 4.821c-.131.066-.197.099-.266.111a.501.501 0 0 1-.184 0c-.069-.012-.135-.045-.266-.11L2 9.5Z"
  }))),
  folderquestion: t => e.createElement("svg", bk({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), gk || (gk = e.createElement("path", {
    d: "m13 7-1.116-2.231c-.32-.642-.481-.963-.72-1.198a2 2 0 0 0-.748-.462C10.1 3 9.74 3 9.022 3H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 4.52 2 5.08 2 6.2V7m0 0h15.2c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C22 9.28 22 10.12 22 11.8v4.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C19.72 21 18.88 21 17.2 21H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.72 2 17.88 2 16.2V7Zm7.85 4.752a2.249 2.249 0 0 1 4.37.75c0 1.499-2.249 2.248-2.249 2.248m.029 3h.01"
  }))),
  filesearch03: t => e.createElement("svg", yk({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), wk || (wk = e.createElement("path", {
    d: "M14 2.27V6.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437c.214.11.494.11 1.054.11h4.13M16 18.5 14.5 17M14 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 19.72 20 18.88 20 17.2V8l-6-6Zm1.5 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
  }))),
  wifioff: t => e.createElement("svg", Ok({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), xk || (xk = e.createElement("path", {
    d: "M15.312 10c1.368.426 2.65 1.12 3.768 2.05m3.5-3.55a16 16 0 0 0-12.383-3.896M8.53 15.61a6 6 0 0 1 6.95 0M12 19.5h.01M1.193 8.7A16.014 16.014 0 0 1 5.76 5.764m-1.027 6.48a10.966 10.966 0 0 1 5-2.51m5.966 6.042A5.974 5.974 0 0 0 12 14.5c-1.416 0-2.718.49-3.745 1.312M3 3l18 18"
  }))),
  coinshand: t => e.createElement("svg", jk({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Ek || (Ek = e.createElement("path", {
    d: "M13.53 8.352a3.5 3.5 0 1 1 .941-4.704M6 20.088h2.61c.34 0 .679.04 1.009.12l2.758.67c.598.147 1.222.16 1.826.043l3.05-.593a4.204 4.204 0 0 0 2.127-1.107l2.158-2.1a1.503 1.503 0 0 0 0-2.168 1.61 1.61 0 0 0-2.06-.143l-2.515 1.835c-.36.263-.799.405-1.25.405h-2.427 1.545c.871 0 1.577-.687 1.577-1.534v-.307c0-.704-.492-1.317-1.194-1.487l-2.385-.58A5.03 5.03 0 0 0 11.643 13c-.965 0-2.711.799-2.711.799L6 15.025M20 6.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0ZM2 14.6v5.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C2.76 22 3.04 22 3.6 22h.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C6 21.24 6 20.96 6 20.4v-5.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C5.24 13 4.96 13 4.4 13h-.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C2 13.76 2 14.04 2 14.6Z"
  }))),
  filterfunnel02: t => e.createElement("svg", Pk({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Ck || (Ck = e.createElement("path", {
    d: "M3.386 5.667C2.63 4.822 2.25 4.399 2.237 4.04a1 1 0 0 1 .363-.811C2.877 3 3.444 3 4.578 3h14.843c1.134 0 1.702 0 1.979.229a1 1 0 0 1 .362.81c-.014.36-.392.783-1.148 1.628l-5.707 6.377c-.15.169-.226.253-.28.35a1 1 0 0 0-.103.27c-.024.108-.024.221-.024.447v5.347c0 .196 0 .294-.032.378a.5.5 0 0 1-.132.196c-.067.06-.158.096-.34.17l-3.4 1.36c-.367.146-.55.22-.698.189a.5.5 0 0 1-.315-.213c-.083-.126-.083-.324-.083-.72v-6.707c0-.226 0-.339-.024-.446a1 1 0 0 0-.104-.272c-.054-.096-.13-.18-.28-.349L3.386 5.667Z"
  }))),
  pilcrow01: t => e.createElement("svg", kk({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Mk || (Mk = e.createElement("path", {
    d: "M16 4v16m0-16h2m-2 0h-5.5a4.5 4.5 0 0 0 0 9H16V4Zm-2 16h4"
  }))),
  cursor03: t => e.createElement("svg", Nk({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Sk || (Sk = e.createElement("path", {
    d: "M4.712 3.674c-.541-.212-.811-.319-.984-.262a.5.5 0 0 0-.316.317c-.057.172.049.442.262.983l5.3 13.456c.172.435.258.652.398.74a.5.5 0 0 0 .408.055c.158-.047.298-.234.579-.609l2.14-2.854 3.45 4.743c.19.26.284.391.405.446a.5.5 0 0 0 .338.026c.128-.035.242-.149.47-.377l3.176-3.176c.227-.228.341-.342.377-.47a.5.5 0 0 0-.027-.337c-.054-.121-.185-.216-.446-.406L15.5 12.5l2.854-2.14c.374-.281.561-.422.608-.58a.5.5 0 0 0-.055-.408c-.087-.14-.305-.225-.74-.397l-13.455-5.3Z"
  }))),
  fileheart03: t => e.createElement("svg", Vk({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Bk || (Bk = e.createElement("path", {
    d: "M14 2.27V6.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437c.214.11.494.11 1.054.11h4.13M14 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 19.72 20 18.88 20 17.2V8l-6-6Zm-2.003 9.83c-.8-.908-2.133-1.153-3.135-.32-1.002.832-1.143 2.223-.356 3.208.787.984 3.491 3.282 3.491 3.282s2.705-2.298 3.492-3.282a2.256 2.256 0 0 0-.356-3.209c-1.02-.823-2.336-.587-3.136.322Z"
  }))),
  puzzlepiece02: t => e.createElement("svg", Ak({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Rk || (Rk = e.createElement("path", {
    d: "m12 2 3.6 3.6c2.4-6.3 9.1.4 2.8 2.8L22 12l-3.6 3.6c-2.4-6.3-9.1.4-2.8 2.8L12 22l-3.6-3.6C6 24.7-.7 18 5.6 15.6L2 12l3.6-3.6C8 14.7 14.7 8 8.4 5.6L12 2Z"
  }))),
  currencyeurocircle: t => e.createElement("svg", Hk({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Tk || (Tk = e.createElement("path", {
    d: "M15.333 8.273a5 5 0 1 0 0 7.454M6 13.5h5m-5-3h5M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }))),
  login01: t => e.createElement("svg", Ik({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Lk || (Lk = e.createElement("path", {
    d: "M15 3h1.2c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H15M10 7l5 5m0 0-5 5m5-5H3"
  }))),
  ticket02: t => e.createElement("svg", _k({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Fk || (Fk = e.createElement("path", {
    d: "M8 8V7m0 5.5v-1M8 17v-1m-1.2 4h10.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 17.72 22 16.88 22 15.2V8.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C19.72 4 18.88 4 17.2 4H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 6.28 2 7.12 2 8.8v6.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 20 5.12 20 6.8 20Z"
  }))),
  mark: t => e.createElement("svg", Dk({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Zk || (Zk = e.createElement("path", {
    d: "M20 12a8 8 0 0 1-8 8m8-8a8 8 0 0 0-8-8m8 8h2m-10 8a8 8 0 0 1-8-8m8 8v2M4 12a8 8 0 0 1 8-8m-8 8H2m10-8V2m3 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
  }))),
  cornerleftdown: t => e.createElement("svg", Uk({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), qk || (qk = e.createElement("path", {
    d: "M21 4h-3.4c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C8 8.56 8 10.24 8 13.6V20m0 0 5-5m-5 5-5-5"
  }))),
  filecheck02: t => e.createElement("svg", zk({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), $k || ($k = e.createElement("path", {
    d: "M20 12.5V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 2 16.88 2 15.2 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22H12m2-11H8m2 4H8m8-8H8m6.5 12 2 2 4.5-4.5"
  }))),
  flipbackward: t => e.createElement("svg", Qk({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Wk || (Wk = e.createElement("path", {
    d: "M3 9h13.5a4.5 4.5 0 1 1 0 9H12M3 9l4-4M3 9l4 4"
  }))),
  server06: t => e.createElement("svg", Yk({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Gk || (Gk = e.createElement("path", {
    d: "M20 12a8 8 0 0 1-8 8m8-8a8 8 0 0 0-8-8m8 8H4m8 8a8 8 0 0 1-8-8m8 8a12.24 12.24 0 0 0 3.2-8A12.24 12.24 0 0 0 12 4m0 16a12.24 12.24 0 0 1-3.2-8A12.24 12.24 0 0 1 12 4m-8 8a8 8 0 0 1 8-8M6 20a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm16 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM6 4a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm16 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
  }))),
  underline02: t => e.createElement("svg", Xk({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Kk || (Kk = e.createElement("path", {
    d: "M19 4v6a7 7 0 1 1-14 0V4m3.5 0v6a7.003 7.003 0 0 0 5.14 6.75M4 21h16M3 4h7.5M17 4h4"
  }))),
  rightindent02: t => e.createElement("svg", eS({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Jk || (Jk = e.createElement("path", {
    d: "M12 9.25H3M12 4H3m18 10.75H3M21 20H3M19.72 2.96l-3.867 2.9c-.29.217-.434.326-.486.459a.5.5 0 0 0 0 .362c.052.133.197.242.486.459l3.867 2.9c.412.309.618.463.79.46a.5.5 0 0 0 .384-.192C21 10.172 21 9.915 21 9.4V3.6c0-.515 0-.773-.106-.908a.5.5 0 0 0-.384-.192c-.172-.004-.378.151-.79.46Z"
  }))),
  batterymid: t => e.createElement("svg", rS({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), tS || (tS = e.createElement("path", {
    d: "M6.5 10v4m4-4v4M22 13v-2M6.8 18h7.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C19 15.72 19 14.88 19 13.2v-2.4c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C16.72 6 15.88 6 14.2 6H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 8.28 2 9.12 2 10.8v2.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 18 5.12 18 6.8 18Z"
  }))),
  belloff01: t => e.createElement("svg", aS({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), nS || (nS = e.createElement("path", {
    d: "M8.633 3.034A6 6 0 0 1 18 8c0 2.1.27 3.751.648 5.032M6.258 6.257A5.998 5.998 0 0 0 6 8c0 3.09-.78 5.206-1.65 6.605-.735 1.18-1.102 1.771-1.089 1.936.015.182.054.252.2.36.133.099.732.099 1.928.099H17m-7.646 4c.705.622 1.632 1 2.646 1s1.94-.378 2.646-1M21 21 3 3"
  }))),
  monitor03: t => e.createElement("svg", iS({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), oS || (oS = e.createElement("path", {
    d: "M2 14h20M8 21h8m-9.2-3h10.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 15.72 22 14.88 22 13.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C19.72 3 18.88 3 17.2 3H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 5.28 2 6.12 2 7.8v5.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 18 5.12 18 6.8 18Z"
  }))),
  bracketsminus: t => e.createElement("svg", sS({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), lS || (lS = e.createElement("path", {
    d: "M18.57 20a2.286 2.286 0 0 0 2.287-2.286v-4.571L22 12l-1.143-1.143V6.286A2.285 2.285 0 0 0 18.57 4M5.429 4a2.285 2.285 0 0 0-2.286 2.286v4.571L2 12l1.143 1.143v4.571A2.285 2.285 0 0 0 5.429 20M8 12h8"
  }))),
  fileattachment03: t => e.createElement("svg", uS({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), cS || (cS = e.createElement("path", {
    d: "M20 7v-.2c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 2 16.88 2 15.2 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22h3.7m5.5-4v-5.5a1.5 1.5 0 0 1 3 0V18a3 3 0 1 1-6 0v-4"
  }))),
  faceid: t => e.createElement("svg", mS({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), hS || (hS = e.createElement("path", {
    d: "M8 3h-.2c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8V8m5 13h-.2c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V16m18-8v-.2c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H16m5 13v.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H16M7.5 8v1.5m9-1.5v1.5M11 12.6c.8 0 1.5-.7 1.5-1.5V8m2.7 7.2c-1.8 1.8-4.7 1.8-6.5 0"
  }))),
  cloudoff: t => e.createElement("svg", fS({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), pS || (pS = e.createElement("path", {
    d: "M21.7 16.118a4.5 4.5 0 0 0-3.78-6.099 6.002 6.002 0 0 0-7.22-4.878M7.287 7.286a5.973 5.973 0 0 0-1.207 2.733A4.5 4.5 0 0 0 6.5 19h11c.456 0 .896-.068 1.311-.194M3 3l18 18"
  }))),
  sun: t => e.createElement("svg", vS({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), dS || (dS = e.createElement("path", {
    d: "M12 2v2m0 16v2M4 12H2m4.314-5.686L4.9 4.9m12.786 1.414L19.1 4.9M6.314 17.69 4.9 19.104m12.786-1.414 1.414 1.414M22 12h-2m-3 0a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z"
  }))),
  flipforward: t => e.createElement("svg", bS({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), gS || (gS = e.createElement("path", {
    d: "M21 9H7.5a4.5 4.5 0 1 0 0 9H12m9-9-4-4m4 4-4 4"
  }))),
  share03: t => e.createElement("svg", yS({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), wS || (wS = e.createElement("path", {
    d: "M21 9V3m0 0h-6m6 0-9 9m-2-9H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V14"
  }))),
  tablet02: t => e.createElement("svg", OS({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), xS || (xS = e.createElement("path", {
    d: "M15 2v1.4c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437C14.24 5 13.96 5 13.4 5h-2.8c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C9 4.24 9 3.96 9 3.4V2M7.2 22h9.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C20 20.48 20 19.92 20 18.8V5.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C18.48 2 17.92 2 16.8 2H7.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C4 3.52 4 4.08 4 5.2v13.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C5.52 22 6.08 22 7.2 22Z"
  }))),
  navigationpointer02: t => e.createElement("svg", jS({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ES || (ES = e.createElement("path", {
    d: "M5.037 21.325c-.585.258-.877.386-1.057.33a.5.5 0 0 1-.326-.327c-.057-.179.071-.471.328-1.056L11.263 3.67c.232-.528.348-.792.51-.873a.5.5 0 0 1 .446 0c.162.081.278.345.51.873l7.281 16.602c.257.585.385.877.328 1.056a.5.5 0 0 1-.326.327c-.18.056-.472-.072-1.057-.33l-6.637-2.92c-.118-.052-.178-.078-.24-.089a.497.497 0 0 0-.164 0c-.062.01-.121.037-.24.089l-6.637 2.92Z"
  }))),
  share01: t => e.createElement("svg", PS({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), CS || (CS = e.createElement("path", {
    d: "M21 12v4.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V12m13-5-4-4m0 0L8 7m4-4v12"
  }))),
  grid02: t => e.createElement("svg", kS({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), MS || (MS = e.createElement("path", {
    d: "M8 3H6.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C3 4.52 3 5.08 3 6.2V8m5 13H6.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C3 19.48 3 18.92 3 17.8V16m18-8V6.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C19.48 3 18.92 3 17.8 3H16m5 13v1.8c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C19.48 21 18.92 21 17.8 21H16m-4-4V7m-5 5h10"
  }))),
  arrowcircledown: t => e.createElement("svg", NS({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), SS || (SS = e.createElement("path", {
    d: "m8 12 4 4m0 0 4-4m-4 4V8m10 4c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }))),
  codebrowser: t => e.createElement("svg", VS({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), BS || (BS = e.createElement("path", {
    d: "M22 9H2m12 8.5 2.5-2.5-2.5-2.5m-4 0L7.5 15l2.5 2.5M2 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 21 5.12 21 6.8 21h10.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 18.72 22 17.88 22 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C19.72 3 18.88 3 17.2 3H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 5.28 2 6.12 2 7.8Z"
  }))),
  codesquare02: t => e.createElement("svg", AS({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), RS || (RS = e.createElement("path", {
    d: "m14 17 3-3-3-3m-4-4-3 3 3 3m-2.2 8h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Z"
  }))),
  browser: t => e.createElement("svg", HS({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), TS || (TS = e.createElement("path", {
    d: "M22 9H2m0-1.2v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 21 5.12 21 6.8 21h10.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 18.72 22 17.88 22 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C19.72 3 18.88 3 17.2 3H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 5.28 2 6.12 2 7.8Z"
  }))),
  monitor01: t => e.createElement("svg", IS({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), LS || (LS = e.createElement("path", {
    d: "M8 21h8m-4-4v4m-5.2-4h10.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 14.72 22 13.88 22 12.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C19.72 3 18.88 3 17.2 3H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 5.28 2 6.12 2 7.8v4.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 17 5.12 17 6.8 17Z"
  }))),
  belloff03: t => e.createElement("svg", _S({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), FS || (FS = e.createElement("path", {
    d: "M15 19a3 3 0 1 1-6 0M7.377 7.885C6.491 8.813 6 9.985 6 11.2c0 2.282-.566 3.95-1.272 5.145-.805 1.36-1.207 2.041-1.191 2.204.018.186.052.244.202.355.132.096.795.096 2.12.096H19.88M12 6c-.293 0-.584.019-.87.055-.382.048-.572.073-.764.02a1.22 1.22 0 0 1-.446-.259c-.14-.14-.17-.215-.232-.363a2.5 2.5 0 1 1 4.108.786A6.852 6.852 0 0 0 12 6Zm0 0c1.591 0 3.117.548 4.243 1.523C17.368 8.498 18 9.821 18 11.2c0 .335.01.656.026.965M21 20 3 4"
  }))),
  chevrondowndouble: t => e.createElement("svg", DS({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ZS || (ZS = e.createElement("path", {
    d: "m7 13 5 5 5-5M7 6l5 5 5-5"
  }))),
  filex02: t => e.createElement("svg", US({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), qS || (qS = e.createElement("path", {
    d: "M14 11H8m2 4H8m8-8H8m12 5V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 2 16.88 2 15.2 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22H12m4-6 5 5m0-5-5 5"
  }))),
  fileattachment01: t => e.createElement("svg", zS({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), $S || ($S = e.createElement("path", {
    d: "M6 10V4.5a1.5 1.5 0 1 1 3 0V10a3 3 0 1 1-6 0V6m9.5-4h2.7c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C20 4.28 20 5.12 20 6.8v10.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C17.72 22 16.88 22 15.2 22H8.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.72 4 18.88 4 17.2v-.7"
  }))),
  anchor: t => e.createElement("svg", QS({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), WS || (WS = e.createElement("path", {
    d: "M12 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0 0v14m0 0A10 10 0 0 1 2 12h3m7 10a10 10 0 0 0 10-10h-3"
  }))),
  arrowsquareupleft: t => e.createElement("svg", YS({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), GS || (GS = e.createElement("path", {
    d: "M9 15V9m0 0h6M9 9l6 6m-7.2 6h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Z"
  }))),
  coins02: t => e.createElement("svg", XS({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), KS || (KS = e.createElement("path", {
    d: "M15.938 15.938A7.001 7.001 0 0 0 15 2a7.001 7.001 0 0 0-6.938 6.062M7.5 13 9 12v5.5m-1.5 0h3M16 15a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
  }))),
  arrowcircledownright: t => e.createElement("svg", eN({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), JS || (JS = e.createElement("path", {
    d: "M15 9v6m0 0H9m6 0L9 9m13 3c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }))),
  flexalignleft: t => e.createElement("svg", rN({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), tN || (tN = e.createElement("path", {
    d: "M6.5 17.5v-11M7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3Z"
  }))),
  alertcircle: t => e.createElement("svg", aN({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), nN || (nN = e.createElement("path", {
    d: "M12 8v4m0 4h.01M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }))),
  arrownarrowdownleft: t => e.createElement("svg", iN({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), oN || (oN = e.createElement("path", {
    d: "M18 6 6 18m0 0h8m-8 0v-8"
  }))),
  barlinechart: t => e.createElement("svg", sN({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), lN || (lN = e.createElement("path", {
    d: "M20 20v-7m-8 7V10M4 20v-4m9.407-10.973 5.168 1.939M10.8 5.4 5.2 9.6m15.86-3.16a1.5 1.5 0 1 1-2.121 2.12 1.5 1.5 0 0 1 2.122-2.12Zm-16 3a1.5 1.5 0 1 1-2.12 2.12 1.5 1.5 0 0 1 2.12-2.12Zm8-6a1.5 1.5 0 1 1-2.121 2.12 1.5 1.5 0 0 1 2.122-2.12Z"
  }))),
  folderdownload: t => e.createElement("svg", uN({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), cN || (cN = e.createElement("path", {
    d: "m13 7-1.116-2.231c-.32-.642-.481-.963-.72-1.198a2 2 0 0 0-.748-.462C10.1 3 9.74 3 9.022 3H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 4.52 2 5.08 2 6.2V7m0 0h15.2c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C22 9.28 22 10.12 22 11.8v4.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C19.72 21 18.88 21 17.2 21H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.72 2 17.88 2 16.2V7Zm7 7 3 3m0 0 3-3m-3 3v-6"
  }))),
  server04: t => e.createElement("svg", mN({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), hN || (hN = e.createElement("path", {
    d: "m22 10.5-.474-3.795c-.186-1.489-.28-2.233-.63-2.794a3 3 0 0 0-1.283-1.133c-.6-.278-1.35-.278-2.85-.278H7.237c-1.5 0-2.25 0-2.85.278a3 3 0 0 0-1.283 1.133c-.35.56-.444 1.305-.63 2.794L2 10.5m3.5 4h13m-13 0a3.5 3.5 0 1 1 0-7h13a3.5 3.5 0 1 1 0 7m-13 0a3.5 3.5 0 1 0 0 7h13a3.5 3.5 0 1 0 0-7M6 11h.01M6 18h.01M12 11h6m-6 7h6"
  }))),
  arrowsup: t => e.createElement("svg", fN({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), pN || (pN = e.createElement("path", {
    d: "M7 20V4m0 0L3 8m4-4 4 4m6 12V9m0 0-4 4m4-4 4 4"
  }))),
  moon02: t => e.createElement("svg", vN({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), dN || (dN = e.createElement("path", {
    d: "M21.955 12.956a8 8 0 1 1-10.91-10.911C5.97 2.526 2 6.799 2 12c0 5.523 4.477 10 10 10 5.2 0 9.473-3.97 9.955-9.044Z"
  }))),
  fileheart01: t => e.createElement("svg", bN({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), gN || (gN = e.createElement("path", {
    d: "M20 10V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 2 16.88 2 15.2 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22H12m4.997-7.17c-.8-.908-2.133-1.153-3.135-.32-1.002.832-1.143 2.223-.356 3.208.787.984 3.491 3.282 3.491 3.282s2.705-2.298 3.492-3.282a2.256 2.256 0 0 0-.356-3.209c-1.02-.823-2.336-.587-3.136.322Z"
  }))),
  login03: t => e.createElement("svg", yN({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), wN || (wN = e.createElement("path", {
    d: "M6 17c0 .351 0 .527.016.68a3 3 0 0 0 2.286 2.611c.15.036.324.059.672.105l6.592.88c1.876.25 2.814.375 3.542.085a3 3 0 0 0 1.509-1.32c.383-.684.383-1.63.383-3.524V7.482c0-1.893 0-2.84-.383-3.523a3 3 0 0 0-1.509-1.32c-.728-.29-1.666-.165-3.542.086l-6.592.878c-.349.047-.523.07-.672.106A3 3 0 0 0 6.016 6.32C6 6.473 6 6.65 6 7m6 1 4 4m0 0-4 4m4-4H3"
  }))),
  cursor01: t => e.createElement("svg", ON({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), xN || (xN = e.createElement("path", {
    d: "m13 13 6 6m-1.036-8.249-5.01 1.702c-.138.047-.206.07-.263.109a.502.502 0 0 0-.129.129c-.04.057-.062.125-.109.262l-1.702 5.011c-.21.621-.316.932-.481 1.026a.5.5 0 0 1-.465.016c-.171-.083-.297-.386-.55-.992L3.747 4.794c-.234-.563-.351-.844-.294-1.02a.5.5 0 0 1 .321-.321c.176-.057.457.06 1.02.294l13.22 5.508c.606.253.909.379.992.55a.5.5 0 0 1-.016.465c-.094.165-.405.27-1.026.481Z"
  }))),
  volumemax: t => e.createElement("svg", jN({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), EN || (EN = e.createElement("path", {
    d: "M19.748 5A11.946 11.946 0 0 1 22 12c0 2.612-.835 5.03-2.252 7M15.745 8A6.968 6.968 0 0 1 17 12a6.967 6.967 0 0 1-1.255 4M9.635 5.366 6.468 8.53c-.173.173-.26.26-.36.322a1 1 0 0 1-.29.12C5.704 9 5.582 9 5.337 9H3.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C2 9.76 2 10.04 2 10.6v2.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C2.76 15 3.04 15 3.6 15h1.737c.245 0 .367 0 .482.028a1 1 0 0 1 .29.12c.1.061.187.148.36.32l3.165 3.166c.429.429.643.643.827.657a.5.5 0 0 0 .42-.174c.119-.14.119-.443.119-1.048V5.93c0-.606 0-.908-.12-1.049a.5.5 0 0 0-.42-.173c-.183.014-.397.228-.826.657Z"
  }))),
  folderlock: t => e.createElement("svg", PN({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), CN || (CN = e.createElement("path", {
    d: "m13 7-1.116-2.231c-.32-.642-.481-.963-.72-1.198a2 2 0 0 0-.748-.462C10.1 3 9.74 3 9.022 3H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 4.52 2 5.08 2 6.2V7m0 0h15.2c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C22 9.28 22 10.12 22 11.8v4.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C19.72 21 18.88 21 17.2 21H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.72 2 17.88 2 16.2V7Zm8.1 10.5h3.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437c.109-.214.109-.494.109-1.054v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437c-.214-.109-.494-.109-1.054-.109h-3.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C8.5 14.26 8.5 14.54 8.5 15.1v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437c.214.109.494.109 1.054.109Zm3.65-4v-1.75a1.75 1.75 0 1 0-3.5 0v1.75h3.5Z"
  }))),
  atom01: t => e.createElement("svg", kN({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), MN || (MN = e.createElement("path", {
    d: "M12 12h.01m3.525 3.536c-4.686 4.686-10.068 6.902-12.02 4.95-1.953-1.953.263-7.335 4.949-12.021 4.686-4.687 10.068-6.903 12.02-4.95 1.953 1.952-.263 7.334-4.949 12.02Zm0-7.072c4.686 4.687 6.902 10.069 4.95 12.021-1.953 1.953-7.335-.263-12.021-4.95-4.686-4.686-6.902-10.068-4.95-12.02 1.953-1.953 7.335.263 12.021 4.95ZM12.499 12a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
  }))),
  crop02: t => e.createElement("svg", NN({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), SN || (SN = e.createElement("path", {
    d: "M10 6h4.8c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C18 7.52 18 8.08 18 9.2V14M2 6h4m12 12v4m4-4H9.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C6 16.48 6 15.92 6 14.8V2"
  }))),
  filesearch01: t => e.createElement("svg", VN({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), BN || (BN = e.createElement("path", {
    d: "M20 10.5V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 2 16.88 2 15.2 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22h2.7M22 22l-1.5-1.5m1-2.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
  }))),
  messagetextsquare01: t => e.createElement("svg", AN({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), RN || (RN = e.createElement("path", {
    d: "M7 8.5h5M7 12h8m-5.316 6H16.2c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 15.72 21 14.88 21 13.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v12.535c0 .533 0 .8.11.937a.5.5 0 0 0 .39.188c.176 0 .384-.167.8-.5l2.385-1.908c.488-.39.731-.585 1.002-.724.241-.122.497-.212.762-.267C8.748 18 9.06 18 9.684 18Z"
  }))),
  youtube: t => e.createElement("svg", LN({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), TN || (TN = e.createElement("path", {
    d: "M21.581 7.2a2.528 2.528 0 0 0-1.763-1.818C18.254 5 12 5 12 5s-6.254 0-7.818.418A2.527 2.527 0 0 0 2.42 7.236 26.362 26.362 0 0 0 2 12.046c-.01 1.624.13 3.246.418 4.844a2.527 2.527 0 0 0 1.763 1.746c1.564.418 7.818.418 7.818.418s6.254 0 7.818-.418a2.528 2.528 0 0 0 1.763-1.818c.284-1.575.424-3.173.419-4.773A26.36 26.36 0 0 0 21.58 7.2Z"
  })), HN || (HN = e.createElement("path", {
    d: "M9.75 9.465c0-.477 0-.716.1-.849a.5.5 0 0 1 .364-.199c.166-.012.367.117.769.375l3.942 2.535c.349.224.523.336.583.478a.5.5 0 0 1 0 .39c-.06.142-.234.254-.583.478l-3.942 2.535c-.402.258-.603.387-.769.375a.5.5 0 0 1-.364-.2c-.1-.132-.1-.371-.1-.848v-5.07Z"
  }))),
  star07: t => e.createElement("svg", FN({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), IN || (IN = e.createElement("path", {
    d: "M22 12h-2m-.929 7.071-1.414-1.414M4 12H2m4.343-5.657L4.929 4.93M12 4V2m5.657 4.343L19.07 4.93M12 22v-2m-7.071-.929 1.414-1.414M12 7l1.545 3.13 3.455.505-2.5 2.435.59 3.44L12 14.885 8.91 16.51l.59-3.44L7 10.635l3.455-.505L12 7Z"
  }))),
  copy06: t => e.createElement("svg", ZN({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), _N || (_N = e.createElement("path", {
    d: "M7.5 3h7.1c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C21 6.04 21 7.16 21 9.4v7.1M6.2 21h8.1c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874c.218-.428.218-.988.218-2.108V9.7c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C15.98 6.5 15.42 6.5 14.3 6.5H6.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C3 8.02 3 8.58 3 9.7v8.1c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C4.52 21 5.08 21 6.2 21Z"
  }))),
  copy07: t => e.createElement("svg", qN({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), DN || (DN = e.createElement("path", {
    d: "M10.5 2.003c-.675.009-1.08.048-1.408.215a2 2 0 0 0-.874.874c-.167.328-.206.733-.215 1.408M19.5 2.003c.675.009 1.08.048 1.408.215a2 2 0 0 1 .874.874c.167.328.206.733.215 1.408m0 9c-.009.675-.048 1.08-.215 1.408a2 2 0 0 1-.874.874c-.328.167-.733.206-1.408.215M22 8v2m-8-8h2M5.2 22h7.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C16 20.48 16 19.92 16 18.8v-7.6c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C14.48 8 13.92 8 12.8 8H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 9.52 2 10.08 2 11.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 22 4.08 22 5.2 22Z"
  }))),
  star06: t => e.createElement("svg", $N({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), UN || (UN = e.createElement("path", {
    d: "M4.5 22v-5m0-10V2M2 4.5h5m-5 15h5M13 3l-1.734 4.509c-.282.733-.423 1.1-.643 1.408a3 3 0 0 1-.706.707c-.308.219-.675.36-1.408.642L4 12l4.509 1.734c.733.282 1.1.423 1.408.643.273.194.512.433.707.706.219.308.36.675.642 1.408L13 21l1.734-4.509c.282-.733.423-1.1.643-1.408.194-.273.433-.512.706-.707.308-.219.675-.36 1.408-.642L22 12l-4.509-1.734c-.733-.282-1.1-.423-1.408-.642a3 3 0 0 1-.706-.707c-.22-.308-.36-.675-.643-1.408L13 3Z"
  }))),
  layerstwo01: t => e.createElement("svg", WN({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), zN || (zN = e.createElement("path", {
    d: "m2 14.5 9.642 4.821c.131.066.197.099.266.111.06.012.123.012.184 0 .069-.012.135-.045.266-.11L22 14.5m-20-5 9.642-4.821c.131-.066.197-.098.266-.111a.5.5 0 0 1 .184 0c.069.013.135.045.266.111L22 9.5l-9.642 4.821c-.131.066-.197.099-.266.111a.501.501 0 0 1-.184 0c-.069-.012-.135-.045-.266-.11L2 9.5Z"
  }))),
  filterfunnel01: t => e.createElement("svg", GN({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), QN || (QN = e.createElement("path", {
    d: "M2 4.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C2.76 3 3.04 3 3.6 3h16.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C22 3.76 22 4.04 22 4.6v.67c0 .268 0 .403-.033.528-.029.11-.077.215-.141.31-.073.106-.175.194-.378.37l-6.396 5.543c-.203.176-.305.265-.377.371-.065.095-.113.2-.142.31-.033.125-.033.26-.033.529v5.227c0 .196 0 .294-.031.378a.5.5 0 0 1-.133.196c-.066.06-.157.096-.339.17l-3.4 1.36c-.367.146-.551.22-.699.189a.5.5 0 0 1-.315-.213c-.083-.126-.083-.324-.083-.72v-6.587c0-.27 0-.404-.033-.529a1.001 1.001 0 0 0-.141-.31c-.073-.106-.175-.194-.378-.37L2.552 6.478c-.203-.177-.305-.265-.378-.371a1 1 0 0 1-.141-.31C2 5.673 2 5.538 2 5.269V4.6Z"
  }))),
  checkheart: t => e.createElement("svg", KN({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), YN || (YN = e.createElement("path", {
    d: "m9 11 2 2 4.5-4.5m-3.507-3.364c-2-2.338-5.333-2.966-7.838-.826s-2.858 5.719-.89 8.25c1.485 1.912 5.706 5.751 7.683 7.515.363.324.545.486.758.55.184.055.39.055.575 0 .212-.064.394-.226.757-.55 1.977-1.764 6.198-5.603 7.684-7.515 1.967-2.531 1.658-6.132-.89-8.25-2.549-2.118-5.84-1.512-7.839.826Z"
  }))),
  compass: t => e.createElement("svg", JN({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), XN || (XN = e.createElement("path", {
    d: "M12 4a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Zm0 0V2m9 12.938A11.971 11.971 0 0 1 12 19a11.971 11.971 0 0 1-9-4.063m7.745-6.275L3 22M13.255 8.662 21 22"
  }))),
  pilcrow02: t => e.createElement("svg", tB({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), eB || (eB = e.createElement("path", {
    d: "M17.5 4v16m2-16H9a4 4 0 1 0 0 8h5m0-8v16m-2 0h7.5"
  }))),
  login02: t => e.createElement("svg", nB({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), rB || (rB = e.createElement("path", {
    d: "M6 17c0 .93 0 1.395.102 1.776a3 3 0 0 0 2.122 2.122C8.605 21 9.07 21 10 21h6.2c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H10c-.93 0-1.395 0-1.776.102a3 3 0 0 0-2.122 2.122C6 5.605 6 6.07 6 7m6 1 4 4m0 0-4 4m4-4H3"
  }))),
  ticket01: t => e.createElement("svg", oB({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), aB || (aB = e.createElement("path", {
    d: "M10 8V7m0 5.5v-1m0 5.5v-1M5.2 4h13.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C22 5.52 22 6.08 22 7.2v1.3a3.5 3.5 0 1 0 0 7v1.3c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C20.48 20 19.92 20 18.8 20H5.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C2 18.48 2 17.92 2 16.8v-1.3a3.5 3.5 0 1 0 0-7V7.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C3.52 4 4.08 4 5.2 4Z"
  }))),
  pluscircle: t => e.createElement("svg", lB({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), iB || (iB = e.createElement("path", {
    d: "M12 8v8m-4-4h8m6 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }))),
  puzzlepiece01: t => e.createElement("svg", cB({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), sB || (sB = e.createElement("path", {
    d: "M7.5 4.5a2.5 2.5 0 0 1 5 0V6h1c1.398 0 2.097 0 2.648.228a3 3 0 0 1 1.624 1.624C18 8.403 18 9.102 18 10.5h1.5a2.5 2.5 0 0 1 0 5H18v1.7c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C15.72 22 14.88 22 13.2 22h-.7v-1.75a2.25 2.25 0 0 0-4.5 0V22H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 19.72 2 18.88 2 17.2v-1.7h1.5a2.5 2.5 0 0 0 0-5H2c0-1.398 0-2.097.228-2.648a3 3 0 0 1 1.624-1.624C4.403 6 5.102 6 6.5 6h1V4.5Z"
  }))),
  cube04: t => e.createElement("svg", hB({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), uB || (uB = e.createElement("path", {
    d: "M20.5 16H8m0 0V3.5M8 16l-4.5 4.5M3.5 8H16m0 0v12.5M16 8l4.5-4.5m.5 11.837V3.8c0-.28 0-.42-.055-.527a.5.5 0 0 0-.218-.219C20.62 3 20.48 3 20.2 3H8.663c-.245 0-.367 0-.482.028a1 1 0 0 0-.29.12c-.1.061-.187.148-.36.32L3.47 7.532c-.173.173-.26.26-.322.36a1 1 0 0 0-.12.29C3 8.296 3 8.418 3 8.663V20.2c0 .28 0 .42.054.527a.5.5 0 0 0 .219.218C3.38 21 3.52 21 3.8 21h11.537c.245 0 .367 0 .482-.028a.998.998 0 0 0 .29-.12c.1-.061.187-.148.36-.32l4.062-4.063c.173-.173.26-.26.322-.36a.998.998 0 0 0 .12-.29c.027-.115.027-.237.027-.482Z"
  }))),
  creditcardcheck: t => e.createElement("svg", pB({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), mB || (mB = e.createElement("path", {
    d: "m16 18 2 2 4-4m0-6H2m20 2V8.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 5 19.92 5 18.8 5H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 6.52 2 7.08 2 8.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 19 4.08 19 5.2 19H12"
  }))),
  currencyrublecircle: t => e.createElement("svg", dB({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), fB || (fB = e.createElement("path", {
    d: "M9.5 6.5H14a2.5 2.5 0 0 1 0 5H9.5v-5Zm0 0v11m.25-6H8m5 3.25H8M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }))),
  filecheck01: t => e.createElement("svg", gB({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), vB || (vB = e.createElement("path", {
    d: "M20 12.5V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 2 16.88 2 15.2 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22H12m2.5-3 2 2 4.5-4.5"
  }))),
  server05: t => e.createElement("svg", wB({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), bB || (bB = e.createElement("path", {
    d: "M19 9a7 7 0 0 1-7 7m7-7a7 7 0 0 0-7-7m7 7H5m7 7a7 7 0 0 1-7-7m7 7a10.71 10.71 0 0 0 2.8-7A10.711 10.711 0 0 0 12 2m0 14a10.709 10.709 0 0 1-2.8-7A10.709 10.709 0 0 1 12 2m0 14v2M5 9a7 7 0 0 1 7-7m2 18a2 2 0 1 1-4 0m4 0a2 2 0 0 0-2-2m2 2h7m-11 0a2 2 0 0 1 2-2m-2 2H3"
  }))),
  underline01: t => e.createElement("svg", xB({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), yB || (yB = e.createElement("path", {
    d: "M18 4v7a6 6 0 0 1-12 0V4M4 21h16"
  }))),
  imageup: t => e.createElement("svg", EB({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), OB || (OB = e.createElement("path", {
    d: "m16 5 3-3m0 0 3 3m-3-3v6m-6.5-5H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21H17c.93 0 1.395 0 1.776-.102a3 3 0 0 0 2.122-2.122C21 18.395 21 17.93 21 17M10.5 8.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4.49 3.418-8.459 7.69c-.476.433-.714.649-.735.836a.5.5 0 0 0 .167.431C6.105 21 6.426 21 7.07 21h9.387c1.44 0 2.159 0 2.724-.242a3 3 0 0 0 1.578-1.578c.242-.565.242-1.285.242-2.724 0-.484 0-.726-.053-.952a2.001 2.001 0 0 0-.374-.778c-.143-.182-.332-.333-.71-.636l-2.797-2.237c-.379-.303-.568-.454-.776-.508a1 1 0 0 0-.557.018c-.205.066-.384.23-.743.555Z"
  }))),
  cloudmoon: t => e.createElement("svg", CB({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), jB || (jB = e.createElement("path", {
    d: "M16.5 13a5.502 5.502 0 0 0 5.337-4.164 5.5 5.5 0 0 1-6.673-6.672 5.502 5.502 0 0 0-3.548 7.867M5 7V3M3 5h4M6 22a4 4 0 0 1-.679-7.943 6.003 6.003 0 0 1 10.968-.892A4.5 4.5 0 1 1 17.5 22H6.001Z"
  }))),
  bank: t => e.createElement("svg", MB({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), PB || (PB = e.createElement("path", {
    d: "M5 9v8m4.5-8v8m5-8v8M19 9v8M3 18.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C3.76 21 4.04 21 4.6 21h14.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C21 20.24 21 19.96 21 19.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C20.24 17 19.96 17 19.4 17H4.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 17.76 3 18.04 3 18.6Zm8.653-15.523-7.4 1.645c-.447.099-.67.149-.838.269a1 1 0 0 0-.334.417C3 5.597 3 5.826 3 6.283V7.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C3.76 9 4.04 9 4.6 9h14.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C21 8.24 21 7.96 21 7.4V6.283c0-.457 0-.686-.081-.875a1 1 0 0 0-.335-.417c-.166-.12-.39-.17-.837-.27l-7.4-1.644a2.083 2.083 0 0 0-.26-.049 1 1 0 0 0-.174 0c-.066.006-.13.02-.26.05Z"
  }))),
  arrownarrowdown: t => e.createElement("svg", SB({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), kB || (kB = e.createElement("path", {
    d: "M12 4v16m0 0 6-6m-6 6-6-6"
  }))),
  clockrefresh: t => e.createElement("svg", BB({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), NB || (NB = e.createElement("path", {
    d: "M20.453 12.893A8.5 8.5 0 0 1 4.638 16.25l-.25-.433m-.842-4.71A8.5 8.5 0 0 1 19.361 7.75l.25.433M3.493 18.066l.732-2.732 2.732.732m10.085-8.132 2.732.732.732-2.732M12 7.5V12l2.5 1.5"
  }))),
  rightindent01: t => e.createElement("svg", RB({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), VB || (VB = e.createElement("path", {
    d: "M21 4H3m18 16H3m9-10.75H3m9 5.5H3m16.72-6.29-3.867 2.9c-.29.217-.434.326-.486.459a.5.5 0 0 0 0 .362c.052.133.197.242.486.459l3.867 2.9c.412.309.618.463.79.46a.5.5 0 0 0 .384-.192c.106-.136.106-.393.106-.908V9.1c0-.515 0-.772-.106-.908A.5.5 0 0 0 20.51 8c-.172-.003-.378.151-.79.46Z"
  }))),
  coins03: t => e.createElement("svg", TB({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), AB || (AB = e.createElement("path", {
    d: "M10.101 4A7 7 0 0 1 20 13.899M16 15a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
  }))),
  musicnoteplus: t => e.createElement("svg", LB({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), HB || (HB = e.createElement("path", {
    d: "M14.5 18V5.589c0-.857 0-1.286.18-1.544a1 1 0 0 1 .674-.416c.312-.046.695.145 1.462.529L20.5 6m-6 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-8-8V4m-3 3h6"
  }))),
  usercircle: t => e.createElement("svg", FB({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), IB || (IB = e.createElement("path", {
    d: "M5.316 19.438A4.001 4.001 0 0 1 9 17h6a4.001 4.001 0 0 1 3.684 2.438M16 9.5a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm6 2.5c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }))),
  filex03: t => e.createElement("svg", ZB({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), _B || (_B = e.createElement("path", {
    d: "M14 2.27V6.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437c.214.11.494.11 1.054.11h4.13M9.5 12l5 5m0-5-5 5M14 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 19.72 20 18.88 20 17.2V8l-6-6Z"
  }))),
  foldershield: t => e.createElement("svg", qB({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), DB || (DB = e.createElement("path", {
    d: "m13 7-1.116-2.231c-.32-.642-.481-.963-.72-1.198a2 2 0 0 0-.748-.462C10.1 3 9.74 3 9.022 3H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 4.52 2 5.08 2 6.2V7m0 0h15.2c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C22 9.28 22 10.12 22 11.8v4.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C19.72 21 18.88 21 17.2 21H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.72 2 17.88 2 16.2V7Zm10 10.5s3-1.43 3-3.575v-2.502l-2.188-.782a2.41 2.41 0 0 0-1.626 0L9 11.423v2.502c0 2.145 3 3.575 3 3.575Z"
  }))),
  videorecorder: t => e.createElement("svg", $B({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), UB || (UB = e.createElement("path", {
    d: "M22 8.931c0-.605 0-.908-.12-1.049a.5.5 0 0 0-.42-.173c-.183.014-.397.228-.826.657L17 12l3.634 3.634c.429.429.643.643.827.657a.5.5 0 0 0 .42-.173c.119-.14.119-.444.119-1.05V8.932ZM2 9.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C4.28 5 5.12 5 6.8 5h5.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C17 7.28 17 8.12 17 9.8v4.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C14.72 19 13.88 19 12.2 19H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 16.72 2 15.88 2 14.2V9.8Z"
  }))),
  belloff02: t => e.createElement("svg", WB({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), zB || (zB = e.createElement("path", {
    d: "M14 21h-4M8.633 3.034A6 6 0 0 1 18 8c0 2.1.27 3.751.648 5.032M6.258 6.257A5.998 5.998 0 0 0 6 8c0 3.09-.78 5.206-1.65 6.605-.735 1.18-1.102 1.771-1.089 1.936.015.182.054.252.2.36.133.099.732.099 1.928.099H17m4 4L3 3"
  }))),
  terminalsquare: t => e.createElement("svg", GB({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), QB || (QB = e.createElement("path", {
    d: "m7 15 3-3-3-3m6 6h4m-9.2 6h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Z"
  }))),
  zapfast: t => e.createElement("svg", KB({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), YB || (YB = e.createElement("path", {
    d: "M9 17.5H3.5m3-5.5H2m7-5.5H4M17 3l-6.596 9.235c-.292.409-.438.613-.432.784a.5.5 0 0 0 .194.377c.135.104.386.104.889.104H16L15 21l6.596-9.235c.292-.409.438-.613.432-.784a.5.5 0 0 0-.194-.377c-.135-.104-.386-.104-.889-.104H16L17 3Z"
  }))),
  navigationpointer01: t => e.createElement("svg", JB({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), XB || (XB = e.createElement("path", {
    d: "M3.413 10.745c-.595-.232-.893-.348-.98-.515a.5.5 0 0 1 0-.461c.087-.167.385-.283.98-.515L20.3 2.664c.537-.21.806-.315.978-.258a.5.5 0 0 1 .316.316c.057.172-.048.44-.258.977l-6.59 16.888c-.232.595-.348.893-.515.98a.5.5 0 0 1-.462 0c-.167-.088-.282-.385-.514-.98l-2.628-6.759a1.075 1.075 0 0 0-.107-.232.5.5 0 0 0-.116-.117c-.051-.036-.112-.06-.232-.106l-6.759-2.628Z"
  }))),
  tablet01: t => e.createElement("svg", tV({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), eV || (eV = e.createElement("path", {
    d: "M12 17.5h.01M7.2 22h9.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C20 20.48 20 19.92 20 18.8V5.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C18.48 2 17.92 2 16.8 2H7.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C4 3.52 4 4.08 4 5.2v13.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C5.52 22 6.08 22 7.2 22Zm5.3-4.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
  }))),
  grid03: t => e.createElement("svg", nV({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), rV || (rV = e.createElement("path", {
    d: "M8 3H6.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C3 4.52 3 5.08 3 6.2V8m5 13H6.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C3 19.48 3 18.92 3 17.8V16m18-8V6.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C19.48 3 18.92 3 17.8 3H16m5 13v1.8c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C19.48 21 18.92 21 17.8 21H16m0-9a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
  }))),
  dataflow04: t => e.createElement("svg", oV({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), aV || (aV = e.createElement("path", {
    d: "M4 18v-.2c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C6.28 13 7.12 13 8.8 13h6.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C20 15.28 20 16.12 20 17.8v.2M4 18a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm16 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-8 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm0 0V8M6 8h12c.932 0 1.398 0 1.765-.152a2 2 0 0 0 1.083-1.083C21 6.398 21 5.932 21 5c0-.932 0-1.398-.152-1.765a2 2 0 0 0-1.083-1.083C19.398 2 18.932 2 18 2H6c-.932 0-1.398 0-1.765.152a2 2 0 0 0-1.083 1.083C3 3.602 3 4.068 3 5c0 .932 0 1.398.152 1.765a2 2 0 0 0 1.083 1.083C4.602 8 5.068 8 6 8Z"
  }))),
  sale01: t => e.createElement("svg", lV({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), iV || (iV = e.createElement("path", {
    d: "M9 9h.01M15 15h.01M16 8l-8 8m14-4c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10ZM9.5 9a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm6 6a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
  }))),
  barchartsquare02: t => e.createElement("svg", cV({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), sV || (sV = e.createElement("path", {
    d: "M8 15v2m4-6v6m4-10v10m-8.2 4h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Z"
  }))),
  camera02: t => e.createElement("svg", mV({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), uV || (uV = e.createElement("path", {
    d: "M2 7.702A2.702 2.702 0 0 1 4.702 5c.775 0 1.463-.496 1.709-1.232L6.5 3.5c.042-.127.063-.19.086-.246a2 2 0 0 1 1.735-1.25C8.38 2 8.448 2 8.58 2h6.838c.133 0 .2 0 .26.004a2 2 0 0 1 1.735 1.25c.023.056.044.12.086.246l.09.268A1.801 1.801 0 0 0 19.297 5 2.702 2.702 0 0 1 22 7.702V16.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C19.72 21 18.88 21 17.2 21H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.72 2 17.88 2 16.2V7.702Z"
  })), hV || (hV = e.createElement("path", {
    d: "M12 16.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Z"
  }))),
  edit02: t => e.createElement("svg", fV({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), pV || (pV = e.createElement("path", {
    d: "m18 10-4-4M2.5 21.5l3.384-.376c.414-.046.62-.069.814-.131a2 2 0 0 0 .485-.234c.17-.111.317-.259.61-.553L21 7a2.828 2.828 0 1 0-4-4L3.794 16.206c-.294.294-.442.442-.553.611a2 2 0 0 0-.233.485c-.063.193-.086.4-.132.814L2.5 21.5Z"
  }))),
  beaker01: t => e.createElement("svg", vV({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), dV || (dV = e.createElement("path", {
    d: "M10 2v4.66c0 .218 0 .326-.033.413a.47.47 0 0 1-.138.198c-.07.06-.183.102-.409.185a7.5 7.5 0 1 0 5.16 0c-.226-.083-.339-.125-.409-.185a.469.469 0 0 1-.138-.198C14 6.986 14 6.878 14 6.66V2M8.5 2h7"
  }))),
  trash04: t => e.createElement("svg", bV({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), gV || (gV = e.createElement("path", {
    d: "M9 3h6M3 6h18m-2 0-.701 10.52c-.105 1.578-.158 2.367-.499 2.965a3 3 0 0 1-1.298 1.215c-.62.3-1.41.3-2.993.3h-3.018c-1.582 0-2.373 0-2.993-.3A3 3 0 0 1 6.2 19.485c-.34-.598-.394-1.387-.499-2.966L5 6"
  }))),
  gamingpad01: t => e.createElement("svg", yV({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), wV || (wV = e.createElement("path", {
    d: "M6 11h4M8 9v4m7-1h.01M18 10h.01m-7.56-5h3.101c2.625 0 3.937 0 4.968.497a5 5 0 0 1 2.162 2.014c.57.992.663 2.3.85 4.919l.246 3.444a2.918 2.918 0 0 1-5.152 2.076l-.375-.45c-.343-.412-.515-.618-.71-.784a3 3 0 0 0-1.435-.672C13.851 16 13.583 16 13.047 16h-2.095c-.536 0-.804 0-1.057.044a3 3 0 0 0-1.436.672c-.195.166-.367.372-.71.784l-.375.45a2.918 2.918 0 0 1-5.152-2.075l.246-3.445c.187-2.618.28-3.927.85-4.92a5 5 0 0 1 2.163-2.013C6.512 5 7.824 5 10.449 5Z"
  }))),
  lockunlocked01: t => e.createElement("svg", OV({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), xV || (xV = e.createElement("path", {
    d: "M7 10V8a5 5 0 0 1 9.584-2M12 14.5v2M8.8 21h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 18.72 20 17.88 20 16.2v-1.4c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 10 16.88 10 15.2 10H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 12.28 4 13.12 4 14.8v1.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 21 7.12 21 8.8 21Z"
  }))),
  messagesmilecircle: t => e.createElement("svg", jV({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), EV || (EV = e.createElement("path", {
    d: "M9 14s1.312 1.5 3.5 1.5c2.187 0 3.5-1.5 3.5-1.5m-.75-5h.01M9.75 9h.01m2.74 11a8.5 8.5 0 1 0-8.057-5.783c.108.32.162.481.172.604a.899.899 0 0 1-.028.326c-.03.12-.098.245-.232.494l-1.636 3.027c-.233.432-.35.648-.324.815a.5.5 0 0 0 .234.35c.144.087.388.062.876.011l5.121-.529c.155-.016.233-.024.303-.021.07.002.12.009.187.024.069.016.155.05.329.116A8.478 8.478 0 0 0 12.5 20Zm3.25-11a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm-5.5 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
  }))),
  simcard: t => e.createElement("svg", MV({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), CV || (CV = e.createElement("path", {
    d: "M4 6.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C6.28 2 7.12 2 8.8 2h3.212c.733 0 1.1 0 1.446.083.306.073.598.195.867.36.303.185.562.444 1.08.963l3.19 3.188c.518.519.777.778.963 1.081a3 3 0 0 1 .36.867c.082.346.082.712.082 1.446V17.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C17.72 22 16.88 22 15.2 22H8.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.72 4 18.88 4 17.2V6.8Z"
  })), PV || (PV = e.createElement("path", {
    d: "M8 13.8c0-.28 0-.42.055-.527a.5.5 0 0 1 .218-.218C8.38 13 8.52 13 8.8 13h6.4c.28 0 .42 0 .527.055a.5.5 0 0 1 .218.218c.055.107.055.247.055.527v3.4c0 .28 0 .42-.055.527a.5.5 0 0 1-.218.218C15.62 18 15.48 18 15.2 18H8.8c-.28 0-.42 0-.527-.055a.5.5 0 0 1-.218-.218C8 17.62 8 17.48 8 17.2v-3.4Z"
  }))),
  messagenotificationcircle: t => e.createElement("svg", SV({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), kV || (kV = e.createElement("path", {
    d: "M11.707 3.036a8.5 8.5 0 0 0-7.264 11.18c.108.322.162.482.172.605a.899.899 0 0 1-.028.326c-.03.12-.098.245-.232.494l-1.636 3.027c-.233.432-.35.648-.324.815a.5.5 0 0 0 .234.35c.144.087.388.062.876.011l5.121-.529c.155-.016.233-.024.303-.021.07.002.12.009.187.024.069.016.155.05.329.116a8.5 8.5 0 0 0 11.52-7.153M20.12 3.88a3 3 0 1 1-4.243 4.242 3 3 0 0 1 4.243-4.242Z"
  }))),
  cloudblank02: t => e.createElement("svg", BV({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), NV || (NV = e.createElement("path", {
    d: "M9.5 19a7.5 7.5 0 1 1 6.641-10.988A5.5 5.5 0 1 1 16.5 19h-7Z"
  }))),
  barchart03: t => e.createElement("svg", RV({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), VV || (VV = e.createElement("path", {
    d: "M6 20V4m12 16v-4m-6 4V10"
  }))),
  skipback: t => e.createElement("svg", TV({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), AV || (AV = e.createElement("path", {
    d: "M5 19V5m11.4 1.08-5.838 4.67c-.534.428-.801.641-.898.9a1 1 0 0 0 0 .7c.097.259.364.472.898.9l5.839 4.67c.832.666 1.248.999 1.598 1a1 1 0 0 0 .783-.377c.218-.273.218-.806.218-1.872V7.329c0-1.066 0-1.599-.218-1.872a1 1 0 0 0-.783-.376c-.35 0-.766.333-1.598.999Z"
  }))),
  glasses01: t => e.createElement("svg", LV({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), HV || (HV = e.createElement("path", {
    d: "M10 11.535a4.008 4.008 0 0 1 4 0M8.828 9.172a4 4 0 1 1-5.657 5.656 4 4 0 0 1 5.657-5.656Zm12 0a4 4 0 1 1-5.656 5.656 4 4 0 0 1 5.656-5.656Z"
  }))),
  delete: t => e.createElement("svg", FV({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), IV || (IV = e.createElement("path", {
    d: "m17 9-6 6m0-6 6 6M2.72 12.96l4.32 5.76c.352.47.528.704.751.873.198.15.421.262.66.33C8.72 20 9.013 20 9.6 20h7.6c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 17.72 22 16.88 22 15.2V8.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C19.72 4 18.88 4 17.2 4H9.6c-.587 0-.88 0-1.15.077a2 2 0 0 0-.659.33c-.223.169-.399.404-.751.873l-4.32 5.76c-.258.344-.387.516-.437.705a1 1 0 0 0 0 .51c.05.189.179.36.437.705Z"
  }))),
  command: t => e.createElement("svg", ZV({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), _V || (_V = e.createElement("path", {
    d: "M9 9V6a3 3 0 1 0-3 3h3Zm0 0v6m0-6h6m-6 6v3a3 3 0 1 1-3-3h3Zm0 0h6m0 0h3a3 3 0 1 1-3 3v-3Zm0 0V9m0 0V6a3 3 0 1 1 3 3h-3Z"
  }))),
  imageuserleft: t => e.createElement("svg", qV({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), DV || (DV = e.createElement("path", {
    d: "m19 8-3-3m0 0 3-3m-3 3h6m0 7v5.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C19.72 22 18.88 22 17.2 22H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 19.72 2 18.88 2 17.2V6.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C4.28 2 5.12 2 6.8 2H12M2.146 19.926A4.002 4.002 0 0 1 6 17h7c.93 0 1.394 0 1.78.077a4 4 0 0 1 3.143 3.143c.077.386.077.85.077 1.78M14 9.5a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
  }))),
  packagecheck: t => e.createElement("svg", $V({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), UV || (UV = e.createElement("path", {
    d: "M20.5 7.278 12 12m0 0L3.5 7.278M12 12v9.5m2-.611-1.223.68c-.284.157-.425.236-.575.267a.998.998 0 0 1-.403 0c-.15-.031-.292-.11-.576-.268l-7.4-4.11c-.3-.167-.45-.25-.558-.369a1 1 0 0 1-.215-.364C3 16.573 3 16.401 3 16.06V7.942c0-.343 0-.514.05-.667a1 1 0 0 1 .215-.364c.109-.119.258-.202.558-.368l7.4-4.111c.284-.158.425-.237.576-.267a1 1 0 0 1 .402 0c.15.03.292.11.576.267l7.4 4.11c.3.167.45.25.558.369a1 1 0 0 1 .215.364c.05.153.05.324.05.667V12.5m-13.5-8 9 5M16 18l2 2 4-4"
  }))),
  pencil02: t => e.createElement("svg", WV({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), zV || (zV = e.createElement("path", {
    d: "m18 2 4 4M2 22l1.276-4.68c.084-.305.125-.458.19-.6.056-.127.126-.247.207-.36.092-.125.204-.237.428-.46L14.434 5.565c.198-.198.297-.297.412-.334a.5.5 0 0 1 .309 0c.114.037.213.136.41.334l2.87 2.868c.197.198.296.297.333.411.033.1.033.21 0 .31-.037.114-.136.213-.334.41L8.101 19.9c-.224.224-.336.336-.462.428a2.003 2.003 0 0 1-.358.208c-.143.064-.296.105-.6.189L2 22Z"
  }))),
  clock: t => e.createElement("svg", GV({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), QV || (QV = e.createElement("path", {
    d: "M12 6v6l4 2m6-2c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }))),
  octagon: t => e.createElement("svg", KV({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), YV || (YV = e.createElement("path", {
    d: "M7.391 2.469c.173-.173.26-.26.36-.322a1 1 0 0 1 .29-.12C8.156 2 8.278 2 8.523 2h6.954c.245 0 .367 0 .482.028a1 1 0 0 1 .29.12c.1.061.187.148.36.32l4.922 4.923c.173.173.26.26.322.36.054.09.095.188.12.29.027.115.027.237.027.482v6.954c0 .245 0 .367-.028.482a.998.998 0 0 1-.12.29c-.061.1-.148.187-.32.36l-4.923 4.922c-.173.173-.26.26-.36.322a.998.998 0 0 1-.29.12c-.115.027-.237.027-.482.027H8.523c-.245 0-.367 0-.482-.028a.998.998 0 0 1-.29-.12c-.1-.061-.187-.148-.36-.32L2.47 16.608c-.173-.173-.26-.26-.322-.36a1 1 0 0 1-.12-.29C2 15.844 2 15.722 2 15.477V8.523c0-.245 0-.367.028-.482a1 1 0 0 1 .12-.29c.061-.1.148-.187.32-.36L7.392 2.47Z"
  }))),
  sliders03: t => e.createElement("svg", JV({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), XV || (XV = e.createElement("path", {
    d: "M15.05 9H5.5a2.5 2.5 0 0 1 0-5h9.55m-6.1 16h9.55a2.5 2.5 0 0 0 0-5H8.95M3 17.5a3.5 3.5 0 1 0 7 0 3.5 3.5 0 0 0-7 0Zm18-11a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
  }))),
  tv01: t => e.createElement("svg", tR({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), eR || (eR = e.createElement("path", {
    d: "M18 17v2.4c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437C17.24 21 16.96 21 16.4 21H7.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C6 20.24 6 19.96 6 19.4V17m.8 0h10.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 14.72 22 13.88 22 12.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C19.72 3 18.88 3 17.2 3H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 5.28 2 6.12 2 7.8v4.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 17 5.12 17 6.8 17Z"
  }))),
  phone: t => e.createElement("svg", nR({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), rR || (rR = e.createElement("path", {
    d: "M8.38 8.853a14.603 14.603 0 0 0 2.847 4.01 14.603 14.603 0 0 0 4.01 2.847c.124.06.187.09.265.112.28.082.625.023.862-.147.067-.048.124-.105.239-.219.35-.35.524-.524.7-.639a2 2 0 0 1 2.18 0c.176.115.35.29.7.64l.195.194c.532.531.797.797.942 1.082a2 2 0 0 1 0 1.806c-.145.285-.41.551-.942 1.082l-.157.158c-.53.53-.795.794-1.155.997-.4.224-1.02.386-1.478.384-.413-.001-.695-.081-1.26-.241a19.038 19.038 0 0 1-8.283-4.874A19.039 19.039 0 0 1 3.17 7.761c-.16-.564-.24-.846-.241-1.26a3.377 3.377 0 0 1 .384-1.477c.202-.36.467-.625.997-1.155l.157-.158c.532-.53.798-.797 1.083-.941a2 2 0 0 1 1.805 0c.286.144.551.41 1.083.942l.195.194c.35.35.524.525.638.7a2 2 0 0 1 0 2.18c-.114.177-.289.352-.638.701-.115.114-.172.172-.22.238-.17.238-.228.582-.147.862.023.08.053.142.113.266Z"
  }))),
  layoutbottom: t => e.createElement("svg", oR({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), aR || (aR = e.createElement("path", {
    d: "M3 15h18M7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3Z"
  }))),
  filequestion02: t => e.createElement("svg", lR({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), iR || (iR = e.createElement("path", {
    d: "M20 9.5V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 2 16.88 2 15.2 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22H14m0-11H8m2 4H8m8-8H8m8.5 8.002a2.249 2.249 0 0 1 4.37.75c0 1.499-2.25 2.248-2.25 2.248m.03 3h.01"
  }))),
  speaker01: t => e.createElement("svg", cR({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), sR || (sR = e.createElement("path", {
    d: "M12 6h.01M8.8 22h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 19.72 20 18.88 20 17.2V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 2 16.88 2 15.2 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22Zm3.7-16a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm3.5 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
  }))),
  toggle01right: t => e.createElement("svg", hR({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), uR || (uR = e.createElement("path", {
    d: "M17 17H7A5 5 0 0 1 7 7h10m0 10a5 5 0 0 0 0-10m0 10a5 5 0 0 1 0-10"
  }))),
  markerpin01: t => e.createElement("svg", fR({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), mR || (mR = e.createElement("path", {
    d: "M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
  })), pR || (pR = e.createElement("path", {
    d: "M12 22c4-4 8-7.582 8-12a8 8 0 1 0-16 0c0 4.418 4 8 8 12Z"
  }))),
  linechartdown04: t => e.createElement("svg", vR({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), dR || (dR = e.createElement("path", {
    d: "m3 9 6.655 4.754a.5.5 0 0 0 .645-.053l3.4-3.402a.5.5 0 0 1 .645-.053L21 15M6 21h12a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3Z"
  }))),
  coinsstacked02: t => e.createElement("svg", bR({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), gR || (gR = e.createElement("path", {
    d: "M13 5c0 1.105-2.462 2-5.5 2S2 6.105 2 5m11 0c0-1.105-2.462-2-5.5-2S2 3.895 2 5m11 0v4.457c-1.222.367-2 .922-2 1.543M2 5v12c0 1.105 2.462 2 5.5 2 1.33 0 2.55-.172 3.5-.457V11M2 9c0 1.105 2.462 2 5.5 2 1.33 0 2.55-.172 3.5-.457M2 13c0 1.105 2.462 2 5.5 2 1.33 0 2.55-.172 3.5-.457M22 11c0 1.105-2.462 2-5.5 2s-5.5-.895-5.5-2m11 0c0-1.105-2.462-2-5.5-2s-5.5.895-5.5 2m11 0v8c0 1.105-2.462 2-5.5 2s-5.5-.895-5.5-2v-8m11 4c0 1.105-2.462 2-5.5 2s-5.5-.895-5.5-2"
  }))),
  headphones02: t => e.createElement("svg", yR({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), wR || (wR = e.createElement("path", {
    d: "M22 17v-4c0-5.523-4.477-10-10-10S2 7.477 2 13v4m5.5 4A2.5 2.5 0 0 1 5 18.5v-3a2.5 2.5 0 0 1 5 0v3A2.5 2.5 0 0 1 7.5 21Zm9 0a2.5 2.5 0 0 1-2.5-2.5v-3a2.5 2.5 0 0 1 5 0v3a2.5 2.5 0 0 1-2.5 2.5Z"
  }))),
  arrowblockright: t => e.createElement("svg", OR({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), xR || (xR = e.createElement("path", {
    d: "m21 12-7-7v4H3.8c-.28 0-.42 0-.527.055a.5.5 0 0 0-.219.218C3 9.38 3 9.52 3 9.8v4.4c0 .28 0 .42.054.527a.5.5 0 0 0 .219.218C3.38 15 3.52 15 3.8 15H14v4l7-7Z"
  }))),
  usersedit: t => e.createElement("svg", jR({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ER || (ER = e.createElement("path", {
    d: "M11 15H8c-1.864 0-2.796 0-3.53.305a4 4 0 0 0-2.166 2.164C2 18.204 2 19.136 2 21M15.5 3.29A4.001 4.001 0 0 1 18 7m-6 14.5 2.025-.405c.176-.035.265-.053.347-.085a.994.994 0 0 0 .207-.111c.073-.05.136-.114.264-.242L21.5 14a1.414 1.414 0 1 0-2-2l-6.658 6.657c-.127.128-.19.191-.241.264a1.001 1.001 0 0 0-.11.207c-.033.082-.05.17-.086.347L12 21.5ZM13.5 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
  }))),
  clockstopwatch: t => e.createElement("svg", PR({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), CR || (CR = e.createElement("path", {
    d: "M12 9.5v4l2.5 1.5M12 5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17Zm0 0V2m-2 0h4m6.329 3.592-1.5-1.5.75.75m-15.908.75 1.5-1.5-.75.75"
  }))),
  filelock02: t => e.createElement("svg", kR({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), MR || (MR = e.createElement("path", {
    d: "M20 10V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 2 16.88 2 15.2 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22h1.7M13 11H8m3 4H8m8-8H8m11.25 10v-1.75a1.75 1.75 0 1 0-3.5 0V17m-.15 4h3.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C21 20.24 21 19.96 21 19.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C20.24 17 19.96 17 19.4 17h-3.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C14 17.76 14 18.04 14 18.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C14.76 21 15.04 21 15.6 21Z"
  }))),
  mail05: t => e.createElement("svg", NR({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), SR || (SR = e.createElement("path", {
    d: "m13.744 2.634 7.528 4.893c.266.173.399.26.495.374a1 1 0 0 1 .189.348c.044.143.044.302.044.62V16.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C19.72 21 18.88 21 17.2 21H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.72 2 17.88 2 16.2V8.868c0-.317 0-.476.044-.62a1 1 0 0 1 .189-.347c.096-.115.229-.201.495-.374l7.528-4.893m3.488 0c-.631-.41-.947-.616-1.287-.696a2 2 0 0 0-.914 0c-.34.08-.656.285-1.287.696m3.488 0 6.192 4.024c.688.448 1.032.671 1.151.955a1 1 0 0 1 0 .774c-.12.284-.463.507-1.15.955l-6.193 4.024c-.631.41-.947.616-1.287.696-.3.07-.613.07-.914 0-.34-.08-.656-.285-1.287-.696L4.064 9.342c-.688-.448-1.032-.671-1.151-.955a1 1 0 0 1 0-.774c.12-.284.463-.507 1.15-.955l6.193-4.024M21.5 19l-6.643-6m-5.714 0L2.5 19"
  }))),
  calendarplus01: t => e.createElement("svg", VR({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), BR || (BR = e.createElement("path", {
    d: "M21 8H3m13-6v3M8 2v3m4 13v-6m-3 3h6m-7.2 7h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 19.72 21 18.88 21 17.2V8.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 4 17.88 4 16.2 4H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 6.28 3 7.12 3 8.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 22 6.12 22 7.8 22Z"
  }))),
  currencyrupeecircle: t => e.createElement("svg", AR({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), RR || (RR = e.createElement("path", {
    d: "M8.5 10h7m-7-3.5h7M14 18l-5.5-4.5H10c4.445 0 4.445-7 0-7M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }))),
  waves: t => e.createElement("svg", HR({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), TR || (TR = e.createElement("path", {
    d: "M2 6c.6.5 1.2 1 2.5 1C7 7 7 5 9.5 5c1.3 0 1.9.5 2.5 1 .6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1M2 18c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1 .6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1M2 12c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1 .6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"
  }))),
  passcodelock: t => e.createElement("svg", IR({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), LR || (LR = e.createElement("path", {
    d: "M22 11V8.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 5 19.92 5 18.8 5H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 6.52 2 7.08 2 8.2v3.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 15 4.08 15 5.2 15H11m1-5h.005M17 10h.005M7 10h.005m12.245 7v-1.75a1.75 1.75 0 1 0-3.5 0V17m-3.5-7a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Zm5 0a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Zm-10 0a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Zm8.35 11h3.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C21 20.24 21 19.96 21 19.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C20.24 17 19.96 17 19.4 17h-3.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C14 17.76 14 18.04 14 18.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C14.76 21 15.04 21 15.6 21Z"
  }))),
  piggybank01: t => e.createElement("svg", _R({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), FR || (FR = e.createElement("path", {
    d: "M5 13c0 1.648.665 3.142 1.74 4.226.104.105.156.157.187.207.03.048.046.09.06.144.013.057.013.122.013.253v2.37c0 .28 0 .42.054.527a.5.5 0 0 0 .219.218C7.38 21 7.52 21 7.8 21h1.9c.28 0 .42 0 .527-.055a.5.5 0 0 0 .218-.218c.055-.107.055-.247.055-.527v-.4c0-.28 0-.42.054-.527a.5.5 0 0 1 .219-.218C10.88 19 11.02 19 11.3 19h1.4c.28 0 .42 0 .527.055a.5.5 0 0 1 .218.218c.055.107.055.247.055.527v.4c0 .28 0 .42.054.527a.5.5 0 0 0 .219.218c.107.055.247.055.527.055h1.9c.28 0 .42 0 .527-.055a.5.5 0 0 0 .218-.218C17 20.62 17 20.48 17 20.2v-.976c0-.202 0-.303.029-.384a.462.462 0 0 1 .121-.19c.061-.06.166-.108.374-.205a6.025 6.025 0 0 0 2.427-2.055c.107-.155.16-.233.217-.28a.464.464 0 0 1 .17-.089c.07-.021.154-.021.32-.021h.542c.28 0 .42 0 .527-.055a.5.5 0 0 0 .218-.218C22 15.62 22 15.48 22 15.2v-3.414c0-.267 0-.4-.05-.503a.5.5 0 0 0-.233-.233c-.103-.05-.236-.05-.503-.05-.193 0-.29 0-.367-.026a.463.463 0 0 1-.203-.13c-.057-.06-.103-.16-.195-.358a6.013 6.013 0 0 0-1.19-1.712c-.104-.105-.155-.157-.186-.207a.462.462 0 0 1-.06-.144C19 8.366 19 8.3 19 8.17V7.06c0-.36 0-.54-.075-.66a.5.5 0 0 0-.288-.218c-.137-.039-.31.01-.657.11l-2.372.677a.498.498 0 0 1-.136.029C15.45 7 15.43 7 15.388 7h-.429m-9.96 6a6 6 0 0 1 3.205-5.31M5 13H4a2 2 0 0 1-1-3.732M15 6.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
  }))),
  stopsquare: t => e.createElement("svg", qR({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ZR || (ZR = e.createElement("path", {
    d: "M3 7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8Z"
  })), DR || (DR = e.createElement("path", {
    d: "M8 9.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C8.76 8 9.04 8 9.6 8h4.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C16 8.76 16 9.04 16 9.6v4.8c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437C15.24 16 14.96 16 14.4 16H9.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C8 15.24 8 14.96 8 14.4V9.6Z"
  }))),
  folderclosed: t => e.createElement("svg", $R({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), UR || (UR = e.createElement("path", {
    d: "m13 7-1.116-2.231c-.32-.642-.481-.963-.72-1.198a2 2 0 0 0-.748-.462C10.1 3 9.74 3 9.022 3H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 4.52 2 5.08 2 6.2V7m0 0h15.2c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C22 9.28 22 10.12 22 11.8v4.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C19.72 21 18.88 21 17.2 21H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.72 2 17.88 2 16.2V7Zm7.5 4.5 5 5M16 14a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
  }))),
  eye: t => e.createElement("svg", QR({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), zR || (zR = e.createElement("path", {
    d: "M2.42 12.713c-.136-.215-.204-.323-.242-.49a1.173 1.173 0 0 1 0-.446c.038-.167.106-.274.242-.49C3.546 9.505 6.895 5 12 5s8.455 4.505 9.58 6.287c.137.215.205.323.243.49.029.125.029.322 0 .446-.038.167-.106.274-.242.49C20.455 14.495 17.105 19 12 19c-5.106 0-8.455-4.505-9.58-6.287Z"
  })), WR || (WR = e.createElement("path", {
    d: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
  }))),
  building01: t => e.createElement("svg", YR({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), GR || (GR = e.createElement("path", {
    d: "M15 21v-5.4c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C14.24 14 13.96 14 13.4 14h-2.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C9 14.76 9 15.04 9 15.6V21m10 0V6.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C17.48 3 16.92 3 15.8 3H8.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C5 4.52 5 5.08 5 6.2V21m16 0H3M9.5 8h.01m4.99 0h.01M10 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm5 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
  }))),
  magicwand01: t => e.createElement("svg", XR({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), KR || (KR = e.createElement("path", {
    d: "m13 14-3-3m5.01-7.5V2m3.94 3.06L20.01 4m-1.06 9 1.06 1.06m-9-9L9.95 4m10.56 5h1.5M6.131 20.869l9.237-9.238c.396-.396.595-.594.669-.822a1 1 0 0 0 0-.618c-.074-.228-.272-.426-.668-.822l-.738-.738c-.396-.396-.594-.594-.822-.668a1 1 0 0 0-.618 0c-.229.074-.427.272-.823.668L3.131 17.87c-.396.396-.594.594-.668.822a1 1 0 0 0 0 .618c.074.228.272.426.668.822l.737.738c.397.396.595.594.823.668a1 1 0 0 0 .618 0c.228-.074.426-.272.822-.668Z"
  }))),
  mail04: t => e.createElement("svg", eA({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), JR || (JR = e.createElement("path", {
    d: "m13.744 2.633 7.528 4.894c.266.173.399.259.495.374a1 1 0 0 1 .189.348c.044.143.044.302.044.62v7.33c0 1.681 0 2.521-.327 3.163a3 3 0 0 1-1.311 1.31C19.72 21 18.88 21 17.2 21H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.72 2 17.88 2 16.2V8.868c0-.317 0-.476.044-.62a1 1 0 0 1 .189-.347c.096-.115.229-.201.495-.374l7.528-4.894m3.488 0c-.631-.41-.947-.615-1.287-.695a2 2 0 0 0-.914 0c-.34.08-.656.285-1.287.695m3.488 0 7.224 4.696c.344.224.516.335.576.477a.5.5 0 0 1 0 .388c-.06.141-.232.253-.576.477l-7.224 4.695c-.631.41-.947.616-1.287.696-.3.07-.613.07-.914 0-.34-.08-.656-.285-1.287-.696L3.032 8.671c-.344-.224-.516-.336-.576-.477a.5.5 0 0 1 0-.388c.06-.142.232-.253.576-.477l7.224-4.696"
  }))),
  filelock03: t => e.createElement("svg", rA({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), tA || (tA = e.createElement("path", {
    d: "M14 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 19.72 20 18.88 20 17.2V8m-6-6 6 6m-6-6v6h6m-6.25 6v-1.75a1.75 1.75 0 1 0-3.5 0V14m-.15 4h3.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437c.109-.214.109-.494.109-1.054v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C14.74 14 14.46 14 13.9 14h-3.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C8.5 14.76 8.5 15.04 8.5 15.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C9.26 18 9.54 18 10.1 18Z"
  }))),
  aligntoparrow02: t => e.createElement("svg", aA({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), nA || (nA = e.createElement("path", {
    d: "M10 18V6c0-.932 0-1.398-.152-1.765a2 2 0 0 0-1.083-1.083C8.398 3 7.932 3 7 3c-.932 0-1.398 0-1.765.152a2 2 0 0 0-1.083 1.083C4 4.602 4 5.068 4 6v12c0 .932 0 1.398.152 1.765a2 2 0 0 0 1.083 1.083C5.602 21 6.068 21 7 21c.932 0 1.398 0 1.765-.152a2 2 0 0 0 1.083-1.083C10 19.398 10 18.932 10 18ZM20 14V6c0-.932 0-1.398-.152-1.765a2 2 0 0 0-1.083-1.083C18.398 3 17.932 3 17 3c-.932 0-1.398 0-1.765.152a2 2 0 0 0-1.083 1.083C14 4.602 14 5.068 14 6v8c0 .932 0 1.398.152 1.765a2 2 0 0 0 1.083 1.083C15.602 17 16.068 17 17 17c.932 0 1.398 0 1.765-.152a2 2 0 0 0 1.083-1.083C20 15.398 20 14.932 20 14Z"
  }))),
  barchartsquareplus: t => e.createElement("svg", iA({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), oA || (oA = e.createElement("path", {
    d: "M12 3h4.2c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V12m5 1v4m8-6v6M12 7v10M5 8V2M2 5h6"
  }))),
  linechartdown05: t => e.createElement("svg", sA({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), lA || (lA = e.createElement("path", {
    d: "m6 10 3.434 3.434c.198.198.297.297.411.334.1.033.21.033.31 0 .114-.037.213-.136.41-.334l2.87-2.868c.197-.198.296-.297.41-.334a.499.499 0 0 1 .31 0c.114.037.213.136.41.334L18 14m4-2c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }))),
  coinsstacked03: t => e.createElement("svg", uA({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), cA || (cA = e.createElement("path", {
    d: "M13 5c0 1.105-2.462 2-5.5 2S2 6.105 2 5m11 0c0-1.105-2.462-2-5.5-2S2 3.895 2 5m11 0v1.5M2 5v12c0 1.105 2.462 2 5.5 2m0-8c-.169 0-.335-.003-.5-.008C4.197 10.9 2 10.043 2 9m5.5 6C4.462 15 2 14.105 2 13m20-1.5c0 1.105-2.462 2-5.5 2s-5.5-.895-5.5-2m11 0c0-1.105-2.462-2-5.5-2s-5.5.895-5.5 2m11 0V19c0 1.105-2.462 2-5.5 2s-5.5-.895-5.5-2v-7.5m11 3.75c0 1.105-2.462 2-5.5 2s-5.5-.895-5.5-2"
  }))),
  imageuserx: t => e.createElement("svg", mA({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), hA || (hA = e.createElement("path", {
    d: "m16.5 2.5 5 5m0-5-5 5M22 12v5.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C19.72 22 18.88 22 17.2 22H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 19.72 2 18.88 2 17.2V6.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C4.28 2 5.12 2 6.8 2H12M2.146 19.926A4.002 4.002 0 0 1 6 17h7c.93 0 1.394 0 1.78.077a4 4 0 0 1 3.143 3.143c.077.386.077.85.077 1.78M14 9.5a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
  }))),
  flashoff: t => e.createElement("svg", fA({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), pA || (pA = e.createElement("path", {
    d: "m8 8-3.907 4.688c-.348.418-.523.628-.525.804a.5.5 0 0 0 .185.397c.138.111.41.111.955.111H12l-1 8 5-6m-.35-6h3.642c.545 0 .817 0 .955.111a.5.5 0 0 1 .185.396c-.002.177-.177.387-.525.805L18.55 12.94m-7.977-8.027L13 2l-.6 4.798M21 21 3 3"
  }))),
  filequestion03: t => e.createElement("svg", vA({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), dA || (dA = e.createElement("path", {
    d: "M14 2.27V6.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437c.214.11.494.11 1.054.11h4.13m-9.88 4.001a2.248 2.248 0 0 1 4.37.75c0 1.499-2.25 2.248-2.25 2.248m.03 3h.01M14 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 19.72 20 18.88 20 17.2V8l-6-6Z"
  }))),
  webcam01: t => e.createElement("svg", bA({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), gA || (gA = e.createElement("path", {
    d: "M12 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0 0v4m0 0H7m5 0h5m-2-12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
  }))),
  codepen: t => e.createElement("svg", yA({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), wA || (wA = e.createElement("path", {
    d: "M12 9 4.064 14.16c-.688.447-1.032.67-1.151.954a1 1 0 0 0 0 .774M12 9l7.936 5.159c.688.447 1.032.67 1.151.954a1 1 0 0 1 0 .774M12 9V2.5M12 15 4.064 9.842c-.688-.447-1.032-.671-1.151-.954a1 1 0 0 1 0-.775M12 15l7.936-5.158c.688-.447 1.032-.671 1.151-.954a1 1 0 0 0 0-.775M12 15v6.5m9.272-5.527-8.4 5.46c-.316.206-.473.308-.643.348a1 1 0 0 1-.457 0c-.17-.04-.328-.142-.644-.348l-8.4-5.46c-.266-.173-.399-.259-.495-.374a1 1 0 0 1-.189-.348C2 15.108 2 14.95 2 14.631V9.369c0-.317 0-.475.044-.619a1 1 0 0 1 .189-.347c.096-.116.229-.202.495-.375l8.4-5.46c.316-.205.473-.308.643-.348a1 1 0 0 1 .457 0c.17.04.328.143.644.348l8.4 5.46c.266.173.399.26.495.375a1 1 0 0 1 .189.347c.044.144.044.302.044.62v5.263c0 .317 0 .476-.044.62a1 1 0 0 1-.189.347c-.096.115-.229.201-.495.374Z"
  }))),
  sliders02: t => e.createElement("svg", OA({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), xA || (xA = e.createElement("path", {
    d: "M5 21v-6m0 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0-8V3m7 18v-6m0-8V3m0 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm7 14v-4m0 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0-8V3"
  }))),
  lock04: t => e.createElement("svg", jA({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), EA || (EA = e.createElement("path", {
    d: "M7.101 10H7V8a5 5 0 0 1 10 0v2h-.101M12 14v2m7-1a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
  }))),
  chevronupdouble: t => e.createElement("svg", PA({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), CA || (CA = e.createElement("path", {
    d: "m17 18-5-5-5 5m10-7-5-5-5 5"
  }))),
  packageplus: t => e.createElement("svg", kA({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), MA || (MA = e.createElement("path", {
    d: "M20.5 7.278 12 12m0 0L3.5 7.278M12 12v9.5m2-.611-1.223.68c-.284.157-.425.236-.575.267a.998.998 0 0 1-.403 0c-.15-.031-.292-.11-.576-.268l-7.4-4.11c-.3-.167-.45-.25-.558-.369a1 1 0 0 1-.215-.364C3 16.573 3 16.401 3 16.06V7.942c0-.343 0-.514.05-.667a1 1 0 0 1 .215-.364c.109-.119.258-.202.558-.368l7.4-4.111c.284-.158.425-.237.576-.267a1 1 0 0 1 .402 0c.15.03.292.11.576.267l7.4 4.11c.3.167.45.25.558.369a1 1 0 0 1 .215.364c.05.153.05.324.05.667V12.5m-13.5-8 9 5M19 21v-6m-3 3h6"
  }))),
  messagealertsquare: t => e.createElement("svg", NA({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), SA || (SA = e.createElement("path", {
    d: "M12 10.5V7m0 7h.01M7 18v2.335c0 .533 0 .8.11.937a.5.5 0 0 0 .39.188c.176 0 .384-.167.8-.5l2.385-1.908c.487-.39.731-.585 1.002-.724.241-.122.497-.212.762-.267.299-.061.61-.061 1.235-.061H16.2c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 15.72 21 14.88 21 13.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8V14c0 .93 0 1.395.102 1.777a3 3 0 0 0 2.122 2.12C5.605 18 6.07 18 7 18Z"
  }))),
  hexagon01: t => e.createElement("svg", VA({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), BA || (BA = e.createElement("path", {
    d: "M11.223 2.432c.284-.158.425-.237.575-.267a1 1 0 0 1 .403 0c.15.03.292.11.576.267l7.4 4.11c.3.167.45.25.558.369a1 1 0 0 1 .215.364c.05.153.05.324.05.667v8.117c0 .342 0 .514-.05.666a.999.999 0 0 1-.215.364c-.109.119-.258.202-.558.368l-7.4 4.111c-.284.158-.425.237-.575.268a.998.998 0 0 1-.403 0c-.15-.031-.292-.11-.576-.268l-7.4-4.11c-.3-.167-.45-.25-.558-.369a1 1 0 0 1-.215-.364C3 16.573 3 16.401 3 16.06V7.942c0-.343 0-.514.05-.667a1 1 0 0 1 .215-.364c.109-.119.258-.202.558-.368l7.4-4.111Z"
  }))),
  bookopen02: t => e.createElement("svg", AA({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), RA || (RA = e.createElement("path", {
    d: "M12 20H5.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C2 18.48 2 17.92 2 16.8V7.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C3.52 4 4.08 4 5.2 4h.4c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C12 7.04 12 8.16 12 10.4m0 9.6v-9.6m0 9.6h6.8c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C22 18.48 22 17.92 22 16.8V7.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 4 19.92 4 18.8 4h-.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C12 7.04 12 8.16 12 10.4"
  }))),
  zap: t => e.createElement("svg", HA({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), TA || (TA = e.createElement("path", {
    d: "M13 2 4.093 12.688c-.348.418-.523.628-.526.804a.5.5 0 0 0 .186.397c.138.111.41.111.955.111H12l-1 8 8.906-10.688c.35-.418.524-.628.526-.804a.5.5 0 0 0-.185-.397c-.138-.111-.41-.111-.955-.111H12l1-8Z"
  }))),
  flexalignbottom: t => e.createElement("svg", IA({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), LA || (LA = e.createElement("path", {
    d: "M17.5 17.6h-11M7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3Z"
  }))),
  globe011: t => e.createElement("svg", _A({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), FA || (FA = e.createElement("path", {
    d: "M18.632 2.368c4.49 4.491 4.49 11.773 0 16.264-4.301 4.3-11.161 4.483-15.679.546-.197-.172-.295-.258-.34-.375a.521.521 0 0 1-.01-.322c.036-.12.134-.218.33-.415L5.15 15.85M18 10.5a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0Z"
  }))),
  arrowcirclebrokenupleft: t => e.createElement("svg", DA({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ZA || (ZA = e.createElement("path", {
    d: "M14.59 21.66a9.996 9.996 0 0 1-9.661-2.589c-3.905-3.905-3.905-10.237 0-14.142 3.905-3.905 10.237-3.905 14.142 0a9.996 9.996 0 0 1 2.59 9.66M9 15V9m0 0h6M9 9 19 19"
  }))),
  hash01: t => e.createElement("svg", UA({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), qA || (qA = e.createElement("path", {
    d: "M4 8h16M4 16h16M8 3v18m8-18v18"
  }))),
  tool01: t => e.createElement("svg", zA({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), $A || ($A = e.createElement("path", {
    d: "M15.632 7.631c-.396-.396-.594-.594-.669-.822a1 1 0 0 1 0-.618c.075-.228.273-.426.669-.822L18.47 2.53a6 6 0 0 0-8.3 6.895c.12.49.18.734.169.888a.849.849 0 0 1-.11.392c-.071.138-.208.274-.481.547L3.5 17.5a2.121 2.121 0 1 0 3 3l6.248-6.248c.273-.273.41-.41.547-.48a.85.85 0 0 1 .392-.11c.154-.011.399.049.888.168a6 6 0 0 0 6.895-8.3L18.632 8.37c-.396.396-.594.594-.823.668a1 1 0 0 1-.618 0c-.228-.074-.426-.272-.822-.668l-.737-.738Z"
  }))),
  barchart02: t => e.createElement("svg", QA({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), WA || (WA = e.createElement("path", {
    d: "M18 20V4M6 20v-4m6 4V10"
  }))),
  moonstar: t => e.createElement("svg", YA({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), GA || (GA = e.createElement("path", {
    d: "m18 2 .618 1.236c.265.53.398.796.575 1.026.158.204.34.387.545.545.23.177.495.31 1.026.575L22 6l-1.236.618c-.53.265-.796.398-1.026.575-.204.158-.387.34-.545.545-.177.23-.31.495-.575 1.026L18 10l-.618-1.236c-.265-.53-.398-.796-.575-1.026a2.996 2.996 0 0 0-.545-.545c-.23-.177-.495-.31-1.026-.575L14 6l1.236-.618c.53-.265.796-.398 1.026-.575.204-.158.387-.34.545-.545.177-.23.31-.495.575-1.026L18 2ZM21 13.39A7.617 7.617 0 1 1 10.611 3C5.78 3.458 2 7.527 2 12.479A9.521 9.521 0 0 0 11.521 22c4.952 0 9.02-3.78 9.479-8.61Z"
  }))),
  cloudraining01: t => e.createElement("svg", XA({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), KA || (KA = e.createElement("path", {
    d: "M20 15.242a4.5 4.5 0 0 0-2.08-8.223 6.002 6.002 0 0 0-11.84 0A4.5 4.5 0 0 0 4 15.242M8 18v2m0-8v2m8 4v2m0-8v2m-4 6v2m0-8v2"
  }))),
  arrowcirclebrokenright: t => e.createElement("svg", eT({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), JA || (JA = e.createElement("path", {
    d: "M3.338 7A9.996 9.996 0 0 1 12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10a9.996 9.996 0 0 1-8.662-5M12 16l4-4m0 0-4-4m4 4H2"
  }))),
  packagesearch: t => e.createElement("svg", rT({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), tT || (tT = e.createElement("path", {
    d: "M20.5 7.278 12 12m0 0L3.5 7.278M12 12v9.5m9-9.5V7.942c0-.343 0-.514-.05-.667a1 1 0 0 0-.215-.364c-.109-.119-.258-.202-.558-.368l-7.4-4.111c-.284-.158-.425-.237-.575-.267a1 1 0 0 0-.403 0c-.15.03-.292.11-.576.267l-7.4 4.11c-.3.167-.45.25-.558.369a1 1 0 0 0-.215.364C3 7.428 3 7.599 3 7.942v8.117c0 .342 0 .514.05.666a1 1 0 0 0 .215.364c.109.119.258.202.558.368l7.4 4.111c.284.158.425.237.576.268.133.027.27.027.402 0 .15-.031.292-.11.576-.268l.223-.123M7.5 4.5l9 5m5.5 12-1-1m1-2.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
  }))),
  messagecircle01: t => e.createElement("svg", aT({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), nT || (nT = e.createElement("path", {
    d: "M21 11.5a8.5 8.5 0 0 1-11.555 7.934c-.174-.066-.26-.1-.33-.116a.901.901 0 0 0-.186-.024 2.314 2.314 0 0 0-.303.021l-5.12.53c-.49.05-.733.075-.877-.013a.5.5 0 0 1-.234-.35c-.026-.166.09-.382.324-.814l1.636-3.027c.134-.25.202-.374.232-.494a.899.899 0 0 0 .028-.326c-.01-.123-.064-.283-.172-.604A8.5 8.5 0 1 1 21 11.5Z"
  }))),
  phonepause: t => e.createElement("svg", iT({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), oT || (oT = e.createElement("path", {
    d: "M20 10V3m-5 7V3m-4.773 10.863a14.604 14.604 0 0 1-2.847-4.01 1.698 1.698 0 0 1-.113-.266 1.046 1.046 0 0 1 .147-.862c.048-.067.105-.124.22-.238.35-.35.524-.524.638-.7a2 2 0 0 0 0-2.18c-.114-.176-.289-.351-.638-.7l-.195-.196c-.532-.531-.797-.797-1.083-.941a2 2 0 0 0-1.805 0c-.285.144-.551.41-1.083.941l-.157.158c-.53.53-.795.794-.997 1.154-.224.4-.386 1.02-.384 1.479 0 .413.081.695.241 1.26a19.038 19.038 0 0 0 4.874 8.283 19.039 19.039 0 0 0 8.283 4.873c.565.16.847.24 1.26.242a3.377 3.377 0 0 0 1.478-.384c.36-.203.625-.468 1.155-.997l.157-.158c.532-.531.797-.797.942-1.082a2 2 0 0 0 0-1.806c-.145-.285-.41-.55-.942-1.082l-.195-.195c-.35-.35-.524-.524-.7-.639a2 2 0 0 0-2.18 0c-.176.114-.35.29-.7.639-.115.114-.172.171-.239.22-.237.17-.581.228-.862.146a1.695 1.695 0 0 1-.266-.113 14.605 14.605 0 0 1-4.01-2.846Z"
  }))),
  image01: t => e.createElement("svg", sT({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), lT || (lT = e.createElement("path", {
    d: "M16.2 21H6.931c-.605 0-.908 0-1.049-.12a.5.5 0 0 1-.173-.42c.014-.183.228-.397.657-.826l8.503-8.503c.396-.396.594-.594.822-.668a1 1 0 0 1 .618 0c.228.074.426.272.822.668L21 15v1.2M16.2 21c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2M16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4M10.5 8.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
  }))),
  code01: t => e.createElement("svg", uT({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), cT || (cT = e.createElement("path", {
    d: "m16 18 6-6-6-6M8 6l-6 6 6 6"
  }))),
  dotpoints01: t => e.createElement("svg", mT({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), hT || (hT = e.createElement("path", {
    d: "M21 12H9m12-6H9m12 12H9m-4-6a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm0-6a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm0 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
  }))),
  edit03: t => e.createElement("svg", fT({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), pT || (pT = e.createElement("path", {
    d: "M12 20h9M3 20h1.675c.489 0 .733 0 .963-.055.205-.05.4-.13.579-.24.201-.123.374-.296.72-.642L19.5 6.5a2.121 2.121 0 1 0-3-3L3.937 16.063c-.346.346-.519.519-.642.72a2 2 0 0 0-.24.578c-.055.23-.055.475-.055.965V20Z"
  }))),
  camera03: t => e.createElement("svg", gT({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), dT || (dT = e.createElement("path", {
    d: "M2 7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C4.28 3 5.12 3 6.8 3h10.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C22 5.28 22 6.12 22 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C19.72 21 18.88 21 17.2 21H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.72 2 17.88 2 16.2V7.8Z"
  })), vT || (vT = e.createElement("path", {
    d: "M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
  }))),
  barchartsquare03: t => e.createElement("svg", wT({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), bT || (bT = e.createElement("path", {
    d: "M8 7v10m4-6v6m4-2v2m-8.2 4h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Z"
  }))),
  arrowsquaredown: t => e.createElement("svg", xT({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), yT || (yT = e.createElement("path", {
    d: "m8 12 4 4m0 0 4-4m-4 4V8M7.8 21h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Z"
  }))),
  barchartsquare01: t => e.createElement("svg", ET({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), OT || (OT = e.createElement("path", {
    d: "M8 13v4m8-6v6M12 7v10m-4.2 4h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Z"
  }))),
  camera01: t => e.createElement("svg", PT({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), jT || (jT = e.createElement("path", {
    d: "M2 8.377c0-.35 0-.525.015-.673a3 3 0 0 1 2.69-2.69C4.851 5 5.035 5 5.404 5c.143 0 .214 0 .274-.004a2 2 0 0 0 1.735-1.25c.023-.056.044-.12.086-.246.042-.127.063-.19.086-.246a2 2 0 0 1 1.735-1.25C9.38 2 9.448 2 9.58 2h4.838c.133 0 .2 0 .26.004a2 2 0 0 1 1.735 1.25c.023.056.044.12.086.246.042.127.063.19.086.246a2 2 0 0 0 1.735 1.25c.06.004.131.004.273.004.37 0 .554 0 .702.015a3 3 0 0 1 2.69 2.69c.014.147.014.322.014.672V16.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C19.72 21 18.88 21 17.2 21H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.72 2 17.88 2 16.2V8.377Z"
  })), CT || (CT = e.createElement("path", {
    d: "M12 16.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
  }))),
  edit01: t => e.createElement("svg", kT({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), MT || (MT = e.createElement("path", {
    d: "M2.876 18.116c.046-.414.069-.62.132-.814a2 2 0 0 1 .233-.485c.111-.17.259-.317.553-.61L17 3a2.828 2.828 0 1 1 4 4L7.794 20.206c-.294.294-.442.442-.611.553a2 2 0 0 1-.485.233c-.193.063-.4.086-.814.132L2.5 21.5l.376-3.384Z"
  }))),
  underlinesquare: t => e.createElement("svg", NT({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ST || (ST = e.createElement("path", {
    d: "M15.5 7v3.5a3.5 3.5 0 1 1-7 0V7M8 17h8m-8.2 4h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Z"
  }))),
  sale02: t => e.createElement("svg", VT({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), BT || (BT = e.createElement("path", {
    d: "M9 9h.01M15 15h.01M16 8l-8 8M7.334 3.819a3.832 3.832 0 0 0 2.18-.904 3.832 3.832 0 0 1 4.972 0c.613.523 1.376.84 2.18.904a3.832 3.832 0 0 1 3.515 3.515c.064.804.38 1.567.904 2.18a3.832 3.832 0 0 1 0 4.972 3.832 3.832 0 0 0-.904 2.18 3.832 3.832 0 0 1-3.515 3.515 3.832 3.832 0 0 0-2.18.904 3.832 3.832 0 0 1-4.972 0 3.832 3.832 0 0 0-2.18-.904 3.832 3.832 0 0 1-3.515-3.515 3.832 3.832 0 0 0-.904-2.18 3.832 3.832 0 0 1 0-4.972c.523-.613.84-1.376.904-2.18a3.832 3.832 0 0 1 3.515-3.515ZM9.5 9a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm6 6a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
  }))),
  arrowsleft: t => e.createElement("svg", AT({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), RT || (RT = e.createElement("path", {
    d: "M20 17H4m0 0 4 4m-4-4 4-4m12-6H9m0 0 4 4M9 7l4-4"
  }))),
  pentoolminus: t => e.createElement("svg", HT({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), TT || (TT = e.createElement("path", {
    d: "M2 5h6m7 2L8.834 8.76c-.304.088-.457.131-.583.213a1 1 0 0 0-.282.276c-.084.125-.131.276-.224.58L4 22m0 0 12.17-3.745c.304-.093.455-.14.58-.224a1 1 0 0 0 .276-.282c.082-.126.125-.279.212-.584L19 11M4 22l6.586-6.586m11.283-7.546L18.13 4.131c-.396-.396-.594-.594-.822-.668a1 1 0 0 0-.618 0c-.228.074-.426.272-.822.668l-.738.737c-.396.396-.594.595-.668.823a1 1 0 0 0 0 .618c.074.228.272.426.668.822l3.738 3.737c.396.396.594.595.822.669a1 1 0 0 0 .618 0c.228-.075.426-.273.822-.669l.738-.737c.396-.396.594-.594.668-.822a1 1 0 0 0 0-.618c-.074-.229-.272-.427-.668-.823ZM12 12a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z"
  }))),
  image03: t => e.createElement("svg", IT({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), LT || (LT = e.createElement("path", {
    d: "m4.272 20.728 6.597-6.597c.396-.396.594-.594.822-.668a1 1 0 0 1 .618 0c.228.074.426.272.822.668l6.553 6.553M14 15l2.869-2.869c.396-.396.594-.594.822-.668a1 1 0 0 1 .618 0c.228.074.426.272.822.668L22 15M10 9a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM6.8 21h10.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 18.72 22 17.88 22 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C19.72 3 18.88 3 17.2 3H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 5.28 2 6.12 2 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 21 5.12 21 6.8 21Z"
  }))),
  arrowup: t => e.createElement("svg", _T({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), FT || (FT = e.createElement("path", {
    d: "M12 19V5m0 0-7 7m7-7 7 7"
  }))),
  lockunlocked02: t => e.createElement("svg", DT({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ZT || (ZT = e.createElement("path", {
    d: "M7 11V8a5 5 0 0 1 9.9-1M7.8 21h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2v-.4c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 11 17.88 11 16.2 11H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 13.28 3 14.12 3 15.8v.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Z"
  }))),
  award04: t => e.createElement("svg", UT({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), qT || (qT = e.createElement("path", {
    d: "M8.876 13.095 4.701 7.877c-.26-.325-.39-.488-.482-.669a2 2 0 0 1-.178-.507C4 6.5 4 6.294 4 5.878V5.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C5.52 2 6.08 2 7.2 2h9.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C20 3.52 20 4.08 20 5.2v.678c0 .416 0 .624-.04.823a2.002 2.002 0 0 1-.179.507c-.092.181-.222.344-.482.669l-4.175 5.218M5 3l7 9 7-9m-3.464 10.464a5 5 0 1 1-7.071 7.071 5 5 0 0 1 7.07-7.07Z"
  }))),
  gamingpad02: t => e.createElement("svg", zT({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), $T || ($T = e.createElement("path", {
    d: "M6 12h4m-2-2v4m7-1h.01M18 11h.01M5.2 18h13.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C22 16.48 22 15.92 22 14.8V9.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 6 19.92 6 18.8 6H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 7.52 2 8.08 2 9.2v5.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 18 4.08 18 5.2 18Z"
  }))),
  beaker02: t => e.createElement("svg", QT({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), WT || (WT = e.createElement("path", {
    d: "M9 6v4.501c0 .551 0 .827-.069 1.082a2 2 0 0 1-.295.631c-.153.216-.364.393-.787.745L4.15 16.041c-.423.352-.634.529-.787.745a2 2 0 0 0-.295.631C3 17.672 3 17.947 3 18.5v.301c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C4.52 22 5.08 22 6.2 22h11.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C21 20.48 21 19.92 21 18.8v-.301c0-.551 0-.827-.069-1.082-.06-.226-.16-.44-.295-.631-.153-.216-.364-.393-.787-.745l-3.698-3.082c-.423-.352-.634-.528-.787-.745a1.999 1.999 0 0 1-.295-.631C15 11.328 15 11.053 15 10.5V6M8.3 6h7.4c.28 0 .42 0 .527-.054a.5.5 0 0 0 .218-.219c.055-.107.055-.247.055-.527V2.8c0-.28 0-.42-.055-.527a.5.5 0 0 0-.218-.219C16.12 2 15.98 2 15.7 2H8.3c-.28 0-.42 0-.527.054a.5.5 0 0 0-.218.219C7.5 2.38 7.5 2.52 7.5 2.8v2.4c0 .28 0 .42.054.527a.5.5 0 0 0 .219.218C7.88 6 8.02 6 8.3 6ZM5.5 17h13c.465 0 .697 0 .89.038a2 2 0 0 1 1.572 1.572c.038.193.038.425.038.89s0 .697-.038.89a2 2 0 0 1-1.572 1.572c-.193.038-.425.038-.89.038h-13c-.465 0-.697 0-.89-.038a2 2 0 0 1-1.572-1.572C3 20.197 3 19.965 3 19.5s0-.697.038-.89a2 2 0 0 1 1.572-1.572C4.803 17 5.035 17 5.5 17Z"
  }))),
  home04: t => e.createElement("svg", KT({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), GT || (GT = e.createElement("path", {
    d: "M12 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
  })), YT || (YT = e.createElement("path", {
    d: "M3 10.565c0-.574 0-.861.074-1.126a2 2 0 0 1 .318-.65c.163-.22.39-.397.843-.75l6.783-5.275c.351-.273.527-.41.72-.462a1 1 0 0 1 .523 0c.194.052.37.189.721.462l6.783 5.275c.453.353.68.53.843.75.145.195.252.416.318.65.074.265.074.552.074 1.126V17.8c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C19.48 21 18.92 21 17.8 21H6.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C3 19.48 3 18.92 3 17.8v-7.235Z"
  }))),
  microscope: t => e.createElement("svg", JT({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), XT || (XT = e.createElement("path", {
    d: "M3 22h9M11 6.252a8 8 0 0 1 5 15.166M5.5 13h4c.465 0 .697 0 .89.038a2 2 0 0 1 1.572 1.572c.038.193.038.425.038.89s0 .697-.038.89a2 2 0 0 1-1.572 1.572C10.197 18 9.965 18 9.5 18h-4c-.465 0-.697 0-.89-.038a2 2 0 0 1-1.572-1.572C3 16.197 3 15.965 3 15.5s0-.697.038-.89a2 2 0 0 1 1.572-1.572C4.803 13 5.035 13 5.5 13ZM4 5.5V13h7V5.5a3.5 3.5 0 1 0-7 0Z"
  }))),
  cloudraining03: t => e.createElement("svg", tH({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), eH || (eH = e.createElement("path", {
    d: "M20 15.242a4.5 4.5 0 0 0-2.08-8.223 6.002 6.002 0 0 0-11.84 0A4.5 4.5 0 0 0 4 15.242M12.25 15l-2.8 7m7.6-9-2.8 7m-5.2-7-2.8 7"
  }))),
  cloudblank01: t => e.createElement("svg", nH({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), rH || (rH = e.createElement("path", {
    d: "M6.5 19a4.5 4.5 0 0 1-.42-8.98 6.002 6.002 0 0 1 11.84 0A4.5 4.5 0 0 1 17.5 19h-11Z"
  }))),
  glasses02: t => e.createElement("svg", oH({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), aH || (aH = e.createElement("path", {
    d: "M10 14.535a4.008 4.008 0 0 1 4 0M2 15l.701-7.015c.027-.266.04-.399.06-.513A3 3 0 0 1 5.485 5.01C5.599 5 5.733 5 6 5m16 10-.701-7.015c-.027-.266-.04-.399-.06-.513a3 3 0 0 0-2.723-2.463C18.402 5 18.268 5 18 5m-9.172 7.172a4 4 0 1 1-5.656 5.656 4 4 0 0 1 5.656-5.656Zm12 0a4 4 0 1 1-5.656 5.656 4 4 0 0 1 5.656-5.656Z"
  }))),
  pencil01: t => e.createElement("svg", lH({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), iH || (iH = e.createElement("path", {
    d: "m2.5 21.5 5.55-2.134c.354-.137.532-.205.698-.294.147-.08.288-.171.42-.274.149-.115.283-.25.552-.518L21 7a2.828 2.828 0 1 0-4-4L5.72 14.28c-.269.268-.403.403-.519.552a2.997 2.997 0 0 0-.273.42c-.089.166-.157.344-.294.699L2.5 21.5Zm0 0 2.058-5.351c.147-.383.221-.575.347-.662a.5.5 0 0 1 .38-.08c.15.028.295.173.585.463l2.26 2.26c.29.29.435.434.464.585a.5.5 0 0 1-.08.38c-.089.126-.28.2-.663.347L2.5 21.5Z"
  }))),
  tv02: t => e.createElement("svg", cH({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), sH || (sH = e.createElement("path", {
    d: "m17 21-5-4-5 4m-.2-4h10.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 14.72 22 13.88 22 12.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C19.72 3 18.88 3 17.2 3H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 5.28 2 6.12 2 7.8v4.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 17 5.12 17 6.8 17Z"
  }))),
  textinput: t => e.createElement("svg", hH({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), uH || (uH = e.createElement("path", {
    d: "M13 7H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 8.52 2 9.08 2 10.2v3.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 17 4.08 17 5.2 17H13m4-10h1.8c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C22 8.52 22 9.08 22 10.2v3.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C20.48 17 19.92 17 18.8 17H17m0 4V3m2.5 0h-5m5 18h-5"
  }))),
  activity: t => e.createElement("svg", pH({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), mH || (mH = e.createElement("path", {
    d: "M22 12h-4l-3 9L9 3l-3 9H2"
  }))),
  pencilline: t => e.createElement("svg", dH({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), fH || (fH = e.createElement("path", {
    d: "M21 21h-8m-10.5.5 5.55-2.134c.354-.137.532-.205.698-.294.147-.08.288-.171.42-.274.149-.115.283-.25.552-.518L21 7a2.828 2.828 0 1 0-4-4L5.72 14.28c-.269.268-.403.403-.519.552a2.997 2.997 0 0 0-.273.42c-.089.166-.157.344-.294.699L2.5 21.5Zm0 0 2.058-5.351c.147-.383.221-.575.347-.662a.5.5 0 0 1 .38-.08c.15.028.295.173.585.463l2.26 2.26c.29.29.435.434.464.585a.5.5 0 0 1-.08.38c-.089.126-.28.2-.663.347L2.5 21.5Z"
  }))),
  messagedotssquare: t => e.createElement("svg", gH({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), vH || (vH = e.createElement("path", {
    d: "M7.5 10.5h.01m4.49 0h.01m4.49 0h.01M7 18v2.335c0 .533 0 .8.11.937a.5.5 0 0 0 .39.188c.176 0 .384-.167.8-.5l2.385-1.908c.487-.39.731-.585 1.002-.724.241-.122.497-.212.762-.267.299-.061.61-.061 1.235-.061H16.2c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 15.72 21 14.88 21 13.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8V14c0 .93 0 1.395.102 1.777a3 3 0 0 0 2.122 2.12C5.605 18 6.07 18 7 18Zm1-7.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm4.5 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm4.5 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
  }))),
  speaker02: t => e.createElement("svg", wH({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), bH || (bH = e.createElement("path", {
    d: "M12 12h.01M18 6h.01M6 6h.01M18 18h.01M6 18h.01m.79 4h10.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 19.72 22 18.88 22 17.2V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C19.72 2 18.88 2 17.2 2H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 4.28 2 5.12 2 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 22 5.12 22 6.8 22Zm5.7-10a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm4.5 0a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z"
  }))),
  filequestion01: t => e.createElement("svg", xH({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), yH || (yH = e.createElement("path", {
    d: "M20 9.5V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 2 16.88 2 15.2 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22H14m2.5-6.998a2.249 2.249 0 0 1 4.37.75c0 1.499-2.25 2.248-2.25 2.248m.03 3h.01"
  }))),
  markerpin02: t => e.createElement("svg", jH({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), OH || (OH = e.createElement("path", {
    d: "M12 12.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
  })), EH || (EH = e.createElement("path", {
    d: "M12 22c2-4 8-6.582 8-12a8 8 0 1 0-16 0c0 5.418 6 8 8 12Z"
  }))),
  zapsquare: t => e.createElement("svg", MH({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), CH || (CH = e.createElement("path", {
    d: "M3 7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8Z"
  })), PH || (PH = e.createElement("path", {
    d: "m12 6-4.566 6.227c-.301.41-.452.616-.447.787a.5.5 0 0 0 .193.38c.135.106.39.106.899.106H12V18l4.566-6.227c.301-.41.452-.616.447-.787a.5.5 0 0 0-.193-.38c-.135-.106-.39-.106-.899-.106H12V6Z"
  }))),
  arrownarrowright: t => e.createElement("svg", SH({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), kH || (kH = e.createElement("path", {
    d: "M4 12h16m0 0-6-6m6 6-6 6"
  }))),
  coinsstacked01: t => e.createElement("svg", BH({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), NH || (NH = e.createElement("path", {
    d: "M12 17a5 5 0 1 0 10 0 5 5 0 0 0-10 0Zm0 0c0-1.126.372-2.165 1-3V5m-1 12c0 .825.2 1.604.554 2.29-.842.712-2.788 1.21-5.054 1.21-3.038 0-5.5-.895-5.5-2V5m11 0c0 1.105-2.462 2-5.5 2S2 6.105 2 5m11 0c0-1.105-2.462-2-5.5-2S2 3.895 2 5m0 9c0 1.105 2.462 2 5.5 2 2.189 0 4.08-.465 4.965-1.138M13 9.5c0 1.105-2.462 2-5.5 2S2 10.605 2 9.5"
  }))),
  headphones01: t => e.createElement("svg", RH({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), VH || (VH = e.createElement("path", {
    d: "M21 18v-6a9 9 0 1 0-18 0v6m2.5 3A2.5 2.5 0 0 1 3 18.5v-2a2.5 2.5 0 0 1 5 0v2A2.5 2.5 0 0 1 5.5 21Zm13 0a2.5 2.5 0 0 1-2.5-2.5v-2a2.5 2.5 0 0 1 5 0v2a2.5 2.5 0 0 1-2.5 2.5Z"
  }))),
  calendarplus02: t => e.createElement("svg", TH({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), AH || (AH = e.createElement("path", {
    d: "M21 11.5V8.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 4 17.88 4 16.2 4H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 6.28 3 7.12 3 8.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 22 6.12 22 7.8 22h4.7M21 10H3m13-8v4M8 2v4m10 15v-6m-3 3h6"
  }))),
  filelock01: t => e.createElement("svg", LH({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), HH || (HH = e.createElement("path", {
    d: "M20 10V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 2 16.88 2 15.2 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22h1.7m8.75-5v-1.75a1.75 1.75 0 1 0-3.5 0V17m-.15 4h3.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C21 20.24 21 19.96 21 19.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C20.24 17 19.96 17 19.4 17h-3.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C14 17.76 14 18.04 14 18.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C14.76 21 15.04 21 15.6 21Z"
  }))),
  piggybank02: t => e.createElement("svg", FH({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), IH || (IH = e.createElement("path", {
    d: "M5 13a6 6 0 0 1 6-6m-6 6c0 1.648.665 3.142 1.74 4.226.104.105.156.157.187.207.03.048.046.09.06.144.013.057.013.122.013.253v2.37c0 .28 0 .42.054.527a.5.5 0 0 0 .219.218C7.38 21 7.52 21 7.8 21h1.9c.28 0 .42 0 .527-.055a.5.5 0 0 0 .218-.218c.055-.107.055-.247.055-.527v-.4c0-.28 0-.42.054-.527a.5.5 0 0 1 .219-.218C10.88 19 11.02 19 11.3 19h1.4c.28 0 .42 0 .527.055a.5.5 0 0 1 .218.218c.055.107.055.247.055.527v.4c0 .28 0 .42.054.527a.5.5 0 0 0 .219.218c.107.055.247.055.527.055h1.9c.28 0 .42 0 .527-.055a.5.5 0 0 0 .218-.218C17 20.62 17 20.48 17 20.2v-.976c0-.202 0-.303.029-.384a.462.462 0 0 1 .121-.19c.061-.06.166-.108.374-.205a6.025 6.025 0 0 0 2.427-2.055c.107-.155.16-.233.217-.28a.464.464 0 0 1 .17-.089c.07-.021.154-.021.32-.021h.542c.28 0 .42 0 .527-.055a.5.5 0 0 0 .218-.218C22 15.62 22 15.48 22 15.2v-3.414c0-.267 0-.4-.05-.503a.5.5 0 0 0-.233-.233c-.103-.05-.236-.05-.503-.05-.193 0-.29 0-.367-.026a.463.463 0 0 1-.203-.13c-.057-.06-.103-.16-.195-.358a6.013 6.013 0 0 0-1.19-1.712c-.104-.105-.155-.157-.186-.207a.462.462 0 0 1-.06-.144C19 8.366 19 8.3 19 8.17V7.06c0-.36 0-.54-.075-.66a.5.5 0 0 0-.288-.218c-.137-.039-.31.01-.657.11l-2.372.677a.498.498 0 0 1-.136.029C15.45 7 15.43 7 15.387 7H11m-6 6H4a2 2 0 0 1-1-3.732M11 7h3.965a3.5 3.5 0 1 0-6.758.688A5.974 5.974 0 0 1 11 7Z"
  }))),
  building03: t => e.createElement("svg", ZH({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), _H || (_H = e.createElement("path", {
    d: "M7.5 7h2.75M7.5 11h2.75M7.5 15h2.75m3.5-8h2.75m-2.75 4h2.75m-2.75 4h2.75m3.5 6V6.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C18.48 3 17.92 3 16.8 3H7.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C4 4.52 4 5.08 4 6.2V21m18 0H2"
  }))),
  calendar: t => e.createElement("svg", qH({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), DH || (DH = e.createElement("path", {
    d: "M21 10H3m13-8v4M8 2v4m-.2 16h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 19.72 21 18.88 21 17.2V8.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 4 17.88 4 16.2 4H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 6.28 3 7.12 3 8.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 22 6.12 22 7.8 22Z"
  }))),
  building02: t => e.createElement("svg", $H({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), UH || (UH = e.createElement("path", {
    d: "M15 21v-5.4c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C14.24 14 13.96 14 13.4 14h-2.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C9 14.76 9 15.04 9 15.6V21M3 7a3 3 0 0 0 6 0 3 3 0 1 0 6 0 3 3 0 1 0 6 0M6.2 21h11.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C21 19.48 21 18.92 21 17.8V6.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C19.48 3 18.92 3 17.8 3H6.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C3 4.52 3 5.08 3 6.2v11.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C4.52 21 5.08 21 6.2 21Z"
  }))),
  arrowsquaredownleft: t => e.createElement("svg", WH({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), zH || (zH = e.createElement("path", {
    d: "M9 9v6m0 0h6m-6 0 6-6M7.8 21h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Z"
  }))),
  arrowleft: t => e.createElement("svg", GH({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), QH || (QH = e.createElement("path", {
    d: "M19 12H5m0 0 7 7m-7-7 7-7"
  }))),
  magicwand02: t => e.createElement("svg", KH({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), YH || (YH = e.createElement("path", {
    d: "M15 4V2m0 14v-2M8 9h2m10 0h2m-4.2 2.8L19 13m-1.2-6.8L19 5M3 21l9-9m.2-5.8L11 5"
  }))),
  aligncenter: t => e.createElement("svg", JH({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), XH || (XH = e.createElement("path", {
    d: "M18 10H6m15-4H3m18 8H3m15 4H6"
  }))),
  aligntoparrow01: t => e.createElement("svg", tL({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), eL || (eL = e.createElement("path", {
    d: "M21 3H3m9 18V7m0 0-7 7m7-7 7 7"
  }))),
  route: t => e.createElement("svg", nL({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), rL || (rL = e.createElement("path", {
    d: "M11.5 5h.434c3.048 0 4.571 0 5.15.547a2 2 0 0 1 .586 1.845c-.156.781-1.4 1.66-3.888 3.42l-4.064 2.876c-2.488 1.76-3.732 2.639-3.888 3.42a2 2 0 0 0 .586 1.845c.579.547 2.102.547 5.15.547h.934M8 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm14 14a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
  }))),
  imageuserup: t => e.createElement("svg", oL({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), aL || (aL = e.createElement("path", {
    d: "m16 5 3-3m0 0 3 3m-3-3v6m3 4v5.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C19.72 22 18.88 22 17.2 22H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 19.72 2 18.88 2 17.2V6.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C4.28 2 5.12 2 6.8 2H12M2.146 19.926A4.002 4.002 0 0 1 6 17h7c.93 0 1.394 0 1.78.077a4 4 0 0 1 3.143 3.143c.077.386.077.85.077 1.78M14 9.5a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
  }))),
  infooctagon: t => e.createElement("svg", lL({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), iL || (iL = e.createElement("path", {
    d: "M12 16v-4m0-4h.01M2 8.523v6.954c0 .245 0 .367.028.482a1 1 0 0 0 .12.29c.061.1.148.187.32.36l4.923 4.922c.173.173.26.26.36.322.09.054.188.095.29.12.115.027.237.027.482.027h6.954c.245 0 .367 0 .482-.028a.998.998 0 0 0 .29-.12c.1-.061.187-.148.36-.32l4.922-4.923c.173-.173.26-.26.322-.36a.998.998 0 0 0 .12-.29c.027-.115.027-.237.027-.482V8.523c0-.245 0-.367-.028-.482a.998.998 0 0 0-.12-.29c-.061-.1-.148-.187-.32-.36L16.608 2.47c-.173-.173-.26-.26-.36-.322a1 1 0 0 0-.29-.12C15.844 2 15.722 2 15.477 2H8.523c-.245 0-.367 0-.482.028a1 1 0 0 0-.29.12c-.1.061-.187.148-.36.32L2.47 7.392c-.173.173-.26.26-.322.36a1 1 0 0 0-.12.29C2 8.156 2 8.278 2 8.523Z"
  }))),
  markerpin03: t => e.createElement("svg", uL({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), sL || (sL = e.createElement("path", {
    d: "M12 22c1-5 8-5.582 8-12a8 8 0 1 0-16 0c0 6.418 7 7 8 12Z"
  })), cL || (cL = e.createElement("path", {
    d: "M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
  }))),
  minuscircle: t => e.createElement("svg", mL({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), hL || (hL = e.createElement("path", {
    d: "M8 12h8m6 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }))),
  speaker03: t => e.createElement("svg", fL({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), pL || (pL = e.createElement("path", {
    d: "M18 18v2.4c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437C17.24 22 16.96 22 16.4 22H7.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C6 21.24 6 20.96 6 20.4V18m6-8h.01M7.8 18h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 15.72 21 14.88 21 13.2V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 2 17.88 2 16.2 2H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 4.28 3 5.12 3 6.8v6.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 18 6.12 18 7.8 18Zm9.2-8a5 5 0 1 1-10 0 5 5 0 0 1 10 0Zm-4.5 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
  }))),
  arrowdownright: t => e.createElement("svg", vL({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), dL || (dL = e.createElement("path", {
    d: "m7 7 10 10m0 0V7m0 10H7"
  }))),
  data: t => e.createElement("svg", bL({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), gL || (gL = e.createElement("path", {
    d: "M21.2 22c.28 0 .42 0 .527-.055a.5.5 0 0 0 .218-.218C22 21.62 22 21.48 22 21.2V10.8c0-.28 0-.42-.055-.527a.5.5 0 0 0-.218-.218C21.62 10 21.48 10 21.2 10h-2.4c-.28 0-.42 0-.527.055a.5.5 0 0 0-.218.218C18 10.38 18 10.52 18 10.8v2.4c0 .28 0 .42-.055.527a.5.5 0 0 1-.218.218C17.62 14 17.48 14 17.2 14h-2.4c-.28 0-.42 0-.527.055a.5.5 0 0 0-.218.218C14 14.38 14 14.52 14 14.8v2.4c0 .28 0 .42-.055.527a.5.5 0 0 1-.218.218C13.62 18 13.48 18 13.2 18h-2.4c-.28 0-.42 0-.527.055a.5.5 0 0 0-.218.218C10 18.38 10 18.52 10 18.8v2.4c0 .28 0 .42.055.527a.5.5 0 0 0 .218.218c.107.055.247.055.527.055h10.4ZM10 6.8c0-.28 0-.42.055-.527a.5.5 0 0 1 .218-.218C10.38 6 10.52 6 10.8 6h2.4c.28 0 .42 0 .527.054a.5.5 0 0 1 .218.219C14 6.38 14 6.52 14 6.8v2.4c0 .28 0 .42-.055.527a.5.5 0 0 1-.218.218C13.62 10 13.48 10 13.2 10h-2.4c-.28 0-.42 0-.527-.055a.5.5 0 0 1-.218-.218C10 9.62 10 9.48 10 9.2V6.8ZM3 12.8c0-.28 0-.42.054-.527a.5.5 0 0 1 .219-.218C3.38 12 3.52 12 3.8 12h2.4c.28 0 .42 0 .527.055a.5.5 0 0 1 .218.218C7 12.38 7 12.52 7 12.8v2.4c0 .28 0 .42-.054.527a.5.5 0 0 1-.219.218C6.62 16 6.48 16 6.2 16H3.8c-.28 0-.42 0-.527-.055a.5.5 0 0 1-.219-.218C3 15.62 3 15.48 3 15.2v-2.4ZM2 2.8c0-.28 0-.42.054-.527a.5.5 0 0 1 .219-.219C2.38 2 2.52 2 2.8 2h2.4c.28 0 .42 0 .527.054a.5.5 0 0 1 .218.219C6 2.38 6 2.52 6 2.8v2.4c0 .28 0 .42-.054.527a.5.5 0 0 1-.219.218C5.62 6 5.48 6 5.2 6H2.8c-.28 0-.42 0-.527-.054a.5.5 0 0 1-.219-.219C2 5.62 2 5.48 2 5.2V2.8Z"
  }))),
  webcam02: t => e.createElement("svg", yL({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), wL || (wL = e.createElement("path", {
    d: "M8 22h8m4.5-11.5a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0Zm-5.313 0a3.188 3.188 0 1 1-6.375 0 3.188 3.188 0 0 1 6.376 0Z"
  }))),
  hearts: t => e.createElement("svg", OL({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), xL || (xL = e.createElement("path", {
    d: "M15.546 9.925c.373-.664.685-1.263.878-1.72.933-2.216.01-4.764-2.247-5.804-2.257-1.04-4.524.038-5.518 2.12-1.902-1.305-4.44-1.114-5.84.923-1.398 2.037-.96 4.698.957 6.15.87.659 2.59 1.63 4.21 2.494m8.311-2.338c-.422-2.268-2.352-3.927-4.781-3.476-2.43.451-4.001 2.643-3.673 5.025.264 1.914 1.72 6.404 2.283 8.095.077.23.116.346.192.427.066.07.154.12.248.143.107.025.226 0 .465-.048 1.745-.358 6.362-1.342 8.152-2.07 2.227-.907 3.376-3.362 2.515-5.693-.86-2.331-3.226-3.171-5.4-2.403Z"
  }))),
  sliders01: t => e.createElement("svg", jL({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), EL || (EL = e.createElement("path", {
    d: "M5 21v-7m0-4V3m7 18v-9m0-4V3m7 18v-5m0-4V3M2 14h6m1-6h6m1 8h6"
  }))),
  framer: t => e.createElement("svg", PL({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), CL || (CL = e.createElement("path", {
    d: "M12 15.5v7l-7-7m0 0v-7h7m-7 7h14l-7-7m0 0h7v-7H5l7 7Z"
  }))),
  tv03: t => e.createElement("svg", kL({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ML || (ML = e.createElement("path", {
    d: "m17 3-5 4-5-4m-.2 18h10.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 18.72 22 17.88 22 16.2v-4.4c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C19.72 7 18.88 7 17.2 7H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 9.28 2 10.12 2 11.8v4.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 21 5.12 21 6.8 21Z"
  }))),
  hexagon02: t => e.createElement("svg", NL({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), SL || (SL = e.createElement("path", {
    d: "M21.568 11.223c.157.284.236.425.267.575a.998.998 0 0 1 0 .403c-.03.15-.11.292-.267.576l-4.111 7.4c-.167.3-.25.45-.368.558a1 1 0 0 1-.364.215c-.153.05-.324.05-.667.05H7.941c-.343 0-.514 0-.667-.05a1 1 0 0 1-.364-.215c-.118-.109-.201-.258-.368-.558l-4.11-7.4c-.158-.284-.237-.425-.268-.575a1 1 0 0 1 0-.403c.03-.15.11-.292.267-.576l4.111-7.4c.167-.3.25-.45.368-.558a1 1 0 0 1 .364-.215C7.427 3 7.598 3 7.941 3h8.117c.343 0 .514 0 .667.05a1 1 0 0 1 .364.215c.118.109.201.258.368.558l4.11 7.4Z"
  }))),
  bookopen01: t => e.createElement("svg", VL({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), BL || (BL = e.createElement("path", {
    d: "m12 21-.1-.15c-.695-1.042-1.042-1.563-1.5-1.94a4 4 0 0 0-1.378-.737C8.453 18 7.827 18 6.575 18H5.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C2 16.48 2 15.92 2 14.8V6.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C3.52 3 4.08 3 5.2 3h.4c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C12 6.04 12 7.16 12 9.4M12 21V9.4M12 21l.1-.15c.695-1.042 1.042-1.563 1.5-1.94a3.999 3.999 0 0 1 1.378-.737C15.547 18 16.173 18 17.425 18H18.8c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C22 16.48 22 15.92 22 14.8V6.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 3 19.92 3 18.8 3h-.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C12 6.04 12 7.16 12 9.4"
  }))),
  clipboardx: t => e.createElement("svg", AL({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), RL || (RL = e.createElement("path", {
    d: "M16 4c.93 0 1.395 0 1.776.102a3 3 0 0 1 2.122 2.122C20 6.605 20 7.07 20 8v9.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C17.72 22 16.88 22 15.2 22H8.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.72 4 18.88 4 17.2V8c0-.93 0-1.395.102-1.776a3 3 0 0 1 2.122-2.122C6.605 4 7.07 4 8 4m1.5 8 5 5m0-5-5 5m.1-11h4.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C16 5.24 16 4.96 16 4.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C15.24 2 14.96 2 14.4 2H9.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C8 2.76 8 3.04 8 3.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C8.76 6 9.04 6 9.6 6Z"
  }))),
  barchart01: t => e.createElement("svg", HL({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), TL || (TL = e.createElement("path", {
    d: "M18 20V10m-6 10V4M6 20v-6"
  }))),
  hash02: t => e.createElement("svg", IL({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), LL || (LL = e.createElement("path", {
    d: "m9.5 3-3 18m11-18-3 18m6-13h-17m16 8h-17"
  }))),
  tool02: t => e.createElement("svg", _L({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), FL || (FL = e.createElement("path", {
    d: "m6 6 4.5 4.5M6 6H3L2 3l1-1 3 1v3Zm13.259-3.259-2.628 2.628c-.396.396-.594.594-.668.822a1 1 0 0 0 0 .618c.074.228.272.426.668.822l.238.238c.396.396.594.594.822.668a1 1 0 0 0 .618 0c.228-.074.426-.272.822-.668L21.59 5.41a5.5 5.5 0 0 1-6.16 7.485c-.485-.096-.729-.144-.876-.13a.836.836 0 0 0-.373.114c-.13.07-.261.201-.523.463L6.5 20.5a2.121 2.121 0 0 1-3-3l7.157-7.157c.262-.262.393-.393.463-.524a.836.836 0 0 0 .113-.372c.015-.148-.033-.39-.129-.877a5.5 5.5 0 0 1 8.155-5.83ZM12 15l5.5 5.5a2.121 2.121 0 0 0 3-3l-4.525-4.525a5.475 5.475 0 0 1-.934-.17c-.39-.107-.816-.03-1.101.255L12 15Z"
  }))),
  messagepluscircle: t => e.createElement("svg", DL({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ZL || (ZL = e.createElement("path", {
    d: "M12.5 14.5v-6m-3 3h6m-3 8.5a8.5 8.5 0 1 0-8.057-5.783c.108.32.162.481.172.604a.899.899 0 0 1-.028.326c-.03.12-.098.245-.232.494l-1.636 3.027c-.233.432-.35.648-.324.815a.5.5 0 0 0 .234.35c.144.087.388.062.876.011l5.121-.529c.155-.016.233-.024.303-.021.07.002.12.009.187.024.069.016.155.05.329.116A8.478 8.478 0 0 0 12.5 20Z"
  }))),
  volumex: t => e.createElement("svg", UL({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), qL || (qL = e.createElement("path", {
    d: "m22 9-6 6m0-6 6 6M9.634 5.366 6.47 8.53c-.173.173-.26.26-.36.322a1 1 0 0 1-.29.12C5.704 9 5.582 9 5.337 9H3.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C2 9.76 2 10.04 2 10.6v2.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C2.76 15 3.04 15 3.6 15h1.737c.245 0 .367 0 .482.028a1 1 0 0 1 .29.12c.1.061.187.148.36.32l3.165 3.166c.429.429.643.643.827.657a.5.5 0 0 0 .42-.174c.119-.14.119-.443.119-1.048V5.93c0-.606 0-.908-.12-1.049a.5.5 0 0 0-.42-.173c-.183.014-.397.228-.826.657Z"
  }))),
  cloudraining02: t => e.createElement("svg", zL({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), $L || ($L = e.createElement("path", {
    d: "M16 12v8m-8-8v8m4-6v8m8-6.758a4.5 4.5 0 0 0-2.08-8.223 6.002 6.002 0 0 0-11.84 0A4.5 4.5 0 0 0 4 15.242"
  }))),
  messagecircle02: t => e.createElement("svg", QL({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), WL || (WL = e.createElement("path", {
    d: "M21 12a9 9 0 0 1-12.385 8.342c-.2-.081-.3-.122-.38-.14a.909.909 0 0 0-.219-.024c-.083 0-.173.015-.353.045l-3.558.593c-.373.062-.56.093-.694.035a.5.5 0 0 1-.262-.262c-.058-.135-.027-.321.035-.694l.593-3.558c.03-.18.045-.27.045-.353a.907.907 0 0 0-.024-.219c-.018-.08-.059-.18-.14-.38A9 9 0 1 1 21 12Z"
  }))),
  flexaligntop: t => e.createElement("svg", YL({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), GL || (GL = e.createElement("path", {
    d: "M17.5 6.5h-11M7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3Z"
  }))),
  dotpoints02: t => e.createElement("svg", XL({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), KL || (KL = e.createElement("path", {
    d: "M21 5H10m11 14H10m11-7H10M6 5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 14a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0-7a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
  }))),
  calendardate: t => e.createElement("svg", eI({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), JL || (JL = e.createElement("path", {
    d: "M21 10H3m13-8v4M8 2v4m2.5 8 1.5-1v5m-1.25 0h2.5M7.8 22h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 19.72 21 18.88 21 17.2V8.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 4 17.88 4 16.2 4H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 6.28 3 7.12 3 8.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 22 6.12 22 7.8 22Z"
  }))),
  code02: t => e.createElement("svg", rI({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), tI || (tI = e.createElement("path", {
    d: "m17 17 5-5-5-5M7 7l-5 5 5 5m7-14-4 18"
  }))),
  home05: t => e.createElement("svg", aI({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), nI || (nI = e.createElement("path", {
    d: "M12.982 2.764c-.351-.273-.527-.41-.72-.462a1 1 0 0 0-.523 0c-.194.052-.37.189-.721.462L4.235 8.039c-.453.353-.68.53-.843.75a2 2 0 0 0-.318.65C3 9.704 3 9.991 3 10.565V17.8c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C4.52 21 5.08 21 6.2 21h2c.28 0 .42 0 .527-.055a.5.5 0 0 0 .218-.218C9 20.62 9 20.48 9 20.2v-6.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C9.76 12 10.04 12 10.6 12h2.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C15 12.76 15 13.04 15 13.6v6.6c0 .28 0 .42.055.527a.5.5 0 0 0 .218.218c.107.055.247.055.527.055h2c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C21 19.48 21 18.92 21 17.8v-7.235c0-.574 0-.861-.074-1.126a2.002 2.002 0 0 0-.318-.65c-.163-.22-.39-.397-.843-.75l-6.783-5.275Z"
  }))),
  image02: t => e.createElement("svg", iI({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), oI || (oI = e.createElement("path", {
    d: "m6 20 8.869-8.869c.396-.396.594-.594.822-.668a1 1 0 0 1 .618 0c.228.074.426.272.822.668l4.274 4.274M10.5 8.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }))),
  award05: t => e.createElement("svg", sI({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), lI || (lI = e.createElement("path", {
    d: "M7.135 11.189 3.33 4.381c-.437-.783-.656-1.175-.619-1.495a1 1 0 0 1 .41-.697C3.38 2 3.83 2 4.726 2h2.235c.333 0 .5 0 .65.048a1 1 0 0 1 .357.205c.118.104.202.248.372.535L12 9l3.659-6.212c.169-.287.254-.43.37-.535a1 1 0 0 1 .359-.205c.15-.048.316-.048.65-.048h2.234c.897 0 1.345 0 1.607.189a1 1 0 0 1 .41.697c.036.32-.183.712-.62 1.495l-3.805 6.808M10.5 14l1.5-1v5m-1.25 0h2.5m3.346-7.096a6.5 6.5 0 1 1-9.192 9.192 6.5 6.5 0 0 1 9.192-9.192Z"
  }))),
  lockunlocked03: t => e.createElement("svg", uI({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), cI || (cI = e.createElement("path", {
    d: "M7 11V8a5 5 0 0 1 9.9-1M8.8 21h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 18.72 20 17.88 20 16.2v-.4c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 11 16.88 11 15.2 11H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 13.28 4 14.12 4 15.8v.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 21 7.12 21 8.8 21Z"
  }))),
  sale03: t => e.createElement("svg", mI({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), hI || (hI = e.createElement("path", {
    d: "M9 9h.01M15 15h.01M16 8l-8 8m9.901-11.001c.206.498.601.893 1.1 1.1l1.744.723a2.033 2.033 0 0 1 1.1 2.656l-.722 1.744a2.03 2.03 0 0 0 0 1.556l.722 1.744a2.033 2.033 0 0 1-1.1 2.656L19 17.901A2.033 2.033 0 0 0 17.9 19l-.723 1.745a2.032 2.032 0 0 1-2.656 1.1l-1.744-.722a2.032 2.032 0 0 0-1.555 0l-1.745.723a2.033 2.033 0 0 1-2.654-1.1L6.1 19.001A2.033 2.033 0 0 0 5 17.9l-1.744-.723a2.033 2.033 0 0 1-1.1-2.654l.721-1.744a2.033 2.033 0 0 0 0-1.556l-.722-1.746a2.033 2.033 0 0 1 1.1-2.657L5 6.098c.498-.206.893-.6 1.1-1.098l.723-1.745a2.033 2.033 0 0 1 2.656-1.1l1.744.722a2.033 2.033 0 0 0 1.555-.001l1.746-.72a2.032 2.032 0 0 1 2.655 1.1l.723 1.746v-.003ZM9.5 9a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm6 6a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
  }))),
  rows02: t => e.createElement("svg", fI({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), pI || (pI = e.createElement("path", {
    d: "M3 12h18M7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3Z"
  }))),
  award01: t => e.createElement("svg", vI({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), dI || (dI = e.createElement("path", {
    d: "M7.967 14.722 7 22l4.588-2.753c.15-.09.225-.135.305-.152a.5.5 0 0 1 .214 0c.08.017.155.062.305.152L17 22l-.966-7.279M19 9A7 7 0 1 1 5 9a7 7 0 0 1 14 0Z"
  }))),
  home01: t => e.createElement("svg", bI({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), gI || (gI = e.createElement("path", {
    d: "M3 10.565c0-.574 0-.861.074-1.126a2 2 0 0 1 .318-.65c.163-.22.39-.397.843-.75l6.783-5.275c.351-.273.527-.41.72-.462a1 1 0 0 1 .523 0c.194.052.37.189.721.462l6.783 5.275c.453.353.68.53.843.75.145.195.252.416.318.65.074.265.074.552.074 1.126V17.8c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C19.48 21 18.92 21 17.8 21H6.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C3 19.48 3 18.92 3 17.8v-7.235Z"
  }))),
  trash02: t => e.createElement("svg", yI({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), wI || (wI = e.createElement("path", {
    d: "M16 6v-.8c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C14.48 2 13.92 2 12.8 2h-1.6c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C8 3.52 8 4.08 8 5.2V6M3 6h18m-2 0v11.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C16.72 22 15.88 22 14.2 22H9.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C5 19.72 5 18.88 5 17.2V6"
  }))),
  scale03: t => e.createElement("svg", OI({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), xI || (xI = e.createElement("path", {
    d: "M16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8M16.2 3c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8M16.2 3h-1c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C12 4.52 12 5.08 12 6.2v2.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C13.52 12 14.08 12 15.2 12h2.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C21 10.48 21 9.92 21 8.8v-1m-8.5 3.7L7 17m0 0h5m-5 0v-5"
  }))),
  messagesquare01: t => e.createElement("svg", jI({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), EI || (EI = e.createElement("path", {
    d: "M3 7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v5.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 18 17.88 18 16.2 18H9.684c-.624 0-.936 0-1.235.061a2.997 2.997 0 0 0-.762.267c-.27.14-.514.334-1.002.724L4.3 20.96c-.416.333-.624.5-.8.5a.5.5 0 0 1-.39-.188C3 21.135 3 20.868 3 20.336V7.8Z"
  }))),
  edit04: t => e.createElement("svg", PI({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), CI || (CI = e.createElement("path", {
    d: "m21 18-1 1.094c-.53.58-1.25.906-2 .906a2.71 2.71 0 0 1-2-.906 2.716 2.716 0 0 0-2-.904c-.75 0-1.469.325-2 .904M3 20h1.675c.489 0 .733 0 .963-.055.205-.05.4-.13.579-.24.201-.123.374-.296.72-.642L19.5 6.5a2.121 2.121 0 1 0-3-3L3.937 16.063c-.346.346-.519.519-.642.72a2 2 0 0 0-.24.578c-.055.23-.055.475-.055.965V20Z"
  }))),
  cloudraining06: t => e.createElement("svg", kI({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), MI || (MI = e.createElement("path", {
    d: "M13 21H6m13-3h-9m-3 0H5m13 3h-2m-9-6a5 5 0 1 1 .1-9.999 5.502 5.502 0 0 1 10.195 1.004A4.5 4.5 0 1 1 17.5 15H6.999Z"
  }))),
  codesnippet02: t => e.createElement("svg", NI({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), SI || (SI = e.createElement("path", {
    d: "m17 17 5-5-5-5M7 7l-5 5 5 5m7-14-4 18"
  }))),
  annotationx: t => e.createElement("svg", VI({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), BI || (BI = e.createElement("path", {
    d: "m9.5 8 5 5m0-5-5 5m.4 6.2 1.46 1.947c.217.29.326.434.459.486a.5.5 0 0 0 .362 0c.133-.052.242-.197.459-.486L14.1 19.2c.293-.39.44-.586.619-.735a2 2 0 0 1 .822-.412c.226-.053.47-.053.959-.053 1.398 0 2.097 0 2.648-.228a3 3 0 0 0 1.624-1.624C21 15.597 21 14.898 21 13.5V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v5.7c0 1.398 0 2.097.228 2.648a3 3 0 0 0 1.624 1.624C5.403 18 6.102 18 7.5 18c.489 0 .733 0 .96.053a2 2 0 0 1 .821.412c.18.149.326.344.619.735Z"
  }))),
  userright01: t => e.createElement("svg", AI({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), RI || (RI = e.createElement("path", {
    d: "m19 21 3-3m0 0-3-3m3 3h-6m-4-2.5H7.5c-1.396 0-2.093 0-2.661.172a4 4 0 0 0-2.667 2.667C2 18.907 2 19.604 2 21M14.5 7.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Z"
  }))),
  barchartcircle03: t => e.createElement("svg", HI({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), TI || (TI = e.createElement("path", {
    d: "M8 7v10m4-6v6m4-2v2m6-5c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }))),
  calendarminus02: t => e.createElement("svg", II({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), LI || (LI = e.createElement("path", {
    d: "M15 18h6m0-6.5V8.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 4 17.88 4 16.2 4H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 6.28 3 7.12 3 8.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 22 6.12 22 7.8 22h4.7M21 10H3m13-8v4M8 2v4"
  }))),
  brush02: t => e.createElement("svg", _I({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), FI || (FI = e.createElement("path", {
    d: "M18 10V3.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C17.24 2 16.96 2 16.4 2H7.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C6 2.76 6 3.04 6 3.6V10m12 0H6m12 0v.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C15.72 15 14.88 15 13.2 15h-2.4c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C6 12.72 6 11.88 6 10.2V10m8.5 5v4.5a2.5 2.5 0 0 1-5 0V15"
  }))),
  banknote02: t => e.createElement("svg", DI({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ZI || (ZI = e.createElement("path", {
    d: "M6 10v4m12-4v4M2 8.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 19 4.08 19 5.2 19h13.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C22 17.48 22 16.92 22 15.8V8.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 5 19.92 5 18.8 5H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 6.52 2 7.08 2 8.2ZM14.5 12a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"
  }))),
  microphone02: t => e.createElement("svg", UI({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), qI || (qI = e.createElement("path", {
    d: "M20 12v1a8 8 0 1 1-16 0v-1m8 5a4 4 0 0 1-4-4V7a4 4 0 1 1 8 0v6a4 4 0 0 1-4 4Z"
  }))),
  barchart11: t => e.createElement("svg", zI({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), $I || ($I = e.createElement("path", {
    d: "M9 21H4.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C3 20.24 3 19.96 3 19.4V4.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C3.76 3 4.04 3 4.6 3h2.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C9 3.76 9 4.04 9 4.6V7m0 14h6m-6 0V7m0 0h4.4c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C15 7.76 15 8.04 15 8.6V21m0-10h4.4c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C21 11.76 21 12.04 21 12.6v6.8c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437C20.24 21 19.96 21 19.4 21H15"
  }))),
  arrowcirclebrokendown: t => e.createElement("svg", QI({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), WI || (WI = e.createElement("path", {
    d: "M17 3.338A9.996 9.996 0 0 1 22 12c0 5.523-4.477 10-10 10S2 17.523 2 12a9.996 9.996 0 0 1 5-8.662M8 12l4 4m0 0 4-4m-4 4V2"
  }))),
  signal03: t => e.createElement("svg", YI({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), GI || (GI = e.createElement("path", {
    d: "M10.586 13.414a2 2 0 1 1 2.828 0m-5.657 2.829a6 6 0 1 1 8.486 0M4.929 19.07c-3.905-3.905-3.905-10.237 0-14.142 3.905-3.905 10.237-3.905 14.142 0 3.905 3.905 3.905 10.237 0 14.142"
  }))),
  pentoolplus: t => e.createElement("svg", XI({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), KI || (KI = e.createElement("path", {
    d: "M15 7 8.834 8.762c-.304.087-.457.13-.583.212a1 1 0 0 0-.282.277c-.084.124-.131.275-.224.578L4 22m0 0 12.17-3.745c.304-.093.455-.14.58-.224a1 1 0 0 0 .276-.282c.082-.126.125-.279.212-.583L19 11M4 22l6.586-6.586M5 8V2M2 5h6m13.869 2.869L18.13 4.13c-.396-.396-.594-.594-.822-.668a1 1 0 0 0-.618 0c-.228.074-.426.272-.822.668l-.738.738c-.396.396-.594.594-.668.822a1 1 0 0 0 0 .618c.074.228.272.426.668.822l3.738 3.738c.396.396.594.594.822.668a1 1 0 0 0 .618 0c.228-.074.426-.272.822-.668l.738-.738c.396-.396.594-.594.668-.822a1 1 0 0 0 0-.618c-.074-.228-.272-.426-.668-.822ZM12 12a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z"
  }))),
  userplus02: t => e.createElement("svg", eF({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), JI || (JI = e.createElement("path", {
    d: "M19 10V4m-3 3h6m-6 14v-1.2c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C13.72 15 12.88 15 11.2 15H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 17.28 2 18.12 2 19.8V21M12.5 7.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
  }))),
  checkdone02: t => e.createElement("svg", rF({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), tF || (tF = e.createElement("path", {
    d: "M16 8V5.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C14.48 2 13.92 2 12.8 2H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 3.52 2 4.08 2 5.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 16 4.08 16 5.2 16H8m4-1 2 2 4.5-4.5M11.2 22h7.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C22 20.48 22 19.92 22 18.8v-7.6c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 8 19.92 8 18.8 8h-7.6c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C8 9.52 8 10.08 8 11.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C9.52 22 10.08 22 11.2 22Z"
  }))),
  bookmarkcheck: t => e.createElement("svg", aF({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), nF || (nF = e.createElement("path", {
    d: "m9 10.5 2 2L15.5 8M19 21V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C16.72 3 15.88 3 14.2 3H9.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C5 5.28 5 6.12 5 7.8V21l7-4 7 4Z"
  }))),
  barchart05: t => e.createElement("svg", iF({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), oF || (oF = e.createElement("path", {
    d: "M3 17v4M15 8v13m-6-8v8M21 3v18"
  }))),
  loading03: t => e.createElement("svg", sF({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), lF || (lF = e.createElement("path", {
    d: "M3.34 17a4.773 4.773 0 0 1 1.458-6.34l.002-.002a4.778 4.778 0 0 1 5.484.094l3.432 2.496a4.778 4.778 0 0 0 5.485.094l.002-.002A4.77 4.77 0 0 0 20.66 7m-3.658 13.66a4.774 4.774 0 0 1-6.34-1.458l-.002-.003a4.778 4.778 0 0 1 .095-5.484l2.495-3.432a4.778 4.778 0 0 0 .094-5.484l-.004-.002A4.772 4.772 0 0 0 7 3.34M19.07 4.93c3.906 3.905 3.906 10.236 0 14.141-3.905 3.906-10.236 3.906-14.141 0-3.905-3.905-3.905-10.236 0-14.141 3.905-3.905 10.236-3.905 14.141 0Z"
  }))),
  filecode01: t => e.createElement("svg", uF({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), cF || (cF = e.createElement("path", {
    d: "M14 2.27V6.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437c.214.11.494.11 1.054.11h4.13M14 17.5l2.5-2.5-2.5-2.5m-4 0L7.5 15l2.5 2.5m10-7.512V17.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C17.72 22 16.88 22 15.2 22H8.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.72 4 18.88 4 17.2V6.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C6.28 2 7.12 2 8.8 2h3.212c.733 0 1.1 0 1.446.083.306.073.598.195.867.36.303.185.562.444 1.08.963l3.19 3.188c.518.519.777.778.963 1.081a3 3 0 0 1 .36.867c.082.346.082.712.082 1.446Z"
  }))),
  type01: t => e.createElement("svg", mF({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), hF || (hF = e.createElement("path", {
    d: "M4 7c0-.932 0-1.398.152-1.765a2 2 0 0 1 1.083-1.083C5.602 4 6.068 4 7 4h10c.932 0 1.398 0 1.765.152a2 2 0 0 1 1.083 1.083C20 5.602 20 6.068 20 7M9 20h6M12 4v16"
  }))),
  lock03: t => e.createElement("svg", fF({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), pF || (pF = e.createElement("path", {
    d: "M17 11V8A5 5 0 0 0 7 8v3m1.8 10h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 18.72 20 17.88 20 16.2v-.4c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 11 16.88 11 15.2 11H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 13.28 4 14.12 4 15.8v.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 21 7.12 21 8.8 21Z"
  }))),
  bookmarkadd: t => e.createElement("svg", vF({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), dF || (dF = e.createElement("path", {
    d: "M12 13V7m-3 3h6m4 11V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C16.72 3 15.88 3 14.2 3H9.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C5 5.28 5 6.12 5 7.8V21l7-4 7 4Z"
  }))),
  bookmark: t => e.createElement("svg", bF({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), gF || (gF = e.createElement("path", {
    d: "M5 7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C7.28 3 8.12 3 9.8 3h4.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C19 5.28 19 6.12 19 7.8V21l-7-4-7 4V7.8Z"
  }))),
  alerttriangle: t => e.createElement("svg", yF({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), wF || (wF = e.createElement("path", {
    d: "M12 9v4m0 4h.01M10.615 3.892 2.39 18.098c-.456.788-.684 1.182-.65 1.506a1 1 0 0 0 .406.705c.263.191.718.191 1.629.191h16.45c.91 0 1.365 0 1.628-.191a1 1 0 0 0 .407-.705c.034-.324-.195-.718-.65-1.506L13.383 3.892c-.454-.785-.681-1.178-.978-1.31a1 1 0 0 0-.813 0c-.296.132-.523.525-.978 1.31Z"
  }))),
  filedownload01: t => e.createElement("svg", OF({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), xF || (xF = e.createElement("path", {
    d: "M20 12.5V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 2 16.88 2 15.2 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22h3.7m2.5-3 3 3m0 0 3-3m-3 3v-6"
  }))),
  typestrikethrough01: t => e.createElement("svg", jF({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), EF || (EF = e.createElement("path", {
    d: "M4 7V6c0-.541.215-1.032.564-1.392M9 20h6m-3-8v8M3 3l18 18M9.5 4H17c.932 0 1.398 0 1.765.152a2 2 0 0 1 1.083 1.083C20 5.602 20 6.068 20 7m-8-3v2.5"
  }))),
  facewink: t => e.createElement("svg", PF({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), CF || (CF = e.createElement("path", {
    d: "M8 14s1.5 2 4 2 4-2 4-2m-1-5h.01M8 9h2m12 3c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-6.5-3a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
  }))),
  linechartdown02: t => e.createElement("svg", kF({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), MF || (MF = e.createElement("path", {
    d: "M21 21H4.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C3 20.24 3 19.96 3 19.4V3m18 12-5.434-5.434c-.198-.198-.297-.297-.412-.334a.5.5 0 0 0-.309 0c-.114.037-.213.136-.41.334l-1.87 1.868c-.197.198-.296.297-.41.334a.499.499 0 0 1-.31 0c-.114-.037-.213-.136-.41-.334L7 7m14 8h-4m4 0v-4"
  }))),
  coinsstacked04: t => e.createElement("svg", NF({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), SF || (SF = e.createElement("path", {
    d: "M20 5c0 1.657-3.582 3-8 3S4 6.657 4 5m16 0c0-1.657-3.582-3-8-3S4 3.343 4 5m16 0v14c0 1.657-3.582 3-8 3s-8-1.343-8-3V5m16 4.667c0 1.656-3.582 3-8 3s-8-1.344-8-3m16 4.663c0 1.657-3.582 3-8 3s-8-1.343-8-3"
  }))),
  foldersearch: t => e.createElement("svg", VF({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), BF || (BF = e.createElement("path", {
    d: "m13 7-1.116-2.231c-.32-.642-.481-.963-.72-1.198a2 2 0 0 0-.748-.462C10.1 3 9.74 3 9.022 3H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 4.52 2 5.08 2 6.2V7m0 0h15.2c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C22 9.28 22 10.12 22 11.8v4.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C19.72 21 18.88 21 17.2 21H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.72 2 17.88 2 16.2V7Zm13.5 10.5L14 16m1-2.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
  }))),
  batterycharging01: t => e.createElement("svg", AF({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), RF || (RF = e.createElement("path", {
    d: "m10.833 15 1.667-3h-4l1.667-3M22 13v-2M6.8 18h7.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C19 15.72 19 14.88 19 13.2v-2.4c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C16.72 6 15.88 6 14.2 6H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 8.28 2 9.12 2 10.8v2.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 18 5.12 18 6.8 18Z"
  }))),
  building06: t => e.createElement("svg", HF({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), TF || (TF = e.createElement("path", {
    d: "M11 11H6.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C3 12.52 3 13.08 3 14.2V21m18 0V6.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C19.48 3 18.92 3 17.8 3h-3.6c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C11 4.52 11 5.08 11 6.2V21m11 0H2M14.5 7h3m-3 4h3m-3 4h3"
  }))),
  stickercircle: t => e.createElement("svg", FF({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), LF || (LF = e.createElement("path", {
    d: "M22 12.117C22 6.53 17.472 2 11.884 2 7.348 2 3.51 4.984 2.226 9.095c-.082.264-.123.395-.12.56.004.134.045.3.104.42.073.147.186.26.41.485l10.822 10.82c.225.226.338.339.486.412.12.059.285.1.419.103.165.004.296-.037.56-.12C19.017 20.49 22 16.652 22 12.117Z"
  })), IF || (IF = e.createElement("path", {
    d: "M3.447 9.734c.24-.017.483-.026.728-.026 5.588 0 10.117 4.53 10.117 10.117 0 .245-.009.488-.026.729-.03.42-.044.63-.167.76a.532.532 0 0 1-.413.154c-.178-.018-.34-.18-.662-.502l-9.99-9.99c-.322-.322-.484-.484-.502-.661a.531.531 0 0 1 .155-.414c.13-.122.34-.137.76-.167Z"
  }))),
  scissorscut02: t => e.createElement("svg", ZF({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), _F || (_F = e.createElement("path", {
    d: "M4.5 8.6 21 17m0-10L4.5 15.4m13-3.4h.01M22 12h.01M6 3a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 12a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z"
  }))),
  mail03: t => e.createElement("svg", qF({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), DF || (DF = e.createElement("path", {
    d: "m2 7 5.194 3.463c.3.2.45.3.611.37.144.063.295.108.45.136.174.031.354.031.714.031h6.062c.36 0 .54 0 .714-.031.155-.028.306-.073.45-.136.162-.07.311-.17.611-.37L22 7M6.8 20h10.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 17.72 22 16.88 22 15.2V8.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C19.72 4 18.88 4 17.2 4H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 6.28 2 7.12 2 8.8v6.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 20 5.12 20 6.8 20Z"
  }))),
  mail02: t => e.createElement("svg", $F({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), UF || (UF = e.createElement("path", {
    d: "m21.5 18-6.643-6m-5.714 0L2.5 18M2 7l8.165 5.715c.661.463.992.695 1.351.784a2 2 0 0 0 .968 0c.36-.09.69-.32 1.351-.784L22 7M6.8 20h10.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 17.72 22 16.88 22 15.2V8.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C19.72 4 18.88 4 17.2 4H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 6.28 2 7.12 2 8.8v6.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 20 5.12 20 6.8 20Z"
  }))),
  currencydollar: t => e.createElement("svg", WF({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), zF || (zF = e.createElement("path", {
    d: "M6 16a4 4 0 0 0 4 4h4a4 4 0 0 0 0-8h-4a4 4 0 0 1 0-8h4a4 4 0 0 1 4 4m-6-6v20"
  }))),
  alertoctagon: t => e.createElement("svg", GF({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), QF || (QF = e.createElement("path", {
    d: "M12 8v4m0 4h.01M2 8.523v6.954c0 .245 0 .367.028.482a1 1 0 0 0 .12.29c.061.1.148.187.32.36l4.923 4.922c.173.173.26.26.36.322.09.054.188.095.29.12.115.027.237.027.482.027h6.954c.245 0 .367 0 .482-.028a.998.998 0 0 0 .29-.12c.1-.061.187-.148.36-.32l4.922-4.923c.173-.173.26-.26.322-.36a.998.998 0 0 0 .12-.29c.027-.115.027-.237.027-.482V8.523c0-.245 0-.367-.028-.482a.998.998 0 0 0-.12-.29c-.061-.1-.148-.187-.32-.36L16.608 2.47c-.173-.173-.26-.26-.36-.322a1 1 0 0 0-.29-.12C15.844 2 15.722 2 15.477 2H8.523c-.245 0-.367 0-.482.028a1 1 0 0 0-.29.12c-.1.061-.187.148-.36.32L2.47 7.392c-.173.173-.26.26-.322.36a1 1 0 0 0-.12.29C2 8.156 2 8.278 2 8.523Z"
  }))),
  building07: t => e.createElement("svg", KF({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), YF || (YF = e.createElement("path", {
    d: "M7.5 11H4.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 11.76 3 12.04 3 12.6V21m13.5-10h2.9c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C21 11.76 21 12.04 21 12.6V21m-4.5 0V6.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C14.98 3 14.42 3 13.3 3h-2.6c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C7.5 4.52 7.5 5.08 7.5 6.2V21M22 21H2m9-14h2m-2 4h2m-2 4h2"
  }))),
  disc02: t => e.createElement("svg", JF({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), XF || (XF = e.createElement("path", {
    d: "M15 5.674A7 7 0 0 1 19 12M8.392 18A6.996 6.996 0 0 1 5 12m17 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-7 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
  }))),
  linkbroken02: t => e.createElement("svg", t_({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), e_ || (e_ = e.createElement("path", {
    d: "m8.5 15.5 7-7M9 4V2m6 18v2M4 9H2m18 6h2M4.914 4.914 3.5 3.5m15.586 15.586L20.5 20.5M12 17.657l-2.121 2.121a4 4 0 1 1-5.657-5.657L6.343 12m11.314 0 2.121-2.121a4 4 0 0 0-5.657-5.657L12 6.343"
  }))),
  layoutleft: t => e.createElement("svg", n_({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), r_ || (r_ = e.createElement("path", {
    d: "M9 3v18M7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3Z"
  }))),
  linechartdown03: t => e.createElement("svg", o_({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), a_ || (a_ = e.createElement("path", {
    d: "m17 15-5.434-5.434c-.198-.198-.297-.297-.412-.334a.5.5 0 0 0-.309 0c-.114.037-.213.136-.41.334l-1.87 1.868c-.197.198-.296.297-.41.334a.499.499 0 0 1-.31 0c-.114-.037-.213-.136-.41-.334L3 7m14 8h-4m4 0v-4M7.8 21h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Z"
  }))),
  phoneoutgoing01: t => e.createElement("svg", l_({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), i_ || (i_ = e.createElement("path", {
    d: "M21 8V3m0 0h-5m5 0-6 6m-4.773 4.863a14.604 14.604 0 0 1-2.847-4.01 1.698 1.698 0 0 1-.113-.266 1.046 1.046 0 0 1 .147-.862c.048-.067.105-.124.22-.238.35-.35.524-.524.638-.7a2 2 0 0 0 0-2.18c-.114-.176-.289-.351-.638-.7l-.195-.196c-.532-.531-.797-.797-1.083-.941a2 2 0 0 0-1.805 0c-.285.144-.551.41-1.083.941l-.157.158c-.53.53-.795.794-.997 1.154-.224.4-.386 1.02-.384 1.479 0 .413.081.695.241 1.26a19.038 19.038 0 0 0 4.874 8.283 19.039 19.039 0 0 0 8.283 4.873c.565.16.847.24 1.26.242a3.377 3.377 0 0 0 1.478-.384c.36-.203.625-.468 1.155-.997l.157-.158c.532-.531.797-.797.942-1.082a2 2 0 0 0 0-1.806c-.145-.285-.41-.55-.942-1.082l-.195-.195c-.35-.35-.524-.524-.7-.639a2 2 0 0 0-2.18 0c-.176.114-.35.29-.7.639-.115.114-.172.171-.239.22-.237.17-.581.228-.862.146a1.695 1.695 0 0 1-.266-.113 14.605 14.605 0 0 1-4.01-2.846Z"
  }))),
  reverseleft: t => e.createElement("svg", c_({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), s_ || (s_ = e.createElement("path", {
    d: "M4 7h10a6 6 0 0 1 0 12H4M4 7l4-4M4 7l4 4"
  }))),
  lockkeyholecircle: t => e.createElement("svg", m_({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), u_ || (u_ = e.createElement("path", {
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z"
  })), h_ || (h_ = e.createElement("path", {
    d: "M13.732 13.195c-.071-.212-.106-.318-.104-.404a.422.422 0 0 1 .056-.22c.04-.077.146-.176.36-.374a3 3 0 1 0-4.086 0c.212.198.319.297.358.374.042.08.054.129.056.22.002.086-.033.192-.104.404l-.917 2.752c-.119.355-.178.533-.142.675a.5.5 0 0 0 .216.3c.123.078.31.078.685.078h3.78c.375 0 .562 0 .685-.078a.5.5 0 0 0 .216-.3c.036-.142-.024-.32-.142-.675l-.917-2.752Z"
  }))),
  markerpin06: t => e.createElement("svg", f_({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), p_ || (p_ = e.createElement("path", {
    d: "M16 13.374c3.532.695 6 2.28 6 4.126 0 2.485-4.477 4.5-10 4.5S2 19.985 2 17.5c0-1.845 2.468-3.431 6-4.126M12 17V9m0 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
  }))),
  presentationchart01: t => e.createElement("svg", v_({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), d_ || (d_ = e.createElement("path", {
    d: "M12 16v5m0-5 6 5m-6-5-6 5M21 3v8.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 16 17.88 16 16.2 16H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 13.72 3 12.88 3 11.2V3m5 6v3m4-5v5m4-1v1m6-9H2"
  }))),
  usercheck02: t => e.createElement("svg", b_({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), g_ || (g_ = e.createElement("path", {
    d: "M16 21v-1.2c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C13.72 15 12.88 15 11.2 15H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 17.28 2 18.12 2 19.8V21M16 6l2 2 4-4m-9.5 3.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
  }))),
  sliders04: t => e.createElement("svg", y_({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), w_ || (w_ = e.createElement("path", {
    d: "M3 8h12m0 0a3 3 0 1 0 6 0 3 3 0 0 0-6 0Zm-6 8h12M9 16a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
  }))),
  minimize02: t => e.createElement("svg", O_({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), x_ || (x_ = e.createElement("path", {
    d: "M3 8h.2c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C8 5.72 8 4.88 8 3.2V3M3 16h.2c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C8 18.28 8 19.12 8 20.8v.2m8-18v.2c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C18.28 8 19.12 8 20.8 8h.2m-5 13v-.2c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C18.28 16 19.12 16 20.8 16h.2"
  }))),
  lock02: t => e.createElement("svg", j_({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), E_ || (E_ = e.createElement("path", {
    d: "M17 11V8A5 5 0 0 0 7 8v3m.8 10h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2v-.4c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 11 17.88 11 16.2 11H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 13.28 3 14.12 3 15.8v.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Z"
  }))),
  currencyethereum: t => e.createElement("svg", P_({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), C_ || (C_ = e.createElement("path", {
    d: "m4 11 8 2 8-2M4 11l8-9m-8 9 8-2m8 2-8-9m8 9-8-2m0-7v7m-6.5 6 6.5 7 6.5-7-6.5 1.5L5.5 15Z"
  }))),
  arrowcirclebrokendownright: t => e.createElement("svg", k_({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), M_ || (M_ = e.createElement("path", {
    d: "M9.41 2.34a9.996 9.996 0 0 1 9.661 2.589c3.905 3.905 3.905 10.237 0 14.142-3.905 3.905-10.237 3.905-14.142 0a9.996 9.996 0 0 1-2.59-9.66M15 9v6m0 0H9m6 0L5 5"
  }))),
  intersectcircle: t => e.createElement("svg", B_({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), S_ || (S_ = e.createElement("path", {
    d: "M9 16A7 7 0 1 0 9 2a7 7 0 0 0 0 14Z"
  })), N_ || (N_ = e.createElement("path", {
    d: "M15 22a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z"
  }))),
  phoneincoming01: t => e.createElement("svg", R_({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), V_ || (V_ = e.createElement("path", {
    d: "M15 4v5m0 0h5m-5 0 6-6M10.227 13.863a14.604 14.604 0 0 1-2.847-4.01 1.698 1.698 0 0 1-.113-.266 1.046 1.046 0 0 1 .147-.862c.048-.067.105-.124.22-.238.35-.35.524-.524.638-.7a2 2 0 0 0 0-2.18c-.114-.176-.289-.351-.638-.7l-.195-.196c-.532-.531-.797-.797-1.083-.941a2 2 0 0 0-1.805 0c-.285.144-.551.41-1.083.941l-.157.158c-.53.53-.795.794-.997 1.154-.224.4-.386 1.02-.384 1.479 0 .413.081.695.241 1.26a19.038 19.038 0 0 0 4.874 8.283 19.039 19.039 0 0 0 8.283 4.873c.565.16.847.24 1.26.242a3.377 3.377 0 0 0 1.478-.384c.36-.203.625-.468 1.155-.997l.157-.158c.532-.531.797-.797.942-1.082a2 2 0 0 0 0-1.806c-.145-.285-.41-.55-.942-1.082l-.195-.195c-.35-.35-.524-.524-.7-.639a2 2 0 0 0-2.18 0c-.176.114-.35.29-.7.639-.115.114-.172.171-.239.22-.237.17-.581.228-.862.146a1.695 1.695 0 0 1-.266-.113 14.605 14.605 0 0 1-4.01-2.846Z"
  }))),
  letterspacing01: t => e.createElement("svg", T_({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), A_ || (A_ = e.createElement("path", {
    d: "M9 13h6m-8 4 4.272-9.398c.231-.509.347-.763.507-.842a.5.5 0 0 1 .442 0c.16.079.276.333.507.842L17 17m4-14v18M3 3v18"
  }))),
  loading02: t => e.createElement("svg", L_({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), H_ || (H_ = e.createElement("path", {
    d: "M12 2v4m0 12v4M6 12H2m20 0h-4m1.078 7.078L16.25 16.25M19.078 5 16.25 7.828M4.922 19.078 7.75 16.25M4.922 5 7.75 7.828"
  }))),
  drop: t => e.createElement("svg", F_({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), I_ || (I_ = e.createElement("path", {
    d: "M20 14a8 8 0 1 1-15.418-3C5.768 8.068 12 2 12 2s6.232 6.068 7.419 9c.375.926.581 1.94.581 3Z"
  }))),
  barchart04: t => e.createElement("svg", Z_({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), __ || (__ = e.createElement("path", {
    d: "M3 11v10m12-10v10M9 3v18M21 3v18"
  }))),
  barchart10: t => e.createElement("svg", q_({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), D_ || (D_ = e.createElement("path", {
    d: "M9 7H4.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 7.76 3 8.04 3 8.6v10.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C3.76 21 4.04 21 4.6 21H9m0 0h6m-6 0V4.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C9.76 3 10.04 3 10.6 3h2.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C15 3.76 15 4.04 15 4.6V21m0-10h4.4c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C21 11.76 21 12.04 21 12.6v6.8c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437C20.24 21 19.96 21 19.4 21H15"
  }))),
  signal02: t => e.createElement("svg", $_({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), U_ || (U_ = e.createElement("path", {
    d: "M16.243 5.757a6 6 0 0 1 0 8.486m-8.485 0a6 6 0 0 1 0-8.486m-2.83 11.314c-3.904-3.905-3.904-10.237 0-14.142m14.143 0c3.906 3.905 3.906 10.237 0 14.142M12.002 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 0v9"
  }))),
  imageleft: t => e.createElement("svg", W_({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), z_ || (z_ = e.createElement("path", {
    d: "m19 8-3-3m0 0 3-3m-3 3h6m-9.5-2H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21H17c.93 0 1.395 0 1.776-.102a3 3 0 0 0 2.122-2.122C21 18.395 21 17.93 21 17M10.5 8.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4.49 3.418-8.459 7.69c-.476.433-.714.649-.735.836a.5.5 0 0 0 .167.431C6.105 21 6.426 21 7.07 21h9.387c1.44 0 2.159 0 2.724-.242a3 3 0 0 0 1.578-1.578c.242-.565.242-1.285.242-2.724 0-.484 0-.726-.053-.952a2.001 2.001 0 0 0-.374-.778c-.143-.182-.332-.333-.71-.636l-2.797-2.237c-.379-.303-.568-.454-.776-.508a1 1 0 0 0-.557.018c-.205.066-.384.23-.743.555Z"
  }))),
  send01: t => e.createElement("svg", G_({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Q_ || (Q_ = e.createElement("path", {
    d: "M10.5 13.5 21 3M10.627 13.828l2.628 6.758c.232.596.347.893.514.98a.5.5 0 0 0 .462 0c.167-.086.283-.384.515-.979L21.336 3.7c.21-.537.315-.805.258-.977a.5.5 0 0 0-.316-.316c-.172-.057-.44.048-.978.257L3.413 9.253c-.595.233-.893.349-.98.516a.5.5 0 0 0 0 .461c.087.167.385.283.98.514l6.758 2.629c.121.047.182.07.233.106a.5.5 0 0 1 .116.117c.037.051.06.111.107.232Z"
  }))),
  trenddown01: t => e.createElement("svg", K_({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Y_ || (Y_ = e.createElement("path", {
    d: "m22 17-7.869-7.869c-.396-.396-.594-.594-.822-.668a1 1 0 0 0-.618 0c-.228.074-.426.272-.822.668L9.13 11.87c-.396.396-.594.594-.822.668a1 1 0 0 1-.618 0c-.228-.074-.426-.272-.822-.668L2 7m20 10h-7m7 0v-7"
  }))),
  banknote03: t => e.createElement("svg", J_({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), X_ || (X_ = e.createElement("path", {
    d: "M14 9h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3H10m2-7v1m0 6v1m6-4h.01M6 12h.01M2 8.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 19 4.08 19 5.2 19h13.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C22 17.48 22 16.92 22 15.8V8.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 5 19.92 5 18.8 5H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 6.52 2 7.08 2 8.2ZM18.5 12a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm-12 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
  }))),
  attachment02: t => e.createElement("svg", tZ({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), eZ || (eZ = e.createElement("path", {
    d: "M17.5 5.256V16.5a5.5 5.5 0 1 1-11 0V5.667a3.667 3.667 0 0 1 7.333 0v10.779a1.833 1.833 0 1 1-3.666 0V6.65"
  }))),
  brush03: t => e.createElement("svg", nZ({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), rZ || (rZ = e.createElement("path", {
    d: "M20 10V3.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C19.24 2 18.96 2 18.4 2H5.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C4 2.76 4 3.04 4 3.6V10m16 0H4m16 0v.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C17.72 15 16.88 15 15.2 15H8.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 12.72 4 11.88 4 10.2V10m10.5 5v4.5a2.5 2.5 0 0 1-5 0V15"
  }))),
  barchartcircle02: t => e.createElement("svg", oZ({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), aZ || (aZ = e.createElement("path", {
    d: "M8 15v2m4-6v6m4-10v10m6-5c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }))),
  hourglass01: t => e.createElement("svg", lZ({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), iZ || (iZ = e.createElement("path", {
    d: "M12 12 7.727 8.44c-.635-.53-.952-.794-1.18-1.119a3 3 0 0 1-.444-.947C6 5.991 6 5.578 6 4.752V2m6 10 4.273-3.56c.635-.53.952-.794 1.18-1.119a3 3 0 0 0 .444-.947C18 5.991 18 5.578 18 4.752V2m-6 10-4.273 3.56c-.635.53-.952.794-1.18 1.119a3 3 0 0 0-.444.947C6 18.009 6 18.422 6 19.248V22m6-10 4.273 3.56c.635.53.952.794 1.18 1.119a3 3 0 0 1 .444.947c.103.383.103.796.103 1.622V22M4 2h16M4 22h16"
  }))),
  edit05: t => e.createElement("svg", cZ({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), sZ || (sZ = e.createElement("path", {
    d: "M11 4H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 6.28 2 7.12 2 8.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 22 5.12 22 6.8 22h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 19.72 20 18.88 20 17.2V13M8 16h1.675c.489 0 .733 0 .963-.055.204-.05.4-.13.579-.24.201-.123.374-.296.72-.642L21.5 5.5a2.121 2.121 0 0 0-3-3l-9.563 9.563c-.346.346-.519.519-.642.72a2 2 0 0 0-.24.579c-.055.23-.055.474-.055.963V16Z"
  }))),
  scale02: t => e.createElement("svg", hZ({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), uZ || (uZ = e.createElement("path", {
    d: "M16 21h.2c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8V8m8.5 4.5L17 7m0 0h-5m5 0v5M6.2 21h2.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C12 19.48 12 18.92 12 17.8v-2.6c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C10.48 12 9.92 12 8.8 12H6.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C3 13.52 3 14.08 3 15.2v2.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C4.52 21 5.08 21 6.2 21Z"
  }))),
  uploadcloud02: t => e.createElement("svg", pZ({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), mZ || (mZ = e.createElement("path", {
    d: "m8 16 4-4m0 0 4 4m-4-4v9m8-4.257A5.5 5.5 0 0 0 16.5 7a.62.62 0 0 1-.534-.302 7.5 7.5 0 1 0-11.78 9.096"
  }))),
  trash03: t => e.createElement("svg", dZ({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), fZ || (fZ = e.createElement("path", {
    d: "M9 3h6M3 6h18m-2 0-.701 10.52c-.105 1.578-.158 2.367-.499 2.965a3 3 0 0 1-1.298 1.215c-.62.3-1.41.3-2.993.3h-3.018c-1.582 0-2.373 0-2.993-.3A3 3 0 0 1 6.2 19.485c-.34-.598-.394-1.387-.499-2.966L5 6m5 4.5v5m4-5v5"
  }))),
  calculator: t => e.createElement("svg", gZ({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), vZ || (vZ = e.createElement("path", {
    d: "m17.5 6.5-11 11m2-7v-4m-2 2h4m3 7h4M7.8 21h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Z"
  }))),
  rows03: t => e.createElement("svg", wZ({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), bZ || (bZ = e.createElement("path", {
    d: "M3 9h18M3 15h18M7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3Z"
  }))),
  trash01: t => e.createElement("svg", xZ({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), yZ || (yZ = e.createElement("path", {
    d: "M16 6v-.8c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C14.48 2 13.92 2 12.8 2h-1.6c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C8 3.52 8 4.08 8 5.2V6m2 5.5v5m4-5v5M3 6h18m-2 0v11.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C16.72 22 15.88 22 14.2 22H9.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C5 19.72 5 18.88 5 17.2V6"
  }))),
  home02: t => e.createElement("svg", EZ({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), OZ || (OZ = e.createElement("path", {
    d: "M9 21v-7.4c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C9.76 12 10.04 12 10.6 12h2.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C15 12.76 15 13.04 15 13.6V21M11.018 2.764 4.235 8.039c-.453.353-.68.53-.843.75a2 2 0 0 0-.318.65C3 9.704 3 9.991 3 10.565V17.8c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C4.52 21 5.08 21 6.2 21h11.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C21 19.48 21 18.92 21 17.8v-7.235c0-.574 0-.861-.074-1.126a2.002 2.002 0 0 0-.318-.65c-.163-.22-.39-.397-.843-.75l-6.783-5.275c-.351-.273-.527-.41-.72-.462a1 1 0 0 0-.523 0c-.194.052-.37.189-.721.462Z"
  }))),
  image05: t => e.createElement("svg", CZ({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), jZ || (jZ = e.createElement("path", {
    d: "M19 21h1.01c.972 0 1.457 0 1.725-.203a1 1 0 0 0 .395-.737c.02-.335-.25-.74-.788-1.547l-3.01-4.516c-.446-.668-.668-1.002-.949-1.118a1 1 0 0 0-.766 0c-.28.116-.503.45-.948 1.118l-.744 1.116M19 21 11.316 9.9c-.442-.638-.663-.957-.94-1.07a1 1 0 0 0-.752 0c-.276.113-.497.432-.94 1.07l-5.946 8.59c-.563.813-.844 1.22-.828 1.557a1 1 0 0 0 .391.747c.27.206.764.206 1.753.206H19Zm2-15a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
  }))),
  rows01: t => e.createElement("svg", MZ({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), PZ || (PZ = e.createElement("path", {
    d: "M17.8 10c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C21 8.48 21 7.92 21 6.8v-.6c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C19.48 3 18.92 3 17.8 3H6.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C3 4.52 3 5.08 3 6.2v.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C4.52 10 5.08 10 6.2 10h11.6ZM17.8 21c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C21 19.48 21 18.92 21 17.8v-.6c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C19.48 14 18.92 14 17.8 14H6.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C3 15.52 3 16.08 3 17.2v.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C4.52 21 5.08 21 6.2 21h11.6Z"
  }))),
  lockunlocked04: t => e.createElement("svg", SZ({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), kZ || (kZ = e.createElement("path", {
    d: "M7 10V8a5 5 0 0 1 9-3m-4 9v2m7-1a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
  }))),
  award02: t => e.createElement("svg", BZ({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), NZ || (NZ = e.createElement("path", {
    d: "M7 15.09V22l4.703-1.881c.11-.044.165-.066.221-.075a.5.5 0 0 1 .152 0c.056.009.111.03.221.075L17 22v-6.91m2.5-5.59a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0Z"
  }))),
  mouse: t => e.createElement("svg", RZ({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), VZ || (VZ = e.createElement("path", {
    d: "M12 9V6m0 16a7 7 0 0 1-7-7V9a7 7 0 0 1 14 0v6a7 7 0 0 1-7 7Z"
  }))),
  sale04: t => e.createElement("svg", TZ({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), AZ || (AZ = e.createElement("path", {
    d: "M9 9h.01M15 15h.01M16 8l-8 8m1.202 4.6a1.24 1.24 0 0 1 .92.247l1.203.924c.398.305.951.305 1.348 0l1.248-.959c.234-.179.528-.258.82-.219l1.561.206c.497.065.976-.212 1.168-.675l.601-1.453c.112-.272.328-.488.6-.6l1.453-.601c.464-.191.74-.671.675-1.168l-.198-1.505a1.24 1.24 0 0 1 .247-.92l.923-1.204a1.105 1.105 0 0 0 0-1.347l-.959-1.25a1.105 1.105 0 0 1-.219-.818l.206-1.562a1.108 1.108 0 0 0-.675-1.168l-1.453-.601a1.103 1.103 0 0 1-.6-.6l-.6-1.453a1.107 1.107 0 0 0-1.169-.675l-1.562.206a1.1 1.1 0 0 1-.817-.217l-1.25-.959a1.105 1.105 0 0 0-1.347 0l-1.249.959a1.115 1.115 0 0 1-.818.219L7.696 3.2a1.108 1.108 0 0 0-1.167.675l-.6 1.453a1.117 1.117 0 0 1-.6.6l-1.453.6c-.464.192-.74.671-.675 1.168l.206 1.562c.038.291-.041.585-.219.818l-.959 1.249a1.105 1.105 0 0 0 0 1.347l.959 1.25c.179.232.258.527.219.818L3.2 16.303c-.065.497.211.976.675 1.168l1.453.601c.272.112.488.328.6.6l.6 1.453c.192.464.672.74 1.169.675l1.504-.2ZM9.5 9a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm6 6a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
  }))),
  pentagon: t => e.createElement("svg", LZ({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), HZ || (HZ = e.createElement("path", {
    d: "M11.06 2.932c.338-.245.507-.368.692-.415a1 1 0 0 1 .497 0c.184.047.353.17.691.415l8.119 5.892c.338.246.507.368.61.53a1 1 0 0 1 .153.473c.012.19-.052.39-.182.787l-3.1 9.53c-.13.398-.194.597-.315.744a1 1 0 0 1-.403.292c-.177.07-.386.07-.803.07H6.982c-.418 0-.626 0-.804-.07a1 1 0 0 1-.402-.292c-.122-.147-.186-.346-.316-.743l-3.1-9.531c-.13-.398-.194-.597-.182-.787a1 1 0 0 1 .154-.473c.102-.162.272-.284.61-.53l8.118-5.892Z"
  }))),
  messagesquare02: t => e.createElement("svg", FZ({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), IZ || (IZ = e.createElement("path", {
    d: "M3 7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v5.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 18 17.88 18 16.2 18h-2.516c-.624 0-.936 0-1.235.061a2.997 2.997 0 0 0-.761.267c-.272.14-.516.334-1.003.724L8.3 20.96c-.416.333-.624.5-.8.5a.5.5 0 0 1-.39-.188C7 21.135 7 20.868 7 20.336V18c-.93 0-1.395 0-1.776-.102a3 3 0 0 1-2.122-2.121C3 15.395 3 14.93 3 14V7.8Z"
  }))),
  hourglass03: t => e.createElement("svg", ZZ({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), _Z || (_Z = e.createElement("path", {
    d: "M9 18.5h6M6.6 2h10.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C19 2.76 19 3.04 19 3.6v2.075c0 .489 0 .733-.055.963-.05.205-.13.4-.24.579-.123.201-.296.374-.642.72L15.13 10.87c-.396.396-.594.594-.668.822a1 1 0 0 0 0 .618c.074.228.272.426.668.822l2.932 2.932c.346.346.519.519.642.72.11.18.19.374.24.578.055.23.055.475.055.965V20.4c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437C18.24 22 17.96 22 17.4 22H6.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C5 21.24 5 20.96 5 20.4v-2.074c0-.49 0-.734.055-.965.05-.204.13-.399.24-.578.123-.201.296-.374.642-.72L8.87 13.13c.396-.396.594-.594.668-.822a1 1 0 0 0 0-.618c-.074-.228-.272-.426-.668-.822L5.937 7.937c-.346-.346-.519-.519-.642-.72a2 2 0 0 1-.24-.579C5 6.408 5 6.164 5 5.675V3.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C5.76 2 6.04 2 6.6 2Z"
  }))),
  userright02: t => e.createElement("svg", qZ({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), DZ || (DZ = e.createElement("path", {
    d: "m19 9 3-3m0 0-3-3m3 3h-6m0 15v-1.2c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C13.72 15 12.88 15 11.2 15H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 17.28 2 18.12 2 19.8V21M12.5 7.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
  }))),
  codesnippet01: t => e.createElement("svg", $Z({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), UZ || (UZ = e.createElement("path", {
    d: "m16 18 6-6-6-6M8 6l-6 6 6 6"
  }))),
  activityheart: t => e.createElement("svg", WZ({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), zZ || (zZ = e.createElement("path", {
    d: "M15.5 11.5h-1l-1.5 3-2-6-1.5 3h-1m3.493-6.364c-2-2.338-5.333-2.966-7.838-.826s-2.858 5.719-.89 8.25c1.485 1.912 5.706 5.751 7.683 7.515.363.324.545.486.758.55.184.055.39.055.575 0 .212-.064.394-.226.757-.55 1.977-1.764 6.198-5.603 7.684-7.515 1.967-2.531 1.658-6.132-.89-8.25-2.549-2.118-5.84-1.512-7.839.826Z"
  }))),
  cloudraining05: t => e.createElement("svg", GZ({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), QZ || (QZ = e.createElement("path", {
    d: "M16 18.5 15 21m-7-2.5L7 21m5-2.5L11 21m-4-6a5 5 0 1 1 .1-9.999 5.502 5.502 0 0 1 10.195 1.004A4.5 4.5 0 1 1 17.5 15H6.999Z"
  }))),
  calendarminus01: t => e.createElement("svg", KZ({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), YZ || (YZ = e.createElement("path", {
    d: "M9 15h6m6-7H3m13-6v3M8 2v3m-.2 17h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 19.72 21 18.88 21 17.2V8.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 4 17.88 4 16.2 4H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 6.28 3 7.12 3 8.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 22 6.12 22 7.8 22Z"
  }))),
  brush01: t => e.createElement("svg", JZ({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), XZ || (XZ = e.createElement("path", {
    d: "M9 11.222 12.778 15m-4.803 5.975C6.608 22.342 4 22 2 22c1.025-2-.342-4.608 1.025-5.975a3.5 3.5 0 0 1 4.95 4.95Zm3.947-5.05 9.137-9.868a2.204 2.204 0 0 0-3.116-3.116L8.075 12.08c-.51.472-.765.708-.913.96a2 2 0 0 0-.038 1.967c.139.257.385.503.876.994.491.492.737.737.994.876a2 2 0 0 0 1.968-.038c.251-.148.487-.403.96-.913Z"
  }))),
  creditcardup: t => e.createElement("svg", tD({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), eD || (eD = e.createElement("path", {
    d: "m16 18 3-3m0 0 3 3m-3-3v6m3-11H2m20 2V8.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 5 19.92 5 18.8 5H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 6.52 2 7.08 2 8.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 19 4.08 19 5.2 19H12"
  }))),
  send03: t => e.createElement("svg", nD({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), rD || (rD = e.createElement("path", {
    d: "M10.5 12H5m-.084.291L2.58 19.267c-.184.548-.275.822-.21.99a.5.5 0 0 0 .332.3c.174.05.438-.07.965-.306l16.711-7.52c.515-.232.772-.348.851-.508a.5.5 0 0 0 0-.444c-.08-.16-.336-.276-.85-.508L3.661 3.748c-.525-.237-.788-.355-.962-.306a.5.5 0 0 0-.332.299c-.066.168.025.442.206.988l2.342 7.057c.032.094.047.14.053.188a.5.5 0 0 1 0 .129c-.006.048-.022.095-.053.188Z"
  }))),
  microphone01: t => e.createElement("svg", oD({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), aD || (aD = e.createElement("path", {
    d: "M19 10v2a7 7 0 0 1-7 7m-7-9v2a7 7 0 0 0 7 7m0 0v3m-4 0h8m-4-7a3 3 0 0 1-3-3V5a3 3 0 1 1 6 0v7a3 3 0 0 1-3 3Z"
  }))),
  banknote01: t => e.createElement("svg", lD({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), iD || (iD = e.createElement("path", {
    d: "M6 11v4m12-6v4m-1-9c2.449 0 3.773.375 4.432.665a.708.708 0 0 1 .258.18c.076.072.215.284.25.383.06.165.06.255.06.435V16.41c0 .909 0 1.363-.136 1.597a.872.872 0 0 1-.532.44c-.255.089-.77-.01-1.8-.208-.72-.138-1.576-.24-2.532-.24-3 0-6 2-10 2-2.449 0-3.773-.375-4.432-.665-.088-.04-.132-.059-.258-.18a1.463 1.463 0 0 1-.25-.383C2 18.607 2 18.517 2 18.337V7.59c0-.909 0-1.363.136-1.597a.871.871 0 0 1 .532-.44c.255-.089.77.01 1.8.208C5.188 5.898 6.043 6 7 6c3 0 6-2 10-2Zm-2.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"
  }))),
  barchart06: t => e.createElement("svg", cD({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), sD || (sD = e.createElement("path", {
    d: "M9 8v13m12-4v4M3 3v18m12-8v8"
  }))),
  checkdone01: t => e.createElement("svg", hD({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), uD || (uD = e.createElement("path", {
    d: "m6 15 2 2 4.5-4.5M8 8V5.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C9.52 2 10.08 2 11.2 2h7.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C22 3.52 22 4.08 22 5.2v7.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C20.48 16 19.92 16 18.8 16H16M5.2 22h7.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C16 20.48 16 19.92 16 18.8v-7.6c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C14.48 8 13.92 8 12.8 8H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 9.52 2 10.08 2 11.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 22 4.08 22 5.2 22Z"
  }))),
  userplus01: t => e.createElement("svg", pD({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), mD || (mD = e.createElement("path", {
    d: "M12 15.5H7.5c-1.396 0-2.093 0-2.661.172a4 4 0 0 0-2.667 2.667C2 18.907 2 19.604 2 21m17 0v-6m-3 3h6M14.5 7.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Z"
  }))),
  watchsquare: t => e.createElement("svg", dD({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), fD || (fD = e.createElement("path", {
    d: "m17 18.5-.337 1.18c-.238.831-.356 1.247-.6 1.556a1.999 1.999 0 0 1-.815.616c-.364.148-.796.148-1.662.148h-3.172c-.865 0-1.298 0-1.662-.148a2 2 0 0 1-.816-.616c-.243-.309-.361-.725-.6-1.557L7 18.5m10-13-.337-1.18c-.238-.831-.356-1.247-.6-1.556a2 2 0 0 0-.815-.616C14.884 2 14.452 2 13.586 2h-3.172c-.865 0-1.298 0-1.662.148a2 2 0 0 0-.816.616c-.243.309-.361.725-.6 1.557L7 5.5M12 9v3l1.5 1.5m-4.8 5h6.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874c.218-.428.218-.988.218-2.108V8.7c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C16.98 5.5 16.42 5.5 15.3 5.5H8.7c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C5.5 7.02 5.5 7.58 5.5 8.7v6.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874c.428.218.988.218 2.108.218Z"
  }))),
  barchart12: t => e.createElement("svg", gD({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), vD || (vD = e.createElement("path", {
    d: "M9 12H4.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 12.76 3 13.04 3 13.6v5.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C3.76 21 4.04 21 4.6 21H9m0 0h6m-6 0V8.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C9.76 7 10.04 7 10.6 7h2.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C15 7.76 15 8.04 15 8.6V21m0 0h4.4c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C21 20.24 21 19.96 21 19.4V4.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C20.24 3 19.96 3 19.4 3h-2.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C15 3.76 15 4.04 15 4.6V8"
  }))),
  filecode02: t => e.createElement("svg", wD({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), bD || (bD = e.createElement("path", {
    d: "M5 18.5c0 .464 0 .697.026.892a3 3 0 0 0 2.582 2.582c.195.026.428.026.892.026h7.7c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 19.72 21 18.88 21 17.2V9.988c0-.734 0-1.1-.083-1.446a3 3 0 0 0-.36-.867c-.185-.303-.444-.562-.963-1.08l-3.188-3.19c-.519-.518-.778-.777-1.081-.963a3.001 3.001 0 0 0-.867-.36C14.112 2 13.745 2 13.012 2H8.5c-.464 0-.697 0-.892.026a3 3 0 0 0-2.582 2.582C5 4.803 5 5.036 5 5.5m4 9 2.5-2.5L9 9.5m-4 0L2.5 12 5 14.5"
  }))),
  messagechecksquare: t => e.createElement("svg", xD({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), yD || (yD = e.createElement("path", {
    d: "m9 10.5 2 2L15.5 8M7 18v2.335c0 .533 0 .8.11.937a.5.5 0 0 0 .39.188c.176 0 .384-.167.8-.5l2.385-1.908c.487-.39.731-.585 1.002-.724.241-.122.497-.212.762-.267.299-.061.61-.061 1.235-.061H16.2c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 15.72 21 14.88 21 13.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8V14c0 .93 0 1.395.102 1.777a3 3 0 0 0 2.122 2.12C5.605 18 6.07 18 7 18Z"
  }))),
  arrowcircleupright: t => e.createElement("svg", ED({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), OD || (OD = e.createElement("path", {
    d: "M15 15V9m0 0H9m6 0-6 6m13-3c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }))),
  griddotshorizontalcenter: t => e.createElement("svg", CD({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), jD || (jD = e.createElement("path", {
    d: "M3 3h.01M3 12h.01M3 21h.01M3 16.5h.01M3 7.5h.01M7.5 3h.01m-.01 9h.01m-.01 9h.01M16.5 3h.01m-.01 9h.01m-.01 9h.01M21 3h.01M21 12h.01M21 21h.01M21 16.5h.01m-.01-9h.01M12 21V3"
  }))),
  type02: t => e.createElement("svg", MD({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), PD || (PD = e.createElement("path", {
    d: "M4 7c0-.932 0-1.398.152-1.765a2 2 0 0 1 1.083-1.083C5.602 4 6.068 4 7 4h10c.932 0 1.398 0 1.765.152a2 2 0 0 1 1.083 1.083C20 5.602 20 6.068 20 7M8 20h8M10.25 4v16m3.5-16v16"
  }))),
  folder: t => e.createElement("svg", SD({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), kD || (kD = e.createElement("path", {
    d: "m13 7-1.116-2.231c-.32-.642-.481-.963-.72-1.198a2 2 0 0 0-.748-.462C10.1 3 9.74 3 9.022 3H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 4.52 2 5.08 2 6.2V7m0 0h15.2c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C22 9.28 22 10.12 22 11.8v4.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C19.72 21 18.88 21 17.2 21H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.72 2 17.88 2 16.2V7Z"
  }))),
  messagechatsquare: t => e.createElement("svg", BD({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ND || (ND = e.createElement("path", {
    d: "m10 15-3.075 3.114c-.43.434-.644.651-.828.666a.5.5 0 0 1-.421-.172c-.12-.14-.12-.446-.12-1.056v-1.56c0-.548-.449-.944-.99-1.024a3 3 0 0 1-2.534-2.533C2 12.219 2 11.96 2 11.445V6.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C4.28 2 5.12 2 6.8 2h7.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C19 4.28 19 5.12 19 6.8V11m0 11-2.176-1.513c-.306-.213-.46-.32-.626-.395a2.002 2.002 0 0 0-.462-.145c-.18-.033-.367-.033-.74-.033H13.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C10 18.394 10 17.834 10 16.714V14.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C11.52 11 12.08 11 13.2 11h5.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C22 12.52 22 13.08 22 14.2v2.714c0 .932 0 1.398-.152 1.766a2 2 0 0 1-1.083 1.082c-.367.152-.833.152-1.765.152V22Z"
  }))),
  markerpin04: t => e.createElement("svg", RD({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), VD || (VD = e.createElement("path", {
    d: "M5 14.286c-1.851.817-3 1.955-3 3.214C2 19.985 6.477 22 12 22s10-2.015 10-4.5c0-1.259-1.149-2.397-3-3.214M18 8c0 4.064-4.5 6-6 9-1.5-3-6-4.936-6-9a6 6 0 1 1 12 0Zm-5 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
  }))),
  presentationchart03: t => e.createElement("svg", TD({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), AD || (AD = e.createElement("path", {
    d: "M12 16v5m0-5 6 5m-6-5-6 5M8 7v5m4-3v3m4-1v1m6-9H2m1 0h18v8.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 16 17.88 16 16.2 16H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 13.72 3 12.88 3 11.2V3Z"
  }))),
  filedownload02: t => e.createElement("svg", LD({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), HD || (HD = e.createElement("path", {
    d: "M20 12.5V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 2 16.88 2 15.2 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22h3.7M14 11H8m2 4H8m8-8H8m7 12 3 3m0 0 3-3m-3 3v-6"
  }))),
  typestrikethrough02: t => e.createElement("svg", FD({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), ID || (ID = e.createElement("path", {
    d: "M8 20h8m-5.75-9.5V20m3.5-6v6M3 3l18 18M4 7V6c0-.541.215-1.032.564-1.392M9.5 4H17c.932 0 1.398 0 1.765.152a2 2 0 0 1 1.083 1.083C20 5.602 20 6.068 20 7m-9.75-3v1m3.5-1v4"
  }))),
  messageheartcircle: t => e.createElement("svg", DD({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), _D || (_D = e.createElement("path", {
    d: "M21 11.5a8.5 8.5 0 0 1-11.555 7.934c-.174-.066-.26-.1-.33-.116a.901.901 0 0 0-.186-.024 2.314 2.314 0 0 0-.303.021l-5.12.53c-.49.05-.733.075-.877-.013a.5.5 0 0 1-.234-.35c-.026-.166.09-.382.324-.814l1.636-3.027c.134-.25.202-.374.232-.494a.899.899 0 0 0 .028-.326c-.01-.123-.064-.283-.172-.604A8.5 8.5 0 1 1 21 11.5Z"
  })), ZD || (ZD = e.createElement("path", {
    d: "M12.496 8.95c-.9-1.04-2.4-1.319-3.527-.368-1.127.951-1.286 2.542-.4 3.667.548.697 1.924 1.97 2.893 2.838.355.319.533.478.746.542.183.055.394.055.577 0 .213-.064.39-.223.746-.542.969-.868 2.345-2.14 2.894-2.838a2.606 2.606 0 0 0-.401-3.667c-1.147-.941-2.628-.672-3.528.367Z",
    clipRule: "evenodd"
  }))),
  cornerdownleft: t => e.createElement("svg", UD({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), qD || (qD = e.createElement("path", {
    d: "M20 4v1.4c0 3.36 0 5.04-.654 6.324a6 6 0 0 1-2.622 2.622C15.44 15 13.76 15 10.4 15H4m0 0 5-5m-5 5 5 5"
  }))),
  linechartdown01: t => e.createElement("svg", zD({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), $D || ($D = e.createElement("path", {
    d: "M21 21H4.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C3 20.24 3 19.96 3 19.4V3m17 12-3.919-4.183c-.148-.158-.223-.237-.312-.278a.5.5 0 0 0-.253-.044c-.098.01-.194.06-.387.16l-3.258 1.69c-.193.1-.289.15-.387.16a.5.5 0 0 1-.253-.044c-.09-.04-.164-.12-.312-.278L7 8"
  }))),
  usbflashdrive: t => e.createElement("svg", QD({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), WD || (WD = e.createElement("path", {
    d: "M18 9V3.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C17.24 2 16.96 2 16.4 2H7.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C6 2.76 6 3.04 6 3.6V9m4-3V5m4 1V5M8.8 22h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 19.72 20 18.88 20 17.2v-5c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C18.48 9 17.92 9 16.8 9H7.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C4 10.52 4 11.08 4 12.2v5c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22Z"
  }))),
  building05: t => e.createElement("svg", YD({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), GD || (GD = e.createElement("path", {
    d: "M13 11h4.8c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C21 12.52 21 13.08 21 14.2V21m-8 0V6.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C11.48 3 10.92 3 9.8 3H6.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C3 4.52 3 5.08 3 6.2V21m19 0H2M6.5 7h3m-3 4h3m-3 4h3"
  }))),
  chevronrightdouble: t => e.createElement("svg", XD({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), KD || (KD = e.createElement("path", {
    d: "m6 17 5-5-5-5m7 10 5-5-5-5"
  }))),
  batterycharging02: t => e.createElement("svg", eq({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), JD || (JD = e.createElement("path", {
    d: "m9.5 18 4-6h-6l4-6M22 13v-2m-8 7h.2c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C19 15.72 19 14.88 19 13.2V10c0-.93 0-1.395-.102-1.776a3 3 0 0 0-2.122-2.122C16.395 6 15.93 6 15 6M7 6h-.2c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 8.28 2 9.12 2 10.8V14c0 .93 0 1.395.102 1.777a3 3 0 0 0 2.122 2.12C4.605 18 5.07 18 6 18"
  }))),
  clipboardcheck: t => e.createElement("svg", rq({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), tq || (tq = e.createElement("path", {
    d: "M16 4c.93 0 1.395 0 1.776.102a3 3 0 0 1 2.122 2.122C20 6.605 20 7.07 20 8v9.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C17.72 22 16.88 22 15.2 22H8.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.72 4 18.88 4 17.2V8c0-.93 0-1.395.102-1.776a3 3 0 0 1 2.122-2.122C6.605 4 7.07 4 8 4m1 11 2 2 4.5-4.5M9.6 6h4.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C16 5.24 16 4.96 16 4.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C15.24 2 14.96 2 14.4 2H9.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C8 2.76 8 3.04 8 3.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C8.76 6 9.04 6 9.6 6Z"
  }))),
  minus: t => e.createElement("svg", aq({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), nq || (nq = e.createElement("path", {
    d: "M5 12h14"
  }))),
  scissorscut01: t => e.createElement("svg", iq({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), oq || (oq = e.createElement("path", {
    d: "M20 4 8.5 15.5m0-7L20 20m-2.5-8h.01M22 12h.01M6 3a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 12a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z"
  }))),
  mail01: t => e.createElement("svg", sq({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), lq || (lq = e.createElement("path", {
    d: "m2 7 8.165 5.715c.661.463.992.695 1.351.784a2 2 0 0 0 .968 0c.36-.09.69-.32 1.351-.784L22 7M6.8 20h10.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 17.72 22 16.88 22 15.2V8.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C19.72 4 18.88 4 17.2 4H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 6.28 2 7.12 2 8.8v6.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 20 5.12 20 6.8 20Z"
  }))),
  disc01: t => e.createElement("svg", hq({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), cq || (cq = e.createElement("path", {
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z"
  })), uq || (uq = e.createElement("path", {
    d: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
  }))),
  building04: t => e.createElement("svg", pq({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), mq || (mq = e.createElement("path", {
    d: "M9.5 7h5m-5 4h5m-5 4h5m3.5 6V6.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C16.48 3 15.92 3 14.8 3H9.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C6 4.52 6 5.08 6 6.2V21m14 0H4"
  }))),
  helpcircle: t => e.createElement("svg", dq({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), fq || (fq = e.createElement("path", {
    d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3m.08 4h.01M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }))),
  chevronleft: t => e.createElement("svg", gq({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), vq || (vq = e.createElement("path", {
    d: "m15 18-6-6 6-6"
  }))),
  annotation: t => e.createElement("svg", wq({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), bq || (bq = e.createElement("path", {
    d: "M3 7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v5.7c0 1.398 0 2.097-.228 2.648a3 3 0 0 1-1.624 1.624C18.597 18 17.898 18 16.5 18c-.489 0-.733 0-.96.053a2 2 0 0 0-.821.412c-.18.149-.326.344-.619.735l-1.46 1.947c-.217.29-.326.434-.459.486a.5.5 0 0 1-.362 0c-.133-.052-.242-.197-.459-.486L9.9 19.2c-.293-.39-.44-.586-.619-.735a2 2 0 0 0-.821-.412C8.233 18 7.989 18 7.5 18c-1.398 0-2.097 0-2.648-.228a3 3 0 0 1-1.624-1.624C3 15.597 3 14.898 3 13.5V7.8Z"
  }))),
  linkbroken01: t => e.createElement("svg", xq({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), yq || (yq = e.createElement("path", {
    d: "M9 4V2m6 18v2M4 9H2m18 6h2M4.914 4.914 3.5 3.5m15.586 15.586L20.5 20.5M12 17.657l-2.121 2.121a4 4 0 1 1-5.657-5.657L6.343 12m11.314 0 2.121-2.121a4 4 0 1 0-5.657-5.657L12 6.343"
  }))),
  phoneoutgoing02: t => e.createElement("svg", Eq({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Oq || (Oq = e.createElement("path", {
    d: "M17.5 3 21 6.5m0 0L17.5 10M21 6.5h-8m-2.773 7.363a14.604 14.604 0 0 1-2.847-4.01 1.698 1.698 0 0 1-.113-.266 1.046 1.046 0 0 1 .147-.862c.048-.067.105-.124.22-.238.35-.35.524-.524.638-.7a2 2 0 0 0 0-2.18c-.114-.176-.289-.351-.638-.7l-.195-.196c-.532-.531-.797-.797-1.083-.941a2 2 0 0 0-1.805 0c-.285.144-.551.41-1.083.941l-.157.158c-.53.53-.795.794-.997 1.154-.224.4-.386 1.02-.384 1.479 0 .413.081.695.241 1.26a19.038 19.038 0 0 0 4.874 8.283 19.039 19.039 0 0 0 8.283 4.873c.565.16.847.24 1.26.242a3.377 3.377 0 0 0 1.478-.384c.36-.203.625-.468 1.155-.997l.157-.158c.532-.531.797-.797.942-1.082a2 2 0 0 0 0-1.806c-.145-.285-.41-.55-.942-1.082l-.195-.195c-.35-.35-.524-.524-.7-.639a2 2 0 0 0-2.18 0c-.176.114-.35.29-.7.639-.115.114-.172.171-.239.22-.237.17-.581.228-.862.146a1.695 1.695 0 0 1-.266-.113 14.605 14.605 0 0 1-4.01-2.846Z"
  }))),
  shieldoff: t => e.createElement("svg", Cq({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), jq || (jq = e.createElement("path", {
    d: "m8.809 3.197 2.63-.986c.207-.078.311-.117.418-.133a1 1 0 0 1 .286 0c.107.016.21.055.419.133l5.362 2.01c.748.28 1.123.421 1.398.664a2 2 0 0 1 .547.79c.131.343.131.743.131 1.542V12c0 .72-.115 1.412-.318 2.07m-2.06 3.555c-1.686 1.96-3.834 3.354-4.922 3.989-.223.13-.334.194-.49.228a1.137 1.137 0 0 1-.42 0c-.156-.034-.267-.098-.488-.227C9.354 20.478 4 16.908 4 12V5.776c0-.467.29-.885.727-1.049M3 3l18 18"
  }))),
  filedownload03: t => e.createElement("svg", Mq({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Pq || (Pq = e.createElement("path", {
    d: "M14 2.27V6.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437c.214.11.494.11 1.054.11h4.13M9 15l3 3m0 0 3-3m-3 3v-6m2-10H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 19.72 20 18.88 20 17.2V8l-6-6Z"
  }))),
  usercheck01: t => e.createElement("svg", Sq({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), kq || (kq = e.createElement("path", {
    d: "M12 15.5H7.5c-1.396 0-2.093 0-2.661.172a4 4 0 0 0-2.667 2.667C2 18.907 2 19.604 2 21m14-3 2 2 4-4m-7.5-8.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Z"
  }))),
  presentationchart02: t => e.createElement("svg", Bq({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Nq || (Nq = e.createElement("path", {
    d: "M12 16v5m6 0-3.951-3.293c-.73-.607-1.094-.91-1.5-1.027a2 2 0 0 0-1.098 0c-.406.116-.77.42-1.5 1.027L6 21m2-10v1m4-3v3m4-5v5m6-9H2m1 0h18v8.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 16 17.88 16 16.2 16H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 13.72 3 12.88 3 11.2V3Z"
  }))),
  markerpin05: t => e.createElement("svg", Rq({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Vq || (Vq = e.createElement("path", {
    d: "M16 13.374c3.532.695 6 2.28 6 4.126 0 2.485-4.477 4.5-10 4.5S2 19.985 2 17.5c0-1.845 2.468-3.431 6-4.126M12 17V3l5.318 3.272c.388.24.581.358.643.509a.5.5 0 0 1-.011.407c-.07.146-.271.254-.672.47L12 10.5"
  }))),
  dotsvertical: t => e.createElement("svg", Tq({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Aq || (Aq = e.createElement("path", {
    d: "M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM12 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM12 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
  }))),
  arrowstriangle: t => e.createElement("svg", Lq({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Hq || (Hq = e.createElement("path", {
    d: "M13 19h4.294c1.865 0 2.798 0 3.328-.39a2 2 0 0 0 .804-1.436c.058-.655-.429-1.451-1.401-3.043l-.997-1.631M6.13 10.605l-2.155 3.526c-.972 1.592-1.459 2.388-1.401 3.043a2 2 0 0 0 .804 1.435C3.908 19 4.841 19 6.706 19H8.5m8.389-10L14.73 5.468C13.829 3.991 13.377 3.252 12.795 3a2 2 0 0 0-1.59 0c-.581.252-1.033.99-1.935 2.468L8.25 7.137M18 5l-1.098 4.098L12.804 8M2 11.598 6.098 10.5l1.098 4.098M15.5 22l-3-3 3-3"
  }))),
  lock01: t => e.createElement("svg", Fq({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Iq || (Iq = e.createElement("path", {
    d: "M17 10V8A5 5 0 0 0 7 8v2m5 4.5v2M8.8 21h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 18.72 20 17.88 20 16.2v-1.4c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 10 16.88 10 15.2 10H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 12.28 4 13.12 4 14.8v1.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 21 7.12 21 8.8 21Z"
  }))),
  minimize01: t => e.createElement("svg", Zq({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), _q || (_q = e.createElement("path", {
    d: "M4 14h6m0 0v6m0-6-7 7m17-11h-6m0 0V4m0 6 7-7"
  }))),
  phoneincoming02: t => e.createElement("svg", qq({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Dq || (Dq = e.createElement("path", {
    d: "M16.5 3 13 6.5m0 0 3.5 3.5M13 6.5h8m-10.773 7.363a14.604 14.604 0 0 1-2.847-4.01 1.698 1.698 0 0 1-.113-.266 1.046 1.046 0 0 1 .147-.862c.048-.067.105-.124.22-.238.35-.35.524-.524.638-.7a2 2 0 0 0 0-2.18c-.114-.176-.289-.351-.638-.7l-.195-.196c-.532-.531-.797-.797-1.083-.941a2 2 0 0 0-1.805 0c-.285.144-.551.41-1.083.941l-.157.158c-.53.53-.795.794-.997 1.154-.224.4-.386 1.02-.384 1.479 0 .413.081.695.241 1.26a19.038 19.038 0 0 0 4.874 8.283 19.039 19.039 0 0 0 8.283 4.873c.565.16.847.24 1.26.242a3.377 3.377 0 0 0 1.478-.384c.36-.203.625-.468 1.155-.997l.157-.158c.532-.531.797-.797.942-1.082a2 2 0 0 0 0-1.806c-.145-.285-.41-.55-.942-1.082l-.195-.195c-.35-.35-.524-.524-.7-.639a2 2 0 0 0-2.18 0c-.176.114-.35.29-.7.639-.115.114-.172.171-.239.22-.237.17-.581.228-.862.146a1.695 1.695 0 0 1-.266-.113 14.605 14.605 0 0 1-4.01-2.846Z"
  }))),
  loading01: t => e.createElement("svg", $q({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Uq || (Uq = e.createElement("path", {
    d: "M12 2.25v2.5M12 18v4M5.75 12h-3.5m19 0h-1.5m-1.293 6.457-.707-.707m.914-12.334L17.25 6.83M4.922 19.078 7.75 16.25M5.129 5.209 7.25 7.33"
  }))),
  letterspacing02: t => e.createElement("svg", Wq({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), zq || (zq = e.createElement("path", {
    d: "M2 18h20M2 18l3-3m-3 3 3 3m17-3-3-3m3 3-3 3M7 3h10m-5 0v11"
  }))),
  distributespacingvertical: t => e.createElement("svg", Gq({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Qq || (Qq = e.createElement("path", {
    d: "M21 3H3m18 18H3m2-9c0-.932 0-1.398.152-1.765a2 2 0 0 1 1.083-1.083C6.602 9 7.068 9 8 9h8c.932 0 1.398 0 1.765.152a2 2 0 0 1 1.083 1.083C19 10.602 19 11.068 19 12c0 .932 0 1.398-.152 1.765a2 2 0 0 1-1.083 1.083C17.398 15 16.932 15 16 15H8c-.932 0-1.398 0-1.765-.152a2 2 0 0 1-1.083-1.083C5 13.398 5 12.932 5 12Z"
  }))),
  signal01: t => e.createElement("svg", Kq({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Yq || (Yq = e.createElement("path", {
    d: "M16.243 7.757a6 6 0 0 1 0 8.486m-8.486 0a6 6 0 0 1 0-8.486M4.93 19.071c-3.905-3.905-3.905-10.237 0-14.142m14.142 0c3.905 3.905 3.905 10.237 0 14.142M14 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
  }))),
  barchart07: t => e.createElement("svg", Jq({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), Xq || (Xq = e.createElement("path", {
    d: "M21 21H6.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C3 19.48 3 18.92 3 17.8V3m4 7.5v7m4.5-12v12m4.5-7v7m4.5-12v12"
  }))),
  xclose: t => e.createElement("svg", tU({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), eU || (eU = e.createElement("path", {
    d: "M18 6 6 18M6 6l12 12"
  }))),
  trenddown02: t => e.createElement("svg", nU({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), rU || (rU = e.createElement("path", {
    d: "m7 7 10 10m0 0V7m0 10H7"
  }))),
  attachment01: t => e.createElement("svg", oU({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), aU || (aU = e.createElement("path", {
    d: "m21.153 10.9-9.016 9.015a5.25 5.25 0 0 1-7.425-7.425l9.016-9.015a3.5 3.5 0 0 1 4.95 4.95l-8.662 8.662a1.75 1.75 0 1 1-2.475-2.475l7.601-7.602"
  }))),
  send02: t => e.createElement("svg", lU({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), iU || (iU = e.createElement("path", {
    d: "M12 19v-7m.292 7.084 6.978 2.337c.547.183.82.274.99.209a.5.5 0 0 0 .3-.331c.048-.175-.07-.438-.305-.964L12.765 3.622c-.23-.514-.346-.772-.507-.852a.5.5 0 0 0-.443 0c-.16.079-.277.336-.51.85L3.753 20.336c-.237.526-.356.789-.308.963a.5.5 0 0 0 .3.332c.168.066.442-.025.99-.206l7.052-2.341c.094-.031.14-.047.189-.053a.5.5 0 0 1 .128 0c.048.006.095.022.189.053Z"
  }))),
  bracketsx: t => e.createElement("svg", cU({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), sU || (sU = e.createElement("path", {
    d: "M18.57 20a2.286 2.286 0 0 0 2.287-2.286v-4.571L22 12l-1.143-1.143V6.286A2.285 2.285 0 0 0 18.57 4M5.429 4a2.285 2.285 0 0 0-2.286 2.286v4.571L2 12l1.143 1.143v4.571A2.285 2.285 0 0 0 5.429 20M15 9l-6 6m0-6 6 6"
  }))),
  barchartcircle01: t => e.createElement("svg", hU({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), uU || (uU = e.createElement("path", {
    d: "M8 13v4m8-6v6M12 7v10m10-5c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }))),
  alignleft: t => e.createElement("svg", pU({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), mU || (mU = e.createElement("path", {
    d: "M16 10H3m17-4H3m17 8H3m13 4H3"
  }))),
  cloudraining04: t => e.createElement("svg", dU({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), fU || (fU = e.createElement("path", {
    d: "M16 18.5V21m-8-2.5V21m4-1.5V22m-5-7a5 5 0 1 1 .1-9.999 5.502 5.502 0 0 1 10.195 1.004A4.5 4.5 0 1 1 17.5 15H6.999Z"
  }))),
  hourglass02: t => e.createElement("svg", gU({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), vU || (vU = e.createElement("path", {
    d: "M18.163 2H5.837A.837.837 0 0 0 5 2.837a10.05 10.05 0 0 0 2.943 7.106l1.22 1.22c.12.12.181.181.224.24a1 1 0 0 1 0 1.195 2.508 2.508 0 0 1-.224.24l-1.22 1.219A10.05 10.05 0 0 0 5 21.163c0 .462.375.837.837.837h12.326a.837.837 0 0 0 .837-.837 10.05 10.05 0 0 0-2.943-7.106l-1.22-1.22c-.12-.12-.181-.181-.224-.24a1 1 0 0 1 0-1.195c.043-.058.103-.118.224-.24l1.22-1.219A10.05 10.05 0 0 0 19 2.837.837.837 0 0 0 18.163 2Z"
  }))),
  scale01: t => e.createElement("svg", wU({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), bU || (bU = e.createElement("path", {
    d: "M14 22H6.8m0 0c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 19.72 2 18.88 2 17.2M6.8 22h.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C12 19.72 12 18.88 12 17.2v-.4c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C9.72 12 8.88 12 7.2 12h-.4c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 14.28 2 15.12 2 16.8v.4m0 0V10m8-8h4m8 8v4m-4 8c.93 0 1.395 0 1.776-.102a3 3 0 0 0 2.122-2.122C22 19.395 22 18.93 22 18m0-12c0-.93 0-1.395-.102-1.776a3 3 0 0 0-2.122-2.122C19.395 2 18.93 2 18 2M6 2c-.93 0-1.395 0-1.776.102a3 3 0 0 0-2.122 2.122C2 4.605 2 5.07 2 6"
  }))),
  uploadcloud01: t => e.createElement("svg", xU({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), yU || (yU = e.createElement("path", {
    d: "M4 16.242A4.5 4.5 0 0 1 6.08 8.02a6.002 6.002 0 0 1 11.84 0A4.5 4.5 0 0 1 20 16.242M8 16l4-4m0 0 4 4m-4-4v9"
  }))),
  heart: t => e.createElement("svg", EU({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), OU || (OU = e.createElement("path", {
    d: "M11.993 5.136c-2-2.338-5.333-2.966-7.838-.826s-2.858 5.719-.89 8.25c1.635 2.105 6.585 6.544 8.207 7.98.182.162.272.242.378.274a.504.504 0 0 0 .286 0c.106-.032.197-.112.378-.273 1.623-1.437 6.573-5.876 8.208-7.98 1.967-2.532 1.658-6.133-.89-8.251-2.549-2.118-5.84-1.512-7.839.826Z",
    clipRule: "evenodd"
  }))),
  toggle03left: t => e.createElement("svg", PU({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), jU || (jU = e.createElement("path", {
    d: "M2 12a6 6 0 0 1 6-6h8a6 6 0 0 1 0 12H8a6 6 0 0 1-6-6Z"
  })), CU || (CU = e.createElement("path", {
    d: "M8 14.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
  }))),
  image04: t => e.createElement("svg", SU({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), MU || (MU = e.createElement("path", {
    d: "M3 7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8Z"
  })), kU || (kU = e.createElement("path", {
    d: "M9 9.5 6 15h12l-4.5-7.5L11 11 9 9.5Z"
  }))),
  award03: t => e.createElement("svg", BU({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), NU || (NU = e.createElement("path", {
    d: "M7.869 15.46 7 22l4.588-2.753c.15-.09.225-.135.305-.152a.5.5 0 0 1 .214 0c.08.017.155.062.305.152L17 22l-.868-6.543m.294-11.208c.154.373.45.67.824.825l1.309.542a1.525 1.525 0 0 1 .825 1.992l-.542 1.308a1.522 1.522 0 0 0 0 1.168l.542 1.307a1.525 1.525 0 0 1-.826 1.993l-1.308.542c-.373.154-.67.45-.825.824l-.542 1.309a1.524 1.524 0 0 1-1.992.825l-1.308-.542a1.525 1.525 0 0 0-1.166 0l-1.31.542a1.524 1.524 0 0 1-1.99-.824l-.542-1.31a1.524 1.524 0 0 0-.824-.825l-1.31-.542a1.524 1.524 0 0 1-.825-1.991l.542-1.308a1.525 1.525 0 0 0 0-1.167l-.542-1.31a1.525 1.525 0 0 1 .826-1.992l1.307-.542c.374-.154.67-.45.825-.823l.543-1.309a1.524 1.524 0 0 1 1.991-.825l1.308.542c.374.154.793.154 1.167-.001l1.31-.54a1.525 1.525 0 0 1 1.99.825l.543 1.31v-.003Z"
  }))),
  toggle02left: t => e.createElement("svg", RU({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), VU || (VU = e.createElement("path", {
    d: "M10 16h8a4 4 0 0 0 0-8h-8m2 4a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z"
  }))),
  placeholder: t => e.createElement("svg", TU({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), AU || (AU = e.createElement("path", {
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z"
  }))),
  home03: t => e.createElement("svg", LU({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, t), HU || (HU = e.createElement("path", {
    d: "M9 21v-7.4c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C9.76 12 10.04 12 10.6 12h2.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C15 12.76 15 13.04 15 13.6V21M2 9.5l9.04-6.78c.344-.258.516-.387.705-.437a1 1 0 0 1 .51 0c.189.05.36.179.705.437L22 9.5M4 8v9.8c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C5.52 21 6.08 21 7.2 21h9.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C20 19.48 20 18.92 20 17.8V8l-6.08-4.56c-.688-.516-1.033-.775-1.41-.874a2 2 0 0 0-1.02 0c-.377.1-.722.358-1.41.874L4 8Z"
  }))),
  HasuraBlueLogo: t => e.createElement("svg", _U({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 31 33"
  }, t), IU || (IU = e.createElement("path", {
    fill: "#3970FD",
    d: "M30.232 11.397c.912-2.87.363-8.597-1.405-10.71a.53.53 0 0 0-.856.068l-2.178 3.453a1.665 1.665 0 0 1-2.239.368 14.85 14.85 0 0 0-8.22-2.47 14.85 14.85 0 0 0-8.222 2.47 1.67 1.67 0 0 1-2.238-.368L2.695.755A.532.532 0 0 0 1.84.686C.07 2.804-.478 8.53.435 11.396c.303.955.385 1.963.207 2.943-.178.972-.357 2.146-.357 2.964C.285 25.697 7.023 32.5 15.33 32.5c8.31 0 15.044-6.806 15.044-15.197 0-.818-.178-1.992-.356-2.964a6.155 6.155 0 0 1 .214-2.942ZM15.33 29.107c-6.424 0-11.647-5.279-11.647-11.768a11.774 11.774 0 0 1 6.67-10.63 11.43 11.43 0 0 1 4.98-1.132c1.783 0 3.47.403 4.98 1.134a11.779 11.779 0 0 1 6.671 10.631c-.004 6.486-5.23 11.766-11.654 11.766Z"
  })), FU || (FU = e.createElement("path", {
    fill: "#3970FD",
    d: "M20.377 21.87 17.4 16.654l-2.553-4.347a.333.333 0 0 0-.288-.166H12.12a.338.338 0 0 0-.289.511l2.442 4.146-3.276 5.049a.343.343 0 0 0-.014.345.334.334 0 0 0 .296.177h2.456a.331.331 0 0 0 .282-.155l1.772-2.795 1.59 2.784c.06.105.17.17.288.17h2.42a.328.328 0 0 0 .29-.17c.06-.1.06-.23 0-.335Z"
  }))),
  hasuraLogoWhite: t => e.createElement("svg", v$({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 105 32"
  }, t), f$ || (f$ = e.createElement("path", {
    fill: "#fff",
    d: "M30.232 10.897c.912-2.87.363-8.597-1.405-10.71a.53.53 0 0 0-.856.068l-2.178 3.453a1.665 1.665 0 0 1-2.239.368 14.85 14.85 0 0 0-8.22-2.47 14.85 14.85 0 0 0-8.222 2.47 1.67 1.67 0 0 1-2.238-.368L2.695.255A.532.532 0 0 0 1.84.186C.07 2.304-.478 8.03.435 10.896c.303.955.385 1.963.207 2.943-.178.972-.357 2.146-.357 2.964C.285 25.197 7.023 32 15.33 32c8.31 0 15.044-6.806 15.044-15.197 0-.818-.178-1.992-.356-2.964a6.155 6.155 0 0 1 .214-2.942ZM15.33 28.607c-6.424 0-11.647-5.279-11.647-11.768a11.774 11.774 0 0 1 6.67-10.63 11.43 11.43 0 0 1 4.98-1.132c1.783 0 3.47.403 4.98 1.134a11.779 11.779 0 0 1 6.671 10.631c-.004 6.486-5.23 11.766-11.654 11.766Z"
  })), d$ || (d$ = e.createElement("path", {
    fill: "#fff",
    d: "M20.377 21.37 17.4 16.154l-2.552-4.347a.333.333 0 0 0-.289-.166h-2.438a.338.338 0 0 0-.289.511l2.442 4.146-3.276 5.049a.343.343 0 0 0-.015.346.334.334 0 0 0 .296.176h2.457a.331.331 0 0 0 .281-.155l1.772-2.794 1.59 2.783c.06.105.171.17.289.17h2.42a.328.328 0 0 0 .29-.17c.06-.1.06-.23 0-.335ZM43.293 8h3.111v17.063h-3.111v-7.27h-3.515v7.274h-3.111V8h3.111v7.41h3.515V8ZM56.002 25.067l-.65-3.544h-3.733l-.597 3.544h-3.11l3.432-17.064h4.19l3.597 17.064H56Zm-3.976-5.899h2.893l-1.486-8.167-1.407 8.167ZM66.061 21.955v-3.651c0-.29-.054-.483-.16-.583-.108-.1-.308-.15-.597-.15h-2.19c-1.857 0-2.786-.9-2.786-2.705V10.68c0-1.786.972-2.676 2.918-2.676h2.976c1.947 0 2.918.894 2.918 2.676v2.38h-3.136v-1.947c0-.29-.054-.483-.16-.583-.108-.1-.308-.15-.597-.15h-1.029c-.307 0-.514.05-.622.15-.107.1-.16.293-.16.583v3.433c0 .29.053.482.16.582.108.1.315.15.622.15h2.136c1.893 0 2.84.883 2.84 2.651v4.463c0 1.786-.983 2.676-2.947 2.676h-2.922c-1.965 0-2.947-.894-2.947-2.676v-2.355h3.108v1.919c0 .29.053.482.16.582.108.1.315.15.622.15h1.029c.289 0 .486-.05.596-.15.11-.1.168-.293.168-.582ZM77.494 8h3.108v14.387c0 1.786-.983 2.676-2.947 2.676h-3.297c-1.965 0-2.947-.893-2.947-2.676V8h3.111v13.955c0 .29.054.482.161.582.107.1.307.15.596.15h1.433c.307 0 .514-.05.621-.15.108-.1.161-.293.161-.582V8ZM86.281 18.414v6.653h-3.107V8h6.272c1.965 0 2.947.893 2.947 2.676v5.059c0 1.479-.657 2.343-1.975 2.597l2.84 6.735h-3.355l-2.596-6.653H86.28Zm0-8.035v5.734h2.244c.289 0 .485-.05.596-.15.107-.1.16-.293.16-.582v-4.27c0-.289-.053-.482-.16-.582-.107-.1-.307-.15-.596-.15H86.28ZM101.802 25.067l-.65-3.544h-3.733l-.597 3.544h-3.107l3.432-17.064h4.19l3.597 17.064h-3.132Zm-3.972-5.899h2.893l-1.486-8.167-1.407 8.167Z"
  })))
};
function mz(_ref2) {
  let {
    variant: e,
    height: r,
    strokeColor: n,
    strokeClass: a,
    className: o
  } = _ref2;
  let i = "hasura";
  hz[e] && (i = hz[e]);
  let l = A(a);
  return "discord" === e && (l = "fill-blue-500 group-hover/icon:fill-blue-500"), "octoface" === e && (l = "fill-blue-500 group-hover/icon:fill-blue-500"), "meetup" === e && (l = "fill-blue-500 group-hover/icon:fill-blue-500"), "graphQL" === e && (l = ""), t.createElement("div", {
    style: {
      stroke: "".concat(n)
    }
  }, t.createElement(i, {
    className: ["".concat(r), "".concat(l), "".concat(o)].join(" ")
  }));
}
function pz(_ref3) {
  let {
    img_url: e,
    video_url: n,
    video_poster: a,
    width: o
  } = _ref3;
  const [i, l] = r(!1),
    s = () => {
      l(!0);
    };
  return t.createElement("div", null, e && t.createElement("div", {
    className: "flex justify-center"
  }, t.createElement("img", {
    src: e,
    alt: "Image",
    className: "rounded-2xl",
    onClick: s
  })), n && !e && a && t.createElement("div", null, i ? t.createElement("div", {
    className: "fixed inset-0 flex justify-center items-center z-50"
  }, t.createElement("div", {
    className: "relative w-screen h-screen flex items-start p-10"
  }, t.createElement("a", {
    className: " z-10 cursor-pointer left-14 top-2 relative w-12 h-12 bg-neutral-0 flex justify-center items-center rounded-full",
    onClick: () => {
      l(!1);
    }
  }, t.createElement(mz, {
    variant: "xclose",
    height: "h-6 w-6",
    strokeClass: "stroke-neutral-800"
  })), t.createElement("video", {
    controls: !1,
    autoPlay: !0,
    className: "object-contain max-w-full max-h-full"
  }, t.createElement("source", {
    src: n,
    type: "video/mp4"
  })))) : t.createElement("div", {
    className: "relative flex justify-center"
  }, t.createElement("div", {
    className: "flex items-center"
  }, t.createElement("a", {
    className: " left-[45%] z-10 cursor-pointer absolute w-12 h-12  flex justify-center items-center rounded-full border border-neutral-0",
    onClick: () => {
      l(!0);
    }
  }, t.createElement(mz, {
    variant: "play",
    height: "h-6 w-6",
    strokeClass: "stroke-neutral-0"
  }))), t.createElement("div", null, t.createElement("img", {
    src: a,
    alt: "Video Poster",
    onClick: s,
    className: "cursor-pointer rounded-2xl"
  })))));
}
mz.propTypes = {
  fillColor: se.string,
  strokeColor: se.string
}, mz.defaultProps = {
  strokeColor: ""
};
const fz = _ref4 => {
  let {
    children: e
  } = _ref4;
  const r = n(null);
  let o;
  return a(() => {
    const e = r.current,
      t = t => {
        const r = t.clientX,
          n = t.clientY,
          a = r - o.x,
          i = n - o.y,
          l = a - o.width / 2,
          s = i - o.height / 2,
          c = Math.sqrt(l ** 2 + s ** 2);
        e.style.transform = "\n        scale3d(1.07, 1.07, 1.07)\n        rotate3d(\n          ".concat(s / 100, ",\n          ").concat(-l / 100, ",\n          0,\n          ").concat(2 * Math.log(c), "deg\n        )\n      "), e.querySelector(".glow").style.backgroundImage = "\n        radial-gradient(\n          circle at\n          ".concat(2 * l + o.width / 2, "px\n          ").concat(2 * s + o.height / 2, "px,\n          #ffffff55,\n      #0000000\n        \n        )\n      ");
      },
      n = () => {
        o = e.getBoundingClientRect(), document.addEventListener("mousemove", t);
      },
      a = () => {
        document.removeEventListener("mousemove", t), e.style.transform = "", e.style.background = "";
      };
    return e.addEventListener("mouseenter", n), e.addEventListener("mouseleave", a), () => {
      e.removeEventListener("mouseenter", n), e.removeEventListener("mouseleave", a);
    };
  }, []), t.createElement("div", {
    className: "card",
    ref: r
  }, t.createElement("div", {
    className: "glow"
  }), e);
};
function dz() {
  return dz = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, dz.apply(this, arguments);
}
var vz = {
  exports: {}
};
function gz() {
  return {
    get: function (e, t) {
      let r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        miss: () => Promise.resolve()
      };
      return t().then(e => Promise.all([e, r.miss(e)])).then(_ref5 => {
        let [e] = _ref5;
        return e;
      });
    },
    set: (e, t) => Promise.resolve(t),
    delete: e => Promise.resolve(),
    clear: () => Promise.resolve()
  };
}
var bz = Object.freeze({
    __proto__: null,
    createFallbackableCache: function e(t) {
      const r = [...t.caches],
        n = r.shift();
      return void 0 === n ? gz() : {
        get: function (t, a) {
          let o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
            miss: () => Promise.resolve()
          };
          return n.get(t, a, o).catch(() => e({
            caches: r
          }).get(t, a, o));
        },
        set: (t, a) => n.set(t, a).catch(() => e({
          caches: r
        }).set(t, a)),
        delete: t => n.delete(t).catch(() => e({
          caches: r
        }).delete(t)),
        clear: () => n.clear().catch(() => e({
          caches: r
        }).clear())
      };
    },
    createNullCache: gz
  }),
  wz = H(bz);
var yz = Object.freeze({
    __proto__: null,
    createInMemoryCache: function () {
      let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        serializable: !0
      };
      let t = {};
      return {
        get(r, n) {
          let a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
            miss: () => Promise.resolve()
          };
          const o = JSON.stringify(r);
          if (o in t) return Promise.resolve(e.serializable ? JSON.parse(t[o]) : t[o]);
          const i = n(),
            l = a && a.miss || (() => Promise.resolve());
          return i.then(e => l(e)).then(() => i);
        },
        set: (r, n) => (t[JSON.stringify(r)] = e.serializable ? JSON.stringify(n) : n, Promise.resolve(n)),
        delete: e => (delete t[JSON.stringify(e)], Promise.resolve()),
        clear: () => (t = {}, Promise.resolve())
      };
    }
  }),
  xz = H(yz);
function Oz(e, t, r) {
  const n = {
    "x-algolia-api-key": r,
    "x-algolia-application-id": t
  };
  return {
    headers: () => e === kz.WithinHeaders ? n : {},
    queryParameters: () => e === kz.WithinQueryParameters ? n : {}
  };
}
function Ez(e) {
  let t = 0;
  const r = () => (t++, new Promise(n => {
    setTimeout(() => {
      n(e(r));
    }, Math.min(100 * t, 1e3));
  }));
  return e(r);
}
function jz(e) {
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (e, t) => Promise.resolve();
  return Object.assign(e, {
    wait: r => jz(e.then(e => Promise.all([t(e, r), e])).then(e => e[1]))
  });
}
function Cz(e) {
  let t = e.length - 1;
  for (; t > 0; t--) {
    const r = Math.floor(Math.random() * (t + 1)),
      n = e[t];
    e[t] = e[r], e[r] = n;
  }
  return e;
}
function Pz(e, t) {
  return t ? (Object.keys(t).forEach(r => {
    e[r] = t[r](e);
  }), e) : e;
}
function Mz(e) {
  for (var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    t[_key - 1] = arguments[_key];
  }
  let r = 0;
  return e.replace(/%s/g, () => encodeURIComponent(t[r++]));
}
const kz = {
  WithinQueryParameters: 0,
  WithinHeaders: 1
};
var Sz = Object.freeze({
  __proto__: null,
  AuthMode: kz,
  addMethods: Pz,
  createAuth: Oz,
  createRetryablePromise: Ez,
  createWaitablePromise: jz,
  destroy: e => () => e.transporter.requester.destroy(),
  encode: Mz,
  shuffle: Cz,
  version: "4.18.0"
});
const Nz = {
  Delete: "DELETE",
  Get: "GET",
  Post: "POST",
  Put: "PUT"
};
function Bz(e, t) {
  const r = e || {},
    n = r.data || {};
  return Object.keys(r).forEach(e => {
    -1 === ["timeout", "headers", "queryParameters", "data", "cacheable"].indexOf(e) && (n[e] = r[e]);
  }), {
    data: Object.entries(n).length > 0 ? n : void 0,
    timeout: r.timeout || t,
    headers: r.headers || {},
    queryParameters: r.queryParameters || {},
    cacheable: r.cacheable
  };
}
const Vz = {
    Read: 1,
    Write: 2,
    Any: 3
  },
  Rz = {
    Up: 1,
    Down: 2,
    Timeouted: 3
  },
  Az = 12e4;
function Tz(e) {
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Rz.Up;
  return {
    ...e,
    status: t,
    lastUpdate: Date.now()
  };
}
function Hz(e) {
  return e.status === Rz.Up || Date.now() - e.lastUpdate > Az;
}
function Lz(e) {
  return e.status === Rz.Timeouted && Date.now() - e.lastUpdate <= Az;
}
function Iz(e) {
  return "string" == typeof e ? {
    protocol: "https",
    url: e,
    accept: Vz.Any
  } : {
    protocol: e.protocol || "https",
    url: e.url,
    accept: e.accept || Vz.Any
  };
}
const Fz = (e, t) => (e => {
  const t = e.status;
  return e.isTimedOut || (_ref6 => {
    let {
      isTimedOut: e,
      status: t
    } = _ref6;
    return !e && 0 == ~~t;
  })(e) || 2 != ~~(t / 100) && 4 != ~~(t / 100);
})(e) ? t.onRetry(e) : (_ref7 => {
  let {
    status: e
  } = _ref7;
  return 2 == ~~(e / 100);
})(e) ? t.onSuccess(e) : t.onFail(e);
function _z(e, t, r, n) {
  const a = [],
    o = zz(r, n),
    i = Wz(e, n),
    l = r.method,
    s = r.method !== Nz.Get ? {} : {
      ...r.data,
      ...n.data
    },
    c = {
      "x-algolia-agent": e.userAgent.value,
      ...e.queryParameters,
      ...s,
      ...n.queryParameters
    };
  let u = 0;
  const h = (t, s) => {
    const m = t.pop();
    if (void 0 === m) throw Xz(Qz(a));
    const p = {
        data: o,
        headers: i,
        method: l,
        url: Uz(m, r.path, c),
        connectTimeout: s(u, e.timeouts.connect),
        responseTimeout: s(u, n.timeout)
      },
      f = e => {
        const r = {
          request: p,
          response: e,
          host: m,
          triesLeft: t.length
        };
        return a.push(r), r;
      },
      d = {
        onSuccess: e => Dz(e),
        onRetry(r) {
          const n = f(r);
          return r.isTimedOut && u++, Promise.all([e.logger.info("Retryable failure", Gz(n)), e.hostsCache.set(m, Tz(m, r.isTimedOut ? Rz.Timeouted : Rz.Down))]).then(() => h(t, s));
        },
        onFail(e) {
          throw f(e), qz(e, Qz(a));
        }
      };
    return e.requester.send(p).then(e => Fz(e, d));
  };
  return function (e, t) {
    return Promise.all(t.map(t => e.get(t, () => Promise.resolve(Tz(t))))).then(e => {
      const r = e.filter(e => Hz(e)),
        n = e.filter(e => Lz(e)),
        a = [...r, ...n];
      return {
        getTimeout: (e, t) => (0 === n.length && 0 === e ? 1 : n.length + 3 + e) * t,
        statelessHosts: a.length > 0 ? a.map(e => Iz(e)) : t
      };
    });
  }(e.hostsCache, t).then(e => h([...e.statelessHosts].reverse(), e.getTimeout));
}
function Zz(e) {
  const {
      hostsCache: t,
      logger: r,
      requester: n,
      requestsCache: a,
      responsesCache: o,
      timeouts: i,
      userAgent: l,
      hosts: s,
      queryParameters: c,
      headers: u
    } = e,
    h = {
      hostsCache: t,
      logger: r,
      requester: n,
      requestsCache: a,
      responsesCache: o,
      timeouts: i,
      userAgent: l,
      headers: u,
      queryParameters: c,
      hosts: s.map(e => Iz(e)),
      read(e, t) {
        const r = Bz(t, h.timeouts.read),
          n = () => _z(h, h.hosts.filter(e => 0 != (e.accept & Vz.Read)), e, r);
        if (!0 !== (void 0 !== r.cacheable ? r.cacheable : e.cacheable)) return n();
        const a = {
          request: e,
          mappedRequestOptions: r,
          transporter: {
            queryParameters: h.queryParameters,
            headers: h.headers
          }
        };
        return h.responsesCache.get(a, () => h.requestsCache.get(a, () => h.requestsCache.set(a, n()).then(e => Promise.all([h.requestsCache.delete(a), e]), e => Promise.all([h.requestsCache.delete(a), Promise.reject(e)])).then(_ref8 => {
          let [e, t] = _ref8;
          return t;
        })), {
          miss: e => h.responsesCache.set(a, e)
        });
      },
      write: (e, t) => _z(h, h.hosts.filter(e => 0 != (e.accept & Vz.Write)), e, Bz(t, h.timeouts.write))
    };
  return h;
}
function Dz(e) {
  try {
    return JSON.parse(e.content);
  } catch (t) {
    throw Kz(t.message, e);
  }
}
function qz(_ref9, r) {
  let {
    content: e,
    status: t
  } = _ref9;
  let n = e;
  try {
    n = JSON.parse(e).message;
  } catch (e) {}
  return Yz(n, t, r);
}
function Uz(e, t, r) {
  const n = $z(r);
  let a = "".concat(e.protocol, "://").concat(e.url, "/").concat("/" === t.charAt(0) ? t.substr(1) : t);
  return n.length && (a += "?".concat(n)), a;
}
function $z(e) {
  return Object.keys(e).map(t => {
    return function (e) {
      for (var _len2 = arguments.length, t = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        t[_key2 - 1] = arguments[_key2];
      }
      let r = 0;
      return e.replace(/%s/g, () => encodeURIComponent(t[r++]));
    }("%s=%s", t, (r = e[t], "[object Object]" === Object.prototype.toString.call(r) || "[object Array]" === Object.prototype.toString.call(r) ? JSON.stringify(e[t]) : e[t]));
    var r;
  }).join("&");
}
function zz(e, t) {
  if (e.method === Nz.Get || void 0 === e.data && void 0 === t.data) return;
  const r = Array.isArray(e.data) ? e.data : {
    ...e.data,
    ...t.data
  };
  return JSON.stringify(r);
}
function Wz(e, t) {
  const r = {
      ...e.headers,
      ...t.headers
    },
    n = {};
  return Object.keys(r).forEach(e => {
    const t = r[e];
    n[e.toLowerCase()] = t;
  }), n;
}
function Qz(e) {
  return e.map(e => Gz(e));
}
function Gz(e) {
  const t = e.request.headers["x-algolia-api-key"] ? {
    "x-algolia-api-key": "*****"
  } : {};
  return {
    ...e,
    request: {
      ...e.request,
      headers: {
        ...e.request.headers,
        ...t
      }
    }
  };
}
function Yz(e, t, r) {
  return {
    name: "ApiError",
    message: e,
    status: t,
    transporterStackTrace: r
  };
}
function Kz(e, t) {
  return {
    name: "DeserializationError",
    message: e,
    response: t
  };
}
function Xz(e) {
  return {
    name: "RetryError",
    message: "Unreachable hosts - your application id may be incorrect. If the error persists, contact support@algolia.com.",
    transporterStackTrace: e
  };
}
var Jz = Object.freeze({
  __proto__: null,
  CallEnum: Vz,
  HostStatusEnum: Rz,
  createApiError: Yz,
  createDeserializationError: Kz,
  createMappedRequestOptions: Bz,
  createRetryError: Xz,
  createStatefulHost: Tz,
  createStatelessHost: Iz,
  createTransporter: Zz,
  createUserAgent: function (e) {
    const t = {
      value: "Algolia for JavaScript (".concat(e, ")"),
      add(e) {
        const r = "; ".concat(e.segment).concat(void 0 !== e.version ? " (".concat(e.version, ")") : "");
        return -1 === t.value.indexOf(r) && (t.value = "".concat(t.value).concat(r)), t;
      }
    };
    return t;
  },
  deserializeFailure: qz,
  deserializeSuccess: Dz,
  isStatefulHostTimeouted: Lz,
  isStatefulHostUp: Hz,
  serializeData: zz,
  serializeHeaders: Wz,
  serializeQueryParameters: $z,
  serializeUrl: Uz,
  stackFrameWithoutCredentials: Gz,
  stackTraceWithoutCredentials: Qz
});
var eW = Object.freeze({
    __proto__: null,
    addABTest: e => (t, r) => e.transporter.write({
      method: Nz.Post,
      path: "2/abtests",
      data: t
    }, r),
    createAnalyticsClient: e => {
      const t = e.region || "us",
        r = Oz(kz.WithinHeaders, e.appId, e.apiKey),
        n = Zz({
          hosts: [{
            url: "analytics.".concat(t, ".algolia.com")
          }],
          ...e,
          headers: {
            ...r.headers(),
            "content-type": "application/json",
            ...e.headers
          },
          queryParameters: {
            ...r.queryParameters(),
            ...e.queryParameters
          }
        });
      return Pz({
        appId: e.appId,
        transporter: n
      }, e.methods);
    },
    deleteABTest: e => (t, r) => e.transporter.write({
      method: Nz.Delete,
      path: Mz("2/abtests/%s", t)
    }, r),
    getABTest: e => (t, r) => e.transporter.read({
      method: Nz.Get,
      path: Mz("2/abtests/%s", t)
    }, r),
    getABTests: e => t => e.transporter.read({
      method: Nz.Get,
      path: "2/abtests"
    }, t),
    stopABTest: e => (t, r) => e.transporter.write({
      method: Nz.Post,
      path: Mz("2/abtests/%s/stop", t)
    }, r)
  }),
  tW = H(eW),
  rW = H(Sz);
var nW = Object.freeze({
    __proto__: null,
    createPersonalizationClient: e => {
      const t = e.region || "us",
        r = Oz(kz.WithinHeaders, e.appId, e.apiKey),
        n = Zz({
          hosts: [{
            url: "personalization.".concat(t, ".algolia.com")
          }],
          ...e,
          headers: {
            ...r.headers(),
            "content-type": "application/json",
            ...e.headers
          },
          queryParameters: {
            ...r.queryParameters(),
            ...e.queryParameters
          }
        });
      return Pz({
        appId: e.appId,
        transporter: n
      }, e.methods);
    },
    getPersonalizationStrategy: e => t => e.transporter.read({
      method: Nz.Get,
      path: "1/strategies/personalization"
    }, t),
    setPersonalizationStrategy: e => (t, r) => e.transporter.write({
      method: Nz.Post,
      path: "1/strategies/personalization",
      data: t
    }, r)
  }),
  aW = H(nW);
function oW(e) {
  const t = r => e.request(r).then(n => {
    if (void 0 !== e.batch && e.batch(n.hits), !e.shouldStop(n)) return n.cursor ? t({
      cursor: n.cursor
    }) : t({
      page: (r.page || 0) + 1
    });
  });
  return t({});
}
function iW() {
  return {
    name: "MissingObjectIDError",
    message: "All objects must have an unique objectID (like a primary key) to be valid. Algolia is also able to generate objectIDs automatically but *it's not recommended*. To do it, use the `{'autoGenerateObjectIDIfNotExist': true}` option."
  };
}
function lW() {
  return {
    name: "ObjectNotFoundError",
    message: "Object not found."
  };
}
function sW() {
  return {
    name: "ValidUntilNotFoundError",
    message: "ValidUntil not found in given secured api key."
  };
}
const cW = e => (t, r, n) => jz(e.transporter.write({
    method: Nz.Post,
    path: Mz("1/indexes/%s/operation", t),
    data: {
      operation: "copy",
      destination: r
    }
  }, n), (r, n) => mW(e)(t, {
    methods: {
      waitTask: MW
    }
  }).waitTask(r.taskID, n)),
  uW = e => (t, r) => e.transporter.read({
    method: Nz.Get,
    path: Mz("1/keys/%s", t)
  }, r),
  hW = e => (t, r) => e.transporter.read({
    method: Nz.Get,
    path: Mz("1/task/%s", t.toString())
  }, r),
  mW = e => function (t) {
    let r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Pz({
      transporter: e.transporter,
      appId: e.appId,
      indexName: t
    }, r.methods);
  },
  pW = e => (t, r) => Ez(n => hW(e)(t, r).then(e => "published" !== e.status ? n() : void 0)),
  fW = e => (t, r) => jz(e.transporter.write({
    method: Nz.Post,
    path: Mz("1/indexes/%s/batch", e.indexName),
    data: {
      requests: t
    }
  }, r), (t, r) => MW(e)(t.taskID, r)),
  dW = e => (t, r, n) => {
    const {
        batchSize: a,
        ...o
      } = n || {},
      i = {
        taskIDs: [],
        objectIDs: []
      },
      l = function () {
        let n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        const s = [];
        let c;
        for (c = n; c < t.length && (s.push(t[c]), s.length !== (a || 1e3)); c++);
        return 0 === s.length ? Promise.resolve(i) : fW(e)(s.map(e => ({
          action: r,
          body: e
        })), o).then(e => (i.objectIDs = i.objectIDs.concat(e.objectIDs), i.taskIDs.push(e.taskID), c++, l(c)));
      };
    return jz(l(), (t, r) => Promise.all(t.taskIDs.map(t => MW(e)(t, r))));
  },
  vW = e => (t, r) => {
    const n = t.map(e => ({
      objectID: e
    }));
    return dW(e)(n, kW.DeleteObject, r);
  },
  gW = e => t => e.transporter.read({
    method: Nz.Get,
    path: Mz("1/indexes/%s/settings", e.indexName),
    data: {
      getVersion: 2
    }
  }, t),
  bW = e => (t, r) => e.transporter.read({
    method: Nz.Get,
    path: Mz("1/indexes/%s/task/%s", e.indexName, t.toString())
  }, r),
  wW = e => (t, r) => {
    const {
        createIfNotExists: n,
        ...a
      } = r || {},
      o = n ? kW.PartialUpdateObject : kW.PartialUpdateObjectNoCreate;
    return dW(e)(t, o, a);
  },
  yW = e => (t, r) => {
    const {
        autoGenerateObjectIDIfNotExist: n,
        ...a
      } = r || {},
      o = n ? kW.AddObject : kW.UpdateObject;
    if (o === kW.UpdateObject) for (const e of t) if (void 0 === e.objectID) return jz(Promise.reject({
      name: "MissingObjectIDError",
      message: "All objects must have an unique objectID (like a primary key) to be valid. Algolia is also able to generate objectIDs automatically but *it's not recommended*. To do it, use the `{'autoGenerateObjectIDIfNotExist': true}` option."
    }));
    return dW(e)(t, o, a);
  },
  xW = e => (t, r) => {
    const {
        forwardToReplicas: n,
        clearExistingRules: a,
        ...o
      } = r || {},
      i = Bz(o);
    return n && (i.queryParameters.forwardToReplicas = 1), a && (i.queryParameters.clearExistingRules = 1), jz(e.transporter.write({
      method: Nz.Post,
      path: Mz("1/indexes/%s/rules/batch", e.indexName),
      data: t
    }, i), (t, r) => MW(e)(t.taskID, r));
  },
  OW = e => (t, r) => {
    const {
        forwardToReplicas: n,
        clearExistingSynonyms: a,
        replaceExistingSynonyms: o,
        ...i
      } = r || {},
      l = Bz(i);
    return n && (l.queryParameters.forwardToReplicas = 1), (o || a) && (l.queryParameters.replaceExistingSynonyms = 1), jz(e.transporter.write({
      method: Nz.Post,
      path: Mz("1/indexes/%s/synonyms/batch", e.indexName),
      data: t
    }, l), (t, r) => MW(e)(t.taskID, r));
  },
  EW = e => (t, r) => e.transporter.read({
    method: Nz.Post,
    path: Mz("1/indexes/%s/query", e.indexName),
    data: {
      query: t
    },
    cacheable: !0
  }, r),
  jW = e => (t, r, n) => e.transporter.read({
    method: Nz.Post,
    path: Mz("1/indexes/%s/facets/%s/query", e.indexName, t),
    data: {
      facetQuery: r
    },
    cacheable: !0
  }, n),
  CW = e => (t, r) => e.transporter.read({
    method: Nz.Post,
    path: Mz("1/indexes/%s/rules/search", e.indexName),
    data: {
      query: t
    }
  }, r),
  PW = e => (t, r) => e.transporter.read({
    method: Nz.Post,
    path: Mz("1/indexes/%s/synonyms/search", e.indexName),
    data: {
      query: t
    }
  }, r),
  MW = e => (t, r) => Ez(n => bW(e)(t, r).then(e => "published" !== e.status ? n() : void 0)),
  kW = {
    AddObject: "addObject",
    UpdateObject: "updateObject",
    PartialUpdateObject: "partialUpdateObject",
    PartialUpdateObjectNoCreate: "partialUpdateObjectNoCreate",
    DeleteObject: "deleteObject",
    DeleteIndex: "delete",
    ClearIndex: "clear"
  },
  SW = {
    Settings: "settings",
    Synonyms: "synonyms",
    Rules: "rules"
  };
var NW = Object.freeze({
    __proto__: null,
    ApiKeyACLEnum: {
      AddObject: "addObject",
      Analytics: "analytics",
      Browser: "browse",
      DeleteIndex: "deleteIndex",
      DeleteObject: "deleteObject",
      EditSettings: "editSettings",
      ListIndexes: "listIndexes",
      Logs: "logs",
      Personalization: "personalization",
      Recommendation: "recommendation",
      Search: "search",
      SeeUnretrievableAttributes: "seeUnretrievableAttributes",
      Settings: "settings",
      Usage: "usage"
    },
    BatchActionEnum: kW,
    ScopeEnum: SW,
    StrategyEnum: {
      None: "none",
      StopIfEnoughMatches: "stopIfEnoughMatches"
    },
    SynonymEnum: {
      Synonym: "synonym",
      OneWaySynonym: "oneWaySynonym",
      AltCorrection1: "altCorrection1",
      AltCorrection2: "altCorrection2",
      Placeholder: "placeholder"
    },
    addApiKey: e => (t, r) => {
      const {
          queryParameters: n,
          ...a
        } = r || {},
        o = {
          acl: t,
          ...(void 0 !== n ? {
            queryParameters: n
          } : {})
        };
      return jz(e.transporter.write({
        method: Nz.Post,
        path: "1/keys",
        data: o
      }, a), (t, r) => Ez(n => uW(e)(t.key, r).catch(e => {
        if (404 !== e.status) throw e;
        return n();
      })));
    },
    assignUserID: e => (t, r, n) => {
      const a = Bz(n);
      return a.queryParameters["X-Algolia-User-ID"] = t, e.transporter.write({
        method: Nz.Post,
        path: "1/clusters/mapping",
        data: {
          cluster: r
        }
      }, a);
    },
    assignUserIDs: e => (t, r, n) => e.transporter.write({
      method: Nz.Post,
      path: "1/clusters/mapping/batch",
      data: {
        users: t,
        cluster: r
      }
    }, n),
    batch: fW,
    browseObjects: e => t => oW({
      shouldStop: e => void 0 === e.cursor,
      ...t,
      request: r => e.transporter.read({
        method: Nz.Post,
        path: Mz("1/indexes/%s/browse", e.indexName),
        data: r
      }, t)
    }),
    browseRules: e => t => {
      const r = {
        hitsPerPage: 1e3,
        ...t
      };
      return oW({
        shouldStop: e => e.hits.length < r.hitsPerPage,
        ...r,
        request: t => CW(e)("", {
          ...r,
          ...t
        }).then(e => ({
          ...e,
          hits: e.hits.map(e => (delete e._highlightResult, e))
        }))
      });
    },
    browseSynonyms: e => t => {
      const r = {
        hitsPerPage: 1e3,
        ...t
      };
      return oW({
        shouldStop: e => e.hits.length < r.hitsPerPage,
        ...r,
        request: t => PW(e)("", {
          ...r,
          ...t
        }).then(e => ({
          ...e,
          hits: e.hits.map(e => (delete e._highlightResult, e))
        }))
      });
    },
    chunkedBatch: dW,
    clearDictionaryEntries: e => (t, r) => jz(e.transporter.write({
      method: Nz.Post,
      path: Mz("/1/dictionaries/%s/batch", t),
      data: {
        clearExistingDictionaryEntries: !0,
        requests: {
          action: "addEntry",
          body: []
        }
      }
    }, r), (t, r) => pW(e)(t.taskID, r)),
    clearObjects: e => t => jz(e.transporter.write({
      method: Nz.Post,
      path: Mz("1/indexes/%s/clear", e.indexName)
    }, t), (t, r) => MW(e)(t.taskID, r)),
    clearRules: e => t => {
      const {
          forwardToReplicas: r,
          ...n
        } = t || {},
        a = Bz(n);
      return r && (a.queryParameters.forwardToReplicas = 1), jz(e.transporter.write({
        method: Nz.Post,
        path: Mz("1/indexes/%s/rules/clear", e.indexName)
      }, a), (t, r) => MW(e)(t.taskID, r));
    },
    clearSynonyms: e => t => {
      const {
          forwardToReplicas: r,
          ...n
        } = t || {},
        a = Bz(n);
      return r && (a.queryParameters.forwardToReplicas = 1), jz(e.transporter.write({
        method: Nz.Post,
        path: Mz("1/indexes/%s/synonyms/clear", e.indexName)
      }, a), (t, r) => MW(e)(t.taskID, r));
    },
    copyIndex: cW,
    copyRules: e => (t, r, n) => cW(e)(t, r, {
      ...n,
      scope: [SW.Rules]
    }),
    copySettings: e => (t, r, n) => cW(e)(t, r, {
      ...n,
      scope: [SW.Settings]
    }),
    copySynonyms: e => (t, r, n) => cW(e)(t, r, {
      ...n,
      scope: [SW.Synonyms]
    }),
    createBrowsablePromise: oW,
    createMissingObjectIDError: iW,
    createObjectNotFoundError: lW,
    createSearchClient: e => {
      const t = e.appId,
        r = Oz(void 0 !== e.authMode ? e.authMode : kz.WithinHeaders, t, e.apiKey),
        n = Zz({
          hosts: [{
            url: "".concat(t, "-dsn.algolia.net"),
            accept: Vz.Read
          }, {
            url: "".concat(t, ".algolia.net"),
            accept: Vz.Write
          }].concat(Cz([{
            url: "".concat(t, "-1.algolianet.com")
          }, {
            url: "".concat(t, "-2.algolianet.com")
          }, {
            url: "".concat(t, "-3.algolianet.com")
          }])),
          ...e,
          headers: {
            ...r.headers(),
            "content-type": "application/x-www-form-urlencoded",
            ...e.headers
          },
          queryParameters: {
            ...r.queryParameters(),
            ...e.queryParameters
          }
        }),
        a = {
          transporter: n,
          appId: t,
          addAlgoliaAgent(e, t) {
            n.userAgent.add({
              segment: e,
              version: t
            });
          },
          clearCache: () => Promise.all([n.requestsCache.clear(), n.responsesCache.clear()]).then(() => {})
        };
      return Pz(a, e.methods);
    },
    createValidUntilNotFoundError: sW,
    customRequest: e => (t, r) => t.method === Nz.Get ? e.transporter.read(t, r) : e.transporter.write(t, r),
    deleteApiKey: e => (t, r) => jz(e.transporter.write({
      method: Nz.Delete,
      path: Mz("1/keys/%s", t)
    }, r), (r, n) => Ez(r => uW(e)(t, n).then(r).catch(e => {
      if (404 !== e.status) throw e;
    }))),
    deleteBy: e => (t, r) => jz(e.transporter.write({
      method: Nz.Post,
      path: Mz("1/indexes/%s/deleteByQuery", e.indexName),
      data: t
    }, r), (t, r) => MW(e)(t.taskID, r)),
    deleteDictionaryEntries: e => (t, r, n) => {
      const a = r.map(e => ({
        action: "deleteEntry",
        body: {
          objectID: e
        }
      }));
      return jz(e.transporter.write({
        method: Nz.Post,
        path: Mz("/1/dictionaries/%s/batch", t),
        data: {
          clearExistingDictionaryEntries: !1,
          requests: a
        }
      }, n), (t, r) => pW(e)(t.taskID, r));
    },
    deleteIndex: e => t => jz(e.transporter.write({
      method: Nz.Delete,
      path: Mz("1/indexes/%s", e.indexName)
    }, t), (t, r) => MW(e)(t.taskID, r)),
    deleteObject: e => (t, r) => jz(vW(e)([t], r).then(e => ({
      taskID: e.taskIDs[0]
    })), (t, r) => MW(e)(t.taskID, r)),
    deleteObjects: vW,
    deleteRule: e => (t, r) => {
      const {
          forwardToReplicas: n,
          ...a
        } = r || {},
        o = Bz(a);
      return n && (o.queryParameters.forwardToReplicas = 1), jz(e.transporter.write({
        method: Nz.Delete,
        path: Mz("1/indexes/%s/rules/%s", e.indexName, t)
      }, o), (t, r) => MW(e)(t.taskID, r));
    },
    deleteSynonym: e => (t, r) => {
      const {
          forwardToReplicas: n,
          ...a
        } = r || {},
        o = Bz(a);
      return n && (o.queryParameters.forwardToReplicas = 1), jz(e.transporter.write({
        method: Nz.Delete,
        path: Mz("1/indexes/%s/synonyms/%s", e.indexName, t)
      }, o), (t, r) => MW(e)(t.taskID, r));
    },
    exists: e => t => gW(e)(t).then(() => !0).catch(e => {
      if (404 !== e.status) throw e;
      return !1;
    }),
    findAnswers: e => (t, r, n) => e.transporter.read({
      method: Nz.Post,
      path: Mz("1/answers/%s/prediction", e.indexName),
      data: {
        query: t,
        queryLanguages: r
      },
      cacheable: !0
    }, n),
    findObject: e => (t, r) => {
      const {
        query: n,
        paginate: a,
        ...o
      } = r || {};
      let i = 0;
      const l = () => EW(e)(n || "", {
        ...o,
        page: i
      }).then(e => {
        for (const [r, n] of Object.entries(e.hits)) if (t(n)) return {
          object: n,
          position: parseInt(r, 10),
          page: i
        };
        if (i++, !1 === a || i >= e.nbPages) throw {
          name: "ObjectNotFoundError",
          message: "Object not found."
        };
        return l();
      });
      return l();
    },
    generateSecuredApiKey: () => (e, t) => {
      const r = $z(t),
        n = E("sha256", e).update(r).digest("hex");
      return Buffer.from(n + r).toString("base64");
    },
    getApiKey: uW,
    getAppTask: hW,
    getDictionarySettings: e => t => e.transporter.read({
      method: Nz.Get,
      path: "/1/dictionaries/*/settings"
    }, t),
    getLogs: e => t => e.transporter.read({
      method: Nz.Get,
      path: "1/logs"
    }, t),
    getObject: e => (t, r) => e.transporter.read({
      method: Nz.Get,
      path: Mz("1/indexes/%s/%s", e.indexName, t)
    }, r),
    getObjectPosition: () => (e, t) => {
      for (const [r, n] of Object.entries(e.hits)) if (n.objectID === t) return parseInt(r, 10);
      return -1;
    },
    getObjects: e => (t, r) => {
      const {
          attributesToRetrieve: n,
          ...a
        } = r || {},
        o = t.map(t => ({
          indexName: e.indexName,
          objectID: t,
          ...(n ? {
            attributesToRetrieve: n
          } : {})
        }));
      return e.transporter.read({
        method: Nz.Post,
        path: "1/indexes/*/objects",
        data: {
          requests: o
        }
      }, a);
    },
    getRule: e => (t, r) => e.transporter.read({
      method: Nz.Get,
      path: Mz("1/indexes/%s/rules/%s", e.indexName, t)
    }, r),
    getSecuredApiKeyRemainingValidity: () => e => {
      const t = Buffer.from(e, "base64").toString("ascii").match(/validUntil=(\d+)/);
      if (null === t) throw {
        name: "ValidUntilNotFoundError",
        message: "ValidUntil not found in given secured api key."
      };
      return parseInt(t[1], 10) - Math.round(new Date().getTime() / 1e3);
    },
    getSettings: gW,
    getSynonym: e => (t, r) => e.transporter.read({
      method: Nz.Get,
      path: Mz("1/indexes/%s/synonyms/%s", e.indexName, t)
    }, r),
    getTask: bW,
    getTopUserIDs: e => t => e.transporter.read({
      method: Nz.Get,
      path: "1/clusters/mapping/top"
    }, t),
    getUserID: e => (t, r) => e.transporter.read({
      method: Nz.Get,
      path: Mz("1/clusters/mapping/%s", t)
    }, r),
    hasPendingMappings: e => t => {
      const {
        retrieveMappings: r,
        ...n
      } = t || {};
      return !0 === r && (n.getClusters = !0), e.transporter.read({
        method: Nz.Get,
        path: "1/clusters/mapping/pending"
      }, n);
    },
    initIndex: mW,
    listApiKeys: e => t => e.transporter.read({
      method: Nz.Get,
      path: "1/keys"
    }, t),
    listClusters: e => t => e.transporter.read({
      method: Nz.Get,
      path: "1/clusters"
    }, t),
    listIndices: e => t => e.transporter.read({
      method: Nz.Get,
      path: "1/indexes"
    }, t),
    listUserIDs: e => t => e.transporter.read({
      method: Nz.Get,
      path: "1/clusters/mapping"
    }, t),
    moveIndex: e => (t, r, n) => jz(e.transporter.write({
      method: Nz.Post,
      path: Mz("1/indexes/%s/operation", t),
      data: {
        operation: "move",
        destination: r
      }
    }, n), (r, n) => mW(e)(t, {
      methods: {
        waitTask: MW
      }
    }).waitTask(r.taskID, n)),
    multipleBatch: e => (t, r) => jz(e.transporter.write({
      method: Nz.Post,
      path: "1/indexes/*/batch",
      data: {
        requests: t
      }
    }, r), (t, r) => Promise.all(Object.keys(t.taskID).map(n => mW(e)(n, {
      methods: {
        waitTask: MW
      }
    }).waitTask(t.taskID[n], r)))),
    multipleGetObjects: e => (t, r) => e.transporter.read({
      method: Nz.Post,
      path: "1/indexes/*/objects",
      data: {
        requests: t
      }
    }, r),
    multipleQueries: e => (t, r) => {
      const n = t.map(e => ({
        ...e,
        params: $z(e.params || {})
      }));
      return e.transporter.read({
        method: Nz.Post,
        path: "1/indexes/*/queries",
        data: {
          requests: n
        },
        cacheable: !0
      }, r);
    },
    multipleSearchForFacetValues: e => (t, r) => Promise.all(t.map(t => {
      const {
        facetName: n,
        facetQuery: a,
        ...o
      } = t.params;
      return mW(e)(t.indexName, {
        methods: {
          searchForFacetValues: jW
        }
      }).searchForFacetValues(n, a, {
        ...r,
        ...o
      });
    })),
    partialUpdateObject: e => (t, r) => jz(wW(e)([t], r).then(e => ({
      objectID: e.objectIDs[0],
      taskID: e.taskIDs[0]
    })), (t, r) => MW(e)(t.taskID, r)),
    partialUpdateObjects: wW,
    removeUserID: e => (t, r) => {
      const n = Bz(r);
      return n.queryParameters["X-Algolia-User-ID"] = t, e.transporter.write({
        method: Nz.Delete,
        path: "1/clusters/mapping"
      }, n);
    },
    replaceAllObjects: e => (t, r) => {
      const {
          safe: n,
          autoGenerateObjectIDIfNotExist: a,
          batchSize: o,
          ...i
        } = r || {},
        l = (t, r, n, a) => jz(e.transporter.write({
          method: Nz.Post,
          path: Mz("1/indexes/%s/operation", t),
          data: {
            operation: n,
            destination: r
          }
        }, a), (t, r) => MW(e)(t.taskID, r)),
        s = Math.random().toString(36).substring(7),
        c = "".concat(e.indexName, "_tmp_").concat(s),
        u = yW({
          appId: e.appId,
          transporter: e.transporter,
          indexName: c
        });
      let h = [];
      const m = l(e.indexName, c, "copy", {
        ...i,
        scope: ["settings", "synonyms", "rules"]
      });
      h.push(m);
      return jz((n ? m.wait(i) : m).then(() => {
        const e = u(t, {
          ...i,
          autoGenerateObjectIDIfNotExist: a,
          batchSize: o
        });
        return h.push(e), n ? e.wait(i) : e;
      }).then(() => {
        const t = l(c, e.indexName, "move", i);
        return h.push(t), n ? t.wait(i) : t;
      }).then(() => Promise.all(h)).then(_ref10 => {
        let [e, t, r] = _ref10;
        return {
          objectIDs: t.objectIDs,
          taskIDs: [e.taskID, ...t.taskIDs, r.taskID]
        };
      }), (e, t) => Promise.all(h.map(e => e.wait(t))));
    },
    replaceAllRules: e => (t, r) => xW(e)(t, {
      ...r,
      clearExistingRules: !0
    }),
    replaceAllSynonyms: e => (t, r) => OW(e)(t, {
      ...r,
      clearExistingSynonyms: !0
    }),
    replaceDictionaryEntries: e => (t, r, n) => {
      const a = r.map(e => ({
        action: "addEntry",
        body: e
      }));
      return jz(e.transporter.write({
        method: Nz.Post,
        path: Mz("/1/dictionaries/%s/batch", t),
        data: {
          clearExistingDictionaryEntries: !0,
          requests: a
        }
      }, n), (t, r) => pW(e)(t.taskID, r));
    },
    restoreApiKey: e => (t, r) => jz(e.transporter.write({
      method: Nz.Post,
      path: Mz("1/keys/%s/restore", t)
    }, r), (r, n) => Ez(r => uW(e)(t, n).catch(e => {
      if (404 !== e.status) throw e;
      return r();
    }))),
    saveDictionaryEntries: e => (t, r, n) => {
      const a = r.map(e => ({
        action: "addEntry",
        body: e
      }));
      return jz(e.transporter.write({
        method: Nz.Post,
        path: Mz("/1/dictionaries/%s/batch", t),
        data: {
          clearExistingDictionaryEntries: !1,
          requests: a
        }
      }, n), (t, r) => pW(e)(t.taskID, r));
    },
    saveObject: e => (t, r) => jz(yW(e)([t], r).then(e => ({
      objectID: e.objectIDs[0],
      taskID: e.taskIDs[0]
    })), (t, r) => MW(e)(t.taskID, r)),
    saveObjects: yW,
    saveRule: e => (t, r) => xW(e)([t], r),
    saveRules: xW,
    saveSynonym: e => (t, r) => OW(e)([t], r),
    saveSynonyms: OW,
    search: EW,
    searchDictionaryEntries: e => (t, r, n) => e.transporter.read({
      method: Nz.Post,
      path: Mz("/1/dictionaries/%s/search", t),
      data: {
        query: r
      },
      cacheable: !0
    }, n),
    searchForFacetValues: jW,
    searchRules: CW,
    searchSynonyms: PW,
    searchUserIDs: e => (t, r) => e.transporter.read({
      method: Nz.Post,
      path: "1/clusters/mapping/search",
      data: {
        query: t
      }
    }, r),
    setDictionarySettings: e => (t, r) => jz(e.transporter.write({
      method: Nz.Put,
      path: "/1/dictionaries/*/settings",
      data: t
    }, r), (t, r) => pW(e)(t.taskID, r)),
    setSettings: e => (t, r) => {
      const {
          forwardToReplicas: n,
          ...a
        } = r || {},
        o = Bz(a);
      return n && (o.queryParameters.forwardToReplicas = 1), jz(e.transporter.write({
        method: Nz.Put,
        path: Mz("1/indexes/%s/settings", e.indexName),
        data: t
      }, o), (t, r) => MW(e)(t.taskID, r));
    },
    updateApiKey: e => (t, r) => {
      const n = Object.assign({}, r),
        {
          queryParameters: a,
          ...o
        } = r || {},
        i = a ? {
          queryParameters: a
        } : {},
        l = ["acl", "indexes", "referers", "restrictSources", "queryParameters", "description", "maxQueriesPerIPPerHour", "maxHitsPerQuery"];
      return jz(e.transporter.write({
        method: Nz.Put,
        path: Mz("1/keys/%s", t),
        data: i
      }, o), (r, a) => Ez(r => uW(e)(t, a).then(e => (e => Object.keys(n).filter(e => -1 !== l.indexOf(e)).every(t => {
        if (Array.isArray(e[t]) && Array.isArray(n[t])) {
          const r = e[t];
          return r.length === n[t].length && r.every((e, r) => e === n[t][r]);
        }
        return e[t] === n[t];
      }))(e) ? Promise.resolve() : r())));
    },
    waitAppTask: pW,
    waitTask: MW
  }),
  BW = H(NW);
var VW = H(Object.freeze({
  __proto__: null,
  LogLevelEnum: {
    Debug: 1,
    Info: 2,
    Error: 3
  },
  createNullLogger: function () {
    return {
      debug: (e, t) => Promise.resolve(),
      info: (e, t) => Promise.resolve(),
      error: (e, t) => Promise.resolve()
    };
  }
}));
const RW = {
    keepAlive: !0
  },
  AW = new C(RW),
  TW = new M(RW);
var HW = Object.freeze({
    __proto__: null,
    createNodeHttpRequester: function () {
      let {
        agent: e,
        httpAgent: t,
        httpsAgent: r,
        requesterOptions: n = {}
      } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      const a = t || e || AW,
        o = r || e || TW;
      return {
        send: e => new Promise(t => {
          const r = k(e.url),
            i = null === r.query ? r.pathname : "".concat(r.pathname, "?").concat(r.query),
            l = {
              ...n,
              agent: "https:" === r.protocol ? o : a,
              hostname: r.hostname,
              path: i,
              method: e.method,
              headers: {
                ...(n && n.headers ? n.headers : {}),
                ...e.headers
              },
              ...(void 0 !== r.port ? {
                port: r.port || ""
              } : {})
            },
            s = ("https:" === r.protocol ? P : j).request(l, e => {
              let r = [];
              e.on("data", e => {
                r = r.concat(e);
              }), e.on("end", () => {
                clearTimeout(u), clearTimeout(h), t({
                  status: e.statusCode || 0,
                  content: Buffer.concat(r).toString(),
                  isTimedOut: !1
                });
              });
            }),
            c = (e, r) => setTimeout(() => {
              s.abort(), t({
                status: 0,
                content: r,
                isTimedOut: !0
              });
            }, 1e3 * e),
            u = c(e.connectTimeout, "Connection timeout");
          let h;
          s.on("error", e => {
            clearTimeout(u), clearTimeout(h), t({
              status: 0,
              content: e.message,
              isTimedOut: !1
            });
          }), s.once("response", () => {
            clearTimeout(u), h = c(e.responseTimeout, "Socket timeout");
          }), void 0 !== e.data && s.write(e.data), s.end();
        }),
        destroy: () => (a.destroy(), o.destroy(), Promise.resolve())
      };
    }
  }),
  LW = wz,
  IW = xz,
  FW = tW,
  _W = rW,
  ZW = aW,
  DW = BW,
  qW = VW,
  UW = H(HW),
  $W = H(Jz);
function zW(e, t, r) {
  const n = {
      appId: e,
      apiKey: t,
      timeouts: {
        connect: 2,
        read: 5,
        write: 30
      },
      requester: UW.createNodeHttpRequester(),
      logger: qW.createNullLogger(),
      responsesCache: LW.createNullCache(),
      requestsCache: LW.createNullCache(),
      hostsCache: IW.createInMemoryCache(),
      userAgent: $W.createUserAgent(_W.version).add({
        segment: "Node.js",
        version: process.versions.node
      })
    },
    a = {
      ...n,
      ...r
    },
    o = () => e => ZW.createPersonalizationClient({
      ...n,
      ...e,
      methods: {
        getPersonalizationStrategy: ZW.getPersonalizationStrategy,
        setPersonalizationStrategy: ZW.setPersonalizationStrategy
      }
    });
  return DW.createSearchClient({
    ...a,
    methods: {
      search: DW.multipleQueries,
      searchForFacetValues: DW.multipleSearchForFacetValues,
      multipleBatch: DW.multipleBatch,
      multipleGetObjects: DW.multipleGetObjects,
      multipleQueries: DW.multipleQueries,
      copyIndex: DW.copyIndex,
      copySettings: DW.copySettings,
      copyRules: DW.copyRules,
      copySynonyms: DW.copySynonyms,
      moveIndex: DW.moveIndex,
      listIndices: DW.listIndices,
      getLogs: DW.getLogs,
      listClusters: DW.listClusters,
      multipleSearchForFacetValues: DW.multipleSearchForFacetValues,
      getApiKey: DW.getApiKey,
      addApiKey: DW.addApiKey,
      listApiKeys: DW.listApiKeys,
      updateApiKey: DW.updateApiKey,
      deleteApiKey: DW.deleteApiKey,
      restoreApiKey: DW.restoreApiKey,
      assignUserID: DW.assignUserID,
      assignUserIDs: DW.assignUserIDs,
      getUserID: DW.getUserID,
      searchUserIDs: DW.searchUserIDs,
      listUserIDs: DW.listUserIDs,
      getTopUserIDs: DW.getTopUserIDs,
      removeUserID: DW.removeUserID,
      hasPendingMappings: DW.hasPendingMappings,
      generateSecuredApiKey: DW.generateSecuredApiKey,
      getSecuredApiKeyRemainingValidity: DW.getSecuredApiKeyRemainingValidity,
      destroy: _W.destroy,
      clearDictionaryEntries: DW.clearDictionaryEntries,
      deleteDictionaryEntries: DW.deleteDictionaryEntries,
      getDictionarySettings: DW.getDictionarySettings,
      getAppTask: DW.getAppTask,
      replaceDictionaryEntries: DW.replaceDictionaryEntries,
      saveDictionaryEntries: DW.saveDictionaryEntries,
      searchDictionaryEntries: DW.searchDictionaryEntries,
      setDictionarySettings: DW.setDictionarySettings,
      waitAppTask: DW.waitAppTask,
      customRequest: DW.customRequest,
      initIndex: e => t => DW.initIndex(e)(t, {
        methods: {
          batch: DW.batch,
          delete: DW.deleteIndex,
          findAnswers: DW.findAnswers,
          getObject: DW.getObject,
          getObjects: DW.getObjects,
          saveObject: DW.saveObject,
          saveObjects: DW.saveObjects,
          search: DW.search,
          searchForFacetValues: DW.searchForFacetValues,
          waitTask: DW.waitTask,
          setSettings: DW.setSettings,
          getSettings: DW.getSettings,
          partialUpdateObject: DW.partialUpdateObject,
          partialUpdateObjects: DW.partialUpdateObjects,
          deleteObject: DW.deleteObject,
          deleteObjects: DW.deleteObjects,
          deleteBy: DW.deleteBy,
          clearObjects: DW.clearObjects,
          browseObjects: DW.browseObjects,
          getObjectPosition: DW.getObjectPosition,
          findObject: DW.findObject,
          exists: DW.exists,
          saveSynonym: DW.saveSynonym,
          saveSynonyms: DW.saveSynonyms,
          getSynonym: DW.getSynonym,
          searchSynonyms: DW.searchSynonyms,
          browseSynonyms: DW.browseSynonyms,
          deleteSynonym: DW.deleteSynonym,
          clearSynonyms: DW.clearSynonyms,
          replaceAllObjects: DW.replaceAllObjects,
          replaceAllSynonyms: DW.replaceAllSynonyms,
          searchRules: DW.searchRules,
          getRule: DW.getRule,
          deleteRule: DW.deleteRule,
          saveRule: DW.saveRule,
          saveRules: DW.saveRules,
          replaceAllRules: DW.replaceAllRules,
          browseRules: DW.browseRules,
          clearRules: DW.clearRules
        }
      }),
      initAnalytics: () => e => FW.createAnalyticsClient({
        ...n,
        ...e,
        methods: {
          addABTest: FW.addABTest,
          getABTest: FW.getABTest,
          getABTests: FW.getABTests,
          stopABTest: FW.stopABTest,
          deleteABTest: FW.deleteABTest
        }
      }),
      initPersonalization: o,
      initRecommendation: () => e => (a.logger.info("The `initRecommendation` method is deprecated. Use `initPersonalization` instead."), o()(e))
    }
  });
}
zW.version = _W.version;
const WW = zW;
vz.exports = WW, vz.exports.default = WW;
var QW = T(vz.exports),
  GW = "undefined" != typeof Element,
  YW = "function" == typeof Map,
  KW = "function" == typeof Set,
  XW = "function" == typeof ArrayBuffer && !!ArrayBuffer.isView;
function JW(e, t) {
  if (e === t) return !0;
  if (e && t && "object" == typeof e && "object" == typeof t) {
    if (e.constructor !== t.constructor) return !1;
    var r, n, a, o;
    if (Array.isArray(e)) {
      if ((r = e.length) != t.length) return !1;
      for (n = r; 0 != n--;) if (!JW(e[n], t[n])) return !1;
      return !0;
    }
    if (YW && e instanceof Map && t instanceof Map) {
      if (e.size !== t.size) return !1;
      for (o = e.entries(); !(n = o.next()).done;) if (!t.has(n.value[0])) return !1;
      for (o = e.entries(); !(n = o.next()).done;) if (!JW(n.value[1], t.get(n.value[0]))) return !1;
      return !0;
    }
    if (KW && e instanceof Set && t instanceof Set) {
      if (e.size !== t.size) return !1;
      for (o = e.entries(); !(n = o.next()).done;) if (!t.has(n.value[0])) return !1;
      return !0;
    }
    if (XW && ArrayBuffer.isView(e) && ArrayBuffer.isView(t)) {
      if ((r = e.length) != t.length) return !1;
      for (n = r; 0 != n--;) if (e[n] !== t[n]) return !1;
      return !0;
    }
    if (e.constructor === RegExp) return e.source === t.source && e.flags === t.flags;
    if (e.valueOf !== Object.prototype.valueOf && "function" == typeof e.valueOf && "function" == typeof t.valueOf) return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString && "function" == typeof e.toString && "function" == typeof t.toString) return e.toString() === t.toString();
    if ((r = (a = Object.keys(e)).length) !== Object.keys(t).length) return !1;
    for (n = r; 0 != n--;) if (!Object.prototype.hasOwnProperty.call(t, a[n])) return !1;
    if (GW && e instanceof Element) return !1;
    for (n = r; 0 != n--;) if (("_owner" !== a[n] && "__v" !== a[n] && "__o" !== a[n] || !e.$$typeof) && !JW(e[a[n]], t[a[n]])) return !1;
    return !0;
  }
  return e != e && t != t;
}
var eQ = function (e, t) {
    try {
      return JW(e, t);
    } catch (e) {
      if ((e.message || "").match(/stack|recursion/i)) return console.warn("react-fast-compare cannot handle circular refs"), !1;
      throw e;
    }
  },
  tQ = T(eQ);
function rQ(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function nQ(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? rQ(Object(r), !0).forEach(function (t) {
      aQ(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : rQ(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
function aQ(e, t, r) {
  return (t = function (e) {
    var t = function (e, t) {
      if ("object" !== oQ(e) || null === e) return e;
      var r = e[Symbol.toPrimitive];
      if (void 0 !== r) {
        var n = r.call(e, t || "default");
        if ("object" !== oQ(n)) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === t ? String : Number)(e);
    }(e, "string");
    return "symbol" === oQ(t) ? t : String(t);
  }(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function oQ(e) {
  return oQ = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, oQ(e);
}
var iQ = Object.prototype.hasOwnProperty,
  lQ = function (e, t) {
    if (e === t) return !0;
    var r = Object.keys(e),
      n = Object.keys(t);
    if (r.length !== n.length) return !1;
    for (var a = 0; a < r.length; a++) if (!iQ.call(t, r[a]) || e[r[a]] !== t[r[a]]) return !1;
    return !0;
  },
  sQ = function (e) {
    return e.displayName || e.name || "UnknownComponent";
  },
  cQ = Promise.resolve(),
  uQ = function (e) {
    cQ.then(e);
  },
  hQ = function e(t) {
    return Object.keys(t).forEach(function (r) {
      var n,
        a = t[r];
      (function (e) {
        return "object" === oQ(e) && null !== e && !Array.isArray(e);
      })(a) && ((n = a) && Object.keys(n).length > 0 ? e(a) : delete t[r]);
    }), t;
  };
function mQ(e, t, r) {
  return e.map(function (e, n) {
    return nQ(nQ({}, e), {}, {
      __position: t * r + n + 1
    });
  });
}
function pQ(e, t) {
  return t ? e.map(function (e) {
    return nQ(nQ({}, e), {}, {
      __queryID: t
    });
  }) : e;
}
function fQ(e, t) {
  if (Array.isArray(e)) for (var r = 0; r < e.length; r++) if (t(e[r])) return e[r];
}
function dQ(e, t) {
  if (null == e) return {};
  for (var r = {}, n = Object.keys(e), a = 0; a < n.length; a++) {
    var o = n[a];
    t.indexOf(o) >= 0 || (r[o] = e[o]);
  }
  return r;
}
var vQ = function (e, t) {
  return (Array.isArray(t) ? t : t.replace(/\[(\d+)]/g, ".$1").split(".")).reduce(function (e, t) {
    return e ? e[t] : void 0;
  }, e);
};
function gQ(e) {
  return e.replace(/^\\-/, "-");
}
var bQ = o({
    onInternalStateUpdate: function () {},
    createHrefForState: function () {
      return "#";
    },
    onSearchForFacetValues: function () {},
    onSearchStateChange: function () {},
    onSearchParameters: function () {},
    store: {},
    widgetsManager: {},
    mainTargetedIndex: ""
  }),
  wQ = bQ.Consumer,
  yQ = bQ.Provider,
  xQ = o(void 0),
  OQ = xQ.Consumer,
  EQ = xQ.Provider,
  jQ = ["contextValue"];
function CQ(e) {
  return CQ = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, CQ(e);
}
function PQ() {
  return PQ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, PQ.apply(this, arguments);
}
function MQ(e, t) {
  if (null == e) return {};
  var r,
    n,
    a = function (e, t) {
      if (null == e) return {};
      var r,
        n,
        a = {},
        o = Object.keys(e);
      for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || (a[r] = e[r]);
      return a;
    }(e, t);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (a[r] = e[r]);
  }
  return a;
}
function kQ(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function SQ(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? kQ(Object(r), !0).forEach(function (t) {
      TQ(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : kQ(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
function NQ(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, HQ(n.key), n);
  }
}
function BQ(e, t) {
  return BQ = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
    return e.__proto__ = t, e;
  }, BQ(e, t);
}
function VQ(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = AQ(e);
    if (t) {
      var a = AQ(this).constructor;
      r = Reflect.construct(n, arguments, a);
    } else r = n.apply(this, arguments);
    return function (e, t) {
      if (t && ("object" === CQ(t) || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return RQ(e);
    }(this, r);
  };
}
function RQ(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function AQ(e) {
  return AQ = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, AQ(e);
}
function TQ(e, t, r) {
  return (t = HQ(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function HQ(e) {
  var t = function (e, t) {
    if ("object" !== CQ(e) || null === e) return e;
    var r = e[Symbol.toPrimitive];
    if (void 0 !== r) {
      var n = r.call(e, t || "default");
      if ("object" !== CQ(n)) return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === t ? String : Number)(e);
  }(e, "string");
  return "symbol" === CQ(t) ? t : String(t);
}
function LQ(e) {
  if (!e.displayName) throw new Error("`createConnector` requires you to provide a `displayName` property.");
  var r = "function" == typeof e.getSearchParameters || "function" == typeof e.getMetadata || "function" == typeof e.transitionState;
  return function (n) {
    var a = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      o = function (a) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && BQ(e, t);
        }(u, i);
        var o,
          l,
          s,
          c = VQ(u);
        function u(t) {
          var r;
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, u), TQ(RQ(r = c.call(this, t)), "unsubscribe", void 0), TQ(RQ(r), "unregisterWidget", void 0), TQ(RQ(r), "cleanupTimerRef", null), TQ(RQ(r), "isUnmounting", !1), TQ(RQ(r), "state", {
            providedProps: r.getProvidedProps(r.props)
          }), TQ(RQ(r), "refine", function () {
            for (var t, n = arguments.length, a = new Array(n), o = 0; o < n; o++) a[o] = arguments[o];
            r.props.contextValue.onInternalStateUpdate((t = e.refine).call.apply(t, [RQ(r), r.props, r.props.contextValue.store.getState().widgets].concat(a)));
          }), TQ(RQ(r), "createURL", function () {
            for (var t, n = arguments.length, a = new Array(n), o = 0; o < n; o++) a[o] = arguments[o];
            return r.props.contextValue.createHrefForState((t = e.refine).call.apply(t, [RQ(r), r.props, r.props.contextValue.store.getState().widgets].concat(a)));
          }), TQ(RQ(r), "searchForFacetValues", function () {
            for (var t, n = arguments.length, a = new Array(n), o = 0; o < n; o++) a[o] = arguments[o];
            r.props.contextValue.onSearchForFacetValues((t = e.searchForFacetValues).call.apply(t, [RQ(r), r.props, r.props.contextValue.store.getState().widgets].concat(a)));
          }), e.getSearchParameters && r.props.contextValue.onSearchParameters(e.getSearchParameters.bind(RQ(r)), {
            ais: r.props.contextValue,
            multiIndexContext: r.props.indexContextValue
          }, r.props, e.getMetadata && e.getMetadata.bind(RQ(r)), e.displayName), r;
        }
        return o = u, l = [{
          key: "componentDidMount",
          value: function () {
            var e = this;
            this.cleanupTimerRef && (clearTimeout(this.cleanupTimerRef), this.cleanupTimerRef = null), this.unsubscribe = this.props.contextValue.store.subscribe(function () {
              e.isUnmounting || e.setState({
                providedProps: e.getProvidedProps(e.props)
              });
            }), r && (this.unregisterWidget = this.props.contextValue.widgetsManager.registerWidget(this));
          }
        }, {
          key: "shouldComponentUpdate",
          value: function (t, r) {
            if ("function" == typeof e.shouldComponentUpdate) return e.shouldComponentUpdate.call(this, this.props, t, this.state, r);
            var n = lQ(this.props, t);
            return null === this.state.providedProps || null === r.providedProps ? this.state.providedProps !== r.providedProps || !n : !n || !lQ(this.state.providedProps, r.providedProps);
          }
        }, {
          key: "componentDidUpdate",
          value: function (t) {
            tQ(t, this.props) || (this.setState({
              providedProps: this.getProvidedProps(this.props)
            }), r && (this.props.contextValue.widgetsManager.update(), "function" == typeof e.transitionState && this.props.contextValue.onSearchStateChange(e.transitionState.call(this, this.props, this.props.contextValue.store.getState().widgets, this.props.contextValue.store.getState().widgets))));
          }
        }, {
          key: "componentWillUnmount",
          value: function () {
            var t = this;
            this.cleanupTimerRef = setTimeout(function () {
              if (t.isUnmounting = !0, t.unsubscribe && t.unsubscribe(), t.unregisterWidget && (t.unregisterWidget(), "function" == typeof e.cleanUp)) {
                var r = e.cleanUp.call(t, t.props, t.props.contextValue.store.getState().widgets);
                t.props.contextValue.store.setState(SQ(SQ({}, t.props.contextValue.store.getState()), {}, {
                  widgets: r
                })), t.props.contextValue.onSearchStateChange(hQ(r));
              }
            });
          }
        }, {
          key: "getProvidedProps",
          value: function (t) {
            var r = this.props.contextValue.store.getState(),
              n = r.widgets,
              a = r.results,
              o = r.resultsFacetValues,
              i = r.searching,
              l = r.searchingForFacetValues,
              s = r.isSearchStalled,
              c = r.metadata,
              u = {
                results: a,
                searching: i,
                searchingForFacetValues: l,
                isSearchStalled: s,
                error: r.error
              };
            return e.getProvidedProps.call(this, t, n, u, c, o);
          }
        }, {
          key: "getSearchParameters",
          value: function (t) {
            return "function" == typeof e.getSearchParameters ? e.getSearchParameters.call(this, t, this.props, this.props.contextValue.store.getState().widgets) : null;
          }
        }, {
          key: "getMetadata",
          value: function (t) {
            return "function" == typeof e.getMetadata ? e.getMetadata.call(this, this.props, t) : {};
          }
        }, {
          key: "transitionState",
          value: function (t, r) {
            return "function" == typeof e.transitionState ? e.transitionState.call(this, this.props, t, r) : r;
          }
        }, {
          key: "render",
          value: function () {
            var r = this.props;
            r.contextValue;
            var a = MQ(r, jQ),
              o = this.state.providedProps;
            if (null === o) return null;
            var i = "function" == typeof e.refine ? {
                refine: this.refine,
                createURL: this.createURL
              } : {},
              l = "function" == typeof e.searchForFacetValues ? {
                searchForItems: this.searchForFacetValues
              } : {};
            return t.createElement(n, PQ({}, a, o, i, l));
          }
        }], l && NQ(o.prototype, l), s && NQ(o, s), Object.defineProperty(o, "prototype", {
          writable: !1
        }), u;
      }();
    return TQ(o, "displayName", "".concat(e.displayName, "(").concat(sQ(n), ")")), TQ(o, "$$type", e.$$type), TQ(o, "$$widgetType", a.$$widgetType), TQ(o, "propTypes", e.propTypes), TQ(o, "defaultProps", e.defaultProps), TQ(o, "_connectorDesc", e), o;
  };
}
var IQ = function (e) {
    return function (r, n) {
      var a = LQ(e)(r, n);
      return function (e) {
        return t.createElement(wQ, null, function (r) {
          return t.createElement(OQ, null, function (n) {
            return t.createElement(a, PQ({
              contextValue: r,
              indexContextValue: n
            }, e));
          });
        });
      };
    };
  },
  FQ = {
    highlightPreTag: "<ais-highlight-0000000000>",
    highlightPostTag: "</ais-highlight-0000000000>"
  };
function _Q(e) {
  var t = e.preTag,
    r = e.postTag,
    n = e.highlightedValue,
    a = (void 0 === n ? "" : n).split(t),
    o = a.shift(),
    i = "" === o ? [] : [{
      value: o,
      isHighlighted: !1
    }];
  if (r === t) {
    var l = !0;
    a.forEach(function (e) {
      i.push({
        value: e,
        isHighlighted: l
      }), l = !l;
    });
  } else a.forEach(function (e) {
    var t = e.split(r);
    i.push({
      value: t[0],
      isHighlighted: !0
    }), "" !== t[1] && i.push({
      value: t[1],
      isHighlighted: !1
    });
  });
  return i;
}
var ZQ = "6.40.1";
function DQ(e) {
  return DQ = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, DQ(e);
}
function qQ() {
  return qQ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, qQ.apply(this, arguments);
}
function UQ(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, GQ(n.key), n);
  }
}
function $Q(e, t) {
  return $Q = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
    return e.__proto__ = t, e;
  }, $Q(e, t);
}
function zQ(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = QQ(e);
    if (t) {
      var a = QQ(this).constructor;
      r = Reflect.construct(n, arguments, a);
    } else r = n.apply(this, arguments);
    return function (e, t) {
      if (t && ("object" === DQ(t) || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return WQ(e);
    }(this, r);
  };
}
function WQ(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function QQ(e) {
  return QQ = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, QQ(e);
}
function GQ(e) {
  var t = function (e, t) {
    if ("object" !== DQ(e) || null === e) return e;
    var r = e[Symbol.toPrimitive];
    if (void 0 !== r) {
      var n = r.call(e, t || "default");
      if ("object" !== DQ(n)) return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === t ? String : Number)(e);
  }(e, "string");
  return "symbol" === DQ(t) ? t : String(t);
}
var YQ = function (e) {
  return function (t, r, n) {
    var a = t[r];
    if (a) for (var o = 0, i = Object.keys(a); o < i.length; o++) {
      var l = i[o];
      if (-1 === e.indexOf(l)) return new Error("Unknown `".concat(r, "` key `").concat(l, "`. Check the render method ") + "of `".concat(n, "`."));
    }
  };
};
function KQ(e) {
  return function (r) {
    var n = function (n) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && $Q(e, t);
        }(c, i);
        var a,
          o,
          l,
          s = zQ(c);
        function c() {
          var t, r, n, a;
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, c);
          for (var o = arguments.length, i = new Array(o), l = 0; l < o; l++) i[l] = arguments[l];
          return t = s.call.apply(s, [this].concat(i)), r = WQ(t), a = function (r) {
            var n = t.props.translations,
              a = n && n.hasOwnProperty(r) ? n[r] : e[r];
            if ("function" == typeof a) {
              for (var o = arguments.length, i = new Array(o > 1 ? o - 1 : 0), l = 1; l < o; l++) i[l - 1] = arguments[l];
              return a.apply(void 0, i);
            }
            return a;
          }, (n = GQ(n = "translate")) in r ? Object.defineProperty(r, n, {
            value: a,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : r[n] = a, t;
        }
        return a = c, (o = [{
          key: "render",
          value: function () {
            return t.createElement(r, qQ({
              translate: this.translate
            }, this.props));
          }
        }]) && UQ(a.prototype, o), l && UQ(a, l), Object.defineProperty(a, "prototype", {
          writable: !1
        }), c;
      }(),
      a = r.displayName || r.name || "UnknownComponent";
    return n.displayName = "Translatable(".concat(a, ")"), n.propTypes = {
      translations: YQ(Object.keys(e))
    }, n;
  };
}
function XQ(e) {
  return XQ = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, XQ(e);
}
function JQ(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function eG(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? JQ(Object(r), !0).forEach(function (t) {
      tG(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : JQ(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
function tG(e, t, r) {
  return (t = function (e) {
    var t = function (e, t) {
      if ("object" !== XQ(e) || null === e) return e;
      var r = e[Symbol.toPrimitive];
      if (void 0 !== r) {
        var n = r.call(e, t || "default");
        if ("object" !== XQ(n)) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === t ? String : Number)(e);
    }(e, "string");
    return "symbol" === XQ(t) ? t : String(t);
  }(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function rG(e) {
  return aG(e) ? e.multiIndexContext.targetedIndex : e.ais.mainTargetedIndex;
}
function nG(e, t) {
  if (e.results) {
    if (e.results.hits) return e.results;
    var r = rG(t);
    if (e.results[r]) return e.results[r];
  }
  return null;
}
function aG(e) {
  return e && e.multiIndexContext;
}
function oG(e, t, r, n, a) {
  if (aG(r)) {
    var o = rG(r);
    return a ? function (e, t, r, n, a) {
      var o,
        i = n ? {
          page: 1
        } : void 0,
        l = e.indices && e.indices[r] ? eG(eG({}, e.indices), {}, tG({}, r, eG(eG({}, e.indices[r]), {}, (tG(o = {}, a, eG(eG({}, e.indices[r][a]), t)), tG(o, "page", 1), o)))) : eG(eG({}, e.indices), {}, tG({}, r, eG(tG({}, a, t), i)));
      return eG(eG({}, e), {}, {
        indices: l
      });
    }(e, t, o, n, a) : function (e, t, r, n) {
      var a = n ? {
          page: 1
        } : void 0,
        o = e.indices && e.indices[r] ? eG(eG({}, e.indices), {}, tG({}, r, eG(eG(eG({}, e.indices[r]), t), a))) : eG(eG({}, e.indices), {}, tG({}, r, eG(eG({}, t), a)));
      return eG(eG({}, e), {}, {
        indices: o
      });
    }(e, t, o, n);
  }
  return e.indices && n && Object.keys(e.indices).forEach(function (t) {
    e = oG(e, {
      page: 1
    }, {
      multiIndexContext: {
        targetedIndex: t
      }
    }, !0, a);
  }), a ? function (e, t, r, n) {
    var a = r ? {
      page: 1
    } : void 0;
    return eG(eG({}, e), {}, tG({}, n, eG(eG({}, e[n]), t)), a);
  }(e, t, n, a) : function (e, t, r) {
    var n = r ? {
      page: 1
    } : void 0;
    return eG(eG(eG({}, e), t), n);
  }(e, t, n);
}
function iG(e) {
  var t = e.match(/^([^.]*)\.(.*)/);
  return {
    namespace: t && t[1],
    attributeName: t && t[2]
  };
}
function lG(e, t, r, n, a) {
  var o = rG(r),
    i = iG(n),
    l = i.namespace,
    s = i.attributeName,
    c = {
      multiIndex: aG(r),
      indexId: o,
      namespace: l,
      attributeName: s,
      id: n,
      searchState: t
    },
    u = function (e) {
      var t = e.multiIndex,
        r = e.indexId,
        n = e.namespace,
        a = e.attributeName,
        o = e.id,
        i = e.searchState;
      return t && n ? i.indices && i.indices[r] && i.indices[r][n] && Object.hasOwnProperty.call(i.indices[r][n], a) : t ? i.indices && i.indices[r] && Object.hasOwnProperty.call(i.indices[r], o) : n ? i[n] && Object.hasOwnProperty.call(i[n], a) : Object.hasOwnProperty.call(i, o);
    }(c);
  return u ? function (e) {
    var t = e.multiIndex,
      r = e.indexId,
      n = e.namespace,
      a = e.attributeName,
      o = e.id,
      i = e.searchState;
    return t && n ? i.indices[r][n][a] : t ? i.indices[r][o] : n ? i[n][a] : i[o];
  }(c) : e.defaultRefinement ? e.defaultRefinement : a;
}
function sG(e, t, r) {
  var n = rG(t),
    a = iG(r),
    o = a.namespace,
    i = a.attributeName;
  return aG(t) && Boolean(e.indices) ? function (e) {
    var t = e.searchState,
      r = e.indexId,
      n = e.id,
      a = e.namespace,
      o = e.attribute,
      i = t.indices[r];
    if (a && i) return eG(eG({}, t), {}, {
      indices: eG(eG({}, t.indices), {}, tG({}, r, eG(eG({}, i), {}, tG({}, a, dQ(i[a], [o])))))
    });
    if (i) return eG(eG({}, t), {}, {
      indices: eG(eG({}, t.indices), {}, tG({}, r, dQ(i, [n])))
    });
    return t;
  }({
    attribute: i,
    searchState: e,
    indexId: n,
    id: r,
    namespace: o
  }) : function (e) {
    var t = e.searchState,
      r = e.id,
      n = e.namespace,
      a = e.attribute;
    if (n) return eG(eG({}, t), {}, tG({}, n, dQ(t[n], [a])));
    return dQ(t, [r]);
  }({
    attribute: i,
    searchState: e,
    id: r,
    namespace: o
  });
}
function cG(e) {
  return cG = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, cG(e);
}
var uG = ["children", "contextValue", "indexContextValue"],
  hG = ["children", "contextValue", "indexContextValue"];
function mG(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function pG(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? mG(Object(r), !0).forEach(function (t) {
      fG(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : mG(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
function fG(e, t, r) {
  return (t = function (e) {
    var t = function (e, t) {
      if ("object" !== cG(e) || null === e) return e;
      var r = e[Symbol.toPrimitive];
      if (void 0 !== r) {
        var n = r.call(e, t || "default");
        if ("object" !== cG(n)) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === t ? String : Number)(e);
    }(e, "string");
    return "symbol" === cG(t) ? t : String(t);
  }(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function dG(e, t) {
  if (null == e) return {};
  var r,
    n,
    a = function (e, t) {
      if (null == e) return {};
      var r,
        n,
        a = {},
        o = Object.keys(e);
      for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || (a[r] = e[r]);
      return a;
    }(e, t);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (a[r] = e[r]);
  }
  return a;
}
var vG = IQ({
  displayName: "AlgoliaConfigure",
  $$type: "ais.configure",
  getProvidedProps: function () {
    return {};
  },
  getSearchParameters: function (e, t) {
    t.children, t.contextValue, t.indexContextValue;
    var r = dG(t, uG);
    return e.setQueryParameters(r);
  },
  transitionState: function (e, t, r) {
    var n = "configure";
    e.children, e.contextValue, e.indexContextValue;
    var a = dG(e, hG),
      o = Object.keys(e),
      i = this._props ? Object.keys(this._props).filter(function (e) {
        return -1 === o.indexOf(e);
      }) : [];
    return this._props = e, oG(r, fG({}, n, pG(pG({}, dQ(r[n], i)), a)), {
      ais: e.contextValue,
      multiIndexContext: e.indexContextValue
    });
  },
  cleanUp: function (e, t) {
    var r = "configure",
      n = rG({
        ais: e.contextValue,
        multiIndexContext: e.indexContextValue
      }),
      a = aG({
        ais: e.contextValue,
        multiIndexContext: e.indexContextValue
      }) && t.indices ? t.indices[n] : t,
      o = (a && a[r] ? Object.keys(a[r]) : []).reduce(function (t, n) {
        return e[n] || (t[n] = a[r][n]), t;
      }, {});
    return oG(t, fG({}, r, o), {
      ais: e.contextValue,
      multiIndexContext: e.indexContextValue
    });
  }
});
function gG(e) {
  return "function" == typeof e || Array.isArray(e) || "[object Object]" === Object.prototype.toString.call(e);
}
function bG(e, t) {
  if (e === t) return e;
  for (var r in t) if (Object.prototype.hasOwnProperty.call(t, r) && "__proto__" !== r && "constructor" !== r) {
    var n = t[r],
      a = e[r];
    void 0 !== a && void 0 === n || (gG(a) && gG(n) ? e[r] = bG(a, n) : e[r] = "object" == typeof (o = n) && null !== o ? bG(Array.isArray(o) ? [] : {}, o) : o);
  }
  var o;
  return e;
}
vG(function () {
  return null;
}, {
  $$widgetType: "ais.configure"
});
var wG = function (e) {
    gG(e) || (e = {});
    for (var t = 1, r = arguments.length; t < r; t++) {
      var n = arguments[t];
      gG(n) && bG(e, n);
    }
    return e;
  },
  yG = function () {
    return Array.prototype.slice.call(arguments).reduceRight(function (e, t) {
      return Object.keys(Object(t)).forEach(function (r) {
        void 0 !== t[r] && (void 0 !== e[r] && delete e[r], e[r] = t[r]);
      }), e;
    }, {});
  };
var xG = function (e, t) {
    return e.filter(function (r, n) {
      return t.indexOf(r) > -1 && e.indexOf(r) === n;
    });
  },
  OG = function (e, t) {
    if (Array.isArray(e)) for (var r = 0; r < e.length; r++) if (t(e[r])) return e[r];
  };
var EG = function e(t) {
  if ("number" == typeof t) return t;
  if ("string" == typeof t) return parseFloat(t);
  if (Array.isArray(t)) return t.map(e);
  throw new Error("The value should be a number, a parsable string or an array of those.");
};
var jG = function (e, t) {
  if (null === e) return {};
  var r,
    n,
    a = {},
    o = Object.keys(e);
  for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || (a[r] = e[r]);
  return a;
};
var CG = function (e) {
    return e && Object.keys(e).length > 0;
  },
  PG = yG,
  MG = jG,
  kG = CG,
  SG = {
    addRefinement: function (e, t, r) {
      if (SG.isRefined(e, t, r)) return e;
      var n = "" + r,
        a = e[t] ? e[t].concat(n) : [n],
        o = {};
      return o[t] = a, PG({}, o, e);
    },
    removeRefinement: function (e, t, r) {
      if (void 0 === r) return SG.clearRefinement(e, function (e, r) {
        return t === r;
      });
      var n = "" + r;
      return SG.clearRefinement(e, function (e, r) {
        return t === r && n === e;
      });
    },
    toggleRefinement: function (e, t, r) {
      if (void 0 === r) throw new Error("toggleRefinement should be used with a value");
      return SG.isRefined(e, t, r) ? SG.removeRefinement(e, t, r) : SG.addRefinement(e, t, r);
    },
    clearRefinement: function (e, t, r) {
      if (void 0 === t) return kG(e) ? {} : e;
      if ("string" == typeof t) return MG(e, [t]);
      if ("function" == typeof t) {
        var n = !1,
          a = Object.keys(e).reduce(function (a, o) {
            var i = e[o] || [],
              l = i.filter(function (e) {
                return !t(e, o, r);
              });
            return l.length !== i.length && (n = !0), a[o] = l, a;
          }, {});
        return n ? a : e;
      }
    },
    isRefined: function (e, t, r) {
      var n = Boolean(e[t]) && e[t].length > 0;
      if (void 0 === r || !n) return n;
      var a = "" + r;
      return -1 !== e[t].indexOf(a);
    }
  },
  NG = wG,
  BG = yG,
  VG = xG,
  RG = OG,
  AG = EG,
  TG = jG,
  HG = CG,
  LG = function (e) {
    return null !== e && /^[a-zA-Z0-9_-]{1,64}$/.test(e);
  },
  IG = SG;
function FG(e, t) {
  return Array.isArray(e) && Array.isArray(t) ? e.length === t.length && e.every(function (e, r) {
    return FG(t[r], e);
  }) : e === t;
}
function _G(e) {
  var t = e ? _G._parseNumbers(e) : {};
  void 0 === t.userToken || LG(t.userToken) || console.warn("[algoliasearch-helper] The `userToken` parameter is invalid. This can lead to wrong analytics.\n  - Format: [a-zA-Z0-9_-]{1,64}"), this.facets = t.facets || [], this.disjunctiveFacets = t.disjunctiveFacets || [], this.hierarchicalFacets = t.hierarchicalFacets || [], this.facetsRefinements = t.facetsRefinements || {}, this.facetsExcludes = t.facetsExcludes || {}, this.disjunctiveFacetsRefinements = t.disjunctiveFacetsRefinements || {}, this.numericRefinements = t.numericRefinements || {}, this.tagRefinements = t.tagRefinements || [], this.hierarchicalFacetsRefinements = t.hierarchicalFacetsRefinements || {};
  var r = this;
  Object.keys(t).forEach(function (e) {
    var n = -1 !== _G.PARAMETERS.indexOf(e),
      a = void 0 !== t[e];
    !n && a && (r[e] = t[e]);
  });
}
_G.PARAMETERS = Object.keys(new _G()), _G._parseNumbers = function (e) {
  if (e instanceof _G) return e;
  var t = {};
  if (["aroundPrecision", "aroundRadius", "getRankingInfo", "minWordSizefor2Typos", "minWordSizefor1Typo", "page", "maxValuesPerFacet", "distinct", "minimumAroundRadius", "hitsPerPage", "minProximity"].forEach(function (r) {
    var n = e[r];
    if ("string" == typeof n) {
      var a = parseFloat(n);
      t[r] = isNaN(a) ? n : a;
    }
  }), Array.isArray(e.insideBoundingBox) && (t.insideBoundingBox = e.insideBoundingBox.map(function (e) {
    return Array.isArray(e) ? e.map(function (e) {
      return parseFloat(e);
    }) : e;
  })), e.numericRefinements) {
    var r = {};
    Object.keys(e.numericRefinements).forEach(function (t) {
      var n = e.numericRefinements[t] || {};
      r[t] = {}, Object.keys(n).forEach(function (e) {
        var a = n[e].map(function (e) {
          return Array.isArray(e) ? e.map(function (e) {
            return "string" == typeof e ? parseFloat(e) : e;
          }) : "string" == typeof e ? parseFloat(e) : e;
        });
        r[t][e] = a;
      });
    }), t.numericRefinements = r;
  }
  return NG({}, e, t);
}, _G.make = function (e) {
  var t = new _G(e);
  return (e.hierarchicalFacets || []).forEach(function (e) {
    if (e.rootPath) {
      var r = t.getHierarchicalRefinement(e.name);
      r.length > 0 && 0 !== r[0].indexOf(e.rootPath) && (t = t.clearRefinements(e.name)), 0 === (r = t.getHierarchicalRefinement(e.name)).length && (t = t.toggleHierarchicalFacetRefinement(e.name, e.rootPath));
    }
  }), t;
}, _G.validate = function (e, t) {
  var r = t || {};
  return e.tagFilters && r.tagRefinements && r.tagRefinements.length > 0 ? new Error("[Tags] Cannot switch from the managed tag API to the advanced API. It is probably an error, if it is really what you want, you should first clear the tags with clearTags method.") : e.tagRefinements.length > 0 && r.tagFilters ? new Error("[Tags] Cannot switch from the advanced tag API to the managed API. It is probably an error, if it is not, you should first clear the tags with clearTags method.") : e.numericFilters && r.numericRefinements && HG(r.numericRefinements) ? new Error("[Numeric filters] Can't switch from the advanced to the managed API. It is probably an error, if this is really what you want, you have to first clear the numeric filters.") : HG(e.numericRefinements) && r.numericFilters ? new Error("[Numeric filters] Can't switch from the managed API to the advanced. It is probably an error, if this is really what you want, you have to first clear the numeric filters.") : null;
}, _G.prototype = {
  constructor: _G,
  clearRefinements: function (e) {
    var t = {
      numericRefinements: this._clearNumericRefinements(e),
      facetsRefinements: IG.clearRefinement(this.facetsRefinements, e, "conjunctiveFacet"),
      facetsExcludes: IG.clearRefinement(this.facetsExcludes, e, "exclude"),
      disjunctiveFacetsRefinements: IG.clearRefinement(this.disjunctiveFacetsRefinements, e, "disjunctiveFacet"),
      hierarchicalFacetsRefinements: IG.clearRefinement(this.hierarchicalFacetsRefinements, e, "hierarchicalFacet")
    };
    return t.numericRefinements === this.numericRefinements && t.facetsRefinements === this.facetsRefinements && t.facetsExcludes === this.facetsExcludes && t.disjunctiveFacetsRefinements === this.disjunctiveFacetsRefinements && t.hierarchicalFacetsRefinements === this.hierarchicalFacetsRefinements ? this : this.setQueryParameters(t);
  },
  clearTags: function () {
    return void 0 === this.tagFilters && 0 === this.tagRefinements.length ? this : this.setQueryParameters({
      tagFilters: void 0,
      tagRefinements: []
    });
  },
  setIndex: function (e) {
    return e === this.index ? this : this.setQueryParameters({
      index: e
    });
  },
  setQuery: function (e) {
    return e === this.query ? this : this.setQueryParameters({
      query: e
    });
  },
  setPage: function (e) {
    return e === this.page ? this : this.setQueryParameters({
      page: e
    });
  },
  setFacets: function (e) {
    return this.setQueryParameters({
      facets: e
    });
  },
  setDisjunctiveFacets: function (e) {
    return this.setQueryParameters({
      disjunctiveFacets: e
    });
  },
  setHitsPerPage: function (e) {
    return this.hitsPerPage === e ? this : this.setQueryParameters({
      hitsPerPage: e
    });
  },
  setTypoTolerance: function (e) {
    return this.typoTolerance === e ? this : this.setQueryParameters({
      typoTolerance: e
    });
  },
  addNumericRefinement: function (e, t, r) {
    var n = AG(r);
    if (this.isNumericRefined(e, t, n)) return this;
    var a = NG({}, this.numericRefinements);
    return a[e] = NG({}, a[e]), a[e][t] ? (a[e][t] = a[e][t].slice(), a[e][t].push(n)) : a[e][t] = [n], this.setQueryParameters({
      numericRefinements: a
    });
  },
  getConjunctiveRefinements: function (e) {
    return this.isConjunctiveFacet(e) && this.facetsRefinements[e] || [];
  },
  getDisjunctiveRefinements: function (e) {
    return this.isDisjunctiveFacet(e) && this.disjunctiveFacetsRefinements[e] || [];
  },
  getHierarchicalRefinement: function (e) {
    return this.hierarchicalFacetsRefinements[e] || [];
  },
  getExcludeRefinements: function (e) {
    return this.isConjunctiveFacet(e) && this.facetsExcludes[e] || [];
  },
  removeNumericRefinement: function (e, t, r) {
    var n = r;
    return void 0 !== n ? this.isNumericRefined(e, t, n) ? this.setQueryParameters({
      numericRefinements: this._clearNumericRefinements(function (r, a) {
        return a === e && r.op === t && FG(r.val, AG(n));
      })
    }) : this : void 0 !== t ? this.isNumericRefined(e, t) ? this.setQueryParameters({
      numericRefinements: this._clearNumericRefinements(function (r, n) {
        return n === e && r.op === t;
      })
    }) : this : this.isNumericRefined(e) ? this.setQueryParameters({
      numericRefinements: this._clearNumericRefinements(function (t, r) {
        return r === e;
      })
    }) : this;
  },
  getNumericRefinements: function (e) {
    return this.numericRefinements[e] || {};
  },
  getNumericRefinement: function (e, t) {
    return this.numericRefinements[e] && this.numericRefinements[e][t];
  },
  _clearNumericRefinements: function (e) {
    if (void 0 === e) return HG(this.numericRefinements) ? {} : this.numericRefinements;
    if ("string" == typeof e) return TG(this.numericRefinements, [e]);
    if ("function" == typeof e) {
      var t = !1,
        r = this.numericRefinements,
        n = Object.keys(r).reduce(function (n, a) {
          var o = r[a],
            i = {};
          return o = o || {}, Object.keys(o).forEach(function (r) {
            var n = o[r] || [],
              l = [];
            n.forEach(function (t) {
              e({
                val: t,
                op: r
              }, a, "numeric") || l.push(t);
            }), l.length !== n.length && (t = !0), i[r] = l;
          }), n[a] = i, n;
        }, {});
      return t ? n : this.numericRefinements;
    }
  },
  addFacet: function (e) {
    return this.isConjunctiveFacet(e) ? this : this.setQueryParameters({
      facets: this.facets.concat([e])
    });
  },
  addDisjunctiveFacet: function (e) {
    return this.isDisjunctiveFacet(e) ? this : this.setQueryParameters({
      disjunctiveFacets: this.disjunctiveFacets.concat([e])
    });
  },
  addHierarchicalFacet: function (e) {
    if (this.isHierarchicalFacet(e.name)) throw new Error("Cannot declare two hierarchical facets with the same name: `" + e.name + "`");
    return this.setQueryParameters({
      hierarchicalFacets: this.hierarchicalFacets.concat([e])
    });
  },
  addFacetRefinement: function (e, t) {
    if (!this.isConjunctiveFacet(e)) throw new Error(e + " is not defined in the facets attribute of the helper configuration");
    return IG.isRefined(this.facetsRefinements, e, t) ? this : this.setQueryParameters({
      facetsRefinements: IG.addRefinement(this.facetsRefinements, e, t)
    });
  },
  addExcludeRefinement: function (e, t) {
    if (!this.isConjunctiveFacet(e)) throw new Error(e + " is not defined in the facets attribute of the helper configuration");
    return IG.isRefined(this.facetsExcludes, e, t) ? this : this.setQueryParameters({
      facetsExcludes: IG.addRefinement(this.facetsExcludes, e, t)
    });
  },
  addDisjunctiveFacetRefinement: function (e, t) {
    if (!this.isDisjunctiveFacet(e)) throw new Error(e + " is not defined in the disjunctiveFacets attribute of the helper configuration");
    return IG.isRefined(this.disjunctiveFacetsRefinements, e, t) ? this : this.setQueryParameters({
      disjunctiveFacetsRefinements: IG.addRefinement(this.disjunctiveFacetsRefinements, e, t)
    });
  },
  addTagRefinement: function (e) {
    if (this.isTagRefined(e)) return this;
    var t = {
      tagRefinements: this.tagRefinements.concat(e)
    };
    return this.setQueryParameters(t);
  },
  removeFacet: function (e) {
    return this.isConjunctiveFacet(e) ? this.clearRefinements(e).setQueryParameters({
      facets: this.facets.filter(function (t) {
        return t !== e;
      })
    }) : this;
  },
  removeDisjunctiveFacet: function (e) {
    return this.isDisjunctiveFacet(e) ? this.clearRefinements(e).setQueryParameters({
      disjunctiveFacets: this.disjunctiveFacets.filter(function (t) {
        return t !== e;
      })
    }) : this;
  },
  removeHierarchicalFacet: function (e) {
    return this.isHierarchicalFacet(e) ? this.clearRefinements(e).setQueryParameters({
      hierarchicalFacets: this.hierarchicalFacets.filter(function (t) {
        return t.name !== e;
      })
    }) : this;
  },
  removeFacetRefinement: function (e, t) {
    if (!this.isConjunctiveFacet(e)) throw new Error(e + " is not defined in the facets attribute of the helper configuration");
    return IG.isRefined(this.facetsRefinements, e, t) ? this.setQueryParameters({
      facetsRefinements: IG.removeRefinement(this.facetsRefinements, e, t)
    }) : this;
  },
  removeExcludeRefinement: function (e, t) {
    if (!this.isConjunctiveFacet(e)) throw new Error(e + " is not defined in the facets attribute of the helper configuration");
    return IG.isRefined(this.facetsExcludes, e, t) ? this.setQueryParameters({
      facetsExcludes: IG.removeRefinement(this.facetsExcludes, e, t)
    }) : this;
  },
  removeDisjunctiveFacetRefinement: function (e, t) {
    if (!this.isDisjunctiveFacet(e)) throw new Error(e + " is not defined in the disjunctiveFacets attribute of the helper configuration");
    return IG.isRefined(this.disjunctiveFacetsRefinements, e, t) ? this.setQueryParameters({
      disjunctiveFacetsRefinements: IG.removeRefinement(this.disjunctiveFacetsRefinements, e, t)
    }) : this;
  },
  removeTagRefinement: function (e) {
    if (!this.isTagRefined(e)) return this;
    var t = {
      tagRefinements: this.tagRefinements.filter(function (t) {
        return t !== e;
      })
    };
    return this.setQueryParameters(t);
  },
  toggleRefinement: function (e, t) {
    return this.toggleFacetRefinement(e, t);
  },
  toggleFacetRefinement: function (e, t) {
    if (this.isHierarchicalFacet(e)) return this.toggleHierarchicalFacetRefinement(e, t);
    if (this.isConjunctiveFacet(e)) return this.toggleConjunctiveFacetRefinement(e, t);
    if (this.isDisjunctiveFacet(e)) return this.toggleDisjunctiveFacetRefinement(e, t);
    throw new Error("Cannot refine the undeclared facet " + e + "; it should be added to the helper options facets, disjunctiveFacets or hierarchicalFacets");
  },
  toggleConjunctiveFacetRefinement: function (e, t) {
    if (!this.isConjunctiveFacet(e)) throw new Error(e + " is not defined in the facets attribute of the helper configuration");
    return this.setQueryParameters({
      facetsRefinements: IG.toggleRefinement(this.facetsRefinements, e, t)
    });
  },
  toggleExcludeFacetRefinement: function (e, t) {
    if (!this.isConjunctiveFacet(e)) throw new Error(e + " is not defined in the facets attribute of the helper configuration");
    return this.setQueryParameters({
      facetsExcludes: IG.toggleRefinement(this.facetsExcludes, e, t)
    });
  },
  toggleDisjunctiveFacetRefinement: function (e, t) {
    if (!this.isDisjunctiveFacet(e)) throw new Error(e + " is not defined in the disjunctiveFacets attribute of the helper configuration");
    return this.setQueryParameters({
      disjunctiveFacetsRefinements: IG.toggleRefinement(this.disjunctiveFacetsRefinements, e, t)
    });
  },
  toggleHierarchicalFacetRefinement: function (e, t) {
    if (!this.isHierarchicalFacet(e)) throw new Error(e + " is not defined in the hierarchicalFacets attribute of the helper configuration");
    var r = this._getHierarchicalFacetSeparator(this.getHierarchicalFacetByName(e)),
      n = {};
    return void 0 !== this.hierarchicalFacetsRefinements[e] && this.hierarchicalFacetsRefinements[e].length > 0 && (this.hierarchicalFacetsRefinements[e][0] === t || 0 === this.hierarchicalFacetsRefinements[e][0].indexOf(t + r)) ? -1 === t.indexOf(r) ? n[e] = [] : n[e] = [t.slice(0, t.lastIndexOf(r))] : n[e] = [t], this.setQueryParameters({
      hierarchicalFacetsRefinements: BG({}, n, this.hierarchicalFacetsRefinements)
    });
  },
  addHierarchicalFacetRefinement: function (e, t) {
    if (this.isHierarchicalFacetRefined(e)) throw new Error(e + " is already refined.");
    if (!this.isHierarchicalFacet(e)) throw new Error(e + " is not defined in the hierarchicalFacets attribute of the helper configuration.");
    var r = {};
    return r[e] = [t], this.setQueryParameters({
      hierarchicalFacetsRefinements: BG({}, r, this.hierarchicalFacetsRefinements)
    });
  },
  removeHierarchicalFacetRefinement: function (e) {
    if (!this.isHierarchicalFacetRefined(e)) return this;
    var t = {};
    return t[e] = [], this.setQueryParameters({
      hierarchicalFacetsRefinements: BG({}, t, this.hierarchicalFacetsRefinements)
    });
  },
  toggleTagRefinement: function (e) {
    return this.isTagRefined(e) ? this.removeTagRefinement(e) : this.addTagRefinement(e);
  },
  isDisjunctiveFacet: function (e) {
    return this.disjunctiveFacets.indexOf(e) > -1;
  },
  isHierarchicalFacet: function (e) {
    return void 0 !== this.getHierarchicalFacetByName(e);
  },
  isConjunctiveFacet: function (e) {
    return this.facets.indexOf(e) > -1;
  },
  isFacetRefined: function (e, t) {
    return !!this.isConjunctiveFacet(e) && IG.isRefined(this.facetsRefinements, e, t);
  },
  isExcludeRefined: function (e, t) {
    return !!this.isConjunctiveFacet(e) && IG.isRefined(this.facetsExcludes, e, t);
  },
  isDisjunctiveFacetRefined: function (e, t) {
    return !!this.isDisjunctiveFacet(e) && IG.isRefined(this.disjunctiveFacetsRefinements, e, t);
  },
  isHierarchicalFacetRefined: function (e, t) {
    if (!this.isHierarchicalFacet(e)) return !1;
    var r = this.getHierarchicalRefinement(e);
    return t ? -1 !== r.indexOf(t) : r.length > 0;
  },
  isNumericRefined: function (e, t, r) {
    if (void 0 === r && void 0 === t) return Boolean(this.numericRefinements[e]);
    var n = this.numericRefinements[e] && void 0 !== this.numericRefinements[e][t];
    if (void 0 === r || !n) return n;
    var a,
      o,
      i = AG(r),
      l = void 0 !== (a = this.numericRefinements[e][t], o = i, RG(a, function (e) {
        return FG(e, o);
      }));
    return n && l;
  },
  isTagRefined: function (e) {
    return -1 !== this.tagRefinements.indexOf(e);
  },
  getRefinedDisjunctiveFacets: function () {
    var e = this,
      t = VG(Object.keys(this.numericRefinements).filter(function (t) {
        return Object.keys(e.numericRefinements[t]).length > 0;
      }), this.disjunctiveFacets);
    return Object.keys(this.disjunctiveFacetsRefinements).filter(function (t) {
      return e.disjunctiveFacetsRefinements[t].length > 0;
    }).concat(t).concat(this.getRefinedHierarchicalFacets());
  },
  getRefinedHierarchicalFacets: function () {
    var e = this;
    return VG(this.hierarchicalFacets.map(function (e) {
      return e.name;
    }), Object.keys(this.hierarchicalFacetsRefinements).filter(function (t) {
      return e.hierarchicalFacetsRefinements[t].length > 0;
    }));
  },
  getUnrefinedDisjunctiveFacets: function () {
    var e = this.getRefinedDisjunctiveFacets();
    return this.disjunctiveFacets.filter(function (t) {
      return -1 === e.indexOf(t);
    });
  },
  managedParameters: ["index", "facets", "disjunctiveFacets", "facetsRefinements", "hierarchicalFacets", "facetsExcludes", "disjunctiveFacetsRefinements", "numericRefinements", "tagRefinements", "hierarchicalFacetsRefinements"],
  getQueryParams: function () {
    var e = this.managedParameters,
      t = {},
      r = this;
    return Object.keys(this).forEach(function (n) {
      var a = r[n];
      -1 === e.indexOf(n) && void 0 !== a && (t[n] = a);
    }), t;
  },
  setQueryParameter: function (e, t) {
    if (this[e] === t) return this;
    var r = {};
    return r[e] = t, this.setQueryParameters(r);
  },
  setQueryParameters: function (e) {
    if (!e) return this;
    var t = _G.validate(this, e);
    if (t) throw t;
    var r = this,
      n = _G._parseNumbers(e),
      a = Object.keys(this).reduce(function (e, t) {
        return e[t] = r[t], e;
      }, {}),
      o = Object.keys(n).reduce(function (e, t) {
        var r = void 0 !== e[t],
          a = void 0 !== n[t];
        return r && !a ? TG(e, [t]) : (a && (e[t] = n[t]), e);
      }, a);
    return new this.constructor(o);
  },
  resetPage: function () {
    return void 0 === this.page ? this : this.setPage(0);
  },
  _getHierarchicalFacetSortBy: function (e) {
    return e.sortBy || ["isRefined:desc", "name:asc"];
  },
  _getHierarchicalFacetSeparator: function (e) {
    return e.separator || " > ";
  },
  _getHierarchicalRootPath: function (e) {
    return e.rootPath || null;
  },
  _getHierarchicalShowParentLevel: function (e) {
    return "boolean" != typeof e.showParentLevel || e.showParentLevel;
  },
  getHierarchicalFacetByName: function (e) {
    return RG(this.hierarchicalFacets, function (t) {
      return t.name === e;
    });
  },
  getHierarchicalFacetBreadcrumb: function (e) {
    if (!this.isHierarchicalFacet(e)) return [];
    var t = this.getHierarchicalRefinement(e)[0];
    if (!t) return [];
    var r = this._getHierarchicalFacetSeparator(this.getHierarchicalFacetByName(e));
    return t.split(r).map(function (e) {
      return e.trim();
    });
  },
  toString: function () {
    return JSON.stringify(this, null, 2);
  }
};
var ZG = _G;
function DG(e, t) {
  if (e !== t) {
    var r = void 0 !== e,
      n = null === e,
      a = void 0 !== t,
      o = null === t;
    if (!o && e > t || n && a || !r) return 1;
    if (!n && e < t || o && r || !a) return -1;
  }
  return 0;
}
var qG = function (e, t, r) {
    if (!Array.isArray(e)) return [];
    Array.isArray(r) || (r = []);
    var n = e.map(function (e, r) {
      return {
        criteria: t.map(function (t) {
          return e[t];
        }),
        index: r,
        value: e
      };
    });
    return n.sort(function (e, t) {
      for (var n = -1; ++n < e.criteria.length;) {
        var a = DG(e.criteria[n], t.criteria[n]);
        if (a) return n >= r.length ? a : "desc" === r[n] ? -a : a;
      }
      return e.index - t.index;
    }), n.map(function (e) {
      return e.value;
    });
  },
  UG = OG,
  $G = function (e, t) {
    var r = (t || []).map(function (e) {
      return e.split(":");
    });
    return e.reduce(function (e, t) {
      var n = t.split(":"),
        a = UG(r, function (e) {
          return e[0] === n[0];
        });
      return n.length > 1 || !a ? (e[0].push(n[0]), e[1].push(n[1]), e) : (e[0].push(a[0]), e[1].push(a[1]), e);
    }, [[], []]);
  };
var zG = {
    escapeFacetValue: function (e) {
      return "string" != typeof e ? e : String(e).replace(/^-/, "\\-");
    },
    unescapeFacetValue: function (e) {
      return "string" != typeof e ? e : e.replace(/^\\-/, "-");
    }
  },
  WG = function (e) {
    return function (t, r) {
      var n = e.hierarchicalFacets[r],
        a = e.hierarchicalFacetsRefinements[n.name] && e.hierarchicalFacetsRefinements[n.name][0] || "",
        o = e._getHierarchicalFacetSeparator(n),
        i = e._getHierarchicalRootPath(n),
        l = e._getHierarchicalShowParentLevel(n),
        s = YG(e._getHierarchicalFacetSortBy(n)),
        c = t.every(function (e) {
          return e.exhaustive;
        }),
        u = function (e, t, r, n, a) {
          return function (o, i, l) {
            var s = o;
            if (l > 0) {
              var c = 0;
              for (s = o; c < l;) {
                var u = s && Array.isArray(s.data) ? s.data : [];
                s = GG(u, function (e) {
                  return e.isRefined;
                }), c++;
              }
            }
            if (s) {
              var h = Object.keys(i.data).map(function (e) {
                return [e, i.data[e]];
              }).filter(function (e) {
                return function (e, t, r, n, a, o) {
                  if (a && (0 !== e.indexOf(a) || a === e)) return !1;
                  return !a && -1 === e.indexOf(n) || a && e.split(n).length - a.split(n).length == 1 || -1 === e.indexOf(n) && -1 === r.indexOf(n) || 0 === r.indexOf(e) || 0 === e.indexOf(t + n) && (o || 0 === e.indexOf(r));
                }(e[0], s.path || r, a, t, r, n);
              });
              s.data = QG(h.map(function (e) {
                var r = e[0];
                return function (e, t, r, n, a) {
                  var o = t.split(r);
                  return {
                    name: o[o.length - 1].trim(),
                    path: t,
                    escapedValue: KG(t),
                    count: e,
                    isRefined: n === t || 0 === n.indexOf(t + r),
                    exhaustive: a,
                    data: null
                  };
                }(e[1], r, t, XG(a), i.exhaustive);
              }), e[0], e[1]);
            }
            return o;
          };
        }(s, o, i, l, a),
        h = t;
      return i && (h = t.slice(i.split(o).length)), h.reduce(u, {
        name: e.hierarchicalFacets[r].name,
        count: null,
        isRefined: !0,
        path: null,
        escapedValue: null,
        exhaustive: c,
        data: null
      });
    };
  },
  QG = qG,
  GG = OG,
  YG = $G,
  KG = zG.escapeFacetValue,
  XG = zG.unescapeFacetValue;
var JG = wG,
  eY = yG,
  tY = qG,
  rY = function (e) {
    return Array.isArray(e) ? e.filter(Boolean) : [];
  },
  nY = OG,
  aY = function (e, t) {
    if (!Array.isArray(e)) return -1;
    for (var r = 0; r < e.length; r++) if (t(e[r])) return r;
    return -1;
  },
  oY = $G,
  iY = zG.escapeFacetValue,
  lY = zG.unescapeFacetValue,
  sY = WG;
function cY(e) {
  var t = {};
  return e.forEach(function (e, r) {
    t[e] = r;
  }), t;
}
function uY(e, t, r) {
  t && t[r] && (e.stats = t[r]);
}
function hY(e, t, r) {
  var n = t[0];
  this._rawResults = t;
  var a = this;
  Object.keys(n).forEach(function (e) {
    a[e] = n[e];
  }), Object.keys(r || {}).forEach(function (e) {
    a[e] = r[e];
  }), this.processingTimeMS = t.reduce(function (e, t) {
    return void 0 === t.processingTimeMS ? e : e + t.processingTimeMS;
  }, 0), this.disjunctiveFacets = [], this.hierarchicalFacets = e.hierarchicalFacets.map(function () {
    return [];
  }), this.facets = [];
  var o = e.getRefinedDisjunctiveFacets(),
    i = cY(e.facets),
    l = cY(e.disjunctiveFacets),
    s = 1,
    c = n.facets || {};
  Object.keys(c).forEach(function (t) {
    var r,
      o,
      s = c[t],
      u = (r = e.hierarchicalFacets, o = t, nY(r, function (e) {
        return (e.attributes || []).indexOf(o) > -1;
      }));
    if (u) {
      var h = u.attributes.indexOf(t),
        m = aY(e.hierarchicalFacets, function (e) {
          return e.name === u.name;
        });
      a.hierarchicalFacets[m][h] = {
        attribute: t,
        data: s,
        exhaustive: n.exhaustiveFacetsCount
      };
    } else {
      var p,
        f = -1 !== e.disjunctiveFacets.indexOf(t),
        d = -1 !== e.facets.indexOf(t);
      f && (p = l[t], a.disjunctiveFacets[p] = {
        name: t,
        data: s,
        exhaustive: n.exhaustiveFacetsCount
      }, uY(a.disjunctiveFacets[p], n.facets_stats, t)), d && (p = i[t], a.facets[p] = {
        name: t,
        data: s,
        exhaustive: n.exhaustiveFacetsCount
      }, uY(a.facets[p], n.facets_stats, t));
    }
  }), this.hierarchicalFacets = rY(this.hierarchicalFacets), o.forEach(function (r) {
    var o = t[s],
      i = o && o.facets ? o.facets : {},
      c = e.getHierarchicalFacetByName(r);
    Object.keys(i).forEach(function (t) {
      var r,
        s = i[t];
      if (c) {
        r = aY(e.hierarchicalFacets, function (e) {
          return e.name === c.name;
        });
        var u = aY(a.hierarchicalFacets[r], function (e) {
          return e.attribute === t;
        });
        if (-1 === u) return;
        a.hierarchicalFacets[r][u].data = JG({}, a.hierarchicalFacets[r][u].data, s);
      } else {
        r = l[t];
        var h = n.facets && n.facets[t] || {};
        a.disjunctiveFacets[r] = {
          name: t,
          data: eY({}, s, h),
          exhaustive: o.exhaustiveFacetsCount
        }, uY(a.disjunctiveFacets[r], o.facets_stats, t), e.disjunctiveFacetsRefinements[t] && e.disjunctiveFacetsRefinements[t].forEach(function (n) {
          !a.disjunctiveFacets[r].data[n] && e.disjunctiveFacetsRefinements[t].indexOf(lY(n)) > -1 && (a.disjunctiveFacets[r].data[n] = 0);
        });
      }
    }), s++;
  }), e.getRefinedHierarchicalFacets().forEach(function (r) {
    var n = e.getHierarchicalFacetByName(r),
      o = e._getHierarchicalFacetSeparator(n),
      i = e.getHierarchicalRefinement(r);
    0 === i.length || i[0].split(o).length < 2 || t.slice(s).forEach(function (t) {
      var r = t && t.facets ? t.facets : {};
      Object.keys(r).forEach(function (t) {
        var l = r[t],
          s = aY(e.hierarchicalFacets, function (e) {
            return e.name === n.name;
          }),
          c = aY(a.hierarchicalFacets[s], function (e) {
            return e.attribute === t;
          });
        if (-1 !== c) {
          var u = {};
          if (i.length > 0) {
            var h = i[0].split(o)[0];
            u[h] = a.hierarchicalFacets[s][c].data[h];
          }
          a.hierarchicalFacets[s][c].data = eY(u, l, a.hierarchicalFacets[s][c].data);
        }
      }), s++;
    });
  }), Object.keys(e.facetsExcludes).forEach(function (t) {
    var r = e.facetsExcludes[t],
      o = i[t];
    a.facets[o] = {
      name: t,
      data: c[t],
      exhaustive: n.exhaustiveFacetsCount
    }, r.forEach(function (e) {
      a.facets[o] = a.facets[o] || {
        name: t
      }, a.facets[o].data = a.facets[o].data || {}, a.facets[o].data[e] = 0;
    });
  }), this.hierarchicalFacets = this.hierarchicalFacets.map(sY(e)), this.facets = rY(this.facets), this.disjunctiveFacets = rY(this.disjunctiveFacets), this._state = e;
}
function mY(e, t) {
  function r(e) {
    return e.name === t;
  }
  if (e._state.isConjunctiveFacet(t)) {
    var n = nY(e.facets, r);
    return n ? Object.keys(n.data).map(function (r) {
      var a = iY(r);
      return {
        name: r,
        escapedValue: a,
        count: n.data[r],
        isRefined: e._state.isFacetRefined(t, a),
        isExcluded: e._state.isExcludeRefined(t, r)
      };
    }) : [];
  }
  if (e._state.isDisjunctiveFacet(t)) {
    var a = nY(e.disjunctiveFacets, r);
    return a ? Object.keys(a.data).map(function (r) {
      var n = iY(r);
      return {
        name: r,
        escapedValue: n,
        count: a.data[r],
        isRefined: e._state.isDisjunctiveFacetRefined(t, n)
      };
    }) : [];
  }
  if (e._state.isHierarchicalFacet(t)) {
    var o = nY(e.hierarchicalFacets, r);
    if (!o) return o;
    var i = e._state.getHierarchicalFacetByName(t),
      l = e._state._getHierarchicalFacetSeparator(i),
      s = lY(e._state.getHierarchicalRefinement(t)[0] || "");
    0 === s.indexOf(i.rootPath) && (s = s.replace(i.rootPath + l, ""));
    var c = s.split(l);
    return c.unshift(t), pY(o, c, 0), o;
  }
}
function pY(e, t, r) {
  e.isRefined = e.name === t[r], e.data && e.data.forEach(function (e) {
    pY(e, t, r + 1);
  });
}
function fY(e, t, r, n) {
  if (n = n || 0, Array.isArray(t)) return e(t, r[n]);
  if (!t.data || 0 === t.data.length) return t;
  var a = t.data.map(function (t) {
      return fY(e, t, r, n + 1);
    }),
    o = e(a, r[n]);
  return eY({
    data: o
  }, t);
}
function dY(e, t) {
  var r = nY(e, function (e) {
    return e.name === t;
  });
  return r && r.stats;
}
function vY(e, t, r, n, a) {
  var o = nY(a, function (e) {
      return e.name === r;
    }),
    i = o && o.data && o.data[n] ? o.data[n] : 0,
    l = o && o.exhaustive || !1;
  return {
    type: t,
    attributeName: r,
    name: n,
    count: i,
    exhaustive: l
  };
}
hY.prototype.getFacetByName = function (e) {
  function t(t) {
    return t.name === e;
  }
  return nY(this.facets, t) || nY(this.disjunctiveFacets, t) || nY(this.hierarchicalFacets, t);
}, hY.DEFAULT_SORT = ["isRefined:desc", "count:desc", "name:asc"], hY.prototype.getFacetValues = function (e, t) {
  var r = mY(this, e);
  if (r) {
    var n,
      a = eY({}, t, {
        sortBy: hY.DEFAULT_SORT,
        facetOrdering: !(t && t.sortBy)
      }),
      o = this;
    if (Array.isArray(r)) n = [e];else n = o._state.getHierarchicalFacetByName(r.name).attributes;
    return fY(function (e, t) {
      if (a.facetOrdering) {
        var r = function (e, t) {
          return e.renderingContent && e.renderingContent.facetOrdering && e.renderingContent.facetOrdering.values && e.renderingContent.facetOrdering.values[t];
        }(o, t);
        if (r) return function (e, t) {
          var r = [],
            n = [],
            a = (t.order || []).reduce(function (e, t, r) {
              return e[t] = r, e;
            }, {});
          e.forEach(function (e) {
            var t = e.path || e.name;
            void 0 !== a[t] ? r[a[t]] = e : n.push(e);
          }), r = r.filter(function (e) {
            return e;
          });
          var o,
            i = t.sortRemainingBy;
          return "hidden" === i ? r : (o = "alpha" === i ? [["path", "name"], ["asc", "asc"]] : [["count"], ["desc"]], r.concat(tY(n, o[0], o[1])));
        }(e, r);
      }
      if (Array.isArray(a.sortBy)) {
        var n = oY(a.sortBy, hY.DEFAULT_SORT);
        return tY(e, n[0], n[1]);
      }
      if ("function" == typeof a.sortBy) return function (e, t) {
        return t.sort(e);
      }(a.sortBy, e);
      throw new Error("options.sortBy is optional but if defined it must be either an array of string (predicates) or a sorting function");
    }, r, n);
  }
}, hY.prototype.getFacetStats = function (e) {
  return this._state.isConjunctiveFacet(e) ? dY(this.facets, e) : this._state.isDisjunctiveFacet(e) ? dY(this.disjunctiveFacets, e) : void 0;
}, hY.prototype.getRefinements = function () {
  var e = this._state,
    t = this,
    r = [];
  return Object.keys(e.facetsRefinements).forEach(function (n) {
    e.facetsRefinements[n].forEach(function (a) {
      r.push(vY(e, "facet", n, a, t.facets));
    });
  }), Object.keys(e.facetsExcludes).forEach(function (n) {
    e.facetsExcludes[n].forEach(function (a) {
      r.push(vY(e, "exclude", n, a, t.facets));
    });
  }), Object.keys(e.disjunctiveFacetsRefinements).forEach(function (n) {
    e.disjunctiveFacetsRefinements[n].forEach(function (a) {
      r.push(vY(e, "disjunctive", n, a, t.disjunctiveFacets));
    });
  }), Object.keys(e.hierarchicalFacetsRefinements).forEach(function (n) {
    e.hierarchicalFacetsRefinements[n].forEach(function (a) {
      r.push(function (e, t, r, n) {
        var a = e.getHierarchicalFacetByName(t),
          o = e._getHierarchicalFacetSeparator(a),
          i = r.split(o),
          l = nY(n, function (e) {
            return e.name === t;
          }),
          s = i.reduce(function (e, t) {
            var r = e && nY(e.data, function (e) {
              return e.name === t;
            });
            return void 0 !== r ? r : e;
          }, l),
          c = s && s.count || 0,
          u = s && s.exhaustive || !1,
          h = s && s.path || "";
        return {
          type: "hierarchical",
          attributeName: t,
          name: h,
          count: c,
          exhaustive: u
        };
      }(e, n, a, t.hierarchicalFacets));
    });
  }), Object.keys(e.numericRefinements).forEach(function (t) {
    var n = e.numericRefinements[t];
    Object.keys(n).forEach(function (e) {
      n[e].forEach(function (n) {
        r.push({
          type: "numeric",
          attributeName: t,
          name: n,
          numericValue: n,
          operator: e
        });
      });
    });
  }), e.tagRefinements.forEach(function (e) {
    r.push({
      type: "tag",
      attributeName: "_tags",
      name: e
    });
  }), r;
};
var gY = hY;
function bY() {
  this._events = this._events || {}, this._maxListeners = this._maxListeners || void 0;
}
var wY = bY;
function yY(e) {
  return "function" == typeof e;
}
function xY(e) {
  return "object" == typeof e && null !== e;
}
function OY(e) {
  return void 0 === e;
}
bY.prototype._events = void 0, bY.prototype._maxListeners = void 0, bY.defaultMaxListeners = 10, bY.prototype.setMaxListeners = function (e) {
  if ("number" != typeof e || e < 0 || isNaN(e)) throw TypeError("n must be a positive number");
  return this._maxListeners = e, this;
}, bY.prototype.emit = function (e) {
  var t, r, n, a, o, i;
  if (this._events || (this._events = {}), "error" === e && (!this._events.error || xY(this._events.error) && !this._events.error.length)) {
    if ((t = arguments[1]) instanceof Error) throw t;
    var l = new Error('Uncaught, unspecified "error" event. (' + t + ")");
    throw l.context = t, l;
  }
  if (OY(r = this._events[e])) return !1;
  if (yY(r)) switch (arguments.length) {
    case 1:
      r.call(this);
      break;
    case 2:
      r.call(this, arguments[1]);
      break;
    case 3:
      r.call(this, arguments[1], arguments[2]);
      break;
    default:
      a = Array.prototype.slice.call(arguments, 1), r.apply(this, a);
  } else if (xY(r)) for (a = Array.prototype.slice.call(arguments, 1), n = (i = r.slice()).length, o = 0; o < n; o++) i[o].apply(this, a);
  return !0;
}, bY.prototype.addListener = function (e, t) {
  var r;
  if (!yY(t)) throw TypeError("listener must be a function");
  return this._events || (this._events = {}), this._events.newListener && this.emit("newListener", e, yY(t.listener) ? t.listener : t), this._events[e] ? xY(this._events[e]) ? this._events[e].push(t) : this._events[e] = [this._events[e], t] : this._events[e] = t, xY(this._events[e]) && !this._events[e].warned && (r = OY(this._maxListeners) ? bY.defaultMaxListeners : this._maxListeners) && r > 0 && this._events[e].length > r && (this._events[e].warned = !0, console.error("(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.", this._events[e].length), "function" == typeof console.trace && console.trace()), this;
}, bY.prototype.on = bY.prototype.addListener, bY.prototype.once = function (e, t) {
  if (!yY(t)) throw TypeError("listener must be a function");
  var r = !1;
  function n() {
    this.removeListener(e, n), r || (r = !0, t.apply(this, arguments));
  }
  return n.listener = t, this.on(e, n), this;
}, bY.prototype.removeListener = function (e, t) {
  var r, n, a, o;
  if (!yY(t)) throw TypeError("listener must be a function");
  if (!this._events || !this._events[e]) return this;
  if (a = (r = this._events[e]).length, n = -1, r === t || yY(r.listener) && r.listener === t) delete this._events[e], this._events.removeListener && this.emit("removeListener", e, t);else if (xY(r)) {
    for (o = a; o-- > 0;) if (r[o] === t || r[o].listener && r[o].listener === t) {
      n = o;
      break;
    }
    if (n < 0) return this;
    1 === r.length ? (r.length = 0, delete this._events[e]) : r.splice(n, 1), this._events.removeListener && this.emit("removeListener", e, t);
  }
  return this;
}, bY.prototype.removeAllListeners = function (e) {
  var t, r;
  if (!this._events) return this;
  if (!this._events.removeListener) return 0 === arguments.length ? this._events = {} : this._events[e] && delete this._events[e], this;
  if (0 === arguments.length) {
    for (t in this._events) "removeListener" !== t && this.removeAllListeners(t);
    return this.removeAllListeners("removeListener"), this._events = {}, this;
  }
  if (yY(r = this._events[e])) this.removeListener(e, r);else if (r) for (; r.length;) this.removeListener(e, r[r.length - 1]);
  return delete this._events[e], this;
}, bY.prototype.listeners = function (e) {
  return this._events && this._events[e] ? yY(this._events[e]) ? [this._events[e]] : this._events[e].slice() : [];
}, bY.prototype.listenerCount = function (e) {
  if (this._events) {
    var t = this._events[e];
    if (yY(t)) return 1;
    if (t) return t.length;
  }
  return 0;
}, bY.listenerCount = function (e, t) {
  return e.listenerCount(t);
};
var EY = function (e, t) {
  e.prototype = Object.create(t.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  });
};
function jY(e, t) {
  this.main = e, this.fn = t, this.lastResults = null;
}
EY(jY, wY), jY.prototype.detach = function () {
  this.removeAllListeners(), this.main.detachDerivedHelper(this);
}, jY.prototype.getModifiedState = function (e) {
  return this.fn(e);
};
var CY = wG;
function PY(e) {
  return Object.keys(e).sort(function (e, t) {
    return e.localeCompare(t);
  }).reduce(function (t, r) {
    return t[r] = e[r], t;
  }, {});
}
var MY = {
    _getQueries: function (e, t) {
      var r = [];
      return r.push({
        indexName: e,
        params: MY._getHitsSearchParams(t)
      }), t.getRefinedDisjunctiveFacets().forEach(function (n) {
        r.push({
          indexName: e,
          params: MY._getDisjunctiveFacetSearchParams(t, n)
        });
      }), t.getRefinedHierarchicalFacets().forEach(function (n) {
        var a = t.getHierarchicalFacetByName(n),
          o = t.getHierarchicalRefinement(n),
          i = t._getHierarchicalFacetSeparator(a);
        if (o.length > 0 && o[0].split(i).length > 1) {
          var l = o[0].split(i).slice(0, -1).reduce(function (e, t, r) {
            return e.concat({
              attribute: a.attributes[r],
              value: 0 === r ? t : [e[e.length - 1].value, t].join(i)
            });
          }, []);
          l.forEach(function (n, o) {
            var i = MY._getDisjunctiveFacetSearchParams(t, n.attribute, 0 === o);
            function s(e) {
              return a.attributes.some(function (t) {
                return t === e.split(":")[0];
              });
            }
            var c = (i.facetFilters || []).reduce(function (e, t) {
                if (Array.isArray(t)) {
                  var r = t.filter(function (e) {
                    return !s(e);
                  });
                  r.length > 0 && e.push(r);
                }
                return "string" != typeof t || s(t) || e.push(t), e;
              }, []),
              u = l[o - 1];
            i.facetFilters = o > 0 ? c.concat(u.attribute + ":" + u.value) : c.length > 0 ? c : void 0, r.push({
              indexName: e,
              params: i
            });
          });
        }
      }), r;
    },
    _getHitsSearchParams: function (e) {
      var t = e.facets.concat(e.disjunctiveFacets).concat(MY._getHitsHierarchicalFacetsAttributes(e)),
        r = MY._getFacetFilters(e),
        n = MY._getNumericFilters(e),
        a = MY._getTagFilters(e),
        o = {
          facets: t.indexOf("*") > -1 ? ["*"] : t,
          tagFilters: a
        };
      return r.length > 0 && (o.facetFilters = r), n.length > 0 && (o.numericFilters = n), PY(CY({}, e.getQueryParams(), o));
    },
    _getDisjunctiveFacetSearchParams: function (e, t, r) {
      var n = MY._getFacetFilters(e, t, r),
        a = MY._getNumericFilters(e, t),
        o = MY._getTagFilters(e),
        i = {
          hitsPerPage: 0,
          page: 0,
          analytics: !1,
          clickAnalytics: !1
        };
      o.length > 0 && (i.tagFilters = o);
      var l = e.getHierarchicalFacetByName(t);
      return i.facets = l ? MY._getDisjunctiveHierarchicalFacetAttribute(e, l, r) : t, a.length > 0 && (i.numericFilters = a), n.length > 0 && (i.facetFilters = n), PY(CY({}, e.getQueryParams(), i));
    },
    _getNumericFilters: function (e, t) {
      if (e.numericFilters) return e.numericFilters;
      var r = [];
      return Object.keys(e.numericRefinements).forEach(function (n) {
        var a = e.numericRefinements[n] || {};
        Object.keys(a).forEach(function (e) {
          var o = a[e] || [];
          t !== n && o.forEach(function (t) {
            if (Array.isArray(t)) {
              var a = t.map(function (t) {
                return n + e + t;
              });
              r.push(a);
            } else r.push(n + e + t);
          });
        });
      }), r;
    },
    _getTagFilters: function (e) {
      return e.tagFilters ? e.tagFilters : e.tagRefinements.join(",");
    },
    _getFacetFilters: function (e, t, r) {
      var n = [],
        a = e.facetsRefinements || {};
      Object.keys(a).forEach(function (e) {
        (a[e] || []).forEach(function (t) {
          n.push(e + ":" + t);
        });
      });
      var o = e.facetsExcludes || {};
      Object.keys(o).forEach(function (e) {
        (o[e] || []).forEach(function (t) {
          n.push(e + ":-" + t);
        });
      });
      var i = e.disjunctiveFacetsRefinements || {};
      Object.keys(i).forEach(function (e) {
        var r = i[e] || [];
        if (e !== t && r && 0 !== r.length) {
          var a = [];
          r.forEach(function (t) {
            a.push(e + ":" + t);
          }), n.push(a);
        }
      });
      var l = e.hierarchicalFacetsRefinements || {};
      return Object.keys(l).forEach(function (a) {
        var o = (l[a] || [])[0];
        if (void 0 !== o) {
          var i,
            s,
            c = e.getHierarchicalFacetByName(a),
            u = e._getHierarchicalFacetSeparator(c),
            h = e._getHierarchicalRootPath(c);
          if (t === a) {
            if (-1 === o.indexOf(u) || !h && !0 === r || h && h.split(u).length === o.split(u).length) return;
            h ? (s = h.split(u).length - 1, o = h) : (s = o.split(u).length - 2, o = o.slice(0, o.lastIndexOf(u))), i = c.attributes[s];
          } else s = o.split(u).length - 1, i = c.attributes[s];
          i && n.push([i + ":" + o]);
        }
      }), n;
    },
    _getHitsHierarchicalFacetsAttributes: function (e) {
      return e.hierarchicalFacets.reduce(function (t, r) {
        var n = e.getHierarchicalRefinement(r.name)[0];
        if (!n) return t.push(r.attributes[0]), t;
        var a = e._getHierarchicalFacetSeparator(r),
          o = n.split(a).length,
          i = r.attributes.slice(0, o + 1);
        return t.concat(i);
      }, []);
    },
    _getDisjunctiveHierarchicalFacetAttribute: function (e, t, r) {
      var n = e._getHierarchicalFacetSeparator(t);
      if (!0 === r) {
        var a = e._getHierarchicalRootPath(t),
          o = 0;
        return a && (o = a.split(n).length), [t.attributes[o]];
      }
      var i = (e.getHierarchicalRefinement(t.name)[0] || "").split(n).length - 1;
      return t.attributes.slice(0, i + 1);
    },
    getSearchForFacetQuery: function (e, t, r, n) {
      var a = n.isDisjunctiveFacet(e) ? n.clearRefinements(e) : n,
        o = {
          facetQuery: t,
          facetName: e
        };
      return "number" == typeof r && (o.maxFacetHits = r), PY(CY({}, MY._getHitsSearchParams(a), o));
    }
  },
  kY = "3.13.3",
  SY = ZG,
  NY = gY,
  BY = jY,
  VY = MY,
  RY = CG,
  AY = jG,
  TY = wG,
  HY = kY,
  LY = zG.escapeFacetValue;
function IY(e, t, r) {
  "function" == typeof e.addAlgoliaAgent && e.addAlgoliaAgent("JS Helper (" + HY + ")"), this.setClient(e);
  var n = r || {};
  n.index = t, this.state = SY.make(n), this.lastResults = null, this._queryId = 0, this._lastQueryIdReceived = -1, this.derivedHelpers = [], this._currentNbQueries = 0;
}
function FY(e) {
  if (e < 0) throw new Error("Page requested below 0.");
  return this._change({
    state: this.state.setPage(e),
    isPageReset: !1
  }), this;
}
function _Y() {
  return this.state.page;
}
EY(IY, wY), IY.prototype.search = function () {
  return this._search({
    onlyWithDerivedHelpers: !1
  }), this;
}, IY.prototype.searchOnlyWithDerivedHelpers = function () {
  return this._search({
    onlyWithDerivedHelpers: !0
  }), this;
}, IY.prototype.getQuery = function () {
  var e = this.state;
  return VY._getHitsSearchParams(e);
}, IY.prototype.searchOnce = function (e, t) {
  var r = e ? this.state.setQueryParameters(e) : this.state,
    n = VY._getQueries(r.index, r),
    a = this;
  if (this._currentNbQueries++, this.emit("searchOnce", {
    state: r
  }), !t) return this.client.search(n).then(function (e) {
    return a._currentNbQueries--, 0 === a._currentNbQueries && a.emit("searchQueueEmpty"), {
      content: new NY(r, e.results),
      state: r,
      _originalResponse: e
    };
  }, function (e) {
    throw a._currentNbQueries--, 0 === a._currentNbQueries && a.emit("searchQueueEmpty"), e;
  });
  this.client.search(n).then(function (e) {
    a._currentNbQueries--, 0 === a._currentNbQueries && a.emit("searchQueueEmpty"), t(null, new NY(r, e.results), r);
  }).catch(function (e) {
    a._currentNbQueries--, 0 === a._currentNbQueries && a.emit("searchQueueEmpty"), t(e, null, r);
  });
}, IY.prototype.findAnswers = function (e) {
  console.warn("[algoliasearch-helper] answers is no longer supported");
  var t = this.state,
    r = this.derivedHelpers[0];
  if (!r) return Promise.resolve([]);
  var n = r.getModifiedState(t),
    a = TY({
      attributesForPrediction: e.attributesForPrediction,
      nbHits: e.nbHits
    }, {
      params: AY(VY._getHitsSearchParams(n), ["attributesToSnippet", "hitsPerPage", "restrictSearchableAttributes", "snippetEllipsisText"])
    }),
    o = "search for answers was called, but this client does not have a function client.initIndex(index).findAnswers";
  if ("function" != typeof this.client.initIndex) throw new Error(o);
  var i = this.client.initIndex(n.index);
  if ("function" != typeof i.findAnswers) throw new Error(o);
  return i.findAnswers(n.query, e.queryLanguages, a);
}, IY.prototype.searchForFacetValues = function (e, t, r, n) {
  var a = "function" == typeof this.client.searchForFacetValues,
    o = "function" == typeof this.client.initIndex;
  if (!a && !o && "function" != typeof this.client.search) throw new Error("search for facet values (searchable) was called, but this client does not have a function client.searchForFacetValues or client.initIndex(index).searchForFacetValues");
  var i = this.state.setQueryParameters(n || {}),
    l = i.isDisjunctiveFacet(e),
    s = VY.getSearchForFacetQuery(e, t, r, i);
  this._currentNbQueries++;
  var c,
    u = this;
  return a ? c = this.client.searchForFacetValues([{
    indexName: i.index,
    params: s
  }]) : o ? c = this.client.initIndex(i.index).searchForFacetValues(s) : (delete s.facetName, c = this.client.search([{
    type: "facet",
    facet: e,
    indexName: i.index,
    params: s
  }]).then(function (e) {
    return e.results[0];
  })), this.emit("searchForFacetValues", {
    state: i,
    facet: e,
    query: t
  }), c.then(function (t) {
    return u._currentNbQueries--, 0 === u._currentNbQueries && u.emit("searchQueueEmpty"), (t = Array.isArray(t) ? t[0] : t).facetHits.forEach(function (t) {
      t.escapedValue = LY(t.value), t.isRefined = l ? i.isDisjunctiveFacetRefined(e, t.escapedValue) : i.isFacetRefined(e, t.escapedValue);
    }), t;
  }, function (e) {
    throw u._currentNbQueries--, 0 === u._currentNbQueries && u.emit("searchQueueEmpty"), e;
  });
}, IY.prototype.setQuery = function (e) {
  return this._change({
    state: this.state.resetPage().setQuery(e),
    isPageReset: !0
  }), this;
}, IY.prototype.clearRefinements = function (e) {
  return this._change({
    state: this.state.resetPage().clearRefinements(e),
    isPageReset: !0
  }), this;
}, IY.prototype.clearTags = function () {
  return this._change({
    state: this.state.resetPage().clearTags(),
    isPageReset: !0
  }), this;
}, IY.prototype.addDisjunctiveFacetRefinement = function (e, t) {
  return this._change({
    state: this.state.resetPage().addDisjunctiveFacetRefinement(e, t),
    isPageReset: !0
  }), this;
}, IY.prototype.addDisjunctiveRefine = function () {
  return this.addDisjunctiveFacetRefinement.apply(this, arguments);
}, IY.prototype.addHierarchicalFacetRefinement = function (e, t) {
  return this._change({
    state: this.state.resetPage().addHierarchicalFacetRefinement(e, t),
    isPageReset: !0
  }), this;
}, IY.prototype.addNumericRefinement = function (e, t, r) {
  return this._change({
    state: this.state.resetPage().addNumericRefinement(e, t, r),
    isPageReset: !0
  }), this;
}, IY.prototype.addFacetRefinement = function (e, t) {
  return this._change({
    state: this.state.resetPage().addFacetRefinement(e, t),
    isPageReset: !0
  }), this;
}, IY.prototype.addRefine = function () {
  return this.addFacetRefinement.apply(this, arguments);
}, IY.prototype.addFacetExclusion = function (e, t) {
  return this._change({
    state: this.state.resetPage().addExcludeRefinement(e, t),
    isPageReset: !0
  }), this;
}, IY.prototype.addExclude = function () {
  return this.addFacetExclusion.apply(this, arguments);
}, IY.prototype.addTag = function (e) {
  return this._change({
    state: this.state.resetPage().addTagRefinement(e),
    isPageReset: !0
  }), this;
}, IY.prototype.removeNumericRefinement = function (e, t, r) {
  return this._change({
    state: this.state.resetPage().removeNumericRefinement(e, t, r),
    isPageReset: !0
  }), this;
}, IY.prototype.removeDisjunctiveFacetRefinement = function (e, t) {
  return this._change({
    state: this.state.resetPage().removeDisjunctiveFacetRefinement(e, t),
    isPageReset: !0
  }), this;
}, IY.prototype.removeDisjunctiveRefine = function () {
  return this.removeDisjunctiveFacetRefinement.apply(this, arguments);
}, IY.prototype.removeHierarchicalFacetRefinement = function (e) {
  return this._change({
    state: this.state.resetPage().removeHierarchicalFacetRefinement(e),
    isPageReset: !0
  }), this;
}, IY.prototype.removeFacetRefinement = function (e, t) {
  return this._change({
    state: this.state.resetPage().removeFacetRefinement(e, t),
    isPageReset: !0
  }), this;
}, IY.prototype.removeRefine = function () {
  return this.removeFacetRefinement.apply(this, arguments);
}, IY.prototype.removeFacetExclusion = function (e, t) {
  return this._change({
    state: this.state.resetPage().removeExcludeRefinement(e, t),
    isPageReset: !0
  }), this;
}, IY.prototype.removeExclude = function () {
  return this.removeFacetExclusion.apply(this, arguments);
}, IY.prototype.removeTag = function (e) {
  return this._change({
    state: this.state.resetPage().removeTagRefinement(e),
    isPageReset: !0
  }), this;
}, IY.prototype.toggleFacetExclusion = function (e, t) {
  return this._change({
    state: this.state.resetPage().toggleExcludeFacetRefinement(e, t),
    isPageReset: !0
  }), this;
}, IY.prototype.toggleExclude = function () {
  return this.toggleFacetExclusion.apply(this, arguments);
}, IY.prototype.toggleRefinement = function (e, t) {
  return this.toggleFacetRefinement(e, t);
}, IY.prototype.toggleFacetRefinement = function (e, t) {
  return this._change({
    state: this.state.resetPage().toggleFacetRefinement(e, t),
    isPageReset: !0
  }), this;
}, IY.prototype.toggleRefine = function () {
  return this.toggleFacetRefinement.apply(this, arguments);
}, IY.prototype.toggleTag = function (e) {
  return this._change({
    state: this.state.resetPage().toggleTagRefinement(e),
    isPageReset: !0
  }), this;
}, IY.prototype.nextPage = function () {
  var e = this.state.page || 0;
  return this.setPage(e + 1);
}, IY.prototype.previousPage = function () {
  var e = this.state.page || 0;
  return this.setPage(e - 1);
}, IY.prototype.setCurrentPage = FY, IY.prototype.setPage = FY, IY.prototype.setIndex = function (e) {
  return this._change({
    state: this.state.resetPage().setIndex(e),
    isPageReset: !0
  }), this;
}, IY.prototype.setQueryParameter = function (e, t) {
  return this._change({
    state: this.state.resetPage().setQueryParameter(e, t),
    isPageReset: !0
  }), this;
}, IY.prototype.setState = function (e) {
  return this._change({
    state: SY.make(e),
    isPageReset: !1
  }), this;
}, IY.prototype.overrideStateWithoutTriggeringChangeEvent = function (e) {
  return this.state = new SY(e), this;
}, IY.prototype.hasRefinements = function (e) {
  return !!RY(this.state.getNumericRefinements(e)) || (this.state.isConjunctiveFacet(e) ? this.state.isFacetRefined(e) : this.state.isDisjunctiveFacet(e) ? this.state.isDisjunctiveFacetRefined(e) : !!this.state.isHierarchicalFacet(e) && this.state.isHierarchicalFacetRefined(e));
}, IY.prototype.isExcluded = function (e, t) {
  return this.state.isExcludeRefined(e, t);
}, IY.prototype.isDisjunctiveRefined = function (e, t) {
  return this.state.isDisjunctiveFacetRefined(e, t);
}, IY.prototype.hasTag = function (e) {
  return this.state.isTagRefined(e);
}, IY.prototype.isTagRefined = function () {
  return this.hasTagRefinements.apply(this, arguments);
}, IY.prototype.getIndex = function () {
  return this.state.index;
}, IY.prototype.getCurrentPage = _Y, IY.prototype.getPage = _Y, IY.prototype.getTags = function () {
  return this.state.tagRefinements;
}, IY.prototype.getRefinements = function (e) {
  var t = [];
  if (this.state.isConjunctiveFacet(e)) this.state.getConjunctiveRefinements(e).forEach(function (e) {
    t.push({
      value: e,
      type: "conjunctive"
    });
  }), this.state.getExcludeRefinements(e).forEach(function (e) {
    t.push({
      value: e,
      type: "exclude"
    });
  });else if (this.state.isDisjunctiveFacet(e)) {
    this.state.getDisjunctiveRefinements(e).forEach(function (e) {
      t.push({
        value: e,
        type: "disjunctive"
      });
    });
  }
  var r = this.state.getNumericRefinements(e);
  return Object.keys(r).forEach(function (e) {
    var n = r[e];
    t.push({
      value: n,
      operator: e,
      type: "numeric"
    });
  }), t;
}, IY.prototype.getNumericRefinement = function (e, t) {
  return this.state.getNumericRefinement(e, t);
}, IY.prototype.getHierarchicalFacetBreadcrumb = function (e) {
  return this.state.getHierarchicalFacetBreadcrumb(e);
}, IY.prototype._search = function (e) {
  var t = this.state,
    r = [],
    n = [];
  e.onlyWithDerivedHelpers || (n = VY._getQueries(t.index, t), r.push({
    state: t,
    queriesCount: n.length,
    helper: this
  }), this.emit("search", {
    state: t,
    results: this.lastResults
  }));
  var a = this.derivedHelpers.map(function (e) {
      var n = e.getModifiedState(t),
        a = n.index ? VY._getQueries(n.index, n) : [];
      return r.push({
        state: n,
        queriesCount: a.length,
        helper: e
      }), e.emit("search", {
        state: n,
        results: e.lastResults
      }), a;
    }),
    o = Array.prototype.concat.apply(n, a),
    i = this._queryId++;
  if (this._currentNbQueries++, !o.length) return Promise.resolve({
    results: []
  }).then(this._dispatchAlgoliaResponse.bind(this, r, i));
  try {
    this.client.search(o).then(this._dispatchAlgoliaResponse.bind(this, r, i)).catch(this._dispatchAlgoliaError.bind(this, i));
  } catch (e) {
    this.emit("error", {
      error: e
    });
  }
}, IY.prototype._dispatchAlgoliaResponse = function (e, t, r) {
  if (!(t < this._lastQueryIdReceived)) {
    this._currentNbQueries -= t - this._lastQueryIdReceived, this._lastQueryIdReceived = t, 0 === this._currentNbQueries && this.emit("searchQueueEmpty");
    var n = r.results.slice();
    e.forEach(function (e) {
      var t = e.state,
        r = e.queriesCount,
        a = e.helper,
        o = n.splice(0, r);
      t.index ? (a.lastResults = new NY(t, o), a.emit("result", {
        results: a.lastResults,
        state: t
      })) : a.emit("result", {
        results: null,
        state: t
      });
    });
  }
}, IY.prototype._dispatchAlgoliaError = function (e, t) {
  e < this._lastQueryIdReceived || (this._currentNbQueries -= e - this._lastQueryIdReceived, this._lastQueryIdReceived = e, this.emit("error", {
    error: t
  }), 0 === this._currentNbQueries && this.emit("searchQueueEmpty"));
}, IY.prototype.containsRefinement = function (e, t, r, n) {
  return e || 0 !== t.length || 0 !== r.length || 0 !== n.length;
}, IY.prototype._hasDisjunctiveRefinements = function (e) {
  return this.state.disjunctiveRefinements[e] && this.state.disjunctiveRefinements[e].length > 0;
}, IY.prototype._change = function (e) {
  var t = e.state,
    r = e.isPageReset;
  t !== this.state && (this.state = t, this.emit("change", {
    state: this.state,
    results: this.lastResults,
    isPageReset: r
  }));
}, IY.prototype.clearCache = function () {
  return this.client.clearCache && this.client.clearCache(), this;
}, IY.prototype.setClient = function (e) {
  return this.client === e || ("function" == typeof e.addAlgoliaAgent && e.addAlgoliaAgent("JS Helper (" + HY + ")"), this.client = e), this;
}, IY.prototype.getClient = function () {
  return this.client;
}, IY.prototype.derive = function (e) {
  var t = new BY(this, e);
  return this.derivedHelpers.push(t), t;
}, IY.prototype.detachDerivedHelper = function (e) {
  var t = this.derivedHelpers.indexOf(e);
  if (-1 === t) throw new Error("Derived helper already detached");
  this.derivedHelpers.splice(t, 1);
}, IY.prototype.hasPendingRequests = function () {
  return this._currentNbQueries > 0;
};
var ZY = IY,
  DY = ZG,
  qY = gY;
function UY(e, t, r) {
  return new ZY(e, t, r);
}
UY.version = kY, UY.AlgoliaSearchHelper = ZY, UY.SearchParameters = DY, UY.SearchResults = qY;
var $Y = T(UY);
function zY(e) {
  return zY = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, zY(e);
}
function WY(e) {
  return function (e) {
    if (Array.isArray(e)) return QY(e);
  }(e) || function (e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
  }(e) || function (e, t) {
    if (!e) return;
    if ("string" == typeof e) return QY(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    "Object" === r && e.constructor && (r = e.constructor.name);
    if ("Map" === r || "Set" === r) return Array.from(e);
    if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return QY(e, t);
  }(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function QY(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function GY(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function YY(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? GY(Object(r), !0).forEach(function (t) {
      KY(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : GY(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
function KY(e, t, r) {
  return (t = function (e) {
    var t = function (e, t) {
      if ("object" !== zY(e) || null === e) return e;
      var r = e[Symbol.toPrimitive];
      if (void 0 !== r) {
        var n = r.call(e, t || "default");
        if ("object" !== zY(n)) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === t ? String : Number)(e);
    }(e, "string");
    return "symbol" === zY(t) ? t : String(t);
  }(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function XY(e) {
  var t = e.attributeName,
    r = e.attributeValue,
    n = e.attributeScore;
  return "".concat(t, ":").concat(r, "<score=").concat(n || 1, ">");
}
var JY = {
  transformSearchParameters: function (e) {
    return YY({}, e);
  }
};
function eK(e) {
  var t = Object.keys(e.matchingPatterns).reduce(function (t, r) {
    var n,
      a = e.matchingPatterns[r],
      o = vQ(e.hit, r),
      i = a.score;
    return Array.isArray(o) ? [].concat(WY(t), [o.map(function (e) {
      return XY({
        attributeName: r,
        attributeValue: e,
        attributeScore: i
      });
    })]) : "string" == typeof o ? [].concat(WY(t), [XY({
      attributeName: r,
      attributeValue: o,
      attributeScore: i
    })]) : ("development" === process.env.NODE_ENV && console.warn("The `matchingPatterns` option returned a value of type ".concat((n = o, Object.prototype.toString.call(n).slice(8, -1)), ' for the "').concat(r, '" key. This value was not sent to Algolia because `optionalFilters` only supports strings and array of strings.\n\nYou can remove the "').concat(r, '" key from the `matchingPatterns` option.\n\nSee https://www.algolia.com/doc/api-reference/api-parameters/optionalFilters/')), t);
  }, []);
  return e.transformSearchParameters(new $Y.SearchParameters({
    sumOrFiltersScores: !0,
    facetFilters: ["objectID:-".concat(e.hit.objectID)],
    optionalFilters: t
  }));
}
var tK = IQ({
  displayName: "AlgoliaConfigureRelatedItems",
  $$type: "ais.configureRelatedItems",
  defaultProps: JY,
  getProvidedProps: function () {
    return {};
  },
  getSearchParameters: function (e, t) {
    return e.setQueryParameters(eK(t));
  },
  transitionState: function (e, t, r) {
    var n,
      a = "configure",
      o = (n = hQ(eK(e)), Object.keys(n).forEach(function (e) {
        var t = n[e];
        Array.isArray(t) && 0 === t.length && delete n[e];
      }), n),
      i = Object.keys(o),
      l = this._searchParameters ? Object.keys(this._searchParameters).filter(function (e) {
        return -1 === i.indexOf(e);
      }) : [];
    return this._searchParameters = o, oG(r, KY({}, a, YY(YY({}, dQ(r[a], l)), o)), {
      ais: e.contextValue,
      multiIndexContext: e.indexContextValue
    });
  },
  cleanUp: function (e, t) {
    var r = this,
      n = "configure",
      a = rG({
        ais: e.contextValue,
        multiIndexContext: e.indexContextValue
      }),
      o = aG({
        ais: e.contextValue,
        multiIndexContext: e.indexContextValue
      }) && t.indices ? t.indices[a] : t,
      i = (o && o[n] ? Object.keys(o[n]) : []).reduce(function (e, t) {
        return r._searchParameters[t] || (e[t] = o[n][t]), e;
      }, {});
    return oG(t, KY({}, n, i), {
      ais: e.contextValue,
      multiIndexContext: e.indexContextValue
    });
  }
});
function rK() {
  return null;
}
rK.propTypes = {
  hit: se.object.isRequired,
  matchingPatterns: se.object.isRequired,
  transformSearchParameters: se.func
}, tK(rK, {
  $$widgetType: "ais.configureRelatedItems"
});
var nK = IQ({
  displayName: "AlgoliaDynamicWidgets",
  $$type: "ais.dynamicWidgets",
  defaultProps: {
    transformItems: function (e) {
      return e;
    },
    maxValuesPerFacet: 20
  },
  propTypes: {
    transformItems: se.func,
    facets: se.arrayOf(se.string),
    maxValuesPerFacet: se.number
  },
  getProvidedProps: function (e, t, r) {
    var n = nG(r, {
      ais: e.contextValue,
      multiIndexContext: e.indexContextValue
    });
    if (e.facets && (!(Array.isArray(e.facets) && e.facets.length <= 1) || "*" !== e.facets[0] && void 0 !== e.facets[0])) throw new Error('The `facets` prop only accepts [] or ["*"], you passed '.concat(JSON.stringify(e.facets)));
    if (!n) return {
      attributesToRender: []
    };
    var a = n.renderingContent && n.renderingContent.facetOrdering && n.renderingContent.facetOrdering.facets && n.renderingContent.facetOrdering.facets.order || [],
      o = e.transformItems(a, {
        results: n
      });
    return o.length > 20 && !e.facets && console.warn("More than ".concat(20, " facets are requested to be displayed without explicitly setting which facets to retrieve. This could have a performance impact. Set \"facets\" to [] to do two smaller network requests, or explicitly to ['*'] to avoid this warning.")), e.maxValuesPerFacet < n._state.maxValuesPerFacet && console.warn("The maxValuesPerFacet set by dynamic widgets (".concat(e.maxValuesPerFacet, ") is smaller than one of the limits set by a widget (").concat(n._state.maxValuesPerFacet, "). This causes a mismatch in query parameters and thus an extra network request when that widget is mounted.")), {
      attributesToRender: o
    };
  },
  getSearchParameters: function (e, t) {
    return (t.facets || ["*"]).reduce(function (e, t) {
      return e.addFacet(t);
    }, e.setQueryParameters({
      maxValuesPerFacet: Math.max(t.maxValuesPerFacet || 0, e.maxValuesPerFacet || 0)
    }));
  }
});
function aK(e) {
  return aK = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, aK(e);
}
function oK(e) {
  if (function (e) {
    return "object" === aK(e) && e.props;
  }(e)) return e.props.attribute ? e.props.attribute : Array.isArray(e.props.attributes) ? e.props.attributes[0] : e.props.children ? oK(t.Children.only(e.props.children)) : void 0;
}
function iK(e) {
  return function (e) {
    if (Array.isArray(e)) return lK(e);
  }(e) || function (e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
  }(e) || function (e, t) {
    if (!e) return;
    if ("string" == typeof e) return lK(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    "Object" === r && e.constructor && (r = e.constructor.name);
    if ("Map" === r || "Set" === r) return Array.from(e);
    if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return lK(e, t);
  }(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function lK(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function sK(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
  return Object.keys(t).filter(function (r) {
    return void 0 !== t[r] && void 0 !== t[r][e];
  }).map(function (r) {
    return function (e, t, r) {
      var n = r[t];
      switch (t) {
        case "range":
          return Object.keys(n[e]).map(function (t) {
            return n[e][t];
          });
        case "refinementList":
          return n[e];
        case "hierarchicalMenu":
        case "menu":
        case "toggle":
          return [n[e]];
        case "multiRange":
          return n[e].split(":");
        default:
          return [];
      }
    }(e, r, t);
  }).reduce(function (e, t) {
    return e.concat(t);
  }, []);
}
nK(function (e) {
  var r = e.children,
    n = e.attributesToRender,
    a = e.fallbackComponent,
    o = void 0 === a ? function () {
      return null;
    } : a,
    i = new Map();
  return t.Children.forEach(r, function (e) {
    var t = oK(e);
    if (!t) throw new Error('Could not find "attribute" prop for '.concat(sQ(e), "."));
    i.set(t, e);
  }), t.createElement(t.Fragment, null, n.map(function (e) {
    return t.createElement(l, {
      key: e
    }, i.get(e) || t.createElement(o, {
      attribute: e
    }));
  }));
}, {
  $$widgetType: "ais.dynamicWidgets"
});
var cK = IQ({
  displayName: "AlgoliaQueryRules",
  $$type: "ais.queryRules",
  defaultProps: {
    transformItems: function (e) {
      return e;
    },
    transformRuleContexts: function (e) {
      return e;
    },
    trackedFilters: {}
  },
  getProvidedProps: function (e, t, r) {
    var n = nG(r, {
      ais: e.contextValue,
      multiIndexContext: e.indexContextValue
    });
    if (null === n) return {
      items: [],
      canRefine: !1
    };
    var a = n.userData,
      o = void 0 === a ? [] : a,
      i = (0, e.transformItems)(o);
    return {
      items: i,
      canRefine: i.length > 0
    };
  },
  getSearchParameters: function (e, t, r) {
    if (0 === Object.keys(t.trackedFilters).length) return e;
    var n = function (e) {
        var t = e.searchState,
          r = e.trackedFilters;
        return Object.keys(r).reduce(function (e, n) {
          var a = sK(n, t),
            o = (0, r[n])(a);
          return [].concat(iK(e), iK(a.filter(function (e) {
            return o.includes(e);
          }).map(function (e) {
            return "ais-".concat(n, "-").concat(e).replace(/[^a-z0-9-_]+/gi, "_");
          })));
        }, []);
      }({
        searchState: aG({
          ais: t.contextValue,
          multiIndexContext: t.indexContextValue
        }) && r.indices ? r.indices[rG({
          ais: t.contextValue,
          multiIndexContext: t.indexContextValue
        })] : r,
        trackedFilters: t.trackedFilters
      }),
      a = e.ruleContexts || [],
      o = [].concat(iK(a), iK(n));
    "development" === process.env.NODE_ENV && o.length > 10 && console.warn("The maximum number of `ruleContexts` is 10. They have been sliced to that limit.\nConsider using `transformRuleContexts` to minimize the number of rules sent to Algolia.");
    var i = t.transformRuleContexts(o).slice(0, 10);
    return e.setQueryParameter("ruleContexts", i);
  }
});
function uK(e) {
  return uK = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, uK(e);
}
function hK() {
  return hK = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, hK.apply(this, arguments);
}
function mK(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, bK(n.key), n);
  }
}
function pK(e, t) {
  return pK = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
    return e.__proto__ = t, e;
  }, pK(e, t);
}
function fK(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = vK(e);
    if (t) {
      var a = vK(this).constructor;
      r = Reflect.construct(n, arguments, a);
    } else r = n.apply(this, arguments);
    return function (e, t) {
      if (t && ("object" === uK(t) || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return dK(e);
    }(this, r);
  };
}
function dK(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function vK(e) {
  return vK = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, vK(e);
}
function gK(e, t, r) {
  return (t = bK(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function bK(e) {
  var t = function (e, t) {
    if ("object" !== uK(e) || null === e) return e;
    var r = e[Symbol.toPrimitive];
    if (void 0 !== r) {
      var n = r.call(e, t || "default");
      if ("object" !== uK(n)) return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === t ? String : Number)(e);
  }(e, "string");
  return "symbol" === uK(t) ? t : String(t);
}
function wK(e) {
  return {
    targetedIndex: e.indexId
  };
}
cK(function () {
  return null;
}, {
  $$widgetType: "ais.queryRuleContext"
});
var yK = function (e) {
  !function (e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), Object.defineProperty(e, "prototype", {
      writable: !1
    }), t && pK(e, t);
  }(l, i);
  var r,
    n,
    a,
    o = fK(l);
  function l(e) {
    var t;
    return function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }(this, l), gK(dK(t = o.call(this, e)), "state", {
      indexContext: wK(t.props)
    }), gK(dK(t), "unregisterWidget", void 0), t.props.contextValue.onSearchParameters(t.getSearchParameters.bind(dK(t)), {
      ais: t.props.contextValue,
      multiIndexContext: t.state.indexContext
    }, t.props, void 0, l.displayName), t;
  }
  return r = l, a = [{
    key: "getDerivedStateFromProps",
    value: function (e) {
      return {
        indexContext: wK(e)
      };
    }
  }], (n = [{
    key: "componentDidMount",
    value: function () {
      this.unregisterWidget = this.props.contextValue.widgetsManager.registerWidget(this);
    }
  }, {
    key: "componentDidUpdate",
    value: function (e) {
      this.props.indexName !== e.indexName && this.props.contextValue.widgetsManager.update();
    }
  }, {
    key: "componentWillUnmount",
    value: function () {
      "function" == typeof this.unregisterWidget && this.unregisterWidget();
    }
  }, {
    key: "getSearchParameters",
    value: function (e, t) {
      return e.setIndex(this.props ? this.props.indexName : t.indexName);
    }
  }, {
    key: "render",
    value: function () {
      return 0 === s.count(this.props.children) ? null : t.createElement(EQ, {
        value: this.state.indexContext
      }, this.props.children);
    }
  }]) && mK(r.prototype, n), a && mK(r, a), Object.defineProperty(r, "prototype", {
    writable: !1
  }), l;
}();
gK(yK, "propTypes", {
  indexName: se.string.isRequired,
  indexId: se.string.isRequired,
  children: se.node
}), gK(yK, "displayName", "AlgoliaIndex"), gK(yK, "$$type", "ais.index"), gK(yK, "$$widgetType", "ais.index");
var xK = function (e) {
  var r = e.indexName;
  return t.createElement(wQ, null, function (n) {
    return t.createElement(yK, hK({
      contextValue: n,
      indexId: r
    }, e));
  });
};
xK.propTypes = {
  indexName: se.string.isRequired,
  indexId: se.string
};
var OK = ["resultsFacetValues"],
  EK = ["resultsFacetValues"],
  jK = ["resultsFacetValues"];
function CK(e) {
  return CK = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, CK(e);
}
function PK(e, t) {
  if (null == e) return {};
  var r,
    n,
    a = function (e, t) {
      if (null == e) return {};
      var r,
        n,
        a = {},
        o = Object.keys(e);
      for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || (a[r] = e[r]);
      return a;
    }(e, t);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (a[r] = e[r]);
  }
  return a;
}
function MK(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function kK(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? MK(Object(r), !0).forEach(function (t) {
      SK(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : MK(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
function SK(e, t, r) {
  return (t = function (e) {
    var t = function (e, t) {
      if ("object" !== CK(e) || null === e) return e;
      var r = e[Symbol.toPrimitive];
      if (void 0 !== r) {
        var n = r.call(e, t || "default");
        if ("object" !== CK(n)) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === t ? String : Number)(e);
    }(e, "string");
    return "symbol" === CK(t) ? t : String(t);
  }(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function NK(e) {
  "function" == typeof e.addAlgoliaAgent && (e.addAlgoliaAgent("react (".concat(c, ")")), e.addAlgoliaAgent("react-instantsearch (".concat(ZQ, ")")));
}
var BK = function (e) {
    return aG({
      ais: e.props.contextValue,
      multiIndexContext: e.props.indexContextValue
    });
  },
  VK = function (e, t) {
    return e.props.indexContextValue.targetedIndex === t;
  },
  RK = function (e) {
    return Boolean(e.props.indexId);
  },
  AK = function (e, t) {
    return e.props.indexId === t;
  },
  TK = function (e, t) {
    var r = RK(e),
      n = RK(t);
    return r && !n ? -1 : !r && n ? 1 : 0;
  };
function HK(e) {
  return Object.keys(e).map(function (t) {
    return function (e) {
      for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) r[n - 1] = arguments[n];
      var a = 0;
      return e.replace(/%s/g, function () {
        return encodeURIComponent(r[a++]);
      });
    }("%s=%s", t, (r = e[t], "[object Object]" === Object.prototype.toString.call(r) || "[object Array]" === Object.prototype.toString.call(r) ? JSON.stringify(e[t]) : e[t]));
    var r;
  }).join("&");
}
function LK(e) {
  var t = e.indexName,
    r = e.initialState,
    n = void 0 === r ? {} : r,
    a = e.searchClient,
    o = e.resultsState,
    i = e.stalledSearchDelay,
    l = $Y(a, t, kK({}, FQ));
  NK(a), l.on("search", function () {
    u || (u = setTimeout(function () {
      var e = p.getState();
      e.resultsFacetValues;
      var t = PK(e, jK);
      p.setState(kK(kK({}, t), {}, {
        isSearchStalled: !0
      }));
    }, i));
  }).on("result", g({
    indexId: t
  })).on("error", b);
  var s,
    c = !1,
    u = null,
    h = l.state,
    m = function (e) {
      var t = [],
        r = !1;
      function n() {
        r || (r = !0, uQ(function () {
          r = !1, e();
        }));
      }
      return {
        registerWidget: function (e) {
          return t.push(e), n(), function () {
            t.splice(t.indexOf(e), 1), n();
          };
        },
        update: n,
        getWidgets: function () {
          return t;
        }
      };
    }(function () {
      var e = f(p.getState().widgets);
      p.setState(kK(kK({}, p.getState()), {}, {
        metadata: e,
        searching: !0
      })), v();
    });
  !function (e, t) {
    if (!t) return;
    if ((!e.transporter || e._cacheHydrated) && (!e._useCache || "function" != typeof e.addAlgoliaAgent)) return;
    if (e.transporter && !e._cacheHydrated) {
      e._cacheHydrated = !0;
      var r = e.search;
      e.search = function (t) {
        for (var n = arguments.length, a = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++) a[o - 1] = arguments[o];
        var i = t.map(function (e) {
          return kK(kK({}, e), {}, {
            params: HK(e.params)
          });
        });
        return e.transporter.responsesCache.get({
          method: "search",
          args: [i].concat(a)
        }, function () {
          return r.apply(void 0, [t].concat(a));
        });
      };
    }
    if (Array.isArray(t.results)) return void function (e, t) {
      if (e.transporter) return void e.transporter.responsesCache.set({
        method: "search",
        args: [t.reduce(function (e, t) {
          return e.concat(t.rawResults.map(function (e) {
            return {
              indexName: e.index,
              params: e.params
            };
          }));
        }, [])]
      }, {
        results: t.reduce(function (e, t) {
          return e.concat(t.rawResults);
        }, [])
      });
      var r = "/1/indexes/*/queries_body_".concat(JSON.stringify({
        requests: t.reduce(function (e, t) {
          return e.concat(t.rawResults.map(function (e) {
            return {
              indexName: e.index,
              params: e.params
            };
          }));
        }, [])
      }));
      e.cache = kK(kK({}, e.cache), {}, SK({}, r, JSON.stringify({
        results: t.reduce(function (e, t) {
          return e.concat(t.rawResults);
        }, [])
      })));
    }(e, t.results);
    !function (e, t) {
      if (e.transporter) return void e.transporter.responsesCache.set({
        method: "search",
        args: [t.rawResults.map(function (e) {
          return {
            indexName: e.index,
            params: e.params
          };
        })]
      }, {
        results: t.rawResults
      });
      var r = "/1/indexes/*/queries_body_".concat(JSON.stringify({
        requests: t.rawResults.map(function (e) {
          return {
            indexName: e.index,
            params: e.params
          };
        })
      }));
      e.cache = kK(kK({}, e.cache), {}, SK({}, r, JSON.stringify({
        results: t.rawResults
      })));
    }(e, t);
  }(a, o);
  var p = function (e) {
    var t = e,
      r = [];
    return {
      getState: function () {
        return t;
      },
      setState: function (e) {
        t = e, r.forEach(function (e) {
          return e();
        });
      },
      subscribe: function (e) {
        return r.push(e), function () {
          r.splice(r.indexOf(e), 1);
        };
      }
    };
  }({
    widgets: n,
    metadata: IK(o),
    results: function (e) {
      if (!e) return null;
      if (Array.isArray(e.results)) return e.results.reduce(function (e, t) {
        return kK(kK({}, e), {}, SK({}, t._internalIndexId, new $Y.SearchResults(new $Y.SearchParameters(t.state), t.rawResults)));
      }, {});
      return new $Y.SearchResults(new $Y.SearchParameters(e.state), e.rawResults);
    }(o),
    error: null,
    searching: !1,
    isSearchStalled: !0,
    searchingForFacetValues: !1
  });
  function f(e) {
    return m.getWidgets().filter(function (e) {
      return Boolean(e.getMetadata);
    }).map(function (t) {
      return t.getMetadata(e);
    });
  }
  function d() {
    var e = m.getWidgets().filter(function (e) {
        return Boolean(e.getSearchParameters);
      }).filter(function (e) {
        return !BK(e) && !RK(e);
      }).reduce(function (e, t) {
        return t.getSearchParameters(e);
      }, h),
      r = m.getWidgets().filter(function (e) {
        return Boolean(e.getSearchParameters);
      }).filter(function (e) {
        var r = BK(e) && VK(e, t),
          n = RK(e) && AK(e, t);
        return r || n;
      }).sort(TK).reduce(function (e, t) {
        return t.getSearchParameters(e);
      }, e),
      n = m.getWidgets().filter(function (e) {
        return Boolean(e.getSearchParameters);
      }).filter(function (e) {
        var r = BK(e) && !VK(e, t),
          n = RK(e) && !AK(e, t);
        return r || n;
      }).sort(TK).reduce(function (e, t) {
        var r = BK(t) ? t.props.indexContextValue.targetedIndex : t.props.indexId,
          n = e[r] || [];
        return kK(kK({}, e), {}, SK({}, r, n.concat(t)));
      }, {});
    return {
      mainParameters: r,
      derivedParameters: Object.keys(n).map(function (t) {
        return {
          parameters: n[t].reduce(function (e, t) {
            return t.getSearchParameters(e);
          }, e),
          indexId: t
        };
      })
    };
  }
  function v() {
    if (!c) {
      var e = d(l.state),
        t = e.mainParameters,
        r = e.derivedParameters;
      s = r.length + 1, l.derivedHelpers.slice().forEach(function (e) {
        e.detach();
      }), r.forEach(function (e) {
        var t = e.indexId,
          r = e.parameters;
        l.derive(function () {
          return r;
        }).on("result", g({
          indexId: t
        })).on("error", b);
      }), l.setState(t), l.search();
    }
  }
  function g(e) {
    var t = e.indexId;
    return function (e) {
      s--;
      var r = p.getState(),
        n = !l.derivedHelpers.length,
        a = r.results ? r.results : {};
      a = !n && a.getFacetByName ? {} : a, a = n ? e.results : kK(kK({}, a), {}, SK({}, t, e.results));
      var o = p.getState(),
        i = o.isSearchStalled;
      l.hasPendingRequests() || (clearTimeout(u), u = null, i = !1), o.resultsFacetValues;
      var c = PK(o, OK);
      p.setState(kK(kK({}, c), {}, {
        results: a,
        isSearchStalled: i,
        searching: s > 0,
        error: null
      }));
    };
  }
  function b(e) {
    var t = e.error,
      r = p.getState(),
      n = r.isSearchStalled;
    l.hasPendingRequests() || (clearTimeout(u), n = !1), r.resultsFacetValues;
    var a = PK(r, EK);
    p.setState(kK(kK({}, a), {}, {
      isSearchStalled: n,
      error: t,
      searching: !1
    }));
  }
  return {
    store: p,
    widgetsManager: m,
    getWidgetsIds: function () {
      return p.getState().metadata.reduce(function (e, t) {
        return void 0 !== t.id ? e.concat(t.id) : e;
      }, []);
    },
    getSearchParameters: d,
    onSearchForFacetValues: function (e) {
      var t = e.facetName,
        r = e.query,
        n = e.maxFacetHits,
        a = void 0 === n ? 10 : n,
        o = Math.max(1, Math.min(a, 100));
      p.setState(kK(kK({}, p.getState()), {}, {
        searchingForFacetValues: !0
      })), l.searchForFacetValues(t, r, o).then(function (e) {
        var n;
        p.setState(kK(kK({}, p.getState()), {}, {
          error: null,
          searchingForFacetValues: !1,
          resultsFacetValues: kK(kK({}, p.getState().resultsFacetValues), {}, (n = {}, SK(n, t, e.facetHits), SK(n, "query", r), n))
        }));
      }, function (e) {
        p.setState(kK(kK({}, p.getState()), {}, {
          searchingForFacetValues: !1,
          error: e
        }));
      }).catch(function (e) {
        setTimeout(function () {
          throw e;
        });
      });
    },
    onExternalStateUpdate: function (e) {
      var t = f(e);
      p.setState(kK(kK({}, p.getState()), {}, {
        widgets: e,
        metadata: t,
        searching: !0
      })), v();
    },
    transitionState: function (e) {
      var t = p.getState().widgets;
      return m.getWidgets().filter(function (e) {
        return Boolean(e.transitionState);
      }).reduce(function (e, r) {
        return r.transitionState(t, e);
      }, e);
    },
    updateClient: function (e) {
      NK(e), l.setClient(e), v();
    },
    updateIndex: function (e) {
      h = h.setIndex(e);
    },
    clearCache: function () {
      l.clearCache(), v();
    },
    skipSearch: function () {
      c = !0;
    }
  };
}
function IK(e) {
  return e ? e.metadata.map(function (e) {
    return kK(kK({
      value: function () {
        return {};
      }
    }, e), {}, {
      items: e.items && e.items.map(function (e) {
        return kK(kK({
          value: function () {
            return {};
          }
        }, e), {}, {
          items: e.items && e.items.map(function (e) {
            return kK({
              value: function () {
                return {};
              }
            }, e);
          })
        });
      })
    });
  }) : [];
}
function FK(e) {
  return FK = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, FK(e);
}
function _K(e, t) {
  var r = document.createElement("meta"),
    n = document.querySelector("head");
  r.name = "algolia:metadata";
  var a = function (e, t) {
    var r = ["contextValue", "indexContextValue"],
      n = e.map(function (e) {
        var t = e.props,
          n = e.constructor,
          a = n._connectorDesc || {},
          o = a.defaultProps,
          i = void 0 === o ? {} : o,
          l = a.displayName;
        return {
          displayName: void 0 === l ? n.displayName : l,
          $$type: n.$$type,
          $$widgetType: n.$$widgetType,
          params: Object.keys(t).filter(function (e) {
            return !r.includes(e) && i[e] !== t[e] && void 0 !== t[e];
          })
        };
      }),
      a = t;
    return {
      ua: a.transporter && a.transporter.userAgent ? a.transporter.userAgent.value : a._ua,
      widgets: n
    };
  }(e, t);
  r.content = JSON.stringify(a), n.appendChild(r);
}
function ZK(e) {
  return ZK = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, ZK(e);
}
function DK(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function qK(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? DK(Object(r), !0).forEach(function (t) {
      GK(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : DK(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
function UK(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, YK(n.key), n);
  }
}
function $K(e, t) {
  return $K = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
    return e.__proto__ = t, e;
  }, $K(e, t);
}
function zK(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = QK(e);
    if (t) {
      var a = QK(this).constructor;
      r = Reflect.construct(n, arguments, a);
    } else r = n.apply(this, arguments);
    return function (e, t) {
      if (t && ("object" === ZK(t) || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return WK(e);
    }(this, r);
  };
}
function WK(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function QK(e) {
  return QK = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, QK(e);
}
function GK(e, t, r) {
  return (t = YK(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function YK(e) {
  var t = function (e, t) {
    if ("object" !== ZK(e) || null === e) return e;
    var r = e[Symbol.toPrimitive];
    if (void 0 !== r) {
      var n = r.call(e, t || "default");
      if ("object" !== ZK(n)) return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === t ? String : Number)(e);
  }(e, "string");
  return "symbol" === ZK(t) ? t : String(t);
}
function KK(e) {
  return Boolean(e.searchState);
}
var XK = function (e) {
  !function (e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), Object.defineProperty(e, "prototype", {
      writable: !1
    }), t && $K(e, t);
  }(l, i);
  var r,
    n,
    a,
    o = zK(l);
  function l(e) {
    var t;
    !function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }(this, l), GK(WK(t = o.call(this, e)), "cleanupTimerRef", null), GK(WK(t), "isUnmounting", !1);
    var r = LK({
        indexName: t.props.indexName,
        searchClient: t.props.searchClient,
        initialState: t.props.searchState || {},
        resultsState: t.props.resultsState,
        stalledSearchDelay: t.props.stalledSearchDelay
      }),
      n = {
        store: r.store,
        widgetsManager: r.widgetsManager,
        mainTargetedIndex: t.props.indexName,
        onInternalStateUpdate: t.onWidgetsInternalStateUpdate.bind(WK(t)),
        createHrefForState: t.createHrefForState.bind(WK(t)),
        onSearchForFacetValues: t.onSearchForFacetValues.bind(WK(t)),
        onSearchStateChange: t.onSearchStateChange.bind(WK(t)),
        onSearchParameters: t.onSearchParameters.bind(WK(t))
      };
    return t.state = {
      isControlled: KK(t.props),
      instantSearchManager: r,
      contextValue: n
    }, t;
  }
  return r = l, a = [{
    key: "getDerivedStateFromProps",
    value: function (e, t) {
      var r = KK(e),
        n = t.instantSearchManager.store.getState().widgets,
        a = e.searchState;
      return r && !tQ(n, a) && t.instantSearchManager.onExternalStateUpdate(e.searchState), {
        isControlled: r,
        contextValue: qK(qK({}, t.contextValue), {}, {
          mainTargetedIndex: e.indexName
        })
      };
    }
  }], (n = [{
    key: "componentDidUpdate",
    value: function (e) {
      var t = KK(e);
      if (t && !this.state.isControlled) throw new Error("You can't switch <InstantSearch> from being controlled to uncontrolled");
      if (!t && this.state.isControlled) throw new Error("You can't switch <InstantSearch> from being uncontrolled to controlled");
      this.props.refresh !== e.refresh && this.props.refresh && this.state.instantSearchManager.clearCache(), e.indexName !== this.props.indexName && this.state.instantSearchManager.updateIndex(this.props.indexName), e.searchClient !== this.props.searchClient && this.state.instantSearchManager.updateClient(this.props.searchClient);
    }
  }, {
    key: "componentDidMount",
    value: function () {
      this.cleanupTimerRef && (clearTimeout(this.cleanupTimerRef), this.cleanupTimerRef = null), "object" === ("undefined" == typeof window ? "undefined" : FK(window)) && "object" === FK(window.navigator) && "string" == typeof window.navigator.userAgent && window.navigator.userAgent.includes("Algolia Crawler") && "object" === FK(window.document) && _K(this.state.instantSearchManager.widgetsManager.getWidgets(), this.props.searchClient);
    }
  }, {
    key: "componentWillUnmount",
    value: function () {
      var e = this;
      this.cleanupTimerRef = setTimeout(function () {
        e.isUnmounting = !0, e.state.instantSearchManager.skipSearch();
      });
    }
  }, {
    key: "createHrefForState",
    value: function (e) {
      return e = this.state.instantSearchManager.transitionState(e), this.state.isControlled && this.props.createURL ? this.props.createURL(e, this.getKnownKeys()) : "#";
    }
  }, {
    key: "onWidgetsInternalStateUpdate",
    value: function (e) {
      e = this.state.instantSearchManager.transitionState(e), this.onSearchStateChange(e), this.state.isControlled || this.state.instantSearchManager.onExternalStateUpdate(e);
    }
  }, {
    key: "onSearchStateChange",
    value: function (e) {
      this.props.onSearchStateChange && !this.isUnmounting && this.props.onSearchStateChange(e);
    }
  }, {
    key: "onSearchParameters",
    value: function (e, t, r, n, a) {
      if (this.props.onSearchParameters) {
        var o = this.props.searchState ? this.props.searchState : {};
        this.props.onSearchParameters(e, t, r, o);
      }
      if (this.props.widgetsCollector) {
        var i = this.props.searchState ? this.props.searchState : {};
        this.props.widgetsCollector({
          getSearchParameters: e,
          getMetadata: n,
          context: t,
          props: r,
          searchState: i,
          displayName: a
        });
      }
    }
  }, {
    key: "onSearchForFacetValues",
    value: function (e) {
      this.state.instantSearchManager.onSearchForFacetValues(e);
    }
  }, {
    key: "getKnownKeys",
    value: function () {
      return this.state.instantSearchManager.getWidgetsIds();
    }
  }, {
    key: "render",
    value: function () {
      return 0 === s.count(this.props.children) ? null : t.createElement(yQ, {
        value: this.state.contextValue
      }, this.props.children);
    }
  }]) && UK(r.prototype, n), a && UK(r, a), Object.defineProperty(r, "prototype", {
    writable: !1
  }), l;
}();
function JK(e) {
  return JK = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, JK(e);
}
function eX(e, t, r) {
  return (t = function (e) {
    var t = function (e, t) {
      if ("object" !== JK(e) || null === e) return e;
      var r = e[Symbol.toPrimitive];
      if (void 0 !== r) {
        var n = r.call(e, t || "default");
        if ("object" !== JK(n)) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === t ? String : Number)(e);
    }(e, "string");
    return "symbol" === JK(t) ? t : String(t);
  }(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
GK(XK, "defaultProps", {
  stalledSearchDelay: 200,
  refresh: !1
}), GK(XK, "propTypes", {
  indexName: se.string.isRequired,
  searchClient: se.shape({
    search: se.func.isRequired,
    searchForFacetValues: se.func,
    addAlgoliaAgent: se.func,
    clearCache: se.func
  }).isRequired,
  createURL: se.func,
  refresh: se.bool,
  searchState: se.object,
  onSearchStateChange: se.func,
  onSearchParameters: se.func,
  widgetsCollector: se.func,
  resultsState: se.oneOfType([se.object, se.array]),
  children: se.node,
  stalledSearchDelay: se.number
});
var tX = function (e) {
  return e.attributes[0];
};
function rX(e) {
  return e.reduce(function (e, t) {
    return t.isRefined && (e.push({
      label: t.name,
      value: t.escapedValue
    }), t.data && (e = e.concat(rX(t.data)))), e;
  }, []);
}
var nX = IQ({
  displayName: "AlgoliaBreadcrumb",
  $$type: "ais.breadcrumb",
  propTypes: {
    attributes: function (e, t, r) {
      if (!Array.isArray(e[t]) || e[t].some(function (e) {
        return "string" != typeof e;
      }) || e[t].length < 1) return new Error("Invalid prop ".concat(t, " supplied to ").concat(r, ". Expected an Array of Strings"));
    },
    transformItems: se.func
  },
  getProvidedProps: function (e, t, r) {
    var n = tX(e),
      a = nG(r, {
        ais: e.contextValue,
        multiIndexContext: e.indexContextValue
      });
    if (!(Boolean(a) && Boolean(a.getFacetByName(n)))) return {
      items: [],
      canRefine: !1
    };
    var o = a.getFacetValues(n),
      i = o.data ? rX(o.data) : [],
      l = e.transformItems ? e.transformItems(i) : i;
    return {
      canRefine: l.length > 0,
      items: l
    };
  },
  refine: function (e, t, r) {
    return function (e, t, r, n) {
      return oG(t, eX({}, tX(e), r || ""), n, !0, "hierarchicalMenu");
    }(e, t, r, {
      ais: e.contextValue,
      multiIndexContext: e.indexContextValue
    });
  }
});
function aX(e) {
  return aX = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, aX(e);
}
function oX(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function iX(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? oX(Object(r), !0).forEach(function (t) {
      lX(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : oX(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
function lX(e, t, r) {
  return (t = function (e) {
    var t = function (e, t) {
      if ("object" !== aX(e) || null === e) return e;
      var r = e[Symbol.toPrimitive];
      if (void 0 !== r) {
        var n = r.call(e, t || "default");
        if ("object" !== aX(n)) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === t ? String : Number)(e);
    }(e, "string");
    return "symbol" === aX(t) ? t : String(t);
  }(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
var sX = IQ({
  displayName: "AlgoliaCurrentRefinements",
  $$type: "ais.currentRefinements",
  propTypes: {
    transformItems: se.func
  },
  getProvidedProps: function (e, t, r, n) {
    var a = n.reduce(function (t, r) {
        return void 0 !== r.items && (e.clearsQuery || "query" !== r.id) ? e.clearsQuery && "query" === r.id && "" === r.items[0].currentRefinement ? t : t.concat(r.items.map(function (e) {
          return iX(iX({}, e), {}, {
            id: r.id,
            index: r.index
          });
        })) : t;
      }, []),
      o = e.transformItems ? e.transformItems(a) : a;
    return {
      items: o,
      canRefine: o.length > 0
    };
  },
  refine: function (e, t, r) {
    return (r instanceof Array ? r.map(function (e) {
      return e.value;
    }) : [r]).reduce(function (e, t) {
      return t(e);
    }, t);
  }
});
function cX(e) {
  return cX = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, cX(e);
}
function uX(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function hX(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? uX(Object(r), !0).forEach(function (t) {
      mX(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : uX(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
function mX(e, t, r) {
  return (t = function (e) {
    var t = function (e, t) {
      if ("object" !== cX(e) || null === e) return e;
      var r = e[Symbol.toPrimitive];
      if (void 0 !== r) {
        var n = r.call(e, t || "default");
        if ("object" !== cX(n)) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === t ? String : Number)(e);
    }(e, "string");
    return "symbol" === cX(t) ? t : String(t);
  }(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
var pX = function (e) {
    return e.attributes[0];
  },
  fX = "hierarchicalMenu";
function dX(e, t, r) {
  var n = lG(e, t, r, "".concat(fX, ".").concat(pX(e)), null);
  return "" === n ? null : n;
}
function vX(e, t, r, n) {
  var a,
    o = t.id,
    i = t.attributes,
    l = t.separator,
    s = t.rootPath,
    c = t.showParentLevel,
    u = dX(t, r, n);
  null === u ? a = e : a = new $Y.SearchParameters({
    hierarchicalFacets: [{
      name: o,
      attributes: i,
      separator: l,
      rootPath: s,
      showParentLevel: c
    }]
  }).toggleHierarchicalFacetRefinement(o, u).toggleHierarchicalFacetRefinement(o, e).getHierarchicalRefinement(o)[0];
  return a;
}
function gX(e, t, r, n) {
  return e.map(function (e) {
    return {
      label: e.name,
      value: vX(e.escapedValue, t, r, n),
      count: e.count,
      isRefined: e.isRefined,
      items: e.data && gX(e.data, t, r, n)
    };
  });
}
var bX = function e() {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 10;
  return (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : []).slice(0, t).map(function () {
    var r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
    return Array.isArray(r.items) ? hX(hX({}, r), {}, {
      items: e(r.items, t)
    }) : r;
  });
};
function wX(e, t, r, n) {
  return oG(t, mX({}, pX(e), r || ""), n, !0, fX);
}
var yX = ["name:asc"],
  xX = IQ({
    displayName: "AlgoliaHierarchicalMenu",
    $$type: "ais.hierarchicalMenu",
    propTypes: {
      attributes: function (e, t, r) {
        if (!Array.isArray(e[t]) || e[t].some(function (e) {
          return "string" != typeof e;
        }) || e[t].length < 1) return new Error("Invalid prop ".concat(t, " supplied to ").concat(r, ". Expected an Array of Strings"));
      },
      separator: se.string,
      rootPath: se.string,
      showParentLevel: se.bool,
      defaultRefinement: se.string,
      showMore: se.bool,
      limit: se.number,
      showMoreLimit: se.number,
      transformItems: se.func,
      facetOrdering: se.bool
    },
    defaultProps: {
      showMore: !1,
      limit: 10,
      showMoreLimit: 20,
      separator: " > ",
      rootPath: null,
      showParentLevel: !0,
      facetOrdering: !0
    },
    getProvidedProps: function (e, t, r) {
      var n = e.showMore,
        a = e.limit,
        o = e.showMoreLimit,
        i = e.facetOrdering,
        l = pX(e),
        s = nG(r, {
          ais: e.contextValue,
          multiIndexContext: e.indexContextValue
        });
      if (!(Boolean(s) && Boolean(s.getFacetByName(l)))) return {
        items: [],
        currentRefinement: dX(e, t, {
          ais: e.contextValue,
          multiIndexContext: e.indexContextValue
        }),
        canRefine: !1
      };
      var c = n ? o : a,
        u = s.getFacetValues(l, {
          sortBy: yX,
          facetOrdering: i
        }),
        h = u.data ? gX(u.data, e, t, {
          ais: e.contextValue,
          multiIndexContext: e.indexContextValue
        }) : [],
        m = e.transformItems ? e.transformItems(h) : h;
      return {
        items: bX(m, c),
        currentRefinement: dX(e, t, {
          ais: e.contextValue,
          multiIndexContext: e.indexContextValue
        }),
        canRefine: m.length > 0
      };
    },
    refine: function (e, t, r) {
      return wX(e, t, r, {
        ais: e.contextValue,
        multiIndexContext: e.indexContextValue
      });
    },
    cleanUp: function (e, t) {
      return function (e, t, r) {
        return sG(t, r, "".concat(fX, ".").concat(pX(e)));
      }(e, t, {
        ais: e.contextValue,
        multiIndexContext: e.indexContextValue
      });
    },
    getSearchParameters: function (e, t, r) {
      var n = t.attributes,
        a = t.separator,
        o = t.rootPath,
        i = t.showParentLevel,
        l = t.showMore,
        s = t.limit,
        c = t.showMoreLimit,
        u = t.contextValue,
        h = pX(t),
        m = l ? c : s;
      e = e.addHierarchicalFacet({
        name: h,
        attributes: n,
        separator: a,
        rootPath: o,
        showParentLevel: i
      }).setQueryParameters({
        maxValuesPerFacet: Math.max(e.maxValuesPerFacet || 0, m)
      });
      var p = dX(t, r, {
        ais: u,
        multiIndexContext: t.indexContextValue
      });
      return null !== p && (e = e.toggleHierarchicalFacetRefinement(h, p)), e;
    },
    getMetadata: function (e, t) {
      var r = e.attributes[0],
        n = pX(e),
        a = dX(e, t, {
          ais: e.contextValue,
          multiIndexContext: e.indexContextValue
        }),
        o = a ? [{
          label: "".concat(r, ": ").concat(gQ(a)),
          attribute: r,
          value: function (t) {
            return wX(e, t, "", {
              ais: e.contextValue,
              multiIndexContext: e.indexContextValue
            });
          },
          currentRefinement: a
        }] : [];
      return {
        id: n,
        index: rG({
          ais: e.contextValue,
          multiIndexContext: e.indexContextValue
        }),
        items: o
      };
    }
  }),
  OX = function (e) {
    var t = e.attribute,
      r = e.hit,
      n = e.highlightProperty,
      a = e.preTag,
      o = void 0 === a ? FQ.highlightPreTag : a,
      i = e.postTag;
    return function (e) {
      var t = e.preTag,
        r = void 0 === t ? "<em>" : t,
        n = e.postTag,
        a = void 0 === n ? "</em>" : n,
        o = e.highlightProperty,
        i = e.attribute,
        l = e.hit;
      if (!l) throw new Error("`hit`, the matching record, must be provided");
      var s = vQ(l[o], i) || {};
      return Array.isArray(s) ? s.map(function (e) {
        return _Q({
          preTag: r,
          postTag: a,
          highlightedValue: e.value
        });
      }) : _Q({
        preTag: r,
        postTag: a,
        highlightedValue: s.value
      });
    }({
      attribute: t,
      highlightProperty: n,
      hit: r,
      preTag: o,
      postTag: void 0 === i ? FQ.highlightPostTag : i
    });
  },
  EX = IQ({
    displayName: "AlgoliaHighlighter",
    $$type: "ais.highlighter",
    propTypes: {},
    getProvidedProps: function () {
      return {
        highlight: OX
      };
    }
  }),
  jX = IQ({
    displayName: "AlgoliaHits",
    $$type: "ais.hits",
    getProvidedProps: function (e, t, r) {
      var n = nG(r, {
        ais: e.contextValue,
        multiIndexContext: e.indexContextValue
      });
      return n ? {
        hits: pQ(mQ(n.hits, n.hitsPerPage, n.page), n.queryID)
      } : {
        hits: []
      };
    },
    getSearchParameters: function (e) {
      return e;
    }
  });
function CX(e) {
  return CX = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, CX(e);
}
function PX(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function MX(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? PX(Object(r), !0).forEach(function (t) {
      kX(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : PX(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
function kX(e, t, r) {
  return (t = function (e) {
    var t = function (e, t) {
      if ("object" !== CX(e) || null === e) return e;
      var r = e[Symbol.toPrimitive];
      if (void 0 !== r) {
        var n = r.call(e, t || "default");
        if ("object" !== CX(n)) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === t ? String : Number)(e);
    }(e, "string");
    return "symbol" === CX(t) ? t : String(t);
  }(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function SX(e, t, r) {
  var n = lG(e, t, r, "hitsPerPage", null);
  return "string" == typeof n ? parseInt(n, 10) : n;
}
var NX = IQ({
  displayName: "AlgoliaHitsPerPage",
  $$type: "ais.hitsPerPage",
  propTypes: {
    defaultRefinement: se.number.isRequired,
    items: se.arrayOf(se.shape({
      label: se.string,
      value: se.number.isRequired
    })).isRequired,
    transformItems: se.func
  },
  getProvidedProps: function (e, t) {
    var r = SX(e, t, {
        ais: e.contextValue,
        multiIndexContext: e.indexContextValue
      }),
      n = e.items.map(function (e) {
        return e.value === r ? MX(MX({}, e), {}, {
          isRefined: !0
        }) : MX(MX({}, e), {}, {
          isRefined: !1
        });
      });
    return {
      items: e.transformItems ? e.transformItems(n) : n,
      currentRefinement: r
    };
  },
  refine: function (e, t, r) {
    return oG(t, kX({}, "hitsPerPage", r), {
      ais: e.contextValue,
      multiIndexContext: e.indexContextValue
    }, !0);
  },
  cleanUp: function (e, t) {
    return sG(t, {
      ais: e.contextValue,
      multiIndexContext: e.indexContextValue
    }, "hitsPerPage");
  },
  getSearchParameters: function (e, t, r) {
    return e.setHitsPerPage(SX(t, r, {
      ais: t.contextValue,
      multiIndexContext: t.indexContextValue
    }));
  },
  getMetadata: function () {
    return {
      id: "hitsPerPage"
    };
  }
});
function BX(e) {
  return BX = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, BX(e);
}
var VX = ["page"];
function RX(e, t, r) {
  return (t = function (e) {
    var t = function (e, t) {
      if ("object" !== BX(e) || null === e) return e;
      var r = e[Symbol.toPrimitive];
      if (void 0 !== r) {
        var n = r.call(e, t || "default");
        if ("object" !== BX(n)) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === t ? String : Number)(e);
    }(e, "string");
    return "symbol" === BX(t) ? t : String(t);
  }(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function AX(e) {
  return function (e) {
    if (Array.isArray(e)) return TX(e);
  }(e) || function (e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
  }(e) || function (e, t) {
    if (!e) return;
    if ("string" == typeof e) return TX(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    "Object" === r && e.constructor && (r = e.constructor.name);
    if ("Map" === r || "Set" === r) return Array.from(e);
    if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return TX(e, t);
  }(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function TX(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function HX(e, t) {
  if (null == e) return {};
  var r,
    n,
    a = function (e, t) {
      if (null == e) return {};
      var r,
        n,
        a = {},
        o = Object.keys(e);
      for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || (a[r] = e[r]);
      return a;
    }(e, t);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (a[r] = e[r]);
  }
  return a;
}
function LX(e, t, r) {
  var n = lG(e, t, r, "page", 1);
  return "string" == typeof n ? parseInt(n, 10) : n;
}
function IX(e) {
  var t = e || {};
  return t.page, HX(t, VX);
}
function FX(e) {
  return Object.keys(e).map(Number).sort(function (e, t) {
    return e - t;
  }).reduce(function (t, r) {
    return t.concat(e[r]);
  }, []);
}
var _X = IQ({
  displayName: "AlgoliaInfiniteHits",
  $$type: "ais.infiniteHits",
  getProvidedProps: function (e, t, r) {
    var n = this,
      a = nG(r, {
        ais: e.contextValue,
        multiIndexContext: e.indexContextValue
      });
    if (!a) return {
      hits: [],
      hasPrevious: !1,
      hasMore: !1,
      refine: function () {},
      refinePrevious: function () {},
      refineNext: function () {}
    };
    var o = a.page,
      i = a.hits,
      l = a.hitsPerPage,
      s = a.nbPages,
      c = a._state;
    this._cache = e.cache ? e.cache : this._cache || function () {
      var e = void 0,
        t = void 0;
      return {
        read: function (r) {
          var n = r.state;
          return tQ(t, IX(n)) ? e : null;
        },
        write: function (r) {
          var n = r.state,
            a = r.hits;
          t = IX(n), e = a;
        }
      };
    }();
    var u = this._cache.read({
        state: c
      }) || {},
      h = pQ(mQ(i, l, o), a.queryID);
    u[o] = h, this._cache.write({
      state: c,
      hits: u
    });
    var m = Math.min.apply(Math, AX(Object.keys(u).map(Number))),
      p = Math.max.apply(Math, AX(Object.keys(u).map(Number))),
      f = m > 0,
      d = p < s - 1;
    return {
      hits: FX(u),
      hasPrevious: f,
      hasMore: d,
      refinePrevious: function (e) {
        return n.refine(e, m - 1);
      },
      refineNext: function (e) {
        return n.refine(e, p + 1);
      }
    };
  },
  getSearchParameters: function (e, t, r) {
    return e.setQueryParameters({
      page: LX(t, r, {
        ais: t.contextValue,
        multiIndexContext: t.indexContextValue
      }) - 1
    });
  },
  refine: function (e, t, r, n) {
    return oG(t, RX({}, "page", n + 1), {
      ais: e.contextValue,
      multiIndexContext: e.indexContextValue
    }, !1);
  }
});
function ZX(e) {
  return ZX = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, ZX(e);
}
function DX(e, t, r) {
  return (t = function (e) {
    var t = function (e, t) {
      if ("object" !== ZX(e) || null === e) return e;
      var r = e[Symbol.toPrimitive];
      if (void 0 !== r) {
        var n = r.call(e, t || "default");
        if ("object" !== ZX(n)) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === t ? String : Number)(e);
    }(e, "string");
    return "symbol" === ZX(t) ? t : String(t);
  }(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
var qX = "menu";
function UX(e) {
  return e.attribute;
}
function $X(e, t, r) {
  var n = lG(e, t, r, "".concat(qX, ".").concat(UX(e)), null);
  return "" === n ? null : n;
}
function zX(e, t, r, n) {
  return e === $X(t, r, n) ? "" : e;
}
function WX(e) {
  var t = e.showMore,
    r = e.limit,
    n = e.showMoreLimit;
  return t ? n : r;
}
function QX(e, t, r, n) {
  return oG(t, DX({}, UX(e), r || ""), n, !0, qX);
}
var GX = ["count:desc", "name:asc"],
  YX = IQ({
    displayName: "AlgoliaMenu",
    $$type: "ais.menu",
    propTypes: {
      attribute: se.string.isRequired,
      showMore: se.bool,
      limit: se.number,
      showMoreLimit: se.number,
      defaultRefinement: se.string,
      transformItems: se.func,
      searchable: se.bool,
      facetOrdering: se.bool
    },
    defaultProps: {
      showMore: !1,
      limit: 10,
      showMoreLimit: 20,
      facetOrdering: !0
    },
    getProvidedProps: function (e, t, r, n, a) {
      var o,
        i = e.attribute,
        l = e.searchable,
        s = e.indexContextValue,
        c = e.facetOrdering,
        u = nG(r, {
          ais: e.contextValue,
          multiIndexContext: e.indexContextValue
        }),
        h = Boolean(u) && Boolean(u.getFacetByName(i)),
        m = Boolean(a && a[i] && "" !== a.query);
      if (l && s) throw new Error("react-instantsearch: searching in *List is not available when used inside a multi index context");
      if (!h) return {
        items: [],
        currentRefinement: $X(e, t, {
          ais: e.contextValue,
          multiIndexContext: e.indexContextValue
        }),
        isFromSearch: m,
        searchable: l,
        canRefine: h
      };
      o = m ? a[i].map(function (r) {
        return {
          label: r.value,
          value: zX(r.escapedValue, e, t, {
            ais: e.contextValue,
            multiIndexContext: e.indexContextValue
          }),
          _highlightResult: {
            label: {
              value: r.highlighted
            }
          },
          count: r.count,
          isRefined: r.isRefined
        };
      }) : u.getFacetValues(i, {
        sortBy: l ? void 0 : GX,
        facetOrdering: c
      }).map(function (r) {
        return {
          label: r.name,
          value: zX(r.escapedValue, e, t, {
            ais: e.contextValue,
            multiIndexContext: e.indexContextValue
          }),
          count: r.count,
          isRefined: r.isRefined
        };
      });
      var p = e.transformItems ? e.transformItems(o) : o;
      return {
        items: p.slice(0, WX(e)),
        currentRefinement: $X(e, t, {
          ais: e.contextValue,
          multiIndexContext: e.indexContextValue
        }),
        isFromSearch: m,
        searchable: l,
        canRefine: p.length > 0
      };
    },
    refine: function (e, t, r) {
      return QX(e, t, r, {
        ais: e.contextValue,
        multiIndexContext: e.indexContextValue
      });
    },
    searchForFacetValues: function (e, t, r) {
      return {
        facetName: e.attribute,
        query: r,
        maxFacetHits: WX(e)
      };
    },
    cleanUp: function (e, t) {
      return function (e, t, r) {
        return sG(t, r, "".concat(qX, ".").concat(UX(e)));
      }(e, t, {
        ais: e.contextValue,
        multiIndexContext: e.indexContextValue
      });
    },
    getSearchParameters: function (e, t, r) {
      var n = t.attribute;
      e = (e = e.setQueryParameters({
        maxValuesPerFacet: Math.max(e.maxValuesPerFacet || 0, WX(t))
      })).addDisjunctiveFacet(n);
      var a = $X(t, r, {
        ais: t.contextValue,
        multiIndexContext: t.indexContextValue
      });
      return null !== a && (e = e.addDisjunctiveFacetRefinement(n, a)), e;
    },
    getMetadata: function (e, t) {
      var r = UX(e),
        n = $X(e, t, {
          ais: e.contextValue,
          multiIndexContext: e.indexContextValue
        });
      return {
        id: r,
        index: rG({
          ais: e.contextValue,
          multiIndexContext: e.indexContextValue
        }),
        items: null === n ? [] : [{
          label: "".concat(e.attribute, ": ").concat(gQ(n)),
          attribute: e.attribute,
          value: function (t) {
            return QX(e, t, "", {
              ais: e.contextValue,
              multiIndexContext: e.indexContextValue
            });
          },
          currentRefinement: n
        }]
      };
    }
  });
function KX(e) {
  return KX = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, KX(e);
}
function XX(e, t, r) {
  return (t = function (e) {
    var t = function (e, t) {
      if ("object" !== KX(e) || null === e) return e;
      var r = e[Symbol.toPrimitive];
      if (void 0 !== r) {
        var n = r.call(e, t || "default");
        if ("object" !== KX(n)) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === t ? String : Number)(e);
    }(e, "string");
    return "symbol" === KX(t) ? t : String(t);
  }(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function JX(e, t) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, t) {
    var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (null != r) {
      var n,
        a,
        o,
        i,
        l = [],
        s = !0,
        c = !1;
      try {
        if (o = (r = r.call(e)).next, 0 === t) {
          if (Object(r) !== r) return;
          s = !1;
        } else for (; !(s = (n = o.call(r)).done) && (l.push(n.value), l.length !== t); s = !0);
      } catch (e) {
        c = !0, a = e;
      } finally {
        try {
          if (!s && null != r.return && (i = r.return(), Object(i) !== i)) return;
        } finally {
          if (c) throw a;
        }
      }
      return l;
    }
  }(e, t) || function (e, t) {
    if (!e) return;
    if ("string" == typeof e) return eJ(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    "Object" === r && e.constructor && (r = e.constructor.name);
    if ("Map" === r || "Set" === r) return Array.from(e);
    if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return eJ(e, t);
  }(e, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function eJ(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function tJ(e) {
  if (void 0 === e.start && void 0 === e.end) return "";
  var t = void 0 !== e.start ? e.start : "",
    r = void 0 !== e.end ? e.end : "";
  return "".concat(t, ":").concat(r);
}
var rJ = "multiRange";
function nJ(e) {
  return e.attribute;
}
function aJ(e, t, r) {
  return lG(e, t, r, "".concat(rJ, ".").concat(nJ(e)), "");
}
function oJ(e, t, r) {
  var n = t.getFacetByName(e) ? t.getFacetStats(e) : null,
    a = r.split(":"),
    o = 0 === Number(a[0]) || "" === r ? Number.NEGATIVE_INFINITY : Number(a[0]),
    i = 0 === Number(a[1]) || "" === r ? Number.POSITIVE_INFINITY : Number(a[1]);
  return !(Boolean(n) && (function (e, t, r) {
    return e.min >= t && e.min <= r || e.max >= t && e.max <= r;
  }(n, o, i) || function (e, t, r) {
    return t >= e.min && t <= e.max || r >= e.min && r <= e.max;
  }(n, o, i)));
}
function iJ(e, t, r, n) {
  return oG(t, XX({}, nJ(e), r), n, !0, rJ);
}
var lJ = IQ({
  displayName: "AlgoliaNumericMenu",
  $$type: "ais.numericMenu",
  propTypes: {
    id: se.string,
    attribute: se.string.isRequired,
    items: se.arrayOf(se.shape({
      label: se.node,
      start: se.number,
      end: se.number
    })).isRequired,
    transformItems: se.func
  },
  getProvidedProps: function (e, t, r) {
    var n = e.attribute,
      a = aJ(e, t, {
        ais: e.contextValue,
        multiIndexContext: e.indexContextValue
      }),
      o = nG(r, {
        ais: e.contextValue,
        multiIndexContext: e.indexContextValue
      }),
      i = e.items.map(function (t) {
        var r = tJ(t);
        return {
          label: t.label,
          value: r,
          isRefined: r === a,
          noRefinement: !!o && oJ(nJ(e), o, r)
        };
      }),
      l = o && o.getFacetByName(n) ? o.getFacetStats(n) : null,
      s = fQ(i, function (e) {
        return !0 === e.isRefined;
      });
    i.some(function (e) {
      return "" === e.value;
    }) || i.push({
      value: "",
      isRefined: void 0 === s,
      noRefinement: !l,
      label: "All"
    });
    var c = e.transformItems ? e.transformItems(i) : i;
    return {
      items: c,
      currentRefinement: a,
      canRefine: c.length > 0 && c.some(function (e) {
        return !1 === e.noRefinement;
      })
    };
  },
  refine: function (e, t, r) {
    return iJ(e, t, r, {
      ais: e.contextValue,
      multiIndexContext: e.indexContextValue
    });
  },
  cleanUp: function (e, t) {
    return function (e, t, r) {
      return sG(t, r, "".concat(rJ, ".").concat(nJ(e)));
    }(e, t, {
      ais: e.contextValue,
      multiIndexContext: e.indexContextValue
    });
  },
  getSearchParameters: function (e, t, r) {
    var n = t.attribute,
      a = function (e) {
        if (0 === e.length) return {
          start: null,
          end: null
        };
        var t = JX(e.split(":"), 2),
          r = t[0],
          n = t[1];
        return {
          start: r.length > 0 ? parseFloat(r) : null,
          end: n.length > 0 ? parseFloat(n) : null
        };
      }(aJ(t, r, {
        ais: t.contextValue,
        multiIndexContext: t.indexContextValue
      })),
      o = a.start,
      i = a.end;
    return e = e.addDisjunctiveFacet(n), "number" == typeof o && (e = e.addNumericRefinement(n, ">=", o)), "number" == typeof i && (e = e.addNumericRefinement(n, "<=", i)), e;
  },
  getMetadata: function (e, t) {
    var r = nJ(e),
      n = aJ(e, t, {
        ais: e.contextValue,
        multiIndexContext: e.indexContextValue
      }),
      a = [],
      o = rG({
        ais: e.contextValue,
        multiIndexContext: e.indexContextValue
      });
    if ("" !== n) {
      var i = fQ(e.items, function (e) {
        return tJ(e) === n;
      }).label;
      a.push({
        label: "".concat(e.attribute, ": ").concat(i),
        attribute: e.attribute,
        currentRefinement: i,
        value: function (t) {
          return iJ(e, t, "", {
            ais: e.contextValue,
            multiIndexContext: e.indexContextValue
          });
        }
      });
    }
    return {
      id: r,
      index: o,
      items: a
    };
  }
});
function sJ(e) {
  return sJ = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, sJ(e);
}
function cJ(e, t, r) {
  return (t = function (e) {
    var t = function (e, t) {
      if ("object" !== sJ(e) || null === e) return e;
      var r = e[Symbol.toPrimitive];
      if (void 0 !== r) {
        var n = r.call(e, t || "default");
        if ("object" !== sJ(n)) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === t ? String : Number)(e);
    }(e, "string");
    return "symbol" === sJ(t) ? t : String(t);
  }(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function uJ(e, t, r) {
  var n = lG(e, t, r, "page", 1);
  return "string" == typeof n ? parseInt(n, 10) : n;
}
var hJ = IQ({
    displayName: "AlgoliaPagination",
    $$type: "ais.pagination",
    getProvidedProps: function (e, t, r) {
      var n = nG(r, {
        ais: e.contextValue,
        multiIndexContext: e.indexContextValue
      });
      if (!n) return null;
      var a = n.nbPages;
      return {
        nbPages: a,
        currentRefinement: uJ(e, t, {
          ais: e.contextValue,
          multiIndexContext: e.indexContextValue
        }),
        canRefine: a > 1
      };
    },
    refine: function (e, t, r) {
      return function (e, t, r, n) {
        return oG(t, cJ({}, "page", r), n, !1);
      }(0, t, r, {
        ais: e.contextValue,
        multiIndexContext: e.indexContextValue
      });
    },
    cleanUp: function (e, t) {
      return sG(t, {
        ais: e.contextValue,
        multiIndexContext: e.indexContextValue
      }, "page");
    },
    getSearchParameters: function (e, t, r) {
      return e.setPage(uJ(t, r, {
        ais: t.contextValue,
        multiIndexContext: t.indexContextValue
      }) - 1);
    },
    getMetadata: function () {
      return {
        id: "page"
      };
    }
  }),
  mJ = IQ({
    displayName: "AlgoliaPoweredBy",
    $$type: "ais.poweredBy",
    getProvidedProps: function () {
      var e = "undefined" == typeof window || void 0 === window.location ? "" : window.location.hostname;
      return {
        url: "https://www.algolia.com/?utm_source=react-instantsearch&utm_medium=website&" + "utm_content=".concat(e, "&") + "utm_campaign=poweredby"
      };
    }
  });
function pJ(e) {
  return pJ = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, pJ(e);
}
function fJ(e, t, r) {
  return (t = function (e) {
    var t = function (e, t) {
      if ("object" !== pJ(e) || null === e) return e;
      var r = e[Symbol.toPrimitive];
      if (void 0 !== r) {
        var n = r.call(e, t || "default");
        if ("object" !== pJ(n)) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === t ? String : Number)(e);
    }(e, "string");
    return "symbol" === pJ(t) ? t : String(t);
  }(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function dJ(e) {
  return e.attribute;
}
var vJ = "range";
function gJ(e, t, r, n) {
  var a = lG(e, t, n, "".concat(vJ, ".").concat(dJ(e)), {}),
    o = a.min,
    i = a.max,
    l = Boolean(e.precision),
    s = o;
  "string" == typeof s && (s = l ? parseFloat(s) : parseInt(s, 10));
  var c = i;
  "string" == typeof c && (c = l ? parseFloat(c) : parseInt(c, 10));
  var u = {
      min: s,
      max: c
    },
    h = void 0 !== e.min,
    m = void 0 !== e.max,
    p = void 0 !== u.min,
    f = void 0 !== u.max;
  if (h && p && u.min < r.min) throw Error("You can't provide min value lower than range.");
  if (m && f && u.max > r.max) throw Error("You can't provide max value greater than range.");
  return h && !p && (u.min = r.min), m && !f && (u.max = r.max), u;
}
function bJ(e, t) {
  return {
    min: void 0 !== e.min ? e.min : t.min,
    max: void 0 !== e.max ? e.max : t.max
  };
}
function wJ(e, t, r, n) {
  return e || r !== n ? e && t ? r : n : void 0;
}
function yJ(e, t, r, n, a) {
  var o = r.min,
    i = r.max,
    l = n.min,
    s = n.max,
    c = void 0 === o || "" === o,
    u = void 0 === i || "" === i,
    h = c ? void 0 : parseFloat(o),
    m = u ? void 0 : parseFloat(i),
    p = c || isFinite(h),
    f = u || isFinite(m);
  if (!p || !f) throw Error("You can't provide non finite values to the range connector.");
  if (h < l) throw Error("You can't provide min value lower than range.");
  if (m > s) throw Error("You can't provide max value greater than range.");
  return oG(t, fJ({}, dJ(e), {
    min: wJ(void 0 !== e.min, c, l, h),
    max: wJ(void 0 !== e.max, u, s, m)
  }), a, !0, vJ);
}
var xJ = IQ({
  displayName: "AlgoliaRange",
  $$type: "ais.range",
  propTypes: {
    id: se.string,
    attribute: se.string.isRequired,
    defaultRefinement: se.shape({
      min: se.number,
      max: se.number
    }),
    min: se.number,
    max: se.number,
    precision: se.number,
    header: se.node,
    footer: se.node
  },
  defaultProps: {
    precision: 0
  },
  getProvidedProps: function (e, t, r) {
    var n = e.attribute,
      a = e.precision,
      o = e.min,
      i = e.max,
      l = nG(r, {
        ais: e.contextValue,
        multiIndexContext: e.indexContextValue
      }),
      s = l && l.getFacetByName(n),
      c = s && l.getFacetStats(n) || {},
      u = (s ? l.getFacetValues(n) : []).map(function (e) {
        return {
          value: e.name,
          count: e.count
        };
      }),
      h = function (e, t, r) {
        var n,
          a,
          o = Math.pow(10, r);
        return n = "number" == typeof e.min && isFinite(e.min) ? e.min : "number" == typeof t.min && isFinite(t.min) ? t.min : void 0, a = "number" == typeof e.max && isFinite(e.max) ? e.max : "number" == typeof t.max && isFinite(t.max) ? t.max : void 0, {
          min: void 0 !== n ? Math.floor(n * o) / o : n,
          max: void 0 !== a ? Math.ceil(a * o) / o : a
        };
      }({
        min: o,
        max: i
      }, c, a),
      m = h.min,
      p = h.max;
    this._currentRange = {
      min: m,
      max: p
    };
    var f = gJ(e, t, this._currentRange, {
      ais: e.contextValue,
      multiIndexContext: e.indexContextValue
    });
    return {
      min: m,
      max: p,
      canRefine: u.length > 0,
      currentRefinement: bJ(f, this._currentRange),
      count: u,
      precision: a
    };
  },
  refine: function (e, t, r) {
    return yJ(e, t, r, this._currentRange, {
      ais: e.contextValue,
      multiIndexContext: e.indexContextValue
    });
  },
  cleanUp: function (e, t) {
    return function (e, t, r) {
      return sG(t, r, "".concat(vJ, ".").concat(dJ(e)));
    }(e, t, {
      ais: e.contextValue,
      multiIndexContext: e.indexContextValue
    });
  },
  getSearchParameters: function (e, t, r) {
    var n = t.attribute,
      a = gJ(t, r, this._currentRange, {
        ais: t.contextValue,
        multiIndexContext: t.indexContextValue
      }),
      o = a.min,
      i = a.max;
    return e = e.addDisjunctiveFacet(n), void 0 !== o && (e = e.addNumericRefinement(n, ">=", o)), void 0 !== i && (e = e.addNumericRefinement(n, "<=", i)), e;
  },
  getMetadata: function (e, t) {
    var r = this,
      n = this._currentRange,
      a = n.min,
      o = n.max,
      i = gJ(e, t, this._currentRange, {
        ais: e.contextValue,
        multiIndexContext: e.indexContextValue
      }),
      l = i.min,
      s = i.max,
      c = [],
      u = void 0 !== l,
      h = void 0 !== s;
    if (u && l !== a || h && s !== o) {
      var m = [u ? "".concat(l, " <= ") : "", e.attribute, h ? " <= ".concat(s) : ""];
      c.push({
        label: m.join(""),
        attribute: e.attribute,
        value: function (t) {
          return yJ(e, t, {}, r._currentRange, {
            ais: e.contextValue,
            multiIndexContext: e.indexContextValue
          });
        },
        currentRefinement: bJ({
          min: l,
          max: s
        }, {
          min: a,
          max: o
        })
      });
    }
    return {
      id: dJ(e),
      index: rG({
        ais: e.contextValue,
        multiIndexContext: e.indexContextValue
      }),
      items: c
    };
  }
});
function OJ(e) {
  return OJ = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, OJ(e);
}
function EJ(e, t, r) {
  return (t = function (e) {
    var t = function (e, t) {
      if ("object" !== OJ(e) || null === e) return e;
      var r = e[Symbol.toPrimitive];
      if (void 0 !== r) {
        var n = r.call(e, t || "default");
        if ("object" !== OJ(n)) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === t ? String : Number)(e);
    }(e, "string");
    return "symbol" === OJ(t) ? t : String(t);
  }(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
var jJ = "refinementList";
function CJ(e) {
  return e.attribute;
}
function PJ(e, t, r) {
  var n = lG(e, t, r, "".concat(jJ, ".").concat(CJ(e)), []);
  return "string" != typeof n ? n : n ? [n] : [];
}
function MJ(e, t, r, n) {
  var a = PJ(t, r, n);
  return -1 === a.indexOf(e) ? a.concat([e]) : a.filter(function (t) {
    return t !== e;
  });
}
function kJ(e) {
  var t = e.showMore,
    r = e.limit,
    n = e.showMoreLimit;
  return t ? n : r;
}
function SJ(e, t, r, n) {
  return oG(t, EJ({}, CJ(e), r.length > 0 ? r : ""), n, !0, jJ);
}
var NJ = ["isRefined", "count:desc", "name:asc"],
  BJ = IQ({
    displayName: "AlgoliaRefinementList",
    $$type: "ais.refinementList",
    propTypes: {
      id: se.string,
      attribute: se.string.isRequired,
      operator: se.oneOf(["and", "or"]),
      showMore: se.bool,
      limit: se.number,
      showMoreLimit: se.number,
      defaultRefinement: se.arrayOf(se.oneOfType([se.string, se.number])),
      searchable: se.bool,
      transformItems: se.func,
      facetOrdering: se.bool
    },
    defaultProps: {
      operator: "or",
      showMore: !1,
      limit: 10,
      showMoreLimit: 20,
      facetOrdering: !0
    },
    getProvidedProps: function (e, t, r, n, a) {
      var o = e.attribute,
        i = e.searchable,
        l = e.indexContextValue,
        s = e.facetOrdering,
        c = nG(r, {
          ais: e.contextValue,
          multiIndexContext: e.indexContextValue
        }),
        u = Boolean(c) && Boolean(c.getFacetByName(o)),
        h = Boolean(a && a[o] && "" !== a.query);
      if (i && l) throw new Error("react-instantsearch: searching in *List is not available when used inside a multi index context");
      if (!u) return {
        items: [],
        currentRefinement: PJ(e, t, {
          ais: e.contextValue,
          multiIndexContext: e.indexContextValue
        }),
        canRefine: u,
        isFromSearch: h,
        searchable: i
      };
      var m = h ? a[o].map(function (r) {
          return {
            label: r.value,
            value: MJ(r.escapedValue, e, t, {
              ais: e.contextValue,
              multiIndexContext: e.indexContextValue
            }),
            _highlightResult: {
              label: {
                value: r.highlighted
              }
            },
            count: r.count,
            isRefined: r.isRefined
          };
        }) : c.getFacetValues(o, {
          sortBy: NJ,
          facetOrdering: s
        }).map(function (r) {
          return {
            label: r.name,
            value: MJ(r.escapedValue, e, t, {
              ais: e.contextValue,
              multiIndexContext: e.indexContextValue
            }),
            count: r.count,
            isRefined: r.isRefined
          };
        }),
        p = e.transformItems ? e.transformItems(m) : m;
      return {
        items: p.slice(0, kJ(e)),
        currentRefinement: PJ(e, t, {
          ais: e.contextValue,
          multiIndexContext: e.indexContextValue
        }),
        isFromSearch: h,
        searchable: i,
        canRefine: p.length > 0
      };
    },
    refine: function (e, t, r) {
      return SJ(e, t, r, {
        ais: e.contextValue,
        multiIndexContext: e.indexContextValue
      });
    },
    searchForFacetValues: function (e, t, r) {
      return {
        facetName: e.attribute,
        query: r,
        maxFacetHits: kJ(e)
      };
    },
    cleanUp: function (e, t) {
      return function (e, t, r) {
        return sG(t, r, "".concat(jJ, ".").concat(CJ(e)));
      }(e, t, {
        ais: e.contextValue,
        multiIndexContext: e.indexContextValue
      });
    },
    getSearchParameters: function (e, t, r) {
      var n = t.attribute,
        a = "and" === t.operator ? "addFacet" : "addDisjunctiveFacet",
        o = "".concat(a, "Refinement");
      return e = (e = e.setQueryParameters({
        maxValuesPerFacet: Math.max(e.maxValuesPerFacet || 0, kJ(t))
      }))[a](n), PJ(t, r, {
        ais: t.contextValue,
        multiIndexContext: t.indexContextValue
      }).reduce(function (e, t) {
        return e[o](n, t);
      }, e);
    },
    getMetadata: function (e, t) {
      var r = CJ(e),
        n = {
          ais: e.contextValue,
          multiIndexContext: e.indexContextValue
        };
      return {
        id: r,
        index: rG(n),
        items: PJ(e, t, n).length > 0 ? [{
          attribute: e.attribute,
          label: "".concat(e.attribute, ": "),
          currentRefinement: PJ(e, t, n),
          value: function (t) {
            return SJ(e, t, [], n);
          },
          items: PJ(e, t, n).map(function (r) {
            return {
              label: gQ("".concat(r)),
              value: function (a) {
                var o = PJ(e, a, n).filter(function (e) {
                  return e !== r;
                });
                return SJ(e, t, o, n);
              }
            };
          })
        }] : []
      };
    }
  }),
  VJ = IQ({
    displayName: "AlgoliaScrollTo",
    $$type: "ais.scrollTo",
    propTypes: {
      scrollOn: se.string
    },
    defaultProps: {
      scrollOn: "page"
    },
    getProvidedProps: function (e, t) {
      var r = e.scrollOn,
        n = lG(e, t, {
          ais: e.contextValue,
          multiIndexContext: e.indexContextValue
        }, r, null);
      this._prevSearchState || (this._prevSearchState = {}), aG({
        ais: e.contextValue,
        multiIndexContext: e.indexContextValue
      }) && (t = t.indices ? t.indices[rG({
        ais: e.contextValue,
        multiIndexContext: e.indexContextValue
      })] : {});
      var a = dQ(t, ["configure", r]),
        o = lQ(this._prevSearchState, a);
      return this._prevSearchState = a, {
        value: n,
        hasNotChanged: o
      };
    }
  });
function RJ(e) {
  return RJ = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, RJ(e);
}
function AJ(e, t, r) {
  return (t = function (e) {
    var t = function (e, t) {
      if ("object" !== RJ(e) || null === e) return e;
      var r = e[Symbol.toPrimitive];
      if (void 0 !== r) {
        var n = r.call(e, t || "default");
        if ("object" !== RJ(n)) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === t ? String : Number)(e);
    }(e, "string");
    return "symbol" === RJ(t) ? t : String(t);
  }(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function TJ(e, t, r) {
  var n = lG(e, t, r, "query", "");
  return n || "";
}
function HJ(e, t, r, n) {
  return oG(t, AJ({}, "query", r), n, !0);
}
var LJ = IQ({
  displayName: "AlgoliaSearchBox",
  $$type: "ais.searchBox",
  propTypes: {
    defaultRefinement: se.string
  },
  getProvidedProps: function (e, t, r) {
    return {
      currentRefinement: TJ(e, t, {
        ais: e.contextValue,
        multiIndexContext: e.indexContextValue
      }),
      isSearchStalled: r.isSearchStalled
    };
  },
  refine: function (e, t, r) {
    return HJ(0, t, r, {
      ais: e.contextValue,
      multiIndexContext: e.indexContextValue
    });
  },
  cleanUp: function (e, t) {
    return function (e, t, r) {
      return sG(t, r, "query");
    }(0, t, {
      ais: e.contextValue,
      multiIndexContext: e.indexContextValue
    });
  },
  getSearchParameters: function (e, t, r) {
    return e.setQuery(TJ(t, r, {
      ais: t.contextValue,
      multiIndexContext: t.indexContextValue
    }));
  },
  getMetadata: function (e, t) {
    var r = "query",
      n = TJ(e, t, {
        ais: e.contextValue,
        multiIndexContext: e.indexContextValue
      });
    return {
      id: r,
      index: rG({
        ais: e.contextValue,
        multiIndexContext: e.indexContextValue
      }),
      items: null === n ? [] : [{
        label: "".concat(r, ": ").concat(n),
        value: function (t) {
          return HJ(0, t, "", {
            ais: e.contextValue,
            multiIndexContext: e.indexContextValue
          });
        },
        currentRefinement: n
      }]
    };
  }
});
function IJ(e) {
  return IJ = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, IJ(e);
}
function FJ(e, t, r) {
  return (t = function (e) {
    var t = function (e, t) {
      if ("object" !== IJ(e) || null === e) return e;
      var r = e[Symbol.toPrimitive];
      if (void 0 !== r) {
        var n = r.call(e, t || "default");
        if ("object" !== IJ(n)) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === t ? String : Number)(e);
    }(e, "string");
    return "symbol" === IJ(t) ? t : String(t);
  }(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
var _J = IQ({
  displayName: "AlgoliaRelevantSort",
  $$type: "ais.relevantSort",
  getProvidedProps: function (e, t, r) {
    var n = nG(r, {
      ais: e.contextValue,
      multiIndexContext: e.indexContextValue
    });
    return n ? {
      isVirtualReplica: void 0 !== n.appliedRelevancyStrictness,
      isRelevantSorted: void 0 !== n.appliedRelevancyStrictness && n.appliedRelevancyStrictness > 0
    } : {
      isVirtualReplica: !1,
      isRelevantSorted: !1
    };
  },
  getSearchParameters: function (e, t, r) {
    return e.setQueryParameter("relevancyStrictness", function (e, t, r) {
      return lG(e, t, r, "relevancyStrictness");
    }(t, r, {
      ais: t.contextValue,
      multiIndexContext: t.indexContextValue
    }));
  },
  refine: function (e, t, r) {
    return oG(t, FJ({}, "relevancyStrictness", r), {
      ais: e.contextValue,
      multiIndexContext: e.indexContextValue
    }, !0);
  }
});
function ZJ(e) {
  return ZJ = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, ZJ(e);
}
function DJ(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function qJ(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? DJ(Object(r), !0).forEach(function (t) {
      UJ(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : DJ(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
function UJ(e, t, r) {
  return (t = function (e) {
    var t = function (e, t) {
      if ("object" !== ZJ(e) || null === e) return e;
      var r = e[Symbol.toPrimitive];
      if (void 0 !== r) {
        var n = r.call(e, t || "default");
        if ("object" !== ZJ(n)) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === t ? String : Number)(e);
    }(e, "string");
    return "symbol" === ZJ(t) ? t : String(t);
  }(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function $J(e, t, r) {
  var n = lG(e, t, r, "sortBy", null);
  return n || null;
}
var zJ = IQ({
    displayName: "AlgoliaSortBy",
    $$type: "ais.sortBy",
    propTypes: {
      defaultRefinement: se.string,
      items: se.arrayOf(se.shape({
        label: se.string,
        value: se.string.isRequired
      })).isRequired,
      transformItems: se.func
    },
    getProvidedProps: function (e, t) {
      var r = $J(e, t, {
          ais: e.contextValue,
          multiIndexContext: e.indexContextValue
        }),
        n = e.items.map(function (e) {
          return e.value === r ? qJ(qJ({}, e), {}, {
            isRefined: !0
          }) : qJ(qJ({}, e), {}, {
            isRefined: !1
          });
        });
      return {
        items: e.transformItems ? e.transformItems(n) : n,
        currentRefinement: r
      };
    },
    refine: function (e, t, r) {
      return oG(t, UJ({}, "sortBy", r), {
        ais: e.contextValue,
        multiIndexContext: e.indexContextValue
      }, !0);
    },
    cleanUp: function (e, t) {
      return sG(t, {
        ais: e.contextValue,
        multiIndexContext: e.indexContextValue
      }, "sortBy");
    },
    getSearchParameters: function (e, t, r) {
      var n = $J(t, r, {
        ais: t.contextValue,
        multiIndexContext: t.indexContextValue
      });
      return e.setIndex(n);
    },
    getMetadata: function () {
      return {
        id: "sortBy"
      };
    }
  }),
  WJ = IQ({
    displayName: "AlgoliaStateResults",
    $$type: "ais.stateResults",
    getProvidedProps: function (e, t, r) {
      return {
        searchState: t,
        searchResults: nG(r, {
          ais: e.contextValue,
          multiIndexContext: e.indexContextValue
        }),
        allSearchResults: r.results,
        searching: r.searching,
        isSearchStalled: r.isSearchStalled,
        error: r.error,
        searchingForFacetValues: r.searchingForFacetValues,
        props: e
      };
    }
  }),
  QJ = IQ({
    displayName: "AlgoliaStats",
    $$type: "ais.stats",
    getProvidedProps: function (e, t, r) {
      var n = nG(r, {
        ais: e.contextValue,
        multiIndexContext: e.indexContextValue
      });
      return n ? {
        areHitsSorted: void 0 !== n.appliedRelevancyStrictness && n.appliedRelevancyStrictness > 0 && n.nbHits !== n.nbSortedHits,
        nbHits: n.nbHits,
        nbSortedHits: n.nbSortedHits,
        processingTimeMS: n.processingTimeMS
      } : null;
    }
  });
function GJ(e) {
  return GJ = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, GJ(e);
}
function YJ(e, t, r) {
  return (t = function (e) {
    var t = function (e, t) {
      if ("object" !== GJ(e) || null === e) return e;
      var r = e[Symbol.toPrimitive];
      if (void 0 !== r) {
        var n = r.call(e, t || "default");
        if ("object" !== GJ(n)) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === t ? String : Number)(e);
    }(e, "string");
    return "symbol" === GJ(t) ? t : String(t);
  }(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function KJ(e) {
  return e.attribute;
}
var XJ = "toggle",
  JJ = ["0", "false", "null", "undefined"];
function e1(e, t, r) {
  var n = lG(e, t, r, "".concat(XJ, ".").concat(KJ(e)), !1);
  return -1 === JJ.indexOf(n) && Boolean(n);
}
function t1(e, t, r, n) {
  return oG(t, YJ({}, KJ(e), r || !1), n, !0, XJ);
}
var r1 = IQ({
  displayName: "AlgoliaToggle",
  $$type: "ais.toggle",
  propTypes: {
    label: se.string.isRequired,
    attribute: se.string.isRequired,
    value: se.any.isRequired,
    filter: se.func,
    defaultRefinement: se.bool
  },
  getProvidedProps: function (e, t, r) {
    var n = e.attribute,
      a = e.value,
      o = nG(r, {
        ais: e.contextValue,
        multiIndexContext: e.indexContextValue
      }),
      i = e1(e, t, {
        ais: e.contextValue,
        multiIndexContext: e.indexContextValue
      }),
      l = o && o.getFacetByName(n) ? o.getFacetValues(n) : null,
      s = l && l.length ? fQ(l, function (e) {
        return e.name === a.toString();
      }) : null,
      c = s && s.count,
      u = l && l.length ? l.reduce(function (e, t) {
        return e + t.count;
      }, 0) : null;
    return {
      currentRefinement: i,
      canRefine: i ? null !== u && u > 0 : null !== c && c > 0,
      count: {
        checked: u,
        unchecked: c
      }
    };
  },
  refine: function (e, t, r) {
    return t1(e, t, r, {
      ais: e.contextValue,
      multiIndexContext: e.indexContextValue
    });
  },
  cleanUp: function (e, t) {
    return function (e, t, r) {
      return sG(t, r, "".concat(XJ, ".").concat(KJ(e)));
    }(e, t, {
      ais: e.contextValue,
      multiIndexContext: e.indexContextValue
    });
  },
  getSearchParameters: function (e, t, r) {
    var n = t.attribute,
      a = t.value,
      o = t.filter,
      i = e1(t, r, {
        ais: t.contextValue,
        multiIndexContext: t.indexContextValue
      }),
      l = e.addDisjunctiveFacet(n);
    return i && (l = l.addDisjunctiveFacetRefinement(n, a), o && (l = o(l))), l;
  },
  getMetadata: function (e, t) {
    var r = KJ(e),
      n = e1(e, t, {
        ais: e.contextValue,
        multiIndexContext: e.indexContextValue
      }),
      a = [],
      o = rG({
        ais: e.contextValue,
        multiIndexContext: e.indexContextValue
      });
    return n && a.push({
      label: e.label,
      currentRefinement: n,
      attribute: e.attribute,
      value: function (t) {
        return t1(e, t, !1, {
          ais: e.contextValue,
          multiIndexContext: e.indexContextValue
        });
      }
    }), {
      id: r,
      index: o,
      items: a
    };
  }
});
function n1(e) {
  return n1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, n1(e);
}
function a1(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function o1(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? a1(Object(r), !0).forEach(function (t) {
      i1(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : a1(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
function i1(e, t, r) {
  return (t = function (e) {
    var t = function (e, t) {
      if ("object" !== n1(e) || null === e) return e;
      var r = e[Symbol.toPrimitive];
      if (void 0 !== r) {
        var n = r.call(e, t || "default");
        if ("object" !== n1(n)) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === t ? String : Number)(e);
    }(e, "string");
    return "symbol" === n1(t) ? t : String(t);
  }(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function l1(e, t, r) {
  var n = lG(e, t, r, "query", "");
  return n || "";
}
function s1(e, t, r, n) {
  var a,
    o = e.language ? {
      queryLanguages: [e.language.split("-")[0]]
    } : {},
    i = "function" == typeof e.additionalQueryParameters ? o1({
      ignorePlurals: !0,
      removeStopWords: !0,
      optionalWords: r
    }, e.additionalQueryParameters({
      query: r
    })) : {};
  return oG(t, (i1(a = {}, "query", r), i1(a, "additionalVoiceParameters", o1(o1({}, o), i)), a), n, !0);
}
var c1,
  u1 = IQ({
    displayName: "AlgoliaVoiceSearch",
    $$type: "ais.voiceSearch",
    propTypes: {
      defaultRefinement: se.string
    },
    getProvidedProps: function (e, t, r) {
      return {
        currentRefinement: l1(e, t, {
          ais: e.contextValue,
          multiIndexContext: e.indexContextValue
        }),
        isSearchStalled: r.isSearchStalled
      };
    },
    refine: function (e, t, r) {
      return s1(e, t, r, {
        ais: e.contextValue,
        multiIndexContext: e.indexContextValue
      });
    },
    cleanUp: function (e, t) {
      return function (e, t, r) {
        var n = sG(t, r, "query");
        return sG(n, r, "additionalVoiceParameters");
      }(0, t, {
        ais: e.contextValue,
        multiIndexContext: e.indexContextValue
      });
    },
    getSearchParameters: function (e, t, r) {
      var n = l1(t, r, {
          ais: t.contextValue,
          multiIndexContext: t.indexContextValue
        }),
        a = function (e, t, r) {
          var n = lG(e, t, r, "additionalVoiceParameters", "");
          return n || {};
        }(t, r, {
          ais: t.contextValue,
          multiIndexContext: t.indexContextValue
        });
      return e.setQuery(n).setQueryParameters(a);
    },
    getMetadata: function (e, t) {
      var r = "query",
        n = l1(e, t, {
          ais: e.contextValue,
          multiIndexContext: e.indexContextValue
        });
      return {
        id: r,
        index: rG({
          ais: e.contextValue,
          multiIndexContext: e.indexContextValue
        }),
        items: null === n ? [] : [{
          label: "".concat(r, ": ").concat(n),
          value: function (t) {
            return s1(e, t, "", {
              ais: e.contextValue,
              multiIndexContext: e.indexContextValue
            });
          },
          currentRefinement: n
        }]
      };
    }
  }),
  h1 = {
    exports: {}
  };
c1 = h1, function () {
  var e = {}.hasOwnProperty;
  function t() {
    for (var r = [], n = 0; n < arguments.length; n++) {
      var a = arguments[n];
      if (a) {
        var o = typeof a;
        if ("string" === o || "number" === o) r.push(a);else if (Array.isArray(a)) {
          if (a.length) {
            var i = t.apply(null, a);
            i && r.push(i);
          }
        } else if ("object" === o) {
          if (a.toString !== Object.prototype.toString && !a.toString.toString().includes("[native code]")) {
            r.push(a.toString());
            continue;
          }
          for (var l in a) e.call(a, l) && a[l] && r.push(l);
        }
      }
    }
    return r.join(" ");
  }
  c1.exports ? (t.default = t, c1.exports = t) : window.classNames = t;
}();
var m1 = T(h1.exports);
function p1(e) {
  return function (e) {
    if (Array.isArray(e)) return f1(e);
  }(e) || function (e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
  }(e) || function (e, t) {
    if (!e) return;
    if ("string" == typeof e) return f1(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    "Object" === r && e.constructor && (r = e.constructor.name);
    if ("Map" === r || "Set" === r) return Array.from(e);
    if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return f1(e, t);
  }(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function f1(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
var d1 = function (e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "ais";
    return function () {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++) n[a] = arguments[a];
      var o = n.filter(function (e) {
        return e || "" === e;
      }).map(function (r) {
        var n = "".concat(t, "-").concat(e);
        return r ? "".concat(n, "-").concat(r) : n;
      });
      return m1(o);
    };
  },
  v1 = function (e) {
    return 0 === e.length ? "" : "".concat(e[0].toUpperCase()).concat(e.slice(1));
  };
function g1(e) {
  var t = e.start,
    r = void 0 === t ? 0 : t,
    n = e.end,
    a = e.step,
    o = void 0 === a ? 1 : a,
    i = 0 === o ? 1 : o,
    l = Math.round((n - r) / i);
  return p1(Array(l)).map(function (e, t) {
    return (r + t) * i;
  });
}
function b1(e, t) {
  if (Array.isArray(e)) for (var r = 0; r < e.length; r++) if (t(e[r])) return e[r];
}
function w1(e) {
  return w1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, w1(e);
}
function y1(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, P1(n.key), n);
  }
}
function x1(e, t) {
  return x1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
    return e.__proto__ = t, e;
  }, x1(e, t);
}
function O1(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = j1(e);
    if (t) {
      var a = j1(this).constructor;
      r = Reflect.construct(n, arguments, a);
    } else r = n.apply(this, arguments);
    return function (e, t) {
      if (t && ("object" === w1(t) || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return E1(e);
    }(this, r);
  };
}
function E1(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function j1(e) {
  return j1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, j1(e);
}
function C1(e, t, r) {
  return (t = P1(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function P1(e) {
  var t = function (e, t) {
    if ("object" !== w1(e) || null === e) return e;
    var r = e[Symbol.toPrimitive];
    if (void 0 !== r) {
      var n = r.call(e, t || "default");
      if ("object" !== w1(n)) return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === t ? String : Number)(e);
  }(e, "string");
  return "symbol" === w1(t) ? t : String(t);
}
var M1 = d1("Panel"),
  k1 = o(function () {}),
  S1 = k1.Consumer,
  N1 = k1.Provider,
  B1 = function (e) {
    !function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t && x1(e, t);
    }(l, i);
    var r,
      n,
      a,
      o = O1(l);
    function l() {
      var e;
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, l);
      for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++) r[n] = arguments[n];
      return C1(E1(e = o.call.apply(o, [this].concat(r))), "state", {
        canRefine: !0
      }), C1(E1(e), "setCanRefine", function (t) {
        e.setState({
          canRefine: t
        });
      }), e;
    }
    return r = l, n = [{
      key: "render",
      value: function () {
        var e = this.props,
          r = e.children,
          n = e.className,
          a = e.header,
          o = e.footer,
          i = this.state.canRefine;
        return t.createElement("div", {
          className: m1(M1("", !i && "-noRefinement"), n)
        }, a && t.createElement("div", {
          className: M1("header")
        }, a), t.createElement("div", {
          className: M1("body")
        }, t.createElement(N1, {
          value: this.setCanRefine
        }, r)), o && t.createElement("div", {
          className: M1("footer")
        }, o));
      }
    }], n && y1(r.prototype, n), a && y1(r, a), Object.defineProperty(r, "prototype", {
      writable: !1
    }), l;
  }();
function V1(e) {
  return V1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, V1(e);
}
function R1(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, L1(n.key), n);
  }
}
function A1(e, t) {
  return A1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
    return e.__proto__ = t, e;
  }, A1(e, t);
}
function T1(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = H1(e);
    if (t) {
      var a = H1(this).constructor;
      r = Reflect.construct(n, arguments, a);
    } else r = n.apply(this, arguments);
    return function (e, t) {
      if (t && ("object" === V1(t) || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }(this, r);
  };
}
function H1(e) {
  return H1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, H1(e);
}
function L1(e) {
  var t = function (e, t) {
    if ("object" !== V1(e) || null === e) return e;
    var r = e[Symbol.toPrimitive];
    if (void 0 !== r) {
      var n = r.call(e, t || "default");
      if ("object" !== V1(n)) return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === t ? String : Number)(e);
  }(e, "string");
  return "symbol" === V1(t) ? t : String(t);
}
C1(B1, "propTypes", {
  children: se.node.isRequired,
  className: se.string,
  header: se.node,
  footer: se.node
}), C1(B1, "defaultProps", {
  className: "",
  header: null,
  footer: null
});
var I1,
  F1,
  _1,
  Z1 = function (e) {
    !function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t && A1(e, t);
    }(o, i);
    var t,
      r,
      n,
      a = T1(o);
    function o() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, o), a.apply(this, arguments);
    }
    return t = o, (r = [{
      key: "componentDidMount",
      value: function () {
        this.props.setCanRefine(this.props.canRefine);
      }
    }, {
      key: "componentDidUpdate",
      value: function (e) {
        e.canRefine !== this.props.canRefine && this.props.setCanRefine(this.props.canRefine);
      }
    }, {
      key: "render",
      value: function () {
        return this.props.children;
      }
    }]) && R1(t.prototype, r), n && R1(t, n), Object.defineProperty(t, "prototype", {
      writable: !1
    }), o;
  }();
I1 = Z1, F1 = "propTypes", _1 = {
  children: se.node.isRequired,
  canRefine: se.bool.isRequired,
  setCanRefine: se.func.isRequired
}, (F1 = L1(F1)) in I1 ? Object.defineProperty(I1, F1, {
  value: _1,
  enumerable: !0,
  configurable: !0,
  writable: !0
}) : I1[F1] = _1;
var D1 = function (e) {
  var r = e.canRefine,
    n = e.children;
  return t.createElement(S1, null, function (e) {
    return t.createElement(Z1, {
      setCanRefine: e,
      canRefine: r
    }, n);
  });
};
function q1(e) {
  return q1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, q1(e);
}
function U1() {
  return U1 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, U1.apply(this, arguments);
}
function $1(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, K1(n.key), n);
  }
}
function z1(e, t) {
  return z1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
    return e.__proto__ = t, e;
  }, z1(e, t);
}
function W1(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = G1(e);
    if (t) {
      var a = G1(this).constructor;
      r = Reflect.construct(n, arguments, a);
    } else r = n.apply(this, arguments);
    return function (e, t) {
      if (t && ("object" === q1(t) || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return Q1(e);
    }(this, r);
  };
}
function Q1(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function G1(e) {
  return G1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, G1(e);
}
function Y1(e, t, r) {
  return (t = K1(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function K1(e) {
  var t = function (e, t) {
    if ("object" !== q1(e) || null === e) return e;
    var r = e[Symbol.toPrimitive];
    if (void 0 !== r) {
      var n = r.call(e, t || "default");
      if ("object" !== q1(n)) return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === t ? String : Number)(e);
  }(e, "string");
  return "symbol" === q1(t) ? t : String(t);
}
D1.propTypes = {
  canRefine: se.bool.isRequired,
  children: se.node.isRequired
};
var X1 = function (e) {
  !function (e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), Object.defineProperty(e, "prototype", {
      writable: !1
    }), t && z1(e, t);
  }(l, i);
  var r,
    n,
    a,
    o = W1(l);
  function l() {
    var e;
    !function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }(this, l);
    for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++) r[n] = arguments[n];
    return Y1(Q1(e = o.call.apply(o, [this].concat(r))), "onClick", function (t) {
      var r, n;
      (n = 1 === (r = t).button, Boolean(n || r.altKey || r.ctrlKey || r.metaKey || r.shiftKey)) || (e.props.onClick(), t.preventDefault());
    }), e;
  }
  return r = l, (n = [{
    key: "render",
    value: function () {
      return t.createElement("a", U1({}, this.props, {
        onClick: this.onClick
      }));
    }
  }]) && $1(r.prototype, n), a && $1(r, a), Object.defineProperty(r, "prototype", {
    writable: !1
  }), l;
}();
function J1(e) {
  return J1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, J1(e);
}
function e0(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, o0(n.key), n);
  }
}
function t0(e, t) {
  return t0 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
    return e.__proto__ = t, e;
  }, t0(e, t);
}
function r0(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = n0(e);
    if (t) {
      var a = n0(this).constructor;
      r = Reflect.construct(n, arguments, a);
    } else r = n.apply(this, arguments);
    return function (e, t) {
      if (t && ("object" === J1(t) || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }(this, r);
  };
}
function n0(e) {
  return n0 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, n0(e);
}
function a0(e, t, r) {
  return (t = o0(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function o0(e) {
  var t = function (e, t) {
    if ("object" !== J1(e) || null === e) return e;
    var r = e[Symbol.toPrimitive];
    if (void 0 !== r) {
      var n = r.call(e, t || "default");
      if ("object" !== J1(n)) return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === t ? String : Number)(e);
  }(e, "string");
  return "symbol" === J1(t) ? t : String(t);
}
Y1(X1, "propTypes", {
  onClick: se.func.isRequired
});
var i0 = d1("Breadcrumb"),
  l0 = se.arrayOf(se.shape({
    label: se.string.isRequired,
    value: se.string.isRequired
  })),
  s0 = function (e) {
    !function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t && t0(e, t);
    }(l, i);
    var r,
      n,
      a,
      o = r0(l);
    function l() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, l), o.apply(this, arguments);
    }
    return r = l, (n = [{
      key: "render",
      value: function () {
        var e = this.props,
          r = e.canRefine,
          n = e.createURL,
          a = e.items,
          o = e.refine,
          i = e.rootURL,
          l = e.separator,
          s = e.translate,
          c = e.className,
          u = r ? t.createElement("li", {
            className: i0("item")
          }, t.createElement(X1, {
            className: i0("link"),
            onClick: function () {
              return i ? null : o();
            },
            href: i || n()
          }, s("rootLabel"))) : null,
          h = a.map(function (e, r) {
            var i = r === a.length - 1;
            return t.createElement("li", {
              className: i0("item", i && "item--selected"),
              key: r
            }, t.createElement("span", {
              className: i0("separator")
            }, l), i ? e.label : t.createElement(X1, {
              className: i0("link"),
              onClick: function () {
                return o(e.value);
              },
              href: n(e.value)
            }, e.label));
          });
        return t.createElement("div", {
          className: m1(i0("", !r && "-noRefinement"), c)
        }, t.createElement("ul", {
          className: i0("list")
        }, u, h));
      }
    }]) && e0(r.prototype, n), a && e0(r, a), Object.defineProperty(r, "prototype", {
      writable: !1
    }), l;
  }();
a0(s0, "propTypes", {
  canRefine: se.bool.isRequired,
  createURL: se.func.isRequired,
  items: l0,
  refine: se.func.isRequired,
  rootURL: se.string,
  separator: se.node,
  translate: se.func.isRequired,
  className: se.string
}), a0(s0, "defaultProps", {
  rootURL: null,
  separator: " > ",
  className: ""
});
var c0 = KQ({
  rootLabel: "Home"
})(s0);
function u0(e) {
  return u0 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, u0(e);
}
function h0(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, v0(n.key), n);
  }
}
function m0(e, t) {
  return m0 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
    return e.__proto__ = t, e;
  }, m0(e, t);
}
function p0(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = f0(e);
    if (t) {
      var a = f0(this).constructor;
      r = Reflect.construct(n, arguments, a);
    } else r = n.apply(this, arguments);
    return function (e, t) {
      if (t && ("object" === u0(t) || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }(this, r);
  };
}
function f0(e) {
  return f0 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, f0(e);
}
function d0(e, t, r) {
  return (t = v0(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function v0(e) {
  var t = function (e, t) {
    if ("object" !== u0(e) || null === e) return e;
    var r = e[Symbol.toPrimitive];
    if (void 0 !== r) {
      var n = r.call(e, t || "default");
      if ("object" !== u0(n)) return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === t ? String : Number)(e);
  }(e, "string");
  return "symbol" === u0(t) ? t : String(t);
}
nX(function (e) {
  return t.createElement(D1, e, t.createElement(c0, e));
}, {
  $$widgetType: "ais.breadcrumb"
});
var g0 = d1("ClearRefinements"),
  b0 = function (e) {
    !function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t && m0(e, t);
    }(l, i);
    var r,
      n,
      a,
      o = p0(l);
    function l() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, l), o.apply(this, arguments);
    }
    return r = l, (n = [{
      key: "render",
      value: function () {
        var e = this.props,
          r = e.items,
          n = e.canRefine,
          a = e.refine,
          o = e.translate,
          i = e.className;
        return t.createElement("div", {
          className: m1(g0(""), i)
        }, t.createElement("button", {
          className: g0("button", !n && "button--disabled"),
          onClick: function () {
            return a(r);
          },
          disabled: !n
        }, o("reset")));
      }
    }]) && h0(r.prototype, n), a && h0(r, a), Object.defineProperty(r, "prototype", {
      writable: !1
    }), l;
  }();
d0(b0, "propTypes", {
  items: se.arrayOf(se.object).isRequired,
  canRefine: se.bool.isRequired,
  refine: se.func.isRequired,
  translate: se.func.isRequired,
  className: se.string
}), d0(b0, "defaultProps", {
  className: ""
});
var w0 = KQ({
  reset: "Clear all filters"
})(b0);
sX(function (e) {
  return t.createElement(D1, e, t.createElement(w0, e));
}, {
  $$widgetType: "ais.clearRefinements"
});
var y0 = d1("CurrentRefinements"),
  x0 = function (e) {
    var r = e.items,
      n = e.canRefine,
      a = e.refine,
      o = e.translate,
      i = e.className;
    return t.createElement("div", {
      className: m1(y0("", !n && "-noRefinement"), i)
    }, t.createElement("ul", {
      className: y0("list", !n && "list--noRefinement")
    }, r.map(function (e) {
      return t.createElement("li", {
        key: e.label,
        className: y0("item")
      }, t.createElement("span", {
        className: y0("label")
      }, e.label), e.items ? e.items.map(function (e) {
        return t.createElement("span", {
          key: e.label,
          className: y0("category")
        }, t.createElement("span", {
          className: y0("categoryLabel")
        }, e.label), t.createElement("button", {
          className: y0("delete"),
          onClick: function () {
            return a(e.value);
          }
        }, o("clearFilter", e)));
      }) : t.createElement("span", {
        className: y0("category")
      }, t.createElement("button", {
        className: y0("delete"),
        onClick: function () {
          return a(e.value);
        }
      }, o("clearFilter", e))));
    })));
  },
  O0 = se.arrayOf(se.shape({
    label: se.string.isRequired,
    value: se.func.isRequired,
    items: function () {
      return O0.apply(void 0, arguments);
    }
  }));
x0.propTypes = {
  items: O0.isRequired,
  canRefine: se.bool.isRequired,
  refine: se.func.isRequired,
  translate: se.func.isRequired,
  className: se.string
}, x0.defaultProps = {
  className: ""
};
var E0 = KQ({
  clearFilter: "✕"
})(x0);
function j0(e) {
  return j0 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, j0(e);
}
function C0() {
  return C0 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, C0.apply(this, arguments);
}
function P0(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function M0(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? P0(Object(r), !0).forEach(function (t) {
      R0(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : P0(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
function k0(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, A0(n.key), n);
  }
}
function S0(e, t) {
  return S0 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
    return e.__proto__ = t, e;
  }, S0(e, t);
}
function N0(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = V0(e);
    if (t) {
      var a = V0(this).constructor;
      r = Reflect.construct(n, arguments, a);
    } else r = n.apply(this, arguments);
    return function (e, t) {
      if (t && ("object" === j0(t) || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return B0(e);
    }(this, r);
  };
}
function B0(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function V0(e) {
  return V0 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, V0(e);
}
function R0(e, t, r) {
  return (t = A0(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function A0(e) {
  var t = function (e, t) {
    if ("object" !== j0(e) || null === e) return e;
    var r = e[Symbol.toPrimitive];
    if (void 0 !== r) {
      var n = r.call(e, t || "default");
      if ("object" !== j0(n)) return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === t ? String : Number)(e);
  }(e, "string");
  return "symbol" === j0(t) ? t : String(t);
}
sX(function (e) {
  return t.createElement(D1, e, t.createElement(E0, e));
}, {
  $$widgetType: "ais.currentRefinements"
});
var T0 = d1("SearchBox"),
  H0 = t.createElement("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 38 38",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#444",
    className: T0("loadingIcon"),
    "aria-hidden": "true"
  }, t.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, t.createElement("g", {
    transform: "translate(1 1)",
    strokeWidth: "2"
  }, t.createElement("circle", {
    strokeOpacity: ".5",
    cx: "18",
    cy: "18",
    r: "18"
  }), t.createElement("path", {
    d: "M36 18c0-9.94-8.06-18-18-18"
  }, t.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 18 18",
    to: "360 18 18",
    dur: "1s",
    repeatCount: "indefinite"
  }))))),
  L0 = t.createElement("svg", {
    className: T0("resetIcon"),
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    width: "10",
    height: "10",
    "aria-hidden": "true"
  }, t.createElement("path", {
    d: "M8.114 10L.944 2.83 0 1.885 1.886 0l.943.943L10 8.113l7.17-7.17.944-.943L20 1.886l-.943.943-7.17 7.17 7.17 7.17.943.944L18.114 20l-.943-.943-7.17-7.17-7.17 7.17-.944.943L0 18.114l.943-.943L8.113 10z"
  })),
  I0 = t.createElement("svg", {
    className: T0("submitIcon"),
    xmlns: "http://www.w3.org/2000/svg",
    width: "10",
    height: "10",
    viewBox: "0 0 40 40",
    "aria-hidden": "true"
  }, t.createElement("path", {
    d: "M26.804 29.01c-2.832 2.34-6.465 3.746-10.426 3.746C7.333 32.756 0 25.424 0 16.378 0 7.333 7.333 0 16.378 0c9.046 0 16.378 7.333 16.378 16.378 0 3.96-1.406 7.594-3.746 10.426l10.534 10.534c.607.607.61 1.59-.004 2.202-.61.61-1.597.61-2.202.004L26.804 29.01zm-10.426.627c7.323 0 13.26-5.936 13.26-13.26 0-7.32-5.937-13.257-13.26-13.257C9.056 3.12 3.12 9.056 3.12 16.378c0 7.323 5.936 13.26 13.258 13.26z"
  })),
  F0 = function (e) {
    !function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t && S0(e, t);
    }(l, i);
    var r,
      n,
      a,
      o = N0(l);
    function l(e) {
      var t;
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, l), R0(B0(t = o.call(this)), "getQuery", function () {
        return t.props.searchAsYouType ? t.props.currentRefinement : t.state.query;
      }), R0(B0(t), "onInputMount", function (e) {
        t.input = e, t.props.inputRef && ("function" == typeof t.props.inputRef ? t.props.inputRef(e) : t.props.inputRef.current = e);
      }), R0(B0(t), "onKeyDown", function (e) {
        if (t.props.focusShortcuts) {
          var r = t.props.focusShortcuts.map(function (e) {
              return "string" == typeof e ? e.toUpperCase().charCodeAt(0) : e;
            }),
            n = e.target || e.srcElement,
            a = n.tagName;
          if (!n.isContentEditable && "INPUT" !== a && "SELECT" !== a && "TEXTAREA" !== a) {
            var o = e.which || e.keyCode;
            -1 !== r.indexOf(o) && (t.input.focus(), e.stopPropagation(), e.preventDefault());
          }
        }
      }), R0(B0(t), "onSubmit", function (e) {
        e.preventDefault(), e.stopPropagation(), t.input.blur();
        var r = t.props,
          n = r.refine;
        return r.searchAsYouType || n(t.getQuery()), !1;
      }), R0(B0(t), "onChange", function (e) {
        var r = t.props,
          n = r.searchAsYouType,
          a = r.refine,
          o = r.onChange,
          i = e.target.value;
        n ? a(i) : t.setState({
          query: i
        }), o && o(e);
      }), R0(B0(t), "onReset", function (e) {
        var r = t.props,
          n = r.searchAsYouType,
          a = r.refine,
          o = r.onReset;
        a(""), t.input.focus(), n || t.setState({
          query: ""
        }), o && o(e);
      }), t.state = {
        query: e.searchAsYouType ? null : e.currentRefinement
      }, t;
    }
    return r = l, (n = [{
      key: "componentDidMount",
      value: function () {
        document.addEventListener("keydown", this.onKeyDown);
      }
    }, {
      key: "componentWillUnmount",
      value: function () {
        document.removeEventListener("keydown", this.onKeyDown);
      }
    }, {
      key: "componentDidUpdate",
      value: function (e) {
        this.props.searchAsYouType || e.currentRefinement === this.props.currentRefinement || this.setState({
          query: this.props.currentRefinement
        });
      }
    }, {
      key: "render",
      value: function () {
        var e = this,
          r = this.props,
          n = r.className,
          a = r.inputId,
          o = r.translate,
          i = r.autoFocus,
          l = r.loadingIndicator,
          s = r.submit,
          c = r.reset,
          u = this.getQuery(),
          h = Object.keys(this.props).reduce(function (t, r) {
            return -1 === ["onsubmit", "onreset", "onchange"].indexOf(r.toLowerCase()) && 0 === r.indexOf("on") ? M0(M0({}, t), {}, R0({}, r, e.props[r])) : t;
          }, {}),
          m = this.props.showLoadingIndicator && this.props.isSearchStalled;
        return t.createElement("div", {
          className: m1(T0(""), n)
        }, t.createElement("form", {
          ref: this.props.formRef,
          noValidate: !0,
          onSubmit: this.props.onSubmit ? this.props.onSubmit : this.onSubmit,
          onReset: this.onReset,
          className: T0("form", m && "form--stalledSearch"),
          action: "",
          role: "search"
        }, t.createElement("input", C0({
          ref: this.onInputMount,
          id: a,
          type: "search",
          placeholder: o("placeholder"),
          autoFocus: i,
          autoComplete: "off",
          autoCorrect: "off",
          autoCapitalize: "off",
          spellCheck: "false",
          required: !0,
          maxLength: "512",
          value: u,
          onChange: this.onChange
        }, h, {
          className: T0("input")
        })), t.createElement("button", {
          type: "submit",
          title: o("submitTitle"),
          className: T0("submit")
        }, s), t.createElement("button", {
          type: "reset",
          title: o("resetTitle"),
          className: T0("reset"),
          hidden: !u || m
        }, c), this.props.showLoadingIndicator && t.createElement("span", {
          hidden: !m,
          className: T0("loadingIndicator")
        }, l)));
      }
    }]) && k0(r.prototype, n), a && k0(r, a), Object.defineProperty(r, "prototype", {
      writable: !1
    }), l;
  }();
R0(F0, "propTypes", {
  currentRefinement: se.string,
  className: se.string,
  refine: se.func.isRequired,
  translate: se.func.isRequired,
  loadingIndicator: se.node,
  reset: se.node,
  submit: se.node,
  focusShortcuts: se.arrayOf(se.oneOfType([se.string, se.number])),
  autoFocus: se.bool,
  searchAsYouType: se.bool,
  onSubmit: se.func,
  onReset: se.func,
  onChange: se.func,
  isSearchStalled: se.bool,
  showLoadingIndicator: se.bool,
  formRef: se.oneOfType([se.func, se.exact({
    current: se.object
  })]),
  inputRef: se.oneOfType([se.func, se.exact({
    current: se.object
  })]),
  inputId: se.string
}), R0(F0, "defaultProps", {
  currentRefinement: "",
  className: "",
  focusShortcuts: ["s", "/"],
  autoFocus: !1,
  searchAsYouType: !0,
  showLoadingIndicator: !1,
  isSearchStalled: !1,
  loadingIndicator: H0,
  reset: L0,
  submit: I0
});
var _0 = KQ({
  resetTitle: "Clear the search query.",
  submitTitle: "Submit your search query.",
  placeholder: "Search here…"
})(F0);
function Z0(e) {
  return Z0 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Z0(e);
}
function D0(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Q0(n.key), n);
  }
}
function q0(e, t) {
  return q0 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
    return e.__proto__ = t, e;
  }, q0(e, t);
}
function U0(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = z0(e);
    if (t) {
      var a = z0(this).constructor;
      r = Reflect.construct(n, arguments, a);
    } else r = n.apply(this, arguments);
    return function (e, t) {
      if (t && ("object" === Z0(t) || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return $0(e);
    }(this, r);
  };
}
function $0(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function z0(e) {
  return z0 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, z0(e);
}
function W0(e, t, r) {
  return (t = Q0(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function Q0(e) {
  var t = function (e, t) {
    if ("object" !== Z0(e) || null === e) return e;
    var r = e[Symbol.toPrimitive];
    if (void 0 !== r) {
      var n = r.call(e, t || "default");
      if ("object" !== Z0(n)) return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === t ? String : Number)(e);
  }(e, "string");
  return "symbol" === Z0(t) ? t : String(t);
}
var G0 = se.arrayOf(se.shape({
    value: se.any,
    label: se.node.isRequired,
    items: function () {
      return G0.apply(void 0, arguments);
    }
  })),
  Y0 = function (e) {
    !function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t && q0(e, t);
    }(l, i);
    var r,
      n,
      a,
      o = U0(l);
    function l() {
      var e;
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, l), W0($0(e = o.call(this)), "onShowMoreClick", function () {
        e.setState(function (e) {
          return {
            extended: !e.extended
          };
        });
      }), W0($0(e), "getLimit", function () {
        var t = e.props,
          r = t.limit,
          n = t.showMoreLimit;
        return e.state.extended ? n : r;
      }), W0($0(e), "resetQuery", function () {
        e.setState({
          query: ""
        });
      }), W0($0(e), "renderItem", function (r, n) {
        var a = r.items && Boolean(r.items.length);
        return t.createElement("li", {
          key: r.key || r.label,
          className: e.props.cx("item", r.isRefined && "item--selected", r.noRefinement && "item--noRefinement", a && "item--parent")
        }, e.props.renderItem(r, n), a && t.createElement("ul", {
          className: e.props.cx("list", "list--child")
        }, r.items.slice(0, e.getLimit()).map(function (t) {
          return e.renderItem(t, r);
        })));
      }), e.state = {
        extended: !1,
        query: ""
      }, e;
    }
    return r = l, n = [{
      key: "renderShowMore",
      value: function () {
        var e = this.props,
          r = e.showMore,
          n = e.translate,
          a = e.cx,
          o = this.state.extended,
          i = this.props.limit >= this.props.items.length;
        return r ? t.createElement("button", {
          disabled: i,
          className: a("showMore", i && "showMore--disabled"),
          onClick: this.onShowMoreClick
        }, n("showMore", o)) : null;
      }
    }, {
      key: "renderSearchBox",
      value: function () {
        var e = this,
          r = this.props,
          n = r.cx,
          a = r.searchForItems,
          o = r.isFromSearch,
          i = r.translate,
          l = r.items,
          s = r.selectItem,
          c = 0 === l.length && "" !== this.state.query ? t.createElement("div", {
            className: n("noResults")
          }, i("noResults")) : null;
        return t.createElement("div", {
          className: n("searchBox")
        }, t.createElement(_0, {
          currentRefinement: this.state.query,
          refine: function (t) {
            e.setState({
              query: t
            }), a(t);
          },
          focusShortcuts: [],
          translate: i,
          onSubmit: function (t) {
            t.preventDefault(), t.stopPropagation(), o && l.length > 0 && s(l[0], e.resetQuery);
          }
        }), c);
      }
    }, {
      key: "render",
      value: function () {
        var e = this,
          r = this.props,
          n = r.cx,
          a = r.items,
          o = r.className,
          i = r.searchable,
          l = r.canRefine,
          s = i ? this.renderSearchBox() : null,
          c = m1(n("", !l && "-noRefinement"), o);
        return 0 === a.length ? t.createElement("div", {
          className: c
        }, s) : t.createElement("div", {
          className: c
        }, s, t.createElement("ul", {
          className: n("list", !l && "list--noRefinement")
        }, a.slice(0, this.getLimit()).map(function (t) {
          return e.renderItem(t, e.resetQuery);
        })), this.renderShowMore());
      }
    }], n && D0(r.prototype, n), a && D0(r, a), Object.defineProperty(r, "prototype", {
      writable: !1
    }), l;
  }();
function K0(e) {
  return K0 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, K0(e);
}
function X0(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, a2(n.key), n);
  }
}
function J0(e, t) {
  return J0 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
    return e.__proto__ = t, e;
  }, J0(e, t);
}
function e2(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = r2(e);
    if (t) {
      var a = r2(this).constructor;
      r = Reflect.construct(n, arguments, a);
    } else r = n.apply(this, arguments);
    return function (e, t) {
      if (t && ("object" === K0(t) || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return t2(e);
    }(this, r);
  };
}
function t2(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function r2(e) {
  return r2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, r2(e);
}
function n2(e, t, r) {
  return (t = a2(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function a2(e) {
  var t = function (e, t) {
    if ("object" !== K0(e) || null === e) return e;
    var r = e[Symbol.toPrimitive];
    if (void 0 !== r) {
      var n = r.call(e, t || "default");
      if ("object" !== K0(n)) return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === t ? String : Number)(e);
  }(e, "string");
  return "symbol" === K0(t) ? t : String(t);
}
W0(Y0, "propTypes", {
  cx: se.func.isRequired,
  translate: se.func,
  items: G0,
  renderItem: se.func.isRequired,
  selectItem: se.func,
  className: se.string,
  showMore: se.bool,
  limit: se.number,
  showMoreLimit: se.number,
  show: se.func,
  searchForItems: se.func,
  searchable: se.bool,
  isFromSearch: se.bool,
  canRefine: se.bool
}), W0(Y0, "defaultProps", {
  className: "",
  isFromSearch: !1
});
var o2 = d1("HierarchicalMenu"),
  i2 = se.arrayOf(se.shape({
    label: se.string.isRequired,
    value: se.string,
    count: se.number.isRequired,
    items: function () {
      return i2.apply(void 0, arguments);
    }
  })),
  l2 = function (e) {
    !function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t && J0(e, t);
    }(l, i);
    var r,
      n,
      a,
      o = e2(l);
    function l() {
      var e;
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, l);
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++) n[a] = arguments[a];
      return n2(t2(e = o.call.apply(o, [this].concat(n))), "renderItem", function (r) {
        var n = e.props,
          a = n.createURL,
          o = n.refine;
        return t.createElement(X1, {
          className: o2("link", r.isRefined && "link--selected"),
          onClick: function () {
            return o(r.value);
          },
          href: a(r.value)
        }, t.createElement("span", {
          className: o2("label")
        }, r.label), " ", t.createElement("span", {
          className: o2("count")
        }, r.count));
      }), e;
    }
    return r = l, (n = [{
      key: "render",
      value: function () {
        var e = this.props,
          r = e.translate,
          n = e.items,
          a = e.showMore,
          o = e.limit,
          i = e.showMoreLimit,
          l = e.canRefine,
          s = e.className;
        return t.createElement(Y0, {
          renderItem: this.renderItem,
          cx: o2,
          translate: r,
          items: n,
          showMore: a,
          limit: o,
          showMoreLimit: i,
          canRefine: l,
          className: s
        });
      }
    }]) && X0(r.prototype, n), a && X0(r, a), Object.defineProperty(r, "prototype", {
      writable: !1
    }), l;
  }();
n2(l2, "propTypes", {
  translate: se.func.isRequired,
  refine: se.func.isRequired,
  createURL: se.func.isRequired,
  canRefine: se.bool.isRequired,
  items: i2,
  showMore: se.bool,
  className: se.string,
  limit: se.number,
  showMoreLimit: se.number,
  transformItems: se.func
}), n2(l2, "defaultProps", {
  className: ""
});
var s2 = KQ({
  showMore: function (e) {
    return e ? "Show less" : "Show more";
  }
})(l2);
xX(function (e) {
  return t.createElement(D1, e, t.createElement(s2, e));
}, {
  $$widgetType: "ais.hierarchicalMenu"
});
var c2 = function (e) {
  var r = e.cx,
    n = e.value,
    a = e.highlightedTagName,
    o = e.isHighlighted,
    i = e.nonHighlightedTagName,
    l = o ? a : i,
    s = o ? "highlighted" : "nonHighlighted";
  return t.createElement(l, {
    className: r(s)
  }, n);
};
c2.propTypes = {
  cx: se.func.isRequired,
  value: se.string.isRequired,
  isHighlighted: se.bool.isRequired,
  highlightedTagName: se.string.isRequired,
  nonHighlightedTagName: se.string.isRequired
};
var u2 = function (e) {
  var r = e.cx,
    n = e.hit,
    a = e.attribute,
    o = e.highlight,
    i = e.highlightProperty,
    l = e.tagName,
    s = e.nonHighlightedTagName,
    c = e.separator,
    u = e.className,
    h = o({
      hit: n,
      attribute: a,
      highlightProperty: i
    });
  return t.createElement("span", {
    className: m1(r(""), u)
  }, h.map(function (e, n) {
    if (Array.isArray(e)) {
      var a = n === h.length - 1;
      return t.createElement("span", {
        key: n
      }, e.map(function (e, n) {
        return t.createElement(c2, {
          cx: r,
          key: n,
          value: e.value,
          highlightedTagName: l,
          nonHighlightedTagName: s,
          isHighlighted: e.isHighlighted
        });
      }), !a && t.createElement("span", {
        className: r("separator")
      }, c));
    }
    return t.createElement(c2, {
      cx: r,
      key: n,
      value: e.value,
      highlightedTagName: l,
      nonHighlightedTagName: s,
      isHighlighted: e.isHighlighted
    });
  }));
};
function h2() {
  return h2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, h2.apply(this, arguments);
}
u2.propTypes = {
  cx: se.func.isRequired,
  hit: se.object.isRequired,
  attribute: se.oneOfType([se.arrayOf(se.string), se.string]).isRequired,
  highlight: se.func.isRequired,
  highlightProperty: se.string.isRequired,
  tagName: se.string,
  nonHighlightedTagName: se.string,
  className: se.string,
  separator: se.node
}, u2.defaultProps = {
  tagName: "em",
  nonHighlightedTagName: "span",
  className: "",
  separator: ", "
};
var m2 = d1("Highlight"),
  p2 = EX(function (e) {
    return t.createElement(u2, h2({}, e, {
      highlightProperty: "_highlightResult",
      cx: m2
    }));
  }, {
    $$widgetType: "ais.highlight"
  }),
  f2 = d1("Hits"),
  d2 = function (e) {
    return t.createElement("div", {
      style: {
        borderBottom: "1px solid #bbb",
        paddingBottom: "5px",
        marginBottom: "5px",
        wordBreak: "break-all"
      }
    }, JSON.stringify(e).slice(0, 100), "...");
  },
  v2 = function (e) {
    var r = e.hits,
      n = e.className,
      a = void 0 === n ? "" : n,
      o = e.hitComponent,
      i = void 0 === o ? d2 : o;
    return t.createElement("div", {
      className: m1(f2(""), a)
    }, t.createElement("ul", {
      className: f2("list")
    }, r.map(function (e) {
      return t.createElement("li", {
        className: f2("item"),
        key: e.objectID
      }, t.createElement(i, {
        hit: e
      }));
    })));
  },
  g2 = se.shape({
    objectID: se.oneOfType([se.string, se.number]).isRequired
  });
v2.propTypes = {
  hits: se.arrayOf(g2.isRequired).isRequired,
  className: se.string,
  hitComponent: se.any
};
var b2 = jX(v2, {
  $$widgetType: "ais.hits"
});
function w2(e) {
  return w2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, w2(e);
}
function y2(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, P2(n.key), n);
  }
}
function x2(e, t) {
  return x2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
    return e.__proto__ = t, e;
  }, x2(e, t);
}
function O2(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = j2(e);
    if (t) {
      var a = j2(this).constructor;
      r = Reflect.construct(n, arguments, a);
    } else r = n.apply(this, arguments);
    return function (e, t) {
      if (t && ("object" === w2(t) || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return E2(e);
    }(this, r);
  };
}
function E2(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function j2(e) {
  return j2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, j2(e);
}
function C2(e, t, r) {
  return (t = P2(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function P2(e) {
  var t = function (e, t) {
    if ("object" !== w2(e) || null === e) return e;
    var r = e[Symbol.toPrimitive];
    if (void 0 !== r) {
      var n = r.call(e, t || "default");
      if ("object" !== w2(n)) return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === t ? String : Number)(e);
  }(e, "string");
  return "symbol" === w2(t) ? t : String(t);
}
var M2 = function (e) {
  !function (e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), Object.defineProperty(e, "prototype", {
      writable: !1
    }), t && x2(e, t);
  }(l, i);
  var r,
    n,
    a,
    o = O2(l);
  function l() {
    var e;
    !function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }(this, l);
    for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++) r[n] = arguments[n];
    return C2(E2(e = o.call.apply(o, [this].concat(r))), "onChange", function (t) {
      e.props.onSelect(t.target.value);
    }), e;
  }
  return r = l, n = [{
    key: "render",
    value: function () {
      var e = this.props,
        r = e.cx,
        n = e.id,
        a = e.items,
        o = e.selectedItem;
      return t.createElement("select", {
        id: n,
        className: r("select"),
        value: o,
        onChange: this.onChange
      }, a.map(function (e) {
        return t.createElement("option", {
          className: r("option"),
          key: void 0 === e.key ? e.value : e.key,
          disabled: e.disabled,
          value: e.value
        }, void 0 === e.label ? e.value : e.label);
      }));
    }
  }], n && y2(r.prototype, n), a && y2(r, a), Object.defineProperty(r, "prototype", {
    writable: !1
  }), l;
}();
function k2(e) {
  return k2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, k2(e);
}
function S2(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, A2(n.key), n);
  }
}
function N2(e, t) {
  return N2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
    return e.__proto__ = t, e;
  }, N2(e, t);
}
function B2(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = V2(e);
    if (t) {
      var a = V2(this).constructor;
      r = Reflect.construct(n, arguments, a);
    } else r = n.apply(this, arguments);
    return function (e, t) {
      if (t && ("object" === k2(t) || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }(this, r);
  };
}
function V2(e) {
  return V2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, V2(e);
}
function R2(e, t, r) {
  return (t = A2(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function A2(e) {
  var t = function (e, t) {
    if ("object" !== k2(e) || null === e) return e;
    var r = e[Symbol.toPrimitive];
    if (void 0 !== r) {
      var n = r.call(e, t || "default");
      if ("object" !== k2(n)) return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === t ? String : Number)(e);
  }(e, "string");
  return "symbol" === k2(t) ? t : String(t);
}
C2(M2, "propTypes", {
  cx: se.func.isRequired,
  id: se.string,
  onSelect: se.func.isRequired,
  items: se.arrayOf(se.shape({
    value: se.oneOfType([se.string, se.number]).isRequired,
    key: se.oneOfType([se.string, se.number]),
    label: se.string,
    disabled: se.bool
  })).isRequired,
  selectedItem: se.oneOfType([se.string, se.number]).isRequired
});
var T2 = d1("HitsPerPage"),
  H2 = function (e) {
    !function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t && N2(e, t);
    }(l, i);
    var r,
      n,
      a,
      o = B2(l);
    function l() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, l), o.apply(this, arguments);
    }
    return r = l, n = [{
      key: "render",
      value: function () {
        var e = this.props,
          r = e.id,
          n = e.items,
          a = e.currentRefinement,
          o = e.refine,
          i = e.className;
        return t.createElement("div", {
          className: m1(T2(""), i)
        }, t.createElement(M2, {
          id: r,
          onSelect: o,
          selectedItem: a,
          items: n,
          cx: T2
        }));
      }
    }], n && S2(r.prototype, n), a && S2(r, a), Object.defineProperty(r, "prototype", {
      writable: !1
    }), l;
  }();
function L2(e) {
  return L2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, L2(e);
}
function I2(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, F2(n.key), n);
  }
}
function F2(e) {
  var t = function (e, t) {
    if ("object" !== L2(e) || null === e) return e;
    var r = e[Symbol.toPrimitive];
    if (void 0 !== r) {
      var n = r.call(e, t || "default");
      if ("object" !== L2(n)) return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === t ? String : Number)(e);
  }(e, "string");
  return "symbol" === L2(t) ? t : String(t);
}
function _2(e, t) {
  return _2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
    return e.__proto__ = t, e;
  }, _2(e, t);
}
function Z2(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = D2(e);
    if (t) {
      var a = D2(this).constructor;
      r = Reflect.construct(n, arguments, a);
    } else r = n.apply(this, arguments);
    return function (e, t) {
      if (t && ("object" === L2(t) || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }(this, r);
  };
}
function D2(e) {
  return D2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, D2(e);
}
R2(H2, "propTypes", {
  id: se.string,
  items: se.arrayOf(se.shape({
    value: se.number.isRequired,
    label: se.string
  })).isRequired,
  currentRefinement: se.number.isRequired,
  refine: se.func.isRequired,
  className: se.string
}), R2(H2, "defaultProps", {
  className: ""
}), NX(H2, {
  $$widgetType: "ais.hitsPerPage"
});
var q2 = d1("InfiniteHits"),
  U2 = function (e) {
    !function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t && _2(e, t);
    }(l, i);
    var r,
      n,
      a,
      o = Z2(l);
    function l() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, l), o.apply(this, arguments);
    }
    return r = l, (n = [{
      key: "render",
      value: function () {
        var e = this.props,
          r = e.hitComponent,
          n = e.hits,
          a = e.showPrevious,
          o = e.hasPrevious,
          i = e.hasMore,
          l = e.refinePrevious,
          s = e.refineNext,
          c = e.translate,
          u = e.className;
        return t.createElement("div", {
          className: m1(q2(""), u)
        }, a && t.createElement("button", {
          className: q2("loadPrevious", !o && "loadPrevious--disabled"),
          onClick: function () {
            return l();
          },
          disabled: !o
        }, c("loadPrevious")), t.createElement("ul", {
          className: q2("list")
        }, n.map(function (e) {
          return t.createElement("li", {
            key: e.objectID,
            className: q2("item")
          }, t.createElement(r, {
            hit: e
          }));
        })), t.createElement("button", {
          className: q2("loadMore", !i && "loadMore--disabled"),
          onClick: function () {
            return s();
          },
          disabled: !i
        }, c("loadMore")));
      }
    }]) && I2(r.prototype, n), a && I2(r, a), Object.defineProperty(r, "prototype", {
      writable: !1
    }), l;
  }();
function $2(e) {
  return $2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, $2(e);
}
function z2(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, X2(n.key), n);
  }
}
function W2(e, t) {
  return W2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
    return e.__proto__ = t, e;
  }, W2(e, t);
}
function Q2(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = Y2(e);
    if (t) {
      var a = Y2(this).constructor;
      r = Reflect.construct(n, arguments, a);
    } else r = n.apply(this, arguments);
    return function (e, t) {
      if (t && ("object" === $2(t) || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return G2(e);
    }(this, r);
  };
}
function G2(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Y2(e) {
  return Y2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, Y2(e);
}
function K2(e, t, r) {
  return (t = X2(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function X2(e) {
  var t = function (e, t) {
    if ("object" !== $2(e) || null === e) return e;
    var r = e[Symbol.toPrimitive];
    if (void 0 !== r) {
      var n = r.call(e, t || "default");
      if ("object" !== $2(n)) return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === t ? String : Number)(e);
  }(e, "string");
  return "symbol" === $2(t) ? t : String(t);
}
U2.propTypes = {
  hits: se.arrayOf(se.object).isRequired,
  showPrevious: se.bool.isRequired,
  hasPrevious: se.bool.isRequired,
  hasMore: se.bool.isRequired,
  refinePrevious: se.func.isRequired,
  refineNext: se.func.isRequired,
  translate: se.func.isRequired,
  className: se.string,
  hitComponent: se.any
}, U2.defaultProps = {
  className: "",
  showPrevious: !1,
  hitComponent: function (e) {
    return t.createElement("div", {
      style: {
        borderBottom: "1px solid #bbb",
        paddingBottom: "5px",
        marginBottom: "5px",
        wordBreak: "break-all"
      }
    }, JSON.stringify(e).slice(0, 100), "...");
  }
}, _X(KQ({
  loadPrevious: "Load previous",
  loadMore: "Load more"
})(U2), {
  $$widgetType: "ais.infiniteHits"
});
var J2 = d1("Menu"),
  e3 = function (e) {
    !function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t && W2(e, t);
    }(l, i);
    var r,
      n,
      a,
      o = Q2(l);
    function l() {
      var e;
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, l);
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++) n[a] = arguments[a];
      return K2(G2(e = o.call.apply(o, [this].concat(n))), "renderItem", function (r, n) {
        var a = e.props.createURL,
          o = e.props.isFromSearch ? t.createElement(p2, {
            attribute: "label",
            hit: r
          }) : r.label;
        return t.createElement(X1, {
          className: J2("link"),
          onClick: function () {
            return e.selectItem(r, n);
          },
          href: a(r.value)
        }, t.createElement("span", {
          className: J2("label")
        }, o), " ", t.createElement("span", {
          className: J2("count")
        }, r.count));
      }), K2(G2(e), "selectItem", function (t, r) {
        r(), e.props.refine(t.value);
      }), e;
    }
    return r = l, (n = [{
      key: "render",
      value: function () {
        var e = this.props,
          r = e.translate,
          n = e.items,
          a = e.showMore,
          o = e.limit,
          i = e.showMoreLimit,
          l = e.isFromSearch,
          s = e.searchForItems,
          c = e.searchable,
          u = e.canRefine,
          h = e.className;
        return t.createElement(Y0, {
          renderItem: this.renderItem,
          selectItem: this.selectItem,
          cx: J2,
          translate: r,
          items: n,
          showMore: a,
          limit: o,
          showMoreLimit: i,
          isFromSearch: l,
          searchForItems: s,
          searchable: c,
          canRefine: u,
          className: h
        });
      }
    }]) && z2(r.prototype, n), a && z2(r, a), Object.defineProperty(r, "prototype", {
      writable: !1
    }), l;
  }();
K2(e3, "propTypes", {
  translate: se.func.isRequired,
  refine: se.func.isRequired,
  searchForItems: se.func.isRequired,
  searchable: se.bool,
  createURL: se.func.isRequired,
  items: se.arrayOf(se.shape({
    label: se.string.isRequired,
    value: se.string.isRequired,
    count: se.number.isRequired,
    isRefined: se.bool.isRequired
  })),
  isFromSearch: se.bool.isRequired,
  canRefine: se.bool.isRequired,
  showMore: se.bool,
  limit: se.number,
  showMoreLimit: se.number,
  transformItems: se.func,
  className: se.string
}), K2(e3, "defaultProps", {
  className: ""
});
var t3 = KQ({
  showMore: function (e) {
    return e ? "Show less" : "Show more";
  },
  noResults: "No results",
  submit: null,
  reset: null,
  resetTitle: "Clear the search query.",
  submitTitle: "Submit your search query.",
  placeholder: "Search here…"
})(e3);
function r3(e) {
  return r3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, r3(e);
}
function n3(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, c3(n.key), n);
  }
}
function a3(e, t) {
  return a3 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
    return e.__proto__ = t, e;
  }, a3(e, t);
}
function o3(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = l3(e);
    if (t) {
      var a = l3(this).constructor;
      r = Reflect.construct(n, arguments, a);
    } else r = n.apply(this, arguments);
    return function (e, t) {
      if (t && ("object" === r3(t) || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return i3(e);
    }(this, r);
  };
}
function i3(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function l3(e) {
  return l3 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, l3(e);
}
function s3(e, t, r) {
  return (t = c3(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function c3(e) {
  var t = function (e, t) {
    if ("object" !== r3(e) || null === e) return e;
    var r = e[Symbol.toPrimitive];
    if (void 0 !== r) {
      var n = r.call(e, t || "default");
      if ("object" !== r3(n)) return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === t ? String : Number)(e);
  }(e, "string");
  return "symbol" === r3(t) ? t : String(t);
}
YX(function (e) {
  return t.createElement(D1, e, t.createElement(t3, e));
}, {
  $$widgetType: "ais.menu"
});
var u3 = d1("MenuSelect"),
  h3 = function (e) {
    !function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t && a3(e, t);
    }(l, i);
    var r,
      n,
      a,
      o = o3(l);
    function l() {
      var e;
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, l);
      for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++) r[n] = arguments[n];
      return s3(i3(e = o.call.apply(o, [this].concat(r))), "handleSelectChange", function (t) {
        var r = t.target.value;
        e.props.refine("ais__see__all__option" === r ? "" : r);
      }), e;
    }
    return r = l, n = [{
      key: "selectedValue",
      get: function () {
        return (b1(this.props.items, function (e) {
          return !0 === e.isRefined;
        }) || {
          value: "ais__see__all__option"
        }).value;
      }
    }, {
      key: "render",
      value: function () {
        var e = this.props,
          r = e.id,
          n = e.items,
          a = e.canRefine,
          o = e.translate,
          i = e.className;
        return t.createElement("div", {
          className: m1(u3("", !a && "-noRefinement"), i)
        }, t.createElement("select", {
          id: r,
          value: this.selectedValue,
          onChange: this.handleSelectChange,
          className: u3("select")
        }, t.createElement("option", {
          value: "ais__see__all__option",
          className: u3("option")
        }, o("seeAllOption")), n.map(function (e) {
          return t.createElement("option", {
            key: e.value,
            value: e.value,
            className: u3("option")
          }, e.label, " (", e.count, ")");
        })));
      }
    }], n && n3(r.prototype, n), a && n3(r, a), Object.defineProperty(r, "prototype", {
      writable: !1
    }), l;
  }();
s3(h3, "propTypes", {
  id: se.string,
  items: se.arrayOf(se.shape({
    label: se.string.isRequired,
    value: se.string.isRequired,
    count: se.oneOfType([se.number.isRequired, se.string.isRequired]),
    isRefined: se.bool.isRequired
  })).isRequired,
  canRefine: se.bool.isRequired,
  refine: se.func.isRequired,
  translate: se.func.isRequired,
  className: se.string
}), s3(h3, "defaultProps", {
  className: ""
});
var m3 = KQ({
  seeAllOption: "See all"
})(h3);
function p3(e) {
  return p3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, p3(e);
}
function f3(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function d3(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? f3(Object(r), !0).forEach(function (t) {
      x3(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : f3(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
function v3(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, O3(n.key), n);
  }
}
function g3(e, t) {
  return g3 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
    return e.__proto__ = t, e;
  }, g3(e, t);
}
function b3(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = y3(e);
    if (t) {
      var a = y3(this).constructor;
      r = Reflect.construct(n, arguments, a);
    } else r = n.apply(this, arguments);
    return function (e, t) {
      if (t && ("object" === p3(t) || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return w3(e);
    }(this, r);
  };
}
function w3(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function y3(e) {
  return y3 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, y3(e);
}
function x3(e, t, r) {
  return (t = O3(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function O3(e) {
  var t = function (e, t) {
    if ("object" !== p3(e) || null === e) return e;
    var r = e[Symbol.toPrimitive];
    if (void 0 !== r) {
      var n = r.call(e, t || "default");
      if ("object" !== p3(n)) return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === t ? String : Number)(e);
  }(e, "string");
  return "symbol" === p3(t) ? t : String(t);
}
YX(function (e) {
  return t.createElement(D1, e, t.createElement(m3, e));
}, {
  $$widgetType: "ais.menuSelect"
});
var E3 = d1("NumericMenu"),
  j3 = function (e) {
    !function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t && g3(e, t);
    }(l, i);
    var r,
      n,
      a,
      o = b3(l);
    function l() {
      var e;
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, l);
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++) n[a] = arguments[a];
      return x3(w3(e = o.call.apply(o, [this].concat(n))), "renderItem", function (r) {
        var n = e.props,
          a = n.refine,
          o = n.translate;
        return t.createElement("label", {
          className: E3("label")
        }, t.createElement("input", {
          className: E3("radio"),
          type: "radio",
          checked: r.isRefined,
          disabled: r.noRefinement,
          onChange: function () {
            return a(r.value);
          }
        }), t.createElement("span", {
          className: E3("labelText")
        }, "" === r.value ? o("all") : r.label));
      }), e;
    }
    return r = l, (n = [{
      key: "render",
      value: function () {
        var e = this.props,
          r = e.items,
          n = e.canRefine,
          a = e.className;
        return t.createElement(Y0, {
          renderItem: this.renderItem,
          showMore: !1,
          canRefine: n,
          cx: E3,
          items: r.map(function (e) {
            return d3(d3({}, e), {}, {
              key: e.value
            });
          }),
          className: a
        });
      }
    }]) && v3(r.prototype, n), a && v3(r, a), Object.defineProperty(r, "prototype", {
      writable: !1
    }), l;
  }();
x3(j3, "propTypes", {
  items: se.arrayOf(se.shape({
    label: se.node.isRequired,
    value: se.string.isRequired,
    isRefined: se.bool.isRequired,
    noRefinement: se.bool.isRequired
  })).isRequired,
  canRefine: se.bool.isRequired,
  refine: se.func.isRequired,
  translate: se.func.isRequired,
  className: se.string
}), x3(j3, "defaultProps", {
  className: ""
});
var C3 = KQ({
  all: "All"
})(j3);
function P3(e) {
  return P3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, P3(e);
}
function M3(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, B3(n.key), n);
  }
}
function k3(e, t) {
  return k3 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
    return e.__proto__ = t, e;
  }, k3(e, t);
}
function S3(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = N3(e);
    if (t) {
      var a = N3(this).constructor;
      r = Reflect.construct(n, arguments, a);
    } else r = n.apply(this, arguments);
    return function (e, t) {
      if (t && ("object" === P3(t) || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }(this, r);
  };
}
function N3(e) {
  return N3 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, N3(e);
}
function B3(e) {
  var t = function (e, t) {
    if ("object" !== P3(e) || null === e) return e;
    var r = e[Symbol.toPrimitive];
    if (void 0 !== r) {
      var n = r.call(e, t || "default");
      if ("object" !== P3(n)) return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === t ? String : Number)(e);
  }(e, "string");
  return "symbol" === P3(t) ? t : String(t);
}
lJ(function (e) {
  return t.createElement(D1, e, t.createElement(C3, e));
}, {
  $$widgetType: "ais.numericMenu"
});
var V3 = function (e) {
  !function (e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), Object.defineProperty(e, "prototype", {
      writable: !1
    }), t && k3(e, t);
  }(l, i);
  var r,
    n,
    a,
    o = S3(l);
  function l() {
    return function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }(this, l), o.apply(this, arguments);
  }
  return r = l, n = [{
    key: "render",
    value: function () {
      var e = this.props,
        r = e.cx,
        n = e.createURL,
        a = e.items,
        o = e.onSelect,
        i = e.canRefine;
      return t.createElement("ul", {
        className: r("list", !i && "list--noRefinement")
      }, a.map(function (e) {
        return t.createElement("li", {
          key: void 0 === e.key ? e.value : e.key,
          className: r("item", e.selected && !e.disabled && "item--selected", e.disabled && "item--disabled", e.modifier)
        }, e.disabled ? t.createElement("span", {
          className: r("link")
        }, void 0 === e.label ? e.value : e.label) : t.createElement(X1, {
          className: r("link", e.selected && "link--selected"),
          "aria-label": e.ariaLabel,
          href: n(e.value),
          onClick: function () {
            return o(e.value);
          }
        }, void 0 === e.label ? e.value : e.label));
      }));
    }
  }], n && M3(r.prototype, n), a && M3(r, a), Object.defineProperty(r, "prototype", {
    writable: !1
  }), l;
}();
!function (e, t, r) {
  (t = B3(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r;
}(V3, "propTypes", {
  cx: se.func.isRequired,
  createURL: se.func.isRequired,
  items: se.arrayOf(se.shape({
    value: se.oneOfType([se.string, se.number, se.object]).isRequired,
    key: se.oneOfType([se.string, se.number]),
    label: se.node,
    modifier: se.string,
    ariaLabel: se.string,
    disabled: se.bool
  })),
  onSelect: se.func.isRequired,
  canRefine: se.bool.isRequired
});
var R3 = ["listComponent", "nbPages", "totalPages", "currentRefinement", "padding", "showFirst", "showPrevious", "showNext", "showLast", "refine", "createURL", "canRefine", "translate", "className"];
function A3(e) {
  return A3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, A3(e);
}
function T3() {
  return T3 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, T3.apply(this, arguments);
}
function H3(e, t) {
  if (null == e) return {};
  var r,
    n,
    a = function (e, t) {
      if (null == e) return {};
      var r,
        n,
        a = {},
        o = Object.keys(e);
      for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || (a[r] = e[r]);
      return a;
    }(e, t);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (a[r] = e[r]);
  }
  return a;
}
function L3(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, D3(n.key), n);
  }
}
function I3(e, t) {
  return I3 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
    return e.__proto__ = t, e;
  }, I3(e, t);
}
function F3(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = _3(e);
    if (t) {
      var a = _3(this).constructor;
      r = Reflect.construct(n, arguments, a);
    } else r = n.apply(this, arguments);
    return function (e, t) {
      if (t && ("object" === A3(t) || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }(this, r);
  };
}
function _3(e) {
  return _3 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, _3(e);
}
function Z3(e, t, r) {
  return (t = D3(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function D3(e) {
  var t = function (e, t) {
    if ("object" !== A3(e) || null === e) return e;
    var r = e[Symbol.toPrimitive];
    if (void 0 !== r) {
      var n = r.call(e, t || "default");
      if ("object" !== A3(n)) return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === t ? String : Number)(e);
  }(e, "string");
  return "symbol" === A3(t) ? t : String(t);
}
var q3 = d1("Pagination");
function U3(e, t, r) {
  var n = function (e, t) {
    return Math.min(2 * e + 1, t);
  }(r, t);
  if (n === t) return g1({
    start: 1,
    end: t + 1
  });
  var a = function (e, t, r, n) {
    return e <= t ? e : e >= r - t ? n - (r - e) : t + 1;
  }(e, r, t, n);
  return g1({
    start: e - a + 1,
    end: e + (n - a) + 1
  });
}
var $3 = function (e) {
  !function (e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), Object.defineProperty(e, "prototype", {
      writable: !1
    }), t && I3(e, t);
  }(l, i);
  var r,
    n,
    a,
    o = F3(l);
  function l() {
    return function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }(this, l), o.apply(this, arguments);
  }
  return r = l, n = [{
    key: "getItem",
    value: function (e, t, r) {
      var n = this.props,
        a = n.nbPages,
        o = n.totalPages,
        i = n.translate;
      return {
        key: "".concat(e, ".").concat(r),
        modifier: e,
        disabled: r < 1 || r >= Math.min(o, a),
        label: i(t, r),
        value: r,
        ariaLabel: i("aria".concat(v1(t)), r)
      };
    }
  }, {
    key: "render",
    value: function () {
      var e = this.props,
        r = e.listComponent,
        n = e.nbPages,
        a = e.totalPages,
        o = e.currentRefinement,
        i = e.padding,
        l = e.showFirst,
        s = e.showPrevious,
        c = e.showNext,
        u = e.showLast,
        h = e.refine,
        m = e.createURL,
        p = e.canRefine,
        f = e.translate,
        d = e.className,
        v = H3(e, R3),
        g = Math.min(n, a),
        b = g,
        w = [];
      return l && w.push({
        key: "first",
        modifier: "item--firstPage",
        disabled: 1 === o,
        label: f("first"),
        value: 1,
        ariaLabel: f("ariaFirst")
      }), s && w.push({
        key: "previous",
        modifier: "item--previousPage",
        disabled: 1 === o,
        label: f("previous"),
        value: o - 1,
        ariaLabel: f("ariaPrevious")
      }), w = w.concat(U3(o, g, i).map(function (e) {
        return {
          key: e,
          modifier: "item--page",
          label: f("page", e),
          value: e,
          selected: e === o,
          ariaLabel: f("ariaPage", e)
        };
      })), c && w.push({
        key: "next",
        modifier: "item--nextPage",
        disabled: o === b || b <= 1,
        label: f("next"),
        value: o + 1,
        ariaLabel: f("ariaNext")
      }), u && w.push({
        key: "last",
        modifier: "item--lastPage",
        disabled: o === b || b <= 1,
        label: f("last"),
        value: b,
        ariaLabel: f("ariaLast")
      }), t.createElement("div", {
        className: m1(q3("", !p && "-noRefinement"), d)
      }, t.createElement(r, T3({}, v, {
        cx: q3,
        items: w,
        onSelect: h,
        createURL: m,
        canRefine: p
      })));
    }
  }], n && L3(r.prototype, n), a && L3(r, a), Object.defineProperty(r, "prototype", {
    writable: !1
  }), l;
}();
Z3($3, "propTypes", {
  nbPages: se.number.isRequired,
  currentRefinement: se.number.isRequired,
  refine: se.func.isRequired,
  createURL: se.func.isRequired,
  canRefine: se.bool.isRequired,
  translate: se.func.isRequired,
  listComponent: se.func,
  showFirst: se.bool,
  showPrevious: se.bool,
  showNext: se.bool,
  showLast: se.bool,
  padding: se.number,
  totalPages: se.number,
  className: se.string
}), Z3($3, "defaultProps", {
  listComponent: V3,
  showFirst: !0,
  showPrevious: !0,
  showNext: !0,
  showLast: !1,
  padding: 3,
  totalPages: 1 / 0,
  className: ""
});
var z3 = KQ({
  previous: "‹",
  next: "›",
  first: "«",
  last: "»",
  page: function (e) {
    return e.toString();
  },
  ariaPrevious: "Previous page",
  ariaNext: "Next page",
  ariaFirst: "First page",
  ariaLast: "Last page",
  ariaPage: function (e) {
    return "Page ".concat(e.toString());
  }
})($3);
function W3(e) {
  return W3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, W3(e);
}
function Q3(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, X3(n.key), n);
  }
}
function G3(e, t) {
  return G3 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
    return e.__proto__ = t, e;
  }, G3(e, t);
}
function Y3(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = K3(e);
    if (t) {
      var a = K3(this).constructor;
      r = Reflect.construct(n, arguments, a);
    } else r = n.apply(this, arguments);
    return function (e, t) {
      if (t && ("object" === W3(t) || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }(this, r);
  };
}
function K3(e) {
  return K3 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, K3(e);
}
function X3(e) {
  var t = function (e, t) {
    if ("object" !== W3(e) || null === e) return e;
    var r = e[Symbol.toPrimitive];
    if (void 0 !== r) {
      var n = r.call(e, t || "default");
      if ("object" !== W3(n)) return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === t ? String : Number)(e);
  }(e, "string");
  return "symbol" === W3(t) ? t : String(t);
}
hJ(function (e) {
  return t.createElement(D1, e, t.createElement(z3, e));
}, {
  $$widgetType: "ais.pagination"
});
var J3 = d1("PoweredBy"),
  e4 = t.createElement("path", {
    fill: "#003DFF",
    d: "M249.5 64.2V1.4c0-.9-.7-1.5-1.6-1.4L236.2 2a1.4 1.4 0 0 0-1.2 1.3V67c0 3 0 21.6 22.4 22.3a1.4 1.4 0 0 0 1.5-1.4v-9.5c0-.7-.6-1.3-1.2-1.4-8.2-.9-8.2-11-8.2-12.7ZM443.5 24.4h-11.8c-.8 0-1.4.6-1.4 1.4v62c0 .8.6 1.4 1.4 1.4h11.8c.8 0 1.4-.6 1.4-1.4v-62c0-.8-.6-1.4-1.4-1.4ZM431.7 16.6h11.8c.8 0 1.4-.6 1.4-1.3v-14c0-.8-.7-1.4-1.6-1.3L431.5 2a1.4 1.4 0 0 0-1.2 1.3v12c0 .8.6 1.4 1.4 1.4Zm-20.5 47.6V1.4c0-.9-.7-1.5-1.5-1.4L397.9 2a1.4 1.4 0 0 0-1.2 1.3V67c0 3 0 21.6 22.4 22.3a1.4 1.4 0 0 0 1.5-1.4v-9.5c0-.7-.5-1.3-1.2-1.4-8.2-.9-8.2-11-8.2-12.7Zm-30.7-31c-2.6-2.8-5.8-5-9.6-6.5a31.7 31.7 0 0 0-12-2.3c-4.5 0-8.5.7-12.2 2.3A27.9 27.9 0 0 0 331 43.5a39.6 39.6 0 0 0 0 26.3c1.5 4 3.6 7.5 6.2 10.3 2.6 2.9 5.8 5 9.5 6.7a38 38 0 0 0 12.2 2.4c2.8 0 8.6-.9 12.3-2.4a27 27 0 0 0 9.5-6.7 35.1 35.1 0 0 0 8.3-23c0-4.9-.8-9.6-2.4-13.6-1.5-4-3.5-7.4-6.1-10.2ZM370 71.5a13.1 13.1 0 0 1-11.2 5.6 13 13 0 0 1-11.2-5.6c-2.7-3.6-4-7.9-4-14.2 0-6.3 1.3-11.5 4-15.1a13 13 0 0 1 11.1-5.5 13 13 0 0 1 11.3 5.5c2.6 3.6 4 8.8 4 15 0 6.4-1.3 10.6-4 14.3Zm-161.6-47H197a32 32 0 0 0-27 15 33.8 33.8 0 0 0 8.9 45.9 18.8 18.8 0 0 0 11.2 3.1H191.2l.6-.2h.2a21 21 0 0 0 16.5-14.6V87c0 .8.6 1.4 1.4 1.4h11.7c.8 0 1.4-.6 1.4-1.4V25.8c0-.8-.6-1.4-1.4-1.4h-13Zm0 48.3a17.8 17.8 0 0 1-10.4 3.5h-.2a12.5 12.5 0 0 1-.7 0A18.4 18.4 0 0 1 180.4 51c2.7-6.8 9-11.6 16.6-11.6h11.5v33.3Zm289-48.3H486a32 32 0 0 0-27 15 33.8 33.8 0 0 0 8.8 45.9 18.8 18.8 0 0 0 11.3 3.1h1.1l.6-.2h.2a21 21 0 0 0 16.5-14.6V87c0 .8.6 1.4 1.4 1.4h11.7c.8 0 1.4-.6 1.4-1.4V25.8c0-.8-.6-1.4-1.4-1.4h-13.1Zm0 48.3a17.8 17.8 0 0 1-10.5 3.5h-.9A18.4 18.4 0 0 1 469.4 51c2.6-6.8 9-11.6 16.6-11.6h11.5v33.3ZM306.3 24.4h-11.5a32 32 0 0 0-27 15 33.7 33.7 0 0 0-5.1 14.6 34.6 34.6 0 0 0 0 7.6c1 8.9 5.4 16.7 11.8 22a19.5 19.5 0 0 0 2.2 1.7 18.8 18.8 0 0 0 21.6-.6c3.8-2.7 6.7-6.7 8-11.1V87.9c0 5-1.3 8.9-4 11.5-2.7 2.6-7.3 3.9-13.6 3.9-2.6 0-6.7-.2-10.9-.6a1.4 1.4 0 0 0-1.4 1l-3 10a1.4 1.4 0 0 0 1.1 1.8c5 .7 10 1 12.8 1 11.4 0 19.8-2.4 25.3-7.4 5-4.6 7.8-11.4 8.2-20.7V25.8c0-.8-.6-1.4-1.3-1.4h-13.2Zm0 15s.2 32.4 0 33.4a17.5 17.5 0 0 1-10 3.4h-.2a13.6 13.6 0 0 1-1.7 0A18.7 18.7 0 0 1 278.3 51c2.6-6.8 9-11.6 16.5-11.6h11.5ZM58.2 0A58.3 58.3 0 1 0 86 109.5c.9-.5 1-1.6.3-2.2l-5.5-4.9a3.8 3.8 0 0 0-4-.6A47 47 0 0 1 11 57.5 47.3 47.3 0 0 1 58.2 11h47.3v84L78.7 71.2a2 2 0 0 0-3 .3 22 22 0 1 1 4.4-15.2 4 4 0 0 0 1.3 2.6l7 6.2c.8.7 2 .3 2.3-.8a33 33 0 0 0-30.4-39 33 33 0 0 0-35 32 33.3 33.3 0 0 0 32.2 33.9 32.8 32.8 0 0 0 20-6.3l35.1 31c1.5 1.4 3.9.3 3.9-1.7V2.2a2.2 2.2 0 0 0-2.2-2.2h-56Z"
  }),
  t4 = function () {
    return t.createElement("svg", {
      viewBox: "0 0 512 117",
      width: "118",
      height: "27",
      className: J3("logo")
    }, e4);
  },
  r4 = t.createElement(t4, null),
  n4 = function (e) {
    !function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t && G3(e, t);
    }(l, i);
    var r,
      n,
      a,
      o = Y3(l);
    function l() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, l), o.apply(this, arguments);
    }
    return r = l, (n = [{
      key: "render",
      value: function () {
        var e = this.props,
          r = e.url,
          n = e.translate,
          a = e.className;
        return t.createElement("div", {
          className: m1(J3(""), a)
        }, t.createElement("span", {
          className: J3("text")
        }, n("searchBy")), " ", t.createElement("a", {
          href: r,
          target: "_blank",
          className: J3("link"),
          "aria-label": "Algolia",
          rel: "noopener noreferrer"
        }, r4));
      }
    }]) && Q3(r.prototype, n), a && Q3(r, a), Object.defineProperty(r, "prototype", {
      writable: !1
    }), l;
  }();
!function (e, t, r) {
  (t = X3(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r;
}(n4, "propTypes", {
  url: se.string.isRequired,
  translate: se.func.isRequired,
  className: se.string
});
var a4 = mJ(KQ({
  searchBy: "Search by"
})(n4), {
  $$widgetType: "ais.poweredBy"
});
function o4(e) {
  return o4 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, o4(e);
}
function i4(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, m4(n.key), n);
  }
}
function l4(e, t) {
  return l4 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
    return e.__proto__ = t, e;
  }, l4(e, t);
}
function s4(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = u4(e);
    if (t) {
      var a = u4(this).constructor;
      r = Reflect.construct(n, arguments, a);
    } else r = n.apply(this, arguments);
    return function (e, t) {
      if (t && ("object" === o4(t) || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return c4(e);
    }(this, r);
  };
}
function c4(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function u4(e) {
  return u4 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, u4(e);
}
function h4(e, t, r) {
  return (t = m4(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function m4(e) {
  var t = function (e, t) {
    if ("object" !== o4(e) || null === e) return e;
    var r = e[Symbol.toPrimitive];
    if (void 0 !== r) {
      var n = r.call(e, t || "default");
      if ("object" !== o4(n)) return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === t ? String : Number)(e);
  }(e, "string");
  return "symbol" === o4(t) ? t : String(t);
}
var p4 = d1("RangeInput"),
  f4 = function (e) {
    !function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t && l4(e, t);
    }(l, i);
    var r,
      n,
      a,
      o = s4(l);
    function l(e) {
      var t;
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, l), h4(c4(t = o.call(this, e)), "onSubmit", function (e) {
        e.preventDefault(), t.props.refine({
          min: t.state.from,
          max: t.state.to
        });
      }), t.state = t.normalizeStateForRendering(e), t;
    }
    return r = l, n = [{
      key: "componentDidUpdate",
      value: function (e) {
        !this.props.canRefine || e.currentRefinement.min === this.props.currentRefinement.min && e.currentRefinement.max === this.props.currentRefinement.max || this.setState(this.normalizeStateForRendering(this.props));
      }
    }, {
      key: "normalizeStateForRendering",
      value: function (e) {
        var t = e.canRefine,
          r = e.min,
          n = e.max,
          a = e.currentRefinement,
          o = a.min,
          i = a.max;
        return {
          from: t && void 0 !== o && o !== r ? o : "",
          to: t && void 0 !== i && i !== n ? i : ""
        };
      }
    }, {
      key: "normalizeRangeForRendering",
      value: function (e) {
        var t = e.canRefine,
          r = e.min,
          n = e.max,
          a = void 0 !== r,
          o = void 0 !== n;
        return {
          min: t && a && o ? r : "",
          max: t && a && o ? n : ""
        };
      }
    }, {
      key: "render",
      value: function () {
        var e = this,
          r = this.state,
          n = r.from,
          a = r.to,
          o = this.props,
          i = o.precision,
          l = o.translate,
          s = o.canRefine,
          c = o.className,
          u = this.normalizeRangeForRendering(this.props),
          h = u.min,
          m = u.max,
          p = 1 / Math.pow(10, i);
        return t.createElement("div", {
          className: m1(p4("", !s && "-noRefinement"), c)
        }, t.createElement("form", {
          className: p4("form"),
          onSubmit: this.onSubmit
        }, t.createElement("input", {
          className: p4("input", "input--min"),
          type: "number",
          min: h,
          max: m,
          value: n,
          step: p,
          placeholder: h,
          disabled: !s,
          onChange: function (t) {
            return e.setState({
              from: t.currentTarget.value
            });
          }
        }), t.createElement("span", {
          className: p4("separator")
        }, l("separator")), t.createElement("input", {
          className: p4("input", "input--max"),
          type: "number",
          min: h,
          max: m,
          value: a,
          step: p,
          placeholder: m,
          disabled: !s,
          onChange: function (t) {
            return e.setState({
              to: t.currentTarget.value
            });
          }
        }), t.createElement("button", {
          className: p4("submit"),
          type: "submit"
        }, l("submit"))));
      }
    }], n && i4(r.prototype, n), a && i4(r, a), Object.defineProperty(r, "prototype", {
      writable: !1
    }), l;
  }();
h4(f4, "propTypes", {
  canRefine: se.bool.isRequired,
  precision: se.number.isRequired,
  translate: se.func.isRequired,
  refine: se.func.isRequired,
  min: se.number,
  max: se.number,
  currentRefinement: se.shape({
    min: se.number,
    max: se.number
  }),
  className: se.string
}), h4(f4, "defaultProps", {
  currentRefinement: {},
  className: ""
});
var d4 = KQ({
  submit: "ok",
  separator: "to"
})(f4);
function v4(e) {
  return v4 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, v4(e);
}
function g4(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function b4(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? g4(Object(r), !0).forEach(function (t) {
      j4(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : g4(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
function w4() {
  return w4 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, w4.apply(this, arguments);
}
function y4(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, C4(n.key), n);
  }
}
function x4(e, t) {
  return x4 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
    return e.__proto__ = t, e;
  }, x4(e, t);
}
function O4(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = E4(e);
    if (t) {
      var a = E4(this).constructor;
      r = Reflect.construct(n, arguments, a);
    } else r = n.apply(this, arguments);
    return function (e, t) {
      if (t && ("object" === v4(t) || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }(this, r);
  };
}
function E4(e) {
  return E4 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, E4(e);
}
function j4(e, t, r) {
  return (t = C4(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function C4(e) {
  var t = function (e, t) {
    if ("object" !== v4(e) || null === e) return e;
    var r = e[Symbol.toPrimitive];
    if (void 0 !== r) {
      var n = r.call(e, t || "default");
      if ("object" !== v4(n)) return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === t ? String : Number)(e);
  }(e, "string");
  return "symbol" === v4(t) ? t : String(t);
}
xJ(function (e) {
  return t.createElement(D1, e, t.createElement(d4, e));
}, {
  $$widgetType: "ais.rangeInput"
});
var P4 = d1("RatingMenu"),
  M4 = t.createElement("path", {
    d: "M12 .288l2.833 8.718h9.167l-7.417 5.389 2.833 8.718-7.416-5.388-7.417 5.388 2.833-8.718-7.416-5.389h9.167z"
  }),
  k4 = t.createElement("path", {
    d: "M12 6.76l1.379 4.246h4.465l-3.612 2.625 1.379 4.246-3.611-2.625-3.612 2.625 1.379-4.246-3.612-2.625h4.465l1.38-4.246zm0-6.472l-2.833 8.718h-9.167l7.416 5.389-2.833 8.718 7.417-5.388 7.416 5.388-2.833-8.718 7.417-5.389h-9.167l-2.833-8.718z"
  }),
  S4 = function (e) {
    !function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t && x4(e, t);
    }(l, i);
    var r,
      n,
      a,
      o = O4(l);
    function l() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, l), o.apply(this, arguments);
    }
    return r = l, n = [{
      key: "onClick",
      value: function (e, t, r) {
        r.preventDefault(), r.stopPropagation(), e === this.props.currentRefinement.min && t === this.props.currentRefinement.max ? this.props.refine({
          min: this.props.min,
          max: this.props.max
        }) : this.props.refine({
          min: e,
          max: t
        });
      }
    }, {
      key: "buildItem",
      value: function (e) {
        for (var r = e.max, n = e.lowerBound, a = e.count, o = e.translate, i = e.createURL, l = e.isLastSelectableItem, s = !a, c = this.props.currentRefinement.min < n, u = l && c || !s && n === this.props.currentRefinement.min && r === this.props.currentRefinement.max, h = [], m = 0, p = 0; p < r; p++) p < n && m++, h.push([t.createElement("svg", {
          key: p,
          className: P4("starIcon", p >= n ? "starIcon--empty" : "starIcon--full"),
          "aria-hidden": "true",
          width: "24",
          height: "24"
        }, t.createElement("use", {
          xlinkHref: "#".concat(P4(p >= n ? "starEmptySymbol" : "starSymbol"))
        })), " "]);
        var f = s || l && u ? {} : {
          href: i({
            min: n,
            max: r
          }),
          onClick: this.onClick.bind(this, n, r)
        };
        return t.createElement("li", {
          key: n,
          className: P4("item", u && "item--selected", s && "item--disabled")
        }, t.createElement("a", w4({
          className: P4("link"),
          "aria-label": "".concat(m).concat(o("ratingLabel"))
        }, f), h, t.createElement("span", {
          className: P4("label"),
          "aria-hidden": "true"
        }, o("ratingLabel")), " ", t.createElement("span", {
          className: P4("count")
        }, a)));
      }
    }, {
      key: "render",
      value: function () {
        var e = this,
          r = this.props,
          n = r.min,
          a = r.max,
          o = r.translate,
          i = r.count,
          l = r.createURL,
          s = r.canRefine,
          c = r.className,
          u = void 0 !== n && n >= 0 ? n : 1,
          h = void 0 !== a && a >= 0 ? a : 0,
          m = h - u + 1,
          p = i.map(function (e) {
            return b4(b4({}, e), {}, {
              value: parseFloat(e.value)
            });
          }).filter(function (e) {
            return e.value >= u && e.value <= h;
          }),
          f = g1({
            start: 0,
            end: Math.max(m, 0)
          }).map(function (e) {
            return b1(p, function (t) {
              return t.value === h - e;
            }) || {
              value: h - e,
              count: 0,
              total: 0
            };
          }).reduce(function (e, t, r) {
            return e.concat(b4(b4({}, t), {}, {
              total: 0 === r ? t.count : e[r - 1].total + t.count
            }));
          }, []).map(function (t, r, n) {
            return e.buildItem({
              lowerBound: t.value,
              count: t.total,
              isLastSelectableItem: n.length - 1 === r,
              max: h,
              translate: o,
              createURL: l
            });
          });
        return t.createElement("div", {
          className: m1(P4("", !s && "-noRefinement"), c)
        }, t.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          style: {
            display: "none"
          }
        }, t.createElement("symbol", {
          id: P4("starSymbol"),
          viewBox: "0 0 24 24"
        }, M4), t.createElement("symbol", {
          id: P4("starEmptySymbol"),
          viewBox: "0 0 24 24"
        }, k4)), t.createElement("ul", {
          className: P4("list", !s && "list--noRefinement")
        }, f));
      }
    }], n && y4(r.prototype, n), a && y4(r, a), Object.defineProperty(r, "prototype", {
      writable: !1
    }), l;
  }();
j4(S4, "propTypes", {
  translate: se.func.isRequired,
  refine: se.func.isRequired,
  createURL: se.func.isRequired,
  min: se.number,
  max: se.number,
  currentRefinement: se.shape({
    min: se.number,
    max: se.number
  }),
  count: se.arrayOf(se.shape({
    value: se.string,
    count: se.number
  })),
  canRefine: se.bool.isRequired,
  className: se.string
}), j4(S4, "defaultProps", {
  className: ""
});
var N4 = KQ({
  ratingLabel: " & Up"
})(S4);
function B4(e) {
  return B4 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, B4(e);
}
function V4(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, I4(n.key), n);
  }
}
function R4(e, t) {
  return R4 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
    return e.__proto__ = t, e;
  }, R4(e, t);
}
function A4(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = H4(e);
    if (t) {
      var a = H4(this).constructor;
      r = Reflect.construct(n, arguments, a);
    } else r = n.apply(this, arguments);
    return function (e, t) {
      if (t && ("object" === B4(t) || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return T4(e);
    }(this, r);
  };
}
function T4(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function H4(e) {
  return H4 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, H4(e);
}
function L4(e, t, r) {
  return (t = I4(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function I4(e) {
  var t = function (e, t) {
    if ("object" !== B4(e) || null === e) return e;
    var r = e[Symbol.toPrimitive];
    if (void 0 !== r) {
      var n = r.call(e, t || "default");
      if ("object" !== B4(n)) return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === t ? String : Number)(e);
  }(e, "string");
  return "symbol" === B4(t) ? t : String(t);
}
xJ(function (e) {
  return t.createElement(D1, e, t.createElement(N4, e));
}, {
  $$widgetType: "ais.ratingMenu"
});
var F4 = d1("RefinementList"),
  _4 = function (e) {
    !function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t && R4(e, t);
    }(l, i);
    var r,
      n,
      a,
      o = A4(l);
    function l() {
      var e;
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, l);
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++) n[a] = arguments[a];
      return L4(T4(e = o.call.apply(o, [this].concat(n))), "state", {
        query: ""
      }), L4(T4(e), "selectItem", function (t, r) {
        r(), e.props.refine(t.value);
      }), L4(T4(e), "renderItem", function (r, n) {
        var a = e.props.isFromSearch ? t.createElement(p2, {
          attribute: "label",
          hit: r
        }) : r.label;
        return t.createElement("label", {
          className: F4("label")
        }, t.createElement("input", {
          className: F4("checkbox"),
          type: "checkbox",
          checked: r.isRefined,
          onChange: function () {
            return e.selectItem(r, n);
          }
        }), t.createElement("span", {
          className: F4("labelText")
        }, a), " ", t.createElement("span", {
          className: F4("count")
        }, r.count.toLocaleString()));
      }), e;
    }
    return r = l, (n = [{
      key: "render",
      value: function () {
        var e = this.props,
          r = e.translate,
          n = e.items,
          a = e.showMore,
          o = e.limit,
          i = e.showMoreLimit,
          l = e.isFromSearch,
          s = e.searchForItems,
          c = e.searchable,
          u = e.canRefine,
          h = e.className;
        return t.createElement(Y0, {
          renderItem: this.renderItem,
          selectItem: this.selectItem,
          cx: F4,
          translate: r,
          items: n,
          showMore: a,
          limit: o,
          showMoreLimit: i,
          isFromSearch: l,
          searchForItems: s,
          searchable: c,
          canRefine: u,
          className: h,
          query: this.state.query
        });
      }
    }]) && V4(r.prototype, n), a && V4(r, a), Object.defineProperty(r, "prototype", {
      writable: !1
    }), l;
  }();
L4(_4, "propTypes", {
  translate: se.func.isRequired,
  refine: se.func.isRequired,
  searchForItems: se.func.isRequired,
  searchable: se.bool,
  createURL: se.func.isRequired,
  items: se.arrayOf(se.shape({
    label: se.string.isRequired,
    value: se.arrayOf(se.string).isRequired,
    count: se.number.isRequired,
    isRefined: se.bool.isRequired
  })),
  isFromSearch: se.bool.isRequired,
  canRefine: se.bool.isRequired,
  showMore: se.bool,
  limit: se.number,
  showMoreLimit: se.number,
  transformItems: se.func,
  className: se.string
}), L4(_4, "defaultProps", {
  className: ""
});
var Z4 = KQ({
  showMore: function (e) {
    return e ? "Show less" : "Show more";
  },
  noResults: "No results",
  submit: null,
  reset: null,
  resetTitle: "Clear the search query.",
  submitTitle: "Submit your search query.",
  placeholder: "Search here…"
})(_4);
function D4(e) {
  return D4 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, D4(e);
}
function q4(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, W4(n.key), n);
  }
}
function U4(e, t) {
  return U4 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
    return e.__proto__ = t, e;
  }, U4(e, t);
}
function $4(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = z4(e);
    if (t) {
      var a = z4(this).constructor;
      r = Reflect.construct(n, arguments, a);
    } else r = n.apply(this, arguments);
    return function (e, t) {
      if (t && ("object" === D4(t) || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }(this, r);
  };
}
function z4(e) {
  return z4 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, z4(e);
}
function W4(e) {
  var t = function (e, t) {
    if ("object" !== D4(e) || null === e) return e;
    var r = e[Symbol.toPrimitive];
    if (void 0 !== r) {
      var n = r.call(e, t || "default");
      if ("object" !== D4(n)) return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === t ? String : Number)(e);
  }(e, "string");
  return "symbol" === D4(t) ? t : String(t);
}
BJ(function (e) {
  return t.createElement(D1, e, t.createElement(Z4, e));
}, {
  $$widgetType: "ais.refinementList"
});
var Q4 = d1("ScrollTo"),
  G4 = function (e) {
    !function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t && U4(e, t);
    }(l, i);
    var r,
      n,
      a,
      o = $4(l);
    function l() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, l), o.apply(this, arguments);
    }
    return r = l, n = [{
      key: "componentDidUpdate",
      value: function (e) {
        var t = this.props,
          r = t.value,
          n = t.hasNotChanged;
        r !== e.value && n && this.el.scrollIntoView();
      }
    }, {
      key: "render",
      value: function () {
        var e = this;
        return t.createElement("div", {
          ref: function (t) {
            return e.el = t;
          },
          className: Q4("")
        }, this.props.children);
      }
    }], n && q4(r.prototype, n), a && q4(r, a), Object.defineProperty(r, "prototype", {
      writable: !1
    }), l;
  }();
function Y4() {
  return Y4 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Y4.apply(this, arguments);
}
!function (e, t, r) {
  (t = W4(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r;
}(G4, "propTypes", {
  value: se.any,
  children: se.node,
  hasNotChanged: se.bool
}), VJ(G4, {
  $$widgetType: "ais.scrollTo"
}), LJ(_0, {
  $$widgetType: "ais.searchBox"
});
var K4 = d1("Snippet"),
  X4 = EX(function (e) {
    return t.createElement(u2, Y4({}, e, {
      highlightProperty: "_snippetResult",
      cx: K4
    }));
  }, {
    $$widgetType: "ais.snippet"
  }),
  J4 = d1("RelevantSort"),
  e5 = function (e) {
    var r = e.isRelevantSorted;
    return t.createElement("span", null, r ? "See all results" : "See relevant results");
  },
  t5 = function (e) {
    var r = e.className,
      n = void 0 === r ? "" : r,
      a = e.isVirtualReplica,
      o = e.isRelevantSorted,
      i = e.buttonTextComponent,
      l = void 0 === i ? e5 : i,
      s = e.textComponent,
      c = e.refine;
    return a ? t.createElement("div", {
      className: m1(J4(""), n)
    }, t.createElement("div", {
      className: J4("text")
    }, s && t.createElement(s, {
      isRelevantSorted: o
    })), t.createElement("button", {
      className: J4("button"),
      onClick: function () {
        return c(o ? 0 : void 0);
      }
    }, t.createElement(l, {
      isRelevantSorted: o
    }))) : null;
  };
function r5(e) {
  return r5 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, r5(e);
}
function n5(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, s5(n.key), n);
  }
}
function a5(e, t) {
  return a5 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
    return e.__proto__ = t, e;
  }, a5(e, t);
}
function o5(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = i5(e);
    if (t) {
      var a = i5(this).constructor;
      r = Reflect.construct(n, arguments, a);
    } else r = n.apply(this, arguments);
    return function (e, t) {
      if (t && ("object" === r5(t) || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }(this, r);
  };
}
function i5(e) {
  return i5 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, i5(e);
}
function l5(e, t, r) {
  return (t = s5(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function s5(e) {
  var t = function (e, t) {
    if ("object" !== r5(e) || null === e) return e;
    var r = e[Symbol.toPrimitive];
    if (void 0 !== r) {
      var n = r.call(e, t || "default");
      if ("object" !== r5(n)) return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === t ? String : Number)(e);
  }(e, "string");
  return "symbol" === r5(t) ? t : String(t);
}
t5.propTypes = {
  buttonTextComponent: se.func,
  className: se.string,
  isVirtualReplica: se.bool.isRequired,
  isRelevantSorted: se.bool.isRequired,
  refine: se.func.isRequired,
  textComponent: se.func
}, _J(t5, {
  $$widgetType: "ais.relevantSort"
});
var c5 = d1("SortBy"),
  u5 = function (e) {
    !function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t && a5(e, t);
    }(l, i);
    var r,
      n,
      a,
      o = o5(l);
    function l() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, l), o.apply(this, arguments);
    }
    return r = l, n = [{
      key: "render",
      value: function () {
        var e = this.props,
          r = e.id,
          n = e.items,
          a = e.currentRefinement,
          o = e.refine,
          i = e.className;
        return t.createElement("div", {
          className: m1(c5(""), i)
        }, t.createElement(M2, {
          id: r,
          cx: c5,
          items: n,
          selectedItem: a,
          onSelect: o
        }));
      }
    }], n && n5(r.prototype, n), a && n5(r, a), Object.defineProperty(r, "prototype", {
      writable: !1
    }), l;
  }();
l5(u5, "propTypes", {
  id: se.string,
  items: se.arrayOf(se.shape({
    label: se.string,
    value: se.string.isRequired
  })).isRequired,
  currentRefinement: se.string.isRequired,
  refine: se.func.isRequired,
  className: se.string
}), l5(u5, "defaultProps", {
  className: ""
}), zJ(u5, {
  $$widgetType: "ais.sortBy"
});
var h5 = d1("Stats"),
  m5 = function (e) {
    var r = e.className,
      n = void 0 === r ? "" : r,
      a = e.areHitsSorted,
      o = e.nbHits,
      i = e.nbSortedHits,
      l = e.processingTimeMS,
      s = e.translate;
    return t.createElement("div", {
      className: m1(h5(""), n)
    }, t.createElement("span", {
      className: h5("text")
    }, s("stats", o, l, i, a)));
  };
m5.propTypes = {
  className: se.string,
  areHitsSorted: se.bool.isRequired,
  nbHits: se.number.isRequired,
  nbSortedHits: se.number,
  processingTimeMS: se.number.isRequired,
  translate: se.func.isRequired
};
var p5 = KQ({
  stats: function (e, t, r, n) {
    return n && e !== r ? "".concat(r.toLocaleString(), " relevant results sorted out of ").concat(e.toLocaleString(), " found in ").concat(t.toLocaleString(), "ms") : "".concat(e.toLocaleString(), " results found in ").concat(t.toLocaleString(), "ms");
  }
})(m5);
QJ(p5, {
  $$widgetType: "ais.stats"
});
var f5 = d1("ToggleRefinement"),
  d5 = function (e) {
    var r = e.currentRefinement,
      n = e.label,
      a = e.canRefine,
      o = e.refine,
      i = e.className;
    return t.createElement("div", {
      className: m1(f5("", !a && "-noRefinement"), i)
    }, t.createElement("label", {
      className: f5("label")
    }, t.createElement("input", {
      className: f5("checkbox"),
      type: "checkbox",
      checked: r,
      onChange: function (e) {
        return o(e.target.checked);
      }
    }), t.createElement("span", {
      className: f5("labelText")
    }, n)));
  };
function v5(e) {
  return v5 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, v5(e);
}
function g5(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function b5(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? g5(Object(r), !0).forEach(function (t) {
      w5(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : g5(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
function w5(e, t, r) {
  return (t = function (e) {
    var t = function (e, t) {
      if ("object" !== v5(e) || null === e) return e;
      var r = e[Symbol.toPrimitive];
      if (void 0 !== r) {
        var n = r.call(e, t || "default");
        if ("object" !== v5(n)) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === t ? String : Number)(e);
    }(e, "string");
    return "symbol" === v5(t) ? t : String(t);
  }(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function y5(e) {
  var t,
    r = e.searchAsYouSpeak,
    n = e.language,
    a = e.onQueryChange,
    o = e.onStateChange,
    i = window.webkitSpeechRecognition || window.SpeechRecognition,
    l = function (e) {
      return {
        status: e,
        transcript: "",
        isSpeechFinal: !1,
        errorCode: void 0
      };
    },
    s = l("initial"),
    c = function () {
      return Boolean(i);
    },
    u = function () {
      return "askingPermission" === s.status || "waiting" === s.status || "recognizing" === s.status;
    },
    h = function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      s = b5(b5({}, s), e), o();
    },
    m = function () {
      h(l(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "initial"));
    },
    p = function () {
      h({
        status: "waiting"
      });
    },
    f = function (e) {
      h({
        status: "error",
        errorCode: e.error
      });
    },
    d = function (e) {
      h({
        status: "recognizing",
        transcript: e.results[0] && e.results[0][0] && e.results[0][0].transcript || "",
        isSpeechFinal: e.results[0] && e.results[0].isFinal
      }), r && s.transcript && a(s.transcript);
    },
    v = function () {
      s.errorCode || !s.transcript || r || a(s.transcript), "error" !== s.status && h({
        status: "finished"
      });
    },
    g = function () {
      t && (t.stop(), t.removeEventListener("start", p), t.removeEventListener("error", f), t.removeEventListener("result", d), t.removeEventListener("end", v), t = void 0);
    };
  return {
    getState: function () {
      return s;
    },
    isBrowserSupported: c,
    isListening: u,
    toggleListening: function () {
      c() && (u() ? (g(), m("finished")) : (t = new i()) && (m("askingPermission"), t.interimResults = !0, n && (t.lang = n), t.addEventListener("start", p), t.addEventListener("error", f), t.addEventListener("result", d), t.addEventListener("end", v), t.start()));
    },
    dispose: g
  };
}
function x5(e) {
  return x5 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, x5(e);
}
function O5(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, k5(n.key), n);
  }
}
function E5(e, t) {
  return E5 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
    return e.__proto__ = t, e;
  }, E5(e, t);
}
function j5(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P5(e);
    if (t) {
      var a = P5(this).constructor;
      r = Reflect.construct(n, arguments, a);
    } else r = n.apply(this, arguments);
    return function (e, t) {
      if (t && ("object" === x5(t) || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return C5(e);
    }(this, r);
  };
}
function C5(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function P5(e) {
  return P5 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, P5(e);
}
function M5(e, t, r) {
  return (t = k5(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function k5(e) {
  var t = function (e, t) {
    if ("object" !== x5(e) || null === e) return e;
    var r = e[Symbol.toPrimitive];
    if (void 0 !== r) {
      var n = r.call(e, t || "default");
      if ("object" !== x5(n)) return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === t ? String : Number)(e);
  }(e, "string");
  return "symbol" === x5(t) ? t : String(t);
}
d5.propTypes = {
  currentRefinement: se.bool.isRequired,
  label: se.string.isRequired,
  canRefine: se.bool.isRequired,
  refine: se.func.isRequired,
  className: se.string
}, d5.defaultProps = {
  className: ""
}, r1(d5, {
  $$widgetType: "ais.toggleRefinement"
});
var S5 = d1("VoiceSearch"),
  N5 = function (e) {
    var r = e.children;
    return t.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "16",
      height: "16",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, r);
  },
  B5 = t.createElement(N5, null, t.createElement("line", {
    x1: "1",
    y1: "1",
    x2: "23",
    y2: "23"
  }), t.createElement("path", {
    d: "M9 9v3a3 3 0 0 0 5.12 2.12M15 9.34V4a3 3 0 0 0-5.94-.6"
  }), t.createElement("path", {
    d: "M17 16.95A7 7 0 0 1 5 12v-2m14 0v2a7 7 0 0 1-.11 1.23"
  }), t.createElement("line", {
    x1: "12",
    y1: "19",
    x2: "12",
    y2: "23"
  }), t.createElement("line", {
    x1: "8",
    y1: "23",
    x2: "16",
    y2: "23"
  })),
  V5 = t.createElement("path", {
    d: "M19 10v2a7 7 0 0 1-14 0v-2"
  }),
  R5 = t.createElement("line", {
    x1: "12",
    y1: "19",
    x2: "12",
    y2: "23"
  }),
  A5 = t.createElement("line", {
    x1: "8",
    y1: "23",
    x2: "16",
    y2: "23"
  }),
  T5 = function (e) {
    !function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t && E5(e, t);
    }(l, i);
    var r,
      n,
      a,
      o = j5(l);
    function l() {
      var e;
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, l);
      for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++) r[n] = arguments[n];
      return M5(C5(e = o.call.apply(o, [this].concat(r))), "voiceSearchHelper", void 0), M5(C5(e), "onClick", function (t) {
        e.voiceSearchHelper && (t.currentTarget.blur(), (0, e.voiceSearchHelper.toggleListening)());
      }), e;
    }
    return r = l, (n = [{
      key: "componentDidMount",
      value: function () {
        var e = this,
          t = this.props,
          r = t.searchAsYouSpeak,
          n = void 0 !== r && r,
          a = t.language,
          o = t.refine;
        this.voiceSearchHelper = y5({
          searchAsYouSpeak: n,
          language: a,
          onQueryChange: function (e) {
            return o(e);
          },
          onStateChange: function () {
            e.setState(e.voiceSearchHelper.getState());
          }
        }), this.setState(this.voiceSearchHelper.getState());
      }
    }, {
      key: "render",
      value: function () {
        if (!this.voiceSearchHelper) return null;
        var e = this.state,
          r = e.status,
          n = e.transcript,
          a = e.isSpeechFinal,
          o = e.errorCode,
          i = this.voiceSearchHelper,
          l = i.isListening,
          s = i.isBrowserSupported,
          c = this.props,
          u = c.translate,
          h = c.buttonTextComponent,
          m = c.statusComponent,
          p = {
            status: r,
            errorCode: o,
            isListening: l(),
            transcript: n,
            isSpeechFinal: a,
            isBrowserSupported: s()
          };
        return t.createElement("div", {
          className: S5("")
        }, t.createElement("button", {
          className: S5("button"),
          type: "button",
          title: s() ? u("buttonTitle") : u("disabledButtonTitle"),
          onClick: this.onClick,
          disabled: !s()
        }, t.createElement(h, p)), t.createElement("div", {
          className: S5("status")
        }, t.createElement(m, p)));
      }
    }, {
      key: "componentWillUnmount",
      value: function () {
        this.voiceSearchHelper && this.voiceSearchHelper.dispose();
      }
    }]) && O5(r.prototype, n), a && O5(r, a), Object.defineProperty(r, "prototype", {
      writable: !1
    }), l;
  }();
M5(T5, "defaultProps", {
  searchAsYouSpeak: !1,
  buttonTextComponent: function (e) {
    var r = e.status,
      n = e.errorCode,
      a = e.isListening;
    return "error" === r && "not-allowed" === n ? B5 : t.createElement(N5, null, t.createElement("path", {
      d: "M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z",
      fill: a ? "currentColor" : ""
    }), V5, R5, A5);
  },
  statusComponent: function (e) {
    var r = e.transcript;
    return t.createElement("p", null, r);
  }
}), u1(KQ({
  buttonTitle: "Search by voice",
  disabledButtonTitle: "Search by voice (not supported on this browser)"
})(T5), {
  $$widgetType: "ais.voiceSearch"
});
var H5 = d1("QueryRuleCustomData"),
  L5 = function (e) {
    var r = e.items,
      n = e.className,
      a = e.children;
    return t.createElement("div", {
      className: m1(H5(""), n)
    }, a({
      items: r
    }));
  };
L5.propTypes = {
  items: se.arrayOf(se.object).isRequired,
  className: se.string,
  children: se.func.isRequired
};
cK(function (e) {
  return t.createElement(D1, e, t.createElement(L5, e));
}, {
  $$widgetType: "ais.queryRuleCustomData"
});
const I5 = ["AI ", "GraphQL", "Actions", "Authentication", "React", "Remote Joins", "Postgres"];
var F5 = LJ(_ref11 => {
  let {
    refine: e,
    currentRefinement: o,
    className: i,
    delay: l = 500,
    isSearchStalled: s
  } = _ref11;
  const [c, u] = r(o),
    h = n(),
    m = n();
  a(() => {
    var _m$current;
    (_m$current = m.current) === null || _m$current === void 0 ? void 0 : _m$current.focus();
  }, []);
  return t.createElement("div", {
    className: " sticky -top-20 tb-m:-top-20 z-10 py-8 pt-16 tb-m:pt-16 tb-m:py-9 bg-neutral-100"
  }, t.createElement("div", {
    className: "flex relative items-center w-full"
  }, t.createElement("div", {
    className: "absolute left-2"
  }, s ? t.createElement("div", {
    className: "loader-spin border-[3px] border-neutral-400 border-t-blue-500 w-5 h-5 rounded-full"
  }) : t.createElement(mz, {
    height: "w-8 h-8 stroke-[1.5px]",
    variant: "searchsm",
    strokeClass: "stroke-neutral-800"
  })), t.createElement("form", {
    className: "".concat(i, " w-full"),
    onSubmit: e => e.preventDefault()
  }, t.createElement("input", {
    id: "search-input",
    ref: m,
    className: "shodow-none bg-neutral-100 w-full font-bold indent-8 tb-m:indent-11 text-2xl tb-m:text-4xl text-neutral-800 placeholder:text-neutral-800 rounded-xl border-0 h-12 focus:border-0 focus:shadow-[none] focus:border-neutral-0 tb:text-2xl",
    type: "text",
    placeholder: "Search for tutorials, articles or docs",
    "aria-label": "Search",
    onChange: t => {
      const r = t.target.value;
      clearTimeout(h.current), h.current = setTimeout(() => e(r), l), u(r);
    },
    value: c
  })), t.createElement("div", {
    onClick: () => {
      e(""), u("");
    },
    className: "absolute right-2 cursor-pointer rounded-md"
  }, t.createElement(mz, {
    height: "w-6 h-6 stroke-[1.5px]",
    variant: "xclose",
    strokeClass: "stroke-neutral-800"
  }))), t.createElement("div", {
    className: "tb:flex flex-wrap items-center mt-4"
  }, I5.map(r => t.createElement("button", {
    key: r,
    className: "px-2 py-[2px] text-blue-800 border rounded-[100px] m-1 " + (o === r ? "border-blue-300 hover:bg-blue-300 bg-blue-300" : "bg-blue-200 hover:bg-blue-300 border-blue-200"),
    onClick: () => {
      return e(t = r), void u(t);
      var t;
    }
  }, t.createElement(ce, {
    textStyle: "body2c-medium"
  }, r)))));
});
const _5 = Object.freeze({
    All: "All",
    blog: "blog",
    docs: "docs",
    learn: "learn"
  }),
  Z5 = [{
    name: "blog-production",
    title: "Hasura Blog",
    type: _5.blog
  }, {
    name: "graphql-docs-prod",
    title: "Hasura GraphQL Engine Docs",
    type: _5.docs
  }, {
    name: "learn-intro-graphql",
    title: "Learn Intro GraphQL",
    type: _5.learn
  }, {
    name: "learn-intro-graphql-zh",
    title: "Learn Intro GraphQL",
    type: _5.learn
  }, {
    name: "learn-elm-graphql",
    title: "Learn ELM GraphQl",
    type: _5.learn
  }, {
    name: "learn-flutter-graphql",
    title: "Learn Flutter GraphQL",
    type: _5.learn
  }, {
    name: "learn-database-mysql",
    title: "Learn Database MySQL",
    type: _5.learn
  }, {
    name: "learn-database-postgresql",
    title: "Learn Database PostgreSQL",
    type: _5.learn
  }, {
    name: "learn-hasura-backend",
    title: "Learn Hasura Backend",
    type: _5.learn
  }, {
    name: "learn-hasura-backend-ja",
    title: "Learn Hasura Backend",
    type: _5.learn
  }, {
    name: "learn-hasura-backend-zh",
    title: "Learn Hasura Backend",
    type: _5.learn
  }, {
    name: "learn-hasura-backend-advanced",
    title: "Learn Hasura Backend Advanced",
    type: _5.learn
  }, {
    name: "learn-hasura-auth-slack",
    title: "Learn Hasura Auth Slack",
    type: _5.learn
  }, {
    name: "learn-react-apollo-hooks",
    title: "Learn React Apollo Hooks",
    type: _5.learn
  }, {
    name: "learn-react-apollo",
    title: "Learn React Apollo",
    type: _5.learn
  }, {
    name: "learn-typescript-react-apollo",
    title: "Learn TypeScript React Apollo",
    type: _5.learn
  }, {
    name: "learn-angular-apollo",
    title: "Learn Angular Apollo",
    type: _5.learn
  }, {
    name: "learn-vue-apollo",
    title: "Learn Vue Apollo",
    type: _5.learn
  }, {
    name: "learn-ios-apollo",
    title: "Learn IOS Apollo",
    type: _5.learn
  }, {
    name: "learn-svelte-apollo",
    title: "Learn Svelte Apollo",
    type: _5.learn
  }, {
    name: "learn-android-apollo",
    title: "Learn Android Apollo",
    type: _5.learn
  }, {
    name: "learn-react-native-apollo",
    title: "Learn React Native Apollo",
    type: _5.learn
  }, {
    name: "learn-reason-react-apollo",
    title: "Learn Reason React Apollo",
    type: _5.learn
  }, {
    name: "learn-database-mssql",
    title: "Learn MicrosoftSQL",
    type: _5.learn
  }],
  D5 = () => t.createElement(l, null, t.createElement("hr", {
    className: "my-8 border-t-neutral-200"
  }), t.createElement("div", {
    className: "mt-10 flex flex-wrap justify-between"
  }, t.createElement("div", {
    className: "community-links-wrapper"
  }, t.createElement("p", null, "Unable to find what you're looking for?"), t.createElement("p", null, "Reach out to our", " ", t.createElement("a", {
    className: "text-blue-500 hover:text-blue-700",
    href: "https://discord.com/invite/hasura",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Discord Community"), " ", "or start a", " ", t.createElement("a", {
    className: "text-blue-500 hover:text-blue-700",
    href: "https://github.com/hasura/graphql-engine/discussions",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Discussion on GitHub"))), t.createElement(a4, null))),
  q5 = WJ(_ref12 => {
    let {
      searchResults: e,
      indexTitle: r,
      showSeparator: n,
      allIndex: a
    } = _ref12;
    return (e && e.nbHits) > 0 ? t.createElement(l, null, n && t.createElement("hr", {
      className: "my-8 border-t-neutral-200"
    }), t.createElement(ce, {
      textStyle: "sub1",
      className: "pb-4 pl-2 flex items-center text-neutral-800 font-normal sticky tb-m:z-0 top-[170px] tb:top-[160px] tb-m:top-[120px] bg-neutral-100"
    }, "Hasura Blog" === r ? t.createElement(mz, {
      height: "block w-6 mr-3 h-6 stroke-[2px] transition ease-in-out",
      variant: "pentool02",
      strokeClass: "stroke-blue-500"
    }) : "Hasura GraphQL Engine Docs" === r ? t.createElement(mz, {
      height: "block w-6 mr-3 h-6 stroke-[2px] transition ease-in-out",
      variant: "file02",
      strokeClass: "stroke-blue-500"
    }) : t.createElement(mz, {
      height: "block w-6 mr-3 h-6 stroke-[2px] transition ease-in-out",
      variant: "graduationhat01",
      strokeClass: "stroke-blue-500"
    }), r)) : null;
  }),
  U5 = _ref13 => {
    let {
      hit: e,
      indexType: r
    } = _ref13;
    return t.createElement("a", {
      href: e.url,
      className: "grid h-full"
    }, t.createElement("div", {
      className: "self-start"
    }, r === _5.docs ? t.createElement("div", {
      className: "flex items-start"
    }, t.createElement("div", {
      className: "w-6 h-6 mr-2 min-w-[24px] flex items-center justify-center"
    }, t.createElement("div", {
      className: "w-3 h-3 rounded-full bg-blue-500"
    })), t.createElement("div", null, !!e.hierarchy && t.createElement(ce, {
      textStyle: "body1c-bold",
      className: "font-bold flex items-start pb-3"
    }, "".concat(Object.values(e.hierarchy).filter(e => !!e).reverse()[0])), t.createElement(ce, {
      textStyle: "body2",
      className: "text-neutral-800 word-break"
    }, t.createElement(X4, {
      attribute: "content",
      hit: e,
      tagName: "mark"
    })))) : t.createElement("div", {
      className: "flex items-start"
    }, t.createElement("div", {
      className: "w-6 h-6 mr-2 min-w-[24px] flex items-center justify-center"
    }, t.createElement("div", {
      className: "w-3 h-3 rounded-full bg-blue-500"
    })), t.createElement("div", null, t.createElement(ce, {
      textStyle: "body1c-bold",
      className: "font-bold text-neutral-800 pb-3"
    }, t.createElement(p2, {
      attribute: "title",
      hit: e,
      tagName: "mark"
    })), t.createElement(ce, {
      textStyle: "body2",
      className: "text-neutral-800 word-break"
    }, t.createElement(X4, {
      attribute: "excerpt",
      hit: e,
      tagName: "mark"
    }))))), e.url ? t.createElement(ce, {
      textStyle: "body3",
      className: "self-end pl-8 pt-3 text-neutral-500"
    }, t.createElement("span", {
      className: "hit-slug word-break"
    }, e.url.replace("https://hasura.io/", "/"))) : null);
  },
  $5 = _ref14 => {
    let {
      indexType: e
    } = _ref14;
    return void 0 === _5[e] ? null : t.createElement(b2, {
      className: "Hits",
      hitComponent: r => t.createElement(U5, dz({}, r, {
        indexType: e
      }))
    });
  },
  z5 = _ref15 => {
    let {
      index: e,
      show: r
    } = _ref15;
    return t.createElement(xK, {
      indexName: e.name
    }, r && t.createElement(l, null, t.createElement(q5, {
      indexTitle: e.title,
      showSeparator: e.type !== _5.blog,
      allIndex: e.type
    }), t.createElement($5, {
      indexType: e.type
    })));
  },
  W5 = _ref16 => {
    let {
      children: e,
      indices: r,
      className: n,
      id: a,
      wrapperRef: o,
      activeIndexTypes: i
    } = _ref16;
    return t.createElement("div", {
      id: a,
      className: "".concat(n, " search-results clear-both"),
      ref: o
    }, e && e, r.map(e => t.createElement(z5, {
      index: e,
      key: e.name,
      show: i[e.type]
    })), t.createElement(D5, null));
  },
  Q5 = WJ(_ref17 => {
    let {
      allSearchResults: e,
      children: r,
      indices: n,
      searchState: a,
      searching: o
    } = _ref17;
    if (!(a !== null && a !== void 0 && a.query)) return null;
    const i = e && Object.values(e).some(e => e.nbHits > 0);
    return i ? r : t.createElement("div", null, t.createElement("div", null, o ? t.createElement("span", null, 'Searching for "', t.createElement("em", null, a === null || a === void 0 ? void 0 : a.query), '"') : t.createElement("span", null, 'No results for "', t.createElement("em", null, a === null || a === void 0 ? void 0 : a.query), '"')), n.map(e => t.createElement(xK, {
      indexName: e.name,
      key: e.name
    })), t.createElement(D5, null));
  });
let G5 = !0;
const Y5 = _ref18 => {
  let {
    activeIndexTypes: e,
    setActiveIndexTypes: n
  } = _ref18;
  const [a, o] = r(!1),
    i = t => {
      if (t === _5.All) {
        G5 = !0;
        const t = Object.keys(e).reduce((e, t) => (e[t] = !0, e), {});
        n(t);
      } else {
        G5 = !1;
        const r = Object.keys(e).reduce((e, t) => (e[t] = !1, e), {});
        n(r), n(e => ({
          ...e,
          [t]: !e[t]
        }));
      }
      o(!1);
    };
  return t.createElement("div", {
    className: "relative"
  }, t.createElement("div", {
    className: "tb-m:min-w-[182px] static tb-m:sticky top-[116px] self-start"
  }, t.createElement("ul", {
    className: "hds-hidden tb-m:block bg-neutral-0 shadow-md p-4 rounded-2xl"
  }, Object.values(_5).map(r => t.createElement("li", {
    key: r,
    className: "flex items-center mb-2 last:mb-0 tb-m:mr-0 py-0"
  }, t.createElement("button", {
    onClick: () => i(r),
    className: "capitalize cursor-pointer py-1 px-3 w-full text-left rounded-full text-neutral-500 ".concat(e[r] && "All" === r ? "bg-blue-500 " : "", " ").concat(e[r] && !G5 ? "bg-blue-500" : "", " ")
  }, t.createElement(ce, {
    textStyle: "body3c-medium",
    className: "".concat(e[r] && "All" === r ? "text-neutral-0 " : "", " ").concat(e[r] && !G5 ? "text-neutral-0" : "", " ")
  }, r)))))), t.createElement("div", {
    className: "relative hds-hidden-tbm"
  }, t.createElement("button", {
    onClick: () => o(!a),
    className: "capitalize cursor-pointer py-1 px-3 w-full border border-neutral-800 text-left rounded-full text-neutral-800 bg-transparent"
  }, Object.values(_5).find(t => e[t]) || "All"), a && t.createElement("ul", {
    className: "absolute top-full left-0 w-full bg-neutral-0 shadow-md z-[20] p-2 rounded-3xl mt-1"
  }, Object.values(_5).map(r => t.createElement("li", {
    key: r,
    onClick: () => i(r),
    className: "capitalize cursor-pointer py-2 px-4 " + (e[r] ? "text-neutral-1000  " : "text-neutral-500")
  }, r)))));
};
function K5(_ref19) {
  let {
    indices: e,
    ...o
  } = _ref19;
  let i, l;
  o.ALGOLIA_APP_ID && o.ALGOLIA_SEARCH_KEY && (i = o.ALGOLIA_APP_ID, l = o.ALGOLIA_SEARCH_KEY);
  const s = QW(i, l),
    c = {
      ...s,
      search: e => e.every(_ref20 => {
        let {
          params: e
        } = _ref20;
        return !e.query;
      }) ? Promise.resolve({
        results: e.map(() => ({
          hits: [],
          nbHits: 0,
          nbPages: 0,
          processingTimeMS: 0
        }))
      }) : s.search(e)
    },
    u = Object.values(_5).reduce((e, t) => (e[t] = !0, e), {}),
    h = n(null),
    [m, p] = r(u);
  return a(() => {
    p(u);
  }, []), t.createElement(XK, {
    searchClient: c,
    indexName: e[0].name,
    onSearchStateChange: () => p(u)
  }, t.createElement(F5, null), t.createElement(Q5, {
    indices: e
  }, t.createElement("div", {
    className: "tb-m:flex gap-10"
  }, t.createElement("div", {
    className: "hds-hidden tb-m:flex"
  }, t.createElement(Y5, {
    activeIndexTypes: m,
    setActiveIndexTypes: p
  })), t.createElement(W5, {
    id: "search-results",
    indices: e,
    wrapperRef: h,
    activeIndexTypes: m,
    className: "search-results"
  }, t.createElement("div", {
    className: "hds-hidden-tbm sticky top-[124px] tb:top-[114px] z-10 bg-neutral-100 pb-3"
  }, t.createElement(Y5, {
    activeIndexTypes: m,
    setActiveIndexTypes: p
  }))))));
}
function X5(_ref21) {
  let {
    showSearch: e,
    onCloseSearch: r,
    ...n
  } = _ref21;
  return a(() => (e && (document.body.style.overflow = "hidden"), () => {
    document.body.style.overflow = "unset";
  }), [e]), e ? t.createElement("div", {
    className: "fixed left-0 top-0 w-full h-full z-[10000] bg-neutral-100"
  }, t.createElement("div", {
    className: "absolute top-4 right-4 cursor-pointer z-[11]",
    onClick: r
  }, t.createElement(mz, {
    height: "w-8 h-8 stroke-[1.5px]",
    variant: "xclose",
    strokeClass: "stroke-neutral-800"
  })), t.createElement("div", {
    className: "py-20 overflow-y-auto h-full w-full bg-neutral-100"
  }, t.createElement("div", {
    className: "px-4"
  }, t.createElement("div", {
    className: "max-w-7xl mx-auto"
  }, t.createElement("div", {
    className: "w-full"
  }, t.createElement(K5, dz({
    indices: Z5
  }, n))))))) : null;
}
const J5 = _ref22 => {
  let {
    text: e
  } = _ref22;
  const [t, n] = r(!1);
  return React.createElement("div", {
    className: "relative bg-white rounded-md shadow-md p-4 border bg-storybook-default-heading"
  }, React.createElement("p", {
    className: "code-md whitespace-pre-wrap font-medium  text-neutral-100"
  }, e), React.createElement("button", {
    className: " code-md absolute bottom-0 right-0 border px-4 py-4 bg-neutral-100 text-storybook-default-heading rounded hover:bg-blue-100 focus:bg-blue-100 focus:outline-none",
    onClick: async () => {
      try {
        await navigator.clipboard.writeText(e), n(!0), setTimeout(() => {
          n(!1);
        }, 2e3);
      } catch (e) {
        console.error("Failed to copy text: ", e);
      }
    }
  }, t ? "Copied!" : "Copy"));
};
function e8(e) {
  const [n, o] = r(!1),
    i = e => {
      if ("/" === e.key || "Escape" === e.key) {
        if (e.preventDefault(), "/" === e.key) return o(!0);
        if ("Escape" === e.key) return l();
      }
      return null;
    };
  a(() => (document.addEventListener("keydown", i), () => {
    document.removeEventListener("keydown", i);
  }), []);
  const l = () => o(!1);
  return t.createElement(t.Fragment, null, t.createElement("div", {
    className: ""
  }, t.createElement("div", {
    className: "max-w-7xl mx-auto"
  }, t.createElement("div", {
    className: "w-full cursor-pointer gap-0.5 flex items-center",
    onClick: () => {
      o(e => !e);
    }
  }, t.createElement("p", {
    className: e !== null && e !== void 0 && e.isDarkMode ? "-mt-1 text-neutral-0" : "-mt-1"
  }, "/", " "), t.createElement(mz, {
    height: "h-4 w-4 stroke-2",
    variant: "searchsm",
    strokeClass: e !== null && e !== void 0 && e.isDarkMode ? "stroke-neutral-0" : "stroke-neutral-1000"
  })))), t.createElement(X5, dz({
    showSearch: n,
    onCloseSearch: l
  }, e)));
}
const t8 = e => {
    for (var t = e + "=", r = document.cookie.split(";"), n = 0; n < r.length; n++) {
      for (var a = r[n]; " " === a.charAt(0);) a = a.substring(1, a.length);
      if (0 === a.indexOf(t)) return a.substring(t.length, a.length);
    }
    return "";
  },
  r8 = () => ({
    utm_campaign: t8("utm_campaign"),
    utm_medium: t8("utm_medium"),
    utm_source: t8("utm_source"),
    utm_content: t8("utm_content")
  });
function n8(_ref23, s) {
  let {
    formId: e,
    onSubmitCB: o,
    styleClass: i,
    hasuraConRegSuccessUrl: l
  } = _ref23;
  const c = "undefined" != typeof window,
    [u, h] = r(!1),
    m = n(null);
  function p(_ref24) {
    var _r$find, _window, _window$analytics, _window2, _window2$analytics;
    let {
      detail: e
    } = _ref24;
    const {
        form_id: t,
        data: r
      } = e,
      n = (_r$find = r.find(e => "email" === e.type)) === null || _r$find === void 0 ? void 0 : _r$find.value;
    n && c && (_window = window) !== null && _window !== void 0 && (_window$analytics = _window.analytics) !== null && _window$analytics !== void 0 && _window$analytics.identify(n, {
      email: n,
      identifiedBy: "Paperform ".concat(t, " Submitted")
    }), c && (_window2 = window) !== null && _window2 !== void 0 && (_window2$analytics = _window2.analytics) !== null && _window2$analytics !== void 0 && _window2$analytics.track("form submit", {
      data: r,
      category: "website",
      label: "Paperform ".concat(t, " Submitted"),
      action: "form submit"
    }), "function" == typeof o && o(e), window.location.reload("".concat(window.location.pathname, "?aliId=success_submit"));
  }
  return a(() => {
    if (document.getElementById("paperform_embed")) return void h(!0);
    const e = document.createElement("script");
    return e.id = "paperform_embed", e.src = "https://forms.hasura.io/__embed.min.js", e.onreadystatechange = () => {
      "complete" !== this.readyState && "loaded" !== this.readyState || h(!0);
    }, e.onload = () => h(!0), document.body.prepend(e), () => e.remove();
  }, []), a(() => {
    const e = m.current,
      t = r8();
    return c && e !== null && e !== void 0 && e.setAttribute("data-prefill", "utm_landing-page=".concat(window.location.pathname, "&utm_search=").concat(window.location.search, "&utm_campaign=").concat(t.utm_campaign, "&utm_medium=").concat(t.utm_medium, "&utm_source=").concat(t.utm_source, "&utm_content=").concat(t.utm_content)), e !== null && e !== void 0 && e.addEventListener("PaperformSubmission", p), () => e === null || e === void 0 ? void 0 : e.removeEventListener("PaperformSubmission", p);
  }, []), t.createElement("div", {
    className: i
  }, !u && t.createElement(ce, {
    textStyle: "h5",
    as: "h5",
    className: "text-neutral-800 font-medium py-8 tb:py-12"
  }, "Loading..."), t.createElement("div", {
    "data-prefill-inherit": "1",
    "data-no-scroll": "1",
    ref: m,
    id: e,
    "data-paperform-id": e,
    "data-spinner": "1"
  }));
}
const a8 = u(_ref25 => {
  let {
    formId: e,
    styleClass: t
  } = _ref25;
  return (_ref26 => {
    let {
      formId: e,
      callback: t
    } = _ref26;
    const [n, o] = r(!1),
      [i, l] = r(!1);
    a(() => {
      if (n) i || (MktoForms2.loadForm("//page.hasura.io", "631-HMN-492", e, t), l(!0));else {
        const e = document.createElement("script");
        e.defer = !0, e.onload = () => {
          var _window3;
          return (_window3 = window) !== null && _window3 !== void 0 && _window3.MktoForms2 ? o(!0) : null;
        }, e.src = "//page.hasura.io/js/forms2/js/forms2.min.js", document.head.appendChild(e);
      }
    }, [n]);
  })({
    formId: e,
    callback: () => {}
  }), React.createElement("form", {
    id: "mktoForm_".concat(e),
    className: "mktoForm marketoFormWrapper eventDetailsFormWrapper"
  });
});
function o8(_ref27) {
  let {
    wordArray: e
  } = _ref27;
  const [n, a] = r(""),
    [o, i] = r([]);
  return t.createElement("div", null, t.createElement("input", {
    type: "text",
    placeholder: "Search...",
    value: n,
    onChange: t => {
      const r = t.target.value.toLowerCase();
      a(r);
      const n = (o = r, e.filter(e => e.toLowerCase().includes(o)));
      var o;
      i(n);
    }
  }), t.createElement("div", {
    id: "results"
  }, o.map((e, r) => t.createElement("div", {
    key: r
  }, e))));
}
function i8(e, t) {
  const r = function (e) {
      const t = {};
      for (const r of e) {
        const e = Object.keys(r)[0],
          n = r[e];
        for (const r of n) t[r] || (t[r] = new Set()), t[r].add(e);
      }
      return t;
    }(e),
    n = e.find(e => e[t]),
    a = new Set(),
    o = new Set();
  if (n) for (const e of n[t]) {
    const n = r[e];
    n && n.forEach(e => {
      e !== t && a.add(e);
    });
  }
  for (const t of e) {
    const e = Object.keys(t)[0];
    o.add(e);
  }
  const i = [...o].filter(e => !a.has(e));
  return [...a, ...i];
}
a8.propTypes = {
  formId: se.string.isRequired
};
const l8 = _ref28 => {
  let {
    imageFile: e,
    altText: r,
    size: n
  } = _ref28;
  const [a, o] = t.useState("");
  return t.useEffect(() => {
    const t = new FileReader();
    e && e.size > 0 && (t.readAsDataURL(e), t.onload = () => {
      o(t.result);
    });
  }, [e]), t.createElement("div", {
    className: "w-[".concat(n, "px] h-[").concat(n, "px] rounded-full overflow-hidden")
  }, t.createElement("img", {
    src: "https://figma-alpha-api.s3.us-west-2.amazonaws.com/images/0b1d8059-e01d-44c2-957c-35370511501b",
    alt: r,
    className: " rounded-full w-12 h-12} object-cover"
  }));
};
l8.defaultProps = {
  size: "12"
};
const s8 = {
    xs: "h-6 w-6 text-xs-medium",
    sm: "h-8 w-8 text-sm-medium",
    md: "h-10 w-10 text-md-medium",
    lg: "h-12 w-12 text-lg-medium",
    xl: "h-[60px] w-[60px] text-xl-medium"
  },
  c8 = {
    xs: "h-4",
    sm: "h-5",
    md: "h-6",
    lg: "h-7",
    xl: "h-9"
  };
function u8(_ref29) {
  let {
    size: e
  } = _ref29;
  return t.createElement("div", null, t.createElement("span", {
    className: "".concat(s8["".concat(e)], " inline-flex items-center justify-center shadow rounded-full bg-neutral-100 border-[1.5px] border-neutral-0 overflow-hidden")
  }, t.createElement(mz, {
    height: "".concat(c8["".concat(e)]),
    variant: "user03",
    strokeColor: "#1F2A37"
  })));
}
function h8() {
  return t.createElement(t.Fragment, null, t.createElement("div", {
    className: "flex -space-x-1 overflow-hidden"
  }, t.createElement("img", {
    className: "inline-block h-6 w-6 rounded-full ring-2 ring-white",
    src: "https://images.unsplash.com/photo-1491528323818-fdd1faba62cc?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    alt: ""
  }), t.createElement("img", {
    className: "inline-block h-6 w-6 rounded-full ring-2 ring-white",
    src: "https://images.unsplash.com/photo-1550525811-e5869dd03032?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    alt: ""
  }), t.createElement("img", {
    className: "inline-block h-6 w-6 rounded-full ring-2 ring-white",
    src: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2.25&w=256&h=256&q=80",
    alt: ""
  }), t.createElement("img", {
    className: "inline-block h-6 w-6 rounded-full ring-2 ring-white",
    src: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    alt: ""
  })), t.createElement("div", {
    className: "flex -space-x-2 overflow-hidden"
  }, t.createElement("img", {
    className: "inline-block h-8 w-8 rounded-full ring-2 ring-white",
    src: "https://images.unsplash.com/photo-1491528323818-fdd1faba62cc?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    alt: ""
  }), t.createElement("img", {
    className: "inline-block h-8 w-8 rounded-full ring-2 ring-white",
    src: "https://images.unsplash.com/photo-1550525811-e5869dd03032?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    alt: ""
  }), t.createElement("img", {
    className: "inline-block h-8 w-8 rounded-full ring-2 ring-white",
    src: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2.25&w=256&h=256&q=80",
    alt: ""
  }), t.createElement("img", {
    className: "inline-block h-8 w-8 rounded-full ring-2 ring-white",
    src: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    alt: ""
  })), t.createElement("div", {
    className: "flex -space-x-2 overflow-hidden"
  }, t.createElement("img", {
    className: "inline-block h-10 w-10 rounded-full ring-2 ring-white",
    src: "https://images.unsplash.com/photo-1491528323818-fdd1faba62cc?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    alt: ""
  }), t.createElement("img", {
    className: "inline-block h-10 w-10 rounded-full ring-2 ring-white",
    src: "https://images.unsplash.com/photo-1550525811-e5869dd03032?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    alt: ""
  }), t.createElement("img", {
    className: "inline-block h-10 w-10 rounded-full ring-2 ring-white",
    src: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2.25&w=256&h=256&q=80",
    alt: ""
  }), t.createElement("img", {
    className: "inline-block h-10 w-10 rounded-full ring-2 ring-white",
    src: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    alt: ""
  })));
}
u8.propTypes = {
  size: se.oneOf(["xs", "sm", "md", "lg", "xl"])
}, u8.defaultProps = {
  size: "sm"
};
const m8 = {
  xs: "h-6 w-6 text-xs-medium",
  sm: "h-8 w-8 text-sm-medium",
  md: "h-10 w-10 text-md-medium",
  lg: "h-12 w-12 text-lg-medium",
  xl: "h-[60px] w-[60px] text-xl-medium"
};
function p8(_ref30) {
  let {
    size: e,
    text: r
  } = _ref30;
  const n = r.slice(0, 2);
  return t.createElement(t.Fragment, null, t.createElement("span", {
    className: "".concat(m8[e], " inline-flex items-center justify-center shadow rounded-full bg-neutral-100 border-[1.5px] border-neutral-0")
  }, t.createElement("span", {
    className: "text-neutral-800"
  }, n)));
}
p8.propTypes = {
  size: se.oneOf(["xs", "sm", "md", "lg", "xl"]),
  text: se.string.isRequired
}, p8.defaultProps = {
  size: "sm",
  text: "AM"
};
const f8 = {
    xs: "h-8 w-8",
    sm: "h-10 w-10",
    md: "h-12 w-12 min-w-[48px]",
    lg: "h-[60px] w-[60px]",
    xl: "h-16 w-16 min-w-[64px] min-h-[64px]"
  },
  d8 = {
    circular: "shadow rounded-full ",
    square: "rounded-lg"
  },
  v8 = {
    default: {
      titleTextStyle: "text-hds-m-body2c-bold tb:text-hds-t-body2c-bold db:text-hds-d-body2c-bold",
      desgnTextStyle: "text-hds-m-body3c tb:text-hds-t-body3c db:text-hds-d-body3c"
    },
    primary: {
      titleTextStyle: "text-hds-m-body1-semi-bold tb:text-hds-t-body1-semi-bold db:text-hds-d-body1-semi-bold",
      desgnTextStyle: "text-hds-m-body2 tb:text-hds-t-body2 db:text-hds-d-body2"
    },
    secondary: {
      titleTextStyle: "text-hds-m-sub2 tb:text-hds-t-sub2 db:text-hds-d-sub2",
      desgnTextStyle: "text-hds-m-body2 tb:text-hds-t-body2 db:text-hds-d-body2"
    }
  };
function g8(_ref31) {
  let {
    avatarBgColor: e,
    name: r,
    designation: n,
    size: a,
    imageUrl: o,
    avatarVariant: i,
    avatarType: l
  } = _ref31;
  const s = f8[a] || f8.md,
    c = d8[i] || d8.circular,
    u = o && o.length > 0,
    h = l || "default";
  return t.createElement("div", {
    className: "group block flex-shrink-0"
  }, t.createElement("div", {
    className: "flex items-center"
  }, t.createElement("div", null, u ? t.createElement("img", {
    className: "".concat(s, " ").concat(c, " ").concat(A(e), " rounded inline-block"),
    src: o,
    alt: r
  }) : t.createElement(mz, {
    variant: "user03",
    height: s,
    strokeColor: "#D2D6DB"
  })), t.createElement("div", {
    className: "ml-3"
  }, t.createElement("div", {
    className: "".concat(v8[h].titleTextStyle, " text-neutral-800")
  }, r), t.createElement("div", {
    className: "".concat(v8[h].desgnTextStyle, " text-neutral-600")
  }, n))));
}
function b8(_ref32) {
  let {
    name: e,
    designation: r,
    size: n,
    imageUrl: a
  } = _ref32;
  return a && a.length, t.createElement("div", {
    className: "shadow group rounded-2xl tb:rounded-3xl flex flex-col-reverse mb-m:flex-row mb-m:flex mb-m:items-center mb-m:justify-between bg-neutral-0 tb:inline-flex tb:flex-col tb:max-w-[289px]  tb:min-w-[18rem]"
  }, t.createElement("div", {
    className: "px-6 pb-6 pt-3 mb-m:px-5 mb-m:py-[30px] tb:p-0 text-left tb:flex-col mb-m:min-h-[120px] tb:flex tb:items-center tb:px-8 tb:pb-8 tb:mt-8 tb:ml-0 tb:text-center"
  }, t.createElement("div", {
    className: " text-hds-m-body1c-bold tb:text-hds-t-h5 db:text-hds-d-h5 text-blue-400"
  }, e), t.createElement("div", {
    className: " text-hds-m-body3c-medium tb:text-hds-t-h7 db:text-hds-d-h7 text-blue-800 capitalize tb:uppercase"
  }, r)), t.createElement("div", {
    className: "relative pt-6 mb-m:pt-0 pl-6 mb-m:pl-0 mb-m:self-center"
  }, t.createElement("img", {
    className: "inline-block max-[399px]:bg-blue-300  rounded-r-xl max-[399px]:rounded-full  w-[60px] mb-m:min-w-[144px] mb-m:w-[9rem] tb:min-w-[18rem] tb:rounded-3xl border-neutral-0",
    src: a
  })));
}
g8.propTypes = {
  name: se.string.isRequired,
  designation: se.string.isRequired
}, g8.defaultProps = {
  name: "Names",
  designation: "Product Marketing, Hasura",
  imageUrl: ""
}, b8.propTypes = {
  name: se.string.isRequired,
  designation: se.string.isRequired
}, b8.defaultProps = {
  name: "Names",
  designation: "Product Marketing, Hasura",
  imageUrl: ""
};
const w8 = {
    sm: "py-0.5 px-3 hds-d-body3c",
    default: "py-1 px-3"
  },
  y8 = {
    blue: "bg-blue-200 text-blue-800 group-hover:bg-blue-300  ",
    grey: "bg-neutral-200 text-neutral-800 group-hover:bg-neutral-300  ",
    purple: "bg-purple-200 text-purple-800 group-hover:bg-purple-300 ",
    pink: "bg-pink-200 text-pink-800 group-hover:bg-pink-300 ",
    amber: "bg-amber-200 text-amber-800 group-hover:bg-amber-300  ",
    cyan: "bg-cyan-200 text-cyan-800 group-hover:bg-cyan-300   ",
    cyan200: "bg-cyan-200 text-cyan-600 border border-cyan-400 border border-cyan-400 ",
    green: "bg-green-200 text-green-800 group-hover:bg-green-300  ",
    purple500: "bg-purple-500 shadow-sm",
    blue500: "bg-blue-500 shadow-sm",
    green500: "bg-green-500 shadow-sm",
    borderN400: "border border-neutral-400 group-hover/badge:bg-purple-500 group-hover/badge:text-neutral-0 group-hover/badge:border-opacity-0 transition-all duration-100 ease-in-out"
  };
function x8(_ref33) {
  let {
    leftIconVariant: e,
    leftIconColor: n,
    leftIconColorClass: a,
    rightIconVariant: o,
    rightIconColor: i,
    rightIconColorClass: l,
    size: s,
    children: c,
    color: u,
    text_color: h,
    onClick: m,
    cursorClass: p
  } = _ref33;
  const [f, d] = r(!1);
  return t.createElement("button", {
    className: " ".concat(p !== null && p !== void 0 ? p : "cursor-default", " ").concat(w8[s], " ").concat(y8[u], " inline-flex items-center rounded-full"),
    onClick: () => {
      d(!f), m && m();
    },
    "aria-pressed": f
  }, e && "none" !== e && t.createElement("div", {
    className: "mr-1"
  }, t.createElement(mz, {
    height: "h-4 w-4 stroke-[1.5px]",
    variant: e,
    strokeColor: n,
    strokeClass: A(a)
  })), t.createElement(ce, {
    textStyle: "body3c",
    className: A(h)
  }, c), o && "none" !== o && t.createElement("div", {
    className: "ml-1"
  }, t.createElement(mz, {
    height: "h-4 w-4 stroke-[1.5px]",
    variant: o,
    strokeColor: i,
    rightIconColorClass: A(l)
  })));
}
x8.propTypes = {
  size: se.oneOf(["sm", "default"]),
  children: se.string.isRequired
}, x8.defaultProps = {
  size: "sm",
  children: "Label",
  leftIconVariant: "none",
  leftIconVariant: "none",
  leftIconColor: "#80ff00",
  rightIconColor: "#80ff00",
  color: "bg-blue-200"
};
const O8 = {
    sm: "py-0.5 px-1.5",
    md: "py-0.5 px-2",
    lg: "py-1 px-2.5"
  },
  E8 = {
    A: "bg-neutral-100 text-neutral-700",
    B: "bg-blue-100 text-blue-700",
    C: "bg-neutral-0 border border-neutral-300 text-neutral-700"
  };
function j8(_ref34) {
  let {
    size: e,
    countVariant: r,
    children: n
  } = _ref34;
  return t.createElement("span", {
    className: "".concat(O8[e], " ").concat(E8[r], " flex flex-row max-w-max justify-center items-center rounded-full")
  }, n);
}
function C8(e) {
  const r = A(e.bgClass),
    n = A(e.statusTextClass),
    a = A(e.statusCircleBgClass);
  let o = "";
  return e.blink && (o = "blinking"), t.createElement("div", {
    className: "".concat(r, " px-3 py-1 rounded-full inline-flex items-center shadow")
  }, t.createElement("div", {
    className: "".concat(a, " ").concat(o, " mr-1 w-3 h-3 min-w-[12px] min-h-[12px] rounded-full")
  }), t.createElement(ce, {
    textStyle: "body3c-medium",
    className: "".concat(n, " ")
  }, e.statusText));
}
function P8(e) {
  const {
      children: r,
      eyebrow: n
    } = e,
    a = A(e.eyebrowColorClass);
  return t.createElement("div", null, t.createElement(ce, {
    textStyle: "h6",
    className: "".concat(a, " uppercase ").concat(e.className, " ")
  }, n || r));
}
j8.propTypes = {
  size: se.oneOf(["sm", "md", "lg"]),
  countVariant: se.oneOf(["A", "B", "C"]),
  children: se.string.isRequired
}, j8.defaultProps = {
  size: "sm",
  children: "24",
  countVariant: "A"
}, C8.defaultProps = {
  statusText: "Live Now",
  statusTextClass: "text-neutral-0",
  bgClass: "bg-neutral-700",
  statusCircleBgClass: "bg-red-400"
}, P8.defaultProps = {
  statusText: "",
  eyebrowColorClass: "text-blue-500"
};
const M8 = {
  blue: "bg-neutral-0 tb:bg-blue-500 text-blue-500 tb:text-neutral-0",
  purple: "bg-neutral-0 tb:bg-purple-500 text-purple-500 tb:text-neutral-0",
  pink: "bg-neutral-0 tb:bg-pink-500 text-pink-500 tb:text-neutral-0",
  amber: "bg-neutral-0 tb:bg-amber-500 text-amber-500 tb:text-neutral-0",
  cyan: "bg-neutral-0 tb:bg-cyan-500 text-cyan-500 tb:text-neutral-0",
  green: "bg-neutral-0 tb:bg-green-500 text-green-500 tb:text-neutral-0"
};
function k8(e) {
  const r = e.bgColorClass ? A(e.bgColorClass) : "bg-neutral-0",
    n = e.linkTextColorClass ? A(e.linkTextColorClass) : "text-neutral-600";
  return t.createElement("div", {
    className: "".concat(r, " rounded-2xl tb:rounded-full shadow p-3 tb:py-2 tb:px-2 inline-flex items-center")
  }, t.createElement("div", {
    className: "block items-center tb:flex"
  }, e.tagText && t.createElement(ce, {
    textStyle: "body2-medium",
    className: "inline-flex pl-0 tb:py-1 tb:px-3 rounded-full mr-4 min-w-fit ".concat(M8[e.tagColor])
  }, e.tagText), t.createElement("a", {
    href: e.linkUrl,
    className: "pl-0 px-3 block tb:px-0 tb:pb-0"
  }, t.createElement(ce, {
    textStyle: "body2-medium",
    className: "".concat(n, " group flex items-center")
  }, e.linkText, t.createElement(mz, {
    height: "block w-6 h-6 stroke-2 ml-2 mr-1 transition ease-in-out group-hover:translate-x-[5px]",
    variant: "arrownarrowright",
    strokeClass: "stroke-blue-500"
  })))));
}
const S8 = {
    blue: "bg-neutral-0 tb:bg-blue-500 text-blue-500 tb:text-neutral-0",
    purple: "bg-neutral-0 tb:bg-purple-500 text-purple-500 tb:text-neutral-0",
    pink: "bg-neutral-0 tb:bg-pink-500 text-pink-500 tb:text-neutral-0",
    amber: "bg-neutral-0 tb:bg-amber-500 text-amber-500 tb:text-neutral-0",
    cyan: "bg-neutral-0 tb:bg-cyan-500 text-cyan-500 tb:text-neutral-0",
    green: "bg-neutral-0 tb:bg-green-500 text-green-500 tb:text-neutral-0"
  },
  N8 = "undefined" != typeof window;
function B8(e) {
  const [n, o] = r(!0),
    i = e.bgColorClass ? A(e.bgColorClass) : "bg-neutral-0",
    l = e.linkTextColorClass ? A(e.linkTextColorClass) : "text-neutral-600",
    s = e.tagColor ? e.tagColor : "purple",
    c = e.iconBgColor ? A(e.iconBgColor) : "bg-blue-200",
    [u, h] = r(!1);
  return a(() => {
    if (N8 && "sessionStorage" in window && window.sessionStorage && "getItem" in window.sessionStorage) {
      window.sessionStorage.getItem("announcementConsent") && h(!0);
    }
  }, []), n && !u ? t.createElement("div", {
    className: "py-6"
  }, t.createElement("div", {
    className: "".concat(i, " flex justify-between relative rounded-2xl tb:rounded-full shadow p-3 tb:justify-center tb:items-center")
  }, t.createElement("div", {
    className: "tb:items-center flex tb:justify-center"
  }, e.brandImg && t.createElement("div", {
    className: "tb:pb-0 tb:pl-14 pr-2"
  }, t.createElement("img", {
    className: "mt-[2px] tb:mt-0 min-h-[20px] min-w-[20px] max-w-[20px] max-h-[20px] tb:min-h-[32px] tb:min-w-[32px] tb:max-w-[32px] tb:max-h-[32px]",
    src: e.brandImg,
    alt: e.brandImgAlt
  })), e.iconBgColor && t.createElement("div", {
    className: "".concat(c, " mt-[2px] tb:mt-0 ml-0 mb-1 tb:mb-0 tb:ml-14 mr-2 w-5 h-5 tb:w-8 tb:h-8 min-w-[20px] tb:min-w-[32px] rounded-full flex items-center justify-center")
  }, t.createElement(mz, {
    height: "block w-4 h-4 tb:w-5 tb:h-5 stroke-[2px] transition ease-in-out",
    variant: e.iconVariant,
    strokeClass: "stroke-neutral-1000"
  })), e.tagText && t.createElement(ce, {
    textStyle: "body2-medium",
    className: "inline-flex py-1 px-0 tb:px-3 ml-0 tb:ml-14 tb-m:ml-6 rounded-full mr-4 min-w-fit ".concat(S8[s])
  }, e.tagText), t.createElement("a", {
    href: e.linkUrl,
    className: "block pb-0"
  }, t.createElement(ce, {
    textStyle: "body2-medium",
    className: "".concat(l, " group flex items-center [&>div]:inline-block")
  }, e.linkText, t.createElement(mz, {
    height: " hds-hidden tb:block w-6 h-6 stroke-[2px] ml-3 transition ease-in-out group-hover:translate-x-[5px]",
    variant: "arrownarrowright",
    strokeClass: "stroke-blue-500"
  })))), t.createElement("div", {
    className: "static mt-[2px] tb:mt-0 ml-3 tb:ml-0 tb:absolute top-1/2 tb:-translate-y-1/2 tb:left-3 cursor-pointer w-5 h-5 min-w-[20px] tb:w-8 tb:min-w-[32px] tb:h-8 rounded-full bg-neutral-100 flex items-center justify-center",
    onClick: () => (o(!1), void (N8 && window.sessionStorage.setItem("announcementConsent", "true")))
  }, t.createElement(mz, {
    height: "block w-4 h-4 tb:w-6 tb:h-6 stroke-[2px] transition ease-in-out",
    variant: "xclose",
    strokeClass: "stroke-neutral-800"
  })))) : null;
}
const V8 = {
    icon1: {
      sm: "h-5 w-5 ",
      md: "h-5 w-5",
      lg: "h-6 w-6"
    },
    icon2: {
      sm: "h-5 w-5 -mt-5",
      md: "h-5 w-5 -mt-5",
      lg: "h-6 w-6 -mt-6"
    }
  },
  R8 = {
    primary: {
      default: {
        base: "db:w-fit tb:w-fit w-full justify-center justify-center bg-blue-500 text-neutral-0",
        hover: "hover:bg-blue-700 hover:text-neutral-0 hover:shadow-md hover:shadow hover:transition-all hover:ease-out hover:duration-300",
        focus: "focus:bg-blue-600 focus:shadow-[0_0px_0px_4px_#DFE8FF] focus:text-neutral-0 focus:outline-none active:bg-blue-600 active:text-neutral-0 active:outline-none"
      },
      disabled: "bg-neutral-200 text-neutral-400"
    },
    tonal: {
      default: {
        base: "db:w-fit tb:w-fit w-full justify-center bg-blue-200 text-blue-600",
        hover: "hover:bg-blue-700 hover:text-neutral-0 hover:shadow-md hover:shadow hover:transition-all hover:ease-out hover:duration-300",
        focus: "focus:bg-blue-100 focus:text-blue-600 focus:shadow-[0px_0px_0px_4px_#DFE8FF] focus:outline-none"
      },
      disabled: "bg-neutral-200 text-neutral-400"
    },
    secondary: {
      default: {
        base: "db:w-fit tb:w-fit w-full justify-center border-2 border-blue-500 text-blue-500",
        hover: "hover:text-neutral-0 hover:bg-blue-700 hover:border-2 hover:border-blue-700 hover:shadow-md hover:shadow hover:transition-all hover:ease-out hover:duration-200 ",
        focus: "focus:bg-blue-200 focus:text-blue-500 focus:border-2 border-blue-500 focus:shadow-[0px_0px_0px_4px_#DFE8FF] focus:outline-none focus:text-blue-500"
      },
      disabled: "bg-neutral-200 text-neutral-400"
    },
    secondaryWhite: {
      default: {
        base: "db:w-fit tb:w-fit w-full justify-center border-2 border-neutral-0 text-neutral-0 ",
        hover: "hover:text-neutral-0 hover:border-opacity-0 hover:shadow-md hover:shadow hover:transition-all hover:ease-out hover:duration-300",
        focus: "focus:text-neutrak-0 focus:border-2 border-neutral-0 focus:outline-none focus:text-neutral-0"
      },
      disabled: "bg-neutral-200 text-neutral-400"
    },
    ghost: {
      default: {
        base: "db:w-fit tb:w-fit w-full  justify-center text-neutral-0",
        hover: " ",
        focus: "focus:outline-none"
      },
      disabled: " bg-neutral-200 text-neutral-400"
    },
    ghostBlue: {
      default: {
        base: "db:w-fit tb:w-fit w-full  justify-center border-none hover:border-opacity-100 hover:border-2 rounded-full text-blue-500",
        hover: "hover:bg-blue-700 hover:text-neutral-0 hover:shadow-md hover:shadow hover:transition-all hover:ease-out hover:duration-300",
        focus: "focus:outline-none"
      },
      disabled: " bg-neutral-200 text-neutral-400"
    },
    primaryLink: {
      default: {
        base: "db:w-fit tb:w-fit w-full justify-center ",
        hover: "",
        focus: "focus:shadow-[0px_0px_0px_4px_#DFE8FF] focus:outline-none focus:text-blue-600"
      },
      disabled: "text-neutral-300"
    },
    secondaryLink: {
      default: {
        base: "db:w-fit tb:w-fit w-full  justify-center ",
        hover: "",
        focus: "focus:text-neutral-900 focus:outline-none focus:shadow-[0px_0px_0px_4px_#E5E7EB]"
      },
      disabled: "text-neutral-300"
    },
    iconOnly: {
      default: {
        base: "w-fit justify-center justify-center bg-blue-200 rounded-full p-1.5",
        hover: "hover:bg-blue-600 hover:shadow-md hover:shadow hover:transition-all hover:ease-in-out hover:duration-300",
        focus: "focus:bg-blue-600 focus:shadow-[0_0px_0px_4px_#DFE8FF] focus:text-neutral-0 focus:outline-none"
      },
      disabled: "bg-neutral-200 text-neutral-400",
      icon: {
        sm: "h-5 w-5 p-0",
        md: "h-5 w-5 p-2.5",
        lg: "h-6 w-6 p-3"
      }
    },
    buttonSizes: {
      default: {
        sm: "text-hds-d-body3c-medium py-1.5 pr-2.5 pl-4 rounded-full",
        md: "text-hds-d-body3c-medium rounded-full py-2.5 pl-5 pr-3",
        lg: "text-hds-d-body1c-medium rounded-full py-3 pl-6 pr-4"
      },
      iconOnly: {
        sm: "rounded-full",
        md: "rounded-full p-2.5",
        lg: "trounded-full p-3"
      },
      links: {
        sm: "text-hds-d-body3c-medium rounded-full",
        md: "text-hds-d-body3c-medium rounded-full",
        lg: "text-hds-d-body1c-medium rounded-full"
      }
    }
  };
function A8(e) {
  const {
    btnTextColorClass: r,
    btnTextHoverClass: n,
    btnBgColorClass: a,
    btnbgHoverClass: o,
    rightIconVariant: i,
    rightIconColor: l,
    leftIconVariant: s,
    leftIconColor: c,
    type: u,
    state: h,
    size: m,
    label: p,
    rightAnimatedArrow: f,
    rightAnimatedArrowColor: d,
    animatedHoverStroke: v,
    className: g,
    ...b
  } = e;
  let w = "";
  if ("default" === h) {
    w = "".concat(R8[u][h].base, " ").concat(R8[u][h].hover, " ").concat(R8[u][h].focus);
  } else "disabled" === h && (w = R8[u][h]);
  let y = "default";
  "iconOnly" === u && (y = "iconOnly"), "secondaryLink" !== u && "primaryLink" !== u || (y = "links");
  const x = ["inline-flex items-center whitespace-pre", "rounded-full", a, r, R8.buttonSizes["".concat(y)]["".concat(m)], "group", w, g, A(n), A(o)].join(" ");
  return t.createElement("div", null, t.createElement("button", dz({
    type: "button",
    className: x
  }, b), s && "none" !== s && "iconOnly" != u && t.createElement("div", {
    className: "-ml-0.5 mr-2 ".concat(V8.icon1["".concat(m)], " ")
  }, t.createElement(mz, {
    variant: s,
    strokeColor: c
  })), s && "none" !== s && "iconOnly" == u && t.createElement("div", {
    className: ""
  }, t.createElement(mz, {
    variant: s,
    height: "".concat(V8.icon1["".concat(m)], " group-active:stroke-neutral-0 stroke-[1.5px] group-hover:transition-all group-hover:ease-in-out group-hover:duration-100 group-hover:stroke-neutral-0 group-focus:stroke-neutral-0"),
    strokeColor: c
  })), p, f && "none" !== f && "iconOnly" !== u && t.createElement("div", {
    className: "group-hover:transition-all ".concat(v)
  }, t.createElement(mz, {
    className: "z-10 stroke-2 group-hover:translate-x-[0.15rem] group-hover:transition-all group-hover:duration-300",
    height: "".concat(V8.icon1["".concat(m)], " ").concat(v),
    variant: "chevronright",
    strokeColor: d
  }), t.createElement(mz, {
    className: "invisible stroke-2 group-hover:transition-all group-hover:delay-100 group-hover:visible ",
    height: "".concat(V8.icon2["".concat(m)], " ").concat(v),
    variant: "minus01",
    strokeColor: d
  })), i && "none" !== i && "iconOnly" != u && t.createElement("div", {
    className: "ml-1.5 h-4 w-4 "
  }, t.createElement(mz, {
    variant: i,
    strokeColor: l
  }))));
}
function T8(e) {
  const {
    variant: r,
    label: n,
    labelColor: a,
    iconVariant: o,
    iconStrokeClass: i,
    onClick: l
  } = e;
  return t.createElement(t.Fragment, null, r && "calendarButton" === r && t.createElement(t.Fragment, null, t.createElement("div", null, t.createElement("button", {
    onClick: l,
    className: " border-2 border-blue-500 rounded-full hover:bg-blue-500 group"
  }, t.createElement("div", {
    className: "flex py-2 pl-[18px] pr-3 items-center"
  }, t.createElement(ce, {
    textStyle: "body3-medium",
    className: A(a) + " group-hover:text-neutral-0"
  }, n), t.createElement(mz, {
    variant: o,
    strokeClass: A(i),
    className: "h-5 w-5 stroke-2 group-hover:stroke-neutral-0"
  }))))));
}
A8.propTypes = {
  size: se.oneOf(["sm", "md", "lg", "xl", "2xl"]),
  label: se.string.isRequired,
  type: se.string.isRequired,
  state: se.oneOf(["default", "disabled"]),
  leftIconVariant: se.string,
  rightIconVariant: se.string,
  animatedHoverStroke: se.string
}, A8.defaultProps = {
  size: "md",
  type: "primary",
  leftIconVariant: "none",
  rightIconVariant: "none",
  rightIconColor: "#FFFFFF",
  leftIconColor: "#FFFFFF",
  state: "default",
  label: "Button",
  rightAnimatedArrow: "true",
  rightAnimatedArrowColor: "#FFFFFF",
  animatedHoverStroke: "group-hover:stroke-neutral-0",
  btnTextHoverClass: "hover:text-neutral-0"
};
const H8 = () => t.createElement("svg", {
  className: "z-10 stroke-blue-500 fill-blue-500",
  width: "18",
  height: "22",
  viewBox: "0 0 18 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, t.createElement("path", {
  d: "M0.873058 10.959L0.873057 0.286119L17.9188 10.959L0.873064 21.6318L0.873058 10.959Z",
  fill: "#3970FD"
}));
function L8(e) {
  var _n$bannerLogoImg, _n$bannerLogoImg$data, _n$bannerLogoImg$data2, _n$bannerLogoImg2, _n$bannerLogoImg2$dat, _n$bannerLogoImg2$dat2, _n$bannerIllustration, _n$bannerIllustration2, _n$bannerIllustration3, _n$bannerIllustration4, _n$bannerIllustration5, _n$bannerIllustration6, _n$bannerVideo, _n$bannerVideo$data, _n$bannerVideo$data$a, _n$videoPosterImg, _n$videoPosterImg$dat, _n$videoPosterImg$dat2, _n$videoPosterImg2, _n$videoPosterImg2$da, _n$videoPosterImg2$da2;
  const n = e,
    a = n.isDarkMode ? ["https://hasura.io/", "https://res.cloudinary.com/hasura-cms-uploads/image/upload/v1701437491/Hasura_Primary_27f9db919f.png"] : ["https://hasura.io/", "https://res.cloudinary.com/hasura-cms-uploads/image/upload/v1695988402/hasura_logo_dark_j8eavh_1e11221ebe.png"],
    [o, i] = r(!1),
    l = n.button,
    s = (_n$bannerLogoImg = n.bannerLogoImg) === null || _n$bannerLogoImg === void 0 ? void 0 : (_n$bannerLogoImg$data = _n$bannerLogoImg.data) === null || _n$bannerLogoImg$data === void 0 ? void 0 : (_n$bannerLogoImg$data2 = _n$bannerLogoImg$data.attributes) === null || _n$bannerLogoImg$data2 === void 0 ? void 0 : _n$bannerLogoImg$data2.url,
    c = n === null || n === void 0 ? void 0 : (_n$bannerLogoImg2 = n.bannerLogoImg) === null || _n$bannerLogoImg2 === void 0 ? void 0 : (_n$bannerLogoImg2$dat = _n$bannerLogoImg2.data) === null || _n$bannerLogoImg2$dat === void 0 ? void 0 : (_n$bannerLogoImg2$dat2 = _n$bannerLogoImg2$dat.attributes) === null || _n$bannerLogoImg2$dat2 === void 0 ? void 0 : _n$bannerLogoImg2$dat2.alternativeText,
    u = (_n$bannerIllustration = n.bannerIllustrationBgImg) === null || _n$bannerIllustration === void 0 ? void 0 : (_n$bannerIllustration2 = _n$bannerIllustration.data) === null || _n$bannerIllustration2 === void 0 ? void 0 : (_n$bannerIllustration3 = _n$bannerIllustration2.attributes) === null || _n$bannerIllustration3 === void 0 ? void 0 : _n$bannerIllustration3.url,
    h = (_n$bannerIllustration4 = n.bannerIllustrationBgImg) === null || _n$bannerIllustration4 === void 0 ? void 0 : (_n$bannerIllustration5 = _n$bannerIllustration4.data) === null || _n$bannerIllustration5 === void 0 ? void 0 : (_n$bannerIllustration6 = _n$bannerIllustration5.attributes) === null || _n$bannerIllustration6 === void 0 ? void 0 : _n$bannerIllustration6.alternativeText,
    m = (_n$bannerVideo = n.bannerVideo) === null || _n$bannerVideo === void 0 ? void 0 : (_n$bannerVideo$data = _n$bannerVideo.data) === null || _n$bannerVideo$data === void 0 ? void 0 : (_n$bannerVideo$data$a = _n$bannerVideo$data.attributes) === null || _n$bannerVideo$data$a === void 0 ? void 0 : _n$bannerVideo$data$a.url,
    p = (_n$videoPosterImg = n.videoPosterImg) === null || _n$videoPosterImg === void 0 ? void 0 : (_n$videoPosterImg$dat = _n$videoPosterImg.data) === null || _n$videoPosterImg$dat === void 0 ? void 0 : (_n$videoPosterImg$dat2 = _n$videoPosterImg$dat.attributes) === null || _n$videoPosterImg$dat2 === void 0 ? void 0 : _n$videoPosterImg$dat2.url,
    f = (_n$videoPosterImg2 = n.videoPosterImg) === null || _n$videoPosterImg2 === void 0 ? void 0 : (_n$videoPosterImg2$da = _n$videoPosterImg2.data) === null || _n$videoPosterImg2$da === void 0 ? void 0 : (_n$videoPosterImg2$da2 = _n$videoPosterImg2$da.attributes) === null || _n$videoPosterImg2$da2 === void 0 ? void 0 : _n$videoPosterImg2$da2.alternativeText,
    d = () => {
      return t.createElement("div", {
        className: "pl-[38px] py-8 rounded-3xl",
        style: {
          backgroundColor: n === null || n === void 0 ? void 0 : n.bgColor
        }
      }, s && t.createElement("div", null, (e = s, r = c !== null && c !== void 0 ? c : "bannerLogoAlt", t.createElement("div", {
        className: "flex divide-x divide-neutral-0 items-center gap-[12px] pr-[74px] h-full"
      }, t.createElement("a", {
        href: a[0]
      }, t.createElement("div", {
        className: " tb:max-h-[17px]"
      }, t.createElement("img", {
        className: " w-full h-full object-contain",
        src: a[1],
        alt: "hasuraLogo"
      }))), t.createElement("div", {
        className: "tb:max-h-[18px] pl-[11px] border-l border-neutral-0"
      }, t.createElement("img", {
        className: " w-full h-full object-contain",
        src: e,
        alt: r
      }))))), t.createElement("div", {
        className: "pt-4"
      }, t.createElement("img", {
        src: u,
        alt: h,
        className: ""
      })), v());
      var e, r;
    },
    v = () => t.createElement("div", {
      className: "pr-8 overflow-clip"
    }, t.createElement(ce, {
      as: "p",
      textStyle: "h4",
      className: n.isDarkMode ? "text-neutral-0" : "text-neutral-1000"
    }, n.bannerTitle), l && l.url && t.createElement("a", {
      href: l.url,
      className: "flex"
    }, t.createElement(A8, {
      label: l === null || l === void 0 ? void 0 : l.text,
      type: "secondaryLink",
      leftIconVariant: "none",
      rightIconVariant: "none",
      state: "default",
      size: "md",
      rightAnimatedArrow: !0,
      btnTextHoverClass: "text-blue-600",
      animatedHoverStroke: n.isDarkMode ? "group-hover:stroke-neutral-0" : "group-hover:stroke-blue-600",
      rightAnimatedArrowColor: n.isDarkMode ? "#ffff" : "#3970FD",
      className: "mt-4",
      btnTextColorClass: n.isDarkMode ? "text-neutral-0" : "text-blue-600"
    })));
  return "card" === e.bannerStyle ? m && p && f ? t.createElement("div", {
    className: "bg-neutral-0 p-4 border rounded-3xl border-neutral-200"
  }, t.createElement("div", {
    className: "relative self-end rounded-2xl"
  }, o ? t.createElement("video", {
    id: "hero_vid",
    controls: !0,
    autoPlay: !0,
    muted: !0,
    playsInline: !0,
    poster: p,
    width: "500",
    height: "500",
    className: "tb:w-full w-full rounded-2xl",
    src: m
  }) : t.createElement("div", {
    className: "relative"
  }, p && t.createElement("img", {
    src: p,
    alt: f
  }), m && t.createElement("div", {
    className: "w-14 h-14 cursor-pointer video-play-btn before:bg-neutral-0 after:bg-neutral-0 rounded-full flex items-center justify-center bg-neutral-0 absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 shadow-neutral-1000 shadow-2xl",
    onClick: () => i(!0)
  }, t.createElement(H8, null)))), t.createElement("div", {
    className: "p-[22px] pt-8"
  }, v())) : u && h ? d() : t.createElement("div", {
    className: "p-4 border border-neutral-200 rounded-3xl"
  }, v()) : "AnnouncementSM" === e.bannerStyle ? t.createElement(k8, {
    linkText: n.bannerTitle,
    linkTextColorClass: n.isDarkMode ? "text-neutral-0" : "text-neutral-1000",
    linkUrl: "#",
    tagColor: "purple",
    tagText: "Just Released"
  }) : "AnnouncementMd" === e.bannerStyle ? t.createElement(B8, {
    iconBgColor: "bg-blue-200",
    iconVariant: "cube02",
    linkText: n.bannerTitle,
    linkTextColorClass: n.isDarkMode ? "text-neutral-0" : "text-neutral-1000",
    linkUrl: "#"
  }) : t.createElement(t.Fragment, null);
}
const I8 = {
  A: "text-blue-600",
  B: "bg-blue-100 text-blue-600 rounded-full",
  C: "bg-neutral-100 text-neutral-800 rounded-full"
};
function F8(e) {
  const r = Array.isArray(e.pages) ? e.pages : [],
    {
      dividerIconVariant: n,
      buttonVariant: a
    } = e;
  return t.createElement("nav", {
    className: "flex",
    "aria-label": "Breadcrumb"
  }, t.createElement("ol", {
    role: "list",
    className: "flex items-center space-x-4"
  }, t.createElement("li", null, t.createElement("div", null, t.createElement("a", {
    href: "#",
    className: "text-pink-400 hover:text-gray-500"
  }, t.createElement(mz, {
    height: "h-5",
    variant: "homeline",
    strokeColor: "#4D5761"
  }), t.createElement("span", {
    className: "sr-only"
  }, "Home")))), r.map(e => t.createElement("li", {
    key: e.name
  }, t.createElement("div", {
    className: "flex items-center"
  }, t.createElement("div", {
    className: "-ml-0.5 mr-2 h-4 w-4"
  }, t.createElement(mz, {
    variant: n,
    strokeColor: "#4D5761"
  })), t.createElement("a", {
    href: e.href,
    className: "".concat(I8["".concat(a)], " ml-4 py-1 px-2 text-sm-medium hover:text-gray-700"),
    "aria-current": e.current ? "page" : void 0
  }, e.name))))));
}
function _8(e) {
  const {
      split: r
    } = e,
    n = (e, n) => t.createElement("div", {
      className: " group h-full  "
    }, t.createElement("div", {
      className: "w-full  h-full " + (r ? " " : " rounded-2xl")
    }, t.createElement("div", {
      className: "w-full tb-l:max-w-[250px] p-6 "
    }, e ? t.createElement(ce, {
      textStyle: "h6",
      className: " uppercase group-hover/split:text-neutral-1000 group-hover:text-neutral-1000 group-hover-transition text-neutral-500 mb-4"
    }, e) : t.createElement("div", {
      className: "mb-9"
    }), t.createElement("div", {
      className: " tb:tb:grid tb:tb:grid-cols-1 tb:gap-x-4 tb:min-w-[186px] "
    }, n && n.map(e => t.createElement("div", {
      key: e.name,
      className: "relative pb-2 flex rounded-lg items-center"
    }, t.createElement("a", {
      href: e.href,
      className: "w-full"
    }, t.createElement("div", {
      className: "flex group/icon pl-2 py-2 pr-3 hover:pl-[9px] hover:bg-neutral-100  rounded-lg flex-row w-full justify-between tb:min-w-[150px] items-center"
    }, t.createElement("div", {
      className: "flex gap-2 flex-row items-center"
    }, t.createElement("div", {
      className: "flex rounded-lg items-center group-hover:bg-white"
    }, e.icon && t.createElement(mz, {
      height: "h-5 w-5 stroke-2 ",
      variant: e.icon,
      strokeClass: e.strokeClass
    })), t.createElement(ce, {
      textStyle: "body3c-medium",
      className: "text-neutral-1000  group-hover/icon:text-blue-600 hover:transition-all hover:duration-300 hover:ease-in-out whitespace-nowrap overflow-clip"
    }, e.name)), t.createElement("div", {
      className: "flex group-hover/icon:translate-x-1 transform transition-all duration-200 ease-in-out "
    }, t.createElement(mz, {
      height: "h-4 w-4 stroke-2 invisible group-hover/icon:visible transition-all ease-in-out   ",
      variant: "chevronright",
      strokeClass: "stroke-blue-500"
    })))))))), t.createElement("div", {
      className: "grid grid-cols-2 divide-x divide-gray-900/5 bg-gray-50"
    })));
  return t.createElement(t.Fragment, null, r ? t.createElement(t.Fragment, null, t.createElement("div", {
    className: "hds-hidden tb-l:flex h-full"
  }, t.createElement("div", {
    className: "border-r  border-neutral-150 shadow rounded-l-2xl"
  }, n(e.label, e.childArray.slice(0, Math.ceil(e.childArray.length / 2)))), t.createElement("div", {
    className: "shadow group/split rounded-r-2xl"
  }, n(null, e.childArray.slice(Math.ceil(e.childArray.length / 2))))), t.createElement("div", {
    className: "hds-hidden-tbl  shadow h-full rounded-2xl"
  }, n(e.label, e.childArray))) : t.createElement("div", {
    className: " h-full rounded-2xl"
  }, n(e.label, e.childArray)));
}
function Z8(e) {
  const {
    iconVariant: r = "home03",
    strokeColor: n = "#C6D6FF",
    strokeClass: a = "stroke-neutral-800",
    primaryBtnLabel: o = "label1",
    primaryBtnCTA: i,
    mainDescription: l = "Choose from our open source community edition, fully managed cloud edition or custom enterprise",
    secondaryBtn: s = [{
      cta_leftVariantIcon: "home03",
      cta_leftVariantIconColor: "#6C737F",
      cta_text: "Button 1"
    }],
    tertiaryBtn: c
  } = e;
  return t.createElement("div", {
    className: "flex flex-col justify-between w-full h-full shadow rounded-2xl"
  }, t.createElement("div", {
    className: " ml-2 mt-2 w-[calc(100%-16px)] h-[calc(100%-16px)] rounded-xl absolute "
  }), t.createElement("div", {
    className: "px-6 pt-6 pb-2 w-full h-full "
  }, t.createElement(ce, {
    textStyle: "h6",
    className: "uppercase relative z-[2] group-hover/card:text-neutral-1000 text-neutral-500 mb-4"
  }, "PLATFORM"), t.createElement("div", {
    className: "flex items-start lg:pt-2"
  }, e.cardDetailsArray ? t.createElement("div", {
    className: "tb:flex items-start gap-3"
  }, e.cardDetailsArray.map((e, r) => t.createElement("a", {
    href: e.btnCTA
  }, t.createElement("div", {
    key: r,
    className: "hover:bg-neutral-100 rounded-lg p-3 w-full min-w-[calc(50%-20px)] items-center relative  group/card  cursor-pointer z-[2]"
  }, t.createElement("div", {
    className: "flex items-center"
  }, t.createElement("div", {
    className: "w-5"
  }, e.iconVariant), t.createElement(ce, {
    textStyle: "body3c-medium",
    className: "text-neutral-1000 ml-[6px] hover:transition-all hover:duration-300 hover:ease-in-out whitespace-nowrap overflow-clip"
  }, e.title), t.createElement(mz, {
    height: "h-5 w-5 stroke-[1.5] invisible group-hover/card:visible transition-all ease-in-out group-hover/card:translate-x-1",
    variant: "chevronright",
    strokeColor: "stroke-neutral-1000",
    strokeClass: "stroke-neutral-1000"
  })), t.createElement(ce, {
    className: "mt-1 text-neutral-600 relative z-[2]",
    textStyle: "body3"
  }, e.description))))) : t.createElement("a", {
    href: i,
    className: "group/card flex items-start hover:bg-neutral-100 p-3 rounded-lg cursor-pointer w-full h-full relative transition-all duration-300 ease-out "
  }, t.createElement("div", {
    className: "flex items-center relative justify-center p-2.5 h-14 w-14 z-[2] group-hover/card:bg-blue-200 bg-blue-200 rounded-2xl min-w-[56px] mr-6"
  }, t.createElement(mz, {
    height: "h-6 w-6 stroke-2 group-hover/card:stroke-blue-500",
    variant: r,
    strokeColor: n,
    strokeClass: a
  })), t.createElement("div", {
    className: "relative group/card  cursor-pointer items-center z-[2]"
  }, t.createElement(ce, {
    textStyle: "body3c-medium",
    className: "text-neutral-1000  group-hover/card:text-blue-600 hover:transition-all hover:duration-300 hover:ease-in-out whitespace-nowrap overflow-clip"
  }, e.primaryBtnLabel), t.createElement(ce, {
    className: "mt-1 text-neutral-600 relative z-[2]",
    textStyle: "body3"
  }, l))))), t.createElement("div", {
    className: "border-t border-neutral-200 pt-3 mx-6"
  }), t.createElement("div", {
    className: "flex pb-3 gap-2"
  }, s.map((e, r) => t.createElement("a", {
    key: r,
    href: e.cta_link,
    className: "group/btn px-2 justify-around  cursor-pointer "
  }, t.createElement("div", {
    className: " flex items-center hover:bg-neutral-100 rounded-xl px-4 "
  }, t.createElement("div", {
    className: "flex w-full justify-between items-center z-[2] py-2.5"
  }, t.createElement("div", {
    className: "flex rounded-lg gap-2 items-center "
  }, e.cta_leftVariantIcon && t.createElement(mz, {
    height: "h-5 w-5 group-hover/btn:stroke-blue-500 stroke-2   ",
    variant: e.cta_leftVariantIcon,
    strokeClass: "stroke-blue-500"
  }), t.createElement(ce, {
    textStyle: "body3c-medium",
    className: "text-neutral-1000  group-hover/btn:text-blue-600 hover:transition-all hover:duration-300 hover:ease-in-out whitespace-nowrap overflow-clip"
  }, e.cta_text)), t.createElement("div", {
    className: "flex group-hover/btn:translate-x-1 transform transition-all duration-200 ease-in-out "
  }, t.createElement(mz, {
    height: "h-4 w-4 stroke-2 invisible group-hover/btn:visible transition-all ease-in-out   ",
    variant: "chevronright",
    strokeClass: "stroke-blue-500"
  })))))), c && c.map((e, r) => t.createElement("a", {
    key: r,
    href: e.cta_link,
    className: "group/btn justify-around  cursor-pointer px-2 "
  }, t.createElement("div", {
    className: " flex items-center hover:bg-neutral-100 rounded-xl px-4 "
  }, t.createElement("div", {
    className: "flex w-full justify-between items-center z-[2] py-2.5"
  }, t.createElement("div", {
    className: "flex rounded-lg gap-2 items-center "
  }, e.cta_leftVariantIcon && t.createElement(mz, {
    height: "h-5 w-5 group-hover/btn:stroke-blue-500 stroke-2   ",
    variant: e.cta_leftVariantIcon,
    strokeClass: "stroke-blue-500"
  }), t.createElement(ce, {
    textStyle: "body3c-medium",
    className: "text-neutral-1000  group-hover/btn:text-blue-600 hover:transition-all hover:duration-300 hover:ease-in-out whitespace-nowrap overflow-clip"
  }, e.cta_text)), t.createElement("div", {
    className: "flex group-hover/btn:translate-x-1 transform transition-all duration-200 ease-in-out "
  }, t.createElement(mz, {
    height: "h-4 w-4 stroke-2 invisible group-hover/btn:visible transition-all ease-in-out   ",
    variant: "chevronright",
    strokeClass: "stroke-blue-500"
  }))))))));
}
function D8(e) {
  const {
    title: r,
    title_colorClass: n,
    img_url: a,
    cta_link: o
  } = e;
  return t.createElement("a", {
    href: o !== null && o !== void 0 ? o : ""
  }, t.createElement("div", {
    className: "p-6 hover:shadow-lg cursor-pointer transition-all duration-300 ease-in-out group/flyoutc"
  }, t.createElement("div", {
    className: " flex flex-row items-center gap-6 tb:min-w-[396px]"
  }, t.createElement("div", {
    className: ""
  }, a && t.createElement("img", {
    src: e.img_url,
    className: "rounded-xl max-w-[128px] group-hover/flyoutc:shadow-lg transition-all duration-300 ease-in-out",
    alt: e.title
  })), t.createElement(ce, {
    textStyle: "body3c-medium",
    className: A(n) + " "
  }, r))));
}
function q8(e) {
  return t.createElement("div", {
    className: "flex justify-center z-[2]"
  }, t.createElement("a", {
    href: e === null || e === void 0 ? void 0 : e.link
  }, t.createElement("img", {
    src: e === null || e === void 0 ? void 0 : e.cardImg,
    alt: e === null || e === void 0 ? void 0 : e.cardImgAlt,
    className: "w-full min-w-[204px] max-w-[204px] mt-2 tb-l:mt-0"
  })));
}
F8.propTypes = {
  dividerIconVariant: se.string
}, F8.defaultProps = {
  dividerIconVariant: "chevronright"
}, D8.defaultProps = {
  img_url: "text-neutral-900"
};
const U8 = ["http", "https", "mailto", "tel"];
function $8(e) {
  const t = (e || "").trim(),
    r = t.charAt(0);
  if ("#" === r || "/" === r) return t;
  const n = t.indexOf(":");
  if (-1 === n) return t;
  let a = -1;
  for (; ++a < U8.length;) {
    const e = U8[a];
    if (n === e.length && t.slice(0, e.length).toLowerCase() === e) return t;
  }
  return a = t.indexOf("?"), -1 !== a && n > a ? t : (a = t.indexOf("#"), -1 !== a && n > a ? t : "javascript:void(0)");
}
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
var z8 = function (e) {
    return null != e && null != e.constructor && "function" == typeof e.constructor.isBuffer && e.constructor.isBuffer(e);
  },
  W8 = T(z8);
function Q8(e) {
  return Y8(e && e.line) + ":" + Y8(e && e.column);
}
function G8(e) {
  return Q8(e && e.start) + "-" + Q8(e && e.end);
}
function Y8(e) {
  return e && "number" == typeof e ? e : 1;
}
class K8 extends Error {
  constructor(e, t, r) {
    const n = [null, null];
    let a = {
      start: {
        line: null,
        column: null
      },
      end: {
        line: null,
        column: null
      }
    };
    if (super(), "string" == typeof t && (r = t, t = void 0), "string" == typeof r) {
      const e = r.indexOf(":");
      -1 === e ? n[1] = r : (n[0] = r.slice(0, e), n[1] = r.slice(e + 1));
    }
    t && ("type" in t || "position" in t ? t.position && (a = t.position) : "start" in t || "end" in t ? a = t : ("line" in t || "column" in t) && (a.start = t)), this.name = function (e) {
      return e && "object" == typeof e ? "position" in e || "type" in e ? G8(e.position) : "start" in e || "end" in e ? G8(e) : "line" in e || "column" in e ? Q8(e) : "" : "";
    }(t) || "1:1", this.message = "object" == typeof e ? e.message : e, this.stack = "", "object" == typeof e && e.stack && (this.stack = e.stack), this.reason = this.message, this.fatal, this.line = a.start.line, this.column = a.start.column, this.position = a, this.source = n[0], this.ruleId = n[1], this.file, this.actual, this.expected, this.url, this.note;
  }
}
function X8(e) {
  return null !== e && "object" == typeof e && e.href && e.origin;
}
K8.prototype.file = "", K8.prototype.name = "", K8.prototype.reason = "", K8.prototype.message = "", K8.prototype.stack = "", K8.prototype.fatal = null, K8.prototype.column = null, K8.prototype.line = null, K8.prototype.source = null, K8.prototype.ruleId = null, K8.prototype.position = null;
const J8 = ["history", "path", "basename", "stem", "extname", "dirname"];
class e6 {
  constructor(e) {
    let t;
    t = e ? "string" == typeof e || function (e) {
      return W8(e);
    }(e) ? {
      value: e
    } : X8(e) ? {
      path: e
    } : e : {}, this.data = {}, this.messages = [], this.history = [], this.cwd = B.cwd(), this.value, this.stored, this.result, this.map;
    let r,
      n = -1;
    for (; ++n < J8.length;) {
      const e = J8[n];
      e in t && void 0 !== t[e] && null !== t[e] && (this[e] = "history" === e ? [...t[e]] : t[e]);
    }
    for (r in t) J8.includes(r) || (this[r] = t[r]);
  }
  get path() {
    return this.history[this.history.length - 1];
  }
  set path(e) {
    X8(e) && (e = S(e)), r6(e, "path"), this.path !== e && this.history.push(e);
  }
  get dirname() {
    return "string" == typeof this.path ? N.dirname(this.path) : void 0;
  }
  set dirname(e) {
    n6(this.basename, "dirname"), this.path = N.join(e || "", this.basename);
  }
  get basename() {
    return "string" == typeof this.path ? N.basename(this.path) : void 0;
  }
  set basename(e) {
    r6(e, "basename"), t6(e, "basename"), this.path = N.join(this.dirname || "", e);
  }
  get extname() {
    return "string" == typeof this.path ? N.extname(this.path) : void 0;
  }
  set extname(e) {
    if (t6(e, "extname"), n6(this.dirname, "extname"), e) {
      if (46 !== e.charCodeAt(0)) throw new Error("`extname` must start with `.`");
      if (e.includes(".", 1)) throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = N.join(this.dirname, this.stem + (e || ""));
  }
  get stem() {
    return "string" == typeof this.path ? N.basename(this.path, this.extname) : void 0;
  }
  set stem(e) {
    r6(e, "stem"), t6(e, "stem"), this.path = N.join(this.dirname || "", e + (this.extname || ""));
  }
  toString(e) {
    return (this.value || "").toString(e || void 0);
  }
  message(e, t, r) {
    const n = new K8(e, t, r);
    return this.path && (n.name = this.path + ":" + n.name, n.file = this.path), n.fatal = !1, this.messages.push(n), n;
  }
  info(e, t, r) {
    const n = this.message(e, t, r);
    return n.fatal = null, n;
  }
  fail(e, t, r) {
    const n = this.message(e, t, r);
    throw n.fatal = !0, n;
  }
}
function t6(e, t) {
  if (e && e.includes(N.sep)) throw new Error("`" + t + "` cannot be a path: did not expect `" + N.sep + "`");
}
function r6(e, t) {
  if (!e) throw new Error("`" + t + "` cannot be empty");
}
function n6(e, t) {
  if (!e) throw new Error("Setting `" + t + "` requires `path` to be set too");
}
function a6(e) {
  if (e) throw e;
}
var o6 = Object.prototype.hasOwnProperty,
  i6 = Object.prototype.toString,
  l6 = Object.defineProperty,
  s6 = Object.getOwnPropertyDescriptor,
  c6 = function (e) {
    return "function" == typeof Array.isArray ? Array.isArray(e) : "[object Array]" === i6.call(e);
  },
  u6 = function (e) {
    if (!e || "[object Object]" !== i6.call(e)) return !1;
    var t,
      r = o6.call(e, "constructor"),
      n = e.constructor && e.constructor.prototype && o6.call(e.constructor.prototype, "isPrototypeOf");
    if (e.constructor && !r && !n) return !1;
    for (t in e);
    return void 0 === t || o6.call(e, t);
  },
  h6 = function (e, t) {
    l6 && "__proto__" === t.name ? l6(e, t.name, {
      enumerable: !0,
      configurable: !0,
      value: t.newValue,
      writable: !0
    }) : e[t.name] = t.newValue;
  },
  m6 = function (e, t) {
    if ("__proto__" === t) {
      if (!o6.call(e, t)) return;
      if (s6) return s6(e, t).value;
    }
    return e[t];
  },
  p6 = function e() {
    var t,
      r,
      n,
      a,
      o,
      i,
      l = arguments[0],
      s = 1,
      c = arguments.length,
      u = !1;
    for ("boolean" == typeof l && (u = l, l = arguments[1] || {}, s = 2), (null == l || "object" != typeof l && "function" != typeof l) && (l = {}); s < c; ++s) if (null != (t = arguments[s])) for (r in t) n = m6(l, r), l !== (a = m6(t, r)) && (u && a && (u6(a) || (o = c6(a))) ? (o ? (o = !1, i = n && c6(n) ? n : []) : i = n && u6(n) ? n : {}, h6(l, {
      name: r,
      newValue: e(u, i, a)
    })) : void 0 !== a && h6(l, {
      name: r,
      newValue: a
    }));
    return l;
  },
  f6 = T(p6);
function d6(e) {
  if ("object" != typeof e || null === e) return !1;
  const t = Object.getPrototypeOf(e);
  return !(null !== t && t !== Object.prototype && null !== Object.getPrototypeOf(t) || Symbol.toStringTag in e || Symbol.iterator in e);
}
function v6() {
  const e = [],
    t = {
      run: function () {
        for (var _len3 = arguments.length, t = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          t[_key3] = arguments[_key3];
        }
        let r = -1;
        const n = t.pop();
        if ("function" != typeof n) throw new TypeError("Expected function as last argument, not " + n);
        !function a(o) {
          const l = e[++r];
          let s = -1;
          if (o) n(o);else {
            for (var _len4 = arguments.length, i = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
              i[_key4 - 1] = arguments[_key4];
            }
            for (; ++s < t.length;) null !== i[s] && void 0 !== i[s] || (i[s] = t[s]);
            t = i, l ? function (e, t) {
              let r;
              return n;
              function n() {
                for (var _len5 = arguments.length, t = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
                  t[_key5] = arguments[_key5];
                }
                const n = e.length > t.length;
                let i;
                n && t.push(a);
                try {
                  i = e.apply(this, t);
                } catch (e) {
                  if (n && r) throw e;
                  return a(e);
                }
                n || (i instanceof Promise ? i.then(o, a) : i instanceof Error ? a(i) : o(i));
              }
              function a(e) {
                for (var _len6 = arguments.length, n = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
                  n[_key6 - 1] = arguments[_key6];
                }
                r || (r = !0, t(e, ...n));
              }
              function o(e) {
                a(null, e);
              }
            }(l, a)(...i) : n(null, ...i);
          }
        }(null, ...t);
      },
      use: function (r) {
        if ("function" != typeof r) throw new TypeError("Expected `middelware` to be a function, not " + r);
        return e.push(r), t;
      }
    };
  return t;
}
const g6 = function e() {
    const t = v6(),
      r = [];
    let n,
      a = {},
      o = -1;
    return i.data = l, i.Parser = void 0, i.Compiler = void 0, i.freeze = function () {
      if (n) return i;
      for (; ++o < r.length;) {
        const [e, ...n] = r[o];
        if (!1 === n[0]) continue;
        !0 === n[0] && (n[0] = void 0);
        const a = e.call(i, ...n);
        "function" == typeof a && t.use(a);
      }
      return n = !0, o = Number.POSITIVE_INFINITY, i;
    }, i.attachers = r, i.use = s, i.parse = function (e) {
      i.freeze();
      const t = C6(e),
        r = i.Parser;
      if (y6("parse", r), w6(r, "parse")) return new r(String(t), t).parse();
      return r(String(t), t);
    }, i.stringify = function (e, t) {
      i.freeze();
      const r = C6(t),
        n = i.Compiler;
      if (x6("stringify", n), E6(e), w6(n, "compile")) return new n(e, r).compile();
      return n(e, r);
    }, i.run = function (e, r, n) {
      E6(e), i.freeze(), n || "function" != typeof r || (n = r, r = void 0);
      if (!n) return new Promise(a);
      function a(a, o) {
        function i(t, r, i) {
          r = r || e, t ? o(t) : a ? a(r) : n(null, r, i);
        }
        t.run(e, C6(r), i);
      }
      a(null, n);
    }, i.runSync = function (e, t) {
      let r, n;
      return i.run(e, t, a), j6("runSync", "run", n), r;
      function a(e, t) {
        a6(e), r = t, n = !0;
      }
    }, i.process = function (e, t) {
      if (i.freeze(), y6("process", i.Parser), x6("process", i.Compiler), !t) return new Promise(r);
      function r(r, n) {
        const a = C6(e);
        function o(e, a) {
          e || !a ? n(e) : r ? r(a) : t(null, a);
        }
        i.run(i.parse(a), a, (e, t, r) => {
          if (!e && t && r) {
            const n = i.stringify(t, r);
            null == n || (!function (e) {
              return "string" == typeof e || W8(e);
            }(n) ? r.result = n : r.value = n), o(e, r);
          } else o(e);
        });
      }
      r(null, t);
    }, i.processSync = function (e) {
      let t;
      i.freeze(), y6("processSync", i.Parser), x6("processSync", i.Compiler);
      const r = C6(e);
      return i.process(r, n), j6("processSync", "process", t), r;
      function n(e) {
        t = !0, a6(e);
      }
    }, i;
    function i() {
      const t = e();
      let n = -1;
      for (; ++n < r.length;) t.use(...r[n]);
      return t.data(f6(!0, {}, a)), t;
    }
    function l(e, t) {
      return "string" == typeof e ? 2 === arguments.length ? (O6("data", n), a[e] = t, i) : b6.call(a, e) && a[e] || null : e ? (O6("data", n), a = e, i) : a;
    }
    function s(e) {
      for (var _len7 = arguments.length, t = new Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
        t[_key7 - 1] = arguments[_key7];
      }
      let o;
      if (O6("use", n), null == e) ;else if ("function" == typeof e) u(e, ...t);else {
        if ("object" != typeof e) throw new TypeError("Expected usable value, not `" + e + "`");
        Array.isArray(e) ? c(e) : s(e);
      }
      return o && (a.settings = Object.assign(a.settings || {}, o)), i;
      function l(e) {
        if ("function" == typeof e) u(e);else {
          if ("object" != typeof e) throw new TypeError("Expected usable value, not `" + e + "`");
          if (Array.isArray(e)) {
            const [t, ...r] = e;
            u(t, ...r);
          } else s(e);
        }
      }
      function s(e) {
        c(e.plugins), e.settings && (o = Object.assign(o || {}, e.settings));
      }
      function c(e) {
        let t = -1;
        if (null == e) ;else {
          if (!Array.isArray(e)) throw new TypeError("Expected a list of plugins, not `" + e + "`");
          for (; ++t < e.length;) {
            l(e[t]);
          }
        }
      }
      function u(e, t) {
        let n,
          a = -1;
        for (; ++a < r.length;) if (r[a][0] === e) {
          n = r[a];
          break;
        }
        n ? (d6(n[1]) && d6(t) && (t = f6(!0, n[1], t)), n[1] = t) : r.push([...arguments]);
      }
    }
  }().freeze(),
  b6 = {}.hasOwnProperty;
function w6(e, t) {
  return "function" == typeof e && e.prototype && (function (e) {
    let t;
    for (t in e) if (b6.call(e, t)) return !0;
    return !1;
  }(e.prototype) || t in e.prototype);
}
function y6(e, t) {
  if ("function" != typeof t) throw new TypeError("Cannot `" + e + "` without `Parser`");
}
function x6(e, t) {
  if ("function" != typeof t) throw new TypeError("Cannot `" + e + "` without `Compiler`");
}
function O6(e, t) {
  if (t) throw new Error("Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`.");
}
function E6(e) {
  if (!d6(e) || "string" != typeof e.type) throw new TypeError("Expected node, got `" + e + "`");
}
function j6(e, t, r) {
  if (!r) throw new Error("`" + e + "` finished async. Use `" + t + "` instead");
}
function C6(e) {
  return function (e) {
    return Boolean(e && "object" == typeof e && "message" in e && "messages" in e);
  }(e) ? e : new e6(e);
}
const P6 = {};
function M6(e, t, r) {
  if (function (e) {
    return Boolean(e && "object" == typeof e);
  }(e)) {
    if ("value" in e) return "html" !== e.type || r ? e.value : "";
    if (t && "alt" in e && e.alt) return e.alt;
    if ("children" in e) return k6(e.children, t, r);
  }
  return Array.isArray(e) ? k6(e, t, r) : "";
}
function k6(e, t, r) {
  const n = [];
  let a = -1;
  for (; ++a < e.length;) n[a] = M6(e[a], t, r);
  return n.join("");
}
function S6(e, t, r, n) {
  const a = e.length;
  let o,
    i = 0;
  if (t = t < 0 ? -t > a ? 0 : a + t : t > a ? a : t, r = r > 0 ? r : 0, n.length < 1e4) o = Array.from(n), o.unshift(t, r), e.splice(...o);else for (r && e.splice(t, r); i < n.length;) o = n.slice(i, i + 1e4), o.unshift(t, 0), e.splice(...o), i += 1e4, t += 1e4;
}
function N6(e, t) {
  return e.length > 0 ? (S6(e, e.length, 0, t), e) : t;
}
const B6 = {}.hasOwnProperty;
function V6(e, t) {
  let r;
  for (r in t) {
    const n = (B6.call(e, r) ? e[r] : void 0) || (e[r] = {}),
      a = t[r];
    let o;
    if (a) for (o in a) {
      B6.call(n, o) || (n[o] = []);
      const e = a[o];
      R6(n[o], Array.isArray(e) ? e : e ? [e] : []);
    }
  }
}
function R6(e, t) {
  let r = -1;
  const n = [];
  for (; ++r < t.length;) ("after" === t[r].add ? e : n).push(t[r]);
  S6(e, 0, 0, n);
}
const A6 = z6(/[A-Za-z]/),
  T6 = z6(/[\dA-Za-z]/),
  H6 = z6(/[#-'*+\--9=?A-Z^-~]/);
function L6(e) {
  return null !== e && (e < 32 || 127 === e);
}
const I6 = z6(/\d/),
  F6 = z6(/[\dA-Fa-f]/),
  _6 = z6(/[!-/:-@[-`{-~]/);
function Z6(e) {
  return null !== e && e < -2;
}
function D6(e) {
  return null !== e && (e < 0 || 32 === e);
}
function q6(e) {
  return -2 === e || -1 === e || 32 === e;
}
const U6 = z6(/[!-\/:-@\[-`\{-~\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/),
  $6 = z6(/\s/);
function z6(e) {
  return function (t) {
    return null !== t && e.test(String.fromCharCode(t));
  };
}
function W6(e, t, r, n) {
  const a = n ? n - 1 : Number.POSITIVE_INFINITY;
  let o = 0;
  return function (n) {
    if (q6(n)) return e.enter(r), i(n);
    return t(n);
  };
  function i(n) {
    return q6(n) && o++ < a ? (e.consume(n), i) : (e.exit(r), t(n));
  }
}
const Q6 = {
  tokenize: function (e) {
    const t = e.attempt(this.parser.constructs.contentInitial, function (r) {
      if (null === r) return void e.consume(r);
      return e.enter("lineEnding"), e.consume(r), e.exit("lineEnding"), W6(e, t, "linePrefix");
    }, function (t) {
      return e.enter("paragraph"), n(t);
    });
    let r;
    return t;
    function n(t) {
      const n = e.enter("chunkText", {
        contentType: "text",
        previous: r
      });
      return r && (r.next = n), r = n, a(t);
    }
    function a(t) {
      return null === t ? (e.exit("chunkText"), e.exit("paragraph"), void e.consume(t)) : Z6(t) ? (e.consume(t), e.exit("chunkText"), n) : (e.consume(t), a);
    }
  }
};
const G6 = {
    tokenize: function (e) {
      const t = this,
        r = [];
      let n,
        a,
        o,
        i = 0;
      return l;
      function l(n) {
        if (i < r.length) {
          const a = r[i];
          return t.containerState = a[1], e.attempt(a[0].continuation, s, c)(n);
        }
        return c(n);
      }
      function s(e) {
        if (i++, t.containerState._closeFlow) {
          t.containerState._closeFlow = void 0, n && b();
          const r = t.events.length;
          let a,
            o = r;
          for (; o--;) if ("exit" === t.events[o][0] && "chunkFlow" === t.events[o][1].type) {
            a = t.events[o][1].end;
            break;
          }
          g(i);
          let l = r;
          for (; l < t.events.length;) t.events[l][1].end = Object.assign({}, a), l++;
          return S6(t.events, o + 1, 0, t.events.slice(r)), t.events.length = l, c(e);
        }
        return l(e);
      }
      function c(a) {
        if (i === r.length) {
          if (!n) return m(a);
          if (n.currentConstruct && n.currentConstruct.concrete) return f(a);
          t.interrupt = Boolean(n.currentConstruct && !n._gfmTableDynamicInterruptHack);
        }
        return t.containerState = {}, e.check(Y6, u, h)(a);
      }
      function u(e) {
        return n && b(), g(i), m(e);
      }
      function h(e) {
        return t.parser.lazy[t.now().line] = i !== r.length, o = t.now().offset, f(e);
      }
      function m(r) {
        return t.containerState = {}, e.attempt(Y6, p, f)(r);
      }
      function p(e) {
        return i++, r.push([t.currentConstruct, t.containerState]), m(e);
      }
      function f(r) {
        return null === r ? (n && b(), g(0), void e.consume(r)) : (n = n || t.parser.flow(t.now()), e.enter("chunkFlow", {
          contentType: "flow",
          previous: a,
          _tokenizer: n
        }), d(r));
      }
      function d(r) {
        return null === r ? (v(e.exit("chunkFlow"), !0), g(0), void e.consume(r)) : Z6(r) ? (e.consume(r), v(e.exit("chunkFlow")), i = 0, t.interrupt = void 0, l) : (e.consume(r), d);
      }
      function v(e, r) {
        const l = t.sliceStream(e);
        if (r && l.push(null), e.previous = a, a && (a.next = e), a = e, n.defineSkip(e.start), n.write(l), t.parser.lazy[e.start.line]) {
          let e = n.events.length;
          for (; e--;) if (n.events[e][1].start.offset < o && (!n.events[e][1].end || n.events[e][1].end.offset > o)) return;
          const r = t.events.length;
          let a,
            l,
            s = r;
          for (; s--;) if ("exit" === t.events[s][0] && "chunkFlow" === t.events[s][1].type) {
            if (a) {
              l = t.events[s][1].end;
              break;
            }
            a = !0;
          }
          for (g(i), e = r; e < t.events.length;) t.events[e][1].end = Object.assign({}, l), e++;
          S6(t.events, s + 1, 0, t.events.slice(r)), t.events.length = e;
        }
      }
      function g(n) {
        let a = r.length;
        for (; a-- > n;) {
          const n = r[a];
          t.containerState = n[1], n[0].exit.call(t, e);
        }
        r.length = n;
      }
      function b() {
        n.write([null]), a = void 0, n = void 0, t.containerState._closeFlow = void 0;
      }
    }
  },
  Y6 = {
    tokenize: function (e, t, r) {
      return W6(e, e.attempt(this.parser.constructs.document, t, r), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
    }
  };
function K6(e) {
  return null === e || D6(e) || $6(e) ? 1 : U6(e) ? 2 : void 0;
}
function X6(e, t, r) {
  const n = [];
  let a = -1;
  for (; ++a < e.length;) {
    const o = e[a].resolveAll;
    o && !n.includes(o) && (t = o(t, r), n.push(o));
  }
  return t;
}
const J6 = {
  name: "attention",
  tokenize: function (e, t) {
    const r = this.parser.constructs.attentionMarkers.null,
      n = this.previous,
      a = K6(n);
    let o;
    return function (t) {
      return o = t, e.enter("attentionSequence"), i(t);
    };
    function i(l) {
      if (l === o) return e.consume(l), i;
      const s = e.exit("attentionSequence"),
        c = K6(l),
        u = !c || 2 === c && a || r.includes(l),
        h = !a || 2 === a && c || r.includes(n);
      return s._open = Boolean(42 === o ? u : u && (a || !h)), s._close = Boolean(42 === o ? h : h && (c || !u)), t(l);
    }
  },
  resolveAll: function (e, t) {
    let r,
      n,
      a,
      o,
      i,
      l,
      s,
      c,
      u = -1;
    for (; ++u < e.length;) if ("enter" === e[u][0] && "attentionSequence" === e[u][1].type && e[u][1]._close) for (r = u; r--;) if ("exit" === e[r][0] && "attentionSequence" === e[r][1].type && e[r][1]._open && t.sliceSerialize(e[r][1]).charCodeAt(0) === t.sliceSerialize(e[u][1]).charCodeAt(0)) {
      if ((e[r][1]._close || e[u][1]._open) && (e[u][1].end.offset - e[u][1].start.offset) % 3 && !((e[r][1].end.offset - e[r][1].start.offset + e[u][1].end.offset - e[u][1].start.offset) % 3)) continue;
      l = e[r][1].end.offset - e[r][1].start.offset > 1 && e[u][1].end.offset - e[u][1].start.offset > 1 ? 2 : 1;
      const h = Object.assign({}, e[r][1].end),
        m = Object.assign({}, e[u][1].start);
      e7(h, -l), e7(m, l), o = {
        type: l > 1 ? "strongSequence" : "emphasisSequence",
        start: h,
        end: Object.assign({}, e[r][1].end)
      }, i = {
        type: l > 1 ? "strongSequence" : "emphasisSequence",
        start: Object.assign({}, e[u][1].start),
        end: m
      }, a = {
        type: l > 1 ? "strongText" : "emphasisText",
        start: Object.assign({}, e[r][1].end),
        end: Object.assign({}, e[u][1].start)
      }, n = {
        type: l > 1 ? "strong" : "emphasis",
        start: Object.assign({}, o.start),
        end: Object.assign({}, i.end)
      }, e[r][1].end = Object.assign({}, o.start), e[u][1].start = Object.assign({}, i.end), s = [], e[r][1].end.offset - e[r][1].start.offset && (s = N6(s, [["enter", e[r][1], t], ["exit", e[r][1], t]])), s = N6(s, [["enter", n, t], ["enter", o, t], ["exit", o, t], ["enter", a, t]]), s = N6(s, X6(t.parser.constructs.insideSpan.null, e.slice(r + 1, u), t)), s = N6(s, [["exit", a, t], ["enter", i, t], ["exit", i, t], ["exit", n, t]]), e[u][1].end.offset - e[u][1].start.offset ? (c = 2, s = N6(s, [["enter", e[u][1], t], ["exit", e[u][1], t]])) : c = 0, S6(e, r - 1, u - r + 3, s), u = r + s.length - c - 2;
      break;
    }
    u = -1;
    for (; ++u < e.length;) "attentionSequence" === e[u][1].type && (e[u][1].type = "data");
    return e;
  }
};
function e7(e, t) {
  e.column += t, e.offset += t, e._bufferIndex += t;
}
const t7 = {
  name: "autolink",
  tokenize: function (e, t, r) {
    let n = 0;
    return function (t) {
      return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(t), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), a;
    };
    function a(t) {
      return A6(t) ? (e.consume(t), o) : s(t);
    }
    function o(e) {
      return 43 === e || 45 === e || 46 === e || T6(e) ? (n = 1, i(e)) : s(e);
    }
    function i(t) {
      return 58 === t ? (e.consume(t), n = 0, l) : (43 === t || 45 === t || 46 === t || T6(t)) && n++ < 32 ? (e.consume(t), i) : (n = 0, s(t));
    }
    function l(n) {
      return 62 === n ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(n), e.exit("autolinkMarker"), e.exit("autolink"), t) : null === n || 32 === n || 60 === n || L6(n) ? r(n) : (e.consume(n), l);
    }
    function s(t) {
      return 64 === t ? (e.consume(t), c) : H6(t) ? (e.consume(t), s) : r(t);
    }
    function c(e) {
      return T6(e) ? u(e) : r(e);
    }
    function u(r) {
      return 46 === r ? (e.consume(r), n = 0, c) : 62 === r ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(r), e.exit("autolinkMarker"), e.exit("autolink"), t) : h(r);
    }
    function h(t) {
      if ((45 === t || T6(t)) && n++ < 63) {
        const r = 45 === t ? h : u;
        return e.consume(t), r;
      }
      return r(t);
    }
  }
};
const r7 = {
  tokenize: function (e, t, r) {
    return function (t) {
      return q6(t) ? W6(e, n, "linePrefix")(t) : n(t);
    };
    function n(e) {
      return null === e || Z6(e) ? t(e) : r(e);
    }
  },
  partial: !0
};
const n7 = {
  name: "blockQuote",
  tokenize: function (e, t, r) {
    const n = this;
    return function (t) {
      if (62 === t) {
        const r = n.containerState;
        return r.open || (e.enter("blockQuote", {
          _container: !0
        }), r.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(t), e.exit("blockQuoteMarker"), a;
      }
      return r(t);
    };
    function a(r) {
      return q6(r) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(r), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), t) : (e.exit("blockQuotePrefix"), t(r));
    }
  },
  continuation: {
    tokenize: function (e, t, r) {
      const n = this;
      return function (t) {
        if (q6(t)) return W6(e, a, "linePrefix", n.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(t);
        return a(t);
      };
      function a(n) {
        return e.attempt(n7, t, r)(n);
      }
    }
  },
  exit: function (e) {
    e.exit("blockQuote");
  }
};
const a7 = {
  name: "characterEscape",
  tokenize: function (e, t, r) {
    return function (t) {
      return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(t), e.exit("escapeMarker"), n;
    };
    function n(n) {
      return _6(n) ? (e.enter("characterEscapeValue"), e.consume(n), e.exit("characterEscapeValue"), e.exit("characterEscape"), t) : r(n);
    }
  }
};
const o7 = {
    AElig: "Æ",
    AMP: "&",
    Aacute: "Á",
    Abreve: "Ă",
    Acirc: "Â",
    Acy: "А",
    Afr: "𝔄",
    Agrave: "À",
    Alpha: "Α",
    Amacr: "Ā",
    And: "⩓",
    Aogon: "Ą",
    Aopf: "𝔸",
    ApplyFunction: "⁡",
    Aring: "Å",
    Ascr: "𝒜",
    Assign: "≔",
    Atilde: "Ã",
    Auml: "Ä",
    Backslash: "∖",
    Barv: "⫧",
    Barwed: "⌆",
    Bcy: "Б",
    Because: "∵",
    Bernoullis: "ℬ",
    Beta: "Β",
    Bfr: "𝔅",
    Bopf: "𝔹",
    Breve: "˘",
    Bscr: "ℬ",
    Bumpeq: "≎",
    CHcy: "Ч",
    COPY: "©",
    Cacute: "Ć",
    Cap: "⋒",
    CapitalDifferentialD: "ⅅ",
    Cayleys: "ℭ",
    Ccaron: "Č",
    Ccedil: "Ç",
    Ccirc: "Ĉ",
    Cconint: "∰",
    Cdot: "Ċ",
    Cedilla: "¸",
    CenterDot: "·",
    Cfr: "ℭ",
    Chi: "Χ",
    CircleDot: "⊙",
    CircleMinus: "⊖",
    CirclePlus: "⊕",
    CircleTimes: "⊗",
    ClockwiseContourIntegral: "∲",
    CloseCurlyDoubleQuote: "”",
    CloseCurlyQuote: "’",
    Colon: "∷",
    Colone: "⩴",
    Congruent: "≡",
    Conint: "∯",
    ContourIntegral: "∮",
    Copf: "ℂ",
    Coproduct: "∐",
    CounterClockwiseContourIntegral: "∳",
    Cross: "⨯",
    Cscr: "𝒞",
    Cup: "⋓",
    CupCap: "≍",
    DD: "ⅅ",
    DDotrahd: "⤑",
    DJcy: "Ђ",
    DScy: "Ѕ",
    DZcy: "Џ",
    Dagger: "‡",
    Darr: "↡",
    Dashv: "⫤",
    Dcaron: "Ď",
    Dcy: "Д",
    Del: "∇",
    Delta: "Δ",
    Dfr: "𝔇",
    DiacriticalAcute: "´",
    DiacriticalDot: "˙",
    DiacriticalDoubleAcute: "˝",
    DiacriticalGrave: "`",
    DiacriticalTilde: "˜",
    Diamond: "⋄",
    DifferentialD: "ⅆ",
    Dopf: "𝔻",
    Dot: "¨",
    DotDot: "⃜",
    DotEqual: "≐",
    DoubleContourIntegral: "∯",
    DoubleDot: "¨",
    DoubleDownArrow: "⇓",
    DoubleLeftArrow: "⇐",
    DoubleLeftRightArrow: "⇔",
    DoubleLeftTee: "⫤",
    DoubleLongLeftArrow: "⟸",
    DoubleLongLeftRightArrow: "⟺",
    DoubleLongRightArrow: "⟹",
    DoubleRightArrow: "⇒",
    DoubleRightTee: "⊨",
    DoubleUpArrow: "⇑",
    DoubleUpDownArrow: "⇕",
    DoubleVerticalBar: "∥",
    DownArrow: "↓",
    DownArrowBar: "⤓",
    DownArrowUpArrow: "⇵",
    DownBreve: "̑",
    DownLeftRightVector: "⥐",
    DownLeftTeeVector: "⥞",
    DownLeftVector: "↽",
    DownLeftVectorBar: "⥖",
    DownRightTeeVector: "⥟",
    DownRightVector: "⇁",
    DownRightVectorBar: "⥗",
    DownTee: "⊤",
    DownTeeArrow: "↧",
    Downarrow: "⇓",
    Dscr: "𝒟",
    Dstrok: "Đ",
    ENG: "Ŋ",
    ETH: "Ð",
    Eacute: "É",
    Ecaron: "Ě",
    Ecirc: "Ê",
    Ecy: "Э",
    Edot: "Ė",
    Efr: "𝔈",
    Egrave: "È",
    Element: "∈",
    Emacr: "Ē",
    EmptySmallSquare: "◻",
    EmptyVerySmallSquare: "▫",
    Eogon: "Ę",
    Eopf: "𝔼",
    Epsilon: "Ε",
    Equal: "⩵",
    EqualTilde: "≂",
    Equilibrium: "⇌",
    Escr: "ℰ",
    Esim: "⩳",
    Eta: "Η",
    Euml: "Ë",
    Exists: "∃",
    ExponentialE: "ⅇ",
    Fcy: "Ф",
    Ffr: "𝔉",
    FilledSmallSquare: "◼",
    FilledVerySmallSquare: "▪",
    Fopf: "𝔽",
    ForAll: "∀",
    Fouriertrf: "ℱ",
    Fscr: "ℱ",
    GJcy: "Ѓ",
    GT: ">",
    Gamma: "Γ",
    Gammad: "Ϝ",
    Gbreve: "Ğ",
    Gcedil: "Ģ",
    Gcirc: "Ĝ",
    Gcy: "Г",
    Gdot: "Ġ",
    Gfr: "𝔊",
    Gg: "⋙",
    Gopf: "𝔾",
    GreaterEqual: "≥",
    GreaterEqualLess: "⋛",
    GreaterFullEqual: "≧",
    GreaterGreater: "⪢",
    GreaterLess: "≷",
    GreaterSlantEqual: "⩾",
    GreaterTilde: "≳",
    Gscr: "𝒢",
    Gt: "≫",
    HARDcy: "Ъ",
    Hacek: "ˇ",
    Hat: "^",
    Hcirc: "Ĥ",
    Hfr: "ℌ",
    HilbertSpace: "ℋ",
    Hopf: "ℍ",
    HorizontalLine: "─",
    Hscr: "ℋ",
    Hstrok: "Ħ",
    HumpDownHump: "≎",
    HumpEqual: "≏",
    IEcy: "Е",
    IJlig: "Ĳ",
    IOcy: "Ё",
    Iacute: "Í",
    Icirc: "Î",
    Icy: "И",
    Idot: "İ",
    Ifr: "ℑ",
    Igrave: "Ì",
    Im: "ℑ",
    Imacr: "Ī",
    ImaginaryI: "ⅈ",
    Implies: "⇒",
    Int: "∬",
    Integral: "∫",
    Intersection: "⋂",
    InvisibleComma: "⁣",
    InvisibleTimes: "⁢",
    Iogon: "Į",
    Iopf: "𝕀",
    Iota: "Ι",
    Iscr: "ℐ",
    Itilde: "Ĩ",
    Iukcy: "І",
    Iuml: "Ï",
    Jcirc: "Ĵ",
    Jcy: "Й",
    Jfr: "𝔍",
    Jopf: "𝕁",
    Jscr: "𝒥",
    Jsercy: "Ј",
    Jukcy: "Є",
    KHcy: "Х",
    KJcy: "Ќ",
    Kappa: "Κ",
    Kcedil: "Ķ",
    Kcy: "К",
    Kfr: "𝔎",
    Kopf: "𝕂",
    Kscr: "𝒦",
    LJcy: "Љ",
    LT: "<",
    Lacute: "Ĺ",
    Lambda: "Λ",
    Lang: "⟪",
    Laplacetrf: "ℒ",
    Larr: "↞",
    Lcaron: "Ľ",
    Lcedil: "Ļ",
    Lcy: "Л",
    LeftAngleBracket: "⟨",
    LeftArrow: "←",
    LeftArrowBar: "⇤",
    LeftArrowRightArrow: "⇆",
    LeftCeiling: "⌈",
    LeftDoubleBracket: "⟦",
    LeftDownTeeVector: "⥡",
    LeftDownVector: "⇃",
    LeftDownVectorBar: "⥙",
    LeftFloor: "⌊",
    LeftRightArrow: "↔",
    LeftRightVector: "⥎",
    LeftTee: "⊣",
    LeftTeeArrow: "↤",
    LeftTeeVector: "⥚",
    LeftTriangle: "⊲",
    LeftTriangleBar: "⧏",
    LeftTriangleEqual: "⊴",
    LeftUpDownVector: "⥑",
    LeftUpTeeVector: "⥠",
    LeftUpVector: "↿",
    LeftUpVectorBar: "⥘",
    LeftVector: "↼",
    LeftVectorBar: "⥒",
    Leftarrow: "⇐",
    Leftrightarrow: "⇔",
    LessEqualGreater: "⋚",
    LessFullEqual: "≦",
    LessGreater: "≶",
    LessLess: "⪡",
    LessSlantEqual: "⩽",
    LessTilde: "≲",
    Lfr: "𝔏",
    Ll: "⋘",
    Lleftarrow: "⇚",
    Lmidot: "Ŀ",
    LongLeftArrow: "⟵",
    LongLeftRightArrow: "⟷",
    LongRightArrow: "⟶",
    Longleftarrow: "⟸",
    Longleftrightarrow: "⟺",
    Longrightarrow: "⟹",
    Lopf: "𝕃",
    LowerLeftArrow: "↙",
    LowerRightArrow: "↘",
    Lscr: "ℒ",
    Lsh: "↰",
    Lstrok: "Ł",
    Lt: "≪",
    Map: "⤅",
    Mcy: "М",
    MediumSpace: " ",
    Mellintrf: "ℳ",
    Mfr: "𝔐",
    MinusPlus: "∓",
    Mopf: "𝕄",
    Mscr: "ℳ",
    Mu: "Μ",
    NJcy: "Њ",
    Nacute: "Ń",
    Ncaron: "Ň",
    Ncedil: "Ņ",
    Ncy: "Н",
    NegativeMediumSpace: "​",
    NegativeThickSpace: "​",
    NegativeThinSpace: "​",
    NegativeVeryThinSpace: "​",
    NestedGreaterGreater: "≫",
    NestedLessLess: "≪",
    NewLine: "\n",
    Nfr: "𝔑",
    NoBreak: "⁠",
    NonBreakingSpace: " ",
    Nopf: "ℕ",
    Not: "⫬",
    NotCongruent: "≢",
    NotCupCap: "≭",
    NotDoubleVerticalBar: "∦",
    NotElement: "∉",
    NotEqual: "≠",
    NotEqualTilde: "≂̸",
    NotExists: "∄",
    NotGreater: "≯",
    NotGreaterEqual: "≱",
    NotGreaterFullEqual: "≧̸",
    NotGreaterGreater: "≫̸",
    NotGreaterLess: "≹",
    NotGreaterSlantEqual: "⩾̸",
    NotGreaterTilde: "≵",
    NotHumpDownHump: "≎̸",
    NotHumpEqual: "≏̸",
    NotLeftTriangle: "⋪",
    NotLeftTriangleBar: "⧏̸",
    NotLeftTriangleEqual: "⋬",
    NotLess: "≮",
    NotLessEqual: "≰",
    NotLessGreater: "≸",
    NotLessLess: "≪̸",
    NotLessSlantEqual: "⩽̸",
    NotLessTilde: "≴",
    NotNestedGreaterGreater: "⪢̸",
    NotNestedLessLess: "⪡̸",
    NotPrecedes: "⊀",
    NotPrecedesEqual: "⪯̸",
    NotPrecedesSlantEqual: "⋠",
    NotReverseElement: "∌",
    NotRightTriangle: "⋫",
    NotRightTriangleBar: "⧐̸",
    NotRightTriangleEqual: "⋭",
    NotSquareSubset: "⊏̸",
    NotSquareSubsetEqual: "⋢",
    NotSquareSuperset: "⊐̸",
    NotSquareSupersetEqual: "⋣",
    NotSubset: "⊂⃒",
    NotSubsetEqual: "⊈",
    NotSucceeds: "⊁",
    NotSucceedsEqual: "⪰̸",
    NotSucceedsSlantEqual: "⋡",
    NotSucceedsTilde: "≿̸",
    NotSuperset: "⊃⃒",
    NotSupersetEqual: "⊉",
    NotTilde: "≁",
    NotTildeEqual: "≄",
    NotTildeFullEqual: "≇",
    NotTildeTilde: "≉",
    NotVerticalBar: "∤",
    Nscr: "𝒩",
    Ntilde: "Ñ",
    Nu: "Ν",
    OElig: "Œ",
    Oacute: "Ó",
    Ocirc: "Ô",
    Ocy: "О",
    Odblac: "Ő",
    Ofr: "𝔒",
    Ograve: "Ò",
    Omacr: "Ō",
    Omega: "Ω",
    Omicron: "Ο",
    Oopf: "𝕆",
    OpenCurlyDoubleQuote: "“",
    OpenCurlyQuote: "‘",
    Or: "⩔",
    Oscr: "𝒪",
    Oslash: "Ø",
    Otilde: "Õ",
    Otimes: "⨷",
    Ouml: "Ö",
    OverBar: "‾",
    OverBrace: "⏞",
    OverBracket: "⎴",
    OverParenthesis: "⏜",
    PartialD: "∂",
    Pcy: "П",
    Pfr: "𝔓",
    Phi: "Φ",
    Pi: "Π",
    PlusMinus: "±",
    Poincareplane: "ℌ",
    Popf: "ℙ",
    Pr: "⪻",
    Precedes: "≺",
    PrecedesEqual: "⪯",
    PrecedesSlantEqual: "≼",
    PrecedesTilde: "≾",
    Prime: "″",
    Product: "∏",
    Proportion: "∷",
    Proportional: "∝",
    Pscr: "𝒫",
    Psi: "Ψ",
    QUOT: '"',
    Qfr: "𝔔",
    Qopf: "ℚ",
    Qscr: "𝒬",
    RBarr: "⤐",
    REG: "®",
    Racute: "Ŕ",
    Rang: "⟫",
    Rarr: "↠",
    Rarrtl: "⤖",
    Rcaron: "Ř",
    Rcedil: "Ŗ",
    Rcy: "Р",
    Re: "ℜ",
    ReverseElement: "∋",
    ReverseEquilibrium: "⇋",
    ReverseUpEquilibrium: "⥯",
    Rfr: "ℜ",
    Rho: "Ρ",
    RightAngleBracket: "⟩",
    RightArrow: "→",
    RightArrowBar: "⇥",
    RightArrowLeftArrow: "⇄",
    RightCeiling: "⌉",
    RightDoubleBracket: "⟧",
    RightDownTeeVector: "⥝",
    RightDownVector: "⇂",
    RightDownVectorBar: "⥕",
    RightFloor: "⌋",
    RightTee: "⊢",
    RightTeeArrow: "↦",
    RightTeeVector: "⥛",
    RightTriangle: "⊳",
    RightTriangleBar: "⧐",
    RightTriangleEqual: "⊵",
    RightUpDownVector: "⥏",
    RightUpTeeVector: "⥜",
    RightUpVector: "↾",
    RightUpVectorBar: "⥔",
    RightVector: "⇀",
    RightVectorBar: "⥓",
    Rightarrow: "⇒",
    Ropf: "ℝ",
    RoundImplies: "⥰",
    Rrightarrow: "⇛",
    Rscr: "ℛ",
    Rsh: "↱",
    RuleDelayed: "⧴",
    SHCHcy: "Щ",
    SHcy: "Ш",
    SOFTcy: "Ь",
    Sacute: "Ś",
    Sc: "⪼",
    Scaron: "Š",
    Scedil: "Ş",
    Scirc: "Ŝ",
    Scy: "С",
    Sfr: "𝔖",
    ShortDownArrow: "↓",
    ShortLeftArrow: "←",
    ShortRightArrow: "→",
    ShortUpArrow: "↑",
    Sigma: "Σ",
    SmallCircle: "∘",
    Sopf: "𝕊",
    Sqrt: "√",
    Square: "□",
    SquareIntersection: "⊓",
    SquareSubset: "⊏",
    SquareSubsetEqual: "⊑",
    SquareSuperset: "⊐",
    SquareSupersetEqual: "⊒",
    SquareUnion: "⊔",
    Sscr: "𝒮",
    Star: "⋆",
    Sub: "⋐",
    Subset: "⋐",
    SubsetEqual: "⊆",
    Succeeds: "≻",
    SucceedsEqual: "⪰",
    SucceedsSlantEqual: "≽",
    SucceedsTilde: "≿",
    SuchThat: "∋",
    Sum: "∑",
    Sup: "⋑",
    Superset: "⊃",
    SupersetEqual: "⊇",
    Supset: "⋑",
    THORN: "Þ",
    TRADE: "™",
    TSHcy: "Ћ",
    TScy: "Ц",
    Tab: "\t",
    Tau: "Τ",
    Tcaron: "Ť",
    Tcedil: "Ţ",
    Tcy: "Т",
    Tfr: "𝔗",
    Therefore: "∴",
    Theta: "Θ",
    ThickSpace: "  ",
    ThinSpace: " ",
    Tilde: "∼",
    TildeEqual: "≃",
    TildeFullEqual: "≅",
    TildeTilde: "≈",
    Topf: "𝕋",
    TripleDot: "⃛",
    Tscr: "𝒯",
    Tstrok: "Ŧ",
    Uacute: "Ú",
    Uarr: "↟",
    Uarrocir: "⥉",
    Ubrcy: "Ў",
    Ubreve: "Ŭ",
    Ucirc: "Û",
    Ucy: "У",
    Udblac: "Ű",
    Ufr: "𝔘",
    Ugrave: "Ù",
    Umacr: "Ū",
    UnderBar: "_",
    UnderBrace: "⏟",
    UnderBracket: "⎵",
    UnderParenthesis: "⏝",
    Union: "⋃",
    UnionPlus: "⊎",
    Uogon: "Ų",
    Uopf: "𝕌",
    UpArrow: "↑",
    UpArrowBar: "⤒",
    UpArrowDownArrow: "⇅",
    UpDownArrow: "↕",
    UpEquilibrium: "⥮",
    UpTee: "⊥",
    UpTeeArrow: "↥",
    Uparrow: "⇑",
    Updownarrow: "⇕",
    UpperLeftArrow: "↖",
    UpperRightArrow: "↗",
    Upsi: "ϒ",
    Upsilon: "Υ",
    Uring: "Ů",
    Uscr: "𝒰",
    Utilde: "Ũ",
    Uuml: "Ü",
    VDash: "⊫",
    Vbar: "⫫",
    Vcy: "В",
    Vdash: "⊩",
    Vdashl: "⫦",
    Vee: "⋁",
    Verbar: "‖",
    Vert: "‖",
    VerticalBar: "∣",
    VerticalLine: "|",
    VerticalSeparator: "❘",
    VerticalTilde: "≀",
    VeryThinSpace: " ",
    Vfr: "𝔙",
    Vopf: "𝕍",
    Vscr: "𝒱",
    Vvdash: "⊪",
    Wcirc: "Ŵ",
    Wedge: "⋀",
    Wfr: "𝔚",
    Wopf: "𝕎",
    Wscr: "𝒲",
    Xfr: "𝔛",
    Xi: "Ξ",
    Xopf: "𝕏",
    Xscr: "𝒳",
    YAcy: "Я",
    YIcy: "Ї",
    YUcy: "Ю",
    Yacute: "Ý",
    Ycirc: "Ŷ",
    Ycy: "Ы",
    Yfr: "𝔜",
    Yopf: "𝕐",
    Yscr: "𝒴",
    Yuml: "Ÿ",
    ZHcy: "Ж",
    Zacute: "Ź",
    Zcaron: "Ž",
    Zcy: "З",
    Zdot: "Ż",
    ZeroWidthSpace: "​",
    Zeta: "Ζ",
    Zfr: "ℨ",
    Zopf: "ℤ",
    Zscr: "𝒵",
    aacute: "á",
    abreve: "ă",
    ac: "∾",
    acE: "∾̳",
    acd: "∿",
    acirc: "â",
    acute: "´",
    acy: "а",
    aelig: "æ",
    af: "⁡",
    afr: "𝔞",
    agrave: "à",
    alefsym: "ℵ",
    aleph: "ℵ",
    alpha: "α",
    amacr: "ā",
    amalg: "⨿",
    amp: "&",
    and: "∧",
    andand: "⩕",
    andd: "⩜",
    andslope: "⩘",
    andv: "⩚",
    ang: "∠",
    ange: "⦤",
    angle: "∠",
    angmsd: "∡",
    angmsdaa: "⦨",
    angmsdab: "⦩",
    angmsdac: "⦪",
    angmsdad: "⦫",
    angmsdae: "⦬",
    angmsdaf: "⦭",
    angmsdag: "⦮",
    angmsdah: "⦯",
    angrt: "∟",
    angrtvb: "⊾",
    angrtvbd: "⦝",
    angsph: "∢",
    angst: "Å",
    angzarr: "⍼",
    aogon: "ą",
    aopf: "𝕒",
    ap: "≈",
    apE: "⩰",
    apacir: "⩯",
    ape: "≊",
    apid: "≋",
    apos: "'",
    approx: "≈",
    approxeq: "≊",
    aring: "å",
    ascr: "𝒶",
    ast: "*",
    asymp: "≈",
    asympeq: "≍",
    atilde: "ã",
    auml: "ä",
    awconint: "∳",
    awint: "⨑",
    bNot: "⫭",
    backcong: "≌",
    backepsilon: "϶",
    backprime: "‵",
    backsim: "∽",
    backsimeq: "⋍",
    barvee: "⊽",
    barwed: "⌅",
    barwedge: "⌅",
    bbrk: "⎵",
    bbrktbrk: "⎶",
    bcong: "≌",
    bcy: "б",
    bdquo: "„",
    becaus: "∵",
    because: "∵",
    bemptyv: "⦰",
    bepsi: "϶",
    bernou: "ℬ",
    beta: "β",
    beth: "ℶ",
    between: "≬",
    bfr: "𝔟",
    bigcap: "⋂",
    bigcirc: "◯",
    bigcup: "⋃",
    bigodot: "⨀",
    bigoplus: "⨁",
    bigotimes: "⨂",
    bigsqcup: "⨆",
    bigstar: "★",
    bigtriangledown: "▽",
    bigtriangleup: "△",
    biguplus: "⨄",
    bigvee: "⋁",
    bigwedge: "⋀",
    bkarow: "⤍",
    blacklozenge: "⧫",
    blacksquare: "▪",
    blacktriangle: "▴",
    blacktriangledown: "▾",
    blacktriangleleft: "◂",
    blacktriangleright: "▸",
    blank: "␣",
    blk12: "▒",
    blk14: "░",
    blk34: "▓",
    block: "█",
    bne: "=⃥",
    bnequiv: "≡⃥",
    bnot: "⌐",
    bopf: "𝕓",
    bot: "⊥",
    bottom: "⊥",
    bowtie: "⋈",
    boxDL: "╗",
    boxDR: "╔",
    boxDl: "╖",
    boxDr: "╓",
    boxH: "═",
    boxHD: "╦",
    boxHU: "╩",
    boxHd: "╤",
    boxHu: "╧",
    boxUL: "╝",
    boxUR: "╚",
    boxUl: "╜",
    boxUr: "╙",
    boxV: "║",
    boxVH: "╬",
    boxVL: "╣",
    boxVR: "╠",
    boxVh: "╫",
    boxVl: "╢",
    boxVr: "╟",
    boxbox: "⧉",
    boxdL: "╕",
    boxdR: "╒",
    boxdl: "┐",
    boxdr: "┌",
    boxh: "─",
    boxhD: "╥",
    boxhU: "╨",
    boxhd: "┬",
    boxhu: "┴",
    boxminus: "⊟",
    boxplus: "⊞",
    boxtimes: "⊠",
    boxuL: "╛",
    boxuR: "╘",
    boxul: "┘",
    boxur: "└",
    boxv: "│",
    boxvH: "╪",
    boxvL: "╡",
    boxvR: "╞",
    boxvh: "┼",
    boxvl: "┤",
    boxvr: "├",
    bprime: "‵",
    breve: "˘",
    brvbar: "¦",
    bscr: "𝒷",
    bsemi: "⁏",
    bsim: "∽",
    bsime: "⋍",
    bsol: "\\",
    bsolb: "⧅",
    bsolhsub: "⟈",
    bull: "•",
    bullet: "•",
    bump: "≎",
    bumpE: "⪮",
    bumpe: "≏",
    bumpeq: "≏",
    cacute: "ć",
    cap: "∩",
    capand: "⩄",
    capbrcup: "⩉",
    capcap: "⩋",
    capcup: "⩇",
    capdot: "⩀",
    caps: "∩︀",
    caret: "⁁",
    caron: "ˇ",
    ccaps: "⩍",
    ccaron: "č",
    ccedil: "ç",
    ccirc: "ĉ",
    ccups: "⩌",
    ccupssm: "⩐",
    cdot: "ċ",
    cedil: "¸",
    cemptyv: "⦲",
    cent: "¢",
    centerdot: "·",
    cfr: "𝔠",
    chcy: "ч",
    check: "✓",
    checkmark: "✓",
    chi: "χ",
    cir: "○",
    cirE: "⧃",
    circ: "ˆ",
    circeq: "≗",
    circlearrowleft: "↺",
    circlearrowright: "↻",
    circledR: "®",
    circledS: "Ⓢ",
    circledast: "⊛",
    circledcirc: "⊚",
    circleddash: "⊝",
    cire: "≗",
    cirfnint: "⨐",
    cirmid: "⫯",
    cirscir: "⧂",
    clubs: "♣",
    clubsuit: "♣",
    colon: ":",
    colone: "≔",
    coloneq: "≔",
    comma: ",",
    commat: "@",
    comp: "∁",
    compfn: "∘",
    complement: "∁",
    complexes: "ℂ",
    cong: "≅",
    congdot: "⩭",
    conint: "∮",
    copf: "𝕔",
    coprod: "∐",
    copy: "©",
    copysr: "℗",
    crarr: "↵",
    cross: "✗",
    cscr: "𝒸",
    csub: "⫏",
    csube: "⫑",
    csup: "⫐",
    csupe: "⫒",
    ctdot: "⋯",
    cudarrl: "⤸",
    cudarrr: "⤵",
    cuepr: "⋞",
    cuesc: "⋟",
    cularr: "↶",
    cularrp: "⤽",
    cup: "∪",
    cupbrcap: "⩈",
    cupcap: "⩆",
    cupcup: "⩊",
    cupdot: "⊍",
    cupor: "⩅",
    cups: "∪︀",
    curarr: "↷",
    curarrm: "⤼",
    curlyeqprec: "⋞",
    curlyeqsucc: "⋟",
    curlyvee: "⋎",
    curlywedge: "⋏",
    curren: "¤",
    curvearrowleft: "↶",
    curvearrowright: "↷",
    cuvee: "⋎",
    cuwed: "⋏",
    cwconint: "∲",
    cwint: "∱",
    cylcty: "⌭",
    dArr: "⇓",
    dHar: "⥥",
    dagger: "†",
    daleth: "ℸ",
    darr: "↓",
    dash: "‐",
    dashv: "⊣",
    dbkarow: "⤏",
    dblac: "˝",
    dcaron: "ď",
    dcy: "д",
    dd: "ⅆ",
    ddagger: "‡",
    ddarr: "⇊",
    ddotseq: "⩷",
    deg: "°",
    delta: "δ",
    demptyv: "⦱",
    dfisht: "⥿",
    dfr: "𝔡",
    dharl: "⇃",
    dharr: "⇂",
    diam: "⋄",
    diamond: "⋄",
    diamondsuit: "♦",
    diams: "♦",
    die: "¨",
    digamma: "ϝ",
    disin: "⋲",
    div: "÷",
    divide: "÷",
    divideontimes: "⋇",
    divonx: "⋇",
    djcy: "ђ",
    dlcorn: "⌞",
    dlcrop: "⌍",
    dollar: "$",
    dopf: "𝕕",
    dot: "˙",
    doteq: "≐",
    doteqdot: "≑",
    dotminus: "∸",
    dotplus: "∔",
    dotsquare: "⊡",
    doublebarwedge: "⌆",
    downarrow: "↓",
    downdownarrows: "⇊",
    downharpoonleft: "⇃",
    downharpoonright: "⇂",
    drbkarow: "⤐",
    drcorn: "⌟",
    drcrop: "⌌",
    dscr: "𝒹",
    dscy: "ѕ",
    dsol: "⧶",
    dstrok: "đ",
    dtdot: "⋱",
    dtri: "▿",
    dtrif: "▾",
    duarr: "⇵",
    duhar: "⥯",
    dwangle: "⦦",
    dzcy: "џ",
    dzigrarr: "⟿",
    eDDot: "⩷",
    eDot: "≑",
    eacute: "é",
    easter: "⩮",
    ecaron: "ě",
    ecir: "≖",
    ecirc: "ê",
    ecolon: "≕",
    ecy: "э",
    edot: "ė",
    ee: "ⅇ",
    efDot: "≒",
    efr: "𝔢",
    eg: "⪚",
    egrave: "è",
    egs: "⪖",
    egsdot: "⪘",
    el: "⪙",
    elinters: "⏧",
    ell: "ℓ",
    els: "⪕",
    elsdot: "⪗",
    emacr: "ē",
    empty: "∅",
    emptyset: "∅",
    emptyv: "∅",
    emsp13: " ",
    emsp14: " ",
    emsp: " ",
    eng: "ŋ",
    ensp: " ",
    eogon: "ę",
    eopf: "𝕖",
    epar: "⋕",
    eparsl: "⧣",
    eplus: "⩱",
    epsi: "ε",
    epsilon: "ε",
    epsiv: "ϵ",
    eqcirc: "≖",
    eqcolon: "≕",
    eqsim: "≂",
    eqslantgtr: "⪖",
    eqslantless: "⪕",
    equals: "=",
    equest: "≟",
    equiv: "≡",
    equivDD: "⩸",
    eqvparsl: "⧥",
    erDot: "≓",
    erarr: "⥱",
    escr: "ℯ",
    esdot: "≐",
    esim: "≂",
    eta: "η",
    eth: "ð",
    euml: "ë",
    euro: "€",
    excl: "!",
    exist: "∃",
    expectation: "ℰ",
    exponentiale: "ⅇ",
    fallingdotseq: "≒",
    fcy: "ф",
    female: "♀",
    ffilig: "ﬃ",
    fflig: "ﬀ",
    ffllig: "ﬄ",
    ffr: "𝔣",
    filig: "ﬁ",
    fjlig: "fj",
    flat: "♭",
    fllig: "ﬂ",
    fltns: "▱",
    fnof: "ƒ",
    fopf: "𝕗",
    forall: "∀",
    fork: "⋔",
    forkv: "⫙",
    fpartint: "⨍",
    frac12: "½",
    frac13: "⅓",
    frac14: "¼",
    frac15: "⅕",
    frac16: "⅙",
    frac18: "⅛",
    frac23: "⅔",
    frac25: "⅖",
    frac34: "¾",
    frac35: "⅗",
    frac38: "⅜",
    frac45: "⅘",
    frac56: "⅚",
    frac58: "⅝",
    frac78: "⅞",
    frasl: "⁄",
    frown: "⌢",
    fscr: "𝒻",
    gE: "≧",
    gEl: "⪌",
    gacute: "ǵ",
    gamma: "γ",
    gammad: "ϝ",
    gap: "⪆",
    gbreve: "ğ",
    gcirc: "ĝ",
    gcy: "г",
    gdot: "ġ",
    ge: "≥",
    gel: "⋛",
    geq: "≥",
    geqq: "≧",
    geqslant: "⩾",
    ges: "⩾",
    gescc: "⪩",
    gesdot: "⪀",
    gesdoto: "⪂",
    gesdotol: "⪄",
    gesl: "⋛︀",
    gesles: "⪔",
    gfr: "𝔤",
    gg: "≫",
    ggg: "⋙",
    gimel: "ℷ",
    gjcy: "ѓ",
    gl: "≷",
    glE: "⪒",
    gla: "⪥",
    glj: "⪤",
    gnE: "≩",
    gnap: "⪊",
    gnapprox: "⪊",
    gne: "⪈",
    gneq: "⪈",
    gneqq: "≩",
    gnsim: "⋧",
    gopf: "𝕘",
    grave: "`",
    gscr: "ℊ",
    gsim: "≳",
    gsime: "⪎",
    gsiml: "⪐",
    gt: ">",
    gtcc: "⪧",
    gtcir: "⩺",
    gtdot: "⋗",
    gtlPar: "⦕",
    gtquest: "⩼",
    gtrapprox: "⪆",
    gtrarr: "⥸",
    gtrdot: "⋗",
    gtreqless: "⋛",
    gtreqqless: "⪌",
    gtrless: "≷",
    gtrsim: "≳",
    gvertneqq: "≩︀",
    gvnE: "≩︀",
    hArr: "⇔",
    hairsp: " ",
    half: "½",
    hamilt: "ℋ",
    hardcy: "ъ",
    harr: "↔",
    harrcir: "⥈",
    harrw: "↭",
    hbar: "ℏ",
    hcirc: "ĥ",
    hearts: "♥",
    heartsuit: "♥",
    hellip: "…",
    hercon: "⊹",
    hfr: "𝔥",
    hksearow: "⤥",
    hkswarow: "⤦",
    hoarr: "⇿",
    homtht: "∻",
    hookleftarrow: "↩",
    hookrightarrow: "↪",
    hopf: "𝕙",
    horbar: "―",
    hscr: "𝒽",
    hslash: "ℏ",
    hstrok: "ħ",
    hybull: "⁃",
    hyphen: "‐",
    iacute: "í",
    ic: "⁣",
    icirc: "î",
    icy: "и",
    iecy: "е",
    iexcl: "¡",
    iff: "⇔",
    ifr: "𝔦",
    igrave: "ì",
    ii: "ⅈ",
    iiiint: "⨌",
    iiint: "∭",
    iinfin: "⧜",
    iiota: "℩",
    ijlig: "ĳ",
    imacr: "ī",
    image: "ℑ",
    imagline: "ℐ",
    imagpart: "ℑ",
    imath: "ı",
    imof: "⊷",
    imped: "Ƶ",
    in: "∈",
    incare: "℅",
    infin: "∞",
    infintie: "⧝",
    inodot: "ı",
    int: "∫",
    intcal: "⊺",
    integers: "ℤ",
    intercal: "⊺",
    intlarhk: "⨗",
    intprod: "⨼",
    iocy: "ё",
    iogon: "į",
    iopf: "𝕚",
    iota: "ι",
    iprod: "⨼",
    iquest: "¿",
    iscr: "𝒾",
    isin: "∈",
    isinE: "⋹",
    isindot: "⋵",
    isins: "⋴",
    isinsv: "⋳",
    isinv: "∈",
    it: "⁢",
    itilde: "ĩ",
    iukcy: "і",
    iuml: "ï",
    jcirc: "ĵ",
    jcy: "й",
    jfr: "𝔧",
    jmath: "ȷ",
    jopf: "𝕛",
    jscr: "𝒿",
    jsercy: "ј",
    jukcy: "є",
    kappa: "κ",
    kappav: "ϰ",
    kcedil: "ķ",
    kcy: "к",
    kfr: "𝔨",
    kgreen: "ĸ",
    khcy: "х",
    kjcy: "ќ",
    kopf: "𝕜",
    kscr: "𝓀",
    lAarr: "⇚",
    lArr: "⇐",
    lAtail: "⤛",
    lBarr: "⤎",
    lE: "≦",
    lEg: "⪋",
    lHar: "⥢",
    lacute: "ĺ",
    laemptyv: "⦴",
    lagran: "ℒ",
    lambda: "λ",
    lang: "⟨",
    langd: "⦑",
    langle: "⟨",
    lap: "⪅",
    laquo: "«",
    larr: "←",
    larrb: "⇤",
    larrbfs: "⤟",
    larrfs: "⤝",
    larrhk: "↩",
    larrlp: "↫",
    larrpl: "⤹",
    larrsim: "⥳",
    larrtl: "↢",
    lat: "⪫",
    latail: "⤙",
    late: "⪭",
    lates: "⪭︀",
    lbarr: "⤌",
    lbbrk: "❲",
    lbrace: "{",
    lbrack: "[",
    lbrke: "⦋",
    lbrksld: "⦏",
    lbrkslu: "⦍",
    lcaron: "ľ",
    lcedil: "ļ",
    lceil: "⌈",
    lcub: "{",
    lcy: "л",
    ldca: "⤶",
    ldquo: "“",
    ldquor: "„",
    ldrdhar: "⥧",
    ldrushar: "⥋",
    ldsh: "↲",
    le: "≤",
    leftarrow: "←",
    leftarrowtail: "↢",
    leftharpoondown: "↽",
    leftharpoonup: "↼",
    leftleftarrows: "⇇",
    leftrightarrow: "↔",
    leftrightarrows: "⇆",
    leftrightharpoons: "⇋",
    leftrightsquigarrow: "↭",
    leftthreetimes: "⋋",
    leg: "⋚",
    leq: "≤",
    leqq: "≦",
    leqslant: "⩽",
    les: "⩽",
    lescc: "⪨",
    lesdot: "⩿",
    lesdoto: "⪁",
    lesdotor: "⪃",
    lesg: "⋚︀",
    lesges: "⪓",
    lessapprox: "⪅",
    lessdot: "⋖",
    lesseqgtr: "⋚",
    lesseqqgtr: "⪋",
    lessgtr: "≶",
    lesssim: "≲",
    lfisht: "⥼",
    lfloor: "⌊",
    lfr: "𝔩",
    lg: "≶",
    lgE: "⪑",
    lhard: "↽",
    lharu: "↼",
    lharul: "⥪",
    lhblk: "▄",
    ljcy: "љ",
    ll: "≪",
    llarr: "⇇",
    llcorner: "⌞",
    llhard: "⥫",
    lltri: "◺",
    lmidot: "ŀ",
    lmoust: "⎰",
    lmoustache: "⎰",
    lnE: "≨",
    lnap: "⪉",
    lnapprox: "⪉",
    lne: "⪇",
    lneq: "⪇",
    lneqq: "≨",
    lnsim: "⋦",
    loang: "⟬",
    loarr: "⇽",
    lobrk: "⟦",
    longleftarrow: "⟵",
    longleftrightarrow: "⟷",
    longmapsto: "⟼",
    longrightarrow: "⟶",
    looparrowleft: "↫",
    looparrowright: "↬",
    lopar: "⦅",
    lopf: "𝕝",
    loplus: "⨭",
    lotimes: "⨴",
    lowast: "∗",
    lowbar: "_",
    loz: "◊",
    lozenge: "◊",
    lozf: "⧫",
    lpar: "(",
    lparlt: "⦓",
    lrarr: "⇆",
    lrcorner: "⌟",
    lrhar: "⇋",
    lrhard: "⥭",
    lrm: "‎",
    lrtri: "⊿",
    lsaquo: "‹",
    lscr: "𝓁",
    lsh: "↰",
    lsim: "≲",
    lsime: "⪍",
    lsimg: "⪏",
    lsqb: "[",
    lsquo: "‘",
    lsquor: "‚",
    lstrok: "ł",
    lt: "<",
    ltcc: "⪦",
    ltcir: "⩹",
    ltdot: "⋖",
    lthree: "⋋",
    ltimes: "⋉",
    ltlarr: "⥶",
    ltquest: "⩻",
    ltrPar: "⦖",
    ltri: "◃",
    ltrie: "⊴",
    ltrif: "◂",
    lurdshar: "⥊",
    luruhar: "⥦",
    lvertneqq: "≨︀",
    lvnE: "≨︀",
    mDDot: "∺",
    macr: "¯",
    male: "♂",
    malt: "✠",
    maltese: "✠",
    map: "↦",
    mapsto: "↦",
    mapstodown: "↧",
    mapstoleft: "↤",
    mapstoup: "↥",
    marker: "▮",
    mcomma: "⨩",
    mcy: "м",
    mdash: "—",
    measuredangle: "∡",
    mfr: "𝔪",
    mho: "℧",
    micro: "µ",
    mid: "∣",
    midast: "*",
    midcir: "⫰",
    middot: "·",
    minus: "−",
    minusb: "⊟",
    minusd: "∸",
    minusdu: "⨪",
    mlcp: "⫛",
    mldr: "…",
    mnplus: "∓",
    models: "⊧",
    mopf: "𝕞",
    mp: "∓",
    mscr: "𝓂",
    mstpos: "∾",
    mu: "μ",
    multimap: "⊸",
    mumap: "⊸",
    nGg: "⋙̸",
    nGt: "≫⃒",
    nGtv: "≫̸",
    nLeftarrow: "⇍",
    nLeftrightarrow: "⇎",
    nLl: "⋘̸",
    nLt: "≪⃒",
    nLtv: "≪̸",
    nRightarrow: "⇏",
    nVDash: "⊯",
    nVdash: "⊮",
    nabla: "∇",
    nacute: "ń",
    nang: "∠⃒",
    nap: "≉",
    napE: "⩰̸",
    napid: "≋̸",
    napos: "ŉ",
    napprox: "≉",
    natur: "♮",
    natural: "♮",
    naturals: "ℕ",
    nbsp: " ",
    nbump: "≎̸",
    nbumpe: "≏̸",
    ncap: "⩃",
    ncaron: "ň",
    ncedil: "ņ",
    ncong: "≇",
    ncongdot: "⩭̸",
    ncup: "⩂",
    ncy: "н",
    ndash: "–",
    ne: "≠",
    neArr: "⇗",
    nearhk: "⤤",
    nearr: "↗",
    nearrow: "↗",
    nedot: "≐̸",
    nequiv: "≢",
    nesear: "⤨",
    nesim: "≂̸",
    nexist: "∄",
    nexists: "∄",
    nfr: "𝔫",
    ngE: "≧̸",
    nge: "≱",
    ngeq: "≱",
    ngeqq: "≧̸",
    ngeqslant: "⩾̸",
    nges: "⩾̸",
    ngsim: "≵",
    ngt: "≯",
    ngtr: "≯",
    nhArr: "⇎",
    nharr: "↮",
    nhpar: "⫲",
    ni: "∋",
    nis: "⋼",
    nisd: "⋺",
    niv: "∋",
    njcy: "њ",
    nlArr: "⇍",
    nlE: "≦̸",
    nlarr: "↚",
    nldr: "‥",
    nle: "≰",
    nleftarrow: "↚",
    nleftrightarrow: "↮",
    nleq: "≰",
    nleqq: "≦̸",
    nleqslant: "⩽̸",
    nles: "⩽̸",
    nless: "≮",
    nlsim: "≴",
    nlt: "≮",
    nltri: "⋪",
    nltrie: "⋬",
    nmid: "∤",
    nopf: "𝕟",
    not: "¬",
    notin: "∉",
    notinE: "⋹̸",
    notindot: "⋵̸",
    notinva: "∉",
    notinvb: "⋷",
    notinvc: "⋶",
    notni: "∌",
    notniva: "∌",
    notnivb: "⋾",
    notnivc: "⋽",
    npar: "∦",
    nparallel: "∦",
    nparsl: "⫽⃥",
    npart: "∂̸",
    npolint: "⨔",
    npr: "⊀",
    nprcue: "⋠",
    npre: "⪯̸",
    nprec: "⊀",
    npreceq: "⪯̸",
    nrArr: "⇏",
    nrarr: "↛",
    nrarrc: "⤳̸",
    nrarrw: "↝̸",
    nrightarrow: "↛",
    nrtri: "⋫",
    nrtrie: "⋭",
    nsc: "⊁",
    nsccue: "⋡",
    nsce: "⪰̸",
    nscr: "𝓃",
    nshortmid: "∤",
    nshortparallel: "∦",
    nsim: "≁",
    nsime: "≄",
    nsimeq: "≄",
    nsmid: "∤",
    nspar: "∦",
    nsqsube: "⋢",
    nsqsupe: "⋣",
    nsub: "⊄",
    nsubE: "⫅̸",
    nsube: "⊈",
    nsubset: "⊂⃒",
    nsubseteq: "⊈",
    nsubseteqq: "⫅̸",
    nsucc: "⊁",
    nsucceq: "⪰̸",
    nsup: "⊅",
    nsupE: "⫆̸",
    nsupe: "⊉",
    nsupset: "⊃⃒",
    nsupseteq: "⊉",
    nsupseteqq: "⫆̸",
    ntgl: "≹",
    ntilde: "ñ",
    ntlg: "≸",
    ntriangleleft: "⋪",
    ntrianglelefteq: "⋬",
    ntriangleright: "⋫",
    ntrianglerighteq: "⋭",
    nu: "ν",
    num: "#",
    numero: "№",
    numsp: " ",
    nvDash: "⊭",
    nvHarr: "⤄",
    nvap: "≍⃒",
    nvdash: "⊬",
    nvge: "≥⃒",
    nvgt: ">⃒",
    nvinfin: "⧞",
    nvlArr: "⤂",
    nvle: "≤⃒",
    nvlt: "<⃒",
    nvltrie: "⊴⃒",
    nvrArr: "⤃",
    nvrtrie: "⊵⃒",
    nvsim: "∼⃒",
    nwArr: "⇖",
    nwarhk: "⤣",
    nwarr: "↖",
    nwarrow: "↖",
    nwnear: "⤧",
    oS: "Ⓢ",
    oacute: "ó",
    oast: "⊛",
    ocir: "⊚",
    ocirc: "ô",
    ocy: "о",
    odash: "⊝",
    odblac: "ő",
    odiv: "⨸",
    odot: "⊙",
    odsold: "⦼",
    oelig: "œ",
    ofcir: "⦿",
    ofr: "𝔬",
    ogon: "˛",
    ograve: "ò",
    ogt: "⧁",
    ohbar: "⦵",
    ohm: "Ω",
    oint: "∮",
    olarr: "↺",
    olcir: "⦾",
    olcross: "⦻",
    oline: "‾",
    olt: "⧀",
    omacr: "ō",
    omega: "ω",
    omicron: "ο",
    omid: "⦶",
    ominus: "⊖",
    oopf: "𝕠",
    opar: "⦷",
    operp: "⦹",
    oplus: "⊕",
    or: "∨",
    orarr: "↻",
    ord: "⩝",
    order: "ℴ",
    orderof: "ℴ",
    ordf: "ª",
    ordm: "º",
    origof: "⊶",
    oror: "⩖",
    orslope: "⩗",
    orv: "⩛",
    oscr: "ℴ",
    oslash: "ø",
    osol: "⊘",
    otilde: "õ",
    otimes: "⊗",
    otimesas: "⨶",
    ouml: "ö",
    ovbar: "⌽",
    par: "∥",
    para: "¶",
    parallel: "∥",
    parsim: "⫳",
    parsl: "⫽",
    part: "∂",
    pcy: "п",
    percnt: "%",
    period: ".",
    permil: "‰",
    perp: "⊥",
    pertenk: "‱",
    pfr: "𝔭",
    phi: "φ",
    phiv: "ϕ",
    phmmat: "ℳ",
    phone: "☎",
    pi: "π",
    pitchfork: "⋔",
    piv: "ϖ",
    planck: "ℏ",
    planckh: "ℎ",
    plankv: "ℏ",
    plus: "+",
    plusacir: "⨣",
    plusb: "⊞",
    pluscir: "⨢",
    plusdo: "∔",
    plusdu: "⨥",
    pluse: "⩲",
    plusmn: "±",
    plussim: "⨦",
    plustwo: "⨧",
    pm: "±",
    pointint: "⨕",
    popf: "𝕡",
    pound: "£",
    pr: "≺",
    prE: "⪳",
    prap: "⪷",
    prcue: "≼",
    pre: "⪯",
    prec: "≺",
    precapprox: "⪷",
    preccurlyeq: "≼",
    preceq: "⪯",
    precnapprox: "⪹",
    precneqq: "⪵",
    precnsim: "⋨",
    precsim: "≾",
    prime: "′",
    primes: "ℙ",
    prnE: "⪵",
    prnap: "⪹",
    prnsim: "⋨",
    prod: "∏",
    profalar: "⌮",
    profline: "⌒",
    profsurf: "⌓",
    prop: "∝",
    propto: "∝",
    prsim: "≾",
    prurel: "⊰",
    pscr: "𝓅",
    psi: "ψ",
    puncsp: " ",
    qfr: "𝔮",
    qint: "⨌",
    qopf: "𝕢",
    qprime: "⁗",
    qscr: "𝓆",
    quaternions: "ℍ",
    quatint: "⨖",
    quest: "?",
    questeq: "≟",
    quot: '"',
    rAarr: "⇛",
    rArr: "⇒",
    rAtail: "⤜",
    rBarr: "⤏",
    rHar: "⥤",
    race: "∽̱",
    racute: "ŕ",
    radic: "√",
    raemptyv: "⦳",
    rang: "⟩",
    rangd: "⦒",
    range: "⦥",
    rangle: "⟩",
    raquo: "»",
    rarr: "→",
    rarrap: "⥵",
    rarrb: "⇥",
    rarrbfs: "⤠",
    rarrc: "⤳",
    rarrfs: "⤞",
    rarrhk: "↪",
    rarrlp: "↬",
    rarrpl: "⥅",
    rarrsim: "⥴",
    rarrtl: "↣",
    rarrw: "↝",
    ratail: "⤚",
    ratio: "∶",
    rationals: "ℚ",
    rbarr: "⤍",
    rbbrk: "❳",
    rbrace: "}",
    rbrack: "]",
    rbrke: "⦌",
    rbrksld: "⦎",
    rbrkslu: "⦐",
    rcaron: "ř",
    rcedil: "ŗ",
    rceil: "⌉",
    rcub: "}",
    rcy: "р",
    rdca: "⤷",
    rdldhar: "⥩",
    rdquo: "”",
    rdquor: "”",
    rdsh: "↳",
    real: "ℜ",
    realine: "ℛ",
    realpart: "ℜ",
    reals: "ℝ",
    rect: "▭",
    reg: "®",
    rfisht: "⥽",
    rfloor: "⌋",
    rfr: "𝔯",
    rhard: "⇁",
    rharu: "⇀",
    rharul: "⥬",
    rho: "ρ",
    rhov: "ϱ",
    rightarrow: "→",
    rightarrowtail: "↣",
    rightharpoondown: "⇁",
    rightharpoonup: "⇀",
    rightleftarrows: "⇄",
    rightleftharpoons: "⇌",
    rightrightarrows: "⇉",
    rightsquigarrow: "↝",
    rightthreetimes: "⋌",
    ring: "˚",
    risingdotseq: "≓",
    rlarr: "⇄",
    rlhar: "⇌",
    rlm: "‏",
    rmoust: "⎱",
    rmoustache: "⎱",
    rnmid: "⫮",
    roang: "⟭",
    roarr: "⇾",
    robrk: "⟧",
    ropar: "⦆",
    ropf: "𝕣",
    roplus: "⨮",
    rotimes: "⨵",
    rpar: ")",
    rpargt: "⦔",
    rppolint: "⨒",
    rrarr: "⇉",
    rsaquo: "›",
    rscr: "𝓇",
    rsh: "↱",
    rsqb: "]",
    rsquo: "’",
    rsquor: "’",
    rthree: "⋌",
    rtimes: "⋊",
    rtri: "▹",
    rtrie: "⊵",
    rtrif: "▸",
    rtriltri: "⧎",
    ruluhar: "⥨",
    rx: "℞",
    sacute: "ś",
    sbquo: "‚",
    sc: "≻",
    scE: "⪴",
    scap: "⪸",
    scaron: "š",
    sccue: "≽",
    sce: "⪰",
    scedil: "ş",
    scirc: "ŝ",
    scnE: "⪶",
    scnap: "⪺",
    scnsim: "⋩",
    scpolint: "⨓",
    scsim: "≿",
    scy: "с",
    sdot: "⋅",
    sdotb: "⊡",
    sdote: "⩦",
    seArr: "⇘",
    searhk: "⤥",
    searr: "↘",
    searrow: "↘",
    sect: "§",
    semi: ";",
    seswar: "⤩",
    setminus: "∖",
    setmn: "∖",
    sext: "✶",
    sfr: "𝔰",
    sfrown: "⌢",
    sharp: "♯",
    shchcy: "щ",
    shcy: "ш",
    shortmid: "∣",
    shortparallel: "∥",
    shy: "­",
    sigma: "σ",
    sigmaf: "ς",
    sigmav: "ς",
    sim: "∼",
    simdot: "⩪",
    sime: "≃",
    simeq: "≃",
    simg: "⪞",
    simgE: "⪠",
    siml: "⪝",
    simlE: "⪟",
    simne: "≆",
    simplus: "⨤",
    simrarr: "⥲",
    slarr: "←",
    smallsetminus: "∖",
    smashp: "⨳",
    smeparsl: "⧤",
    smid: "∣",
    smile: "⌣",
    smt: "⪪",
    smte: "⪬",
    smtes: "⪬︀",
    softcy: "ь",
    sol: "/",
    solb: "⧄",
    solbar: "⌿",
    sopf: "𝕤",
    spades: "♠",
    spadesuit: "♠",
    spar: "∥",
    sqcap: "⊓",
    sqcaps: "⊓︀",
    sqcup: "⊔",
    sqcups: "⊔︀",
    sqsub: "⊏",
    sqsube: "⊑",
    sqsubset: "⊏",
    sqsubseteq: "⊑",
    sqsup: "⊐",
    sqsupe: "⊒",
    sqsupset: "⊐",
    sqsupseteq: "⊒",
    squ: "□",
    square: "□",
    squarf: "▪",
    squf: "▪",
    srarr: "→",
    sscr: "𝓈",
    ssetmn: "∖",
    ssmile: "⌣",
    sstarf: "⋆",
    star: "☆",
    starf: "★",
    straightepsilon: "ϵ",
    straightphi: "ϕ",
    strns: "¯",
    sub: "⊂",
    subE: "⫅",
    subdot: "⪽",
    sube: "⊆",
    subedot: "⫃",
    submult: "⫁",
    subnE: "⫋",
    subne: "⊊",
    subplus: "⪿",
    subrarr: "⥹",
    subset: "⊂",
    subseteq: "⊆",
    subseteqq: "⫅",
    subsetneq: "⊊",
    subsetneqq: "⫋",
    subsim: "⫇",
    subsub: "⫕",
    subsup: "⫓",
    succ: "≻",
    succapprox: "⪸",
    succcurlyeq: "≽",
    succeq: "⪰",
    succnapprox: "⪺",
    succneqq: "⪶",
    succnsim: "⋩",
    succsim: "≿",
    sum: "∑",
    sung: "♪",
    sup1: "¹",
    sup2: "²",
    sup3: "³",
    sup: "⊃",
    supE: "⫆",
    supdot: "⪾",
    supdsub: "⫘",
    supe: "⊇",
    supedot: "⫄",
    suphsol: "⟉",
    suphsub: "⫗",
    suplarr: "⥻",
    supmult: "⫂",
    supnE: "⫌",
    supne: "⊋",
    supplus: "⫀",
    supset: "⊃",
    supseteq: "⊇",
    supseteqq: "⫆",
    supsetneq: "⊋",
    supsetneqq: "⫌",
    supsim: "⫈",
    supsub: "⫔",
    supsup: "⫖",
    swArr: "⇙",
    swarhk: "⤦",
    swarr: "↙",
    swarrow: "↙",
    swnwar: "⤪",
    szlig: "ß",
    target: "⌖",
    tau: "τ",
    tbrk: "⎴",
    tcaron: "ť",
    tcedil: "ţ",
    tcy: "т",
    tdot: "⃛",
    telrec: "⌕",
    tfr: "𝔱",
    there4: "∴",
    therefore: "∴",
    theta: "θ",
    thetasym: "ϑ",
    thetav: "ϑ",
    thickapprox: "≈",
    thicksim: "∼",
    thinsp: " ",
    thkap: "≈",
    thksim: "∼",
    thorn: "þ",
    tilde: "˜",
    times: "×",
    timesb: "⊠",
    timesbar: "⨱",
    timesd: "⨰",
    tint: "∭",
    toea: "⤨",
    top: "⊤",
    topbot: "⌶",
    topcir: "⫱",
    topf: "𝕥",
    topfork: "⫚",
    tosa: "⤩",
    tprime: "‴",
    trade: "™",
    triangle: "▵",
    triangledown: "▿",
    triangleleft: "◃",
    trianglelefteq: "⊴",
    triangleq: "≜",
    triangleright: "▹",
    trianglerighteq: "⊵",
    tridot: "◬",
    trie: "≜",
    triminus: "⨺",
    triplus: "⨹",
    trisb: "⧍",
    tritime: "⨻",
    trpezium: "⏢",
    tscr: "𝓉",
    tscy: "ц",
    tshcy: "ћ",
    tstrok: "ŧ",
    twixt: "≬",
    twoheadleftarrow: "↞",
    twoheadrightarrow: "↠",
    uArr: "⇑",
    uHar: "⥣",
    uacute: "ú",
    uarr: "↑",
    ubrcy: "ў",
    ubreve: "ŭ",
    ucirc: "û",
    ucy: "у",
    udarr: "⇅",
    udblac: "ű",
    udhar: "⥮",
    ufisht: "⥾",
    ufr: "𝔲",
    ugrave: "ù",
    uharl: "↿",
    uharr: "↾",
    uhblk: "▀",
    ulcorn: "⌜",
    ulcorner: "⌜",
    ulcrop: "⌏",
    ultri: "◸",
    umacr: "ū",
    uml: "¨",
    uogon: "ų",
    uopf: "𝕦",
    uparrow: "↑",
    updownarrow: "↕",
    upharpoonleft: "↿",
    upharpoonright: "↾",
    uplus: "⊎",
    upsi: "υ",
    upsih: "ϒ",
    upsilon: "υ",
    upuparrows: "⇈",
    urcorn: "⌝",
    urcorner: "⌝",
    urcrop: "⌎",
    uring: "ů",
    urtri: "◹",
    uscr: "𝓊",
    utdot: "⋰",
    utilde: "ũ",
    utri: "▵",
    utrif: "▴",
    uuarr: "⇈",
    uuml: "ü",
    uwangle: "⦧",
    vArr: "⇕",
    vBar: "⫨",
    vBarv: "⫩",
    vDash: "⊨",
    vangrt: "⦜",
    varepsilon: "ϵ",
    varkappa: "ϰ",
    varnothing: "∅",
    varphi: "ϕ",
    varpi: "ϖ",
    varpropto: "∝",
    varr: "↕",
    varrho: "ϱ",
    varsigma: "ς",
    varsubsetneq: "⊊︀",
    varsubsetneqq: "⫋︀",
    varsupsetneq: "⊋︀",
    varsupsetneqq: "⫌︀",
    vartheta: "ϑ",
    vartriangleleft: "⊲",
    vartriangleright: "⊳",
    vcy: "в",
    vdash: "⊢",
    vee: "∨",
    veebar: "⊻",
    veeeq: "≚",
    vellip: "⋮",
    verbar: "|",
    vert: "|",
    vfr: "𝔳",
    vltri: "⊲",
    vnsub: "⊂⃒",
    vnsup: "⊃⃒",
    vopf: "𝕧",
    vprop: "∝",
    vrtri: "⊳",
    vscr: "𝓋",
    vsubnE: "⫋︀",
    vsubne: "⊊︀",
    vsupnE: "⫌︀",
    vsupne: "⊋︀",
    vzigzag: "⦚",
    wcirc: "ŵ",
    wedbar: "⩟",
    wedge: "∧",
    wedgeq: "≙",
    weierp: "℘",
    wfr: "𝔴",
    wopf: "𝕨",
    wp: "℘",
    wr: "≀",
    wreath: "≀",
    wscr: "𝓌",
    xcap: "⋂",
    xcirc: "◯",
    xcup: "⋃",
    xdtri: "▽",
    xfr: "𝔵",
    xhArr: "⟺",
    xharr: "⟷",
    xi: "ξ",
    xlArr: "⟸",
    xlarr: "⟵",
    xmap: "⟼",
    xnis: "⋻",
    xodot: "⨀",
    xopf: "𝕩",
    xoplus: "⨁",
    xotime: "⨂",
    xrArr: "⟹",
    xrarr: "⟶",
    xscr: "𝓍",
    xsqcup: "⨆",
    xuplus: "⨄",
    xutri: "△",
    xvee: "⋁",
    xwedge: "⋀",
    yacute: "ý",
    yacy: "я",
    ycirc: "ŷ",
    ycy: "ы",
    yen: "¥",
    yfr: "𝔶",
    yicy: "ї",
    yopf: "𝕪",
    yscr: "𝓎",
    yucy: "ю",
    yuml: "ÿ",
    zacute: "ź",
    zcaron: "ž",
    zcy: "з",
    zdot: "ż",
    zeetrf: "ℨ",
    zeta: "ζ",
    zfr: "𝔷",
    zhcy: "ж",
    zigrarr: "⇝",
    zopf: "𝕫",
    zscr: "𝓏",
    zwj: "‍",
    zwnj: "‌"
  },
  i7 = {}.hasOwnProperty;
function l7(e) {
  return !!i7.call(o7, e) && o7[e];
}
const s7 = {
  name: "characterReference",
  tokenize: function (e, t, r) {
    const n = this;
    let a,
      o,
      i = 0;
    return function (t) {
      return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(t), e.exit("characterReferenceMarker"), l;
    };
    function l(t) {
      return 35 === t ? (e.enter("characterReferenceMarkerNumeric"), e.consume(t), e.exit("characterReferenceMarkerNumeric"), s) : (e.enter("characterReferenceValue"), a = 31, o = T6, c(t));
    }
    function s(t) {
      return 88 === t || 120 === t ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(t), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), a = 6, o = F6, c) : (e.enter("characterReferenceValue"), a = 7, o = I6, c(t));
    }
    function c(l) {
      if (59 === l && i) {
        const a = e.exit("characterReferenceValue");
        return o !== T6 || l7(n.sliceSerialize(a)) ? (e.enter("characterReferenceMarker"), e.consume(l), e.exit("characterReferenceMarker"), e.exit("characterReference"), t) : r(l);
      }
      return o(l) && i++ < a ? (e.consume(l), c) : r(l);
    }
  }
};
const c7 = {
    tokenize: function (e, t, r) {
      const n = this;
      return function (t) {
        if (null === t) return r(t);
        return e.enter("lineEnding"), e.consume(t), e.exit("lineEnding"), a;
      };
      function a(e) {
        return n.parser.lazy[n.now().line] ? r(e) : t(e);
      }
    },
    partial: !0
  },
  u7 = {
    name: "codeFenced",
    tokenize: function (e, t, r) {
      const n = this,
        a = {
          tokenize: function (e, t, r) {
            let a = 0;
            return i;
            function i(t) {
              return e.enter("lineEnding"), e.consume(t), e.exit("lineEnding"), s;
            }
            function s(t) {
              return e.enter("codeFencedFence"), q6(t) ? W6(e, c, "linePrefix", n.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(t) : c(t);
            }
            function c(t) {
              return t === o ? (e.enter("codeFencedFenceSequence"), u(t)) : r(t);
            }
            function u(t) {
              return t === o ? (a++, e.consume(t), u) : a >= l ? (e.exit("codeFencedFenceSequence"), q6(t) ? W6(e, h, "whitespace")(t) : h(t)) : r(t);
            }
            function h(n) {
              return null === n || Z6(n) ? (e.exit("codeFencedFence"), t(n)) : r(n);
            }
          },
          partial: !0
        };
      let o,
        i = 0,
        l = 0;
      return function (t) {
        return function (t) {
          const r = n.events[n.events.length - 1];
          return i = r && "linePrefix" === r[1].type ? r[2].sliceSerialize(r[1], !0).length : 0, o = t, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), s(t);
        }(t);
      };
      function s(t) {
        return t === o ? (l++, e.consume(t), s) : l < 3 ? r(t) : (e.exit("codeFencedFenceSequence"), q6(t) ? W6(e, c, "whitespace")(t) : c(t));
      }
      function c(r) {
        return null === r || Z6(r) ? (e.exit("codeFencedFence"), n.interrupt ? t(r) : e.check(c7, p, b)(r)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
          contentType: "string"
        }), u(r));
      }
      function u(t) {
        return null === t || Z6(t) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), c(t)) : q6(t) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), W6(e, h, "whitespace")(t)) : 96 === t && t === o ? r(t) : (e.consume(t), u);
      }
      function h(t) {
        return null === t || Z6(t) ? c(t) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
          contentType: "string"
        }), m(t));
      }
      function m(t) {
        return null === t || Z6(t) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), c(t)) : 96 === t && t === o ? r(t) : (e.consume(t), m);
      }
      function p(t) {
        return e.attempt(a, b, f)(t);
      }
      function f(t) {
        return e.enter("lineEnding"), e.consume(t), e.exit("lineEnding"), d;
      }
      function d(t) {
        return i > 0 && q6(t) ? W6(e, v, "linePrefix", i + 1)(t) : v(t);
      }
      function v(t) {
        return null === t || Z6(t) ? e.check(c7, p, b)(t) : (e.enter("codeFlowValue"), g(t));
      }
      function g(t) {
        return null === t || Z6(t) ? (e.exit("codeFlowValue"), v(t)) : (e.consume(t), g);
      }
      function b(r) {
        return e.exit("codeFenced"), t(r);
      }
    },
    concrete: !0
  };
const h7 = {
    name: "codeIndented",
    tokenize: function (e, t, r) {
      const n = this;
      return function (t) {
        return e.enter("codeIndented"), W6(e, a, "linePrefix", 5)(t);
      };
      function a(e) {
        const t = n.events[n.events.length - 1];
        return t && "linePrefix" === t[1].type && t[2].sliceSerialize(t[1], !0).length >= 4 ? o(e) : r(e);
      }
      function o(t) {
        return null === t ? l(t) : Z6(t) ? e.attempt(m7, o, l)(t) : (e.enter("codeFlowValue"), i(t));
      }
      function i(t) {
        return null === t || Z6(t) ? (e.exit("codeFlowValue"), o(t)) : (e.consume(t), i);
      }
      function l(r) {
        return e.exit("codeIndented"), t(r);
      }
    }
  },
  m7 = {
    tokenize: function (e, t, r) {
      const n = this;
      return a;
      function a(t) {
        return n.parser.lazy[n.now().line] ? r(t) : Z6(t) ? (e.enter("lineEnding"), e.consume(t), e.exit("lineEnding"), a) : W6(e, o, "linePrefix", 5)(t);
      }
      function o(e) {
        const o = n.events[n.events.length - 1];
        return o && "linePrefix" === o[1].type && o[2].sliceSerialize(o[1], !0).length >= 4 ? t(e) : Z6(e) ? a(e) : r(e);
      }
    },
    partial: !0
  };
const p7 = {
  name: "codeText",
  tokenize: function (e, t, r) {
    let n,
      a,
      o = 0;
    return function (t) {
      return e.enter("codeText"), e.enter("codeTextSequence"), i(t);
    };
    function i(t) {
      return 96 === t ? (e.consume(t), o++, i) : (e.exit("codeTextSequence"), l(t));
    }
    function l(t) {
      return null === t ? r(t) : 32 === t ? (e.enter("space"), e.consume(t), e.exit("space"), l) : 96 === t ? (a = e.enter("codeTextSequence"), n = 0, c(t)) : Z6(t) ? (e.enter("lineEnding"), e.consume(t), e.exit("lineEnding"), l) : (e.enter("codeTextData"), s(t));
    }
    function s(t) {
      return null === t || 32 === t || 96 === t || Z6(t) ? (e.exit("codeTextData"), l(t)) : (e.consume(t), s);
    }
    function c(r) {
      return 96 === r ? (e.consume(r), n++, c) : n === o ? (e.exit("codeTextSequence"), e.exit("codeText"), t(r)) : (a.type = "codeTextData", s(r));
    }
  },
  resolve: function (e) {
    let t,
      r,
      n = e.length - 4,
      a = 3;
    if (!("lineEnding" !== e[a][1].type && "space" !== e[a][1].type || "lineEnding" !== e[n][1].type && "space" !== e[n][1].type)) for (t = a; ++t < n;) if ("codeTextData" === e[t][1].type) {
      e[a][1].type = "codeTextPadding", e[n][1].type = "codeTextPadding", a += 2, n -= 2;
      break;
    }
    t = a - 1, n++;
    for (; ++t <= n;) void 0 === r ? t !== n && "lineEnding" !== e[t][1].type && (r = t) : t !== n && "lineEnding" !== e[t][1].type || (e[r][1].type = "codeTextData", t !== r + 2 && (e[r][1].end = e[t - 1][1].end, e.splice(r + 2, t - r - 2), n -= t - r - 2, t = r + 2), r = void 0);
    return e;
  },
  previous: function (e) {
    return 96 !== e || "characterEscape" === this.events[this.events.length - 1][1].type;
  }
};
function f7(e) {
  const t = {};
  let r,
    n,
    a,
    o,
    i,
    l,
    s,
    c = -1;
  for (; ++c < e.length;) {
    for (; (c in t);) c = t[c];
    if (r = e[c], c && "chunkFlow" === r[1].type && "listItemPrefix" === e[c - 1][1].type && (l = r[1]._tokenizer.events, a = 0, a < l.length && "lineEndingBlank" === l[a][1].type && (a += 2), a < l.length && "content" === l[a][1].type)) for (; ++a < l.length && "content" !== l[a][1].type;) "chunkText" === l[a][1].type && (l[a][1]._isInFirstContentOfListItem = !0, a++);
    if ("enter" === r[0]) r[1].contentType && (Object.assign(t, d7(e, c)), c = t[c], s = !0);else if (r[1]._container) {
      for (a = c, n = void 0; a-- && (o = e[a], "lineEnding" === o[1].type || "lineEndingBlank" === o[1].type);) "enter" === o[0] && (n && (e[n][1].type = "lineEndingBlank"), o[1].type = "lineEnding", n = a);
      n && (r[1].end = Object.assign({}, e[n][1].start), i = e.slice(n, c), i.unshift(r), S6(e, n, c - n + 1, i));
    }
  }
  return !s;
}
function d7(e, t) {
  const r = e[t][1],
    n = e[t][2];
  let a = t - 1;
  const o = [],
    i = r._tokenizer || n.parser[r.contentType](r.start),
    l = i.events,
    s = [],
    c = {};
  let u,
    h,
    m = -1,
    p = r,
    f = 0,
    d = 0;
  const v = [d];
  for (; p;) {
    for (; e[++a][1] !== p;);
    o.push(a), p._tokenizer || (u = n.sliceStream(p), p.next || u.push(null), h && i.defineSkip(p.start), p._isInFirstContentOfListItem && (i._gfmTasklistFirstContentOfListItem = !0), i.write(u), p._isInFirstContentOfListItem && (i._gfmTasklistFirstContentOfListItem = void 0)), h = p, p = p.next;
  }
  for (p = r; ++m < l.length;) "exit" === l[m][0] && "enter" === l[m - 1][0] && l[m][1].type === l[m - 1][1].type && l[m][1].start.line !== l[m][1].end.line && (d = m + 1, v.push(d), p._tokenizer = void 0, p.previous = void 0, p = p.next);
  for (i.events = [], p ? (p._tokenizer = void 0, p.previous = void 0) : v.pop(), m = v.length; m--;) {
    const t = l.slice(v[m], v[m + 1]),
      r = o.pop();
    s.unshift([r, r + t.length - 1]), S6(e, r, 2, t);
  }
  for (m = -1; ++m < s.length;) c[f + s[m][0]] = f + s[m][1], f += s[m][1] - s[m][0] - 1;
  return c;
}
const v7 = {
    tokenize: function (e, t) {
      let r;
      return function (t) {
        return e.enter("content"), r = e.enter("chunkContent", {
          contentType: "content"
        }), n(t);
      };
      function n(t) {
        return null === t ? a(t) : Z6(t) ? e.check(g7, o, a)(t) : (e.consume(t), n);
      }
      function a(r) {
        return e.exit("chunkContent"), e.exit("content"), t(r);
      }
      function o(t) {
        return e.consume(t), e.exit("chunkContent"), r.next = e.enter("chunkContent", {
          contentType: "content",
          previous: r
        }), r = r.next, n;
      }
    },
    resolve: function (e) {
      return f7(e), e;
    }
  },
  g7 = {
    tokenize: function (e, t, r) {
      const n = this;
      return function (t) {
        return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(t), e.exit("lineEnding"), W6(e, a, "linePrefix");
      };
      function a(a) {
        if (null === a || Z6(a)) return r(a);
        const o = n.events[n.events.length - 1];
        return !n.parser.constructs.disable.null.includes("codeIndented") && o && "linePrefix" === o[1].type && o[2].sliceSerialize(o[1], !0).length >= 4 ? t(a) : e.interrupt(n.parser.constructs.flow, r, t)(a);
      }
    },
    partial: !0
  };
function b7(e, t, r, n, a, o, i, l, s) {
  const c = s || Number.POSITIVE_INFINITY;
  let u = 0;
  return function (t) {
    if (60 === t) return e.enter(n), e.enter(a), e.enter(o), e.consume(t), e.exit(o), h;
    if (null === t || 32 === t || 41 === t || L6(t)) return r(t);
    return e.enter(n), e.enter(i), e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), f(t);
  };
  function h(r) {
    return 62 === r ? (e.enter(o), e.consume(r), e.exit(o), e.exit(a), e.exit(n), t) : (e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), m(r));
  }
  function m(t) {
    return 62 === t ? (e.exit("chunkString"), e.exit(l), h(t)) : null === t || 60 === t || Z6(t) ? r(t) : (e.consume(t), 92 === t ? p : m);
  }
  function p(t) {
    return 60 === t || 62 === t || 92 === t ? (e.consume(t), m) : m(t);
  }
  function f(a) {
    return u || null !== a && 41 !== a && !D6(a) ? u < c && 40 === a ? (e.consume(a), u++, f) : 41 === a ? (e.consume(a), u--, f) : null === a || 32 === a || 40 === a || L6(a) ? r(a) : (e.consume(a), 92 === a ? d : f) : (e.exit("chunkString"), e.exit(l), e.exit(i), e.exit(n), t(a));
  }
  function d(t) {
    return 40 === t || 41 === t || 92 === t ? (e.consume(t), f) : f(t);
  }
}
function w7(e, t, r, n, a, o) {
  const i = this;
  let l,
    s = 0;
  return function (t) {
    return e.enter(n), e.enter(a), e.consume(t), e.exit(a), e.enter(o), c;
  };
  function c(h) {
    return s > 999 || null === h || 91 === h || 93 === h && !l || 94 === h && !s && "_hiddenFootnoteSupport" in i.parser.constructs ? r(h) : 93 === h ? (e.exit(o), e.enter(a), e.consume(h), e.exit(a), e.exit(n), t) : Z6(h) ? (e.enter("lineEnding"), e.consume(h), e.exit("lineEnding"), c) : (e.enter("chunkString", {
      contentType: "string"
    }), u(h));
  }
  function u(t) {
    return null === t || 91 === t || 93 === t || Z6(t) || s++ > 999 ? (e.exit("chunkString"), c(t)) : (e.consume(t), l || (l = !q6(t)), 92 === t ? h : u);
  }
  function h(t) {
    return 91 === t || 92 === t || 93 === t ? (e.consume(t), s++, u) : u(t);
  }
}
function y7(e, t, r, n, a, o) {
  let i;
  return function (t) {
    if (34 === t || 39 === t || 40 === t) return e.enter(n), e.enter(a), e.consume(t), e.exit(a), i = 40 === t ? 41 : t, l;
    return r(t);
  };
  function l(r) {
    return r === i ? (e.enter(a), e.consume(r), e.exit(a), e.exit(n), t) : (e.enter(o), s(r));
  }
  function s(t) {
    return t === i ? (e.exit(o), l(i)) : null === t ? r(t) : Z6(t) ? (e.enter("lineEnding"), e.consume(t), e.exit("lineEnding"), W6(e, s, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), c(t));
  }
  function c(t) {
    return t === i || null === t || Z6(t) ? (e.exit("chunkString"), s(t)) : (e.consume(t), 92 === t ? u : c);
  }
  function u(t) {
    return t === i || 92 === t ? (e.consume(t), c) : c(t);
  }
}
function x7(e, t) {
  let r;
  return function n(a) {
    if (Z6(a)) return e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), r = !0, n;
    if (q6(a)) return W6(e, n, r ? "linePrefix" : "lineSuffix")(a);
    return t(a);
  };
}
function O7(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const E7 = {
    name: "definition",
    tokenize: function (e, t, r) {
      const n = this;
      let a;
      return function (t) {
        return e.enter("definition"), function (t) {
          return w7.call(n, e, o, r, "definitionLabel", "definitionLabelMarker", "definitionLabelString")(t);
        }(t);
      };
      function o(t) {
        return a = O7(n.sliceSerialize(n.events[n.events.length - 1][1]).slice(1, -1)), 58 === t ? (e.enter("definitionMarker"), e.consume(t), e.exit("definitionMarker"), i) : r(t);
      }
      function i(t) {
        return D6(t) ? x7(e, l)(t) : l(t);
      }
      function l(t) {
        return b7(e, s, r, "definitionDestination", "definitionDestinationLiteral", "definitionDestinationLiteralMarker", "definitionDestinationRaw", "definitionDestinationString")(t);
      }
      function s(t) {
        return e.attempt(j7, c, c)(t);
      }
      function c(t) {
        return q6(t) ? W6(e, u, "whitespace")(t) : u(t);
      }
      function u(o) {
        return null === o || Z6(o) ? (e.exit("definition"), n.parser.defined.push(a), t(o)) : r(o);
      }
    }
  },
  j7 = {
    tokenize: function (e, t, r) {
      return function (t) {
        return D6(t) ? x7(e, n)(t) : r(t);
      };
      function n(t) {
        return y7(e, a, r, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(t);
      }
      function a(t) {
        return q6(t) ? W6(e, o, "whitespace")(t) : o(t);
      }
      function o(e) {
        return null === e || Z6(e) ? t(e) : r(e);
      }
    },
    partial: !0
  };
const C7 = {
  name: "hardBreakEscape",
  tokenize: function (e, t, r) {
    return function (t) {
      return e.enter("hardBreakEscape"), e.consume(t), n;
    };
    function n(n) {
      return Z6(n) ? (e.exit("hardBreakEscape"), t(n)) : r(n);
    }
  }
};
const P7 = {
  name: "headingAtx",
  tokenize: function (e, t, r) {
    let n = 0;
    return function (t) {
      return e.enter("atxHeading"), function (t) {
        return e.enter("atxHeadingSequence"), a(t);
      }(t);
    };
    function a(t) {
      return 35 === t && n++ < 6 ? (e.consume(t), a) : null === t || D6(t) ? (e.exit("atxHeadingSequence"), o(t)) : r(t);
    }
    function o(r) {
      return 35 === r ? (e.enter("atxHeadingSequence"), i(r)) : null === r || Z6(r) ? (e.exit("atxHeading"), t(r)) : q6(r) ? W6(e, o, "whitespace")(r) : (e.enter("atxHeadingText"), l(r));
    }
    function i(t) {
      return 35 === t ? (e.consume(t), i) : (e.exit("atxHeadingSequence"), o(t));
    }
    function l(t) {
      return null === t || 35 === t || D6(t) ? (e.exit("atxHeadingText"), o(t)) : (e.consume(t), l);
    }
  },
  resolve: function (e, t) {
    let r,
      n,
      a = e.length - 2,
      o = 3;
    "whitespace" === e[o][1].type && (o += 2);
    a - 2 > o && "whitespace" === e[a][1].type && (a -= 2);
    "atxHeadingSequence" === e[a][1].type && (o === a - 1 || a - 4 > o && "whitespace" === e[a - 2][1].type) && (a -= o + 1 === a ? 2 : 4);
    a > o && (r = {
      type: "atxHeadingText",
      start: e[o][1].start,
      end: e[a][1].end
    }, n = {
      type: "chunkText",
      start: e[o][1].start,
      end: e[a][1].end,
      contentType: "text"
    }, S6(e, o, a - o + 1, [["enter", r, t], ["enter", n, t], ["exit", n, t], ["exit", r, t]]));
    return e;
  }
};
const M7 = ["address", "article", "aside", "base", "basefont", "blockquote", "body", "caption", "center", "col", "colgroup", "dd", "details", "dialog", "dir", "div", "dl", "dt", "fieldset", "figcaption", "figure", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hr", "html", "iframe", "legend", "li", "link", "main", "menu", "menuitem", "nav", "noframes", "ol", "optgroup", "option", "p", "param", "search", "section", "summary", "table", "tbody", "td", "tfoot", "th", "thead", "title", "tr", "track", "ul"],
  k7 = ["pre", "script", "style", "textarea"],
  S7 = {
    name: "htmlFlow",
    tokenize: function (e, t, r) {
      const n = this;
      let a, o, i, l, s;
      return function (t) {
        return function (t) {
          return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(t), c;
        }(t);
      };
      function c(l) {
        return 33 === l ? (e.consume(l), u) : 47 === l ? (e.consume(l), o = !0, p) : 63 === l ? (e.consume(l), a = 3, n.interrupt ? t : A) : A6(l) ? (e.consume(l), i = String.fromCharCode(l), f) : r(l);
      }
      function u(o) {
        return 45 === o ? (e.consume(o), a = 2, h) : 91 === o ? (e.consume(o), a = 5, l = 0, m) : A6(o) ? (e.consume(o), a = 4, n.interrupt ? t : A) : r(o);
      }
      function h(a) {
        return 45 === a ? (e.consume(a), n.interrupt ? t : A) : r(a);
      }
      function m(a) {
        const o = "CDATA[";
        return a === o.charCodeAt(l++) ? (e.consume(a), l === o.length ? n.interrupt ? t : P : m) : r(a);
      }
      function p(t) {
        return A6(t) ? (e.consume(t), i = String.fromCharCode(t), f) : r(t);
      }
      function f(l) {
        if (null === l || 47 === l || 62 === l || D6(l)) {
          const s = 47 === l,
            c = i.toLowerCase();
          return s || o || !k7.includes(c) ? M7.includes(i.toLowerCase()) ? (a = 6, s ? (e.consume(l), d) : n.interrupt ? t(l) : P(l)) : (a = 7, n.interrupt && !n.parser.lazy[n.now().line] ? r(l) : o ? v(l) : g(l)) : (a = 1, n.interrupt ? t(l) : P(l));
        }
        return 45 === l || T6(l) ? (e.consume(l), i += String.fromCharCode(l), f) : r(l);
      }
      function d(a) {
        return 62 === a ? (e.consume(a), n.interrupt ? t : P) : r(a);
      }
      function v(t) {
        return q6(t) ? (e.consume(t), v) : j(t);
      }
      function g(t) {
        return 47 === t ? (e.consume(t), j) : 58 === t || 95 === t || A6(t) ? (e.consume(t), b) : q6(t) ? (e.consume(t), g) : j(t);
      }
      function b(t) {
        return 45 === t || 46 === t || 58 === t || 95 === t || T6(t) ? (e.consume(t), b) : w(t);
      }
      function w(t) {
        return 61 === t ? (e.consume(t), y) : q6(t) ? (e.consume(t), w) : g(t);
      }
      function y(t) {
        return null === t || 60 === t || 61 === t || 62 === t || 96 === t ? r(t) : 34 === t || 39 === t ? (e.consume(t), s = t, x) : q6(t) ? (e.consume(t), y) : O(t);
      }
      function x(t) {
        return t === s ? (e.consume(t), s = null, E) : null === t || Z6(t) ? r(t) : (e.consume(t), x);
      }
      function O(t) {
        return null === t || 34 === t || 39 === t || 47 === t || 60 === t || 61 === t || 62 === t || 96 === t || D6(t) ? w(t) : (e.consume(t), O);
      }
      function E(e) {
        return 47 === e || 62 === e || q6(e) ? g(e) : r(e);
      }
      function j(t) {
        return 62 === t ? (e.consume(t), C) : r(t);
      }
      function C(t) {
        return null === t || Z6(t) ? P(t) : q6(t) ? (e.consume(t), C) : r(t);
      }
      function P(t) {
        return 45 === t && 2 === a ? (e.consume(t), N) : 60 === t && 1 === a ? (e.consume(t), B) : 62 === t && 4 === a ? (e.consume(t), T) : 63 === t && 3 === a ? (e.consume(t), A) : 93 === t && 5 === a ? (e.consume(t), R) : !Z6(t) || 6 !== a && 7 !== a ? null === t || Z6(t) ? (e.exit("htmlFlowData"), M(t)) : (e.consume(t), P) : (e.exit("htmlFlowData"), e.check(N7, H, M)(t));
      }
      function M(t) {
        return e.check(B7, k, H)(t);
      }
      function k(t) {
        return e.enter("lineEnding"), e.consume(t), e.exit("lineEnding"), S;
      }
      function S(t) {
        return null === t || Z6(t) ? M(t) : (e.enter("htmlFlowData"), P(t));
      }
      function N(t) {
        return 45 === t ? (e.consume(t), A) : P(t);
      }
      function B(t) {
        return 47 === t ? (e.consume(t), i = "", V) : P(t);
      }
      function V(t) {
        if (62 === t) {
          const r = i.toLowerCase();
          return k7.includes(r) ? (e.consume(t), T) : P(t);
        }
        return A6(t) && i.length < 8 ? (e.consume(t), i += String.fromCharCode(t), V) : P(t);
      }
      function R(t) {
        return 93 === t ? (e.consume(t), A) : P(t);
      }
      function A(t) {
        return 62 === t ? (e.consume(t), T) : 45 === t && 2 === a ? (e.consume(t), A) : P(t);
      }
      function T(t) {
        return null === t || Z6(t) ? (e.exit("htmlFlowData"), H(t)) : (e.consume(t), T);
      }
      function H(r) {
        return e.exit("htmlFlow"), t(r);
      }
    },
    resolveTo: function (e) {
      let t = e.length;
      for (; t-- && ("enter" !== e[t][0] || "htmlFlow" !== e[t][1].type););
      t > 1 && "linePrefix" === e[t - 2][1].type && (e[t][1].start = e[t - 2][1].start, e[t + 1][1].start = e[t - 2][1].start, e.splice(t - 2, 2));
      return e;
    },
    concrete: !0
  },
  N7 = {
    tokenize: function (e, t, r) {
      return function (n) {
        return e.enter("lineEnding"), e.consume(n), e.exit("lineEnding"), e.attempt(r7, t, r);
      };
    },
    partial: !0
  },
  B7 = {
    tokenize: function (e, t, r) {
      const n = this;
      return function (t) {
        if (Z6(t)) return e.enter("lineEnding"), e.consume(t), e.exit("lineEnding"), a;
        return r(t);
      };
      function a(e) {
        return n.parser.lazy[n.now().line] ? r(e) : t(e);
      }
    },
    partial: !0
  };
const V7 = {
  name: "htmlText",
  tokenize: function (e, t, r) {
    const n = this;
    let a, o, i;
    return function (t) {
      return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(t), l;
    };
    function l(t) {
      return 33 === t ? (e.consume(t), s) : 47 === t ? (e.consume(t), y) : 63 === t ? (e.consume(t), b) : A6(t) ? (e.consume(t), E) : r(t);
    }
    function s(t) {
      return 45 === t ? (e.consume(t), c) : 91 === t ? (e.consume(t), o = 0, p) : A6(t) ? (e.consume(t), g) : r(t);
    }
    function c(t) {
      return 45 === t ? (e.consume(t), m) : r(t);
    }
    function u(t) {
      return null === t ? r(t) : 45 === t ? (e.consume(t), h) : Z6(t) ? (i = u, V(t)) : (e.consume(t), u);
    }
    function h(t) {
      return 45 === t ? (e.consume(t), m) : u(t);
    }
    function m(e) {
      return 62 === e ? B(e) : 45 === e ? h(e) : u(e);
    }
    function p(t) {
      const n = "CDATA[";
      return t === n.charCodeAt(o++) ? (e.consume(t), o === n.length ? f : p) : r(t);
    }
    function f(t) {
      return null === t ? r(t) : 93 === t ? (e.consume(t), d) : Z6(t) ? (i = f, V(t)) : (e.consume(t), f);
    }
    function d(t) {
      return 93 === t ? (e.consume(t), v) : f(t);
    }
    function v(t) {
      return 62 === t ? B(t) : 93 === t ? (e.consume(t), v) : f(t);
    }
    function g(t) {
      return null === t || 62 === t ? B(t) : Z6(t) ? (i = g, V(t)) : (e.consume(t), g);
    }
    function b(t) {
      return null === t ? r(t) : 63 === t ? (e.consume(t), w) : Z6(t) ? (i = b, V(t)) : (e.consume(t), b);
    }
    function w(e) {
      return 62 === e ? B(e) : b(e);
    }
    function y(t) {
      return A6(t) ? (e.consume(t), x) : r(t);
    }
    function x(t) {
      return 45 === t || T6(t) ? (e.consume(t), x) : O(t);
    }
    function O(t) {
      return Z6(t) ? (i = O, V(t)) : q6(t) ? (e.consume(t), O) : B(t);
    }
    function E(t) {
      return 45 === t || T6(t) ? (e.consume(t), E) : 47 === t || 62 === t || D6(t) ? j(t) : r(t);
    }
    function j(t) {
      return 47 === t ? (e.consume(t), B) : 58 === t || 95 === t || A6(t) ? (e.consume(t), C) : Z6(t) ? (i = j, V(t)) : q6(t) ? (e.consume(t), j) : B(t);
    }
    function C(t) {
      return 45 === t || 46 === t || 58 === t || 95 === t || T6(t) ? (e.consume(t), C) : P(t);
    }
    function P(t) {
      return 61 === t ? (e.consume(t), M) : Z6(t) ? (i = P, V(t)) : q6(t) ? (e.consume(t), P) : j(t);
    }
    function M(t) {
      return null === t || 60 === t || 61 === t || 62 === t || 96 === t ? r(t) : 34 === t || 39 === t ? (e.consume(t), a = t, k) : Z6(t) ? (i = M, V(t)) : q6(t) ? (e.consume(t), M) : (e.consume(t), S);
    }
    function k(t) {
      return t === a ? (e.consume(t), a = void 0, N) : null === t ? r(t) : Z6(t) ? (i = k, V(t)) : (e.consume(t), k);
    }
    function S(t) {
      return null === t || 34 === t || 39 === t || 60 === t || 61 === t || 96 === t ? r(t) : 47 === t || 62 === t || D6(t) ? j(t) : (e.consume(t), S);
    }
    function N(e) {
      return 47 === e || 62 === e || D6(e) ? j(e) : r(e);
    }
    function B(n) {
      return 62 === n ? (e.consume(n), e.exit("htmlTextData"), e.exit("htmlText"), t) : r(n);
    }
    function V(t) {
      return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(t), e.exit("lineEnding"), R;
    }
    function R(t) {
      return q6(t) ? W6(e, A, "linePrefix", n.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(t) : A(t);
    }
    function A(t) {
      return e.enter("htmlTextData"), i(t);
    }
  }
};
const R7 = {
    name: "labelEnd",
    tokenize: function (e, t, r) {
      const n = this;
      let a,
        o,
        i = n.events.length;
      for (; i--;) if (("labelImage" === n.events[i][1].type || "labelLink" === n.events[i][1].type) && !n.events[i][1]._balanced) {
        a = n.events[i][1];
        break;
      }
      return function (t) {
        if (!a) return r(t);
        if (a._inactive) return u(t);
        return o = n.parser.defined.includes(O7(n.sliceSerialize({
          start: a.end,
          end: n.now()
        }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(t), e.exit("labelMarker"), e.exit("labelEnd"), l;
      };
      function l(t) {
        return 40 === t ? e.attempt(A7, c, o ? c : u)(t) : 91 === t ? e.attempt(T7, c, o ? s : u)(t) : o ? c(t) : u(t);
      }
      function s(t) {
        return e.attempt(H7, c, u)(t);
      }
      function c(e) {
        return t(e);
      }
      function u(e) {
        return a._balanced = !0, r(e);
      }
    },
    resolveTo: function (e, t) {
      let r,
        n,
        a,
        o,
        i = e.length,
        l = 0;
      for (; i--;) if (r = e[i][1], n) {
        if ("link" === r.type || "labelLink" === r.type && r._inactive) break;
        "enter" === e[i][0] && "labelLink" === r.type && (r._inactive = !0);
      } else if (a) {
        if ("enter" === e[i][0] && ("labelImage" === r.type || "labelLink" === r.type) && !r._balanced && (n = i, "labelLink" !== r.type)) {
          l = 2;
          break;
        }
      } else "labelEnd" === r.type && (a = i);
      const s = {
          type: "labelLink" === e[n][1].type ? "link" : "image",
          start: Object.assign({}, e[n][1].start),
          end: Object.assign({}, e[e.length - 1][1].end)
        },
        c = {
          type: "label",
          start: Object.assign({}, e[n][1].start),
          end: Object.assign({}, e[a][1].end)
        },
        u = {
          type: "labelText",
          start: Object.assign({}, e[n + l + 2][1].end),
          end: Object.assign({}, e[a - 2][1].start)
        };
      return o = [["enter", s, t], ["enter", c, t]], o = N6(o, e.slice(n + 1, n + l + 3)), o = N6(o, [["enter", u, t]]), o = N6(o, X6(t.parser.constructs.insideSpan.null, e.slice(n + l + 4, a - 3), t)), o = N6(o, [["exit", u, t], e[a - 2], e[a - 1], ["exit", c, t]]), o = N6(o, e.slice(a + 1)), o = N6(o, [["exit", s, t]]), S6(e, n, e.length, o), e;
    },
    resolveAll: function (e) {
      let t = -1;
      for (; ++t < e.length;) {
        const r = e[t][1];
        "labelImage" !== r.type && "labelLink" !== r.type && "labelEnd" !== r.type || (e.splice(t + 1, "labelImage" === r.type ? 4 : 2), r.type = "data", t++);
      }
      return e;
    }
  },
  A7 = {
    tokenize: function (e, t, r) {
      return function (t) {
        return e.enter("resource"), e.enter("resourceMarker"), e.consume(t), e.exit("resourceMarker"), n;
      };
      function n(t) {
        return D6(t) ? x7(e, a)(t) : a(t);
      }
      function a(t) {
        return 41 === t ? c(t) : b7(e, o, i, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(t);
      }
      function o(t) {
        return D6(t) ? x7(e, l)(t) : c(t);
      }
      function i(e) {
        return r(e);
      }
      function l(t) {
        return 34 === t || 39 === t || 40 === t ? y7(e, s, r, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(t) : c(t);
      }
      function s(t) {
        return D6(t) ? x7(e, c)(t) : c(t);
      }
      function c(n) {
        return 41 === n ? (e.enter("resourceMarker"), e.consume(n), e.exit("resourceMarker"), e.exit("resource"), t) : r(n);
      }
    }
  },
  T7 = {
    tokenize: function (e, t, r) {
      const n = this;
      return function (t) {
        return w7.call(n, e, a, o, "reference", "referenceMarker", "referenceString")(t);
      };
      function a(e) {
        return n.parser.defined.includes(O7(n.sliceSerialize(n.events[n.events.length - 1][1]).slice(1, -1))) ? t(e) : r(e);
      }
      function o(e) {
        return r(e);
      }
    }
  },
  H7 = {
    tokenize: function (e, t, r) {
      return function (t) {
        return e.enter("reference"), e.enter("referenceMarker"), e.consume(t), e.exit("referenceMarker"), n;
      };
      function n(n) {
        return 93 === n ? (e.enter("referenceMarker"), e.consume(n), e.exit("referenceMarker"), e.exit("reference"), t) : r(n);
      }
    }
  };
const L7 = {
  name: "labelStartImage",
  tokenize: function (e, t, r) {
    const n = this;
    return function (t) {
      return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(t), e.exit("labelImageMarker"), a;
    };
    function a(t) {
      return 91 === t ? (e.enter("labelMarker"), e.consume(t), e.exit("labelMarker"), e.exit("labelImage"), o) : r(t);
    }
    function o(e) {
      return 94 === e && "_hiddenFootnoteSupport" in n.parser.constructs ? r(e) : t(e);
    }
  },
  resolveAll: R7.resolveAll
};
const I7 = {
  name: "labelStartLink",
  tokenize: function (e, t, r) {
    const n = this;
    return function (t) {
      return e.enter("labelLink"), e.enter("labelMarker"), e.consume(t), e.exit("labelMarker"), e.exit("labelLink"), a;
    };
    function a(e) {
      return 94 === e && "_hiddenFootnoteSupport" in n.parser.constructs ? r(e) : t(e);
    }
  },
  resolveAll: R7.resolveAll
};
const F7 = {
  name: "lineEnding",
  tokenize: function (e, t) {
    return function (r) {
      return e.enter("lineEnding"), e.consume(r), e.exit("lineEnding"), W6(e, t, "linePrefix");
    };
  }
};
const _7 = {
  name: "thematicBreak",
  tokenize: function (e, t, r) {
    let n,
      a = 0;
    return function (t) {
      return e.enter("thematicBreak"), function (e) {
        return n = e, o(e);
      }(t);
    };
    function o(o) {
      return o === n ? (e.enter("thematicBreakSequence"), i(o)) : a >= 3 && (null === o || Z6(o)) ? (e.exit("thematicBreak"), t(o)) : r(o);
    }
    function i(t) {
      return t === n ? (e.consume(t), a++, i) : (e.exit("thematicBreakSequence"), q6(t) ? W6(e, o, "whitespace")(t) : o(t));
    }
  }
};
const Z7 = {
    name: "list",
    tokenize: function (e, t, r) {
      const n = this,
        a = n.events[n.events.length - 1];
      let o = a && "linePrefix" === a[1].type ? a[2].sliceSerialize(a[1], !0).length : 0,
        i = 0;
      return function (t) {
        const a = n.containerState.type || (42 === t || 43 === t || 45 === t ? "listUnordered" : "listOrdered");
        if ("listUnordered" === a ? !n.containerState.marker || t === n.containerState.marker : I6(t)) {
          if (n.containerState.type || (n.containerState.type = a, e.enter(a, {
            _container: !0
          })), "listUnordered" === a) return e.enter("listItemPrefix"), 42 === t || 45 === t ? e.check(_7, r, s)(t) : s(t);
          if (!n.interrupt || 49 === t) return e.enter("listItemPrefix"), e.enter("listItemValue"), l(t);
        }
        return r(t);
      };
      function l(t) {
        return I6(t) && ++i < 10 ? (e.consume(t), l) : (!n.interrupt || i < 2) && (n.containerState.marker ? t === n.containerState.marker : 41 === t || 46 === t) ? (e.exit("listItemValue"), s(t)) : r(t);
      }
      function s(t) {
        return e.enter("listItemMarker"), e.consume(t), e.exit("listItemMarker"), n.containerState.marker = n.containerState.marker || t, e.check(r7, n.interrupt ? r : c, e.attempt(D7, h, u));
      }
      function c(e) {
        return n.containerState.initialBlankLine = !0, o++, h(e);
      }
      function u(t) {
        return q6(t) ? (e.enter("listItemPrefixWhitespace"), e.consume(t), e.exit("listItemPrefixWhitespace"), h) : r(t);
      }
      function h(r) {
        return n.containerState.size = o + n.sliceSerialize(e.exit("listItemPrefix"), !0).length, t(r);
      }
    },
    continuation: {
      tokenize: function (e, t, r) {
        const n = this;
        return n.containerState._closeFlow = void 0, e.check(r7, a, o);
        function a(r) {
          return n.containerState.furtherBlankLines = n.containerState.furtherBlankLines || n.containerState.initialBlankLine, W6(e, t, "listItemIndent", n.containerState.size + 1)(r);
        }
        function o(r) {
          return n.containerState.furtherBlankLines || !q6(r) ? (n.containerState.furtherBlankLines = void 0, n.containerState.initialBlankLine = void 0, i(r)) : (n.containerState.furtherBlankLines = void 0, n.containerState.initialBlankLine = void 0, e.attempt(q7, t, i)(r));
        }
        function i(a) {
          return n.containerState._closeFlow = !0, n.interrupt = void 0, W6(e, e.attempt(Z7, t, r), "linePrefix", n.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(a);
        }
      }
    },
    exit: function (e) {
      e.exit(this.containerState.type);
    }
  },
  D7 = {
    tokenize: function (e, t, r) {
      const n = this;
      return W6(e, function (e) {
        const a = n.events[n.events.length - 1];
        return !q6(e) && a && "listItemPrefixWhitespace" === a[1].type ? t(e) : r(e);
      }, "listItemPrefixWhitespace", n.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
    },
    partial: !0
  },
  q7 = {
    tokenize: function (e, t, r) {
      const n = this;
      return W6(e, function (e) {
        const a = n.events[n.events.length - 1];
        return a && "listItemIndent" === a[1].type && a[2].sliceSerialize(a[1], !0).length === n.containerState.size ? t(e) : r(e);
      }, "listItemIndent", n.containerState.size + 1);
    },
    partial: !0
  };
const U7 = {
  name: "setextUnderline",
  tokenize: function (e, t, r) {
    const n = this;
    let a;
    return function (t) {
      let i,
        l = n.events.length;
      for (; l--;) if ("lineEnding" !== n.events[l][1].type && "linePrefix" !== n.events[l][1].type && "content" !== n.events[l][1].type) {
        i = "paragraph" === n.events[l][1].type;
        break;
      }
      if (!n.parser.lazy[n.now().line] && (n.interrupt || i)) return e.enter("setextHeadingLine"), a = t, function (t) {
        return e.enter("setextHeadingLineSequence"), o(t);
      }(t);
      return r(t);
    };
    function o(t) {
      return t === a ? (e.consume(t), o) : (e.exit("setextHeadingLineSequence"), q6(t) ? W6(e, i, "lineSuffix")(t) : i(t));
    }
    function i(n) {
      return null === n || Z6(n) ? (e.exit("setextHeadingLine"), t(n)) : r(n);
    }
  },
  resolveTo: function (e, t) {
    let r,
      n,
      a,
      o = e.length;
    for (; o--;) if ("enter" === e[o][0]) {
      if ("content" === e[o][1].type) {
        r = o;
        break;
      }
      "paragraph" === e[o][1].type && (n = o);
    } else "content" === e[o][1].type && e.splice(o, 1), a || "definition" !== e[o][1].type || (a = o);
    const i = {
      type: "setextHeading",
      start: Object.assign({}, e[n][1].start),
      end: Object.assign({}, e[e.length - 1][1].end)
    };
    e[n][1].type = "setextHeadingText", a ? (e.splice(n, 0, ["enter", i, t]), e.splice(a + 1, 0, ["exit", e[r][1], t]), e[r][1].end = Object.assign({}, e[a][1].end)) : e[r][1] = i;
    return e.push(["exit", i, t]), e;
  }
};
const $7 = {
  tokenize: function (e) {
    const t = this,
      r = e.attempt(r7, function (n) {
        if (null === n) return void e.consume(n);
        return e.enter("lineEndingBlank"), e.consume(n), e.exit("lineEndingBlank"), t.currentConstruct = void 0, r;
      }, e.attempt(this.parser.constructs.flowInitial, n, W6(e, e.attempt(this.parser.constructs.flow, n, e.attempt(v7, n)), "linePrefix")));
    return r;
    function n(n) {
      if (null !== n) return e.enter("lineEnding"), e.consume(n), e.exit("lineEnding"), t.currentConstruct = void 0, r;
      e.consume(n);
    }
  }
};
const z7 = {
    resolveAll: Y7()
  },
  W7 = G7("string"),
  Q7 = G7("text");
function G7(e) {
  return {
    tokenize: function (t) {
      const r = this,
        n = this.parser.constructs[e],
        a = t.attempt(n, o, i);
      return o;
      function o(e) {
        return s(e) ? a(e) : i(e);
      }
      function i(e) {
        if (null !== e) return t.enter("data"), t.consume(e), l;
        t.consume(e);
      }
      function l(e) {
        return s(e) ? (t.exit("data"), a(e)) : (t.consume(e), l);
      }
      function s(e) {
        if (null === e) return !0;
        const t = n[e];
        let a = -1;
        if (t) for (; ++a < t.length;) {
          const e = t[a];
          if (!e.previous || e.previous.call(r, r.previous)) return !0;
        }
        return !1;
      }
    },
    resolveAll: Y7("text" === e ? K7 : void 0)
  };
}
function Y7(e) {
  return function (t, r) {
    let n,
      a = -1;
    for (; ++a <= t.length;) void 0 === n ? t[a] && "data" === t[a][1].type && (n = a, a++) : t[a] && "data" === t[a][1].type || (a !== n + 2 && (t[n][1].end = t[a - 1][1].end, t.splice(n + 2, a - n - 2), a = n + 2), n = void 0);
    return e ? e(t, r) : t;
  };
}
function K7(e, t) {
  let r = 0;
  for (; ++r <= e.length;) if ((r === e.length || "lineEnding" === e[r][1].type) && "data" === e[r - 1][1].type) {
    const n = e[r - 1][1],
      a = t.sliceStream(n);
    let o,
      i = a.length,
      l = -1,
      s = 0;
    for (; i--;) {
      const e = a[i];
      if ("string" == typeof e) {
        for (l = e.length; 32 === e.charCodeAt(l - 1);) s++, l--;
        if (l) break;
        l = -1;
      } else if (-2 === e) o = !0, s++;else if (-1 !== e) {
        i++;
        break;
      }
    }
    if (s) {
      const a = {
        type: r === e.length || o || s < 2 ? "lineSuffix" : "hardBreakTrailing",
        start: {
          line: n.end.line,
          column: n.end.column - s,
          offset: n.end.offset - s,
          _index: n.start._index + i,
          _bufferIndex: i ? l : n.start._bufferIndex + l
        },
        end: Object.assign({}, n.end)
      };
      n.end = Object.assign({}, a.start), n.start.offset === n.end.offset ? Object.assign(n, a) : (e.splice(r, 0, ["enter", a, t], ["exit", a, t]), r += 2);
    }
    r++;
  }
  return e;
}
function X7(e, t, r) {
  let n = Object.assign(r ? Object.assign({}, r) : {
    line: 1,
    column: 1,
    offset: 0
  }, {
    _index: 0,
    _bufferIndex: -1
  });
  const a = {},
    o = [];
  let i = [],
    l = [];
  const s = {
      consume: function (e) {
        Z6(e) ? (n.line++, n.column = 1, n.offset += -3 === e ? 2 : 1, b()) : -1 !== e && (n.column++, n.offset++);
        n._bufferIndex < 0 ? n._index++ : (n._bufferIndex++, n._bufferIndex === i[n._index].length && (n._bufferIndex = -1, n._index++));
        c.previous = e;
      },
      enter: function (e, t) {
        const r = t || {};
        return r.type = e, r.start = m(), c.events.push(["enter", r, c]), l.push(r), r;
      },
      exit: function (e) {
        const t = l.pop();
        return t.end = m(), c.events.push(["exit", t, c]), t;
      },
      attempt: v(function (e, t) {
        g(e, t.from);
      }),
      check: v(d),
      interrupt: v(d, {
        interrupt: !0
      })
    },
    c = {
      previous: null,
      code: null,
      containerState: {},
      events: [],
      parser: e,
      sliceStream: h,
      sliceSerialize: function (e, t) {
        return function (e, t) {
          let r = -1;
          const n = [];
          let a;
          for (; ++r < e.length;) {
            const o = e[r];
            let i;
            if ("string" == typeof o) i = o;else switch (o) {
              case -5:
                i = "\r";
                break;
              case -4:
                i = "\n";
                break;
              case -3:
                i = "\r\n";
                break;
              case -2:
                i = t ? " " : "\t";
                break;
              case -1:
                if (!t && a) continue;
                i = " ";
                break;
              default:
                i = String.fromCharCode(o);
            }
            a = -2 === o, n.push(i);
          }
          return n.join("");
        }(h(e), t);
      },
      now: m,
      defineSkip: function (e) {
        a[e.line] = e.column, b();
      },
      write: function (e) {
        if (i = N6(i, e), p(), null !== i[i.length - 1]) return [];
        return g(t, 0), c.events = X6(o, c.events, c), c.events;
      }
    };
  let u = t.tokenize.call(c, s);
  return t.resolveAll && o.push(t), c;
  function h(e) {
    return function (e, t) {
      const r = t.start._index,
        n = t.start._bufferIndex,
        a = t.end._index,
        o = t.end._bufferIndex;
      let i;
      if (r === a) i = [e[r].slice(n, o)];else {
        if (i = e.slice(r, a), n > -1) {
          const e = i[0];
          "string" == typeof e ? i[0] = e.slice(n) : i.shift();
        }
        o > 0 && i.push(e[a].slice(0, o));
      }
      return i;
    }(i, e);
  }
  function m() {
    const {
      line: e,
      column: t,
      offset: r,
      _index: a,
      _bufferIndex: o
    } = n;
    return {
      line: e,
      column: t,
      offset: r,
      _index: a,
      _bufferIndex: o
    };
  }
  function p() {
    let e;
    for (; n._index < i.length;) {
      const t = i[n._index];
      if ("string" == typeof t) for (e = n._index, n._bufferIndex < 0 && (n._bufferIndex = 0); n._index === e && n._bufferIndex < t.length;) f(t.charCodeAt(n._bufferIndex));else f(t);
    }
  }
  function f(e) {
    u = u(e);
  }
  function d(e, t) {
    t.restore();
  }
  function v(e, t) {
    return function (r, a, o) {
      let i, u, h, p;
      return Array.isArray(r) ? f(r) : "tokenize" in r ? f([r]) : function (e) {
        return t;
        function t(t) {
          const r = null !== t && e[t],
            n = null !== t && e.null;
          return f([...(Array.isArray(r) ? r : r ? [r] : []), ...(Array.isArray(n) ? n : n ? [n] : [])])(t);
        }
      }(r);
      function f(e) {
        return i = e, u = 0, 0 === e.length ? o : d(e[u]);
      }
      function d(e) {
        return function (r) {
          p = function () {
            const e = m(),
              t = c.previous,
              r = c.currentConstruct,
              a = c.events.length,
              o = Array.from(l);
            return {
              restore: i,
              from: a
            };
            function i() {
              n = e, c.previous = t, c.currentConstruct = r, c.events.length = a, l = o, b();
            }
          }(), h = e, e.partial || (c.currentConstruct = e);
          if (e.name && c.parser.constructs.disable.null.includes(e.name)) return g();
          return e.tokenize.call(t ? Object.assign(Object.create(c), t) : c, s, v, g)(r);
        };
      }
      function v(t) {
        return e(h, p), a;
      }
      function g(e) {
        return p.restore(), ++u < i.length ? d(i[u]) : o;
      }
    };
  }
  function g(e, t) {
    e.resolveAll && !o.includes(e) && o.push(e), e.resolve && S6(c.events, t, c.events.length - t, e.resolve(c.events.slice(t), c)), e.resolveTo && (c.events = e.resolveTo(c.events, c));
  }
  function b() {
    n.line in a && n.column < 2 && (n.column = a[n.line], n.offset += a[n.line] - 1);
  }
}
const J7 = {
    42: Z7,
    43: Z7,
    45: Z7,
    48: Z7,
    49: Z7,
    50: Z7,
    51: Z7,
    52: Z7,
    53: Z7,
    54: Z7,
    55: Z7,
    56: Z7,
    57: Z7,
    62: n7
  },
  e9 = {
    91: E7
  },
  t9 = {
    [-2]: h7,
    [-1]: h7,
    32: h7
  },
  r9 = {
    35: P7,
    42: _7,
    45: [U7, _7],
    60: S7,
    61: U7,
    95: _7,
    96: u7,
    126: u7
  },
  n9 = {
    38: s7,
    92: a7
  },
  a9 = {
    [-5]: F7,
    [-4]: F7,
    [-3]: F7,
    33: L7,
    38: s7,
    42: J6,
    60: [t7, V7],
    91: I7,
    92: [C7, a7],
    93: R7,
    95: J6,
    96: p7
  },
  o9 = {
    null: [J6, z7]
  };
var i9 = Object.freeze({
  __proto__: null,
  document: J7,
  contentInitial: e9,
  flowInitial: t9,
  flow: r9,
  string: n9,
  text: a9,
  insideSpan: o9,
  attentionMarkers: {
    null: [42, 95]
  },
  disable: {
    null: []
  }
});
function l9(e) {
  const t = function (e) {
      const t = {};
      let r = -1;
      for (; ++r < e.length;) V6(t, e[r]);
      return t;
    }([i9, ...((e || {}).extensions || [])]),
    r = {
      defined: [],
      lazy: {},
      constructs: t,
      content: n(Q6),
      document: n(G6),
      flow: n($7),
      string: n(W7),
      text: n(Q7)
    };
  return r;
  function n(e) {
    return function (t) {
      return X7(r, e, t);
    };
  }
}
const s9 = /[\0\t\n\r]/g;
function c9(e, t) {
  const r = Number.parseInt(e, t);
  return r < 9 || 11 === r || r > 13 && r < 32 || r > 126 && r < 160 || r > 55295 && r < 57344 || r > 64975 && r < 65008 || 65535 == (65535 & r) || 65534 == (65535 & r) || r > 1114111 ? "�" : String.fromCharCode(r);
}
const u9 = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function h9(e, t, r) {
  if (t) return t;
  if (35 === r.charCodeAt(0)) {
    const e = r.charCodeAt(1),
      t = 120 === e || 88 === e;
    return c9(r.slice(t ? 2 : 1), t ? 16 : 10);
  }
  return l7(r) || e;
}
function m9(e) {
  return e && "object" == typeof e ? "position" in e || "type" in e ? f9(e.position) : "start" in e || "end" in e ? f9(e) : "line" in e || "column" in e ? p9(e) : "" : "";
}
function p9(e) {
  return d9(e && e.line) + ":" + d9(e && e.column);
}
function f9(e) {
  return p9(e && e.start) + "-" + p9(e && e.end);
}
function d9(e) {
  return e && "number" == typeof e ? e : 1;
}
const v9 = {}.hasOwnProperty,
  g9 = function (e, t, r) {
    return "string" != typeof t && (r = t, t = void 0), function (e) {
      const t = {
        transforms: [],
        canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
        enter: {
          autolink: l(re),
          autolinkProtocol: M,
          autolinkEmail: M,
          atxHeading: l(X),
          blockQuote: l(W),
          characterEscape: M,
          characterReference: M,
          codeFenced: l(Q),
          codeFencedFenceInfo: s,
          codeFencedFenceMeta: s,
          codeIndented: l(Q, s),
          codeText: l(G, s),
          codeTextData: M,
          data: M,
          codeFlowValue: M,
          definition: l(Y),
          definitionDestinationString: s,
          definitionLabelString: s,
          definitionTitleString: s,
          emphasis: l(K),
          hardBreakEscape: l(J),
          hardBreakTrailing: l(J),
          htmlFlow: l(ee, s),
          htmlFlowData: M,
          htmlText: l(ee, s),
          htmlTextData: M,
          image: l(te),
          label: s,
          link: l(re),
          listItem: l(ae),
          listItemValue: f,
          listOrdered: l(ne, p),
          listUnordered: l(ne),
          paragraph: l(oe),
          reference: Z,
          referenceString: s,
          resourceDestinationString: s,
          resourceTitleString: s,
          setextHeading: l(X),
          strong: l(ie),
          thematicBreak: l(se)
        },
        exit: {
          atxHeading: u(),
          atxHeadingSequence: E,
          autolink: u(),
          autolinkEmail: z,
          autolinkProtocol: $,
          blockQuote: u(),
          characterEscapeValue: k,
          characterReferenceMarkerHexadecimal: q,
          characterReferenceMarkerNumeric: q,
          characterReferenceValue: U,
          codeFenced: u(b),
          codeFencedFence: g,
          codeFencedFenceInfo: d,
          codeFencedFenceMeta: v,
          codeFlowValue: k,
          codeIndented: u(w),
          codeText: u(R),
          codeTextData: k,
          data: k,
          definition: u(),
          definitionDestinationString: O,
          definitionLabelString: y,
          definitionTitleString: x,
          emphasis: u(),
          hardBreakEscape: u(N),
          hardBreakTrailing: u(N),
          htmlFlow: u(B),
          htmlFlowData: k,
          htmlText: u(V),
          htmlTextData: k,
          image: u(T),
          label: L,
          labelText: H,
          lineEnding: S,
          link: u(A),
          listItem: u(),
          listOrdered: u(),
          listUnordered: u(),
          paragraph: u(),
          referenceString: D,
          resourceDestinationString: I,
          resourceTitleString: F,
          resource: _,
          setextHeading: u(P),
          setextHeadingLineSequence: C,
          setextHeadingText: j,
          strong: u(),
          thematicBreak: u()
        }
      };
      w9(t, (e || {}).mdastExtensions || []);
      const r = {};
      return n;
      function n(e) {
        let r = {
          type: "root",
          children: []
        };
        const n = {
            stack: [r],
            tokenStack: [],
            config: t,
            enter: c,
            exit: h,
            buffer: s,
            resume: m,
            setData: o,
            getData: i
          },
          l = [];
        let u = -1;
        for (; ++u < e.length;) if ("listOrdered" === e[u][1].type || "listUnordered" === e[u][1].type) if ("enter" === e[u][0]) l.push(u);else {
          u = a(e, l.pop(), u);
        }
        for (u = -1; ++u < e.length;) {
          const r = t[e[u][0]];
          v9.call(r, e[u][1].type) && r[e[u][1].type].call(Object.assign({
            sliceSerialize: e[u][2].sliceSerialize
          }, n), e[u][1]);
        }
        if (n.tokenStack.length > 0) {
          const e = n.tokenStack[n.tokenStack.length - 1];
          (e[1] || x9).call(n, void 0, e[0]);
        }
        for (r.position = {
          start: b9(e.length > 0 ? e[0][1].start : {
            line: 1,
            column: 1,
            offset: 0
          }),
          end: b9(e.length > 0 ? e[e.length - 2][1].end : {
            line: 1,
            column: 1,
            offset: 0
          })
        }, u = -1; ++u < t.transforms.length;) r = t.transforms[u](r) || r;
        return r;
      }
      function a(e, t, r) {
        let n,
          a,
          o,
          i,
          l = t - 1,
          s = -1,
          c = !1;
        for (; ++l <= r;) {
          const t = e[l];
          if ("listUnordered" === t[1].type || "listOrdered" === t[1].type || "blockQuote" === t[1].type ? ("enter" === t[0] ? s++ : s--, i = void 0) : "lineEndingBlank" === t[1].type ? "enter" === t[0] && (!n || i || s || o || (o = l), i = void 0) : "linePrefix" === t[1].type || "listItemValue" === t[1].type || "listItemMarker" === t[1].type || "listItemPrefix" === t[1].type || "listItemPrefixWhitespace" === t[1].type || (i = void 0), !s && "enter" === t[0] && "listItemPrefix" === t[1].type || -1 === s && "exit" === t[0] && ("listUnordered" === t[1].type || "listOrdered" === t[1].type)) {
            if (n) {
              let i = l;
              for (a = void 0; i--;) {
                const t = e[i];
                if ("lineEnding" === t[1].type || "lineEndingBlank" === t[1].type) {
                  if ("exit" === t[0]) continue;
                  a && (e[a][1].type = "lineEndingBlank", c = !0), t[1].type = "lineEnding", a = i;
                } else if ("linePrefix" !== t[1].type && "blockQuotePrefix" !== t[1].type && "blockQuotePrefixWhitespace" !== t[1].type && "blockQuoteMarker" !== t[1].type && "listItemIndent" !== t[1].type) break;
              }
              o && (!a || o < a) && (n._spread = !0), n.end = Object.assign({}, a ? e[a][1].start : t[1].end), e.splice(a || l, 0, ["exit", n, t[2]]), l++, r++;
            }
            "listItemPrefix" === t[1].type && (n = {
              type: "listItem",
              _spread: !1,
              start: Object.assign({}, t[1].start),
              end: void 0
            }, e.splice(l, 0, ["enter", n, t[2]]), l++, r++, o = void 0, i = !0);
          }
        }
        return e[t][1]._spread = c, r;
      }
      function o(e, t) {
        r[e] = t;
      }
      function i(e) {
        return r[e];
      }
      function l(e, t) {
        return r;
        function r(r) {
          c.call(this, e(r), r), t && t.call(this, r);
        }
      }
      function s() {
        this.stack.push({
          type: "fragment",
          children: []
        });
      }
      function c(e, t, r) {
        return this.stack[this.stack.length - 1].children.push(e), this.stack.push(e), this.tokenStack.push([t, r]), e.position = {
          start: b9(t.start)
        }, e;
      }
      function u(e) {
        return t;
        function t(t) {
          e && e.call(this, t), h.call(this, t);
        }
      }
      function h(e, t) {
        const r = this.stack.pop(),
          n = this.tokenStack.pop();
        if (!n) throw new Error("Cannot close `" + e.type + "` (" + m9({
          start: e.start,
          end: e.end
        }) + "): it’s not open");
        if (n[0].type !== e.type) if (t) t.call(this, e, n[0]);else {
          (n[1] || x9).call(this, e, n[0]);
        }
        return r.position.end = b9(e.end), r;
      }
      function m() {
        return function (e, t) {
          const r = t || P6;
          return M6(e, "boolean" != typeof r.includeImageAlt || r.includeImageAlt, "boolean" != typeof r.includeHtml || r.includeHtml);
        }(this.stack.pop());
      }
      function p() {
        o("expectingFirstListItemValue", !0);
      }
      function f(e) {
        if (i("expectingFirstListItemValue")) {
          this.stack[this.stack.length - 2].start = Number.parseInt(this.sliceSerialize(e), 10), o("expectingFirstListItemValue");
        }
      }
      function d() {
        const e = this.resume();
        this.stack[this.stack.length - 1].lang = e;
      }
      function v() {
        const e = this.resume();
        this.stack[this.stack.length - 1].meta = e;
      }
      function g() {
        i("flowCodeInside") || (this.buffer(), o("flowCodeInside", !0));
      }
      function b() {
        const e = this.resume();
        this.stack[this.stack.length - 1].value = e.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), o("flowCodeInside");
      }
      function w() {
        const e = this.resume();
        this.stack[this.stack.length - 1].value = e.replace(/(\r?\n|\r)$/g, "");
      }
      function y(e) {
        const t = this.resume(),
          r = this.stack[this.stack.length - 1];
        r.label = t, r.identifier = O7(this.sliceSerialize(e)).toLowerCase();
      }
      function x() {
        const e = this.resume();
        this.stack[this.stack.length - 1].title = e;
      }
      function O() {
        const e = this.resume();
        this.stack[this.stack.length - 1].url = e;
      }
      function E(e) {
        const t = this.stack[this.stack.length - 1];
        if (!t.depth) {
          const r = this.sliceSerialize(e).length;
          t.depth = r;
        }
      }
      function j() {
        o("setextHeadingSlurpLineEnding", !0);
      }
      function C(e) {
        this.stack[this.stack.length - 1].depth = 61 === this.sliceSerialize(e).charCodeAt(0) ? 1 : 2;
      }
      function P() {
        o("setextHeadingSlurpLineEnding");
      }
      function M(e) {
        const t = this.stack[this.stack.length - 1];
        let r = t.children[t.children.length - 1];
        r && "text" === r.type || (r = le(), r.position = {
          start: b9(e.start)
        }, t.children.push(r)), this.stack.push(r);
      }
      function k(e) {
        const t = this.stack.pop();
        t.value += this.sliceSerialize(e), t.position.end = b9(e.end);
      }
      function S(e) {
        const r = this.stack[this.stack.length - 1];
        if (i("atHardBreak")) {
          return r.children[r.children.length - 1].position.end = b9(e.end), void o("atHardBreak");
        }
        !i("setextHeadingSlurpLineEnding") && t.canContainEols.includes(r.type) && (M.call(this, e), k.call(this, e));
      }
      function N() {
        o("atHardBreak", !0);
      }
      function B() {
        const e = this.resume();
        this.stack[this.stack.length - 1].value = e;
      }
      function V() {
        const e = this.resume();
        this.stack[this.stack.length - 1].value = e;
      }
      function R() {
        const e = this.resume();
        this.stack[this.stack.length - 1].value = e;
      }
      function A() {
        const e = this.stack[this.stack.length - 1];
        if (i("inReference")) {
          const t = i("referenceType") || "shortcut";
          e.type += "Reference", e.referenceType = t, delete e.url, delete e.title;
        } else delete e.identifier, delete e.label;
        o("referenceType");
      }
      function T() {
        const e = this.stack[this.stack.length - 1];
        if (i("inReference")) {
          const t = i("referenceType") || "shortcut";
          e.type += "Reference", e.referenceType = t, delete e.url, delete e.title;
        } else delete e.identifier, delete e.label;
        o("referenceType");
      }
      function H(e) {
        const t = this.sliceSerialize(e),
          r = this.stack[this.stack.length - 2];
        r.label = function (e) {
          return e.replace(u9, h9);
        }(t), r.identifier = O7(t).toLowerCase();
      }
      function L() {
        const e = this.stack[this.stack.length - 1],
          t = this.resume(),
          r = this.stack[this.stack.length - 1];
        if (o("inReference", !0), "link" === r.type) {
          const t = e.children;
          r.children = t;
        } else r.alt = t;
      }
      function I() {
        const e = this.resume();
        this.stack[this.stack.length - 1].url = e;
      }
      function F() {
        const e = this.resume();
        this.stack[this.stack.length - 1].title = e;
      }
      function _() {
        o("inReference");
      }
      function Z() {
        o("referenceType", "collapsed");
      }
      function D(e) {
        const t = this.resume(),
          r = this.stack[this.stack.length - 1];
        r.label = t, r.identifier = O7(this.sliceSerialize(e)).toLowerCase(), o("referenceType", "full");
      }
      function q(e) {
        o("characterReferenceType", e.type);
      }
      function U(e) {
        const t = this.sliceSerialize(e),
          r = i("characterReferenceType");
        let n;
        if (r) n = c9(t, "characterReferenceMarkerNumeric" === r ? 10 : 16), o("characterReferenceType");else {
          n = l7(t);
        }
        const a = this.stack.pop();
        a.value += n, a.position.end = b9(e.end);
      }
      function $(e) {
        k.call(this, e);
        this.stack[this.stack.length - 1].url = this.sliceSerialize(e);
      }
      function z(e) {
        k.call(this, e);
        this.stack[this.stack.length - 1].url = "mailto:" + this.sliceSerialize(e);
      }
      function W() {
        return {
          type: "blockquote",
          children: []
        };
      }
      function Q() {
        return {
          type: "code",
          lang: null,
          meta: null,
          value: ""
        };
      }
      function G() {
        return {
          type: "inlineCode",
          value: ""
        };
      }
      function Y() {
        return {
          type: "definition",
          identifier: "",
          label: null,
          title: null,
          url: ""
        };
      }
      function K() {
        return {
          type: "emphasis",
          children: []
        };
      }
      function X() {
        return {
          type: "heading",
          depth: void 0,
          children: []
        };
      }
      function J() {
        return {
          type: "break"
        };
      }
      function ee() {
        return {
          type: "html",
          value: ""
        };
      }
      function te() {
        return {
          type: "image",
          title: null,
          url: "",
          alt: null
        };
      }
      function re() {
        return {
          type: "link",
          title: null,
          url: "",
          children: []
        };
      }
      function ne(e) {
        return {
          type: "list",
          ordered: "listOrdered" === e.type,
          start: null,
          spread: e._spread,
          children: []
        };
      }
      function ae(e) {
        return {
          type: "listItem",
          spread: e._spread,
          checked: null,
          children: []
        };
      }
      function oe() {
        return {
          type: "paragraph",
          children: []
        };
      }
      function ie() {
        return {
          type: "strong",
          children: []
        };
      }
      function le() {
        return {
          type: "text",
          value: ""
        };
      }
      function se() {
        return {
          type: "thematicBreak"
        };
      }
    }(r)(function (e) {
      for (; !f7(e););
      return e;
    }(l9(r).document().write(function () {
      let e,
        t = 1,
        r = "",
        n = !0;
      return function (a, o, i) {
        const l = [];
        let s, c, u, h, m;
        for (a = r + a.toString(o), u = 0, r = "", n && (65279 === a.charCodeAt(0) && u++, n = void 0); u < a.length;) {
          if (s9.lastIndex = u, s = s9.exec(a), h = s && void 0 !== s.index ? s.index : a.length, m = a.charCodeAt(h), !s) {
            r = a.slice(u);
            break;
          }
          if (10 === m && u === h && e) l.push(-3), e = void 0;else switch (e && (l.push(-5), e = void 0), u < h && (l.push(a.slice(u, h)), t += h - u), m) {
            case 0:
              l.push(65533), t++;
              break;
            case 9:
              for (c = 4 * Math.ceil(t / 4), l.push(-2); t++ < c;) l.push(-1);
              break;
            case 10:
              l.push(-4), t = 1;
              break;
            default:
              e = !0, t = 1;
          }
          u = h + 1;
        }
        return i && (e && l.push(-5), r && l.push(r), l.push(null)), l;
      };
    }()(e, t, !0))));
  };
function b9(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function w9(e, t) {
  let r = -1;
  for (; ++r < t.length;) {
    const n = t[r];
    Array.isArray(n) ? w9(e, n) : y9(e, n);
  }
}
function y9(e, t) {
  let r;
  for (r in t) if (v9.call(t, r)) if ("canContainEols" === r) {
    const n = t[r];
    n && e[r].push(...n);
  } else if ("transforms" === r) {
    const n = t[r];
    n && e[r].push(...n);
  } else if ("enter" === r || "exit" === r) {
    const n = t[r];
    n && Object.assign(e[r], n);
  }
}
function x9(e, t) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + m9({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + t.type + "`, " + m9({
    start: t.start,
    end: t.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + t.type + "`, " + m9({
    start: t.start,
    end: t.end
  }) + ") is still open");
}
function O9(e) {
  Object.assign(this, {
    Parser: t => {
      const r = this.data("settings");
      return g9(t, Object.assign({}, r, e, {
        extensions: this.data("micromarkExtensions") || [],
        mdastExtensions: this.data("fromMarkdownExtensions") || []
      }));
    }
  });
}
function E9(e) {
  const t = [];
  let r = -1,
    n = 0,
    a = 0;
  for (; ++r < e.length;) {
    const o = e.charCodeAt(r);
    let i = "";
    if (37 === o && T6(e.charCodeAt(r + 1)) && T6(e.charCodeAt(r + 2))) a = 2;else if (o < 128) /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(o)) || (i = String.fromCharCode(o));else if (o > 55295 && o < 57344) {
      const t = e.charCodeAt(r + 1);
      o < 56320 && t > 56319 && t < 57344 ? (i = String.fromCharCode(o, t), a = 1) : i = "�";
    } else i = String.fromCharCode(o);
    i && (t.push(e.slice(n, r), encodeURIComponent(i)), n = r + a + 1, i = ""), a && (r += a, a = 0);
  }
  return t.join("") + e.slice(n);
}
function j9(e, t) {
  const r = String(t.identifier).toUpperCase(),
    n = E9(r.toLowerCase()),
    a = e.footnoteOrder.indexOf(r);
  let o;
  -1 === a ? (e.footnoteOrder.push(r), e.footnoteCounts[r] = 1, o = e.footnoteOrder.length) : (e.footnoteCounts[r]++, o = a + 1);
  const i = e.footnoteCounts[r],
    l = {
      type: "element",
      tagName: "a",
      properties: {
        href: "#" + e.clobberPrefix + "fn-" + n,
        id: e.clobberPrefix + "fnref-" + n + (i > 1 ? "-" + i : ""),
        dataFootnoteRef: !0,
        ariaDescribedBy: ["footnote-label"]
      },
      children: [{
        type: "text",
        value: String(o)
      }]
    };
  e.patch(t, l);
  const s = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [l]
  };
  return e.patch(t, s), e.applyData(t, s);
}
function C9(e, t) {
  const r = t.referenceType;
  let n = "]";
  if ("collapsed" === r ? n += "[]" : "full" === r && (n += "[" + (t.label || t.identifier) + "]"), "imageReference" === t.type) return {
    type: "text",
    value: "![" + t.alt + n
  };
  const a = e.all(t),
    o = a[0];
  o && "text" === o.type ? o.value = "[" + o.value : a.unshift({
    type: "text",
    value: "["
  });
  const i = a[a.length - 1];
  return i && "text" === i.type ? i.value += n : a.push({
    type: "text",
    value: n
  }), a;
}
function P9(e) {
  const t = e.spread;
  return null == t ? e.children.length > 1 : t;
}
const M9 = S9("start"),
  k9 = S9("end");
function S9(e) {
  return function (t) {
    const r = t && t.position && t.position[e] || {};
    return {
      line: r.line || null,
      column: r.column || null,
      offset: r.offset > -1 ? r.offset : null
    };
  };
}
const N9 = 9,
  B9 = 32;
function V9(e) {
  const t = String(e),
    r = /\r?\n|\r/g;
  let n = r.exec(t),
    a = 0;
  const o = [];
  for (; n;) o.push(R9(t.slice(a, n.index), a > 0, !0), n[0]), a = n.index + n[0].length, n = r.exec(t);
  return o.push(R9(t.slice(a), a > 0, !1)), o.join("");
}
function R9(e, t, r) {
  let n = 0,
    a = e.length;
  if (t) {
    let t = e.codePointAt(n);
    for (; t === N9 || t === B9;) n++, t = e.codePointAt(n);
  }
  if (r) {
    let t = e.codePointAt(a - 1);
    for (; t === N9 || t === B9;) a--, t = e.codePointAt(a - 1);
  }
  return a > n ? e.slice(n, a) : "";
}
const A9 = {
  blockquote: function (e, t) {
    const r = {
      type: "element",
      tagName: "blockquote",
      properties: {},
      children: e.wrap(e.all(t), !0)
    };
    return e.patch(t, r), e.applyData(t, r);
  },
  break: function (e, t) {
    const r = {
      type: "element",
      tagName: "br",
      properties: {},
      children: []
    };
    return e.patch(t, r), [e.applyData(t, r), {
      type: "text",
      value: "\n"
    }];
  },
  code: function (e, t) {
    const r = t.value ? t.value + "\n" : "",
      n = t.lang ? t.lang.match(/^[^ \t]+(?=[ \t]|$)/) : null,
      a = {};
    n && (a.className = ["language-" + n]);
    let o = {
      type: "element",
      tagName: "code",
      properties: a,
      children: [{
        type: "text",
        value: r
      }]
    };
    return t.meta && (o.data = {
      meta: t.meta
    }), e.patch(t, o), o = e.applyData(t, o), o = {
      type: "element",
      tagName: "pre",
      properties: {},
      children: [o]
    }, e.patch(t, o), o;
  },
  delete: function (e, t) {
    const r = {
      type: "element",
      tagName: "del",
      properties: {},
      children: e.all(t)
    };
    return e.patch(t, r), e.applyData(t, r);
  },
  emphasis: function (e, t) {
    const r = {
      type: "element",
      tagName: "em",
      properties: {},
      children: e.all(t)
    };
    return e.patch(t, r), e.applyData(t, r);
  },
  footnoteReference: j9,
  footnote: function (e, t) {
    const r = e.footnoteById;
    let n = 1;
    for (; (n in r);) n++;
    const a = String(n);
    return r[a] = {
      type: "footnoteDefinition",
      identifier: a,
      children: [{
        type: "paragraph",
        children: t.children
      }],
      position: t.position
    }, j9(e, {
      type: "footnoteReference",
      identifier: a,
      position: t.position
    });
  },
  heading: function (e, t) {
    const r = {
      type: "element",
      tagName: "h" + t.depth,
      properties: {},
      children: e.all(t)
    };
    return e.patch(t, r), e.applyData(t, r);
  },
  html: function (e, t) {
    if (e.dangerous) {
      const r = {
        type: "raw",
        value: t.value
      };
      return e.patch(t, r), e.applyData(t, r);
    }
    return null;
  },
  imageReference: function (e, t) {
    const r = e.definition(t.identifier);
    if (!r) return C9(e, t);
    const n = {
      src: E9(r.url || ""),
      alt: t.alt
    };
    null !== r.title && void 0 !== r.title && (n.title = r.title);
    const a = {
      type: "element",
      tagName: "img",
      properties: n,
      children: []
    };
    return e.patch(t, a), e.applyData(t, a);
  },
  image: function (e, t) {
    const r = {
      src: E9(t.url)
    };
    null !== t.alt && void 0 !== t.alt && (r.alt = t.alt), null !== t.title && void 0 !== t.title && (r.title = t.title);
    const n = {
      type: "element",
      tagName: "img",
      properties: r,
      children: []
    };
    return e.patch(t, n), e.applyData(t, n);
  },
  inlineCode: function (e, t) {
    const r = {
      type: "text",
      value: t.value.replace(/\r?\n|\r/g, " ")
    };
    e.patch(t, r);
    const n = {
      type: "element",
      tagName: "code",
      properties: {},
      children: [r]
    };
    return e.patch(t, n), e.applyData(t, n);
  },
  linkReference: function (e, t) {
    const r = e.definition(t.identifier);
    if (!r) return C9(e, t);
    const n = {
      href: E9(r.url || "")
    };
    null !== r.title && void 0 !== r.title && (n.title = r.title);
    const a = {
      type: "element",
      tagName: "a",
      properties: n,
      children: e.all(t)
    };
    return e.patch(t, a), e.applyData(t, a);
  },
  link: function (e, t) {
    const r = {
      href: E9(t.url)
    };
    null !== t.title && void 0 !== t.title && (r.title = t.title);
    const n = {
      type: "element",
      tagName: "a",
      properties: r,
      children: e.all(t)
    };
    return e.patch(t, n), e.applyData(t, n);
  },
  listItem: function (e, t, r) {
    const n = e.all(t),
      a = r ? function (e) {
        let t = !1;
        if ("list" === e.type) {
          t = e.spread || !1;
          const r = e.children;
          let n = -1;
          for (; !t && ++n < r.length;) t = P9(r[n]);
        }
        return t;
      }(r) : P9(t),
      o = {},
      i = [];
    if ("boolean" == typeof t.checked) {
      const e = n[0];
      let r;
      e && "element" === e.type && "p" === e.tagName ? r = e : (r = {
        type: "element",
        tagName: "p",
        properties: {},
        children: []
      }, n.unshift(r)), r.children.length > 0 && r.children.unshift({
        type: "text",
        value: " "
      }), r.children.unshift({
        type: "element",
        tagName: "input",
        properties: {
          type: "checkbox",
          checked: t.checked,
          disabled: !0
        },
        children: []
      }), o.className = ["task-list-item"];
    }
    let l = -1;
    for (; ++l < n.length;) {
      const e = n[l];
      (a || 0 !== l || "element" !== e.type || "p" !== e.tagName) && i.push({
        type: "text",
        value: "\n"
      }), "element" !== e.type || "p" !== e.tagName || a ? i.push(e) : i.push(...e.children);
    }
    const s = n[n.length - 1];
    s && (a || "element" !== s.type || "p" !== s.tagName) && i.push({
      type: "text",
      value: "\n"
    });
    const c = {
      type: "element",
      tagName: "li",
      properties: o,
      children: i
    };
    return e.patch(t, c), e.applyData(t, c);
  },
  list: function (e, t) {
    const r = {},
      n = e.all(t);
    let a = -1;
    for ("number" == typeof t.start && 1 !== t.start && (r.start = t.start); ++a < n.length;) {
      const e = n[a];
      if ("element" === e.type && "li" === e.tagName && e.properties && Array.isArray(e.properties.className) && e.properties.className.includes("task-list-item")) {
        r.className = ["contains-task-list"];
        break;
      }
    }
    const o = {
      type: "element",
      tagName: t.ordered ? "ol" : "ul",
      properties: r,
      children: e.wrap(n, !0)
    };
    return e.patch(t, o), e.applyData(t, o);
  },
  paragraph: function (e, t) {
    const r = {
      type: "element",
      tagName: "p",
      properties: {},
      children: e.all(t)
    };
    return e.patch(t, r), e.applyData(t, r);
  },
  root: function (e, t) {
    const r = {
      type: "root",
      children: e.wrap(e.all(t))
    };
    return e.patch(t, r), e.applyData(t, r);
  },
  strong: function (e, t) {
    const r = {
      type: "element",
      tagName: "strong",
      properties: {},
      children: e.all(t)
    };
    return e.patch(t, r), e.applyData(t, r);
  },
  table: function (e, t) {
    const r = e.all(t),
      n = r.shift(),
      a = [];
    if (n) {
      const r = {
        type: "element",
        tagName: "thead",
        properties: {},
        children: e.wrap([n], !0)
      };
      e.patch(t.children[0], r), a.push(r);
    }
    if (r.length > 0) {
      const n = {
          type: "element",
          tagName: "tbody",
          properties: {},
          children: e.wrap(r, !0)
        },
        o = M9(t.children[1]),
        i = k9(t.children[t.children.length - 1]);
      o.line && i.line && (n.position = {
        start: o,
        end: i
      }), a.push(n);
    }
    const o = {
      type: "element",
      tagName: "table",
      properties: {},
      children: e.wrap(a, !0)
    };
    return e.patch(t, o), e.applyData(t, o);
  },
  tableCell: function (e, t) {
    const r = {
      type: "element",
      tagName: "td",
      properties: {},
      children: e.all(t)
    };
    return e.patch(t, r), e.applyData(t, r);
  },
  tableRow: function (e, t, r) {
    const n = r ? r.children : void 0,
      a = 0 === (n ? n.indexOf(t) : 1) ? "th" : "td",
      o = r && "table" === r.type ? r.align : void 0,
      i = o ? o.length : t.children.length;
    let l = -1;
    const s = [];
    for (; ++l < i;) {
      const r = t.children[l],
        n = {},
        i = o ? o[l] : void 0;
      i && (n.align = i);
      let c = {
        type: "element",
        tagName: a,
        properties: n,
        children: []
      };
      r && (c.children = e.all(r), e.patch(r, c), c = e.applyData(t, c)), s.push(c);
    }
    const c = {
      type: "element",
      tagName: "tr",
      properties: {},
      children: e.wrap(s, !0)
    };
    return e.patch(t, c), e.applyData(t, c);
  },
  text: function (e, t) {
    const r = {
      type: "text",
      value: V9(String(t.value))
    };
    return e.patch(t, r), e.applyData(t, r);
  },
  thematicBreak: function (e, t) {
    const r = {
      type: "element",
      tagName: "hr",
      properties: {},
      children: []
    };
    return e.patch(t, r), e.applyData(t, r);
  },
  toml: T9,
  yaml: T9,
  definition: T9,
  footnoteDefinition: T9
};
function T9() {
  return null;
}
const H9 = function (e) {
  if (null == e) return I9;
  if ("string" == typeof e) return function (e) {
    return L9(t);
    function t(t) {
      return t && t.type === e;
    }
  }(e);
  if ("object" == typeof e) return Array.isArray(e) ? function (e) {
    const t = [];
    let r = -1;
    for (; ++r < e.length;) t[r] = H9(e[r]);
    return L9(n);
    function n() {
      let r = -1;
      for (var _len8 = arguments.length, e = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
        e[_key8] = arguments[_key8];
      }
      for (; ++r < t.length;) if (t[r].call(this, ...e)) return !0;
      return !1;
    }
  }(e) : function (e) {
    return L9(t);
    function t(t) {
      let r;
      for (r in e) if (t[r] !== e[r]) return !1;
      return !0;
    }
  }(e);
  if ("function" == typeof e) return L9(e);
  throw new Error("Expected function, string, or object as test");
};
function L9(e) {
  return function (t) {
    for (var _len9 = arguments.length, r = new Array(_len9 > 1 ? _len9 - 1 : 0), _key9 = 1; _key9 < _len9; _key9++) {
      r[_key9 - 1] = arguments[_key9];
    }
    return Boolean(t && "object" == typeof t && "type" in t && Boolean(e.call(this, t, ...r)));
  };
}
function I9() {
  return !0;
}
function F9(e) {
  return "[33m" + e + "[39m";
}
const _9 = function (e, t, r, n) {
  "function" == typeof t && "function" != typeof r && (n = r, r = t, t = null);
  const a = H9(t),
    o = n ? -1 : 1;
  !function e(i, l, s) {
    const c = i && "object" == typeof i ? i : {};
    if ("string" == typeof c.type) {
      const e = "string" == typeof c.tagName ? c.tagName : "string" == typeof c.name ? c.name : void 0;
      Object.defineProperty(u, "name", {
        value: "node (" + F9(i.type + (e ? "<" + e + ">" : "")) + ")"
      });
    }
    return u;
    function u() {
      let c,
        u,
        h,
        m = [];
      if ((!t || a(i, l, s[s.length - 1] || null)) && (m = function (e) {
        if (Array.isArray(e)) return e;
        if ("number" == typeof e) return [true, e];
        return [e];
      }(r(i, s)), false === m[0])) return m;
      if (i.children && "skip" !== m[0]) for (u = (n ? i.children.length : -1) + o, h = s.concat(i); u > -1 && u < i.children.length;) {
        if (c = e(i.children[u], u, h)(), false === c[0]) return c;
        u = "number" == typeof c[1] ? c[1] : u + o;
      }
      return m;
    }
  }(e, void 0, [])();
};
const Z9 = function (e, t, r, n) {
  "function" == typeof t && "function" != typeof r && (n = r, r = t, t = null), _9(e, t, function (e, t) {
    const n = t[t.length - 1];
    return r(e, n ? n.children.indexOf(e) : null, n);
  }, n);
};
const D9 = {}.hasOwnProperty;
function q9(e) {
  return String(e || "").toUpperCase();
}
const U9 = {}.hasOwnProperty;
function $9(e, t) {
  const r = t || {},
    n = r.allowDangerousHtml || !1,
    a = {};
  return i.dangerous = n, i.clobberPrefix = void 0 === r.clobberPrefix || null === r.clobberPrefix ? "user-content-" : r.clobberPrefix, i.footnoteLabel = r.footnoteLabel || "Footnotes", i.footnoteLabelTagName = r.footnoteLabelTagName || "h2", i.footnoteLabelProperties = r.footnoteLabelProperties || {
    className: ["sr-only"]
  }, i.footnoteBackLabel = r.footnoteBackLabel || "Back to content", i.unknownHandler = r.unknownHandler, i.passThrough = r.passThrough, i.handlers = {
    ...A9,
    ...r.handlers
  }, i.definition = function (e) {
    const t = Object.create(null);
    if (!e || !e.type) throw new Error("mdast-util-definitions expected node");
    return Z9(e, "definition", e => {
      const r = q9(e.identifier);
      r && !D9.call(t, r) && (t[r] = e);
    }), function (e) {
      const r = q9(e);
      return r && D9.call(t, r) ? t[r] : null;
    };
  }(e), i.footnoteById = a, i.footnoteOrder = [], i.footnoteCounts = {}, i.patch = z9, i.applyData = W9, i.one = function (e, t) {
    return Q9(i, e, t);
  }, i.all = function (e) {
    return G9(i, e);
  }, i.wrap = Y9, i.augment = o, Z9(e, "footnoteDefinition", e => {
    const t = String(e.identifier).toUpperCase();
    U9.call(a, t) || (a[t] = e);
  }), i;
  function o(e, t) {
    if (e && "data" in e && e.data) {
      const r = e.data;
      r.hName && ("element" !== t.type && (t = {
        type: "element",
        tagName: "",
        properties: {},
        children: []
      }), t.tagName = r.hName), "element" === t.type && r.hProperties && (t.properties = {
        ...t.properties,
        ...r.hProperties
      }), "children" in t && t.children && r.hChildren && (t.children = r.hChildren);
    }
    if (e) {
      const r = "type" in e ? e : {
        position: e
      };
      (function (e) {
        return !(e && e.position && e.position.start && e.position.start.line && e.position.start.column && e.position.end && e.position.end.line && e.position.end.column);
      })(r) || (t.position = {
        start: M9(r),
        end: k9(r)
      });
    }
    return t;
  }
  function i(e, t, r, n) {
    return Array.isArray(r) && (n = r, r = {}), o(e, {
      type: "element",
      tagName: t,
      properties: r || {},
      children: n || []
    });
  }
}
function z9(e, t) {
  e.position && (t.position = function (e) {
    return {
      start: M9(e),
      end: k9(e)
    };
  }(e));
}
function W9(e, t) {
  let r = t;
  if (e && e.data) {
    const t = e.data.hName,
      n = e.data.hChildren,
      a = e.data.hProperties;
    "string" == typeof t && ("element" === r.type ? r.tagName = t : r = {
      type: "element",
      tagName: t,
      properties: {},
      children: []
    }), "element" === r.type && a && (r.properties = {
      ...r.properties,
      ...a
    }), "children" in r && r.children && null != n && (r.children = n);
  }
  return r;
}
function Q9(e, t, r) {
  const n = t && t.type;
  if (!n) throw new Error("Expected node, got `" + t + "`");
  return U9.call(e.handlers, n) ? e.handlers[n](e, t, r) : e.passThrough && e.passThrough.includes(n) ? "children" in t ? {
    ...t,
    children: G9(e, t)
  } : t : e.unknownHandler ? e.unknownHandler(e, t, r) : function (e, t) {
    const r = t.data || {},
      n = !("value" in t) || U9.call(r, "hProperties") || U9.call(r, "hChildren") ? {
        type: "element",
        tagName: "div",
        properties: {},
        children: G9(e, t)
      } : {
        type: "text",
        value: t.value
      };
    return e.patch(t, n), e.applyData(t, n);
  }(e, t);
}
function G9(e, t) {
  const r = [];
  if ("children" in t) {
    const n = t.children;
    let a = -1;
    for (; ++a < n.length;) {
      const o = Q9(e, n[a], t);
      if (o) {
        if (a && "break" === n[a - 1].type && (Array.isArray(o) || "text" !== o.type || (o.value = o.value.replace(/^\s+/, "")), !Array.isArray(o) && "element" === o.type)) {
          const e = o.children[0];
          e && "text" === e.type && (e.value = e.value.replace(/^\s+/, ""));
        }
        Array.isArray(o) ? r.push(...o) : r.push(o);
      }
    }
  }
  return r;
}
function Y9(e, t) {
  const r = [];
  let n = -1;
  for (t && r.push({
    type: "text",
    value: "\n"
  }); ++n < e.length;) n && r.push({
    type: "text",
    value: "\n"
  }), r.push(e[n]);
  return t && e.length > 0 && r.push({
    type: "text",
    value: "\n"
  }), r;
}
function K9(e, t) {
  const r = $9(e, t),
    n = r.one(e, null),
    a = function (e) {
      const t = [];
      let r = -1;
      for (; ++r < e.footnoteOrder.length;) {
        const n = e.footnoteById[e.footnoteOrder[r]];
        if (!n) continue;
        const a = e.all(n),
          o = String(n.identifier).toUpperCase(),
          i = E9(o.toLowerCase());
        let l = 0;
        const s = [];
        for (; ++l <= e.footnoteCounts[o];) {
          const t = {
            type: "element",
            tagName: "a",
            properties: {
              href: "#" + e.clobberPrefix + "fnref-" + i + (l > 1 ? "-" + l : ""),
              dataFootnoteBackref: !0,
              className: ["data-footnote-backref"],
              ariaLabel: e.footnoteBackLabel
            },
            children: [{
              type: "text",
              value: "↩"
            }]
          };
          l > 1 && t.children.push({
            type: "element",
            tagName: "sup",
            children: [{
              type: "text",
              value: String(l)
            }]
          }), s.length > 0 && s.push({
            type: "text",
            value: " "
          }), s.push(t);
        }
        const c = a[a.length - 1];
        if (c && "element" === c.type && "p" === c.tagName) {
          const e = c.children[c.children.length - 1];
          e && "text" === e.type ? e.value += " " : c.children.push({
            type: "text",
            value: " "
          }), c.children.push(...s);
        } else a.push(...s);
        const u = {
          type: "element",
          tagName: "li",
          properties: {
            id: e.clobberPrefix + "fn-" + i
          },
          children: e.wrap(a, !0)
        };
        e.patch(n, u), t.push(u);
      }
      if (0 !== t.length) return {
        type: "element",
        tagName: "section",
        properties: {
          dataFootnotes: !0,
          className: ["footnotes"]
        },
        children: [{
          type: "element",
          tagName: e.footnoteLabelTagName,
          properties: {
            ...JSON.parse(JSON.stringify(e.footnoteLabelProperties)),
            id: "footnote-label"
          },
          children: [{
            type: "text",
            value: e.footnoteLabel
          }]
        }, {
          type: "text",
          value: "\n"
        }, {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(t, !0)
        }, {
          type: "text",
          value: "\n"
        }]
      };
    }(r);
  return a && n.children.push({
    type: "text",
    value: "\n"
  }, a), Array.isArray(n) ? {
    type: "root",
    children: n
  } : n;
}
const X9 = function (e, t) {
  return e && "run" in e ? function (e, t) {
    return (r, n, a) => {
      e.run(K9(r, t), n, e => {
        a(e);
      });
    };
  }(e, t) : function (e) {
    return t => K9(t, e);
  }(e || t);
};
class J9 {
  constructor(e, t, r) {
    this.property = e, this.normal = t, r && (this.space = r);
  }
}
function eee(e, t) {
  const r = {},
    n = {};
  let a = -1;
  for (; ++a < e.length;) Object.assign(r, e[a].property), Object.assign(n, e[a].normal);
  return new J9(r, n, t);
}
function tee(e) {
  return e.toLowerCase();
}
J9.prototype.property = {}, J9.prototype.normal = {}, J9.prototype.space = null;
class ree {
  constructor(e, t) {
    this.property = e, this.attribute = t;
  }
}
ree.prototype.space = null, ree.prototype.boolean = !1, ree.prototype.booleanish = !1, ree.prototype.overloadedBoolean = !1, ree.prototype.number = !1, ree.prototype.commaSeparated = !1, ree.prototype.spaceSeparated = !1, ree.prototype.commaOrSpaceSeparated = !1, ree.prototype.mustUseProperty = !1, ree.prototype.defined = !1;
let nee = 0;
const aee = hee(),
  oee = hee(),
  iee = hee(),
  lee = hee(),
  see = hee(),
  cee = hee(),
  uee = hee();
function hee() {
  return 2 ** ++nee;
}
var mee = Object.freeze({
  __proto__: null,
  boolean: aee,
  booleanish: oee,
  overloadedBoolean: iee,
  number: lee,
  spaceSeparated: see,
  commaSeparated: cee,
  commaOrSpaceSeparated: uee
});
const pee = Object.keys(mee);
class fee extends ree {
  constructor(e, t, r, n) {
    let a = -1;
    if (super(e, t), dee(this, "space", n), "number" == typeof r) for (; ++a < pee.length;) {
      const e = pee[a];
      dee(this, pee[a], (r & mee[e]) === mee[e]);
    }
  }
}
function dee(e, t, r) {
  r && (e[t] = r);
}
fee.prototype.defined = !0;
const vee = {}.hasOwnProperty;
function gee(e) {
  const t = {},
    r = {};
  let n;
  for (n in e.properties) if (vee.call(e.properties, n)) {
    const a = e.properties[n],
      o = new fee(n, e.transform(e.attributes || {}, n), a, e.space);
    e.mustUseProperty && e.mustUseProperty.includes(n) && (o.mustUseProperty = !0), t[n] = o, r[tee(n)] = n, r[tee(o.attribute)] = n;
  }
  return new J9(t, r, e.space);
}
const bee = gee({
    space: "xlink",
    transform: (e, t) => "xlink:" + t.slice(5).toLowerCase(),
    properties: {
      xLinkActuate: null,
      xLinkArcRole: null,
      xLinkHref: null,
      xLinkRole: null,
      xLinkShow: null,
      xLinkTitle: null,
      xLinkType: null
    }
  }),
  wee = gee({
    space: "xml",
    transform: (e, t) => "xml:" + t.slice(3).toLowerCase(),
    properties: {
      xmlLang: null,
      xmlBase: null,
      xmlSpace: null
    }
  });
function yee(e, t) {
  return t in e ? e[t] : t;
}
function xee(e, t) {
  return yee(e, t.toLowerCase());
}
const Oee = gee({
    space: "xmlns",
    attributes: {
      xmlnsxlink: "xmlns:xlink"
    },
    transform: xee,
    properties: {
      xmlns: null,
      xmlnsXLink: null
    }
  }),
  Eee = gee({
    transform: (e, t) => "role" === t ? t : "aria-" + t.slice(4).toLowerCase(),
    properties: {
      ariaActiveDescendant: null,
      ariaAtomic: oee,
      ariaAutoComplete: null,
      ariaBusy: oee,
      ariaChecked: oee,
      ariaColCount: lee,
      ariaColIndex: lee,
      ariaColSpan: lee,
      ariaControls: see,
      ariaCurrent: null,
      ariaDescribedBy: see,
      ariaDetails: null,
      ariaDisabled: oee,
      ariaDropEffect: see,
      ariaErrorMessage: null,
      ariaExpanded: oee,
      ariaFlowTo: see,
      ariaGrabbed: oee,
      ariaHasPopup: null,
      ariaHidden: oee,
      ariaInvalid: null,
      ariaKeyShortcuts: null,
      ariaLabel: null,
      ariaLabelledBy: see,
      ariaLevel: lee,
      ariaLive: null,
      ariaModal: oee,
      ariaMultiLine: oee,
      ariaMultiSelectable: oee,
      ariaOrientation: null,
      ariaOwns: see,
      ariaPlaceholder: null,
      ariaPosInSet: lee,
      ariaPressed: oee,
      ariaReadOnly: oee,
      ariaRelevant: null,
      ariaRequired: oee,
      ariaRoleDescription: see,
      ariaRowCount: lee,
      ariaRowIndex: lee,
      ariaRowSpan: lee,
      ariaSelected: oee,
      ariaSetSize: lee,
      ariaSort: null,
      ariaValueMax: lee,
      ariaValueMin: lee,
      ariaValueNow: lee,
      ariaValueText: null,
      role: null
    }
  }),
  jee = gee({
    space: "html",
    attributes: {
      acceptcharset: "accept-charset",
      classname: "class",
      htmlfor: "for",
      httpequiv: "http-equiv"
    },
    transform: xee,
    mustUseProperty: ["checked", "multiple", "muted", "selected"],
    properties: {
      abbr: null,
      accept: cee,
      acceptCharset: see,
      accessKey: see,
      action: null,
      allow: null,
      allowFullScreen: aee,
      allowPaymentRequest: aee,
      allowUserMedia: aee,
      alt: null,
      as: null,
      async: aee,
      autoCapitalize: null,
      autoComplete: see,
      autoFocus: aee,
      autoPlay: aee,
      capture: aee,
      charSet: null,
      checked: aee,
      cite: null,
      className: see,
      cols: lee,
      colSpan: null,
      content: null,
      contentEditable: oee,
      controls: aee,
      controlsList: see,
      coords: lee | cee,
      crossOrigin: null,
      data: null,
      dateTime: null,
      decoding: null,
      default: aee,
      defer: aee,
      dir: null,
      dirName: null,
      disabled: aee,
      download: iee,
      draggable: oee,
      encType: null,
      enterKeyHint: null,
      form: null,
      formAction: null,
      formEncType: null,
      formMethod: null,
      formNoValidate: aee,
      formTarget: null,
      headers: see,
      height: lee,
      hidden: aee,
      high: lee,
      href: null,
      hrefLang: null,
      htmlFor: see,
      httpEquiv: see,
      id: null,
      imageSizes: null,
      imageSrcSet: null,
      inputMode: null,
      integrity: null,
      is: null,
      isMap: aee,
      itemId: null,
      itemProp: see,
      itemRef: see,
      itemScope: aee,
      itemType: see,
      kind: null,
      label: null,
      lang: null,
      language: null,
      list: null,
      loading: null,
      loop: aee,
      low: lee,
      manifest: null,
      max: null,
      maxLength: lee,
      media: null,
      method: null,
      min: null,
      minLength: lee,
      multiple: aee,
      muted: aee,
      name: null,
      nonce: null,
      noModule: aee,
      noValidate: aee,
      onAbort: null,
      onAfterPrint: null,
      onAuxClick: null,
      onBeforeMatch: null,
      onBeforePrint: null,
      onBeforeUnload: null,
      onBlur: null,
      onCancel: null,
      onCanPlay: null,
      onCanPlayThrough: null,
      onChange: null,
      onClick: null,
      onClose: null,
      onContextLost: null,
      onContextMenu: null,
      onContextRestored: null,
      onCopy: null,
      onCueChange: null,
      onCut: null,
      onDblClick: null,
      onDrag: null,
      onDragEnd: null,
      onDragEnter: null,
      onDragExit: null,
      onDragLeave: null,
      onDragOver: null,
      onDragStart: null,
      onDrop: null,
      onDurationChange: null,
      onEmptied: null,
      onEnded: null,
      onError: null,
      onFocus: null,
      onFormData: null,
      onHashChange: null,
      onInput: null,
      onInvalid: null,
      onKeyDown: null,
      onKeyPress: null,
      onKeyUp: null,
      onLanguageChange: null,
      onLoad: null,
      onLoadedData: null,
      onLoadedMetadata: null,
      onLoadEnd: null,
      onLoadStart: null,
      onMessage: null,
      onMessageError: null,
      onMouseDown: null,
      onMouseEnter: null,
      onMouseLeave: null,
      onMouseMove: null,
      onMouseOut: null,
      onMouseOver: null,
      onMouseUp: null,
      onOffline: null,
      onOnline: null,
      onPageHide: null,
      onPageShow: null,
      onPaste: null,
      onPause: null,
      onPlay: null,
      onPlaying: null,
      onPopState: null,
      onProgress: null,
      onRateChange: null,
      onRejectionHandled: null,
      onReset: null,
      onResize: null,
      onScroll: null,
      onScrollEnd: null,
      onSecurityPolicyViolation: null,
      onSeeked: null,
      onSeeking: null,
      onSelect: null,
      onSlotChange: null,
      onStalled: null,
      onStorage: null,
      onSubmit: null,
      onSuspend: null,
      onTimeUpdate: null,
      onToggle: null,
      onUnhandledRejection: null,
      onUnload: null,
      onVolumeChange: null,
      onWaiting: null,
      onWheel: null,
      open: aee,
      optimum: lee,
      pattern: null,
      ping: see,
      placeholder: null,
      playsInline: aee,
      poster: null,
      preload: null,
      readOnly: aee,
      referrerPolicy: null,
      rel: see,
      required: aee,
      reversed: aee,
      rows: lee,
      rowSpan: lee,
      sandbox: see,
      scope: null,
      scoped: aee,
      seamless: aee,
      selected: aee,
      shape: null,
      size: lee,
      sizes: null,
      slot: null,
      span: lee,
      spellCheck: oee,
      src: null,
      srcDoc: null,
      srcLang: null,
      srcSet: null,
      start: lee,
      step: null,
      style: null,
      tabIndex: lee,
      target: null,
      title: null,
      translate: null,
      type: null,
      typeMustMatch: aee,
      useMap: null,
      value: oee,
      width: lee,
      wrap: null,
      align: null,
      aLink: null,
      archive: see,
      axis: null,
      background: null,
      bgColor: null,
      border: lee,
      borderColor: null,
      bottomMargin: lee,
      cellPadding: null,
      cellSpacing: null,
      char: null,
      charOff: null,
      classId: null,
      clear: null,
      code: null,
      codeBase: null,
      codeType: null,
      color: null,
      compact: aee,
      declare: aee,
      event: null,
      face: null,
      frame: null,
      frameBorder: null,
      hSpace: lee,
      leftMargin: lee,
      link: null,
      longDesc: null,
      lowSrc: null,
      marginHeight: lee,
      marginWidth: lee,
      noResize: aee,
      noHref: aee,
      noShade: aee,
      noWrap: aee,
      object: null,
      profile: null,
      prompt: null,
      rev: null,
      rightMargin: lee,
      rules: null,
      scheme: null,
      scrolling: oee,
      standby: null,
      summary: null,
      text: null,
      topMargin: lee,
      valueType: null,
      version: null,
      vAlign: null,
      vLink: null,
      vSpace: lee,
      allowTransparency: null,
      autoCorrect: null,
      autoSave: null,
      disablePictureInPicture: aee,
      disableRemotePlayback: aee,
      prefix: null,
      property: null,
      results: lee,
      security: null,
      unselectable: null
    }
  }),
  Cee = gee({
    space: "svg",
    attributes: {
      accentHeight: "accent-height",
      alignmentBaseline: "alignment-baseline",
      arabicForm: "arabic-form",
      baselineShift: "baseline-shift",
      capHeight: "cap-height",
      className: "class",
      clipPath: "clip-path",
      clipRule: "clip-rule",
      colorInterpolation: "color-interpolation",
      colorInterpolationFilters: "color-interpolation-filters",
      colorProfile: "color-profile",
      colorRendering: "color-rendering",
      crossOrigin: "crossorigin",
      dataType: "datatype",
      dominantBaseline: "dominant-baseline",
      enableBackground: "enable-background",
      fillOpacity: "fill-opacity",
      fillRule: "fill-rule",
      floodColor: "flood-color",
      floodOpacity: "flood-opacity",
      fontFamily: "font-family",
      fontSize: "font-size",
      fontSizeAdjust: "font-size-adjust",
      fontStretch: "font-stretch",
      fontStyle: "font-style",
      fontVariant: "font-variant",
      fontWeight: "font-weight",
      glyphName: "glyph-name",
      glyphOrientationHorizontal: "glyph-orientation-horizontal",
      glyphOrientationVertical: "glyph-orientation-vertical",
      hrefLang: "hreflang",
      horizAdvX: "horiz-adv-x",
      horizOriginX: "horiz-origin-x",
      horizOriginY: "horiz-origin-y",
      imageRendering: "image-rendering",
      letterSpacing: "letter-spacing",
      lightingColor: "lighting-color",
      markerEnd: "marker-end",
      markerMid: "marker-mid",
      markerStart: "marker-start",
      navDown: "nav-down",
      navDownLeft: "nav-down-left",
      navDownRight: "nav-down-right",
      navLeft: "nav-left",
      navNext: "nav-next",
      navPrev: "nav-prev",
      navRight: "nav-right",
      navUp: "nav-up",
      navUpLeft: "nav-up-left",
      navUpRight: "nav-up-right",
      onAbort: "onabort",
      onActivate: "onactivate",
      onAfterPrint: "onafterprint",
      onBeforePrint: "onbeforeprint",
      onBegin: "onbegin",
      onCancel: "oncancel",
      onCanPlay: "oncanplay",
      onCanPlayThrough: "oncanplaythrough",
      onChange: "onchange",
      onClick: "onclick",
      onClose: "onclose",
      onCopy: "oncopy",
      onCueChange: "oncuechange",
      onCut: "oncut",
      onDblClick: "ondblclick",
      onDrag: "ondrag",
      onDragEnd: "ondragend",
      onDragEnter: "ondragenter",
      onDragExit: "ondragexit",
      onDragLeave: "ondragleave",
      onDragOver: "ondragover",
      onDragStart: "ondragstart",
      onDrop: "ondrop",
      onDurationChange: "ondurationchange",
      onEmptied: "onemptied",
      onEnd: "onend",
      onEnded: "onended",
      onError: "onerror",
      onFocus: "onfocus",
      onFocusIn: "onfocusin",
      onFocusOut: "onfocusout",
      onHashChange: "onhashchange",
      onInput: "oninput",
      onInvalid: "oninvalid",
      onKeyDown: "onkeydown",
      onKeyPress: "onkeypress",
      onKeyUp: "onkeyup",
      onLoad: "onload",
      onLoadedData: "onloadeddata",
      onLoadedMetadata: "onloadedmetadata",
      onLoadStart: "onloadstart",
      onMessage: "onmessage",
      onMouseDown: "onmousedown",
      onMouseEnter: "onmouseenter",
      onMouseLeave: "onmouseleave",
      onMouseMove: "onmousemove",
      onMouseOut: "onmouseout",
      onMouseOver: "onmouseover",
      onMouseUp: "onmouseup",
      onMouseWheel: "onmousewheel",
      onOffline: "onoffline",
      onOnline: "ononline",
      onPageHide: "onpagehide",
      onPageShow: "onpageshow",
      onPaste: "onpaste",
      onPause: "onpause",
      onPlay: "onplay",
      onPlaying: "onplaying",
      onPopState: "onpopstate",
      onProgress: "onprogress",
      onRateChange: "onratechange",
      onRepeat: "onrepeat",
      onReset: "onreset",
      onResize: "onresize",
      onScroll: "onscroll",
      onSeeked: "onseeked",
      onSeeking: "onseeking",
      onSelect: "onselect",
      onShow: "onshow",
      onStalled: "onstalled",
      onStorage: "onstorage",
      onSubmit: "onsubmit",
      onSuspend: "onsuspend",
      onTimeUpdate: "ontimeupdate",
      onToggle: "ontoggle",
      onUnload: "onunload",
      onVolumeChange: "onvolumechange",
      onWaiting: "onwaiting",
      onZoom: "onzoom",
      overlinePosition: "overline-position",
      overlineThickness: "overline-thickness",
      paintOrder: "paint-order",
      panose1: "panose-1",
      pointerEvents: "pointer-events",
      referrerPolicy: "referrerpolicy",
      renderingIntent: "rendering-intent",
      shapeRendering: "shape-rendering",
      stopColor: "stop-color",
      stopOpacity: "stop-opacity",
      strikethroughPosition: "strikethrough-position",
      strikethroughThickness: "strikethrough-thickness",
      strokeDashArray: "stroke-dasharray",
      strokeDashOffset: "stroke-dashoffset",
      strokeLineCap: "stroke-linecap",
      strokeLineJoin: "stroke-linejoin",
      strokeMiterLimit: "stroke-miterlimit",
      strokeOpacity: "stroke-opacity",
      strokeWidth: "stroke-width",
      tabIndex: "tabindex",
      textAnchor: "text-anchor",
      textDecoration: "text-decoration",
      textRendering: "text-rendering",
      typeOf: "typeof",
      underlinePosition: "underline-position",
      underlineThickness: "underline-thickness",
      unicodeBidi: "unicode-bidi",
      unicodeRange: "unicode-range",
      unitsPerEm: "units-per-em",
      vAlphabetic: "v-alphabetic",
      vHanging: "v-hanging",
      vIdeographic: "v-ideographic",
      vMathematical: "v-mathematical",
      vectorEffect: "vector-effect",
      vertAdvY: "vert-adv-y",
      vertOriginX: "vert-origin-x",
      vertOriginY: "vert-origin-y",
      wordSpacing: "word-spacing",
      writingMode: "writing-mode",
      xHeight: "x-height",
      playbackOrder: "playbackorder",
      timelineBegin: "timelinebegin"
    },
    transform: yee,
    properties: {
      about: uee,
      accentHeight: lee,
      accumulate: null,
      additive: null,
      alignmentBaseline: null,
      alphabetic: lee,
      amplitude: lee,
      arabicForm: null,
      ascent: lee,
      attributeName: null,
      attributeType: null,
      azimuth: lee,
      bandwidth: null,
      baselineShift: null,
      baseFrequency: null,
      baseProfile: null,
      bbox: null,
      begin: null,
      bias: lee,
      by: null,
      calcMode: null,
      capHeight: lee,
      className: see,
      clip: null,
      clipPath: null,
      clipPathUnits: null,
      clipRule: null,
      color: null,
      colorInterpolation: null,
      colorInterpolationFilters: null,
      colorProfile: null,
      colorRendering: null,
      content: null,
      contentScriptType: null,
      contentStyleType: null,
      crossOrigin: null,
      cursor: null,
      cx: null,
      cy: null,
      d: null,
      dataType: null,
      defaultAction: null,
      descent: lee,
      diffuseConstant: lee,
      direction: null,
      display: null,
      dur: null,
      divisor: lee,
      dominantBaseline: null,
      download: aee,
      dx: null,
      dy: null,
      edgeMode: null,
      editable: null,
      elevation: lee,
      enableBackground: null,
      end: null,
      event: null,
      exponent: lee,
      externalResourcesRequired: null,
      fill: null,
      fillOpacity: lee,
      fillRule: null,
      filter: null,
      filterRes: null,
      filterUnits: null,
      floodColor: null,
      floodOpacity: null,
      focusable: null,
      focusHighlight: null,
      fontFamily: null,
      fontSize: null,
      fontSizeAdjust: null,
      fontStretch: null,
      fontStyle: null,
      fontVariant: null,
      fontWeight: null,
      format: null,
      fr: null,
      from: null,
      fx: null,
      fy: null,
      g1: cee,
      g2: cee,
      glyphName: cee,
      glyphOrientationHorizontal: null,
      glyphOrientationVertical: null,
      glyphRef: null,
      gradientTransform: null,
      gradientUnits: null,
      handler: null,
      hanging: lee,
      hatchContentUnits: null,
      hatchUnits: null,
      height: null,
      href: null,
      hrefLang: null,
      horizAdvX: lee,
      horizOriginX: lee,
      horizOriginY: lee,
      id: null,
      ideographic: lee,
      imageRendering: null,
      initialVisibility: null,
      in: null,
      in2: null,
      intercept: lee,
      k: lee,
      k1: lee,
      k2: lee,
      k3: lee,
      k4: lee,
      kernelMatrix: uee,
      kernelUnitLength: null,
      keyPoints: null,
      keySplines: null,
      keyTimes: null,
      kerning: null,
      lang: null,
      lengthAdjust: null,
      letterSpacing: null,
      lightingColor: null,
      limitingConeAngle: lee,
      local: null,
      markerEnd: null,
      markerMid: null,
      markerStart: null,
      markerHeight: null,
      markerUnits: null,
      markerWidth: null,
      mask: null,
      maskContentUnits: null,
      maskUnits: null,
      mathematical: null,
      max: null,
      media: null,
      mediaCharacterEncoding: null,
      mediaContentEncodings: null,
      mediaSize: lee,
      mediaTime: null,
      method: null,
      min: null,
      mode: null,
      name: null,
      navDown: null,
      navDownLeft: null,
      navDownRight: null,
      navLeft: null,
      navNext: null,
      navPrev: null,
      navRight: null,
      navUp: null,
      navUpLeft: null,
      navUpRight: null,
      numOctaves: null,
      observer: null,
      offset: null,
      onAbort: null,
      onActivate: null,
      onAfterPrint: null,
      onBeforePrint: null,
      onBegin: null,
      onCancel: null,
      onCanPlay: null,
      onCanPlayThrough: null,
      onChange: null,
      onClick: null,
      onClose: null,
      onCopy: null,
      onCueChange: null,
      onCut: null,
      onDblClick: null,
      onDrag: null,
      onDragEnd: null,
      onDragEnter: null,
      onDragExit: null,
      onDragLeave: null,
      onDragOver: null,
      onDragStart: null,
      onDrop: null,
      onDurationChange: null,
      onEmptied: null,
      onEnd: null,
      onEnded: null,
      onError: null,
      onFocus: null,
      onFocusIn: null,
      onFocusOut: null,
      onHashChange: null,
      onInput: null,
      onInvalid: null,
      onKeyDown: null,
      onKeyPress: null,
      onKeyUp: null,
      onLoad: null,
      onLoadedData: null,
      onLoadedMetadata: null,
      onLoadStart: null,
      onMessage: null,
      onMouseDown: null,
      onMouseEnter: null,
      onMouseLeave: null,
      onMouseMove: null,
      onMouseOut: null,
      onMouseOver: null,
      onMouseUp: null,
      onMouseWheel: null,
      onOffline: null,
      onOnline: null,
      onPageHide: null,
      onPageShow: null,
      onPaste: null,
      onPause: null,
      onPlay: null,
      onPlaying: null,
      onPopState: null,
      onProgress: null,
      onRateChange: null,
      onRepeat: null,
      onReset: null,
      onResize: null,
      onScroll: null,
      onSeeked: null,
      onSeeking: null,
      onSelect: null,
      onShow: null,
      onStalled: null,
      onStorage: null,
      onSubmit: null,
      onSuspend: null,
      onTimeUpdate: null,
      onToggle: null,
      onUnload: null,
      onVolumeChange: null,
      onWaiting: null,
      onZoom: null,
      opacity: null,
      operator: null,
      order: null,
      orient: null,
      orientation: null,
      origin: null,
      overflow: null,
      overlay: null,
      overlinePosition: lee,
      overlineThickness: lee,
      paintOrder: null,
      panose1: null,
      path: null,
      pathLength: lee,
      patternContentUnits: null,
      patternTransform: null,
      patternUnits: null,
      phase: null,
      ping: see,
      pitch: null,
      playbackOrder: null,
      pointerEvents: null,
      points: null,
      pointsAtX: lee,
      pointsAtY: lee,
      pointsAtZ: lee,
      preserveAlpha: null,
      preserveAspectRatio: null,
      primitiveUnits: null,
      propagate: null,
      property: uee,
      r: null,
      radius: null,
      referrerPolicy: null,
      refX: null,
      refY: null,
      rel: uee,
      rev: uee,
      renderingIntent: null,
      repeatCount: null,
      repeatDur: null,
      requiredExtensions: uee,
      requiredFeatures: uee,
      requiredFonts: uee,
      requiredFormats: uee,
      resource: null,
      restart: null,
      result: null,
      rotate: null,
      rx: null,
      ry: null,
      scale: null,
      seed: null,
      shapeRendering: null,
      side: null,
      slope: null,
      snapshotTime: null,
      specularConstant: lee,
      specularExponent: lee,
      spreadMethod: null,
      spacing: null,
      startOffset: null,
      stdDeviation: null,
      stemh: null,
      stemv: null,
      stitchTiles: null,
      stopColor: null,
      stopOpacity: null,
      strikethroughPosition: lee,
      strikethroughThickness: lee,
      string: null,
      stroke: null,
      strokeDashArray: uee,
      strokeDashOffset: null,
      strokeLineCap: null,
      strokeLineJoin: null,
      strokeMiterLimit: lee,
      strokeOpacity: lee,
      strokeWidth: null,
      style: null,
      surfaceScale: lee,
      syncBehavior: null,
      syncBehaviorDefault: null,
      syncMaster: null,
      syncTolerance: null,
      syncToleranceDefault: null,
      systemLanguage: uee,
      tabIndex: lee,
      tableValues: null,
      target: null,
      targetX: lee,
      targetY: lee,
      textAnchor: null,
      textDecoration: null,
      textRendering: null,
      textLength: null,
      timelineBegin: null,
      title: null,
      transformBehavior: null,
      type: null,
      typeOf: uee,
      to: null,
      transform: null,
      u1: null,
      u2: null,
      underlinePosition: lee,
      underlineThickness: lee,
      unicode: null,
      unicodeBidi: null,
      unicodeRange: null,
      unitsPerEm: lee,
      values: null,
      vAlphabetic: lee,
      vMathematical: lee,
      vectorEffect: null,
      vHanging: lee,
      vIdeographic: lee,
      version: null,
      vertAdvY: lee,
      vertOriginX: lee,
      vertOriginY: lee,
      viewBox: null,
      viewTarget: null,
      visibility: null,
      width: null,
      widths: null,
      wordSpacing: null,
      writingMode: null,
      x: null,
      x1: null,
      x2: null,
      xChannelSelector: null,
      xHeight: lee,
      y: null,
      y1: null,
      y2: null,
      yChannelSelector: null,
      z: null,
      zoomAndPan: null
    }
  }),
  Pee = /^data[-\w.:]+$/i,
  Mee = /-[a-z]/g,
  kee = /[A-Z]/g;
function See(e) {
  return "-" + e.toLowerCase();
}
function Nee(e) {
  return e.charAt(1).toUpperCase();
}
const Bee = {
    classId: "classID",
    dataType: "datatype",
    itemId: "itemID",
    strokeDashArray: "strokeDasharray",
    strokeDashOffset: "strokeDashoffset",
    strokeLineCap: "strokeLinecap",
    strokeLineJoin: "strokeLinejoin",
    strokeMiterLimit: "strokeMiterlimit",
    typeOf: "typeof",
    xLinkActuate: "xlinkActuate",
    xLinkArcRole: "xlinkArcrole",
    xLinkHref: "xlinkHref",
    xLinkRole: "xlinkRole",
    xLinkShow: "xlinkShow",
    xLinkTitle: "xlinkTitle",
    xLinkType: "xlinkType",
    xmlnsXLink: "xmlnsXlink"
  },
  Vee = eee([wee, bee, Oee, Eee, jee], "html"),
  Ree = eee([wee, bee, Oee, Eee, Cee], "svg"),
  Aee = function (e) {
    if (null == e) return Hee;
    if ("string" == typeof e) return function (e) {
      return Tee(t);
      function t(t) {
        return t && t.type === e;
      }
    }(e);
    if ("object" == typeof e) return Array.isArray(e) ? function (e) {
      const t = [];
      let r = -1;
      for (; ++r < e.length;) t[r] = Aee(e[r]);
      return Tee(n);
      function n() {
        let r = -1;
        for (var _len10 = arguments.length, e = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
          e[_key10] = arguments[_key10];
        }
        for (; ++r < t.length;) if (t[r].call(this, ...e)) return !0;
        return !1;
      }
    }(e) : function (e) {
      return Tee(t);
      function t(t) {
        let r;
        for (r in e) if (t[r] !== e[r]) return !1;
        return !0;
      }
    }(e);
    if ("function" == typeof e) return Tee(e);
    throw new Error("Expected function, string, or object as test");
  };
function Tee(e) {
  return function (t) {
    for (var _len11 = arguments.length, r = new Array(_len11 > 1 ? _len11 - 1 : 0), _key11 = 1; _key11 < _len11; _key11++) {
      r[_key11 - 1] = arguments[_key11];
    }
    return Boolean(t && "object" == typeof t && "type" in t && Boolean(e.call(this, t, ...r)));
  };
}
function Hee() {
  return !0;
}
function Lee(e) {
  return "[33m" + e + "[39m";
}
const Iee = function (e, t, r, n) {
  "function" == typeof t && "function" != typeof r && (n = r, r = t, t = null);
  const a = Aee(t),
    o = n ? -1 : 1;
  !function e(i, l, s) {
    const c = i && "object" == typeof i ? i : {};
    if ("string" == typeof c.type) {
      const e = "string" == typeof c.tagName ? c.tagName : "string" == typeof c.name ? c.name : void 0;
      Object.defineProperty(u, "name", {
        value: "node (" + Lee(i.type + (e ? "<" + e + ">" : "")) + ")"
      });
    }
    return u;
    function u() {
      let c,
        u,
        h,
        m = [];
      if ((!t || a(i, l, s[s.length - 1] || null)) && (m = function (e) {
        if (Array.isArray(e)) return e;
        if ("number" == typeof e) return [true, e];
        return [e];
      }(r(i, s)), false === m[0])) return m;
      if (i.children && "skip" !== m[0]) for (u = (n ? i.children.length : -1) + o, h = s.concat(i); u > -1 && u < i.children.length;) {
        if (c = e(i.children[u], u, h)(), false === c[0]) return c;
        u = "number" == typeof c[1] ? c[1] : u + o;
      }
      return m;
    }
  }(e, void 0, [])();
};
const Fee = function (e, t, r, n) {
  "function" == typeof t && "function" != typeof r && (n = r, r = t, t = null), Iee(e, t, function (e, t) {
    const n = t[t.length - 1];
    return r(e, n ? n.children.indexOf(e) : null, n);
  }, n);
};
function _ee(e) {
  if (e.allowedElements && e.disallowedElements) throw new TypeError("Only one of `allowedElements` and `disallowedElements` should be defined");
  if (e.allowedElements || e.disallowedElements || e.allowElement) return t => {
    Fee(t, "element", (t, r, n) => {
      const a = n;
      let o;
      if (e.allowedElements ? o = !e.allowedElements.includes(t.tagName) : e.disallowedElements && (o = e.disallowedElements.includes(t.tagName)), !o && e.allowElement && "number" == typeof r && (o = !e.allowElement(t, r, a)), o && "number" == typeof r) return e.unwrapDisallowed && t.children ? a.children.splice(r, 1, ...t.children) : a.children.splice(r, 1), r;
    });
  };
}
var Zee,
  Dee = {
    exports: {}
  },
  qee = {};
var Uee,
  $ee = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"production" === process.env.NODE_ENV ? Dee.exports = function () {
  if (Zee) return qee;
  Zee = 1;
  var e,
    t = Symbol.for("react.element"),
    r = Symbol.for("react.portal"),
    n = Symbol.for("react.fragment"),
    a = Symbol.for("react.strict_mode"),
    o = Symbol.for("react.profiler"),
    i = Symbol.for("react.provider"),
    l = Symbol.for("react.context"),
    s = Symbol.for("react.server_context"),
    c = Symbol.for("react.forward_ref"),
    u = Symbol.for("react.suspense"),
    h = Symbol.for("react.suspense_list"),
    m = Symbol.for("react.memo"),
    p = Symbol.for("react.lazy"),
    f = Symbol.for("react.offscreen");
  function d(e) {
    if ("object" == typeof e && null !== e) {
      var f = e.$$typeof;
      switch (f) {
        case t:
          switch (e = e.type) {
            case n:
            case o:
            case a:
            case u:
            case h:
              return e;
            default:
              switch (e = e && e.$$typeof) {
                case s:
                case l:
                case c:
                case p:
                case m:
                case i:
                  return e;
                default:
                  return f;
              }
          }
        case r:
          return f;
      }
    }
  }
  return e = Symbol.for("react.module.reference"), qee.ContextConsumer = l, qee.ContextProvider = i, qee.Element = t, qee.ForwardRef = c, qee.Fragment = n, qee.Lazy = p, qee.Memo = m, qee.Portal = r, qee.Profiler = o, qee.StrictMode = a, qee.Suspense = u, qee.SuspenseList = h, qee.isAsyncMode = function () {
    return !1;
  }, qee.isConcurrentMode = function () {
    return !1;
  }, qee.isContextConsumer = function (e) {
    return d(e) === l;
  }, qee.isContextProvider = function (e) {
    return d(e) === i;
  }, qee.isElement = function (e) {
    return "object" == typeof e && null !== e && e.$$typeof === t;
  }, qee.isForwardRef = function (e) {
    return d(e) === c;
  }, qee.isFragment = function (e) {
    return d(e) === n;
  }, qee.isLazy = function (e) {
    return d(e) === p;
  }, qee.isMemo = function (e) {
    return d(e) === m;
  }, qee.isPortal = function (e) {
    return d(e) === r;
  }, qee.isProfiler = function (e) {
    return d(e) === o;
  }, qee.isStrictMode = function (e) {
    return d(e) === a;
  }, qee.isSuspense = function (e) {
    return d(e) === u;
  }, qee.isSuspenseList = function (e) {
    return d(e) === h;
  }, qee.isValidElementType = function (t) {
    return "string" == typeof t || "function" == typeof t || t === n || t === o || t === a || t === u || t === h || t === f || "object" == typeof t && null !== t && (t.$$typeof === p || t.$$typeof === m || t.$$typeof === i || t.$$typeof === l || t.$$typeof === c || t.$$typeof === e || void 0 !== t.getModuleId);
  }, qee.typeOf = d, qee;
}() : Dee.exports = (Uee || (Uee = 1, "production" !== process.env.NODE_ENV && function () {
  var e,
    t = Symbol.for("react.element"),
    r = Symbol.for("react.portal"),
    n = Symbol.for("react.fragment"),
    a = Symbol.for("react.strict_mode"),
    o = Symbol.for("react.profiler"),
    i = Symbol.for("react.provider"),
    l = Symbol.for("react.context"),
    s = Symbol.for("react.server_context"),
    c = Symbol.for("react.forward_ref"),
    u = Symbol.for("react.suspense"),
    h = Symbol.for("react.suspense_list"),
    m = Symbol.for("react.memo"),
    p = Symbol.for("react.lazy"),
    f = Symbol.for("react.offscreen");
  function d(e) {
    if ("object" == typeof e && null !== e) {
      var f = e.$$typeof;
      switch (f) {
        case t:
          var d = e.type;
          switch (d) {
            case n:
            case o:
            case a:
            case u:
            case h:
              return d;
            default:
              var v = d && d.$$typeof;
              switch (v) {
                case s:
                case l:
                case c:
                case p:
                case m:
                case i:
                  return v;
                default:
                  return f;
              }
          }
        case r:
          return f;
      }
    }
  }
  e = Symbol.for("react.module.reference");
  var v = l,
    g = i,
    b = t,
    w = c,
    y = n,
    x = p,
    O = m,
    E = r,
    j = o,
    C = a,
    P = u,
    M = h,
    k = !1,
    S = !1;
  $ee.ContextConsumer = v, $ee.ContextProvider = g, $ee.Element = b, $ee.ForwardRef = w, $ee.Fragment = y, $ee.Lazy = x, $ee.Memo = O, $ee.Portal = E, $ee.Profiler = j, $ee.StrictMode = C, $ee.Suspense = P, $ee.SuspenseList = M, $ee.isAsyncMode = function (e) {
    return k || (k = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
  }, $ee.isConcurrentMode = function (e) {
    return S || (S = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
  }, $ee.isContextConsumer = function (e) {
    return d(e) === l;
  }, $ee.isContextProvider = function (e) {
    return d(e) === i;
  }, $ee.isElement = function (e) {
    return "object" == typeof e && null !== e && e.$$typeof === t;
  }, $ee.isForwardRef = function (e) {
    return d(e) === c;
  }, $ee.isFragment = function (e) {
    return d(e) === n;
  }, $ee.isLazy = function (e) {
    return d(e) === p;
  }, $ee.isMemo = function (e) {
    return d(e) === m;
  }, $ee.isPortal = function (e) {
    return d(e) === r;
  }, $ee.isProfiler = function (e) {
    return d(e) === o;
  }, $ee.isStrictMode = function (e) {
    return d(e) === a;
  }, $ee.isSuspense = function (e) {
    return d(e) === u;
  }, $ee.isSuspenseList = function (e) {
    return d(e) === h;
  }, $ee.isValidElementType = function (t) {
    return "string" == typeof t || "function" == typeof t || t === n || t === o || t === a || t === u || t === h || t === f || "object" == typeof t && null !== t && (t.$$typeof === p || t.$$typeof === m || t.$$typeof === i || t.$$typeof === l || t.$$typeof === c || t.$$typeof === e || void 0 !== t.getModuleId);
  }, $ee.typeOf = d;
}()), $ee);
var zee = T(Dee.exports);
function Wee(e) {
  const t = e && "object" == typeof e && "text" === e.type ? e.value || "" : e;
  return "string" == typeof t && "" === t.replace(/[ \t\n\f\r]/g, "");
}
var Qee = {
    exports: {}
  },
  Gee = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g,
  Yee = /\n/g,
  Kee = /^\s*/,
  Xee = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/,
  Jee = /^:\s*/,
  ete = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/,
  tte = /^[;\s]*/,
  rte = /^\s+|\s+$/g,
  nte = "";
function ate(e) {
  return e ? e.replace(rte, nte) : nte;
}
var ote = function (e, t) {
  if ("string" != typeof e) throw new TypeError("First argument must be a string");
  if (!e) return [];
  t = t || {};
  var r = 1,
    n = 1;
  function a(e) {
    var t = e.match(Yee);
    t && (r += t.length);
    var a = e.lastIndexOf("\n");
    n = ~a ? e.length - a : n + e.length;
  }
  function o() {
    var e = {
      line: r,
      column: n
    };
    return function (t) {
      return t.position = new i(e), c(), t;
    };
  }
  function i(e) {
    this.start = e, this.end = {
      line: r,
      column: n
    }, this.source = t.source;
  }
  function l(a) {
    var o = new Error(t.source + ":" + r + ":" + n + ": " + a);
    if (o.reason = a, o.filename = t.source, o.line = r, o.column = n, o.source = e, !t.silent) throw o;
  }
  function s(t) {
    var r = t.exec(e);
    if (r) {
      var n = r[0];
      return a(n), e = e.slice(n.length), r;
    }
  }
  function c() {
    s(Kee);
  }
  function u(e) {
    var t;
    for (e = e || []; t = h();) !1 !== t && e.push(t);
    return e;
  }
  function h() {
    var t = o();
    if ("/" == e.charAt(0) && "*" == e.charAt(1)) {
      for (var r = 2; nte != e.charAt(r) && ("*" != e.charAt(r) || "/" != e.charAt(r + 1));) ++r;
      if (r += 2, nte === e.charAt(r - 1)) return l("End of comment missing");
      var i = e.slice(2, r - 2);
      return n += 2, a(i), e = e.slice(r), n += 2, t({
        type: "comment",
        comment: i
      });
    }
  }
  function m() {
    var e = o(),
      t = s(Xee);
    if (t) {
      if (h(), !s(Jee)) return l("property missing ':'");
      var r = s(ete),
        n = e({
          type: "declaration",
          property: ate(t[0].replace(Gee, nte)),
          value: r ? ate(r[0].replace(Gee, nte)) : nte
        });
      return s(tte), n;
    }
  }
  return i.prototype.content = e, c(), function () {
    var e,
      t = [];
    for (u(t); e = m();) !1 !== e && (t.push(e), u(t));
    return t;
  }();
};
function ite(e, t) {
  var r,
    n = null;
  if (!e || "string" != typeof e) return n;
  for (var a, o, i = ote(e), l = "function" == typeof t, s = 0, c = i.length; s < c; s++) a = (r = i[s]).property, o = r.value, l ? t(a, o, r) : o && (n || (n = {}), n[a] = o);
  return n;
}
Qee.exports = ite, Qee.exports.default = ite;
var lte = T(Qee.exports);
const ste = {}.hasOwnProperty,
  cte = new Set(["table", "thead", "tbody", "tfoot", "tr"]);
function ute(e, t) {
  const r = [];
  let n,
    a = -1;
  for (; ++a < t.children.length;) n = t.children[a], "element" === n.type ? r.push(hte(e, n, a, t)) : "text" === n.type ? "element" === t.type && cte.has(t.tagName) && Wee(n) || r.push(n.value) : "raw" !== n.type || e.options.skipHtml || r.push(n.value);
  return r;
}
function hte(e, r, n, a) {
  const o = e.options,
    i = void 0 === o.transformLinkUri ? $8 : o.transformLinkUri,
    l = e.schema,
    s = r.tagName,
    c = {};
  let u,
    h = l;
  if ("html" === l.space && "svg" === s && (h = Ree, e.schema = h), r.properties) for (u in r.properties) ste.call(r.properties, u) && pte(c, u, r.properties[u], e);
  "ol" !== s && "ul" !== s || e.listDepth++;
  const m = ute(e, r);
  "ol" !== s && "ul" !== s || e.listDepth--, e.schema = l;
  const p = r.position || {
      start: {
        line: null,
        column: null,
        offset: null
      },
      end: {
        line: null,
        column: null,
        offset: null
      }
    },
    f = o.components && ste.call(o.components, s) ? o.components[s] : s,
    d = "string" == typeof f || f === t.Fragment;
  if (!zee.isValidElementType(f)) throw new TypeError("Component for name `".concat(s, "` not defined or is not renderable"));
  if (c.key = n, "a" === s && o.linkTarget && (c.target = "function" == typeof o.linkTarget ? o.linkTarget(String(c.href || ""), r.children, "string" == typeof c.title ? c.title : null) : o.linkTarget), "a" === s && i && (c.href = i(String(c.href || ""), r.children, "string" == typeof c.title ? c.title : null)), d || "code" !== s || "element" !== a.type || "pre" === a.tagName || (c.inline = !0), d || "h1" !== s && "h2" !== s && "h3" !== s && "h4" !== s && "h5" !== s && "h6" !== s || (c.level = Number.parseInt(s.charAt(1), 10)), "img" === s && o.transformImageUri && (c.src = o.transformImageUri(String(c.src || ""), String(c.alt || ""), "string" == typeof c.title ? c.title : null)), !d && "li" === s && "element" === a.type) {
    const e = function (e) {
      let t = -1;
      for (; ++t < e.children.length;) {
        const r = e.children[t];
        if ("element" === r.type && "input" === r.tagName) return r;
      }
      return null;
    }(r);
    c.checked = e && e.properties ? Boolean(e.properties.checked) : null, c.index = mte(a, r), c.ordered = "ol" === a.tagName;
  }
  var v;
  return d || "ol" !== s && "ul" !== s || (c.ordered = "ol" === s, c.depth = e.listDepth), "td" !== s && "th" !== s || (c.align && (c.style || (c.style = {}), c.style.textAlign = c.align, delete c.align), d || (c.isHeader = "th" === s)), d || "tr" !== s || "element" !== a.type || (c.isHeader = Boolean("thead" === a.tagName)), o.sourcePos && (c["data-sourcepos"] = [(v = p).start.line, ":", v.start.column, "-", v.end.line, ":", v.end.column].map(String).join("")), !d && o.rawSourcePos && (c.sourcePosition = r.position), !d && o.includeElementIndex && (c.index = mte(a, r), c.siblingCount = mte(a)), d || (c.node = r), m.length > 0 ? t.createElement(f, c, m) : t.createElement(f, c);
}
function mte(e, t) {
  let r = -1,
    n = 0;
  for (; ++r < e.children.length && e.children[r] !== t;) "element" === e.children[r].type && n++;
  return n;
}
function pte(e, t, r, n) {
  const a = function (e, t) {
    const r = tee(t);
    let n = t,
      a = ree;
    if (r in e.normal) return e.property[e.normal[r]];
    if (r.length > 4 && "data" === r.slice(0, 4) && Pee.test(t)) {
      if ("-" === t.charAt(4)) {
        const e = t.slice(5).replace(Mee, Nee);
        n = "data" + e.charAt(0).toUpperCase() + e.slice(1);
      } else {
        const e = t.slice(4);
        if (!Mee.test(e)) {
          let r = e.replace(kee, See);
          "-" !== r.charAt(0) && (r = "-" + r), t = "data" + r;
        }
      }
      a = fee;
    }
    return new a(n, t);
  }(n.schema, t);
  let o = r;
  null != o && o == o && (Array.isArray(o) && (o = a.commaSeparated ? function (e, t) {
    const r = t || {};
    return ("" === e[e.length - 1] ? [...e, ""] : e).join((r.padRight ? " " : "") + "," + (!1 === r.padLeft ? "" : " ")).trim();
  }(o) : o.join(" ").trim()), "style" === a.property && "string" == typeof o && (o = function (e) {
    const t = {};
    try {
      lte(e, r);
    } catch {}
    return t;
    function r(e, r) {
      const n = "-ms-" === e.slice(0, 4) ? "ms-".concat(e.slice(4)) : e;
      t[n.replace(/-([a-z])/g, fte)] = r;
    }
  }(o)), a.space && a.property ? e[ste.call(Bee, a.property) ? Bee[a.property] : a.property] = o : a.attribute && (e[a.attribute] = o));
}
function fte(e, t) {
  return t.toUpperCase();
}
const dte = {}.hasOwnProperty,
  vte = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md",
  gte = {
    plugins: {
      to: "remarkPlugins",
      id: "change-plugins-to-remarkplugins"
    },
    renderers: {
      to: "components",
      id: "change-renderers-to-components"
    },
    astPlugins: {
      id: "remove-buggy-html-in-markdown-parser"
    },
    allowDangerousHtml: {
      id: "remove-buggy-html-in-markdown-parser"
    },
    escapeHtml: {
      id: "remove-buggy-html-in-markdown-parser"
    },
    source: {
      to: "children",
      id: "change-source-to-children"
    },
    allowNode: {
      to: "allowElement",
      id: "replace-allownode-allowedtypes-and-disallowedtypes"
    },
    allowedTypes: {
      to: "allowedElements",
      id: "replace-allownode-allowedtypes-and-disallowedtypes"
    },
    disallowedTypes: {
      to: "disallowedElements",
      id: "replace-allownode-allowedtypes-and-disallowedtypes"
    },
    includeNodeIndex: {
      to: "includeElementIndex",
      id: "change-includenodeindex-to-includeelementindex"
    }
  };
function bte(e) {
  for (const t in gte) if (dte.call(gte, t) && dte.call(e, t)) {
    const e = gte[t];
    console.warn("[react-markdown] Warning: please ".concat(e.to ? "use `".concat(e.to, "` instead of") : "remove", " `").concat(t, "` (see <").concat(vte, "#").concat(e.id, "> for more info)")), delete gte[t];
  }
  const r = g6().use(O9).use(e.remarkPlugins || []).use(X9, {
      ...e.remarkRehypeOptions,
      allowDangerousHtml: !0
    }).use(e.rehypePlugins || []).use(_ee, e),
    n = new e6();
  "string" == typeof e.children ? n.value = e.children : void 0 !== e.children && null !== e.children && console.warn("[react-markdown] Warning: please pass a string as `children` (not: `".concat(e.children, "`)"));
  const a = r.runSync(r.parse(n), n);
  if ("root" !== a.type) throw new TypeError("Expected a `root` node");
  let o = t.createElement(t.Fragment, {}, ute({
    options: e,
    schema: Vee,
    listDepth: 0
  }, a));
  return e.className && (o = t.createElement("div", {
    className: e.className
  }, o)), o;
}
function wte(e) {
  let r = "";
  return r = void 0 === e.speakerSet ? "flex" : "flex tb-l:flex-row flex-col", t.createElement("div", {
    className: "grid w-full"
  }, t.createElement("div", {
    className: "".concat(r, " w-full max-w-[882px]")
  }, t.createElement("div", {
    className: "px-8 py-6" + (e.speakerSet ? " border-b tb-l:w-[62%] border-b-neutral-150 tb:border-0 tb:border-r tb:border-r-neutral-150" : "")
  }, t.createElement(x8, {
    size: e.badges.size,
    color: e.badges.color,
    leftIconVariant: e.badges.leftIconVariant,
    leftIconColor: e.badges.leftIconColor,
    children: e.badges.label
  }), t.createElement(ce, {
    className: "my-2 text-blue-800",
    textStyle: "h5"
  }, e.title), e.para && t.createElement(ce, {
    className: "line-clamp-3 text-neutral-700",
    textStyle: "body1c"
  }, e.para)), e.speakerSet && t.createElement("div", {
    className: "flex flex-col tb-l:w-[38%] pt-0 tb:pt-[2.875rem] justify-between"
  }, e.speakerSet && t.createElement("div", {
    className: "pl-6 flex gap-6 mt-9 tb:mt-0 mb-9 flex-col "
  }, e.speakerSet.map((e, r) => t.createElement("div", {
    key: r,
    className: ""
  }, t.createElement(g8, {
    name: e.name,
    size: "md",
    designation: e.designation,
    imageUrl: e.imageUrl
  })))), t.createElement("div", {
    className: " w-full border-t border-t-neutral-150 p-6 flex flex-row justify-between items-center"
  }, t.createElement(ce, {
    textStyle: "h6",
    className: "text-blue-800"
  }, e.eventTime), t.createElement(A8, {
    leftIconVariant: "calendarplus02",
    leftIconColor: "#1E56E3",
    rightIconVariant: "none",
    state: "default",
    size: "sm",
    type: "iconOnly",
    label: ""
  })))));
}
function yte(e) {
  var _e$readUrl;
  let r = "";
  return r = e.speakerSet ? "tb-l:justify-between" : "tb-l:justify-center", t.createElement("a", {
    href: (_e$readUrl = e.readUrl) !== null && _e$readUrl !== void 0 ? _e$readUrl : "#",
    className: "grid group"
  }, t.createElement("div", {
    className: "flex flex-col tb-l:flex-row tb-l:justify-between "
  }, t.createElement("div", {
    className: "px-6 pt-6 tb-l:px-8 tb-l:pb-6  tb-l:border-r tb-l:border-r-neutral-200"
  }, t.createElement("div", {
    className: "flex flex-row flex-wrap tb:gap-3 gap-2"
  }, e.badges && e.badges.map((e, r) => t.createElement("div", {
    key: r,
    className: "flex  whitespace-nowrap"
  }, t.createElement(x8, {
    size: e.size,
    color: e.color,
    leftIconVariant: e.leftIconVariant,
    leftIconColor: e.leftIconColor,
    leftIconColorClass: A(e.leftIconColorClass),
    children: e.label
  })))), t.createElement("div", {
    className: "tb-l:w-[380px] db:w-[520px] flex flex-col tb:justify-between"
  }, t.createElement("div", null, t.createElement(ce, {
    className: "mt-2 text-blue-800",
    textStyle: "h5"
  }, e.title), e.para && t.createElement(ce, {
    className: "line-clamp-3 mt-2 text-neutral-700",
    textStyle: "body1c"
  }, e.para)), t.createElement("div", {
    className: "flex pb-6 tb-l:pb-0"
  }, e.readUrl && e.para && t.createElement("div", null, t.createElement(A8, {
    label: e.videoUrl ? "Watch Recording" : "Read more",
    type: "secondaryLink",
    leftIconVariant: "none",
    rightIconVariant: "none",
    state: "default",
    size: "md",
    rightAnimatedArrow: !0,
    rightAnimatedArrowColor: "#3970FD",
    className: "mt-2",
    btnTextColorClass: "text-blue-500",
    animatedHoverStroke: "stroke-blue-500",
    btnTextHoverClass: "hover:text-blue-500"
  }))))), t.createElement("div", {
    className: "".concat(r, " tb-l:divide-y-2 divide-neutral-200 flex tb-l:w-full flex-col pt-0")
  }, e.speakerSet && t.createElement("div", {
    className: "px-6 py-6 border-t border-neutral-200 flex flex-col gap-6 tb:mt-0 tb-l:border-0 tb-l:h-full tb-l:justify-center  "
  }, e.speakerSet.map((r, n) => t.createElement("div", {
    key: n,
    className: "block"
  }, t.createElement(g8, {
    name: r.name,
    size: "md",
    designation: r.designation,
    imageUrl: r.imageUrl,
    avatarBgColor: e.avatarBgColor
  })))), e.eventTime && t.createElement("div", {
    className: "border-t border-neutral-200 tb-l:border-0 w-full pl-6 p-6 flex flex-row justify-between items-center"
  }, t.createElement(ce, {
    textStyle: "h6",
    className: "text-blue-800 uppercase"
  }, e.eventTime), e.addCalendarUrl && t.createElement("a", {
    href: e.addCalendarUrl
  }, t.createElement(A8, {
    leftIconVariant: "calendarplus02",
    leftIconColor: "#1E56E3",
    rightIconVariant: "none",
    state: "default",
    size: "sm",
    type: "iconOnly",
    label: ""
  }))))));
}
bte.propTypes = {
  children: se.string,
  className: se.string,
  allowElement: se.func,
  allowedElements: se.arrayOf(se.string),
  disallowedElements: se.arrayOf(se.string),
  unwrapDisallowed: se.bool,
  remarkPlugins: se.arrayOf(se.oneOfType([se.object, se.func, se.arrayOf(se.oneOfType([se.bool, se.string, se.object, se.func, se.arrayOf(se.any)]))])),
  rehypePlugins: se.arrayOf(se.oneOfType([se.object, se.func, se.arrayOf(se.oneOfType([se.bool, se.string, se.object, se.func, se.arrayOf(se.any)]))])),
  sourcePos: se.bool,
  rawSourcePos: se.bool,
  skipHtml: se.bool,
  includeElementIndex: se.bool,
  transformLinkUri: se.oneOfType([se.func, se.bool]),
  linkTarget: se.oneOfType([se.func, se.string]),
  transformImageUri: se.func,
  components: se.object
};
const xte = {
  withButton: {
    cardStyle: "p-10 ",
    iconWidthStyle: "h-20 w-20",
    iconStyle: "h-10 w-10",
    titleTextStyle: "h4",
    titleClasses: "mb-1 text-blue-800 text-hds-m-h4 tb:text-hds-t-h4 db:text-hds-d-h4",
    descTextStyle: "body1c",
    descClasses: "text-neutral-1000 text-hds-m-body1c tb:text-hds-t-body1c db:text-hds-d-body1c"
  },
  withoutButton: {
    cardStyle: "p-6",
    iconWidthStyle: "h-12 w-12",
    iconStyle: "h-6 w-6",
    titleTextStyle: "h5",
    titleClasses: "mb-1 text-blue-600 text-hds-m-h5 tb:text-hds-t-h5 db:text-hds-d-h5",
    descTextStyle: "body1",
    descClasses: "text-neutral-1000 text-hds-m-body1 tb:text-hds-t-body1 db:text-hds-d-body1"
  },
  sm: {
    cardStyle: "p-6",
    iconWidthStyle: "h-12 w-12",
    iconStyle: "h-6 w-6",
    titleTextStyle: "body1c-semi-bold",
    titleClasses: "mb-1 text-neutral-800 text-hds-m-body1c-semi-bold tb:text-hds-t-body1c-semi-bold db:text-hds-d-body1c-semi-bold",
    descTextStyle: "body3",
    descClasses: "text-neutral-800 text-hds-m-body3 tb:text-hds-t-body3 db:text-hds-d-body3"
  }
};
function Ote(e) {
  const r = A(e.iconBg);
  return t.createElement(t.Fragment, null, e.readMoreBtn && e.button || !e.readMoreBtn && !e.button || e.button && e.button.length > 1 || !e.linkHover ? t.createElement("div", {
    className: "bg-neutral-0 grid h-full transition-all ease-in-out rounded-3xl ".concat(xte[e.cardType].cardStyle, " ") + (e.cardBorder ? e.cardBorder : "tb:shadow")
  }, t.createElement("div", {
    className: " self-start"
  }, t.createElement("div", {
    className: "".concat(r, " ").concat(xte[e.cardType].iconWidthStyle, " w-12 h-12 flex items-center justify-center rounded-full mb-6")
  }, t.createElement(mz, {
    height: "stroke-[1.5px] ".concat(xte[e.cardType].iconStyle),
    variant: e.iconVariant,
    strokeColor: e.iconStroke,
    strokeClass: A(e.iconStrokeClass)
  })), t.createElement("div", {
    className: "flex-1"
  }, e.cardType && t.createElement(t.Fragment, null, t.createElement(ce, {
    textStyle: xte[e.cardType].titleTextStyle,
    className: xte[e.cardType].titleClasses
  }, e.title), t.createElement(ce, {
    textStyle: xte[e.cardType].descTextStyle,
    className: "".concat(xte[e.cardType].descClasses, " [&>p]:pb-2 last:[&>p]:pb-0 [&>ul]:ps-4 [&>ul>li]:list-disc [&>ul>li]:pb-2 last:[&>ul>li]:pb-0 [&>p>a]:text-blue-600")
  }, t.createElement(bte, null, e.description))))), e.readMoreBtn && t.createElement(t.Fragment, null, e.linkHover ? t.createElement("a", {
    href: e.readMoreBtn.cta_link,
    className: "flex self-end"
  }, t.createElement("div", {
    className: "flex"
  }, t.createElement(A8, {
    label: e.readMoreBtn.cta_text,
    type: "secondaryLink",
    leftIconVariant: "none",
    rightIconVariant: "none",
    state: "default",
    size: "sm",
    rightAnimatedArrow: !0,
    rightAnimatedArrowColor: "#3970FD",
    animatedHoverStroke: "#3970FD",
    btnTextColorClass: "text-blue-500",
    btnTextHoverClass: "",
    className: " mt-4"
  }))) : t.createElement("div", {
    className: "flex self-end"
  }, t.createElement(A8, {
    label: e.readMoreBtn.cta_text,
    type: "secondaryLink",
    leftIconVariant: "none",
    rightIconVariant: "none",
    state: "default",
    size: "sm",
    rightAnimatedArrow: !1,
    rightAnimatedArrowColor: "#3970FD",
    animatedHoverStroke: "#3970FD",
    btnTextColorClass: "text-neutral-800",
    btnTextHoverClass: "",
    className: " mt-4 hover:cursor-default"
  }))), e.button && t.createElement("div", {
    className: "flex gap-2 "
  }, e.button.map((e, r) => t.createElement("a", {
    href: e.cta_link,
    key: r,
    className: "flex self-end mt-7"
  }, t.createElement("div", {
    className: "flex"
  }, t.createElement(A8, {
    label: e.cta_text,
    type: e.cta_type || "secondary",
    leftIconVariant: "none",
    rightIconVariant: "none",
    state: "default",
    size: "sm",
    rightAnimatedArrow: !0,
    rightAnimatedArrowColor: e.rightAnimatedArrowColor || "#3970FD",
    btnBgColorClass: e.btnBg,
    btnTextHoverClass: e.btnTextColorClass,
    animatedHoverStroke: e.animatedHoverStroke,
    btnTextColorClass: e.btnTextColorClass
  })))))) : t.createElement("a", {
    href: e.readMoreBtn && !e.button ? e.readMoreBtn.cta_link : e.button[0].cta_link,
    className: "bg-neutral-0 group grid h-full duration-300 transition-all ease-in-out rounded-3xl ".concat(xte[e.cardType].cardStyle, " ") + (e.cardBorder ? e.cardBorder : "tb:shadow") + (e.readMoreBtn || e.button || e.linkHover ? " hover:shadow-lg hover:translate-y-0.5 " : "")
  }, t.createElement("div", {
    className: " self-start"
  }, t.createElement("div", {
    className: "".concat(r, " ").concat(xte[e.cardType].iconWidthStyle, " w-12 h-12 flex items-center justify-center rounded-full mb-6")
  }, t.createElement(mz, {
    height: "stroke-[1.5px] ".concat(xte[e.cardType].iconStyle),
    variant: e.iconVariant,
    strokeColor: e.iconStroke,
    strokeClass: A(e.iconStrokeClass)
  })), t.createElement("div", {
    className: "flex-1"
  }, e.cardType && t.createElement(t.Fragment, null, t.createElement(ce, {
    textStyle: xte[e.cardType].titleTextStyle,
    className: xte[e.cardType].titleClasses
  }, e.title), t.createElement(ce, {
    textStyle: xte[e.cardType].descTextStyle,
    className: "".concat(xte[e.cardType].descClasses, " [&>p]:pb-2 last:[&>p]:pb-0 [&>ul]:ps-4 [&>ul>li]:list-disc [&>ul>li]:pb-2 last:[&>ul>li]:pb-0 [&>p>a]:text-blue-600")
  }, t.createElement(bte, null, e.description))))), e.readMoreBtn && t.createElement("div", {
    className: "flex self-end"
  }, t.createElement(A8, {
    label: e.readMoreBtn.cta_text,
    type: "secondaryLink",
    leftIconVariant: "none",
    rightIconVariant: "none",
    state: "default",
    size: "sm",
    rightAnimatedArrow: !0,
    rightAnimatedArrowColor: "#3970FD",
    animatedHoverStroke: "#3970FD",
    btnTextColorClass: "text-blue-500",
    btnTextHoverClass: "",
    className: " mt-4"
  })), e.button && t.createElement("div", {
    className: "flex pt-4 gap-2 self-end"
  }, e.button.map((e, r) => t.createElement("div", {
    className: "flex"
  }, t.createElement(A8, {
    label: e.cta_text,
    type: e.cta_type || "secondary",
    leftIconVariant: "none",
    rightIconVariant: "none",
    state: "default",
    size: "sm",
    rightAnimatedArrow: !0,
    rightAnimatedArrowColor: e.rightAnimatedArrowColor || "#3970FD",
    btnBgColorClass: e.btnBg,
    btnTextHoverClass: e.btnTextColorClass,
    animatedHoverStroke: e.animatedHoverStroke,
    btnTextColorClass: e.btnTextColorClass
  }))))));
}
function Ete(e) {
  return t.createElement("a", {
    href: e.linkUrl,
    className: " bg-neutral-0 rounded-3xl mb-s:flex items-center shadow-sm"
  }, t.createElement("div", {
    className: "h-full w-full mb-s:max-w-[142px]"
  }, t.createElement("img", {
    className: " w-full rounded-t-3xl mb-s:rounded-tr-none mb-s:rounded-s-3xl h-full",
    src: e.imgUrl,
    alt: e.imgAlt
  })), t.createElement("div", {
    className: "p-4 mb-m:p-6"
  }, t.createElement(ce, {
    textStyle: "h5",
    as: "h5",
    className: "text-neutral-1000 pb-2"
  }, e.title), t.createElement(ce, {
    textStyle: "body3",
    className: " text-neutral-600"
  }, e.description)));
}
function jte(e) {
  return t.createElement(t.Fragment, null, t.createElement("div", null, t.createElement("a", {
    href: e.sliderLink
  }, t.createElement("div", {
    className: "".concat(A(e.cardBg), "bg-neutral-0 shadow hover:transition-all hover:ease-in-out hover:duration-300 hover:border-opacity-0 min-h-[443px]  min-w-[312px] tb:max-w-[763px] tb:min-h-[245px] rounded-3xl tb:p-8 p-4")
  }, t.createElement("div", {
    className: "flex flex-col-reverse tb:flex-row  justify-between gap-4 items-center"
  }, t.createElement("div", {
    className: "tb:max-w-[393px] mt-8 tb:mt-0"
  }, t.createElement(x8, {
    color: e.badge.color,
    children: e.badge.label,
    text_color: "text-neutral-0"
  }), t.createElement(ce, {
    textStyle: "h4",
    className: "mt-2 text-neutral-1000 max-w-[326px]"
  }, e.title), t.createElement(ce, {
    textStyle: "sub2",
    className: "mt-2 text-neutral-600"
  }, e.subTitle)), t.createElement("div", {
    className: "flex justify-center h-full items-center"
  }, t.createElement("img", {
    src: e.imageUrl,
    alt: e.title,
    className: "tb:max-w-[290px] rounded-lg flex items-center justify-center tb:max-h-[181px]"
  })))))));
}
Ote.defaultProps = {
  cardType: "withoutButton",
  iconStrokeClass: "stroke-neutral-1000",
  linkHover: "true"
}, mz.propTypes = {
  cardType: se.oneOf(["withoutButton", "withButton", "sm"])
};
const Cte = {
  withButton: {
    cardStyle: "p-10 ",
    iconWidthStyle: "h-20 w-20",
    iconStyle: "h-10 w-10",
    titleTextStyle: "h4",
    titleClasses: "mb-1 text-hds-m-h4 tb:text-hds-t-h4 db:text-hds-d-h4",
    descTextStyle: "body1c",
    descClasses: "text-hds-m-body1c tb:text-hds-t-body1c db:text-hds-d-body1c"
  },
  withoutButton: {
    cardStyle: "p-6",
    iconWidthStyle: "h-12 w-12",
    iconStyle: "h-6 w-6",
    titleTextStyle: "h5",
    titleClasses: "mb-1 text-blue-600 text-hds-m-h5 tb:text-hds-t-h5 db:text-hds-d-h5",
    descTextStyle: "body1",
    descClasses: "text-neutral-1000 text-hds-m-body1 tb:text-hds-t-body1 db:text-hds-d-body1"
  },
  sm: {
    cardStyle: "p-6",
    iconWidthStyle: "h-12 w-12",
    iconStyle: "h-6 w-6",
    titleTextStyle: "body3c",
    titleClasses: "mb-1 text-neutral-800 text-hds-m-body3c-bold tb:text-hds-t-body3c-bold db:text-hds-d-body3c-bold",
    descTextStyle: "body3",
    descClasses: "text-neutral-800 text-hds-m-body3 tb:text-hds-t-body3 db:text-hds-d-body3"
  }
};
function Pte(e) {
  const r = e.iconBg ? A(e.iconBg) : "",
    n = e.titleColorClass ? A(e.titleColorClass) : "text-neutral-1000",
    a = e.descColorClass ? A(e.descColorClass) : "text-neutral-800";
  return t.createElement(t.Fragment, null, t.createElement("div", null, e.imgUrl ? t.createElement("div", {
    className: "".concat(Cte[e.cardType].iconWidthStyle, " w-12 h-12 inline-flex items-center justify-center rounded-full mb-6")
  }, t.createElement("img", {
    className: "w-full",
    src: e.imgUrl,
    alt: e.title
  })) : t.createElement("div", {
    className: "".concat(r, " ").concat(Cte[e.cardType].iconWidthStyle, " w-12 h-12 flex items-center justify-center rounded-full mb-6")
  }, t.createElement(mz, {
    height: "stroke-[1.5px] ".concat(Cte[e.cardType].iconStyle),
    variant: e.iconVariant,
    strokeColor: e.iconStroke,
    strokeClass: A(e.iconStrokeClass)
  })), e.cardType && t.createElement(t.Fragment, null, t.createElement(ce, {
    textStyle: Cte[e.cardType].titleTextStyle,
    className: "".concat(Cte[e.cardType].titleClasses, " ").concat(n)
  }, e.title), t.createElement(ce, {
    textStyle: Cte[e.cardType].descTextStyle,
    className: "".concat(Cte[e.cardType].descClasses, " ").concat(a, " [&>p]:").concat(a, " [&>p]:pb-2 last:[&>p]:pb-0 [&>ul]:ps-4 [&>ul>li]:list-disc [&>ul>li]:pb-2 last:[&>ul>li]:pb-0 [&>p>a]:text-blue-600")
  }, t.createElement(bte, null, e.description)))), e.button && t.createElement("div", {
    className: "inline-flex pt-6"
  }, t.createElement(A8, {
    label: e.button.cta_text,
    type: e.button.cta_type || "secondary",
    leftIconVariant: "none",
    rightIconVariant: "none",
    state: "default",
    size: "sm",
    rightAnimatedArrow: !0,
    rightAnimatedArrowColor: e.button.rightAnimatedArrowColor || "#3970FD",
    btnBgColorClass: e.button.btnBg,
    btnTextHoverClass: e.button.btnTextColorClass,
    animatedHoverStroke: e.button.animatedHoverStroke,
    btnTextColorClass: e.button.btnTextColorClass
  })));
}
function Mte(e) {
  return t.createElement(t.Fragment, null, t.createElement(t.Fragment, null, t.createElement("div", {
    className: "pt-10 db:pt-20"
  }, t.createElement(ce, {
    textStyle: "h6",
    as: "h6",
    className: "pb-6 db:pb-10 text-center text-neutral-400 uppercase"
  }, "40+ of the fortune100 companies use hasura"), t.createElement("div", {
    className: "gridAutoClass"
  }, e.imgArray.map((e, r) => t.createElement("div", {
    key: r,
    className: "border"
  }, t.createElement("img", {
    src: e.imgSrc,
    alt: e.imgAlt
  })))))));
}
function kte(e) {
  const {
      split: r
    } = e,
    n = (e, n) => t.createElement("div", {
      className: " group h-full"
    }, t.createElement("div", {
      className: "w-full  h-full " + (r ? " " : " rounded-2xl")
    }, t.createElement("div", {
      className: "w-full p-6"
    }, e ? t.createElement(ce, {
      textStyle: "h6",
      className: " uppercase group-hover/split:text-neutral-1000 group-hover:text-neutral-1000 group-hover-transition text-neutral-500 mb-4"
    }, e) : t.createElement("div", {
      className: "mb-8"
    }), t.createElement("div", {
      className: " tb:tb:grid tb:tb:grid-cols-1  tb:min-w-[140px] "
    }, n && n.map(e => t.createElement("div", {
      key: e.name,
      className: "relative pb-2 flex rounded-lg items-center"
    }, t.createElement("a", {
      href: e.href,
      className: "w-full",
      "aria-label": e.name
    }, t.createElement("div", {
      className: "flex group/icon pl-2 py-2 pr-3 hover:pl-[9px] hover:bg-neutral-100  rounded-lg flex-row w-full justify-between tb:min-w-[140px] items-center"
    }, t.createElement("div", {
      className: "flex gap-2 flex-row items-center"
    }, t.createElement("div", {
      className: "flex rounded-lg items-center group-hover:bg-white"
    }, e.icon && t.createElement(mz, {
      height: "h-5 w-5 stroke-2 ",
      variant: e.icon,
      strokeClass: e.strokeClass
    })), t.createElement(ce, {
      textStyle: "body3c-medium",
      className: "text-neutral-1000  group-hover/icon:text-blue-600 hover:transition-all hover:duration-300 hover:ease-in-out whitespace-nowrap overflow-clip"
    }, e.name)), t.createElement("div", {
      className: "flex group-hover/icon:translate-x-1 transform transition-all duration-200 ease-in-out tb-l:-ml-1"
    }, t.createElement(mz, {
      height: "h-4 w-4 stroke-2 invisible group-hover/icon:visible transition-all ease-in-out   ",
      variant: "chevronright",
      strokeClass: "stroke-blue-500"
    }))))))))));
  return t.createElement(t.Fragment, null, r ? t.createElement(t.Fragment, null, t.createElement("div", {
    className: "hds-hidden tb-l:flex h-full"
  }, t.createElement("div", {
    className: "rounded-l-2xl"
  }, n(e.label, e.childArray.slice(0, Math.ceil(e.childArray.length / 2)))), t.createElement("div", {
    className: "group/split rounded-r-2xl tb-l:-ml-6"
  }, n(null, e.childArray.slice(Math.ceil(e.childArray.length / 2))))), t.createElement("div", {
    className: "hds-hidden-tbl  h-full rounded-2xl"
  }, n(e.label, e.childArray))) : t.createElement("div", {
    className: " shadow h-full rounded-2xl"
  }, n(e.label, e.childArray)));
}
function Ste(e) {
  const {
      split: r
    } = e,
    n = (e, n) => t.createElement("div", {
      className: " group h-full"
    }, t.createElement("div", {
      className: "w-full  h-full " + (r ? " " : " rounded-2xl")
    }, t.createElement("div", {
      className: "w-full py-6 px-4"
    }, e ? t.createElement(ce, {
      textStyle: "h6",
      className: " uppercase group-hover/split:text-neutral-1000 group-hover:text-neutral-1000 group-hover-transition text-neutral-500 mb-4"
    }, e) : t.createElement("div", {
      className: "mb-8"
    }), t.createElement("div", {
      className: " tb:tb:grid tb:tb:grid-cols-1  tb:min-w-[200px] "
    }, n && n.map(e => t.createElement("div", {
      key: e.name,
      className: "relative pb-2 flex rounded-lg items-center"
    }, t.createElement("a", {
      href: e.href,
      className: "w-full"
    }, t.createElement("div", {
      className: "flex group/icon pl-2 py-2 pr-3 hover:pl-[9px] hover:bg-neutral-100  rounded-lg flex-row w-full justify-between items-center"
    }, t.createElement("div", {
      className: "flex gap-2 flex-row items-center"
    }, t.createElement("div", {
      className: "flex rounded-lg items-center group-hover:bg-white"
    }, e.icon && t.createElement(mz, {
      height: "h-5 w-5 stroke-2 ",
      variant: e.icon,
      strokeClass: e.strokeClass
    })), t.createElement(ce, {
      textStyle: "body3c-medium",
      className: "text-neutral-1000  group-hover/icon:text-blue-600 hover:transition-all hover:duration-300 hover:ease-in-out whitespace-nowrap overflow-clip"
    }, e.name)), t.createElement("div", {
      className: "flex group-hover/icon:translate-x-1 transform transition-all duration-200 ease-in-out tb-l:-ml-1"
    }, t.createElement(mz, {
      height: "h-4 w-4 stroke-2 invisible group-hover/icon:visible transition-all ease-in-out   ",
      variant: "chevronright",
      strokeClass: "stroke-blue-500"
    }))))))))));
  return t.createElement(t.Fragment, null, r ? t.createElement(t.Fragment, null, t.createElement("div", {
    className: "hds-hidden tb-l:flex h-full"
  }, t.createElement("div", {
    className: "rounded-l-2xl"
  }, n(e.label, e.childArray.slice(0, Math.ceil(e.childArray.length / 2)))), t.createElement("div", {
    className: "group/split rounded-r-2xl tb-l:-ml-6"
  }, n(null, e.childArray.slice(Math.ceil(e.childArray.length / 2))))), t.createElement("div", {
    className: "hds-hidden-tbl  h-full rounded-2xl"
  }, n(e.label, e.childArray))) : t.createElement("div", {
    className: " shadow h-full rounded-2xl"
  }, n(e.label, e.childArray)));
}
function Nte(e) {
  return t.createElement("div", null, t.createElement("div", {
    className: "tb-l:flex mb-2 tb-l:mb-0 flex w-full tb-l:bg-neutral-150 flex-col tb-l:flex-row max-w-7xl tb-l:gap-2 rounded-2xl "
  }, e.primaryCard && t.createElement("div", {
    className: ""
  }, t.createElement("div", {
    className: "bg-neutral-0 rounded-2xl h-full w-full " + (e.primaryCard.cardDetailsArray ? "tb-l:min-w-[250px]" : " min-w-[250px]")
  }, t.createElement(Z8, e.primaryCard))), t.createElement("div", {
    className: "tb-l:flex-row tb-l:flex mt-2 flex flex-col gap-2 tb-l:mt-0"
  }, e.secondaryCardArr && e.secondaryCardArr.map((e, r) => t.createElement("div", {
    key: r,
    className: (e.card_bg, "bg-neutral-0 rounded-2xl shadow")
  }, "CONNECTORS" === e.label ? t.createElement(kte, {
    label: e.label,
    childArray: e.childArray,
    split: !0
  }) : "RESOURCES" === (e === null || e === void 0 ? void 0 : e.label) ? t.createElement(Ste, {
    label: e.label,
    childArray: e.childArray,
    split: !0
  }) : t.createElement(_8, {
    label: e.label,
    childArray: e.childArray,
    split: e.split
  })))), e.flyoutD && t.createElement(q8, e === null || e === void 0 ? void 0 : e.flyoutD)));
}
function Bte(e) {
  let r = "";
  return e.logoBg && (r = A(e.logoBg)), t.createElement("a", {
    href: e.caseStudyUrl,
    className: "group bg-neutral-0 rounded-3xl shadow p-6 tb-l:p-10 grid mb-6 db-s:mb-0 last:mb-0 flex-1 max-w-[920px] mx-auto flex-col transition-all duration-300 ease-in-out hover:shadow-lg hover:translate-y-0.5"
  }, t.createElement("div", {
    className: " self-start"
  }, t.createElement(g8, {
    name: e.speakerName,
    size: "xl",
    designation: e.speakerDesignation,
    imageUrl: e.speakerImgUrl,
    avatarVariant: "circle",
    avatarType: "secondary"
  }), t.createElement("div", {
    className: e.dividerClass ? "py-8" : "py-6"
  }, t.createElement(ce, {
    textStyle: "sub2",
    className: "text-neutral-600"
  }, e.description))), t.createElement("div", {
    className: " self-end"
  }, e.dividerClass && t.createElement("div", {
    className: "".concat(A(e.dividerClass), " mb-2")
  }), t.createElement("div", {
    className: "mb-s:flex items-start" + (e.dividerClass ? " pt-6" : "mt-0")
  }, t.createElement("div", {
    className: "border border-neutral-150 p-2 flex items-center justify-center rounded-2xl " + r + (e.dividerClass ? " w-[72px] h-[56px] min-w-[72px]" : " w-[112px] h-[90px] min-w-[112px] ")
  }, t.createElement("img", {
    className: "max-h-[20px]",
    src: e.brandImgUrl,
    alt: e.brandImgAlt
  })), t.createElement("div", {
    className: "pt-4 mb-s:pt-0 " + (e.dividerClass ? "mb-s:pl-6" : "mb-s:pl-8")
  }, t.createElement(ce, {
    textStyle: e.dividerClass ? "body2" : "body1",
    className: "text-neutral-600 pb-1"
  }, e.blurb), t.createElement("div", {
    className: "flex"
  }, t.createElement(A8, {
    label: e.ctaText,
    type: "secondaryLink",
    leftIconVariant: "none",
    rightIconVariant: "none",
    state: "default",
    size: "md",
    rightAnimatedArrow: !0,
    rightAnimatedArrowColor: "#3970FD",
    className: "mt-0 justify-start",
    btnTextColorClass: "text-blue-500",
    btnTextHoverClass: "hover:text-blue-500",
    animatedHoverStroke: "group-hover:stroke-blue-500"
  }))))));
}
function Vte(e) {
  return t.createElement(t.Fragment, null, t.createElement("a", {
    href: e.linkUrl,
    className: "rounded-2xl p-6 h-full flex flex-col justify-between"
  }, e.brandImageUrl ? t.createElement("div", {
    className: "flex flex-col"
  }, e.iconArrowVariant && t.createElement("div", {
    className: "flex justify-end items-end"
  }, t.createElement(mz, {
    height: "w-6 h-6 stroke-[1.5px] stroke-blue-400",
    variant: e.iconArrowVariant,
    strokeColor: e.iconArrowStrokeColor,
    strokeClass: A(e.iconArrowStrokeClass)
  })), t.createElement("img", {
    src: e.brandImageUrl,
    alt: e.brandImageAlt
  })) : t.createElement(t.Fragment, null, t.createElement("div", {
    className: "flex items-center"
  }, t.createElement("div", {
    className: "flex items-center flex-1 pb-2"
  }, e.iconVariant && t.createElement(mz, {
    height: "w-6 h-6 mr-2 stroke-[1.5px] ",
    variant: e.iconVariant,
    strokeColor: e.iconStrokeColor,
    strokeClass: A(e.iconStrokeClass)
  }), t.createElement(ce, {
    as: "h5",
    textStyle: "body1c-bold",
    className: A(e.titleTextColor)
  }, e.title)), e.iconArrowVariant && t.createElement(mz, {
    height: "w-6 h-6 stroke-[1.5px] stroke-blue-400",
    variant: e.iconArrowVariant,
    strokeColor: e.iconArrowStrokeColor,
    strokeClass: A(e.iconArrowStrokeClass)
  })), e.description && t.createElement("div", null, t.createElement(ce, {
    textStyle: "body3",
    className: "".concat(A(e.descTextColor), " mt-2")
  }, e.description)))));
}
function Rte(e) {
  return A(e.iconBg), t.createElement(t.Fragment, null, t.createElement("div", {
    className: "p-8 ".concat(e.cardBg, " min-w-[18rem] rounded-3xl")
  }, e.title && t.createElement(ce, {
    textStyle: "h6",
    className: "uppercase ".concat(e.title_text_color)
  }, e.title), t.createElement("div", {
    className: "mt-6"
  }, e.resourcesArr.map((e, r) => t.createElement("a", {
    key: r,
    href: e.cta_linkUrl,
    className: "flex gap-2 mt-4"
  }, t.createElement(mz, {
    height: "w-6 h-6 mr-2 stroke-[1.5px] stroke-blue-600",
    variant: e.cta_icon,
    strokeClass: e.cta_stroke
  }), t.createElement(ce, {
    textStyle: "body2c",
    className: e.cta_text_color
  }, e.cta_text))))));
}
function Ate(e) {
  const n = "undefined" != typeof window;
  A(e.badgeLeftIconColor);
  const [o, i] = r(!1);
  return a(() => {
    if (n && "localStorage" in window && window.localStorage && "getItem" in window.localStorage) {
      window.localStorage.getItem("hasCon2023TalkVideoConsent") && i(!0);
    }
  }, []), t.createElement("div", {
    className: "grid grid-cols-1 tb-m:grid-cols-2 gap-6 db:gap-28 tb-m:gap-16"
  }, t.createElement("div", {
    className: "tb-m:sticky tb-m:self-start tb-m:top-36"
  }, t.createElement("div", {
    className: "flex flex-row flex-wrap tb:gap-3 gap-2"
  }, e.badges && e.badges.map((e, r) => t.createElement("div", {
    key: r,
    className: "flex  whitespace-nowrap"
  }, t.createElement(x8, {
    size: e.size,
    color: e.color,
    leftIconVariant: e.leftIconVariant,
    leftIconColor: e.leftIconColor,
    leftIconColorClass: A(e.leftIconColorClass),
    children: e.label
  })))), e.tag_line && t.createElement(ce, {
    textStyle: "h6",
    className: "text-blue-600 uppercase pt-4 pb-2"
  }, e.tag_line), e.title && t.createElement(ce, {
    textStyle: "h3",
    as: "h3",
    className: "text-blue-900 pb-6 db:pb-0"
  }, e.title), e.social_share && t.createElement("div", {
    className: "flex pb-6 tb:pt-0 tb:pb-0 items-center "
  }, e.social_share.map((e, r) => t.createElement("a", {
    key: r,
    href: e.share_url,
    className: "mx-2 first:ml-0 last:mr-0"
  }, t.createElement("img", {
    src: e.img_url,
    alt: e.img_alt
  })))), e.speaker_card && t.createElement("div", {
    className: "border-t border-neutral-200 border-b pb-6 tb:border-0 tb:pb-0"
  }, t.createElement(ce, {
    textStyle: "h6",
    as: "h6",
    className: "uppercase   text-neutral-500 pb-6 pt-6 tb:pt-14"
  }, "speakers"), e.speaker_card.map((r, n) => t.createElement("div", {
    key: n,
    className: "pb-4 last:pb-0"
  }, t.createElement(g8, {
    name: r.name,
    size: "md",
    designation: r.designation,
    imageUrl: r.imageUrl,
    avatarVariant: "circle",
    avatarBgColor: e.avatarBgColor
  }))))), t.createElement("div", null, e.videoUrl && t.createElement("div", {
    className: "pb-6"
  }, o ? t.createElement(t.Fragment, null, t.createElement("div", {
    className: "relative pb-[56.2%]"
  }, t.createElement("iframe", {
    loading: "lazy",
    title: e.title,
    src: e.videoUrl,
    frameBorder: "0",
    allowFullScreen: !0,
    className: "absolute w-full h-full"
  }))) : t.createElement("div", {
    className: "p-5 md:pt-10 md:px-6 lg:px-9 rounded-3xl border border-neutral-200"
  }, t.createElement(ce, {
    textStyle: "h6",
    as: "h6",
    className: "text-neutral-800 uppercase flex items-center"
  }, t.createElement(mz, {
    height: "w-6 h-6 mr-3 stroke-neutral-800 stroke-[1.5px]",
    variant: "ticket01",
    strokeColor: "#1F2A37"
  }), e.formTitle), t.createElement(n8, {
    onSubmitCB: () => {
      n && window.localStorage.setItem("hasCon2023TalkVideoConsent", "true");
    },
    formId: e.paperformId,
    styleClass: "paper-form-wrapper"
  }))), t.createElement(ce, {
    textStyle: "h4",
    as: "h4",
    className: "text-neutral-800 pb-4"
  }, "About the Talk"), e.description && t.createElement(ce, {
    className: "text-neutral-800 [&>p]:pb-2 last:[&>p]:pb-0 [&>ul]:ps-4 [&>ul>li]:list-disc [&>ul>li]:pb-2 last:[&>ul>li]:pb-0",
    textStyle: "body1"
  }, t.createElement(bte, null, e.description))));
}
Pte.defaultProps = {
  cardType: "withoutButton",
  iconStrokeClass: "stroke-neutral-1000",
  iconVariant: "cube01"
}, Pte.propTypes = {
  cardType: se.oneOf(["withoutButton", "withButton", "sm"])
}, Mte.defaultProps = {
  rotate: "false",
  imgArray: [{
    imgSrc: "https://res.cloudinary.com/dh8fp23nd/image/upload/v1682487186/hasura-con-2023/costco_eb2lmu.png",
    imgAlt: ""
  }, {
    imgSrc: "https://res.cloudinary.com/dh8fp23nd/image/upload/v1682487186/hasura-con-2023/verizon_sj4rgc.png",
    imgAlt: ""
  }, {
    imgSrc: "https://res.cloudinary.com/dh8fp23nd/image/upload/v1682487186/hasura-con-2023/costco_eb2lmu.png",
    imgAlt: ""
  }, {
    imgSrc: "https://res.cloudinary.com/dh8fp23nd/image/upload/v1682487186/hasura-con-2023/costco_eb2lmu.png",
    imgAlt: ""
  }]
}, Nte.defaultProps = {
  secondaryCardArr: [{
    childArray: [{
      description: "",
      href: "#",
      icon: "cube01",
      name: "Analytics"
    }, {
      description: "",
      href: "#",
      icon: "cube01",
      name: "Engagement"
    }, {
      description: "",
      href: "#",
      icon: "cube01",
      name: "Security"
    }, {
      description: "",
      href: "#",
      icon: "cube01",
      name: "Security"
    }, {
      description: "",
      href: "#",
      icon: "cube01",
      name: "Security"
    }],
    label: "Label1"
  }]
}, Bte.defaultProps = {
  ctaText: "Read the case study"
}, Vte.defaultProps = {
  descTextColor: "",
  titleTextColor: "",
  brandImageUrl: "",
  brandImageAlt: "",
  linkUrl: "#",
  iconVariant: "videorecorder",
  iconStrokeColor: "blue-500",
  iconArrowVariant: "arrownarrowupright",
  iconArrowStrokeColor: "blue-400",
  title: "Webinar",
  description: "Model Level Authorization System for GraphQL with Hasura"
}, Rte.defaultProps = {
  cardBg: "bg-neutral-0",
  title: "Resources Card",
  title_text_color: "text-blue-600",
  resourcesArr: [{
    cta_text: "This is one really long link that may spill onto the next line",
    cta_icon: "linkexternal01",
    cta_text_color: "text-neutral-700 hover:text-blue-600 ",
    cta_stroke: "stroke-blue-600",
    cta_linkUrl: "#"
  }, {
    cta_text: "This is a regular link that fits in one line",
    cta_text_color: "text-neutral-700",
    cta_icon: "linkexternal01",
    cta_stroke: "stroke-blue-600",
    cta_linkUrl: "#"
  }, {
    cta_text: "text3",
    cta_text_color: "text-neutral-700",
    cta_icon: "linkexternal01",
    cta_stroke: "stroke-blue-600",
    cta_linkUrl: "#"
  }, {
    cta_text: "text4",
    cta_text_color: "text-neutral-700",
    cta_icon: "linkexternal01",
    cta_stroke: "stroke-blue-600",
    cta_linkUrl: "#"
  }]
}, Ate.defaultProps = {};
const Tte = () => t.createElement("svg", {
  width: "26",
  height: "32",
  viewBox: "0 0 26 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, t.createElement("path", {
  d: "M8.67602 24.7482C16.8006 24.7482 21.2437 18.0172 21.2437 12.1806C21.2437 11.9893 21.2398 11.7991 21.2309 11.6096C22.0934 10.9861 22.8431 10.208 23.4345 9.32253C22.6431 9.67415 21.7914 9.91094 20.8979 10.0177C21.8098 9.47092 22.5101 8.60557 22.8404 7.5742C21.9868 8.08033 21.0417 8.44812 20.0358 8.64646C19.2294 7.78796 18.0815 7.25098 16.8114 7.25098C14.3718 7.25098 12.3935 9.22924 12.3935 11.6676C12.3935 12.0143 12.4325 12.3513 12.5079 12.6747C8.83714 12.4903 5.58191 10.7325 3.4036 8.06001C3.02381 8.71257 2.80515 9.47116 2.80515 10.2799C2.80515 11.8123 3.58504 13.1652 4.77092 13.9568C4.04637 13.9345 3.36564 13.7352 2.77038 13.4042C2.7694 13.4225 2.7694 13.4411 2.7694 13.4605C2.7694 15.5999 4.29221 17.3859 6.31308 17.7907C5.94211 17.8918 5.55179 17.9462 5.14875 17.9462C4.86421 17.9462 4.58752 17.9178 4.31841 17.8666C4.88062 19.6213 6.51142 20.8985 8.44486 20.9345C6.93283 22.1194 5.02827 22.8253 2.95892 22.8253C2.60265 22.8253 2.25102 22.805 1.90527 22.7641C3.86002 24.0168 6.18109 24.7482 8.67602 24.7482Z",
  fill: "#00acee"
}));
function Hte(e) {
  return t.createElement("a", {
    href: e.linkUrl
  }, t.createElement("div", {
    className: "p-5 tb:p-8 bg-neutral-0 shadow-sm rounded-3xl mx-5"
  }, t.createElement(Tte, null), t.createElement(ce, {
    textStyle: "h5",
    as: "h5",
    className: "text-neutral-1000 py-4"
  }, e.name), t.createElement(ce, {
    textStyle: "body1",
    className: "text-neutral-500"
  }, e.tweets)));
}
function Lte(e) {
  const [n, a] = r(!1),
    o = e => {
      var _e$avatarBgColor;
      return e = e.card, t.createElement(t.Fragment, null, t.createElement("div", {
        className: " backdrop-blur-lg bg-neutral-1000 bg-opacity-20  rounded-[6px] w-[220px] h-[428px] flex flex-col justify-between "
      }, t.createElement("div", {
        className: "h-[428px]"
      }, t.createElement("div", {
        className: " pt-8 pl-6"
      }, t.createElement("img", {
        src: e.title_img,
        alt: "Card",
        className: " inline-block w-16 "
      })), e.subtitle && t.createElement("div", {
        className: "mt-6 px-6 font-petrona text-base font-normal text-neutral-0 "
      }, e.subtitle)), t.createElement("div", {
        className: "pl-6 pb-8"
      }, e.avatar.img_url && t.createElement("img", {
        className: " w-14 h-14 shadow rounded-full ".concat((_e$avatarBgColor = e.avatarBgColor) !== null && _e$avatarBgColor !== void 0 ? _e$avatarBgColor : "bg-neutral-0", " rounded inline-block"),
        alt: "avatar",
        src: e.avatar.img_url
      }), t.createElement("div", {
        className: " pt-3"
      }, e.avatar && e.avatar.name && t.createElement(ce, {
        textStyle: "body2c-bold",
        className: " text-neutral-0"
      }, e.avatar.name), e.avatar && e.avatar.designation && t.createElement(ce, {
        textStyle: "body3c",
        className: " text-neutral-0 mt-1"
      }, e.avatar.designation)))));
    },
    i = e => {
      var _e2;
      return e = e.cardHover, t.createElement("div", {
        className: "h-[428px]"
      }, t.createElement("div", {
        className: "".concat(A(e.cardBg), " rounded-[6px] w-[220px] justify-between h-[428px] flex flex-col")
      }, t.createElement("div", {
        className: " "
      }, t.createElement("div", {
        className: "pt-8 pl-6 "
      }, t.createElement("img", {
        src: e.img_url,
        alt: "Card",
        className: " inline-block max-w-[148px]"
      })), t.createElement("div", {
        className: "mt-6 px-6 text-xl leading-[27px] font-semibold text-neutral-0"
      }, e.title)), t.createElement("div", {
        className: "flex pb-8 pl-6 pt-5"
      }, t.createElement("a", {
        href: ((_e2 = e) === null || _e2 === void 0 ? void 0 : _e2.slideCTA) || ""
      }, t.createElement(A8, {
        className: "flex",
        label: e.button.cta_text,
        type: "secondaryLink",
        btnTextHoverClass: "hover:text-neutral-0",
        btnTextColorClass: "text-neutral-0"
      })))));
    };
  return t.createElement("div", {
    className: "  w-[220px] h-[428px] rounded-2xl",
    onMouseEnter: () => {
      a(!0);
    },
    onMouseLeave: () => {
      a(!1);
    }
  }, t.createElement("div", {
    className: "transition-all max-w-[220px] absolute left-0 top-0 ease-in-out rounded-[6px]  duration-300 " + (n ? "opacity-0 " : "opacity-100")
  }, t.createElement(o, {
    card: e.card
  })), t.createElement("div", {
    className: "transition-al absolute left-0 top-0 ease-in-out rounded-[6px] duration-300 " + (n ? "opacity-100" : "opacity-0")
  }, t.createElement(i, {
    cardHover: e.cardHover
  })));
}
function Ite(e) {
  return t.createElement(t.Fragment, null, t.createElement("div", {
    className: "relative overflow-hidden"
  }, t.createElement("div", {
    className: "absolute z-50 right-[4px] rounded-[6px] hidden min-[699px]:block  w-[220px] h-[428px] top-[4px] bg-neutral-0/40"
  }, t.createElement(Lte, {
    card: e.testimonial.card,
    cardHover: e.testimonial.cardHover
  })), t.createElement("div", {
    className: " relative hidden w-[580px] h-[436px] rounded-2xl min-[699px]:flex justify-center items-center"
  }, t.createElement("div", {
    className: "w-[580px] h-[436px] rounded-lg flex flex-col items-center justify-center overflow-hidden"
  }, t.createElement("div", {
    className: ""
  }, t.createElement("div", {
    className: ""
  }, t.createElement("video", {
    autoPlay: !0,
    loop: !0,
    muted: !0,
    className: " object-fill  max-w-full max-h-full scale-150",
    src: e.video_url
  }), t.createElement("div", {
    className: "w-full relative z-50 flex-col flex items-center"
  }, t.createElement("div", {
    className: "relative top-[55px] left-[0px] w-[147px] h-[3px] bg-neutral-0/20"
  })))))), t.createElement("div", {
    className: "overflow-x-hidden w-screen  min-[699px]:hidden"
  }, t.createElement("div", {
    className: "max-[375]:h-[684px] h-[600px] rounded flex flex-col items-center justify-cente overflow-hidden"
  }, t.createElement("div", {
    className: ""
  }, t.createElement("div", {
    className: ""
  }, t.createElement("div", {
    className: "h-[348px]"
  }, t.createElement("video", {
    autoPlay: !0,
    loop: !0,
    muted: !0,
    className: " object-fill  max-w-full max-h-full min-[699px]:scale-[1.7]",
    src: e.video_url
  })), t.createElement("div", {
    className: "absolute max-[365px]:h-[657px] h-[600px] z-50 top-[72px] px-4"
  }, t.createElement("div", {
    className: ""
  }, t.createElement(Bte, {
    brandImgUrl: e.testimonial.card.title_img,
    brandImgAlt: e.testimonial.card.avatar.name,
    description: e.testimonial.card.subtitle,
    speakerName: e.testimonial.card.avatar.name,
    speakerDesignation: e.testimonial.card.avatar.designation,
    speakerImgUrl: e.testimonial.card.avatar.img_url,
    blurb: e.testimonial.cardHover.title,
    dividerClass: "border-b border-neutral-150",
    caseStudyUrl: e.testimonial.cardHover.button.cta_text
  })))))))));
}
function Fte(e) {
  var _e$iconArrowVariant, _e$readMoreBtn$cta_te;
  return t.createElement(t.Fragment, null, t.createElement("a", {
    href: e.linkUrl,
    target: e.isExternalLink ? "_blank" : "",
    rel: e.isExternalLink ? "noopener noreferrer" : "",
    className: "rounded-2xl hover:shadow-xl p-8 h-full flex flex-col justify-between group/sc border border-neutral-200 hover:border-opacity-0 min-h-[260px] group"
  }, t.createElement(t.Fragment, null, t.createElement("div", {
    className: "flex items-center justify-between pb-5"
  }, e.brandImageUrl && e.brandImageAlt && t.createElement("div", {
    className: "max-h-[64px]"
  }, t.createElement("img", {
    src: e.brandImageUrl,
    alt: e.brandImageAlt,
    loading: "lazy",
    className: "max-h-[44px]  transition ease-in-out duration-300"
  })), e.iconVariant && t.createElement("div", {
    className: "hidden tb:flex flex-row relative  "
  }, e.iconTag && t.createElement("div", {
    className: "gap-2 items-center transition-all duration-[350ms] group-hover/sc:opacity-100 inline-flex flex-row  translate-x-0 group-hover/sc:-translate-x-5"
  }, t.createElement(mz, {
    height: "w-6 h-6 stroke-[1.5px]",
    variant: (_e$iconArrowVariant = e.iconArrowVariant) !== null && _e$iconArrowVariant !== void 0 ? _e$iconArrowVariant : "",
    strokeClass: "stroke-neutral-400"
  }), t.createElement("div", {
    className: " opacity-0 group-hover/sc:opacity-100 transition-opacity duration-[350ms] "
  }, t.createElement(ce, {
    textStyle: "body3-medium",
    className: "hidden text-neutral-400 group-hover/sc:block"
  }, e.iconTag))))), e.description && t.createElement("div", null, t.createElement("div", {
    className: "translate-y-10 group-hover/sc:translate-y-0 duration-300 transition-all"
  }, t.createElement(ce, {
    textStyle: "body1c",
    className: "".concat(A(e.descTextColor), " mt-2")
  }, e.description)), t.createElement("div", {
    className: "translate-y-8 transition-all group-hover/sc:translate-y-0 opacity-0 group-hover/sc:opacity-100 duration-300 group-hover/sc:flex"
  }, t.createElement("div", {
    className: "flex"
  }, t.createElement(A8, {
    label: (_e$readMoreBtn$cta_te = e.readMoreBtn.cta_text) !== null && _e$readMoreBtn$cta_te !== void 0 ? _e$readMoreBtn$cta_te : "Read More",
    type: "secondaryLink",
    leftIconVariant: "none",
    rightIconVariant: "none",
    state: "default",
    size: "sm",
    rightAnimatedArrow: !0,
    rightAnimatedArrowColor: "#3970FD",
    animatedHoverStroke: "#3970FD",
    btnTextColorClass: "text-blue-500",
    btnTextHoverClass: "",
    className: " mt-[14px]"
  })))))));
}
function _te(e) {
  return t.createElement(t.Fragment, null, t.createElement("div", {
    className: "flex flex-col-reverse px-6 py-10 tb-l:px-0 tb-l:py-0 tb-l:flex-row tb-l:gap-10 db:gap-32 tb-l:max-w-7xl min-h-[742px] tb-l:min-h-[518px]"
  }, t.createElement("div", {
    className: "flex flex-col tb-l:pl-20 tb-l:pt-14 tb-l:pb-14"
  }, e.tagline && t.createElement(ce, {
    textStyle: "h6",
    className: "text-blue-400 tb-l:block uppercase mb-2 hidden "
  }, e.tagline), e.brandImageURL && e.brandImageAlt && t.createElement("div", {
    className: "tb-l:flex hidden -ml-2 pb-1 justify-start"
  }, t.createElement("img", {
    src: e.brandImageURL,
    alt: e.brandImageAlt,
    className: "max-h-[64px]"
  })), e.title && t.createElement("div", {
    className: "flex flex-col gap-6 tb-l:max-w-[547px] "
  }, t.createElement(ce, {
    textStyle: "h3",
    className: "text-neutral-1000 tb-l:block hidden min-h-[144px] overflow-clip"
  }, e.title), e.heroList && t.createElement("div", null, t.createElement("div", {
    className: "flex flex-col pt-6 tb-l:pt-0 gap-4"
  }, e.heroList.map((e, r) => {
    var _e$strokeClass;
    return t.createElement("div", {
      key: r,
      className: "flex gap-5"
    }, t.createElement(mz, {
      height: "tb:h-8 tb:w-8 h-6 w-6",
      variant: e.iconVariant,
      strokeClass: (_e$strokeClass = e.strokeClass) !== null && _e$strokeClass !== void 0 ? _e$strokeClass : "stroke-neutral-800"
    }), t.createElement(ce, {
      textStyle: "sub2",
      className: "text-neutral-700"
    }, e.title));
  })))), e.CTA && t.createElement("div", {
    className: "mt-10 tb:flex"
  }, t.createElement("a", {
    href: e.CTA.url
  }, t.createElement(A8, {
    label: e.CTA.text,
    type: "secondary",
    size: "md",
    rightAnimatedArrowColor: "#3970FD"
  })))), e.heroImageURL && e.heroImageAlt ? t.createElement(t.Fragment, null, t.createElement("div", {
    className: "flex justify-center tb:justify-start tb-l:justify-end tb-l:pt-14 tb:max-w-[600px]"
  }, t.createElement("img", {
    src: e.heroImageURL,
    alt: e.heroImageAlt,
    className: "rounded-xl tb-l:rounded-none tb-l:rounded-br-3xl tb-l:rounded-tl-3xl w-full h-auto object-cover db-s:max-w-[650px] tb-l:max-w-[600px] tb:max-w-[420px] "
  }))) : t.createElement(t.Fragment, null, e.video_url && t.createElement("div", {
    className: "flex mt-4 tb:mt-0 tb:items-end tb:max-w-[600px] tb-l:min-w-[550px]"
  }, t.createElement("video", {
    autoPlay: !0,
    loop: !0,
    playsInline: !0,
    muted: !0,
    src: e.video_url,
    className: " rounded-xl tb-l:rounded-none tb-l:rounded-br-3xl tb-l:rounded-tl-3xl"
  }))), t.createElement("div", {
    className: "tb-l:hidden pb-6"
  }, e.brandImageURL && e.brandImageAlt && t.createElement("div", {
    className: "pb-1 -ml-1 "
  }, t.createElement("img", {
    src: e.brandImageURL,
    alt: e.brandImageAlt,
    className: "max-h-[40px]"
  })), t.createElement("div", {
    className: "text-neutral-1000 text-hds-m-h4 tb:text-hds-t-h3 db:text-hds-d-h3"
  }, e.title)), e.tagline && t.createElement(ce, {
    textStyle: "h6",
    className: "text-blue-400 tb-l:hidden uppercase"
  }, e.tagline)));
}
function Zte(e) {
  var _e$badgeColor;
  return t.createElement(t.Fragment, null, t.createElement("div", null, e.eventBadge && t.createElement("div", {
    className: "pb-2"
  }, t.createElement(x8, {
    color: (_e$badgeColor = e.badgeColor) !== null && _e$badgeColor !== void 0 ? _e$badgeColor : "green",
    children: e.eventBadge
  })), e.title && t.createElement(ce, {
    textStyle: "h3",
    as: "h1",
    className: A(e.titleTextColor) + " pb-6"
  }, e.title), (e.eventDate || e.eventTime || e.eventLocation || e.social) && t.createElement("div", {
    className: "flex tb:divide-x divide-y tb:divide-y-0 divide-neutral-200 pb-6 tb:flex-row flex-col"
  }, e.eventDate && t.createElement("div", {
    className: "flex flex-col tb:pr-6 pb-4 tb:pb-0 gap-1"
  }, t.createElement("div", {
    className: "flex gap-2 items-center"
  }, t.createElement(mz, {
    height: "h-[18px] w-[18px]",
    variant: "calendar",
    strokeClass: "stroke-neutral-600 stroke-2"
  }), t.createElement(ce, {
    textStyle: "h6",
    className: "capitalize text-neutral-600"
  }, "WHEN")), t.createElement(ce, {
    textStyle: "sub2",
    className: "text-neutral-700"
  }, e.eventDate)), e.eventTime && t.createElement("div", {
    className: "flex flex-col tb:px-6 py-4 tb:py-0 gap-1"
  }, t.createElement("div", {
    className: "flex gap-2 items-center"
  }, t.createElement(mz, {
    height: "h-[18px] w-[18px]",
    variant: "clock",
    strokeClass: "stroke-neutral-600 stroke-2"
  }), t.createElement(ce, {
    textStyle: "h6",
    className: "capitalize text-neutral-600"
  }, "TIME")), t.createElement(ce, {
    textStyle: "sub2",
    className: "text-neutral-700"
  }, e.eventTime)), e.eventLocation && t.createElement("div", {
    className: "flex flex-col tb:px-6 py-4 tb:py-0 gap-1 "
  }, t.createElement("div", {
    className: "flex gap-2 items-center"
  }, t.createElement(mz, {
    height: "h-[18px] w-[18px]",
    variant: "markerpin03",
    strokeClass: "stroke-neutral-600 stroke-2"
  }), t.createElement(ce, {
    textStyle: "h6",
    className: "capitalize text-neutral-600"
  }, "WHERE")), t.createElement(ce, {
    textStyle: "sub2",
    className: "text-neutral-700"
  }, e.eventLocation)), e.social && t.createElement("div", {
    className: "px-6 flex flex-wrap gap-4 items-center"
  }, e.social && e.social.twitter && t.createElement("a", {
    href: e.social.twitter
  }, t.createElement(mz, {
    variant: "twitter",
    className: "brightness-0 hover:brightness-100 cursor-pointer transition-all duration-300"
  })), e.social && e.social.linkedin && t.createElement("a", {
    href: e.social.linkedin
  }, t.createElement(mz, {
    variant: "linkedin",
    className: "brightness-0 hover:brightness-100 cursor-pointer transition-all duration-300"
  })), e.social && e.social.facebook && t.createElement("a", {
    href: e.social.facebook
  }, t.createElement(mz, {
    variant: "facebookBlue",
    className: "brightness-0 hover:brightness-100 cursor-pointer transition-all duration-300"
  })))), e.subtitle && t.createElement(ce, {
    textStyle: "h5",
    className: "text-neutral-700 pb-2"
  }, e.subtitle), e.description && t.createElement(ce, {
    textStyle: "sub2",
    className: "text-neutral-700 pb-6  [&>p]:pb-2 [&>p>img]:mt-4 [&>p>img]:max-w-[420px] [&>p>img]:w-full [&>p>img:nth-child(2)]:max-w-[140px] last:[&>p]:pb-0 [&>ul]:ps-4 [&>ul>li]:list-disc [&>ul>li]:pb-1 last:[&>ul>li]:pb-0 [&>p>a]:text-blue-600 [&>p>a:hover]:text-blue-800 "
  }, t.createElement(bte, {
    components: {
      a: _ref35 => {
        let {
          node: e,
          ...r
        } = _ref35;
        return t.createElement("a", dz({
          target: "_blank",
          rel: "noopener noreferrer"
        }, r));
      }
    }
  }, e.description)), e.speakers && t.createElement("div", {
    className: "pt-6 border-t border-neutral-200 gap-8 flex flex-wrap"
  }, e.speakers && e.speakers.map((e, r) => {
    return t.createElement("div", {
      key: r
    }, (n = e.speakerName, a = e.speakerDesignation, o = e.speakerImgUrl, t.createElement("div", {
      className: ""
    }, t.createElement(g8, {
      name: n,
      size: "md",
      designation: a,
      imageUrl: o,
      avatarVariant: "circle",
      avatarType: "primary"
    }))));
    var n, a, o;
  }))));
}
function Dte(_ref36) {
  let {
    disabled: e,
    label: n,
    helper: a,
    size: o,
    placeholder: i,
    onChange: l
  } = _ref36;
  const [s, c] = r("");
  return t.createElement("div", null, t.createElement("label", {
    htmlFor: "email",
    className: "ml-4 block text-sm-medium  text-neutral-800"
  }, n), t.createElement("div", {
    className: "mt-1"
  }, t.createElement("input", {
    type: "email",
    name: "email",
    id: "email",
    disabled: e,
    className: "block w-full rounded-full border-neutral-200 shadow-none text-neutral-800  focus:outline-none focus:border-neutral-200 focus:shadow-[0_0px_0px_4px_#DFE8FF] focus:ring-0  hover:shadow hover:border-neutral-300  placeholder:text-neutral-500 placeholder:text-md-regular  disabled:cursor-not-allowed disabled:bg-neutral-100 disabled:text-neutral-500 disabled:ring-gray-200",
    placeholder: i,
    "aria-describedby": "email-description",
    onChange: e => {
      const t = e.target.value;
      c(t), l && l(t);
    }
  })), t.createElement("p", {
    className: "mt-2 ml-4 text-sm-regular text-neutral-800",
    id: "email-description"
  }, a));
}
function qte(_ref37) {
  let {
    label: e,
    helper: n,
    size: a,
    placeholder: o,
    rightIconVariant: i,
    rightIconColor: l,
    disabled: s,
    onChange: c
  } = _ref37;
  const [u, h] = r("");
  return t.createElement("div", null, t.createElement("label", {
    htmlFor: "email",
    className: "block ml-4 text-sm-medium  text-neutral-800"
  }, e), t.createElement("div", {
    className: "relative mt-1 rounded-full shadow-sm"
  }, t.createElement("input", {
    type: "email",
    name: "email",
    id: "email",
    className: "block w-full rounded-full shadow border-pink-500 focus:border-pink-500 focus:outline-none focus:ring-pink-500 sm:text-sm focus:shadow-[0_0px_0px_4px_#FFE6F0]  placeholder:text-neutral-500 placeholder:text-md-regular  ",
    placeholder: o,
    defaultValue: "adamwathan",
    "aria-invalid": "true",
    "aria-describedby": "email-error",
    onChange: e => {
      const t = e.target.value;
      h(t), c && c(t);
    }
  }), t.createElement("div", {
    className: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-4"
  }, i && "none" !== i && t.createElement("div", {
    className: " ml-1.5 h-4 w-4"
  }, t.createElement(mz, {
    variant: i,
    strokeColor: l
  })))), t.createElement("p", {
    className: "mt-2 ml-4 text-xs-regular text-pink-600",
    id: "email-error"
  }, n));
}
function Ute(_ref38) {
  let {
    label: e,
    helper: n,
    size: a,
    placeholder: o,
    leftIconVariant: i,
    leftIconColor: l,
    disabled: s,
    onChange: c
  } = _ref38;
  return r(""), t.createElement("div", null, t.createElement("label", {
    htmlFor: "email",
    className: "block text-sm-medium  text-neutral-800"
  }, e), t.createElement("div", {
    className: "relative mt-1 rounded-md shadow-sm"
  }, t.createElement("div", {
    className: "pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3"
  }, i && "none" !== i && t.createElement("div", {
    className: "-ml-0.5 mr-2 h-4 w-4"
  }, t.createElement(mz, {
    variant: i,
    strokeColor: l
  }))), t.createElement("input", {
    type: "email",
    name: "email",
    id: "email",
    disabled: s,
    className: "block w-full rounded-md border-gray-300 pl-10  focus:border-indigo-500 focus:ring-indigo-500  disabled:cursor-not-allowed disabled:bg-neutral-100 disabled:text-neutral-500 disabled:ring-gray-200 sm:text-sm",
    placeholder: o
  })), t.createElement("p", {
    className: "mt-2 text-sm-regular text-neutral-800",
    id: "email-description"
  }, n));
}
function $te(_ref39) {
  let {
    label: e,
    helper: n,
    size: a,
    placeholder: o,
    rightIconVariant: i,
    rightIconColor: l,
    disabled: s,
    onChange: c
  } = _ref39;
  const [u, h] = r("");
  return t.createElement("div", null, t.createElement("label", {
    htmlFor: "account-number",
    className: "block text-sm-medium ml-4 text-neutral-800"
  }, e), t.createElement("div", {
    className: "relative mt-1 rounded-full shadow-sm"
  }, t.createElement("input", {
    type: "text",
    name: "account-number",
    id: "account-number",
    disabled: s,
    className: "block w-full rounded-full border-gray-300 pr-10  focus:border-indigo-500 focus:ring-indigo-500  disabled:cursor-not-allowed disabled:bg-neutral-100 disabled:text-neutral-500 disabled:ring-gray-200 sm:text-sm",
    placeholder: "000-00-0000",
    onChange: e => {
      const t = e.target.value;
      h(t), c && c(t);
    }
  }), t.createElement("div", {
    className: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-4"
  }, i && "none" !== i && t.createElement("div", {
    className: " ml-1.5 h-4 w-4"
  }, t.createElement(mz, {
    variant: i,
    strokeColor: l
  })))), t.createElement("p", {
    className: "mt-2 ml-4 text-sm-regular text-neutral-800",
    id: "email-description"
  }, n));
}
function zte(_ref40) {
  let {
    disabled: e,
    label: n,
    helper: a,
    size: o,
    placeholder: i,
    dropOptions: l,
    onChange: s
  } = _ref40;
  return r(""), t.createElement("div", null, t.createElement("label", {
    htmlFor: "phone-number",
    className: "block text-sm-medium  text-neutral-800"
  }, n), t.createElement("div", {
    className: "relative mt-1"
  }, t.createElement("div", {
    className: "absolute inset-y-0 left-0 flex items-center"
  }, t.createElement("label", {
    htmlFor: "country",
    className: "sr-only"
  }, "Country"), t.createElement("select", {
    id: "country",
    name: "country",
    autoComplete: "country",
    disabled: e,
    className: "h-full rounded-l-md border-neutral-300 border-r-0 bg-transparent py-0 pl-3 pr-7 text-gray-500  focus:border-none focus:ring-0 sm:text-sm-regular focus:outline-none focus:border-neutral-200 focus:shadow-[0_0px_0px_4px_#DFE8FF] disabled:cursor-not-allowed disabled:bg-neutral-100 disabled:text-neutral-500 disabled:ring-gray-200"
  }, l.map(e => t.createElement("option", null, e)))), t.createElement("input", {
    type: "text",
    name: "phone-number",
    id: "phone-number",
    disabled: e,
    className: " block w-full rounded-lg border-neutral-200 shadow-none text-neutral-800 py-1.5 pl-16 sm:text-sm-regular focus:outline-none focus:border-neutral-200 focus:shadow-[0_0px_0px_4px_#DFE8FF] focus:ring-0  hover:shadow hover:border-neutral-300  placeholder:text-neutral-500 placeholder:text-md-regular  disabled:cursor-not-allowed disabled:bg-neutral-100 disabled:text-neutral-500 disabled:ring-gray-200 ",
    placeholder: "   " + i
  })), t.createElement("p", {
    className: "mt-2 text-sm-regular text-neutral-800",
    id: "email-description"
  }, a));
}
function Wte() {
  return React.createElement("div", null, "leading text");
}
function Qte(_ref41) {
  let {
    label: e,
    placeholder: r,
    disabled: n
  } = _ref41;
  return t.createElement("div", null, t.createElement("label", {
    htmlFor: "comment",
    className: "block text-sm-medium leading-6 text-neutral-800"
  }, e), t.createElement("div", {
    className: "mt-2"
  }, t.createElement("textarea", {
    rows: 4,
    name: "comment",
    id: "comment",
    disabled: n,
    className: "block w-full rounded-md border-0 text-neutral-800 shadow ring-1 ring-inset ring-neutral-200 placeholder:text-gray-400  focus:ring-2 focus:ring-inset focus:ring-indigo-600  disabled:cursor-not-allowed disabled:bg-neutral-100 disabled:text-neutral-500 disabled:ring-gray-200 sm:py-1.5 sm:text-md-regular sm:leading-6",
    defaultValue: "",
    placeholder: r
  })));
}
function Gte(_ref42) {
  let {
    label: e,
    disabled: r,
    helper: n,
    size: a,
    placeholder: o,
    leftIconVariant: i,
    leftIconColor: l,
    rightIconVariant: s,
    rightIconColor: c,
    buttonName: u
  } = _ref42;
  return t.createElement("div", null, t.createElement("label", {
    htmlFor: "email",
    className: "block text-sm font-medium leading-6 text-gray-900"
  }, e), t.createElement("div", {
    className: "mt-2 flex rounded-md shadow-sm"
  }, t.createElement("div", {
    className: "relative flex flex-grow items-stretch focus-within:z-10"
  }, t.createElement("div", {
    className: "pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3"
  }, i && "none" !== i && t.createElement("div", {
    className: "-ml-0.5 mr-2 h-4 w-4"
  }, t.createElement(mz, {
    variant: i,
    strokeColor: l
  }))), t.createElement("input", {
    type: "email",
    name: "email",
    id: "email",
    disabled: r,
    className: "block w-full rounded-none rounded-l-md border-0 py-1.5 pl-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400  focus:ring-2 focus:ring-inset focus:ring-indigo-600  disabled:cursor-not-allowed disabled:bg-neutral-100 disabled:text-neutral-500 disabled:ring-gray-200 sm:text-sm sm:leading-6",
    placeholder: o
  })), t.createElement("button", {
    type: "button",
    disabled: r,
    className: "relative -ml-px inline-flex items-center gap-x-1.5 rounded-r-md px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 disabled:cursor-not-allowed disabled:bg-neutral-100 disabled:text-neutral-500 disabled:ring-gray-200"
  }, s && "none" !== s && t.createElement("div", {
    className: " ml-1.5 h-4 w-4"
  }, t.createElement(mz, {
    variant: s,
    strokeColor: c
  })), u)));
}
function Yte(_ref43) {
  let {
    disabled: e,
    label: r,
    helper: n,
    size: a,
    placeholder: o,
    dropOptions: i,
    currencySymbol: l
  } = _ref43;
  return t.createElement("div", null, t.createElement("label", {
    htmlFor: "price",
    className: "block text-sm font-medium leading-6 text-gray-900"
  }, r), t.createElement("div", {
    className: "relative mt-2 rounded-md shadow-sm"
  }, t.createElement("div", {
    className: "pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3"
  }, t.createElement("span", {
    className: "text-gray-500 sm:text-sm"
  }, l)), t.createElement("input", {
    type: "text",
    name: "price",
    id: "price",
    disabled: e,
    className: "block w-full rounded-md border-0 py-1.5 pl-7 pr-20 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400  focus:ring-2 focus:ring-inset focus:ring-indigo-600  disabled:cursor-not-allowed disabled:bg-neutral-100 disabled:text-neutral-500 disabled:ring-gray-200 sm:text-sm sm:leading-6",
    placeholder: o
  }), t.createElement("div", {
    className: "absolute inset-y-0 right-0 flex items-center"
  }, t.createElement("label", {
    htmlFor: "currency",
    className: "sr-only"
  }, "Currency"), t.createElement("select", {
    id: "currency",
    name: "currency",
    disabled: e,
    className: "h-full rounded-md border border-blue-200 py-0 pl-2 pr-7 text-gray-500 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm"
  }, i.map(e => t.createElement("option", null, e))))));
}
function Kte(_ref44) {
  let {
    disabled: e,
    label: n,
    helper: a,
    size: o,
    placeholder: i,
    onChange: l
  } = _ref44;
  return r(""), t.createElement("div", null, t.createElement("div", {
    className: "flex bg-neutral-0 border border-neutral-300 rounded-full shadow-sm"
  }, t.createElement("div", {
    className: "relative flex flex-grow items-stretch "
  }, t.createElement("input", {
    type: "email",
    name: "email",
    id: "email",
    disabled: e,
    className: "block w-full rounded-l-full border-0 text-hds-m-body3c tb:text-hds-t-body3c db:text-hds-d-body3c py-3 pl-5 placeholder:text-hds-m-body3c placeholder:tb:text-hds-t-body3c placeholder:db:text-hds-d-body3c placeholder:text-neutral-500 placeholder:bg-neutral-0 focus:ring-0 active:bg-neutral-0 focus:bg-neutral-0 visited:bg-neutral-0  disabled:cursor-not-allowed disabled:bg-neutral-100 disabled:text-neutral-500 disabled:ring-neutral-200",
    placeholder: i
  })), t.createElement("div", {
    className: " py-[3.5px] pr-[3px] z-20"
  }, t.createElement(A8, {
    type: "tonal",
    btnBgColorClass: "bg-blue-100",
    btnbgHoverClass: "hover:bg-blue-500",
    rightAnimatedArrowColor: "#3970FD",
    label: n
  }))));
}
function Xte(e) {
  return t.createElement("div", {
    className: ""
  }, t.createElement("div", {
    className: " flex " + ("primary" === e.cardType ? " flex flex-col-reverse " : "pb-6 flex flex-col")
  }, e.imgURL && t.createElement("div", {
    className: "primary" === e.cardType ? "py-11" : "pb-4"
  }, t.createElement("img", {
    src: e.imgURL,
    loading: "lazy",
    alt: e.title,
    className: (e.cardType, "max-h-[200px]")
  })), t.createElement("div", null, e.titleTag && t.createElement("div", {
    className: " text-hds-m-h6 text-neutral-500 uppercase"
  }, e.titleTag), e.title && t.createElement(ce, {
    textStyle: "h4",
    className: "text-neutral-1000"
  }, e.title), e.schedule && t.createElement("div", {
    className: "flex gap-4 pt-4 flex-wrap"
  }, e.schedule.date && t.createElement("div", {
    className: "border border-neutral-200 rounded-2xl p-4 min-w-[152px] "
  }, e.schedule.day && t.createElement(ce, {
    textStyle: "h6",
    className: "text-neutral-600"
  }, e.schedule.day), e.schedule.date && t.createElement(ce, {
    textStyle: "h4",
    className: "text-neutral-1000"
  }, e.schedule.date)), e.schedule.time && t.createElement("div", {
    className: "border border-neutral-200 rounded-2xl p-4 min-w-[152px]"
  }, e.schedule.timezone && t.createElement(ce, {
    textStyle: "h6",
    className: "text-neutral-600"
  }, e.schedule.timezone), e.schedule.time && t.createElement(ce, {
    textStyle: "h4",
    className: "text-neutral-1000"
  }, e.schedule.time))))), t.createElement("div", {
    className: "pb-6 border-neutral-200"
  }, e.inviteTitle && t.createElement(ce, {
    textStyle: "h5",
    className: "text-neutral-800 border-t border-neutral-200 pt-6"
  }, e.inviteTitle), e.inviteTitle2 && t.createElement(ce, {
    textStyle: "h4",
    className: "text-neutral-1000"
  }, e.inviteTitle2), e.inviteSubtitle && t.createElement(ce, {
    textStyle: "body1",
    className: "text-neutral-800"
  }, e.inviteSubtitle)), t.createElement("div", {
    className: "pb-6"
  }, (() => {
    const r = e.invites || 0,
      n = Array.from({
        length: r
      }, (r, n) => t.createElement("div", {
        className: "",
        key: n
      }, t.createElement(Kte, {
        label: e.IFbuttonLabel,
        placeholder: e.IFbuttonPlaceholder
      })));
    return t.createElement("div", {
      className: "flex flex-col gap-4"
    }, n);
  })()), (e.social || e.calendarLink) && t.createElement("div", {
    className: "border-t border-neutral-200 pt-6 flex gap-6 flex-wrap justify-center"
  }, e.social && t.createElement("div", {
    className: "flex flex-wrap items-center"
  }, e.social && e.social.twitter && t.createElement("a", {
    href: e.social.twitter,
    className: "w-[45px] flex justify-center"
  }, t.createElement(mz, {
    variant: "twitter",
    className: "brightness-0 hover:brightness-100 cursor-pointer transition-all duration-300"
  })), e.social && e.social.linkedin && t.createElement("a", {
    href: e.social.linkedin,
    className: "w-[45px] flex justify-center"
  }, t.createElement(mz, {
    variant: "linkedin",
    className: "brightness-0 hover:brightness-100 cursor-pointer transition-all duration-300"
  })), e.social && e.social.facebook && t.createElement("a", {
    href: e.social.facebook,
    className: "w-[45px] flex justify-center"
  }, t.createElement(mz, {
    variant: "facebookBlue",
    className: "brightness-0 hover:brightness-100 cursor-pointer transition-all duration-300"
  }))), t.createElement("div", null, t.createElement(T8, {
    variant: "calendarButton",
    label: "Add to Calendar",
    labelColor: "text-blue-500",
    iconStrokeClass: "stroke-blue-500",
    iconVariant: "calendarplus02"
  }))));
}
function Jte(e) {
  var _e$title;
  return t.createElement(t.Fragment, null, e.linkUrl && t.createElement("a", {
    href: e.linkUrl,
    className: " flex flex-col gap-10 justify-between h-full"
  }, t.createElement("div", {
    className: "flex justify-between"
  }, e.imgUrl && t.createElement("div", {
    className: "flex"
  }, t.createElement("img", {
    alt: (_e$title = e.title) !== null && _e$title !== void 0 ? _e$title : "connectorImage",
    src: e.imgUrl,
    className: " max-h-[25px] object-contain "
  })), e.checkIcon && t.createElement("div", {
    className: "ml-2"
  }, t.createElement(mz, {
    height: "h-6 w-6 stroke-[1.5px]",
    variant: e.checkIcon,
    strokeClass: "stroke-blue-600"
  }))), t.createElement("div", null, e.title && t.createElement(ce, {
    textStyle: "body2-bold",
    className: "text-neutral-1000"
  }, e.title), e.description && t.createElement(ce, {
    textStyle: "body3",
    className: "pt-2 text-neutral-600"
  }, e.description), t.createElement("div", {
    className: "flex flex-row items-center gap-2 pt-3"
  }, e.iconVariant && t.createElement(mz, {
    height: "h-5 w-5 stroke-[1.5px]",
    variant: e.iconVariant,
    strokeClass: "stroke-neutral-600"
  }), e.iconTag && t.createElement(ce, {
    textStyle: "body2-bold",
    className: "text-neutral-1000"
  }, e.iconTag)))));
}
function ere(e) {
  const {
    disabled: r,
    CHECKBOX_ARR: n
  } = e;
  return t.createElement("fieldset", null, t.createElement("legend", {
    className: "sr-only"
  }, "Notifications"), t.createElement("div", {
    className: "space-y-5"
  }, n.map(e => t.createElement("div", {
    className: "relative flex items-start"
  }, t.createElement("div", {
    className: "flex h-6 items-center"
  }, t.createElement("input", {
    id: "comments",
    "aria-describedby": "comments-description",
    name: "comments",
    type: "checkbox",
    disabled: r,
    className: "h-4 w-4 rounded-full border-neutral-200  focus:ring-blue-100 focus:ring-offset-0 focus:ring-0 focus:border focus:bg-neutral-0 focus:border-neutral-300 focus:shadow-[0px_0px_0px_4px_#F0F4FF] focus:outline-none hover:bg-blue-200 hover:border hover:border-blue-600 bg-checkbox checked:hover:bg-blue-200 checked:border-blue-600 checked:bg-blue-100 checked:focus:border checked:focus:border-blue-600 checked:focus:bg-blue-100 checked:hover:border checked:hover:border-blue-600 checked:focus:shadow-[0px_0px_0px_4px_#F0F4FF] disabled:bg-neutral-100 disabled:border disabled:border-neutral-300 "
  })), t.createElement("div", {
    className: "ml-3 text-sm leading-6"
  }, t.createElement("label", {
    htmlFor: "comments",
    className: "text-neutral-800"
  }, e.label), t.createElement("p", {
    id: "comments-description",
    className: "text-neutral-600"
  }, e.description))))), t.createElement("style", null, '\n        .bg-checkbox:checked {\n          background-image: url("data:image/svg+xml,%3csvg viewBox=%270 0 16 16%27 fill=%27blue%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath d=%27M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z%27/%3e%3c/svg%3e")\n          \n        }\n        '));
}
Lte.defaultProps = {
  card: {
    cardBg: "",
    img_url: "https://res.cloudinary.com/dh8fp23nd/image/upload/v1679302435/main-web/roadshow/nagaraja-nayak_l4xte5.png",
    title_img: "Optum",
    img_alt: "optum",
    subtitle: "“Optum goes from concept to production in 100 days with Hasura”",
    avatar: {
      img_url: "https://res.cloudinary.com/dh8fp23nd/image/upload/v1679302435/main-web/roadshow/nagaraja-nayak_l4xte5.png",
      name: "Nagaraja Nayak",
      designation: "Optum",
      avatarBgColor: "bg-yellow-400"
    }
  },
  cardHover: {
    cardBg: "bg-green-500",
    img_url: "",
    img_alt: "",
    title: "Optum goes from concept to production in 100 days with Hasura",
    button: {
      cta_text: "Read the case Study"
    }
  }
}, Fte.defaultProps = {
  descTextColor: "text-neutral-700",
  isExternalLink: "false",
  iconTag: "Customer Stories",
  titleTextColor: "",
  brandImageUrl: "https://res.cloudinary.com/dh8fp23nd/image/upload/v1690909443/hasura-design-system/swiggy_m2hjxy.png",
  brandImageAlt: "pipe",
  linkUrl: "?path=/story/hasura-design-system--hasura-design-system&globals=backgrounds.value:!hex(3b5998)",
  iconVariant: "videorecorder",
  iconStrokeColor: "blue-500",
  iconArrowVariant: "home03",
  iconArrowStrokeColor: "blue-400",
  title: "Webinar",
  description: "Model Level Authorization System for GraphQL with Hasura Model Level Authorization System for ",
  readMoreBtn: {
    cta_text: "Read More"
  }
}, _te.defaultProps = {
  heroImageURL: "https://res.cloudinary.com/dh8fp23nd/image/upload/v1690802853/website%20v3/optum_hiqty8.png",
  heroImageAlt: "optum",
  heroIconVariant: "calendar",
  heroIconStrokeClass: "stroke-neutral-1000",
  heroListTitle: "100 days from concept to production",
  brandImageURL: "https://res.cloudinary.com/hasura-cms-uploads/image/upload/v1690982762/pulley_pcj45e_8fd10af212.png",
  brandImageAlt: "optum",
  title: "Healthcare giant Optum goes from concept to production in 100 days with Hasura",
  description: "description1",
  CTA: {
    text: "Button Label"
  },
  heroList: [{
    iconVariant: "calendar",
    title: "100 days from concept to production"
  }, {
    iconVariant: "database03",
    title: "Vastly improved access to relevant data"
  }, {
    iconVariant: "settings01",
    title: "Simpler data and API management"
  }]
};
const tre = o({
    transformPagePoint: e => e,
    isStatic: !1,
    reducedMotion: "never"
  }),
  rre = o({}),
  nre = o(null),
  are = "undefined" != typeof document,
  ore = are ? h : a,
  ire = o({
    strict: !1
  });
function lre(e) {
  return "object" == typeof e && Object.prototype.hasOwnProperty.call(e, "current");
}
function sre(e) {
  return "string" == typeof e || Array.isArray(e);
}
function cre(e) {
  return "object" == typeof e && "function" == typeof e.start;
}
const ure = ["animate", "whileInView", "whileFocus", "whileHover", "whileTap", "whileDrag", "exit"],
  hre = ["initial", ...ure];
function mre(e) {
  return cre(e.animate) || hre.some(t => sre(e[t]));
}
function pre(e) {
  return Boolean(mre(e) || e.variants);
}
function fre(e) {
  const {
    initial: t,
    animate: r
  } = function (e, t) {
    if (mre(e)) {
      const {
        initial: t,
        animate: r
      } = e;
      return {
        initial: !1 === t || sre(t) ? t : void 0,
        animate: sre(r) ? r : void 0
      };
    }
    return !1 !== e.inherit ? t : {};
  }(e, m(rre));
  return d(() => ({
    initial: t,
    animate: r
  }), [dre(t), dre(r)]);
}
function dre(e) {
  return Array.isArray(e) ? e.join(" ") : e;
}
const vre = {
    animation: ["animate", "variants", "whileHover", "whileTap", "exit", "whileInView", "whileFocus", "whileDrag"],
    exit: ["exit"],
    drag: ["drag", "dragControls"],
    focus: ["whileFocus"],
    hover: ["whileHover", "onHoverStart", "onHoverEnd"],
    tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
    pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
    inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
    layout: ["layout", "layoutId"]
  },
  gre = {};
for (const e in vre) gre[e] = {
  isEnabled: t => vre[e].some(e => !!t[e])
};
const bre = o({}),
  wre = o({}),
  yre = Symbol.for("motionComponentSymbol");
function xre(_ref45) {
  let {
    preloadedFeatures: t,
    createVisualElement: r,
    useRender: o,
    useVisualState: i,
    Component: l
  } = _ref45;
  t && function (e) {
    for (const t in e) gre[t] = {
      ...gre[t],
      ...e[t]
    };
  }(t);
  const s = v(function (s, c) {
    let u;
    const h = {
        ...m(tre),
        ...s,
        layoutId: Ore(s)
      },
      {
        isStatic: d
      } = h,
      v = fre(s),
      g = i(s, d);
    if (!d && are) {
      v.visualElement = function (e, t, r, o) {
        const {
            visualElement: i
          } = m(rre),
          l = m(ire),
          s = m(nre),
          c = m(tre).reducedMotion,
          u = n();
        o = o || l.renderer, !u.current && o && (u.current = o(e, {
          visualState: t,
          parent: i,
          props: r,
          presenceContext: s,
          blockInitialAnimation: !!s && !1 === s.initial,
          reducedMotionConfig: c
        }));
        const h = u.current;
        return p(() => {
          h && h.update(r, s);
        }), ore(() => {
          h && h.render();
        }), a(() => {
          h && h.updateFeatures();
        }), (window.HandoffAppearAnimations ? ore : a)(() => {
          h && h.animationState && h.animationState.animateChanges();
        }), h;
      }(l, g, h, r);
      const e = m(wre),
        o = m(ire).strict;
      v.visualElement && (u = v.visualElement.loadFeatures(h, o, t, e));
    }
    return e.createElement(rre.Provider, {
      value: v
    }, u && v.visualElement ? e.createElement(u, {
      visualElement: v.visualElement,
      ...h
    }) : null, o(l, s, function (e, t, r) {
      return f(n => {
        n && e.mount && e.mount(n), t && (n ? t.mount(n) : t.unmount()), r && ("function" == typeof r ? r(n) : lre(r) && (r.current = n));
      }, [t]);
    }(g, v.visualElement, c), g, d, v.visualElement));
  });
  return s[yre] = l, s;
}
function Ore(_ref46) {
  let {
    layoutId: e
  } = _ref46;
  const t = m(bre).id;
  return t && void 0 !== e ? t + "-" + e : e;
}
function Ere(e) {
  function t(t) {
    let r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return xre(e(t, r));
  }
  if ("undefined" == typeof Proxy) return t;
  const r = new Map();
  return new Proxy(t, {
    get: (e, n) => (r.has(n) || r.set(n, t(n)), r.get(n))
  });
}
const jre = ["animate", "circle", "defs", "desc", "ellipse", "g", "image", "line", "filter", "marker", "mask", "metadata", "path", "pattern", "polygon", "polyline", "rect", "stop", "switch", "symbol", "svg", "text", "tspan", "use", "view"];
function Cre(e) {
  return "string" == typeof e && !e.includes("-") && !!(jre.indexOf(e) > -1 || /[A-Z]/.test(e));
}
const Pre = {};
const Mre = ["transformPerspective", "x", "y", "z", "translateX", "translateY", "translateZ", "scale", "scaleX", "scaleY", "rotate", "rotateX", "rotateY", "rotateZ", "skew", "skewX", "skewY"],
  kre = new Set(Mre);
function Sre(e, _ref47) {
  let {
    layout: t,
    layoutId: r
  } = _ref47;
  return kre.has(e) || e.startsWith("origin") || (t || void 0 !== r) && (!!Pre[e] || "opacity" === e);
}
const Nre = e => Boolean(e && e.getVelocity),
  Bre = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
  },
  Vre = Mre.length;
const Rre = e => t => "string" == typeof t && t.startsWith(e),
  Are = Rre("--"),
  Tre = Rre("var(--"),
  Hre = (e, t) => t && "number" == typeof e ? t.transform(e) : e,
  Lre = (e, t, r) => Math.min(Math.max(r, e), t),
  Ire = {
    test: e => "number" == typeof e,
    parse: parseFloat,
    transform: e => e
  },
  Fre = {
    ...Ire,
    transform: e => Lre(0, 1, e)
  },
  _re = {
    ...Ire,
    default: 1
  },
  Zre = e => Math.round(1e5 * e) / 1e5,
  Dre = /(-)?([\d]*\.?[\d])+/g,
  qre = /(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))/gi,
  Ure = /^(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))$/i;
function $re(e) {
  return "string" == typeof e;
}
const zre = e => ({
    test: t => $re(t) && t.endsWith(e) && 1 === t.split(" ").length,
    parse: parseFloat,
    transform: t => "".concat(t).concat(e)
  }),
  Wre = zre("deg"),
  Qre = zre("%"),
  Gre = zre("px"),
  Yre = zre("vh"),
  Kre = zre("vw"),
  Xre = {
    ...Qre,
    parse: e => Qre.parse(e) / 100,
    transform: e => Qre.transform(100 * e)
  },
  Jre = {
    ...Ire,
    transform: Math.round
  },
  ene = {
    borderWidth: Gre,
    borderTopWidth: Gre,
    borderRightWidth: Gre,
    borderBottomWidth: Gre,
    borderLeftWidth: Gre,
    borderRadius: Gre,
    radius: Gre,
    borderTopLeftRadius: Gre,
    borderTopRightRadius: Gre,
    borderBottomRightRadius: Gre,
    borderBottomLeftRadius: Gre,
    width: Gre,
    maxWidth: Gre,
    height: Gre,
    maxHeight: Gre,
    size: Gre,
    top: Gre,
    right: Gre,
    bottom: Gre,
    left: Gre,
    padding: Gre,
    paddingTop: Gre,
    paddingRight: Gre,
    paddingBottom: Gre,
    paddingLeft: Gre,
    margin: Gre,
    marginTop: Gre,
    marginRight: Gre,
    marginBottom: Gre,
    marginLeft: Gre,
    rotate: Wre,
    rotateX: Wre,
    rotateY: Wre,
    rotateZ: Wre,
    scale: _re,
    scaleX: _re,
    scaleY: _re,
    scaleZ: _re,
    skew: Wre,
    skewX: Wre,
    skewY: Wre,
    distance: Gre,
    translateX: Gre,
    translateY: Gre,
    translateZ: Gre,
    x: Gre,
    y: Gre,
    z: Gre,
    perspective: Gre,
    transformPerspective: Gre,
    opacity: Fre,
    originX: Xre,
    originY: Xre,
    originZ: Gre,
    zIndex: Jre,
    fillOpacity: Fre,
    strokeOpacity: Fre,
    numOctaves: Jre
  };
function tne(e, t, r, n) {
  const {
    style: a,
    vars: o,
    transform: i,
    transformOrigin: l
  } = e;
  let s = !1,
    c = !1,
    u = !0;
  for (const e in t) {
    const r = t[e];
    if (Are(e)) {
      o[e] = r;
      continue;
    }
    const n = ene[e],
      h = Hre(r, n);
    if (kre.has(e)) {
      if (s = !0, i[e] = h, !u) continue;
      r !== (n.default || 0) && (u = !1);
    } else e.startsWith("origin") ? (c = !0, l[e] = h) : a[e] = h;
  }
  if (t.transform || (s || n ? a.transform = function (e, _ref48, n, a) {
    let {
      enableHardwareAcceleration: t = !0,
      allowTransformNone: r = !0
    } = _ref48;
    let o = "";
    for (let t = 0; t < Vre; t++) {
      const r = Mre[t];
      void 0 !== e[r] && (o += "".concat(Bre[r] || r, "(").concat(e[r], ") "));
    }
    return t && !e.z && (o += "translateZ(0)"), o = o.trim(), a ? o = a(e, n ? "" : o) : r && n && (o = "none"), o;
  }(e.transform, r, u, n) : a.transform && (a.transform = "none")), c) {
    const {
      originX: e = "50%",
      originY: t = "50%",
      originZ: r = 0
    } = l;
    a.transformOrigin = "".concat(e, " ").concat(t, " ").concat(r);
  }
}
const rne = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});
function nne(e, t, r) {
  for (const n in t) Nre(t[n]) || Sre(n, r) || (e[n] = t[n]);
}
function ane(e, t, r) {
  const n = {};
  return nne(n, e.style || {}, e), Object.assign(n, function (_ref49, t, r) {
    let {
      transformTemplate: e
    } = _ref49;
    return d(() => {
      const n = rne();
      return tne(n, t, {
        enableHardwareAcceleration: !r
      }, e), Object.assign({}, n.vars, n.style);
    }, [t]);
  }(e, t, r)), e.transformValues ? e.transformValues(n) : n;
}
function one(e, t, r) {
  const n = {},
    a = ane(e, t, r);
  return e.drag && !1 !== e.dragListener && (n.draggable = !1, a.userSelect = a.WebkitUserSelect = a.WebkitTouchCallout = "none", a.touchAction = !0 === e.drag ? "none" : "pan-" + ("x" === e.drag ? "y" : "x")), void 0 === e.tabIndex && (e.onTap || e.onTapStart || e.whileTap) && (n.tabIndex = 0), n.style = a, n;
}
const ine = new Set(["animate", "exit", "variants", "initial", "style", "values", "variants", "transition", "transformTemplate", "transformValues", "custom", "inherit", "onLayoutAnimationStart", "onLayoutAnimationComplete", "onLayoutMeasure", "onBeforeLayoutMeasure", "onAnimationStart", "onAnimationComplete", "onUpdate", "onDragStart", "onDrag", "onDragEnd", "onMeasureDragConstraints", "onDirectionLock", "onDragTransitionEnd", "_dragX", "_dragY", "onHoverStart", "onHoverEnd", "onViewportEnter", "onViewportLeave", "ignoreStrict", "viewport"]);
function lne(e) {
  return e.startsWith("while") || e.startsWith("drag") && "draggable" !== e || e.startsWith("layout") || e.startsWith("onTap") || e.startsWith("onPan") || ine.has(e);
}
let sne = e => !lne(e);
try {
  (cne = require("@emotion/is-prop-valid").default) && (sne = e => e.startsWith("on") ? !lne(e) : cne(e));
} catch (e) {}
var cne;
function une(e, t, r) {
  return "string" == typeof e ? e : Gre.transform(t + r * e);
}
const hne = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
  },
  mne = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
  };
function pne(e, _ref50, u, h, m) {
  let {
    attrX: t,
    attrY: r,
    attrScale: n,
    originX: a,
    originY: o,
    pathLength: i,
    pathSpacing: l = 1,
    pathOffset: s = 0,
    ...c
  } = _ref50;
  if (tne(e, c, u, m), h) return void (e.style.viewBox && (e.attrs.viewBox = e.style.viewBox));
  e.attrs = e.style, e.style = {};
  const {
    attrs: p,
    style: f,
    dimensions: d
  } = e;
  p.transform && (d && (f.transform = p.transform), delete p.transform), d && (void 0 !== a || void 0 !== o || f.transform) && (f.transformOrigin = function (e, t, r) {
    return "".concat(une(t, e.x, e.width), " ").concat(une(r, e.y, e.height));
  }(d, void 0 !== a ? a : .5, void 0 !== o ? o : .5)), void 0 !== t && (p.x = t), void 0 !== r && (p.y = r), void 0 !== n && (p.scale = n), void 0 !== i && function (e, t) {
    let r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    let n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    let a = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !0;
    e.pathLength = 1;
    const o = a ? hne : mne;
    e[o.offset] = Gre.transform(-n);
    const i = Gre.transform(t),
      l = Gre.transform(r);
    e[o.array] = "".concat(i, " ").concat(l);
  }(p, i, l, s, !1);
}
const fne = () => ({
    ...rne(),
    attrs: {}
  }),
  dne = e => "string" == typeof e && "svg" === e.toLowerCase();
function vne(e, t, r, n) {
  const a = d(() => {
    const r = fne();
    return pne(r, t, {
      enableHardwareAcceleration: !1
    }, dne(n), e.transformTemplate), {
      ...r.attrs,
      style: {
        ...r.style
      }
    };
  }, [t]);
  if (e.style) {
    const t = {};
    nne(t, e.style, e), a.style = {
      ...t,
      ...a.style
    };
  }
  return a;
}
function gne() {
  let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
  return (t, r, n, _ref51, o) => {
    let {
      latestValues: a
    } = _ref51;
    const i = (Cre(t) ? vne : one)(r, a, o, t),
      l = function (e, t, r) {
        const n = {};
        for (const a in e) "values" === a && "object" == typeof e.values || (sne(a) || !0 === r && lne(a) || !t && !lne(a) || e.draggable && a.startsWith("onDrag")) && (n[a] = e[a]);
        return n;
      }(r, "string" == typeof t, e),
      s = {
        ...l,
        ...i,
        ref: n
      },
      {
        children: c
      } = r,
      u = d(() => Nre(c) ? c.get() : c, [c]);
    return g(t, {
      ...s,
      children: u
    });
  };
}
const bne = e => e.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
function wne(e, _ref52, n, a) {
  let {
    style: t,
    vars: r
  } = _ref52;
  Object.assign(e.style, t, a && a.getProjectionStyles(n));
  for (const t in r) e.style.setProperty(t, r[t]);
}
const yne = new Set(["baseFrequency", "diffuseConstant", "kernelMatrix", "kernelUnitLength", "keySplines", "keyTimes", "limitingConeAngle", "markerHeight", "markerWidth", "numOctaves", "targetX", "targetY", "surfaceScale", "specularConstant", "specularExponent", "stdDeviation", "tableValues", "viewBox", "gradientTransform", "pathLength", "startOffset", "textLength", "lengthAdjust"]);
function xne(e, t, r, n) {
  wne(e, t, void 0, n);
  for (const r in t.attrs) e.setAttribute(yne.has(r) ? r : bne(r), t.attrs[r]);
}
function One(e, t) {
  const {
      style: r
    } = e,
    n = {};
  for (const a in r) (Nre(r[a]) || t.style && Nre(t.style[a]) || Sre(a, e)) && (n[a] = r[a]);
  return n;
}
function Ene(e, t) {
  const r = One(e, t);
  for (const n in e) if (Nre(e[n]) || Nre(t[n])) {
    r[-1 !== Mre.indexOf(n) ? "attr" + n.charAt(0).toUpperCase() + n.substring(1) : n] = e[n];
  }
  return r;
}
function jne(e, t, r) {
  let n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  let a = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  return "function" == typeof t && (t = t(void 0 !== r ? r : e.custom, n, a)), "string" == typeof t && (t = e.variants && e.variants[t]), "function" == typeof t && (t = t(void 0 !== r ? r : e.custom, n, a)), t;
}
function Cne(e) {
  const t = n(null);
  return null === t.current && (t.current = e()), t.current;
}
const Pne = e => Array.isArray(e),
  Mne = e => Boolean(e && "object" == typeof e && e.mix && e.toValue),
  kne = e => Pne(e) ? e[e.length - 1] || 0 : e;
function Sne(e) {
  const t = Nre(e) ? e.get() : e;
  return Mne(t) ? t.toValue() : t;
}
const Nne = e => (t, r) => {
  const n = m(rre),
    a = m(nre),
    o = () => function (_ref53, n, a, o) {
      let {
        scrapeMotionValuesFromProps: e,
        createRenderState: t,
        onMount: r
      } = _ref53;
      const i = {
        latestValues: Bne(n, a, o, e),
        renderState: t()
      };
      return r && (i.mount = e => r(n, e, i)), i;
    }(e, t, n, a);
  return r ? o() : Cne(o);
};
function Bne(e, t, r, n) {
  const a = {},
    o = n(e, {});
  for (const e in o) a[e] = Sne(o[e]);
  let {
    initial: i,
    animate: l
  } = e;
  const s = mre(e),
    c = pre(e);
  t && c && !s && !1 !== e.inherit && (void 0 === i && (i = t.initial), void 0 === l && (l = t.animate));
  let u = !!r && !1 === r.initial;
  u = u || !1 === i;
  const h = u ? l : i;
  if (h && "boolean" != typeof h && !cre(h)) {
    (Array.isArray(h) ? h : [h]).forEach(t => {
      const r = jne(e, t);
      if (!r) return;
      const {
        transitionEnd: n,
        transition: o,
        ...i
      } = r;
      for (const e in i) {
        let t = i[e];
        if (Array.isArray(t)) {
          t = t[u ? t.length - 1 : 0];
        }
        null !== t && (a[e] = t);
      }
      for (const e in n) a[e] = n[e];
    });
  }
  return a;
}
const Vne = {
    useVisualState: Nne({
      scrapeMotionValuesFromProps: Ene,
      createRenderState: fne,
      onMount: (e, t, _ref54) => {
        let {
          renderState: r,
          latestValues: n
        } = _ref54;
        try {
          r.dimensions = "function" == typeof t.getBBox ? t.getBBox() : t.getBoundingClientRect();
        } catch (e) {
          r.dimensions = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
          };
        }
        pne(r, n, {
          enableHardwareAcceleration: !1
        }, dne(t.tagName), e.transformTemplate), xne(t, r);
      }
    })
  },
  Rne = {
    useVisualState: Nne({
      scrapeMotionValuesFromProps: One,
      createRenderState: rne
    })
  };
function Ane(e, t, r) {
  let n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    passive: !0
  };
  return e.addEventListener(t, r, n), () => e.removeEventListener(t, r);
}
const Tne = e => "mouse" === e.pointerType ? "number" != typeof e.button || e.button <= 0 : !1 !== e.isPrimary;
function Hne(e) {
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "page";
  return {
    point: {
      x: e[t + "X"],
      y: e[t + "Y"]
    }
  };
}
const Lne = e => t => Tne(t) && e(t, Hne(t));
function Ine(e, t, r, n) {
  return Ane(e, t, Lne(r), n);
}
const Fne = (e, t) => r => t(e(r)),
  _ne = function () {
    for (var _len12 = arguments.length, e = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
      e[_key12] = arguments[_key12];
    }
    return e.reduce(Fne);
  };
function Zne(e) {
  let t = null;
  return () => {
    const r = () => {
      t = null;
    };
    return null === t && (t = e, r);
  };
}
const Dne = Zne("dragHorizontal"),
  qne = Zne("dragVertical");
function Une(e) {
  let t = !1;
  if ("y" === e) t = qne();else if ("x" === e) t = Dne();else {
    const e = Dne(),
      r = qne();
    e && r ? t = () => {
      e(), r();
    } : (e && e(), r && r());
  }
  return t;
}
function $ne() {
  const e = Une(!0);
  return !e || (e(), !1);
}
class zne {
  constructor(e) {
    this.isMounted = !1, this.node = e;
  }
  update() {}
}
const Wne = {
  delta: 0,
  timestamp: 0,
  isProcessing: !1
};
let Qne = !0,
  Gne = !1;
const Yne = ["read", "update", "preRender", "render", "postRender"],
  Kne = Yne.reduce((e, t) => (e[t] = function (e) {
    let t = [],
      r = [],
      n = 0,
      a = !1,
      o = !1;
    const i = new WeakSet(),
      l = {
        schedule: function (e) {
          let o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          let l = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
          const s = l && a,
            c = s ? t : r;
          return o && i.add(e), -1 === c.indexOf(e) && (c.push(e), s && a && (n = t.length)), e;
        },
        cancel: e => {
          const t = r.indexOf(e);
          -1 !== t && r.splice(t, 1), i.delete(e);
        },
        process: s => {
          if (a) o = !0;else {
            if (a = !0, [t, r] = [r, t], r.length = 0, n = t.length, n) for (let r = 0; r < n; r++) {
              const n = t[r];
              n(s), i.has(n) && (l.schedule(n), e());
            }
            a = !1, o && (o = !1, l.process(s));
          }
        }
      };
    return l;
  }(() => Gne = !0), e), {}),
  Xne = e => Kne[e].process(Wne),
  Jne = e => {
    Gne = !1, Wne.delta = Qne ? 1e3 / 60 : Math.max(Math.min(e - Wne.timestamp, 40), 1), Wne.timestamp = e, Wne.isProcessing = !0, Yne.forEach(Xne), Wne.isProcessing = !1, Gne && (Qne = !1, requestAnimationFrame(Jne));
  },
  eae = Yne.reduce((e, t) => {
    const r = Kne[t];
    return e[t] = function (e) {
      let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      return Gne || (Gne = !0, Qne = !0, Wne.isProcessing || requestAnimationFrame(Jne)), r.schedule(e, t, n);
    }, e;
  }, {});
function tae(e) {
  Yne.forEach(t => Kne[t].cancel(e));
}
function rae(e, t) {
  const r = "pointer" + (t ? "enter" : "leave"),
    n = "onHover" + (t ? "Start" : "End");
  return Ine(e.current, r, (r, a) => {
    if ("touch" === r.type || $ne()) return;
    const o = e.getProps();
    e.animationState && o.whileHover && e.animationState.setActive("whileHover", t), o[n] && eae.update(() => o[n](r, a));
  }, {
    passive: !e.getProps()[n]
  });
}
const nae = (e, t) => !!t && (e === t || nae(e, t.parentElement)),
  aae = e => e;
function oae(e, t) {
  if (!t) return;
  const r = new PointerEvent("pointer" + e);
  t(r, Hne(r));
}
const iae = new WeakMap(),
  lae = new WeakMap(),
  sae = e => {
    const t = iae.get(e.target);
    t && t(e);
  },
  cae = e => {
    e.forEach(sae);
  };
function uae(e, t, r) {
  const n = function (_ref55) {
    let {
      root: e,
      ...t
    } = _ref55;
    const r = e || document;
    lae.has(r) || lae.set(r, {});
    const n = lae.get(r),
      a = JSON.stringify(t);
    return n[a] || (n[a] = new IntersectionObserver(cae, {
      root: e,
      ...t
    })), n[a];
  }(t);
  return iae.set(e, r), n.observe(e), () => {
    iae.delete(e), n.unobserve(e);
  };
}
const hae = {
  some: 0,
  all: 1
};
const mae = {
  inView: {
    Feature: class extends zne {
      constructor() {
        super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
      }
      startObserver() {
        this.unmount();
        const {
            viewport: e = {}
          } = this.node.getProps(),
          {
            root: t,
            margin: r,
            amount: n = "some",
            once: a
          } = e,
          o = {
            root: t ? t.current : void 0,
            rootMargin: r,
            threshold: "number" == typeof n ? n : hae[n]
          };
        return uae(this.node.current, o, e => {
          const {
            isIntersecting: t
          } = e;
          if (this.isInView === t) return;
          if (this.isInView = t, a && !t && this.hasEnteredView) return;
          t && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", t);
          const {
              onViewportEnter: r,
              onViewportLeave: n
            } = this.node.getProps(),
            o = t ? r : n;
          o && o(e);
        });
      }
      mount() {
        this.startObserver();
      }
      update() {
        if ("undefined" == typeof IntersectionObserver) return;
        const {
          props: e,
          prevProps: t
        } = this.node;
        ["amount", "margin", "root"].some(function (_ref56) {
          let {
            viewport: e = {}
          } = _ref56;
          let {
            viewport: t = {}
          } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          return r => e[r] !== t[r];
        }(e, t)) && this.startObserver();
      }
      unmount() {}
    }
  },
  tap: {
    Feature: class extends zne {
      constructor() {
        super(...arguments), this.removeStartListeners = aae, this.removeEndListeners = aae, this.removeAccessibleListeners = aae, this.startPointerPress = (e, t) => {
          if (this.removeEndListeners(), this.isPressing) return;
          const r = this.node.getProps(),
            n = Ine(window, "pointerup", (e, t) => {
              if (!this.checkPressEnd()) return;
              const {
                onTap: r,
                onTapCancel: n
              } = this.node.getProps();
              eae.update(() => {
                nae(this.node.current, e.target) ? r && r(e, t) : n && n(e, t);
              });
            }, {
              passive: !(r.onTap || r.onPointerUp)
            }),
            a = Ine(window, "pointercancel", (e, t) => this.cancelPress(e, t), {
              passive: !(r.onTapCancel || r.onPointerCancel)
            });
          this.removeEndListeners = _ne(n, a), this.startPress(e, t);
        }, this.startAccessiblePress = () => {
          const e = Ane(this.node.current, "keydown", e => {
              if ("Enter" !== e.key || this.isPressing) return;
              this.removeEndListeners(), this.removeEndListeners = Ane(this.node.current, "keyup", e => {
                "Enter" === e.key && this.checkPressEnd() && oae("up", (e, t) => {
                  const {
                    onTap: r
                  } = this.node.getProps();
                  r && eae.update(() => r(e, t));
                });
              }), oae("down", (e, t) => {
                this.startPress(e, t);
              });
            }),
            t = Ane(this.node.current, "blur", () => {
              this.isPressing && oae("cancel", (e, t) => this.cancelPress(e, t));
            });
          this.removeAccessibleListeners = _ne(e, t);
        };
      }
      startPress(e, t) {
        this.isPressing = !0;
        const {
          onTapStart: r,
          whileTap: n
        } = this.node.getProps();
        n && this.node.animationState && this.node.animationState.setActive("whileTap", !0), r && eae.update(() => r(e, t));
      }
      checkPressEnd() {
        this.removeEndListeners(), this.isPressing = !1;
        return this.node.getProps().whileTap && this.node.animationState && this.node.animationState.setActive("whileTap", !1), !$ne();
      }
      cancelPress(e, t) {
        if (!this.checkPressEnd()) return;
        const {
          onTapCancel: r
        } = this.node.getProps();
        r && eae.update(() => r(e, t));
      }
      mount() {
        const e = this.node.getProps(),
          t = Ine(this.node.current, "pointerdown", this.startPointerPress, {
            passive: !(e.onTapStart || e.onPointerStart)
          }),
          r = Ane(this.node.current, "focus", this.startAccessiblePress);
        this.removeStartListeners = _ne(t, r);
      }
      unmount() {
        this.removeStartListeners(), this.removeEndListeners(), this.removeAccessibleListeners();
      }
    }
  },
  focus: {
    Feature: class extends zne {
      constructor() {
        super(...arguments), this.isActive = !1;
      }
      onFocus() {
        let e = !1;
        try {
          e = this.node.current.matches(":focus-visible");
        } catch (t) {
          e = !0;
        }
        e && this.node.animationState && (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
      }
      onBlur() {
        this.isActive && this.node.animationState && (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
      }
      mount() {
        this.unmount = _ne(Ane(this.node.current, "focus", () => this.onFocus()), Ane(this.node.current, "blur", () => this.onBlur()));
      }
      unmount() {}
    }
  },
  hover: {
    Feature: class extends zne {
      mount() {
        this.unmount = _ne(rae(this.node, !0), rae(this.node, !1));
      }
      unmount() {}
    }
  }
};
function pae(e, t) {
  if (!Array.isArray(t)) return !1;
  const r = t.length;
  if (r !== e.length) return !1;
  for (let n = 0; n < r; n++) if (t[n] !== e[n]) return !1;
  return !0;
}
function fae(e, t, r) {
  const n = e.getProps();
  return jne(n, t, void 0 !== r ? r : n.custom, function (e) {
    const t = {};
    return e.values.forEach((e, r) => t[r] = e.get()), t;
  }(e), function (e) {
    const t = {};
    return e.values.forEach((e, r) => t[r] = e.getVelocity()), t;
  }(e));
}
const dae = "data-" + bne("framerAppearId");
let vae = aae,
  gae = aae;
"production" !== process.env.NODE_ENV && (vae = (e, t) => {
  e || "undefined" == typeof console || console.warn(t);
}, gae = (e, t) => {
  if (!e) throw new Error(t);
});
const bae = e => 1e3 * e,
  wae = e => e / 1e3,
  yae = !1,
  xae = e => Array.isArray(e) && "number" == typeof e[0];
function Oae(e) {
  return Boolean(!e || "string" == typeof e && jae[e] || xae(e) || Array.isArray(e) && e.every(Oae));
}
const Eae = _ref57 => {
    let [e, t, r, n] = _ref57;
    return "cubic-bezier(".concat(e, ", ").concat(t, ", ").concat(r, ", ").concat(n, ")");
  },
  jae = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: Eae([0, .65, .55, 1]),
    circOut: Eae([.55, 0, 1, .45]),
    backIn: Eae([.31, .01, .66, -.59]),
    backOut: Eae([.33, 1.53, .69, .99])
  };
function Cae(e) {
  if (e) return xae(e) ? Eae(e) : Array.isArray(e) ? e.map(Cae) : jae[e];
}
const Pae = {
    waapi: () => Object.hasOwnProperty.call(Element.prototype, "animate")
  },
  Mae = {},
  kae = {};
for (const e in Pae) kae[e] = () => (void 0 === Mae[e] && (Mae[e] = Pae[e]()), Mae[e]);
const Sae = (e, t, r) => (((1 - 3 * r + 3 * t) * e + (3 * r - 6 * t)) * e + 3 * t) * e,
  Nae = 1e-7,
  Bae = 12;
function Vae(e, t, r, n) {
  if (e === t && r === n) return aae;
  const a = t => function (e, t, r, n, a) {
    let o,
      i,
      l = 0;
    do {
      i = t + (r - t) / 2, o = Sae(i, n, a) - e, o > 0 ? r = i : t = i;
    } while (Math.abs(o) > Nae && ++l < Bae);
    return i;
  }(t, 0, 1, e, r);
  return e => 0 === e || 1 === e ? e : Sae(a(e), t, n);
}
const Rae = Vae(.42, 0, 1, 1),
  Aae = Vae(0, 0, .58, 1),
  Tae = Vae(.42, 0, .58, 1),
  Hae = e => Array.isArray(e) && "number" != typeof e[0],
  Lae = e => t => t <= .5 ? e(2 * t) / 2 : (2 - e(2 * (1 - t))) / 2,
  Iae = e => t => 1 - e(1 - t),
  Fae = e => 1 - Math.sin(Math.acos(e)),
  _ae = Iae(Fae),
  Zae = Lae(_ae),
  Dae = Vae(.33, 1.53, .69, .99),
  qae = Iae(Dae),
  Uae = Lae(qae),
  $ae = {
    linear: aae,
    easeIn: Rae,
    easeInOut: Tae,
    easeOut: Aae,
    circIn: Fae,
    circInOut: Zae,
    circOut: _ae,
    backIn: qae,
    backInOut: Uae,
    backOut: Dae,
    anticipate: e => (e *= 2) < 1 ? .5 * qae(e) : .5 * (2 - Math.pow(2, -10 * (e - 1)))
  },
  zae = e => {
    if (Array.isArray(e)) {
      gae(4 === e.length, "Cubic bezier arrays must contain four numerical values.");
      const [t, r, n, a] = e;
      return Vae(t, r, n, a);
    }
    return "string" == typeof e ? (gae(void 0 !== $ae[e], "Invalid easing type '".concat(e, "'")), $ae[e]) : e;
  },
  Wae = (e, t) => r => Boolean($re(r) && Ure.test(r) && r.startsWith(e) || t && Object.prototype.hasOwnProperty.call(r, t)),
  Qae = (e, t, r) => n => {
    if (!$re(n)) return n;
    const [a, o, i, l] = n.match(Dre);
    return {
      [e]: parseFloat(a),
      [t]: parseFloat(o),
      [r]: parseFloat(i),
      alpha: void 0 !== l ? parseFloat(l) : 1
    };
  },
  Gae = {
    ...Ire,
    transform: e => Math.round((e => Lre(0, 255, e))(e))
  },
  Yae = {
    test: Wae("rgb", "red"),
    parse: Qae("red", "green", "blue"),
    transform: _ref58 => {
      let {
        red: e,
        green: t,
        blue: r,
        alpha: n = 1
      } = _ref58;
      return "rgba(" + Gae.transform(e) + ", " + Gae.transform(t) + ", " + Gae.transform(r) + ", " + Zre(Fre.transform(n)) + ")";
    }
  };
const Kae = {
    test: Wae("#"),
    parse: function (e) {
      let t = "",
        r = "",
        n = "",
        a = "";
      return e.length > 5 ? (t = e.substring(1, 3), r = e.substring(3, 5), n = e.substring(5, 7), a = e.substring(7, 9)) : (t = e.substring(1, 2), r = e.substring(2, 3), n = e.substring(3, 4), a = e.substring(4, 5), t += t, r += r, n += n, a += a), {
        red: parseInt(t, 16),
        green: parseInt(r, 16),
        blue: parseInt(n, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
      };
    },
    transform: Yae.transform
  },
  Xae = {
    test: Wae("hsl", "hue"),
    parse: Qae("hue", "saturation", "lightness"),
    transform: _ref59 => {
      let {
        hue: e,
        saturation: t,
        lightness: r,
        alpha: n = 1
      } = _ref59;
      return "hsla(" + Math.round(e) + ", " + Qre.transform(Zre(t)) + ", " + Qre.transform(Zre(r)) + ", " + Zre(Fre.transform(n)) + ")";
    }
  },
  Jae = {
    test: e => Yae.test(e) || Kae.test(e) || Xae.test(e),
    parse: e => Yae.test(e) ? Yae.parse(e) : Xae.test(e) ? Xae.parse(e) : Kae.parse(e),
    transform: e => $re(e) ? e : e.hasOwnProperty("red") ? Yae.transform(e) : Xae.transform(e)
  },
  eoe = (e, t, r) => -r * e + r * t + e;
function toe(e, t, r) {
  return r < 0 && (r += 1), r > 1 && (r -= 1), r < 1 / 6 ? e + 6 * (t - e) * r : r < .5 ? t : r < 2 / 3 ? e + (t - e) * (2 / 3 - r) * 6 : e;
}
const roe = (e, t, r) => {
    const n = e * e;
    return Math.sqrt(Math.max(0, r * (t * t - n) + n));
  },
  noe = [Kae, Yae, Xae];
function aoe(e) {
  const t = (e => noe.find(t => t.test(e)))(e);
  gae(Boolean(t), "'".concat(e, "' is not an animatable color. Use the equivalent color code instead."));
  let r = t.parse(e);
  return t === Xae && (r = function (_ref60) {
    let {
      hue: e,
      saturation: t,
      lightness: r,
      alpha: n
    } = _ref60;
    e /= 360, r /= 100;
    let a = 0,
      o = 0,
      i = 0;
    if (t /= 100) {
      const n = r < .5 ? r * (1 + t) : r + t - r * t,
        l = 2 * r - n;
      a = toe(l, n, e + 1 / 3), o = toe(l, n, e), i = toe(l, n, e - 1 / 3);
    } else a = o = i = r;
    return {
      red: Math.round(255 * a),
      green: Math.round(255 * o),
      blue: Math.round(255 * i),
      alpha: n
    };
  }(r)), r;
}
const ooe = (e, t) => {
  const r = aoe(e),
    n = aoe(t),
    a = {
      ...r
    };
  return e => (a.red = roe(r.red, n.red, e), a.green = roe(r.green, n.green, e), a.blue = roe(r.blue, n.blue, e), a.alpha = eoe(r.alpha, n.alpha, e), Yae.transform(a));
};
const ioe = {
    regex: /var\s*\(\s*--[\w-]+(\s*,\s*(?:(?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)+)?\s*\)/g,
    countKey: "Vars",
    token: "${v}",
    parse: aae
  },
  loe = {
    regex: qre,
    countKey: "Colors",
    token: "${c}",
    parse: Jae.parse
  },
  soe = {
    regex: Dre,
    countKey: "Numbers",
    token: "${n}",
    parse: Ire.parse
  };
function coe(e, _ref61) {
  let {
    regex: t,
    countKey: r,
    token: n,
    parse: a
  } = _ref61;
  const o = e.tokenised.match(t);
  o && (e["num" + r] = o.length, e.tokenised = e.tokenised.replace(t, n), e.values.push(...o.map(a)));
}
function uoe(e) {
  const t = e.toString(),
    r = {
      value: t,
      tokenised: t,
      values: [],
      numVars: 0,
      numColors: 0,
      numNumbers: 0
    };
  return r.value.includes("var(--") && coe(r, ioe), coe(r, loe), coe(r, soe), r;
}
function hoe(e) {
  return uoe(e).values;
}
function moe(e) {
  const {
      values: t,
      numColors: r,
      numVars: n,
      tokenised: a
    } = uoe(e),
    o = t.length;
  return e => {
    let t = a;
    for (let a = 0; a < o; a++) t = a < n ? t.replace(ioe.token, e[a]) : a < n + r ? t.replace(loe.token, Jae.transform(e[a])) : t.replace(soe.token, Zre(e[a]));
    return t;
  };
}
const poe = e => "number" == typeof e ? 0 : e;
const foe = {
    test: function (e) {
      var t, r;
      return isNaN(e) && $re(e) && ((null === (t = e.match(Dre)) || void 0 === t ? void 0 : t.length) || 0) + ((null === (r = e.match(qre)) || void 0 === r ? void 0 : r.length) || 0) > 0;
    },
    parse: hoe,
    createTransformer: moe,
    getAnimatableNone: function (e) {
      const t = hoe(e);
      return moe(e)(t.map(poe));
    }
  },
  doe = (e, t) => r => "".concat(r > 0 ? t : e);
function voe(e, t) {
  return "number" == typeof e ? r => eoe(e, t, r) : Jae.test(e) ? ooe(e, t) : e.startsWith("var(") ? doe(e, t) : woe(e, t);
}
const goe = (e, t) => {
    const r = [...e],
      n = r.length,
      a = e.map((e, r) => voe(e, t[r]));
    return e => {
      for (let t = 0; t < n; t++) r[t] = a[t](e);
      return r;
    };
  },
  boe = (e, t) => {
    const r = {
        ...e,
        ...t
      },
      n = {};
    for (const a in r) void 0 !== e[a] && void 0 !== t[a] && (n[a] = voe(e[a], t[a]));
    return e => {
      for (const t in n) r[t] = n[t](e);
      return r;
    };
  },
  woe = (e, t) => {
    const r = foe.createTransformer(t),
      n = uoe(e),
      a = uoe(t);
    return n.numVars === a.numVars && n.numColors === a.numColors && n.numNumbers >= a.numNumbers ? _ne(goe(n.values, a.values), r) : (vae(!0, "Complex values '".concat(e, "' and '").concat(t, "' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.")), doe(e, t));
  },
  yoe = (e, t, r) => {
    const n = t - e;
    return 0 === n ? 1 : (r - e) / n;
  },
  xoe = (e, t) => r => eoe(e, t, r);
function Ooe(e, t, r) {
  const n = [],
    a = r || function (e) {
      return "number" == typeof e ? xoe : "string" == typeof e ? Jae.test(e) ? ooe : woe : Array.isArray(e) ? goe : "object" == typeof e ? boe : xoe;
    }(e[0]),
    o = e.length - 1;
  for (let r = 0; r < o; r++) {
    let o = a(e[r], e[r + 1]);
    if (t) {
      const e = Array.isArray(t) ? t[r] || aae : t;
      o = _ne(e, o);
    }
    n.push(o);
  }
  return n;
}
function Eoe(e, t) {
  let {
    clamp: r = !0,
    ease: n,
    mixer: a
  } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const o = e.length;
  if (gae(o === t.length, "Both input and output ranges must be the same length"), 1 === o) return () => t[0];
  e[0] > e[o - 1] && (e = [...e].reverse(), t = [...t].reverse());
  const i = Ooe(t, n, a),
    l = i.length,
    s = t => {
      let r = 0;
      if (l > 1) for (; r < e.length - 2 && !(t < e[r + 1]); r++);
      const n = yoe(e[r], e[r + 1], t);
      return i[r](n);
    };
  return r ? t => s(Lre(e[0], e[o - 1], t)) : s;
}
function joe(e) {
  const t = [0];
  return function (e, t) {
    const r = e[e.length - 1];
    for (let n = 1; n <= t; n++) {
      const a = yoe(0, t, n);
      e.push(eoe(r, 1, a));
    }
  }(t, e.length - 1), t;
}
function Coe(_ref62) {
  let {
    duration: e = 300,
    keyframes: t,
    times: r,
    ease: n = "easeInOut"
  } = _ref62;
  const a = Hae(n) ? n.map(zae) : zae(n),
    o = {
      done: !1,
      value: t[0]
    },
    i = function (e, t) {
      return e.map(e => e * t);
    }(r && r.length === t.length ? r : joe(t), e),
    l = Eoe(i, t, {
      ease: Array.isArray(a) ? a : (s = t, c = a, s.map(() => c || Tae).splice(0, s.length - 1))
    });
  var s, c;
  return {
    calculatedDuration: e,
    next: t => (o.value = l(t), o.done = t >= e, o)
  };
}
function Poe(e, t) {
  return t ? e * (1e3 / t) : 0;
}
const Moe = 5;
function koe(e, t, r) {
  const n = Math.max(t - Moe, 0);
  return Poe(r - e(n), t - n);
}
const Soe = .001,
  Noe = .01,
  Boe = 10,
  Voe = .05,
  Roe = 1;
function Aoe(_ref63) {
  let {
    duration: e = 800,
    bounce: t = .25,
    velocity: r = 0,
    mass: n = 1
  } = _ref63;
  let a, o;
  vae(e <= bae(Boe), "Spring duration must be 10 seconds or less");
  let i = 1 - t;
  i = Lre(Voe, Roe, i), e = Lre(Noe, Boe, wae(e)), i < 1 ? (a = t => {
    const n = t * i,
      a = n * e,
      o = n - r,
      l = Hoe(t, i),
      s = Math.exp(-a);
    return Soe - o / l * s;
  }, o = t => {
    const n = t * i * e,
      o = n * r + r,
      l = Math.pow(i, 2) * Math.pow(t, 2) * e,
      s = Math.exp(-n),
      c = Hoe(Math.pow(t, 2), i);
    return (-a(t) + Soe > 0 ? -1 : 1) * ((o - l) * s) / c;
  }) : (a = t => Math.exp(-t * e) * ((t - r) * e + 1) - Soe, o = t => Math.exp(-t * e) * (e * e * (r - t)));
  const l = function (e, t, r) {
    let n = r;
    for (let r = 1; r < Toe; r++) n -= e(n) / t(n);
    return n;
  }(a, o, 5 / e);
  if (e = bae(e), isNaN(l)) return {
    stiffness: 100,
    damping: 10,
    duration: e
  };
  {
    const t = Math.pow(l, 2) * n;
    return {
      stiffness: t,
      damping: 2 * i * Math.sqrt(n * t),
      duration: e
    };
  }
}
const Toe = 12;
function Hoe(e, t) {
  return e * Math.sqrt(1 - t * t);
}
const Loe = ["duration", "bounce"],
  Ioe = ["stiffness", "damping", "mass"];
function Foe(e, t) {
  return t.some(t => void 0 !== e[t]);
}
function _oe(_ref64) {
  let {
    keyframes: e,
    restDelta: t,
    restSpeed: r,
    ...n
  } = _ref64;
  const a = e[0],
    o = e[e.length - 1],
    i = {
      done: !1,
      value: a
    },
    {
      stiffness: l,
      damping: s,
      mass: c,
      velocity: u,
      duration: h,
      isResolvedFromDuration: m
    } = function (e) {
      let t = {
        velocity: 0,
        stiffness: 100,
        damping: 10,
        mass: 1,
        isResolvedFromDuration: !1,
        ...e
      };
      if (!Foe(e, Ioe) && Foe(e, Loe)) {
        const r = Aoe(e);
        t = {
          ...t,
          ...r,
          velocity: 0,
          mass: 1
        }, t.isResolvedFromDuration = !0;
      }
      return t;
    }(n),
    p = u ? -wae(u) : 0,
    f = s / (2 * Math.sqrt(l * c)),
    d = o - a,
    v = wae(Math.sqrt(l / c)),
    g = Math.abs(d) < 5;
  let b;
  if (r || (r = g ? .01 : 2), t || (t = g ? .005 : .5), f < 1) {
    const e = Hoe(v, f);
    b = t => {
      const r = Math.exp(-f * v * t);
      return o - r * ((p + f * v * d) / e * Math.sin(e * t) + d * Math.cos(e * t));
    };
  } else if (1 === f) b = e => o - Math.exp(-v * e) * (d + (p + v * d) * e);else {
    const e = v * Math.sqrt(f * f - 1);
    b = t => {
      const r = Math.exp(-f * v * t),
        n = Math.min(e * t, 300);
      return o - r * ((p + f * v * d) * Math.sinh(n) + e * d * Math.cosh(n)) / e;
    };
  }
  return {
    calculatedDuration: m && h || null,
    next: e => {
      const n = b(e);
      if (m) i.done = e >= h;else {
        let a = p;
        0 !== e && (a = f < 1 ? koe(b, e, n) : 0);
        const l = Math.abs(a) <= r,
          s = Math.abs(o - n) <= t;
        i.done = l && s;
      }
      return i.value = i.done ? o : n, i;
    }
  };
}
function Zoe(_ref65) {
  let {
    keyframes: e,
    velocity: t = 0,
    power: r = .8,
    timeConstant: n = 325,
    bounceDamping: a = 10,
    bounceStiffness: o = 500,
    modifyTarget: i,
    min: l,
    max: s,
    restDelta: c = .5,
    restSpeed: u
  } = _ref65;
  const h = e[0],
    m = {
      done: !1,
      value: h
    },
    p = e => void 0 === l ? s : void 0 === s || Math.abs(l - e) < Math.abs(s - e) ? l : s;
  let f = r * t;
  const d = h + f,
    v = void 0 === i ? d : i(d);
  v !== d && (f = v - h);
  const g = e => -f * Math.exp(-e / n),
    b = e => v + g(e),
    w = e => {
      const t = g(e),
        r = b(e);
      m.done = Math.abs(t) <= c, m.value = m.done ? v : r;
    };
  let y, x;
  const O = e => {
    (e => void 0 !== l && e < l || void 0 !== s && e > s)(m.value) && (y = e, x = _oe({
      keyframes: [m.value, p(m.value)],
      velocity: koe(b, e, m.value),
      damping: a,
      stiffness: o,
      restDelta: c,
      restSpeed: u
    }));
  };
  return O(0), {
    calculatedDuration: null,
    next: e => {
      let t = !1;
      return x || void 0 !== y || (t = !0, w(e), O(e)), void 0 !== y && e > y ? x.next(e - y) : (!t && w(e), m);
    }
  };
}
const Doe = e => {
    const t = _ref66 => {
      let {
        timestamp: t
      } = _ref66;
      return e(t);
    };
    return {
      start: () => eae.update(t, !0),
      stop: () => tae(t),
      now: () => Wne.isProcessing ? Wne.timestamp : performance.now()
    };
  },
  qoe = 2e4;
function Uoe(e) {
  let t = 0;
  let r = e.next(t);
  for (; !r.done && t < qoe;) t += 50, r = e.next(t);
  return t >= qoe ? 1 / 0 : t;
}
const $oe = {
  decay: Zoe,
  inertia: Zoe,
  tween: Coe,
  keyframes: Coe,
  spring: _oe
};
function zoe(_ref67) {
  let {
    autoplay: e = !0,
    delay: t = 0,
    driver: r = Doe,
    keyframes: n,
    type: a = "keyframes",
    repeat: o = 0,
    repeatDelay: i = 0,
    repeatType: l = "loop",
    onPlay: s,
    onStop: c,
    onComplete: u,
    onUpdate: h,
    ...m
  } = _ref67;
  let p,
    f,
    d = 1,
    v = !1;
  const g = () => {
    p && p(), f = new Promise(e => {
      p = e;
    });
  };
  let b;
  g();
  const w = $oe[a] || Coe;
  let y;
  w !== Coe && "number" != typeof n[0] && (y = Eoe([0, 100], n, {
    clamp: !1
  }), n = [0, 100]);
  const x = w({
    ...m,
    keyframes: n
  });
  let O;
  "mirror" === l && (O = w({
    ...m,
    keyframes: [...n].reverse(),
    velocity: -(m.velocity || 0)
  }));
  let E = "idle",
    j = null,
    C = null,
    P = null;
  null === x.calculatedDuration && o && (x.calculatedDuration = Uoe(x));
  const {
    calculatedDuration: M
  } = x;
  let k = 1 / 0,
    S = 1 / 0;
  null !== M && (k = M + i, S = k * (o + 1) - i);
  let N = 0;
  const B = e => {
      if (null === C) return;
      d > 0 && (C = Math.min(C, e)), N = null !== j ? j : (e - C) * d;
      const r = N - t,
        a = r < 0;
      N = Math.max(r, 0), "finished" === E && null === j && (N = S);
      let s = N,
        c = x;
      if (o) {
        const e = N / k;
        let t = Math.floor(e),
          r = e % 1;
        !r && e >= 1 && (r = 1), 1 === r && t--, t = Math.min(t, o + 1);
        const n = Boolean(t % 2);
        n && ("reverse" === l ? (r = 1 - r, i && (r -= i / k)) : "mirror" === l && (c = O));
        let a = Lre(0, 1, r);
        N > S && (a = "reverse" === l && n ? 1 : 0), s = a * k;
      }
      const u = a ? {
        done: !1,
        value: n[0]
      } : c.next(s);
      y && (u.value = y(u.value));
      let {
        done: m
      } = u;
      a || null === M || (m = N >= S);
      const p = null === j && ("finished" === E || "running" === E && m || d < 0 && N <= 0);
      return h && h(u.value), p && A(), u;
    },
    V = () => {
      b && b.stop(), b = void 0;
    },
    R = () => {
      E = "idle", V(), g(), C = P = null;
    },
    A = () => {
      E = "finished", u && u(), V(), g();
    },
    T = () => {
      if (v) return;
      b || (b = r(B));
      const e = b.now();
      s && s(), null !== j ? C = e - j : C && "finished" !== E || (C = e), P = C, j = null, E = "running", b.start();
    };
  e && T();
  const H = {
    then: (e, t) => f.then(e, t),
    get time() {
      return wae(N);
    },
    set time(e) {
      e = bae(e), N = e, null === j && b && 0 !== d ? C = b.now() - e / d : j = e;
    },
    get duration() {
      const e = null === x.calculatedDuration ? Uoe(x) : x.calculatedDuration;
      return wae(e);
    },
    get speed() {
      return d;
    },
    set speed(e) {
      e !== d && b && (d = e, H.time = wae(N));
    },
    get state() {
      return E;
    },
    play: T,
    pause: () => {
      E = "paused", j = N;
    },
    stop: () => {
      v = !0, "idle" !== E && (E = "idle", c && c(), R());
    },
    cancel: () => {
      null !== P && B(P), R();
    },
    complete: () => {
      E = "finished";
    },
    sample: e => (C = 0, B(e))
  };
  return H;
}
const Woe = new Set(["opacity", "clipPath", "filter", "transform", "backgroundColor"]);
function Qoe(e, t, _ref68) {
  let {
    onUpdate: r,
    onComplete: n,
    ...a
  } = _ref68;
  if (!(kae.waapi() && Woe.has(t) && !a.repeatDelay && "mirror" !== a.repeatType && 0 !== a.damping && "inertia" !== a.type)) return !1;
  let o,
    i,
    l = !1;
  const s = () => {
    i = new Promise(e => {
      o = e;
    });
  };
  s();
  let {
    keyframes: c,
    duration: u = 300,
    ease: h,
    times: m
  } = a;
  if (((e, t) => "spring" === t.type || "backgroundColor" === e || !Oae(t.ease))(t, a)) {
    const e = zoe({
      ...a,
      repeat: 0,
      delay: 0
    });
    let t = {
      done: !1,
      value: c[0]
    };
    const r = [];
    let n = 0;
    for (; !t.done && n < 2e4;) t = e.sample(n), r.push(t.value), n += 10;
    m = void 0, c = r, u = n - 10, h = "linear";
  }
  const p = function (e, t, r) {
      let {
        delay: n = 0,
        duration: a,
        repeat: o = 0,
        repeatType: i = "loop",
        ease: l,
        times: s
      } = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      const c = {
        [t]: r
      };
      s && (c.offset = s);
      const u = Cae(l);
      return Array.isArray(u) && (c.easing = u), e.animate(c, {
        delay: n,
        duration: a,
        easing: Array.isArray(u) ? "linear" : u,
        fill: "both",
        iterations: o + 1,
        direction: "reverse" === i ? "alternate" : "normal"
      });
    }(e.owner.current, t, c, {
      ...a,
      duration: u,
      ease: h,
      times: m
    }),
    f = () => p.cancel(),
    d = () => {
      eae.update(f), o(), s();
    };
  return p.onfinish = () => {
    e.set(function (e, _ref69) {
      let {
        repeat: t,
        repeatType: r = "loop"
      } = _ref69;
      return e[t && "loop" !== r && t % 2 == 1 ? 0 : e.length - 1];
    }(c, a)), n && n(), d();
  }, {
    then: (e, t) => i.then(e, t),
    get time() {
      return wae(p.currentTime || 0);
    },
    set time(e) {
      p.currentTime = bae(e);
    },
    get speed() {
      return p.playbackRate;
    },
    set speed(e) {
      p.playbackRate = e;
    },
    get duration() {
      return wae(u);
    },
    play: () => {
      l || (p.play(), tae(f));
    },
    pause: () => p.pause(),
    stop: () => {
      if (l = !0, "idle" === p.playState) return;
      const {
        currentTime: t
      } = p;
      if (t) {
        const r = zoe({
          ...a,
          autoplay: !1
        });
        e.setWithVelocity(r.sample(t - 10).value, r.sample(t).value, 10);
      }
      d();
    },
    complete: () => p.finish(),
    cancel: d
  };
}
const Goe = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
  },
  Yoe = {
    type: "keyframes",
    duration: .8
  },
  Koe = {
    type: "keyframes",
    ease: [.25, .1, .35, 1],
    duration: .3
  },
  Xoe = (e, _ref70) => {
    let {
      keyframes: t
    } = _ref70;
    return t.length > 2 ? Yoe : kre.has(e) ? e.startsWith("scale") ? {
      type: "spring",
      stiffness: 550,
      damping: 0 === t[1] ? 2 * Math.sqrt(550) : 30,
      restSpeed: 10
    } : Goe : Koe;
  },
  Joe = (e, t) => "zIndex" !== e && (!("number" != typeof t && !Array.isArray(t)) || !("string" != typeof t || !foe.test(t) && "0" !== t || t.startsWith("url("))),
  eie = new Set(["brightness", "contrast", "saturate", "opacity"]);
function tie(e) {
  const [t, r] = e.slice(0, -1).split("(");
  if ("drop-shadow" === t) return e;
  const [n] = r.match(Dre) || [];
  if (!n) return e;
  const a = r.replace(n, "");
  let o = eie.has(t) ? 1 : 0;
  return n !== r && (o *= 100), t + "(" + o + a + ")";
}
const rie = /([a-z-]*)\(.*?\)/g,
  nie = {
    ...foe,
    getAnimatableNone: e => {
      const t = e.match(rie);
      return t ? t.map(tie).join(" ") : e;
    }
  },
  aie = {
    ...ene,
    color: Jae,
    backgroundColor: Jae,
    outlineColor: Jae,
    fill: Jae,
    stroke: Jae,
    borderColor: Jae,
    borderTopColor: Jae,
    borderRightColor: Jae,
    borderBottomColor: Jae,
    borderLeftColor: Jae,
    filter: nie,
    WebkitFilter: nie
  },
  oie = e => aie[e];
function iie(e, t) {
  let r = oie(e);
  return r !== nie && (r = foe), r.getAnimatableNone ? r.getAnimatableNone(t) : void 0;
}
const lie = e => /^0[^.\s]+$/.test(e);
function sie(e) {
  return "number" == typeof e ? 0 === e : null !== e ? "none" === e || "0" === e || lie(e) : void 0;
}
function cie(e, t) {
  return e[t] || e.default || e;
}
const uie = function (e, t, r) {
  let n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return a => {
    const o = cie(n, e) || {},
      i = o.delay || n.delay || 0;
    let {
      elapsed: l = 0
    } = n;
    l -= bae(i);
    const s = function (e, t, r, n) {
        const a = Joe(t, r);
        let o;
        o = Array.isArray(r) ? [...r] : [null, r];
        const i = void 0 !== n.from ? n.from : e.get();
        let l;
        const s = [];
        for (let e = 0; e < o.length; e++) null === o[e] && (o[e] = 0 === e ? i : o[e - 1]), sie(o[e]) && s.push(e), "string" == typeof o[e] && "none" !== o[e] && "0" !== o[e] && (l = o[e]);
        if (a && s.length && l) for (let e = 0; e < s.length; e++) o[s[e]] = iie(t, l);
        return o;
      }(t, e, r, o),
      c = s[0],
      u = s[s.length - 1],
      h = Joe(e, c),
      m = Joe(e, u);
    vae(h === m, "You are trying to animate ".concat(e, " from \"").concat(c, "\" to \"").concat(u, "\". ").concat(c, " is not an animatable value - to enable this animation set ").concat(c, " to a value animatable to ").concat(u, " via the `style` property."));
    let p = {
      keyframes: s,
      velocity: t.getVelocity(),
      ease: "easeOut",
      ...o,
      delay: -l,
      onUpdate: e => {
        t.set(e), o.onUpdate && o.onUpdate(e);
      },
      onComplete: () => {
        a(), o.onComplete && o.onComplete();
      }
    };
    if (function (_ref71) {
      let {
        when: e,
        delay: t,
        delayChildren: r,
        staggerChildren: n,
        staggerDirection: a,
        repeat: o,
        repeatType: i,
        repeatDelay: l,
        from: s,
        elapsed: c,
        ...u
      } = _ref71;
      return !!Object.keys(u).length;
    }(o) || (p = {
      ...p,
      ...Xoe(e, p)
    }), p.duration && (p.duration = bae(p.duration)), p.repeatDelay && (p.repeatDelay = bae(p.repeatDelay)), !h || !m || yae || !1 === o.type) return function (_ref72) {
      let {
        keyframes: e,
        delay: t,
        onUpdate: r,
        onComplete: n
      } = _ref72;
      const a = () => (r && r(e[e.length - 1]), n && n(), {
        time: 0,
        speed: 1,
        duration: 0,
        play: aae,
        pause: aae,
        stop: aae,
        then: e => (e(), Promise.resolve()),
        cancel: aae,
        complete: aae
      });
      return t ? zoe({
        keyframes: [0, 1],
        duration: 0,
        delay: t,
        onComplete: a
      }) : a();
    }(p);
    if (t.owner && t.owner.current instanceof HTMLElement && !t.owner.getProps().onUpdate) {
      const r = Qoe(t, e, p);
      if (r) return r;
    }
    return zoe(p);
  };
};
function hie(e) {
  return Boolean(Nre(e) && e.add);
}
const mie = e => /^\-?\d*\.?\d+$/.test(e);
function pie(e, t) {
  -1 === e.indexOf(t) && e.push(t);
}
function fie(e, t) {
  const r = e.indexOf(t);
  r > -1 && e.splice(r, 1);
}
class die {
  constructor() {
    this.subscriptions = [];
  }
  add(e) {
    return pie(this.subscriptions, e), () => fie(this.subscriptions, e);
  }
  notify(e, t, r) {
    const n = this.subscriptions.length;
    if (n) if (1 === n) this.subscriptions[0](e, t, r);else for (let a = 0; a < n; a++) {
      const n = this.subscriptions[a];
      n && n(e, t, r);
    }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const vie = new Set();
function gie(e, t, r) {
  e || vie.has(t) || (console.warn(t), r && console.warn(r), vie.add(t));
}
class bie {
  constructor(e) {
    var _this = this;
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.version = "10.12.16", this.timeDelta = 0, this.lastUpdated = 0, this.canTrackVelocity = !1, this.events = {}, this.updateAndNotify = function (e) {
      let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      _this.prev = _this.current, _this.current = e;
      const {
        delta: r,
        timestamp: n
      } = Wne;
      _this.lastUpdated !== n && (_this.timeDelta = r, _this.lastUpdated = n, eae.postRender(_this.scheduleVelocityCheck)), _this.prev !== _this.current && _this.events.change && _this.events.change.notify(_this.current), _this.events.velocityChange && _this.events.velocityChange.notify(_this.getVelocity()), t && _this.events.renderRequest && _this.events.renderRequest.notify(_this.current);
    }, this.scheduleVelocityCheck = () => eae.postRender(this.velocityCheck), this.velocityCheck = _ref73 => {
      let {
        timestamp: e
      } = _ref73;
      e !== this.lastUpdated && (this.prev = this.current, this.events.velocityChange && this.events.velocityChange.notify(this.getVelocity()));
    }, this.hasAnimated = !1, this.prev = this.current = e, this.canTrackVelocity = (e => !isNaN(parseFloat(e)))(this.current), this.owner = t.owner;
  }
  onChange(e) {
    return "production" !== process.env.NODE_ENV && gie(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", e);
  }
  on(e, t) {
    this.events[e] || (this.events[e] = new die());
    const r = this.events[e].add(t);
    return "change" === e ? () => {
      r(), eae.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : r;
  }
  clearListeners() {
    for (const e in this.events) this.events[e].clear();
  }
  attach(e, t) {
    this.passiveEffect = e, this.stopPassiveEffect = t;
  }
  set(e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
    t && this.passiveEffect ? this.passiveEffect(e, this.updateAndNotify) : this.updateAndNotify(e, t);
  }
  setWithVelocity(e, t, r) {
    this.set(t), this.prev = e, this.timeDelta = r;
  }
  jump(e) {
    this.updateAndNotify(e), this.prev = e, this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  get() {
    return this.current;
  }
  getPrevious() {
    return this.prev;
  }
  getVelocity() {
    return this.canTrackVelocity ? Poe(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta) : 0;
  }
  start(e) {
    return this.stop(), new Promise(t => {
      this.hasAnimated = !0, this.animation = e(t), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  destroy() {
    this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function wie(e, t) {
  return new bie(e, t);
}
const yie = e => t => t.test(e),
  xie = [Ire, Gre, Qre, Wre, Kre, Yre, {
    test: e => "auto" === e,
    parse: e => e
  }],
  Oie = e => xie.find(yie(e)),
  Eie = [...xie, Jae, foe],
  jie = e => Eie.find(yie(e));
function Cie(e, t, r) {
  e.hasValue(t) ? e.getValue(t).set(r) : e.addValue(t, wie(r));
}
function Pie(e, t) {
  if (!t) return;
  return (t[e] || t.default || t).from;
}
function Mie(_ref74, r) {
  let {
    protectedKeys: e,
    needsAnimating: t
  } = _ref74;
  const n = e.hasOwnProperty(r) && !0 !== t[r];
  return t[r] = !1, n;
}
function kie(e, t) {
  let {
    delay: r = 0,
    transitionOverride: n,
    type: a
  } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  let {
    transition: o = e.getDefaultTransition(),
    transitionEnd: i,
    ...l
  } = e.makeTargetAnimatable(t);
  const s = e.getValue("willChange");
  n && (o = n);
  const c = [],
    u = a && e.animationState && e.animationState.getState()[a];
  for (const t in l) {
    const n = e.getValue(t),
      a = l[t];
    if (!n || void 0 === a || u && Mie(u, t)) continue;
    const i = {
      delay: r,
      elapsed: 0,
      ...o
    };
    if (window.HandoffAppearAnimations && !n.hasAnimated) {
      const r = e.getProps()[dae];
      r && (i.elapsed = window.HandoffAppearAnimations(r, t, n, eae));
    }
    n.start(uie(t, n, a, e.shouldReduceMotion && kre.has(t) ? {
      type: !1
    } : i));
    const h = n.animation;
    hie(s) && (s.add(t), h.then(() => s.remove(t))), c.push(h);
  }
  return i && Promise.all(c).then(() => {
    i && function (e, t) {
      const r = fae(e, t);
      let {
        transitionEnd: n = {},
        transition: a = {},
        ...o
      } = r ? e.makeTargetAnimatable(r, !1) : {};
      o = {
        ...o,
        ...n
      };
      for (const t in o) Cie(e, t, kne(o[t]));
    }(e, i);
  }), c;
}
function Sie(e, t) {
  let r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const n = fae(e, t, r.custom);
  let {
    transition: a = e.getDefaultTransition() || {}
  } = n || {};
  r.transitionOverride && (a = r.transitionOverride);
  const o = n ? () => Promise.all(kie(e, n, r)) : () => Promise.resolve(),
    i = e.variantChildren && e.variantChildren.size ? function () {
      let n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      const {
        delayChildren: o = 0,
        staggerChildren: i,
        staggerDirection: l
      } = a;
      return function (e, t) {
        let r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        let n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        let a = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
        let o = arguments.length > 5 ? arguments[5] : undefined;
        const i = [],
          l = (e.variantChildren.size - 1) * n,
          s = 1 === a ? function () {
            let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            return e * n;
          } : function () {
            let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            return l - e * n;
          };
        return Array.from(e.variantChildren).sort(Nie).forEach((e, n) => {
          e.notify("AnimationStart", t), i.push(Sie(e, t, {
            ...o,
            delay: r + s(n)
          }).then(() => e.notify("AnimationComplete", t)));
        }), Promise.all(i);
      }(e, t, o + n, i, l, r);
    } : () => Promise.resolve(),
    {
      when: l
    } = a;
  if (l) {
    const [e, t] = "beforeChildren" === l ? [o, i] : [i, o];
    return e().then(() => t());
  }
  return Promise.all([o(), i(r.delay)]);
}
function Nie(e, t) {
  return e.sortNodePosition(t);
}
const Bie = [...ure].reverse(),
  Vie = ure.length;
function Rie(e) {
  return t => Promise.all(t.map(_ref75 => {
    let {
      animation: t,
      options: r
    } = _ref75;
    return function (e, t) {
      let r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      let n;
      if (e.notify("AnimationStart", t), Array.isArray(t)) {
        const a = t.map(t => Sie(e, t, r));
        n = Promise.all(a);
      } else if ("string" == typeof t) n = Sie(e, t, r);else {
        const a = "function" == typeof t ? fae(e, t, r.custom) : t;
        n = Promise.all(kie(e, a, r));
      }
      return n.then(() => e.notify("AnimationComplete", t));
    }(e, t, r);
  }));
}
function Aie(e) {
  let t = Rie(e);
  const r = {
    animate: Hie(!0),
    whileInView: Hie(),
    whileHover: Hie(),
    whileTap: Hie(),
    whileDrag: Hie(),
    whileFocus: Hie(),
    exit: Hie()
  };
  let n = !0;
  const a = (t, r) => {
    const n = fae(e, r);
    if (n) {
      const {
        transition: e,
        transitionEnd: r,
        ...a
      } = n;
      t = {
        ...t,
        ...a,
        ...r
      };
    }
    return t;
  };
  function o(o, i) {
    const l = e.getProps(),
      s = e.getVariantContext(!0) || {},
      c = [],
      u = new Set();
    let h = {},
      m = 1 / 0;
    for (let t = 0; t < Vie; t++) {
      const p = Bie[t],
        f = r[p],
        d = void 0 !== l[p] ? l[p] : s[p],
        v = sre(d),
        g = p === i ? f.isActive : null;
      !1 === g && (m = t);
      let b = d === s[p] && d !== l[p] && v;
      if (b && n && e.manuallyAnimateOnMount && (b = !1), f.protectedKeys = {
        ...h
      }, !f.isActive && null === g || !d && !f.prevProp || cre(d) || "boolean" == typeof d) continue;
      const w = Tie(f.prevProp, d);
      let y = w || p === i && f.isActive && !b && v || t > m && v;
      const x = Array.isArray(d) ? d : [d];
      let O = x.reduce(a, {});
      !1 === g && (O = {});
      const {
          prevResolvedValues: E = {}
        } = f,
        j = {
          ...E,
          ...O
        },
        C = e => {
          y = !0, u.delete(e), f.needsAnimating[e] = !0;
        };
      for (const e in j) {
        const t = O[e],
          r = E[e];
        h.hasOwnProperty(e) || (t !== r ? Pne(t) && Pne(r) ? !pae(t, r) || w ? C(e) : f.protectedKeys[e] = !0 : void 0 !== t ? C(e) : u.add(e) : void 0 !== t && u.has(e) ? C(e) : f.protectedKeys[e] = !0);
      }
      f.prevProp = d, f.prevResolvedValues = O, f.isActive && (h = {
        ...h,
        ...O
      }), n && e.blockInitialAnimation && (y = !1), y && !b && c.push(...x.map(e => ({
        animation: e,
        options: {
          type: p,
          ...o
        }
      })));
    }
    if (u.size) {
      const t = {};
      u.forEach(r => {
        const n = e.getBaseTarget(r);
        void 0 !== n && (t[r] = n);
      }), c.push({
        animation: t
      });
    }
    let p = Boolean(c.length);
    return n && !1 === l.initial && !e.manuallyAnimateOnMount && (p = !1), n = !1, p ? t(c) : Promise.resolve();
  }
  return {
    animateChanges: o,
    setActive: function (t, n, a) {
      var i;
      if (r[t].isActive === n) return Promise.resolve();
      null === (i = e.variantChildren) || void 0 === i || i.forEach(e => {
        var r;
        return null === (r = e.animationState) || void 0 === r ? void 0 : r.setActive(t, n);
      }), r[t].isActive = n;
      const l = o(a, t);
      for (const e in r) r[e].protectedKeys = {};
      return l;
    },
    setAnimateFunction: function (r) {
      t = r(e);
    },
    getState: () => r
  };
}
function Tie(e, t) {
  return "string" == typeof t ? t !== e : !!Array.isArray(t) && !pae(t, e);
}
function Hie() {
  let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
  return {
    isActive: e,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
let Lie = 0;
const Iie = {
    animation: {
      Feature: class extends zne {
        constructor(e) {
          super(e), e.animationState || (e.animationState = Aie(e));
        }
        updateAnimationControlsSubscription() {
          const {
            animate: e
          } = this.node.getProps();
          this.unmount(), cre(e) && (this.unmount = e.subscribe(this.node));
        }
        mount() {
          this.updateAnimationControlsSubscription();
        }
        update() {
          const {
              animate: e
            } = this.node.getProps(),
            {
              animate: t
            } = this.node.prevProps || {};
          e !== t && this.updateAnimationControlsSubscription();
        }
        unmount() {}
      }
    },
    exit: {
      Feature: class extends zne {
        constructor() {
          super(...arguments), this.id = Lie++;
        }
        update() {
          if (!this.node.presenceContext) return;
          const {
              isPresent: e,
              onExitComplete: t,
              custom: r
            } = this.node.presenceContext,
            {
              isPresent: n
            } = this.node.prevPresenceContext || {};
          if (!this.node.animationState || e === n) return;
          const a = this.node.animationState.setActive("exit", !e, {
            custom: null != r ? r : this.node.getProps().custom
          });
          t && !e && a.then(() => t(this.id));
        }
        mount() {
          const {
            register: e
          } = this.node.presenceContext || {};
          e && (this.unmount = e(this.id));
        }
        unmount() {}
      }
    }
  },
  Fie = (e, t) => Math.abs(e - t);
class _ie {
  constructor(e, t) {
    let {
      transformPagePoint: r
    } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.updatePoint = () => {
      if (!this.lastMoveEvent || !this.lastMoveEventInfo) return;
      const e = qie(this.lastMoveEventInfo, this.history),
        t = null !== this.startEvent,
        r = function (e, t) {
          const r = Fie(e.x, t.x),
            n = Fie(e.y, t.y);
          return Math.sqrt(r ** 2 + n ** 2);
        }(e.offset, {
          x: 0,
          y: 0
        }) >= 3;
      if (!t && !r) return;
      const {
          point: n
        } = e,
        {
          timestamp: a
        } = Wne;
      this.history.push({
        ...n,
        timestamp: a
      });
      const {
        onStart: o,
        onMove: i
      } = this.handlers;
      t || (o && o(this.lastMoveEvent, e), this.startEvent = this.lastMoveEvent), i && i(this.lastMoveEvent, e);
    }, this.handlePointerMove = (e, t) => {
      this.lastMoveEvent = e, this.lastMoveEventInfo = Zie(t, this.transformPagePoint), eae.update(this.updatePoint, !0);
    }, this.handlePointerUp = (e, t) => {
      if (this.end(), !this.lastMoveEvent || !this.lastMoveEventInfo) return;
      const {
          onEnd: r,
          onSessionEnd: n
        } = this.handlers,
        a = qie("pointercancel" === e.type ? this.lastMoveEventInfo : Zie(t, this.transformPagePoint), this.history);
      this.startEvent && r && r(e, a), n && n(e, a);
    }, !Tne(e)) return;
    this.handlers = t, this.transformPagePoint = r;
    const n = Zie(Hne(e), this.transformPagePoint),
      {
        point: a
      } = n,
      {
        timestamp: o
      } = Wne;
    this.history = [{
      ...a,
      timestamp: o
    }];
    const {
      onSessionStart: i
    } = t;
    i && i(e, qie(n, this.history)), this.removeListeners = _ne(Ine(window, "pointermove", this.handlePointerMove), Ine(window, "pointerup", this.handlePointerUp), Ine(window, "pointercancel", this.handlePointerUp));
  }
  updateHandlers(e) {
    this.handlers = e;
  }
  end() {
    this.removeListeners && this.removeListeners(), tae(this.updatePoint);
  }
}
function Zie(e, t) {
  return t ? {
    point: t(e.point)
  } : e;
}
function Die(e, t) {
  return {
    x: e.x - t.x,
    y: e.y - t.y
  };
}
function qie(_ref76, t) {
  let {
    point: e
  } = _ref76;
  return {
    point: e,
    delta: Die(e, $ie(t)),
    offset: Die(e, Uie(t)),
    velocity: zie(t, .1)
  };
}
function Uie(e) {
  return e[0];
}
function $ie(e) {
  return e[e.length - 1];
}
function zie(e, t) {
  if (e.length < 2) return {
    x: 0,
    y: 0
  };
  let r = e.length - 1,
    n = null;
  const a = $ie(e);
  for (; r >= 0 && (n = e[r], !(a.timestamp - n.timestamp > bae(t)));) r--;
  if (!n) return {
    x: 0,
    y: 0
  };
  const o = wae(a.timestamp - n.timestamp);
  if (0 === o) return {
    x: 0,
    y: 0
  };
  const i = {
    x: (a.x - n.x) / o,
    y: (a.y - n.y) / o
  };
  return i.x === 1 / 0 && (i.x = 0), i.y === 1 / 0 && (i.y = 0), i;
}
function Wie(e) {
  return e.max - e.min;
}
function Qie(e) {
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  let r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : .01;
  return Math.abs(e - t) <= r;
}
function Gie(e, t, r) {
  let n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : .5;
  e.origin = n, e.originPoint = eoe(t.min, t.max, e.origin), e.scale = Wie(r) / Wie(t), (Qie(e.scale, 1, 1e-4) || isNaN(e.scale)) && (e.scale = 1), e.translate = eoe(r.min, r.max, e.origin) - e.originPoint, (Qie(e.translate) || isNaN(e.translate)) && (e.translate = 0);
}
function Yie(e, t, r, n) {
  Gie(e.x, t.x, r.x, n ? n.originX : void 0), Gie(e.y, t.y, r.y, n ? n.originY : void 0);
}
function Kie(e, t, r) {
  e.min = r.min + t.min, e.max = e.min + Wie(t);
}
function Xie(e, t, r) {
  e.min = t.min - r.min, e.max = e.min + Wie(t);
}
function Jie(e, t, r) {
  Xie(e.x, t.x, r.x), Xie(e.y, t.y, r.y);
}
function ele(e, t, r) {
  return {
    min: void 0 !== t ? e.min + t : void 0,
    max: void 0 !== r ? e.max + r - (e.max - e.min) : void 0
  };
}
function tle(e, t) {
  let r = t.min - e.min,
    n = t.max - e.max;
  return t.max - t.min < e.max - e.min && ([r, n] = [n, r]), {
    min: r,
    max: n
  };
}
const rle = .35;
function nle(e, t, r) {
  return {
    min: ale(e, t),
    max: ale(e, r)
  };
}
function ale(e, t) {
  return "number" == typeof e ? e : e[t] || 0;
}
const ole = () => ({
    x: {
      translate: 0,
      scale: 1,
      origin: 0,
      originPoint: 0
    },
    y: {
      translate: 0,
      scale: 1,
      origin: 0,
      originPoint: 0
    }
  }),
  ile = () => ({
    x: {
      min: 0,
      max: 0
    },
    y: {
      min: 0,
      max: 0
    }
  });
function lle(e) {
  return [e("x"), e("y")];
}
function sle(_ref77) {
  let {
    top: e,
    left: t,
    right: r,
    bottom: n
  } = _ref77;
  return {
    x: {
      min: t,
      max: r
    },
    y: {
      min: e,
      max: n
    }
  };
}
function cle(e) {
  return void 0 === e || 1 === e;
}
function ule(_ref78) {
  let {
    scale: e,
    scaleX: t,
    scaleY: r
  } = _ref78;
  return !cle(e) || !cle(t) || !cle(r);
}
function hle(e) {
  return ule(e) || mle(e) || e.z || e.rotate || e.rotateX || e.rotateY;
}
function mle(e) {
  return ple(e.x) || ple(e.y);
}
function ple(e) {
  return e && "0%" !== e;
}
function fle(e, t, r) {
  return r + t * (e - r);
}
function dle(e, t, r, n, a) {
  return void 0 !== a && (e = fle(e, a, n)), fle(e, r, n) + t;
}
function vle(e) {
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  let r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  let n = arguments.length > 3 ? arguments[3] : undefined;
  let a = arguments.length > 4 ? arguments[4] : undefined;
  e.min = dle(e.min, t, r, n, a), e.max = dle(e.max, t, r, n, a);
}
function gle(e, _ref79) {
  let {
    x: t,
    y: r
  } = _ref79;
  vle(e.x, t.translate, t.scale, t.originPoint), vle(e.y, r.translate, r.scale, r.originPoint);
}
function ble(e) {
  return Number.isInteger(e) || e > 1.0000000000001 || e < .999999999999 ? e : 1;
}
function wle(e, t) {
  e.min = e.min + t, e.max = e.max + t;
}
function yle(e, t, _ref80) {
  let [r, n, a] = _ref80;
  const o = void 0 !== t[a] ? t[a] : .5,
    i = eoe(e.min, e.max, o);
  vle(e, t[r], t[n], i, t.scale);
}
const xle = ["x", "scaleX", "originX"],
  Ole = ["y", "scaleY", "originY"];
function Ele(e, t) {
  yle(e.x, t, xle), yle(e.y, t, Ole);
}
function jle(e, t) {
  return sle(function (e, t) {
    if (!t) return e;
    const r = t({
        x: e.left,
        y: e.top
      }),
      n = t({
        x: e.right,
        y: e.bottom
      });
    return {
      top: r.y,
      left: r.x,
      bottom: n.y,
      right: n.x
    };
  }(e.getBoundingClientRect(), t));
}
const Cle = new WeakMap();
class Ple {
  constructor(e) {
    this.openGlobalLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = {
      x: 0,
      y: 0
    }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = ile(), this.visualElement = e;
  }
  start(e) {
    let {
      snapToCursor: t = !1
    } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const {
      presenceContext: r
    } = this.visualElement;
    if (r && !1 === r.isPresent) return;
    this.panSession = new _ie(e, {
      onSessionStart: e => {
        this.stopAnimation(), t && this.snapToCursor(Hne(e, "page").point);
      },
      onStart: (e, t) => {
        const {
          drag: r,
          dragPropagation: n,
          onDragStart: a
        } = this.getProps();
        if (r && !n && (this.openGlobalLock && this.openGlobalLock(), this.openGlobalLock = Une(r), !this.openGlobalLock)) return;
        this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), lle(e => {
          let t = this.getAxisMotionValue(e).get() || 0;
          if (Qre.test(t)) {
            const {
              projection: r
            } = this.visualElement;
            if (r && r.layout) {
              const n = r.layout.layoutBox[e];
              if (n) {
                t = Wie(n) * (parseFloat(t) / 100);
              }
            }
          }
          this.originPoint[e] = t;
        }), a && eae.update(() => a(e, t), !1, !0);
        const {
          animationState: o
        } = this.visualElement;
        o && o.setActive("whileDrag", !0);
      },
      onMove: (e, t) => {
        const {
          dragPropagation: r,
          dragDirectionLock: n,
          onDirectionLock: a,
          onDrag: o
        } = this.getProps();
        if (!r && !this.openGlobalLock) return;
        const {
          offset: i
        } = t;
        if (n && null === this.currentDirection) return this.currentDirection = function (e) {
          let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
          let r = null;
          Math.abs(e.y) > t ? r = "y" : Math.abs(e.x) > t && (r = "x");
          return r;
        }(i), void (null !== this.currentDirection && a && a(this.currentDirection));
        this.updateAxis("x", t.point, i), this.updateAxis("y", t.point, i), this.visualElement.render(), o && o(e, t);
      },
      onSessionEnd: (e, t) => this.stop(e, t)
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint()
    });
  }
  stop(e, t) {
    const r = this.isDragging;
    if (this.cancel(), !r) return;
    const {
      velocity: n
    } = t;
    this.startAnimation(n);
    const {
      onDragEnd: a
    } = this.getProps();
    a && eae.update(() => a(e, t));
  }
  cancel() {
    this.isDragging = !1;
    const {
      projection: e,
      animationState: t
    } = this.visualElement;
    e && (e.isAnimationBlocked = !1), this.panSession && this.panSession.end(), this.panSession = void 0;
    const {
      dragPropagation: r
    } = this.getProps();
    !r && this.openGlobalLock && (this.openGlobalLock(), this.openGlobalLock = null), t && t.setActive("whileDrag", !1);
  }
  updateAxis(e, t, r) {
    const {
      drag: n
    } = this.getProps();
    if (!r || !Mle(e, n, this.currentDirection)) return;
    const a = this.getAxisMotionValue(e);
    let o = this.originPoint[e] + r[e];
    this.constraints && this.constraints[e] && (o = function (e, _ref81, n) {
      let {
        min: t,
        max: r
      } = _ref81;
      return void 0 !== t && e < t ? e = n ? eoe(t, e, n.min) : Math.max(e, t) : void 0 !== r && e > r && (e = n ? eoe(r, e, n.max) : Math.min(e, r)), e;
    }(o, this.constraints[e], this.elastic[e])), a.set(o);
  }
  resolveConstraints() {
    const {
        dragConstraints: e,
        dragElastic: t
      } = this.getProps(),
      {
        layout: r
      } = this.visualElement.projection || {},
      n = this.constraints;
    e && lre(e) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : this.constraints = !(!e || !r) && function (e, _ref82) {
      let {
        top: t,
        left: r,
        bottom: n,
        right: a
      } = _ref82;
      return {
        x: ele(e.x, r, a),
        y: ele(e.y, t, n)
      };
    }(r.layoutBox, e), this.elastic = function () {
      let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rle;
      return !1 === e ? e = 0 : !0 === e && (e = rle), {
        x: nle(e, "left", "right"),
        y: nle(e, "top", "bottom")
      };
    }(t), n !== this.constraints && r && this.constraints && !this.hasMutatedConstraints && lle(e => {
      this.getAxisMotionValue(e) && (this.constraints[e] = function (e, t) {
        const r = {};
        return void 0 !== t.min && (r.min = t.min - e.min), void 0 !== t.max && (r.max = t.max - e.min), r;
      }(r.layoutBox[e], this.constraints[e]));
    });
  }
  resolveRefConstraints() {
    const {
      dragConstraints: e,
      onMeasureDragConstraints: t
    } = this.getProps();
    if (!e || !lre(e)) return !1;
    const r = e.current;
    gae(null !== r, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
    const {
      projection: n
    } = this.visualElement;
    if (!n || !n.layout) return !1;
    const a = function (e, t, r) {
      const n = jle(e, r),
        {
          scroll: a
        } = t;
      return a && (wle(n.x, a.offset.x), wle(n.y, a.offset.y)), n;
    }(r, n.root, this.visualElement.getTransformPagePoint());
    let o = function (e, t) {
      return {
        x: tle(e.x, t.x),
        y: tle(e.y, t.y)
      };
    }(n.layout.layoutBox, a);
    if (t) {
      const e = t(function (_ref83) {
        let {
          x: e,
          y: t
        } = _ref83;
        return {
          top: t.min,
          right: e.max,
          bottom: t.max,
          left: e.min
        };
      }(o));
      this.hasMutatedConstraints = !!e, e && (o = sle(e));
    }
    return o;
  }
  startAnimation(e) {
    const {
        drag: t,
        dragMomentum: r,
        dragElastic: n,
        dragTransition: a,
        dragSnapToOrigin: o,
        onDragTransitionEnd: i
      } = this.getProps(),
      l = this.constraints || {},
      s = lle(i => {
        if (!Mle(i, t, this.currentDirection)) return;
        let s = l && l[i] || {};
        o && (s = {
          min: 0,
          max: 0
        });
        const c = n ? 200 : 1e6,
          u = n ? 40 : 1e7,
          h = {
            type: "inertia",
            velocity: r ? e[i] : 0,
            bounceStiffness: c,
            bounceDamping: u,
            timeConstant: 750,
            restDelta: 1,
            restSpeed: 10,
            ...a,
            ...s
          };
        return this.startAxisValueAnimation(i, h);
      });
    return Promise.all(s).then(i);
  }
  startAxisValueAnimation(e, t) {
    const r = this.getAxisMotionValue(e);
    return r.start(uie(e, r, 0, t));
  }
  stopAnimation() {
    lle(e => this.getAxisMotionValue(e).stop());
  }
  getAxisMotionValue(e) {
    const t = "_drag" + e.toUpperCase(),
      r = this.visualElement.getProps(),
      n = r[t];
    return n || this.visualElement.getValue(e, (r.initial ? r.initial[e] : void 0) || 0);
  }
  snapToCursor(e) {
    lle(t => {
      const {
        drag: r
      } = this.getProps();
      if (!Mle(t, r, this.currentDirection)) return;
      const {
          projection: n
        } = this.visualElement,
        a = this.getAxisMotionValue(t);
      if (n && n.layout) {
        const {
          min: r,
          max: o
        } = n.layout.layoutBox[t];
        a.set(e[t] - eoe(r, o, .5));
      }
    });
  }
  scalePositionWithinConstraints() {
    if (!this.visualElement.current) return;
    const {
        drag: e,
        dragConstraints: t
      } = this.getProps(),
      {
        projection: r
      } = this.visualElement;
    if (!lre(t) || !r || !this.constraints) return;
    this.stopAnimation();
    const n = {
      x: 0,
      y: 0
    };
    lle(e => {
      const t = this.getAxisMotionValue(e);
      if (t) {
        const r = t.get();
        n[e] = function (e, t) {
          let r = .5;
          const n = Wie(e),
            a = Wie(t);
          return a > n ? r = yoe(t.min, t.max - n, e.min) : n > a && (r = yoe(e.min, e.max - a, t.min)), Lre(0, 1, r);
        }({
          min: r,
          max: r
        }, this.constraints[e]);
      }
    });
    const {
      transformTemplate: a
    } = this.visualElement.getProps();
    this.visualElement.current.style.transform = a ? a({}, "") : "none", r.root && r.root.updateScroll(), r.updateLayout(), this.resolveConstraints(), lle(t => {
      if (!Mle(t, e, null)) return;
      const r = this.getAxisMotionValue(t),
        {
          min: a,
          max: o
        } = this.constraints[t];
      r.set(eoe(a, o, n[t]));
    });
  }
  addListeners() {
    if (!this.visualElement.current) return;
    Cle.set(this.visualElement, this);
    const e = Ine(this.visualElement.current, "pointerdown", e => {
        const {
          drag: t,
          dragListener: r = !0
        } = this.getProps();
        t && r && this.start(e);
      }),
      t = () => {
        const {
          dragConstraints: e
        } = this.getProps();
        lre(e) && (this.constraints = this.resolveRefConstraints());
      },
      {
        projection: r
      } = this.visualElement,
      n = r.addEventListener("measure", t);
    r && !r.layout && (r.root && r.root.updateScroll(), r.updateLayout()), t();
    const a = Ane(window, "resize", () => this.scalePositionWithinConstraints()),
      o = r.addEventListener("didUpdate", _ref84 => {
        let {
          delta: e,
          hasLayoutChanged: t
        } = _ref84;
        this.isDragging && t && (lle(t => {
          const r = this.getAxisMotionValue(t);
          r && (this.originPoint[t] += e[t].translate, r.set(r.get() + e[t].translate));
        }), this.visualElement.render());
      });
    return () => {
      a(), e(), n(), o && o();
    };
  }
  getProps() {
    const e = this.visualElement.getProps(),
      {
        drag: t = !1,
        dragDirectionLock: r = !1,
        dragPropagation: n = !1,
        dragConstraints: a = !1,
        dragElastic: o = rle,
        dragMomentum: i = !0
      } = e;
    return {
      ...e,
      drag: t,
      dragDirectionLock: r,
      dragPropagation: n,
      dragConstraints: a,
      dragElastic: o,
      dragMomentum: i
    };
  }
}
function Mle(e, t, r) {
  return !(!0 !== t && t !== e || null !== r && r !== e);
}
const kle = e => (t, r) => {
  e && eae.update(() => e(t, r));
};
const Sle = {
  hasAnimatedSinceResize: !0,
  hasEverUpdated: !1
};
function Nle(e, t) {
  return t.max === t.min ? 0 : e / (t.max - t.min) * 100;
}
const Ble = {
    correct: (e, t) => {
      if (!t.target) return e;
      if ("string" == typeof e) {
        if (!Gre.test(e)) return e;
        e = parseFloat(e);
      }
      return "".concat(Nle(e, t.target.x), "% ").concat(Nle(e, t.target.y), "%");
    }
  },
  Vle = {
    correct: (e, _ref85) => {
      let {
        treeScale: t,
        projectionDelta: r
      } = _ref85;
      const n = e,
        a = foe.parse(e);
      if (a.length > 5) return n;
      const o = foe.createTransformer(e),
        i = "number" != typeof a[0] ? 1 : 0,
        l = r.x.scale * t.x,
        s = r.y.scale * t.y;
      a[0 + i] /= l, a[1 + i] /= s;
      const c = eoe(l, s, .5);
      return "number" == typeof a[2 + i] && (a[2 + i] /= c), "number" == typeof a[3 + i] && (a[3 + i] /= c), o(a);
    }
  };
class Rle extends t.Component {
  componentDidMount() {
    const {
        visualElement: e,
        layoutGroup: t,
        switchLayoutGroup: r,
        layoutId: n
      } = this.props,
      {
        projection: a
      } = e;
    var o;
    o = Tle, Object.assign(Pre, o), a && (t.group && t.group.add(a), r && r.register && n && r.register(a), a.root.didUpdate(), a.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), a.setOptions({
      ...a.options,
      onExitComplete: () => this.safeToRemove()
    })), Sle.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(e) {
    const {
        layoutDependency: t,
        visualElement: r,
        drag: n,
        isPresent: a
      } = this.props,
      o = r.projection;
    return o ? (o.isPresent = a, n || e.layoutDependency !== t || void 0 === t ? o.willUpdate() : this.safeToRemove(), e.isPresent !== a && (a ? o.promote() : o.relegate() || eae.postRender(() => {
      const e = o.getStack();
      e && e.members.length || this.safeToRemove();
    })), null) : null;
  }
  componentDidUpdate() {
    const {
      projection: e
    } = this.props.visualElement;
    e && (e.root.didUpdate(), queueMicrotask(() => {
      !e.currentAnimation && e.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const {
        visualElement: e,
        layoutGroup: t,
        switchLayoutGroup: r
      } = this.props,
      {
        projection: n
      } = e;
    n && (n.scheduleCheckAfterUnmount(), t && t.group && t.group.remove(n), r && r.deregister && r.deregister(n));
  }
  safeToRemove() {
    const {
      safeToRemove: e
    } = this.props;
    e && e();
  }
  render() {
    return null;
  }
}
function Ale(e) {
  const [r, n] = function () {
      const e = m(nre);
      if (null === e) return [!0, null];
      const {
          isPresent: t,
          onExitComplete: r,
          register: n
        } = e,
        o = b();
      return a(() => n(o), []), !t && r ? [!1, () => r && r(o)] : [!0];
    }(),
    o = m(bre);
  return t.createElement(Rle, {
    ...e,
    layoutGroup: o,
    switchLayoutGroup: m(wre),
    isPresent: r,
    safeToRemove: n
  });
}
const Tle = {
    borderRadius: {
      ...Ble,
      applyTo: ["borderTopLeftRadius", "borderTopRightRadius", "borderBottomLeftRadius", "borderBottomRightRadius"]
    },
    borderTopLeftRadius: Ble,
    borderTopRightRadius: Ble,
    borderBottomLeftRadius: Ble,
    borderBottomRightRadius: Ble,
    boxShadow: Vle
  },
  Hle = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"],
  Lle = Hle.length,
  Ile = e => "string" == typeof e ? parseFloat(e) : e,
  Fle = e => "number" == typeof e || Gre.test(e);
function _le(e, t) {
  return void 0 !== e[t] ? e[t] : e.borderRadius;
}
const Zle = qle(0, .5, _ae),
  Dle = qle(.5, .95, aae);
function qle(e, t, r) {
  return n => n < e ? 0 : n > t ? 1 : r(yoe(e, t, n));
}
function Ule(e, t) {
  e.min = t.min, e.max = t.max;
}
function $le(e, t) {
  Ule(e.x, t.x), Ule(e.y, t.y);
}
function zle(e, t, r, n, a) {
  return e = fle(e -= t, 1 / r, n), void 0 !== a && (e = fle(e, 1 / a, n)), e;
}
function Wle(e, t, _ref86, o, i) {
  let [r, n, a] = _ref86;
  !function (e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    let r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    let n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : .5;
    let a = arguments.length > 4 ? arguments[4] : undefined;
    let o = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : e;
    let i = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : e;
    Qre.test(t) && (t = parseFloat(t), t = eoe(i.min, i.max, t / 100) - i.min);
    if ("number" != typeof t) return;
    let l = eoe(o.min, o.max, n);
    e === o && (l -= t), e.min = zle(e.min, t, r, l, a), e.max = zle(e.max, t, r, l, a);
  }(e, t[r], t[n], t[a], t.scale, o, i);
}
const Qle = ["x", "scaleX", "originX"],
  Gle = ["y", "scaleY", "originY"];
function Yle(e, t, r, n) {
  Wle(e.x, t, Qle, r ? r.x : void 0, n ? n.x : void 0), Wle(e.y, t, Gle, r ? r.y : void 0, n ? n.y : void 0);
}
function Kle(e) {
  return 0 === e.translate && 1 === e.scale;
}
function Xle(e) {
  return Kle(e.x) && Kle(e.y);
}
function Jle(e, t) {
  return e.x.min === t.x.min && e.x.max === t.x.max && e.y.min === t.y.min && e.y.max === t.y.max;
}
function ese(e) {
  return Wie(e.x) / Wie(e.y);
}
class tse {
  constructor() {
    this.members = [];
  }
  add(e) {
    pie(this.members, e), e.scheduleRender();
  }
  remove(e) {
    if (fie(this.members, e), e === this.prevLead && (this.prevLead = void 0), e === this.lead) {
      const e = this.members[this.members.length - 1];
      e && this.promote(e);
    }
  }
  relegate(e) {
    const t = this.members.findIndex(t => e === t);
    if (0 === t) return !1;
    let r;
    for (let e = t; e >= 0; e--) {
      const t = this.members[e];
      if (!1 !== t.isPresent) {
        r = t;
        break;
      }
    }
    return !!r && (this.promote(r), !0);
  }
  promote(e, t) {
    const r = this.lead;
    if (e !== r && (this.prevLead = r, this.lead = e, e.show(), r)) {
      r.instance && r.scheduleRender(), e.scheduleRender(), e.resumeFrom = r, t && (e.resumeFrom.preserveOpacity = !0), r.snapshot && (e.snapshot = r.snapshot, e.snapshot.latestValues = r.animationValues || r.latestValues), e.root && e.root.isUpdating && (e.isLayoutDirty = !0);
      const {
        crossfade: n
      } = e.options;
      !1 === n && r.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach(e => {
      const {
        options: t,
        resumingFrom: r
      } = e;
      t.onExitComplete && t.onExitComplete(), r && r.options.onExitComplete && r.options.onExitComplete();
    });
  }
  scheduleRender() {
    this.members.forEach(e => {
      e.instance && e.scheduleRender(!1);
    });
  }
  removeLeadSnapshot() {
    this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
  }
}
function rse(e, t, r) {
  let n = "";
  const a = e.x.translate / t.x,
    o = e.y.translate / t.y;
  if ((a || o) && (n = "translate3d(".concat(a, "px, ").concat(o, "px, 0) ")), 1 === t.x && 1 === t.y || (n += "scale(".concat(1 / t.x, ", ").concat(1 / t.y, ") ")), r) {
    const {
      rotate: e,
      rotateX: t,
      rotateY: a
    } = r;
    e && (n += "rotate(".concat(e, "deg) ")), t && (n += "rotateX(".concat(t, "deg) ")), a && (n += "rotateY(".concat(a, "deg) "));
  }
  const i = e.x.scale * t.x,
    l = e.y.scale * t.y;
  return 1 === i && 1 === l || (n += "scale(".concat(i, ", ").concat(l, ")")), n || "none";
}
const nse = (e, t) => e.depth - t.depth;
class ase {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(e) {
    pie(this.children, e), this.isDirty = !0;
  }
  remove(e) {
    fie(this.children, e), this.isDirty = !0;
  }
  forEach(e) {
    this.isDirty && this.children.sort(nse), this.isDirty = !1, this.children.forEach(e);
  }
}
const ose = ["", "X", "Y", "Z"];
let ise = 0;
const lse = {
  type: "projectionFrame",
  totalNodes: 0,
  resolvedTargetDeltas: 0,
  recalculatedProjection: 0
};
function sse(_ref87) {
  let {
    attachResizeListener: e,
    defaultParent: t,
    measureScroll: r,
    checkIsScrollRoot: n,
    resetTransform: a
  } = _ref87;
  return class {
    constructor() {
      let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      let r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null == t ? void 0 : t();
      this.id = ise++, this.animationId = 0, this.children = new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.treeScale = {
        x: 1,
        y: 1
      }, this.eventHandlers = new Map(), this.hasTreeAnimated = !1, this.updateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        var e;
        lse.totalNodes = lse.resolvedTargetDeltas = lse.recalculatedProjection = 0, this.nodes.forEach(hse), this.nodes.forEach(bse), this.nodes.forEach(wse), this.nodes.forEach(mse), e = lse, window.MotionDebug && window.MotionDebug.record(e);
      }, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = new Map(), this.latestValues = e, this.root = r ? r.root || r : this, this.path = r ? [...r.path, r] : [], this.parent = r, this.depth = r ? r.depth + 1 : 0;
      for (let e = 0; e < this.path.length; e++) this.path[e].shouldResetTransform = !0;
      this.root === this && (this.nodes = new ase());
    }
    addEventListener(e, t) {
      return this.eventHandlers.has(e) || this.eventHandlers.set(e, new die()), this.eventHandlers.get(e).add(t);
    }
    notifyListeners(e) {
      const r = this.eventHandlers.get(e);
      for (var _len13 = arguments.length, t = new Array(_len13 > 1 ? _len13 - 1 : 0), _key13 = 1; _key13 < _len13; _key13++) {
        t[_key13 - 1] = arguments[_key13];
      }
      r && r.notify(...t);
    }
    hasListeners(e) {
      return this.eventHandlers.has(e);
    }
    mount(t) {
      let r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.root.hasTreeAnimated;
      if (this.instance) return;
      var n;
      this.isSVG = (n = t) instanceof SVGElement && "svg" !== n.tagName, this.instance = t;
      const {
        layoutId: a,
        layout: o,
        visualElement: i
      } = this.options;
      if (i && !i.current && i.mount(t), this.root.nodes.add(this), this.parent && this.parent.children.add(this), r && (o || a) && (this.isLayoutDirty = !0), e) {
        let r;
        const n = () => this.root.updateBlockedByResize = !1;
        e(t, () => {
          this.root.updateBlockedByResize = !0, r && r(), r = function (e, t) {
            const r = performance.now(),
              n = _ref88 => {
                let {
                  timestamp: a
                } = _ref88;
                const o = a - r;
                o >= t && (tae(n), e(o - t));
              };
            return eae.read(n, !0), () => tae(n);
          }(n, 250), Sle.hasAnimatedSinceResize && (Sle.hasAnimatedSinceResize = !1, this.nodes.forEach(gse));
        });
      }
      a && this.root.registerSharedNode(a, this), !1 !== this.options.animate && i && (a || o) && this.addEventListener("didUpdate", _ref89 => {
        let {
          delta: e,
          hasLayoutChanged: t,
          hasRelativeTargetChanged: r,
          layout: n
        } = _ref89;
        if (this.isTreeAnimationBlocked()) return this.target = void 0, void (this.relativeTarget = void 0);
        const a = this.options.transition || i.getDefaultTransition() || Cse,
          {
            onLayoutAnimationStart: o,
            onLayoutAnimationComplete: l
          } = i.getProps(),
          s = !this.targetLayout || !Jle(this.targetLayout, n) || r,
          c = !t && r;
        if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || c || t && (s || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0), this.setAnimationOrigin(e, c);
          const t = {
            ...cie(a, "layout"),
            onPlay: o,
            onComplete: l
          };
          (i.shouldReduceMotion || this.options.layoutRoot) && (t.delay = 0, t.type = !1), this.startAnimation(t);
        } else t || gse(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = n;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const e = this.getStack();
      e && e.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, tae(this.updateProjection);
    }
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(yse), this.animationId++);
    }
    getTransformTemplate() {
      const {
        visualElement: e
      } = this.options;
      return e && e.getProps().transformTemplate;
    }
    willUpdate() {
      let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) return void (this.options.onExitComplete && this.options.onExitComplete());
      if (!this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty) return;
      this.isLayoutDirty = !0;
      for (let e = 0; e < this.path.length; e++) {
        const t = this.path[e];
        t.shouldResetTransform = !0, t.updateScroll("snapshot"), t.options.layoutRoot && t.willUpdate(!1);
      }
      const {
        layoutId: t,
        layout: r
      } = this.options;
      if (void 0 === t && !r) return;
      const n = this.getTransformTemplate();
      this.prevTransformTemplateValue = n ? n(this.latestValues, "") : void 0, this.updateSnapshot(), e && this.notifyListeners("willUpdate");
    }
    update() {
      this.updateScheduled = !1;
      if (this.isUpdateBlocked()) return this.unblockUpdate(), this.clearAllSnapshots(), void this.nodes.forEach(fse);
      this.isUpdating || this.nodes.forEach(dse), this.isUpdating = !1, this.nodes.forEach(vse), this.nodes.forEach(cse), this.nodes.forEach(use), this.clearAllSnapshots();
      const e = performance.now();
      Wne.delta = Lre(0, 1e3 / 60, e - Wne.timestamp), Wne.timestamp = e, Wne.isProcessing = !0, Kne.update.process(Wne), Kne.preRender.process(Wne), Kne.render.process(Wne), Wne.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, queueMicrotask(() => this.update()));
    }
    clearAllSnapshots() {
      this.nodes.forEach(pse), this.sharedNodes.forEach(xse);
    }
    scheduleUpdateProjection() {
      eae.preRender(this.updateProjection, !1, !0);
    }
    scheduleCheckAfterUnmount() {
      eae.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    updateSnapshot() {
      !this.snapshot && this.instance && (this.snapshot = this.measure());
    }
    updateLayout() {
      if (!this.instance) return;
      if (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead() || this.isLayoutDirty)) return;
      if (this.resumeFrom && !this.resumeFrom.instance) for (let e = 0; e < this.path.length; e++) {
        this.path[e].updateScroll();
      }
      const e = this.layout;
      this.layout = this.measure(!1), this.layoutCorrected = ile(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const {
        visualElement: t
      } = this.options;
      t && t.notify("LayoutMeasure", this.layout.layoutBox, e ? e.layoutBox : void 0);
    }
    updateScroll() {
      let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "measure";
      let t = Boolean(this.options.layoutScroll && this.instance);
      this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === e && (t = !1), t && (this.scroll = {
        animationId: this.root.animationId,
        phase: e,
        isRoot: n(this.instance),
        offset: r(this.instance)
      });
    }
    resetTransform() {
      if (!a) return;
      const e = this.isLayoutDirty || this.shouldResetTransform,
        t = this.projectionDelta && !Xle(this.projectionDelta),
        r = this.getTransformTemplate(),
        n = r ? r(this.latestValues, "") : void 0,
        o = n !== this.prevTransformTemplateValue;
      e && (t || hle(this.latestValues) || o) && (a(this.instance, n), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure() {
      let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
      const t = this.measurePageBox();
      let r = this.removeElementScroll(t);
      var n;
      return e && (r = this.removeTransform(r)), Pse((n = r).x), Pse(n.y), {
        animationId: this.root.animationId,
        measuredBox: t,
        layoutBox: r,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      const {
        visualElement: e
      } = this.options;
      if (!e) return ile();
      const t = e.measureViewportBox(),
        {
          scroll: r
        } = this.root;
      return r && (wle(t.x, r.offset.x), wle(t.y, r.offset.y)), t;
    }
    removeElementScroll(e) {
      const t = ile();
      $le(t, e);
      for (let r = 0; r < this.path.length; r++) {
        const n = this.path[r],
          {
            scroll: a,
            options: o
          } = n;
        if (n !== this.root && a && o.layoutScroll) {
          if (a.isRoot) {
            $le(t, e);
            const {
              scroll: r
            } = this.root;
            r && (wle(t.x, -r.offset.x), wle(t.y, -r.offset.y));
          }
          wle(t.x, a.offset.x), wle(t.y, a.offset.y);
        }
      }
      return t;
    }
    applyTransform(e) {
      let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      const r = ile();
      $le(r, e);
      for (let e = 0; e < this.path.length; e++) {
        const n = this.path[e];
        !t && n.options.layoutScroll && n.scroll && n !== n.root && Ele(r, {
          x: -n.scroll.offset.x,
          y: -n.scroll.offset.y
        }), hle(n.latestValues) && Ele(r, n.latestValues);
      }
      return hle(this.latestValues) && Ele(r, this.latestValues), r;
    }
    removeTransform(e) {
      const t = ile();
      $le(t, e);
      for (let e = 0; e < this.path.length; e++) {
        const r = this.path[e];
        if (!r.instance) continue;
        if (!hle(r.latestValues)) continue;
        ule(r.latestValues) && r.updateSnapshot();
        const n = ile();
        $le(n, r.measurePageBox()), Yle(t, r.latestValues, r.snapshot ? r.snapshot.layoutBox : void 0, n);
      }
      return hle(this.latestValues) && Yle(t, this.latestValues), t;
    }
    setTargetDelta(e) {
      this.targetDelta = e, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(e) {
      this.options = {
        ...this.options,
        ...e,
        crossfade: void 0 === e.crossfade || e.crossfade
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== Wne.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta() {
      let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      var t;
      const r = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = r.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = r.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = r.isSharedProjectionDirty);
      const n = Boolean(this.resumingFrom) || this !== r;
      if (!(e || n && this.isSharedProjectionDirty || this.isProjectionDirty || (null === (t = this.parent) || void 0 === t ? void 0 : t.isProjectionDirty) || this.attemptToResolveRelativeTarget)) return;
      const {
        layout: a,
        layoutId: o
      } = this.options;
      if (this.layout && (a || o)) {
        if (this.resolvedRelativeTargetAt = Wne.timestamp, !this.targetDelta && !this.relativeTarget) {
          const e = this.getClosestProjectingParent();
          e && e.layout && 1 !== this.animationProgress ? (this.relativeParent = e, this.forceRelativeParentToResolveTarget(), this.relativeTarget = ile(), this.relativeTargetOrigin = ile(), Jie(this.relativeTargetOrigin, this.layout.layoutBox, e.layout.layoutBox), $le(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
        if (this.relativeTarget || this.targetDelta) {
          var i, l, s;
          if (this.target || (this.target = ile(), this.targetWithTransforms = ile()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), i = this.target, l = this.relativeTarget, s = this.relativeParent.target, Kie(i.x, l.x, s.x), Kie(i.y, l.y, s.y)) : this.targetDelta ? (Boolean(this.resumingFrom) ? this.target = this.applyTransform(this.layout.layoutBox) : $le(this.target, this.layout.layoutBox), gle(this.target, this.targetDelta)) : $le(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget) {
            this.attemptToResolveRelativeTarget = !1;
            const e = this.getClosestProjectingParent();
            e && Boolean(e.resumingFrom) === Boolean(this.resumingFrom) && !e.options.layoutScroll && e.target && 1 !== this.animationProgress ? (this.relativeParent = e, this.forceRelativeParentToResolveTarget(), this.relativeTarget = ile(), this.relativeTargetOrigin = ile(), Jie(this.relativeTargetOrigin, this.target, e.target), $le(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
          }
          lse.resolvedTargetDeltas++;
        }
      }
    }
    getClosestProjectingParent() {
      if (this.parent && !ule(this.parent.latestValues) && !mle(this.parent.latestValues)) return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    calcProjection() {
      var e;
      const t = this.getLead(),
        r = Boolean(this.resumingFrom) || this !== t;
      let n = !0;
      if ((this.isProjectionDirty || (null === (e = this.parent) || void 0 === e ? void 0 : e.isProjectionDirty)) && (n = !1), r && (this.isSharedProjectionDirty || this.isTransformDirty) && (n = !1), this.resolvedRelativeTargetAt === Wne.timestamp && (n = !1), n) return;
      const {
        layout: a,
        layoutId: o
      } = this.options;
      if (this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !a && !o) return;
      $le(this.layoutCorrected, this.layout.layoutBox);
      const i = this.treeScale.x,
        l = this.treeScale.y;
      !function (e, t, r) {
        let n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
        const a = r.length;
        if (!a) return;
        let o, i;
        t.x = t.y = 1;
        for (let l = 0; l < a; l++) {
          o = r[l], i = o.projectionDelta;
          const a = o.instance;
          a && a.style && "contents" === a.style.display || (n && o.options.layoutScroll && o.scroll && o !== o.root && Ele(e, {
            x: -o.scroll.offset.x,
            y: -o.scroll.offset.y
          }), i && (t.x *= i.x.scale, t.y *= i.y.scale, gle(e, i)), n && hle(o.latestValues) && Ele(e, o.latestValues));
        }
        t.x = ble(t.x), t.y = ble(t.y);
      }(this.layoutCorrected, this.treeScale, this.path, r), !t.layout || t.target || 1 === this.treeScale.x && 1 === this.treeScale.y || (t.target = t.layout.layoutBox);
      const {
        target: s
      } = t;
      if (!s) return void (this.projectionTransform && (this.projectionDelta = ole(), this.projectionTransform = "none", this.scheduleRender()));
      this.projectionDelta || (this.projectionDelta = ole(), this.projectionDeltaWithTransform = ole());
      const c = this.projectionTransform;
      Yie(this.projectionDelta, this.layoutCorrected, s, this.latestValues), this.projectionTransform = rse(this.projectionDelta, this.treeScale), this.projectionTransform === c && this.treeScale.x === i && this.treeScale.y === l || (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", s)), lse.recalculatedProjection++;
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender() {
      let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
      if (this.options.scheduleRender && this.options.scheduleRender(), e) {
        const e = this.getStack();
        e && e.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    setAnimationOrigin(e) {
      let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      const r = this.snapshot,
        n = r ? r.latestValues : {},
        a = {
          ...this.latestValues
        },
        o = ole();
      this.relativeParent && this.relativeParent.options.layoutRoot || (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !t;
      const i = ile(),
        l = (r ? r.source : void 0) !== (this.layout ? this.layout.source : void 0),
        s = this.getStack(),
        c = !s || s.members.length <= 1,
        u = Boolean(l && !c && !0 === this.options.crossfade && !this.path.some(jse));
      let h;
      this.animationProgress = 0, this.mixTargetDelta = t => {
        const r = t / 1e3;
        Ose(o.x, e.x, r), Ose(o.y, e.y, r), this.setTargetDelta(o), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (Jie(i, this.layout.layoutBox, this.relativeParent.layout.layoutBox), function (e, t, r, n) {
          Ese(e.x, t.x, r.x, n), Ese(e.y, t.y, r.y, n);
        }(this.relativeTarget, this.relativeTargetOrigin, i, r), h && Jle(this.relativeTarget, h) && (this.isProjectionDirty = !1), h || (h = ile()), $le(h, this.relativeTarget)), l && (this.animationValues = a, function (e, t, r, n, a, o) {
          a ? (e.opacity = eoe(0, void 0 !== r.opacity ? r.opacity : 1, Zle(n)), e.opacityExit = eoe(void 0 !== t.opacity ? t.opacity : 1, 0, Dle(n))) : o && (e.opacity = eoe(void 0 !== t.opacity ? t.opacity : 1, void 0 !== r.opacity ? r.opacity : 1, n));
          for (let a = 0; a < Lle; a++) {
            const o = "border".concat(Hle[a], "Radius");
            let i = _le(t, o),
              l = _le(r, o);
            void 0 === i && void 0 === l || (i || (i = 0), l || (l = 0), 0 === i || 0 === l || Fle(i) === Fle(l) ? (e[o] = Math.max(eoe(Ile(i), Ile(l), n), 0), (Qre.test(l) || Qre.test(i)) && (e[o] += "%")) : e[o] = l);
          }
          (t.rotate || r.rotate) && (e.rotate = eoe(t.rotate || 0, r.rotate || 0, n));
        }(a, n, this.latestValues, r, u, c)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = r;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(e) {
      this.notifyListeners("animationStart"), this.currentAnimation && this.currentAnimation.stop(), this.resumingFrom && this.resumingFrom.currentAnimation && this.resumingFrom.currentAnimation.stop(), this.pendingAnimation && (tae(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = eae.update(() => {
        Sle.hasAnimatedSinceResize = !0, this.currentAnimation = function (e, t, r) {
          const n = Nre(e) ? e : wie(e);
          return n.start(uie("", n, t, r)), n.animation;
        }(0, 1e3, {
          ...e,
          onUpdate: t => {
            this.mixTargetDelta(t), e.onUpdate && e.onUpdate(t);
          },
          onComplete: () => {
            e.onComplete && e.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const e = this.getStack();
      e && e.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(1e3), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const e = this.getLead();
      let {
        targetWithTransforms: t,
        target: r,
        layout: n,
        latestValues: a
      } = e;
      if (t && r && n) {
        if (this !== e && this.layout && n && Mse(this.options.animationType, this.layout.layoutBox, n.layoutBox)) {
          r = this.target || ile();
          const t = Wie(this.layout.layoutBox.x);
          r.x.min = e.target.x.min, r.x.max = r.x.min + t;
          const n = Wie(this.layout.layoutBox.y);
          r.y.min = e.target.y.min, r.y.max = r.y.min + n;
        }
        $le(t, r), Ele(t, a), Yie(this.projectionDeltaWithTransform, this.layoutCorrected, t, a);
      }
    }
    registerSharedNode(e, t) {
      this.sharedNodes.has(e) || this.sharedNodes.set(e, new tse());
      this.sharedNodes.get(e).add(t);
      const r = t.options.initialPromotionConfig;
      t.promote({
        transition: r ? r.transition : void 0,
        preserveFollowOpacity: r && r.shouldPreserveFollowOpacity ? r.shouldPreserveFollowOpacity(t) : void 0
      });
    }
    isLead() {
      const e = this.getStack();
      return !e || e.lead === this;
    }
    getLead() {
      var e;
      const {
        layoutId: t
      } = this.options;
      return t && (null === (e = this.getStack()) || void 0 === e ? void 0 : e.lead) || this;
    }
    getPrevLead() {
      var e;
      const {
        layoutId: t
      } = this.options;
      return t ? null === (e = this.getStack()) || void 0 === e ? void 0 : e.prevLead : void 0;
    }
    getStack() {
      const {
        layoutId: e
      } = this.options;
      if (e) return this.root.sharedNodes.get(e);
    }
    promote() {
      let {
        needsReset: e,
        transition: t,
        preserveFollowOpacity: r
      } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      const n = this.getStack();
      n && n.promote(this, r), e && (this.projectionDelta = void 0, this.needsReset = !0), t && this.setOptions({
        transition: t
      });
    }
    relegate() {
      const e = this.getStack();
      return !!e && e.relegate(this);
    }
    resetRotation() {
      const {
        visualElement: e
      } = this.options;
      if (!e) return;
      let t = !1;
      const {
        latestValues: r
      } = e;
      if ((r.rotate || r.rotateX || r.rotateY || r.rotateZ) && (t = !0), !t) return;
      const n = {};
      for (let t = 0; t < ose.length; t++) {
        const a = "rotate" + ose[t];
        r[a] && (n[a] = r[a], e.setStaticValue(a, 0));
      }
      e.render();
      for (const t in n) e.setStaticValue(t, n[t]);
      e.scheduleRender();
    }
    getProjectionStyles() {
      let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var t, r;
      const n = {};
      if (!this.instance || this.isSVG) return n;
      if (!this.isVisible) return {
        visibility: "hidden"
      };
      n.visibility = "";
      const a = this.getTransformTemplate();
      if (this.needsReset) return this.needsReset = !1, n.opacity = "", n.pointerEvents = Sne(e.pointerEvents) || "", n.transform = a ? a(this.latestValues, "") : "none", n;
      const o = this.getLead();
      if (!this.projectionDelta || !this.layout || !o.target) {
        const t = {};
        return this.options.layoutId && (t.opacity = void 0 !== this.latestValues.opacity ? this.latestValues.opacity : 1, t.pointerEvents = Sne(e.pointerEvents) || ""), this.hasProjected && !hle(this.latestValues) && (t.transform = a ? a({}, "") : "none", this.hasProjected = !1), t;
      }
      const i = o.animationValues || o.latestValues;
      this.applyTransformsToTarget(), n.transform = rse(this.projectionDeltaWithTransform, this.treeScale, i), a && (n.transform = a(i, n.transform));
      const {
        x: l,
        y: s
      } = this.projectionDelta;
      n.transformOrigin = "".concat(100 * l.origin, "% ").concat(100 * s.origin, "% 0"), o.animationValues ? n.opacity = o === this ? null !== (r = null !== (t = i.opacity) && void 0 !== t ? t : this.latestValues.opacity) && void 0 !== r ? r : 1 : this.preserveOpacity ? this.latestValues.opacity : i.opacityExit : n.opacity = o === this ? void 0 !== i.opacity ? i.opacity : "" : void 0 !== i.opacityExit ? i.opacityExit : 0;
      for (const e in Pre) {
        if (void 0 === i[e]) continue;
        const {
            correct: t,
            applyTo: r
          } = Pre[e],
          a = "none" === n.transform ? i[e] : t(i[e], o);
        if (r) {
          const e = r.length;
          for (let t = 0; t < e; t++) n[r[t]] = a;
        } else n[e] = a;
      }
      return this.options.layoutId && (n.pointerEvents = o === this ? Sne(e.pointerEvents) || "" : "none"), n;
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    resetTree() {
      this.root.nodes.forEach(e => {
        var t;
        return null === (t = e.currentAnimation) || void 0 === t ? void 0 : t.stop();
      }), this.root.nodes.forEach(fse), this.root.sharedNodes.clear();
    }
  };
}
function cse(e) {
  e.updateLayout();
}
function use(e) {
  var t;
  const r = (null === (t = e.resumeFrom) || void 0 === t ? void 0 : t.snapshot) || e.snapshot;
  if (e.isLead() && e.layout && r && e.hasListeners("didUpdate")) {
    const {
        layoutBox: t,
        measuredBox: n
      } = e.layout,
      {
        animationType: a
      } = e.options,
      o = r.source !== e.layout.source;
    "size" === a ? lle(e => {
      const n = o ? r.measuredBox[e] : r.layoutBox[e],
        a = Wie(n);
      n.min = t[e].min, n.max = n.min + a;
    }) : Mse(a, r.layoutBox, t) && lle(n => {
      const a = o ? r.measuredBox[n] : r.layoutBox[n],
        i = Wie(t[n]);
      a.max = a.min + i, e.relativeTarget && !e.currentAnimation && (e.isProjectionDirty = !0, e.relativeTarget[n].max = e.relativeTarget[n].min + i);
    });
    const i = ole();
    Yie(i, t, r.layoutBox);
    const l = ole();
    o ? Yie(l, e.applyTransform(n, !0), r.measuredBox) : Yie(l, t, r.layoutBox);
    const s = !Xle(i);
    let c = !1;
    if (!e.resumeFrom) {
      const n = e.getClosestProjectingParent();
      if (n && !n.resumeFrom) {
        const {
          snapshot: a,
          layout: o
        } = n;
        if (a && o) {
          const i = ile();
          Jie(i, r.layoutBox, a.layoutBox);
          const l = ile();
          Jie(l, t, o.layoutBox), Jle(i, l) || (c = !0), n.options.layoutRoot && (e.relativeTarget = l, e.relativeTargetOrigin = i, e.relativeParent = n);
        }
      }
    }
    e.notifyListeners("didUpdate", {
      layout: t,
      snapshot: r,
      delta: l,
      layoutDelta: i,
      hasLayoutChanged: s,
      hasRelativeTargetChanged: c
    });
  } else if (e.isLead()) {
    const {
      onExitComplete: t
    } = e.options;
    t && t();
  }
  e.options.transition = void 0;
}
function hse(e) {
  lse.totalNodes++, e.parent && (e.isProjecting() || (e.isProjectionDirty = e.parent.isProjectionDirty), e.isSharedProjectionDirty || (e.isSharedProjectionDirty = Boolean(e.isProjectionDirty || e.parent.isProjectionDirty || e.parent.isSharedProjectionDirty)), e.isTransformDirty || (e.isTransformDirty = e.parent.isTransformDirty));
}
function mse(e) {
  e.isProjectionDirty = e.isSharedProjectionDirty = e.isTransformDirty = !1;
}
function pse(e) {
  e.clearSnapshot();
}
function fse(e) {
  e.clearMeasurements();
}
function dse(e) {
  e.isLayoutDirty = !1;
}
function vse(e) {
  const {
    visualElement: t
  } = e.options;
  t && t.getProps().onBeforeLayoutMeasure && t.notify("BeforeLayoutMeasure"), e.resetTransform();
}
function gse(e) {
  e.finishAnimation(), e.targetDelta = e.relativeTarget = e.target = void 0, e.isProjectionDirty = !0;
}
function bse(e) {
  e.resolveTargetDelta();
}
function wse(e) {
  e.calcProjection();
}
function yse(e) {
  e.resetRotation();
}
function xse(e) {
  e.removeLeadSnapshot();
}
function Ose(e, t, r) {
  e.translate = eoe(t.translate, 0, r), e.scale = eoe(t.scale, 1, r), e.origin = t.origin, e.originPoint = t.originPoint;
}
function Ese(e, t, r, n) {
  e.min = eoe(t.min, r.min, n), e.max = eoe(t.max, r.max, n);
}
function jse(e) {
  return e.animationValues && void 0 !== e.animationValues.opacityExit;
}
const Cse = {
  duration: .45,
  ease: [.4, 0, .1, 1]
};
function Pse(e) {
  e.min = Math.round(e.min), e.max = Math.round(e.max);
}
function Mse(e, t, r) {
  return "position" === e || "preserve-aspect" === e && !Qie(ese(t), ese(r), .2);
}
const kse = sse({
    attachResizeListener: (e, t) => Ane(e, "resize", t),
    measureScroll: () => ({
      x: document.documentElement.scrollLeft || document.body.scrollLeft,
      y: document.documentElement.scrollTop || document.body.scrollTop
    }),
    checkIsScrollRoot: () => !0
  }),
  Sse = {
    current: void 0
  },
  Nse = sse({
    measureScroll: e => ({
      x: e.scrollLeft,
      y: e.scrollTop
    }),
    defaultParent: () => {
      if (!Sse.current) {
        const e = new kse({});
        e.mount(window), e.setOptions({
          layoutScroll: !0
        }), Sse.current = e;
      }
      return Sse.current;
    },
    resetTransform: (e, t) => {
      e.style.transform = void 0 !== t ? t : "none";
    },
    checkIsScrollRoot: e => Boolean("fixed" === window.getComputedStyle(e).position)
  }),
  Bse = {
    pan: {
      Feature: class extends zne {
        constructor() {
          super(...arguments), this.removePointerDownListener = aae;
        }
        onPointerDown(e) {
          this.session = new _ie(e, this.createPanHandlers(), {
            transformPagePoint: this.node.getTransformPagePoint()
          });
        }
        createPanHandlers() {
          const {
            onPanSessionStart: e,
            onPanStart: t,
            onPan: r,
            onPanEnd: n
          } = this.node.getProps();
          return {
            onSessionStart: kle(e),
            onStart: kle(t),
            onMove: r,
            onEnd: (e, t) => {
              delete this.session, n && eae.update(() => n(e, t));
            }
          };
        }
        mount() {
          this.removePointerDownListener = Ine(this.node.current, "pointerdown", e => this.onPointerDown(e));
        }
        update() {
          this.session && this.session.updateHandlers(this.createPanHandlers());
        }
        unmount() {
          this.removePointerDownListener(), this.session && this.session.end();
        }
      }
    },
    drag: {
      Feature: class extends zne {
        constructor(e) {
          super(e), this.removeGroupControls = aae, this.removeListeners = aae, this.controls = new Ple(e);
        }
        mount() {
          const {
            dragControls: e
          } = this.node.getProps();
          e && (this.removeGroupControls = e.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || aae;
        }
        unmount() {
          this.removeGroupControls(), this.removeListeners();
        }
      },
      ProjectionNode: Nse,
      MeasureLayout: Ale
    }
  },
  Vse = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
const Rse = 4;
function Ase(e, t) {
  let r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  gae(r <= Rse, "Max CSS variable fallback depth detected in property \"".concat(e, "\". This may indicate a circular fallback dependency."));
  const [n, a] = function (e) {
    const t = Vse.exec(e);
    if (!t) return [,];
    const [, r, n] = t;
    return [r, n];
  }(e);
  if (!n) return;
  const o = window.getComputedStyle(t).getPropertyValue(n);
  return o ? o.trim() : Tre(a) ? Ase(a, t, r + 1) : a;
}
const Tse = new Set(["width", "height", "top", "left", "right", "bottom", "x", "y", "translateX", "translateY"]),
  Hse = e => Tse.has(e),
  Lse = e => e === Ire || e === Gre,
  Ise = (e, t) => parseFloat(e.split(", ")[t]),
  Fse = (e, t) => (r, _ref90) => {
    let {
      transform: n
    } = _ref90;
    if ("none" === n || !n) return 0;
    const a = n.match(/^matrix3d\((.+)\)$/);
    if (a) return Ise(a[1], t);
    {
      const t = n.match(/^matrix\((.+)\)$/);
      return t ? Ise(t[1], e) : 0;
    }
  },
  _se = new Set(["x", "y", "z"]),
  Zse = Mre.filter(e => !_se.has(e));
const Dse = {
    width: (_ref91, _ref92) => {
      let {
        x: e
      } = _ref91;
      let {
        paddingLeft: t = "0",
        paddingRight: r = "0"
      } = _ref92;
      return e.max - e.min - parseFloat(t) - parseFloat(r);
    },
    height: (_ref93, _ref94) => {
      let {
        y: e
      } = _ref93;
      let {
        paddingTop: t = "0",
        paddingBottom: r = "0"
      } = _ref94;
      return e.max - e.min - parseFloat(t) - parseFloat(r);
    },
    top: (e, _ref95) => {
      let {
        top: t
      } = _ref95;
      return parseFloat(t);
    },
    left: (e, _ref96) => {
      let {
        left: t
      } = _ref96;
      return parseFloat(t);
    },
    bottom: (_ref97, _ref98) => {
      let {
        y: e
      } = _ref97;
      let {
        top: t
      } = _ref98;
      return parseFloat(t) + (e.max - e.min);
    },
    right: (_ref99, _ref100) => {
      let {
        x: e
      } = _ref99;
      let {
        left: t
      } = _ref100;
      return parseFloat(t) + (e.max - e.min);
    },
    x: Fse(4, 13),
    y: Fse(5, 14)
  },
  qse = function (e, t) {
    let r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    let n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    t = {
      ...t
    }, n = {
      ...n
    };
    const a = Object.keys(t).filter(Hse);
    let o = [],
      i = !1;
    const l = [];
    if (a.forEach(a => {
      const s = e.getValue(a);
      if (!e.hasValue(a)) return;
      let c = r[a],
        u = Oie(c);
      const h = t[a];
      let m;
      if (Pne(h)) {
        const e = h.length,
          t = null === h[0] ? 1 : 0;
        c = h[t], u = Oie(c);
        for (let r = t; r < e && null !== h[r]; r++) m ? gae(Oie(h[r]) === m, "All keyframes must be of the same type") : (m = Oie(h[r]), gae(m === u || Lse(u) && Lse(m), "Keyframes must be of the same dimension as the current value"));
      } else m = Oie(h);
      if (u !== m) if (Lse(u) && Lse(m)) {
        const e = s.get();
        "string" == typeof e && s.set(parseFloat(e)), "string" == typeof h ? t[a] = parseFloat(h) : Array.isArray(h) && m === Gre && (t[a] = h.map(parseFloat));
      } else (null == u ? void 0 : u.transform) && (null == m ? void 0 : m.transform) && (0 === c || 0 === h) ? 0 === c ? s.set(m.transform(c)) : t[a] = u.transform(h) : (i || (o = function (e) {
        const t = [];
        return Zse.forEach(r => {
          const n = e.getValue(r);
          void 0 !== n && (t.push([r, n.get()]), n.set(r.startsWith("scale") ? 1 : 0));
        }), t.length && e.render(), t;
      }(e), i = !0), l.push(a), n[a] = void 0 !== n[a] ? n[a] : t[a], s.jump(h));
    }), l.length) {
      const r = l.indexOf("height") >= 0 ? window.pageYOffset : null,
        a = ((e, t, r) => {
          const n = t.measureViewportBox(),
            a = t.current,
            o = getComputedStyle(a),
            {
              display: i
            } = o,
            l = {};
          "none" === i && t.setStaticValue("display", e.display || "block"), r.forEach(e => {
            l[e] = Dse[e](n, o);
          }), t.render();
          const s = t.measureViewportBox();
          return r.forEach(r => {
            const n = t.getValue(r);
            n && n.jump(l[r]), e[r] = Dse[r](s, o);
          }), e;
        })(t, e, l);
      return o.length && o.forEach(_ref101 => {
        let [t, r] = _ref101;
        e.getValue(t).set(r);
      }), e.render(), are && null !== r && window.scrollTo({
        top: r
      }), {
        target: a,
        transitionEnd: n
      };
    }
    return {
      target: t,
      transitionEnd: n
    };
  };
function Use(e, t, r, n) {
  return (e => Object.keys(e).some(Hse))(t) ? qse(e, t, r, n) : {
    target: t,
    transitionEnd: n
  };
}
const $se = (e, t, r, n) => {
    const a = function (e, _ref102, r) {
      let {
        ...t
      } = _ref102;
      const n = e.current;
      if (!(n instanceof Element)) return {
        target: t,
        transitionEnd: r
      };
      r && (r = {
        ...r
      }), e.values.forEach(e => {
        const t = e.get();
        if (!Tre(t)) return;
        const r = Ase(t, n);
        r && e.set(r);
      });
      for (const e in t) {
        const a = t[e];
        if (!Tre(a)) continue;
        const o = Ase(a, n);
        o && (t[e] = o, r || (r = {}), void 0 === r[e] && (r[e] = a));
      }
      return {
        target: t,
        transitionEnd: r
      };
    }(e, t, n);
    return Use(e, t = a.target, r, n = a.transitionEnd);
  },
  zse = {
    current: null
  },
  Wse = {
    current: !1
  };
const Qse = new WeakMap(),
  Gse = Object.keys(gre),
  Yse = Gse.length,
  Kse = ["AnimationStart", "AnimationComplete", "Update", "BeforeLayoutMeasure", "LayoutMeasure", "LayoutAnimationStart", "LayoutAnimationComplete"],
  Xse = hre.length;
class Jse {
  constructor(_ref103) {
    let {
      parent: e,
      props: t,
      presenceContext: r,
      reducedMotionConfig: n,
      visualState: a
    } = _ref103;
    let o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.current = null, this.children = new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = new Map(), this.features = {}, this.valueSubscriptions = new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.scheduleRender = () => eae.render(this.render, !1, !0);
    const {
      latestValues: i,
      renderState: l
    } = a;
    this.latestValues = i, this.baseTarget = {
      ...i
    }, this.initialValues = t.initial ? {
      ...i
    } : {}, this.renderState = l, this.parent = e, this.props = t, this.presenceContext = r, this.depth = e ? e.depth + 1 : 0, this.reducedMotionConfig = n, this.options = o, this.isControllingVariants = mre(t), this.isVariantNode = pre(t), this.isVariantNode && (this.variantChildren = new Set()), this.manuallyAnimateOnMount = Boolean(e && e.current);
    const {
      willChange: s,
      ...c
    } = this.scrapeMotionValuesFromProps(t, {});
    for (const e in c) {
      const t = c[e];
      void 0 !== i[e] && Nre(t) && (t.set(i[e], !1), hie(s) && s.add(e));
    }
  }
  scrapeMotionValuesFromProps(e, t) {
    return {};
  }
  mount(e) {
    this.current = e, Qse.set(e, this), this.projection && !this.projection.instance && this.projection.mount(e), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((e, t) => this.bindToMotionValue(t, e)), Wse.current || function () {
      if (Wse.current = !0, are) if (window.matchMedia) {
        const e = window.matchMedia("(prefers-reduced-motion)"),
          t = () => zse.current = e.matches;
        e.addListener(t), t();
      } else zse.current = !1;
    }(), this.shouldReduceMotion = "never" !== this.reducedMotionConfig && ("always" === this.reducedMotionConfig || zse.current), "production" !== process.env.NODE_ENV && gie(!0 !== this.shouldReduceMotion, "You have Reduced Motion enabled on your device. Animations may not appear as expected."), this.parent && this.parent.children.add(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    Qse.delete(this.current), this.projection && this.projection.unmount(), tae(this.notifyUpdate), tae(this.render), this.valueSubscriptions.forEach(e => e()), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent && this.parent.children.delete(this);
    for (const e in this.events) this.events[e].clear();
    for (const e in this.features) this.features[e].unmount();
    this.current = null;
  }
  bindToMotionValue(e, t) {
    const r = kre.has(e),
      n = t.on("change", t => {
        this.latestValues[e] = t, this.props.onUpdate && eae.update(this.notifyUpdate, !1, !0), r && this.projection && (this.projection.isTransformDirty = !0);
      }),
      a = t.on("renderRequest", this.scheduleRender);
    this.valueSubscriptions.set(e, () => {
      n(), a();
    });
  }
  sortNodePosition(e) {
    return this.current && this.sortInstanceNodePosition && this.type === e.type ? this.sortInstanceNodePosition(this.current, e.current) : 0;
  }
  loadFeatures(_ref104, r, n, a) {
    let {
      children: e,
      ...t
    } = _ref104;
    let o, i;
    if ("production" !== process.env.NODE_ENV && n && r) {
      const e = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
      t.ignoreStrict ? vae(!1, e) : gae(!1, e);
    }
    for (let e = 0; e < Yse; e++) {
      const r = Gse[e],
        {
          isEnabled: n,
          Feature: a,
          ProjectionNode: l,
          MeasureLayout: s
        } = gre[r];
      l && (o = l), n(t) && (!this.features[r] && a && (this.features[r] = new a(this)), s && (i = s));
    }
    if (!this.projection && o) {
      this.projection = new o(this.latestValues, this.parent && this.parent.projection);
      const {
        layoutId: e,
        layout: r,
        drag: n,
        dragConstraints: i,
        layoutScroll: l,
        layoutRoot: s
      } = t;
      this.projection.setOptions({
        layoutId: e,
        layout: r,
        alwaysMeasureLayout: Boolean(n) || i && lre(i),
        visualElement: this,
        scheduleRender: () => this.scheduleRender(),
        animationType: "string" == typeof r ? r : "both",
        initialPromotionConfig: a,
        layoutScroll: l,
        layoutRoot: s
      });
    }
    return i;
  }
  updateFeatures() {
    for (const e in this.features) {
      const t = this.features[e];
      t.isMounted ? t.update() : (t.mount(), t.isMounted = !0);
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.options, this.props);
  }
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : ile();
  }
  getStaticValue(e) {
    return this.latestValues[e];
  }
  setStaticValue(e, t) {
    this.latestValues[e] = t;
  }
  makeTargetAnimatable(e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
    return this.makeTargetAnimatableFromInstance(e, this.props, t);
  }
  update(e, t) {
    (e.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = e, this.prevPresenceContext = this.presenceContext, this.presenceContext = t;
    for (let t = 0; t < Kse.length; t++) {
      const r = Kse[t];
      this.propEventSubscriptions[r] && (this.propEventSubscriptions[r](), delete this.propEventSubscriptions[r]);
      const n = e["on" + r];
      n && (this.propEventSubscriptions[r] = this.on(r, n));
    }
    this.prevMotionValues = function (e, t, r) {
      const {
        willChange: n
      } = t;
      for (const a in t) {
        const o = t[a],
          i = r[a];
        if (Nre(o)) e.addValue(a, o), hie(n) && n.add(a), "development" === process.env.NODE_ENV && gie("10.12.16" === o.version, "Attempting to mix Framer Motion versions ".concat(o.version, " with 10.12.16 may not work as expected."));else if (Nre(i)) e.addValue(a, wie(o, {
          owner: e
        })), hie(n) && n.remove(a);else if (i !== o) if (e.hasValue(a)) {
          const t = e.getValue(a);
          !t.hasAnimated && t.set(o);
        } else {
          const t = e.getStaticValue(a);
          e.addValue(a, wie(void 0 !== t ? t : o, {
            owner: e
          }));
        }
      }
      for (const n in r) void 0 === t[n] && e.removeValue(n);
      return t;
    }(this, this.scrapeMotionValuesFromProps(e, this.prevProps), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  getVariant(e) {
    return this.props.variants ? this.props.variants[e] : void 0;
  }
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  getVariantContext() {
    let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
    if (e) return this.parent ? this.parent.getVariantContext() : void 0;
    if (!this.isControllingVariants) {
      const e = this.parent && this.parent.getVariantContext() || {};
      return void 0 !== this.props.initial && (e.initial = this.props.initial), e;
    }
    const t = {};
    for (let e = 0; e < Xse; e++) {
      const r = hre[e],
        n = this.props[r];
      (sre(n) || !1 === n) && (t[r] = n);
    }
    return t;
  }
  addVariantChild(e) {
    const t = this.getClosestVariantNode();
    if (t) return t.variantChildren && t.variantChildren.add(e), () => t.variantChildren.delete(e);
  }
  addValue(e, t) {
    t !== this.values.get(e) && (this.removeValue(e), this.bindToMotionValue(e, t)), this.values.set(e, t), this.latestValues[e] = t.get();
  }
  removeValue(e) {
    this.values.delete(e);
    const t = this.valueSubscriptions.get(e);
    t && (t(), this.valueSubscriptions.delete(e)), delete this.latestValues[e], this.removeValueFromRenderState(e, this.renderState);
  }
  hasValue(e) {
    return this.values.has(e);
  }
  getValue(e, t) {
    if (this.props.values && this.props.values[e]) return this.props.values[e];
    let r = this.values.get(e);
    return void 0 === r && void 0 !== t && (r = wie(t, {
      owner: this
    }), this.addValue(e, r)), r;
  }
  readValue(e) {
    return void 0 === this.latestValues[e] && this.current ? this.readValueFromInstance(this.current, e, this.options) : this.latestValues[e];
  }
  setBaseTarget(e, t) {
    this.baseTarget[e] = t;
  }
  getBaseTarget(e) {
    var t;
    const {
        initial: r
      } = this.props,
      n = "string" == typeof r || "object" == typeof r ? null === (t = jne(this.props, r)) || void 0 === t ? void 0 : t[e] : void 0;
    if (r && void 0 !== n) return n;
    const a = this.getBaseTargetFromProps(this.props, e);
    return void 0 === a || Nre(a) ? void 0 !== this.initialValues[e] && void 0 === n ? void 0 : this.baseTarget[e] : a;
  }
  on(e, t) {
    return this.events[e] || (this.events[e] = new die()), this.events[e].add(t);
  }
  notify(e) {
    for (var _len14 = arguments.length, t = new Array(_len14 > 1 ? _len14 - 1 : 0), _key14 = 1; _key14 < _len14; _key14++) {
      t[_key14 - 1] = arguments[_key14];
    }
    this.events[e] && this.events[e].notify(...t);
  }
}
class ece extends Jse {
  sortInstanceNodePosition(e, t) {
    return 2 & e.compareDocumentPosition(t) ? 1 : -1;
  }
  getBaseTargetFromProps(e, t) {
    return e.style ? e.style[t] : void 0;
  }
  removeValueFromRenderState(e, _ref105) {
    let {
      vars: t,
      style: r
    } = _ref105;
    delete t[e], delete r[e];
  }
  makeTargetAnimatableFromInstance(_ref106, _ref107, a) {
    let {
      transition: e,
      transitionEnd: t,
      ...r
    } = _ref106;
    let {
      transformValues: n
    } = _ref107;
    let o = function (e, t, r) {
      const n = {};
      for (const a in e) {
        const e = Pie(a, t);
        if (void 0 !== e) n[a] = e;else {
          const e = r.getValue(a);
          e && (n[a] = e.get());
        }
      }
      return n;
    }(r, e || {}, this);
    if (n && (t && (t = n(t)), r && (r = n(r)), o && (o = n(o))), a) {
      !function (e, t, r) {
        var n, a;
        const o = Object.keys(t).filter(t => !e.hasValue(t)),
          i = o.length;
        if (i) for (let l = 0; l < i; l++) {
          const i = o[l],
            s = t[i];
          let c = null;
          Array.isArray(s) && (c = s[0]), null === c && (c = null !== (a = null !== (n = r[i]) && void 0 !== n ? n : e.readValue(i)) && void 0 !== a ? a : t[i]), null != c && ("string" == typeof c && (mie(c) || lie(c)) ? c = parseFloat(c) : !jie(c) && foe.test(s) && (c = iie(i, s)), e.addValue(i, wie(c, {
            owner: e
          })), void 0 === r[i] && (r[i] = c), null !== c && e.setBaseTarget(i, c));
        }
      }(this, r, o);
      const e = $se(this, r, o, t);
      t = e.transitionEnd, r = e.target;
    }
    return {
      transition: e,
      transitionEnd: t,
      ...r
    };
  }
}
class tce extends ece {
  readValueFromInstance(e, t) {
    if (kre.has(t)) {
      const e = oie(t);
      return e && e.default || 0;
    }
    {
      const n = (r = e, window.getComputedStyle(r)),
        a = (Are(t) ? n.getPropertyValue(t) : n[t]) || 0;
      return "string" == typeof a ? a.trim() : a;
    }
    var r;
  }
  measureInstanceViewportBox(e, _ref108) {
    let {
      transformPagePoint: t
    } = _ref108;
    return jle(e, t);
  }
  build(e, t, r, n) {
    tne(e, t, r, n.transformTemplate);
  }
  scrapeMotionValuesFromProps(e, t) {
    return One(e, t);
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const {
      children: e
    } = this.props;
    Nre(e) && (this.childSubscription = e.on("change", e => {
      this.current && (this.current.textContent = "".concat(e));
    }));
  }
  renderInstance(e, t, r, n) {
    wne(e, t, r, n);
  }
}
class rce extends ece {
  constructor() {
    super(...arguments), this.isSVGTag = !1;
  }
  getBaseTargetFromProps(e, t) {
    return e[t];
  }
  readValueFromInstance(e, t) {
    if (kre.has(t)) {
      const e = oie(t);
      return e && e.default || 0;
    }
    return t = yne.has(t) ? t : bne(t), e.getAttribute(t);
  }
  measureInstanceViewportBox() {
    return ile();
  }
  scrapeMotionValuesFromProps(e, t) {
    return Ene(e, t);
  }
  build(e, t, r, n) {
    pne(e, t, r, this.isSVGTag, n.transformTemplate);
  }
  renderInstance(e, t, r, n) {
    xne(e, t, 0, n);
  }
  mount(e) {
    this.isSVGTag = dne(e.tagName), super.mount(e);
  }
}
const nce = (e, t) => Cre(e) ? new rce(t, {
    enableHardwareAcceleration: !1
  }) : new tce(t, {
    enableHardwareAcceleration: !0
  }),
  ace = {
    ...Iie,
    ...mae,
    ...Bse,
    ...{
      layout: {
        ProjectionNode: Nse,
        MeasureLayout: Ale
      }
    }
  },
  oce = Ere((e, t) => function (e, _ref109, r, n) {
    let {
      forwardMotionProps: t = !1
    } = _ref109;
    return {
      ...(Cre(e) ? Vne : Rne),
      preloadedFeatures: r,
      useRender: gne(t),
      createVisualElement: n,
      Component: e
    };
  }(e, t, ace, nce));
function ice() {
  const e = n(!1);
  return ore(() => (e.current = !0, () => {
    e.current = !1;
  }), []), e;
}
class lce extends e.Component {
  getSnapshotBeforeUpdate(e) {
    const t = this.props.childRef.current;
    if (t && e.isPresent && !this.props.isPresent) {
      const e = this.props.sizeRef.current;
      e.height = t.offsetHeight || 0, e.width = t.offsetWidth || 0, e.top = t.offsetTop, e.left = t.offsetLeft;
    }
    return null;
  }
  componentDidUpdate() {}
  render() {
    return this.props.children;
  }
}
function sce(_ref110) {
  let {
    children: t,
    isPresent: r
  } = _ref110;
  const a = b(),
    o = n(null),
    i = n({
      width: 0,
      height: 0,
      top: 0,
      left: 0
    });
  return p(() => {
    const {
      width: e,
      height: t,
      top: n,
      left: l
    } = i.current;
    if (r || !o.current || !e || !t) return;
    o.current.dataset.motionPopId = a;
    const s = document.createElement("style");
    return document.head.appendChild(s), s.sheet && s.sheet.insertRule("\n          [data-motion-pop-id=\"".concat(a, "\"] {\n            position: absolute !important;\n            width: ").concat(e, "px !important;\n            height: ").concat(t, "px !important;\n            top: ").concat(n, "px !important;\n            left: ").concat(l, "px !important;\n          }\n        ")), () => {
      document.head.removeChild(s);
    };
  }, [r]), e.createElement(lce, {
    isPresent: r,
    childRef: o,
    sizeRef: i
  }, e.cloneElement(t, {
    ref: o
  }));
}
const cce = _ref111 => {
  let {
    children: t,
    initial: r,
    isPresent: n,
    onExitComplete: a,
    custom: o,
    presenceAffectsLayout: i,
    mode: l
  } = _ref111;
  const s = Cne(uce),
    c = b(),
    u = d(() => ({
      id: c,
      initial: r,
      isPresent: n,
      custom: o,
      onExitComplete: e => {
        s.set(e, !0);
        for (const e of s.values()) if (!e) return;
        a && a();
      },
      register: e => (s.set(e, !1), () => s.delete(e))
    }), i ? void 0 : [n]);
  return d(() => {
    s.forEach((e, t) => s.set(t, !1));
  }, [n]), e.useEffect(() => {
    !n && !s.size && a && a();
  }, [n]), "popLayout" === l && (t = e.createElement(sce, {
    isPresent: n
  }, t)), e.createElement(nre.Provider, {
    value: u
  }, t);
};
function uce() {
  return new Map();
}
const hce = e => e.key || "";
const mce = _ref112 => {
  let {
    children: t,
    custom: o,
    initial: i = !0,
    onExitComplete: l,
    exitBeforeEnter: c,
    presenceAffectsLayout: u = !0,
    mode: h = "sync"
  } = _ref112;
  gae(!c, "Replace exitBeforeEnter with mode='wait'");
  const p = m(bre).forceRender || function () {
      const e = ice(),
        [t, n] = r(0),
        a = f(() => {
          e.current && n(t + 1);
        }, [t]);
      return [f(() => eae.postRender(a), [a]), t];
    }()[0],
    d = ice(),
    v = function (e) {
      const t = [];
      return s.forEach(e, e => {
        y(e) && t.push(e);
      }), t;
    }(t);
  let g = v;
  const b = n(new Map()).current,
    x = n(g),
    O = n(new Map()).current,
    E = n(!0);
  var j;
  if (ore(() => {
    E.current = !1, function (e, t) {
      e.forEach(e => {
        const r = hce(e);
        t.set(r, e);
      });
    }(v, O), x.current = g;
  }), j = () => {
    E.current = !0, O.clear(), b.clear();
  }, a(() => () => j(), []), E.current) return e.createElement(e.Fragment, null, g.map(t => e.createElement(cce, {
    key: hce(t),
    isPresent: !0,
    initial: !!i && void 0,
    presenceAffectsLayout: u,
    mode: h
  }, t)));
  g = [...g];
  const C = x.current.map(hce),
    P = v.map(hce),
    M = C.length;
  for (let e = 0; e < M; e++) {
    const t = C[e];
    -1 !== P.indexOf(t) || b.has(t) || b.set(t, void 0);
  }
  return "wait" === h && b.size && (g = []), b.forEach((t, r) => {
    if (-1 !== P.indexOf(r)) return;
    const n = O.get(r);
    if (!n) return;
    const a = C.indexOf(r);
    let i = t;
    if (!i) {
      const t = () => {
        O.delete(r), b.delete(r);
        const e = x.current.findIndex(e => e.key === r);
        if (x.current.splice(e, 1), !b.size) {
          if (x.current = v, !1 === d.current) return;
          p(), l && l();
        }
      };
      i = e.createElement(cce, {
        key: hce(n),
        isPresent: !1,
        onExitComplete: t,
        custom: o,
        presenceAffectsLayout: u,
        mode: h
      }, n), b.set(r, i);
    }
    g.splice(a, 0, i);
  }), g = g.map(t => {
    const r = t.key;
    return b.has(r) ? t : e.createElement(cce, {
      key: hce(t),
      isPresent: !0,
      presenceAffectsLayout: u,
      mode: h
    }, t);
  }), "production" !== process.env.NODE_ENV && "wait" === h && g.length > 1 && console.warn('You\'re attempting to animate multiple children within AnimatePresence, but its mode is set to "wait". This will lead to odd visual behaviour.'), e.createElement(e.Fragment, null, b.size ? g : g.map(e => w(e)));
};
function pce() {
  for (var _len15 = arguments.length, e = new Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {
    e[_key15] = arguments[_key15];
  }
  return e.filter(Boolean).join(" ");
}
const fce = (e, t) => {
    if (t) {
      const r = new URL(e);
      return r.searchParams.set("pg", t), r.toString();
    }
    return e;
  },
  dce = () => t.createElement("svg", {
    width: "20",
    height: "21",
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, t.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M17.0402 2.08323C17.9627 3.18615 18.2492 6.17362 17.773 7.67111C17.6149 8.16902 17.5703 8.69511 17.6614 9.20617C17.7544 9.71348 17.8474 10.326 17.8474 10.7525C17.8474 15.1304 14.3338 18.6815 9.99814 18.6815C5.6643 18.6815 2.14887 15.1323 2.14887 10.7525C2.14887 10.326 2.24187 9.71348 2.33487 9.20617C2.42787 8.69511 2.38509 8.16902 2.22699 7.67111C1.75083 6.1755 2.03727 3.18803 2.95984 2.08323C3.08074 1.94043 3.3058 1.95922 3.40624 2.11893L4.54271 3.9208C4.82543 4.27968 5.33136 4.36423 5.7108 4.11245C6.94399 3.29701 8.41713 2.82352 10 2.82352C11.5829 2.82352 13.056 3.29701 14.2892 4.11245C14.6705 4.36423 15.1764 4.28156 15.4573 3.9208L16.5938 2.11893C16.6942 1.95922 16.9193 1.93856 17.0402 2.08323ZM11.0787 10.4144L12.6318 13.1351C12.6634 13.1896 12.6634 13.2572 12.6318 13.3098C12.602 13.3643 12.5444 13.3981 12.4811 13.3981H11.2182C11.1568 13.3981 11.0991 13.3643 11.0675 13.3098L10.2379 11.8574L9.31351 13.3154C9.28189 13.3662 9.22609 13.3962 9.16657 13.3962H7.88502C7.81992 13.3962 7.7604 13.3605 7.73064 13.3042C7.70088 13.2478 7.70274 13.1783 7.73808 13.1238L9.44743 10.4896L8.17332 8.32694C8.1417 8.27245 8.13984 8.20481 8.17146 8.15032C8.20308 8.09395 8.26074 8.06013 8.32398 8.06013H9.59624C9.65762 8.06013 9.71528 8.09207 9.7469 8.14656L11.0787 10.4144Z",
    fill: "#000615"
  }));
function vce(e) {
  const [n, o] = r(!1),
    [i, l] = r(!1),
    [s, c] = r(!1),
    [u, h] = r(!1),
    [m, p] = r(!1),
    [f, d] = r(""),
    [v, g] = r(!1),
    b = e.signUpLink ? e.signUpLink : "https://console.hasura.io",
    w = e.logInLink ? e.logInLink : "https://console.hasura.io/pg=header&plcmt=header&cta=log-in&tech=default",
    y = fce(b, e.website_key),
    x = fce(w, e.website_key),
    O = e.hideLoginButton,
    E = e === null || e === void 0 ? void 0 : e.isDarkMode,
    [j, C] = r(Array(e.HEADER_LIST.length).fill(!1)),
    P = e => {
      C(t => {
        const r = [...t];
        return r[e] = !0, r;
      });
    },
    M = e => {
      C(t => {
        const r = [...t];
        return r[e] = !1, r;
      });
    },
    k = (e, r) => {
      const {
        title: n,
        primaryCard: a,
        secondaryCardArr: o,
        tertiaryCard: i,
        flyoutD: l
      } = e[r];
      return t.createElement("div", {
        id: "dropdown_".concat(r)
      }, e[r] && t.createElement("div", {
        className: "relative",
        onMouseEnter: () => P(r),
        onMouseLeave: () => M(r)
      }, t.createElement("div", {
        className: pce("group inline-flex items-center rounded-md bg-white hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2", j[r] ? "" : E ? "text-neutral-0" : "text-gray-500")
      }, t.createElement("div", {
        className: "flex flex-col items-center cursor-pointer"
      }, t.createElement(ce, {
        className: E ? "text-neutral-0 hover:text-blue-400" : "hover:text-blue-600",
        textStyle: "body3c-medium"
      }, "".concat(n, " ")))), t.createElement(oce.div, null, j[r] && t.createElement("div", {
        id: "dropdown_".concat(r, "_content"),
        className: "left-0 z-20",
        onMouseEnter: () => P(r),
        onMouseLeave: () => M(r),
        onScroll: () => M(r)
      }, t.createElement(oce.div, {
        initial: {
          opacity: 0
        },
        animate: {
          opacity: 1
        },
        transition: {
          ease: "easeInOut",
          duration: .1
        },
        className: "absolute top-[21px] -left-[137px] z-[2] transform " + (j[0] ? "-left-[137px] " : "") + (j[1] ? "-left-[218px]" : "") + (j[3] ? "-left-[50px] " : "")
      }, ((e, r, n, a) => t.createElement("div", null, t.createElement("div", null, t.createElement("hr", {
        className: "w-full h-6 border-0"
      })), t.createElement("div", {
        className: "p-2 bg-neutral-150 rounded-3xl"
      }, t.createElement(Nte, {
        primaryCard: e,
        secondaryCardArr: r,
        tertiaryCard: n,
        flyoutD: a
      }))))(a, o, i, l))))));
    };
  let S, N;
  function B() {
    o(!n), c(!1), h(!1), p(!1), l(!1), d(""), e.HEADER_LIST.forEach((e, t) => {
      M(t);
    });
  }
  n && (S = "rotate-45 ", N = "-rotate-45 "), n || (S = " ", N = "translate-y-[5.8px] "), a(() => {
    i ? d("Product") : s ? d("Developer") : u ? d("Resources") : m && d("Company");
  }, [i, s, m, u]);
  const V = E ? "https://res.cloudinary.com/dh8fp23nd/image/upload/v1718878031/hasura_dark_mode_kjrlxi.svg" : "https://res.cloudinary.com/dh8fp23nd/image/upload/v1686659126/website%20v3/hasura-primary_y9cdnn.svg";
  return t.createElement("div", {
    className: "relative mx-auto"
  }, t.createElement("div", {
    className: "flex items-center ".concat(A(e.headerBg), " justify-between py-4 db:py-3 tb-l:justify-start")
  }, t.createElement("div", {
    className: "flex flex-row justify-between items-center w-full tb-l:w-fit"
  }, t.createElement("div", null, t.createElement("a", {
    href: e.headerUrl,
    className: "flex items-center"
  }, t.createElement("img", {
    className: "min-w-[103px] w-[103px] h-[33px]",
    src: V,
    alt: "Hasura Logo"
  }))), t.createElement("div", {
    className: "hds-hidden-tbl flex z-[10] items-center gap-6"
  }, !(m || s || i || u) && t.createElement(oce.div, {
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    transition: {
      duration: .3,
      opacity: {
        ease: "easeIn"
      }
    },
    className: "h-5 w-5 mt-3",
    onClick: () => B()
  }, t.createElement("div", {
    className: " h-5  cursor-pointer"
  }, t.createElement("div", {
    "aria-hidden": "true",
    className: E ? "".concat(S, " block  absolute h-[2px] w-[15px] bg-neutral-400 transform transition duration-500 ease-in-out") : "".concat(S, " block  absolute h-[2px] w-[15px] bg-neutral-800 transform transition duration-500 ease-in-out")
  }), t.createElement("div", {
    "aria-hidden": "true",
    className: E ? "".concat(N, " block absolute h-0.5 w-[15px] bg-neutral-400 transform  transition duration-500 ease-in-out") : "".concat(N, " block absolute h-0.5 w-[15px] bg-neutral-800 transform  transition duration-500 ease-in-out")
  }))))), t.createElement("div", {
    className: "hds-hidden tb-l:flex flex-row w-full  justify-between items-center"
  }, t.createElement("nav", {
    className: "hds-hidden items-baseline relative tb-l:pl-8 tb-l:flex tb-l:space-x-6",
    onMouseEnter: () => g(!0),
    onMouseLeave: () => g(!1)
  }, (T = e.HEADER_LIST, t.createElement(t.Fragment, null, k(T, 0), k(T, 1), k(T, 2), t.createElement("a", {
    href: "/customers"
  }, t.createElement(ce, {
    className: E ? "text-neutral-0 hover:text-blue-400 cursor-pointer" : "hover:text-blue-600 cursor-pointer",
    textStyle: "body3c-medium"
  }, "Customers ")), t.createElement("a", {
    href: "/pricing"
  }, t.createElement(ce, {
    className: E ? "text-neutral-0 hover:text-blue-400 cursor-pointer" : "hover:text-blue-600 cursor-pointer",
    textStyle: "body3c-medium"
  }, "Pricing ")), t.createElement("div", {
    className: "hidden"
  }, t.createElement("a", {
    href: "https://hasura.io/products"
  }, "What is Hasura?"), t.createElement("a", {
    href: "https://hasura.io/pricing"
  }, "Compare Plans"), t.createElement("a", {
    href: "https://console.hasura.io/"
  }, "Get started"), t.createElement("p", null, "Connectors"), t.createElement("a", {
    href: "https://hasura.io/graphql/database/postgresql"
  }, "PostgreSQL"), t.createElement("a", {
    href: "https://hasura.io/graphql/database/mysql"
  }, "MySQL"), t.createElement("a", {
    href: "https://hasura.io/graphql/database/elasticsearch"
  }, "Elasticsearch"), t.createElement("a", {
    href: "https://hasura.io/graphql/database/sql-server"
  }, "SQL Server"), t.createElement("a", {
    href: "https://hasura.io/graphql/database/mongodb"
  }, "MongoDB"), t.createElement("a", {
    href: "https://hasura.io/graphql/database/snowflake"
  }, "Snowflake"), t.createElement("a", {
    href: "https://hasura.io/graphql/database/clickhouse"
  }, "Clickhouse"), t.createElement("a", {
    href: "https://hasura.io/connectors"
  }, "More"), t.createElement("p", null, "Developer"), t.createElement("a", {
    href: "https://hasura.io/docs/3.0/index/"
  }, "Documentation"), t.createElement("a", {
    href: "https://hasura.io/connectors"
  }, "Connector Hub"), t.createElement("a", {
    href: "https://hasura.io/learn/"
  }, "Tutorials"), t.createElement("a", {
    href: "https://hasura.io/community"
  }, "Community"), t.createElement("a", {
    href: "https://discord.com/invite/hasura"
  }, "Discord"), t.createElement("a", {
    href: "https://github.com/hasura/graphql-engine/discussions"
  }, "Discussions"), t.createElement("a", {
    href: "https://www.meetup.com/pro/hasura/"
  }, "Meetups"), t.createElement("a", {
    href: "https://hasura.io/events/community-call/latest"
  }, "Hasura Community Call"), t.createElement("p", null, "Resources"), t.createElement("a", {
    href: "https://hasura.io/blog"
  }, "Blogs"), t.createElement("a", {
    href: "https://hasura.io/events?category=Webinar#wall-section"
  }, "Webinars"), t.createElement("a", {
    href: "https://hasura.io/graphql/"
  }, "Graphql Hub"), t.createElement("a", {
    href: "https://hasura.io/events"
  }, "Events"), t.createElement("a", {
    href: "https://hasura.io/resources"
  }, "Whitepapers"), t.createElement("a", {
    href: "https://supergraph.io/"
  }, "Supergraph Manifesto"))))), t.createElement("div", {
    className: "hds-hidden tb-l:flex flex-row items-center gap-x-4 "
  }, t.createElement("a", {
    href: "/contact-us",
    className: "hds-hidden db:flex"
  }, t.createElement(ce, {
    textStyle: "body3c-medium",
    className: E ? "text-neutral-0 hover:text-blue-400" : "text-neutral-800 hover:text-blue-600"
  }, "Contact Us")), !O && t.createElement("a", {
    href: x
  }, t.createElement(A8, {
    label: "Log In",
    type: "tonal",
    leftIconVariant: "none",
    rightIconVariant: "none",
    state: "default",
    size: "sm",
    rightAnimatedArrow: "true",
    rightAnimatedArrowColor: "#3970FD",
    animatedHoverStroke: "group-hover:stroke-neutral-0",
    className: "hds-hidden tb-l:flex"
  })), t.createElement("a", {
    href: y
  }, t.createElement(A8, {
    label: "Get Started",
    type: "primary",
    leftIconVariant: "none",
    rightIconVariant: "none",
    state: "default",
    size: "sm",
    rightAnimatedArrow: "true",
    rightAnimatedArrowColor: "#ffffff",
    animatedHoverStroke: "group-hover:stroke-neutral-0",
    className: "hds-hidden tb:flex"
  })))), t.createElement("div", {
    className: "hds-hidden-tbl overflow-auto flex "
  }, t.createElement("div", {
    className: "bg-neutral-100 shadow-sh1 hds-hidden-tbl block fixed w-full tb:max-w-[480px] tb:left-auto tb:right-0 mx-auto left-4 top-0 transform transition duration-500 ease-in-out h-[calc(100%-1px)] max-h-screen overflow-y-auto" + (n ? " translate-x-0" : " translate-x-[1240px]")
  }, t.createElement("div", {
    className: "bg-neutral-100 h-[calc(100%-80px)] rounded-2xl overflow-y-scroll scrollbar-hide"
  }, t.createElement("div", {
    className: "pt-6 pb-4 tb:mr-[12px] mr-[30px] min-h-[36px] flex flex-row justify-between items-center sticky top-0 bg-neutral-100 z-50 "
  }, (m || s || i || u) && t.createElement("div", {
    className: " flex flex-row justify-start z-10",
    onClick: () => (c(!1), h(!1), p(!1), l(!1), d(""), void e.HEADER_LIST.forEach((e, t) => {
      M(t);
    }))
  }, t.createElement(mz, {
    height: "w-5 h-5 ml-4 cursor-pointer",
    variant: "arrowleft",
    strokeClass: "stroke-neutral-1000"
  })), t.createElement(oce.div, {
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    transition: {
      duration: .4,
      opacity: {
        ease: "easeIn"
      }
    },
    className: "w-full justify-center flex "
  }, t.createElement(ce, {
    textStyle: "body3c-medium",
    className: "text-neutral-900"
  }, f)), (m || s || i || u) && t.createElement(oce.div, {
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    transition: {
      duration: .4,
      opacity: {
        ease: "easeIn"
      }
    },
    className: " flex flex-row justify-start z-10",
    onClick: () => B()
  }, t.createElement(mz, {
    height: "w-5 h-5 ml-4 stroke-2 cursor-pointer",
    variant: "xclose",
    strokeClass: "stroke-neutral-1000"
  }))), t.createElement(mce, {
    mode: "wait",
    exit: !1
  }, i || s || m || u ? t.createElement(oce.div, {
    key: "hey",
    exit: {
      opacity: 0,
      y: [0, 300]
    },
    animate: {
      opacity: 1,
      y: [300, 0]
    },
    transition: {
      duration: .2,
      exit: {
        duration: .3
      },
      opacity: {
        ease: "easeIn"
      }
    },
    when: i || s || m || u,
    className: "flex flex-col justify-between "
  }, t.createElement("div", {
    className: "flex flex-col justify-between rounded-2xl h-full"
  }, t.createElement("div", {
    className: "pl-4 pr-8 tb:pr-4"
  }, (R = e.HEADER_LIST, t.createElement("div", {
    className: "pt-4 "
  }, t.createElement("div", {
    className: "transform transition-all"
  }, i && t.createElement(oce.div, {
    className: "product_mobile mr-0"
  }, t.createElement(Nte, {
    primaryCard: R[0].primaryCard,
    secondaryCardArr: R[0].secondaryCardArr,
    tertiaryCard: R[0].tertiaryCard,
    flyoutD: R[0].flyoutD
  })), s && t.createElement("div", {
    className: "product_developer"
  }, t.createElement(Nte, {
    primaryCard: R[1].primaryCard,
    secondaryCardArr: R[1].secondaryCardArr,
    tertiaryCard: R[1].tertiaryCard,
    flyoutD: R[1].flyoutD
  })), u && t.createElement("div", {
    className: "product_resources"
  }, t.createElement(Nte, {
    primaryCard: R[2].primaryCard,
    secondaryCardArr: R[2].secondaryCardArr,
    tertiaryCard: R[2].tertiaryCard,
    flyoutD: R[2].flyoutD
  })))))))) : t.createElement(oce.div, {
    initial: {
      opacity: 1
    },
    animate: {
      opacity: 1
    },
    transition: {
      duration: .1,
      opacity: {
        ease: "easeIn"
      }
    },
    className: "mt-7 flex flex-col gap-6 ml-4"
  }, t.createElement("div", {
    className: "flex flex-col mr-[50px] mb-m:items-center items-end"
  }, t.createElement("img", {
    className: "inline-block max-w-[242px] w-full",
    src: "https://res.cloudinary.com/dh8fp23nd/image/upload/v1705670474/website%20v3/customers/mutations_1_tdh5ir_yf6n7k.png",
    alt: "hasura-header-illustration",
    loading: "lazy"
  })), t.createElement("nav", {
    className: "grid divide-y mr-8 tb:mr-4 bg-neutral-0 divide-neutral-200 border border-neutral-200 rounded-3xl mb-6"
  }, e.HEADER_LIST.map(r => t.createElement("div", {
    key: r.title,
    onClick: () => function (t) {
      const r = e.HEADER_LIST.findIndex(e => e.title === t);
      P(r), "Developer" === t && c(!0), "Resources" === t && h(!0), "Customers" === t && (window.location.href = "/customers"), "Pricing" === t && (window.location.href = "/pricing"), "Product" === t && l(!0), "Company" === t && p(!0);
    }(r.title),
    className: "flex justify-between items-center p-4 cursor-pointer group"
  }, t.createElement("div", {
    className: "flex items-center justify-center gap-2"
  }, t.createElement(ce, {
    textStyle: "body3c-medium",
    className: "text-neutral-700 hover:text-neutral-1000 transition-all duration-300 ease-in-out"
  }, "".concat(r.title))), t.createElement(mz, {
    height: "h-5 w-5 stroke-[1.5px] group-hover:translate-x-1 ease-in-out transition duration-300",
    variant: "chevronright",
    strokeClass: "stroke-neutral-500"
  }))), t.createElement("a", {
    href: "https://hasura.io/customers"
  }, t.createElement("div", {
    key: "Contact",
    className: "flex justify-between items-center p-4 cursor-pointer group"
  }, t.createElement("div", {
    className: "flex items-center justify-center gap-2"
  }, t.createElement(ce, {
    textStyle: "body3c-medium",
    className: "text-neutral-700 hover:text-neutral-1000 transition-all duration-300 ease-in-out"
  }, "Customers")), t.createElement(mz, {
    height: "h-5 w-5 stroke-[1.5px] group-hover:translate-x-1 ease-in-out transition duration-300",
    variant: "chevronright",
    strokeClass: "stroke-neutral-500"
  }))), t.createElement("a", {
    href: "https://hasura.io/pricing"
  }, t.createElement("div", {
    key: "Contact",
    className: "flex justify-between items-center p-4 cursor-pointer group"
  }, t.createElement("div", {
    className: "flex items-center justify-center gap-2"
  }, t.createElement(ce, {
    textStyle: "body3c-medium",
    className: "text-neutral-700 hover:text-neutral-1000 transition-all duration-300 ease-in-out"
  }, "Pricing")), t.createElement(mz, {
    height: "h-5 w-5 stroke-[1.5px] group-hover:translate-x-1 ease-in-out transition duration-300",
    variant: "chevronright",
    strokeClass: "stroke-neutral-500"
  }))), t.createElement("a", {
    href: "https://hasura.io/contact-us"
  }, t.createElement("div", {
    key: "Contact",
    className: "flex justify-between items-center p-4 cursor-pointer group"
  }, t.createElement("div", {
    className: "flex items-center justify-center gap-2"
  }, t.createElement(ce, {
    textStyle: "body3c-medium",
    className: "text-neutral-700 hover:text-neutral-1000 transition-all duration-300 ease-in-out"
  }, "Contact Us")), t.createElement(mz, {
    height: "h-5 w-5 stroke-[1.5px] group-hover:translate-x-1 ease-in-out transition duration-300",
    variant: "chevronright",
    strokeClass: "stroke-neutral-500"
  }))))))), t.createElement("div", {
    className: "py-6 shadow-sh1 bg-neutral-0 pl-4 pr-8 self-end w-full"
  }, t.createElement("div", {
    className: "flex flex-row justify-around"
  }, t.createElement("div", {
    className: "w-full flex gap-2"
  }, !O && t.createElement("a", {
    href: x,
    className: "w-1/2"
  }, t.createElement(A8, {
    label: "Log In",
    type: "tonal",
    leftIconVariant: "none",
    rightIconVariant: "none",
    state: "default",
    size: "sm",
    rightAnimatedArrow: "true",
    rightAnimatedArrowColor: "#3970FD",
    animatedHoverStroke: "group-hover:stroke-neutral-0",
    className: " !w-full"
  })), t.createElement("a", {
    href: y,
    className: O ? "w-full" : "w-1/2"
  }, t.createElement(A8, {
    label: "Get Started",
    type: "primary",
    leftIconVariant: "none",
    rightIconVariant: "none",
    state: "default",
    size: "sm",
    rightAnimatedArrow: "true",
    rightAnimatedArrowColor: "#ffffff",
    animatedHoverStroke: "group-hover:stroke-neutral-0",
    className: " !w-full"
  })))))))));
  var R, T;
}
vce.defaultProps = {
  hideLoginButton: !1,
  hideSearch: !1,
  HEADER_LIST: [{
    title: "Product",
    primaryCard: {
      iconVariant: "layersthree01",
      mainDescription: "Enable your backend team to deliver an incredible unified API on all your data effortlessly.",
      cardDetailsArray: [{
        iconVariant: t.createElement(dce, null),
        description: "Enable your backend team to deliver an incredible unified API on all your data effortlessly.",
        title: "What is Hasura?",
        btnCTA: "/products",
        strokeClass: "stroke-blue-500"
      }],
      primaryBtnLabel: "What is Hasura?",
      primaryBtnCTA: "/products",
      strokeClass: "stroke-blue-500",
      secondaryBtn: [{
        cta_leftVariantIcon: "checksquarebroken",
        cta_leftVariantIconColor: "#6C737F",
        cta_text: "Compare Plans",
        cta_link: "/pricing"
      }],
      tertiaryBtn: [{
        cta_leftVariantIcon: "zap",
        cta_leftVariantIconColor: "#6C737F",
        cta_text: "Get Started",
        cta_link: "https://console.hasura.io/"
      }]
    },
    secondaryCardArr: [{
      label: "CONNECTORS",
      childArray: [{
        description: "",
        href: "/graphql/database/postgresql",
        icon: "database01",
        name: "PostgreSQL",
        strokeClass: "stroke-blue-500"
      }, {
        description: "",
        href: "/graphql/database/mysql",
        icon: "database01",
        name: "MySQL",
        strokeClass: "stroke-blue-500"
      }, {
        description: "",
        href: "/graphql/database/elasticsearch",
        icon: "database01",
        name: "Elasticsearch",
        strokeClass: "stroke-blue-500"
      }, {
        description: "",
        href: "/graphql/database/sql-server",
        icon: "database01",
        name: "SQL Server",
        strokeClass: "stroke-blue-500"
      }, {
        description: "",
        href: "/graphql/database/mongodb",
        icon: "database01",
        name: "MongoDB",
        strokeClass: "stroke-blue-500"
      }, {
        description: "",
        href: "/graphql/database/snowflake",
        icon: "database01",
        name: "Snowflake",
        strokeClass: "stroke-blue-500"
      }, {
        description: "",
        href: "/graphql/database/clickhouse",
        icon: "database01",
        name: "ClickHouse",
        strokeClass: "stroke-blue-500"
      }, {
        description: "",
        href: "/connectors",
        icon: "database01",
        name: "More",
        strokeClass: "stroke-blue-500"
      }]
    }]
  }, {
    title: "Developer",
    secondaryCardArr: [{
      childArray: [{
        description: "",
        href: "/docs/3.0/index/",
        icon: "file02",
        name: "Documentation",
        strokeClass: "stroke-blue-500"
      }, {
        description: "",
        href: "/connectors",
        icon: "route",
        name: "Connector Hub",
        strokeClass: "stroke-blue-500"
      }, {
        description: "",
        href: "/learn/",
        icon: "graduationhat02",
        name: "Tutorials",
        strokeClass: "stroke-blue-500"
      }],
      label: "BUILD"
    }, {
      childArray: [{
        description: "",
        href: "/community",
        icon: "users01",
        name: "Community",
        strokeClass: "stroke-blue-500"
      }, {
        description: "",
        href: "https://discord.com/invite/hasura",
        icon: "discord",
        name: "Discord",
        strokeClass: "stroke-blue-500"
      }, {
        description: "",
        href: "https://github.com/hasura/graphql-engine/discussions",
        icon: "octoface",
        name: "Discussions",
        strokeClass: "stroke-blue-500"
      }, {
        description: "",
        href: "https://www.meetup.com/pro/hasura/",
        icon: "meetup",
        name: "Meetups",
        strokeClass: "stroke-blue-500"
      }],
      label: "Connect"
    }],
    flyoutD: {
      link: "https://hasura.io/events/community-call/latest",
      cardImg: "https://res.cloudinary.com/dh8fp23nd/image/upload/v1723398379/cc-blog-july_4_d9mzrf.png",
      cardImgAlt: "Hasura Community Call"
    }
  }, {
    title: "Resources",
    secondaryCardArr: [{
      childArray: [{
        description: "",
        href: "/blog",
        icon: "bookopen01",
        name: "Blogs",
        strokeClass: "stroke-blue-500"
      }, {
        description: "",
        href: "/events?category=Webinar#wall-section",
        icon: "videorecorder",
        name: "Webinars",
        strokeClass: "stroke-blue-500"
      }, {
        description: "",
        href: "/graphql/",
        icon: "home04",
        name: "GraphQL Hub",
        strokeClass: "stroke-blue-500"
      }, {
        description: "",
        href: "/events",
        icon: "calendarplus02",
        name: "Events",
        strokeClass: "stroke-blue-500"
      }, {
        description: "",
        href: "/resources",
        icon: "file05",
        name: "Whitepapers",
        strokeClass: "stroke-blue-500"
      }, {
        description: "",
        href: "https://supergraph.io/",
        icon: "beziercurve02",
        name: "Supergraph Manifesto",
        strokeClass: "stroke-blue-500"
      }],
      label: "RESOURCES"
    }]
  }],
  headerUrl: "/"
};
var gce = Object.defineProperty,
  bce = (e, t, r) => (((e, t, r) => {
    t in e ? gce(e, t, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: r
    }) : e[t] = r;
  })(e, "symbol" != typeof t ? t + "" : t, r), r);
let wce = new class {
    constructor() {
      bce(this, "current", this.detect()), bce(this, "handoffState", "pending"), bce(this, "currentId", 0);
    }
    set(e) {
      this.current !== e && (this.handoffState = "pending", this.currentId = 0, this.current = e);
    }
    reset() {
      this.set(this.detect());
    }
    nextId() {
      return ++this.currentId;
    }
    get isServer() {
      return "server" === this.current;
    }
    get isClient() {
      return "client" === this.current;
    }
    detect() {
      return "undefined" == typeof window || "undefined" == typeof document ? "server" : "client";
    }
    handoff() {
      "pending" === this.handoffState && (this.handoffState = "complete");
    }
    get isHandoffComplete() {
      return "complete" === this.handoffState;
    }
  }(),
  yce = (e, t) => {
    wce.isServer ? a(e, t) : h(e, t);
  };
function xce(e) {
  let t = n(e);
  return yce(() => {
    t.current = e;
  }, [e]), t;
}
function Oce(e, t) {
  let [n, a] = r(e),
    o = xce(e);
  return yce(() => a(o.current), [o, a, ...t]), n;
}
function Ece(e) {
  "function" == typeof queueMicrotask ? queueMicrotask(e) : Promise.resolve().then(e).catch(e => setTimeout(() => {
    throw e;
  }));
}
function jce() {
  let e = [],
    t = {
      addEventListener: (e, r, n, a) => (e.addEventListener(r, n, a), t.add(() => e.removeEventListener(r, n, a))),
      requestAnimationFrame() {
        let r = requestAnimationFrame(...arguments);
        return t.add(() => cancelAnimationFrame(r));
      },
      nextFrame: function () {
        for (var _len16 = arguments.length, e = new Array(_len16), _key16 = 0; _key16 < _len16; _key16++) {
          e[_key16] = arguments[_key16];
        }
        return t.requestAnimationFrame(() => t.requestAnimationFrame(...e));
      },
      setTimeout() {
        let r = setTimeout(...arguments);
        return t.add(() => clearTimeout(r));
      },
      microTask() {
        for (var _len17 = arguments.length, e = new Array(_len17), _key17 = 0; _key17 < _len17; _key17++) {
          e[_key17] = arguments[_key17];
        }
        let r = {
          current: !0
        };
        return Ece(() => {
          r.current && e[0]();
        }), t.add(() => {
          r.current = !1;
        });
      },
      style(e, t, r) {
        let n = e.style.getPropertyValue(t);
        return Object.assign(e.style, {
          [t]: r
        }), this.add(() => {
          Object.assign(e.style, {
            [t]: n
          });
        });
      },
      group(e) {
        let t = jce();
        return e(t), this.add(() => t.dispose());
      },
      add: t => (e.push(t), () => {
        let r = e.indexOf(t);
        if (r >= 0) for (let t of e.splice(r, 1)) t();
      }),
      dispose() {
        for (let t of e.splice(0)) t();
      }
    };
  return t;
}
function Cce() {
  let [e] = r(jce);
  return a(() => () => e.dispose(), [e]), e;
}
let Pce = function (e) {
  let r = xce(e);
  return t.useCallback(function () {
    return r.current(...arguments);
  }, [r]);
};
function Mce() {
  let [e, t] = r(wce.isHandoffComplete);
  return e && !1 === wce.isHandoffComplete && t(!1), a(() => {
    !0 !== e && t(!0);
  }, [e]), a(() => wce.handoff(), []), e;
}
var kce;
let Sce = null != (kce = t.useId) ? kce : function () {
  let e = Mce(),
    [r, n] = t.useState(e ? () => wce.nextId() : null);
  return yce(() => {
    null === r && n(wce.nextId());
  }, [r]), null != r ? "" + r : void 0;
};
function Nce(e, t) {
  if (e in t) {
    let n = t[e];
    for (var _len18 = arguments.length, r = new Array(_len18 > 2 ? _len18 - 2 : 0), _key18 = 2; _key18 < _len18; _key18++) {
      r[_key18 - 2] = arguments[_key18];
    }
    return "function" == typeof n ? n(...r) : n;
  }
  let n = new Error("Tried to handle \"".concat(e, "\" but there is no handler defined. Only defined handlers are: ").concat(Object.keys(t).map(e => "\"".concat(e, "\"")).join(", "), "."));
  throw Error.captureStackTrace && Error.captureStackTrace(n, Nce), n;
}
function Bce(e) {
  return wce.isServer ? null : e instanceof Node ? e.ownerDocument : null != e && e.hasOwnProperty("current") && e.current instanceof Node ? e.current.ownerDocument : document;
}
let Vce = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map(e => "".concat(e, ":not([tabindex='-1'])")).join(",");
var Rce = (e => (e[e.First = 1] = "First", e[e.Previous = 2] = "Previous", e[e.Next = 4] = "Next", e[e.Last = 8] = "Last", e[e.WrapAround = 16] = "WrapAround", e[e.NoScroll = 32] = "NoScroll", e))(Rce || {}),
  Ace = (e => (e[e.Error = 0] = "Error", e[e.Overflow = 1] = "Overflow", e[e.Success = 2] = "Success", e[e.Underflow = 3] = "Underflow", e))(Ace || {}),
  Tce = (e => (e[e.Previous = -1] = "Previous", e[e.Next = 1] = "Next", e))(Tce || {});
function Hce() {
  let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
  return null == e ? [] : Array.from(e.querySelectorAll(Vce)).sort((e, t) => Math.sign((e.tabIndex || Number.MAX_SAFE_INTEGER) - (t.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var Lce = (e => (e[e.Strict = 0] = "Strict", e[e.Loose = 1] = "Loose", e))(Lce || {});
function Ice(e) {
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var r;
  return e !== (null == (r = Bce(e)) ? void 0 : r.body) && Nce(t, {
    0: () => e.matches(Vce),
    1() {
      let t = e;
      for (; null !== t;) {
        if (t.matches(Vce)) return !0;
        t = t.parentElement;
      }
      return !1;
    }
  });
}
function Fce(e) {
  let t = Bce(e);
  jce().nextFrame(() => {
    t && !Ice(t.activeElement, 0) && _ce(e);
  });
}
function _ce(e) {
  null == e || e.focus({
    preventScroll: !0
  });
}
let Zce = ["textarea", "input"].join(",");
function Dce(e) {
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : e => e;
  return e.slice().sort((e, r) => {
    let n = t(e),
      a = t(r);
    if (null === n || null === a) return 0;
    let o = n.compareDocumentPosition(a);
    return o & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : o & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function qce(e, t) {
  let {
    sorted: r = !0,
    relativeTo: n = null,
    skipElements: a = []
  } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  let o = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e.ownerDocument,
    i = Array.isArray(e) ? r ? Dce(e) : e : Hce(e);
  a.length > 0 && i.length > 1 && (i = i.filter(e => !a.includes(e))), n = null != n ? n : o.activeElement;
  let l,
    s = (() => {
      if (5 & t) return 1;
      if (10 & t) return -1;
      throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
    })(),
    c = (() => {
      if (1 & t) return 0;
      if (2 & t) return Math.max(0, i.indexOf(n)) - 1;
      if (4 & t) return Math.max(0, i.indexOf(n)) + 1;
      if (8 & t) return i.length - 1;
      throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
    })(),
    u = 32 & t ? {
      preventScroll: !0
    } : {},
    h = 0,
    m = i.length;
  do {
    if (h >= m || h + m <= 0) return 0;
    let e = c + h;
    if (16 & t) e = (e + m) % m;else {
      if (e < 0) return 3;
      if (e >= m) return 1;
    }
    l = i[e], null == l || l.focus(u), h += s;
  } while (l !== o.activeElement);
  return 6 & t && function (e) {
    var t, r;
    return null != (r = null == (t = null == e ? void 0 : e.matches) ? void 0 : t.call(e, Zce)) && r;
  }(l) && l.select(), l.hasAttribute("tabindex") || l.setAttribute("tabindex", "0"), 2;
}
function Uce(e, t, r) {
  let n = xce(t);
  a(() => {
    function t(e) {
      n.current(e);
    }
    return document.addEventListener(e, t, r), () => document.removeEventListener(e, t, r);
  }, [e, r]);
}
function $ce(e, t) {
  let r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
  let o = n(!1);
  function i(r, n) {
    if (!o.current || r.defaultPrevented) return;
    let a = function e(t) {
        return "function" == typeof t ? e(t()) : Array.isArray(t) || t instanceof Set ? t : [t];
      }(e),
      i = n(r);
    if (null !== i && i.getRootNode().contains(i)) {
      for (let e of a) {
        if (null === e) continue;
        let t = e instanceof HTMLElement ? e : e.current;
        if (null != t && t.contains(i) || r.composed && r.composedPath().includes(t)) return;
      }
      return !Ice(i, Lce.Loose) && -1 !== i.tabIndex && r.preventDefault(), t(r, i);
    }
  }
  a(() => {
    requestAnimationFrame(() => {
      o.current = r;
    });
  }, [r]);
  let l = n(null);
  Uce("mousedown", e => {
    var t, r;
    o.current && (l.current = (null == (r = null == (t = e.composedPath) ? void 0 : t.call(e)) ? void 0 : r[0]) || e.target);
  }, !0), Uce("click", e => {
    l.current && (i(e, () => l.current), l.current = null);
  }, !0), Uce("blur", e => i(e, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}
function zce(e) {
  var t;
  if (e.type) return e.type;
  let r = null != (t = e.as) ? t : "button";
  return "string" == typeof r && "button" === r.toLowerCase() ? "button" : void 0;
}
function Wce(e, t) {
  let [n, a] = r(() => zce(e));
  return yce(() => {
    a(zce(e));
  }, [e.type, e.as]), yce(() => {
    n || t.current && t.current instanceof HTMLButtonElement && !t.current.hasAttribute("type") && a("button");
  }, [n, t]), n;
}
let Qce = Symbol();
function Gce(e) {
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
  return Object.assign(e, {
    [Qce]: t
  });
}
function Yce() {
  for (var _len19 = arguments.length, e = new Array(_len19), _key19 = 0; _key19 < _len19; _key19++) {
    e[_key19] = arguments[_key19];
  }
  let t = n(e);
  a(() => {
    t.current = e;
  }, [e]);
  let r = Pce(e => {
    for (let r of t.current) null != r && ("function" == typeof r ? r(e) : r.current = e);
  });
  return e.every(e => null == e || (null == e ? void 0 : e[Qce])) ? void 0 : r;
}
function Kce(_ref113) {
  let {
    container: e,
    accept: t,
    walk: r,
    enabled: o = !0
  } = _ref113;
  let i = n(t),
    l = n(r);
  a(() => {
    i.current = t, l.current = r;
  }, [t, r]), yce(() => {
    if (!e || !o) return;
    let t = Bce(e);
    if (!t) return;
    let r = i.current,
      n = l.current,
      a = Object.assign(e => r(e), {
        acceptNode: r
      }),
      s = t.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, a, !1);
    for (; s.nextNode();) n(s.currentNode);
  }, [e, o, i, l]);
}
var Xce = (e => (e[e.First = 0] = "First", e[e.Previous = 1] = "Previous", e[e.Next = 2] = "Next", e[e.Last = 3] = "Last", e[e.Specific = 4] = "Specific", e[e.Nothing = 5] = "Nothing", e))(Xce || {});
function Jce(e, t) {
  let r = t.resolveItems();
  if (r.length <= 0) return null;
  let n = t.resolveActiveIndex(),
    a = null != n ? n : -1,
    o = (() => {
      switch (e.focus) {
        case 0:
          return r.findIndex(e => !t.resolveDisabled(e));
        case 1:
          {
            let e = r.slice().reverse().findIndex((e, r, n) => !(-1 !== a && n.length - r - 1 >= a) && !t.resolveDisabled(e));
            return -1 === e ? e : r.length - 1 - e;
          }
        case 2:
          return r.findIndex((e, r) => !(r <= a) && !t.resolveDisabled(e));
        case 3:
          {
            let e = r.slice().reverse().findIndex(e => !t.resolveDisabled(e));
            return -1 === e ? e : r.length - 1 - e;
          }
        case 4:
          return r.findIndex(r => t.resolveId(r) === e.id);
        case 5:
          return null;
        default:
          !function (e) {
            throw new Error("Unexpected object: " + e);
          }(e);
      }
    })();
  return -1 === o ? n : o;
}
function eue() {
  for (var _len20 = arguments.length, e = new Array(_len20), _key20 = 0; _key20 < _len20; _key20++) {
    e[_key20] = arguments[_key20];
  }
  return e.filter(Boolean).join(" ");
}
var tue = (e => (e[e.None = 0] = "None", e[e.RenderStrategy = 1] = "RenderStrategy", e[e.Static = 2] = "Static", e))(tue || {}),
  rue = (e => (e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))(rue || {});
function nue(_ref114) {
  let {
    ourProps: e,
    theirProps: t,
    slot: r,
    defaultTag: n,
    features: a,
    visible: o = !0,
    name: i
  } = _ref114;
  let l = oue(t, e);
  if (o) return aue(l, r, n, i);
  let s = null != a ? a : 0;
  if (2 & s) {
    let {
      static: e = !1,
      ...t
    } = l;
    if (e) return aue(t, r, n, i);
  }
  if (1 & s) {
    let {
      unmount: e = !0,
      ...t
    } = l;
    return Nce(e ? 0 : 1, {
      0: () => null,
      1: () => aue({
        ...t,
        hidden: !0,
        style: {
          display: "none"
        }
      }, r, n, i)
    });
  }
  return aue(l, r, n, i);
}
function aue(e) {
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let r = arguments.length > 2 ? arguments[2] : undefined;
  let n = arguments.length > 3 ? arguments[3] : undefined;
  var a;
  let {
      as: o = r,
      children: i,
      refName: s = "ref",
      ...c
    } = sue(e, ["unmount", "static"]),
    u = void 0 !== e.ref ? {
      [s]: e.ref
    } : {},
    h = "function" == typeof i ? i(t) : i;
  "className" in c && c.className && "function" == typeof c.className && (c.className = c.className(t));
  let m = {};
  if (t) {
    let e = !1,
      r = [];
    for (let [n, a] of Object.entries(t)) "boolean" == typeof a && (e = !0), !0 === a && r.push(n);
    e && (m["data-headlessui-state"] = r.join(" "));
  }
  if (o === l && Object.keys(lue(c)).length > 0) {
    if (!y(h) || Array.isArray(h) && h.length > 1) throw new Error(['Passing props on "Fragment"!', "", "The current component <".concat(n, " /> is rendering a \"Fragment\"."), "However we need to passthrough the following props:", Object.keys(c).map(e => "  - ".concat(e)).join("\n"), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".', "Render a single element as the child so that we can forward the props onto that element."].map(e => "  - ".concat(e)).join("\n")].join("\n"));
    let e = eue(null == (a = h.props) ? void 0 : a.className, c.className),
      t = e ? {
        className: e
      } : {};
    return w(h, Object.assign({}, oue(h.props, lue(sue(c, ["ref"]))), m, u, function () {
      for (var _len21 = arguments.length, e = new Array(_len21), _key21 = 0; _key21 < _len21; _key21++) {
        e[_key21] = arguments[_key21];
      }
      return {
        ref: e.every(e => null == e) ? void 0 : t => {
          for (let r of e) null != r && ("function" == typeof r ? r(t) : r.current = t);
        }
      };
    }(h.ref, u.ref), t));
  }
  return g(o, Object.assign({}, sue(c, ["ref"]), o !== l && u, o !== l && m), h);
}
function oue() {
  for (var _len22 = arguments.length, e = new Array(_len22), _key22 = 0; _key22 < _len22; _key22++) {
    e[_key22] = arguments[_key22];
  }
  if (0 === e.length) return {};
  if (1 === e.length) return e[0];
  let t = {},
    r = {};
  for (let n of e) for (let e in n) e.startsWith("on") && "function" == typeof n[e] ? (null != r[e] || (r[e] = []), r[e].push(n[e])) : t[e] = n[e];
  if (t.disabled || t["aria-disabled"]) return Object.assign(t, Object.fromEntries(Object.keys(r).map(e => [e, void 0])));
  for (let e in r) Object.assign(t, {
    [e](t) {
      let a = r[e];
      for (var _len23 = arguments.length, n = new Array(_len23 > 1 ? _len23 - 1 : 0), _key23 = 1; _key23 < _len23; _key23++) {
        n[_key23 - 1] = arguments[_key23];
      }
      for (let e of a) {
        if ((t instanceof Event || (null == t ? void 0 : t.nativeEvent) instanceof Event) && t.defaultPrevented) return;
        e(t, ...n);
      }
    }
  });
  return t;
}
function iue(e) {
  var t;
  return Object.assign(v(e), {
    displayName: null != (t = e.displayName) ? t : e.name
  });
}
function lue(e) {
  let t = Object.assign({}, e);
  for (let e in t) void 0 === t[e] && delete t[e];
  return t;
}
function sue(e) {
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  let r = Object.assign({}, e);
  for (let e of t) e in r && delete r[e];
  return r;
}
function cue(e) {
  let t = e.parentElement,
    r = null;
  for (; t && !(t instanceof HTMLFieldSetElement);) t instanceof HTMLLegendElement && (r = t), t = t.parentElement;
  let n = "" === (null == t ? void 0 : t.getAttribute("disabled"));
  return (!n || !function (e) {
    if (!e) return !1;
    let t = e.previousElementSibling;
    for (; null !== t;) {
      if (t instanceof HTMLLegendElement) return !1;
      t = t.previousElementSibling;
    }
    return !0;
  }(r)) && n;
}
function uue() {
  let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  let r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  for (let [n, a] of Object.entries(e)) mue(r, hue(t, n), a);
  return r;
}
function hue(e, t) {
  return e ? e + "[" + t + "]" : t;
}
function mue(e, t, r) {
  if (Array.isArray(r)) for (let [n, a] of r.entries()) mue(e, hue(t, n.toString()), a);else r instanceof Date ? e.push([t, r.toISOString()]) : "boolean" == typeof r ? e.push([t, r ? "1" : "0"]) : "string" == typeof r ? e.push([t, r]) : "number" == typeof r ? e.push([t, "".concat(r)]) : null == r ? e.push([t, ""]) : uue(r, t, e);
}
function pue(e) {
  var t;
  let r = null != (t = null == e ? void 0 : e.form) ? t : e.closest("form");
  if (r) for (let e of r.elements) if ("INPUT" === e.tagName && "submit" === e.type || "BUTTON" === e.tagName && "submit" === e.type || "INPUT" === e.nodeName && "image" === e.type) return void e.click();
}
var fue = (e => (e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))(fue || {});
let due = iue(function (e, t) {
    let {
      features: r = 1,
      ...n
    } = e;
    return nue({
      ourProps: {
        ref: t,
        "aria-hidden": 2 == (2 & r) || void 0,
        style: {
          position: "fixed",
          top: 1,
          left: 1,
          width: 1,
          height: 0,
          padding: 0,
          margin: -1,
          overflow: "hidden",
          clip: "rect(0, 0, 0, 0)",
          whiteSpace: "nowrap",
          borderWidth: "0",
          ...(4 == (4 & r) && 2 != (2 & r) && {
            display: "none"
          })
        }
      },
      theirProps: n,
      slot: {},
      defaultTag: "div",
      name: "Hidden"
    });
  }),
  vue = o(null);
vue.displayName = "OpenClosedContext";
var gue = (e => (e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))(gue || {});
function bue() {
  return m(vue);
}
function wue(_ref115) {
  let {
    value: e,
    children: r
  } = _ref115;
  return t.createElement(vue.Provider, {
    value: e
  }, r);
}
var yue = (e => (e.Space = " ", e.Enter = "Enter", e.Escape = "Escape", e.Backspace = "Backspace", e.Delete = "Delete", e.ArrowLeft = "ArrowLeft", e.ArrowUp = "ArrowUp", e.ArrowRight = "ArrowRight", e.ArrowDown = "ArrowDown", e.Home = "Home", e.End = "End", e.PageUp = "PageUp", e.PageDown = "PageDown", e.Tab = "Tab", e))(yue || {});
function xue(e, t, a) {
  let [o, i] = r(a),
    l = void 0 !== e,
    s = n(l),
    c = n(!1),
    u = n(!1);
  return !l || s.current || c.current ? !l && s.current && !u.current && (u.current = !0, s.current = l, console.error("A component is changing from controlled to uncontrolled. This may be caused by the value changing from a defined value to undefined, which should not happen.")) : (c.current = !0, s.current = l, console.error("A component is changing from uncontrolled to controlled. This may be caused by the value changing from undefined to a defined value, which should not happen.")), [l ? e : o, Pce(e => (l || i(e), null == t ? void 0 : t(e)))];
}
function Oue(e, t) {
  let r = n([]),
    o = Pce(e);
  a(() => {
    let e = [...r.current];
    for (let [n, a] of t.entries()) if (r.current[n] !== a) {
      let n = o(t, e);
      return r.current = t, n;
    }
  }, [o, ...t]);
}
function Eue(e) {
  return [e.screenX, e.screenY];
}
function jue() {
  let e = n([-1, -1]);
  return {
    wasMoved(t) {
      let r = Eue(t);
      return (e.current[0] !== r[0] || e.current[1] !== r[1]) && (e.current = r, !0);
    },
    update(t) {
      e.current = Eue(t);
    }
  };
}
function Cue() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function Pue() {
  return Cue() || /Android/gi.test(window.navigator.userAgent);
}
var Mue = (e => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(Mue || {}),
  kue = (e => (e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e))(kue || {}),
  Sue = (e => (e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e))(Sue || {}),
  Nue = (e => (e[e.OpenCombobox = 0] = "OpenCombobox", e[e.CloseCombobox = 1] = "CloseCombobox", e[e.GoToOption = 2] = "GoToOption", e[e.RegisterOption = 3] = "RegisterOption", e[e.UnregisterOption = 4] = "UnregisterOption", e[e.RegisterLabel = 5] = "RegisterLabel", e))(Nue || {});
function Bue(e) {
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : e => e;
  let r = null !== e.activeOptionIndex ? e.options[e.activeOptionIndex] : null,
    n = Dce(t(e.options.slice()), e => e.dataRef.current.domRef.current),
    a = r ? n.indexOf(r) : null;
  return -1 === a && (a = null), {
    options: n,
    activeOptionIndex: a
  };
}
let Vue = {
    1(e) {
      var t;
      return null != (t = e.dataRef.current) && t.disabled || 1 === e.comboboxState ? e : {
        ...e,
        activeOptionIndex: null,
        comboboxState: 1
      };
    },
    0(e) {
      var t;
      if (null != (t = e.dataRef.current) && t.disabled || 0 === e.comboboxState) return e;
      let r = e.activeOptionIndex;
      if (e.dataRef.current) {
        let {
            isSelected: t
          } = e.dataRef.current,
          n = e.options.findIndex(e => t(e.dataRef.current.value));
        -1 !== n && (r = n);
      }
      return {
        ...e,
        comboboxState: 0,
        activeOptionIndex: r
      };
    },
    2(e, t) {
      var r, n, a, o;
      if (null != (r = e.dataRef.current) && r.disabled || null != (n = e.dataRef.current) && n.optionsRef.current && (null == (a = e.dataRef.current) || !a.optionsPropsRef.current.static) && 1 === e.comboboxState) return e;
      let i = Bue(e);
      if (null === i.activeOptionIndex) {
        let e = i.options.findIndex(e => !e.dataRef.current.disabled);
        -1 !== e && (i.activeOptionIndex = e);
      }
      let l = Jce(t, {
        resolveItems: () => i.options,
        resolveActiveIndex: () => i.activeOptionIndex,
        resolveId: e => e.id,
        resolveDisabled: e => e.dataRef.current.disabled
      });
      return {
        ...e,
        ...i,
        activeOptionIndex: l,
        activationTrigger: null != (o = t.trigger) ? o : 1
      };
    },
    3: (e, t) => {
      var r, n;
      let a = {
          id: t.id,
          dataRef: t.dataRef
        },
        o = Bue(e, e => [...e, a]);
      null === e.activeOptionIndex && null != (r = e.dataRef.current) && r.isSelected(t.dataRef.current.value) && (o.activeOptionIndex = o.options.indexOf(a));
      let i = {
        ...e,
        ...o,
        activationTrigger: 1
      };
      return null != (n = e.dataRef.current) && n.__demoMode && void 0 === e.dataRef.current.value && (i.activeOptionIndex = 0), i;
    },
    4: (e, t) => {
      let r = Bue(e, e => {
        let r = e.findIndex(e => e.id === t.id);
        return -1 !== r && e.splice(r, 1), e;
      });
      return {
        ...e,
        ...r,
        activationTrigger: 1
      };
    },
    5: (e, t) => ({
      ...e,
      labelId: t.id
    })
  },
  Rue = o(null);
function Aue(e) {
  let t = m(Rue);
  if (null === t) {
    let t = new Error("<".concat(e, " /> is missing a parent <Combobox /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(t, Aue), t;
  }
  return t;
}
Rue.displayName = "ComboboxActionsContext";
let Tue = o(null);
function Hue(e) {
  let t = m(Tue);
  if (null === t) {
    let t = new Error("<".concat(e, " /> is missing a parent <Combobox /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(t, Hue), t;
  }
  return t;
}
function Lue(e, t) {
  return Nce(t.type, Vue, e, t);
}
Tue.displayName = "ComboboxDataContext";
let Iue = l;
let Fue = tue.RenderStrategy | tue.Static;
let _ue = iue(function (e, r) {
    let {
        value: o,
        defaultValue: i,
        onChange: l,
        name: s,
        by: c = (e, t) => e === t,
        disabled: u = !1,
        __demoMode: h = !1,
        nullable: m = !1,
        multiple: p = !1,
        ...v
      } = e,
      [g = p ? [] : void 0, b] = xue(o, l, i),
      [w, y] = x(Lue, {
        dataRef: O(),
        comboboxState: h ? 0 : 1,
        options: [],
        activeOptionIndex: null,
        activationTrigger: 1,
        labelId: null
      }),
      E = n(!1),
      j = n({
        static: !1,
        hold: !1
      }),
      C = n(null),
      P = n(null),
      M = n(null),
      k = n(null),
      S = Pce("string" == typeof c ? (e, t) => {
        let r = c;
        return (null == e ? void 0 : e[r]) === (null == t ? void 0 : t[r]);
      } : c),
      N = f(e => Nce(B.mode, {
        1: () => g.some(t => S(t, e)),
        0: () => S(g, e)
      }), [g]),
      B = d(() => ({
        ...w,
        optionsPropsRef: j,
        labelRef: C,
        inputRef: P,
        buttonRef: M,
        optionsRef: k,
        value: g,
        defaultValue: i,
        disabled: u,
        mode: p ? 1 : 0,
        get activeOptionIndex() {
          if (E.current && null === w.activeOptionIndex && w.options.length > 0) {
            let e = w.options.findIndex(e => !e.dataRef.current.disabled);
            if (-1 !== e) return e;
          }
          return w.activeOptionIndex;
        },
        compare: S,
        isSelected: N,
        nullable: m,
        __demoMode: h
      }), [g, i, u, p, m, h, w]),
      V = n(null !== B.activeOptionIndex ? B.options[B.activeOptionIndex] : null);
    a(() => {
      let e = null !== B.activeOptionIndex ? B.options[B.activeOptionIndex] : null;
      V.current !== e && (V.current = e);
    }), yce(() => {
      w.dataRef.current = B;
    }, [B]), $ce([B.buttonRef, B.inputRef, B.optionsRef], () => D.closeCombobox(), 0 === B.comboboxState);
    let R = d(() => ({
        open: 0 === B.comboboxState,
        disabled: u,
        activeIndex: B.activeOptionIndex,
        activeOption: null === B.activeOptionIndex ? null : B.options[B.activeOptionIndex].dataRef.current.value,
        value: g
      }), [B, u, g]),
      A = Pce(e => {
        let t = B.options.find(t => t.id === e);
        t && Z(t.dataRef.current.value);
      }),
      T = Pce(() => {
        if (null !== B.activeOptionIndex) {
          let {
            dataRef: e,
            id: t
          } = B.options[B.activeOptionIndex];
          Z(e.current.value), D.goToOption(Xce.Specific, t);
        }
      }),
      H = Pce(() => {
        y({
          type: 0
        }), E.current = !0;
      }),
      L = Pce(() => {
        y({
          type: 1
        }), E.current = !1;
      }),
      I = Pce((e, t, r) => (E.current = !1, e === Xce.Specific ? y({
        type: 2,
        focus: Xce.Specific,
        id: t,
        trigger: r
      }) : y({
        type: 2,
        focus: e,
        trigger: r
      }))),
      F = Pce((e, t) => (y({
        type: 3,
        id: e,
        dataRef: t
      }), () => {
        var t;
        (null == (t = V.current) ? void 0 : t.id) === e && (E.current = !0), y({
          type: 4,
          id: e
        });
      })),
      _ = Pce(e => (y({
        type: 5,
        id: e
      }), () => y({
        type: 5,
        id: null
      }))),
      Z = Pce(e => Nce(B.mode, {
        0: () => null == b ? void 0 : b(e),
        1() {
          let t = B.value.slice(),
            r = t.findIndex(t => S(t, e));
          return -1 === r ? t.push(e) : t.splice(r, 1), null == b ? void 0 : b(t);
        }
      })),
      D = d(() => ({
        onChange: Z,
        registerOption: F,
        registerLabel: _,
        goToOption: I,
        closeCombobox: L,
        openCombobox: H,
        selectActiveOption: T,
        selectOption: A
      }), []),
      q = null === r ? {} : {
        ref: r
      },
      U = n(null),
      $ = Cce();
    return a(() => {
      U.current && void 0 !== i && $.addEventListener(U.current, "reset", () => {
        Z(i);
      });
    }, [U, Z]), t.createElement(Rue.Provider, {
      value: D
    }, t.createElement(Tue.Provider, {
      value: B
    }, t.createElement(wue, {
      value: Nce(B.comboboxState, {
        0: gue.Open,
        1: gue.Closed
      })
    }, null != s && null != g && uue({
      [s]: g
    }).map((_ref116, n) => {
      let [e, r] = _ref116;
      return t.createElement(due, {
        features: fue.Hidden,
        ref: 0 === n ? e => {
          var t;
          U.current = null != (t = null == e ? void 0 : e.closest("form")) ? t : null;
        } : void 0,
        ...lue({
          key: e,
          as: "input",
          type: "hidden",
          hidden: !0,
          readOnly: !0,
          name: e,
          value: r
        })
      });
    }), nue({
      ourProps: q,
      theirProps: v,
      slot: R,
      defaultTag: Iue,
      name: "Combobox"
    }))));
  }),
  Zue = iue(function (e, t) {
    var r;
    let n = Hue("Combobox.Button"),
      a = Aue("Combobox.Button"),
      o = Yce(n.buttonRef, t),
      i = Sce(),
      {
        id: l = "headlessui-combobox-button-".concat(i),
        ...s
      } = e,
      c = Cce(),
      u = Pce(e => {
        switch (e.key) {
          case yue.ArrowDown:
            return e.preventDefault(), e.stopPropagation(), 1 === n.comboboxState && a.openCombobox(), c.nextFrame(() => {
              var e;
              return null == (e = n.inputRef.current) ? void 0 : e.focus({
                preventScroll: !0
              });
            });
          case yue.ArrowUp:
            return e.preventDefault(), e.stopPropagation(), 1 === n.comboboxState && (a.openCombobox(), c.nextFrame(() => {
              n.value || a.goToOption(Xce.Last);
            })), c.nextFrame(() => {
              var e;
              return null == (e = n.inputRef.current) ? void 0 : e.focus({
                preventScroll: !0
              });
            });
          case yue.Escape:
            return 0 !== n.comboboxState ? void 0 : (e.preventDefault(), n.optionsRef.current && !n.optionsPropsRef.current.static && e.stopPropagation(), a.closeCombobox(), c.nextFrame(() => {
              var e;
              return null == (e = n.inputRef.current) ? void 0 : e.focus({
                preventScroll: !0
              });
            }));
          default:
            return;
        }
      }),
      h = Pce(e => {
        if (cue(e.currentTarget)) return e.preventDefault();
        0 === n.comboboxState ? a.closeCombobox() : (e.preventDefault(), a.openCombobox()), c.nextFrame(() => {
          var e;
          return null == (e = n.inputRef.current) ? void 0 : e.focus({
            preventScroll: !0
          });
        });
      }),
      m = Oce(() => {
        if (n.labelId) return [n.labelId, l].join(" ");
      }, [n.labelId, l]),
      p = d(() => ({
        open: 0 === n.comboboxState,
        disabled: n.disabled,
        value: n.value
      }), [n]);
    return nue({
      ourProps: {
        ref: o,
        id: l,
        type: Wce(e, n.buttonRef),
        tabIndex: -1,
        "aria-haspopup": "listbox",
        "aria-controls": null == (r = n.optionsRef.current) ? void 0 : r.id,
        "aria-expanded": n.disabled ? void 0 : 0 === n.comboboxState,
        "aria-labelledby": m,
        disabled: n.disabled,
        onClick: h,
        onKeyDown: u
      },
      theirProps: s,
      slot: p,
      defaultTag: "button",
      name: "Combobox.Button"
    });
  }),
  Due = iue(function (e, t) {
    var r, a, o, i;
    let l = Sce(),
      {
        id: s = "headlessui-combobox-input-".concat(l),
        onChange: c,
        displayValue: u,
        type: h = "text",
        ...m
      } = e,
      p = Hue("Combobox.Input"),
      f = Aue("Combobox.Input"),
      v = Yce(p.inputRef, t),
      g = n(!1),
      b = Cce(),
      w = function () {
        var e;
        return "function" == typeof u && void 0 !== p.value ? null != (e = u(p.value)) ? e : "" : "string" == typeof p.value ? p.value : "";
      }();
    Oue((_ref117, _ref118) => {
      let [e, t] = _ref117;
      let [r, n] = _ref118;
      g.current || p.inputRef.current && (0 === n && 1 === t || e !== r) && (p.inputRef.current.value = e);
    }, [w, p.comboboxState]), Oue((_ref119, _ref120) => {
      let [e] = _ref119;
      let [t] = _ref120;
      if (0 === e && 1 === t) {
        let e = p.inputRef.current;
        if (!e) return;
        let t = e.value,
          {
            selectionStart: r,
            selectionEnd: n,
            selectionDirection: a
          } = e;
        e.value = "", e.value = t, null !== a ? e.setSelectionRange(r, n, a) : e.setSelectionRange(r, n);
      }
    }, [p.comboboxState]);
    let y = n(!1),
      x = Pce(() => {
        y.current = !0;
      }),
      O = Pce(() => {
        setTimeout(() => {
          y.current = !1;
        });
      }),
      E = Pce(e => {
        switch (g.current = !0, e.key) {
          case yue.Backspace:
          case yue.Delete:
            if (0 !== p.mode || !p.nullable) return;
            let t = e.currentTarget;
            b.requestAnimationFrame(() => {
              "" === t.value && (f.onChange(null), p.optionsRef.current && (p.optionsRef.current.scrollTop = 0), f.goToOption(Xce.Nothing));
            });
            break;
          case yue.Enter:
            if (g.current = !1, 0 !== p.comboboxState || y.current) return;
            if (e.preventDefault(), e.stopPropagation(), null === p.activeOptionIndex) return void f.closeCombobox();
            f.selectActiveOption(), 0 === p.mode && f.closeCombobox();
            break;
          case yue.ArrowDown:
            return g.current = !1, e.preventDefault(), e.stopPropagation(), Nce(p.comboboxState, {
              0: () => {
                f.goToOption(Xce.Next);
              },
              1: () => {
                f.openCombobox();
              }
            });
          case yue.ArrowUp:
            return g.current = !1, e.preventDefault(), e.stopPropagation(), Nce(p.comboboxState, {
              0: () => {
                f.goToOption(Xce.Previous);
              },
              1: () => {
                f.openCombobox(), b.nextFrame(() => {
                  p.value || f.goToOption(Xce.Last);
                });
              }
            });
          case yue.Home:
            if (e.shiftKey) break;
            return g.current = !1, e.preventDefault(), e.stopPropagation(), f.goToOption(Xce.First);
          case yue.PageUp:
            return g.current = !1, e.preventDefault(), e.stopPropagation(), f.goToOption(Xce.First);
          case yue.End:
            if (e.shiftKey) break;
            return g.current = !1, e.preventDefault(), e.stopPropagation(), f.goToOption(Xce.Last);
          case yue.PageDown:
            return g.current = !1, e.preventDefault(), e.stopPropagation(), f.goToOption(Xce.Last);
          case yue.Escape:
            return g.current = !1, 0 !== p.comboboxState ? void 0 : (e.preventDefault(), p.optionsRef.current && !p.optionsPropsRef.current.static && e.stopPropagation(), f.closeCombobox());
          case yue.Tab:
            if (g.current = !1, 0 !== p.comboboxState) return;
            0 === p.mode && f.selectActiveOption(), f.closeCombobox();
        }
      }),
      j = Pce(e => {
        f.openCombobox(), null == c || c(e);
      }),
      C = Pce(() => {
        g.current = !1;
      }),
      P = Oce(() => {
        if (p.labelId) return [p.labelId].join(" ");
      }, [p.labelId]),
      M = d(() => ({
        open: 0 === p.comboboxState,
        disabled: p.disabled
      }), [p]);
    return nue({
      ourProps: {
        ref: v,
        id: s,
        role: "combobox",
        type: h,
        "aria-controls": null == (r = p.optionsRef.current) ? void 0 : r.id,
        "aria-expanded": p.disabled ? void 0 : 0 === p.comboboxState,
        "aria-activedescendant": null === p.activeOptionIndex || null == (a = p.options[p.activeOptionIndex]) ? void 0 : a.id,
        "aria-labelledby": P,
        "aria-autocomplete": "list",
        defaultValue: null != (i = null != (o = e.defaultValue) ? o : void 0 !== p.defaultValue ? null == u ? void 0 : u(p.defaultValue) : null) ? i : p.defaultValue,
        disabled: p.disabled,
        onCompositionStart: x,
        onCompositionEnd: O,
        onKeyDown: E,
        onChange: j,
        onBlur: C
      },
      theirProps: m,
      slot: M,
      defaultTag: "input",
      name: "Combobox.Input"
    });
  }),
  que = iue(function (e, t) {
    let r = Sce(),
      {
        id: n = "headlessui-combobox-label-".concat(r),
        ...a
      } = e,
      o = Hue("Combobox.Label"),
      i = Aue("Combobox.Label"),
      l = Yce(o.labelRef, t);
    yce(() => i.registerLabel(n), [n]);
    let s = Pce(() => {
        var e;
        return null == (e = o.inputRef.current) ? void 0 : e.focus({
          preventScroll: !0
        });
      }),
      c = d(() => ({
        open: 0 === o.comboboxState,
        disabled: o.disabled
      }), [o]);
    return nue({
      ourProps: {
        ref: l,
        id: n,
        onClick: s
      },
      theirProps: a,
      slot: c,
      defaultTag: "label",
      name: "Combobox.Label"
    });
  }),
  Uue = iue(function (e, t) {
    let r = Sce(),
      {
        id: n = "headlessui-combobox-options-".concat(r),
        hold: a = !1,
        ...o
      } = e,
      i = Hue("Combobox.Options"),
      l = Yce(i.optionsRef, t),
      s = bue(),
      c = null !== s ? (s & gue.Open) === gue.Open : 0 === i.comboboxState;
    yce(() => {
      var t;
      i.optionsPropsRef.current.static = null != (t = e.static) && t;
    }, [i.optionsPropsRef, e.static]), yce(() => {
      i.optionsPropsRef.current.hold = a;
    }, [i.optionsPropsRef, a]), Kce({
      container: i.optionsRef.current,
      enabled: 0 === i.comboboxState,
      accept: e => "option" === e.getAttribute("role") ? NodeFilter.FILTER_REJECT : e.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT,
      walk(e) {
        e.setAttribute("role", "none");
      }
    });
    let u = Oce(() => {
        var e, t;
        return null != (t = i.labelId) ? t : null == (e = i.buttonRef.current) ? void 0 : e.id;
      }, [i.labelId, i.buttonRef.current]),
      h = d(() => ({
        open: 0 === i.comboboxState
      }), [i]);
    return nue({
      ourProps: {
        "aria-labelledby": u,
        role: "listbox",
        "aria-multiselectable": 1 === i.mode || void 0,
        id: n,
        ref: l
      },
      theirProps: o,
      slot: h,
      defaultTag: "ul",
      features: Fue,
      visible: c,
      name: "Combobox.Options"
    });
  }),
  $ue = iue(function (e, t) {
    var r, a;
    let o = Sce(),
      {
        id: i = "headlessui-combobox-option-".concat(o),
        disabled: l = !1,
        value: s,
        ...c
      } = e,
      u = Hue("Combobox.Option"),
      h = Aue("Combobox.Option"),
      m = null !== u.activeOptionIndex && u.options[u.activeOptionIndex].id === i,
      p = u.isSelected(s),
      f = n(null),
      v = xce({
        disabled: l,
        value: s,
        domRef: f,
        textValue: null == (a = null == (r = f.current) ? void 0 : r.textContent) ? void 0 : a.toLowerCase()
      }),
      g = Yce(t, f),
      b = Pce(() => h.selectOption(i));
    yce(() => h.registerOption(i, v), [v, i]);
    let w = n(!u.__demoMode);
    yce(() => {
      if (!u.__demoMode) return;
      let e = jce();
      return e.requestAnimationFrame(() => {
        w.current = !0;
      }), e.dispose;
    }, []), yce(() => {
      if (0 !== u.comboboxState || !m || !w.current || 0 === u.activationTrigger) return;
      let e = jce();
      return e.requestAnimationFrame(() => {
        var e, t;
        null == (t = null == (e = f.current) ? void 0 : e.scrollIntoView) || t.call(e, {
          block: "nearest"
        });
      }), e.dispose;
    }, [f, m, u.comboboxState, u.activationTrigger, u.activeOptionIndex]);
    let y = Pce(e => {
        if (l) return e.preventDefault();
        b(), 0 === u.mode && h.closeCombobox(), Pue() || requestAnimationFrame(() => {
          var e;
          return null == (e = u.inputRef.current) ? void 0 : e.focus();
        });
      }),
      x = Pce(() => {
        if (l) return h.goToOption(Xce.Nothing);
        h.goToOption(Xce.Specific, i);
      }),
      O = jue(),
      E = Pce(e => O.update(e)),
      j = Pce(e => {
        O.wasMoved(e) && (l || m || h.goToOption(Xce.Specific, i, 0));
      }),
      C = Pce(e => {
        O.wasMoved(e) && (l || m && (u.optionsPropsRef.current.hold || h.goToOption(Xce.Nothing)));
      }),
      P = d(() => ({
        active: m,
        selected: p,
        disabled: l
      }), [m, p, l]);
    return nue({
      ourProps: {
        id: i,
        ref: g,
        role: "option",
        tabIndex: !0 === l ? void 0 : -1,
        "aria-disabled": !0 === l || void 0,
        "aria-selected": p,
        disabled: void 0,
        onClick: y,
        onFocus: x,
        onPointerEnter: E,
        onMouseEnter: E,
        onPointerMove: j,
        onMouseMove: j,
        onPointerLeave: C,
        onMouseLeave: C
      },
      theirProps: c,
      slot: P,
      defaultTag: "li",
      name: "Combobox.Option"
    });
  });
Object.assign(_ue, {
  Input: Due,
  Button: Zue,
  Label: que,
  Options: Uue,
  Option: $ue
});
var zue = (e => (e[e.Forwards = 0] = "Forwards", e[e.Backwards = 1] = "Backwards", e))(zue || {});
function Wue() {
  let e = n(0);
  return function (e, t, r) {
    let n = xce(t);
    a(() => {
      function t(e) {
        n.current(e);
      }
      return window.addEventListener(e, t, r), () => window.removeEventListener(e, t, r);
    }, [e, r]);
  }("keydown", t => {
    "Tab" === t.key && (e.current = t.shiftKey ? 1 : 0);
  }, !0), e;
}
function Que() {
  let e = n(!1);
  return yce(() => (e.current = !0, () => {
    e.current = !1;
  }), []), e;
}
function Gue() {
  for (var _len24 = arguments.length, e = new Array(_len24), _key24 = 0; _key24 < _len24; _key24++) {
    e[_key24] = arguments[_key24];
  }
  return d(() => Bce(...e), [...e]);
}
function Yue(e, t, r, n) {
  let o = xce(r);
  a(() => {
    function r(e) {
      o.current(e);
    }
    return (e = null != e ? e : window).addEventListener(t, r, n), () => e.removeEventListener(t, r, n);
  }, [e, t, n]);
}
function Kue(e) {
  if (!e) return new Set();
  if ("function" == typeof e) return new Set(e());
  let t = new Set();
  for (let r of e.current) r.current instanceof HTMLElement && t.add(r.current);
  return t;
}
var Xue = (e => (e[e.None = 1] = "None", e[e.InitialFocus = 2] = "InitialFocus", e[e.TabLock = 4] = "TabLock", e[e.FocusLock = 8] = "FocusLock", e[e.RestoreFocus = 16] = "RestoreFocus", e[e.All = 30] = "All", e))(Xue || {});
let Jue = iue(function (e, r) {
    let o = n(null),
      i = Yce(o, r),
      {
        initialFocus: l,
        containers: s,
        features: c = 30,
        ...u
      } = e;
    Mce() || (c = 1);
    let h = Gue(o);
    !function (_ref121, t) {
      let {
        ownerDocument: e
      } = _ref121;
      let r = function () {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
        let t = n(the.slice());
        return Oue((_ref122, _ref123) => {
          let [e] = _ref122;
          let [r] = _ref123;
          !0 === r && !1 === e && Ece(() => {
            t.current.splice(0);
          }), !1 === r && !0 === e && (t.current = the.slice());
        }, [e, the, t]), Pce(() => {
          var e;
          return null != (e = t.current.find(e => null != e && e.isConnected)) ? e : null;
        });
      }(t);
      Oue(() => {
        t || (null == e ? void 0 : e.activeElement) === (null == e ? void 0 : e.body) && _ce(r());
      }, [t]);
      let o = n(!1);
      a(() => (o.current = !1, () => {
        o.current = !0, Ece(() => {
          o.current && _ce(r());
        });
      }), []);
    }({
      ownerDocument: h
    }, Boolean(16 & c));
    let m = function (_ref124, a) {
      let {
        ownerDocument: e,
        container: t,
        initialFocus: r
      } = _ref124;
      let o = n(null),
        i = Que();
      return Oue(() => {
        if (!a) return;
        let n = t.current;
        n && Ece(() => {
          if (!i.current) return;
          let t = null == e ? void 0 : e.activeElement;
          if (null != r && r.current) {
            if ((null == r ? void 0 : r.current) === t) return void (o.current = t);
          } else if (n.contains(t)) return void (o.current = t);
          null != r && r.current ? _ce(r.current) : qce(n, Rce.First) === Ace.Error && console.warn("There are no focusable elements inside the <FocusTrap />"), o.current = null == e ? void 0 : e.activeElement;
        });
      }, [a]), o;
    }({
      ownerDocument: h,
      container: o,
      initialFocus: l
    }, Boolean(2 & c));
    !function (_ref125, a) {
      let {
        ownerDocument: e,
        container: t,
        containers: r,
        previousActiveElement: n
      } = _ref125;
      let o = Que();
      Yue(null == e ? void 0 : e.defaultView, "focus", e => {
        if (!a || !o.current) return;
        let i = Kue(r);
        t.current instanceof HTMLElement && i.add(t.current);
        let l = n.current;
        if (!l) return;
        let s = e.target;
        s && s instanceof HTMLElement ? rhe(i, s) ? (n.current = s, _ce(s)) : (e.preventDefault(), e.stopPropagation(), _ce(l)) : _ce(n.current);
      }, !0);
    }({
      ownerDocument: h,
      container: o,
      containers: s,
      previousActiveElement: m
    }, Boolean(8 & c));
    let p = Wue(),
      f = Pce(e => {
        let t = o.current;
        t && Nce(p.current, {
          [zue.Forwards]: () => {
            qce(t, Rce.First, {
              skipElements: [e.relatedTarget]
            });
          },
          [zue.Backwards]: () => {
            qce(t, Rce.Last, {
              skipElements: [e.relatedTarget]
            });
          }
        });
      }),
      d = Cce(),
      v = n(!1),
      g = {
        ref: i,
        onKeyDown(e) {
          "Tab" == e.key && (v.current = !0, d.requestAnimationFrame(() => {
            v.current = !1;
          }));
        },
        onBlur(e) {
          let t = Kue(s);
          o.current instanceof HTMLElement && t.add(o.current);
          let r = e.relatedTarget;
          r instanceof HTMLElement && "true" !== r.dataset.headlessuiFocusGuard && (rhe(t, r) || (v.current ? qce(o.current, Nce(p.current, {
            [zue.Forwards]: () => Rce.Next,
            [zue.Backwards]: () => Rce.Previous
          }) | Rce.WrapAround, {
            relativeTo: e.target
          }) : e.target instanceof HTMLElement && _ce(e.target)));
        }
      };
    return t.createElement(t.Fragment, null, Boolean(4 & c) && t.createElement(due, {
      as: "button",
      type: "button",
      "data-headlessui-focus-guard": !0,
      onFocus: f,
      features: fue.Focusable
    }), nue({
      ourProps: g,
      theirProps: u,
      defaultTag: "div",
      name: "FocusTrap"
    }), Boolean(4 & c) && t.createElement(due, {
      as: "button",
      type: "button",
      "data-headlessui-focus-guard": !0,
      onFocus: f,
      features: fue.Focusable
    }));
  }),
  ehe = Object.assign(Jue, {
    features: Xue
  }),
  the = [];
if ("undefined" != typeof window && "undefined" != typeof document) {
  let e = function (e) {
    e.target instanceof HTMLElement && e.target !== document.body && the[0] !== e.target && (the.unshift(e.target), the = the.filter(e => null != e && e.isConnected), the.splice(10));
  };
  window.addEventListener("click", e, {
    capture: !0
  }), window.addEventListener("mousedown", e, {
    capture: !0
  }), window.addEventListener("focus", e, {
    capture: !0
  }), document.body.addEventListener("click", e, {
    capture: !0
  }), document.body.addEventListener("mousedown", e, {
    capture: !0
  }), document.body.addEventListener("focus", e, {
    capture: !0
  });
}
function rhe(e, t) {
  for (let r of e) if (r.contains(t)) return !0;
  return !1;
}
let nhe = o(!1);
function ahe() {
  return m(nhe);
}
function ohe(e) {
  return t.createElement(nhe.Provider, {
    value: e.force
  }, e.children);
}
let ihe = l;
let lhe = l,
  she = o(null);
let che = iue(function (e, t) {
    let o = e,
      i = n(null),
      l = Yce(Gce(e => {
        i.current = e;
      }), t),
      s = Gue(i),
      c = function (e) {
        let t = ahe(),
          n = m(she),
          o = Gue(e),
          [i, l] = r(() => {
            if (!t && null !== n || wce.isServer) return null;
            let e = null == o ? void 0 : o.getElementById("headlessui-portal-root");
            if (e) return e;
            if (null === o) return null;
            let r = o.createElement("div");
            return r.setAttribute("id", "headlessui-portal-root"), o.body.appendChild(r);
          });
        return a(() => {
          null !== i && (null != o && o.body.contains(i) || null == o || o.body.appendChild(i));
        }, [i, o]), a(() => {
          t || null !== n && l(n.current);
        }, [n, l, t]), i;
      }(i),
      [u] = r(() => {
        var e;
        return wce.isServer ? null : null != (e = null == s ? void 0 : s.createElement("div")) ? e : null;
      }),
      h = Mce(),
      p = n(!1);
    return yce(() => {
      if (p.current = !1, c && u) return c.contains(u) || (u.setAttribute("data-headlessui-portal", ""), c.appendChild(u)), () => {
        p.current = !0, Ece(() => {
          var e;
          p.current && (!c || !u || (u instanceof Node && c.contains(u) && c.removeChild(u), c.childNodes.length <= 0 && (null == (e = c.parentElement) || e.removeChild(c))));
        });
      };
    }, [c, u]), h && c && u ? V(nue({
      ourProps: {
        ref: l
      },
      theirProps: o,
      defaultTag: ihe,
      name: "Portal"
    }), u) : null;
  }),
  uhe = iue(function (e, r) {
    let {
        target: n,
        ...a
      } = e,
      o = {
        ref: Yce(r)
      };
    return t.createElement(she.Provider, {
      value: n
    }, nue({
      ourProps: o,
      theirProps: a,
      defaultTag: lhe,
      name: "Popover.Group"
    }));
  }),
  hhe = Object.assign(che, {
    Group: uhe
  }),
  mhe = o(null);
function phe() {
  let e = m(mhe);
  if (null === e) {
    let e = new Error("You used a <Description /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(e, phe), e;
  }
  return e;
}
function fhe() {
  let [e, n] = r([]);
  return [e.length > 0 ? e.join(" ") : void 0, d(() => function (e) {
    let r = Pce(e => (n(t => [...t, e]), () => n(t => {
        let r = t.slice(),
          n = r.indexOf(e);
        return -1 !== n && r.splice(n, 1), r;
      }))),
      a = d(() => ({
        register: r,
        slot: e.slot,
        name: e.name,
        props: e.props
      }), [r, e.slot, e.name, e.props]);
    return t.createElement(mhe.Provider, {
      value: a
    }, e.children);
  }, [n])];
}
let dhe = iue(function (e, t) {
    let r = Sce(),
      {
        id: n = "headlessui-description-".concat(r),
        ...a
      } = e,
      o = phe(),
      i = Yce(t);
    return yce(() => o.register(n), [n, o.register]), nue({
      ourProps: {
        ref: i,
        ...o.props,
        id: n
      },
      theirProps: a,
      slot: o.slot || {},
      defaultTag: "p",
      name: o.name || "Description"
    });
  }),
  vhe = Object.assign(dhe, {}),
  ghe = o(() => {});
ghe.displayName = "StackContext";
var bhe = (e => (e[e.Add = 0] = "Add", e[e.Remove = 1] = "Remove", e))(bhe || {});
function whe(_ref126) {
  let {
    children: e,
    onUpdate: r,
    type: n,
    element: a,
    enabled: o
  } = _ref126;
  let i = m(ghe),
    l = Pce(function () {
      null == r || r(...arguments), i(...arguments);
    });
  return yce(() => {
    let e = void 0 === o || !0 === o;
    return e && l(0, n, a), () => {
      e && l(1, n, a);
    };
  }, [l, n, a, o]), t.createElement(ghe.Provider, {
    value: l
  }, e);
}
const yhe = "function" == typeof Object.is ? Object.is : function (e, t) {
    return e === t && (0 !== e || 1 / e == 1 / t) || e != e && t != t;
  },
  {
    useState: xhe,
    useEffect: Ohe,
    useLayoutEffect: Ehe,
    useDebugValue: jhe
  } = e;
function Che(e) {
  const t = e.getSnapshot,
    r = e.value;
  try {
    const e = t();
    return !yhe(r, e);
  } catch {
    return !0;
  }
}
const Phe = !("undefined" != typeof window && void 0 !== window.document && void 0 !== window.document.createElement) ? function (e, t, r) {
    return t();
  } : function (e, t, r) {
    const n = t(),
      [{
        inst: a
      }, o] = xhe({
        inst: {
          value: n,
          getSnapshot: t
        }
      });
    return Ehe(() => {
      a.value = n, a.getSnapshot = t, Che(a) && o({
        inst: a
      });
    }, [e, n, t]), Ohe(() => (Che(a) && o({
      inst: a
    }), e(() => {
      Che(a) && o({
        inst: a
      });
    })), [e]), jhe(n), n;
  },
  Mhe = "useSyncExternalStore" in e ? e.useSyncExternalStore : Phe;
function khe() {
  let e;
  return {
    before(_ref127) {
      let {
        doc: t
      } = _ref127;
      var r;
      let n = t.documentElement;
      e = (null != (r = t.defaultView) ? r : window).innerWidth - n.clientWidth;
    },
    after(_ref128) {
      let {
        doc: t,
        d: r
      } = _ref128;
      let n = t.documentElement,
        a = n.clientWidth - n.offsetWidth,
        o = e - a;
      r.style(n, "paddingRight", "".concat(o, "px"));
    }
  };
}
function She() {
  if (!Cue()) return {};
  let e;
  return {
    before() {
      e = window.pageYOffset;
    },
    after(_ref129) {
      let {
        doc: t,
        d: r,
        meta: n
      } = _ref129;
      function a(e) {
        return n.containers.flatMap(e => e()).some(t => t.contains(e));
      }
      r.style(t.body, "marginTop", "-".concat(e, "px")), window.scrollTo(0, 0);
      let o = null;
      r.addEventListener(t, "click", e => {
        if (e.target instanceof HTMLElement) try {
          let r = e.target.closest("a");
          if (!r) return;
          let {
              hash: n
            } = new URL(r.href),
            i = t.querySelector(n);
          i && !a(i) && (o = i);
        } catch {}
      }, !0), r.addEventListener(t, "touchmove", e => {
        e.target instanceof HTMLElement && !a(e.target) && e.preventDefault();
      }, {
        passive: !1
      }), r.add(() => {
        window.scrollTo(0, window.pageYOffset + e), o && o.isConnected && (o.scrollIntoView({
          block: "nearest"
        }), o = null);
      });
    }
  };
}
function Nhe(e) {
  let t = {};
  for (let r of e) Object.assign(t, r(t));
  return t;
}
let Bhe = function (e, t) {
  let r = e(),
    n = new Set();
  return {
    getSnapshot: () => r,
    subscribe: e => (n.add(e), () => n.delete(e)),
    dispatch(e) {
      for (var _len25 = arguments.length, a = new Array(_len25 > 1 ? _len25 - 1 : 0), _key25 = 1; _key25 < _len25; _key25++) {
        a[_key25 - 1] = arguments[_key25];
      }
      let o = t[e].call(r, ...a);
      o && (r = o, n.forEach(e => e()));
    }
  };
}(() => new Map(), {
  PUSH(e, t) {
    var r;
    let n = null != (r = this.get(e)) ? r : {
      doc: e,
      count: 0,
      d: jce(),
      meta: new Set()
    };
    return n.count++, n.meta.add(t), this.set(e, n), this;
  },
  POP(e, t) {
    let r = this.get(e);
    return r && (r.count--, r.meta.delete(t)), this;
  },
  SCROLL_PREVENT(_ref130) {
    let {
      doc: e,
      d: t,
      meta: r
    } = _ref130;
    let n = {
        doc: e,
        d: t,
        meta: Nhe(r)
      },
      a = [She(), khe(), {
        before(_ref131) {
          let {
            doc: e,
            d: t
          } = _ref131;
          t.style(e.documentElement, "overflow", "hidden");
        }
      }];
    a.forEach(_ref132 => {
      let {
        before: e
      } = _ref132;
      return null == e ? void 0 : e(n);
    }), a.forEach(_ref133 => {
      let {
        after: e
      } = _ref133;
      return null == e ? void 0 : e(n);
    });
  },
  SCROLL_ALLOW(_ref134) {
    let {
      d: e
    } = _ref134;
    e.dispose();
  },
  TEARDOWN(_ref135) {
    let {
      doc: e
    } = _ref135;
    this.delete(e);
  }
});
function Vhe(e, t, r) {
  let n = function (e) {
      return Mhe(e.subscribe, e.getSnapshot, e.getSnapshot);
    }(Bhe),
    a = e ? n.get(e) : void 0,
    o = !!a && a.count > 0;
  return yce(() => {
    if (e && t) return Bhe.dispatch("PUSH", e, r), () => Bhe.dispatch("POP", e, r);
  }, [t, e]), o;
}
Bhe.subscribe(() => {
  let e = Bhe.getSnapshot(),
    t = new Map();
  for (let [r] of e) t.set(r, r.documentElement.style.overflow);
  for (let r of e.values()) {
    let e = "hidden" === t.get(r.doc),
      n = 0 !== r.count;
    (n && !e || !n && e) && Bhe.dispatch(r.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", r), 0 === r.count && Bhe.dispatch("TEARDOWN", r);
  }
});
let Rhe = new Map(),
  Ahe = new Map();
function The(e) {
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
  yce(() => {
    var r;
    if (!t) return;
    let n = "function" == typeof e ? e() : e.current;
    if (!n) return;
    let a = null != (r = Ahe.get(n)) ? r : 0;
    return Ahe.set(n, a + 1), 0 !== a || (Rhe.set(n, {
      "aria-hidden": n.getAttribute("aria-hidden"),
      inert: n.inert
    }), n.setAttribute("aria-hidden", "true"), n.inert = !0), function () {
      var e;
      if (!n) return;
      let t = null != (e = Ahe.get(n)) ? e : 1;
      if (1 === t ? Ahe.delete(n) : Ahe.set(n, t - 1), 1 !== t) return;
      let r = Rhe.get(n);
      r && (null === r["aria-hidden"] ? n.removeAttribute("aria-hidden") : n.setAttribute("aria-hidden", r["aria-hidden"]), n.inert = r.inert, Rhe.delete(n));
    };
  }, [e, t]);
}
var Hhe = (e => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(Hhe || {}),
  Lhe = (e => (e[e.SetTitleId = 0] = "SetTitleId", e))(Lhe || {});
let Ihe = {
    0: (e, t) => e.titleId === t.id ? e : {
      ...e,
      titleId: t.id
    }
  },
  Fhe = o(null);
function _he(e) {
  let t = m(Fhe);
  if (null === t) {
    let t = new Error("<".concat(e, " /> is missing a parent <Dialog /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(t, _he), t;
  }
  return t;
}
function Zhe(e, t) {
  return Nce(t.type, Ihe, e, t);
}
Fhe.displayName = "DialogContext";
let Dhe = tue.RenderStrategy | tue.Static;
let qhe = iue(function (e, o) {
    let i = Sce(),
      {
        id: l = "headlessui-dialog-".concat(i),
        open: s,
        onClose: c,
        initialFocus: u,
        __demoMode: h = !1,
        ...p
      } = e,
      [v, g] = r(0),
      b = bue();
    void 0 === s && null !== b && (s = (b & gue.Open) === gue.Open);
    let w = n(null),
      y = Yce(w, o),
      E = n(null),
      j = Gue(w),
      C = e.hasOwnProperty("open") || null !== b,
      P = e.hasOwnProperty("onClose");
    if (!C && !P) throw new Error("You have to provide an `open` and an `onClose` prop to the `Dialog` component.");
    if (!C) throw new Error("You provided an `onClose` prop to the `Dialog`, but forgot an `open` prop.");
    if (!P) throw new Error("You provided an `open` prop to the `Dialog`, but forgot an `onClose` prop.");
    if ("boolean" != typeof s) throw new Error("You provided an `open` prop to the `Dialog`, but the value is not a boolean. Received: ".concat(s));
    if ("function" != typeof c) throw new Error("You provided an `onClose` prop to the `Dialog`, but the value is not a function. Received: ".concat(c));
    let M = s ? 0 : 1,
      [k, S] = x(Zhe, {
        titleId: null,
        descriptionId: null,
        panelRef: O()
      }),
      N = Pce(() => c(!1)),
      B = Pce(e => S({
        type: 0,
        id: e
      })),
      V = !!Mce() && !h && 0 === M,
      R = v > 1,
      A = null !== m(Fhe),
      T = R ? "parent" : "leaf",
      H = null !== b && (b & gue.Closing) === gue.Closing,
      L = !A && !H && V,
      I = f(() => {
        var e, t;
        return null != (t = Array.from(null != (e = null == j ? void 0 : j.querySelectorAll("body > *")) ? e : []).find(e => "headlessui-portal-root" !== e.id && e.contains(E.current) && e instanceof HTMLElement)) ? t : null;
      }, [E]);
    The(I, L);
    let F = !!R || V,
      _ = f(() => {
        var e, t;
        return null != (t = Array.from(null != (e = null == j ? void 0 : j.querySelectorAll("[data-headlessui-portal]")) ? e : []).find(e => e.contains(E.current) && e instanceof HTMLElement)) ? t : null;
      }, [E]);
    The(_, F);
    let Z = Pce(() => {
      var e, t;
      return [...Array.from(null != (e = null == j ? void 0 : j.querySelectorAll("html > *, body > *, [data-headlessui-portal]")) ? e : []).filter(e => !(e === document.body || e === document.head || !(e instanceof HTMLElement) || e.contains(E.current) || k.panelRef.current && e.contains(k.panelRef.current))), null != (t = k.panelRef.current) ? t : w.current];
    });
    $ce(() => Z(), N, !(!V || R));
    let D = !(R || 0 !== M);
    Yue(null == j ? void 0 : j.defaultView, "keydown", e => {
      D && (e.defaultPrevented || e.key === yue.Escape && (e.preventDefault(), e.stopPropagation(), N()));
    }), function (e, t) {
      let r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : () => [document.body];
      Vhe(e, t, e => {
        var t;
        return {
          containers: [...(null != (t = e.containers) ? t : []), r]
        };
      });
    }(j, !(H || 0 !== M || A), Z), a(() => {
      if (0 !== M || !w.current) return;
      let e = new ResizeObserver(e => {
        for (let t of e) {
          let e = t.target.getBoundingClientRect();
          0 === e.x && 0 === e.y && 0 === e.width && 0 === e.height && N();
        }
      });
      return e.observe(w.current), () => e.disconnect();
    }, [M, w, N]);
    let [q, U] = fhe(),
      $ = d(() => [{
        dialogState: M,
        close: N,
        setTitleId: B
      }, k], [M, k, N, B]),
      z = d(() => ({
        open: 0 === M
      }), [M]),
      W = {
        ref: y,
        id: l,
        role: "dialog",
        "aria-modal": 0 === M || void 0,
        "aria-labelledby": k.titleId,
        "aria-describedby": q
      };
    return t.createElement(whe, {
      type: "Dialog",
      enabled: 0 === M,
      element: w,
      onUpdate: Pce((e, t) => {
        "Dialog" === t && Nce(e, {
          [bhe.Add]: () => g(e => e + 1),
          [bhe.Remove]: () => g(e => e - 1)
        });
      })
    }, t.createElement(ohe, {
      force: !0
    }, t.createElement(hhe, null, t.createElement(Fhe.Provider, {
      value: $
    }, t.createElement(hhe.Group, {
      target: w
    }, t.createElement(ohe, {
      force: !1
    }, t.createElement(U, {
      slot: z,
      name: "Dialog.Description"
    }, t.createElement(ehe, {
      initialFocus: u,
      containers: Z,
      features: V ? Nce(T, {
        parent: ehe.features.RestoreFocus,
        leaf: ehe.features.All & ~ehe.features.FocusLock
      }) : ehe.features.None
    }, nue({
      ourProps: W,
      theirProps: p,
      slot: z,
      defaultTag: "div",
      features: Dhe,
      visible: 0 === M,
      name: "Dialog"
    })))))))), t.createElement(due, {
      features: fue.Hidden,
      ref: E
    }));
  }),
  Uhe = iue(function (e, r) {
    let n = Sce(),
      {
        id: o = "headlessui-dialog-backdrop-".concat(n),
        ...i
      } = e,
      [{
        dialogState: l
      }, s] = _he("Dialog.Backdrop"),
      c = Yce(r);
    a(() => {
      if (null === s.panelRef.current) throw new Error("A <Dialog.Backdrop /> component is being used, but a <Dialog.Panel /> component is missing.");
    }, [s.panelRef]);
    let u = d(() => ({
      open: 0 === l
    }), [l]);
    return t.createElement(ohe, {
      force: !0
    }, t.createElement(hhe, null, nue({
      ourProps: {
        ref: c,
        id: o,
        "aria-hidden": !0
      },
      theirProps: i,
      slot: u,
      defaultTag: "div",
      name: "Dialog.Backdrop"
    })));
  }),
  $he = iue(function (e, t) {
    let r = Sce(),
      {
        id: n = "headlessui-dialog-panel-".concat(r),
        ...a
      } = e,
      [{
        dialogState: o
      }, i] = _he("Dialog.Panel"),
      l = Yce(t, i.panelRef),
      s = d(() => ({
        open: 0 === o
      }), [o]),
      c = Pce(e => {
        e.stopPropagation();
      });
    return nue({
      ourProps: {
        ref: l,
        id: n,
        onClick: c
      },
      theirProps: a,
      slot: s,
      defaultTag: "div",
      name: "Dialog.Panel"
    });
  }),
  zhe = iue(function (e, t) {
    let r = Sce(),
      {
        id: n = "headlessui-dialog-overlay-".concat(r),
        ...a
      } = e,
      [{
        dialogState: o,
        close: i
      }] = _he("Dialog.Overlay"),
      l = Yce(t),
      s = Pce(e => {
        if (e.target === e.currentTarget) {
          if (cue(e.currentTarget)) return e.preventDefault();
          e.preventDefault(), e.stopPropagation(), i();
        }
      });
    return nue({
      ourProps: {
        ref: l,
        id: n,
        "aria-hidden": !0,
        onClick: s
      },
      theirProps: a,
      slot: d(() => ({
        open: 0 === o
      }), [o]),
      defaultTag: "div",
      name: "Dialog.Overlay"
    });
  }),
  Whe = iue(function (e, t) {
    let r = Sce(),
      {
        id: n = "headlessui-dialog-title-".concat(r),
        ...o
      } = e,
      [{
        dialogState: i,
        setTitleId: l
      }] = _he("Dialog.Title"),
      s = Yce(t);
    a(() => (l(n), () => l(null)), [n, l]);
    let c = d(() => ({
      open: 0 === i
    }), [i]);
    return nue({
      ourProps: {
        ref: s,
        id: n
      },
      theirProps: o,
      slot: c,
      defaultTag: "h2",
      name: "Dialog.Title"
    });
  }),
  Qhe = Object.assign(qhe, {
    Backdrop: Uhe,
    Panel: $he,
    Overlay: zhe,
    Title: Whe,
    Description: vhe
  });
var Ghe;
let Yhe = null != (Ghe = t.startTransition) ? Ghe : function (e) {
  e();
};
var Khe = (e => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(Khe || {}),
  Xhe = (e => (e[e.ToggleDisclosure = 0] = "ToggleDisclosure", e[e.CloseDisclosure = 1] = "CloseDisclosure", e[e.SetButtonId = 2] = "SetButtonId", e[e.SetPanelId = 3] = "SetPanelId", e[e.LinkPanel = 4] = "LinkPanel", e[e.UnlinkPanel = 5] = "UnlinkPanel", e))(Xhe || {});
let Jhe = {
    0: e => ({
      ...e,
      disclosureState: Nce(e.disclosureState, {
        0: 1,
        1: 0
      })
    }),
    1: e => 1 === e.disclosureState ? e : {
      ...e,
      disclosureState: 1
    },
    4: e => !0 === e.linkedPanel ? e : {
      ...e,
      linkedPanel: !0
    },
    5: e => !1 === e.linkedPanel ? e : {
      ...e,
      linkedPanel: !1
    },
    2: (e, t) => e.buttonId === t.buttonId ? e : {
      ...e,
      buttonId: t.buttonId
    },
    3: (e, t) => e.panelId === t.panelId ? e : {
      ...e,
      panelId: t.panelId
    }
  },
  eme = o(null);
function tme(e) {
  let t = m(eme);
  if (null === t) {
    let t = new Error("<".concat(e, " /> is missing a parent <Disclosure /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(t, tme), t;
  }
  return t;
}
eme.displayName = "DisclosureContext";
let rme = o(null);
function nme(e) {
  let t = m(rme);
  if (null === t) {
    let t = new Error("<".concat(e, " /> is missing a parent <Disclosure /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(t, nme), t;
  }
  return t;
}
rme.displayName = "DisclosureAPIContext";
let ame = o(null);
function ome(e, t) {
  return Nce(t.type, Jhe, e, t);
}
ame.displayName = "DisclosurePanelContext";
let ime = l;
let lme = tue.RenderStrategy | tue.Static;
let sme = iue(function (e, r) {
    let {
        defaultOpen: a = !1,
        ...o
      } = e,
      i = n(null),
      s = Yce(r, Gce(e => {
        i.current = e;
      }, void 0 === e.as || e.as === l)),
      c = n(null),
      u = n(null),
      h = x(ome, {
        disclosureState: a ? 0 : 1,
        linkedPanel: !1,
        buttonRef: u,
        panelRef: c,
        buttonId: null,
        panelId: null
      }),
      [{
        disclosureState: m,
        buttonId: p
      }, f] = h,
      v = Pce(e => {
        f({
          type: 1
        });
        let t = Bce(i);
        if (!t || !p) return;
        let r = e ? e instanceof HTMLElement ? e : e.current instanceof HTMLElement ? e.current : t.getElementById(p) : t.getElementById(p);
        null == r || r.focus();
      }),
      g = d(() => ({
        close: v
      }), [v]),
      b = d(() => ({
        open: 0 === m,
        close: v
      }), [m, v]),
      w = {
        ref: s
      };
    return t.createElement(eme.Provider, {
      value: h
    }, t.createElement(rme.Provider, {
      value: g
    }, t.createElement(wue, {
      value: Nce(m, {
        0: gue.Open,
        1: gue.Closed
      })
    }, nue({
      ourProps: w,
      theirProps: o,
      slot: b,
      defaultTag: ime,
      name: "Disclosure"
    }))));
  }),
  cme = iue(function (e, t) {
    let r = Sce(),
      {
        id: o = "headlessui-disclosure-button-".concat(r),
        ...i
      } = e,
      [l, s] = tme("Disclosure.Button"),
      c = m(ame),
      u = null !== c && c === l.panelId,
      h = n(null),
      p = Yce(h, t, u ? null : l.buttonRef);
    a(() => {
      if (!u) return s({
        type: 2,
        buttonId: o
      }), () => {
        s({
          type: 2,
          buttonId: null
        });
      };
    }, [o, s, u]);
    let f = Pce(e => {
        var t;
        if (u) {
          if (1 === l.disclosureState) return;
          switch (e.key) {
            case yue.Space:
            case yue.Enter:
              e.preventDefault(), e.stopPropagation(), s({
                type: 0
              }), null == (t = l.buttonRef.current) || t.focus();
          }
        } else switch (e.key) {
          case yue.Space:
          case yue.Enter:
            e.preventDefault(), e.stopPropagation(), s({
              type: 0
            });
        }
      }),
      v = Pce(e => {
        if (e.key === yue.Space) e.preventDefault();
      }),
      g = Pce(t => {
        var r;
        cue(t.currentTarget) || e.disabled || (u ? (s({
          type: 0
        }), null == (r = l.buttonRef.current) || r.focus()) : s({
          type: 0
        }));
      }),
      b = d(() => ({
        open: 0 === l.disclosureState
      }), [l]),
      w = Wce(e, h);
    return nue({
      ourProps: u ? {
        ref: p,
        type: w,
        onKeyDown: f,
        onClick: g
      } : {
        ref: p,
        id: o,
        type: w,
        "aria-expanded": e.disabled ? void 0 : 0 === l.disclosureState,
        "aria-controls": l.linkedPanel ? l.panelId : void 0,
        onKeyDown: f,
        onKeyUp: v,
        onClick: g
      },
      theirProps: i,
      slot: b,
      defaultTag: "button",
      name: "Disclosure.Button"
    });
  }),
  ume = iue(function (e, r) {
    let n = Sce(),
      {
        id: o = "headlessui-disclosure-panel-".concat(n),
        ...i
      } = e,
      [l, s] = tme("Disclosure.Panel"),
      {
        close: c
      } = nme("Disclosure.Panel"),
      u = Yce(r, l.panelRef, e => {
        Yhe(() => s({
          type: e ? 4 : 5
        }));
      });
    a(() => (s({
      type: 3,
      panelId: o
    }), () => {
      s({
        type: 3,
        panelId: null
      });
    }), [o, s]);
    let h = bue(),
      m = null !== h ? (h & gue.Open) === gue.Open : 0 === l.disclosureState,
      p = d(() => ({
        open: 0 === l.disclosureState,
        close: c
      }), [l, c]),
      f = {
        ref: u,
        id: o
      };
    return t.createElement(ame.Provider, {
      value: l.panelId
    }, nue({
      ourProps: f,
      theirProps: i,
      slot: p,
      defaultTag: "div",
      features: lme,
      visible: m,
      name: "Disclosure.Panel"
    }));
  });
Object.assign(sme, {
  Button: cme,
  Panel: ume
});
var hme = (e => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(hme || {}),
  mme = (e => (e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e))(mme || {}),
  pme = (e => (e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e))(pme || {}),
  fme = (e => (e[e.OpenListbox = 0] = "OpenListbox", e[e.CloseListbox = 1] = "CloseListbox", e[e.GoToOption = 2] = "GoToOption", e[e.Search = 3] = "Search", e[e.ClearSearch = 4] = "ClearSearch", e[e.RegisterOption = 5] = "RegisterOption", e[e.UnregisterOption = 6] = "UnregisterOption", e[e.RegisterLabel = 7] = "RegisterLabel", e))(fme || {});
function dme(e) {
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : e => e;
  let r = null !== e.activeOptionIndex ? e.options[e.activeOptionIndex] : null,
    n = Dce(t(e.options.slice()), e => e.dataRef.current.domRef.current),
    a = r ? n.indexOf(r) : null;
  return -1 === a && (a = null), {
    options: n,
    activeOptionIndex: a
  };
}
let vme = {
    1: e => e.dataRef.current.disabled || 1 === e.listboxState ? e : {
      ...e,
      activeOptionIndex: null,
      listboxState: 1
    },
    0(e) {
      if (e.dataRef.current.disabled || 0 === e.listboxState) return e;
      let t = e.activeOptionIndex,
        {
          isSelected: r
        } = e.dataRef.current,
        n = e.options.findIndex(e => r(e.dataRef.current.value));
      return -1 !== n && (t = n), {
        ...e,
        listboxState: 0,
        activeOptionIndex: t
      };
    },
    2(e, t) {
      var r;
      if (e.dataRef.current.disabled || 1 === e.listboxState) return e;
      let n = dme(e),
        a = Jce(t, {
          resolveItems: () => n.options,
          resolveActiveIndex: () => n.activeOptionIndex,
          resolveId: e => e.id,
          resolveDisabled: e => e.dataRef.current.disabled
        });
      return {
        ...e,
        ...n,
        searchQuery: "",
        activeOptionIndex: a,
        activationTrigger: null != (r = t.trigger) ? r : 1
      };
    },
    3: (e, t) => {
      if (e.dataRef.current.disabled || 1 === e.listboxState) return e;
      let r = "" !== e.searchQuery ? 0 : 1,
        n = e.searchQuery + t.value.toLowerCase(),
        a = (null !== e.activeOptionIndex ? e.options.slice(e.activeOptionIndex + r).concat(e.options.slice(0, e.activeOptionIndex + r)) : e.options).find(e => {
          var t;
          return !e.dataRef.current.disabled && (null == (t = e.dataRef.current.textValue) ? void 0 : t.startsWith(n));
        }),
        o = a ? e.options.indexOf(a) : -1;
      return -1 === o || o === e.activeOptionIndex ? {
        ...e,
        searchQuery: n
      } : {
        ...e,
        searchQuery: n,
        activeOptionIndex: o,
        activationTrigger: 1
      };
    },
    4: e => e.dataRef.current.disabled || 1 === e.listboxState || "" === e.searchQuery ? e : {
      ...e,
      searchQuery: ""
    },
    5: (e, t) => {
      let r = {
          id: t.id,
          dataRef: t.dataRef
        },
        n = dme(e, e => [...e, r]);
      return null === e.activeOptionIndex && e.dataRef.current.isSelected(t.dataRef.current.value) && (n.activeOptionIndex = n.options.indexOf(r)), {
        ...e,
        ...n
      };
    },
    6: (e, t) => {
      let r = dme(e, e => {
        let r = e.findIndex(e => e.id === t.id);
        return -1 !== r && e.splice(r, 1), e;
      });
      return {
        ...e,
        ...r,
        activationTrigger: 1
      };
    },
    7: (e, t) => ({
      ...e,
      labelId: t.id
    })
  },
  gme = o(null);
function bme(e) {
  let t = m(gme);
  if (null === t) {
    let t = new Error("<".concat(e, " /> is missing a parent <Listbox /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(t, bme), t;
  }
  return t;
}
gme.displayName = "ListboxActionsContext";
let wme = o(null);
function yme(e) {
  let t = m(wme);
  if (null === t) {
    let t = new Error("<".concat(e, " /> is missing a parent <Listbox /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(t, yme), t;
  }
  return t;
}
function xme(e, t) {
  return Nce(t.type, vme, e, t);
}
wme.displayName = "ListboxDataContext";
let Ome = l;
let Eme = tue.RenderStrategy | tue.Static;
let jme = iue(function (e, r) {
    let {
      value: o,
      defaultValue: i,
      name: l,
      onChange: s,
      by: c = (e, t) => e === t,
      disabled: u = !1,
      horizontal: h = !1,
      multiple: m = !1,
      ...p
    } = e;
    const v = h ? "horizontal" : "vertical";
    let g = Yce(r),
      [b = m ? [] : void 0, w] = xue(o, s, i),
      [y, E] = x(xme, {
        dataRef: O(),
        listboxState: 1,
        options: [],
        searchQuery: "",
        labelId: null,
        activeOptionIndex: null,
        activationTrigger: 1
      }),
      j = n({
        static: !1,
        hold: !1
      }),
      C = n(null),
      P = n(null),
      M = n(null),
      k = Pce("string" == typeof c ? (e, t) => {
        let r = c;
        return (null == e ? void 0 : e[r]) === (null == t ? void 0 : t[r]);
      } : c),
      S = f(e => Nce(N.mode, {
        1: () => b.some(t => k(t, e)),
        0: () => k(b, e)
      }), [b]),
      N = d(() => ({
        ...y,
        value: b,
        disabled: u,
        mode: m ? 1 : 0,
        orientation: v,
        compare: k,
        isSelected: S,
        optionsPropsRef: j,
        labelRef: C,
        buttonRef: P,
        optionsRef: M
      }), [b, u, m, y]);
    yce(() => {
      y.dataRef.current = N;
    }, [N]), $ce([N.buttonRef, N.optionsRef], (e, t) => {
      var r;
      E({
        type: 1
      }), Ice(t, Lce.Loose) || (e.preventDefault(), null == (r = N.buttonRef.current) || r.focus());
    }, 0 === N.listboxState);
    let B = d(() => ({
        open: 0 === N.listboxState,
        disabled: u,
        value: b
      }), [N, u, b]),
      V = Pce(e => {
        let t = N.options.find(t => t.id === e);
        t && F(t.dataRef.current.value);
      }),
      R = Pce(() => {
        if (null !== N.activeOptionIndex) {
          let {
            dataRef: e,
            id: t
          } = N.options[N.activeOptionIndex];
          F(e.current.value), E({
            type: 2,
            focus: Xce.Specific,
            id: t
          });
        }
      }),
      A = Pce(() => E({
        type: 0
      })),
      T = Pce(() => E({
        type: 1
      })),
      H = Pce((e, t, r) => e === Xce.Specific ? E({
        type: 2,
        focus: Xce.Specific,
        id: t,
        trigger: r
      }) : E({
        type: 2,
        focus: e,
        trigger: r
      })),
      L = Pce((e, t) => (E({
        type: 5,
        id: e,
        dataRef: t
      }), () => E({
        type: 6,
        id: e
      }))),
      I = Pce(e => (E({
        type: 7,
        id: e
      }), () => E({
        type: 7,
        id: null
      }))),
      F = Pce(e => Nce(N.mode, {
        0: () => null == w ? void 0 : w(e),
        1() {
          let t = N.value.slice(),
            r = t.findIndex(t => k(t, e));
          return -1 === r ? t.push(e) : t.splice(r, 1), null == w ? void 0 : w(t);
        }
      })),
      _ = Pce(e => E({
        type: 3,
        value: e
      })),
      Z = Pce(() => E({
        type: 4
      })),
      D = d(() => ({
        onChange: F,
        registerOption: L,
        registerLabel: I,
        goToOption: H,
        closeListbox: T,
        openListbox: A,
        selectActiveOption: R,
        selectOption: V,
        search: _,
        clearSearch: Z
      }), []),
      q = {
        ref: g
      },
      U = n(null),
      $ = Cce();
    return a(() => {
      U.current && void 0 !== i && $.addEventListener(U.current, "reset", () => {
        F(i);
      });
    }, [U, F]), t.createElement(gme.Provider, {
      value: D
    }, t.createElement(wme.Provider, {
      value: N
    }, t.createElement(wue, {
      value: Nce(N.listboxState, {
        0: gue.Open,
        1: gue.Closed
      })
    }, null != l && null != b && uue({
      [l]: b
    }).map((_ref136, n) => {
      let [e, r] = _ref136;
      return t.createElement(due, {
        features: fue.Hidden,
        ref: 0 === n ? e => {
          var t;
          U.current = null != (t = null == e ? void 0 : e.closest("form")) ? t : null;
        } : void 0,
        ...lue({
          key: e,
          as: "input",
          type: "hidden",
          hidden: !0,
          readOnly: !0,
          name: e,
          value: r
        })
      });
    }), nue({
      ourProps: q,
      theirProps: p,
      slot: B,
      defaultTag: Ome,
      name: "Listbox"
    }))));
  }),
  Cme = iue(function (e, t) {
    var r;
    let n = Sce(),
      {
        id: a = "headlessui-listbox-button-".concat(n),
        ...o
      } = e,
      i = yme("Listbox.Button"),
      l = bme("Listbox.Button"),
      s = Yce(i.buttonRef, t),
      c = Cce(),
      u = Pce(e => {
        switch (e.key) {
          case yue.Space:
          case yue.Enter:
          case yue.ArrowDown:
            e.preventDefault(), l.openListbox(), c.nextFrame(() => {
              i.value || l.goToOption(Xce.First);
            });
            break;
          case yue.ArrowUp:
            e.preventDefault(), l.openListbox(), c.nextFrame(() => {
              i.value || l.goToOption(Xce.Last);
            });
        }
      }),
      h = Pce(e => {
        if (e.key === yue.Space) e.preventDefault();
      }),
      m = Pce(e => {
        if (cue(e.currentTarget)) return e.preventDefault();
        0 === i.listboxState ? (l.closeListbox(), c.nextFrame(() => {
          var e;
          return null == (e = i.buttonRef.current) ? void 0 : e.focus({
            preventScroll: !0
          });
        })) : (e.preventDefault(), l.openListbox());
      }),
      p = Oce(() => {
        if (i.labelId) return [i.labelId, a].join(" ");
      }, [i.labelId, a]),
      f = d(() => ({
        open: 0 === i.listboxState,
        disabled: i.disabled,
        value: i.value
      }), [i]);
    return nue({
      ourProps: {
        ref: s,
        id: a,
        type: Wce(e, i.buttonRef),
        "aria-haspopup": "listbox",
        "aria-controls": null == (r = i.optionsRef.current) ? void 0 : r.id,
        "aria-expanded": i.disabled ? void 0 : 0 === i.listboxState,
        "aria-labelledby": p,
        disabled: i.disabled,
        onKeyDown: u,
        onKeyUp: h,
        onClick: m
      },
      theirProps: o,
      slot: f,
      defaultTag: "button",
      name: "Listbox.Button"
    });
  }),
  Pme = iue(function (e, t) {
    let r = Sce(),
      {
        id: n = "headlessui-listbox-label-".concat(r),
        ...a
      } = e,
      o = yme("Listbox.Label"),
      i = bme("Listbox.Label"),
      l = Yce(o.labelRef, t);
    yce(() => i.registerLabel(n), [n]);
    let s = Pce(() => {
        var e;
        return null == (e = o.buttonRef.current) ? void 0 : e.focus({
          preventScroll: !0
        });
      }),
      c = d(() => ({
        open: 0 === o.listboxState,
        disabled: o.disabled
      }), [o]);
    return nue({
      ourProps: {
        ref: l,
        id: n,
        onClick: s
      },
      theirProps: a,
      slot: c,
      defaultTag: "label",
      name: "Listbox.Label"
    });
  }),
  Mme = iue(function (e, t) {
    var r;
    let n = Sce(),
      {
        id: o = "headlessui-listbox-options-".concat(n),
        ...i
      } = e,
      l = yme("Listbox.Options"),
      s = bme("Listbox.Options"),
      c = Yce(l.optionsRef, t),
      u = Cce(),
      h = Cce(),
      m = bue(),
      p = null !== m ? (m & gue.Open) === gue.Open : 0 === l.listboxState;
    a(() => {
      var e;
      let t = l.optionsRef.current;
      t && 0 === l.listboxState && t !== (null == (e = Bce(t)) ? void 0 : e.activeElement) && t.focus({
        preventScroll: !0
      });
    }, [l.listboxState, l.optionsRef]);
    let f = Pce(e => {
        switch (h.dispose(), e.key) {
          case yue.Space:
            if ("" !== l.searchQuery) return e.preventDefault(), e.stopPropagation(), s.search(e.key);
          case yue.Enter:
            if (e.preventDefault(), e.stopPropagation(), null !== l.activeOptionIndex) {
              let {
                dataRef: e
              } = l.options[l.activeOptionIndex];
              s.onChange(e.current.value);
            }
            0 === l.mode && (s.closeListbox(), jce().nextFrame(() => {
              var e;
              return null == (e = l.buttonRef.current) ? void 0 : e.focus({
                preventScroll: !0
              });
            }));
            break;
          case Nce(l.orientation, {
            vertical: yue.ArrowDown,
            horizontal: yue.ArrowRight
          }):
            return e.preventDefault(), e.stopPropagation(), s.goToOption(Xce.Next);
          case Nce(l.orientation, {
            vertical: yue.ArrowUp,
            horizontal: yue.ArrowLeft
          }):
            return e.preventDefault(), e.stopPropagation(), s.goToOption(Xce.Previous);
          case yue.Home:
          case yue.PageUp:
            return e.preventDefault(), e.stopPropagation(), s.goToOption(Xce.First);
          case yue.End:
          case yue.PageDown:
            return e.preventDefault(), e.stopPropagation(), s.goToOption(Xce.Last);
          case yue.Escape:
            return e.preventDefault(), e.stopPropagation(), s.closeListbox(), u.nextFrame(() => {
              var e;
              return null == (e = l.buttonRef.current) ? void 0 : e.focus({
                preventScroll: !0
              });
            });
          case yue.Tab:
            e.preventDefault(), e.stopPropagation();
            break;
          default:
            1 === e.key.length && (s.search(e.key), h.setTimeout(() => s.clearSearch(), 350));
        }
      }),
      v = Oce(() => {
        var e, t, r;
        return null != (r = null == (e = l.labelRef.current) ? void 0 : e.id) ? r : null == (t = l.buttonRef.current) ? void 0 : t.id;
      }, [l.labelRef.current, l.buttonRef.current]),
      g = d(() => ({
        open: 0 === l.listboxState
      }), [l]);
    return nue({
      ourProps: {
        "aria-activedescendant": null === l.activeOptionIndex || null == (r = l.options[l.activeOptionIndex]) ? void 0 : r.id,
        "aria-multiselectable": 1 === l.mode || void 0,
        "aria-labelledby": v,
        "aria-orientation": l.orientation,
        id: o,
        onKeyDown: f,
        role: "listbox",
        tabIndex: 0,
        ref: c
      },
      theirProps: i,
      slot: g,
      defaultTag: "ul",
      features: Eme,
      visible: p,
      name: "Listbox.Options"
    });
  }),
  kme = iue(function (e, t) {
    let r = Sce(),
      {
        id: a = "headlessui-listbox-option-".concat(r),
        disabled: o = !1,
        value: i,
        ...l
      } = e,
      s = yme("Listbox.Option"),
      c = bme("Listbox.Option"),
      u = null !== s.activeOptionIndex && s.options[s.activeOptionIndex].id === a,
      h = s.isSelected(i),
      m = n(null),
      p = xce({
        disabled: o,
        value: i,
        domRef: m,
        get textValue() {
          var e, t;
          return null == (t = null == (e = m.current) ? void 0 : e.textContent) ? void 0 : t.toLowerCase();
        }
      }),
      f = Yce(t, m);
    yce(() => {
      if (0 !== s.listboxState || !u || 0 === s.activationTrigger) return;
      let e = jce();
      return e.requestAnimationFrame(() => {
        var e, t;
        null == (t = null == (e = m.current) ? void 0 : e.scrollIntoView) || t.call(e, {
          block: "nearest"
        });
      }), e.dispose;
    }, [m, u, s.listboxState, s.activationTrigger, s.activeOptionIndex]), yce(() => c.registerOption(a, p), [p, a]);
    let v = Pce(e => {
        if (o) return e.preventDefault();
        c.onChange(i), 0 === s.mode && (c.closeListbox(), jce().nextFrame(() => {
          var e;
          return null == (e = s.buttonRef.current) ? void 0 : e.focus({
            preventScroll: !0
          });
        }));
      }),
      g = Pce(() => {
        if (o) return c.goToOption(Xce.Nothing);
        c.goToOption(Xce.Specific, a);
      }),
      b = jue(),
      w = Pce(e => b.update(e)),
      y = Pce(e => {
        b.wasMoved(e) && (o || u || c.goToOption(Xce.Specific, a, 0));
      }),
      x = Pce(e => {
        b.wasMoved(e) && (o || u && c.goToOption(Xce.Nothing));
      }),
      O = d(() => ({
        active: u,
        selected: h,
        disabled: o
      }), [u, h, o]);
    return nue({
      ourProps: {
        id: a,
        ref: f,
        role: "option",
        tabIndex: !0 === o ? void 0 : -1,
        "aria-disabled": !0 === o || void 0,
        "aria-selected": h,
        disabled: void 0,
        onClick: v,
        onFocus: g,
        onPointerEnter: w,
        onMouseEnter: w,
        onPointerMove: y,
        onMouseMove: y,
        onPointerLeave: x,
        onMouseLeave: x
      },
      theirProps: l,
      slot: O,
      defaultTag: "li",
      name: "Listbox.Option"
    });
  });
Object.assign(jme, {
  Button: Cme,
  Label: Pme,
  Options: Mme,
  Option: kme
});
var Sme = (e => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(Sme || {}),
  Nme = (e => (e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e))(Nme || {}),
  Bme = (e => (e[e.OpenMenu = 0] = "OpenMenu", e[e.CloseMenu = 1] = "CloseMenu", e[e.GoToItem = 2] = "GoToItem", e[e.Search = 3] = "Search", e[e.ClearSearch = 4] = "ClearSearch", e[e.RegisterItem = 5] = "RegisterItem", e[e.UnregisterItem = 6] = "UnregisterItem", e))(Bme || {});
function Vme(e) {
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : e => e;
  let r = null !== e.activeItemIndex ? e.items[e.activeItemIndex] : null,
    n = Dce(t(e.items.slice()), e => e.dataRef.current.domRef.current),
    a = r ? n.indexOf(r) : null;
  return -1 === a && (a = null), {
    items: n,
    activeItemIndex: a
  };
}
let Rme = {
    1: e => 1 === e.menuState ? e : {
      ...e,
      activeItemIndex: null,
      menuState: 1
    },
    0: e => 0 === e.menuState ? e : {
      ...e,
      menuState: 0
    },
    2: (e, t) => {
      var r;
      let n = Vme(e),
        a = Jce(t, {
          resolveItems: () => n.items,
          resolveActiveIndex: () => n.activeItemIndex,
          resolveId: e => e.id,
          resolveDisabled: e => e.dataRef.current.disabled
        });
      return {
        ...e,
        ...n,
        searchQuery: "",
        activeItemIndex: a,
        activationTrigger: null != (r = t.trigger) ? r : 1
      };
    },
    3: (e, t) => {
      let r = "" !== e.searchQuery ? 0 : 1,
        n = e.searchQuery + t.value.toLowerCase(),
        a = (null !== e.activeItemIndex ? e.items.slice(e.activeItemIndex + r).concat(e.items.slice(0, e.activeItemIndex + r)) : e.items).find(e => {
          var t;
          return (null == (t = e.dataRef.current.textValue) ? void 0 : t.startsWith(n)) && !e.dataRef.current.disabled;
        }),
        o = a ? e.items.indexOf(a) : -1;
      return -1 === o || o === e.activeItemIndex ? {
        ...e,
        searchQuery: n
      } : {
        ...e,
        searchQuery: n,
        activeItemIndex: o,
        activationTrigger: 1
      };
    },
    4: e => "" === e.searchQuery ? e : {
      ...e,
      searchQuery: "",
      searchActiveItemIndex: null
    },
    5: (e, t) => {
      let r = Vme(e, e => [...e, {
        id: t.id,
        dataRef: t.dataRef
      }]);
      return {
        ...e,
        ...r
      };
    },
    6: (e, t) => {
      let r = Vme(e, e => {
        let r = e.findIndex(e => e.id === t.id);
        return -1 !== r && e.splice(r, 1), e;
      });
      return {
        ...e,
        ...r,
        activationTrigger: 1
      };
    }
  },
  Ame = o(null);
function Tme(e) {
  let t = m(Ame);
  if (null === t) {
    let t = new Error("<".concat(e, " /> is missing a parent <Menu /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(t, Tme), t;
  }
  return t;
}
function Hme(e, t) {
  return Nce(t.type, Rme, e, t);
}
Ame.displayName = "MenuContext";
let Lme = l;
let Ime = tue.RenderStrategy | tue.Static;
let Fme = l;
let _me = iue(function (e, r) {
    let n = x(Hme, {
        menuState: 1,
        buttonRef: O(),
        itemsRef: O(),
        items: [],
        searchQuery: "",
        activeItemIndex: null,
        activationTrigger: 1
      }),
      [{
        menuState: a,
        itemsRef: o,
        buttonRef: i
      }, l] = n,
      s = Yce(r);
    $ce([i, o], (e, t) => {
      var r;
      l({
        type: 1
      }), Ice(t, Lce.Loose) || (e.preventDefault(), null == (r = i.current) || r.focus());
    }, 0 === a);
    let c = Pce(() => {
        l({
          type: 1
        });
      }),
      u = d(() => ({
        open: 0 === a,
        close: c
      }), [a, c]),
      h = e,
      m = {
        ref: s
      };
    return t.createElement(Ame.Provider, {
      value: n
    }, t.createElement(wue, {
      value: Nce(a, {
        0: gue.Open,
        1: gue.Closed
      })
    }, nue({
      ourProps: m,
      theirProps: h,
      slot: u,
      defaultTag: Lme,
      name: "Menu"
    })));
  }),
  Zme = iue(function (e, t) {
    var r;
    let n = Sce(),
      {
        id: a = "headlessui-menu-button-".concat(n),
        ...o
      } = e,
      [i, l] = Tme("Menu.Button"),
      s = Yce(i.buttonRef, t),
      c = Cce(),
      u = Pce(e => {
        switch (e.key) {
          case yue.Space:
          case yue.Enter:
          case yue.ArrowDown:
            e.preventDefault(), e.stopPropagation(), l({
              type: 0
            }), c.nextFrame(() => l({
              type: 2,
              focus: Xce.First
            }));
            break;
          case yue.ArrowUp:
            e.preventDefault(), e.stopPropagation(), l({
              type: 0
            }), c.nextFrame(() => l({
              type: 2,
              focus: Xce.Last
            }));
        }
      }),
      h = Pce(e => {
        if (e.key === yue.Space) e.preventDefault();
      }),
      m = Pce(t => {
        if (cue(t.currentTarget)) return t.preventDefault();
        e.disabled || (0 === i.menuState ? (l({
          type: 1
        }), c.nextFrame(() => {
          var e;
          return null == (e = i.buttonRef.current) ? void 0 : e.focus({
            preventScroll: !0
          });
        })) : (t.preventDefault(), l({
          type: 0
        })));
      }),
      p = d(() => ({
        open: 0 === i.menuState
      }), [i]);
    return nue({
      ourProps: {
        ref: s,
        id: a,
        type: Wce(e, i.buttonRef),
        "aria-haspopup": "menu",
        "aria-controls": null == (r = i.itemsRef.current) ? void 0 : r.id,
        "aria-expanded": e.disabled ? void 0 : 0 === i.menuState,
        onKeyDown: u,
        onKeyUp: h,
        onClick: m
      },
      theirProps: o,
      slot: p,
      defaultTag: "button",
      name: "Menu.Button"
    });
  }),
  Dme = iue(function (e, t) {
    var r, n;
    let o = Sce(),
      {
        id: i = "headlessui-menu-items-".concat(o),
        ...l
      } = e,
      [s, c] = Tme("Menu.Items"),
      u = Yce(s.itemsRef, t),
      h = Gue(s.itemsRef),
      m = Cce(),
      p = bue(),
      f = null !== p ? (p & gue.Open) === gue.Open : 0 === s.menuState;
    a(() => {
      let e = s.itemsRef.current;
      e && 0 === s.menuState && e !== (null == h ? void 0 : h.activeElement) && e.focus({
        preventScroll: !0
      });
    }, [s.menuState, s.itemsRef, h]), Kce({
      container: s.itemsRef.current,
      enabled: 0 === s.menuState,
      accept: e => "menuitem" === e.getAttribute("role") ? NodeFilter.FILTER_REJECT : e.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT,
      walk(e) {
        e.setAttribute("role", "none");
      }
    });
    let v = Pce(e => {
        var t, r;
        switch (m.dispose(), e.key) {
          case yue.Space:
            if ("" !== s.searchQuery) return e.preventDefault(), e.stopPropagation(), c({
              type: 3,
              value: e.key
            });
          case yue.Enter:
            if (e.preventDefault(), e.stopPropagation(), c({
              type: 1
            }), null !== s.activeItemIndex) {
              let {
                dataRef: e
              } = s.items[s.activeItemIndex];
              null == (r = null == (t = e.current) ? void 0 : t.domRef.current) || r.click();
            }
            Fce(s.buttonRef.current);
            break;
          case yue.ArrowDown:
            return e.preventDefault(), e.stopPropagation(), c({
              type: 2,
              focus: Xce.Next
            });
          case yue.ArrowUp:
            return e.preventDefault(), e.stopPropagation(), c({
              type: 2,
              focus: Xce.Previous
            });
          case yue.Home:
          case yue.PageUp:
            return e.preventDefault(), e.stopPropagation(), c({
              type: 2,
              focus: Xce.First
            });
          case yue.End:
          case yue.PageDown:
            return e.preventDefault(), e.stopPropagation(), c({
              type: 2,
              focus: Xce.Last
            });
          case yue.Escape:
            e.preventDefault(), e.stopPropagation(), c({
              type: 1
            }), jce().nextFrame(() => {
              var e;
              return null == (e = s.buttonRef.current) ? void 0 : e.focus({
                preventScroll: !0
              });
            });
            break;
          case yue.Tab:
            e.preventDefault(), e.stopPropagation(), c({
              type: 1
            }), jce().nextFrame(() => {
              !function (e, t) {
                qce(Hce(), t, {
                  relativeTo: e
                });
              }(s.buttonRef.current, e.shiftKey ? Rce.Previous : Rce.Next);
            });
            break;
          default:
            1 === e.key.length && (c({
              type: 3,
              value: e.key
            }), m.setTimeout(() => c({
              type: 4
            }), 350));
        }
      }),
      g = Pce(e => {
        if (e.key === yue.Space) e.preventDefault();
      }),
      b = d(() => ({
        open: 0 === s.menuState
      }), [s]);
    return nue({
      ourProps: {
        "aria-activedescendant": null === s.activeItemIndex || null == (r = s.items[s.activeItemIndex]) ? void 0 : r.id,
        "aria-labelledby": null == (n = s.buttonRef.current) ? void 0 : n.id,
        id: i,
        onKeyDown: v,
        onKeyUp: g,
        role: "menu",
        tabIndex: 0,
        ref: u
      },
      theirProps: l,
      slot: b,
      defaultTag: "div",
      features: Ime,
      visible: f,
      name: "Menu.Items"
    });
  }),
  qme = iue(function (e, t) {
    let r = Sce(),
      {
        id: a = "headlessui-menu-item-".concat(r),
        disabled: o = !1,
        ...i
      } = e,
      [l, s] = Tme("Menu.Item"),
      c = null !== l.activeItemIndex && l.items[l.activeItemIndex].id === a,
      u = n(null),
      h = Yce(t, u);
    yce(() => {
      if (0 !== l.menuState || !c || 0 === l.activationTrigger) return;
      let e = jce();
      return e.requestAnimationFrame(() => {
        var e, t;
        null == (t = null == (e = u.current) ? void 0 : e.scrollIntoView) || t.call(e, {
          block: "nearest"
        });
      }), e.dispose;
    }, [u, c, l.menuState, l.activationTrigger, l.activeItemIndex]);
    let m = n({
      disabled: o,
      domRef: u
    });
    yce(() => {
      m.current.disabled = o;
    }, [m, o]), yce(() => {
      var e, t;
      m.current.textValue = null == (t = null == (e = u.current) ? void 0 : e.textContent) ? void 0 : t.toLowerCase();
    }, [m, u]), yce(() => (s({
      type: 5,
      id: a,
      dataRef: m
    }), () => s({
      type: 6,
      id: a
    })), [m, a]);
    let p = Pce(() => {
        s({
          type: 1
        });
      }),
      f = Pce(e => {
        if (o) return e.preventDefault();
        s({
          type: 1
        }), Fce(l.buttonRef.current);
      }),
      v = Pce(() => {
        if (o) return s({
          type: 2,
          focus: Xce.Nothing
        });
        s({
          type: 2,
          focus: Xce.Specific,
          id: a
        });
      }),
      g = jue(),
      b = Pce(e => g.update(e)),
      w = Pce(e => {
        g.wasMoved(e) && (o || c || s({
          type: 2,
          focus: Xce.Specific,
          id: a,
          trigger: 0
        }));
      }),
      y = Pce(e => {
        g.wasMoved(e) && (o || c && s({
          type: 2,
          focus: Xce.Nothing
        }));
      }),
      x = d(() => ({
        active: c,
        disabled: o,
        close: p
      }), [c, o, p]);
    return nue({
      ourProps: {
        id: a,
        ref: h,
        role: "menuitem",
        tabIndex: !0 === o ? void 0 : -1,
        "aria-disabled": !0 === o || void 0,
        disabled: void 0,
        onClick: f,
        onFocus: v,
        onPointerEnter: b,
        onMouseEnter: b,
        onPointerMove: w,
        onMouseMove: w,
        onPointerLeave: y,
        onMouseLeave: y
      },
      theirProps: i,
      slot: x,
      defaultTag: Fme,
      name: "Menu.Item"
    });
  });
Object.assign(_me, {
  Button: Zme,
  Items: Dme,
  Item: qme
});
var Ume = (e => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(Ume || {}),
  $me = (e => (e[e.TogglePopover = 0] = "TogglePopover", e[e.ClosePopover = 1] = "ClosePopover", e[e.SetButton = 2] = "SetButton", e[e.SetButtonId = 3] = "SetButtonId", e[e.SetPanel = 4] = "SetPanel", e[e.SetPanelId = 5] = "SetPanelId", e))($me || {});
let zme = {
    0: e => ({
      ...e,
      popoverState: Nce(e.popoverState, {
        0: 1,
        1: 0
      })
    }),
    1: e => 1 === e.popoverState ? e : {
      ...e,
      popoverState: 1
    },
    2: (e, t) => e.button === t.button ? e : {
      ...e,
      button: t.button
    },
    3: (e, t) => e.buttonId === t.buttonId ? e : {
      ...e,
      buttonId: t.buttonId
    },
    4: (e, t) => e.panel === t.panel ? e : {
      ...e,
      panel: t.panel
    },
    5: (e, t) => e.panelId === t.panelId ? e : {
      ...e,
      panelId: t.panelId
    }
  },
  Wme = o(null);
function Qme(e) {
  let t = m(Wme);
  if (null === t) {
    let t = new Error("<".concat(e, " /> is missing a parent <Popover /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(t, Qme), t;
  }
  return t;
}
Wme.displayName = "PopoverContext";
let Gme = o(null);
function Yme(e) {
  let t = m(Gme);
  if (null === t) {
    let t = new Error("<".concat(e, " /> is missing a parent <Popover /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(t, Yme), t;
  }
  return t;
}
Gme.displayName = "PopoverAPIContext";
let Kme = o(null);
function Xme() {
  return m(Kme);
}
Kme.displayName = "PopoverGroupContext";
let Jme = o(null);
function epe(e, t) {
  return Nce(t.type, zme, e, t);
}
Jme.displayName = "PopoverPanelContext";
let tpe = tue.RenderStrategy | tue.Static;
let rpe = tue.RenderStrategy | tue.Static;
let npe = iue(function (e, r) {
    var o;
    let i = n(null),
      l = Yce(r, Gce(e => {
        i.current = e;
      })),
      s = n([]),
      c = x(epe, {
        popoverState: 1,
        buttons: s,
        button: null,
        buttonId: null,
        panel: null,
        panelId: null,
        beforePanelSentinel: O(),
        afterPanelSentinel: O()
      }),
      [{
        popoverState: u,
        button: h,
        buttonId: m,
        panel: p,
        panelId: f,
        beforePanelSentinel: v,
        afterPanelSentinel: g
      }, b] = c,
      w = Gue(null != (o = i.current) ? o : h),
      y = d(() => {
        if (!h || !p) return !1;
        for (let e of document.querySelectorAll("body > *")) if (Number(null == e ? void 0 : e.contains(h)) ^ Number(null == e ? void 0 : e.contains(p))) return !0;
        let e = Hce(),
          t = e.indexOf(h),
          r = (t + e.length - 1) % e.length,
          n = (t + 1) % e.length,
          a = e[r],
          o = e[n];
        return !p.contains(a) && !p.contains(o);
      }, [h, p]),
      E = xce(m),
      j = xce(f),
      C = d(() => ({
        buttonId: E,
        panelId: j,
        close: () => b({
          type: 1
        })
      }), [E, j, b]),
      P = Xme(),
      M = null == P ? void 0 : P.registerPopover,
      k = Pce(() => {
        var e;
        return null != (e = null == P ? void 0 : P.isFocusWithinPopoverGroup()) ? e : (null == w ? void 0 : w.activeElement) && ((null == h ? void 0 : h.contains(w.activeElement)) || (null == p ? void 0 : p.contains(w.activeElement)));
      });
    a(() => null == M ? void 0 : M(C), [M, C]), Yue(null == w ? void 0 : w.defaultView, "focus", e => {
      var t, r, n, a;
      0 === u && (k() || h && p && e.target !== window && (null != (r = null == (t = v.current) ? void 0 : t.contains) && r.call(t, e.target) || null != (a = null == (n = g.current) ? void 0 : n.contains) && a.call(n, e.target) || b({
        type: 1
      })));
    }, !0), $ce([h, p], (e, t) => {
      b({
        type: 1
      }), Ice(t, Lce.Loose) || (e.preventDefault(), null == h || h.focus());
    }, 0 === u);
    let S = Pce(e => {
        b({
          type: 1
        });
        let t = e ? e instanceof HTMLElement ? e : "current" in e && e.current instanceof HTMLElement ? e.current : h : h;
        null == t || t.focus();
      }),
      N = d(() => ({
        close: S,
        isPortalled: y
      }), [S, y]),
      B = d(() => ({
        open: 0 === u,
        close: S
      }), [u, S]),
      V = e,
      R = {
        ref: l
      };
    return t.createElement(Jme.Provider, {
      value: null
    }, t.createElement(Wme.Provider, {
      value: c
    }, t.createElement(Gme.Provider, {
      value: N
    }, t.createElement(wue, {
      value: Nce(u, {
        0: gue.Open,
        1: gue.Closed
      })
    }, nue({
      ourProps: R,
      theirProps: V,
      slot: B,
      defaultTag: "div",
      name: "Popover"
    })))));
  }),
  ape = iue(function (e, o) {
    let i = Sce(),
      {
        id: l = "headlessui-popover-button-".concat(i),
        ...s
      } = e,
      [c, u] = Qme("Popover.Button"),
      {
        isPortalled: h
      } = Yme("Popover.Button"),
      p = n(null),
      f = "headlessui-focus-sentinel-".concat(Sce()),
      v = Xme(),
      g = null == v ? void 0 : v.closeOthers,
      b = null !== m(Jme);
    a(() => {
      if (!b) return u({
        type: 3,
        buttonId: l
      }), () => {
        u({
          type: 3,
          buttonId: null
        });
      };
    }, [b, l, u]);
    let [w] = r(() => Symbol()),
      y = Yce(p, o, b ? null : e => {
        if (e) c.buttons.current.push(w);else {
          let e = c.buttons.current.indexOf(w);
          -1 !== e && c.buttons.current.splice(e, 1);
        }
        c.buttons.current.length > 1 && console.warn("You are already using a <Popover.Button /> but only 1 <Popover.Button /> is supported."), e && u({
          type: 2,
          button: e
        });
      }),
      x = Yce(p, o),
      O = Gue(p),
      E = Pce(e => {
        var t, r, n;
        if (b) {
          if (1 === c.popoverState) return;
          switch (e.key) {
            case yue.Space:
            case yue.Enter:
              e.preventDefault(), null == (r = (t = e.target).click) || r.call(t), u({
                type: 1
              }), null == (n = c.button) || n.focus();
          }
        } else switch (e.key) {
          case yue.Space:
          case yue.Enter:
            e.preventDefault(), e.stopPropagation(), 1 === c.popoverState && (null == g || g(c.buttonId)), u({
              type: 0
            });
            break;
          case yue.Escape:
            if (0 !== c.popoverState) return null == g ? void 0 : g(c.buttonId);
            if (!p.current || null != O && O.activeElement && !p.current.contains(O.activeElement)) return;
            e.preventDefault(), e.stopPropagation(), u({
              type: 1
            });
        }
      }),
      j = Pce(e => {
        b || e.key === yue.Space && e.preventDefault();
      }),
      C = Pce(t => {
        var r, n;
        cue(t.currentTarget) || e.disabled || (b ? (u({
          type: 1
        }), null == (r = c.button) || r.focus()) : (t.preventDefault(), t.stopPropagation(), 1 === c.popoverState && (null == g || g(c.buttonId)), u({
          type: 0
        }), null == (n = c.button) || n.focus()));
      }),
      P = Pce(e => {
        e.preventDefault(), e.stopPropagation();
      }),
      M = 0 === c.popoverState,
      k = d(() => ({
        open: M
      }), [M]),
      S = Wce(e, p),
      N = b ? {
        ref: x,
        type: S,
        onKeyDown: E,
        onClick: C
      } : {
        ref: y,
        id: c.buttonId,
        type: S,
        "aria-expanded": e.disabled ? void 0 : 0 === c.popoverState,
        "aria-controls": c.panel ? c.panelId : void 0,
        onKeyDown: E,
        onKeyUp: j,
        onClick: C,
        onMouseDown: P
      },
      B = Wue(),
      V = Pce(() => {
        let e = c.panel;
        e && Nce(B.current, {
          [zue.Forwards]: () => qce(e, Rce.First),
          [zue.Backwards]: () => qce(e, Rce.Last)
        }) === Ace.Error && qce(Hce().filter(e => "true" !== e.dataset.headlessuiFocusGuard), Nce(B.current, {
          [zue.Forwards]: Rce.Next,
          [zue.Backwards]: Rce.Previous
        }), {
          relativeTo: c.button
        });
      });
    return t.createElement(t.Fragment, null, nue({
      ourProps: N,
      theirProps: s,
      slot: k,
      defaultTag: "button",
      name: "Popover.Button"
    }), M && !b && h && t.createElement(due, {
      id: f,
      features: fue.Focusable,
      "data-headlessui-focus-guard": !0,
      as: "button",
      type: "button",
      onFocus: V
    }));
  }),
  ope = iue(function (e, t) {
    let r = Sce(),
      {
        id: n = "headlessui-popover-overlay-".concat(r),
        ...a
      } = e,
      [{
        popoverState: o
      }, i] = Qme("Popover.Overlay"),
      l = Yce(t),
      s = bue(),
      c = null !== s ? (s & gue.Open) === gue.Open : 0 === o,
      u = Pce(e => {
        if (cue(e.currentTarget)) return e.preventDefault();
        i({
          type: 1
        });
      });
    return nue({
      ourProps: {
        ref: l,
        id: n,
        "aria-hidden": !0,
        onClick: u
      },
      theirProps: a,
      slot: d(() => ({
        open: 0 === o
      }), [o]),
      defaultTag: "div",
      features: tpe,
      visible: c,
      name: "Popover.Overlay"
    });
  }),
  ipe = iue(function (e, r) {
    let o = Sce(),
      {
        id: i = "headlessui-popover-panel-".concat(o),
        focus: l = !1,
        ...s
      } = e,
      [c, u] = Qme("Popover.Panel"),
      {
        close: h,
        isPortalled: m
      } = Yme("Popover.Panel"),
      p = "headlessui-focus-sentinel-before-".concat(Sce()),
      f = "headlessui-focus-sentinel-after-".concat(Sce()),
      v = n(null),
      g = Yce(v, r, e => {
        u({
          type: 4,
          panel: e
        });
      }),
      b = Gue(v);
    yce(() => (u({
      type: 5,
      panelId: i
    }), () => {
      u({
        type: 5,
        panelId: null
      });
    }), [i, u]);
    let w = bue(),
      y = null !== w ? (w & gue.Open) === gue.Open : 0 === c.popoverState,
      x = Pce(e => {
        var t;
        if (e.key === yue.Escape) {
          if (0 !== c.popoverState || !v.current || null != b && b.activeElement && !v.current.contains(b.activeElement)) return;
          e.preventDefault(), e.stopPropagation(), u({
            type: 1
          }), null == (t = c.button) || t.focus();
        }
      });
    a(() => {
      var t;
      e.static || 1 === c.popoverState && (null == (t = e.unmount) || t) && u({
        type: 4,
        panel: null
      });
    }, [c.popoverState, e.unmount, e.static, u]), a(() => {
      if (!l || 0 !== c.popoverState || !v.current) return;
      let e = null == b ? void 0 : b.activeElement;
      v.current.contains(e) || qce(v.current, Rce.First);
    }, [l, v, c.popoverState]);
    let O = d(() => ({
        open: 0 === c.popoverState,
        close: h
      }), [c, h]),
      E = {
        ref: g,
        id: i,
        onKeyDown: x,
        onBlur: l && 0 === c.popoverState ? e => {
          var t, r, n, a, o;
          let i = e.relatedTarget;
          i && v.current && (null != (t = v.current) && t.contains(i) || (u({
            type: 1
          }), (null != (n = null == (r = c.beforePanelSentinel.current) ? void 0 : r.contains) && n.call(r, i) || null != (o = null == (a = c.afterPanelSentinel.current) ? void 0 : a.contains) && o.call(a, i)) && i.focus({
            preventScroll: !0
          })));
        } : void 0,
        tabIndex: -1
      },
      j = Wue(),
      C = Pce(() => {
        let e = v.current;
        e && Nce(j.current, {
          [zue.Forwards]: () => {
            var t;
            qce(e, Rce.First) === Ace.Error && (null == (t = c.afterPanelSentinel.current) || t.focus());
          },
          [zue.Backwards]: () => {
            var e;
            null == (e = c.button) || e.focus({
              preventScroll: !0
            });
          }
        });
      }),
      P = Pce(() => {
        let e = v.current;
        e && Nce(j.current, {
          [zue.Forwards]: () => {
            var e;
            if (!c.button) return;
            let t = Hce(),
              r = t.indexOf(c.button),
              n = t.slice(0, r + 1),
              a = [...t.slice(r + 1), ...n];
            for (let t of a.slice()) if ("true" === t.dataset.headlessuiFocusGuard || null != (e = c.panel) && e.contains(t)) {
              let e = a.indexOf(t);
              -1 !== e && a.splice(e, 1);
            }
            qce(a, Rce.First, {
              sorted: !1
            });
          },
          [zue.Backwards]: () => {
            var t;
            qce(e, Rce.Previous) === Ace.Error && (null == (t = c.button) || t.focus());
          }
        });
      });
    return t.createElement(Jme.Provider, {
      value: i
    }, y && m && t.createElement(due, {
      id: p,
      ref: c.beforePanelSentinel,
      features: fue.Focusable,
      "data-headlessui-focus-guard": !0,
      as: "button",
      type: "button",
      onFocus: C
    }), nue({
      ourProps: E,
      theirProps: s,
      slot: O,
      defaultTag: "div",
      features: rpe,
      visible: y,
      name: "Popover.Panel"
    }), y && m && t.createElement(due, {
      id: f,
      ref: c.afterPanelSentinel,
      features: fue.Focusable,
      "data-headlessui-focus-guard": !0,
      as: "button",
      type: "button",
      onFocus: P
    }));
  }),
  lpe = iue(function (e, a) {
    let o = n(null),
      i = Yce(o, a),
      [l, s] = r([]),
      c = Pce(e => {
        s(t => {
          let r = t.indexOf(e);
          if (-1 !== r) {
            let e = t.slice();
            return e.splice(r, 1), e;
          }
          return t;
        });
      }),
      u = Pce(e => (s(t => [...t, e]), () => c(e))),
      h = Pce(() => {
        var e;
        let t = Bce(o);
        if (!t) return !1;
        let r = t.activeElement;
        return !(null == (e = o.current) || !e.contains(r)) || l.some(e => {
          var n, a;
          return (null == (n = t.getElementById(e.buttonId.current)) ? void 0 : n.contains(r)) || (null == (a = t.getElementById(e.panelId.current)) ? void 0 : a.contains(r));
        });
      }),
      m = Pce(e => {
        for (let t of l) t.buttonId.current !== e && t.close();
      }),
      p = d(() => ({
        registerPopover: u,
        unregisterPopover: c,
        isFocusWithinPopoverGroup: h,
        closeOthers: m
      }), [u, c, h, m]),
      f = d(() => ({}), []),
      v = e,
      g = {
        ref: i
      };
    return t.createElement(Kme.Provider, {
      value: p
    }, nue({
      ourProps: g,
      theirProps: v,
      slot: f,
      defaultTag: "div",
      name: "Popover.Group"
    }));
  });
function spe() {
  let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  let [t, n] = r(e),
    a = f(e => n(t => t | e), [t]),
    o = f(e => Boolean(t & e), [t]),
    i = f(e => n(t => t & ~e), [n]),
    l = f(e => n(t => t ^ e), [n]);
  return {
    flags: t,
    addFlag: a,
    hasFlag: o,
    removeFlag: i,
    toggleFlag: l
  };
}
Object.assign(npe, {
  Button: ape,
  Overlay: ope,
  Panel: ipe,
  Group: lpe
});
let cpe = o(null);
function upe() {
  let e = m(cpe);
  if (null === e) {
    let e = new Error("You used a <Label /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(e, upe), e;
  }
  return e;
}
function hpe() {
  let [e, n] = r([]);
  return [e.length > 0 ? e.join(" ") : void 0, d(() => function (e) {
    let r = Pce(e => (n(t => [...t, e]), () => n(t => {
        let r = t.slice(),
          n = r.indexOf(e);
        return -1 !== n && r.splice(n, 1), r;
      }))),
      a = d(() => ({
        register: r,
        slot: e.slot,
        name: e.name,
        props: e.props
      }), [r, e.slot, e.name, e.props]);
    return t.createElement(cpe.Provider, {
      value: a
    }, e.children);
  }, [n])];
}
let mpe = iue(function (e, t) {
    let r = Sce(),
      {
        id: n = "headlessui-label-".concat(r),
        passive: a = !1,
        ...o
      } = e,
      i = upe(),
      l = Yce(t);
    yce(() => i.register(n), [n, i.register]);
    let s = {
      ref: l,
      ...i.props,
      id: n
    };
    return a && ("onClick" in s && (delete s.htmlFor, delete s.onClick), "onClick" in o && delete o.onClick), nue({
      ourProps: s,
      theirProps: o,
      slot: i.slot || {},
      defaultTag: "label",
      name: i.name || "Label"
    });
  }),
  ppe = Object.assign(mpe, {});
var fpe = (e => (e[e.RegisterOption = 0] = "RegisterOption", e[e.UnregisterOption = 1] = "UnregisterOption", e))(fpe || {});
let dpe = {
    0(e, t) {
      let r = [...e.options, {
        id: t.id,
        element: t.element,
        propsRef: t.propsRef
      }];
      return {
        ...e,
        options: Dce(r, e => e.element.current)
      };
    },
    1(e, t) {
      let r = e.options.slice(),
        n = e.options.findIndex(e => e.id === t.id);
      return -1 === n ? e : (r.splice(n, 1), {
        ...e,
        options: r
      });
    }
  },
  vpe = o(null);
function gpe(e) {
  let t = m(vpe);
  if (null === t) {
    let t = new Error("<".concat(e, " /> is missing a parent <RadioGroup /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(t, gpe), t;
  }
  return t;
}
vpe.displayName = "RadioGroupDataContext";
let bpe = o(null);
function wpe(e) {
  let t = m(bpe);
  if (null === t) {
    let t = new Error("<".concat(e, " /> is missing a parent <RadioGroup /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(t, wpe), t;
  }
  return t;
}
function ype(e, t) {
  return Nce(t.type, dpe, e, t);
}
bpe.displayName = "RadioGroupActionsContext";
var xpe = (e => (e[e.Empty = 1] = "Empty", e[e.Active = 2] = "Active", e))(xpe || {});
let Ope = iue(function (e, r) {
    let o = Sce(),
      {
        id: i = "headlessui-radiogroup-".concat(o),
        value: l,
        defaultValue: s,
        name: c,
        onChange: u,
        by: h = (e, t) => e === t,
        disabled: m = !1,
        ...p
      } = e,
      f = Pce("string" == typeof h ? (e, t) => {
        let r = h;
        return (null == e ? void 0 : e[r]) === (null == t ? void 0 : t[r]);
      } : h),
      [v, g] = x(ype, {
        options: []
      }),
      b = v.options,
      [w, y] = hpe(),
      [O, E] = fhe(),
      j = n(null),
      C = Yce(j, r),
      [P, M] = xue(l, u, s),
      k = d(() => b.find(e => !e.propsRef.current.disabled), [b]),
      S = d(() => b.some(e => f(e.propsRef.current.value, P)), [b, P]),
      N = Pce(e => {
        var t;
        if (m || f(e, P)) return !1;
        let r = null == (t = b.find(t => f(t.propsRef.current.value, e))) ? void 0 : t.propsRef.current;
        return (null == r || !r.disabled) && (null == M || M(e), !0);
      });
    Kce({
      container: j.current,
      accept: e => "radio" === e.getAttribute("role") ? NodeFilter.FILTER_REJECT : e.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT,
      walk(e) {
        e.setAttribute("role", "none");
      }
    });
    let B = Pce(e => {
        let t = j.current;
        if (!t) return;
        let r = Bce(t),
          n = b.filter(e => !1 === e.propsRef.current.disabled).map(e => e.element.current);
        switch (e.key) {
          case yue.Enter:
            pue(e.currentTarget);
            break;
          case yue.ArrowLeft:
          case yue.ArrowUp:
            if (e.preventDefault(), e.stopPropagation(), qce(n, Rce.Previous | Rce.WrapAround) === Ace.Success) {
              let e = b.find(e => e.element.current === (null == r ? void 0 : r.activeElement));
              e && N(e.propsRef.current.value);
            }
            break;
          case yue.ArrowRight:
          case yue.ArrowDown:
            if (e.preventDefault(), e.stopPropagation(), qce(n, Rce.Next | Rce.WrapAround) === Ace.Success) {
              let e = b.find(e => e.element.current === (null == r ? void 0 : r.activeElement));
              e && N(e.propsRef.current.value);
            }
            break;
          case yue.Space:
            {
              e.preventDefault(), e.stopPropagation();
              let t = b.find(e => e.element.current === (null == r ? void 0 : r.activeElement));
              t && N(t.propsRef.current.value);
            }
        }
      }),
      V = Pce(e => (g({
        type: 0,
        ...e
      }), () => g({
        type: 1,
        id: e.id
      }))),
      R = d(() => ({
        value: P,
        firstOption: k,
        containsCheckedOption: S,
        disabled: m,
        compare: f,
        ...v
      }), [P, k, S, m, f, v]),
      A = d(() => ({
        registerOption: V,
        change: N
      }), [V, N]),
      T = {
        ref: C,
        id: i,
        role: "radiogroup",
        "aria-labelledby": w,
        "aria-describedby": O,
        onKeyDown: B
      },
      H = d(() => ({
        value: P
      }), [P]),
      L = n(null),
      I = Cce();
    return a(() => {
      L.current && void 0 !== s && I.addEventListener(L.current, "reset", () => {
        N(s);
      });
    }, [L, N]), t.createElement(E, {
      name: "RadioGroup.Description"
    }, t.createElement(y, {
      name: "RadioGroup.Label"
    }, t.createElement(bpe.Provider, {
      value: A
    }, t.createElement(vpe.Provider, {
      value: R
    }, null != c && null != P && uue({
      [c]: P
    }).map((_ref137, n) => {
      let [e, r] = _ref137;
      return t.createElement(due, {
        features: fue.Hidden,
        ref: 0 === n ? e => {
          var t;
          L.current = null != (t = null == e ? void 0 : e.closest("form")) ? t : null;
        } : void 0,
        ...lue({
          key: e,
          as: "input",
          type: "radio",
          checked: null != r,
          hidden: !0,
          readOnly: !0,
          name: e,
          value: r
        })
      });
    }), nue({
      ourProps: T,
      theirProps: p,
      slot: H,
      defaultTag: "div",
      name: "RadioGroup"
    })))));
  }),
  Epe = iue(function (e, r) {
    var a;
    let o = Sce(),
      {
        id: i = "headlessui-radiogroup-option-".concat(o),
        value: l,
        disabled: s = !1,
        ...c
      } = e,
      u = n(null),
      h = Yce(u, r),
      [m, p] = hpe(),
      [f, v] = fhe(),
      {
        addFlag: g,
        removeFlag: b,
        hasFlag: w
      } = spe(1),
      y = xce({
        value: l,
        disabled: s
      }),
      x = gpe("RadioGroup.Option"),
      O = wpe("RadioGroup.Option");
    yce(() => O.registerOption({
      id: i,
      element: u,
      propsRef: y
    }), [i, O, u, e]);
    let E = Pce(e => {
        var t;
        if (cue(e.currentTarget)) return e.preventDefault();
        O.change(l) && (g(2), null == (t = u.current) || t.focus());
      }),
      j = Pce(e => {
        if (cue(e.currentTarget)) return e.preventDefault();
        g(2);
      }),
      C = Pce(() => b(2)),
      P = (null == (a = x.firstOption) ? void 0 : a.id) === i,
      M = x.disabled || s,
      k = x.compare(x.value, l),
      S = {
        ref: h,
        id: i,
        role: "radio",
        "aria-checked": k ? "true" : "false",
        "aria-labelledby": m,
        "aria-describedby": f,
        "aria-disabled": !!M || void 0,
        tabIndex: M ? -1 : k || !x.containsCheckedOption && P ? 0 : -1,
        onClick: M ? void 0 : E,
        onFocus: M ? void 0 : j,
        onBlur: M ? void 0 : C
      },
      N = d(() => ({
        checked: k,
        disabled: M,
        active: w(2)
      }), [k, M, w]);
    return t.createElement(v, {
      name: "RadioGroup.Description"
    }, t.createElement(p, {
      name: "RadioGroup.Label"
    }, nue({
      ourProps: S,
      theirProps: c,
      slot: N,
      defaultTag: "div",
      name: "RadioGroup.Option"
    })));
  });
Object.assign(Ope, {
  Option: Epe,
  Label: ppe,
  Description: vhe
});
let jpe = o(null);
jpe.displayName = "GroupContext";
let Cpe = l;
let Ppe = iue(function (e, r) {
    let o = Sce(),
      {
        id: i = "headlessui-switch-".concat(o),
        checked: l,
        defaultChecked: s = !1,
        onChange: c,
        name: u,
        value: h,
        ...p
      } = e,
      f = m(jpe),
      v = n(null),
      g = Yce(v, r, null === f ? null : f.setSwitch),
      [b, w] = xue(l, c, s),
      y = Pce(() => null == w ? void 0 : w(!b)),
      x = Pce(e => {
        if (cue(e.currentTarget)) return e.preventDefault();
        e.preventDefault(), y();
      }),
      O = Pce(e => {
        e.key === yue.Space ? (e.preventDefault(), y()) : e.key === yue.Enter && pue(e.currentTarget);
      }),
      E = Pce(e => e.preventDefault()),
      j = d(() => ({
        checked: b
      }), [b]),
      C = {
        id: i,
        ref: g,
        role: "switch",
        type: Wce(e, v),
        tabIndex: 0,
        "aria-checked": b,
        "aria-labelledby": null == f ? void 0 : f.labelledby,
        "aria-describedby": null == f ? void 0 : f.describedby,
        onClick: x,
        onKeyUp: O,
        onKeyPress: E
      },
      P = Cce();
    return a(() => {
      var e;
      let t = null == (e = v.current) ? void 0 : e.closest("form");
      t && void 0 !== s && P.addEventListener(t, "reset", () => {
        w(s);
      });
    }, [v, w]), t.createElement(t.Fragment, null, null != u && b && t.createElement(due, {
      features: fue.Hidden,
      ...lue({
        as: "input",
        type: "checkbox",
        hidden: !0,
        readOnly: !0,
        checked: b,
        name: u,
        value: h
      })
    }), nue({
      ourProps: C,
      theirProps: p,
      slot: j,
      defaultTag: "button",
      name: "Switch"
    }));
  }),
  Mpe = function (e) {
    var n;
    let [a, o] = r(null),
      [i, l] = hpe(),
      [s, c] = fhe(),
      u = d(() => ({
        switch: a,
        setSwitch: o,
        labelledby: i,
        describedby: s
      }), [a, o, i, s]),
      h = e;
    return t.createElement(c, {
      name: "Switch.Description"
    }, t.createElement(l, {
      name: "Switch.Label",
      props: {
        htmlFor: null == (n = u.switch) ? void 0 : n.id,
        onClick(e) {
          a && ("LABEL" === e.currentTarget.tagName && e.preventDefault(), a.click(), a.focus({
            preventScroll: !0
          }));
        }
      }
    }, t.createElement(jpe.Provider, {
      value: u
    }, nue({
      ourProps: {},
      theirProps: h,
      defaultTag: Cpe,
      name: "Switch.Group"
    }))));
  };
function kpe(_ref138) {
  let {
    onFocus: e
  } = _ref138;
  let [n, a] = r(!0);
  return n ? t.createElement(due, {
    as: "button",
    type: "button",
    features: fue.Focusable,
    onFocus: t => {
      t.preventDefault();
      let r,
        n = 50;
      r = requestAnimationFrame(function t() {
        if (!(n-- <= 0)) return e() ? (a(!1), void cancelAnimationFrame(r)) : void (r = requestAnimationFrame(t));
        r && cancelAnimationFrame(r);
      });
    }
  }) : null;
}
Object.assign(Ppe, {
  Group: Mpe,
  Label: ppe,
  Description: vhe
});
const Spe = e.createContext(null);
function Npe(_ref139) {
  let {
    children: t
  } = _ref139;
  let r = e.useRef({
    groups: new Map(),
    get(e, t) {
      var r;
      let n = this.groups.get(e);
      n || (n = new Map(), this.groups.set(e, n));
      let a = null != (r = n.get(t)) ? r : 0;
      return n.set(t, a + 1), [Array.from(n.keys()).indexOf(t), function () {
        let e = n.get(t);
        e > 1 ? n.set(t, e - 1) : n.delete(t);
      }];
    }
  });
  return e.createElement(Spe.Provider, {
    value: r
  }, t);
}
function Bpe(t) {
  let r = e.useContext(Spe);
  if (!r) throw new Error("You must wrap your component in a <StableCollection>");
  let n = function () {
      var t, r, n;
      let a = null != (n = null == (r = null == (t = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) ? void 0 : t.ReactCurrentOwner) ? void 0 : r.current) ? n : null;
      if (!a) return Symbol();
      let o = [],
        i = a;
      for (; i;) o.push(i.index), i = i.return;
      return "$." + o.join(".");
    }(),
    [a, o] = r.current.get(t, n);
  return e.useEffect(() => o, []), a;
}
var Vpe = (e => (e[e.Forwards = 0] = "Forwards", e[e.Backwards = 1] = "Backwards", e))(Vpe || {}),
  Rpe = (e => (e[e.Less = -1] = "Less", e[e.Equal = 0] = "Equal", e[e.Greater = 1] = "Greater", e))(Rpe || {}),
  Ape = (e => (e[e.SetSelectedIndex = 0] = "SetSelectedIndex", e[e.RegisterTab = 1] = "RegisterTab", e[e.UnregisterTab = 2] = "UnregisterTab", e[e.RegisterPanel = 3] = "RegisterPanel", e[e.UnregisterPanel = 4] = "UnregisterPanel", e))(Ape || {});
let Tpe = {
    0(e, t) {
      var r;
      let n = Dce(e.tabs, e => e.current),
        a = Dce(e.panels, e => e.current),
        o = n.filter(e => {
          var t;
          return !(null != (t = e.current) && t.hasAttribute("disabled"));
        }),
        i = {
          ...e,
          tabs: n,
          panels: a
        };
      if (t.index < 0 || t.index > n.length - 1) {
        let r = Nce(Math.sign(t.index - e.selectedIndex), {
          [-1]: () => 1,
          0: () => Nce(Math.sign(t.index), {
            [-1]: () => 0,
            0: () => 0,
            1: () => 1
          }),
          1: () => 0
        });
        return 0 === o.length ? i : {
          ...i,
          selectedIndex: Nce(r, {
            0: () => n.indexOf(o[0]),
            1: () => n.indexOf(o[o.length - 1])
          })
        };
      }
      let l = n.slice(0, t.index),
        s = [...n.slice(t.index), ...l].find(e => o.includes(e));
      if (!s) return i;
      let c = null != (r = n.indexOf(s)) ? r : e.selectedIndex;
      return -1 === c && (c = e.selectedIndex), {
        ...i,
        selectedIndex: c
      };
    },
    1(e, t) {
      var r;
      if (e.tabs.includes(t.tab)) return e;
      let n = e.tabs[e.selectedIndex],
        a = Dce([...e.tabs, t.tab], e => e.current),
        o = null != (r = a.indexOf(n)) ? r : e.selectedIndex;
      return -1 === o && (o = e.selectedIndex), {
        ...e,
        tabs: a,
        selectedIndex: o
      };
    },
    2: (e, t) => ({
      ...e,
      tabs: e.tabs.filter(e => e !== t.tab)
    }),
    3: (e, t) => e.panels.includes(t.panel) ? e : {
      ...e,
      panels: Dce([...e.panels, t.panel], e => e.current)
    },
    4: (e, t) => ({
      ...e,
      panels: e.panels.filter(e => e !== t.panel)
    })
  },
  Hpe = o(null);
function Lpe(e) {
  let t = m(Hpe);
  if (null === t) {
    let t = new Error("<".concat(e, " /> is missing a parent <Tab.Group /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(t, Lpe), t;
  }
  return t;
}
Hpe.displayName = "TabsDataContext";
let Ipe = o(null);
function Fpe(e) {
  let t = m(Ipe);
  if (null === t) {
    let t = new Error("<".concat(e, " /> is missing a parent <Tab.Group /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(t, Fpe), t;
  }
  return t;
}
function _pe(e, t) {
  return Nce(t.type, Tpe, e, t);
}
Ipe.displayName = "TabsActionsContext";
let Zpe = l;
let Dpe = tue.RenderStrategy | tue.Static;
let qpe = iue(function (e, t) {
    var r, a;
    let o = Sce(),
      {
        id: i = "headlessui-tabs-tab-".concat(o),
        ...l
      } = e,
      {
        orientation: s,
        activation: c,
        selectedIndex: u,
        tabs: h,
        panels: m
      } = Lpe("Tab"),
      p = Fpe("Tab"),
      f = Lpe("Tab"),
      v = n(null),
      g = Yce(v, t);
    yce(() => p.registerTab(v), [p, v]);
    let b = Bpe("tabs"),
      w = h.indexOf(v);
    -1 === w && (w = b);
    let y = w === u,
      x = Pce(e => {
        var t;
        let r = e();
        if (r === Ace.Success && "auto" === c) {
          let e = null == (t = Bce(v)) ? void 0 : t.activeElement,
            r = f.tabs.findIndex(t => t.current === e);
          -1 !== r && p.change(r);
        }
        return r;
      }),
      O = Pce(e => {
        let t = h.map(e => e.current).filter(Boolean);
        if (e.key === yue.Space || e.key === yue.Enter) return e.preventDefault(), e.stopPropagation(), void p.change(w);
        switch (e.key) {
          case yue.Home:
          case yue.PageUp:
            return e.preventDefault(), e.stopPropagation(), x(() => qce(t, Rce.First));
          case yue.End:
          case yue.PageDown:
            return e.preventDefault(), e.stopPropagation(), x(() => qce(t, Rce.Last));
        }
        return x(() => Nce(s, {
          vertical: () => e.key === yue.ArrowUp ? qce(t, Rce.Previous | Rce.WrapAround) : e.key === yue.ArrowDown ? qce(t, Rce.Next | Rce.WrapAround) : Ace.Error,
          horizontal: () => e.key === yue.ArrowLeft ? qce(t, Rce.Previous | Rce.WrapAround) : e.key === yue.ArrowRight ? qce(t, Rce.Next | Rce.WrapAround) : Ace.Error
        })) === Ace.Success ? e.preventDefault() : void 0;
      }),
      E = n(!1),
      j = Pce(() => {
        var e;
        E.current || (E.current = !0, null == (e = v.current) || e.focus(), p.change(w), Ece(() => {
          E.current = !1;
        }));
      }),
      C = Pce(e => {
        e.preventDefault();
      }),
      P = d(() => ({
        selected: y
      }), [y]);
    return nue({
      ourProps: {
        ref: g,
        onKeyDown: O,
        onMouseDown: C,
        onClick: j,
        id: i,
        role: "tab",
        type: Wce(e, v),
        "aria-controls": null == (a = null == (r = m[w]) ? void 0 : r.current) ? void 0 : a.id,
        "aria-selected": y,
        tabIndex: y ? 0 : -1
      },
      theirProps: l,
      slot: P,
      defaultTag: "button",
      name: "Tabs.Tab"
    });
  }),
  Upe = iue(function (e, r) {
    let {
      defaultIndex: n = 0,
      vertical: a = !1,
      manual: o = !1,
      onChange: i,
      selectedIndex: l = null,
      ...s
    } = e;
    const c = a ? "vertical" : "horizontal",
      u = o ? "manual" : "auto";
    let h = null !== l,
      m = Yce(r),
      [p, f] = x(_pe, {
        selectedIndex: null != l ? l : n,
        tabs: [],
        panels: []
      }),
      v = d(() => ({
        selectedIndex: p.selectedIndex
      }), [p.selectedIndex]),
      g = xce(i || (() => {})),
      b = xce(p.tabs),
      w = d(() => ({
        orientation: c,
        activation: u,
        ...p
      }), [c, u, p]),
      y = Pce(e => (f({
        type: 1,
        tab: e
      }), () => f({
        type: 2,
        tab: e
      }))),
      O = Pce(e => (f({
        type: 3,
        panel: e
      }), () => f({
        type: 4,
        panel: e
      }))),
      E = Pce(e => {
        j.current !== e && g.current(e), h || f({
          type: 0,
          index: e
        });
      }),
      j = xce(h ? e.selectedIndex : p.selectedIndex),
      C = d(() => ({
        registerTab: y,
        registerPanel: O,
        change: E
      }), []);
    yce(() => {
      f({
        type: 0,
        index: null != l ? l : n
      });
    }, [l]), yce(() => {
      if (void 0 === j.current || p.tabs.length <= 0) return;
      let e = Dce(p.tabs, e => e.current);
      e.some((e, t) => p.tabs[t] !== e) && E(e.indexOf(p.tabs[j.current]));
    });
    let P = {
      ref: m
    };
    return t.createElement(Npe, null, t.createElement(Ipe.Provider, {
      value: C
    }, t.createElement(Hpe.Provider, {
      value: w
    }, w.tabs.length <= 0 && t.createElement(kpe, {
      onFocus: () => {
        var e, t;
        for (let r of b.current) if (0 === (null == (e = r.current) ? void 0 : e.tabIndex)) return null == (t = r.current) || t.focus(), !0;
        return !1;
      }
    }), nue({
      ourProps: P,
      theirProps: s,
      slot: v,
      defaultTag: Zpe,
      name: "Tabs"
    }))));
  }),
  $pe = iue(function (e, t) {
    let {
      orientation: r,
      selectedIndex: n
    } = Lpe("Tab.List");
    return nue({
      ourProps: {
        ref: Yce(t),
        role: "tablist",
        "aria-orientation": r
      },
      theirProps: e,
      slot: {
        selectedIndex: n
      },
      defaultTag: "div",
      name: "Tabs.List"
    });
  }),
  zpe = iue(function (e, t) {
    let {
      selectedIndex: r
    } = Lpe("Tab.Panels");
    return nue({
      ourProps: {
        ref: Yce(t)
      },
      theirProps: e,
      slot: d(() => ({
        selectedIndex: r
      }), [r]),
      defaultTag: "div",
      name: "Tabs.Panels"
    });
  }),
  Wpe = iue(function (e, r) {
    var a, o, i, l;
    let s = Sce(),
      {
        id: c = "headlessui-tabs-panel-".concat(s),
        tabIndex: u = 0,
        ...h
      } = e,
      {
        selectedIndex: m,
        tabs: p,
        panels: f
      } = Lpe("Tab.Panel"),
      v = Fpe("Tab.Panel"),
      g = n(null),
      b = Yce(g, r);
    yce(() => v.registerPanel(g), [v, g]);
    let w = Bpe("panels"),
      y = f.indexOf(g);
    -1 === y && (y = w);
    let x = y === m,
      O = d(() => ({
        selected: x
      }), [x]),
      E = {
        ref: b,
        id: c,
        role: "tabpanel",
        "aria-labelledby": null == (o = null == (a = p[y]) ? void 0 : a.current) ? void 0 : o.id,
        tabIndex: x ? u : -1
      };
    return x || null != (i = h.unmount) && !i || null != (l = h.static) && l ? nue({
      ourProps: E,
      theirProps: h,
      slot: O,
      defaultTag: "div",
      features: Dpe,
      visible: x,
      name: "Tabs.Panel"
    }) : t.createElement(due, {
      as: "span",
      ...E
    });
  });
function Qpe(e) {
  for (var _len26 = arguments.length, t = new Array(_len26 > 1 ? _len26 - 1 : 0), _key26 = 1; _key26 < _len26; _key26++) {
    t[_key26 - 1] = arguments[_key26];
  }
  e && t.length > 0 && e.classList.add(...t);
}
function Gpe(e) {
  for (var _len27 = arguments.length, t = new Array(_len27 > 1 ? _len27 - 1 : 0), _key27 = 1; _key27 < _len27; _key27++) {
    t[_key27 - 1] = arguments[_key27];
  }
  e && t.length > 0 && e.classList.remove(...t);
}
function Ype(e, t, r, n) {
  let a = r ? "enter" : "leave",
    o = jce(),
    i = void 0 !== n ? function (e) {
      let t = {
        called: !1
      };
      return function () {
        if (!t.called) return t.called = !0, e(...arguments);
      };
    }(n) : () => {};
  "enter" === a && (e.removeAttribute("hidden"), e.style.display = "");
  let l = Nce(a, {
      enter: () => t.enter,
      leave: () => t.leave
    }),
    s = Nce(a, {
      enter: () => t.enterTo,
      leave: () => t.leaveTo
    }),
    c = Nce(a, {
      enter: () => t.enterFrom,
      leave: () => t.leaveFrom
    });
  return Gpe(e, ...t.enter, ...t.enterTo, ...t.enterFrom, ...t.leave, ...t.leaveFrom, ...t.leaveTo, ...t.entered), Qpe(e, ...l, ...c), o.nextFrame(() => {
    Gpe(e, ...c), Qpe(e, ...s), function (e, t) {
      let r = jce();
      if (!e) return r.dispose;
      let {
          transitionDuration: n,
          transitionDelay: a
        } = getComputedStyle(e),
        [o, i] = [n, a].map(e => {
          let [t = 0] = e.split(",").filter(Boolean).map(e => e.includes("ms") ? parseFloat(e) : 1e3 * parseFloat(e)).sort((e, t) => t - e);
          return t;
        }),
        l = o + i;
      if (0 !== l) {
        r.group(r => {
          r.setTimeout(() => {
            t(), r.dispose();
          }, l), r.addEventListener(e, "transitionrun", e => {
            e.target === e.currentTarget && r.dispose();
          });
        });
        let n = r.addEventListener(e, "transitionend", e => {
          e.target === e.currentTarget && (t(), n());
        });
      } else t();
      r.add(() => t()), r.dispose;
    }(e, () => (Gpe(e, ...l), Qpe(e, ...t.entered), i()));
  }), o.dispose;
}
function Kpe(_ref140) {
  let {
    container: e,
    direction: t,
    classes: r,
    onStart: n,
    onStop: a
  } = _ref140;
  let o = Que(),
    i = Cce(),
    l = xce(t);
  yce(() => {
    let t = jce();
    i.add(t.dispose);
    let s = e.current;
    if (s && "idle" !== l.current && o.current) return t.dispose(), n.current(l.current), t.add(Ype(s, r.current, "enter" === l.current, () => {
      t.dispose(), a.current(l.current);
    })), t.dispose;
  }, [t]);
}
function Xpe() {
  let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return e.split(" ").filter(e => e.trim().length > 1);
}
Object.assign(qpe, {
  Group: Upe,
  List: $pe,
  Panels: zpe,
  Panel: Wpe
});
let Jpe = o(null);
Jpe.displayName = "TransitionContext";
var efe = (e => (e.Visible = "visible", e.Hidden = "hidden", e))(efe || {});
let tfe = o(null);
function rfe(e) {
  return "children" in e ? rfe(e.children) : e.current.filter(_ref141 => {
    let {
      el: e
    } = _ref141;
    return null !== e.current;
  }).filter(_ref142 => {
    let {
      state: e
    } = _ref142;
    return "visible" === e;
  }).length > 0;
}
function nfe(e, t) {
  let r = xce(e),
    a = n([]),
    o = Que(),
    i = Cce(),
    l = Pce(function (e) {
      let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : rue.Hidden;
      let n = a.current.findIndex(_ref143 => {
        let {
          el: t
        } = _ref143;
        return t === e;
      });
      -1 !== n && (Nce(t, {
        [rue.Unmount]() {
          a.current.splice(n, 1);
        },
        [rue.Hidden]() {
          a.current[n].state = "hidden";
        }
      }), i.microTask(() => {
        var e;
        !rfe(a) && o.current && (null == (e = r.current) || e.call(r));
      }));
    }),
    s = Pce(e => {
      let t = a.current.find(_ref144 => {
        let {
          el: t
        } = _ref144;
        return t === e;
      });
      return t ? "visible" !== t.state && (t.state = "visible") : a.current.push({
        el: e,
        state: "visible"
      }), () => l(e, rue.Unmount);
    }),
    c = n([]),
    u = n(Promise.resolve()),
    h = n({
      enter: [],
      leave: [],
      idle: []
    }),
    m = Pce((e, r, n) => {
      c.current.splice(0), t && (t.chains.current[r] = t.chains.current[r].filter(_ref145 => {
        let [t] = _ref145;
        return t !== e;
      })), null == t || t.chains.current[r].push([e, new Promise(e => {
        c.current.push(e);
      })]), null == t || t.chains.current[r].push([e, new Promise(e => {
        Promise.all(h.current[r].map(_ref146 => {
          let [e, t] = _ref146;
          return t;
        })).then(() => e());
      })]), "enter" === r ? u.current = u.current.then(() => null == t ? void 0 : t.wait.current).then(() => n(r)) : n(r);
    }),
    p = Pce((e, t, r) => {
      Promise.all(h.current[t].splice(0).map(_ref147 => {
        let [e, t] = _ref147;
        return t;
      })).then(() => {
        var e;
        null == (e = c.current.shift()) || e();
      }).then(() => r(t));
    });
  return d(() => ({
    children: a,
    register: s,
    unregister: l,
    onStart: m,
    onStop: p,
    wait: u,
    chains: h
  }), [s, l, a, m, p, h, u]);
}
function afe() {}
tfe.displayName = "NestingContext";
let ofe = ["beforeEnter", "afterEnter", "beforeLeave", "afterLeave"];
function ife(e) {
  var t;
  let r = {};
  for (let n of ofe) r[n] = null != (t = e[n]) ? t : afe;
  return r;
}
let lfe = tue.RenderStrategy;
let sfe = iue(function (e, o) {
    let {
        show: i,
        appear: s = !1,
        unmount: c,
        ...u
      } = e,
      h = n(null),
      m = Yce(h, o);
    Mce();
    let p = bue();
    if (void 0 === i && null !== p && (i = (p & gue.Open) === gue.Open), ![!0, !1].includes(i)) throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");
    let [f, v] = r(i ? "visible" : "hidden"),
      g = nfe(() => {
        v("hidden");
      }),
      [b, w] = r(!0),
      y = n([i]);
    yce(() => {
      !1 !== b && y.current[y.current.length - 1] !== i && (y.current.push(i), w(!1));
    }, [y, i]);
    let x = d(() => ({
      show: i,
      appear: s,
      initial: b
    }), [i, s, b]);
    a(() => {
      if (i) v("visible");else if (rfe(g)) {
        let e = h.current;
        if (!e) return;
        let t = e.getBoundingClientRect();
        0 === t.x && 0 === t.y && 0 === t.width && 0 === t.height && v("hidden");
      } else v("hidden");
    }, [i, g]);
    let O = {
      unmount: c
    };
    return t.createElement(tfe.Provider, {
      value: g
    }, t.createElement(Jpe.Provider, {
      value: x
    }, nue({
      ourProps: {
        ...O,
        as: l,
        children: t.createElement(cfe, {
          ref: m,
          ...O,
          ...u
        })
      },
      theirProps: {},
      defaultTag: l,
      features: lfe,
      visible: "visible" === f,
      name: "Transition"
    })));
  }),
  cfe = iue(function (e, o) {
    let {
        beforeEnter: i,
        afterEnter: l,
        beforeLeave: s,
        afterLeave: c,
        enter: u,
        enterFrom: h,
        enterTo: p,
        entered: f,
        leave: d,
        leaveFrom: v,
        leaveTo: g,
        ...b
      } = e,
      w = n(null),
      y = Yce(w, o),
      x = b.unmount ? rue.Unmount : rue.Hidden,
      {
        show: O,
        appear: E,
        initial: j
      } = function () {
        let e = m(Jpe);
        if (null === e) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
        return e;
      }(),
      [C, P] = r(O ? "visible" : "hidden"),
      M = function () {
        let e = m(tfe);
        if (null === e) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
        return e;
      }(),
      {
        register: k,
        unregister: S
      } = M,
      N = n(null);
    a(() => k(w), [k, w]), a(() => {
      if (x === rue.Hidden && w.current) return O && "visible" !== C ? void P("visible") : Nce(C, {
        hidden: () => S(w),
        visible: () => k(w)
      });
    }, [C, w, k, S, O, x]);
    let B = xce({
        enter: Xpe(u),
        enterFrom: Xpe(h),
        enterTo: Xpe(p),
        entered: Xpe(f),
        leave: Xpe(d),
        leaveFrom: Xpe(v),
        leaveTo: Xpe(g)
      }),
      V = function (e) {
        let t = n(ife(e));
        return a(() => {
          t.current = ife(e);
        }, [e]), t;
      }({
        beforeEnter: i,
        afterEnter: l,
        beforeLeave: s,
        afterLeave: c
      }),
      R = Mce();
    a(() => {
      if (R && "visible" === C && null === w.current) throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
    }, [w, C, R]);
    let A = j && !E,
      T = !R || A || N.current === O ? "idle" : O ? "enter" : "leave",
      H = spe(0),
      L = Pce(e => Nce(e, {
        enter: () => {
          H.addFlag(gue.Opening), V.current.beforeEnter();
        },
        leave: () => {
          H.addFlag(gue.Closing), V.current.beforeLeave();
        },
        idle: () => {}
      })),
      I = Pce(e => Nce(e, {
        enter: () => {
          H.removeFlag(gue.Opening), V.current.afterEnter();
        },
        leave: () => {
          H.removeFlag(gue.Closing), V.current.afterLeave();
        },
        idle: () => {}
      })),
      F = nfe(() => {
        P("hidden"), S(w);
      }, M);
    Kpe({
      container: w,
      classes: B,
      direction: T,
      onStart: xce(e => {
        F.onStart(w, e, L);
      }),
      onStop: xce(e => {
        F.onStop(w, e, I), "leave" === e && !rfe(F) && (P("hidden"), S(w));
      })
    }), a(() => {
      A && (x === rue.Hidden ? N.current = null : N.current = O);
    }, [O, A, C]);
    let _ = b,
      Z = {
        ref: y
      };
    return E && O && wce.isServer && (_ = {
      ..._,
      className: eue(b.className, ...B.current.enter, ...B.current.enterFrom)
    }), t.createElement(tfe.Provider, {
      value: F
    }, t.createElement(wue, {
      value: Nce(C, {
        visible: gue.Open,
        hidden: gue.Closed
      }) | H.flags
    }, nue({
      ourProps: Z,
      theirProps: _,
      defaultTag: "div",
      features: lfe,
      visible: "visible" === C,
      name: "Transition.Child"
    })));
  }),
  ufe = iue(function (e, r) {
    let n = null !== m(Jpe),
      a = null !== bue();
    return t.createElement(t.Fragment, null, !n && a ? t.createElement(sfe, {
      ref: r,
      ...e
    }) : t.createElement(cfe, {
      ref: r,
      ...e
    }));
  });
function hfe(e) {
  const {
      label: n,
      childArray: a
    } = e,
    [o, i] = r(!1);
  return t.createElement("header", {
    className: "bg-white"
  }, t.createElement("nav", {
    className: "mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8",
    "aria-label": "Global"
  }, t.createElement("a", {
    href: "#",
    className: "-m-1.5 p-1.5 flex"
  }, t.createElement(mz, {
    variant: "hasuraPrimary",
    strokeColor: ""
  })), t.createElement("div", {
    className: "flex lg:hidden"
  }, t.createElement("button", {
    type: "button",
    className: "-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700",
    onClick: () => i(!0)
  }, t.createElement("span", {
    className: "sr-only"
  }, "Open main menu"), t.createElement(mz, {
    height: "h-6",
    variant: "menu05",
    strokeColor: "#3970FD"
  }))), t.createElement("div", {
    className: "hidden lg:flex lg:gap-x-12"
  }, a.map(e => t.createElement("a", {
    key: e.name,
    href: e.href
  }, t.createElement(ce, {
    className: "ml-1.5",
    textStyle: "body3"
  }, e.name))), t.createElement("a", {
    href: "#",
    className: "text-sm font-semibold leading-6 text-gray-900"
  }, "Log in ", t.createElement("span", {
    "aria-hidden": "true"
  }, "→")))), t.createElement("div", {
    className: "transition-all "
  }, t.createElement(Qhe, {
    as: "div",
    className: "lg:hidden",
    open: o,
    onClose: i
  }, t.createElement("div", {
    className: "fixed inset-0 z-10"
  }), t.createElement(Qhe.Panel, {
    className: "fixed border rounded-l-3xl inset-y-0 bg-neutral-0 max-w-min min-w-fit right-0 z-10 w-full overflow-y-auto bg-white px-6 py-6 sm:ring-1 sm:ring-gray-900/10"
  }, t.createElement("div", {
    className: "flex items-center justify-end"
  }, t.createElement("button", {
    type: "button",
    className: "-m-2.5 rounded-md p-2.5 text-gray-700",
    onClick: () => i(!1)
  }, t.createElement("span", {
    className: "sr-only"
  }, "Close menu"), t.createElement(mz, {
    height: "h-6",
    variant: "xclose",
    strokeColor: "#3970FD"
  }))), t.createElement("div", {
    className: "mt-6 flow-root"
  }, t.createElement(ce, {
    textStyle: "h6",
    className: "text-neutral-400"
  }, "MENU"), t.createElement("div", {
    className: " flex-col divide-y divide-blue-600/10"
  }, t.createElement("div", {
    className: "space-y-2 py-6 pr-48"
  }, a.map(e => t.createElement("a", {
    key: e.name,
    href: e.href,
    className: "-mx-3 rounded-lg flex gap-5 py-2 px-3 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
  }, t.createElement(mz, {
    height: "h-6",
    variant: "home03",
    strokeColor: "#6C737F"
  }), e.name))), t.createElement("div", {
    className: "py-6"
  }, t.createElement(A8, {
    leftIconVariant: "none",
    rightIconVariant: "none",
    label: "Log In",
    state: "default",
    size: "sm",
    rightAnimatedArrow: "true",
    rightAnimatedArrowColor: "#ffffff",
    animatedHoverStroke: "group-hover:stroke-neutral-0"
  }))))))));
}
function mfe() {
  for (var _len28 = arguments.length, e = new Array(_len28), _key28 = 0; _key28 < _len28; _key28++) {
    e[_key28] = arguments[_key28];
  }
  return e.filter(Boolean).join(" ");
}
function pfe(e) {
  const r = Array.isArray(e.tabs) ? e.tabs : [];
  return t.createElement("div", null, t.createElement("div", {
    className: "sm:hidden"
  }, t.createElement("label", {
    htmlFor: "tabs",
    className: "sr-only"
  }, "Select a tab"), t.createElement("select", {
    id: "tabs",
    name: "tabs",
    className: "block w-full rounded-md border-amber-600 py-2 pl-3 pr-10 text-base focus:border-green-600 focus:outline-none focus:ring-pink-500 sm:text-sm",
    defaultValue: r.length && r.find(e => e.current).name
  }, r.length && r.map(e => t.createElement("option", {
    key: e.name
  }, e.name)))), t.createElement("div", {
    className: "hidden sm:block"
  }, t.createElement("div", {
    className: "border-b border-neutral-200"
  }, t.createElement("nav", {
    className: "-mb-px flex space-x-8",
    "aria-label": "Tabs"
  }, r.length && r.map(e => t.createElement("a", {
    key: e.name,
    href: e.href,
    className: mfe(e.current ? "border-blue-600 text-blue-600 border-b-2" : "border-transparent text-neutral-700 hover:text-blue-600 hover:border-blue-600", "whitespace-nowrap py-4 px-1 font-medium text-sm"),
    "aria-current": e.current ? "page" : void 0
  }, e.name))))));
}
function ffe() {
  for (var _len29 = arguments.length, e = new Array(_len29), _key29 = 0; _key29 < _len29; _key29++) {
    e[_key29] = arguments[_key29];
  }
  return e.filter(Boolean).join(" ");
}
function dfe(e) {
  const r = Array.isArray(e.tabs) ? e.tabs : [];
  return t.createElement("div", null, t.createElement("div", {
    className: "sm:hidden"
  }, t.createElement("label", {
    htmlFor: "tabs",
    className: "sr-only"
  }, "Select a tab"), t.createElement("select", {
    id: "tabs",
    name: "tabs",
    className: "block w-full rounded-md border-pink-300 focus:border-pink-500 focus:ring-pink-500",
    defaultValue: r.length && r.find(e => e.current).name
  }, r.length && r.map(e => t.createElement("option", {
    key: e.name
  }, e.name)))), t.createElement("div", {
    className: "hidden sm:block"
  }, t.createElement("nav", {
    className: "inline-flex space-x-4 bg-neutral-100 p-2 rounded",
    "aria-label": "Tabs"
  }, r.length && r.map(e => t.createElement("a", {
    key: e.name,
    href: e.href,
    className: ffe(e.current ? "bg-neutral-0 text-neutral-700" : "text-neutral-700 bg-neutral-50 hover:text-gray-800", "px-3 py-2 font-medium text-sm rounded-md"),
    "aria-current": e.current ? "page" : void 0
  }, e.name)))));
}
function vfe() {
  for (var _len30 = arguments.length, e = new Array(_len30), _key30 = 0; _key30 < _len30; _key30++) {
    e[_key30] = arguments[_key30];
  }
  return e.filter(Boolean).join(" ");
}
function gfe(e) {
  const r = Array.isArray(e.tabs) ? e.tabs : [];
  return t.createElement("div", null, t.createElement("div", {
    className: "sm:hidden"
  }, t.createElement("label", {
    htmlFor: "tabs",
    className: "sr-only"
  }, "Select a tab"), t.createElement("select", {
    id: "tabs",
    name: "tabs",
    className: "block w-full rounded-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500",
    defaultValue: r.length && r.find(e => e.current).name
  }, r.length && r.map(e => t.createElement("option", {
    key: e.name
  }, e.name)))), t.createElement("div", {
    className: "hidden sm:block"
  }, t.createElement("nav", {
    className: "flex space-x-4",
    "aria-label": "Tabs"
  }, r.length && r.map(e => t.createElement("a", {
    key: e.name,
    href: e.href,
    className: vfe(e.current ? "bg-blue-100 text-blue-600 border-blue-600 border-b-2" : "text-neutral-700 hover:text-gray-700", "px-3 py-2 font-medium text-sm rounded-t-md"),
    "aria-current": e.current ? "page" : void 0
  }, e.name)))));
}
function bfe(e) {
  const {
      tabs: a,
      onTabClick: o,
      pillColor: i
    } = e,
    [l, s] = r(a.find(e => e.current) || a[0]),
    c = n(null);
  let u = "";
  i && (u = A(i));
  let h = "";
  function m(e) {
    h = l.tabTextColorClass ? A(l.tabTextColorClass) : "text-neutral-500";
    let t = " text-neutral-0 transition-all rounded-full " + u,
      r = " flex-nowrap rounded-full " + h;
    return l.name === e ? t : r;
  }
  return t.createElement("div", {
    className: ""
  }, t.createElement("div", {
    className: "block"
  }, t.createElement("nav", {
    className: "relative inline-flex gap-2 rounded-full",
    "aria-label": "Tabs"
  }, a.map(e => t.createElement("div", {
    key: e.name,
    onClick: t => ((e, t) => {
      e.preventDefault(), s(t), o && o(t);
      const r = c.current;
      if (r) {
        const t = e.currentTarget.offsetWidth,
          n = e.currentTarget.offsetLeft;
        r.parentElement.offsetLeft;
        const a = n;
        r.style.transform = "translateX(".concat(a, "px)"), r.style.width = "".concat(t, "px");
      }
    })(t, e)
  }, t.createElement(ce, {
    className: "".concat(m(e.name), " ").concat(e.name === l.name ? "" : "hover:bg-neutral-150", " cursor-pointer px-3 py-1  z-[2] relative whitespace-nowrap"),
    textStyle: "body3c-medium"
  }, e.name))), t.createElement("span", {
    ref: c,
    className: "absolute left-0 z-[1] ".concat(u, "  rounded-full transition-all ease-in duration-150"),
    style: {
      left: 100 * l.index + "%",
      width: "".concat(l.width, "px"),
      height: "28px"
    }
  }))));
}
function wfe(e) {
  var _n$find;
  const {
      tabs: n,
      onTabClick: a,
      pillColor: o,
      initalTab: i = !0
    } = e,
    l = ((_n$find = n.find(e => e.current)) === null || _n$find === void 0 ? void 0 : _n$find.name) || (i ? n[0].name : ""),
    [s, c] = r(l);
  let u = "";
  o && (u = A(o));
  return t.createElement("div", {
    className: ""
  }, t.createElement("div", {
    className: "block "
  }, t.createElement("nav", {
    className: "relative inline-flex gap-2 rounded-[32px] ",
    "aria-label": "Tabs"
  }, n && n.map(e => t.createElement("button", {
    key: e.name,
    onClick: () => {
      var t;
      c((t = e).name), a && a(t);
    },
    className: (s === e.name ? " text-neutral-0 transition-all duration-300" : " hover:bg-neutral-500/30 text-neutral-400") + " relative  px-3 py-1 whitespace-nowrap rounded-full hover:text-neutral-0 transition-all duration-300"
  }, s === e.name && t.createElement(oce.div, {
    layoutId: "active-pill",
    className: "absolute inset-0 ".concat(u),
    style: {
      borderRadius: 32
    }
  }), t.createElement(ce, {
    textStyle: "body3c-medium",
    className: "relative z-10 "
  }, e.name))))));
}
Object.assign(sfe, {
  Child: ufe,
  Root: sfe
}), bfe.defaultProps = {
  pillColor: "bg-blue-500"
}, wfe.defaultProps = {
  pillColor: "bg-blue-500"
};
const yfe = e => {
  let n;
  const [a, o] = r(e.visible || !1);
  return t.createElement("div", {
    className: "relative inline-flex",
    onMouseEnter: () => {
      n = setTimeout(() => {
        o(!0);
      }, e.delay || 500);
    },
    onMouseLeave: () => {
      clearInterval(n), o(!1);
    }
  }, e.children, a && t.createElement("div", {
    className: "absolute z-50 px-2 py-1 rounded " + ("bottom-centre" === e.direction || "bottom-right" === e.direction || "bottom-left" === e.direction ? "bottom-full text-xs-bold  mb-2.5 left-1/2 transform -translate-x-1/2 bg-blue-600 text-neutral-0 shadow-lg w-full" : "left-centre" === e.direction ? " text-xs-bold left-[160%] transform -translate-x-1/2 bg-blue-600 text-neutral-0 shadow-lg w-full" : "right-centre" === e.direction ? " text-xs-bold -left-[60%] transform -translate-x-1/2 bg-blue-600 text-neutral-0 shadow-lg w-full" : "top-centre" === e.direction || "top-left" === e.direction ? "bottom-full text-xs-bold  -mb-[112%] left-1/2 transform -translate-x-1/2 bg-blue-600 text-neutral-0 shadow-lg w-full" : "top-right" === e.direction ? "bottom-full text-xs-bold -mb-[112%] left-1/2 transform -translate-x-1/2 bg-blue-600 text-neutral-0 shadow-lg w-full" : "")
  }, e.content, t.createElement("div", {
    className: "absolute w-full " + ("bottom-centre" === e.direction ? "-bottom-1.5 left-1/2 mb-px transform rotate-45 bg-blue-600 -z-10 -ml-1.5" : "bottom-right" === e.direction ? "-bottom-1.5 left-[82.3%] mb-px transform rotate-45 bg-blue-600 -z-10 -ml-1.5" : "bottom-left" === e.direction ? "-bottom-1.5 left-[17.6%] mb-px transform rotate-45 bg-blue-600 -z-10 -ml-1.5" : "left-centre" === e.direction ? "bottom-1.5  transform rotate-45 bg-blue-600 -z-10 -ml-3" : "right-centre" === e.direction ? "bottom-1.5 left-[82.4%]  transform rotate-45 bg-blue-600 -z-10 ml-1.5" : "top-centre" === e.direction ? "-bottom-1.5 left-1/2 mb-[28%] transform rotate-45 bg-blue-600 -z-10 -ml-1.5" : "top-left" === e.direction ? "-bottom-1.5 left-[17.6%] mb-[28%] transform rotate-45 bg-blue-600 -z-10 -ml-1.5" : "top-right" === e.direction ? "-bottom-1.5 left-[82.3%] mb-[28%] transform rotate-45 bg-blue-600 -z-10 -ml-1.5" : ""),
    style: {
      width: "12px",
      height: "12px",
      transform: "rotate(45deg)"
    }
  })));
};
function xfe(_ref148) {
  let {
    heroData: e,
    logo: t,
    scrollArrow: n,
    fontSize: a
  } = _ref148;
  const [o, i] = r("volumex"),
    l = A(e.video_gradient_bg);
  return React.createElement("div", {
    className: "db:pt-32 mb-10 db:mb-5 tb:mb-16 tb-l:mb-0"
  }, React.createElement("div", {
    className: "tb:px-4"
  }, React.createElement("div", {
    className: "max-w-7xl mx-auto rounded-3xl overflow-hidden " + (e.bg_color ? e.bg_color : "")
  }, React.createElement("div", {
    className: "w-full"
  }, React.createElement("div", {
    className: "db:flex db:w-full tb-l:flex block" + (e.video_url ? " tb:block" : " tb:flex")
  }, React.createElement("div", {
    className: "db:px-28 db:py-20 db:pr-0 tb-l:self-center tb-l:min-w-[400px] mx-auto db:ml-0 db:max-w-[625px] db:min-w-[625px] p-5 pt-10 z-[1] tb:p-16 tb-l:py-12" + (e.video_url ? " tb:max-w-[530px]" : " tb:ml-0 tb:max-w-[290px] tb:min-w-[310px] tb:pr-0")
  }, e.tag_line && React.createElement("div", null, React.createElement(ce, {
    textStyle: "h6",
    as: "h6",
    className: "pb-6 uppercase text-center db:text-left font-normal tb-l:text-left " + (e.tag_line_color ? e.tag_line_color : "") + (e.video_url ? " tb:text-center" : " tb:text-left")
  }, e.tag_line)), e.title && React.createElement("div", null, t ? React.createElement("div", {
    className: "pb-4 db:text-left text-center tb-l:text-left" + (e.video_url ? " tb:text-center" : " tb:text-left")
  }, React.createElement("img", {
    className: "w-[290px] inline-block",
    src: t,
    alt: "Brand"
  })) : React.createElement(ce, {
    textStyle: a || "h1",
    as: "h1",
    className: "pb-2 text-center break-words db:text-left tb-l:text-left  " + (e.title_color ? e.title_color : "") + (e.video_url ? " tb:text-center" : " tb:text-left")
  }, e.title)), e.sub_title && React.createElement("div", null, React.createElement(ce, {
    textStyle: "sub1",
    className: "text-center db:text-left tb-l:text-left " + (e.sub_title_color ? e.sub_title_color : "") + (e.video_url ? " tb:text-center" : " tb:text-left")
  }, e.sub_title)), e.description && React.createElement("div", null, React.createElement(ce, {
    textStyle: "sub2",
    className: "text-center tb:text-left db:text-left tb-l:text-left text-blue-700 [&>*]:mb-8 last:[&>*]:mb-0"
  }, e.description)), e.buttons && React.createElement("div", {
    className: " gap-2 flex items-center justify-center tb-l:justify-start db:justify-start pt-6" + (e.video_url ? " tb:justify-center" : " tb:justify-start")
  }, e.buttons.map((e, t) => React.createElement(A8, {
    leftIconVariant: "none",
    rightIconVariant: "none",
    label: e.cta_text,
    state: "default",
    size: "lg",
    rightAnimatedArrow: "true",
    rightAnimatedArrowColor: "#ffffff"
  })))), e.video_url ? React.createElement("div", {
    className: "relative" + (e.video_gradient_bg ? "" : " p-4")
  }, React.createElement("div", {
    className: "w-12 h-12 bg-neutral-0 rounded-full absolute right-8 bottom-8 shadow-md cursor-pointer z-[2] flex items-center justify-center",
    onClick: () => (() => {
      if (e.video_url) {
        const e = document.getElementById("hero_vid");
        e !== null && e !== void 0 && e.muted ? (e.muted = !1, i("volumemax")) : (e.muted = !0, i("volumex"));
      }
    })()
  }, React.createElement(mz, {
    height: "w-6 h-6 stroke-neutral-800 stroke-[1.5px]",
    variant: o,
    strokeColor: "#1F2A37"
  })), React.createElement("video", {
    id: "hero_vid",
    controls: !1,
    loop: !0,
    muted: !0,
    poster: "https://res.cloudinary.com/dh8fp23nd/image/upload/v1683311269/hasura-con-2023/hascon23_fallback_homepage_tg5sgv.jpg",
    width: "500",
    height: "500",
    className: "tb:w-full w-full db:max-w-[500px]" + (e.video_gradient_bg ? "" : " rounded-xl shadow-md")
  }, React.createElement("source", {
    src: e.video_url,
    type: "video/mp4"
  })), e.video_gradient_bg && React.createElement("div", {
    className: "tb-l:w-1/2 w-full h-1/2 tb:h-full absolute left-0 top-0 tb-l:ml-[-4px] tb-l:bg-gradient-to-r ".concat(l, " to-transparent bg-gradient-to-b tb:mt-[-4px] tb-l:mt-0")
  })) : React.createElement("div", {
    className: "w-full",
    variants: {
      hidden: {
        opacity: 0
      },
      visible: {
        opacity: 1,
        transition: {
          delay: .2,
          duration: 1
        }
      }
    }
  }, e.img_url && React.createElement("div", {
    className: "text-right pt-0 flex items-end justify-end h-full"
  }, React.createElement("img", {
    src: e.img_url,
    alt: "Hero",
    className: "db:inline tb:w-[90%] tb-l:w-[70%] db:w-[75%] w-full rounded-b-3xl"
  })))))), n && React.createElement("div", {
    className: " hidden tb-l:block translate-y-[-20px]"
  }, React.createElement("div", {
    className: "px-6 flex justify-center pb-16 animate-bounce h-6 grid-cols-3"
  }, React.createElement("svg", {
    width: "60",
    height: "60",
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    filter: "url(#filter0_dd_1052_3729)"
  }, React.createElement("circle", {
    cx: "30",
    cy: "26",
    r: "24",
    fill: "white"
  }), React.createElement("path", {
    d: "M25 27L30 32L35 27M25 20L30 25L35 20",
    stroke: "#1F2A37",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), React.createElement("defs", null, React.createElement("filter", {
    id: "filter0_dd_1052_3729",
    x: "0",
    y: "0",
    width: "60",
    height: "60",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, React.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), React.createElement("feMorphology", {
    radius: "2",
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1052_3729"
  }), React.createElement("feOffset", {
    dy: "2"
  }), React.createElement("feGaussianBlur", {
    stdDeviation: "2"
  }), React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.14902 0 0 0 0 0.247059 0 0 0 0.06 0"
  }), React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1052_3729"
  }), React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), React.createElement("feMorphology", {
    radius: "2",
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_1052_3729"
  }), React.createElement("feOffset", {
    dy: "4"
  }), React.createElement("feGaussianBlur", {
    stdDeviation: "4"
  }), React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.14902 0 0 0 0 0.247059 0 0 0 0.1 0"
  }), React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1052_3729",
    result: "effect2_dropShadow_1052_3729"
  }), React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1052_3729",
    result: "shape"
  }))))))));
}
function Ofe(_ref149) {
  let {
    heroData: e,
    logo: n,
    scrollArrow: a,
    fontSize: o
  } = _ref149;
  r("volumex");
  const i = e => {
    const t = e.nextElementSibling;
    t && t.scrollIntoView({
      behavior: "smooth"
    });
  };
  return A(e.video_gradient_bg), t.createElement("div", {
    className: ""
  }, t.createElement("div", {
    className: ""
  }, t.createElement("div", {
    className: "max-w-7xl mx-auto px-20 py-20 rounded-3xl overflow-hidden " + (e.bg_color ? e.bg_color : "")
  }, t.createElement("div", {
    className: "w-full"
  }, t.createElement("div", {
    className: "tb-l:flex tb-l:justify-between tb-l:items-center tb-l:flex-row db:w-full flex flex-col-reverse tb:gap-x-16 db:gap-x-10 min-[1880px]:gap-x-72" + (e.video_url ? " " : " tb:flex")
  }, t.createElement("div", {
    className: "max-w-[29.18rem] w-full tb:flex items-start tb:flex-col mt-4 tb:mt-0"
  }, e.tag_line && t.createElement("div", null, t.createElement(ce, {
    textStyle: "h6",
    as: "h6",
    className: "pb-2 uppercase text-center db:text-left font-normal tb-l:text-left " + (e.tag_line_color ? e.tag_line_color : "") + (e.video_url ? " tb:text-center" : " tb:text-left")
  }, e.tag_line)), e.title && t.createElement("div", null, n ? t.createElement("div", {
    className: "pb-4 db:text-left tb:text-center tb-l:text-left" + (e.video_url ? " tb:text-center" : " tb:text-left")
  }, t.createElement("img", {
    className: "w-[290px] inline-block",
    src: n,
    alt: "Brand"
  })) : t.createElement(ce, {
    textStyle: "h2",
    as: "h2",
    className: "pb-2 tb:text-center break-words db:text-left tb-l:text-left  " + (e.title_color ? e.title_color : "") + (e.video_url ? " tb:text-center" : " tb:text-left")
  }, e.title)), e.sub_title && t.createElement(ce, {
    textStyle: "sub1",
    className: "tb-l:text-center db:text-left flex" + (e.sub_title_color ? e.sub_title_color : "") + (e.video_url ? " tb:text-center" : " tb:text-left")
  }, e.sub_title), e.description && t.createElement(ce, {
    textStyle: "sub1",
    className: "db:text-left text-neutral-0 [&>*]:mb-8 last:[&>*]:mb-0"
  }, e.description), e.buttons && t.createElement("div", {
    className: " gap-6 flex items-center tb:justify-center tb-l:justify-start db:justify-start pt-6" + (e.video_url ? " tb:justify-center" : " tb:justify-start")
  }, e.buttons[0] && t.createElement(A8, {
    type: e.buttons[0].cta_type || "secondary",
    btnTextColorClass: A("text-neutral-0"),
    leftIconVariant: "none",
    rightIconVariant: "none",
    label: e.buttons[0].cta_text,
    state: "default",
    size: "lg",
    rightAnimatedArrow: "true",
    rightAnimatedArrowColor: "#ffffff"
  }), e.buttons[1] && t.createElement(A8, {
    type: e.buttons[0].cta_type || "primaryLink",
    btnTextColorClass: A("text-neutral-0"),
    leftIconVariant: "none",
    rightIconVariant: "none",
    label: e.buttons[1].cta_text,
    state: "default",
    size: "lg",
    rightAnimatedArrow: "true",
    rightAnimatedArrowColor: "#ffffff"
  }))), t.createElement("div", {
    className: ""
  }, (e => e.imageUrl && t.createElement("div", {
    className: ""
  }, t.createElement("img", {
    src: e.imageUrl,
    alt: e.imageAlt,
    className: "tb-l:w-full w-1/2"
  })))(e))), (e => e.linkCards && t.createElement("div", {
    className: "flex mt-16 px-20 pb-20 gap-6 justify-center"
  }, e.linkCards.map((e, r) => t.createElement("div", {
    key: r,
    className: "w-full"
  }, t.createElement(Vte, {
    linkUrl: e.linkUrl,
    cardBgColor: e.cardBgColor,
    cardHoverBg: e.cardHoverBg,
    iconVariant: e.iconVariant,
    iconStrokeColor: e.iconStrokeColor,
    iconArrowVariant: e.iconArrowVariant,
    iconArrowStrokeColor: e.iconArrowStrokeColor,
    title: e.title,
    description: e.description
  })))))(e))), e.scrollArrow && t.createElement("a", {
    className: "flex justify-center flex-row z-10",
    onClick: e => i(e.currentTarget)
  }, t.createElement("div", {
    className: "flex bg-neutral-0 shadow-md -mt-5 animate-bounce justify-center rounded-full items-center w-12 h-12",
    onClick: e => {
      const t = e.target.parentNode;
      i(t);
    }
  }, t.createElement(mz, {
    variant: "chevrondowndouble",
    strokeClass: "stroke-neutral-800",
    height: "h-6 w-6"
  })))));
}
function Efe(e) {
  const {
    heroData: r,
    activeTab: n,
    onTabChange: a
  } = e;
  let o;
  if (n.activeTab && (o = n.activeTab), !r) return t.createElement("div", null);
  let i = "",
    l = "",
    s = "",
    c = "",
    u = "";
  return e.heroData && e.heroData.tabContent && e.heroData.tabContent[o] && e.heroData.tabContent[o].heroBgColor && (i = A(e.heroData.tabContent[o].heroBgColor)), e.heroData && e.heroData.tabContent && e.heroData.tabContent[o] && e.heroData.tabContent[o].bgColorTab && (l = A(e.heroData.tabContent[o].bgColorTab)), e.heroData && e.heroData.tabContent && e.heroData.tabContent[o] && e.heroData.tabContent[o].videoUrl && (s = e.heroData.tabContent[o].videoUrl), e.heroData && e.heroData.tabContent && e.heroData.tabContent[o] && e.heroData.tabContent[o].videoPoster && (c = e.heroData.tabContent[o].videoPoster), e.heroData && e.heroData.tabContent && e.heroData.tabContent[o] && e.heroData.tabContent[o].img_url && e.heroData.tabContent[o].img_url, e.heroData && e.heroData.tabContent && e.heroData.tabContent[o] && e.heroData.tabContent[o].pillColor && (u = e.heroData.tabContent[o].pillColor), e.heroData && e.heroData.tabContent && e.heroData.tabContent[o] && e.heroData.tabContent[o].bgColorTab && (l = A(e.heroData.tabContent[o].bgColorTab)), t.createElement("div", {
    className: "".concat(i, " -mt-[81px] pt-[81px] tb:mt-0 tb:pt-0 max-w-7xl rounded-b-3xl tb:rounded-3xl")
  }, e.heroData.navTabs && t.createElement("div", {
    className: "py-5 db:p-20 tb:p-10 flex flex-col shadow rounded-2xl"
  }, t.createElement("div", {
    className: "flex px-8 tb:px-0 overflow-scroll scrollbar-hide tb-l:justify-center justify-start"
  }, t.createElement("div", {
    className: "".concat(l, " bg-opacity-30 p-1 rounded-[32px]")
  }, t.createElement(bfe, {
    onTabClick: e => {
      if (e.name) {
        const t = e.name.replace(/\s/g, "");
        a(t);
      }
    },
    tabs: e.heroData.navTabs,
    bgColorTab: e.heroData.bgColorTab,
    pillColor: u
  }))), t.createElement("div", {
    className: "flex flex-col-reverse pt-6 px-8 tb:px-0 tb:flex tb:flex-row tb:items-center tb:pt-10 tb:justify-between"
  }, t.createElement("div", {
    className: " mt-3 db:max-w-[488px] tb:w-1/2"
  }, e.heroData.tabContent && e.heroData.tabContent[o] && (h = e.heroData.tabContent[o], t.createElement(t.Fragment, null, t.createElement("div", {
    className: "tb:px-3"
  }, h.title && t.createElement(ce, {
    textStyle: "h2",
    className: A(h.titleTextColor)
  }, h.title), h.subTitle && t.createElement(ce, {
    textStyle: "sub2",
    className: "mt-2 ".concat(A(h.subTitleTextColor))
  }, h.subTitle)), h.btnLabel && t.createElement("div", {
    className: "flex pl-3 pt-6"
  }, t.createElement(A8, {
    label: h.btnLabel,
    type: "secondary",
    leftIconVariant: "none",
    rightIconVariant: "none",
    state: "default",
    size: "sm",
    rightAnimatedArrow: !0,
    rightAnimatedArrowColor: "#1E56E3",
    animatedHoverStroke: "group-hover:stroke-blue-600",
    className: "flex",
    btnTextColorClass: "text-blue-600"
  }))))), t.createElement("div", {
    className: " db:max-w-[540px] tb:w-1/2 "
  }, t.createElement(pz, {
    video_url: s,
    video_poster: c
  }))), t.createElement("div", {
    className: ""
  }, e.heroData.tabContent[o] && (e => e.linkCards && t.createElement("div", {
    className: "flex px-8 tb:px-0 tb:justify-center overflow-auto scrollbar-hide flex-row mt-16 gap-6 tb:flex-row  "
  }, e.linkCards.map((e, r) => t.createElement("div", {
    key: r,
    className: "".concat(A(e.cardBorderClass), " border rounded-2xl w-full pb-2 min-w-[11.5rem] max-w-[22.313rem]")
  }, t.createElement(Vte, {
    titleTextColor: e.titleTextColor,
    descTextColor: e.descTextColor,
    linkUrl: e.linkUrl,
    cardBgColor: e.cardBgColor,
    cardHoverBg: e.cardHoverBg,
    iconVariant: e.iconVariant,
    iconStrokeClass: e.iconStrokeColor,
    iconArrowVariant: e.iconArrowVariant,
    iconArrowStrokeClass: e.iconArrowStrokeColor,
    title: e.title,
    description: e.description
  })))))(e.heroData.tabContent[o]))));
  var h;
}
function jfe(_ref150) {
  let {
    heroData: e
  } = _ref150;
  return t.createElement("div", {
    className: ""
  }, t.createElement("div", {
    className: ""
  }, t.createElement("div", {
    className: "max-w-7xl mx-auto pb-14 tb:pb-10 db-s:p-20 rounded-3xl overflow-hidden " + (e.bg_color ? e.bg_color : "")
  }, t.createElement("div", {
    className: "w-full"
  }, t.createElement("div", {
    className: "flex flex-col px-8 db-s:px-0 tb:px-10 pt-5 tb:pt-10 db-s:flex db-s:justify-between db-s:items-center db-s:flex-row db-s:w-full db-s:gap-x-[92px]"
  }, t.createElement("div", {
    className: "db-s:max-w-[490px] tb-l:max-w-[658px]  w-full tb:flex items-start tb:flex-col mt-4 tb:mt-0"
  }, e.title && t.createElement(t.Fragment, null, e.title && t.createElement(t.Fragment, null, e.stackedCard && t.createElement("div", {
    className: "pb-6"
  }, (r = e.stackedCard, t.createElement("div", {
    className: "flex flex-row"
  }, r && r.map((e, r) => t.createElement("div", {
    key: r,
    className: "w-20 h-20 ".concat(r > 0 ? "-ml-4" : "", " ").concat(A(e.cardBgClass), " ").concat(A(e.cardHoverbgClass), " rounded-full flex items-center justify-center ")
  }, t.createElement("div", {
    className: "w-14 h-14"
  }, t.createElement("img", {
    className: "inline-block",
    src: e.img_link,
    alt: e.img_alt
  }))))))), t.createElement(ce, {
    textStyle: "h2",
    as: "h2",
    className: "pb-2 tb:text-center break-words db:text-left tb-l:text-left  " + (e.title_color ? e.title_color : "") + (e.video_url ? " tb:text-center" : " tb:text-left")
  }, e.title))), e.sub_title && t.createElement(ce, {
    textStyle: "sub1",
    className: "tb-l:text-center db:text-left flex" + (e.sub_title_color ? e.sub_title_color : "")
  }, e.sub_title), e.description && t.createElement(ce, {
    textStyle: "sub1",
    className: "db:text-left text-neutral-0 [&>*]:mb-8 last:[&>*]:mb-0"
  }, e.description), e.buttons && t.createElement("div", {
    className: " gap-6 flex items-center tb:justify-center tb-l:justify-start db:justify-start pt-6" + (e.video_url ? " tb:justify-center" : " tb:justify-start")
  }, e.buttons[0] && t.createElement(A8, {
    type: "primary",
    btnTextColorClass: A("text-neutral-0"),
    leftIconVariant: "none",
    rightIconVariant: "none",
    label: e.buttons[0].cta_text,
    state: "default",
    size: "lg",
    rightAnimatedArrow: "true",
    rightAnimatedArrowColor: "#ffffff"
  }), e.buttons[1] && t.createElement(A8, {
    type: "primaryLink",
    btnTextColorClass: A("text-neutral-0"),
    leftIconVariant: "none",
    rightIconVariant: "none",
    label: e.buttons[1].cta_text,
    state: "default",
    size: "lg",
    rightAnimatedArrow: "true",
    rightAnimatedArrowColor: "#ffffff"
  }))), t.createElement("div", {
    className: "h-full flex justify-center db-s:self-start w-full"
  }, (e => e.imageUrl && t.createElement("div", {
    className: "py-12 tb:py-14 db-s:pt-0   "
  }, t.createElement("img", {
    src: e.imageUrl,
    alt: e.imageAlt,
    className: "tb-l:w-full db-s:max-w-[540px]"
  })))(e))), (e => e.linkCards && t.createElement("div", {
    className: "flex px-8 tb:px-10 tb:justify-center db-s:px-0 overflow-auto scrollbar-hide flex-row gap-6 db-s:mt-[68px] tb:flex-row "
  }, e.linkCards.map((e, r) => t.createElement("div", {
    key: r,
    className: "".concat(A(e.cardBorderClass), " ").concat(A(e.cardBgColor), " ").concat(A(e.cardHoverBg), " transition-all ease-out duration-300 hover:shadow-2xl hover:border-opacity-0 border rounded-2xl w-full min-w-[11.5rem] max-w-[22.313rem]")
  }, t.createElement(Vte, {
    titleTextColor: e.titleTextColor,
    descTextColor: e.descTextColor,
    linkUrl: e.linkUrl,
    iconVariant: e.iconVariant,
    iconStrokeClass: e.iconStrokeColor,
    iconArrowVariant: e.iconArrowVariant,
    iconArrowStrokeClass: e.iconArrowStrokeColor,
    title: e.title,
    description: e.description
  })))))(e)))));
  var r;
}
function Cfe(e) {
  return t.createElement("div", {
    className: "max-w-7xl"
  }, t.createElement("div", {
    className: "relative"
  }, t.createElement("img", {
    loading: "lazy",
    src: "https://res.cloudinary.com/dh8fp23nd/image/upload/v1692355512/hasura-design-system/heroevents2_c8mpzp.png",
    alt: e.img_alt,
    className: "bg-discord h-[336px] object-cover "
  })), t.createElement("div", {
    className: "flex items-start py-12 px-20"
  }, t.createElement("div", {
    className: "flex-1"
  }), t.createElement("div", {
    className: "bg-neutral-0 rounded-3xl w-[400px] z-[1] -mt-[200px] p-10 border border-neutral-200"
  }, t.createElement("div", {
    className: "flex gap-2 items-center pb-6"
  }, t.createElement(mz, {
    height: "h-5 w-5",
    variant: "videorecorder",
    strokeClass: "stroke-blue-600"
  }), t.createElement(ce, {
    textStyle: "h5",
    className: "text-neutral-1000"
  })), t.createElement("div", null, t.createElement(n8, {
    formId: "hf-1051",
    styleClass: "paper-form-wrapper"
  })))));
}
Efe.defaultProps = {
  heroData: {
    tabContent: {
      Performance: {
        heroBgColor: "bg-green-500",
        title: "Blazing-fast APIs at Global Scale ",
        subTitle: "Hasura optimizes your API performance up to 10x faster with end-to-end caching, while scaling both vertically and horizontally.",
        videoUrl: "https://res.cloudinary.com/dh8fp23nd/video/upload/v1683307555/hasura-con-2023/tg_hascon23_homepage_ue29jn.mp4",
        videoPoster: "https://res.cloudinary.com/dh8fp23nd/image/upload/v1685017301/Group_2608667_gu6idw.png",
        subTitleTextColor: "text-neutral-0",
        titleTextColor: "text-neutral-0",
        bgColorTab: "bg-neutral-1000",
        pillColor: "bg-pink-500",
        button: [{
          cta_text: "Get Started",
          btnBg: "",
          bg_color: "bg-blue-900",
          cta_link: "",
          cta_type: ""
        }, {
          cta_text: "Get Started",
          btnBg: "",
          bg_color: "bg-blue-900",
          cta_link: "",
          cta_type: ""
        }],
        linkCards: [{
          titleTextColor: "text-neutral-0",
          descTextColor: "text-neutral-0",
          iconVariant: "videorecorder",
          iconStrokeColor: "#3970FD",
          iconArrowVariant: "arrownarrowupright",
          iconArrowStrokeColor: "blue-400",
          title: "Webinar",
          description: "Model Level Authorization System for GraphQL with Hasura"
        }, {
          cardBgColor: "bg-pink-300",
          cardHoverBg: "bg-pink-900",
          iconVariant: "videorecorder",
          iconStrokeColor: "#3970FD",
          iconArrowVariant: "arrownarrowupright",
          iconArrowStrokeColor: "blue-400",
          title: "Webinar",
          description: "GraphQL response caching"
        }, {
          cardBgColor: "bg-pink-300",
          cardHoverBg: "bg-pink-900",
          iconVariant: "videorecorder",
          iconStrokeColor: "#3970FD",
          iconArrowVariant: "arrownarrowupright",
          iconArrowStrokeColor: "blue-400",
          title: "Webinar",
          description: "Model Level Authorization System for GraphQL with Hasura"
        }]
      },
      Company: {
        heroBgColor: "bg-blue-500",
        title: "Leverage Hasura’s Authorization Engine",
        subTitle: "Hasura optimizes your API performance up to 10x faster with end-to-end caching, while scaling both vertically and horizontally.ss",
        videoUrl: "https://res.cloudinary.com/dh8fp23nd/video/upload/v1683307555/hasura-con-2023/tg_hascon23_homepage_ue29jn.mp4",
        videoPoster: "https://res.cloudinary.com/dh8fp23nd/image/upload/v1685017301/Group_2608667_gu6idw.png",
        imgUrl: "",
        subTitleTextColor: "text-neutral-0",
        titleTextColor: "text-neutral-0",
        bgColorTab: "bg-neutral-1000",
        pillColor: "bg-amber-500",
        button: [{
          cta_text: "Get Started",
          btnBg: "",
          bg_color: "bg-blue-900",
          cta_link: "",
          cta_type: ""
        }, {
          cta_text: "Get Started",
          btnBg: "",
          bg_color: "bg-blue-900",
          cta_link: "",
          cta_type: ""
        }],
        linkCards: [{
          titleTextColor: "text-neutral-0",
          descTextColor: "text-neutral-0",
          iconVariant: "videorecorder",
          iconStrokeColor: "#3970FD",
          iconArrowVariant: "arrownarrowupright",
          iconArrowStrokeColor: "blue-400",
          title: "Webinar",
          description: "Model Level Authorization System for GraphQL with Hasura"
        }, {
          cardBgColor: "bg-pink-300",
          cardHoverBg: "bg-pink-900",
          iconVariant: "videorecorder",
          iconStrokeColor: "#3970FD",
          iconArrowVariant: "arrownarrowupright",
          iconArrowStrokeColor: "blue-400",
          title: "Webinar",
          description: "Model Level Authorization System for GraphQL with Hasura"
        }, {
          cardBgColor: "bg-pink-300",
          cardHoverBg: "bg-pink-900",
          iconVariant: "videorecorder",
          iconStrokeColor: "#3970FD",
          iconArrowVariant: "arrownarrowupright",
          iconArrowStrokeColor: "blue-400",
          title: "Webinar",
          description: "Model Level Authorization System for GraphQL with Hasura"
        }]
      },
      Authorization: {
        heroBgColor: "bg-cyan-500",
        title: "Blazing-fast APIs at Global Scale ",
        subTitle: "Hasura optimizes your API performance up to 10x faster with end-to-end caching, while scaling both vertically and horizontally.",
        videoUrl: "https://res.cloudinary.com/dh8fp23nd/video/upload/v1683307555/hasura-con-2023/tg_hascon23_homepage_ue29jn.mp4",
        videoPoster: "https://res.cloudinary.com/dh8fp23nd/image/upload/v1685017301/Group_2608667_gu6idw.png",
        imgUrl: "",
        subTitleTextColor: "text-neutral-0",
        titleTextColor: "text-neutral-0",
        bgColorTab: "bg-pink-500",
        pillColor: "bg-neutral-500",
        button: [{
          cta_text: "Get Started",
          btnBg: "",
          bg_color: "bg-blue-900",
          cta_link: "",
          cta_type: ""
        }, {
          cta_text: "Get Started",
          btnBg: "",
          bg_color: "bg-blue-900",
          cta_link: "",
          cta_type: ""
        }],
        linkCards: [{
          titleTextColor: "text-neutral-0",
          descTextColor: "text-neutral-0",
          iconVariant: "videorecorder",
          iconStrokeColor: "#3970FD",
          iconArrowVariant: "arrownarrowupright",
          iconArrowStrokeColor: "blue-400",
          title: "Webinar",
          description: "Model Level Authorization System for GraphQL with Hasura"
        }, {
          cardBgColor: "bg-pink-300",
          cardHoverBg: "bg-pink-900",
          iconVariant: "videorecorder",
          iconStrokeColor: "#3970FD",
          iconArrowVariant: "arrownarrowupright",
          iconArrowStrokeColor: "blue-400",
          title: "Webinar",
          description: "Model Level Authorization System for GraphQL with Hasura"
        }, {
          cardBgColor: "bg-pink-300",
          cardHoverBg: "bg-pink-900",
          iconVariant: "videorecorder",
          iconStrokeColor: "#3970FD",
          iconArrowVariant: "arrownarrowupright",
          iconArrowStrokeColor: "blue-400",
          title: "Webinar",
          description: "Model Level Authorization System for GraphQL with Hasura"
        }]
      }
    },
    navTabs: [{
      current: !0,
      name: "Performance"
    }, {
      current: "false",
      name: "Company"
    }, {
      current: "false",
      name: "Authorization"
    }, {
      current: "false",
      name: "Observability"
    }, {
      current: "false",
      name: "API Security"
    }]
  }
};
function Pfe(e) {
  const [n, a] = r(!1);
  if (!e) return t.createElement("div", null);
  const o = e !== null && e !== void 0 && e.isLargeVideoPlayer ? "grid items-center relative db:max-w-[600px] tb:w-3/5 transition-opacity duration-700 ease-linear " : "grid items-center relative db:max-w-[500px] tb:w-1/2 transition-opacity duration-700 ease-linear ";
  return t.createElement("div", null, t.createElement("div", {
    className: "flex flex-col-reverse tb-l:flex tb-l:flex-row tb-l:justify-between gap-4"
  }, t.createElement("div", {
    className: "max-w-[435px] db:max-w-[".concat(e.contentWd ? e.contentWd : "535px", "]")
  }, e && (i = e, t.createElement(t.Fragment, null, i.title && t.createElement(ce, {
    textStyle: "h2",
    as: "h2",
    className: " hidden tb:block ".concat(i.titleTextColor ? A(i.titleTextColor) : "text-neutral-1000")
  }, i.title), i.subTitle && t.createElement(ce, {
    textStyle: "sub1",
    className: "mt-2 ".concat(i.subTitleTextColor ? A(i.subTitleTextColor) : "text-neutral-700")
  }, i.subTitle), i.description && t.createElement(ce, {
    textStyle: "sub2",
    className: "mt-2 [&>p]:pb-4 last:[&>p]:pb-0 [&>ul]:ps-4 [&>ul>li]:list-disc [&>ul>li]:pb-1 last:[&>ul>li]:pb-0 [&>p>a]:text-blue-600 [&>p>a:hover]:text-blue-800 ".concat(i.descriptionTextColor ? A(i.subTitleTextColor) : "text-neutral-700")
  }, t.createElement(bte, null, i.description)), i.buttons && t.createElement("div", {
    className: "flex items-center flex-wrap flex-row gap-2 pt-6"
  }, i.buttons.map((e, r) => {
    var _e$rightAnimatedArrow, _e$animatedHoverStrok;
    return t.createElement(l, {
      key: r
    }, e.url && e.text && e.type && t.createElement("a", {
      href: e.url,
      key: r,
      className: "flex "
    }, t.createElement(A8, {
      label: e.text,
      type: e.type,
      leftIconVariant: "none",
      rightIconVariant: "none",
      state: "default",
      size: "md",
      rightAnimatedArrow: !0,
      rightAnimatedArrowColor: (_e$rightAnimatedArrow = e.rightAnimatedArrowColor) !== null && _e$rightAnimatedArrow !== void 0 ? _e$rightAnimatedArrow : "#3970FD",
      animatedHoverStroke: (_e$animatedHoverStrok = e.animatedHoverStroke) !== null && _e$animatedHoverStrok !== void 0 ? _e$animatedHoverStrok : "group-hover:stroke-neutral-0",
      btnTextColorClass: e.btnTextColorClass,
      btnTextHoverClass: e.btnTextHoverClass,
      className: e.className,
      btnbgHoverClass: e.btnBgColorClass
    })));
  }))))), t.createElement("div", {
    className: o
  }, t.createElement(ce, {
    textStyle: "h2",
    as: "h2",
    className: "tb:hidden pb-6 ".concat(e.titleTextColor ? A(e.titleTextColor) : "text-neutral-1000")
  }, e.title), n ? t.createElement(t.Fragment, null, e.videoUrl && t.createElement("video", {
    id: "hero_vid",
    controls: !0,
    autoPlay: !0,
    playsInline: !0,
    width: "500",
    height: "500",
    className: "tb:w-full w-full rounded-2xl",
    src: e.videoUrl
  })) : t.createElement("div", {
    className: "relative"
  }, e.imgUrl && t.createElement("img", {
    src: e.imgUrl,
    alt: "Illustration",
    loading: "lazy"
  }), e.videoUrl && t.createElement("div", {
    className: "".concat(e.currentPlayBtnClass, " w-14 h-14 cursor-pointer video-play-btn rounded-full flex items-center justify-center absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 shadow-neutral-1000 shadow-2xl"),
    onClick: () => a(!0)
  }, t.createElement(mz, {
    variant: "play",
    height: "h-6 w-6",
    strokeColor: "#ffffff",
    strokeClass: "stroke-neutral-0"
  }))))), t.createElement("div", {
    className: ""
  }, (e => e.linkCards && t.createElement("div", {
    className: "flex tb-m:justify-center overflow-auto no-scrollbar db:overflow-visible scrollbar-hide flex-row mt-10 tb:mt-12 db:mt-16 gap-6 tb:flex-row  "
  }, e.linkCards.map((e, r) => t.createElement("div", {
    key: r,
    className: "".concat(A(e.cardBorderClass), " ").concat(A(e.cardBgColor), " ").concat(A(e.cardHoverBg), " transition-all ease-out duration-300 hover:shadow-2xl hover:border-opacity-0 border rounded-2xl w-full min-w-[11.5rem] max-w-[22.313rem]")
  }, t.createElement(Vte, {
    titleTextColor: e.titleTextColor,
    descTextColor: e.descTextColor,
    linkUrl: e.linkUrl,
    iconVariant: e.iconVariant,
    iconStrokeClass: e.iconStrokeColor,
    iconArrowVariant: e.iconArrowVariant,
    iconArrowStrokeClass: e.iconArrowStrokeColor,
    title: e.title,
    description: e.description
  })))))(e)));
  var i;
}
function Mfe(e) {
  const {
    head: r,
    description: n,
    tableValue: a,
    children: o
  } = e;
  return t.createElement("div", {
    className: "px-4 sm:px-6 lg:px-8 "
  }, t.createElement("div", {
    className: "sm:flex sm:items-center "
  }, t.createElement("div", {
    className: "sm:flex-auto"
  }, t.createElement("h1", {
    className: "text-base font-semibold leading-6 text-gray-900"
  }, r), t.createElement("p", {
    className: "mt-2 text-sm text-gray-700"
  }, n))), t.createElement("div", null, t.createElement("div", {
    className: "-mx-4 mt-8 sm:-mx-0"
  }, t.createElement("table", {
    className: "min-w-full divide-y divide-gray-300 border"
  }, t.createElement("thead", null, t.createElement("tr", null, Object.keys(a[0]).map(e => t.createElement("th", {
    key: e,
    scope: "col",
    className: "px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:table-cell"
  }, e)))), t.createElement("tbody", {
    className: "divide-y divide-gray-200 bg-white"
  }, a.map((e, r) => t.createElement("tr", {
    key: r
  }, Object.keys(e).map((n, a) => t.createElement("td", {
    key: a + r,
    className: " py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-3"
  }, "", e[n])))))))));
}
const kfe = [{
  name: "Tier 1",
  href: "",
  current: !0
}, {
  name: "Tier 2",
  href: "",
  current: !1
}, {
  name: "Tier 3",
  href: "",
  current: !1
}];
function Sfe(e) {
  const {
      title: n,
      title_color: a,
      description: o,
      desc_color: i,
      TABLE_VALUE: l,
      TABLE_HEADER: s
    } = e,
    [c, u] = r(1);
  return t.createElement("div", {
    className: " max-w-7xl px-4 sm:px-6 lg:px-8 "
  }, t.createElement("div", {
    className: " flex justify-around "
  }, t.createElement("div", {
    className: "w-full flex-col items-center flex justify-around tb-l:flex tb-l:flex-col tb-l:items-center"
  }, t.createElement("div", null, n && t.createElement(ce, {
    textStyle: "h3",
    className: A(a)
  }, n), o && t.createElement(ce, {
    textStyle: "body1c",
    className: A(i)
  }, o)), t.createElement("div", {
    className: " mt-11 p-2 bg-neutral-0 rounded-full shadow tb-l:hidden"
  }, t.createElement(bfe, {
    onTabClick: function (e) {
      "Tier 1" === e.name && u(1), "Tier 2" === e.name && u(2), "Tier 3" === e.name && u(3);
    },
    tabs: kfe
  })))), t.createElement("div", {
    className: "tb-l:hidden"
  }, t.createElement("div", {
    className: "mt-8 bg-neutral-0 rounded-3xl "
  }, t.createElement("div", {
    className: " shadow rounded-3xl "
  }, t.createElement("div", {
    className: "flex border-x px-8 py-[1.625rem] border-neutral-200 rounded-t-3xl flex-col justify-center items-center text-center"
  }, t.createElement("div", {
    className: "flex items-center gap-2"
  }, s[c].icon && t.createElement(mz, {
    height: "h-6 w-6",
    variant: s[c].icon,
    strokeClass: s[c].iconStrokeClass
  }), s[c].title && 0 == c && t.createElement(ce, {
    textStyle: "h5",
    className: s[c].title_text_color
  }, "".concat(s[c].title)), s[c].title && 0 != c && t.createElement(ce, {
    textStyle: "h5",
    className: s[c].title_text_color
  }, "".concat(s[c].title))), t.createElement("div", {
    className: " max-w-[10rem]"
  }, s[c].descr && t.createElement(ce, {
    textStyle: "body1",
    className: s[c].descr_text_color
  }, "".concat(s[c].descr)))), t.createElement("div", {
    className: "divide-y divide-neutral-200 rounded-b-3xl"
  }, t.createElement("div", {
    className: "flex flex-col border border-neutral-200 divide-y divide-neutral-200 rounded-b-3xl  items-center"
  }, t.createElement("div", {
    className: "flex divide-y divide-neutral-200 flex-col w-full gap-2 items-start"
  }, l.map((e, r) => t.createElement(t.Fragment, {
    key: r
  }, ((e, r) => {
    const n = "key".concat(r);
    if (e[n] && (e[n].text || e[n].iconVariant)) return t.createElement(t.Fragment, null, t.createElement("div", {
      className: "flex gap-4 p-4 w-full"
    }, (e[n].text || e[n].iconVariant) && t.createElement(mz, {
      height: "h-5 w-5 stroke-[1.5px]",
      variant: "checkcircle",
      strokeClass: "stroke-green-500"
    }), t.createElement(t.Fragment, null, t.createElement(ce, {
      textStyle: "body1c",
      className: "text-neutral-700 [&>span]:pb-2 [&>ul]:ps-4 [&>ul>li]:list-disc [&>ul>li]:pb-2 [&>ul>li]:last:pb-0"
    }, e[n].text && null !== e[n].text && t.createElement(t.Fragment, null, "".concat(e[n].text, " ")), e.rowTitle && (e[n].text || e[n].iconVariant) && t.createElement(t.Fragment, null, t.createElement(bte, {
      components: {
        p: "span"
      }
    }, "".concat(e.rowTitle)))))));
  })(e, c))))))))), t.createElement("div", {
    className: "hidden tb-l:block"
  }, t.createElement("div", {
    className: "mt-12 bg-neutral-0 rounded-3xl "
  }, t.createElement("table", {
    className: "min-w-full shadow tableclss rounded-3xl "
  }, t.createElement("thead", null, t.createElement("tr", {
    className: "divide-x border-b border-neutral-200 divide-neutral-200 text-center rounded-t-3xl"
  }, Object.keys(s).map((e, r) => t.createElement("th", {
    key: r,
    scope: "col",
    className: "px-8 py-6 sm:table-cell"
  }, t.createElement("div", {
    className: ""
  }, t.createElement("div", {
    className: "flex flex-col justify-center items-center text-center"
  }, t.createElement("div", {
    className: "flex items-center gap-2 w-full justify-center"
  }, s[e].icon && t.createElement(mz, {
    height: "h-6 w-6 stroke-[1.5px]",
    variant: s[e].icon,
    strokeClass: A(s[e].iconStrokeClass)
  }), s[e].title && 0 == e && t.createElement(ce, {
    textStyle: "h5",
    className: "w-full text-left ".concat(A(s[e].title_text_color))
  }, s[e].title), s[e].title && 0 != e && t.createElement(ce, {
    textStyle: "h5",
    className: A(s[e].title_text_color)
  }, t.createElement(bte, null, s[e].title))), t.createElement("div", {
    className: " max-w-[10rem]"
  }, s[e].descr && t.createElement(ce, {
    textStyle: "body1",
    className: A(s[e].descr_text_color)
  }, s[e].descr)))))))), t.createElement("tbody", {
    className: "divide-y divide-neutral-200"
  }, l.map((e, r) => t.createElement("tr", {
    className: "divide-x divide-neutral-200",
    key: r
  }, Object.keys(e).map(n => t.createElement(t.Fragment, {
    key: r + n
  }, null !== n && "rowTitle" === n && t.createElement("td", {
    className: "px-8 py-7 w-[22.5rem]"
  }, t.createElement(ce, {
    className: "max-w-[22rem] text-neutral-700 [&>p]:pb-2 [&>ul]:ps-4 [&>ul>li]:list-disc [&>ul>li]:pb-2 [&>ul>li]:last:pb-0",
    textStyle: "body1c"
  }, t.createElement(bte, null, e[n]))), null !== n && "rowTitle" !== n && null !== e[n] && t.createElement("td", {
    className: "px-8 py-7 border-table text-center "
  }, e && n && e[n] && null === e[n].text && !e[n].iconVariant && null === e[n].iconVariant && t.createElement(t.Fragment, null), null !== e[n].text && e[n].text && t.createElement(ce, {
    className: "text-neutral-700",
    textStyle: "body1c"
  }, e[n].text), (null === e[n].text || !e[n].text) && e[n].iconVariant && t.createElement("div", {
    className: "flex justify-center"
  }, t.createElement(mz, {
    height: "h-5 w-5 stroke-[1.5px]",
    variant: e[n].iconVariant,
    strokeClass: A(e[n].iconStrokeClass)
  }))), null === n && t.createElement("td", {
    key: r,
    className: "px-8 py-7 border-table text-center"
  }))))))))));
}
function Nfe(e) {
  const {
    head: r,
    description: n,
    tableValue: a,
    children: o
  } = e;
  return Object.keys(a[0]).length, t.createElement("div", {
    className: " "
  }, t.createElement("div", {
    className: "sm:flex sm:items-center "
  }, t.createElement("div", {
    className: "sm:flex-auto"
  }, t.createElement("h1", {
    className: "text-base font-semibold leading-6 text-gray-900"
  }, r), t.createElement("p", {
    className: "mt-2 text-sm text-gray-700"
  }, n))), t.createElement("div", null, t.createElement("div", {
    className: "border border-neutral-100 rounded-2xl"
  }, t.createElement("table", {
    className: "min-w-full divide-y divide-neutral-100 "
  }, t.createElement("thead", null, t.createElement("tr", {
    className: "divide-x divide-neutral-100"
  }, Object.keys(a[0]).map((e, r) => t.createElement("th", {
    key: e,
    scope: "col",
    className: 0 === r ? "rounded-tl-2xl text-left sm:table-cell bg-neutral-50" : "text-left sm:table-cell bg-neutral-50 rounded-tr-2xl"
  }, t.createElement(ce, {
    className: "p-6",
    textStyle: "body3c-bold"
  }, e))))), t.createElement("tbody", {
    className: "divide-y rounded-b-3xl divide-neutral-100 "
  }, a.slice(1).map((e, r) => t.createElement("tr", {
    key: r,
    className: "divide-x divide-neutral-100 "
  }, Object.keys(e).map((n, o) => t.createElement("td", {
    key: o + r,
    className: "p-6 " + (r == "" + (a.length - 2) ? "rounded-3xl" : "")
  }, t.createElement(ce, {
    textStyle: "body3c-bold",
    className: "bg-transparent text-neutral-800"
  }, n.toString()), t.createElement(ce, {
    textStyle: "body3",
    className: "text-neutral-800 mt-2"
  }, e[n].toString()))))))))));
}
function Bfe(e) {
  const {
      title: o,
      title_color: i,
      description: l,
      desc_color: s,
      TABLE_VALUE: c,
      TABLE_HEADER: u
    } = e,
    [h, m] = r(!1),
    p = n();
  a(() => {
    const e = () => {
      p.current.getBoundingClientRect().top, m(!0);
    };
    return window.addEventListener("scroll", e), () => {
      window.removeEventListener("scroll", e);
    };
  }, []);
  return t.createElement("div", {
    className: "px-10"
  }, t.createElement("div", {
    className: "hidden tb:block"
  }, t.createElement("div", {
    className: " mt-[70px] rounded-3xl  bg-neutral-0"
  }, u && u[0] && u[0].title && t.createElement(ce, {
    textStyle: "h4",
    className: "pb-10 pl-8 pt-[72px] ".concat(A(i))
  }, u[0].title), t.createElement("table", {
    className: "rounded-3xl w-full table-fixed "
  }, c.map((e, r) => t.createElement("tbody", {
    key: r,
    className: "border-90  bg-neutral-0"
  }, Object.keys(e).map(n => t.createElement(t.Fragment, null, t.createElement("tr", {
    key: r + n,
    className: ""
  }, Object.keys(e[n][0]).map(a => t.createElement(t.Fragment, {
    key: a + n + r
  }, null !== a && t.createElement("th", {
    ref: p,
    className: "first:rounded-l-full last:rounded-r-full px-8 z-[100] top-[72px] sticky " + (0 === r ? "bg-neutral-0" : "bg-neutral-100")
  }, t.createElement("div", {
    className: "flex flex-col py-3.5 gap-[11px]"
  }, t.createElement(ce, {
    textStyle: "h5",
    className: "text-neutral-900 text-left whitespace-nowrap"
  }, a), e[n][0][a].btn && e[n][0][a].btn_cta && t.createElement("div", {
    className: "flex -mt-4"
  }, t.createElement("a", {
    href: e[n][0][a].btn_cta
  }, t.createElement(A8, {
    label: e[n][0][a].btn,
    type: "secondaryLink",
    leftIconVariant: "none",
    rightIconVariant: "none",
    state: "default",
    size: "sm",
    rightAnimatedArrow: !0,
    rightAnimatedArrowColor: "#3970FD",
    animatedHoverStroke: "#3970FD",
    btnTextColorClass: "text-blue-500",
    btnTextHoverClass: "",
    className: " "
  })))))))), ((e, r) => {
    let n = "";
    e[r][0] && e[r][0];
    const a = e[r].map(e => Object.keys(e)[0])[0];
    return e[r].length && (n = e[r].length), t.createElement(t.Fragment, null, e[r].map((e, r) => t.createElement("tr", {
      className: "",
      key: r
    }, Object.keys(e).map(o => t.createElement(t.Fragment, {
      key: r + o
    }, null !== o && o === a && r !== n - 1 && 0 !== r && t.createElement("td", {
      className: "pl-[30px] border-80 "
    }, t.createElement("div", {
      className: " "
    }, t.createElement(ce, {
      className: "py-4 text-neutral-700",
      textStyle: "body1"
    }, e[o]))), null !== o && o === a && r !== n - 1 && 0 === r && t.createElement("td", {
      className: "pl-[30px] border-80 "
    }, t.createElement("div", {
      className: " "
    }, t.createElement(ce, {
      className: "pb-4 pt-12 text-neutral-700",
      textStyle: "body1"
    }, e[o]))), null !== o && o === a && r === n - 1 && t.createElement("td", {
      className: "pl-[30px] border-80 "
    }, t.createElement("div", {
      className: " "
    }, t.createElement(ce, {
      className: "pt-4 pb-12 text-neutral-700",
      textStyle: "body1"
    }, e[o]))), null !== o && o !== a && null !== e[o] && 0 !== r && r !== n - 1 && t.createElement("td", {
      className: "px-8 text-left ml-[30px] border-80 "
    }, e && o && e[o] && null === e[o].text && !e[o].iconVariant && null === e[o].iconVariant && t.createElement("div", {
      className: ""
    }), null !== e[o].text && e[o].text && t.createElement("div", {
      className: " "
    }, t.createElement(ce, {
      className: "text-neutral-700 py-4",
      textStyle: "body1"
    }, e[o].text)), (null === e[o].text || !e[o].text) && e[o].iconVariant && t.createElement("div", {
      className: "flex "
    }, t.createElement(mz, {
      height: "h-5 w-5 stroke-[1.5px]",
      variant: e[o].iconVariant,
      strokeClass: A(e[o].iconStrokeClass)
    }))), null !== o && o !== a && null !== e[o] && 0 === r && t.createElement("td", {
      className: "px-8 text-left ml-[30px] border-80 "
    }, e && o && e[o] && null === e[o].text && !e[o].iconVariant && null === e[o].iconVariant && t.createElement("div", {
      className: ""
    }), null !== e[o].text && e[o].text && t.createElement("div", {
      className: " "
    }, t.createElement(ce, {
      className: "text-neutral-700 pb-4 pt-12",
      textStyle: "body1"
    }, e[o].text)), (null === e[o].text || !e[o].text) && e[o].iconVariant && t.createElement("div", {
      className: "flex pb-4 pt-12"
    }, t.createElement(mz, {
      height: "h-5 w-5 stroke-[1.5px]",
      variant: e[o].iconVariant,
      strokeClass: A(e[o].iconStrokeClass)
    }))), null !== o && o !== a && null !== e[o] && r === n - 1 && t.createElement("td", {
      className: "px-8 text-left ml-[30px] border-80 "
    }, e && o && e[o] && null === e[o].text && !e[o].iconVariant && null === e[o].iconVariant && t.createElement("div", {
      className: ""
    }), null !== e[o].text && e[o].text && t.createElement("div", {
      className: " "
    }, t.createElement(ce, {
      className: "text-neutral-700 pt-4 pb-12",
      textStyle: "body1"
    }, e[o].text)), (null === e[o].text || !e[o].text) && e[o].iconVariant && t.createElement("div", {
      className: "flex pt-4 pb-12 "
    }, t.createElement(mz, {
      height: "h-5 w-5 stroke-[1.5px]",
      variant: e[o].iconVariant,
      strokeClass: A(e[o].iconStrokeClass)
    }))), null === o && t.createElement("td", {
      key: r,
      className: "px-8 py-7 border-table text-center"
    }))))));
  })(e, n))))), u && t.createElement(t.Fragment, null, t.createElement("tbody", null, t.createElement("tr", null, t.createElement("td", null), u.map((e, r) => t.createElement(t.Fragment, {
    key: r
  }, 0 !== r && e.button_title && t.createElement("td", {
    key: r,
    className: "px-8"
  }, t.createElement("a", {
    href: e.button_link
  }, t.createElement(A8, {
    label: e.button_title,
    type: "secondary",
    leftIconVariant: "none",
    rightIconVariant: "none",
    state: "default",
    size: "sm",
    rightAnimatedArrow: !0,
    rightAnimatedArrowColor: "#3970FD",
    className: "mt-4 mb-16"
  }))))))))))));
}
function Vfe(e) {
  const [r, n] = t.useState(0),
    [a, o] = t.useState(0),
    [i, l] = t.useState(0),
    s = e.images.reduce((e, r, n) => (e[n] = t.createRef(), e), {}),
    c = e => {
      n(e), s[e].current.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "start"
      });
    },
    u = e.images.length,
    h = () => {
      c(r >= u - 1 ? 0 : r + 1);
    },
    m = () => {
      c(0 === r ? u - 1 : r - 1);
    },
    p = e => t.createElement("button", {
      type: "button",
      onClick: e ? m : h,
      className: "absolute text-2xl z-10 bg-black h-10 w-10 rounded-full bg-neutral-0 flex items-center justify-center " + (e ? "left-2 db:-left-5" : "right-2 db:-right-5"),
      style: {
        top: "40%"
      }
    }, t.createElement("span", {
      role: "img",
      "aria-label": "Arrow " + (e ? "left" : "right")
    }, e ? t.createElement(mz, {
      className: "" + (0 == r ? "invisible" : ""),
      height: "h-6",
      variant: "chevronleft",
      strokeColor: "#1F2A37"
    }) : t.createElement(mz, {
      height: "h-6",
      variant: "chevronright",
      strokeColor: "#1F2A37"
    })));
  return t.createElement("div", null, t.createElement("div", {
    className: "flex justify-center select-none  items-center gap-10 "
  }, t.createElement("div", {
    className: "relative w-full"
  }, t.createElement("div", {
    className: "snap-x inline-flex select-none overflow-x-scroll scrollbar-hide",
    onTouchStart: e => {
      o(e.targetTouches[0].clientX);
    },
    onTouchMove: e => {
      l(e.targetTouches[0].clientX);
    },
    onTouchEnd: () => {
      a - i > 150 && h(), a - i < -150 && m();
    },
    onMouseDown: e => o(e.clientX),
    onMouseUp: e => {
      a - e.clientX > 50 && h(), a - e.clientX < -50 && m();
    }
  }, p(!0), e.images.map((e, n) => t.createElement("div", {
    className: "w-3/4 snap-center shrink-0  mx-4",
    key: n,
    ref: s[n]
  }, t.createElement("img", {
    src: e,
    className: "w-full select-none rounded-3xl object-contain " + (r == n ? "" : " opacity-60 transition-opacity delay-300 ease-in"),
    draggable: "false"
  }))), p()))), t.createElement("div", null, t.createElement("div", {
    className: "flex flex-row gap-4 mt-10 ml-4"
  }, e.images.map((e, n) => t.createElement("div", {
    className: "",
    key: n
  }, t.createElement("img", {
    src: e,
    className: "max-w-[6rem] ".concat(r == n ? "border-blue-400 border-4" : "", " rounded-lg object-contain")
  }))))));
}
function Rfe(e) {
  const a = n(null),
    [o, i] = t.useState(0),
    [l, s] = t.useState(0),
    [c, u] = t.useState(0),
    [h, m] = r(!1),
    p = e.cards.reduce((e, r, n) => (e[n] = t.createRef(), e), {}),
    f = e.cards.length,
    d = () => {
      let e = 1;
      window.innerWidth > 800 && (e = 2), window.innerWidth > 1140 && (e = 3), o < f - e ? (i(o + e), a.current.scrollTo({
        left: a.current.scrollLeft + a.current.children[0].offsetWidth * e,
        behavior: "smooth"
      })) : (i(0), a.current.scrollTo({
        left: 0,
        behavior: "smooth"
      }));
    },
    v = () => {
      let e = 1;
      if (window.innerWidth > 800 && (e = 2), window.innerWidth > 1140 && (e = 3), o > 0) i(o - e), a.current.scrollTo({
        left: a.current.scrollLeft - a.current.children[0].offsetWidth * e,
        behavior: "smooth"
      });else {
        const t = f - 1,
          r = a.current.scrollWidth - a.current.children[0].offsetWidth * e;
        i(t), a.current.scrollTo({
          left: r,
          behavior: "smooth"
        });
      }
    },
    g = e => t.createElement("button", {
      type: "button",
      onClick: e ? v : d,
      className: "flex   text-2xl z-10 bg-black h-10 ml-6 w-10 rounded-full bg-purple-200 hover:bg-neutral-0 flex items-center justify-center "
    }, t.createElement("span", {
      role: "img",
      "aria-label": "Arrow " + (e ? "left" : "right")
    }, e ? t.createElement(mz, {
      height: "h-6 w-6",
      variant: "chevronleft",
      strokeColor: "#00288E"
    }) : t.createElement(mz, {
      height: "h-6 w-6",
      variant: "chevronright",
      strokeColor: "#00288E"
    })));
  return t.createElement("div", {
    className: ""
  }, t.createElement("div", {
    className: "block tb:hidden"
  }, h ? e.cards.map((r, n) => t.createElement("div", {
    className: "my-5",
    key: n,
    ref: p[n]
  }, t.createElement("div", {
    className: "rounded-3xl overflow-hidden"
  }, t.createElement(e.component, r)))) : e.cards.slice(0, 6).map((r, n) => t.createElement("div", {
    className: "my-5",
    key: n,
    ref: p[n]
  }, t.createElement("div", {
    className: "rounded-3xl overflow-hidden"
  }, t.createElement(e.component, r)))), e.cards.length > 6 && t.createElement("div", {
    className: "flex"
  }, t.createElement(A8, {
    label: h ? "View less" : "View more",
    type: "secondary",
    leftIconVariant: "none",
    rightIconVariant: "none",
    state: "default",
    size: "sm",
    rightAnimatedArrow: !0,
    rightAnimatedArrowColor: "#1E56E3",
    animatedHoverStroke: "group-hover:stroke-neutral-0",
    className: "flex",
    btnTextColorClass: "text-blue-600",
    btnBgColorClass: "",
    onClick: () => m(!h)
  }))), t.createElement("div", {
    className: "hidden tb:flex tb:flex-col"
  }, t.createElement("div", {
    className: "flex pb-12 items-center justify-end "
  }, t.createElement("div", {
    className: "flex"
  }, g(!0), g())), t.createElement("div", {
    className: "justify-center select-none  items-center",
    onTouchStart: e => {
      s(e.targetTouches[0].clientX);
    },
    onTouchMove: e => {
      u(e.targetTouches[0].clientX);
    },
    onTouchEnd: () => {
      l - c > 150 && d(), l - c < -150 && v();
    },
    onMouseDown: e => s(e.clientX),
    onMouseUp: e => {
      l - e.clientX > 50 && d(), l - e.clientX < -50 && v();
    }
  }, t.createElement("div", {
    className: ""
  }, t.createElement("div", {
    className: "snap-x w-full inline-flex select-none overflow-x-hidden scrollbar-hide",
    ref: a
  }, e.cards.map((r, n) => t.createElement("div", {
    className: " db:snap-center snap-center tb-m:snap-start mx-5 shrink-0",
    key: n,
    ref: p[n]
  }, t.createElement("div", {
    className: "w-full select-none rounded-3xl object-contain"
  }, t.createElement(e.component, r)))))))));
}
function Afe(e) {
  const a = n(null),
    [o, i] = t.useState(0),
    [l, s] = r(!1),
    c = e.cards.reduce((e, r, n) => (e[n] = t.createRef(), e), {}),
    u = e.cards.length,
    h = " text-2xl z-10 bg-black h-12 w-12 ml-6 w-10 rounded-full bg-neutral-0 hover:bg-neutral-0 flex items-center justify-center shadow",
    m = (e, t) => "isLeft" === t ? 0 === e : "isRight" === t ? 2 === e : void 0;
  return t.createElement("div", {
    className: ""
  }, t.createElement("div", {
    className: "block tb:hidden"
  }, l ? e.cards.map((r, n) => t.createElement("div", {
    className: "my-5",
    key: n,
    ref: c[n]
  }, t.createElement("div", {
    className: "rounded-3xl overflow-hidden"
  }, t.createElement(e.component, r)))) : e.cards.slice(0, 6).map((r, n) => t.createElement("div", {
    className: "my-5",
    key: n,
    ref: c[n]
  }, t.createElement("div", {
    className: "rounded-3xl overflow-hidden"
  }, t.createElement(e.component, r)))), e.cards.length > 6 && t.createElement("div", {
    className: "flex"
  }, t.createElement(A8, {
    label: l ? "View less" : "View more",
    type: "secondary",
    leftIconVariant: "none",
    rightIconVariant: "none",
    state: "default",
    size: "sm",
    rightAnimatedArrow: !0,
    rightAnimatedArrowColor: "#1E56E3",
    animatedHoverStroke: "group-hover:stroke-neutral-0",
    className: "flex",
    btnTextColorClass: "text-blue-600",
    btnBgColorClass: "",
    onClick: () => s(!l)
  }))), t.createElement("div", {
    className: "hidden tb:flex tb:flex-col-reverse"
  }, t.createElement("div", {
    className: "flex pt-10 justify-center items-center"
  }, t.createElement("div", {
    className: "flex"
  }, t.createElement("button", {
    type: "button",
    onClick: () => {
      (() => {
        if (o > 0) i(o - 1), a.current.scrollTo({
          left: a.current.scrollLeft - 1 * a.current.children[0].offsetWidth,
          behavior: "smooth"
        });else {
          const e = u - 1,
            t = a.current.scrollWidth - 1 * a.current.children[0].offsetWidth;
          i(e), a.current.scrollTo({
            left: t,
            behavior: "smooth"
          });
        }
      })();
    },
    className: "flex bg-blue-600 ".concat(h, " disabled:bg-neutral-200 "),
    disabled: m(o, "isLeft")
  }, t.createElement("span", {
    role: "img",
    "aria-label": "Arrow left "
  }, t.createElement(mz, {
    height: "h-6 w-6 stroke-[1.5]",
    variant: "arrowleft",
    strokeColor: "#1F2A37"
  }))), t.createElement("button", {
    type: "button",
    onClick: () => {
      o < u - 1 ? (i(o + 1), a.current.scrollTo({
        left: a.current.scrollLeft + 1 * a.current.children[0].offsetWidth,
        behavior: "smooth"
      })) : (i(0), a.current.scrollTo({
        left: 0,
        behavior: "smooth"
      }));
    },
    className: "flex bg-blue-600 ".concat(h, " disabled:bg-neutral-200 "),
    disabled: m(o, "isRight")
  }, t.createElement("span", {
    role: "img",
    "aria-label": "Arrow right "
  }, t.createElement(mz, {
    height: "h-6 w-6 stroke-[1.5]",
    variant: "arrowright",
    strokeColor: "#1F2A37"
  }))))), t.createElement("div", {
    className: "justify-center select-none  items-center"
  }, t.createElement("div", {
    className: ""
  }, t.createElement("div", {
    className: "snap-center w-full inline-flex select-none overflow-x-hidden scrollbar-hide",
    ref: a
  }, e.cards.map((r, n) => t.createElement("div", {
    className: "snap-center first:ml-0 mx-5 shrink-0",
    key: n,
    ref: c[n]
  }, t.createElement("div", {
    className: "w-full snap-center  select-none rounded-3xl object-contain"
  }, t.createElement(e.component, r)))))))));
}
Sfe.defaultProps = {
  title_color: "text-blue-800",
  desc_color: "text-blue-600"
};
const Tfe = [["https://res.cloudinary.com/hasura-cms-uploads/image/upload/v1687016995/optum_Card_17973d6328.png", "https://res.cloudinary.com/hasura-cms-uploads/image/upload/v1687016994/philips_5bab1602cd.png", "https://res.cloudinary.com/hasura-cms-uploads/image/upload/v1687016996/nutrien_e629b651d5.png"]],
  Hfe = e => t.createElement("div", {
    className: "h-full"
  }, t.createElement("div", {
    className: " w-[300px] flex flex-col items-center justify-between rounded-3xl h-[338px] "
  }, t.createElement("img", {
    src: e,
    alt: "img",
    className: "w-[300px]"
  })));
function Lfe(e) {
  let a = ["https://res.cloudinary.com/hasura-cms-uploads/image/upload/v1687016994/philips_5bab1602cd.png", "https://res.cloudinary.com/hasura-cms-uploads/image/upload/v1687016996/nutrien_e629b651d5.png", "https://res.cloudinary.com/hasura-cms-uploads/image/upload/v1687016995/optum_Card_17973d6328.png"];
  function o(e) {
    var _e$slideLogo, _e$slideLogo$data, _e$slideLogo$data$att, _e$slideAuthorImage, _e$slideAuthorImage$d, _e$slideAuthorImage$d2, _e$slideHoverImage, _e$slideHoverImage$da, _e$slideHoverImage$da2;
    return {
      video_url: e.video.data.attributes.url || "",
      testimonial: {
        card: {
          title_img: ((_e$slideLogo = e.slideLogo) === null || _e$slideLogo === void 0 ? void 0 : (_e$slideLogo$data = _e$slideLogo.data) === null || _e$slideLogo$data === void 0 ? void 0 : (_e$slideLogo$data$att = _e$slideLogo$data.attributes) === null || _e$slideLogo$data$att === void 0 ? void 0 : _e$slideLogo$data$att.url) || "",
          subtitle: e.slideQuoteText || "",
          avatar: {
            img_url: ((_e$slideAuthorImage = e.slideAuthorImage) === null || _e$slideAuthorImage === void 0 ? void 0 : (_e$slideAuthorImage$d = _e$slideAuthorImage.data) === null || _e$slideAuthorImage$d === void 0 ? void 0 : (_e$slideAuthorImage$d2 = _e$slideAuthorImage$d.attributes) === null || _e$slideAuthorImage$d2 === void 0 ? void 0 : _e$slideAuthorImage$d2.url) || "",
            name: e.slideAuthorName || "",
            designation: e.slideAuthorTitle || ""
          }
        },
        cardHover: {
          cardBg: e.slideHoverColor || "",
          img_url: ((_e$slideHoverImage = e.slideHoverImage) === null || _e$slideHoverImage === void 0 ? void 0 : (_e$slideHoverImage$da = _e$slideHoverImage.data) === null || _e$slideHoverImage$da === void 0 ? void 0 : (_e$slideHoverImage$da2 = _e$slideHoverImage$da.attributes) === null || _e$slideHoverImage$da2 === void 0 ? void 0 : _e$slideHoverImage$da2.url) || "",
          title: e.slideHoverText || "",
          button: {
            cta_text: e.slideCTAText || ""
          },
          slideCTA: (e === null || e === void 0 ? void 0 : e.slideCTA) || ""
        }
      }
    };
  }
  const i = [];
  for (const t in e.data) if (e.data.hasOwnProperty(t)) {
    const r = o(e.data[t]);
    i.push(r);
  }
  const [l, s] = r(!1),
    [c, u] = t.useState(null),
    h = n(null),
    m = n(null),
    [p, f] = t.useState(0),
    d = i.reduce((e, r, n) => (e[n] = t.createRef(), e), {}),
    v = Tfe.reduce((e, r, n) => (e[n] = t.createRef(), e), {}),
    g = a.length,
    b = " text-2xl z-50 bg-black h-10 w-10 rounded-full bg-neutral-0 shadow-md hover:bg-neutral-100 hover:shadow-lg bg-blue-600 z-500 flex items-center justify-center",
    w = () => {
      u(e => !e);
    },
    y = (e, t) => "isLeft" === t ? 0 === e : "isRight" === t ? 2 === e : void 0,
    x = () => t.createElement("button", {
      type: "button",
      onClick: () => {
        w(), (() => {
          if (p > 0) f(p - 1), h.current.scrollTo({
            left: h.current.scrollLeft - 1 * h.current.children[0].offsetWidth,
            behavior: "smooth"
          }), m.current.scrollTo({
            left: m.current.scrollLeft - 1.5 * m.current.children[0].offsetWidth,
            behavior: "smooth"
          }), s(!1);else {
            const e = g - 1,
              t = h.current.scrollWidth - 1 * h.current.children[0].offsetWidth;
            f(e), h.current.scrollTo({
              left: t,
              behavior: "smooth"
            });
            const r = m.current.scrollWidth - 1.5 * m.current.children[0].offsetWidth;
            f(e), m.current.scrollTo({
              left: r,
              behavior: "smooth"
            }), s(!1);
          }
        })();
      },
      className: "flex bg-blue-600 ".concat(b, " disabled:bg-neutral-200 "),
      disabled: y(p, "isLeft")
    }, t.createElement("span", {
      role: "img",
      "aria-label": "Arrow left "
    }, t.createElement(mz, {
      height: "h-6 w-6",
      variant: "chevronleft",
      strokeColor: "#00288E"
    }))),
    O = () => t.createElement("button", {
      type: "button",
      onClick: () => {
        w(), p < g - 1 ? (f(p + 1), h.current.scrollTo({
          left: h.current.scrollLeft + 1 * h.current.children[0].offsetWidth,
          behavior: "smooth"
        }), m.current.scrollTo({
          left: m.current.scrollLeft + 1.5 * m.current.children[0].offsetWidth,
          behavior: "smooth"
        })) : (f(0), h.current.scrollTo({
          left: 0,
          behavior: "smooth"
        }), m.current.scrollTo({
          left: 0,
          behavior: "smooth"
        }), s(!0));
      },
      className: "flex bg-blue-600 ".concat(b, " disabled:bg-neutral-200 "),
      disabled: y(p, "isRight")
    }, t.createElement("span", {
      role: "img",
      "aria-label": "Arrow right "
    }, t.createElement(mz, {
      height: "h-6 w-6",
      variant: "chevronright",
      strokeColor: "#00288E"
    }))),
    [E, j] = r(!1);
  return t.createElement("div", {
    className: "min-[699px]:relative block"
  }, t.createElement("div", {
    className: "mx-auto w-screen"
  }, t.createElement("div", {
    className: "min-[699px]:relative flex flex-col items-center right-[75ppx] top-[112px]"
  }, t.createElement("div", {
    className: "absolute"
  })), t.createElement("div", {
    className: " min-[699px]:relative top-5 rounded-lg"
  }, t.createElement("div", {
    className: " min-[699px]:absolute"
  }, t.createElement("div", {
    className: " flex flex-col-reverse tb:flex-col-reverse tb:flex items-center"
  }, t.createElement("div", {
    className: "hidden min-[699px]:flex z-10 min-[699px]:mt-[70px] justify-center items-center"
  }, t.createElement("div", {
    className: "flex w-screen gap-6 justify-center "
  }, t.createElement("div", {
    className: "btnDBleft"
  }, x()), t.createElement("div", {
    className: "btnDBright"
  }, O()))), t.createElement("div", {
    className: "max-[369px]:mt-8  min-[400px]:-mt-[10rem] min-[699px]:hidden"
  }, t.createElement("div", {
    className: "flex w-screen gap-6 justify-center "
  }, x(), O())), t.createElement("div", {
    className: "justify-center  select-none items-center"
  }, t.createElement("div", {
    className: "w-screen flex justify-center items-center "
  }, t.createElement("div", {
    className: " z-30"
  }, t.createElement("div", {
    className: "snap-x max-[699px]:w-screen  bg-neutral-00 tb:w-[580px] items-center z-20 inline-flex select-none overflow-x-hidden scrollbar-hide",
    ref: h
  }, i.map((e, r) => t.createElement("div", {
    className: " db:snap-center  snap-center  mx-6 ",
    key: r,
    ref: d[r]
  }, t.createElement("div", {
    className: "select-none rounded-3xl object-contain "
  }, t.createElement(Ite, e)))))), t.createElement("div", {
    className: "hidden snap-x tb-l:max-w-[1240px] min-[1300px]:max-w-7xl\n                                        gap-[167px]\n                                        items-center min-[1300px]:flex  select-none overflow-x-hidden scrollbar-hide  absolute z-0",
    ref: m
  }, a.map((e, r) => t.createElement(t.Fragment, null, t.createElement("div", {
    className: " transition-all duration-[1500ms] z-[1] snap-center tb-m:snap-start mx-3",
    key: r + "x",
    ref: v[r]
  }, t.createElement("div", {
    className: "select-none rounded-3xl object-contain"
  }, t.createElement("div", null, 0 == r && Hfe(a[r + 1]), 1 == r && Hfe(a[1])))), t.createElement("div", {
    className: (E ? " " : "") + " transition-all duration-[1500ms]   z-[1] snap-center tb-m:snap-start mx-3 ",
    key: r + "y",
    ref: v[r]
  }, t.createElement("div", {
    className: "select-none rounded-3xl object-contain"
  }, Hfe(a[2]))), t.createElement("div", {
    className: " transition-all duration-[1500ms] z-[1] snap-center tb-m:snap-start mx-3 ",
    key: r + "z",
    ref: v[r]
  }, t.createElement("div", {
    className: "select-none rounded-3xl object-contain"
  }, Hfe(a[0]))))))))))), t.createElement("div", {
    className: " hidden min-[699px]:flex tb:flex-col items-center"
  }, t.createElement("div", {
    className: "relative -right-[44px]"
  }, t.createElement("img", {
    alt: "tab",
    src: "https://res.cloudinary.com/dh8fp23nd/image/upload/v1687108911/hasura-design-system/Group_2608834_rxnldq.png",
    className: "w-[709px]"
  })))));
}
function Ife(e) {
  const a = n(null),
    [o, i] = t.useState(0),
    [l, s] = t.useState(0),
    [c, u] = t.useState(0),
    [h, m] = r(!1),
    p = e.cards.reduce((e, r, n) => (e[n] = t.createRef(), e), {}),
    f = e.cards.length,
    d = () => {
      o < f - 1 ? (i(o + 1), a.current.scrollTo({
        left: a.current.scrollLeft + 1 * a.current.children[0].offsetWidth,
        behavior: "smooth"
      })) : (i(0), a.current.scrollTo({
        left: 0,
        behavior: "smooth"
      }));
    },
    v = () => {
      if (o > 0) i(o - 1), a.current.scrollTo({
        left: a.current.scrollLeft - 1 * a.current.children[0].offsetWidth,
        behavior: "smooth"
      });else {
        const e = f - 1,
          t = a.current.scrollWidth - 1 * a.current.children[0].offsetWidth;
        i(e), a.current.scrollTo({
          left: t,
          behavior: "smooth"
        });
      }
    },
    g = " text-2xl z-10 bg-black h-10 w-10 ml-6 w-10 rounded-full bg-neutral-0 hover:bg-neutral-0 flex items-center justify-center shadow",
    b = (e, t) => "isLeft" === t ? 0 === e : "isRight" === t ? 2 === e : void 0;
  return t.createElement("div", {
    className: ""
  }, t.createElement("div", {
    className: "flex flex-row overflow-scroll scrollbar-hide gap-4 tb:hidden"
  }, h ? e.cards.map((r, n) => t.createElement("div", {
    className: "my-5",
    key: n,
    ref: p[n]
  }, t.createElement("div", {
    className: "rounded-3xl shadow min-w-[312px] overflow-hidden"
  }, t.createElement(e.component, r)))) : e.cards.slice(0, 6).map((r, n) => t.createElement("div", {
    className: "my-5",
    key: n,
    ref: p[n]
  }, t.createElement("div", {
    className: "rounded-3xl shadow overflow-hidden"
  }, t.createElement(e.component, r)))), e.cards.length > 6 && t.createElement("div", {
    className: "flex"
  }, t.createElement(A8, {
    label: h ? "View less" : "View more",
    type: "secondary",
    leftIconVariant: "none",
    rightIconVariant: "none",
    state: "default",
    size: "sm",
    rightAnimatedArrow: !0,
    rightAnimatedArrowColor: "#1E56E3",
    animatedHoverStroke: "group-hover:stroke-neutral-0",
    className: "flex",
    btnTextColorClass: "text-blue-600",
    btnBgColorClass: "",
    onClick: () => m(!h)
  }))), t.createElement("div", {
    className: "hidden tb:flex tb:flex-col-reverse"
  }, t.createElement("div", {
    className: "flex items-center justify-center mt-10"
  }, t.createElement("div", {
    className: "flex"
  }, t.createElement("button", {
    type: "button",
    onClick: () => {
      v();
    },
    className: "flex bg-blue-600 ".concat(g, " disabled:bg-neutral-200 "),
    disabled: b(o, "isLeft")
  }, t.createElement("span", {
    role: "img",
    "aria-label": "Arrow left "
  }, t.createElement(mz, {
    height: "h-6 w-6",
    variant: "chevronleft",
    strokeColor: "#6C737F"
  }))), t.createElement("button", {
    type: "button",
    onClick: () => {
      d();
    },
    className: "flex bg-blue-600 ".concat(g, " disabled:bg-neutral-200 "),
    disabled: b(o, "isRight")
  }, t.createElement("span", {
    role: "img",
    "aria-label": "Arrow right "
  }, t.createElement(mz, {
    height: "h-6 w-6 stroke-[1.5]",
    variant: "chevronright",
    strokeColor: "#6C737F"
  }))))), t.createElement("div", {
    className: "justify-center select-none  items-center",
    onTouchStart: e => {
      s(e.targetTouches[0].clientX);
    },
    onTouchMove: e => {
      u(e.targetTouches[0].clientX);
    },
    onTouchEnd: () => {
      l - c > 150 && d(), l - c < -150 && v();
    },
    onMouseDown: e => s(e.clientX),
    onMouseUp: e => {
      l - e.clientX > 50 && d(), l - e.clientX < -50 && v();
    }
  }, t.createElement("div", {
    className: ""
  }, t.createElement("div", {
    className: "snap-x w-full inline-flex select-none overflow-x-hidden scrollbar-hide",
    ref: a
  }, e.cards.map((r, n) => t.createElement("div", {
    className: " snap-center mx-5 shrink-0 py-1",
    key: n,
    ref: p[n]
  }, t.createElement("div", {
    className: "w-full select-none rounded-3xl object-contain"
  }, t.createElement(e.component, r)))))))));
}
function Ffe(_ref151) {
  let {
    components: e,
    variants: n
  } = _ref151;
  const [o, i] = r(!0),
    [l, s] = r(0),
    [c, u] = r(e.length - 1),
    [h, m] = r(1),
    [p, f] = r(0),
    [d, v] = r(!0),
    g = () => {
      d && b();
    };
  a(() => {
    const e = setInterval(g, 3e3);
    return () => clearInterval(e);
  }, [l, d]);
  const b = () => {
      c === e.length - 1 ? u(0) : u(c + 1), l === e.length - 1 ? s(0) : s(l + 1), h === e.length - 1 ? m(0) : m(h + 1), i(!0), f(t => t === e.length - 1 ? 0 : t + 1), i(!0);
    },
    w = () => {
      i(!1), u(0 === c ? e.length - 1 : c - 1), s(0 === l ? e.length - 1 : l - 1), m(0 === h ? e.length - 1 : h - 1), f(t => 0 === t ? e.length - 1 : t - 1), i(!1);
    },
    y = () => {
      v(!1);
    },
    x = () => {
      v(!0);
    };
  return e ? t.createElement("div", {
    className: "h-full",
    onMouseEnter: y,
    onMouseLeave: x
  }, t.createElement("div", {
    className: "hidden tb-l:grid relative h-full"
  }, t.createElement(oce.div, {
    className: "flex justify-center "
  }, t.createElement(mce, {
    initial: !1
  }, t.createElement(oce.div, {
    key: c,
    variants: n,
    initial: o ? "center" : "leftHidden",
    animate: "left",
    exit: "leftHidden",
    className: "carousel-item"
  }, e[c]), t.createElement(oce.div, {
    variants: n,
    key: l,
    initial: o ? "right" : "left",
    animate: "center",
    className: "carousel-item"
  }, e[l]), t.createElement(oce.div, {
    key: h,
    variants: n,
    initial: o ? "rightHidden" : "center",
    animate: "right",
    exit: "rightHidden",
    className: "carousel-item"
  }, e[h])))), t.createElement("div", {
    className: "hidden tb-l:flex mt-10 "
  }, t.createElement("div", {
    className: "gap-4 w-full h-full flex justify-center"
  }, t.createElement(oce.button, {
    initial: {
      opacity: 0,
      scale: 0
    },
    animate: {
      opacity: 1,
      scale: 1
    },
    transition: {
      type: "spring",
      duration: .5
    },
    whileHover: {
      scale: 1.1
    },
    whileTap: {
      scale: .8
    },
    className: " w-12 h-12 bg-neutral-0 shadow hover:bg-neutral-100 rounded-full flex justify-center items-center active:bg-neutral-200 ",
    onClick: w
  }, t.createElement(mz, {
    height: "h-6 w-6",
    variant: "chevronleft",
    strokeClass: "stroke-neutral-800"
  })), t.createElement(oce.button, {
    initial: {
      opacity: 0,
      scale: 0
    },
    animate: {
      opacity: 1,
      scale: 1
    },
    transition: {
      type: "spring",
      duration: .5
    },
    whileHover: {
      scale: 1.1
    },
    whileTap: {
      scale: .8
    },
    className: "w-12 h-12 bg-neutral-0 shadow hover:bg-neutral-100 rounded-full flex justify-center items-center active:bg-neutral-200",
    onClick: b
  }, t.createElement(mz, {
    height: "h-6 w-6",
    variant: "chevronright",
    strokeClass: "stroke-neutral-800"
  })))), t.createElement("div", {
    className: "tb-l:hidden flex overflow-x-scroll pb-10 pt-4 tb:pb-16 tb:pt-10 px-4 gap-2 mb-m:gap-4 tb-m:gap-4"
  }, e.map((e, r) => t.createElement(t.Fragment, {
    key: r
  }, t.createElement("div", {
    className: "tb-l:min-w-[700px] tb:min-w-[500px] mb-s:min-w-[350px] min-w-[300px]"
  }, e))))) : t.createElement(t.Fragment, null);
}
function _fe(_ref152) {
  let {
    components: e,
    variants: n
  } = _ref152;
  const [o, i] = r(!0),
    [l, s] = r(0),
    [c, u] = r(e.length - 1),
    [h, m] = r(1),
    [p, f] = r(0),
    [d, v] = r(!0),
    g = () => {
      d && b();
    };
  a(() => {
    const e = setInterval(g, 3e3);
    return () => clearInterval(e);
  }, [l, d]);
  const b = () => {
      i(!0), c === e.length - 1 ? u(0) : u(c + 1), l === e.length - 1 ? s(0) : s(l + 1), h === e.length - 1 ? m(0) : m(h + 1), f(t => t === e.length - 1 ? 0 : t + 1);
    },
    w = () => {
      i(!1), u(0 === c ? e.length - 1 : c - 1), s(0 === l ? e.length - 1 : l - 1), m(0 === h ? e.length - 1 : h - 1), f(t => 0 === t ? e.length - 1 : t - 1);
    },
    y = () => {
      v(!1);
    },
    x = () => {
      v(!1);
    };
  return e ? t.createElement("div", {
    className: "h-full",
    onMouseEnter: y,
    onMouseLeave: x
  }, t.createElement("div", {
    className: "hidden tb-l:grid relative h-full"
  }, t.createElement(oce.div, {
    className: "flex justify-center "
  }, t.createElement(mce, {
    initial: !1
  }, t.createElement(oce.div, {
    key: c,
    variants: n,
    animate: o ? "rightHidden" : "left",
    exit: "leftHidden",
    className: "carousel-item"
  }, e[c]), t.createElement(oce.div, {
    variants: n,
    key: l,
    animate: "center",
    className: "carousel-item"
  }, e[l]), t.createElement(oce.div, {
    key: h,
    variants: n,
    animate: o ? "leftHidden" : "right",
    exit: "rightHidden",
    className: "carousel-item"
  }, e[h])))), t.createElement("div", {
    className: "hidden tb-l:flex mt-10 "
  }, t.createElement("div", {
    className: "gap-4 w-full h-full flex justify-center"
  }, t.createElement(oce.button, {
    initial: {
      opacity: 0,
      scale: 0
    },
    animate: {
      opacity: 1,
      scale: 1
    },
    transition: {
      type: "spring",
      duration: .5
    },
    whileHover: {
      scale: 1.1
    },
    whileTap: {
      scale: .8
    },
    className: " w-12 h-12 bg-neutral-0 shadow hover:bg-neutral-100 rounded-full flex justify-center items-center active:bg-neutral-200 ",
    onClick: w
  }, t.createElement(mz, {
    height: "h-6 w-6",
    variant: "chevronleft",
    strokeClass: "stroke-neutral-800"
  })), t.createElement(oce.button, {
    initial: {
      opacity: 0,
      scale: 0
    },
    animate: {
      opacity: 1,
      scale: 1
    },
    transition: {
      type: "spring",
      duration: .5
    },
    whileHover: {
      scale: 1.1
    },
    whileTap: {
      scale: .8
    },
    className: "w-12 h-12 bg-neutral-0 shadow hover:bg-neutral-100 rounded-full flex justify-center items-center active:bg-neutral-200",
    onClick: b
  }, t.createElement(mz, {
    height: "h-6 w-6",
    variant: "chevronright",
    strokeClass: "stroke-neutral-800"
  })))), t.createElement("div", {
    className: "tb-l:hidden flex overflow-x-scroll pb-10 pt-4 tb:pb-16 tb:pt-10 px-4 gap-2 mb-m:gap-4 tb-m:gap-4"
  }, e.map((e, r) => t.createElement(t.Fragment, {
    key: r
  }, t.createElement("div", {
    className: "tb-l:min-w-[700px] tb:min-w-[500px] mb-s:min-w-[350px] min-w-[300px]"
  }, e))))) : t.createElement(t.Fragment, null);
}
const Zfe = () => t.createElement("svg", {
    width: "26",
    height: "32",
    viewBox: "0 0 26 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, t.createElement("path", {
    d: "M7.31687 9.12914C7.31687 10.1979 6.47716 11.0376 5.40844 11.0376C4.33971 11.0376 3.5 10.1979 3.5 9.12914C3.5 8.06042 4.33971 7.2207 5.40844 7.2207C6.47716 7.2207 7.31687 8.06042 7.31687 9.12914ZM7.31687 12.5643H3.5V24.7783H7.31687V12.5643ZM13.4239 12.5643H9.607V24.7783H13.4239V18.366C13.4239 14.7781 18.0041 14.4728 18.0041 18.366V24.7783H21.821V17.0682C21.821 11.0376 15.027 11.2666 13.4239 14.2438V12.5643Z"
  })),
  Dfe = () => t.createElement("svg", {
    width: "26",
    height: "32",
    viewBox: "0 0 26 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, t.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M21.087 8.93655L21.087 8.93659L21.1002 8.93761C21.9378 9.00203 22.3817 9.16101 22.6263 9.30672C22.827 9.42628 23.0039 9.59975 23.1728 9.98218C23.3636 10.4144 23.5265 11.0801 23.6296 12.1242C23.7315 13.1571 23.7646 14.4356 23.7646 16.0392C23.7646 17.6426 23.7315 18.9284 23.6294 19.9704C23.5261 21.0243 23.3626 21.7015 23.17 22.1417C22.9987 22.5332 22.8229 22.7001 22.6368 22.8096C22.4079 22.9441 21.9795 23.0951 21.1534 23.1375L21.1534 23.1374L21.1445 23.1379C17.4729 23.3419 9.22945 23.3423 5.5387 23.1392C4.71481 23.0738 4.27627 22.9162 4.03377 22.7718C3.8331 22.6522 3.65613 22.4787 3.4873 22.0963C3.29651 21.6641 3.13358 20.9984 3.03051 19.9542C2.92855 18.9213 2.8955 17.6429 2.8955 16.0392C2.8955 14.4356 2.92855 13.1571 3.03051 12.1242C3.13358 11.0801 3.29651 10.4144 3.4873 9.98219C3.65613 9.59975 3.8331 9.42628 4.03377 9.30672C4.27834 9.16101 4.7223 9.00203 5.55985 8.93761L5.55985 8.93765L5.5731 8.93655C9.21419 8.63312 17.4459 8.63312 21.087 8.93655ZM0.808594 16.0392C0.808594 22.5087 1.33032 24.9086 5.39979 25.2216C9.15622 25.4303 17.5039 25.4303 21.2603 25.2216C25.3298 25.0129 25.8515 22.5087 25.8515 16.0392C25.8515 9.56983 25.3298 7.16988 21.2603 6.85685C17.5039 6.54381 9.15622 6.54381 5.39979 6.85685C1.33032 7.16988 0.808594 9.56983 0.808594 16.0392ZM11.71 19.4583C11.0162 19.8052 10.1999 19.3006 10.1999 18.525V13.554C10.1999 12.7783 11.0162 12.2738 11.71 12.6207L16.6809 15.1062C17.45 15.4907 17.45 16.5882 16.6809 16.9728L11.71 19.4583Z"
  })),
  qfe = () => t.createElement("svg", {
    width: "26",
    height: "32",
    viewBox: "0 0 26 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, t.createElement("path", {
    d: "M10.755 13.0059H8.50977V15.9995H10.755V24.9805H14.4971V15.9995H17.1914L17.4907 13.0059H14.4971V11.7336C14.4971 11.06 14.6468 10.7606 15.3203 10.7606H17.4907V7.01855H14.6468C11.9525 7.01855 10.755 8.21602 10.755 10.4613V13.0059Z"
  })),
  Ufe = () => t.createElement("svg", {
    className: "w-[21px] h-5",
    width: "1200",
    height: "1227",
    viewBox: "0 0 1200 1227",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, t.createElement("path", {
    d: "M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z",
    fill: "white"
  })),
  $fe = () => t.createElement("svg", {
    width: "26",
    height: "32",
    viewBox: "0 0 26 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, t.createElement("path", {
    d: "M13.3394 7.2359C16.2009 7.2359 16.5586 7.2359 17.7212 7.32532C20.6722 7.41475 22.0135 8.84554 22.103 11.7071C22.1924 12.8696 22.1924 13.1379 22.1924 15.9995C22.1924 18.8611 22.1924 19.2188 22.103 20.2919C22.0135 23.1535 20.5828 24.5843 17.7212 24.6737C16.5586 24.7631 16.2904 24.7631 13.3394 24.7631C10.4778 24.7631 10.1201 24.7631 9.04697 24.6737C6.09596 24.5843 4.75459 23.1535 4.66517 20.2919C4.57574 19.1294 4.57574 18.8611 4.57574 15.9995C4.57574 13.1379 4.57574 12.7802 4.66517 11.7071C4.75459 8.84554 6.18538 7.41475 9.04697 7.32532C10.1201 7.2359 10.4778 7.2359 13.3394 7.2359ZM13.3394 5.26855C10.3883 5.26855 10.0306 5.26855 8.95755 5.35798C5.02286 5.53683 2.87667 7.68302 2.69782 11.6177C2.6084 12.6908 2.6084 13.0485 2.6084 15.9995C2.6084 18.9505 2.6084 19.3082 2.69782 20.3813C2.87667 24.316 5.02286 26.4622 8.95755 26.641C10.0306 26.7305 10.3883 26.7305 13.3394 26.7305C16.2904 26.7305 16.6481 26.7305 17.7212 26.641C21.6558 26.4622 23.802 24.316 23.9809 20.3813C24.0703 19.3082 24.0703 18.9505 24.0703 15.9995C24.0703 13.0485 24.0703 12.6908 23.9809 11.6177C23.802 7.68302 21.6558 5.53683 17.7212 5.35798C16.6481 5.26855 16.2904 5.26855 13.3394 5.26855ZM13.3394 10.4552C10.2989 10.4552 7.79503 12.9591 7.79503 15.9995C7.79503 19.0399 10.2989 21.5438 13.3394 21.5438C16.3798 21.5438 18.8837 19.0399 18.8837 15.9995C18.8837 12.9591 16.3798 10.4552 13.3394 10.4552ZM13.3394 19.5765C11.372 19.5765 9.76237 17.9669 9.76237 15.9995C9.76237 14.0322 11.372 12.4225 13.3394 12.4225C15.3067 12.4225 16.9163 14.0322 16.9163 15.9995C16.9163 17.9669 15.3067 19.5765 13.3394 19.5765ZM19.0625 9.02439C18.3471 9.02439 17.8106 9.56094 17.8106 10.2763C17.8106 10.9917 18.3471 11.5283 19.0625 11.5283C19.7779 11.5283 20.3145 10.9917 20.3145 10.2763C20.3145 9.56094 19.7779 9.02439 19.0625 9.02439Z"
  })),
  zfe = [{
    icon: t.createElement(Zfe, null),
    linkUrl: "https://www.linkedin.com/company/hasura/"
  }, {
    icon: t.createElement(Dfe, null),
    linkUrl: "https://www.youtube.com/channel/UCZo1ciR8pZvdD3Wxp9aSNhQ"
  }, {
    icon: t.createElement(qfe, null),
    linkUrl: "https://www.facebook.com/HasuraHQ"
  }, {
    icon: t.createElement(Ufe, null),
    linkUrl: "https://twitter.com/hasurahq",
    className: "py-1"
  }, {
    icon: t.createElement($fe, null),
    linkUrl: "https://www.instagram.com/hasurahq/?hl=en"
  }];
function Wfe(e) {
  const [n, o] = r(!1),
    [i, l] = r(null);
  a(() => {
    fetch("https://status.hasura.io/api/v2/status.json").then(e => e.json()).then(e => {
      l(e), o(!1);
    }, e => {
      o(!0);
    });
  }, []);
  const s = e === null || e === void 0 ? void 0 : e.isDarkMode,
    c = s ? "https://res.cloudinary.com/dh8fp23nd/image/upload/v1718878031/hasura_dark_mode_kjrlxi.svg" : "https://res.cloudinary.com/dh8fp23nd/image/upload/v1686659126/website%20v3/hasura-primary_y9cdnn.svg";
  return t.createElement("div", null, t.createElement("div", {
    className: "db-s:flex justify-between gap-10 db-s:gap-20 db:gap-40"
  }, t.createElement("div", {
    className: "pb-10 db-s:pb-0 px-4 tb:px-0"
  }, t.createElement("a", {
    href: e.brandLink,
    className: ""
  }, t.createElement("img", {
    className: "max-w-[125px]",
    src: c,
    loading: "lazy",
    alt: e.brandAlt
  }))), t.createElement("div", {
    className: "flex justify-between px-4 tb:px-0 tb:justify-start tb-l:justify-between flex-1 flex-wrap gap-y-10 tb:gap-y-16 lg:max-w-[712px] 2xl:max-w-[756px]"
  }, e.footerLinks.map((e, r) => t.createElement("div", {
    key: r,
    className: "min-w-[130px] db-s:min-w-fit"
  }, t.createElement(ce, {
    textStyle: "body3c-semi-bold",
    className: s ? "text-neutral-400" : "text-neutral-600"
  }, e.title), e.links.map((e, r) => t.createElement("a", {
    href: e.linkUrl,
    key: r
  }, t.createElement(ce, {
    textStyle: "body3",
    className: s ? "text-neutral-400 mt-2 tb:mt-4 hover:text-neutral-0" : "text-neutral-600 mt-2 tb:mt-4 hover:text-neutral-1000"
  }, e.linkText))))))), t.createElement("div", {
    className: "flex flex-col tb-m:flex-row items-center justify-between tb:pt-24"
  }, t.createElement("div", {
    className: "flex items-center justify-center pt-10 tb-m:pt-0 pb-4 tb-m:pb-0 tb-m:justify-start"
  }, zfe.map((e, r) => t.createElement("a", {
    key: r,
    href: e.linkUrl,
    className: "mx-2 tb-l:mx-4 first:ml-0 last:mr-0 [&>svg>path]:fill-neutral-400 [&>svg>path]:hover:fill-neutral-600 " + (e.className ? e.className : "")
  }, e.icon))), t.createElement("div", {
    className: "flex flex-col md:flex-row justify-between items-center w-full lg:max-w-[716px] 2xl:max-w-[756px]"
  }, i && !n && t.createElement(t.Fragment, null, t.createElement("a", {
    href: "https://status.hasura.io/",
    className: ""
  }, t.createElement("div", {
    className: " bg-neutral-0 rounded-full shadow hover:shadow-lg transition-all duration-300 px-4 py-2 inline-flex justify-center items-center md:ml-16 lg:ml-0"
  }, t.createElement("div", {
    className: "w-4 h-4 bg-green-400 rounded-full mr-2"
  }), t.createElement(ce, {
    textStyle: "body3",
    className: "text-neutral-1000"
  }, i === null || i === void 0 ? void 0 : i.status.description)))), t.createElement("div", null, t.createElement(ce, {
    textStyle: "body3c",
    className: s ? "text-neutral-400 pt-4 tb-m:pt-0" : "text-neutral-600 pt-4 tb-m:pt-0"
  }, "© ", new Date().getFullYear(), " Hasura Inc. All rights reserved")))));
}
function Qfe(e) {
  var _e$feature_cards_link;
  A(e.title_color);
  const n = A(e.sub_text_color),
    o = e.feature_cards_links && (_e$feature_cards_link = e.feature_cards_links[0]) !== null && _e$feature_cards_link !== void 0 && _e$feature_cards_link.title ? e.feature_cards_links[0].title : null,
    [i, s] = r();
  return a(() => {
    o && s(o);
  }, [o]), t.createElement(t.Fragment, null, e.feature_cards_links && t.createElement(t.Fragment, null, e.tagLine && t.createElement(ce, {
    textStyle: "h6",
    as: "h6",
    className: "text-blue-800 uppercase pb-1 tb-l:w-1/2"
  }, e.tagLine), t.createElement(ce, {
    textStyle: "h4",
    as: "h4",
    className: "text-neutral-1000 pb-8 tb-l:w-1/2"
  }, e.title)), t.createElement("div", {
    className: "grid grid-cols-1 tb-l:grid-cols-2 gap-10 tb:gap-8" + (e.feature_cards_links ? " tb:gap-16" : " tb-l:gap-20")
  }, t.createElement("div", null, t.createElement("div", null, !e.feature_cards_links && t.createElement(t.Fragment, null, e.tagLine && t.createElement(ce, {
    textStyle: "h6",
    as: "h6",
    className: "text-blue-800 uppercase pb-1 tb-l:w-1/2"
  }, e.tagLine), t.createElement(ce, {
    textStyle: "h4",
    as: "h4",
    className: "text-neutral-1000 pb-6 max-w-[330px]"
  }, e.title)), !e.feature_cards_links && e.sub_title && t.createElement(ce, {
    textStyle: "sub1",
    className: "".concat(n, " pb-2 -mt-4")
  }, e.sub_title), !e.content_right && t.createElement(t.Fragment, null, e.descriptions && e.descriptions.map((e, r) => t.createElement(ce, {
    key: r,
    textStyle: "body1",
    className: "pb-6 pr-8 max-w-[412px] [&>p]:pb-2 [&>p]:text-neutral-600 last:[&>p]:pb-0 [&>ul]:ps-4 [&>ul>li]:list-disc [&>ul>li]:pb-2 last:[&>ul>li]:pb-0 [&>p>a]:text-blue-600 [&>ul>li]:text-neutral-600"
  }, t.createElement(bte, null, e.description))), e.descriptions_list && t.createElement("div", {
    className: "pb-6"
  }, e.descriptions_list && e.descriptions_list.map((e, r) => {
    const n = A(e.icon_bg_color),
      a = A(e.icon_color);
    return t.createElement("div", {
      className: "flex items-start pb-4 last:pb-0",
      key: r
    }, t.createElement("div", {
      className: "".concat(n, " w-6 h-6 min-w-[24px] min-h-[24px] rounded-full mr-2 flex items-center justify-center")
    }, t.createElement(mz, {
      height: "h-3 w-3 stroke-[1.5px]",
      variant: e.icon_name,
      strokeClass: a,
      strokeColor: ""
    })), t.createElement(ce, {
      textStyle: "body1",
      className: "text-neutral-600"
    }, e.description));
  })), e.addiDescription && t.createElement(ce, {
    textStyle: "body1",
    className: "text-neutral-600 max-w-[412px]"
  }, e.addiDescription)), e.feature_cards_links && t.createElement("div", {
    className: "tb:border border-neutral-150 rounded-3xl max-w-[460px]"
  }, e.feature_cards_links.map((e, r) => {
    const n = A(e.icon_color),
      a = A(e.tab_img_bg_class);
    return t.createElement("div", {
      key: r,
      className: "border-b border-b-neutral-150 last:border-b-0 cursor-pointer",
      onClick: () => s(e.title)
    }, t.createElement("div", {
      className: "my-4 tb-l:m-2 p-4 tb:p-6 rounded-2xl transition ease-in duration-200 hover:bg-neutral-50" + (i === e.title ? " bg-neutral-150" : ""),
      key: r
    }, t.createElement("div", {
      className: "flex items-center pb-4"
    }, t.createElement(mz, {
      height: "w-6 h-6 mr-2 stroke-[1.5px]",
      variant: e.icon_name,
      strokeClass: n,
      strokeColor: ""
    }), t.createElement(ce, {
      textStyle: "h5",
      as: "h5",
      className: "text-neutral-1000"
    }, e.title)), e.description && t.createElement(ce, {
      textStyle: "body3",
      className: "pb-4 text-neutral-600"
    }, e.description), e.descriptions_list && e.descriptions_list.map((e, r) => {
      const n = A(e.icon_bg_color),
        a = A(e.icon_color);
      return t.createElement("div", {
        className: "flex items-start pb-4 last:pb-0",
        key: r
      }, t.createElement("div", {
        className: "".concat(n, " w-5 h-5 min-w-[20px] min-h-[20px] rounded-full mr-2 flex items-center justify-center")
      }, t.createElement(mz, {
        height: "h-3 w-3 stroke-[1.5px]",
        variant: e.icon_name,
        strokeClass: a,
        strokeColor: ""
      })), t.createElement(ce, {
        textStyle: "body3",
        className: "text-neutral-600"
      }, e.description));
    }), e.cta_text && e.cta_link && t.createElement("a", {
      href: e.cta_link,
      className: "inline-flex"
    }, t.createElement(A8, {
      label: e.cta_text,
      type: "secondaryLink",
      leftIconVariant: "none",
      rightIconVariant: "none",
      state: "default",
      size: "md",
      rightAnimatedArrow: !0,
      rightAnimatedArrowColor: "#3970FD",
      btnTextColorClass: "text-blue-500",
      btnTextHoverClass: "text-blue-600",
      animatedHoverStroke: "group-hover:stroke-blue-600"
    })), e.tab_img_url && t.createElement("div", {
      className: "".concat(a, " tb-l:hidden p-4 tb-l:p-12 rounded-2xl mt-8")
    }, t.createElement("img", {
      src: e.tab_img_url,
      alt: e.title,
      loading: "lazy"
    }))));
  })), e.button && t.createElement("div", {
    className: "flex gap-6 items-center"
  }, e.button.map((e, r) => t.createElement("a", {
    href: e.cta_link,
    key: r,
    className: "flex "
  }, t.createElement(A8, {
    label: e.cta_text,
    type: e.cta_type || "secondary",
    leftIconVariant: "none",
    rightIconVariant: "none",
    state: "default",
    size: "md",
    rightAnimatedArrow: !0,
    rightAnimatedArrowColor: e.rightAnimatedArrowColor || "#3970FD",
    btnBgColorClass: e.btnBg,
    btnTextHoverClass: e.btnTextColorClass,
    animatedHoverStroke: e.animatedHoverStroke,
    btnTextColorClass: e.btnTextColorClass
  })))))), t.createElement(t.Fragment, null, e.content_right ? t.createElement("div", null, e.descriptions && e.descriptions.map((e, r) => t.createElement(ce, {
    key: r,
    textStyle: "body1",
    className: "pb-6 pr-8 max-w-[412px] [&>p]:pb-2 last:[&>p]:pb-0 [&>p]:text-neutral-600 [&>ul]:ps-4 [&>ul>li]:list-disc [&>ul>li]:pb-2 last:[&>ul>li]:pb-0 [&>p>a]:text-blue-600 [&>ul>li]:text-neutral-600"
  }, t.createElement(bte, null, e.description))), e.descriptions_list && t.createElement("div", {
    className: "pb-6"
  }, e.descriptions_list && e.descriptions_list.map((e, r) => {
    const n = A(e.icon_bg_color),
      a = A(e.icon_color);
    return t.createElement("div", {
      className: "flex items-start pb-4 last:pb-0",
      key: r
    }, t.createElement("div", {
      className: "".concat(n, " w-6 h-6 min-w-[24px] min-h-[24px] rounded-full mr-2 flex items-center justify-center")
    }, t.createElement(mz, {
      height: "h-3 w-3 stroke-[1.5px]",
      variant: e.icon_name,
      strokeClass: a,
      strokeColor: ""
    })), t.createElement(ce, {
      textStyle: "body1",
      className: "text-neutral-600"
    }, e.description));
  })), e.addiDescription && t.createElement(ce, {
    textStyle: "body1",
    className: "text-neutral-600 max-w-[412px]"
  }, e.addiDescription)) : t.createElement(t.Fragment, null, e.feature_cards_links ? t.createElement(t.Fragment, null, e.feature_cards_links.map((e, r) => (A(e.tab_img_bg_class), t.createElement(l, {
    key: r
  }, i === e.title && t.createElement("div", {
    className: ("pattern" === e.tab_img_bg_class ? "bg-neutral-100" : "") + " hidden h-full p-4 tb-l:p-12 tb-l:flex items-center justify-center rounded-2xl db:rounded-3xl relative bg-neutral-100"
  }, "pattern" === e.tab_img_bg_class && t.createElement("div", {
    className: "pattern-gradient absolute left-0 top-0 w-full h-full rounded-3xl"
  }), e.tab_video_url ? t.createElement("video", {
    loading: "lazy",
    controls: !1,
    autoPlay: !0,
    loop: !0,
    muted: !0,
    poster: e.tab_video_poster,
    className: "z-[1]"
  }, t.createElement("source", {
    src: e.tab_video_url,
    type: "video/mp4"
  })) : t.createElement("img", {
    className: "z-[1] max-h-[530px]",
    src: e.tab_img_url,
    alt: e.title,
    loading: "lazy"
  })))))) : t.createElement(t.Fragment, null, e.iframe_url || e.video_url ? t.createElement("div", null, e.iframe_url ? t.createElement("div", {
    className: "relative pb-[56.2%]"
  }, t.createElement("iframe", {
    loading: "lazy",
    title: e.title,
    src: e.iframe_url,
    frameBorder: "0",
    allowFullScreen: !0,
    className: "absolute w-full h-full rounded-2xl db:rounded-3xl"
  })) : t.createElement("video", {
    loading: "lazy",
    controls: !1,
    autoPlay: !0,
    loop: !0,
    muted: !0,
    playsInline: !0,
    poster: e.video_poster,
    src: e.video_url,
    className: "rounded-2xl db:rounded-3xl"
  })) : t.createElement(t.Fragment, null, e.img_url && t.createElement("div", {
    className: ("pattern" === e.img_bg_class ? "px-5 py-10 db:p-8 bg-neutral-100" : "px-0 py-0") + " ".concat(A(e.img_bg_class), " relative rounded-2xl db:rounded-3xl")
  }, "pattern" === e.img_bg_class && t.createElement("div", {
    className: "pattern-gradient z-0 absolute left-0 top-0 w-full h-full rounded-3xl"
  }), t.createElement("img", {
    className: ("pattern" === e.img_bg_class ? "" : "rounded-2xl db:rounded-3xl") + " z-[1] relative inline-block",
    src: e.img_url,
    alt: e.title,
    loading: "lazy"
  }))))))));
}
function Gfe(e) {
  return t.createElement("div", {
    className: "tb-m:flex gap-14 gap-y-14  gap-x-14 tb:gap-12 db-s:gap-20 db:gap-24"
  }, t.createElement("div", {
    className: "pb-10 tb-m:pb-0 db-s:max-w-[524px] tb-m:w-1/2 w-full flex flex-col justify-between"
  }, t.createElement("div", null, e.tagline && t.createElement(ce, {
    textStyle: "h6",
    as: "h6",
    className: "pb-2 uppercase text-blue-400"
  }, e.tagline), e.title && t.createElement(ce, {
    textStyle: "h3",
    as: "h3",
    className: "pb-2 text-neutral-1000"
  }, e.title), e.description && t.createElement(ce, {
    textStyle: "sub2",
    className: "pb-6 text-neutral-600"
  }, e.description)), t.createElement("div", null, e.imgUrl && t.createElement("div", {
    className: "pb-4 pt-2"
  }, t.createElement("img", {
    className: "max-w-[210px]",
    src: e.imgUrl,
    alt: e.title ? e.title : "Illu"
  })), e.button && t.createElement("a", {
    href: e.button.cta_link,
    className: "inline-flex "
  }, t.createElement(A8, {
    label: e.button.cta_text,
    type: e.button.cta_type || "secondary",
    leftIconVariant: "none",
    rightIconVariant: "none",
    state: "default",
    size: "md",
    rightAnimatedArrow: !0,
    rightAnimatedArrowColor: e.button.rightAnimatedArrowColor || "#3970FD",
    animatedHoverStroke: "group-hover:stroke-blue-600",
    btnTextHoverClass: "hover:text-blue-600",
    btnTextColorClass: "text-blue-500"
  })))), e.iconCards && t.createElement("div", {
    className: "flex-1 pt-10 tb-m:pt-0 border-t border-neutral-200 tb-m:border-t-0"
  }, e.iconCards.map((e, r) => t.createElement("div", {
    className: "pb-6 tb:pb-10 tb-l:pb-16 last:pb-0 tb:flex",
    key: r
  }, t.createElement("div", {
    className: "w-12 h-12 min-w-[48px] rounded-full flex justify-center items-center mr-5 " + (e.iconBgClass ? A(e.iconBgClass) : "bg-blue-300")
  }, t.createElement(mz, {
    height: "h-6 w-6 stroke-[1.5px]",
    variant: e.iconName ? e.iconName : "cube02",
    strokeClass: "stroke-neutral-1000"
  })), t.createElement("div", null, t.createElement(ce, {
    textStyle: "h4",
    as: "h4",
    className: "pb-2 pt-4 tb:pt-0 text-neutral-1000"
  }, e.title), t.createElement(ce, {
    textStyle: "body1",
    className: "text-neutral-600"
  }, e.description))))));
}
function Yfe(e) {
  var _s$readMore_cta_link;
  const [n, o] = r(!1),
    [i, l] = r("");
  a(() => {
    if (e.tabContent) {
      const t = Object.keys(e.tabContent);
      l(t[0]);
    }
  }, [e.tabContent]);
  return t.createElement("div", null, e.navTabs && t.createElement("div", {
    className: "max-w-[44.44rem] rounded-2xl"
  }, t.createElement("div", {
    className: "flex pb-8 overflow-scroll scrollbar-hide"
  }, t.createElement(bfe, {
    onTabClick: e => {
      e.name && l(e.name);
    },
    tabs: e.navTabs,
    pillColor: e.pillColor,
    bgColorTab: e.bgColorTab
  })), t.createElement("div", {
    className: ""
  }, e.tabContent && e.tabContent[i] && (s = e.tabContent[i], t.createElement(t.Fragment, null, t.createElement("div", {
    className: ""
  }, s.title && t.createElement(ce, {
    textStyle: "body1c-semi-bold",
    className: A(s.title_color)
  }, s.title), s.subTitle && t.createElement(ce, {
    textStyle: "body3",
    className: "mt-2 " + A(s.sub_title_color)
  }, s.subTitle), s.readMore_cta && t.createElement("div", {
    className: "flex"
  }, t.createElement("a", {
    href: (_s$readMore_cta_link = s.readMore_cta_link) !== null && _s$readMore_cta_link !== void 0 ? _s$readMore_cta_link : ""
  }, t.createElement(A8, {
    label: s.readMore_cta,
    type: "secondaryLink",
    leftIconVariant: "none",
    rightIconVariant: "none",
    state: "default",
    size: "sm",
    rightAnimatedArrow: !0,
    rightAnimatedArrowColor: "#3970FD",
    animatedHoverStroke: "#3970FD",
    btnTextColorClass: "text-blue-500",
    btnTextHoverClass: "",
    className: " mt-4"
  })))), s.btnLabel && t.createElement("div", {
    className: "flex pl-3 pt-6 pb-8"
  }, t.createElement(A8, {
    label: s.btnLabel,
    type: "secondaryLink",
    leftIconVariant: "none",
    rightIconVariant: "none",
    state: "default",
    size: "sm",
    rightAnimatedArrow: !0,
    rightAnimatedArrowColor: "#1E56E3",
    animatedHoverStroke: "group-hover:stroke-blue-600",
    className: "flex",
    btnTextColorClass: "text-blue-600"
  })), t.createElement("div", {
    className: "mt-8"
  }, n && s.video_url ? t.createElement("video", {
    id: "hero_vid",
    controls: !0,
    autoPlay: !0,
    muted: !0,
    playsInline: !0,
    width: "500",
    height: "500",
    className: "tb:w-full w-full rounded-3xl",
    src: s.video_url
  }) : t.createElement("div", {
    className: "relative"
  }, s.img_url && t.createElement("img", {
    src: s.img_url,
    alt: "Illustration",
    className: " rounded-2xl"
  }), s.video_url && t.createElement("div", {
    className: "w-14 h-14 cursor-pointer video-play-btn before:bg-blue-700 after:bg-blue-700 rounded-full flex items-center justify-center bg-blue-700 absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 shadow-neutral-1000 shadow-2xl",
    onClick: () => o(!0)
  }, t.createElement(mz, {
    variant: "play",
    height: "h-6 w-6 ml-1",
    strokeClass: "stroke-neutral-0"
  })))))))));
  var s;
}
function Kfe(e) {
  return t.createElement("div", {
    className: "flex tb-l:flex-row flex-col justify-between"
  }, t.createElement("div", null, t.createElement(ce, {
    textStyle: "h4",
    className: "text-neutral-1000"
  }, e.title), t.createElement(ce, {
    textStyle: "body1",
    className: "mt-4 text-neutral-700 max-w-[430px]"
  }, e.description)), t.createElement("div", {
    className: "max-w-[583px] pt-8 tb-l:pt-0"
  }, t.createElement(Yfe, {
    navTabs: e.navTabs,
    tabContent: e.tabContent,
    pillColor: e.pillColor,
    bgColorTab: e.bgColorTab
  })));
}
function Xfe(e) {
  return t.createElement(t.Fragment, null, t.createElement("div", {
    className: "flex flex-col-reverse px-6 py-10 db:px-0 db:py-0 db:flex-row db:gap-[132px]"
  }, t.createElement("div", {
    className: "flex flex-col db:pl-20 db:pt-20 db:pb-[74px]"
  }, e.tagline && t.createElement(ce, {
    textStyle: "h6",
    className: "text-blue-400 db:block uppercase mb-2 hidden "
  }, e.tagline), e.title && e.description && t.createElement("div", {
    className: "flex flex-col gap-4"
  }, t.createElement(ce, {
    textStyle: "h3",
    className: "text-neutral-1000 db:block hidden"
  }, e.title), t.createElement(ce, {
    textStyle: "sub2",
    className: "text-neutral-600 db:mt-0 mt-4 "
  }, e.description)), e.CTA && t.createElement("div", {
    className: "mt-4 tb:mt-6 flex"
  }, t.createElement("a", {
    href: e.CTA.url
  }, t.createElement(A8, {
    label: e.CTA.text,
    type: e.CTA.type || "secondary",
    size: "md",
    rightAnimatedArrowColor: "#3970FD"
  })))), e.video_url && t.createElement("div", {
    className: "flex mt-4 tb:mt-0 tb:items-end tb:max-w-[600px] db:min-w-[550px]"
  }, t.createElement("video", {
    autoPlay: !0,
    loop: !0,
    playsInline: !0,
    muted: !0,
    src: e.video_url,
    className: " rounded-xl db:rounded-none db:rounded-br-3xl db:rounded-tl-3xl"
  })), t.createElement("div", {
    className: "db:hidden pb-2"
  }, t.createElement(ce, {
    textStyle: "h3",
    className: "text-neutral-1000"
  }, e.title)), e.tagline && t.createElement(ce, {
    textStyle: "h6",
    className: "text-blue-400 db:hidden uppercase"
  }, e.tagline)));
}
function Jfe(e) {
  var _e$title2, _e$btnLabel, _e$aboutTitle, _e$version, _e$typeText, _e$releasedText, _e$lastUpdatedText, _e$deployed, _e$githubText, _e$creator;
  return t.createElement(t.Fragment, null, t.createElement("div", {
    className: "divide-y divide-neutral-200"
  }, t.createElement("div", {
    className: " pb-8"
  }, t.createElement("div", null, e.imgUrl && t.createElement("div", {
    className: "flex"
  }, t.createElement("img", {
    alt: (_e$title2 = e.title) !== null && _e$title2 !== void 0 ? _e$title2 : "connectorImage",
    src: e.imgUrl,
    className: (e === null || e === void 0 ? void 0 : e.logoClass) || "max-h-[48px] pl-1"
  })), e.tags && t.createElement("div", {
    className: "gap-2 pt-8 flex flex-wrap"
  }, e.tags.map((e, r) => t.createElement(x8, {
    key: r,
    color: e.color,
    children: e.label
  })))), t.createElement("div", null, e.title && t.createElement("div", {
    className: "pt-4 text-hds-t-h3 text-neutral-1000"
  }, e.title), e.description && t.createElement(ce, {
    textStyle: "sub2",
    className: "pt-2 text-neutral-500"
  }, e.description)), e.btnLink && t.createElement("a", {
    href: e.btnLink,
    className: "mt-4 flex"
  }, t.createElement(A8, {
    type: "secondary",
    label: (_e$btnLabel = e.btnLabel) !== null && _e$btnLabel !== void 0 ? _e$btnLabel : "Deployment guide",
    state: "default",
    size: "sm",
    rightAnimatedArrow: "true",
    rightAnimatedArrowColor: "#3970FD"
  }))), t.createElement("div", {
    className: "py-8 "
  }, t.createElement(ce, {
    textStyle: "h6",
    className: "text-neutral-500 uppercase"
  }, (_e$aboutTitle = e.aboutTitle) !== null && _e$aboutTitle !== void 0 ? _e$aboutTitle : "About"), t.createElement("div", {
    className: "pt-4 flex flex-col gap-2"
  }, e.versionValue && t.createElement("div", {
    className: "flex gap-2"
  }, t.createElement(ce, {
    textStyle: "body1-medium",
    className: "text-neutral-500"
  }, (_e$version = e.version) !== null && _e$version !== void 0 ? _e$version : "Version"), t.createElement(x8, {
    color: "blue",
    children: e.versionValue
  })), e.typeValue && t.createElement("div", {
    className: "flex gap-2 items-center"
  }, t.createElement(ce, {
    textStyle: "body1-medium",
    className: "text-neutral-500"
  }, (_e$typeText = e.typeText) !== null && _e$typeText !== void 0 ? _e$typeText : "Type"), t.createElement(mz, {
    height: "h-5 w-5 stroke-[1.5px]",
    variant: e.typeIconVariant,
    strokeClass: "stroke-neutral-800"
  }), t.createElement(ce, {
    textStyle: "body1c-medium",
    className: "text-neutral-800"
  }, e.typeValue)), e.releasedValue && t.createElement("div", {
    className: "flex gap-2"
  }, t.createElement(ce, {
    textStyle: "body1-medium",
    className: "text-neutral-500"
  }, (_e$releasedText = e.releasedText) !== null && _e$releasedText !== void 0 ? _e$releasedText : "Released"), t.createElement(ce, {
    textStyle: "body1-medium",
    className: "text-neutral-800"
  }, e.releasedValue)), e.lastUpdateValue && t.createElement("div", {
    className: "flex gap-2"
  }, t.createElement(ce, {
    textStyle: "body1-medium",
    className: "text-neutral-500"
  }, (_e$lastUpdatedText = e.lastUpdatedText) !== null && _e$lastUpdatedText !== void 0 ? _e$lastUpdatedText : "Last Updated"), t.createElement(ce, {
    textStyle: "body1-medium",
    className: "text-neutral-800"
  }, e.lastUpdateValue)), e.deployed && t.createElement("div", {
    className: "flex gap-2"
  }, t.createElement(ce, {
    textStyle: "body1-medium",
    className: "text-neutral-500"
  }, (_e$deployed = e.deployed) !== null && _e$deployed !== void 0 ? _e$deployed : "Deployed"), t.createElement(ce, {
    textStyle: "body1-medium",
    className: "text-neutral-800"
  }, e.deployedValue)), e.githubRepoLink && t.createElement("a", {
    href: e.githubRepoLink,
    className: "flex gap-2 items-center",
    target: "_blank",
    rel: "noopener noreferrer"
  }, t.createElement(mz, {
    height: "h-6 w-6 stroke-[1.5px]",
    variant: "octoface"
  }), t.createElement(ce, {
    textStyle: "body1-medium",
    className: "text-blue-600"
  }, (_e$githubText = e.githubText) !== null && _e$githubText !== void 0 ? _e$githubText : "GitHub Repo"), t.createElement(mz, {
    height: "h-5 w-5 stroke-[1.5px]",
    variant: "linkexternal01",
    strokeClass: "stroke-blue-600"
  })))), t.createElement("div", {
    className: "py-8"
  }, t.createElement(ce, {
    textStyle: "h6",
    className: "text-neutral-500 uppercase"
  }, (_e$creator = e.creator) !== null && _e$creator !== void 0 ? _e$creator : "Creator"), e.authorURL && (e === null || e === void 0 ? void 0 : e.authorName) && t.createElement("a", {
    href: e.authorURL,
    className: "flex gap-2 items-center pt-4",
    target: "_blank",
    rel: "noopener noreferrer"
  }, t.createElement(ce, {
    textStyle: "body1-medium",
    className: "text-blue-600"
  }, e.authorName), t.createElement(mz, {
    height: "h-5 w-5 stroke-[1.5px]",
    variant: "linkexternal01",
    strokeClass: "stroke-blue-600"
  })), e.authorEmail && t.createElement(ce, {
    textStyle: "body1-medium",
    className: "text-neutral-500 pt-2"
  }, e.authorEmail))));
}
function ede(e) {
  return t.createElement(t.Fragment, null, e.tagline && t.createElement(ce, {
    textStyle: "body1-medium",
    className: "flex items-center text-neutral-700 pb-4"
  }, e.tagIcon && t.createElement(mz, {
    height: "h-6 w-6 stroke-[1.5px] mr-2",
    variant: e.tagIcon,
    strokeClass: "stroke-neutral-700"
  }), e.tagline), e.agendaTitle && t.createElement(ce, {
    textStyle: "h3",
    as: "h3",
    className: "text-neutral-1000 pb-4"
  }, e.agendaTitle), e.agendaList && e.agendaList.map((e, r) => t.createElement("div", {
    key: r,
    className: 0 === r ? "" : "pt-4"
  }, e.title && t.createElement(ce, {
    textStyle: "h5",
    as: "h5",
    className: "text-neutral-700 pb-1"
  }, e.title), e.description && t.createElement(ce, {
    textStyle: "body1",
    className: "text-neutral-700 [&>p]:pb-1 [&>p>img]:mt-4 [&>p>img]:max-w-[420px] [&>p>img]:w-full [&>p>img:nth-child(2)]:max-w-[140px] last:[&>p]:pb-0 [&>ul]:ps-4 [&>ul>li]:list-disc [&>ul>li]:pb-1 last:[&>ul>li]:pb-0 [&>p>a]:text-blue-600 [&>p>a:hover]:text-blue-800"
  }, t.createElement(bte, {
    components: {
      a: _ref153 => {
        let {
          node: e,
          ...r
        } = _ref153;
        return t.createElement("a", dz({
          target: "_blank",
          rel: "noopener noreferrer"
        }, r));
      }
    }
  }, e.description)))), e.closingNotes && t.createElement(ce, {
    textStyle: "body1",
    className: "text-neutral-700 pt-4 [&>p]:pb-4 last:[&>p]:pb-0 [&>ul]:ps-4 [&>ul>li]:list-disc [&>ul>li]:pb-1 last:[&>ul>li]:pb-0 [&>p>a]:text-blue-600 [&>p>a:hover]:text-blue-800"
  }, t.createElement(bte, {
    components: {
      a: _ref154 => {
        let {
          node: e,
          ...r
        } = _ref154;
        return t.createElement("a", dz({
          target: "_blank",
          rel: "noopener noreferrer"
        }, r));
      }
    }
  }, e.closingNotes)));
}
function tde(e) {
  var _e$circleBG, _e$imgTagText, _e$badgeColor2;
  return t.createElement("div", {
    className: "group/eventListing rounded-2xl transition-all duration-300"
  }, t.createElement("div", {
    className: "self-start rounded-t-2xl"
  }, e.eventListingImg && t.createElement("div", {
    className: "relative"
  }, t.createElement("div", null, t.createElement("img", {
    src: e.eventListingImg,
    alt: e.title,
    className: " rounded-t-2xl h-[179px] object-cover ".concat(e.imgBG),
    loading: e !== null && e !== void 0 && e.isCardLazyLoaded ? "lazy" : "eager"
  }), e.imgTagText && t.createElement("div", {
    className: " scale-75 absolute top-2 -right-1"
  }, t.createElement(C8, {
    statusCircleBgClass: (_e$circleBG = e.circleBG) !== null && _e$circleBG !== void 0 ? _e$circleBG : "bg-red-400",
    statusTextClass: "text-neutral-900",
    bgClass: "bg-neutral-0",
    statusText: (_e$imgTagText = e.imgTagText) !== null && _e$imgTagText !== void 0 ? _e$imgTagText : "Concluded"
  }))))), t.createElement("div", {
    className: "border border-neutral-200 group-hover/eventListing:border-opacity-0 transition-all duration-300 rounded-b-2xl"
  }, t.createElement("div", {
    className: "p-6 pb-0"
  }, e.eventType && t.createElement(x8, {
    color: (_e$badgeColor2 = e.badgeColor) !== null && _e$badgeColor2 !== void 0 ? _e$badgeColor2 : "green",
    children: e.eventType
  }), e.title && t.createElement("div", {
    className: "text-neutral-1000 text-hds-m-h5 tb:text-hds-t-h5  py-2"
  }, e.title)), e.eventDate && t.createElement(ce, {
    textStyle: "body3-medium",
    className: "text-neutral-700 flex items-center duration-300 self-end p-6 pt-0"
  }, e.eventDate, t.createElement("div", null, t.createElement(mz, {
    className: "z-10 stroke-2 group-hover/eventListing:translate-x-[0.15rem] group-hover/eventListing:transition-all group-hover/eventListing:duration-300",
    height: "h-5 w-5",
    variant: "chevronright",
    strokeClass: "stroke-neutral-500"
  }), t.createElement(mz, {
    className: "invisible stroke-2 group-hover/eventListing:transition-all group-hover/eventListing:delay-100 group-hover/eventListing:visible ",
    height: "h-5 w-5 -mt-5",
    variant: "minus01",
    strokeClass: "stroke-neutral-500"
  })))));
}
function rde(e) {
  const [n, a] = r(null),
    o = e => {
      a(n === e ? null : e);
    };
  return t.createElement("div", {
    className: "divide-y divide-neutral-200"
  }, e.accordionData && e.accordionData.map((e, r) => t.createElement("div", {
    key: r,
    className: " first:pt-0 last:pb-0 py-6 flex"
  }, t.createElement("div", {
    className: " cursor-pointer",
    onClick: () => o(r)
  }, t.createElement(mz, {
    height: "h-5 w-5 stroke-[1.5px] ",
    variant: n === r ? "minus" : "plus",
    strokeClass: "stroke-blue-600",
    className: " transition-opacity duration-300 mt-1"
  })), t.createElement("div", null, t.createElement(oce.div, {
    className: " pl-4 ",
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 1
    },
    transition: {
      duration: .3,
      type: "easeIn"
    }
  }, t.createElement("div", {
    className: "flex items-center justify-between cursor-pointer"
  }, t.createElement("div", {
    className: "flex items-center",
    onClick: () => o(r)
  }, e.title && t.createElement(ce, {
    textStyle: "body1-medium",
    className: "text-neutral-900"
  }, e.title)))), t.createElement(mce, null, n === r && t.createElement(oce.div, {
    className: "",
    initial: {
      height: 0,
      opacity: 0
    },
    animate: {
      height: "auto",
      opacity: 1
    },
    exit: {
      height: 0,
      opacity: 0
    },
    transition: {
      duration: .1,
      type: "tween"
    }
  }, e.content && t.createElement(ce, {
    textStyle: "body1",
    className: "text-neutral-900 pl-4 [&>ul]:ps-4 [&>ul>li]:list-disc [&>ul>li]:pb-2 last:[&>ul>li]:pb-0 [&>p>a]:text-blue-600 [&>p]:pb-2 last:[&>p]:pb-0 [&>ul>li>a]:text-blue-600"
  }, t.createElement(bte, {
    components: {
      a: _ref155 => {
        let {
          node: e,
          ...r
        } = _ref155;
        return t.createElement("a", dz({
          className: "text-blue-600",
          target: "_blank",
          rel: "noopener noreferrer"
        }, r));
      }
    }
  }, e.content))))))));
}
Wfe.defaultProps = {
  brandUrl: "https://res.cloudinary.com/dh8fp23nd/image/upload/v1686659126/website%20v3/hasura-primary_y9cdnn.svg",
  brandAlt: "Hasura",
  brandLink: "https://hasura.io/",
  footerLinks: [{
    title: "Platform",
    links: [{
      linkText: "Hasura DDN",
      linkUrl: "https://hasura.io/products"
    }, {
      linkText: "Connectors",
      linkUrl: "https://hasura.io/connectors"
    }, {
      linkText: "Pricing",
      linkUrl: "https://hasura.io/pricing"
    }, {
      linkText: "Security",
      linkUrl: "https://hasura.io/security/"
    }]
  }, {
    title: "Build",
    links: [{
      linkText: "Docs",
      linkUrl: "https://hasura.io/docs/3.0/index/"
    }, {
      linkText: "Tutorials",
      linkUrl: "https://hasura.io/learn/"
    }, {
      linkText: "GitHub",
      linkUrl: "https://github.com/hasura"
    }]
  }, {
    title: "Learn",
    links: [{
      linkText: "Blog",
      linkUrl: "https://hasura.io/blog"
    }, {
      linkText: "Events",
      linkUrl: "https://hasura.io/events"
    }, {
      linkText: "Supergraph.io",
      linkUrl: "https://supergraph.io/"
    }, {
      linkText: "GraphQL Hub",
      linkUrl: "https://hasura.io/graphql/"
    }]
  }, {
    title: "Company",
    links: [{
      linkText: "Our Story",
      linkUrl: "https://hasura.io/about/"
    }, {
      linkText: "Careers",
      linkUrl: "https://hasura.io/careers/"
    }, {
      linkText: "Partners",
      linkUrl: "https://hasura.io/partners"
    }, {
      linkText: "Legal",
      linkUrl: "https://hasura.io/legal"
    }, {
      linkText: "Cookie Policy",
      linkUrl: "https://hasura.io/legal/hasura-cookie-policy"
    }, {
      linkText: "Privacy Policy",
      linkUrl: "https://hasura.io/legal/hasura-privacy-policy"
    }]
  }, {
    title: "Connect",
    links: [{
      linkText: "Community",
      linkUrl: "https://hasura.io/community"
    }, {
      linkText: "Discord",
      linkUrl: "https://discord.com/invite/hasura"
    }, {
      linkText: "Forum",
      linkUrl: "https://github.com/hasura/graphql-engine/discussions"
    }, {
      linkText: "Meetups",
      linkUrl: "https://www.meetup.com/pro/hasura/"
    }, {
      linkText: "Monthly call",
      linkUrl: "https://hasura.io/events/community-call/latest"
    }, {
      linkText: "Support",
      linkUrl: "https://hasura.io/support-hub"
    }, {
      linkText: "Contact Us",
      linkUrl: "https://hasura.io/contact-us"
    }]
  }]
}, Kfe.defaultProps = {
  title: "Build any supergraph topology",
  description: "Build a supergraph using Hasura, use Hasura to implement a GraphQL gateway pattern or use Hasura to federate existing resources into another supergraph. Hasura allows you to shape any supergraph topology that works for you. \n\nCheck out some of the Federation architecture patterns implemented by our users.",
  navTabs: [{
    current: "[Circular]",
    href: "",
    name: "Performance"
  }, {
    current: "[Circular]",
    href: "",
    name: "Company"
  }, {
    current: "[Circular]",
    href: "",
    name: "Authorization"
  }, {
    current: "[Circular]",
    href: "",
    name: "Observability"
  }, {
    current: "[Circular]",
    href: "",
    name: "API Security"
  }],
  tabContent: {
    "API Security": {
      img_url: "https://res.cloudinary.com/dh8fp23nd/image/upload/v1683311269/hasura-con-2023/hascon23_fallback_homepage_tg5sgv.jpg",
      subTitle: "Hasura simplifies data access and reduces latency for optimizing performance via a Haskell core, JIT query compiler, predicate pushdown, and application-level caching out of the box.",
      title: "5Get blazing-fast APIs without the extra work",
      video_poster: "https://res.cloudinary.com/dh8fp23nd/image/upload/v1683311269/hasura-con-2023/hascon23_fallback_homepage_tg5sgv.jpg",
      video_url: "https://res.cloudinary.com/dh8fp23nd/video/upload/v1683307555/hasura-con-2023/tg_hascon23_homepage_ue29jn.mp4"
    },
    Authorization: {
      img_url: "https://res.cloudinary.com/dh8fp23nd/image/upload/v1683311269/hasura-con-2023/hascon23_fallback_homepage_tg5sgv.jpg",
      subTitle: "Hasura simplifies data access and reduces latency for optimizing performance via a Haskell core, JIT query compiler, predicate pushdown, and application-level caching out of the box.",
      title: "3Get blazing-fast APIs without the extra work",
      video_poster: "https://res.cloudinary.com/dh8fp23nd/image/upload/v1683311269/hasura-con-2023/hascon23_fallback_homepage_tg5sgv.jpg",
      video_url: "https://res.cloudinary.com/dh8fp23nd/video/upload/v1683307555/hasura-con-2023/tg_hascon23_homepage_ue29jn.mp4"
    },
    Company: {
      img_url: "https://res.cloudinary.com/dh8fp23nd/image/upload/v1683311269/hasura-con-2023/hascon23_fallback_homepage_tg5sgv.jpg",
      subTitle: "Hasura simplifies data access and reduces latency for optimizing performance via a Haskell core, JIT query compiler, predicate pushdown, and application-level caching out of the box.",
      title: "2Get blazing-fast APIs without the extra work",
      video_poster: "https://res.cloudinary.com/dh8fp23nd/image/upload/v1683311269/hasura-con-2023/hascon23_fallback_homepage_tg5sgv.jpg",
      video_url: "https://res.cloudinary.com/dh8fp23nd/video/upload/v1683307555/hasura-con-2023/tg_hascon23_homepage_ue29jn.mp4"
    },
    Observability: {
      img_url: "https://res.cloudinary.com/dh8fp23nd/image/upload/v1683311269/hasura-con-2023/hascon23_fallback_homepage_tg5sgv.jpg",
      subTitle: "Hasura simplifies data access and reduces latency for optimizing performance via a Haskell core, JIT query compiler, predicate pushdown, and application-level caching out of the box.",
      title: "4Get blazing-fast APIs without the extra work",
      video_poster: "https://res.cloudinary.com/dh8fp23nd/image/upload/v1683311269/hasura-con-2023/hascon23_fallback_homepage_tg5sgv.jpg",
      video_url: "https://res.cloudinary.com/dh8fp23nd/video/upload/v1683307555/hasura-con-2023/tg_hascon23_homepage_ue29jn.mp4"
    },
    Performance: {
      img_url: "https://res.cloudinary.com/dh8fp23nd/image/upload/v1683311269/hasura-con-2023/hascon23_fallback_homepage_tg5sgv.jpg",
      readMore_cta: "Read More About Performance",
      subTitle: "Hasura simplifies data access and reduces latency for optimizing performance via a Haskell core, JIT query compiler, predicate pushdown, and application-level caching out of the box.",
      title: "1Get blazing-fast APIs without the extra work",
      video_poster: "https://res.cloudinary.com/dh8fp23nd/image/upload/v1683311269/hasura-con-2023/hascon23_fallback_homepage_tg5sgv.jpg",
      video_url: "https://res.cloudinary.com/dh8fp23nd/video/upload/v1683307555/hasura-con-2023/tg_hascon23_homepage_ue29jn.mp4"
    }
  }
}, Xfe.defaultProps = {
  title: "100+ Data Sources",
  description: "description1",
  CTA: {
    text: "Button Label"
  },
  video_url: "https://res.cloudinary.com/dh8fp23nd/video/upload/v1654760488/samples/sea-turtle.mp4"
};
export { Jfe as AboutSectionCard, e8 as AlgoliaSearch, B8 as AnnouncementMd, k8 as AnnouncementSM, h8 as AvatarGroup, x8 as Badges, L8 as Banner, Mte as BrandCard, F8 as BreadCrumbs, J5 as Card, fz as Card3dHover, Vfe as Carousel, Afe as CarouselB, Rfe as CarouselCard, ere as Checkbox, Hte as CommunityCard, Jte as ConnectorCard, j8 as Count, Ife as CustomCarousel, hfe as CustomHeader, Ffe as CustomerStories, Xfe as DataSourcesCard, Dte as DefaultIF, qte as ErrorIF, tde as EventListingCard, Zte as EventScheduleCard, _fe as EventStories, ede as EventsAgenda, P8 as EyeBrowText, rde as FAQSection, Bte as FeedbackCard, _8 as FlyoutA, Z8 as FlyoutB, D8 as FlyoutC, q8 as FlyoutD, A8 as HDSButton, T8 as HDSButtonVariants, A as HDSColor, n8 as HDSPaperForm, o8 as HDSSearch, b8 as HasConAvatar, xfe as Hero1, Efe as HeroCapability, Cfe as HeroEvents, jfe as HeroIntegration, Pfe as HeroLinkCard, Ofe as HeroSecondary, Lfe as HomepageCarouselPrimary, mz as Icon, u8 as IconAvatar, Ote as IconCard, Pte as IconCardButton, Ute as IconLeadingIF, $te as IconTrailIF, l8 as ImageAvatar, jte as ImageBadgeCard, Ete as ImageCard, p8 as InitialsAvatar, Xte as InviteCard, Kte as InviteIF, zte as LeadingDropIF, Wte as LeadingTextIF, Vte as LinkCard, C8 as LiveStatus, a8 as MarketoForm, pz as MediaBox, Yfe as NavCard, Kfe as NavTabCard, Bfe as PricingTableB, g8 as ProfileAvatar, Rte as ResourcesCard, Fte as StoryCardSM, _te as StoryCardXL, bfe as Tab, Mfe as TableA, Sfe as TableB, Nfe as TableC, pfe as Tabone, dfe as Tabthree, gfe as Tabtwo, i8 as TagFilter, wte as TalkCard, yte as TalkCard2, Ate as TalkDetailCard, Lte as Testimonial, Qte as TextAreaIF, Qfe as TextCard, Gfe as TextIconCard, yfe as Tooltip, Gte as TrailingButtonIF, Yte as TrailingDropdownIF, he as Translations, ce as Typography, ue as TypographyClasses, Nte as V3Dropdown, Wfe as V3Footer, vce as V3Header, wfe as V3Tab, Ite as VideoCard };